import { Aggregator as QV, isSameAddress as ja, TRON_CHAIN_ID as qV, isNativeToken as di, isEvmAddress as Dd, isTronAddress as KV, isSolanaAddress as eH, CanonicalBridgeSDK as tH, isMobile as nH } from "@bnb-chain/canonical-bridge-sdk";
export * from "@bnb-chain/canonical-bridge-sdk";
import { jsx as g, jsxs as X, Fragment as st } from "react/jsx-runtime";
import * as Se from "react";
import w, { createContext as pn, useContext as N1, useLayoutEffect as z0, useEffect as Oe, useState as ze, useRef as Re, useMemo as we, useCallback as se, forwardRef as ro, useReducer as lw, useInsertionEffect as cw, createElement as X5, useId as dr, cloneElement as ko, Children as Ps, isValidElement as G0, memo as Zd, useSyncExternalStore as rH, Fragment as m0, PureComponent as oH, Component as iH } from "react";
import { Global as M9, ThemeContext as aH, ThemeProvider as sH, keyframes as W0, jsx as qe, css as uw } from "@emotion/react";
import BC from "@emotion/styled";
import lH, { createPortal as zd } from "react-dom";
import { useAccount as lt, useChains as dw, useBalance as $0, useReadContract as fw, useBytecode as Gd, useWalletClient as Wd, usePublicClient as eo, useSwitchChain as cH, useSignMessage as uH, useDisconnect as dH } from "wagmi";
import { createPublicClient as fH, http as pH, formatUnits as x1, parseUnits as en, pad as hH, encodePacked as mH } from "viem";
import { useWallet as r2 } from "@tronweb3/tronwallet-adapter-react-hooks";
import { TronWeb as CH } from "tronweb";
import { useWallet as $d, useConnection as U0 } from "@solana/wallet-adapter-react";
import { PublicKey as Uc, LAMPORTS_PER_SOL as pw, VersionedTransaction as gH } from "@solana/web3.js";
import { useQuery as gi } from "@tanstack/react-query";
import * as bH from "@solana/spl-token";
import { TOKEN_PROGRAM_ID as vH } from "@solana/spl-token";
var hw = String.raw, mw = hw`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`, yH = () => /* @__PURE__ */ g(M9, { styles: mw }), xH = ({ scope: e = "" }) => /* @__PURE__ */ g(
  M9,
  {
    styles: hw`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${e} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${e} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${e} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${e} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${e} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${e} :where(b, strong) {
        font-weight: bold;
      }

      ${e} small {
        font-size: 80%;
      }

      ${e} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${e} sub {
        bottom: -0.25em;
      }

      ${e} sup {
        top: -0.5em;
      }

      ${e} img {
        border-style: none;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${e} :where(button, input) {
        overflow: visible;
      }

      ${e} :where(button, select) {
        text-transform: none;
      }

      ${e} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${e} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${e} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${e} progress {
        vertical-align: baseline;
      }

      ${e} textarea {
        overflow: auto;
      }

      ${e} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${e} input[type="number"]::-webkit-inner-spin-button,
      ${e} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${e} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${e} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${e} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${e} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${e} details {
        display: block;
      }

      ${e} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${e} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${e} button {
        background: transparent;
        padding: 0;
      }

      ${e} fieldset {
        margin: 0;
        padding: 0;
      }

      ${e} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${e} textarea {
        resize: vertical;
      }

      ${e} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${e} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${e} table {
        border-collapse: collapse;
      }

      ${e} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${e} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${e} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${e} select::-ms-expand {
        display: none;
      }

      ${mw}
    `
  }
);
function wH(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function tn(e = {}) {
  const {
    name: t,
    strict: n = !0,
    hookName: r = "useContext",
    providerName: o = "Provider",
    errorMessage: i,
    defaultValue: a
  } = e, l = pn(a);
  l.displayName = t;
  function c() {
    var u;
    const f = N1(l);
    if (!f && n) {
      const p = new Error(
        i ?? wH(r, o)
      );
      throw p.name = "ContextError", (u = Error.captureStackTrace) == null || u.call(Error, p, c), p;
    }
    return f;
  }
  return [l.Provider, c, l];
}
var [SH, TH] = tn({
  strict: !1,
  name: "PortalManagerContext"
});
function Cw(e) {
  const { children: t, zIndex: n } = e;
  return /* @__PURE__ */ g(SH, { value: { zIndex: n }, children: t });
}
Cw.displayName = "PortalManager";
var Xa = globalThis?.document ? z0 : Oe, [gw, AH] = tn({
  strict: !1,
  name: "PortalContext"
}), Ud = "chakra-portal", IH = ".chakra-portal", LH = (e) => /* @__PURE__ */ g(
  "div",
  {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: e.zIndex,
      top: 0,
      left: 0,
      right: 0
    },
    children: e.children
  }
), EH = (e) => {
  const { appendToParentPortal: t, children: n } = e, [r, o] = ze(null), i = Re(null), [, a] = ze({});
  Oe(() => a({}), []);
  const l = AH(), c = TH();
  Xa(() => {
    if (!r)
      return;
    const f = r.ownerDocument, p = t ? l ?? f.body : f.body;
    if (!p)
      return;
    i.current = f.createElement("div"), i.current.className = Ud, p.appendChild(i.current), a({});
    const h = i.current;
    return () => {
      p.contains(h) && p.removeChild(h);
    };
  }, [r]);
  const u = c?.zIndex ? /* @__PURE__ */ g(LH, { zIndex: c?.zIndex, children: n }) : n;
  return i.current ? zd(
    /* @__PURE__ */ g(gw, { value: i.current, children: u }),
    i.current
  ) : /* @__PURE__ */ g(
    "span",
    {
      ref: (f) => {
        f && o(f);
      }
    }
  );
}, MH = (e) => {
  const { children: t, containerRef: n, appendToParentPortal: r } = e, o = n.current, i = o ?? (typeof window < "u" ? document.body : void 0), a = we(() => {
    const c = o?.ownerDocument.createElement("div");
    return c && (c.className = Ud), c;
  }, [o]), [, l] = ze({});
  return Xa(() => l({}), []), Xa(() => {
    if (!(!a || !i))
      return i.appendChild(a), () => {
        i.removeChild(a);
      };
  }, [a, i]), i && a ? zd(
    /* @__PURE__ */ g(gw, { value: r ? a : null, children: t }),
    a
  ) : null;
};
function o2(e) {
  const t = {
    appendToParentPortal: !0,
    ...e
  }, { containerRef: n, ...r } = t;
  return n ? /* @__PURE__ */ g(MH, { containerRef: n, ...r }) : /* @__PURE__ */ g(EH, { ...r });
}
o2.className = Ud;
o2.selector = IH;
o2.displayName = "Portal";
function Xe() {
  const e = N1(
    aH
  );
  if (!e)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return e;
}
var B9 = pn({});
B9.displayName = "ColorModeContext";
function Ee() {
  const e = N1(B9);
  if (e === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return e;
}
var O4 = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function BH(e = {}) {
  const { preventTransition: t = !0 } = e, n = {
    setDataset: (r) => {
      const o = t ? n.preventTransition() : void 0;
      document.documentElement.dataset.theme = r, document.documentElement.style.colorScheme = r, o?.();
    },
    setClassName(r) {
      document.body.classList.add(r ? O4.dark : O4.light), document.body.classList.remove(r ? O4.light : O4.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(r) {
      var o;
      return ((o = n.query().matches) != null ? o : r === "dark") ? "dark" : "light";
    },
    addListener(r) {
      const o = n.query(), i = (a) => {
        r(a.matches ? "dark" : "light");
      };
      return typeof o.addListener == "function" ? o.addListener(i) : o.addEventListener("change", i), () => {
        typeof o.removeListener == "function" ? o.removeListener(i) : o.removeEventListener("change", i);
      };
    },
    preventTransition() {
      const r = document.createElement("style");
      return r.appendChild(
        document.createTextNode(
          "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"
        )
      ), document.head.appendChild(r), () => {
        window.getComputedStyle(document.body), requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(r);
          });
        });
      };
    }
  };
  return n;
}
var kH = "chakra-ui-color-mode";
function RH(e) {
  return {
    ssr: !1,
    type: "localStorage",
    get(t) {
      if (!globalThis?.document)
        return t;
      let n;
      try {
        n = localStorage.getItem(e) || t;
      } catch {
      }
      return n || t;
    },
    set(t) {
      try {
        localStorage.setItem(e, t);
      } catch {
      }
    }
  };
}
var _H = RH(kH), $l = () => {
};
function kC(e, t) {
  return e.type === "cookie" && e.ssr ? e.get(t) : t;
}
function bw(e) {
  const {
    value: t,
    children: n,
    options: {
      useSystemColorMode: r,
      initialColorMode: o,
      disableTransitionOnChange: i
    } = {},
    colorModeManager: a = _H
  } = e, l = o === "dark" ? "dark" : "light", [c, u] = ze(
    () => kC(a, l)
  ), [f, p] = ze(
    () => kC(a)
  ), { getSystemTheme: h, setClassName: C, setDataset: v, addListener: b } = we(
    () => BH({ preventTransition: i }),
    [i]
  ), y = o === "system" && !c ? f : c, x = se(
    (L) => {
      const I = L === "system" ? h() : L;
      u(I), C(I === "dark"), v(I), a.set(I);
    },
    [a, h, C, v]
  );
  Xa(() => {
    o === "system" && p(h());
  }, []), Oe(() => {
    const L = a.get();
    if (L) {
      x(L);
      return;
    }
    if (o === "system") {
      x("system");
      return;
    }
    x(l);
  }, [a, l, o, x]);
  const T = se(() => {
    x(y === "dark" ? "light" : "dark");
  }, [y, x]);
  Oe(() => {
    if (r)
      return b(x);
  }, [r, b, x]);
  const A = we(
    () => ({
      colorMode: t ?? y,
      toggleColorMode: t ? $l : T,
      setColorMode: t ? $l : x,
      forced: t !== void 0
    }),
    [y, T, x, t]
  );
  return /* @__PURE__ */ g(B9.Provider, { value: A, children: n });
}
bw.displayName = "ColorModeProvider";
function jd(e) {
  const t = we(
    () => ({
      colorMode: "light",
      toggleColorMode: $l,
      setColorMode: $l,
      forced: !0
    }),
    []
  );
  return /* @__PURE__ */ g(B9.Provider, { value: t, ...e });
}
jd.displayName = "LightMode";
function vw() {
  const e = Ee(), t = Xe();
  return { ...e, theme: t };
}
function FH(e, t, n) {
  var r, o;
  if (t == null)
    return t;
  const i = (a) => {
    var l, c;
    return (c = (l = e.__cssMap) == null ? void 0 : l[a]) == null ? void 0 : c.value;
  };
  return (o = (r = i(t)) != null ? r : i(n)) != null ? o : n;
}
function PH(e, t, n) {
  const r = Xe();
  return VH(e, t, n)(r);
}
function VH(e, t, n) {
  const r = Array.isArray(t) ? t : [t], o = Array.isArray(n) ? n : [n];
  return (i) => {
    const a = o.filter(Boolean), l = r.map((c, u) => {
      var f;
      const p = `${e}.${c}`;
      return FH(i, p, (f = a[u]) != null ? f : c);
    });
    return Array.isArray(t) ? l : l[0];
  };
}
var v1 = (...e) => e.filter(Boolean).join(" ");
function HH() {
  return process.env.NODE_ENV !== "production";
}
function wn(e) {
  const t = typeof e;
  return e != null && (t === "object" || t === "function") && !Array.isArray(e);
}
var Xd = (e) => {
  const { condition: t, message: n } = e;
  t && HH() && console.warn(n);
};
function Er(e, ...t) {
  return OH(e) ? e(...t) : e;
}
var OH = (e) => typeof e == "function", Xi = (e) => e ? "" : void 0, s8 = (e) => e ? !0 : void 0;
function it(...e) {
  return function(n) {
    e.some((r) => (r?.(n), n?.defaultPrevented));
  };
}
function yw(...e) {
  return function(n) {
    e.forEach((r) => {
      r?.(n);
    });
  };
}
var Yi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function k9(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var H5 = { exports: {} };
H5.exports;
var RC;
function NH() {
  return RC || (RC = 1, function(e, t) {
    var n = 200, r = "__lodash_hash_undefined__", o = 800, i = 16, a = 9007199254740991, l = "[object Arguments]", c = "[object Array]", u = "[object AsyncFunction]", f = "[object Boolean]", p = "[object Date]", h = "[object Error]", C = "[object Function]", v = "[object GeneratorFunction]", b = "[object Map]", y = "[object Number]", x = "[object Null]", T = "[object Object]", A = "[object Proxy]", L = "[object RegExp]", I = "[object Set]", M = "[object String]", k = "[object Undefined]", _ = "[object WeakMap]", F = "[object ArrayBuffer]", $ = "[object DataView]", oe = "[object Float32Array]", te = "[object Float64Array]", ae = "[object Int8Array]", be = "[object Int16Array]", K = "[object Int32Array]", ue = "[object Uint8Array]", J = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", _e = "[object Uint32Array]", ne = /[\\^$.*+?()[\]{}|]/g, ee = /^\[object .+?Constructor\]$/, ye = /^(?:0|[1-9]\d*)$/, fe = {};
    fe[oe] = fe[te] = fe[ae] = fe[be] = fe[K] = fe[ue] = fe[J] = fe[Me] = fe[_e] = !0, fe[l] = fe[c] = fe[F] = fe[f] = fe[$] = fe[p] = fe[h] = fe[C] = fe[b] = fe[y] = fe[T] = fe[L] = fe[I] = fe[M] = fe[_] = !1;
    var xe = typeof Yi == "object" && Yi && Yi.Object === Object && Yi, Te = typeof self == "object" && self && self.Object === Object && self, Ie = xe || Te || Function("return this")(), Q = t && !t.nodeType && t, pe = Q && !0 && e && !e.nodeType && e, me = pe && pe.exports === Q, Be = me && xe.process, We = function() {
      try {
        var V = pe && pe.require && pe.require("util").types;
        return V || Be && Be.binding && Be.binding("util");
      } catch {
      }
    }(), ie = We && We.isTypedArray;
    function f1(V, z, ce) {
      switch (ce.length) {
        case 0:
          return V.call(z);
        case 1:
          return V.call(z, ce[0]);
        case 2:
          return V.call(z, ce[0], ce[1]);
        case 3:
          return V.call(z, ce[0], ce[1], ce[2]);
      }
      return V.apply(z, ce);
    }
    function s1(V, z) {
      for (var ce = -1, Ne = Array(V); ++ce < V; )
        Ne[ce] = z(ce);
      return Ne;
    }
    function Ye(V) {
      return function(z) {
        return V(z);
      };
    }
    function B1(V, z) {
      return V?.[z];
    }
    function Pe(V, z) {
      return function(ce) {
        return V(z(ce));
      };
    }
    var j1 = Array.prototype, X1 = Function.prototype, p1 = Object.prototype, L1 = Ie["__core-js_shared__"], Ct = X1.toString, Z1 = p1.hasOwnProperty, r1 = function() {
      var V = /[^.]+$/.exec(L1 && L1.keys && L1.keys.IE_PROTO || "");
      return V ? "Symbol(src)_1." + V : "";
    }(), ut = p1.toString, rn = Ct.call(Object), on = RegExp(
      "^" + Ct.call(Z1).replace(ne, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), ln = me ? Ie.Buffer : void 0, Ca = Ie.Symbol, wi = Ie.Uint8Array;
    ln && ln.allocUnsafe;
    var No = Pe(Object.getPrototypeOf, Object), Si = Object.create, Js = p1.propertyIsEnumerable, Qs = j1.splice, Zr = Ca ? Ca.toStringTag : void 0, Ti = function() {
      try {
        var V = r5(Object, "defineProperty");
        return V({}, "", {}), V;
      } catch {
      }
    }(), qs = ln ? ln.isBuffer : void 0, I3 = Math.max, B6 = Date.now, L3 = r5(Ie, "Map"), Ai = r5(Object, "create"), E3 = /* @__PURE__ */ function() {
      function V() {
      }
      return function(z) {
        if (!Zo(z))
          return {};
        if (Si)
          return Si(z);
        V.prototype = z;
        var ce = new V();
        return V.prototype = void 0, ce;
      };
    }();
    function Do(V) {
      var z = -1, ce = V == null ? 0 : V.length;
      for (this.clear(); ++z < ce; ) {
        var Ne = V[z];
        this.set(Ne[0], Ne[1]);
      }
    }
    function k6() {
      this.__data__ = Ai ? Ai(null) : {}, this.size = 0;
    }
    function R6(V) {
      var z = this.has(V) && delete this.__data__[V];
      return this.size -= z ? 1 : 0, z;
    }
    function _6(V) {
      var z = this.__data__;
      if (Ai) {
        var ce = z[V];
        return ce === r ? void 0 : ce;
      }
      return Z1.call(z, V) ? z[V] : void 0;
    }
    function M3(V) {
      var z = this.__data__;
      return Ai ? z[V] !== void 0 : Z1.call(z, V);
    }
    function F6(V, z) {
      var ce = this.__data__;
      return this.size += this.has(V) ? 0 : 1, ce[V] = Ai && z === void 0 ? r : z, this;
    }
    Do.prototype.clear = k6, Do.prototype.delete = R6, Do.prototype.get = _6, Do.prototype.has = M3, Do.prototype.set = F6;
    function zr(V) {
      var z = -1, ce = V == null ? 0 : V.length;
      for (this.clear(); ++z < ce; ) {
        var Ne = V[z];
        this.set(Ne[0], Ne[1]);
      }
    }
    function P6() {
      this.__data__ = [], this.size = 0;
    }
    function Ks(V) {
      var z = this.__data__, ce = A2(z, V);
      if (ce < 0)
        return !1;
      var Ne = z.length - 1;
      return ce == Ne ? z.pop() : Qs.call(z, ce, 1), --this.size, !0;
    }
    function V6(V) {
      var z = this.__data__, ce = A2(z, V);
      return ce < 0 ? void 0 : z[ce][1];
    }
    function e5(V) {
      return A2(this.__data__, V) > -1;
    }
    function H6(V, z) {
      var ce = this.__data__, Ne = A2(ce, V);
      return Ne < 0 ? (++this.size, ce.push([V, z])) : ce[Ne][1] = z, this;
    }
    zr.prototype.clear = P6, zr.prototype.delete = Ks, zr.prototype.get = V6, zr.prototype.has = e5, zr.prototype.set = H6;
    function Ii(V) {
      var z = -1, ce = V == null ? 0 : V.length;
      for (this.clear(); ++z < ce; ) {
        var Ne = V[z];
        this.set(Ne[0], Ne[1]);
      }
    }
    function O6() {
      this.size = 0, this.__data__ = {
        hash: new Do(),
        map: new (L3 || zr)(),
        string: new Do()
      };
    }
    function N6(V) {
      var z = ga(this, V).delete(V);
      return this.size -= z ? 1 : 0, z;
    }
    function D6(V) {
      return ga(this, V).get(V);
    }
    function Z6(V) {
      return ga(this, V).has(V);
    }
    function z6(V, z) {
      var ce = ga(this, V), Ne = ce.size;
      return ce.set(V, z), this.size += ce.size == Ne ? 0 : 1, this;
    }
    Ii.prototype.clear = O6, Ii.prototype.delete = N6, Ii.prototype.get = D6, Ii.prototype.has = Z6, Ii.prototype.set = z6;
    function Li(V) {
      var z = this.__data__ = new zr(V);
      this.size = z.size;
    }
    function B3() {
      this.__data__ = new zr(), this.size = 0;
    }
    function G6(V) {
      var z = this.__data__, ce = z.delete(V);
      return this.size = z.size, ce;
    }
    function W6(V) {
      return this.__data__.get(V);
    }
    function $6(V) {
      return this.__data__.has(V);
    }
    function U6(V, z) {
      var ce = this.__data__;
      if (ce instanceof zr) {
        var Ne = ce.__data__;
        if (!L3 || Ne.length < n - 1)
          return Ne.push([V, z]), this.size = ++ce.size, this;
        ce = this.__data__ = new Ii(Ne);
      }
      return ce.set(V, z), this.size = ce.size, this;
    }
    Li.prototype.clear = B3, Li.prototype.delete = G6, Li.prototype.get = W6, Li.prototype.has = $6, Li.prototype.set = U6;
    function j6(V, z) {
      var ce = s5(V), Ne = !ce && a5(V), E1 = !ce && !Ne && Y3(V), Y1 = !ce && !Ne && !E1 && Q3(V), gt = ce || Ne || E1 || Y1, l1 = gt ? s1(V.length, String) : [], ot = l1.length;
      for (var Ut in V)
        gt && // Safari 9 has enumerable `arguments.length` in strict mode.
        (Ut == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        E1 && (Ut == "offset" || Ut == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        Y1 && (Ut == "buffer" || Ut == "byteLength" || Ut == "byteOffset") || // Skip index properties.
        E2(Ut, ot)) || l1.push(Ut);
      return l1;
    }
    function t5(V, z, ce) {
      (ce !== void 0 && !ba(V[z], ce) || ce === void 0 && !(z in V)) && Ei(V, z, ce);
    }
    function T2(V, z, ce) {
      var Ne = V[z];
      (!(Z1.call(V, z) && ba(Ne, ce)) || ce === void 0 && !(z in V)) && Ei(V, z, ce);
    }
    function A2(V, z) {
      for (var ce = V.length; ce--; )
        if (ba(V[ce][0], z))
          return ce;
      return -1;
    }
    function Ei(V, z, ce) {
      z == "__proto__" && Ti ? Ti(V, z, {
        configurable: !0,
        enumerable: !0,
        value: ce,
        writable: !0
      }) : V[z] = ce;
    }
    var X6 = L2();
    function I2(V) {
      return V == null ? V === void 0 ? k : x : Zr && Zr in Object(V) ? D3(V) : G3(V);
    }
    function k3(V) {
      return zo(V) && I2(V) == l;
    }
    function R3(V) {
      if (!Zo(V) || o5(V))
        return !1;
      var z = c5(V) ? on : ee;
      return z.test(j3(V));
    }
    function _3(V) {
      return zo(V) && J3(V.length) && !!fe[I2(V)];
    }
    function F3(V) {
      if (!Zo(V))
        return Mi(V);
      var z = M2(V), ce = [];
      for (var Ne in V)
        Ne == "constructor" && (z || !Z1.call(V, Ne)) || ce.push(Ne);
      return ce;
    }
    function P3(V, z, ce, Ne, E1) {
      V !== z && X6(z, function(Y1, gt) {
        if (E1 || (E1 = new Li()), Zo(Y1))
          Y6(V, z, gt, ce, P3, Ne, E1);
        else {
          var l1 = Ne ? Ne(i5(V, gt), Y1, gt + "", V, z, E1) : void 0;
          l1 === void 0 && (l1 = Y1), t5(V, gt, l1);
        }
      }, q3);
    }
    function Y6(V, z, ce, Ne, E1, Y1, gt) {
      var l1 = i5(V, ce), ot = i5(z, ce), Ut = gt.get(ot);
      if (Ut) {
        t5(V, ce, Ut);
        return;
      }
      var hn = Y1 ? Y1(l1, ot, ce + "", V, z, gt) : void 0, Go = hn === void 0;
      if (Go) {
        var mn = s5(ot), B2 = !mn && Y3(ot), u5 = !mn && !B2 && Q3(ot);
        hn = ot, mn || B2 || u5 ? s5(l1) ? hn = l1 : X3(l1) ? hn = n5(l1) : B2 ? (Go = !1, hn = V3(ot)) : u5 ? (Go = !1, hn = O3(ot)) : hn = [] : e7(ot) || a5(ot) ? (hn = l1, a5(l1) ? hn = t7(l1) : (!Zo(l1) || c5(l1)) && (hn = Z3(ot))) : Go = !1;
      }
      Go && (gt.set(ot, hn), E1(hn, ot, Ne, Y1, gt), gt.delete(ot)), t5(V, ce, hn);
    }
    function J6(V, z) {
      return $3(W3(V, z, et), V + "");
    }
    var Q6 = Ti ? function(V, z) {
      return Ti(V, "toString", {
        configurable: !0,
        enumerable: !1,
        value: dt(z),
        writable: !0
      });
    } : et;
    function V3(V, z) {
      return V.slice();
    }
    function H3(V) {
      var z = new V.constructor(V.byteLength);
      return new wi(z).set(new wi(V)), z;
    }
    function O3(V, z) {
      var ce = H3(V.buffer);
      return new V.constructor(ce, V.byteOffset, V.length);
    }
    function n5(V, z) {
      var ce = -1, Ne = V.length;
      for (z || (z = Array(Ne)); ++ce < Ne; )
        z[ce] = V[ce];
      return z;
    }
    function q6(V, z, ce, Ne) {
      var E1 = !ce;
      ce || (ce = {});
      for (var Y1 = -1, gt = z.length; ++Y1 < gt; ) {
        var l1 = z[Y1], ot = void 0;
        ot === void 0 && (ot = V[l1]), E1 ? Ei(ce, l1, ot) : T2(ce, l1, ot);
      }
      return ce;
    }
    function N3(V) {
      return J6(function(z, ce) {
        var Ne = -1, E1 = ce.length, Y1 = E1 > 1 ? ce[E1 - 1] : void 0, gt = E1 > 2 ? ce[2] : void 0;
        for (Y1 = V.length > 3 && typeof Y1 == "function" ? (E1--, Y1) : void 0, gt && K6(ce[0], ce[1], gt) && (Y1 = E1 < 3 ? void 0 : Y1, E1 = 1), z = Object(z); ++Ne < E1; ) {
          var l1 = ce[Ne];
          l1 && V(z, l1, Ne, Y1);
        }
        return z;
      });
    }
    function L2(V) {
      return function(z, ce, Ne) {
        for (var E1 = -1, Y1 = Object(z), gt = Ne(z), l1 = gt.length; l1--; ) {
          var ot = gt[++E1];
          if (ce(Y1[ot], ot, Y1) === !1)
            break;
        }
        return z;
      };
    }
    function ga(V, z) {
      var ce = V.__data__;
      return z3(z) ? ce[typeof z == "string" ? "string" : "hash"] : ce.map;
    }
    function r5(V, z) {
      var ce = B1(V, z);
      return R3(ce) ? ce : void 0;
    }
    function D3(V) {
      var z = Z1.call(V, Zr), ce = V[Zr];
      try {
        V[Zr] = void 0;
        var Ne = !0;
      } catch {
      }
      var E1 = ut.call(V);
      return Ne && (z ? V[Zr] = ce : delete V[Zr]), E1;
    }
    function Z3(V) {
      return typeof V.constructor == "function" && !M2(V) ? E3(No(V)) : {};
    }
    function E2(V, z) {
      var ce = typeof V;
      return z = z ?? a, !!z && (ce == "number" || ce != "symbol" && ye.test(V)) && V > -1 && V % 1 == 0 && V < z;
    }
    function K6(V, z, ce) {
      if (!Zo(ce))
        return !1;
      var Ne = typeof z;
      return (Ne == "number" ? l5(ce) && E2(z, ce.length) : Ne == "string" && z in ce) ? ba(ce[z], V) : !1;
    }
    function z3(V) {
      var z = typeof V;
      return z == "string" || z == "number" || z == "symbol" || z == "boolean" ? V !== "__proto__" : V === null;
    }
    function o5(V) {
      return !!r1 && r1 in V;
    }
    function M2(V) {
      var z = V && V.constructor, ce = typeof z == "function" && z.prototype || p1;
      return V === ce;
    }
    function Mi(V) {
      var z = [];
      if (V != null)
        for (var ce in Object(V))
          z.push(ce);
      return z;
    }
    function G3(V) {
      return ut.call(V);
    }
    function W3(V, z, ce) {
      return z = I3(z === void 0 ? V.length - 1 : z, 0), function() {
        for (var Ne = arguments, E1 = -1, Y1 = I3(Ne.length - z, 0), gt = Array(Y1); ++E1 < Y1; )
          gt[E1] = Ne[z + E1];
        E1 = -1;
        for (var l1 = Array(z + 1); ++E1 < z; )
          l1[E1] = Ne[E1];
        return l1[z] = ce(gt), f1(V, this, l1);
      };
    }
    function i5(V, z) {
      if (!(z === "constructor" && typeof V[z] == "function") && z != "__proto__")
        return V[z];
    }
    var $3 = U3(Q6);
    function U3(V) {
      var z = 0, ce = 0;
      return function() {
        var Ne = B6(), E1 = i - (Ne - ce);
        if (ce = Ne, E1 > 0) {
          if (++z >= o)
            return arguments[0];
        } else
          z = 0;
        return V.apply(void 0, arguments);
      };
    }
    function j3(V) {
      if (V != null) {
        try {
          return Ct.call(V);
        } catch {
        }
        try {
          return V + "";
        } catch {
        }
      }
      return "";
    }
    function ba(V, z) {
      return V === z || V !== V && z !== z;
    }
    var a5 = k3(/* @__PURE__ */ function() {
      return arguments;
    }()) ? k3 : function(V) {
      return zo(V) && Z1.call(V, "callee") && !Js.call(V, "callee");
    }, s5 = Array.isArray;
    function l5(V) {
      return V != null && J3(V.length) && !c5(V);
    }
    function X3(V) {
      return zo(V) && l5(V);
    }
    var Y3 = qs || r7;
    function c5(V) {
      if (!Zo(V))
        return !1;
      var z = I2(V);
      return z == C || z == v || z == u || z == A;
    }
    function J3(V) {
      return typeof V == "number" && V > -1 && V % 1 == 0 && V <= a;
    }
    function Zo(V) {
      var z = typeof V;
      return V != null && (z == "object" || z == "function");
    }
    function zo(V) {
      return V != null && typeof V == "object";
    }
    function e7(V) {
      if (!zo(V) || I2(V) != T)
        return !1;
      var z = No(V);
      if (z === null)
        return !0;
      var ce = Z1.call(z, "constructor") && z.constructor;
      return typeof ce == "function" && ce instanceof ce && Ct.call(ce) == rn;
    }
    var Q3 = ie ? Ye(ie) : _3;
    function t7(V) {
      return q6(V, q3(V));
    }
    function q3(V) {
      return l5(V) ? j6(V) : F3(V);
    }
    var n7 = N3(function(V, z, ce, Ne) {
      P3(V, z, ce, Ne);
    });
    function dt(V) {
      return function() {
        return V;
      };
    }
    function et(V) {
      return V;
    }
    function r7() {
      return !1;
    }
    e.exports = n7;
  }(H5, H5.exports)), H5.exports;
}
var DH = NH();
const nr = /* @__PURE__ */ k9(DH);
var ZH = (e) => /!(important)?$/.test(e), _C = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, zH = (e, t) => (n) => {
  const r = String(t), o = ZH(r), i = _C(r), a = e ? `${e}.${i}` : i;
  let l = wn(n.__cssMap) && a in n.__cssMap ? n.__cssMap[a].varRef : t;
  return l = _C(l), o ? `${l} !important` : l;
};
function Yd(e) {
  const { scale: t, transform: n, compose: r } = e;
  return (i, a) => {
    var l;
    const c = zH(t, i)(a);
    let u = (l = n?.(c, a)) != null ? l : c;
    return r && (u = r(u, a)), u;
  };
}
var N4 = (...e) => (t) => e.reduce((n, r) => r(n), t);
function wr(e, t) {
  return (n) => {
    const r = { property: n, scale: e };
    return r.transform = Yd({
      scale: e,
      transform: t
    }), r;
  };
}
var GH = ({ rtl: e, ltr: t }) => (n) => n.direction === "rtl" ? e : t;
function WH(e) {
  const { property: t, scale: n, transform: r } = e;
  return {
    scale: n,
    property: GH(t),
    transform: n ? Yd({
      scale: n,
      compose: r
    }) : r
  };
}
var xw = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function $H() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...xw
  ].join(" ");
}
function UH() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...xw
  ].join(" ");
}
var jH = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, XH = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function YH(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
var JH = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, jc = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, QH = new Set(Object.values(jc)), Xc = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), qH = (e) => e.trim();
function KH(e, t) {
  if (e == null || Xc.has(e))
    return e;
  if (!(Yc(e) || Xc.has(e)))
    return `url('${e}')`;
  const o = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), i = o?.[1], a = o?.[2];
  if (!i || !a)
    return e;
  const l = i.includes("-gradient") ? i : `${i}-gradient`, [c, ...u] = a.split(",").map(qH).filter(Boolean);
  if (u?.length === 0)
    return e;
  const f = c in jc ? jc[c] : c;
  u.unshift(f);
  const p = u.map((h) => {
    if (QH.has(h))
      return h;
    const C = h.indexOf(" "), [v, b] = C !== -1 ? [h.substr(0, C), h.substr(C + 1)] : [h], y = Yc(b) ? b : b && b.split(" "), x = `colors.${v}`, T = x in t.__cssMap ? t.__cssMap[x].varRef : v;
    return y ? [
      T,
      ...Array.isArray(y) ? y : [y]
    ].join(" ") : T;
  });
  return `${l}(${p.join(", ")})`;
}
var Yc = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), eO = (e, t) => KH(e, t ?? {});
function tO(e) {
  return /^var\(--.+\)$/.test(e);
}
var nO = (e) => {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}, co = (e) => (t) => `${e}(${t})`, O1 = {
  filter(e) {
    return e !== "auto" ? e : jH;
  },
  backdropFilter(e) {
    return e !== "auto" ? e : XH;
  },
  ring(e) {
    return YH(O1.px(e));
  },
  bgClip(e) {
    return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
  },
  transform(e) {
    return e === "auto" ? $H() : e === "auto-gpu" ? UH() : e;
  },
  vh(e) {
    return e === "$100vh" ? "var(--chakra-vh)" : e;
  },
  px(e) {
    if (e == null)
      return e;
    const { unitless: t } = nO(e);
    return t || typeof e == "number" ? `${e}px` : e;
  },
  fraction(e) {
    return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
  },
  float(e, t) {
    const n = { left: "right", right: "left" };
    return t.direction === "rtl" ? n[e] : e;
  },
  degree(e) {
    if (tO(e) || e == null)
      return e;
    const t = typeof e == "string" && !e.endsWith("deg");
    return typeof e == "number" || t ? `${e}deg` : e;
  },
  gradient: eO,
  blur: co("blur"),
  opacity: co("opacity"),
  brightness: co("brightness"),
  contrast: co("contrast"),
  dropShadow: co("drop-shadow"),
  grayscale: co("grayscale"),
  hueRotate: co("hue-rotate"),
  invert: co("invert"),
  saturate: co("saturate"),
  sepia: co("sepia"),
  bgImage(e) {
    return e == null || Yc(e) || Xc.has(e) ? e : `url(${e})`;
  },
  outline(e) {
    const t = String(e) === "0" || String(e) === "none";
    return e !== null && t ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: e };
  },
  flexDirection(e) {
    var t;
    const { space: n, divide: r } = (t = JH[e]) != null ? t : {}, o = { flexDirection: e };
    return n && (o[n] = 1), r && (o[r] = 1), o;
  }
}, G = {
  borderWidths: wr("borderWidths"),
  borderStyles: wr("borderStyles"),
  colors: wr("colors"),
  borders: wr("borders"),
  gradients: wr("gradients", O1.gradient),
  radii: wr("radii", O1.px),
  space: wr("space", N4(O1.vh, O1.px)),
  spaceT: wr("space", N4(O1.vh, O1.px)),
  degreeT(e) {
    return { property: e, transform: O1.degree };
  },
  prop(e, t, n) {
    return {
      property: e,
      scale: t,
      ...t && {
        transform: Yd({ scale: t, transform: n })
      }
    };
  },
  propT(e, t) {
    return { property: e, transform: t };
  },
  sizes: wr("sizes", N4(O1.vh, O1.px)),
  sizesT: wr("sizes", N4(O1.vh, O1.fraction)),
  shadows: wr("shadows"),
  logical: WH,
  blur: wr("blur", O1.blur)
}, Cl = {
  background: G.colors("background"),
  backgroundColor: G.colors("backgroundColor"),
  backgroundImage: G.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: O1.bgClip },
  bgSize: G.prop("backgroundSize"),
  bgPosition: G.prop("backgroundPosition"),
  bg: G.colors("background"),
  bgColor: G.colors("backgroundColor"),
  bgPos: G.prop("backgroundPosition"),
  bgRepeat: G.prop("backgroundRepeat"),
  bgAttachment: G.prop("backgroundAttachment"),
  bgGradient: G.gradients("backgroundImage"),
  bgClip: { transform: O1.bgClip }
};
Object.assign(Cl, {
  bgImage: Cl.backgroundImage,
  bgImg: Cl.backgroundImage
});
var G1 = {
  border: G.borders("border"),
  borderWidth: G.borderWidths("borderWidth"),
  borderStyle: G.borderStyles("borderStyle"),
  borderColor: G.colors("borderColor"),
  borderRadius: G.radii("borderRadius"),
  borderTop: G.borders("borderTop"),
  borderBlockStart: G.borders("borderBlockStart"),
  borderTopLeftRadius: G.radii("borderTopLeftRadius"),
  borderStartStartRadius: G.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: G.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: G.radii("borderTopRightRadius"),
  borderStartEndRadius: G.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: G.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: G.borders("borderRight"),
  borderInlineEnd: G.borders("borderInlineEnd"),
  borderBottom: G.borders("borderBottom"),
  borderBlockEnd: G.borders("borderBlockEnd"),
  borderBottomLeftRadius: G.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: G.radii("borderBottomRightRadius"),
  borderLeft: G.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: G.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: G.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: G.borders(["borderLeft", "borderRight"]),
  borderInline: G.borders("borderInline"),
  borderY: G.borders(["borderTop", "borderBottom"]),
  borderBlock: G.borders("borderBlock"),
  borderTopWidth: G.borderWidths("borderTopWidth"),
  borderBlockStartWidth: G.borderWidths("borderBlockStartWidth"),
  borderTopColor: G.colors("borderTopColor"),
  borderBlockStartColor: G.colors("borderBlockStartColor"),
  borderTopStyle: G.borderStyles("borderTopStyle"),
  borderBlockStartStyle: G.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: G.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: G.borderWidths("borderBlockEndWidth"),
  borderBottomColor: G.colors("borderBottomColor"),
  borderBlockEndColor: G.colors("borderBlockEndColor"),
  borderBottomStyle: G.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: G.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: G.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: G.borderWidths("borderInlineStartWidth"),
  borderLeftColor: G.colors("borderLeftColor"),
  borderInlineStartColor: G.colors("borderInlineStartColor"),
  borderLeftStyle: G.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: G.borderStyles("borderInlineStartStyle"),
  borderRightWidth: G.borderWidths("borderRightWidth"),
  borderInlineEndWidth: G.borderWidths("borderInlineEndWidth"),
  borderRightColor: G.colors("borderRightColor"),
  borderInlineEndColor: G.colors("borderInlineEndColor"),
  borderRightStyle: G.borderStyles("borderRightStyle"),
  borderInlineEndStyle: G.borderStyles("borderInlineEndStyle"),
  borderTopRadius: G.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: G.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: G.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: G.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(G1, {
  rounded: G1.borderRadius,
  roundedTop: G1.borderTopRadius,
  roundedTopLeft: G1.borderTopLeftRadius,
  roundedTopRight: G1.borderTopRightRadius,
  roundedTopStart: G1.borderStartStartRadius,
  roundedTopEnd: G1.borderStartEndRadius,
  roundedBottom: G1.borderBottomRadius,
  roundedBottomLeft: G1.borderBottomLeftRadius,
  roundedBottomRight: G1.borderBottomRightRadius,
  roundedBottomStart: G1.borderEndStartRadius,
  roundedBottomEnd: G1.borderEndEndRadius,
  roundedLeft: G1.borderLeftRadius,
  roundedRight: G1.borderRightRadius,
  roundedStart: G1.borderInlineStartRadius,
  roundedEnd: G1.borderInlineEndRadius,
  borderStart: G1.borderInlineStart,
  borderEnd: G1.borderInlineEnd,
  borderTopStartRadius: G1.borderStartStartRadius,
  borderTopEndRadius: G1.borderStartEndRadius,
  borderBottomStartRadius: G1.borderEndStartRadius,
  borderBottomEndRadius: G1.borderEndEndRadius,
  borderStartRadius: G1.borderInlineStartRadius,
  borderEndRadius: G1.borderInlineEndRadius,
  borderStartWidth: G1.borderInlineStartWidth,
  borderEndWidth: G1.borderInlineEndWidth,
  borderStartColor: G1.borderInlineStartColor,
  borderEndColor: G1.borderInlineEndColor,
  borderStartStyle: G1.borderInlineStartStyle,
  borderEndStyle: G1.borderInlineEndStyle
});
var rO = {
  color: G.colors("color"),
  textColor: G.colors("color"),
  fill: G.colors("fill"),
  stroke: G.colors("stroke")
}, Jc = {
  boxShadow: G.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: G.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: G.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(Jc, {
  shadow: Jc.boxShadow
});
var oO = {
  filter: { transform: O1.filter },
  blur: G.blur("--chakra-blur"),
  brightness: G.propT("--chakra-brightness", O1.brightness),
  contrast: G.propT("--chakra-contrast", O1.contrast),
  hueRotate: G.degreeT("--chakra-hue-rotate"),
  invert: G.propT("--chakra-invert", O1.invert),
  saturate: G.propT("--chakra-saturate", O1.saturate),
  dropShadow: G.propT("--chakra-drop-shadow", O1.dropShadow),
  backdropFilter: { transform: O1.backdropFilter },
  backdropBlur: G.blur("--chakra-backdrop-blur"),
  backdropBrightness: G.propT(
    "--chakra-backdrop-brightness",
    O1.brightness
  ),
  backdropContrast: G.propT("--chakra-backdrop-contrast", O1.contrast),
  backdropHueRotate: G.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: G.propT("--chakra-backdrop-invert", O1.invert),
  backdropSaturate: G.propT("--chakra-backdrop-saturate", O1.saturate)
}, Ul = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: O1.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: G.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: G.space("gap"),
  rowGap: G.space("rowGap"),
  columnGap: G.space("columnGap")
};
Object.assign(Ul, {
  flexDir: Ul.flexDirection
});
var ww = {
  gridGap: G.space("gridGap"),
  gridColumnGap: G.space("gridColumnGap"),
  gridRowGap: G.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, iO = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: O1.outline },
  outlineOffset: !0,
  outlineColor: G.colors("outlineColor")
}, Ar = {
  width: G.sizesT("width"),
  inlineSize: G.sizesT("inlineSize"),
  height: G.sizes("height"),
  blockSize: G.sizes("blockSize"),
  boxSize: G.sizes(["width", "height"]),
  minWidth: G.sizes("minWidth"),
  minInlineSize: G.sizes("minInlineSize"),
  minHeight: G.sizes("minHeight"),
  minBlockSize: G.sizes("minBlockSize"),
  maxWidth: G.sizes("maxWidth"),
  maxInlineSize: G.sizes("maxInlineSize"),
  maxHeight: G.sizes("maxHeight"),
  maxBlockSize: G.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (e, t) => {
      var n, r, o;
      return { [`@media screen and (min-width: ${(o = (r = (n = t.__breakpoints) == null ? void 0 : n.get(e)) == null ? void 0 : r.minW) != null ? o : e})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (e, t) => {
      var n, r, o;
      return { [`@media screen and (max-width: ${(o = (r = (n = t.__breakpoints) == null ? void 0 : n.get(e)) == null ? void 0 : r._minW) != null ? o : e})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: G.propT("float", O1.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Ar, {
  w: Ar.width,
  h: Ar.height,
  minW: Ar.minWidth,
  maxW: Ar.maxWidth,
  minH: Ar.minHeight,
  maxH: Ar.maxHeight,
  overscroll: Ar.overscrollBehavior,
  overscrollX: Ar.overscrollBehaviorX,
  overscrollY: Ar.overscrollBehaviorY
});
var aO = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: G.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: G.prop("listStyleImage")
};
function sO(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
var lO = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, i, a) => {
    if (typeof r > "u")
      return e(r, o, i);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const l = t.get(r);
    if (l.has(o))
      return l.get(o);
    const c = e(r, o, i, a);
    return l.set(o, c), c;
  };
}, cO = lO(sO), uO = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, dO = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, l8 = (e, t, n) => {
  const r = {}, o = cO(e, t, {});
  for (const i in o)
    i in n && n[i] != null || (r[i] = o[i]);
  return r;
}, fO = {
  srOnly: {
    transform(e) {
      return e === !0 ? uO : e === "focusable" ? dO : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (e, t, n) => l8(t, `layerStyles.${e}`, n)
  },
  textStyle: {
    processResult: !0,
    transform: (e, t, n) => l8(t, `textStyles.${e}`, n)
  },
  apply: {
    processResult: !0,
    transform: (e, t, n) => l8(t, e, n)
  }
}, Y5 = {
  position: !0,
  pos: G.prop("position"),
  zIndex: G.prop("zIndex", "zIndices"),
  inset: G.spaceT("inset"),
  insetX: G.spaceT(["left", "right"]),
  insetInline: G.spaceT("insetInline"),
  insetY: G.spaceT(["top", "bottom"]),
  insetBlock: G.spaceT("insetBlock"),
  top: G.spaceT("top"),
  insetBlockStart: G.spaceT("insetBlockStart"),
  bottom: G.spaceT("bottom"),
  insetBlockEnd: G.spaceT("insetBlockEnd"),
  left: G.spaceT("left"),
  insetInlineStart: G.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: G.spaceT("right"),
  insetInlineEnd: G.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(Y5, {
  insetStart: Y5.insetInlineStart,
  insetEnd: Y5.insetInlineEnd
});
var pO = {
  ring: { transform: O1.ring },
  ringColor: G.colors("--chakra-ring-color"),
  ringOffset: G.prop("--chakra-ring-offset-width"),
  ringOffsetColor: G.colors("--chakra-ring-offset-color"),
  ringInset: G.prop("--chakra-ring-inset")
}, yt = {
  margin: G.spaceT("margin"),
  marginTop: G.spaceT("marginTop"),
  marginBlockStart: G.spaceT("marginBlockStart"),
  marginRight: G.spaceT("marginRight"),
  marginInlineEnd: G.spaceT("marginInlineEnd"),
  marginBottom: G.spaceT("marginBottom"),
  marginBlockEnd: G.spaceT("marginBlockEnd"),
  marginLeft: G.spaceT("marginLeft"),
  marginInlineStart: G.spaceT("marginInlineStart"),
  marginX: G.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: G.spaceT("marginInline"),
  marginY: G.spaceT(["marginTop", "marginBottom"]),
  marginBlock: G.spaceT("marginBlock"),
  padding: G.space("padding"),
  paddingTop: G.space("paddingTop"),
  paddingBlockStart: G.space("paddingBlockStart"),
  paddingRight: G.space("paddingRight"),
  paddingBottom: G.space("paddingBottom"),
  paddingBlockEnd: G.space("paddingBlockEnd"),
  paddingLeft: G.space("paddingLeft"),
  paddingInlineStart: G.space("paddingInlineStart"),
  paddingInlineEnd: G.space("paddingInlineEnd"),
  paddingX: G.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: G.space("paddingInline"),
  paddingY: G.space(["paddingTop", "paddingBottom"]),
  paddingBlock: G.space("paddingBlock")
};
Object.assign(yt, {
  m: yt.margin,
  mt: yt.marginTop,
  mr: yt.marginRight,
  me: yt.marginInlineEnd,
  marginEnd: yt.marginInlineEnd,
  mb: yt.marginBottom,
  ml: yt.marginLeft,
  ms: yt.marginInlineStart,
  marginStart: yt.marginInlineStart,
  mx: yt.marginX,
  my: yt.marginY,
  p: yt.padding,
  pt: yt.paddingTop,
  py: yt.paddingY,
  px: yt.paddingX,
  pb: yt.paddingBottom,
  pl: yt.paddingLeft,
  ps: yt.paddingInlineStart,
  paddingStart: yt.paddingInlineStart,
  pr: yt.paddingRight,
  pe: yt.paddingInlineEnd,
  paddingEnd: yt.paddingInlineEnd
});
var hO = {
  textDecorationColor: G.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: G.shadows("textShadow")
}, mO = {
  clipPath: !0,
  transform: G.propT("transform", O1.transform),
  transformOrigin: !0,
  translateX: G.spaceT("--chakra-translate-x"),
  translateY: G.spaceT("--chakra-translate-y"),
  skewX: G.degreeT("--chakra-skew-x"),
  skewY: G.degreeT("--chakra-skew-y"),
  scaleX: G.prop("--chakra-scale-x"),
  scaleY: G.prop("--chakra-scale-y"),
  scale: G.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: G.degreeT("--chakra-rotate")
}, CO = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: G.prop("transitionDuration", "transition.duration"),
  transitionProperty: G.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: G.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, gO = {
  fontFamily: G.prop("fontFamily", "fonts"),
  fontSize: G.prop("fontSize", "fontSizes", O1.px),
  fontWeight: G.prop("fontWeight", "fontWeights"),
  lineHeight: G.prop("lineHeight", "lineHeights"),
  letterSpacing: G.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(e) {
      if (e === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, bO = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  scrollMargin: G.spaceT("scrollMargin"),
  scrollMarginTop: G.spaceT("scrollMarginTop"),
  scrollMarginBottom: G.spaceT("scrollMarginBottom"),
  scrollMarginLeft: G.spaceT("scrollMarginLeft"),
  scrollMarginRight: G.spaceT("scrollMarginRight"),
  scrollMarginX: G.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: G.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  scrollPadding: G.spaceT("scrollPadding"),
  scrollPaddingTop: G.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: G.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: G.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: G.spaceT("scrollPaddingRight"),
  scrollPaddingX: G.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: G.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function Sw(e) {
  return wn(e) && e.reference ? e.reference : String(e);
}
var R9 = (e, ...t) => t.map(Sw).join(` ${e} `).replace(/calc/g, ""), FC = (...e) => `calc(${R9("+", ...e)})`, PC = (...e) => `calc(${R9("-", ...e)})`, Qc = (...e) => `calc(${R9("*", ...e)})`, VC = (...e) => `calc(${R9("/", ...e)})`, HC = (e) => {
  const t = Sw(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : Qc(t, -1);
}, Ra = Object.assign(
  (e) => ({
    add: (...t) => Ra(FC(e, ...t)),
    subtract: (...t) => Ra(PC(e, ...t)),
    multiply: (...t) => Ra(Qc(e, ...t)),
    divide: (...t) => Ra(VC(e, ...t)),
    negate: () => Ra(HC(e)),
    toString: () => e.toString()
  }),
  {
    add: FC,
    subtract: PC,
    multiply: Qc,
    divide: VC,
    negate: HC
  }
);
function vO(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function yO(e) {
  const t = vO(e.toString());
  return wO(xO(t));
}
function xO(e) {
  return e.includes("\\.") ? e : !Number.isInteger(parseFloat(e.toString())) ? e.replace(".", "\\.") : e;
}
function wO(e) {
  return e.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function SO(e, t = "") {
  return [t, e].filter(Boolean).join("-");
}
function TO(e, t) {
  return `var(${e}${t ? `, ${t}` : ""})`;
}
function AO(e, t = "") {
  return yO(`--${SO(e, t)}`);
}
function a1(e, t, n) {
  const r = AO(e, n);
  return {
    variable: r,
    reference: TO(r, t)
  };
}
function IO(e, t) {
  const n = {};
  for (const r of t) {
    if (Array.isArray(r)) {
      const [o, i] = r;
      n[o] = a1(`${e}-${o}`, i);
      continue;
    }
    n[r] = a1(`${e}-${r}`);
  }
  return n;
}
function LO(e) {
  const t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function EO(e) {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}
function qc(e) {
  if (e == null)
    return e;
  const { unitless: t } = EO(e);
  return t || typeof e == "number" ? `${e}px` : e;
}
var Tw = (e, t) => parseInt(e[1], 10) > parseInt(t[1], 10) ? 1 : -1, Jd = (e) => Object.fromEntries(Object.entries(e).sort(Tw));
function OC(e) {
  const t = Jd(e);
  return Object.assign(Object.values(t), t);
}
function MO(e) {
  const t = Object.keys(Jd(e));
  return new Set(t);
}
function NC(e) {
  var t;
  if (!e)
    return e;
  e = (t = qc(e)) != null ? t : e;
  const n = -0.02;
  return typeof e == "number" ? `${e + n}` : e.replace(/(\d+\.?\d*)/u, (r) => `${parseFloat(r) + n}`);
}
function O5(e, t) {
  const n = ["@media screen"];
  return e && n.push("and", `(min-width: ${qc(e)})`), t && n.push("and", `(max-width: ${qc(t)})`), n.join(" ");
}
function BO(e) {
  var t;
  if (!e)
    return null;
  e.base = (t = e.base) != null ? t : "0px";
  const n = OC(e), r = Object.entries(e).sort(Tw).map(([a, l], c, u) => {
    var f;
    let [, p] = (f = u[c + 1]) != null ? f : [];
    return p = parseFloat(p) > 0 ? NC(p) : void 0, {
      _minW: NC(l),
      breakpoint: a,
      minW: l,
      maxW: p,
      maxWQuery: O5(null, p),
      minWQuery: O5(l),
      minMaxQuery: O5(l, p)
    };
  }), o = MO(e), i = Array.from(o.values());
  return {
    keys: o,
    normalized: n,
    isResponsive(a) {
      const l = Object.keys(a);
      return l.length > 0 && l.every((c) => o.has(c));
    },
    asObject: Jd(e),
    asArray: OC(e),
    details: r,
    get(a) {
      return r.find((l) => l.breakpoint === a);
    },
    media: [
      null,
      ...n.map((a) => O5(a)).slice(1)
    ],
    toArrayValue(a) {
      if (!wn(a))
        throw new Error("toArrayValue: value must be an object");
      const l = i.map((c) => {
        var u;
        return (u = a[c]) != null ? u : null;
      });
      for (; LO(l) === null; )
        l.pop();
      return l;
    },
    toObjectValue(a) {
      if (!Array.isArray(a))
        throw new Error("toObjectValue: value must be an array");
      return a.reduce((l, c, u) => {
        const f = i[u];
        return f != null && c != null && (l[f] = c), l;
      }, {});
    }
  };
}
var un = {
  hover: (e, t) => `${e}:hover ${t}, ${e}[data-hover] ${t}`,
  focus: (e, t) => `${e}:focus ${t}, ${e}[data-focus] ${t}`,
  focusVisible: (e, t) => `${e}:focus-visible ${t}`,
  focusWithin: (e, t) => `${e}:focus-within ${t}`,
  active: (e, t) => `${e}:active ${t}, ${e}[data-active] ${t}`,
  disabled: (e, t) => `${e}:disabled ${t}, ${e}[data-disabled] ${t}`,
  invalid: (e, t) => `${e}:invalid ${t}, ${e}[data-invalid] ${t}`,
  checked: (e, t) => `${e}:checked ${t}, ${e}[data-checked] ${t}`,
  indeterminate: (e, t) => `${e}:indeterminate ${t}, ${e}[aria-checked=mixed] ${t}, ${e}[data-indeterminate] ${t}`,
  readOnly: (e, t) => `${e}:read-only ${t}, ${e}[readonly] ${t}, ${e}[data-read-only] ${t}`,
  expanded: (e, t) => `${e}:read-only ${t}, ${e}[aria-expanded=true] ${t}, ${e}[data-expanded] ${t}`,
  placeholderShown: (e, t) => `${e}:placeholder-shown ${t}`
}, Ni = (e) => Aw((t) => e(t, "&"), "[role=group]", "[data-group]", ".group"), Ko = (e) => Aw((t) => e(t, "~ &"), "[data-peer]", ".peer"), Aw = (e, ...t) => t.map(e).join(", "), _9 = {
  _hover: "&:hover, &[data-hover]",
  _active: "&:active, &[data-active]",
  _focus: "&:focus, &[data-focus]",
  _highlighted: "&[data-highlighted]",
  _focusWithin: "&:focus-within",
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  _before: "&::before",
  _after: "&::after",
  _empty: "&:empty",
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  _checked: "&[aria-checked=true], &[data-checked]",
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  _valid: "&[data-valid], &[data-state=valid]",
  _loading: "&[data-loading], &[aria-busy=true]",
  _selected: "&[aria-selected=true], &[data-selected]",
  _hidden: "&[hidden], &[data-hidden]",
  _autofill: "&:-webkit-autofill",
  _even: "&:nth-of-type(even)",
  _odd: "&:nth-of-type(odd)",
  _first: "&:first-of-type",
  _firstLetter: "&::first-letter",
  _last: "&:last-of-type",
  _notFirst: "&:not(:first-of-type)",
  _notLast: "&:not(:last-of-type)",
  _visited: "&:visited",
  _activeLink: "&[aria-current=page]",
  _activeStep: "&[aria-current=step]",
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  _groupHover: Ni(un.hover),
  _peerHover: Ko(un.hover),
  _groupFocus: Ni(un.focus),
  _peerFocus: Ko(un.focus),
  _groupFocusVisible: Ni(un.focusVisible),
  _peerFocusVisible: Ko(un.focusVisible),
  _groupActive: Ni(un.active),
  _peerActive: Ko(un.active),
  _groupDisabled: Ni(un.disabled),
  _peerDisabled: Ko(un.disabled),
  _groupInvalid: Ni(un.invalid),
  _peerInvalid: Ko(un.invalid),
  _groupChecked: Ni(un.checked),
  _peerChecked: Ko(un.checked),
  _groupFocusWithin: Ni(un.focusWithin),
  _peerFocusWithin: Ko(un.focusWithin),
  _peerPlaceholderShown: Ko(un.placeholderShown),
  _placeholder: "&::placeholder",
  _placeholderShown: "&:placeholder-shown",
  _fullScreen: "&:fullscreen",
  _selection: "&::selection",
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  _mediaDark: "@media (prefers-color-scheme: dark)",
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  _horizontal: "&[data-orientation=horizontal]",
  _vertical: "&[data-orientation=vertical]"
}, Iw = Object.keys(
  _9
);
function DC(e, t) {
  return a1(String(e).replace(/\./g, "-"), void 0, t);
}
function kO(e, t) {
  let n = {};
  const r = {};
  for (const [o, i] of Object.entries(e)) {
    const { isSemantic: a, value: l } = i, { variable: c, reference: u } = DC(o, t?.cssVarPrefix);
    if (!a) {
      if (o.startsWith("space")) {
        const h = o.split("."), [C, ...v] = h, b = `${C}.-${v.join(".")}`, y = Ra.negate(l), x = Ra.negate(u);
        r[b] = {
          value: y,
          var: c,
          varRef: x
        };
      }
      n[c] = l, r[o] = {
        value: l,
        var: c,
        varRef: u
      };
      continue;
    }
    const f = (h) => {
      const v = [String(o).split(".")[0], h].join(".");
      if (!e[v])
        return h;
      const { reference: y } = DC(v, t?.cssVarPrefix);
      return y;
    }, p = wn(l) ? l : { default: l };
    n = nr(
      n,
      Object.entries(p).reduce(
        (h, [C, v]) => {
          var b, y;
          if (!v)
            return h;
          const x = f(`${v}`);
          if (C === "default")
            return h[c] = x, h;
          const T = (y = (b = _9) == null ? void 0 : b[C]) != null ? y : C;
          return h[T] = { [c]: x }, h;
        },
        {}
      )
    ), r[o] = {
      value: u,
      var: c,
      varRef: u
    };
  }
  return {
    cssVars: n,
    cssMap: r
  };
}
function RO(e, t = []) {
  const n = Object.assign({}, e);
  for (const r of t)
    r in n && delete n[r];
  return n;
}
function _O(e, t) {
  const n = {};
  for (const r of t)
    r in e && (n[r] = e[r]);
  return n;
}
function FO(e) {
  return typeof e == "object" && e != null && !Array.isArray(e);
}
function ZC(e, t, n = {}) {
  const { stop: r, getKey: o } = n;
  function i(a, l = []) {
    var c;
    if (FO(a) || Array.isArray(a)) {
      const u = {};
      for (const [f, p] of Object.entries(a)) {
        const h = (c = o?.(f)) != null ? c : f, C = [...l, h];
        if (r?.(a, C))
          return t(a, l);
        u[h] = i(p, C);
      }
      return u;
    }
    return t(a, l);
  }
  return i(e);
}
var PO = [
  "colors",
  "borders",
  "borderWidths",
  "borderStyles",
  "fonts",
  "fontSizes",
  "fontWeights",
  "gradients",
  "letterSpacings",
  "lineHeights",
  "radii",
  "space",
  "shadows",
  "sizes",
  "zIndices",
  "transition",
  "blur",
  "breakpoints"
];
function VO(e) {
  return _O(e, PO);
}
function HO(e) {
  return e.semanticTokens;
}
function OO(e) {
  const { __cssMap: t, __cssVars: n, __breakpoints: r, ...o } = e;
  return o;
}
var NO = (e) => Iw.includes(e) || e === "default";
function DO({
  tokens: e,
  semanticTokens: t
}) {
  const n = {};
  return ZC(e, (r, o) => {
    r != null && (n[o.join(".")] = { isSemantic: !1, value: r });
  }), ZC(
    t,
    (r, o) => {
      r != null && (n[o.join(".")] = { isSemantic: !0, value: r });
    },
    {
      stop: (r) => Object.keys(r).every(NO)
    }
  ), n;
}
function ZO(e) {
  var t;
  const n = OO(e), r = VO(n), o = HO(n), i = DO({ tokens: r, semanticTokens: o }), a = (t = n.config) == null ? void 0 : t.cssVarPrefix, {
    cssMap: l,
    cssVars: c
  } = kO(i, { cssVarPrefix: a });
  return Object.assign(n, {
    __cssVars: { ...{
      "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
      "--chakra-ring-offset-width": "0px",
      "--chakra-ring-offset-color": "#fff",
      "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
      "--chakra-ring-offset-shadow": "0 0 #0000",
      "--chakra-ring-shadow": "0 0 #0000",
      "--chakra-space-x-reverse": "0",
      "--chakra-space-y-reverse": "0"
    }, ...c },
    __cssMap: l,
    __breakpoints: BO(n.breakpoints)
  }), n;
}
var Qd = nr(
  {},
  Cl,
  G1,
  rO,
  Ul,
  Ar,
  oO,
  pO,
  iO,
  ww,
  fO,
  Y5,
  Jc,
  yt,
  bO,
  gO,
  hO,
  mO,
  aO,
  CO
);
Object.assign({}, yt, Ar, Ul, ww, Y5);
var zO = [...Object.keys(Qd), ...Iw], GO = { ...Qd, ..._9 }, WO = (e) => e in GO, $O = (e) => (t) => {
  if (!t.__breakpoints)
    return e;
  const { isResponsive: n, toArrayValue: r, media: o } = t.__breakpoints, i = {};
  for (const a in e) {
    let l = Er(e[a], t);
    if (l == null)
      continue;
    if (l = wn(l) && n(l) ? r(l) : l, !Array.isArray(l)) {
      i[a] = l;
      continue;
    }
    const c = l.slice(0, o.length).length;
    for (let u = 0; u < c; u += 1) {
      const f = o?.[u];
      if (!f) {
        i[a] = l[u];
        continue;
      }
      i[f] = i[f] || {}, l[u] != null && (i[f][a] = l[u]);
    }
  }
  return i;
};
function UO(e) {
  const t = [];
  let n = "", r = !1;
  for (let o = 0; o < e.length; o++) {
    const i = e[o];
    i === "(" ? (r = !0, n += i) : i === ")" ? (r = !1, n += i) : i === "," && !r ? (t.push(n), n = "") : n += i;
  }
  return n = n.trim(), n && t.push(n), t;
}
function jO(e) {
  return /^var\(--.+\)$/.test(e);
}
var XO = (e, t) => e.startsWith("--") && typeof t == "string" && !jO(t), YO = (e, t) => {
  var n, r;
  if (t == null)
    return t;
  const o = (c) => {
    var u, f;
    return (f = (u = e.__cssMap) == null ? void 0 : u[c]) == null ? void 0 : f.varRef;
  }, i = (c) => {
    var u;
    return (u = o(c)) != null ? u : c;
  }, [a, l] = UO(t);
  return t = (r = (n = o(a)) != null ? n : i(l)) != null ? r : i(t), t;
};
function JO(e) {
  const { configs: t = {}, pseudos: n = {}, theme: r } = e, o = (i, a = !1) => {
    var l, c, u;
    const f = Er(i, r), p = $O(f)(r);
    let h = {};
    for (let C in p) {
      const v = p[C];
      let b = Er(v, r);
      C in n && (C = n[C]), XO(C, b) && (b = YO(r, b));
      let y = t[C];
      if (y === !0 && (y = { property: C }), wn(b)) {
        h[C] = (l = h[C]) != null ? l : {}, h[C] = nr(
          {},
          h[C],
          o(b, !0)
        );
        continue;
      }
      let x = (u = (c = y?.transform) == null ? void 0 : c.call(y, b, r, f)) != null ? u : b;
      x = y?.processResult ? o(x, !0) : x;
      const T = Er(y?.property, r);
      if (!a && y?.static) {
        const A = Er(y.static, r);
        h = nr({}, h, A);
      }
      if (T && Array.isArray(T)) {
        for (const A of T)
          h[A] = x;
        continue;
      }
      if (T) {
        T === "&" && wn(x) ? h = nr({}, h, x) : h[T] = x;
        continue;
      }
      if (wn(x)) {
        h = nr({}, h, x);
        continue;
      }
      h[C] = x;
    }
    return h;
  };
  return o;
}
var F9 = (e) => (t) => JO({
  theme: t,
  pseudos: _9,
  configs: Qd
})(e);
function vt(e) {
  return {
    definePartsStyle(t) {
      return t;
    },
    defineMultiStyleConfig(t) {
      return { parts: e, ...t };
    }
  };
}
function QO(e, t) {
  if (Array.isArray(e))
    return e;
  if (wn(e))
    return t(e);
  if (e != null)
    return [e];
}
function qO(e, t) {
  for (let n = t + 1; n < e.length; n++)
    if (e[n] != null)
      return n;
  return -1;
}
function KO(e) {
  const t = e.__breakpoints;
  return function(r, o, i, a) {
    var l, c;
    if (!t)
      return;
    const u = {}, f = QO(i, t.toArrayValue);
    if (!f)
      return u;
    const p = f.length, h = p === 1, C = !!r.parts;
    for (let v = 0; v < p; v++) {
      const b = t.details[v], y = t.details[qO(f, v)], x = O5(b.minW, y?._minW), T = Er((l = r[o]) == null ? void 0 : l[f[v]], a);
      if (T) {
        if (C) {
          (c = r.parts) == null || c.forEach((A) => {
            nr(u, {
              [A]: h ? T[A] : { [x]: T[A] }
            });
          });
          continue;
        }
        if (!C) {
          h ? nr(u, T) : u[x] = T;
          continue;
        }
        u[x] = T;
      }
    }
    return u;
  };
}
function eN(e) {
  return (t) => {
    var n;
    const { variant: r, size: o, theme: i } = t, a = KO(i);
    return nr(
      {},
      Er((n = e.baseStyle) != null ? n : {}, t),
      a(e, "sizes", o, t),
      a(e, "variants", r, t)
    );
  };
}
function Lw(e, t, n) {
  var r, o, i;
  return (i = (o = (r = e.__cssMap) == null ? void 0 : r[`${t}.${n}`]) == null ? void 0 : o.varRef) != null ? i : n;
}
function fr(e) {
  return RO(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
var tN = [
  "borders",
  "breakpoints",
  "colors",
  "components",
  "config",
  "direction",
  "fonts",
  "fontSizes",
  "fontWeights",
  "letterSpacings",
  "lineHeights",
  "radii",
  "shadows",
  "sizes",
  "space",
  "styles",
  "transition",
  "zIndices"
];
function nN(e) {
  return wn(e) ? tN.every(
    (t) => Object.prototype.hasOwnProperty.call(e, t)
  ) : !1;
}
var rN = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, oN = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, iN = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, aN = {
  property: rN,
  easing: oN,
  duration: iN
}, sN = aN, lN = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, cN = lN, uN = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, dN = uN, fN = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}, pN = fN, hN = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  linkedin: {
    50: "#E8F4F9",
    100: "#CFEDFB",
    200: "#9BDAF3",
    300: "#68C7EC",
    400: "#34B3E4",
    500: "#00A0DC",
    600: "#008CC9",
    700: "#0077B5",
    800: "#005E93",
    900: "#004471"
  },
  facebook: {
    50: "#E8F4F9",
    100: "#D9DEE9",
    200: "#B7C2DA",
    300: "#6482C0",
    400: "#4267B2",
    500: "#385898",
    600: "#314E89",
    700: "#29487D",
    800: "#223B67",
    900: "#1E355B"
  },
  messenger: {
    50: "#D0E6FF",
    100: "#B9DAFF",
    200: "#A2CDFF",
    300: "#7AB8FF",
    400: "#2E90FF",
    500: "#0078FF",
    600: "#0063D1",
    700: "#0052AC",
    800: "#003C7E",
    900: "#002C5C"
  },
  whatsapp: {
    50: "#dffeec",
    100: "#b9f5d0",
    200: "#90edb3",
    300: "#65e495",
    400: "#3cdd78",
    500: "#22c35e",
    600: "#179848",
    700: "#0c6c33",
    800: "#01421c",
    900: "#001803"
  },
  twitter: {
    50: "#E5F4FD",
    100: "#C8E9FB",
    200: "#A8DCFA",
    300: "#83CDF7",
    400: "#57BBF5",
    500: "#1DA1F2",
    600: "#1A94DA",
    700: "#1681BF",
    800: "#136B9E",
    900: "#0D4D71"
  },
  telegram: {
    50: "#E3F2F9",
    100: "#C5E4F3",
    200: "#A2D4EC",
    300: "#7AC1E4",
    400: "#47A9DA",
    500: "#0088CC",
    600: "#007AB8",
    700: "#006BA1",
    800: "#005885",
    900: "#003F5E"
  }
}, mN = hN, CN = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, gN = CN, bN = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, vN = bN, yN = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, xN = yN, wN = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    "3xs": "0.45rem",
    "2xs": "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, Ew = wN, Mw = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, SN = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem",
  prose: "60ch"
}, TN = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, AN = {
  ...Mw,
  ...SN,
  container: TN
}, Bw = AN, kw = {
  breakpoints: pN,
  zIndices: cN,
  radii: gN,
  blur: xN,
  colors: mN,
  ...Ew,
  sizes: Bw,
  shadows: vN,
  space: Mw,
  borders: dN,
  transition: sN
}, { defineMultiStyleConfig: IN, definePartsStyle: N5 } = vt([
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
]), ti = a1("stepper-indicator-size"), q2 = a1("stepper-icon-size"), K2 = a1("stepper-title-font-size"), D5 = a1("stepper-description-font-size"), I5 = a1("stepper-accent-color"), LN = N5(({ colorScheme: e }) => ({
  stepper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "4",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center"
    },
    [I5.variable]: `colors.${e}.500`,
    _dark: {
      [I5.variable]: `colors.${e}.200`
    }
  },
  title: {
    fontSize: K2.reference,
    fontWeight: "medium"
  },
  description: {
    fontSize: D5.reference,
    color: "chakra-subtle-text"
  },
  number: {
    fontSize: K2.reference
  },
  step: {
    flexShrink: 0,
    position: "relative",
    display: "flex",
    gap: "2",
    "&[data-orientation=horizontal]": {
      alignItems: "center"
    },
    flex: "1",
    "&:last-of-type:not([data-stretch])": {
      flex: "initial"
    }
  },
  icon: {
    flexShrink: 0,
    width: q2.reference,
    height: q2.reference
  },
  indicator: {
    flexShrink: 0,
    borderRadius: "full",
    width: ti.reference,
    height: ti.reference,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&[data-status=active]": {
      borderWidth: "2px",
      borderColor: I5.reference
    },
    "&[data-status=complete]": {
      bg: I5.reference,
      color: "chakra-inverse-text"
    },
    "&[data-status=incomplete]": {
      borderWidth: "2px"
    }
  },
  separator: {
    bg: "chakra-border-color",
    flex: "1",
    "&[data-status=complete]": {
      bg: I5.reference
    },
    "&[data-orientation=horizontal]": {
      width: "100%",
      height: "2px",
      marginStart: "2"
    },
    "&[data-orientation=vertical]": {
      width: "2px",
      position: "absolute",
      height: "100%",
      maxHeight: `calc(100% - ${ti.reference} - 8px)`,
      top: `calc(${ti.reference} + 4px)`,
      insetStart: `calc(${ti.reference} / 2 - 1px)`
    }
  }
})), EN = IN({
  baseStyle: LN,
  sizes: {
    xs: N5({
      stepper: {
        [ti.variable]: "sizes.4",
        [q2.variable]: "sizes.3",
        [K2.variable]: "fontSizes.xs",
        [D5.variable]: "fontSizes.xs"
      }
    }),
    sm: N5({
      stepper: {
        [ti.variable]: "sizes.6",
        [q2.variable]: "sizes.4",
        [K2.variable]: "fontSizes.sm",
        [D5.variable]: "fontSizes.xs"
      }
    }),
    md: N5({
      stepper: {
        [ti.variable]: "sizes.8",
        [q2.variable]: "sizes.5",
        [K2.variable]: "fontSizes.md",
        [D5.variable]: "fontSizes.sm"
      }
    }),
    lg: N5({
      stepper: {
        [ti.variable]: "sizes.10",
        [q2.variable]: "sizes.6",
        [K2.variable]: "fontSizes.lg",
        [D5.variable]: "fontSizes.md"
      }
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});
function K1(e, t = {}) {
  let n = !1;
  function r() {
    if (!n) {
      n = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function o(...f) {
    r();
    for (const p of f)
      t[p] = c(p);
    return K1(e, t);
  }
  function i(...f) {
    for (const p of f)
      p in t || (t[p] = c(p));
    return K1(e, t);
  }
  function a() {
    return Object.fromEntries(
      Object.entries(t).map(([p, h]) => [p, h.selector])
    );
  }
  function l() {
    return Object.fromEntries(
      Object.entries(t).map(([p, h]) => [p, h.className])
    );
  }
  function c(f) {
    const C = `chakra-${(["container", "root"].includes(f ?? "") ? [e] : [e, f]).filter(Boolean).join("__")}`;
    return {
      className: C,
      selector: `.${C}`,
      toString: () => f
    };
  }
  return {
    parts: o,
    toPart: c,
    extend: i,
    selectors: a,
    classnames: l,
    get keys() {
      return Object.keys(t);
    },
    __type: {}
  };
}
var Rw = K1("accordion").parts("root", "container", "button", "panel").extend("icon"), MN = K1("alert").parts("title", "description", "container").extend("icon", "spinner"), BN = K1("avatar").parts("label", "badge", "container").extend("excessLabel", "group"), kN = K1("breadcrumb").parts("link", "item", "container").extend("separator");
K1("button").parts();
var RN = K1("checkbox").parts("control", "icon", "container").extend("label");
K1("progress").parts("track", "filledTrack").extend("label");
var _N = K1("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), FN = K1("editable").parts(
  "preview",
  "input",
  "textarea"
), _w = K1("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
), Fw = K1("formError").parts("text", "icon"), Pw = K1("input").parts("addon", "field", "element"), PN = K1("list").parts("container", "item", "icon"), VN = K1("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider"), Vw = K1("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), HN = K1("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
K1("pininput").parts("field");
var Hw = K1("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton"), ON = K1("progress").parts(
  "label",
  "filledTrack",
  "track"
), NN = K1("radio").parts(
  "container",
  "control",
  "label"
), DN = K1("select").parts("field", "icon"), ZN = K1("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
), zN = K1("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
), GN = K1("switch").parts(
  "container",
  "track",
  "thumb"
), Ow = K1("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
), Nw = K1("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
), Dw = K1("tag").parts(
  "container",
  "label",
  "closeButton"
), WN = K1("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
function Pa(e, t, n) {
  return Math.min(Math.max(e, n), t);
}
class $N extends Error {
  constructor(t) {
    super(`Failed to parse color: "${t}"`);
  }
}
var Z5 = $N;
function qd(e) {
  if (typeof e != "string") throw new Z5(e);
  if (e.trim().toLowerCase() === "transparent") return [0, 0, 0, 0];
  let t = e.trim();
  t = KN.test(e) ? XN(e) : e;
  const n = YN.exec(t);
  if (n) {
    const a = Array.from(n).slice(1);
    return [...a.slice(0, 3).map((l) => parseInt(C0(l, 2), 16)), parseInt(C0(a[3] || "f", 2), 16) / 255];
  }
  const r = JN.exec(t);
  if (r) {
    const a = Array.from(r).slice(1);
    return [...a.slice(0, 3).map((l) => parseInt(l, 16)), parseInt(a[3] || "ff", 16) / 255];
  }
  const o = QN.exec(t);
  if (o) {
    const a = Array.from(o).slice(1);
    return [...a.slice(0, 3).map((l) => parseInt(l, 10)), parseFloat(a[3] || "1")];
  }
  const i = qN.exec(t);
  if (i) {
    const [a, l, c, u] = Array.from(i).slice(1).map(parseFloat);
    if (Pa(0, 100, l) !== l) throw new Z5(e);
    if (Pa(0, 100, c) !== c) throw new Z5(e);
    return [...eD(a, l, c), Number.isNaN(u) ? 1 : u];
  }
  throw new Z5(e);
}
function UN(e) {
  let t = 5381, n = e.length;
  for (; n; )
    t = t * 33 ^ e.charCodeAt(--n);
  return (t >>> 0) % 2341;
}
const zC = (e) => parseInt(e.replace(/_/g, ""), 36), jN = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((e, t) => {
  const n = zC(t.substring(0, 3)), r = zC(t.substring(3)).toString(16);
  let o = "";
  for (let i = 0; i < 6 - r.length; i++)
    o += "0";
  return e[n] = `${o}${r}`, e;
}, {});
function XN(e) {
  const t = e.toLowerCase().trim(), n = jN[UN(t)];
  if (!n) throw new Z5(e);
  return `#${n}`;
}
const C0 = (e, t) => Array.from(Array(t)).map(() => e).join(""), YN = new RegExp(`^#${C0("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), JN = new RegExp(`^#${C0("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), QN = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${C0(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), qN = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, KN = /^[a-z]+$/i, GC = (e) => Math.round(e * 255), eD = (e, t, n) => {
  let r = n / 100;
  if (t === 0)
    return [r, r, r].map(GC);
  const o = (e % 360 + 360) % 360 / 60, i = (1 - Math.abs(2 * r - 1)) * (t / 100), a = i * (1 - Math.abs(o % 2 - 1));
  let l = 0, c = 0, u = 0;
  o >= 0 && o < 1 ? (l = i, c = a) : o >= 1 && o < 2 ? (l = a, c = i) : o >= 2 && o < 3 ? (c = i, u = a) : o >= 3 && o < 4 ? (c = a, u = i) : o >= 4 && o < 5 ? (l = a, u = i) : o >= 5 && o < 6 && (l = i, u = a);
  const f = r - i / 2, p = l + f, h = c + f, C = u + f;
  return [p, h, C].map(GC);
};
function tD(e, t, n, r) {
  return `rgba(${Pa(0, 255, e).toFixed()}, ${Pa(0, 255, t).toFixed()}, ${Pa(0, 255, n).toFixed()}, ${parseFloat(Pa(0, 1, r).toFixed(3))})`;
}
function nD(e, t) {
  const [n, r, o, i] = qd(e);
  return tD(n, r, o, i - t);
}
function rD(e) {
  const [t, n, r, o] = qd(e);
  let i = (a) => {
    const l = Pa(0, 255, a).toString(16);
    return l.length === 1 ? `0${l}` : l;
  };
  return `#${i(t)}${i(n)}${i(r)}${o < 1 ? i(Math.round(o * 255)) : ""}`;
}
function oD(e, t, n, r, o) {
  for (t = t.split ? t.split(".") : t, r = 0; r < t.length; r++)
    e = e ? e[t[r]] : o;
  return e === o ? n : e;
}
var iD = (e) => Object.keys(e).length === 0, jl = (e, t, n) => {
  const r = oD(e, `colors.${t}`, t);
  try {
    return rD(r), r;
  } catch {
    return n ?? "#000000";
  }
}, qr = (e, t, n) => {
  var r;
  return (r = Lw(e, "colors", t)) != null ? r : n;
}, aD = (e) => {
  const [t, n, r] = qd(e);
  return (t * 299 + n * 587 + r * 114) / 1e3;
}, sD = (e) => (t) => {
  const n = jl(t, e);
  return aD(n) < 128 ? "dark" : "light";
}, lD = (e) => (t) => sD(e)(t) === "dark", gs = (e, t) => (n) => {
  const r = jl(n, e);
  return nD(r, 1 - t);
};
function WC(e = "1rem", t = "rgba(255, 255, 255, 0.15)") {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${t} 25%,
    transparent 25%,
    transparent 50%,
    ${t} 50%,
    ${t} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${e} ${e}`
  };
}
var cD = () => `#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function uD(e) {
  const t = cD();
  return !e || iD(e) ? t : e.string && e.colors ? fD(e.string, e.colors) : e.string && !e.colors ? dD(e.string) : e.colors && !e.string ? pD(e.colors) : t;
}
function dD(e) {
  let t = 0;
  if (e.length === 0)
    return t.toString();
  for (let r = 0; r < e.length; r += 1)
    t = e.charCodeAt(r) + ((t << 5) - t), t = t & t;
  let n = "#";
  for (let r = 0; r < 3; r += 1) {
    const o = t >> r * 8 & 255;
    n += `00${o.toString(16)}`.substr(-2);
  }
  return n;
}
function fD(e, t) {
  let n = 0;
  if (e.length === 0)
    return t[0];
  for (let r = 0; r < e.length; r += 1)
    n = e.charCodeAt(r) + ((n << 5) - n), n = n & n;
  return n = (n % t.length + t.length) % t.length, t[n];
}
function pD(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function Ke(e, t) {
  return (n) => n.colorMode === "dark" ? t : e;
}
function Kd(e) {
  const { orientation: t, vertical: n, horizontal: r } = e;
  return t ? t === "vertical" ? n : r : {};
}
function Zw(e) {
  return wn(e) && e.reference ? e.reference : String(e);
}
var P9 = (e, ...t) => t.map(Zw).join(` ${e} `).replace(/calc/g, ""), $C = (...e) => `calc(${P9("+", ...e)})`, UC = (...e) => `calc(${P9("-", ...e)})`, Kc = (...e) => `calc(${P9("*", ...e)})`, jC = (...e) => `calc(${P9("/", ...e)})`, XC = (e) => {
  const t = Zw(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : Kc(t, -1);
}, ni = Object.assign(
  (e) => ({
    add: (...t) => ni($C(e, ...t)),
    subtract: (...t) => ni(UC(e, ...t)),
    multiply: (...t) => ni(Kc(e, ...t)),
    divide: (...t) => ni(jC(e, ...t)),
    negate: () => ni(XC(e)),
    toString: () => e.toString()
  }),
  {
    add: $C,
    subtract: UC,
    multiply: Kc,
    divide: jC,
    negate: XC
  }
);
function hD(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function mD(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function zw(e) {
  const t = mD(e.toString());
  return t.includes("\\.") ? e : hD(e) ? t.replace(".", "\\.") : e;
}
function CD(e, t = "") {
  return [t, zw(e)].filter(Boolean).join("-");
}
function gD(e, t) {
  return `var(${zw(e)}${t ? `, ${t}` : ""})`;
}
function bD(e, t = "") {
  return `--${CD(e, t)}`;
}
function nn(e, t) {
  const n = bD(e, void 0);
  return {
    variable: n,
    reference: gD(n, vD(void 0))
  };
}
function vD(e) {
  return typeof e == "string" ? e : e?.reference;
}
var { defineMultiStyleConfig: yD, definePartsStyle: gl } = vt(GN.keys), J5 = nn("switch-track-width"), Da = nn("switch-track-height"), c8 = nn("switch-track-diff"), xD = ni.subtract(J5, Da), eu = nn("switch-thumb-x"), L5 = nn("switch-bg"), wD = (e) => {
  const { colorScheme: t } = e;
  return {
    borderRadius: "full",
    p: "0.5",
    width: [J5.reference],
    height: [Da.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    [L5.variable]: "colors.gray.300",
    _dark: {
      [L5.variable]: "colors.whiteAlpha.400"
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      [L5.variable]: `colors.${t}.500`,
      _dark: {
        [L5.variable]: `colors.${t}.200`
      }
    },
    bg: L5.reference
  };
}, SD = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Da.reference],
  height: [Da.reference],
  _checked: {
    transform: `translateX(${eu.reference})`
  }
}, TD = gl((e) => ({
  container: {
    [c8.variable]: xD,
    [eu.variable]: c8.reference,
    _rtl: {
      [eu.variable]: ni(c8).negate().toString()
    }
  },
  track: wD(e),
  thumb: SD
})), AD = {
  sm: gl({
    container: {
      [J5.variable]: "1.375rem",
      [Da.variable]: "sizes.3"
    }
  }),
  md: gl({
    container: {
      [J5.variable]: "1.875rem",
      [Da.variable]: "sizes.4"
    }
  }),
  lg: gl({
    container: {
      [J5.variable]: "2.875rem",
      [Da.variable]: "sizes.6"
    }
  })
}, ID = yD({
  baseStyle: TD,
  sizes: AD,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: LD, definePartsStyle: is } = vt(Ow.keys), ED = is({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}), Xl = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, MD = is((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: Ke("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: Ke(`${t}.100`, `${t}.700`)(e),
      ...Xl
    },
    td: {
      borderBottom: "1px",
      borderColor: Ke(`${t}.100`, `${t}.700`)(e),
      ...Xl
    },
    caption: {
      color: Ke("gray.600", "gray.100")(e)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), BD = is((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: Ke("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: Ke(`${t}.100`, `${t}.700`)(e),
      ...Xl
    },
    td: {
      borderBottom: "1px",
      borderColor: Ke(`${t}.100`, `${t}.700`)(e),
      ...Xl
    },
    caption: {
      color: Ke("gray.600", "gray.100")(e)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: Ke(`${t}.100`, `${t}.700`)(e)
          },
          td: {
            background: Ke(`${t}.100`, `${t}.700`)(e)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), kD = {
  simple: MD,
  striped: BD,
  unstyled: {}
}, RD = {
  sm: is({
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  }),
  md: is({
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  }),
  lg: is({
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  })
}, _D = LD({
  baseStyle: ED,
  variants: kD,
  sizes: RD,
  defaultProps: {
    variant: "simple",
    size: "md",
    colorScheme: "gray"
  }
}), Gn = a1("tabs-color"), Qr = a1("tabs-bg"), D4 = a1("tabs-border-color"), { defineMultiStyleConfig: FD, definePartsStyle: Ao } = vt(Nw.keys), PD = (e) => {
  const { orientation: t } = e;
  return {
    display: t === "vertical" ? "flex" : "block"
  };
}, VD = (e) => {
  const { isFitted: t } = e;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}, HD = (e) => {
  const { align: t = "start", orientation: n } = e;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[t],
    flexDirection: n === "vertical" ? "column" : "row"
  };
}, OD = {
  p: 4
}, ND = Ao((e) => ({
  root: PD(e),
  tab: VD(e),
  tablist: HD(e),
  tabpanel: OD
})), DD = {
  sm: Ao({
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  }),
  md: Ao({
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }),
  lg: Ao({
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  })
}, ZD = Ao((e) => {
  const { colorScheme: t, orientation: n } = e, r = n === "vertical", o = r ? "borderStart" : "borderBottom", i = r ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [o]: "2px solid",
      borderColor: "inherit"
    },
    tab: {
      [o]: "2px solid",
      borderColor: "transparent",
      [i]: "-2px",
      _selected: {
        [Gn.variable]: `colors.${t}.600`,
        _dark: {
          [Gn.variable]: `colors.${t}.300`
        },
        borderColor: "currentColor"
      },
      _active: {
        [Qr.variable]: "colors.gray.200",
        _dark: {
          [Qr.variable]: "colors.whiteAlpha.300"
        }
      },
      _disabled: {
        _active: { bg: "none" }
      },
      color: Gn.reference,
      bg: Qr.reference
    }
  };
}), zD = Ao((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      [D4.variable]: "transparent",
      _selected: {
        [Gn.variable]: `colors.${t}.600`,
        [D4.variable]: "colors.white",
        _dark: {
          [Gn.variable]: `colors.${t}.300`,
          [D4.variable]: "colors.gray.800"
        },
        borderColor: "inherit",
        borderBottomColor: D4.reference
      },
      color: Gn.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), GD = Ao((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      [Qr.variable]: "colors.gray.50",
      _dark: {
        [Qr.variable]: "colors.whiteAlpha.50"
      },
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        [Qr.variable]: "colors.white",
        [Gn.variable]: `colors.${t}.600`,
        _dark: {
          [Qr.variable]: "colors.gray.800",
          [Gn.variable]: `colors.${t}.300`
        },
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      },
      color: Gn.reference,
      bg: Qr.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), WD = Ao((e) => {
  const { colorScheme: t, theme: n } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: jl(n, `${t}.700`),
        bg: jl(n, `${t}.100`)
      }
    }
  };
}), $D = Ao((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      [Gn.variable]: "colors.gray.600",
      _dark: {
        [Gn.variable]: "inherit"
      },
      _selected: {
        [Gn.variable]: "colors.white",
        [Qr.variable]: `colors.${t}.600`,
        _dark: {
          [Gn.variable]: "colors.gray.800",
          [Qr.variable]: `colors.${t}.300`
        }
      },
      color: Gn.reference,
      bg: Qr.reference
    }
  };
}), UD = Ao({}), jD = {
  line: ZD,
  enclosed: zD,
  "enclosed-colored": GD,
  "soft-rounded": WD,
  "solid-rounded": $D,
  unstyled: UD
}, XD = FD({
  baseStyle: ND,
  sizes: DD,
  variants: jD,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
}), zt = IO("badge", ["bg", "color", "shadow"]), YD = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: zt.bg.reference,
  color: zt.color.reference,
  boxShadow: zt.shadow.reference
}, JD = (e) => {
  const { colorScheme: t, theme: n } = e, r = gs(`${t}.500`, 0.6)(n);
  return {
    [zt.bg.variable]: `colors.${t}.500`,
    [zt.color.variable]: "colors.white",
    _dark: {
      [zt.bg.variable]: r,
      [zt.color.variable]: "colors.whiteAlpha.800"
    }
  };
}, QD = (e) => {
  const { colorScheme: t, theme: n } = e, r = gs(`${t}.200`, 0.16)(n);
  return {
    [zt.bg.variable]: `colors.${t}.100`,
    [zt.color.variable]: `colors.${t}.800`,
    _dark: {
      [zt.bg.variable]: r,
      [zt.color.variable]: `colors.${t}.200`
    }
  };
}, qD = (e) => {
  const { colorScheme: t, theme: n } = e, r = gs(`${t}.200`, 0.8)(n);
  return {
    [zt.color.variable]: `colors.${t}.500`,
    _dark: {
      [zt.color.variable]: r
    },
    [zt.shadow.variable]: `inset 0 0 0px 1px ${zt.color.reference}`
  };
}, KD = {
  solid: JD,
  subtle: QD,
  outline: qD
}, Q5 = {
  baseStyle: YD,
  variants: KD,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
}, { defineMultiStyleConfig: eZ, definePartsStyle: Za } = vt(Dw.keys), YC = a1("tag-bg"), JC = a1("tag-color"), u8 = a1("tag-shadow"), bl = a1("tag-min-height"), vl = a1("tag-min-width"), yl = a1("tag-font-size"), xl = a1("tag-padding-inline"), tZ = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  [JC.variable]: zt.color.reference,
  [YC.variable]: zt.bg.reference,
  [u8.variable]: zt.shadow.reference,
  color: JC.reference,
  bg: YC.reference,
  boxShadow: u8.reference,
  borderRadius: "md",
  minH: bl.reference,
  minW: vl.reference,
  fontSize: yl.reference,
  px: xl.reference,
  _focusVisible: {
    [u8.variable]: "shadows.outline"
  }
}, nZ = {
  lineHeight: 1.2,
  overflow: "visible"
}, rZ = {
  fontSize: "lg",
  w: "5",
  h: "5",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "1.5",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focusVisible: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, oZ = Za({
  container: tZ,
  label: nZ,
  closeButton: rZ
}), iZ = {
  sm: Za({
    container: {
      [bl.variable]: "sizes.5",
      [vl.variable]: "sizes.5",
      [yl.variable]: "fontSizes.xs",
      [xl.variable]: "space.2"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  }),
  md: Za({
    container: {
      [bl.variable]: "sizes.6",
      [vl.variable]: "sizes.6",
      [yl.variable]: "fontSizes.sm",
      [xl.variable]: "space.2"
    }
  }),
  lg: Za({
    container: {
      [bl.variable]: "sizes.8",
      [vl.variable]: "sizes.8",
      [yl.variable]: "fontSizes.md",
      [xl.variable]: "space.3"
    }
  })
}, aZ = {
  subtle: Za((e) => {
    var t;
    return {
      container: (t = Q5.variants) == null ? void 0 : t.subtle(e)
    };
  }),
  solid: Za((e) => {
    var t;
    return {
      container: (t = Q5.variants) == null ? void 0 : t.solid(e)
    };
  }),
  outline: Za((e) => {
    var t;
    return {
      container: (t = Q5.variants) == null ? void 0 : t.outline(e)
    };
  })
}, sZ = eZ({
  variants: aZ,
  baseStyle: oZ,
  sizes: iZ,
  defaultProps: {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
  }
}), { definePartsStyle: oi, defineMultiStyleConfig: lZ } = vt(Pw.keys), cZ = oi({
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
}), Di = {
  lg: {
    fontSize: "lg",
    px: "4",
    h: "12",
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    px: "4",
    h: "10",
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    px: "3",
    h: "8",
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    px: "2",
    h: "6",
    borderRadius: "sm"
  }
}, uZ = {
  lg: oi({
    field: Di.lg,
    addon: Di.lg
  }),
  md: oi({
    field: Di.md,
    addon: Di.md
  }),
  sm: oi({
    field: Di.sm,
    addon: Di.sm
  }),
  xs: oi({
    field: Di.xs,
    addon: Di.xs
  })
};
function ef(e) {
  const { focusBorderColor: t, errorBorderColor: n } = e;
  return {
    focusBorderColor: t || Ke("blue.500", "blue.300")(e),
    errorBorderColor: n || Ke("red.500", "red.300")(e)
  };
}
var dZ = oi((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = ef(e);
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: Ke("gray.300", "whiteAlpha.400")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: qr(t, r),
        boxShadow: `0 0 0 1px ${qr(t, r)}`
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: qr(t, n),
        boxShadow: `0 0 0 1px ${qr(t, n)}`
      }
    },
    addon: {
      border: "1px solid",
      borderColor: Ke("inherit", "whiteAlpha.50")(e),
      bg: Ke("gray.100", "whiteAlpha.300")(e)
    }
  };
}), fZ = oi((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = ef(e);
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: Ke("gray.100", "whiteAlpha.50")(e),
      _hover: {
        bg: Ke("gray.200", "whiteAlpha.100")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: qr(t, r)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: qr(t, n)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: Ke("gray.100", "whiteAlpha.50")(e)
    }
  };
}), pZ = oi((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = ef(e);
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: qr(t, r),
        boxShadow: `0px 1px 0px 0px ${qr(t, r)}`
      },
      _focusVisible: {
        borderColor: qr(t, n),
        boxShadow: `0px 1px 0px 0px ${qr(t, n)}`
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
}), hZ = oi({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
}), mZ = {
  outline: dZ,
  filled: fZ,
  flushed: pZ,
  unstyled: hZ
}, $1 = lZ({
  baseStyle: cZ,
  sizes: uZ,
  variants: mZ,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}), QC, CZ = {
  ...(QC = $1.baseStyle) == null ? void 0 : QC.field,
  paddingY: "2",
  minHeight: "20",
  lineHeight: "short",
  verticalAlign: "top"
}, qC, KC, gZ = {
  outline: (e) => {
    var t, n;
    return (n = (t = $1.variants) == null ? void 0 : t.outline(e).field) != null ? n : {};
  },
  flushed: (e) => {
    var t, n;
    return (n = (t = $1.variants) == null ? void 0 : t.flushed(e).field) != null ? n : {};
  },
  filled: (e) => {
    var t, n;
    return (n = (t = $1.variants) == null ? void 0 : t.filled(e).field) != null ? n : {};
  },
  unstyled: (KC = (qC = $1.variants) == null ? void 0 : qC.unstyled.field) != null ? KC : {}
}, eg, tg, ng, rg, og, ig, ag, sg, bZ = {
  xs: (tg = (eg = $1.sizes) == null ? void 0 : eg.xs.field) != null ? tg : {},
  sm: (rg = (ng = $1.sizes) == null ? void 0 : ng.sm.field) != null ? rg : {},
  md: (ig = (og = $1.sizes) == null ? void 0 : og.md.field) != null ? ig : {},
  lg: (sg = (ag = $1.sizes) == null ? void 0 : ag.lg.field) != null ? sg : {}
}, vZ = {
  baseStyle: CZ,
  sizes: bZ,
  variants: gZ,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}, Z4 = nn("tooltip-bg"), d8 = nn("tooltip-fg"), yZ = nn("popper-arrow-bg"), xZ = {
  bg: Z4.reference,
  color: d8.reference,
  [Z4.variable]: "colors.gray.700",
  [d8.variable]: "colors.whiteAlpha.900",
  _dark: {
    [Z4.variable]: "colors.gray.300",
    [d8.variable]: "colors.gray.900"
  },
  [yZ.variable]: Z4.reference,
  px: "2",
  py: "0.5",
  borderRadius: "sm",
  fontWeight: "medium",
  fontSize: "sm",
  boxShadow: "md",
  maxW: "xs",
  zIndex: "tooltip"
}, wZ = {
  baseStyle: xZ
}, { defineMultiStyleConfig: SZ, definePartsStyle: z5 } = vt(ON.keys), TZ = (e) => {
  const { colorScheme: t, theme: n, isIndeterminate: r, hasStripe: o } = e, i = Ke(
    WC(),
    WC("1rem", "rgba(0,0,0,0.1)")
  )(e), a = Ke(`${t}.500`, `${t}.200`)(e), l = `linear-gradient(
    to right,
    transparent 0%,
    ${qr(n, a)} 50%,
    transparent 100%
  )`;
  return {
    ...!r && o && i,
    ...r ? { bgImage: l } : { bgColor: a }
  };
}, AZ = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, IZ = (e) => ({
  bg: Ke("gray.100", "whiteAlpha.300")(e)
}), LZ = (e) => ({
  transitionProperty: "common",
  transitionDuration: "slow",
  ...TZ(e)
}), EZ = z5((e) => ({
  label: AZ,
  filledTrack: LZ(e),
  track: IZ(e)
})), MZ = {
  xs: z5({
    track: { h: "1" }
  }),
  sm: z5({
    track: { h: "2" }
  }),
  md: z5({
    track: { h: "3" }
  }),
  lg: z5({
    track: { h: "4" }
  })
}, BZ = SZ({
  sizes: MZ,
  baseStyle: EZ,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), kZ = (e) => typeof e == "function";
function Pn(e, ...t) {
  return kZ(e) ? e(...t) : e;
}
var { definePartsStyle: wl, defineMultiStyleConfig: RZ } = vt(RN.keys), q5 = a1("checkbox-size"), _Z = (e) => {
  const { colorScheme: t } = e;
  return {
    w: q5.reference,
    h: q5.reference,
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: Ke(`${t}.500`, `${t}.200`)(e),
      borderColor: Ke(`${t}.500`, `${t}.200`)(e),
      color: Ke("white", "gray.900")(e),
      _hover: {
        bg: Ke(`${t}.600`, `${t}.300`)(e),
        borderColor: Ke(`${t}.600`, `${t}.300`)(e)
      },
      _disabled: {
        borderColor: Ke("gray.200", "transparent")(e),
        bg: Ke("gray.200", "whiteAlpha.300")(e),
        color: Ke("gray.500", "whiteAlpha.500")(e)
      }
    },
    _indeterminate: {
      bg: Ke(`${t}.500`, `${t}.200`)(e),
      borderColor: Ke(`${t}.500`, `${t}.200`)(e),
      color: Ke("white", "gray.900")(e)
    },
    _disabled: {
      bg: Ke("gray.100", "whiteAlpha.100")(e),
      borderColor: Ke("gray.100", "transparent")(e)
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: Ke("red.500", "red.300")(e)
    }
  };
}, FZ = {
  _disabled: { cursor: "not-allowed" }
}, PZ = {
  userSelect: "none",
  _disabled: { opacity: 0.4 }
}, VZ = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, HZ = wl((e) => ({
  icon: VZ,
  container: FZ,
  control: Pn(_Z, e),
  label: PZ
})), OZ = {
  sm: wl({
    control: { [q5.variable]: "sizes.3" },
    label: { fontSize: "sm" },
    icon: { fontSize: "3xs" }
  }),
  md: wl({
    control: { [q5.variable]: "sizes.4" },
    label: { fontSize: "md" },
    icon: { fontSize: "2xs" }
  }),
  lg: wl({
    control: { [q5.variable]: "sizes.5" },
    label: { fontSize: "lg" },
    icon: { fontSize: "2xs" }
  })
}, Yl = RZ({
  baseStyle: HZ,
  sizes: OZ,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: NZ, definePartsStyle: Sl } = vt(NN.keys), DZ = (e) => {
  var t;
  const n = (t = Pn(Yl.baseStyle, e)) == null ? void 0 : t.control;
  return {
    ...n,
    borderRadius: "full",
    _checked: {
      ...n?._checked,
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    }
  };
}, ZZ = Sl((e) => {
  var t, n, r, o;
  return {
    label: (n = (t = Yl).baseStyle) == null ? void 0 : n.call(t, e).label,
    container: (o = (r = Yl).baseStyle) == null ? void 0 : o.call(r, e).container,
    control: DZ(e)
  };
}), zZ = {
  md: Sl({
    control: { w: "4", h: "4" },
    label: { fontSize: "md" }
  }),
  lg: Sl({
    control: { w: "5", h: "5" },
    label: { fontSize: "lg" }
  }),
  sm: Sl({
    control: { width: "3", height: "3" },
    label: { fontSize: "sm" }
  })
}, GZ = NZ({
  baseStyle: ZZ,
  sizes: zZ,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: WZ, definePartsStyle: $Z } = vt(DN.keys), z4 = a1("select-bg"), lg, UZ = {
  ...(lg = $1.baseStyle) == null ? void 0 : lg.field,
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: z4.reference,
  [z4.variable]: "colors.white",
  _dark: {
    [z4.variable]: "colors.gray.700"
  },
  "> option, > optgroup": {
    bg: z4.reference
  }
}, jZ = {
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
}, XZ = $Z({
  field: UZ,
  icon: jZ
}), G4 = {
  paddingInlineEnd: "8"
}, cg, ug, dg, fg, pg, hg, mg, Cg, YZ = {
  lg: {
    ...(cg = $1.sizes) == null ? void 0 : cg.lg,
    field: {
      ...(ug = $1.sizes) == null ? void 0 : ug.lg.field,
      ...G4
    }
  },
  md: {
    ...(dg = $1.sizes) == null ? void 0 : dg.md,
    field: {
      ...(fg = $1.sizes) == null ? void 0 : fg.md.field,
      ...G4
    }
  },
  sm: {
    ...(pg = $1.sizes) == null ? void 0 : pg.sm,
    field: {
      ...(hg = $1.sizes) == null ? void 0 : hg.sm.field,
      ...G4
    }
  },
  xs: {
    ...(mg = $1.sizes) == null ? void 0 : mg.xs,
    field: {
      ...(Cg = $1.sizes) == null ? void 0 : Cg.xs.field,
      ...G4
    },
    icon: {
      insetEnd: "1"
    }
  }
}, JZ = WZ({
  baseStyle: XZ,
  sizes: YZ,
  variants: $1.variants,
  defaultProps: $1.defaultProps
}), f8 = a1("skeleton-start-color"), p8 = a1("skeleton-end-color"), QZ = {
  [f8.variable]: "colors.gray.100",
  [p8.variable]: "colors.gray.400",
  _dark: {
    [f8.variable]: "colors.gray.800",
    [p8.variable]: "colors.gray.600"
  },
  background: f8.reference,
  borderColor: p8.reference,
  opacity: 0.7,
  borderRadius: "sm"
}, qZ = {
  baseStyle: QZ
}, h8 = a1("skip-link-bg"), KZ = {
  borderRadius: "md",
  fontWeight: "semibold",
  _focusVisible: {
    boxShadow: "outline",
    padding: "4",
    position: "fixed",
    top: "6",
    insetStart: "6",
    [h8.variable]: "colors.white",
    _dark: {
      [h8.variable]: "colors.gray.700"
    },
    bg: h8.reference
  }
}, ez = {
  baseStyle: KZ
}, { defineMultiStyleConfig: tz, definePartsStyle: V9 } = vt(ZN.keys), g0 = a1("slider-thumb-size"), b0 = a1("slider-track-size"), $i = a1("slider-bg"), nz = (e) => {
  const { orientation: t } = e;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    },
    ...Kd({
      orientation: t,
      vertical: { h: "100%" },
      horizontal: { w: "100%" }
    })
  };
}, rz = (e) => ({
  ...Kd({
    orientation: e.orientation,
    horizontal: { h: b0.reference },
    vertical: { w: b0.reference }
  }),
  overflow: "hidden",
  borderRadius: "sm",
  [$i.variable]: "colors.gray.200",
  _dark: {
    [$i.variable]: "colors.whiteAlpha.200"
  },
  _disabled: {
    [$i.variable]: "colors.gray.300",
    _dark: {
      [$i.variable]: "colors.whiteAlpha.300"
    }
  },
  bg: $i.reference
}), oz = (e) => {
  const { orientation: t } = e;
  return {
    ...Kd({
      orientation: t,
      vertical: {
        left: "50%",
        transform: "translateX(-50%)",
        _active: {
          transform: "translateX(-50%) scale(1.15)"
        }
      },
      horizontal: {
        top: "50%",
        transform: "translateY(-50%)",
        _active: {
          transform: "translateY(-50%) scale(1.15)"
        }
      }
    }),
    w: g0.reference,
    h: g0.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      bg: "gray.300"
    }
  };
}, iz = (e) => {
  const { colorScheme: t } = e;
  return {
    width: "inherit",
    height: "inherit",
    [$i.variable]: `colors.${t}.500`,
    _dark: {
      [$i.variable]: `colors.${t}.200`
    },
    bg: $i.reference
  };
}, az = V9((e) => ({
  container: nz(e),
  track: rz(e),
  thumb: oz(e),
  filledTrack: iz(e)
})), sz = V9({
  container: {
    [g0.variable]: "sizes.4",
    [b0.variable]: "sizes.1"
  }
}), lz = V9({
  container: {
    [g0.variable]: "sizes.3.5",
    [b0.variable]: "sizes.1"
  }
}), cz = V9({
  container: {
    [g0.variable]: "sizes.2.5",
    [b0.variable]: "sizes.0.5"
  }
}), uz = {
  lg: sz,
  md: lz,
  sm: cz
}, dz = tz({
  baseStyle: az,
  sizes: uz,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), _a = nn("spinner-size"), fz = {
  width: [_a.reference],
  height: [_a.reference]
}, pz = {
  xs: {
    [_a.variable]: "sizes.3"
  },
  sm: {
    [_a.variable]: "sizes.4"
  },
  md: {
    [_a.variable]: "sizes.6"
  },
  lg: {
    [_a.variable]: "sizes.8"
  },
  xl: {
    [_a.variable]: "sizes.12"
  }
}, hz = {
  baseStyle: fz,
  sizes: pz,
  defaultProps: {
    size: "md"
  }
}, { defineMultiStyleConfig: mz, definePartsStyle: Gw } = vt(zN.keys), Cz = {
  fontWeight: "medium"
}, gz = {
  opacity: 0.8,
  marginBottom: "2"
}, bz = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, vz = {
  marginEnd: 1,
  w: "3.5",
  h: "3.5",
  verticalAlign: "middle"
}, yz = Gw({
  container: {},
  label: Cz,
  helpText: gz,
  number: bz,
  icon: vz
}), xz = {
  md: Gw({
    label: { fontSize: "sm" },
    helpText: { fontSize: "sm" },
    number: { fontSize: "2xl" }
  })
}, wz = mz({
  baseStyle: yz,
  sizes: xz,
  defaultProps: {
    size: "md"
  }
}), m8 = a1("kbd-bg"), Sz = {
  [m8.variable]: "colors.gray.100",
  _dark: {
    [m8.variable]: "colors.whiteAlpha.100"
  },
  bg: m8.reference,
  borderRadius: "md",
  borderWidth: "1px",
  borderBottomWidth: "3px",
  fontSize: "0.8em",
  fontWeight: "bold",
  lineHeight: "normal",
  px: "0.4em",
  whiteSpace: "nowrap"
}, Tz = {
  baseStyle: Sz
}, Az = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focusVisible: {
    boxShadow: "outline"
  }
}, Iz = {
  baseStyle: Az
}, { defineMultiStyleConfig: Lz, definePartsStyle: Ez } = vt(PN.keys), Mz = {
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
}, Bz = Ez({
  icon: Mz
}), kz = Lz({
  baseStyle: Bz
}), { defineMultiStyleConfig: Rz, definePartsStyle: _z } = vt(VN.keys), mo = a1("menu-bg"), C8 = a1("menu-shadow"), Fz = {
  [mo.variable]: "#fff",
  [C8.variable]: "shadows.sm",
  _dark: {
    [mo.variable]: "colors.gray.700",
    [C8.variable]: "shadows.dark-lg"
  },
  color: "inherit",
  minW: "3xs",
  py: "2",
  zIndex: 1,
  borderRadius: "md",
  borderWidth: "1px",
  bg: mo.reference,
  boxShadow: C8.reference
}, Pz = {
  py: "1.5",
  px: "3",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _focus: {
    [mo.variable]: "colors.gray.100",
    _dark: {
      [mo.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [mo.variable]: "colors.gray.200",
    _dark: {
      [mo.variable]: "colors.whiteAlpha.200"
    }
  },
  _expanded: {
    [mo.variable]: "colors.gray.100",
    _dark: {
      [mo.variable]: "colors.whiteAlpha.100"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  bg: mo.reference
}, Vz = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, Hz = {
  opacity: 0.6
}, Oz = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}, Nz = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, Dz = _z({
  button: Nz,
  list: Fz,
  item: Pz,
  groupTitle: Vz,
  command: Hz,
  divider: Oz
}), Zz = Rz({
  baseStyle: Dz
}), { defineMultiStyleConfig: zz, definePartsStyle: tu } = vt(Vw.keys), g8 = a1("modal-bg"), b8 = a1("modal-shadow"), Gz = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, Wz = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
}, $z = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    borderRadius: "md",
    color: "inherit",
    my: t ? "auto" : "16",
    mx: t ? "auto" : void 0,
    zIndex: "modal",
    maxH: n === "inside" ? "calc(100% - 7.5rem)" : void 0,
    [g8.variable]: "colors.white",
    [b8.variable]: "shadows.lg",
    _dark: {
      [g8.variable]: "colors.gray.700",
      [b8.variable]: "shadows.dark-lg"
    },
    bg: g8.reference,
    boxShadow: b8.reference
  };
}, Uz = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, jz = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, Xz = (e) => {
  const { scrollBehavior: t } = e;
  return {
    px: "6",
    py: "2",
    flex: "1",
    overflow: t === "inside" ? "auto" : void 0
  };
}, Yz = {
  px: "6",
  py: "4"
}, Jz = tu((e) => ({
  overlay: Gz,
  dialogContainer: Pn(Wz, e),
  dialog: Pn($z, e),
  header: Uz,
  closeButton: jz,
  body: Pn(Xz, e),
  footer: Yz
}));
function jr(e) {
  return tu(e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "$100vh",
      my: "0",
      borderRadius: "0"
    }
  } : {
    dialog: { maxW: e }
  });
}
var Qz = {
  xs: jr("xs"),
  sm: jr("sm"),
  md: jr("md"),
  lg: jr("lg"),
  xl: jr("xl"),
  "2xl": jr("2xl"),
  "3xl": jr("3xl"),
  "4xl": jr("4xl"),
  "5xl": jr("5xl"),
  "6xl": jr("6xl"),
  full: jr("full")
}, qz = zz({
  baseStyle: Jz,
  sizes: Qz,
  defaultProps: { size: "md" }
}), { defineMultiStyleConfig: Kz, definePartsStyle: Ww } = vt(HN.keys), tf = nn("number-input-stepper-width"), $w = nn("number-input-input-padding"), eG = ni(tf).add("0.5rem").toString(), v8 = nn("number-input-bg"), y8 = nn("number-input-color"), x8 = nn("number-input-border-color"), tG = {
  [tf.variable]: "sizes.6",
  [$w.variable]: eG
}, nG = (e) => {
  var t, n;
  return (n = (t = Pn($1.baseStyle, e)) == null ? void 0 : t.field) != null ? n : {};
}, rG = {
  width: tf.reference
}, oG = {
  borderStart: "1px solid",
  borderStartColor: x8.reference,
  color: y8.reference,
  bg: v8.reference,
  [y8.variable]: "colors.chakra-body-text",
  [x8.variable]: "colors.chakra-border-color",
  _dark: {
    [y8.variable]: "colors.whiteAlpha.800",
    [x8.variable]: "colors.whiteAlpha.300"
  },
  _active: {
    [v8.variable]: "colors.gray.200",
    _dark: {
      [v8.variable]: "colors.whiteAlpha.300"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  }
}, iG = Ww((e) => {
  var t;
  return {
    root: tG,
    field: (t = Pn(nG, e)) != null ? t : {},
    stepperGroup: rG,
    stepper: oG
  };
});
function W4(e) {
  var t, n, r;
  const o = (t = $1.sizes) == null ? void 0 : t[e], i = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, a = (r = (n = o.field) == null ? void 0 : n.fontSize) != null ? r : "md", l = Ew.fontSizes[a];
  return Ww({
    field: {
      ...o.field,
      paddingInlineEnd: $w.reference,
      verticalAlign: "top"
    },
    stepper: {
      fontSize: ni(l).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: i[e]
      },
      _last: {
        borderBottomEndRadius: i[e],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
var aG = {
  xs: W4("xs"),
  sm: W4("sm"),
  md: W4("md"),
  lg: W4("lg")
}, sG = Kz({
  baseStyle: iG,
  sizes: aG,
  variants: $1.variants,
  defaultProps: $1.defaultProps
}), gg, lG = {
  ...(gg = $1.baseStyle) == null ? void 0 : gg.field,
  textAlign: "center"
}, cG = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
}, bg, vg, uG = {
  outline: (e) => {
    var t, n, r;
    return (r = (n = Pn((t = $1.variants) == null ? void 0 : t.outline, e)) == null ? void 0 : n.field) != null ? r : {};
  },
  flushed: (e) => {
    var t, n, r;
    return (r = (n = Pn((t = $1.variants) == null ? void 0 : t.flushed, e)) == null ? void 0 : n.field) != null ? r : {};
  },
  filled: (e) => {
    var t, n, r;
    return (r = (n = Pn((t = $1.variants) == null ? void 0 : t.filled, e)) == null ? void 0 : n.field) != null ? r : {};
  },
  unstyled: (vg = (bg = $1.variants) == null ? void 0 : bg.unstyled.field) != null ? vg : {}
}, dG = {
  baseStyle: lG,
  sizes: cG,
  variants: uG,
  defaultProps: $1.defaultProps
}, { defineMultiStyleConfig: fG, definePartsStyle: pG } = vt(Hw.keys), $4 = nn("popper-bg"), hG = nn("popper-arrow-bg"), yg = nn("popper-arrow-shadow-color"), mG = { zIndex: 10 }, CG = {
  [$4.variable]: "colors.white",
  bg: $4.reference,
  [hG.variable]: $4.reference,
  [yg.variable]: "colors.gray.200",
  _dark: {
    [$4.variable]: "colors.gray.700",
    [yg.variable]: "colors.whiteAlpha.300"
  },
  width: "xs",
  border: "1px solid",
  borderColor: "inherit",
  borderRadius: "md",
  boxShadow: "sm",
  zIndex: "inherit",
  _focusVisible: {
    outline: 0,
    boxShadow: "outline"
  }
}, gG = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, bG = {
  px: 3,
  py: 2
}, vG = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, yG = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, xG = pG({
  popper: mG,
  content: CG,
  header: gG,
  body: bG,
  footer: vG,
  closeButton: yG
}), wG = fG({
  baseStyle: xG
}), { definePartsStyle: nu, defineMultiStyleConfig: SG } = vt(_N.keys), w8 = a1("drawer-bg"), S8 = a1("drawer-box-shadow");
function W2(e) {
  return nu(e === "full" ? {
    dialog: { maxW: "100vw", h: "100vh" }
  } : {
    dialog: { maxW: e }
  });
}
var TG = {
  bg: "blackAlpha.600",
  zIndex: "overlay"
}, AG = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, IG = (e) => {
  const { isFullHeight: t } = e;
  return {
    ...t && { height: "100vh" },
    zIndex: "modal",
    maxH: "100vh",
    color: "inherit",
    [w8.variable]: "colors.white",
    [S8.variable]: "shadows.lg",
    _dark: {
      [w8.variable]: "colors.gray.700",
      [S8.variable]: "shadows.dark-lg"
    },
    bg: w8.reference,
    boxShadow: S8.reference
  };
}, LG = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, EG = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, MG = {
  px: "6",
  py: "2",
  flex: "1",
  overflow: "auto"
}, BG = {
  px: "6",
  py: "4"
}, kG = nu((e) => ({
  overlay: TG,
  dialogContainer: AG,
  dialog: Pn(IG, e),
  header: LG,
  closeButton: EG,
  body: MG,
  footer: BG
})), RG = {
  xs: W2("xs"),
  sm: W2("md"),
  md: W2("lg"),
  lg: W2("2xl"),
  xl: W2("4xl"),
  full: W2("full")
}, _G = SG({
  baseStyle: kG,
  sizes: RG,
  defaultProps: {
    size: "xs"
  }
}), { definePartsStyle: FG, defineMultiStyleConfig: PG } = vt(FN.keys), VG = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal"
}, HG = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, OG = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, NG = FG({
  preview: VG,
  input: HG,
  textarea: OG
}), DG = PG({
  baseStyle: NG
}), { definePartsStyle: ZG, defineMultiStyleConfig: zG } = vt(_w.keys), as = a1("form-control-color"), GG = {
  marginStart: "1",
  [as.variable]: "colors.red.500",
  _dark: {
    [as.variable]: "colors.red.300"
  },
  color: as.reference
}, WG = {
  mt: "2",
  [as.variable]: "colors.gray.600",
  _dark: {
    [as.variable]: "colors.whiteAlpha.600"
  },
  color: as.reference,
  lineHeight: "normal",
  fontSize: "sm"
}, $G = ZG({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: GG,
  helperText: WG
}), UG = zG({
  baseStyle: $G
}), { definePartsStyle: jG, defineMultiStyleConfig: XG } = vt(Fw.keys), ss = a1("form-error-color"), YG = {
  [ss.variable]: "colors.red.500",
  _dark: {
    [ss.variable]: "colors.red.300"
  },
  color: ss.reference,
  mt: "2",
  fontSize: "sm",
  lineHeight: "normal"
}, JG = {
  marginEnd: "0.5em",
  [ss.variable]: "colors.red.500",
  _dark: {
    [ss.variable]: "colors.red.300"
  },
  color: ss.reference
}, QG = jG({
  text: YG,
  icon: JG
}), qG = XG({
  baseStyle: QG
}), KG = {
  fontSize: "md",
  marginEnd: "3",
  mb: "2",
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, eW = {
  baseStyle: KG
}, tW = {
  fontFamily: "heading",
  fontWeight: "bold"
}, nW = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, rW = {
  baseStyle: tW,
  sizes: nW,
  defaultProps: {
    size: "xl"
  }
}, { defineMultiStyleConfig: oW, definePartsStyle: iW } = vt(kN.keys), T8 = a1("breadcrumb-link-decor"), aW = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  outline: "none",
  color: "inherit",
  textDecoration: T8.reference,
  [T8.variable]: "none",
  "&:not([aria-current=page])": {
    cursor: "pointer",
    _hover: {
      [T8.variable]: "underline"
    },
    _focusVisible: {
      boxShadow: "outline"
    }
  }
}, sW = iW({
  link: aW
}), lW = oW({
  baseStyle: sW
}), cW = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, Uw = (e) => {
  const { colorScheme: t, theme: n } = e;
  if (t === "gray")
    return {
      color: Ke("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: Ke("gray.100", "whiteAlpha.200")(e)
      },
      _active: { bg: Ke("gray.200", "whiteAlpha.300")(e) }
    };
  const r = gs(`${t}.200`, 0.12)(n), o = gs(`${t}.200`, 0.24)(n);
  return {
    color: Ke(`${t}.600`, `${t}.200`)(e),
    bg: "transparent",
    _hover: {
      bg: Ke(`${t}.50`, r)(e)
    },
    _active: {
      bg: Ke(`${t}.100`, o)(e)
    }
  };
}, uW = (e) => {
  const { colorScheme: t } = e, n = Ke("gray.200", "whiteAlpha.300")(e);
  return {
    border: "1px solid",
    borderColor: t === "gray" ? n : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
    ...Pn(Uw, e)
  };
}, dW = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, fW = (e) => {
  var t;
  const { colorScheme: n } = e;
  if (n === "gray") {
    const c = Ke("gray.100", "whiteAlpha.200")(e);
    return {
      bg: c,
      color: Ke("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: Ke("gray.200", "whiteAlpha.300")(e),
        _disabled: {
          bg: c
        }
      },
      _active: { bg: Ke("gray.300", "whiteAlpha.400")(e) }
    };
  }
  const {
    bg: r = `${n}.500`,
    color: o = "white",
    hoverBg: i = `${n}.600`,
    activeBg: a = `${n}.700`
  } = (t = dW[n]) != null ? t : {}, l = Ke(r, `${n}.200`)(e);
  return {
    bg: l,
    color: Ke(o, "gray.800")(e),
    _hover: {
      bg: Ke(i, `${n}.300`)(e),
      _disabled: {
        bg: l
      }
    },
    _active: { bg: Ke(a, `${n}.400`)(e) }
  };
}, pW = (e) => {
  const { colorScheme: t } = e;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: Ke(`${t}.500`, `${t}.200`)(e),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: Ke(`${t}.700`, `${t}.500`)(e)
    }
  };
}, hW = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
}, mW = {
  ghost: Uw,
  outline: uW,
  solid: fW,
  link: pW,
  unstyled: hW
}, CW = {
  lg: {
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  },
  md: {
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  },
  sm: {
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  },
  xs: {
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  }
}, gW = {
  baseStyle: cW,
  variants: mW,
  sizes: CW,
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  }
}, { definePartsStyle: za, defineMultiStyleConfig: bW } = vt(WN.keys), Jl = a1("card-bg"), ai = a1("card-padding"), jw = a1("card-shadow"), Tl = a1("card-radius"), Xw = a1("card-border-width", "0"), Yw = a1("card-border-color"), vW = za({
  container: {
    [Jl.variable]: "colors.chakra-body-bg",
    backgroundColor: Jl.reference,
    boxShadow: jw.reference,
    borderRadius: Tl.reference,
    color: "chakra-body-text",
    borderWidth: Xw.reference,
    borderColor: Yw.reference
  },
  body: {
    padding: ai.reference,
    flex: "1 1 0%"
  },
  header: {
    padding: ai.reference
  },
  footer: {
    padding: ai.reference
  }
}), yW = {
  sm: za({
    container: {
      [Tl.variable]: "radii.base",
      [ai.variable]: "space.3"
    }
  }),
  md: za({
    container: {
      [Tl.variable]: "radii.md",
      [ai.variable]: "space.5"
    }
  }),
  lg: za({
    container: {
      [Tl.variable]: "radii.xl",
      [ai.variable]: "space.7"
    }
  })
}, xW = {
  elevated: za({
    container: {
      [jw.variable]: "shadows.base",
      _dark: {
        [Jl.variable]: "colors.gray.700"
      }
    }
  }),
  outline: za({
    container: {
      [Xw.variable]: "1px",
      [Yw.variable]: "colors.chakra-border-color"
    }
  }),
  filled: za({
    container: {
      [Jl.variable]: "colors.chakra-subtle-bg"
    }
  }),
  unstyled: {
    body: {
      [ai.variable]: 0
    },
    header: {
      [ai.variable]: 0
    },
    footer: {
      [ai.variable]: 0
    }
  }
}, wW = bW({
  baseStyle: vW,
  variants: xW,
  sizes: yW,
  defaultProps: {
    variant: "elevated",
    size: "md"
  }
}), K5 = nn("close-button-size"), E5 = nn("close-button-bg"), SW = {
  w: [K5.reference],
  h: [K5.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    [E5.variable]: "colors.blackAlpha.100",
    _dark: {
      [E5.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [E5.variable]: "colors.blackAlpha.200",
    _dark: {
      [E5.variable]: "colors.whiteAlpha.200"
    }
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: E5.reference
}, TW = {
  lg: {
    [K5.variable]: "sizes.10",
    fontSize: "md"
  },
  md: {
    [K5.variable]: "sizes.8",
    fontSize: "xs"
  },
  sm: {
    [K5.variable]: "sizes.6",
    fontSize: "2xs"
  }
}, AW = {
  baseStyle: SW,
  sizes: TW,
  defaultProps: {
    size: "md"
  }
}, { variants: IW, defaultProps: LW } = Q5, EW = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm",
  bg: zt.bg.reference,
  color: zt.color.reference,
  boxShadow: zt.shadow.reference
}, MW = {
  baseStyle: EW,
  variants: IW,
  defaultProps: LW
}, BW = {
  w: "100%",
  mx: "auto",
  maxW: "prose",
  px: "4"
}, kW = {
  baseStyle: BW
}, RW = {
  opacity: 0.6,
  borderColor: "inherit"
}, _W = {
  borderStyle: "solid"
}, FW = {
  borderStyle: "dashed"
}, PW = {
  solid: _W,
  dashed: FW
}, VW = {
  baseStyle: RW,
  variants: PW,
  defaultProps: {
    variant: "solid"
  }
}, { definePartsStyle: HW, defineMultiStyleConfig: OW } = vt(Rw.keys), NW = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, DW = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "md",
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: "4",
  py: "2"
}, ZW = {
  pt: "2",
  px: "4",
  pb: "5"
}, zW = {
  fontSize: "1.25em"
}, GW = HW({
  container: NW,
  button: DW,
  panel: ZW,
  icon: zW
}), WW = OW({ baseStyle: GW }), { definePartsStyle: j0, defineMultiStyleConfig: $W } = vt(MN.keys), rr = a1("alert-fg"), fi = a1("alert-bg"), UW = j0({
  container: {
    bg: fi.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: rr.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: rr.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function nf(e) {
  const { theme: t, colorScheme: n } = e, r = gs(`${n}.200`, 0.16)(t);
  return {
    light: `colors.${n}.100`,
    dark: r
  };
}
var jW = j0((e) => {
  const { colorScheme: t } = e, n = nf(e);
  return {
    container: {
      [rr.variable]: `colors.${t}.500`,
      [fi.variable]: n.light,
      _dark: {
        [rr.variable]: `colors.${t}.200`,
        [fi.variable]: n.dark
      }
    }
  };
}), XW = j0((e) => {
  const { colorScheme: t } = e, n = nf(e);
  return {
    container: {
      [rr.variable]: `colors.${t}.500`,
      [fi.variable]: n.light,
      _dark: {
        [rr.variable]: `colors.${t}.200`,
        [fi.variable]: n.dark
      },
      paddingStart: "3",
      borderStartWidth: "4px",
      borderStartColor: rr.reference
    }
  };
}), YW = j0((e) => {
  const { colorScheme: t } = e, n = nf(e);
  return {
    container: {
      [rr.variable]: `colors.${t}.500`,
      [fi.variable]: n.light,
      _dark: {
        [rr.variable]: `colors.${t}.200`,
        [fi.variable]: n.dark
      },
      pt: "2",
      borderTopWidth: "4px",
      borderTopColor: rr.reference
    }
  };
}), JW = j0((e) => {
  const { colorScheme: t } = e;
  return {
    container: {
      [rr.variable]: "colors.white",
      [fi.variable]: `colors.${t}.500`,
      _dark: {
        [rr.variable]: "colors.gray.900",
        [fi.variable]: `colors.${t}.200`
      },
      color: rr.reference
    }
  };
}), QW = {
  subtle: jW,
  "left-accent": XW,
  "top-accent": YW,
  solid: JW
}, qW = $W({
  baseStyle: UW,
  variants: QW,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
}), { definePartsStyle: Jw, defineMultiStyleConfig: KW } = vt(BN.keys), ls = a1("avatar-border-color"), e0 = a1("avatar-bg"), v0 = a1("avatar-font-size"), bs = a1("avatar-size"), e$ = {
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: ls.reference,
  [ls.variable]: "white",
  _dark: {
    [ls.variable]: "colors.gray.800"
  }
}, t$ = {
  bg: e0.reference,
  fontSize: v0.reference,
  width: bs.reference,
  height: bs.reference,
  lineHeight: "1",
  [e0.variable]: "colors.gray.200",
  _dark: {
    [e0.variable]: "colors.whiteAlpha.400"
  }
}, n$ = (e) => {
  const { name: t, theme: n } = e, r = t ? uD({ string: t }) : "colors.gray.400", o = lD(r)(n);
  let i = "white";
  return o || (i = "gray.800"), {
    bg: e0.reference,
    fontSize: v0.reference,
    color: i,
    borderColor: ls.reference,
    verticalAlign: "top",
    width: bs.reference,
    height: bs.reference,
    "&:not([data-loaded])": {
      [e0.variable]: r
    },
    [ls.variable]: "colors.white",
    _dark: {
      [ls.variable]: "colors.gray.800"
    }
  };
}, r$ = {
  fontSize: v0.reference,
  lineHeight: "1"
}, o$ = Jw((e) => ({
  badge: Pn(e$, e),
  excessLabel: Pn(t$, e),
  container: Pn(n$, e),
  label: r$
}));
function Zi(e) {
  const t = e !== "100%" ? Bw[e] : void 0;
  return Jw({
    container: {
      [bs.variable]: t ?? e,
      [v0.variable]: `calc(${t ?? e} / 2.5)`
    },
    excessLabel: {
      [bs.variable]: t ?? e,
      [v0.variable]: `calc(${t ?? e} / 2.5)`
    }
  });
}
var i$ = {
  "2xs": Zi(4),
  xs: Zi(6),
  sm: Zi(8),
  md: Zi(12),
  lg: Zi(16),
  xl: Zi(24),
  "2xl": Zi(32),
  full: Zi("100%")
}, a$ = KW({
  baseStyle: o$,
  sizes: i$,
  defaultProps: {
    size: "md"
  }
}), s$ = {
  Accordion: WW,
  Alert: qW,
  Avatar: a$,
  Badge: Q5,
  Breadcrumb: lW,
  Button: gW,
  Checkbox: Yl,
  CloseButton: AW,
  Code: MW,
  Container: kW,
  Divider: VW,
  Drawer: _G,
  Editable: DG,
  Form: UG,
  FormError: qG,
  FormLabel: eW,
  Heading: rW,
  Input: $1,
  Kbd: Tz,
  Link: Iz,
  List: kz,
  Menu: Zz,
  Modal: qz,
  NumberInput: sG,
  PinInput: dG,
  Popover: wG,
  Progress: BZ,
  Radio: GZ,
  Select: JZ,
  Skeleton: qZ,
  SkipLink: ez,
  Slider: dz,
  Spinner: hz,
  Stat: wz,
  Switch: ID,
  Table: _D,
  Tabs: XD,
  Tag: sZ,
  Textarea: vZ,
  Tooltip: wZ,
  Card: wW,
  Stepper: EN
}, Qw = {
  colors: {
    "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
    "chakra-body-bg": { _light: "white", _dark: "gray.800" },
    "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
    "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
    "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
    "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
    "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" }
  }
}, qw = {
  global: {
    body: {
      fontFamily: "body",
      color: "chakra-body-text",
      bg: "chakra-body-bg",
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base"
    },
    "*::placeholder": {
      color: "chakra-placeholder-color"
    },
    "*, *::before, &::after": {
      borderColor: "chakra-border-color"
    }
  }
}, Kw = "ltr", eS = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, Mr = {
  semanticTokens: Qw,
  direction: Kw,
  ...kw,
  components: s$,
  styles: qw,
  config: eS
}, tS = {
  semanticTokens: Qw,
  direction: Kw,
  components: {},
  ...kw,
  styles: qw,
  config: eS
};
function G5(e) {
  return typeof e == "function";
}
function l$(...e) {
  return (t) => e.reduce((n, r) => r(n), t);
}
var c$ = (e) => function(...n) {
  let r = [...n], o = n[n.length - 1];
  return nN(o) && r.length > 1 ? r = r.slice(0, r.length - 1) : o = e, l$(
    ...r.map(
      (i) => (a) => G5(i) ? i(a) : d$(a, i)
    )
  )(o);
}, u$ = c$(tS);
function d$(...e) {
  return nr({}, ...e, nS);
}
function nS(e, t, n, r) {
  if ((G5(e) || G5(t)) && Object.prototype.hasOwnProperty.call(r, n))
    return (...o) => {
      const i = G5(e) ? e(...o) : e, a = G5(t) ? t(...o) : t;
      return nr({}, i, a, nS);
    };
}
function f$() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var p$ = /* @__PURE__ */ f$();
function h$(e, t) {
  const n = {};
  return Object.keys(e).forEach((r) => {
    t.includes(r) || (n[r] = e[r]);
  }), n;
}
function m$(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
var C$ = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, i, a) => {
    if (typeof r > "u")
      return e(r, o, i);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const l = t.get(r);
    if (l.has(o))
      return l.get(o);
    const c = e(r, o, i, a);
    return l.set(o, c), c;
  };
}, rS = C$(m$);
function oS(e, t) {
  const n = {};
  return Object.keys(e).forEach((r) => {
    const o = e[r];
    t(o, r, e) && (n[r] = o);
  }), n;
}
var iS = (e) => oS(e, (t) => t != null);
function g$(e) {
  return typeof e == "function";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
function aS(e, ...t) {
  return g$(e) ? e(...t) : e;
}
function b$(...e) {
  return function(n) {
    e.some((r) => (r?.(n), n?.defaultPrevented));
  };
}
var A8, xg;
function v$() {
  if (xg) return A8;
  xg = 1;
  var e = typeof Element < "u", t = typeof Map == "function", n = typeof Set == "function", r = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function o(i, a) {
    if (i === a) return !0;
    if (i && a && typeof i == "object" && typeof a == "object") {
      if (i.constructor !== a.constructor) return !1;
      var l, c, u;
      if (Array.isArray(i)) {
        if (l = i.length, l != a.length) return !1;
        for (c = l; c-- !== 0; )
          if (!o(i[c], a[c])) return !1;
        return !0;
      }
      var f;
      if (t && i instanceof Map && a instanceof Map) {
        if (i.size !== a.size) return !1;
        for (f = i.entries(); !(c = f.next()).done; )
          if (!a.has(c.value[0])) return !1;
        for (f = i.entries(); !(c = f.next()).done; )
          if (!o(c.value[1], a.get(c.value[0]))) return !1;
        return !0;
      }
      if (n && i instanceof Set && a instanceof Set) {
        if (i.size !== a.size) return !1;
        for (f = i.entries(); !(c = f.next()).done; )
          if (!a.has(c.value[0])) return !1;
        return !0;
      }
      if (r && ArrayBuffer.isView(i) && ArrayBuffer.isView(a)) {
        if (l = i.length, l != a.length) return !1;
        for (c = l; c-- !== 0; )
          if (i[c] !== a[c]) return !1;
        return !0;
      }
      if (i.constructor === RegExp) return i.source === a.source && i.flags === a.flags;
      if (i.valueOf !== Object.prototype.valueOf && typeof i.valueOf == "function" && typeof a.valueOf == "function") return i.valueOf() === a.valueOf();
      if (i.toString !== Object.prototype.toString && typeof i.toString == "function" && typeof a.toString == "function") return i.toString() === a.toString();
      if (u = Object.keys(i), l = u.length, l !== Object.keys(a).length) return !1;
      for (c = l; c-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(a, u[c])) return !1;
      if (e && i instanceof Element) return !1;
      for (c = l; c-- !== 0; )
        if (!((u[c] === "_owner" || u[c] === "__v" || u[c] === "__o") && i.$$typeof) && !o(i[u[c]], a[u[c]]))
          return !1;
      return !0;
    }
    return i !== i && a !== a;
  }
  return A8 = function(a, l) {
    try {
      return o(a, l);
    } catch (c) {
      if ((c.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw c;
    }
  }, A8;
}
var y$ = v$();
const x$ = /* @__PURE__ */ k9(y$);
function sS(e, t = {}) {
  var n;
  const { styleConfig: r, ...o } = t, { theme: i, colorMode: a } = vw(), l = e ? rS(i, `components.${e}`) : void 0, c = r || l, u = nr(
    { theme: i, colorMode: a },
    (n = c?.defaultProps) != null ? n : {},
    iS(h$(o, ["children"]))
  ), f = Re({});
  if (c) {
    const h = eN(c)(u);
    x$(f.current, h) || (f.current = h);
  }
  return f.current;
}
function aa(e, t = {}) {
  return sS(e, t);
}
function i2(e, t = {}) {
  return sS(e, t);
}
var w$ = /* @__PURE__ */ new Set([
  ...zO,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), S$ = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function T$(e) {
  return S$.has(e) || !w$.has(e);
}
function A$(e, ...t) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const n = { ...e };
  for (const r of t)
    if (r != null)
      for (const o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (o in n && delete n[o], n[o] = r[o]);
  return n;
}
function lS(e) {
  const t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
var wg, I$ = (wg = BC.default) != null ? wg : BC, L$ = ({ baseStyle: e }) => (t) => {
  const { theme: n, css: r, __css: o, sx: i, ...a } = t, l = oS(a, (p, h) => WO(h)), c = aS(e, t), u = A$(
    {},
    o,
    c,
    iS(l),
    i
  ), f = F9(u)(t.theme);
  return r ? [f, r] : f;
};
function I8(e, t) {
  const { baseStyle: n, ...r } = t ?? {};
  r.shouldForwardProp || (r.shouldForwardProp = T$);
  const o = L$({ baseStyle: n }), i = I$(
    e,
    r
  )(o);
  return w.forwardRef(function(c, u) {
    const { colorMode: f, forced: p } = Ee();
    return w.createElement(i, {
      ref: u,
      "data-theme": p ? f : void 0,
      ...c
    });
  });
}
function E$() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(I8, {
    apply(t, n, r) {
      return I8(...r);
    },
    get(t, n) {
      return e.has(n) || e.set(n, I8(n)), e.get(n);
    }
  });
}
var je = E$();
function Le(e) {
  return ro(e);
}
function M$(e = {}) {
  const {
    strict: t = !0,
    errorMessage: n = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name: r
  } = e, o = pn(void 0);
  o.displayName = r;
  function i() {
    var a;
    const l = N1(o);
    if (!l && t) {
      const c = new Error(n);
      throw c.name = "ContextError", (a = Error.captureStackTrace) == null || a.call(Error, c, i), c;
    }
    return l;
  }
  return [
    o.Provider,
    i,
    o
  ];
}
function B$(e) {
  const { cssVarsRoot: t, theme: n, children: r } = e, o = we(() => ZO(n), [n]);
  return /* @__PURE__ */ X(sH, { theme: o, children: [
    /* @__PURE__ */ g(k$, { root: t }),
    r
  ] });
}
function k$({ root: e = ":host, :root" }) {
  const t = [e, "[data-theme]"].join(",");
  return /* @__PURE__ */ g(M9, { styles: (n) => ({ [t]: n.__cssVars }) });
}
M$({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function R$() {
  const { colorMode: e } = Ee();
  return /* @__PURE__ */ g(
    M9,
    {
      styles: (t) => {
        const n = rS(t, "styles.global"), r = aS(n, { theme: t, colorMode: e });
        return r ? F9(r)(t) : void 0;
      }
    }
  );
}
var rf = pn({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
rf.displayName = "EnvironmentContext";
function _$({ defer: e } = {}) {
  const [, t] = lw((n) => n + 1, 0);
  return Xa(() => {
    e && t();
  }, [e]), N1(rf);
}
function cS(e) {
  const { children: t, environment: n, disabled: r } = e, o = Re(null), i = we(() => n || {
    getDocument: () => {
      var l, c;
      return (c = (l = o.current) == null ? void 0 : l.ownerDocument) != null ? c : document;
    },
    getWindow: () => {
      var l, c;
      return (c = (l = o.current) == null ? void 0 : l.ownerDocument.defaultView) != null ? c : window;
    }
  }, [n]), a = !r || !n;
  return /* @__PURE__ */ X(rf.Provider, { value: i, children: [
    t,
    a && /* @__PURE__ */ g("span", { id: "__chakra_env", hidden: !0, ref: o })
  ] });
}
cS.displayName = "EnvironmentProvider";
var F$ = (e) => {
  const {
    children: t,
    colorModeManager: n,
    portalZIndex: r,
    resetScope: o,
    resetCSS: i = !0,
    theme: a = {},
    environment: l,
    cssVarsRoot: c,
    disableEnvironment: u,
    disableGlobalStyle: f
  } = e, p = /* @__PURE__ */ g(
    cS,
    {
      environment: l,
      disabled: u,
      children: t
    }
  );
  return /* @__PURE__ */ g(B$, { theme: a, cssVarsRoot: c, children: /* @__PURE__ */ X(
    bw,
    {
      colorModeManager: n,
      options: a.config,
      children: [
        i ? /* @__PURE__ */ g(xH, { scope: o }) : /* @__PURE__ */ g(yH, {}),
        !f && /* @__PURE__ */ g(R$, {}),
        r ? /* @__PURE__ */ g(Cw, { zIndex: r, children: p }) : p
      ]
    }
  ) });
}, P$ = (e, t) => e.find((n) => n.id === t);
function Sg(e, t) {
  const n = uS(e, t), r = n ? e[n].findIndex((o) => o.id === t) : -1;
  return {
    position: n,
    index: r
  };
}
function uS(e, t) {
  for (const [n, r] of Object.entries(e))
    if (P$(r, t))
      return n;
}
function V$(e) {
  const t = e.includes("right"), n = e.includes("left");
  let r = "center";
  return t && (r = "flex-end"), n && (r = "flex-start"), {
    display: "flex",
    flexDirection: "column",
    alignItems: r
  };
}
function H$(e) {
  const n = e === "top" || e === "bottom" ? "0 auto" : void 0, r = e.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0, o = e.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0, i = e.includes("left") ? void 0 : "env(safe-area-inset-right, 0px)", a = e.includes("right") ? void 0 : "env(safe-area-inset-left, 0px)";
  return {
    position: "fixed",
    zIndex: "var(--toast-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin: n,
    top: r,
    bottom: o,
    right: i,
    left: a
  };
}
function qi(e, t = []) {
  const n = Re(e);
  return Oe(() => {
    n.current = e;
  }), se((...r) => {
    var o;
    return (o = n.current) == null ? void 0 : o.call(n, ...r);
  }, t);
}
function O$(e, t) {
  const n = qi(e);
  Oe(() => {
    if (t == null)
      return;
    let r = null;
    return r = window.setTimeout(() => {
      n();
    }, t), () => {
      r && window.clearTimeout(r);
    };
  }, [t, n]);
}
function vs(e, t) {
  const n = Re(!1), r = Re(!1);
  Oe(() => {
    if (n.current && r.current)
      return e();
    r.current = !0;
  }, t), Oe(() => (n.current = !0, () => {
    n.current = !1;
  }), []);
}
const dS = pn({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), H9 = pn({}), X0 = pn(null), O9 = typeof document < "u", Ql = O9 ? z0 : Oe, fS = pn({ strict: !1 });
function N$(e, t, n, r) {
  const { visualElement: o } = N1(H9), i = N1(fS), a = N1(X0), l = N1(dS).reducedMotion, c = Re();
  r = r || i.renderer, !c.current && r && (c.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const u = c.current;
  return cw(() => {
    u && u.update(n, a);
  }), Ql(() => {
    u && u.render();
  }), Oe(() => {
    u && u.updateFeatures();
  }), (window.HandoffAppearAnimations ? Ql : Oe)(() => {
    u && u.animationState && u.animationState.animateChanges();
  }), u;
}
function es(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function D$(e, t, n) {
  return se(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : es(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function y0(e) {
  return typeof e == "string" || Array.isArray(e);
}
function N9(e) {
  return typeof e == "object" && typeof e.start == "function";
}
const of = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], af = ["initial", ...of];
function D9(e) {
  return N9(e.animate) || af.some((t) => y0(e[t]));
}
function pS(e) {
  return !!(D9(e) || e.variants);
}
function Z$(e, t) {
  if (D9(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || y0(n) ? n : void 0,
      animate: y0(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function z$(e) {
  const { initial: t, animate: n } = Z$(e, N1(H9));
  return we(() => ({ initial: t, animate: n }), [Tg(t), Tg(n)]);
}
function Tg(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Ag = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, x0 = {};
for (const e in Ag)
  x0[e] = {
    isEnabled: (t) => Ag[e].some((n) => !!t[n])
  };
function G$(e) {
  for (const t in e)
    x0[t] = {
      ...x0[t],
      ...e[t]
    };
}
function sf(e) {
  const t = Re(null);
  return t.current === null && (t.current = e()), t.current;
}
const t0 = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
let W$ = 1;
function $$() {
  return sf(() => {
    if (t0.hasEverUpdated)
      return W$++;
  });
}
const lf = pn({}), hS = pn({}), U$ = Symbol.for("motionComponentSymbol");
function j$({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: o }) {
  e && G$(e);
  function i(l, c) {
    let u;
    const f = {
      ...N1(dS),
      ...l,
      layoutId: X$(l)
    }, { isStatic: p } = f, h = z$(l), C = p ? void 0 : $$(), v = r(l, p);
    if (!p && O9) {
      h.visualElement = N$(o, v, f, t);
      const b = N1(hS), y = N1(fS).strict;
      h.visualElement && (u = h.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        f,
        y,
        e,
        C,
        b
      ));
    }
    return Se.createElement(
      H9.Provider,
      { value: h },
      u && h.visualElement ? Se.createElement(u, { visualElement: h.visualElement, ...f }) : null,
      n(o, l, C, D$(v, h.visualElement, c), v, p, h.visualElement)
    );
  }
  const a = ro(i);
  return a[U$] = o, a;
}
function X$({ layoutId: e }) {
  const t = N1(lf).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function Y$(e) {
  function t(r, o = {}) {
    return j$(e(r, o));
  }
  if (typeof Proxy > "u")
    return t;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => (n.has(o) || n.set(o, t(o)), n.get(o))
  });
}
const J$ = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function cf(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(J$.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const ql = {};
function Q$(e) {
  Object.assign(ql, e);
}
const Z9 = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], a2 = new Set(Z9);
function mS(e, { layout: t, layoutId: n }) {
  return a2.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!ql[e] || e === "opacity");
}
const jn = (e) => !!(e && e.getVelocity), q$ = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, K$ = Z9.length;
function eU(e, { enableHardwareAcceleration: t = !0, allowTransformNone: n = !0 }, r, o) {
  let i = "";
  for (let a = 0; a < K$; a++) {
    const l = Z9[a];
    if (e[l] !== void 0) {
      const c = q$[l] || l;
      i += `${c}(${e[l]}) `;
    }
  }
  return t && !e.z && (i += "translateZ(0)"), i = i.trim(), o ? i = o(e, r ? "" : i) : n && r && (i = "none"), i;
}
const CS = (e) => (t) => typeof t == "string" && t.startsWith(e), gS = CS("--"), ru = CS("var(--"), tU = (e, t) => t && typeof e == "number" ? t.transform(e) : e, Ya = (e, t, n) => Math.min(Math.max(n, e), t), s2 = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, n0 = {
  ...s2,
  transform: (e) => Ya(0, 1, e)
}, U4 = {
  ...s2,
  default: 1
}, r0 = (e) => Math.round(e * 1e5) / 1e5, w0 = /(-)?([\d]*\.?[\d])+/g, ou = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, nU = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function Y0(e) {
  return typeof e == "string";
}
const J0 = (e) => ({
  test: (t) => Y0(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), Gi = J0("deg"), Io = J0("%"), c1 = J0("px"), rU = J0("vh"), oU = J0("vw"), Ig = {
  ...Io,
  parse: (e) => Io.parse(e) / 100,
  transform: (e) => Io.transform(e * 100)
}, Lg = {
  ...s2,
  transform: Math.round
}, bS = {
  // Border props
  borderWidth: c1,
  borderTopWidth: c1,
  borderRightWidth: c1,
  borderBottomWidth: c1,
  borderLeftWidth: c1,
  borderRadius: c1,
  radius: c1,
  borderTopLeftRadius: c1,
  borderTopRightRadius: c1,
  borderBottomRightRadius: c1,
  borderBottomLeftRadius: c1,
  // Positioning props
  width: c1,
  maxWidth: c1,
  height: c1,
  maxHeight: c1,
  size: c1,
  top: c1,
  right: c1,
  bottom: c1,
  left: c1,
  // Spacing props
  padding: c1,
  paddingTop: c1,
  paddingRight: c1,
  paddingBottom: c1,
  paddingLeft: c1,
  margin: c1,
  marginTop: c1,
  marginRight: c1,
  marginBottom: c1,
  marginLeft: c1,
  // Transform props
  rotate: Gi,
  rotateX: Gi,
  rotateY: Gi,
  rotateZ: Gi,
  scale: U4,
  scaleX: U4,
  scaleY: U4,
  scaleZ: U4,
  skew: Gi,
  skewX: Gi,
  skewY: Gi,
  distance: c1,
  translateX: c1,
  translateY: c1,
  translateZ: c1,
  x: c1,
  y: c1,
  z: c1,
  perspective: c1,
  transformPerspective: c1,
  opacity: n0,
  originX: Ig,
  originY: Ig,
  originZ: c1,
  // Misc
  zIndex: Lg,
  // SVG
  fillOpacity: n0,
  strokeOpacity: n0,
  numOctaves: Lg
};
function uf(e, t, n, r) {
  const { style: o, vars: i, transform: a, transformOrigin: l } = e;
  let c = !1, u = !1, f = !0;
  for (const p in t) {
    const h = t[p];
    if (gS(p)) {
      i[p] = h;
      continue;
    }
    const C = bS[p], v = tU(h, C);
    if (a2.has(p)) {
      if (c = !0, a[p] = v, !f)
        continue;
      h !== (C.default || 0) && (f = !1);
    } else p.startsWith("origin") ? (u = !0, l[p] = v) : o[p] = v;
  }
  if (t.transform || (c || r ? o.transform = eU(e.transform, n, f, r) : o.transform && (o.transform = "none")), u) {
    const { originX: p = "50%", originY: h = "50%", originZ: C = 0 } = l;
    o.transformOrigin = `${p} ${h} ${C}`;
  }
}
const df = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function vS(e, t, n) {
  for (const r in t)
    !jn(t[r]) && !mS(r, n) && (e[r] = t[r]);
}
function iU({ transformTemplate: e }, t, n) {
  return we(() => {
    const r = df();
    return uf(r, t, { enableHardwareAcceleration: !n }, e), Object.assign({}, r.vars, r.style);
  }, [t]);
}
function aU(e, t, n) {
  const r = e.style || {}, o = {};
  return vS(o, r, e), Object.assign(o, iU(e, t, n)), e.transformValues ? e.transformValues(o) : o;
}
function sU(e, t, n) {
  const r = {}, o = aU(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (r.tabIndex = 0), r.style = o, r;
}
const lU = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "ignoreStrict",
  "viewport"
]);
function Kl(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || lU.has(e);
}
let yS = (e) => !Kl(e);
function cU(e) {
  e && (yS = (t) => t.startsWith("on") ? !Kl(t) : e(t));
}
try {
  cU(require("@emotion/is-prop-valid").default);
} catch {
}
function uU(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (yS(o) || n === !0 && Kl(o) || !t && !Kl(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
function Eg(e, t, n) {
  return typeof e == "string" ? e : c1.transform(t + n * e);
}
function dU(e, t, n) {
  const r = Eg(t, e.x, e.width), o = Eg(n, e.y, e.height);
  return `${r} ${o}`;
}
const fU = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, pU = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function hU(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const i = o ? fU : pU;
  e[i.offset] = c1.transform(-r);
  const a = c1.transform(t), l = c1.transform(n);
  e[i.array] = `${a} ${l}`;
}
function ff(e, {
  attrX: t,
  attrY: n,
  originX: r,
  originY: o,
  pathLength: i,
  pathSpacing: a = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, u, f, p) {
  if (uf(e, c, u, p), f) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: h, style: C, dimensions: v } = e;
  h.transform && (v && (C.transform = h.transform), delete h.transform), v && (r !== void 0 || o !== void 0 || C.transform) && (C.transformOrigin = dU(v, r !== void 0 ? r : 0.5, o !== void 0 ? o : 0.5)), t !== void 0 && (h.x = t), n !== void 0 && (h.y = n), i !== void 0 && hU(h, i, a, l, !1);
}
const xS = () => ({
  ...df(),
  attrs: {}
}), pf = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function mU(e, t, n, r) {
  const o = we(() => {
    const i = xS();
    return ff(i, t, { enableHardwareAcceleration: !1 }, pf(r), e.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    vS(i, e.style, e), o.style = { ...i, ...o.style };
  }
  return o;
}
function CU(e = !1) {
  return (n, r, o, i, { latestValues: a }, l) => {
    const u = (cf(n) ? mU : sU)(r, a, l, n), p = {
      ...uU(r, typeof n == "string", e),
      ...u,
      ref: i
    }, { children: h } = r, C = we(() => jn(h) ? h.get() : h, [h]);
    return o && (p["data-projection-id"] = o), X5(n, {
      ...p,
      children: C
    });
  };
}
const hf = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
function wS(e, { style: t, vars: n }, r, o) {
  Object.assign(e.style, t, o && o.getProjectionStyles(r));
  for (const i in n)
    e.style.setProperty(i, n[i]);
}
const SS = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function TS(e, t, n, r) {
  wS(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(SS.has(o) ? o : hf(o), t.attrs[o]);
}
function mf(e, t) {
  const { style: n } = e, r = {};
  for (const o in n)
    (jn(n[o]) || t.style && jn(t.style[o]) || mS(o, e)) && (r[o] = n[o]);
  return r;
}
function AS(e, t) {
  const n = mf(e, t);
  for (const r in e)
    if (jn(e[r]) || jn(t[r])) {
      const o = r === "x" || r === "y" ? "attr" + r.toUpperCase() : r;
      n[o] = e[r];
    }
  return n;
}
function Cf(e, t, n, r = {}, o = {}) {
  return typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, o)), typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, o)), t;
}
const e9 = (e) => Array.isArray(e), gU = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), bU = (e) => e9(e) ? e[e.length - 1] || 0 : e;
function Al(e) {
  const t = jn(e) ? e.get() : e;
  return gU(t) ? t.toValue() : t;
}
function vU({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, o, i) {
  const a = {
    latestValues: yU(r, o, i, e),
    renderState: t()
  };
  return n && (a.mount = (l) => n(r, l, a)), a;
}
const IS = (e) => (t, n) => {
  const r = N1(H9), o = N1(X0), i = () => vU(e, t, r, o);
  return n ? i() : sf(i);
};
function yU(e, t, n, r) {
  const o = {}, i = r(e, {});
  for (const h in i)
    o[h] = Al(i[h]);
  let { initial: a, animate: l } = e;
  const c = D9(e), u = pS(e);
  t && u && !c && e.inherit !== !1 && (a === void 0 && (a = t.initial), l === void 0 && (l = t.animate));
  let f = n ? n.initial === !1 : !1;
  f = f || a === !1;
  const p = f ? l : a;
  return p && typeof p != "boolean" && !N9(p) && (Array.isArray(p) ? p : [p]).forEach((C) => {
    const v = Cf(e, C);
    if (!v)
      return;
    const { transitionEnd: b, transition: y, ...x } = v;
    for (const T in x) {
      let A = x[T];
      if (Array.isArray(A)) {
        const L = f ? A.length - 1 : 0;
        A = A[L];
      }
      A !== null && (o[T] = A);
    }
    for (const T in b)
      o[T] = b[T];
  }), o;
}
const xU = {
  useVisualState: IS({
    scrapeMotionValuesFromProps: AS,
    createRenderState: xS,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      try {
        n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
      } catch {
        n.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      ff(n, r, { enableHardwareAcceleration: !1 }, pf(t.tagName), e.transformTemplate), TS(t, n);
    }
  })
}, wU = {
  useVisualState: IS({
    scrapeMotionValuesFromProps: mf,
    createRenderState: df
  })
};
function SU(e, { forwardMotionProps: t = !1 }, n, r) {
  return {
    ...cf(e) ? xU : wU,
    preloadedFeatures: n,
    useRender: CU(t),
    createVisualElement: r,
    Component: e
  };
}
function ii(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const LS = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function z9(e, t = "page") {
  return {
    point: {
      x: e[t + "X"],
      y: e[t + "Y"]
    }
  };
}
const TU = (e) => (t) => LS(t) && e(t, z9(t));
function si(e, t, n, r) {
  return ii(e, t, TU(n), r);
}
const AU = (e, t) => (n) => t(e(n)), Ki = (...e) => e.reduce(AU);
function ES(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const Mg = ES("dragHorizontal"), Bg = ES("dragVertical");
function MS(e) {
  let t = !1;
  if (e === "y")
    t = Bg();
  else if (e === "x")
    t = Mg();
  else {
    const n = Mg(), r = Bg();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function BS() {
  const e = MS(!0);
  return e ? (e(), !1) : !0;
}
class sa {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function IU(e) {
  let t = [], n = [], r = 0, o = !1, i = !1;
  const a = /* @__PURE__ */ new WeakSet(), l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, u = !1, f = !1) => {
      const p = f && o, h = p ? t : n;
      return u && a.add(c), h.indexOf(c) === -1 && (h.push(c), p && o && (r = t.length)), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      const u = n.indexOf(c);
      u !== -1 && n.splice(u, 1), a.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (o) {
        i = !0;
        return;
      }
      if (o = !0, [t, n] = [n, t], n.length = 0, r = t.length, r)
        for (let u = 0; u < r; u++) {
          const f = t[u];
          f(c), a.has(f) && (l.schedule(f), e());
        }
      o = !1, i && (i = !1, l.process(c));
    }
  };
  return l;
}
const Kr = {
  delta: 0,
  timestamp: 0
}, LU = 40;
let iu = !0, S0 = !1, au = !1;
const Q0 = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], G9 = Q0.reduce((e, t) => (e[t] = IU(() => S0 = !0), e), {}), Tt = Q0.reduce((e, t) => {
  const n = G9[t];
  return e[t] = (r, o = !1, i = !1) => (S0 || MU(), n.schedule(r, o, i)), e;
}, {}), ta = Q0.reduce((e, t) => (e[t] = G9[t].cancel, e), {}), L8 = Q0.reduce((e, t) => (e[t] = () => G9[t].process(Kr), e), {}), EU = (e) => G9[e].process(Kr), kS = (e) => {
  S0 = !1, Kr.delta = iu ? 1e3 / 60 : Math.max(Math.min(e - Kr.timestamp, LU), 1), Kr.timestamp = e, au = !0, Q0.forEach(EU), au = !1, S0 && (iu = !1, requestAnimationFrame(kS));
}, MU = () => {
  S0 = !0, iu = !0, au || requestAnimationFrame(kS);
};
function kg(e, t) {
  const n = "pointer" + (t ? "enter" : "leave"), r = "onHover" + (t ? "Start" : "End"), o = (i, a) => {
    if (i.type === "touch" || BS())
      return;
    const l = e.getProps();
    e.animationState && l.whileHover && e.animationState.setActive("whileHover", t), l[r] && Tt.update(() => l[r](i, a));
  };
  return si(e.current, n, o, {
    passive: !e.getProps()[r]
  });
}
class BU extends sa {
  mount() {
    this.unmount = Ki(kg(this.node, !0), kg(this.node, !1));
  }
  unmount() {
  }
}
class kU extends sa {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Ki(ii(this.node.current, "focus", () => this.onFocus()), ii(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const RS = (e, t) => t ? e === t ? !0 : RS(e, t.parentElement) : !1, Rr = (e) => e;
function E8(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, z9(n));
}
class RU extends sa {
  constructor() {
    super(...arguments), this.removeStartListeners = Rr, this.removeEndListeners = Rr, this.removeAccessibleListeners = Rr, this.startPointerPress = (t, n) => {
      if (this.removeEndListeners(), this.isPressing)
        return;
      const r = this.node.getProps(), i = si(window, "pointerup", (l, c) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: u, onTapCancel: f } = this.node.getProps();
        Tt.update(() => {
          RS(this.node.current, l.target) ? u && u(l, c) : f && f(l, c);
        });
      }, { passive: !(r.onTap || r.onPointerUp) }), a = si(window, "pointercancel", (l, c) => this.cancelPress(l, c), { passive: !(r.onTapCancel || r.onPointerCancel) });
      this.removeEndListeners = Ki(i, a), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (i) => {
        if (i.key !== "Enter" || this.isPressing)
          return;
        const a = (l) => {
          l.key !== "Enter" || !this.checkPressEnd() || E8("up", (c, u) => {
            const { onTap: f } = this.node.getProps();
            f && Tt.update(() => f(c, u));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = ii(this.node.current, "keyup", a), E8("down", (l, c) => {
          this.startPress(l, c);
        });
      }, n = ii(this.node.current, "keydown", t), r = () => {
        this.isPressing && E8("cancel", (i, a) => this.cancelPress(i, a));
      }, o = ii(this.node.current, "blur", r);
      this.removeAccessibleListeners = Ki(n, o);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: o } = this.node.getProps();
    o && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && Tt.update(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !BS();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && Tt.update(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = si(this.node.current, "pointerdown", this.startPointerPress, { passive: !(t.onTapStart || t.onPointerStart) }), r = ii(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = Ki(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const su = /* @__PURE__ */ new WeakMap(), M8 = /* @__PURE__ */ new WeakMap(), _U = (e) => {
  const t = su.get(e.target);
  t && t(e);
}, FU = (e) => {
  e.forEach(_U);
};
function PU({ root: e, ...t }) {
  const n = e || document;
  M8.has(n) || M8.set(n, {});
  const r = M8.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(FU, { root: e, ...t })), r[o];
}
function VU(e, t, n) {
  const r = PU(t);
  return su.set(e, n), r.observe(e), () => {
    su.delete(e), r.unobserve(e);
  };
}
const HU = {
  some: 0,
  all: 1
};
class OU extends sa {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: i } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : HU[o]
    }, l = (c) => {
      const { isIntersecting: u } = c;
      if (this.isInView === u || (this.isInView = u, i && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: f, onViewportLeave: p } = this.node.getProps(), h = u ? f : p;
      h && h(c);
    };
    return VU(this.node.current, a, l);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(NU(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function NU({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const DU = {
  inView: {
    Feature: OU
  },
  tap: {
    Feature: RU
  },
  focus: {
    Feature: kU
  },
  hover: {
    Feature: BU
  }
};
function _S(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const ZU = (e) => /^\-?\d*\.?\d+$/.test(e), zU = (e) => /^0[^.\s]+$/.test(e);
function gf(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function bf(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class vf {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return gf(this.subscriptions, t), () => bf(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let i = 0; i < o; i++) {
          const a = this.subscriptions[i];
          a && a(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function FS(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const Rg = /* @__PURE__ */ new Set();
function yf(e, t, n) {
  e || Rg.has(t) || (console.warn(t), Rg.add(t));
}
const GU = (e) => !isNaN(parseFloat(e));
class WU {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "10.2.5", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (r, o = !0) => {
      this.prev = this.current, this.current = r;
      const { delta: i, timestamp: a } = Kr;
      this.lastUpdated !== a && (this.timeDelta = i, this.lastUpdated = a, Tt.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), o && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => Tt.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: r }) => {
      r !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = GU(this.current), this.owner = n.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && yf(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new vf());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), Tt.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = t, this.timeDelta = r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t) {
    this.updateAndNotify(t), this.prev = t, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      FS(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function ys(e, t) {
  return new WU(e, t);
}
const xf = (e, t) => (n) => !!(Y0(n) && nU.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), PS = (e, t, n) => (r) => {
  if (!Y0(r))
    return r;
  const [o, i, a, l] = r.match(w0);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(i),
    [n]: parseFloat(a),
    alpha: l !== void 0 ? parseFloat(l) : 1
  };
}, $U = (e) => Ya(0, 255, e), B8 = {
  ...s2,
  transform: (e) => Math.round($U(e))
}, Va = {
  test: xf("rgb", "red"),
  parse: PS("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + B8.transform(e) + ", " + B8.transform(t) + ", " + B8.transform(n) + ", " + r0(n0.transform(r)) + ")"
};
function UU(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const lu = {
  test: xf("#"),
  parse: UU,
  transform: Va.transform
}, ts = {
  test: xf("hsl", "hue"),
  parse: PS("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Io.transform(r0(t)) + ", " + Io.transform(r0(n)) + ", " + r0(n0.transform(r)) + ")"
}, En = {
  test: (e) => Va.test(e) || lu.test(e) || ts.test(e),
  parse: (e) => Va.test(e) ? Va.parse(e) : ts.test(e) ? ts.parse(e) : lu.parse(e),
  transform: (e) => Y0(e) ? e : e.hasOwnProperty("red") ? Va.transform(e) : ts.transform(e)
}, VS = "${c}", HS = "${n}";
function jU(e) {
  var t, n;
  return isNaN(e) && Y0(e) && (((t = e.match(w0)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(ou)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
function t9(e) {
  typeof e == "number" && (e = `${e}`);
  const t = [];
  let n = 0, r = 0;
  const o = e.match(ou);
  o && (n = o.length, e = e.replace(ou, VS), t.push(...o.map(En.parse)));
  const i = e.match(w0);
  return i && (r = i.length, e = e.replace(w0, HS), t.push(...i.map(s2.parse))), { values: t, numColors: n, numNumbers: r, tokenised: e };
}
function OS(e) {
  return t9(e).values;
}
function NS(e) {
  const { values: t, numColors: n, tokenised: r } = t9(e), o = t.length;
  return (i) => {
    let a = r;
    for (let l = 0; l < o; l++)
      a = a.replace(l < n ? VS : HS, l < n ? En.transform(i[l]) : r0(i[l]));
    return a;
  };
}
const XU = (e) => typeof e == "number" ? 0 : e;
function YU(e) {
  const t = OS(e);
  return NS(e)(t.map(XU));
}
const na = { test: jU, parse: OS, createTransformer: NS, getAnimatableNone: YU }, JU = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function QU(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(w0) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let i = JU.has(t) ? 1 : 0;
  return r !== n && (i *= 100), t + "(" + i + o + ")";
}
const qU = /([a-z-]*)\(.*?\)/g, cu = {
  ...na,
  getAnimatableNone: (e) => {
    const t = e.match(qU);
    return t ? t.map(QU).join(" ") : e;
  }
}, KU = {
  ...bS,
  // Color props
  color: En,
  backgroundColor: En,
  outlineColor: En,
  fill: En,
  stroke: En,
  // Border props
  borderColor: En,
  borderTopColor: En,
  borderRightColor: En,
  borderBottomColor: En,
  borderLeftColor: En,
  filter: cu,
  WebkitFilter: cu
}, wf = (e) => KU[e];
function Sf(e, t) {
  let n = wf(e);
  return n !== cu && (n = na), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const DS = (e) => (t) => t.test(e), ej = {
  test: (e) => e === "auto",
  parse: (e) => e
}, ZS = [s2, c1, Io, Gi, oU, rU, ej], M5 = (e) => ZS.find(DS(e)), tj = [...ZS, En, na], nj = (e) => tj.find(DS(e));
function rj(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.get()), t;
}
function oj(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.getVelocity()), t;
}
function W9(e, t, n) {
  const r = e.getProps();
  return Cf(r, t, n !== void 0 ? n : r.custom, rj(e), oj(e));
}
function ij(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, ys(n));
}
function aj(e, t) {
  const n = W9(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...i } = n ? e.makeTargetAnimatable(n, !1) : {};
  i = { ...i, ...r };
  for (const a in i) {
    const l = bU(i[a]);
    ij(e, a, l);
  }
}
function sj(e, t, n) {
  var r, o;
  const i = Object.keys(t).filter((l) => !e.hasValue(l)), a = i.length;
  if (a)
    for (let l = 0; l < a; l++) {
      const c = i[l], u = t[c];
      let f = null;
      Array.isArray(u) && (f = u[0]), f === null && (f = (o = (r = n[c]) !== null && r !== void 0 ? r : e.readValue(c)) !== null && o !== void 0 ? o : t[c]), f != null && (typeof f == "string" && (ZU(f) || zU(f)) ? f = parseFloat(f) : !nj(f) && na.test(u) && (f = Sf(c, u)), e.addValue(c, ys(f, { owner: e })), n[c] === void 0 && (n[c] = f), f !== null && e.setBaseTarget(c, f));
    }
}
function lj(e, t) {
  return t ? (t[e] || t.default || t).from : void 0;
}
function cj(e, t, n) {
  const r = {};
  for (const o in e) {
    const i = lj(o, t);
    if (i !== void 0)
      r[o] = i;
    else {
      const a = n.getValue(o);
      a && (r[o] = a.get());
    }
  }
  return r;
}
function n9(e) {
  return !!(jn(e) && e.add);
}
const uj = "framerAppearId", dj = "data-" + hf(uj);
let q0 = Rr, Fr = Rr;
process.env.NODE_ENV !== "production" && (q0 = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, Fr = (e, t) => {
  if (!e)
    throw new Error(t);
});
const ea = (e) => e * 1e3, xs = (e) => e / 1e3, fj = {
  current: !1
};
function pj(e) {
  return !e || // Default easing
  Array.isArray(e) || // Bezier curve
  typeof e == "string" && zS[e];
}
const W5 = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, zS = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: W5([0, 0.65, 0.55, 1]),
  circOut: W5([0.55, 0, 1, 0.45]),
  backIn: W5([0.31, 0.01, 0.66, -0.59]),
  backOut: W5([0.33, 1.53, 0.69, 0.99])
};
function hj(e) {
  if (e)
    return Array.isArray(e) ? W5(e) : zS[e];
}
function mj(e, t, n, { delay: r = 0, duration: o, repeat: i = 0, repeatType: a = "loop", ease: l, times: c } = {}) {
  const u = { [t]: n };
  return c && (u.offset = c), e.animate(u, {
    delay: r,
    duration: o,
    easing: hj(l),
    fill: "both",
    iterations: i + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  });
}
const _g = {
  waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate")
}, k8 = {}, GS = {};
for (const e in _g)
  GS[e] = () => (k8[e] === void 0 && (k8[e] = _g[e]()), k8[e]);
function Cj(e, { repeat: t, repeatType: n = "loop" }) {
  const r = t && n !== "loop" && t % 2 === 1 ? 0 : e.length - 1;
  return e[r];
}
const Tf = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Af = (e) => (t) => 1 - e(1 - t), If = (e) => e * e, gj = Af(If), WS = Tf(If), kt = (e, t, n) => -n * e + n * t + e;
function R8(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function bj({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, i = 0, a = 0;
  if (!t)
    o = i = a = n;
  else {
    const l = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - l;
    o = R8(c, l, e + 1 / 3), i = R8(c, l, e), a = R8(c, l, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
const _8 = (e, t, n) => {
  const r = e * e;
  return Math.sqrt(Math.max(0, n * (t * t - r) + r));
}, vj = [lu, Va, ts], yj = (e) => vj.find((t) => t.test(e));
function Fg(e) {
  const t = yj(e);
  Fr(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`);
  let n = t.parse(e);
  return t === ts && (n = bj(n)), n;
}
const $S = (e, t) => {
  const n = Fg(e), r = Fg(t), o = { ...n };
  return (i) => (o.red = _8(n.red, r.red, i), o.green = _8(n.green, r.green, i), o.blue = _8(n.blue, r.blue, i), o.alpha = kt(n.alpha, r.alpha, i), Va.transform(o));
};
function US(e, t) {
  return typeof e == "number" ? (n) => kt(e, t, n) : En.test(e) ? $S(e, t) : XS(e, t);
}
const jS = (e, t) => {
  const n = [...e], r = n.length, o = e.map((i, a) => US(i, t[a]));
  return (i) => {
    for (let a = 0; a < r; a++)
      n[a] = o[a](i);
    return n;
  };
}, xj = (e, t) => {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = US(e[o], t[o]));
  return (o) => {
    for (const i in r)
      n[i] = r[i](o);
    return n;
  };
}, XS = (e, t) => {
  const n = na.createTransformer(t), r = t9(e), o = t9(t);
  return r.numColors === o.numColors && r.numNumbers >= o.numNumbers ? Ki(jS(r.values, o.values), n) : (q0(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (a) => `${a > 0 ? t : e}`);
}, T0 = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, Pg = (e, t) => (n) => kt(e, t, n);
function wj(e) {
  return typeof e == "number" ? Pg : typeof e == "string" ? En.test(e) ? $S : XS : Array.isArray(e) ? jS : typeof e == "object" ? xj : Pg;
}
function Sj(e, t, n) {
  const r = [], o = n || wj(e[0]), i = e.length - 1;
  for (let a = 0; a < i; a++) {
    let l = o(e[a], e[a + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[a] : t;
      l = Ki(c, l);
    }
    r.push(l);
  }
  return r;
}
function YS(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const i = e.length;
  Fr(i === t.length, "Both input and output ranges must be the same length"), Fr(!r || !Array.isArray(r) || r.length === i - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const a = Sj(t, r, o), l = a.length, c = (u) => {
    let f = 0;
    if (l > 1)
      for (; f < e.length - 2 && !(u < e[f + 1]); f++)
        ;
    const p = T0(e[f], e[f + 1], u);
    return a[f](p);
  };
  return n ? (u) => c(Ya(e[0], e[i - 1], u)) : c;
}
function Tj(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = T0(0, t, r);
    e.push(kt(n, 1, o));
  }
}
function Aj(e) {
  const t = [0];
  return Tj(t, e.length - 1), t;
}
function Ij(e, t) {
  return e.map((n) => n * t);
}
const JS = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, Lj = 1e-7, Ej = 12;
function Mj(e, t, n, r, o) {
  let i, a, l = 0;
  do
    a = t + (n - t) / 2, i = JS(a, r, o) - e, i > 0 ? n = a : t = a;
  while (Math.abs(i) > Lj && ++l < Ej);
  return a;
}
function QS(e, t, n, r) {
  if (e === t && n === r)
    return Rr;
  const o = (i) => Mj(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : JS(o(i), t, r);
}
const qS = (e) => 1 - Math.sin(Math.acos(e)), Lf = Af(qS), Bj = Tf(Lf), KS = QS(0.33, 1.53, 0.69, 0.99), Ef = Af(KS), kj = Tf(Ef), Rj = (e) => (e *= 2) < 1 ? 0.5 * Ef(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Vg = {
  linear: Rr,
  easeIn: If,
  easeInOut: WS,
  easeOut: gj,
  circIn: qS,
  circInOut: Bj,
  circOut: Lf,
  backIn: Ef,
  backInOut: kj,
  backOut: KS,
  anticipate: Rj
}, Hg = (e) => {
  if (Array.isArray(e)) {
    Fr(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, o] = e;
    return QS(t, n, r, o);
  } else if (typeof e == "string")
    return Fr(Vg[e] !== void 0, `Invalid easing type '${e}'`), Vg[e];
  return e;
}, _j = (e) => Array.isArray(e) && typeof e[0] != "number";
function Fj(e, t) {
  return e.map(() => t || WS).splice(0, e.length - 1);
}
function r9({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = _j(r) ? r.map(Hg) : Hg(r), i = {
    done: !1,
    value: t[0]
  }, a = Ij(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : Aj(t),
    e
  ), l = YS(a, t, {
    ease: Array.isArray(o) ? o : Fj(t, o)
  });
  return {
    calculatedDuration: e,
    next: (c) => (i.value = l(c), i.done = c >= e, i)
  };
}
const Pj = 5;
function eT(e, t, n) {
  const r = Math.max(t - Pj, 0);
  return FS(n - e(r), t - r);
}
const F8 = 1e-3, Vj = 0.01, Og = 10, Hj = 0.05, Oj = 1;
function Nj({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let o, i;
  q0(e <= ea(Og), "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = Ya(Hj, Oj, a), e = Ya(Vj, Og, xs(e)), a < 1 ? (o = (u) => {
    const f = u * a, p = f * e, h = f - n, C = uu(u, a), v = Math.exp(-p);
    return F8 - h / C * v;
  }, i = (u) => {
    const p = u * a * e, h = p * n + n, C = Math.pow(a, 2) * Math.pow(u, 2) * e, v = Math.exp(-p), b = uu(Math.pow(u, 2), a);
    return (-o(u) + F8 > 0 ? -1 : 1) * ((h - C) * v) / b;
  }) : (o = (u) => {
    const f = Math.exp(-u * e), p = (u - n) * e + 1;
    return -F8 + f * p;
  }, i = (u) => {
    const f = Math.exp(-u * e), p = (n - u) * (e * e);
    return f * p;
  });
  const l = 5 / e, c = Zj(o, i, l);
  if (e = ea(e), isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const u = Math.pow(c, 2) * r;
    return {
      stiffness: u,
      damping: a * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const Dj = 12;
function Zj(e, t, n) {
  let r = n;
  for (let o = 1; o < Dj; o++)
    r = r - e(r) / t(r);
  return r;
}
function uu(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const zj = ["duration", "bounce"], Gj = ["stiffness", "damping", "mass"];
function Ng(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function Wj(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Ng(e, Gj) && Ng(e, zj)) {
    const n = Nj(e);
    t = {
      ...t,
      ...n,
      velocity: 0,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function tT({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const o = e[0], i = e[e.length - 1], a = { done: !1, value: o }, { stiffness: l, damping: c, mass: u, velocity: f, duration: p, isResolvedFromDuration: h } = Wj(r), C = f ? -xs(f) : 0, v = c / (2 * Math.sqrt(l * u)), b = i - o, y = xs(Math.sqrt(l / u)), x = Math.abs(b) < 5;
  n || (n = x ? 0.01 : 2), t || (t = x ? 5e-3 : 0.5);
  let T;
  if (v < 1) {
    const A = uu(y, v);
    T = (L) => {
      const I = Math.exp(-v * y * L);
      return i - I * ((C + v * y * b) / A * Math.sin(A * L) + b * Math.cos(A * L));
    };
  } else if (v === 1)
    T = (A) => i - Math.exp(-y * A) * (b + (C + y * b) * A);
  else {
    const A = y * Math.sqrt(v * v - 1);
    T = (L) => {
      const I = Math.exp(-v * y * L), M = Math.min(A * L, 300);
      return i - I * ((C + v * y * b) * Math.sinh(M) + A * b * Math.cosh(M)) / A;
    };
  }
  return {
    calculatedDuration: h && p || null,
    next: (A) => {
      const L = T(A);
      if (h)
        a.done = A >= p;
      else {
        let I = C;
        A !== 0 && (v < 1 ? I = eT(T, A, L) : I = 0);
        const M = Math.abs(I) <= n, k = Math.abs(i - L) <= t;
        a.done = M && k;
      }
      return a.value = a.done ? i : L, a;
    }
  };
}
function Dg({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: i = 500, modifyTarget: a, min: l, max: c, restDelta: u = 0.5, restSpeed: f }) {
  const p = e[0], h = {
    done: !1,
    value: p
  }, C = (_) => l !== void 0 && _ < l || c !== void 0 && _ > c, v = (_) => l === void 0 ? c : c === void 0 || Math.abs(l - _) < Math.abs(c - _) ? l : c;
  let b = n * t;
  const y = p + b, x = a === void 0 ? y : a(y);
  x !== y && (b = x - p);
  const T = (_) => -b * Math.exp(-_ / r), A = (_) => x + T(_), L = (_) => {
    const F = T(_), $ = A(_);
    h.done = Math.abs(F) <= u, h.value = h.done ? x : $;
  };
  let I, M;
  const k = (_) => {
    C(h.value) && (I = _, M = tT({
      keyframes: [h.value, v(h.value)],
      velocity: eT(A, _, h.value),
      damping: o,
      stiffness: i,
      restDelta: u,
      restSpeed: f
    }));
  };
  return k(0), {
    calculatedDuration: null,
    next: (_) => {
      let F = !1;
      return !M && I === void 0 && (F = !0, L(_), k(_)), I !== void 0 && _ > I ? M.next(_ - I) : (!F && L(_), h);
    }
  };
}
const $j = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => Tt.update(t, !0),
    stop: () => ta.update(t),
    now: () => performance.now()
  };
}, Uj = {
  decay: Dg,
  inertia: Dg,
  tween: r9,
  keyframes: r9,
  spring: tT
}, jj = 2e4;
function Xj(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < jj; )
    t += n, r = e.next(t);
  return t;
}
function o9({ autoplay: e = !0, delay: t = 0, driver: n = $j, keyframes: r, type: o = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: l = "loop", onPlay: c, onStop: u, onComplete: f, onUpdate: p, ...h }) {
  let C;
  const v = Uj[o] || r9;
  let b;
  v !== r9 && typeof r[0] != "number" && (b = YS([0, 100], r, {
    clamp: !1
  }), r = [0, 100]);
  const y = v({ ...h, keyframes: r });
  let x;
  l === "mirror" && (x = v({
    ...h,
    keyframes: [...r].reverse(),
    velocity: -(h.velocity || 0)
  }));
  let T = "idle", A = null, L = null;
  y.calculatedDuration === null && i && (y.calculatedDuration = Xj(y));
  const { calculatedDuration: I } = y;
  let M = 1 / 0, k = 1 / 0;
  I && (M = I + a, k = M * (i + 1) - a);
  let _ = 0;
  const F = (te) => {
    if (L === null)
      return;
    A !== null ? _ = A : _ = te - L, _ = Math.max(_ - t, 0), T === "finished" && A === null && (_ = k);
    let ae = _, be = y;
    if (i) {
      const _e = _ / M;
      let ne = Math.floor(_e), ee = _e % 1;
      !ee && _e >= 1 && (ee = 1), ee === 1 && ne--;
      const ye = ne % 2;
      ye && (l === "reverse" ? (ee = 1 - ee, a && (ee -= a / M)) : l === "mirror" && (be = x)), ae = (_ >= k ? l === "reverse" && ye ? 0 : 1 : Ya(0, 1, ee)) * M;
    }
    const K = be.next(ae);
    let { value: ue, done: J } = K;
    return p && p(b ? b(ue) : ue), I !== null && (J = _ >= k), A === null && (T === "finished" || T === "running" && J) && (T = "finished", f && f(), C && C.stop()), K;
  };
  return e && (() => {
    C = n(F);
    const te = C.now();
    c && c(), T = "running", A !== null ? L = te - A : L || (L = te), A = null, C.start();
  })(), {
    get currentTime() {
      return xs(_);
    },
    set currentTime(te) {
      A !== null || !C ? A = 0 : L = C.now() - ea(te);
    },
    stop: () => {
      u && u(), C && C.stop();
    },
    sample: (te) => (L = 0, F(te))
  };
}
const Yj = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), j4 = 10, Jj = 2e4, Qj = (e, t) => t.type === "spring" || e === "backgroundColor" || !pj(t.ease);
function qj(e, t, { onUpdate: n, onComplete: r, ...o }) {
  if (!(GS.waapi() && Yj.has(t) && !o.repeatDelay && o.repeatType !== "mirror" && o.damping !== 0 && o.type !== "inertia"))
    return !1;
  let { keyframes: a, duration: l = 300, ease: c } = o;
  if (Qj(t, o)) {
    const f = o9({
      ...o,
      repeat: 0,
      delay: 0
    });
    let p = { done: !1, value: a[0] };
    const h = [];
    let C = 0;
    for (; !p.done && C < Jj; )
      p = f.sample(C), h.push(p.value), C += j4;
    a = h, l = C - j4, c = "linear";
  }
  const u = mj(e.owner.current, t, a, {
    ...o,
    duration: l,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: c
  });
  return u.onfinish = () => {
    e.set(Cj(a, o)), Tt.update(() => u.cancel()), r && r();
  }, {
    get currentTime() {
      return xs(u.currentTime || 0);
    },
    set currentTime(f) {
      u.currentTime = ea(f);
    },
    stop: () => {
      const { currentTime: f } = u;
      if (f) {
        const p = o9({
          ...o,
          autoplay: !1
        });
        e.setWithVelocity(p.sample(f - j4).value, p.sample(f).value, j4);
      }
      Tt.update(() => u.cancel());
    }
  };
}
function Kj({ keyframes: e, delay: t, onUpdate: n, onComplete: r }) {
  const o = () => (n && n(e[e.length - 1]), r && r(), {
    stop: () => {
    },
    currentTime: 0
  });
  return t ? o9({
    keyframes: [0, 1],
    duration: t,
    onComplete: o
  }) : o();
}
const eX = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, tX = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), nX = {
  type: "keyframes",
  duration: 0.8
}, rX = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, oX = (e, { keyframes: t }) => t.length > 2 ? nX : a2.has(e) ? e.startsWith("scale") ? tX(t[1]) : eX : rX, du = (e, t) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
na.test(t) && // And it contains numbers and/or colors
!t.startsWith("url("));
function iX({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: i, repeatType: a, repeatDelay: l, from: c, elapsed: u, ...f }) {
  return !!Object.keys(f).length;
}
function Zg(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function zg(e) {
  return typeof e == "number" ? 0 : Sf("", e);
}
function nT(e, t) {
  return e[t] || e.default || e;
}
function aX(e, t, n, r) {
  const o = du(t, n);
  let i = r.from !== void 0 ? r.from : e.get();
  return i === "none" && o && typeof n == "string" ? i = Sf(t, n) : Zg(i) && typeof n == "string" ? i = zg(n) : !Array.isArray(n) && Zg(n) && typeof i == "string" && (n = zg(i)), Array.isArray(n) ? (n[0] === null && (n[0] = i), n) : [i, n];
}
const Mf = (e, t, n, r = {}) => (o) => {
  const i = nT(r, e) || {}, a = i.delay || r.delay || 0;
  let { elapsed: l = 0 } = r;
  l = l - ea(a);
  const c = aX(t, e, n, i), u = c[0], f = c[c.length - 1], p = du(e, u), h = du(e, f);
  q0(p === h, `You are trying to animate ${e} from "${u}" to "${f}". ${u} is not an animatable value - to enable this animation set ${u} to a value animatable to ${f} via the \`style\` property.`);
  let C = {
    keyframes: c,
    velocity: t.getVelocity(),
    ...i,
    delay: -l,
    onUpdate: (v) => {
      t.set(v), i.onUpdate && i.onUpdate(v);
    },
    onComplete: () => {
      o(), i.onComplete && i.onComplete();
    }
  };
  if (!p || !h || fj.current || i.type === !1)
    return Kj(C);
  if (iX(i) || (C = {
    ...C,
    ...oX(e, C)
  }), C.duration && (C.duration = ea(C.duration)), C.repeatDelay && (C.repeatDelay = ea(C.repeatDelay)), t.owner && t.owner.current instanceof HTMLElement && !t.owner.getProps().onUpdate) {
    const v = qj(t, e, C);
    if (v)
      return v;
  }
  return o9(C);
};
function sX(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((i) => fu(e, i, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = fu(e, t, n);
  else {
    const o = typeof t == "function" ? W9(e, t, n.custom) : t;
    r = rT(e, o, n);
  }
  return r.then(() => e.notify("AnimationComplete", t));
}
function fu(e, t, n = {}) {
  const r = W9(e, t, n.custom);
  let { transition: o = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (o = n.transitionOverride);
  const i = r ? () => rT(e, r, n) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: f, staggerDirection: p } = o;
    return lX(e, t, u + c, f, p, n);
  } : () => Promise.resolve(), { when: l } = o;
  if (l) {
    const [c, u] = l === "beforeChildren" ? [i, a] : [a, i];
    return c().then(u);
  } else
    return Promise.all([i(), a(n.delay)]);
}
function rT(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  let { transition: i = e.getDefaultTransition(), transitionEnd: a, ...l } = e.makeTargetAnimatable(t);
  const c = e.getValue("willChange");
  r && (i = r);
  const u = [], f = o && e.animationState && e.animationState.getState()[o];
  for (const p in l) {
    const h = e.getValue(p), C = l[p];
    if (!h || C === void 0 || f && uX(f, p))
      continue;
    const v = { delay: n, elapsed: 0, ...i };
    if (window.HandoffAppearAnimations && !h.hasAnimated) {
      const y = e.getProps()[dj];
      y && (v.elapsed = window.HandoffAppearAnimations(y, p, h, Tt));
    }
    let b = h.start(Mf(p, h, C, e.shouldReduceMotion && a2.has(p) ? { type: !1 } : v));
    n9(c) && (c.add(p), b = b.then(() => c.remove(p))), u.push(b);
  }
  return Promise.all(u).then(() => {
    a && aj(e, a);
  });
}
function lX(e, t, n = 0, r = 0, o = 1, i) {
  const a = [], l = (e.variantChildren.size - 1) * r, c = o === 1 ? (u = 0) => u * r : (u = 0) => l - u * r;
  return Array.from(e.variantChildren).sort(cX).forEach((u, f) => {
    u.notify("AnimationStart", t), a.push(fu(u, t, {
      ...i,
      delay: n + c(f)
    }).then(() => u.notify("AnimationComplete", t)));
  }), Promise.all(a);
}
function cX(e, t) {
  return e.sortNodePosition(t);
}
function uX({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
const dX = [...of].reverse(), fX = of.length;
function pX(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => sX(e, n, r)));
}
function hX(e) {
  let t = pX(e);
  const n = CX();
  let r = !0;
  const o = (c, u) => {
    const f = W9(e, u);
    if (f) {
      const { transition: p, transitionEnd: h, ...C } = f;
      c = { ...c, ...C, ...h };
    }
    return c;
  };
  function i(c) {
    t = c(e);
  }
  function a(c, u) {
    const f = e.getProps(), p = e.getVariantContext(!0) || {}, h = [], C = /* @__PURE__ */ new Set();
    let v = {}, b = 1 / 0;
    for (let x = 0; x < fX; x++) {
      const T = dX[x], A = n[T], L = f[T] !== void 0 ? f[T] : p[T], I = y0(L), M = T === u ? A.isActive : null;
      M === !1 && (b = x);
      let k = L === p[T] && L !== f[T] && I;
      if (k && r && e.manuallyAnimateOnMount && (k = !1), A.protectedKeys = { ...v }, // If it isn't active and hasn't *just* been set as inactive
      !A.isActive && M === null || // If we didn't and don't have any defined prop for this animation type
      !L && !A.prevProp || // Or if the prop doesn't define an animation
      N9(L) || typeof L == "boolean")
        continue;
      const _ = mX(A.prevProp, L);
      let F = _ || // If we're making this variant active, we want to always make it active
      T === u && A.isActive && !k && I || // If we removed a higher-priority variant (i is in reverse order)
      x > b && I;
      const $ = Array.isArray(L) ? L : [L];
      let oe = $.reduce(o, {});
      M === !1 && (oe = {});
      const { prevResolvedValues: te = {} } = A, ae = {
        ...te,
        ...oe
      }, be = (K) => {
        F = !0, C.delete(K), A.needsAnimating[K] = !0;
      };
      for (const K in ae) {
        const ue = oe[K], J = te[K];
        v.hasOwnProperty(K) || (ue !== J ? e9(ue) && e9(J) ? !_S(ue, J) || _ ? be(K) : A.protectedKeys[K] = !0 : ue !== void 0 ? be(K) : C.add(K) : ue !== void 0 && C.has(K) ? be(K) : A.protectedKeys[K] = !0);
      }
      A.prevProp = L, A.prevResolvedValues = oe, A.isActive && (v = { ...v, ...oe }), r && e.blockInitialAnimation && (F = !1), F && !k && h.push(...$.map((K) => ({
        animation: K,
        options: { type: T, ...c }
      })));
    }
    if (C.size) {
      const x = {};
      C.forEach((T) => {
        const A = e.getBaseTarget(T);
        A !== void 0 && (x[T] = A);
      }), h.push({ animation: x });
    }
    let y = !!h.length;
    return r && f.initial === !1 && !e.manuallyAnimateOnMount && (y = !1), r = !1, y ? t(h) : Promise.resolve();
  }
  function l(c, u, f) {
    var p;
    if (n[c].isActive === u)
      return Promise.resolve();
    (p = e.variantChildren) === null || p === void 0 || p.forEach((C) => {
      var v;
      return (v = C.animationState) === null || v === void 0 ? void 0 : v.setActive(c, u);
    }), n[c].isActive = u;
    const h = a(f, c);
    for (const C in n)
      n[C].protectedKeys = {};
    return h;
  }
  return {
    animateChanges: a,
    setActive: l,
    setAnimateFunction: i,
    getState: () => n
  };
}
function mX(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !_S(t, e) : !1;
}
function La(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function CX() {
  return {
    animate: La(!0),
    whileInView: La(),
    whileHover: La(),
    whileTap: La(),
    whileDrag: La(),
    whileFocus: La(),
    exit: La()
  };
}
class gX extends sa {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = hX(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    this.unmount(), N9(t) && (this.unmount = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let bX = 0;
class vX extends sa {
  constructor() {
    super(...arguments), this.id = bX++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n, custom: r } = this.node.presenceContext, { isPresent: o } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === o)
      return;
    const i = this.node.animationState.setActive("exit", !t, { custom: r ?? this.node.getProps().custom });
    n && !t && i.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const yX = {
  animation: {
    Feature: gX
  },
  exit: {
    Feature: vX
  }
}, Gg = (e, t) => Math.abs(e - t);
function xX(e, t) {
  const n = Gg(e.x, t.x), r = Gg(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class oT {
  constructor(t, n, { transformPagePoint: r } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const u = V8(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, p = xX(u.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !p)
        return;
      const { point: h } = u, { timestamp: C } = Kr;
      this.history.push({ ...h, timestamp: C });
      const { onStart: v, onMove: b } = this.handlers;
      f || (v && v(this.lastMoveEvent, u), this.startEvent = this.lastMoveEvent), b && b(this.lastMoveEvent, u);
    }, this.handlePointerMove = (u, f) => {
      this.lastMoveEvent = u, this.lastMoveEventInfo = P8(f, this.transformPagePoint), Tt.update(this.updatePoint, !0);
    }, this.handlePointerUp = (u, f) => {
      if (this.end(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const { onEnd: p, onSessionEnd: h } = this.handlers, C = V8(u.type === "pointercancel" ? this.lastMoveEventInfo : P8(f, this.transformPagePoint), this.history);
      this.startEvent && p && p(u, C), h && h(u, C);
    }, !LS(t))
      return;
    this.handlers = n, this.transformPagePoint = r;
    const o = z9(t), i = P8(o, this.transformPagePoint), { point: a } = i, { timestamp: l } = Kr;
    this.history = [{ ...a, timestamp: l }];
    const { onSessionStart: c } = n;
    c && c(t, V8(i, this.history)), this.removeListeners = Ki(si(window, "pointermove", this.handlePointerMove), si(window, "pointerup", this.handlePointerUp), si(window, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), ta.update(this.updatePoint);
  }
}
function P8(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Wg(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function V8({ point: e }, t) {
  return {
    point: e,
    delta: Wg(e, iT(t)),
    offset: Wg(e, wX(t)),
    velocity: SX(t, 0.1)
  };
}
function wX(e) {
  return e[0];
}
function iT(e) {
  return e[e.length - 1];
}
function SX(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = iT(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > ea(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const i = xs(o.timestamp - r.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (o.x - r.x) / i,
    y: (o.y - r.y) / i
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function lr(e) {
  return e.max - e.min;
}
function pu(e, t = 0, n = 0.01) {
  return Math.abs(e - t) <= n;
}
function $g(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = kt(t.min, t.max, e.origin), e.scale = lr(n) / lr(t), (pu(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = kt(n.min, n.max, e.origin) - e.originPoint, (pu(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function o0(e, t, n, r) {
  $g(e.x, t.x, n.x, r ? r.originX : void 0), $g(e.y, t.y, n.y, r ? r.originY : void 0);
}
function Ug(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + lr(t);
}
function TX(e, t, n) {
  Ug(e.x, t.x, n.x), Ug(e.y, t.y, n.y);
}
function jg(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + lr(t);
}
function i0(e, t, n) {
  jg(e.x, t.x, n.x), jg(e.y, t.y, n.y);
}
function AX(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? kt(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? kt(n, e, r.max) : Math.min(e, n)), e;
}
function Xg(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function IX(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: Xg(e.x, n, o),
    y: Xg(e.y, t, r)
  };
}
function Yg(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function LX(e, t) {
  return {
    x: Yg(e.x, t.x),
    y: Yg(e.y, t.y)
  };
}
function EX(e, t) {
  let n = 0.5;
  const r = lr(e), o = lr(t);
  return o > r ? n = T0(t.min, t.max - r, e.min) : r > o && (n = T0(e.min, e.max - o, t.min)), Ya(0, 1, n);
}
function MX(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const hu = 0.35;
function BX(e = hu) {
  return e === !1 ? e = 0 : e === !0 && (e = hu), {
    x: Jg(e, "left", "right"),
    y: Jg(e, "top", "bottom")
  };
}
function Jg(e, t, n) {
  return {
    min: Qg(e, t),
    max: Qg(e, n)
  };
}
function Qg(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const qg = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), a0 = () => ({
  x: qg(),
  y: qg()
}), Kg = () => ({ min: 0, max: 0 }), Wt = () => ({
  x: Kg(),
  y: Kg()
});
function ho(e) {
  return [e("x"), e("y")];
}
function aT({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function kX({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function RX(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function H8(e) {
  return e === void 0 || e === 1;
}
function mu({ scale: e, scaleX: t, scaleY: n }) {
  return !H8(e) || !H8(t) || !H8(n);
}
function Ma(e) {
  return mu(e) || sT(e) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function sT(e) {
  return eb(e.x) || eb(e.y);
}
function eb(e) {
  return e && e !== "0%";
}
function i9(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function tb(e, t, n, r, o) {
  return o !== void 0 && (e = i9(e, o, r)), i9(e, n, r) + t;
}
function Cu(e, t = 0, n = 1, r, o) {
  e.min = tb(e.min, t, n, r, o), e.max = tb(e.max, t, n, r, o);
}
function lT(e, { x: t, y: n }) {
  Cu(e.x, t.translate, t.scale, t.originPoint), Cu(e.y, n.translate, n.scale, n.originPoint);
}
function _X(e, t, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let i, a;
  for (let l = 0; l < o; l++) {
    i = n[l], a = i.projectionDelta;
    const c = i.instance;
    c && c.style && c.style.display === "contents" || (r && i.options.layoutScroll && i.scroll && i !== i.root && ns(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), a && (t.x *= a.x.scale, t.y *= a.y.scale, lT(e, a)), r && Ma(i.latestValues) && ns(e, i.latestValues));
  }
  t.x = nb(t.x), t.y = nb(t.y);
}
function nb(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < 0.999999999999 ? e : 1;
}
function Wi(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function rb(e, t, [n, r, o]) {
  const i = t[o] !== void 0 ? t[o] : 0.5, a = kt(e.min, e.max, i);
  Cu(e, t[n], t[r], a, t.scale);
}
const FX = ["x", "scaleX", "originX"], PX = ["y", "scaleY", "originY"];
function ns(e, t) {
  rb(e.x, t, FX), rb(e.y, t, PX);
}
function cT(e, t) {
  return aT(RX(e.getBoundingClientRect(), t));
}
function VX(e, t, n) {
  const r = cT(e, n), { scroll: o } = t;
  return o && (Wi(r.x, o.offset.x), Wi(r.y, o.offset.y)), r;
}
const HX = /* @__PURE__ */ new WeakMap();
class OX {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Wt(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const o = (c) => {
      this.stopAnimation(), n && this.snapToCursor(z9(c, "page").point);
    }, i = (c, u) => {
      const { drag: f, dragPropagation: p, onDragStart: h } = this.getProps();
      if (f && !p && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = MS(f), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ho((v) => {
        let b = this.getAxisMotionValue(v).get() || 0;
        if (Io.test(b)) {
          const { projection: y } = this.visualElement;
          if (y && y.layout) {
            const x = y.layout.layoutBox[v];
            x && (b = lr(x) * (parseFloat(b) / 100));
          }
        }
        this.originPoint[v] = b;
      }), h && Tt.update(() => h(c, u));
      const { animationState: C } = this.visualElement;
      C && C.setActive("whileDrag", !0);
    }, a = (c, u) => {
      const { dragPropagation: f, dragDirectionLock: p, onDirectionLock: h, onDrag: C } = this.getProps();
      if (!f && !this.openGlobalLock)
        return;
      const { offset: v } = u;
      if (p && this.currentDirection === null) {
        this.currentDirection = NX(v), this.currentDirection !== null && h && h(this.currentDirection);
        return;
      }
      this.updateAxis("x", u.point, v), this.updateAxis("y", u.point, v), this.visualElement.render(), C && C(c, u);
    }, l = (c, u) => this.stop(c, u);
    this.panSession = new oT(t, {
      onSessionStart: o,
      onStart: i,
      onMove: a,
      onSessionEnd: l
    }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: o } = n;
    this.startAnimation(o);
    const { onDragEnd: i } = this.getProps();
    i && Tt.update(() => i(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !X4(t, o, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let a = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (a = AX(a, this.constraints[t], this.elastic[t])), i.set(a);
  }
  resolveConstraints() {
    const { dragConstraints: t, dragElastic: n } = this.getProps(), { layout: r } = this.visualElement.projection || {}, o = this.constraints;
    t && es(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = IX(r.layoutBox, t) : this.constraints = !1, this.elastic = BX(n), o !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && ho((i) => {
      this.getAxisMotionValue(i) && (this.constraints[i] = MX(r.layoutBox[i], this.constraints[i]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !es(t))
      return !1;
    const r = t.current;
    Fr(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const i = VX(r, o.root, this.visualElement.getTransformPagePoint());
    let a = LX(o.layout.layoutBox, i);
    if (n) {
      const l = n(kX(a));
      this.hasMutatedConstraints = !!l, l && (a = aT(l));
    }
    return a;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: i, dragSnapToOrigin: a, onDragTransitionEnd: l } = this.getProps(), c = this.constraints || {}, u = ho((f) => {
      if (!X4(f, n, this.currentDirection))
        return;
      let p = c[f] || {};
      a && (p = { min: 0, max: 0 });
      const h = o ? 200 : 1e6, C = o ? 40 : 1e7, v = {
        type: "inertia",
        velocity: r ? t[f] : 0,
        bounceStiffness: h,
        bounceDamping: C,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...p
      };
      return this.startAxisValueAnimation(f, v);
    });
    return Promise.all(u).then(l);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return r.start(Mf(t, r, 0, n));
  }
  stopAnimation() {
    ho((t) => this.getAxisMotionValue(t).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = "_drag" + t.toUpperCase(), r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    ho((n) => {
      const { drag: r } = this.getProps();
      if (!X4(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, i = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: a, max: l } = o.layout.layoutBox[n];
        i.set(t[n] - kt(a, l, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!es(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    ho((a) => {
      const l = this.getAxisMotionValue(a);
      if (l) {
        const c = l.get();
        o[a] = EX({ min: c, max: c }, this.constraints[a]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), ho((a) => {
      if (!X4(a, t, null))
        return;
      const l = this.getAxisMotionValue(a), { min: c, max: u } = this.constraints[a];
      l.set(kt(c, u, o[a]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    HX.set(this.visualElement, this);
    const t = this.visualElement.current, n = si(t, "pointerdown", (c) => {
      const { drag: u, dragListener: f = !0 } = this.getProps();
      u && f && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      es(c) && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, i = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), r();
    const a = ii(window, "resize", () => this.scalePositionWithinConstraints()), l = o.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: u }) => {
      this.isDragging && u && (ho((f) => {
        const p = this.getAxisMotionValue(f);
        p && (this.originPoint[f] += c[f].translate, p.set(p.get() + c[f].translate));
      }), this.visualElement.render());
    });
    return () => {
      a(), n(), i(), l && l();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: i = !1, dragElastic: a = hu, dragMomentum: l = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: i,
      dragElastic: a,
      dragMomentum: l
    };
  }
}
function X4(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function NX(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class DX extends sa {
  constructor(t) {
    super(t), this.removeGroupControls = Rr, this.removeListeners = Rr, this.controls = new OX(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Rr;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const ob = (e) => (t, n) => {
  e && Tt.update(() => e(t, n));
};
class ZX extends sa {
  constructor() {
    super(...arguments), this.removePointerDownListener = Rr;
  }
  onPointerDown(t) {
    this.session = new oT(t, this.createPanHandlers(), { transformPagePoint: this.node.getTransformPagePoint() });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: ob(t),
      onStart: ob(n),
      onMove: r,
      onEnd: (i, a) => {
        delete this.session, o && Tt.update(() => o(i, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = si(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function uT() {
  const e = N1(X0);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, o = dr();
  return Oe(() => r(o), []), !t && n ? [!1, () => n && n(o)] : [!0];
}
function zX() {
  return GX(N1(X0));
}
function GX(e) {
  return e === null ? !0 : e.isPresent;
}
function ib(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const B5 = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (c1.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = ib(e, t.target.x), r = ib(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, dT = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function WX(e) {
  const t = dT.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}
const $X = 4;
function gu(e, t, n = 1) {
  Fr(n <= $X, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, o] = WX(e);
  if (!r)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(r);
  return i ? i.trim() : ru(o) ? gu(o, t, n + 1) : o;
}
function UX(e, { ...t }, n) {
  const r = e.current;
  if (!(r instanceof Element))
    return { target: t, transitionEnd: n };
  n && (n = { ...n }), e.values.forEach((o) => {
    const i = o.get();
    if (!ru(i))
      return;
    const a = gu(i, r);
    a && o.set(a);
  });
  for (const o in t) {
    const i = t[o];
    if (!ru(i))
      continue;
    const a = gu(i, r);
    a && (t[o] = a, n && n[o] === void 0 && (n[o] = i));
  }
  return { target: t, transitionEnd: n };
}
const ab = "_$css", jX = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = e.includes("var("), i = [];
    o && (e = e.replace(dT, (C) => (i.push(C), ab)));
    const a = na.parse(e);
    if (a.length > 5)
      return r;
    const l = na.createTransformer(e), c = typeof a[0] != "number" ? 1 : 0, u = n.x.scale * t.x, f = n.y.scale * t.y;
    a[0 + c] /= u, a[1 + c] /= f;
    const p = kt(u, f, 0.5);
    typeof a[2 + c] == "number" && (a[2 + c] /= p), typeof a[3 + c] == "number" && (a[3 + c] /= p);
    let h = l(a);
    if (o) {
      let C = 0;
      h = h.replace(ab, () => {
        const v = i[C];
        return C++, v;
      });
    }
    return h;
  }
};
class XX extends w.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: i } = t;
    Q$(YX), i && (n.group && n.group.add(i), r && r.register && o && r.register(i), i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), t0.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: i } = this.props, a = r.projection;
    return a && (a.isPresent = i, o || t.layoutDependency !== n || n === void 0 ? a.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? a.promote() : a.relegate() || Tt.postRender(() => {
      const l = a.getStack();
      (!l || !l.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), !t.currentAnimation && t.isLead() && this.safeToRemove());
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function fT(e) {
  const [t, n] = uT(), r = N1(lf);
  return w.createElement(XX, { ...e, layoutGroup: r, switchLayoutGroup: N1(hS), isPresent: t, safeToRemove: n });
}
const YX = {
  borderRadius: {
    ...B5,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: B5,
  borderTopRightRadius: B5,
  borderBottomLeftRadius: B5,
  borderBottomRightRadius: B5,
  boxShadow: jX
};
class JX {
  constructor(t) {
    this.animations = t.filter(Boolean);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  get currentTime() {
    return this.animations[0].currentTime;
  }
  /**
   * currentTime assignment could reasonably run every frame, so
   * we iterate using a normal loop to avoid function creation.
   */
  set currentTime(t) {
    for (let n = 0; n < this.animations.length; n++)
      this.animations[n].currentTime = t;
  }
  stop() {
    this.animations.forEach((t) => t.stop());
  }
}
function QX(e, t, n = {}) {
  const r = jn(e) ? e : ys(e);
  return r.start(Mf("", r, t, n)), r.animation || new JX([]);
}
const pT = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], qX = pT.length, sb = (e) => typeof e == "string" ? parseFloat(e) : e, lb = (e) => typeof e == "number" || c1.test(e);
function KX(e, t, n, r, o, i) {
  o ? (e.opacity = kt(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    eY(r)
  ), e.opacityExit = kt(t.opacity !== void 0 ? t.opacity : 1, 0, tY(r))) : i && (e.opacity = kt(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let a = 0; a < qX; a++) {
    const l = `border${pT[a]}Radius`;
    let c = cb(t, l), u = cb(n, l);
    if (c === void 0 && u === void 0)
      continue;
    c || (c = 0), u || (u = 0), c === 0 || u === 0 || lb(c) === lb(u) ? (e[l] = Math.max(kt(sb(c), sb(u), r), 0), (Io.test(u) || Io.test(c)) && (e[l] += "%")) : e[l] = u;
  }
  (t.rotate || n.rotate) && (e.rotate = kt(t.rotate || 0, n.rotate || 0, r));
}
function cb(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const eY = hT(0, 0.5, Lf), tY = hT(0.5, 0.95, Rr);
function hT(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(T0(e, t, r));
}
function ub(e, t) {
  e.min = t.min, e.max = t.max;
}
function Sr(e, t) {
  ub(e.x, t.x), ub(e.y, t.y);
}
function db(e, t, n, r, o) {
  return e -= t, e = i9(e, 1 / n, r), o !== void 0 && (e = i9(e, 1 / o, r)), e;
}
function nY(e, t = 0, n = 1, r = 0.5, o, i = e, a = e) {
  if (Io.test(t) && (t = parseFloat(t), t = kt(a.min, a.max, t / 100) - a.min), typeof t != "number")
    return;
  let l = kt(i.min, i.max, r);
  e === i && (l -= t), e.min = db(e.min, t, n, l, o), e.max = db(e.max, t, n, l, o);
}
function fb(e, t, [n, r, o], i, a) {
  nY(e, t[n], t[r], t[o], t.scale, i, a);
}
const rY = ["x", "scaleX", "originX"], oY = ["y", "scaleY", "originY"];
function pb(e, t, n, r) {
  fb(e.x, t, rY, n ? n.x : void 0, r ? r.x : void 0), fb(e.y, t, oY, n ? n.y : void 0, r ? r.y : void 0);
}
function hb(e) {
  return e.translate === 0 && e.scale === 1;
}
function mT(e) {
  return hb(e.x) && hb(e.y);
}
function bu(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
function mb(e) {
  return lr(e.x) / lr(e.y);
}
class iY {
  constructor() {
    this.members = [];
  }
  add(t) {
    gf(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (bf(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((o) => t === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const i = this.members[o];
      if (i.isPresent !== !1) {
        r = i;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Cb(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, i = e.y.translate / t.y;
  if ((o || i) && (r = `translate3d(${o}px, ${i}px, 0) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { rotate: c, rotateX: u, rotateY: f } = n;
    c && (r += `rotate(${c}deg) `), u && (r += `rotateX(${u}deg) `), f && (r += `rotateY(${f}deg) `);
  }
  const a = e.x.scale * t.x, l = e.y.scale * t.y;
  return (a !== 1 || l !== 1) && (r += `scale(${a}, ${l})`), r || "none";
}
const aY = (e, t) => e.depth - t.depth;
class sY {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    gf(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    bf(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(aY), this.isDirty = !1, this.children.forEach(t);
  }
}
function lY(e, t) {
  const n = performance.now(), r = ({ timestamp: o }) => {
    const i = o - n;
    i >= t && (ta.read(r), e(i - t));
  };
  return Tt.read(r, !0), () => ta.read(r);
}
function cY(e) {
  window.MotionDebug && window.MotionDebug.record(e);
}
const gb = ["", "X", "Y", "Z"], bb = 1e3;
let uY = 0;
const Ba = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function CT({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(a, l = {}, c = t?.()) {
      this.id = uY++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        Ba.totalNodes = Ba.resolvedTargetDeltas = Ba.recalculatedProjection = 0, this.nodes.forEach(pY), this.nodes.forEach(gY), this.nodes.forEach(bY), this.nodes.forEach(hY), cY(Ba);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.elementId = a, this.latestValues = l, this.root = c ? c.root || c : this, this.path = c ? [...c.path, c] : [], this.parent = c, this.depth = c ? c.depth + 1 : 0, a && this.root.registerPotentialNode(a, this);
      for (let u = 0; u < this.path.length; u++)
        this.path[u].shouldResetTransform = !0;
      this.root === this && (this.nodes = new sY());
    }
    addEventListener(a, l) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new vf()), this.eventHandlers.get(a).add(l);
    }
    notifyListeners(a, ...l) {
      const c = this.eventHandlers.get(a);
      c && c.notify(...l);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    registerPotentialNode(a, l) {
      this.potentialNodes.set(a, l);
    }
    /**
     * Lifecycles
     */
    mount(a, l = !1) {
      if (this.instance)
        return;
      this.isSVG = a instanceof SVGElement && a.tagName !== "svg", this.instance = a;
      const { layoutId: c, layout: u, visualElement: f } = this.options;
      if (f && !f.current && f.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.elementId && this.root.potentialNodes.delete(this.elementId), l && (u || c) && (this.isLayoutDirty = !0), e) {
        let p;
        const h = () => this.root.updateBlockedByResize = !1;
        e(a, () => {
          this.root.updateBlockedByResize = !0, p && p(), p = lY(h, 250), t0.hasAnimatedSinceResize && (t0.hasAnimatedSinceResize = !1, this.nodes.forEach(yb));
        });
      }
      c && this.root.registerSharedNode(c, this), this.options.animate !== !1 && f && (c || u) && this.addEventListener("didUpdate", ({ delta: p, hasLayoutChanged: h, hasRelativeTargetChanged: C, layout: v }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const b = this.options.transition || f.getDefaultTransition() || SY, { onLayoutAnimationStart: y, onLayoutAnimationComplete: x } = f.getProps(), T = !this.targetLayout || !bu(this.targetLayout, v) || C, A = !h && C;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || A || h && (T || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(p, A);
          const L = {
            ...nT(b, "layout"),
            onPlay: y,
            onComplete: x
          };
          (f.shouldReduceMotion || this.options.layoutRoot) && (L.delay = 0, L.type = !1), this.startAnimation(L);
        } else
          !h && this.animationProgress === 0 && yb(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = v;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, ta.preRender(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(vY), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let f = 0; f < this.path.length; f++) {
        const p = this.path[f];
        p.shouldResetTransform = !0, p.updateScroll("snapshot"), p.options.layoutRoot && p.willUpdate(!1);
      }
      const { layoutId: l, layout: c } = this.options;
      if (l === void 0 && !c)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    // Note: Currently only running on root node
    didUpdate() {
      if (this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(vb);
        return;
      }
      this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(TY), this.potentialNodes.clear()), this.nodes.forEach(CY), this.nodes.forEach(dY), this.nodes.forEach(fY), this.clearAllSnapshots(), L8.update(), L8.preRender(), L8.render());
    }
    clearAllSnapshots() {
      this.nodes.forEach(mY), this.sharedNodes.forEach(yY);
    }
    scheduleUpdateProjection() {
      Tt.preRender(this.updateProjection, !1, !0);
    }
    scheduleCheckAfterUnmount() {
      Tt.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Wt(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: l } = this.options;
      l && l.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let l = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (l = !1), l && (this.scroll = {
        animationId: this.root.animationId,
        phase: a,
        isRoot: r(this.instance),
        offset: n(this.instance)
      });
    }
    resetTransform() {
      if (!o)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform, l = this.projectionDelta && !mT(this.projectionDelta), c = this.getTransformTemplate(), u = c ? c(this.latestValues, "") : void 0, f = u !== this.prevTransformTemplateValue;
      a && (l || Ma(this.latestValues) || f) && (o(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const l = this.measurePageBox();
      let c = this.removeElementScroll(l);
      return a && (c = this.removeTransform(c)), AY(c), {
        animationId: this.root.animationId,
        measuredBox: l,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: a } = this.options;
      if (!a)
        return Wt();
      const l = a.measureViewportBox(), { scroll: c } = this.root;
      return c && (Wi(l.x, c.offset.x), Wi(l.y, c.offset.y)), l;
    }
    removeElementScroll(a) {
      const l = Wt();
      Sr(l, a);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: f, options: p } = u;
        if (u !== this.root && f && p.layoutScroll) {
          if (f.isRoot) {
            Sr(l, a);
            const { scroll: h } = this.root;
            h && (Wi(l.x, -h.offset.x), Wi(l.y, -h.offset.y));
          }
          Wi(l.x, f.offset.x), Wi(l.y, f.offset.y);
        }
      }
      return l;
    }
    applyTransform(a, l = !1) {
      const c = Wt();
      Sr(c, a);
      for (let u = 0; u < this.path.length; u++) {
        const f = this.path[u];
        !l && f.options.layoutScroll && f.scroll && f !== f.root && ns(c, {
          x: -f.scroll.offset.x,
          y: -f.scroll.offset.y
        }), Ma(f.latestValues) && ns(c, f.latestValues);
      }
      return Ma(this.latestValues) && ns(c, this.latestValues), c;
    }
    removeTransform(a) {
      const l = Wt();
      Sr(l, a);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        if (!u.instance || !Ma(u.latestValues))
          continue;
        mu(u.latestValues) && u.updateSnapshot();
        const f = Wt(), p = u.measurePageBox();
        Sr(f, p), pb(l, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, f);
      }
      return Ma(this.latestValues) && pb(l, this.latestValues), l;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    resolveTargetDelta(a = !1) {
      var l;
      const c = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = c.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = c.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = c.isSharedProjectionDirty);
      const u = !!this.resumingFrom || this !== c;
      if (!(a || u && this.isSharedProjectionDirty || this.isProjectionDirty || !((l = this.parent) === null || l === void 0) && l.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: p, layoutId: h } = this.options;
      if (!(!this.layout || !(p || h))) {
        if (this.resolvedRelativeTargetAt = Kr.timestamp, !this.targetDelta && !this.relativeTarget) {
          const C = this.getClosestProjectingParent();
          C && C.layout ? (this.relativeParent = C, this.relativeTarget = Wt(), this.relativeTargetOrigin = Wt(), i0(this.relativeTargetOrigin, this.layout.layoutBox, C.layout.layoutBox), Sr(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = Wt(), this.targetWithTransforms = Wt()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.relativeParent.resolvedRelativeTargetAt !== Kr.timestamp && this.relativeParent.resolveTargetDelta(!0), TX(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Sr(this.target, this.layout.layoutBox), lT(this.target, this.targetDelta)) : Sr(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const C = this.getClosestProjectingParent();
            C && !!C.resumingFrom == !!this.resumingFrom && !C.options.layoutScroll && C.target ? (this.relativeParent = C, this.relativeTarget = Wt(), this.relativeTargetOrigin = Wt(), i0(this.relativeTargetOrigin, this.target, C.target), Sr(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Ba.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || mu(this.parent.latestValues) || sT(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var a;
      const l = this.getLead(), c = !!this.resumingFrom || this !== l;
      let u = !0;
      if ((this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty) && (u = !1), c && (this.isSharedProjectionDirty || this.isTransformDirty) && (u = !1), this.resolvedRelativeTargetAt === Kr.timestamp && (u = !1), u)
        return;
      const { layout: f, layoutId: p } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(f || p))
        return;
      Sr(this.layoutCorrected, this.layout.layoutBox), _X(this.layoutCorrected, this.treeScale, this.path, c);
      const { target: h } = l;
      if (!h)
        return;
      this.projectionDelta || (this.projectionDelta = a0(), this.projectionDeltaWithTransform = a0());
      const C = this.treeScale.x, v = this.treeScale.y, b = this.projectionTransform;
      o0(this.projectionDelta, this.layoutCorrected, h, this.latestValues), this.projectionTransform = Cb(this.projectionDelta, this.treeScale), (this.projectionTransform !== b || this.treeScale.x !== C || this.treeScale.y !== v) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h)), Ba.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), a) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(a, l = !1) {
      const c = this.snapshot, u = c ? c.latestValues : {}, f = { ...this.latestValues }, p = a0();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !l;
      const h = Wt(), C = c ? c.source : void 0, v = this.layout ? this.layout.source : void 0, b = C !== v, y = this.getStack(), x = !y || y.members.length <= 1, T = !!(b && !x && this.options.crossfade === !0 && !this.path.some(wY));
      this.animationProgress = 0;
      let A;
      this.mixTargetDelta = (L) => {
        const I = L / 1e3;
        xb(p.x, a.x, I), xb(p.y, a.y, I), this.setTargetDelta(p), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (i0(h, this.layout.layoutBox, this.relativeParent.layout.layoutBox), xY(this.relativeTarget, this.relativeTargetOrigin, h, I), A && bu(this.relativeTarget, A) && (this.isProjectionDirty = !1), A || (A = Wt()), Sr(A, this.relativeTarget)), b && (this.animationValues = f, KX(f, u, this.latestValues, I, T, x)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = I;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (ta.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Tt.update(() => {
        t0.hasAnimatedSinceResize = !0, this.currentAnimation = QX(0, bb, {
          ...a,
          onUpdate: (l) => {
            this.mixTargetDelta(l), a.onUpdate && a.onUpdate(l);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(bb), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: l, target: c, layout: u, latestValues: f } = a;
      if (!(!l || !c || !u)) {
        if (this !== a && this.layout && u && gT(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          c = this.target || Wt();
          const p = lr(this.layout.layoutBox.x);
          c.x.min = a.target.x.min, c.x.max = c.x.min + p;
          const h = lr(this.layout.layoutBox.y);
          c.y.min = a.target.y.min, c.y.max = c.y.min + h;
        }
        Sr(l, c), ns(l, f), o0(this.projectionDeltaWithTransform, this.layoutCorrected, l, f);
      }
    }
    registerSharedNode(a, l) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new iY()), this.sharedNodes.get(a).add(l);
      const u = l.options.initialPromotionConfig;
      l.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(l) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: l } = this.options;
      return l ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: l } = this.options;
      return l ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: l, preserveFollowOpacity: c } = {}) {
      const u = this.getStack();
      u && u.promote(this, c), a && (this.projectionDelta = void 0, this.needsReset = !0), l && this.setOptions({ transition: l });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let l = !1;
      const { latestValues: c } = a;
      if ((c.rotate || c.rotateX || c.rotateY || c.rotateZ) && (l = !0), !l)
        return;
      const u = {};
      for (let f = 0; f < gb.length; f++) {
        const p = "rotate" + gb[f];
        c[p] && (u[p] = c[p], a.setStaticValue(p, 0));
      }
      a.render();
      for (const f in u)
        a.setStaticValue(f, u[f]);
      a.scheduleRender();
    }
    getProjectionStyles(a = {}) {
      var l, c;
      const u = {};
      if (!this.instance || this.isSVG)
        return u;
      if (this.isVisible)
        u.visibility = "";
      else
        return { visibility: "hidden" };
      const f = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, u.opacity = "", u.pointerEvents = Al(a.pointerEvents) || "", u.transform = f ? f(this.latestValues, "") : "none", u;
      const p = this.getLead();
      if (!this.projectionDelta || !this.layout || !p.target) {
        const b = {};
        return this.options.layoutId && (b.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, b.pointerEvents = Al(a.pointerEvents) || ""), this.hasProjected && !Ma(this.latestValues) && (b.transform = f ? f({}, "") : "none", this.hasProjected = !1), b;
      }
      const h = p.animationValues || p.latestValues;
      this.applyTransformsToTarget(), u.transform = Cb(this.projectionDeltaWithTransform, this.treeScale, h), f && (u.transform = f(h, u.transform));
      const { x: C, y: v } = this.projectionDelta;
      u.transformOrigin = `${C.origin * 100}% ${v.origin * 100}% 0`, p.animationValues ? u.opacity = p === this ? (c = (l = h.opacity) !== null && l !== void 0 ? l : this.latestValues.opacity) !== null && c !== void 0 ? c : 1 : this.preserveOpacity ? this.latestValues.opacity : h.opacityExit : u.opacity = p === this ? h.opacity !== void 0 ? h.opacity : "" : h.opacityExit !== void 0 ? h.opacityExit : 0;
      for (const b in ql) {
        if (h[b] === void 0)
          continue;
        const { correct: y, applyTo: x } = ql[b], T = u.transform === "none" ? h[b] : y(h[b], p);
        if (x) {
          const A = x.length;
          for (let L = 0; L < A; L++)
            u[x[L]] = T;
        } else
          u[b] = T;
      }
      return this.options.layoutId && (u.pointerEvents = p === this ? Al(a.pointerEvents) || "" : "none"), u;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => {
        var l;
        return (l = a.currentAnimation) === null || l === void 0 ? void 0 : l.stop();
      }), this.root.nodes.forEach(vb), this.root.sharedNodes.clear();
    }
  };
}
function dY(e) {
  e.updateLayout();
}
function fY(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: i } = e.options, a = n.source !== e.layout.source;
    i === "size" ? ho((p) => {
      const h = a ? n.measuredBox[p] : n.layoutBox[p], C = lr(h);
      h.min = r[p].min, h.max = h.min + C;
    }) : gT(i, n.layoutBox, r) && ho((p) => {
      const h = a ? n.measuredBox[p] : n.layoutBox[p], C = lr(r[p]);
      h.max = h.min + C;
    });
    const l = a0();
    o0(l, r, n.layoutBox);
    const c = a0();
    a ? o0(c, e.applyTransform(o, !0), n.measuredBox) : o0(c, r, n.layoutBox);
    const u = !mT(l);
    let f = !1;
    if (!e.resumeFrom) {
      const p = e.getClosestProjectingParent();
      if (p && !p.resumeFrom) {
        const { snapshot: h, layout: C } = p;
        if (h && C) {
          const v = Wt();
          i0(v, n.layoutBox, h.layoutBox);
          const b = Wt();
          i0(b, r, C.layoutBox), bu(v, b) || (f = !0), p.options.layoutRoot && (e.relativeTarget = b, e.relativeTargetOrigin = v, e.relativeParent = p);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: c,
      layoutDelta: l,
      hasLayoutChanged: u,
      hasRelativeTargetChanged: f
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function pY(e) {
  Ba.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function hY(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function mY(e) {
  e.clearSnapshot();
}
function vb(e) {
  e.clearMeasurements();
}
function CY(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function yb(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0;
}
function gY(e) {
  e.resolveTargetDelta();
}
function bY(e) {
  e.calcProjection();
}
function vY(e) {
  e.resetRotation();
}
function yY(e) {
  e.removeLeadSnapshot();
}
function xb(e, t, n) {
  e.translate = kt(t.translate, 0, n), e.scale = kt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function wb(e, t, n, r) {
  e.min = kt(t.min, n.min, r), e.max = kt(t.max, n.max, r);
}
function xY(e, t, n, r) {
  wb(e.x, t.x, n.x, r), wb(e.y, t.y, n.y, r);
}
function wY(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const SY = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function TY(e, t) {
  let n = e.root;
  for (let i = e.path.length - 1; i >= 0; i--)
    if (e.path[i].instance) {
      n = e.path[i];
      break;
    }
  const o = (n && n !== e.root ? n.instance : document).querySelector(`[data-projection-id="${t}"]`);
  o && e.mount(o, !0);
}
function Sb(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function AY(e) {
  Sb(e.x), Sb(e.y);
}
function gT(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !pu(mb(t), mb(n), 0.2);
}
const IY = CT({
  attachResizeListener: (e, t) => ii(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), O8 = {
  current: void 0
}, bT = CT({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!O8.current) {
      const e = new IY(0, {});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), O8.current = e;
    }
    return O8.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), LY = {
  pan: {
    Feature: ZX
  },
  drag: {
    Feature: DX,
    ProjectionNode: bT,
    MeasureLayout: fT
  }
}, EY = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), vT = (e) => EY.has(e), MY = (e) => Object.keys(e).some(vT), Y4 = (e) => e === s2 || e === c1, Tb = (e, t) => parseFloat(e.split(", ")[t]), Ab = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const o = r.match(/^matrix3d\((.+)\)$/);
  if (o)
    return Tb(o[1], t);
  {
    const i = r.match(/^matrix\((.+)\)$/);
    return i ? Tb(i[1], e) : 0;
  }
}, BY = /* @__PURE__ */ new Set(["x", "y", "z"]), kY = Z9.filter((e) => !BY.has(e));
function RY(e) {
  const t = [];
  return kY.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.render(), t;
}
const Ib = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: Ab(4, 13),
  y: Ab(5, 14)
}, _Y = (e, t, n) => {
  const r = t.measureViewportBox(), o = t.current, i = getComputedStyle(o), { display: a } = i, l = {};
  a === "none" && t.setStaticValue("display", e.display || "block"), n.forEach((u) => {
    l[u] = Ib[u](r, i);
  }), t.render();
  const c = t.measureViewportBox();
  return n.forEach((u) => {
    const f = t.getValue(u);
    f && f.jump(l[u]), e[u] = Ib[u](c, i);
  }), e;
}, FY = (e, t, n = {}, r = {}) => {
  t = { ...t }, r = { ...r };
  const o = Object.keys(t).filter(vT);
  let i = [], a = !1;
  const l = [];
  if (o.forEach((c) => {
    const u = e.getValue(c);
    if (!e.hasValue(c))
      return;
    let f = n[c], p = M5(f);
    const h = t[c];
    let C;
    if (e9(h)) {
      const v = h.length, b = h[0] === null ? 1 : 0;
      f = h[b], p = M5(f);
      for (let y = b; y < v; y++)
        C ? Fr(M5(h[y]) === C, "All keyframes must be of the same type") : (C = M5(h[y]), Fr(C === p || Y4(p) && Y4(C), "Keyframes must be of the same dimension as the current value"));
    } else
      C = M5(h);
    if (p !== C)
      if (Y4(p) && Y4(C)) {
        const v = u.get();
        typeof v == "string" && u.set(parseFloat(v)), typeof h == "string" ? t[c] = parseFloat(h) : Array.isArray(h) && C === c1 && (t[c] = h.map(parseFloat));
      } else p?.transform && C?.transform && (f === 0 || h === 0) ? f === 0 ? u.set(C.transform(f)) : t[c] = p.transform(h) : (a || (i = RY(e), a = !0), l.push(c), r[c] = r[c] !== void 0 ? r[c] : t[c], u.jump(h));
  }), l.length) {
    const c = l.indexOf("height") >= 0 ? window.pageYOffset : null, u = _Y(t, e, l);
    return i.length && i.forEach(([f, p]) => {
      e.getValue(f).set(p);
    }), e.render(), O9 && c !== null && window.scrollTo({ top: c }), { target: u, transitionEnd: r };
  } else
    return { target: t, transitionEnd: r };
};
function PY(e, t, n, r) {
  return MY(t) ? FY(e, t, n, r) : { target: t, transitionEnd: r };
}
const VY = (e, t, n, r) => {
  const o = UX(e, t, r);
  return t = o.target, r = o.transitionEnd, PY(e, t, n, r);
}, vu = { current: null }, yT = { current: !1 };
function HY() {
  if (yT.current = !0, !!O9)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => vu.current = e.matches;
      e.addListener(t), t();
    } else
      vu.current = !1;
}
function OY(e, t, n) {
  const { willChange: r } = t;
  for (const o in t) {
    const i = t[o], a = n[o];
    if (jn(i))
      e.addValue(o, i), n9(r) && r.add(o), process.env.NODE_ENV === "development" && yf(i.version === "10.2.5", `Attempting to mix Framer Motion versions ${i.version} with 10.2.5 may not work as expected.`);
    else if (jn(a))
      e.addValue(o, ys(i, { owner: e })), n9(r) && r.remove(o);
    else if (a !== i)
      if (e.hasValue(o)) {
        const l = e.getValue(o);
        !l.hasAnimated && l.set(i);
      } else {
        const l = e.getStaticValue(o);
        e.addValue(o, ys(l !== void 0 ? l : i, { owner: e }));
      }
  }
  for (const o in n)
    t[o] === void 0 && e.removeValue(o);
  return t;
}
const xT = Object.keys(x0), NY = xT.length, Lb = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], DY = af.length;
class ZY {
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, visualState: i }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => Tt.render(this.render, !1, !0);
    const { latestValues: l, renderState: c } = i;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = a, this.isControllingVariants = D9(n), this.isVariantNode = pS(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: u, ...f } = this.scrapeMotionValuesFromProps(n, {});
    for (const p in f) {
      const h = f[p];
      l[p] !== void 0 && jn(h) && (h.set(l[p], !1), n9(u) && u.add(p));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n) {
    return {};
  }
  mount(t) {
    this.current = t, this.projection && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), yT.current || HY(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : vu.current, process.env.NODE_ENV !== "production" && yf(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), ta.update(this.notifyUpdate), ta.render(this.render), this.valueSubscriptions.forEach((t) => t()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features)
      this.features[t].unmount();
    this.current = null;
  }
  bindToMotionValue(t, n) {
    const r = a2.has(t), o = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && Tt.update(this.notifyUpdate, !1, !0), r && this.projection && (this.projection.isTransformDirty = !0);
    }), i = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(t, () => {
      o(), i();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  loadFeatures({ children: t, ...n }, r, o, i, a) {
    let l, c;
    if (process.env.NODE_ENV !== "production" && o && r) {
      const u = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      n.ignoreStrict ? q0(!1, u) : Fr(!1, u);
    }
    for (let u = 0; u < NY; u++) {
      const f = xT[u], { isEnabled: p, Feature: h, ProjectionNode: C, MeasureLayout: v } = x0[f];
      C && (l = C), p(n) && (!this.features[f] && h && (this.features[f] = new h(this)), v && (c = v));
    }
    if (!this.projection && l) {
      this.projection = new l(i, this.latestValues, this.parent && this.parent.projection);
      const { layoutId: u, layout: f, drag: p, dragConstraints: h, layoutScroll: C, layoutRoot: v } = n;
      this.projection.setOptions({
        layoutId: u,
        layout: f,
        alwaysMeasureLayout: !!p || h && es(h),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof f == "string" ? f : "both",
        initialPromotionConfig: a,
        layoutScroll: C,
        layoutRoot: v
      });
    }
    return c;
  }
  updateFeatures() {
    for (const t in this.features) {
      const n = this.features[t];
      n.isMounted ? n.update(this.props, this.prevProps) : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Wt();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(t, n = !0) {
    return this.makeTargetAnimatableFromInstance(t, this.props, n);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Lb.length; r++) {
      const o = Lb[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const i = t["on" + o];
      i && (this.propEventSubscriptions[o] = this.on(o, i));
    }
    this.prevMotionValues = OY(this, this.scrapeMotionValuesFromProps(t, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(t = !1) {
    if (t)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const r = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (r.initial = this.props.initial), r;
    }
    const n = {};
    for (let r = 0; r < DY; r++) {
      const o = af[r], i = this.props[o];
      (y0(i) || i === !1) && (n[o] = i);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    n !== this.values.get(t) && (this.removeValue(t), this.bindToMotionValue(t, n)), this.values.set(t, n), this.latestValues[t] = n.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = ys(n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t) {
    return this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.readValueFromInstance(this.current, t, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props, o = typeof r == "string" || typeof r == "object" ? (n = Cf(this.props, r)) === null || n === void 0 ? void 0 : n[t] : void 0;
    if (r && o !== void 0)
      return o;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !jn(i) ? i : this.initialValues[t] !== void 0 && o === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new vf()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class wT extends ZY {
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  makeTargetAnimatableFromInstance({ transition: t, transitionEnd: n, ...r }, { transformValues: o }, i) {
    let a = cj(r, t || {}, this);
    if (o && (n && (n = o(n)), r && (r = o(r)), a && (a = o(a))), i) {
      sj(this, r, a);
      const l = VY(this, r, a, n);
      n = l.transitionEnd, r = l.target;
    }
    return {
      transition: t,
      transitionEnd: n,
      ...r
    };
  }
}
function zY(e) {
  return window.getComputedStyle(e);
}
class GY extends wT {
  readValueFromInstance(t, n) {
    if (a2.has(n)) {
      const r = wf(n);
      return r && r.default || 0;
    } else {
      const r = zY(t), o = (gS(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return cT(t, n);
  }
  build(t, n, r, o) {
    uf(t, n, r, o.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n) {
    return mf(t, n);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    jn(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(t, n, r, o) {
    wS(t, n, r, o);
  }
}
class WY extends wT {
  constructor() {
    super(...arguments), this.isSVGTag = !1;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (a2.has(n)) {
      const r = wf(n);
      return r && r.default || 0;
    }
    return n = SS.has(n) ? n : hf(n), t.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return Wt();
  }
  scrapeMotionValuesFromProps(t, n) {
    return AS(t, n);
  }
  build(t, n, r, o) {
    ff(t, n, r, this.isSVGTag, o.transformTemplate);
  }
  renderInstance(t, n, r, o) {
    TS(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = pf(t.tagName), super.mount(t);
  }
}
const $Y = (e, t) => cf(e) ? new WY(t, { enableHardwareAcceleration: !1 }) : new GY(t, { enableHardwareAcceleration: !0 }), UY = {
  layout: {
    ProjectionNode: bT,
    MeasureLayout: fT
  }
}, jY = {
  ...yX,
  ...DU,
  ...LY,
  ...UY
}, Po = /* @__PURE__ */ Y$((e, t) => SU(e, t, jY, $Y));
function ST() {
  const e = Re(!1);
  return Ql(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function XY() {
  const e = ST(), [t, n] = ze(0), r = se(() => {
    e.current && n(t + 1);
  }, [t]);
  return [se(() => Tt.postRender(r), [r]), t];
}
class YY extends Se.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function JY({ children: e, isPresent: t }) {
  const n = dr(), r = Re(null), o = Re({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return cw(() => {
    const { width: i, height: a, top: l, left: c } = o.current;
    if (t || !r.current || !i || !a)
      return;
    r.current.dataset.motionPopId = n;
    const u = document.createElement("style");
    return document.head.appendChild(u), u.sheet && u.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${i}px !important;
            height: ${a}px !important;
            top: ${l}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(u);
    };
  }, [t]), Se.createElement(YY, { isPresent: t, childRef: r, sizeRef: o }, Se.cloneElement(e, { ref: r }));
}
const N8 = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: o, presenceAffectsLayout: i, mode: a }) => {
  const l = sf(QY), c = dr(), u = we(
    () => ({
      id: c,
      initial: t,
      isPresent: n,
      custom: o,
      onExitComplete: (f) => {
        l.set(f, !0);
        for (const p of l.values())
          if (!p)
            return;
        r && r();
      },
      register: (f) => (l.set(f, !1), () => l.delete(f))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? void 0 : [n]
  );
  return we(() => {
    l.forEach((f, p) => l.set(p, !1));
  }, [n]), Se.useEffect(() => {
    !n && !l.size && r && r();
  }, [n]), a === "popLayout" && (e = Se.createElement(JY, { isPresent: n }, e)), Se.createElement(X0.Provider, { value: u }, e);
};
function QY() {
  return /* @__PURE__ */ new Map();
}
function qY(e) {
  return Oe(() => () => e(), []);
}
const Q2 = (e) => e.key || "";
function KY(e, t) {
  e.forEach((n) => {
    const r = Q2(n);
    t.set(r, n);
  });
}
function eJ(e) {
  const t = [];
  return Ps.forEach(e, (n) => {
    G0(n) && t.push(n);
  }), t;
}
const l2 = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, exitBeforeEnter: o, presenceAffectsLayout: i = !0, mode: a = "sync" }) => {
  Fr(!o, "Replace exitBeforeEnter with mode='wait'");
  let [l] = XY();
  const c = N1(lf).forceRender;
  c && (l = c);
  const u = ST(), f = eJ(e);
  let p = f;
  const h = /* @__PURE__ */ new Set(), C = Re(p), v = Re(/* @__PURE__ */ new Map()).current, b = Re(!0);
  if (Ql(() => {
    b.current = !1, KY(f, v), C.current = p;
  }), qY(() => {
    b.current = !0, v.clear(), h.clear();
  }), b.current)
    return Se.createElement(Se.Fragment, null, p.map((A) => Se.createElement(N8, { key: Q2(A), isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: i, mode: a }, A)));
  p = [...p];
  const y = C.current.map(Q2), x = f.map(Q2), T = y.length;
  for (let A = 0; A < T; A++) {
    const L = y[A];
    x.indexOf(L) === -1 && h.add(L);
  }
  return a === "wait" && h.size && (p = []), h.forEach((A) => {
    if (x.indexOf(A) !== -1)
      return;
    const L = v.get(A);
    if (!L)
      return;
    const I = y.indexOf(A), M = () => {
      v.delete(A), h.delete(A);
      const k = C.current.findIndex((_) => _.key === A);
      if (C.current.splice(k, 1), !h.size) {
        if (C.current = f, u.current === !1)
          return;
        l(), r && r();
      }
    };
    p.splice(I, 0, Se.createElement(N8, { key: Q2(L), isPresent: !1, onExitComplete: M, custom: t, presenceAffectsLayout: i, mode: a }, L));
  }), p = p.map((A) => {
    const L = A.key;
    return h.has(L) ? A : Se.createElement(N8, { key: Q2(A), isPresent: !0, presenceAffectsLayout: i, mode: a }, A);
  }), process.env.NODE_ENV !== "production" && a === "wait" && p.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), Se.createElement(Se.Fragment, null, h.size ? p : p.map((A) => ko(A)));
};
var tJ = {
  initial: (e) => {
    const { position: t } = e, n = ["top", "bottom"].includes(t) ? "y" : "x";
    let r = ["top-right", "bottom-right"].includes(t) ? 1 : -1;
    return t === "bottom" && (r = 1), {
      opacity: 0,
      [n]: r * 24
    };
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
}, TT = Zd((e) => {
  const {
    id: t,
    message: n,
    onCloseComplete: r,
    onRequestRemove: o,
    requestClose: i = !1,
    position: a = "bottom",
    duration: l = 5e3,
    containerStyle: c,
    motionVariants: u = tJ,
    toastSpacing: f = "0.5rem"
  } = e, [p, h] = ze(l), C = zX();
  vs(() => {
    C || r?.();
  }, [C]), vs(() => {
    h(l);
  }, [l]);
  const v = () => h(null), b = () => h(l), y = () => {
    C && o();
  };
  Oe(() => {
    C && i && o();
  }, [C, i, o]), O$(y, p);
  const x = we(
    () => ({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: f,
      ...c
    }),
    [c, f]
  ), T = we(() => V$(a), [a]);
  return /* @__PURE__ */ g(
    Po.div,
    {
      layout: !0,
      className: "chakra-toast",
      variants: u,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      onHoverStart: v,
      onHoverEnd: b,
      custom: { position: a },
      style: T,
      children: /* @__PURE__ */ g(
        je.div,
        {
          role: "status",
          "aria-atomic": "true",
          className: "chakra-toast__inner",
          __css: x,
          children: Er(n, { id: t, onClose: y })
        }
      )
    }
  );
});
TT.displayName = "ToastComponent";
function nJ(e, t) {
  var n;
  const r = e ?? "bottom", i = {
    "top-start": { ltr: "top-left", rtl: "top-right" },
    "top-end": { ltr: "top-right", rtl: "top-left" },
    "bottom-start": { ltr: "bottom-left", rtl: "bottom-right" },
    "bottom-end": { ltr: "bottom-right", rtl: "bottom-left" }
  }[r];
  return (n = i?.[t]) != null ? n : r;
}
var Eb = {
  path: /* @__PURE__ */ X("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ g(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ g(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ g("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
}, U1 = Le((e, t) => {
  const {
    as: n,
    viewBox: r,
    color: o = "currentColor",
    focusable: i = !1,
    children: a,
    className: l,
    __css: c,
    ...u
  } = e, f = v1("chakra-icon", l), p = aa("Icon", e), h = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: o,
    ...c,
    ...p
  }, C = {
    ref: t,
    focusable: i,
    className: f,
    __css: h
  }, v = r ?? Eb.viewBox;
  if (n && typeof n != "string")
    return /* @__PURE__ */ g(je.svg, { as: n, ...C, ...u });
  const b = a ?? Eb.path;
  return /* @__PURE__ */ g(je.svg, { verticalAlign: "middle", viewBox: v, ...C, ...u, children: b });
});
U1.displayName = "Icon";
function P(e) {
  const {
    viewBox: t = "0 0 24 24",
    d: n,
    displayName: r,
    defaultProps: o = {}
  } = e, i = Ps.toArray(e.path), a = Le((l, c) => /* @__PURE__ */ g(U1, { ref: c, viewBox: t, ...o, ...l, children: i.length ? i : /* @__PURE__ */ g("path", { fill: "currentColor", d: n }) }));
  return a.displayName = r, a;
}
function rJ(e) {
  return /* @__PURE__ */ g(U1, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ g(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    }
  ) });
}
function oJ(e) {
  return /* @__PURE__ */ g(U1, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ g(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    }
  ) });
}
function Mb(e) {
  return /* @__PURE__ */ g(U1, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ g(
    "path",
    {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    }
  ) });
}
var iJ = W0({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), Bf = Le((e, t) => {
  const n = aa("Spinner", e), {
    label: r = "Loading...",
    thickness: o = "2px",
    speed: i = "0.45s",
    emptyColor: a = "transparent",
    className: l,
    ...c
  } = fr(e), u = v1("chakra-spinner", l), f = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: o,
    borderBottomColor: a,
    borderLeftColor: a,
    animation: `${iJ} ${i} linear infinite`,
    ...n
  };
  return /* @__PURE__ */ g(
    je.div,
    {
      ref: t,
      __css: f,
      className: u,
      ...c,
      children: r && /* @__PURE__ */ g(je.span, { srOnly: !0, children: r })
    }
  );
});
Bf.displayName = "Spinner";
var [aJ, kf] = tn({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<Alert />"
}), [sJ, Rf] = tn({
  name: "AlertStylesContext",
  hookName: "useAlertStyles",
  providerName: "<Alert />"
}), AT = {
  info: { icon: oJ, colorScheme: "blue" },
  warning: { icon: Mb, colorScheme: "orange" },
  success: { icon: rJ, colorScheme: "green" },
  error: { icon: Mb, colorScheme: "red" },
  loading: { icon: Bf, colorScheme: "blue" }
};
function lJ(e) {
  return AT[e].colorScheme;
}
function cJ(e) {
  return AT[e].icon;
}
var IT = Le(
  function(t, n) {
    const r = Rf(), { status: o } = kf(), i = {
      display: "inline",
      ...r.description
    };
    return /* @__PURE__ */ g(
      je.div,
      {
        ref: n,
        "data-status": o,
        ...t,
        className: v1("chakra-alert__desc", t.className),
        __css: i
      }
    );
  }
);
IT.displayName = "AlertDescription";
function LT(e) {
  const { status: t } = kf(), n = cJ(t), r = Rf(), o = t === "loading" ? r.spinner : r.icon;
  return /* @__PURE__ */ g(
    je.span,
    {
      display: "inherit",
      "data-status": t,
      ...e,
      className: v1("chakra-alert__icon", e.className),
      __css: o,
      children: e.children || /* @__PURE__ */ g(n, { h: "100%", w: "100%" })
    }
  );
}
LT.displayName = "AlertIcon";
var ET = Le(
  function(t, n) {
    const r = Rf(), { status: o } = kf();
    return /* @__PURE__ */ g(
      je.div,
      {
        ref: n,
        "data-status": o,
        ...t,
        className: v1("chakra-alert__title", t.className),
        __css: r.title
      }
    );
  }
);
ET.displayName = "AlertTitle";
var MT = Le(function(t, n) {
  var r;
  const { status: o = "info", addRole: i = !0, ...a } = fr(t), l = (r = t.colorScheme) != null ? r : lJ(o), c = i2("Alert", { ...t, colorScheme: l }), u = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    ...c.container
  };
  return /* @__PURE__ */ g(aJ, { value: { status: o }, children: /* @__PURE__ */ g(sJ, { value: c, children: /* @__PURE__ */ g(
    je.div,
    {
      "data-status": o,
      role: i ? "alert" : void 0,
      ref: n,
      ...a,
      className: v1("chakra-alert", t.className),
      __css: u
    }
  ) }) });
});
MT.displayName = "Alert";
function uJ(e) {
  return /* @__PURE__ */ g(U1, { focusable: "false", "aria-hidden": !0, ...e, children: /* @__PURE__ */ g(
    "path",
    {
      fill: "currentColor",
      d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    }
  ) });
}
var _f = Le(
  function(t, n) {
    const r = aa("CloseButton", t), { children: o, isDisabled: i, __css: a, ...l } = fr(t), c = {
      outline: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    };
    return /* @__PURE__ */ g(
      je.button,
      {
        type: "button",
        "aria-label": "Close",
        ref: n,
        disabled: i,
        __css: {
          ...c,
          ...r,
          ...a
        },
        ...l,
        children: o || /* @__PURE__ */ g(uJ, { width: "1em", height: "1em" })
      }
    );
  }
);
_f.displayName = "CloseButton";
var dJ = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
}, yo = fJ(dJ);
function fJ(e) {
  let t = e;
  const n = /* @__PURE__ */ new Set(), r = (o) => {
    t = o(t), n.forEach((i) => i());
  };
  return {
    getState: () => t,
    subscribe: (o) => (n.add(o), () => {
      r(() => e), n.delete(o);
    }),
    removeToast: (o, i) => {
      r((a) => ({
        ...a,
        [i]: a[i].filter((l) => l.id != o)
      }));
    },
    notify: (o, i) => {
      const a = pJ(o, i), { position: l, id: c } = a;
      return r((u) => {
        var f, p;
        const C = l.includes("top") ? [a, ...(f = u[l]) != null ? f : []] : [...(p = u[l]) != null ? p : [], a];
        return {
          ...u,
          [l]: C
        };
      }), c;
    },
    update: (o, i) => {
      o && r((a) => {
        const l = { ...a }, { position: c, index: u } = Sg(l, o);
        return c && u !== -1 && (l[c][u] = {
          ...l[c][u],
          ...i,
          message: BT(i)
        }), l;
      });
    },
    closeAll: ({ positions: o } = {}) => {
      r((i) => (o ?? [
        "bottom",
        "bottom-right",
        "bottom-left",
        "top",
        "top-left",
        "top-right"
      ]).reduce(
        (c, u) => (c[u] = i[u].map((f) => ({
          ...f,
          requestClose: !0
        })), c),
        { ...i }
      ));
    },
    close: (o) => {
      r((i) => {
        const a = uS(i, o);
        return a ? {
          ...i,
          [a]: i[a].map((l) => l.id == o ? {
            ...l,
            requestClose: !0
          } : l)
        } : i;
      });
    },
    isActive: (o) => !!Sg(yo.getState(), o).position
  };
}
var Bb = 0;
function pJ(e, t = {}) {
  var n, r;
  Bb += 1;
  const o = (n = t.id) != null ? n : Bb, i = (r = t.position) != null ? r : "bottom";
  return {
    id: o,
    message: e,
    position: i,
    duration: t.duration,
    onCloseComplete: t.onCloseComplete,
    onRequestRemove: () => yo.removeToast(String(o), i),
    status: t.status,
    requestClose: !1,
    containerStyle: t.containerStyle
  };
}
var hJ = (e) => {
  const {
    status: t,
    variant: n = "solid",
    id: r,
    title: o,
    isClosable: i,
    onClose: a,
    description: l,
    colorScheme: c,
    icon: u
  } = e, f = r ? {
    root: `toast-${r}`,
    title: `toast-${r}-title`,
    description: `toast-${r}-description`
  } : void 0;
  return /* @__PURE__ */ X(
    MT,
    {
      addRole: !1,
      status: t,
      variant: n,
      id: f?.root,
      alignItems: "start",
      borderRadius: "md",
      boxShadow: "lg",
      paddingEnd: 8,
      textAlign: "start",
      width: "auto",
      colorScheme: c,
      children: [
        /* @__PURE__ */ g(LT, { children: u }),
        /* @__PURE__ */ X(je.div, { flex: "1", maxWidth: "100%", children: [
          o && /* @__PURE__ */ g(ET, { id: f?.title, children: o }),
          l && /* @__PURE__ */ g(IT, { id: f?.description, display: "block", children: l })
        ] }),
        i && /* @__PURE__ */ g(
          _f,
          {
            size: "sm",
            onClick: a,
            position: "absolute",
            insetEnd: 1,
            top: 1
          }
        )
      ]
    }
  );
};
function BT(e = {}) {
  const { render: t, toastComponent: n = hJ } = e;
  return (o) => typeof t == "function" ? t({ ...o, ...e }) : /* @__PURE__ */ g(n, { ...o, ...e });
}
function mJ(e, t) {
  const n = (o) => {
    var i;
    return {
      ...t,
      ...o,
      position: nJ(
        (i = o?.position) != null ? i : t?.position,
        e
      )
    };
  }, r = (o) => {
    const i = n(o), a = BT(i);
    return yo.notify(a, i);
  };
  return r.update = (o, i) => {
    yo.update(o, n(i));
  }, r.promise = (o, i) => {
    const a = r({
      ...i.loading,
      status: "loading",
      duration: null
    });
    o.then(
      (l) => r.update(a, {
        status: "success",
        duration: 5e3,
        ...Er(i.success, l)
      })
    ).catch(
      (l) => r.update(a, {
        status: "error",
        duration: 5e3,
        ...Er(i.error, l)
      })
    );
  }, r.closeAll = yo.closeAll, r.close = yo.close, r.isActive = yo.isActive, r;
}
var [CJ, gJ] = tn({
  name: "ToastOptionsContext",
  strict: !1
}), bJ = (e) => {
  const t = rH(
    yo.subscribe,
    yo.getState,
    yo.getState
  ), {
    motionVariants: n,
    component: r = TT,
    portalProps: o
  } = e, a = Object.keys(t).map((l) => {
    const c = t[l];
    return /* @__PURE__ */ g(
      "div",
      {
        role: "region",
        "aria-live": "polite",
        id: `chakra-toast-manager-${l}`,
        style: H$(l),
        children: /* @__PURE__ */ g(l2, { initial: !1, children: c.map((u) => /* @__PURE__ */ g(
          r,
          {
            motionVariants: n,
            ...u
          },
          u.id
        )) })
      },
      l
    );
  });
  return /* @__PURE__ */ g(o2, { ...o, children: a });
};
function vJ(e) {
  const { theme: t } = vw(), n = gJ();
  return we(
    () => mJ(t.direction, {
      ...n,
      ...e
    }),
    [e, t.direction, n]
  );
}
var yJ = (e) => function({
  children: n,
  theme: r = e,
  toastOptions: o,
  ...i
}) {
  return /* @__PURE__ */ X(F$, { theme: r, ...i, children: [
    /* @__PURE__ */ g(CJ, { value: o?.defaultOptions, children: n }),
    /* @__PURE__ */ g(bJ, { ...o })
  ] });
}, xJ = yJ(tS), wJ = Object.defineProperty, SJ = (e, t, n) => t in e ? wJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ft = (e, t, n) => (SJ(e, typeof t != "symbol" ? t + "" : t, n), n);
function kb(e) {
  return e.sort((t, n) => {
    const r = t.compareDocumentPosition(n);
    if (r & Node.DOCUMENT_POSITION_FOLLOWING || r & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (r & Node.DOCUMENT_POSITION_PRECEDING || r & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (r & Node.DOCUMENT_POSITION_DISCONNECTED || r & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
var TJ = (e) => typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
function Rb(e, t, n) {
  let r = e + 1;
  return n && r >= t && (r = 0), r;
}
function _b(e, t, n) {
  let r = e - 1;
  return n && r < 0 && (r = t), r;
}
var yu = typeof window < "u" ? z0 : Oe, a9 = (e) => e, AJ = class {
  constructor() {
    Ft(this, "descendants", /* @__PURE__ */ new Map()), Ft(this, "register", (e) => {
      if (e != null)
        return TJ(e) ? this.registerNode(e) : (t) => {
          this.registerNode(t, e);
        };
    }), Ft(this, "unregister", (e) => {
      this.descendants.delete(e);
      const t = kb(Array.from(this.descendants.keys()));
      this.assignIndex(t);
    }), Ft(this, "destroy", () => {
      this.descendants.clear();
    }), Ft(this, "assignIndex", (e) => {
      this.descendants.forEach((t) => {
        const n = e.indexOf(t.node);
        t.index = n, t.node.dataset.index = t.index.toString();
      });
    }), Ft(this, "count", () => this.descendants.size), Ft(this, "enabledCount", () => this.enabledValues().length), Ft(this, "values", () => Array.from(this.descendants.values()).sort((t, n) => t.index - n.index)), Ft(this, "enabledValues", () => this.values().filter((e) => !e.disabled)), Ft(this, "item", (e) => {
      if (this.count() !== 0)
        return this.values()[e];
    }), Ft(this, "enabledItem", (e) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[e];
    }), Ft(this, "first", () => this.item(0)), Ft(this, "firstEnabled", () => this.enabledItem(0)), Ft(this, "last", () => this.item(this.descendants.size - 1)), Ft(this, "lastEnabled", () => {
      const e = this.enabledValues().length - 1;
      return this.enabledItem(e);
    }), Ft(this, "indexOf", (e) => {
      var t, n;
      return e && (n = (t = this.descendants.get(e)) == null ? void 0 : t.index) != null ? n : -1;
    }), Ft(this, "enabledIndexOf", (e) => e == null ? -1 : this.enabledValues().findIndex((t) => t.node.isSameNode(e))), Ft(this, "next", (e, t = !0) => {
      const n = Rb(e, this.count(), t);
      return this.item(n);
    }), Ft(this, "nextEnabled", (e, t = !0) => {
      const n = this.item(e);
      if (!n)
        return;
      const r = this.enabledIndexOf(n.node), o = Rb(
        r,
        this.enabledCount(),
        t
      );
      return this.enabledItem(o);
    }), Ft(this, "prev", (e, t = !0) => {
      const n = _b(e, this.count() - 1, t);
      return this.item(n);
    }), Ft(this, "prevEnabled", (e, t = !0) => {
      const n = this.item(e);
      if (!n)
        return;
      const r = this.enabledIndexOf(n.node), o = _b(
        r,
        this.enabledCount() - 1,
        t
      );
      return this.enabledItem(o);
    }), Ft(this, "registerNode", (e, t) => {
      if (!e || this.descendants.has(e))
        return;
      const n = Array.from(this.descendants.keys()).concat(e), r = kb(n);
      t?.disabled && (t.disabled = !!t.disabled);
      const o = { node: e, index: -1, ...t };
      this.descendants.set(e, o), this.assignIndex(r);
    });
  }
};
function IJ(e, t) {
  if (e != null) {
    if (typeof e == "function") {
      e(t);
      return;
    }
    try {
      e.current = t;
    } catch {
      throw new Error(`Cannot assign value '${t}' to ref '${e}'`);
    }
  }
}
function Kt(...e) {
  return (t) => {
    e.forEach((n) => {
      IJ(n, t);
    });
  };
}
function LJ(...e) {
  return we(() => Kt(...e), e);
}
function EJ() {
  const e = Re(new AJ());
  return yu(() => () => e.current.destroy()), e.current;
}
var [MJ, kT] = tn({
  name: "DescendantsProvider",
  errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function BJ(e) {
  const t = kT(), [n, r] = ze(-1), o = Re(null);
  yu(() => () => {
    o.current && t.unregister(o.current);
  }, []), yu(() => {
    if (!o.current)
      return;
    const a = Number(o.current.dataset.index);
    n != a && !Number.isNaN(a) && r(a);
  });
  const i = a9(e ? t.register(e) : t.register);
  return {
    descendants: t,
    index: n,
    enabledIndex: t.enabledIndexOf(o.current),
    register: Kt(i, o)
  };
}
function RT() {
  return [
    a9(MJ),
    () => a9(kT()),
    () => EJ(),
    (o) => BJ(o)
  ];
}
var [dfe, Ff] = tn({
  name: "AccordionStylesContext",
  hookName: "useAccordionStyles",
  providerName: "<Accordion />"
}), [kJ, _T] = tn({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItem />"
}), [
  ffe,
  pfe,
  hfe,
  RJ
] = RT(), FT = Le(
  function(t, n) {
    const { getButtonProps: r } = _T(), o = r(t, n), a = {
      display: "flex",
      alignItems: "center",
      width: "100%",
      outline: 0,
      ...Ff().button
    };
    return /* @__PURE__ */ g(
      je.button,
      {
        ...o,
        className: v1("chakra-accordion__button", t.className),
        __css: a
      }
    );
  }
);
FT.displayName = "AccordionButton";
function _J(e) {
  const {
    value: t,
    defaultValue: n,
    onChange: r,
    shouldUpdate: o = (h, C) => h !== C
  } = e, i = qi(r), a = qi(o), [l, c] = ze(n), u = t !== void 0, f = u ? t : l, p = qi(
    (h) => {
      const v = typeof h == "function" ? h(f) : h;
      a(f, v) && (u || c(v), i(v));
    },
    [u, i, f, a]
  );
  return [f, p];
}
var [mfe, PT] = tn({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "Accordion"
});
function FJ(e) {
  const { isDisabled: t, isFocusable: n, id: r, ...o } = e, { getAccordionItemProps: i, setFocusedIndex: a } = PT(), l = Re(null), c = dr(), u = r ?? c, f = `accordion-button-${u}`, p = `accordion-panel-${u}`;
  PJ(e);
  const { register: h, index: C, descendants: v } = RJ({
    disabled: t && !n
  }), { isOpen: b, onChange: y } = i(
    C === -1 ? null : C
  );
  VJ({ isOpen: b, isDisabled: t });
  const x = () => {
    y?.(!0);
  }, T = () => {
    y?.(!1);
  }, A = se(() => {
    y?.(!b), a(C);
  }, [C, a, b, y]), L = se(
    (_) => {
      const $ = {
        ArrowDown: () => {
          const oe = v.nextEnabled(C);
          oe?.node.focus();
        },
        ArrowUp: () => {
          const oe = v.prevEnabled(C);
          oe?.node.focus();
        },
        Home: () => {
          const oe = v.firstEnabled();
          oe?.node.focus();
        },
        End: () => {
          const oe = v.lastEnabled();
          oe?.node.focus();
        }
      }[_.key];
      $ && (_.preventDefault(), $(_));
    },
    [v, C]
  ), I = se(() => {
    a(C);
  }, [a, C]), M = se(
    function(F = {}, $ = null) {
      return {
        ...F,
        type: "button",
        ref: Kt(h, l, $),
        id: f,
        disabled: !!t,
        "aria-expanded": !!b,
        "aria-controls": p,
        onClick: it(F.onClick, A),
        onFocus: it(F.onFocus, I),
        onKeyDown: it(F.onKeyDown, L)
      };
    },
    [
      f,
      t,
      b,
      A,
      I,
      L,
      p,
      h
    ]
  ), k = se(
    function(F = {}, $ = null) {
      return {
        ...F,
        ref: $,
        role: "region",
        id: p,
        "aria-labelledby": f,
        hidden: !b
      };
    },
    [f, b, p]
  );
  return {
    isOpen: b,
    isDisabled: t,
    isFocusable: n,
    onOpen: x,
    onClose: T,
    getButtonProps: M,
    getPanelProps: k,
    htmlProps: o
  };
}
function PJ(e) {
  Xd({
    condition: !!(e.isFocusable && !e.isDisabled),
    message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
  });
}
function VJ(e) {
  Xd({
    condition: e.isOpen && !!e.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}
var VT = Le(
  function(t, n) {
    const { children: r, className: o } = t, { htmlProps: i, ...a } = FJ(t), c = {
      ...Ff().container,
      overflowAnchor: "none"
    }, u = we(() => a, [a]);
    return /* @__PURE__ */ g(kJ, { value: u, children: /* @__PURE__ */ g(
      je.div,
      {
        ref: n,
        ...i,
        className: v1("chakra-accordion__item", o),
        __css: c,
        children: typeof r == "function" ? r({
          isExpanded: !!a.isOpen,
          isDisabled: !!a.isDisabled
        }) : r
      }
    ) });
  }
);
VT.displayName = "AccordionItem";
var rs = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
}, Ga = {
  enter: {
    duration: 0.2,
    ease: rs.easeOut
  },
  exit: {
    duration: 0.1,
    ease: rs.easeIn
  }
}, li = {
  enter: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t?.enter
  }),
  exit: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t?.exit
  })
}, HJ = (e) => e != null && parseInt(e.toString(), 10) > 0, Fb = {
  exit: {
    height: { duration: 0.2, ease: rs.ease },
    opacity: { duration: 0.3, ease: rs.ease }
  },
  enter: {
    height: { duration: 0.3, ease: rs.ease },
    opacity: { duration: 0.4, ease: rs.ease }
  }
}, OJ = {
  exit: ({
    animateOpacity: e,
    startingHeight: t,
    transition: n,
    transitionEnd: r,
    delay: o
  }) => {
    var i;
    return {
      ...e && { opacity: HJ(t) ? 1 : 0 },
      height: t,
      transitionEnd: r?.exit,
      transition: (i = n?.exit) != null ? i : li.exit(Fb.exit, o)
    };
  },
  enter: ({
    animateOpacity: e,
    endingHeight: t,
    transition: n,
    transitionEnd: r,
    delay: o
  }) => {
    var i;
    return {
      ...e && { opacity: 1 },
      height: t,
      transitionEnd: r?.enter,
      transition: (i = n?.enter) != null ? i : li.enter(Fb.enter, o)
    };
  }
}, $9 = ro(
  (e, t) => {
    const {
      in: n,
      unmountOnExit: r,
      animateOpacity: o = !0,
      startingHeight: i = 0,
      endingHeight: a = "auto",
      style: l,
      className: c,
      transition: u,
      transitionEnd: f,
      ...p
    } = e, [h, C] = ze(!1);
    Oe(() => {
      const T = setTimeout(() => {
        C(!0);
      });
      return () => clearTimeout(T);
    }, []), Xd({
      condition: Number(i) > 0 && !!r,
      message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
    });
    const v = parseFloat(i.toString()) > 0, b = {
      startingHeight: i,
      endingHeight: a,
      animateOpacity: o,
      transition: h ? u : { enter: { duration: 0 } },
      transitionEnd: {
        enter: f?.enter,
        exit: r ? f?.exit : {
          ...f?.exit,
          display: v ? "block" : "none"
        }
      }
    }, y = r ? n : !0, x = n || r ? "enter" : "exit";
    return /* @__PURE__ */ g(l2, { initial: !1, custom: b, children: y && /* @__PURE__ */ g(
      Po.div,
      {
        ref: t,
        ...p,
        className: v1("chakra-collapse", c),
        style: {
          overflow: "hidden",
          display: "block",
          ...l
        },
        custom: b,
        variants: OJ,
        initial: r ? "exit" : !1,
        animate: x,
        exit: "exit"
      }
    ) });
  }
);
$9.displayName = "Collapse";
var NJ = {
  enter: ({ transition: e, transitionEnd: t, delay: n } = {}) => {
    var r;
    return {
      opacity: 1,
      transition: (r = e?.enter) != null ? r : li.enter(Ga.enter, n),
      transitionEnd: t?.enter
    };
  },
  exit: ({ transition: e, transitionEnd: t, delay: n } = {}) => {
    var r;
    return {
      opacity: 0,
      transition: (r = e?.exit) != null ? r : li.exit(Ga.exit, n),
      transitionEnd: t?.exit
    };
  }
}, HT = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: NJ
}, DJ = ro(function(t, n) {
  const {
    unmountOnExit: r,
    in: o,
    className: i,
    transition: a,
    transitionEnd: l,
    delay: c,
    ...u
  } = t, f = o || r ? "enter" : "exit", p = r ? o && r : !0, h = { transition: a, transitionEnd: l, delay: c };
  return /* @__PURE__ */ g(l2, { custom: h, children: p && /* @__PURE__ */ g(
    Po.div,
    {
      ref: n,
      className: v1("chakra-fade", i),
      custom: h,
      ...HT,
      animate: f,
      ...u
    }
  ) });
});
DJ.displayName = "Fade";
var ZJ = {
  exit: ({ reverse: e, initialScale: t, transition: n, transitionEnd: r, delay: o }) => {
    var i;
    return {
      opacity: 0,
      ...e ? { scale: t, transitionEnd: r?.exit } : { transitionEnd: { scale: t, ...r?.exit } },
      transition: (i = n?.exit) != null ? i : li.exit(Ga.exit, o)
    };
  },
  enter: ({ transitionEnd: e, transition: t, delay: n }) => {
    var r;
    return {
      opacity: 1,
      scale: 1,
      transition: (r = t?.enter) != null ? r : li.enter(Ga.enter, n),
      transitionEnd: e?.enter
    };
  }
}, OT = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: ZJ
}, zJ = ro(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      reverse: i = !0,
      initialScale: a = 0.95,
      className: l,
      transition: c,
      transitionEnd: u,
      delay: f,
      ...p
    } = t, h = r ? o && r : !0, C = o || r ? "enter" : "exit", v = { initialScale: a, reverse: i, transition: c, transitionEnd: u, delay: f };
    return /* @__PURE__ */ g(l2, { custom: v, children: h && /* @__PURE__ */ g(
      Po.div,
      {
        ref: n,
        className: v1("chakra-offset-slide", l),
        ...OT,
        animate: C,
        custom: v,
        ...p
      }
    ) });
  }
);
zJ.displayName = "ScaleFade";
var GJ = {
  initial: ({ offsetX: e, offsetY: t, transition: n, transitionEnd: r, delay: o }) => {
    var i;
    return {
      opacity: 0,
      x: e,
      y: t,
      transition: (i = n?.exit) != null ? i : li.exit(Ga.exit, o),
      transitionEnd: r?.exit
    };
  },
  enter: ({ transition: e, transitionEnd: t, delay: n }) => {
    var r;
    return {
      opacity: 1,
      x: 0,
      y: 0,
      transition: (r = e?.enter) != null ? r : li.enter(Ga.enter, n),
      transitionEnd: t?.enter
    };
  },
  exit: ({ offsetY: e, offsetX: t, transition: n, transitionEnd: r, reverse: o, delay: i }) => {
    var a;
    const l = { x: t, y: e };
    return {
      opacity: 0,
      transition: (a = n?.exit) != null ? a : li.exit(Ga.exit, i),
      ...o ? { ...l, transitionEnd: r?.exit } : { transitionEnd: { ...l, ...r?.exit } }
    };
  }
}, xu = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: GJ
}, WJ = ro(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      reverse: i = !0,
      className: a,
      offsetX: l = 0,
      offsetY: c = 8,
      transition: u,
      transitionEnd: f,
      delay: p,
      ...h
    } = t, C = r ? o && r : !0, v = o || r ? "enter" : "exit", b = {
      offsetX: l,
      offsetY: c,
      reverse: i,
      transition: u,
      transitionEnd: f,
      delay: p
    };
    return /* @__PURE__ */ g(l2, { custom: b, children: C && /* @__PURE__ */ g(
      Po.div,
      {
        ref: n,
        className: v1("chakra-offset-slide", a),
        custom: b,
        ...xu,
        animate: v,
        ...h
      }
    ) });
  }
);
WJ.displayName = "SlideFade";
var NT = Le(
  function(t, n) {
    const { className: r, motionProps: o, ...i } = t, { reduceMotion: a } = PT(), { getPanelProps: l, isOpen: c } = _T(), u = l(i, n), f = v1("chakra-accordion__panel", r), p = Ff();
    a || delete u.hidden;
    const h = /* @__PURE__ */ g(je.div, { ...u, __css: p.panel, className: f });
    return a ? h : /* @__PURE__ */ g($9, { in: c, ...o, children: h });
  }
);
NT.displayName = "AccordionPanel";
var wu = Le(function(t, n) {
  const { htmlWidth: r, htmlHeight: o, alt: i, ...a } = t;
  return /* @__PURE__ */ g("img", { width: r, height: o, ref: n, alt: i, ...a });
});
wu.displayName = "NativeImage";
function $J(e) {
  const {
    loading: t,
    src: n,
    srcSet: r,
    onLoad: o,
    onError: i,
    crossOrigin: a,
    sizes: l,
    ignoreFallback: c
  } = e, [u, f] = ze("pending");
  Oe(() => {
    f(n ? "loading" : "pending");
  }, [n]);
  const p = Re(), h = se(() => {
    if (!n)
      return;
    C();
    const v = new Image();
    v.src = n, a && (v.crossOrigin = a), r && (v.srcset = r), l && (v.sizes = l), t && (v.loading = t), v.onload = (b) => {
      C(), f("loaded"), o?.(b);
    }, v.onerror = (b) => {
      C(), f("failed"), i?.(b);
    }, p.current = v;
  }, [n, a, r, l, o, i, t]), C = () => {
    p.current && (p.current.onload = null, p.current.onerror = null, p.current = null);
  };
  return Xa(() => {
    if (!c)
      return u === "loading" && h(), () => {
        C();
      };
  }, [u, h, c]), c ? "loaded" : u;
}
var UJ = (e, t) => e !== "loaded" && t === "beforeLoadOrError" || e === "failed" && t === "onError";
function jJ(e, t = []) {
  const n = Object.assign({}, e);
  for (const r of t)
    r in n && delete n[r];
  return n;
}
var cs = Le(function(t, n) {
  const {
    fallbackSrc: r,
    fallback: o,
    src: i,
    srcSet: a,
    align: l,
    fit: c,
    loading: u,
    ignoreFallback: f,
    crossOrigin: p,
    fallbackStrategy: h = "beforeLoadOrError",
    referrerPolicy: C,
    ...v
  } = t, b = r !== void 0 || o !== void 0, y = u != null || f || !b, x = $J({
    ...t,
    crossOrigin: p,
    ignoreFallback: y
  }), T = UJ(x, h), A = {
    ref: n,
    objectFit: c,
    objectPosition: l,
    ...y ? v : jJ(v, ["onError", "onLoad"])
  };
  return T ? o || /* @__PURE__ */ g(
    je.img,
    {
      as: wu,
      className: "chakra-image__placeholder",
      src: r,
      ...A
    }
  ) : /* @__PURE__ */ g(
    je.img,
    {
      as: wu,
      src: i,
      srcSet: a,
      crossOrigin: p,
      loading: u,
      referrerPolicy: C,
      className: "chakra-image",
      ...A
    }
  );
});
cs.displayName = "Image";
function Pf(e) {
  return Ps.toArray(e).filter(
    (t) => G0(t)
  );
}
var [Cfe, XJ] = tn({
  strict: !1,
  name: "ButtonGroupContext"
});
function YJ(e) {
  const [t, n] = ze(!e);
  return { ref: se((i) => {
    i && n(i.tagName === "BUTTON");
  }, []), type: t ? "button" : void 0 };
}
function Su(e) {
  const { children: t, className: n, ...r } = e, o = G0(t) ? ko(t, {
    "aria-hidden": !0,
    focusable: !1
  }) : t, i = v1("chakra-button__icon", n);
  return /* @__PURE__ */ g(
    je.span,
    {
      display: "inline-flex",
      alignSelf: "center",
      flexShrink: 0,
      ...r,
      className: i,
      children: o
    }
  );
}
Su.displayName = "ButtonIcon";
function Tu(e) {
  const {
    label: t,
    placement: n,
    spacing: r = "0.5rem",
    children: o = /* @__PURE__ */ g(Bf, { color: "currentColor", width: "1em", height: "1em" }),
    className: i,
    __css: a,
    ...l
  } = e, c = v1("chakra-button__spinner", i), u = n === "start" ? "marginEnd" : "marginStart", f = we(
    () => ({
      display: "flex",
      alignItems: "center",
      position: t ? "relative" : "absolute",
      [u]: t ? r : 0,
      fontSize: "1em",
      lineHeight: "normal",
      ...a
    }),
    [a, t, u, r]
  );
  return /* @__PURE__ */ g(je.div, { className: c, ...l, __css: f, children: o });
}
Tu.displayName = "ButtonSpinner";
var U9 = Le((e, t) => {
  const n = XJ(), r = aa("Button", { ...n, ...e }), {
    isDisabled: o = n?.isDisabled,
    isLoading: i,
    isActive: a,
    children: l,
    leftIcon: c,
    rightIcon: u,
    loadingText: f,
    iconSpacing: p = "0.5rem",
    type: h,
    spinner: C,
    spinnerPlacement: v = "start",
    className: b,
    as: y,
    ...x
  } = fr(e), T = we(() => {
    const M = { ...r?._focus, zIndex: 1 };
    return {
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      ...r,
      ...!!n && { _focus: M }
    };
  }, [r, n]), { ref: A, type: L } = YJ(y), I = { rightIcon: u, leftIcon: c, iconSpacing: p, children: l };
  return /* @__PURE__ */ X(
    je.button,
    {
      ref: LJ(t, A),
      as: y,
      type: h ?? L,
      "data-active": Xi(a),
      "data-loading": Xi(i),
      __css: T,
      className: v1("chakra-button", b),
      ...x,
      disabled: o || i,
      children: [
        i && v === "start" && /* @__PURE__ */ g(
          Tu,
          {
            className: "chakra-button__spinner--start",
            label: f,
            placement: "start",
            spacing: p,
            children: C
          }
        ),
        i ? f || /* @__PURE__ */ g(je.span, { opacity: 0, children: /* @__PURE__ */ g(Pb, { ...I }) }) : /* @__PURE__ */ g(Pb, { ...I }),
        i && v === "end" && /* @__PURE__ */ g(
          Tu,
          {
            className: "chakra-button__spinner--end",
            label: f,
            placement: "end",
            spacing: p,
            children: C
          }
        )
      ]
    }
  );
});
U9.displayName = "Button";
function Pb(e) {
  const { leftIcon: t, rightIcon: n, children: r, iconSpacing: o } = e;
  return /* @__PURE__ */ X(st, { children: [
    t && /* @__PURE__ */ g(Su, { marginEnd: o, children: t }),
    r,
    n && /* @__PURE__ */ g(Su, { marginStart: o, children: n })
  ] });
}
var DT = Le(
  (e, t) => {
    const { icon: n, children: r, isRound: o, "aria-label": i, ...a } = e, l = n || r, c = G0(l) ? ko(l, {
      "aria-hidden": !0,
      focusable: !1
    }) : null;
    return /* @__PURE__ */ g(
      U9,
      {
        padding: "0",
        borderRadius: o ? "full" : void 0,
        ref: t,
        "aria-label": i,
        ...a,
        children: c
      }
    );
  }
);
DT.displayName = "IconButton";
var [JJ, QJ] = tn({
  name: "FormControlStylesContext",
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
}), [qJ, ZT] = tn({
  strict: !1,
  name: "FormControlContext"
});
function KJ(e) {
  const {
    id: t,
    isRequired: n,
    isInvalid: r,
    isDisabled: o,
    isReadOnly: i,
    ...a
  } = e, l = dr(), c = t || `field-${l}`, u = `${c}-label`, f = `${c}-feedback`, p = `${c}-helptext`, [h, C] = ze(!1), [v, b] = ze(!1), [y, x] = ze(!1), T = se(
    (k = {}, _ = null) => ({
      id: p,
      ...k,
      ref: Kt(_, (F) => {
        F && b(!0);
      })
    }),
    [p]
  ), A = se(
    (k = {}, _ = null) => ({
      ...k,
      ref: _,
      "data-focus": Xi(y),
      "data-disabled": Xi(o),
      "data-invalid": Xi(r),
      "data-readonly": Xi(i),
      id: k.id !== void 0 ? k.id : u,
      htmlFor: k.htmlFor !== void 0 ? k.htmlFor : c
    }),
    [c, o, y, r, i, u]
  ), L = se(
    (k = {}, _ = null) => ({
      id: f,
      ...k,
      ref: Kt(_, (F) => {
        F && C(!0);
      }),
      "aria-live": "polite"
    }),
    [f]
  ), I = se(
    (k = {}, _ = null) => ({
      ...k,
      ...a,
      ref: _,
      role: "group"
    }),
    [a]
  ), M = se(
    (k = {}, _ = null) => ({
      ...k,
      ref: _,
      role: "presentation",
      "aria-hidden": !0,
      children: k.children || "*"
    }),
    []
  );
  return {
    isRequired: !!n,
    isInvalid: !!r,
    isReadOnly: !!i,
    isDisabled: !!o,
    isFocused: !!y,
    onFocus: () => x(!0),
    onBlur: () => x(!1),
    hasFeedbackText: h,
    setHasFeedbackText: C,
    hasHelpText: v,
    setHasHelpText: b,
    id: c,
    labelId: u,
    feedbackId: f,
    helpTextId: p,
    htmlProps: a,
    getHelpTextProps: T,
    getErrorMessageProps: L,
    getRootProps: I,
    getLabelProps: A,
    getRequiredIndicatorProps: M
  };
}
var zT = Le(
  function(t, n) {
    const r = i2("Form", t), o = fr(t), {
      getRootProps: i,
      htmlProps: a,
      ...l
    } = KJ(o), c = v1("chakra-form-control", t.className);
    return /* @__PURE__ */ g(qJ, { value: l, children: /* @__PURE__ */ g(JJ, { value: r, children: /* @__PURE__ */ g(
      je.div,
      {
        ...i({}, n),
        className: c,
        __css: r.container
      }
    ) }) });
  }
);
zT.displayName = "FormControl";
var GT = Le(
  function(t, n) {
    const r = ZT(), o = QJ(), i = v1("chakra-form__helper-text", t.className);
    return /* @__PURE__ */ g(
      je.div,
      {
        ...r?.getHelpTextProps(t, n),
        __css: o.helperText,
        className: i
      }
    );
  }
);
GT.displayName = "FormHelperText";
function eQ(e) {
  const { isDisabled: t, isInvalid: n, isReadOnly: r, isRequired: o, ...i } = tQ(e);
  return {
    ...i,
    disabled: t,
    readOnly: r,
    required: o,
    "aria-invalid": s8(n),
    "aria-required": s8(o),
    "aria-readonly": s8(r)
  };
}
function tQ(e) {
  var t, n, r;
  const o = ZT(), {
    id: i,
    disabled: a,
    readOnly: l,
    required: c,
    isRequired: u,
    isInvalid: f,
    isReadOnly: p,
    isDisabled: h,
    onFocus: C,
    onBlur: v,
    ...b
  } = e, y = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return o?.hasFeedbackText && o?.isInvalid && y.push(o.feedbackId), o?.hasHelpText && y.push(o.helpTextId), {
    ...b,
    "aria-describedby": y.join(" ") || void 0,
    id: i ?? o?.id,
    isDisabled: (t = a ?? h) != null ? t : o?.isDisabled,
    isReadOnly: (n = l ?? p) != null ? n : o?.isReadOnly,
    isRequired: (r = c ?? u) != null ? r : o?.isRequired,
    isInvalid: f ?? o?.isInvalid,
    onFocus: it(o?.onFocus, C),
    onBlur: it(o?.onBlur, v)
  };
}
function us(e, t, n, r) {
  const o = qi(n);
  return Oe(() => {
    const i = typeof e == "function" ? e() : e ?? document;
    if (!(!n || !i))
      return i.addEventListener(t, o, r), () => {
        i.removeEventListener(t, o, r);
      };
  }, [t, e, r, o, n]), () => {
    const i = typeof e == "function" ? e() : e ?? document;
    i?.removeEventListener(t, o, r);
  };
}
function nQ(e) {
  return "current" in e;
}
var WT = () => typeof window < "u";
function rQ() {
  var e;
  const t = navigator.userAgentData;
  return (e = t?.platform) != null ? e : navigator.platform;
}
var oQ = (e) => WT() && e.test(navigator.vendor), iQ = (e) => WT() && e.test(rQ()), aQ = () => iQ(/mac|iphone|ipad|ipod/i), sQ = () => aQ() && oQ(/apple/i);
function lQ(e) {
  const { ref: t, elements: n, enabled: r } = e, o = () => {
    var i, a;
    return (a = (i = t.current) == null ? void 0 : i.ownerDocument) != null ? a : document;
  };
  us(o, "pointerdown", (i) => {
    if (!sQ() || !r)
      return;
    const a = i.target, c = (n ?? [t]).some((u) => {
      const f = nQ(u) ? u.current : u;
      return f?.contains(a) || f === a;
    });
    o().activeElement !== a && c && (i.preventDefault(), a.focus());
  });
}
function $T(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
function He() {
  return He = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, He.apply(null, arguments);
}
var J4 = { exports: {} }, Q4 = { exports: {} }, Q1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vb;
function cQ() {
  if (Vb) return Q1;
  Vb = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
  function A(I) {
    if (typeof I == "object" && I !== null) {
      var M = I.$$typeof;
      switch (M) {
        case t:
          switch (I = I.type, I) {
            case c:
            case u:
            case r:
            case i:
            case o:
            case p:
              return I;
            default:
              switch (I = I && I.$$typeof, I) {
                case l:
                case f:
                case v:
                case C:
                case a:
                  return I;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function L(I) {
    return A(I) === u;
  }
  return Q1.AsyncMode = c, Q1.ConcurrentMode = u, Q1.ContextConsumer = l, Q1.ContextProvider = a, Q1.Element = t, Q1.ForwardRef = f, Q1.Fragment = r, Q1.Lazy = v, Q1.Memo = C, Q1.Portal = n, Q1.Profiler = i, Q1.StrictMode = o, Q1.Suspense = p, Q1.isAsyncMode = function(I) {
    return L(I) || A(I) === c;
  }, Q1.isConcurrentMode = L, Q1.isContextConsumer = function(I) {
    return A(I) === l;
  }, Q1.isContextProvider = function(I) {
    return A(I) === a;
  }, Q1.isElement = function(I) {
    return typeof I == "object" && I !== null && I.$$typeof === t;
  }, Q1.isForwardRef = function(I) {
    return A(I) === f;
  }, Q1.isFragment = function(I) {
    return A(I) === r;
  }, Q1.isLazy = function(I) {
    return A(I) === v;
  }, Q1.isMemo = function(I) {
    return A(I) === C;
  }, Q1.isPortal = function(I) {
    return A(I) === n;
  }, Q1.isProfiler = function(I) {
    return A(I) === i;
  }, Q1.isStrictMode = function(I) {
    return A(I) === o;
  }, Q1.isSuspense = function(I) {
    return A(I) === p;
  }, Q1.isValidElementType = function(I) {
    return typeof I == "string" || typeof I == "function" || I === r || I === u || I === i || I === o || I === p || I === h || typeof I == "object" && I !== null && (I.$$typeof === v || I.$$typeof === C || I.$$typeof === a || I.$$typeof === l || I.$$typeof === f || I.$$typeof === y || I.$$typeof === x || I.$$typeof === T || I.$$typeof === b);
  }, Q1.typeOf = A, Q1;
}
var q1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hb;
function uQ() {
  return Hb || (Hb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
    function A(ie) {
      return typeof ie == "string" || typeof ie == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ie === r || ie === u || ie === i || ie === o || ie === p || ie === h || typeof ie == "object" && ie !== null && (ie.$$typeof === v || ie.$$typeof === C || ie.$$typeof === a || ie.$$typeof === l || ie.$$typeof === f || ie.$$typeof === y || ie.$$typeof === x || ie.$$typeof === T || ie.$$typeof === b);
    }
    function L(ie) {
      if (typeof ie == "object" && ie !== null) {
        var f1 = ie.$$typeof;
        switch (f1) {
          case t:
            var s1 = ie.type;
            switch (s1) {
              case c:
              case u:
              case r:
              case i:
              case o:
              case p:
                return s1;
              default:
                var Ye = s1 && s1.$$typeof;
                switch (Ye) {
                  case l:
                  case f:
                  case v:
                  case C:
                  case a:
                    return Ye;
                  default:
                    return f1;
                }
            }
          case n:
            return f1;
        }
      }
    }
    var I = c, M = u, k = l, _ = a, F = t, $ = f, oe = r, te = v, ae = C, be = n, K = i, ue = o, J = p, Me = !1;
    function _e(ie) {
      return Me || (Me = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ne(ie) || L(ie) === c;
    }
    function ne(ie) {
      return L(ie) === u;
    }
    function ee(ie) {
      return L(ie) === l;
    }
    function ye(ie) {
      return L(ie) === a;
    }
    function fe(ie) {
      return typeof ie == "object" && ie !== null && ie.$$typeof === t;
    }
    function xe(ie) {
      return L(ie) === f;
    }
    function Te(ie) {
      return L(ie) === r;
    }
    function Ie(ie) {
      return L(ie) === v;
    }
    function Q(ie) {
      return L(ie) === C;
    }
    function pe(ie) {
      return L(ie) === n;
    }
    function me(ie) {
      return L(ie) === i;
    }
    function Be(ie) {
      return L(ie) === o;
    }
    function We(ie) {
      return L(ie) === p;
    }
    q1.AsyncMode = I, q1.ConcurrentMode = M, q1.ContextConsumer = k, q1.ContextProvider = _, q1.Element = F, q1.ForwardRef = $, q1.Fragment = oe, q1.Lazy = te, q1.Memo = ae, q1.Portal = be, q1.Profiler = K, q1.StrictMode = ue, q1.Suspense = J, q1.isAsyncMode = _e, q1.isConcurrentMode = ne, q1.isContextConsumer = ee, q1.isContextProvider = ye, q1.isElement = fe, q1.isForwardRef = xe, q1.isFragment = Te, q1.isLazy = Ie, q1.isMemo = Q, q1.isPortal = pe, q1.isProfiler = me, q1.isStrictMode = Be, q1.isSuspense = We, q1.isValidElementType = A, q1.typeOf = L;
  }()), q1;
}
var Ob;
function Vf() {
  return Ob || (Ob = 1, process.env.NODE_ENV === "production" ? Q4.exports = cQ() : Q4.exports = uQ()), Q4.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var D8, Nb;
function dQ() {
  if (Nb) return D8;
  Nb = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, l = 0; l < 10; l++)
        a["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(a).map(function(f) {
        return a[f];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        u[f] = f;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return D8 = o() ? Object.assign : function(i, a) {
    for (var l, c = r(i), u, f = 1; f < arguments.length; f++) {
      l = Object(arguments[f]);
      for (var p in l)
        t.call(l, p) && (c[p] = l[p]);
      if (e) {
        u = e(l);
        for (var h = 0; h < u.length; h++)
          n.call(l, u[h]) && (c[u[h]] = l[u[h]]);
      }
    }
    return c;
  }, D8;
}
var Z8, Db;
function Hf() {
  if (Db) return Z8;
  Db = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Z8 = e, Z8;
}
var z8, Zb;
function UT() {
  return Zb || (Zb = 1, z8 = Function.call.bind(Object.prototype.hasOwnProperty)), z8;
}
var G8, zb;
function fQ() {
  if (zb) return G8;
  zb = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Hf(), n = {}, r = /* @__PURE__ */ UT();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, l, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (r(i, f)) {
          var p;
          try {
            if (typeof i[f] != "function") {
              var h = Error(
                (c || "React class") + ": " + l + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            p = i[f](a, f, c, l, null, t);
          } catch (v) {
            p = v;
          }
          if (p && !(p instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in n)) {
            n[p.message] = !0;
            var C = u ? u() : "";
            e(
              "Failed " + l + " type: " + p.message + (C ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, G8 = o, G8;
}
var W8, Gb;
function pQ() {
  if (Gb) return W8;
  Gb = 1;
  var e = Vf(), t = dQ(), n = /* @__PURE__ */ Hf(), r = /* @__PURE__ */ UT(), o = /* @__PURE__ */ fQ(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return W8 = function(l, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function p(ne) {
      var ee = ne && (u && ne[u] || ne[f]);
      if (typeof ee == "function")
        return ee;
    }
    var h = "<<anonymous>>", C = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: T(),
      arrayOf: A,
      element: L(),
      elementType: I(),
      instanceOf: M,
      node: $(),
      objectOf: _,
      oneOf: k,
      oneOfType: F,
      shape: te,
      exact: ae
    };
    function v(ne, ee) {
      return ne === ee ? ne !== 0 || 1 / ne === 1 / ee : ne !== ne && ee !== ee;
    }
    function b(ne, ee) {
      this.message = ne, this.data = ee && typeof ee == "object" ? ee : {}, this.stack = "";
    }
    b.prototype = Error.prototype;
    function y(ne) {
      if (process.env.NODE_ENV !== "production")
        var ee = {}, ye = 0;
      function fe(Te, Ie, Q, pe, me, Be, We) {
        if (pe = pe || h, Be = Be || Q, We !== n) {
          if (c) {
            var ie = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ie.name = "Invariant Violation", ie;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var f1 = pe + ":" + Q;
            !ee[f1] && // Avoid spamming the console because they are often not actionable except for lib authors
            ye < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Be + "` prop on `" + pe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ee[f1] = !0, ye++);
          }
        }
        return Ie[Q] == null ? Te ? Ie[Q] === null ? new b("The " + me + " `" + Be + "` is marked as required " + ("in `" + pe + "`, but its value is `null`.")) : new b("The " + me + " `" + Be + "` is marked as required in " + ("`" + pe + "`, but its value is `undefined`.")) : null : ne(Ie, Q, pe, me, Be);
      }
      var xe = fe.bind(null, !1);
      return xe.isRequired = fe.bind(null, !0), xe;
    }
    function x(ne) {
      function ee(ye, fe, xe, Te, Ie, Q) {
        var pe = ye[fe], me = ue(pe);
        if (me !== ne) {
          var Be = J(pe);
          return new b(
            "Invalid " + Te + " `" + Ie + "` of type " + ("`" + Be + "` supplied to `" + xe + "`, expected ") + ("`" + ne + "`."),
            { expectedType: ne }
          );
        }
        return null;
      }
      return y(ee);
    }
    function T() {
      return y(a);
    }
    function A(ne) {
      function ee(ye, fe, xe, Te, Ie) {
        if (typeof ne != "function")
          return new b("Property `" + Ie + "` of component `" + xe + "` has invalid PropType notation inside arrayOf.");
        var Q = ye[fe];
        if (!Array.isArray(Q)) {
          var pe = ue(Q);
          return new b("Invalid " + Te + " `" + Ie + "` of type " + ("`" + pe + "` supplied to `" + xe + "`, expected an array."));
        }
        for (var me = 0; me < Q.length; me++) {
          var Be = ne(Q, me, xe, Te, Ie + "[" + me + "]", n);
          if (Be instanceof Error)
            return Be;
        }
        return null;
      }
      return y(ee);
    }
    function L() {
      function ne(ee, ye, fe, xe, Te) {
        var Ie = ee[ye];
        if (!l(Ie)) {
          var Q = ue(Ie);
          return new b("Invalid " + xe + " `" + Te + "` of type " + ("`" + Q + "` supplied to `" + fe + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(ne);
    }
    function I() {
      function ne(ee, ye, fe, xe, Te) {
        var Ie = ee[ye];
        if (!e.isValidElementType(Ie)) {
          var Q = ue(Ie);
          return new b("Invalid " + xe + " `" + Te + "` of type " + ("`" + Q + "` supplied to `" + fe + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(ne);
    }
    function M(ne) {
      function ee(ye, fe, xe, Te, Ie) {
        if (!(ye[fe] instanceof ne)) {
          var Q = ne.name || h, pe = _e(ye[fe]);
          return new b("Invalid " + Te + " `" + Ie + "` of type " + ("`" + pe + "` supplied to `" + xe + "`, expected ") + ("instance of `" + Q + "`."));
        }
        return null;
      }
      return y(ee);
    }
    function k(ne) {
      if (!Array.isArray(ne))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function ee(ye, fe, xe, Te, Ie) {
        for (var Q = ye[fe], pe = 0; pe < ne.length; pe++)
          if (v(Q, ne[pe]))
            return null;
        var me = JSON.stringify(ne, function(We, ie) {
          var f1 = J(ie);
          return f1 === "symbol" ? String(ie) : ie;
        });
        return new b("Invalid " + Te + " `" + Ie + "` of value `" + String(Q) + "` " + ("supplied to `" + xe + "`, expected one of " + me + "."));
      }
      return y(ee);
    }
    function _(ne) {
      function ee(ye, fe, xe, Te, Ie) {
        if (typeof ne != "function")
          return new b("Property `" + Ie + "` of component `" + xe + "` has invalid PropType notation inside objectOf.");
        var Q = ye[fe], pe = ue(Q);
        if (pe !== "object")
          return new b("Invalid " + Te + " `" + Ie + "` of type " + ("`" + pe + "` supplied to `" + xe + "`, expected an object."));
        for (var me in Q)
          if (r(Q, me)) {
            var Be = ne(Q, me, xe, Te, Ie + "." + me, n);
            if (Be instanceof Error)
              return Be;
          }
        return null;
      }
      return y(ee);
    }
    function F(ne) {
      if (!Array.isArray(ne))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var ee = 0; ee < ne.length; ee++) {
        var ye = ne[ee];
        if (typeof ye != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Me(ye) + " at index " + ee + "."
          ), a;
      }
      function fe(xe, Te, Ie, Q, pe) {
        for (var me = [], Be = 0; Be < ne.length; Be++) {
          var We = ne[Be], ie = We(xe, Te, Ie, Q, pe, n);
          if (ie == null)
            return null;
          ie.data && r(ie.data, "expectedType") && me.push(ie.data.expectedType);
        }
        var f1 = me.length > 0 ? ", expected one of type [" + me.join(", ") + "]" : "";
        return new b("Invalid " + Q + " `" + pe + "` supplied to " + ("`" + Ie + "`" + f1 + "."));
      }
      return y(fe);
    }
    function $() {
      function ne(ee, ye, fe, xe, Te) {
        return be(ee[ye]) ? null : new b("Invalid " + xe + " `" + Te + "` supplied to " + ("`" + fe + "`, expected a ReactNode."));
      }
      return y(ne);
    }
    function oe(ne, ee, ye, fe, xe) {
      return new b(
        (ne || "React class") + ": " + ee + " type `" + ye + "." + fe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + xe + "`."
      );
    }
    function te(ne) {
      function ee(ye, fe, xe, Te, Ie) {
        var Q = ye[fe], pe = ue(Q);
        if (pe !== "object")
          return new b("Invalid " + Te + " `" + Ie + "` of type `" + pe + "` " + ("supplied to `" + xe + "`, expected `object`."));
        for (var me in ne) {
          var Be = ne[me];
          if (typeof Be != "function")
            return oe(xe, Te, Ie, me, J(Be));
          var We = Be(Q, me, xe, Te, Ie + "." + me, n);
          if (We)
            return We;
        }
        return null;
      }
      return y(ee);
    }
    function ae(ne) {
      function ee(ye, fe, xe, Te, Ie) {
        var Q = ye[fe], pe = ue(Q);
        if (pe !== "object")
          return new b("Invalid " + Te + " `" + Ie + "` of type `" + pe + "` " + ("supplied to `" + xe + "`, expected `object`."));
        var me = t({}, ye[fe], ne);
        for (var Be in me) {
          var We = ne[Be];
          if (r(ne, Be) && typeof We != "function")
            return oe(xe, Te, Ie, Be, J(We));
          if (!We)
            return new b(
              "Invalid " + Te + " `" + Ie + "` key `" + Be + "` supplied to `" + xe + "`.\nBad object: " + JSON.stringify(ye[fe], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(ne), null, "  ")
            );
          var ie = We(Q, Be, xe, Te, Ie + "." + Be, n);
          if (ie)
            return ie;
        }
        return null;
      }
      return y(ee);
    }
    function be(ne) {
      switch (typeof ne) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !ne;
        case "object":
          if (Array.isArray(ne))
            return ne.every(be);
          if (ne === null || l(ne))
            return !0;
          var ee = p(ne);
          if (ee) {
            var ye = ee.call(ne), fe;
            if (ee !== ne.entries) {
              for (; !(fe = ye.next()).done; )
                if (!be(fe.value))
                  return !1;
            } else
              for (; !(fe = ye.next()).done; ) {
                var xe = fe.value;
                if (xe && !be(xe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function K(ne, ee) {
      return ne === "symbol" ? !0 : ee ? ee["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ee instanceof Symbol : !1;
    }
    function ue(ne) {
      var ee = typeof ne;
      return Array.isArray(ne) ? "array" : ne instanceof RegExp ? "object" : K(ee, ne) ? "symbol" : ee;
    }
    function J(ne) {
      if (typeof ne > "u" || ne === null)
        return "" + ne;
      var ee = ue(ne);
      if (ee === "object") {
        if (ne instanceof Date)
          return "date";
        if (ne instanceof RegExp)
          return "regexp";
      }
      return ee;
    }
    function Me(ne) {
      var ee = J(ne);
      switch (ee) {
        case "array":
        case "object":
          return "an " + ee;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ee;
        default:
          return ee;
      }
    }
    function _e(ne) {
      return !ne.constructor || !ne.constructor.name ? h : ne.constructor.name;
    }
    return C.checkPropTypes = o, C.resetWarningCache = o.resetWarningCache, C.PropTypes = C, C;
  }, W8;
}
var $8, Wb;
function hQ() {
  if (Wb) return $8;
  Wb = 1;
  var e = /* @__PURE__ */ Hf();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, $8 = function() {
    function r(a, l, c, u, f, p) {
      if (p !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, $8;
}
var $b;
function mQ() {
  if ($b) return J4.exports;
  if ($b = 1, process.env.NODE_ENV !== "production") {
    var e = Vf(), t = !0;
    J4.exports = /* @__PURE__ */ pQ()(e.isElement, t);
  } else
    J4.exports = /* @__PURE__ */ hQ()();
  return J4.exports;
}
var pt = /* @__PURE__ */ mQ();
const jT = /* @__PURE__ */ k9(pt);
var Au = "data-focus-lock", XT = "data-focus-lock-disabled", CQ = "data-no-focus-lock", gQ = "data-autofocus-inside", bQ = "data-no-autofocus";
function U8(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function vQ(e, t) {
  var n = ze(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var yQ = typeof window < "u" ? Se.useLayoutEffect : Se.useEffect, Ub = /* @__PURE__ */ new WeakMap();
function YT(e, t) {
  var n = vQ(null, function(r) {
    return e.forEach(function(o) {
      return U8(o, r);
    });
  });
  return yQ(function() {
    var r = Ub.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), a = n.current;
      o.forEach(function(l) {
        i.has(l) || U8(l, null);
      }), i.forEach(function(l) {
        o.has(l) || U8(l, a);
      });
    }
    Ub.set(n, e);
  }, [e]), n;
}
var j8 = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && jT.node;
var xo = function() {
  return xo = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, xo.apply(this, arguments);
};
function JT(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function xQ(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function QT(e) {
  return e;
}
function qT(e, t) {
  t === void 0 && (t = QT);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(l) {
          return l !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(l) {
          return i(l);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var l = n;
        n = [], l.forEach(i), a = n;
      }
      var c = function() {
        var f = a;
        a = [], f.forEach(i);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), n = {
        push: function(f) {
          a.push(f), u();
        },
        filter: function(f) {
          return a = a.filter(f), n;
        }
      };
    }
  };
  return o;
}
function Of(e, t) {
  return t === void 0 && (t = QT), qT(e, t);
}
function KT(e) {
  e === void 0 && (e = {});
  var t = qT(null);
  return t.options = xo({ async: !0, ssr: !1 }, e), t;
}
var eA = function(e) {
  var t = e.sideCar, n = JT(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return Se.createElement(r, xo({}, n));
};
eA.isSideCarExport = !0;
function wQ(e, t) {
  return e.useMedium(t), eA;
}
var tA = Of({}, function(e) {
  var t = e.target, n = e.currentTarget;
  return {
    target: t,
    currentTarget: n
  };
}), nA = Of(), SQ = Of(), TQ = KT({
  async: !0,
  ssr: typeof document < "u"
}), AQ = /* @__PURE__ */ pn(void 0), IQ = [], Nf = /* @__PURE__ */ ro(function(t, n) {
  var r, o = ze(), i = o[0], a = o[1], l = Re(), c = Re(!1), u = Re(null), f = ze({}), p = f[1], h = t.children, C = t.disabled, v = C === void 0 ? !1 : C, b = t.noFocusGuards, y = b === void 0 ? !1 : b, x = t.persistentFocus, T = x === void 0 ? !1 : x, A = t.crossFrame, L = A === void 0 ? !0 : A, I = t.autoFocus, M = I === void 0 ? !0 : I, k = t.allowTextSelection, _ = t.group, F = t.className, $ = t.whiteList, oe = t.hasPositiveIndices, te = t.shards, ae = te === void 0 ? IQ : te, be = t.as, K = be === void 0 ? "div" : be, ue = t.lockProps, J = ue === void 0 ? {} : ue, Me = t.sideCar, _e = t.returnFocus, ne = _e === void 0 ? !1 : _e, ee = t.focusOptions, ye = t.onActivation, fe = t.onDeactivation, xe = ze({}), Te = xe[0], Ie = se(function(Pe) {
    var j1 = Pe.captureFocusRestore;
    if (!u.current) {
      var X1, p1 = (X1 = document) == null ? void 0 : X1.activeElement;
      u.current = p1, p1 !== document.body && (u.current = j1(p1));
    }
    l.current && ye && ye(l.current), c.current = !0, p();
  }, [ye]), Q = se(function() {
    c.current = !1, fe && fe(l.current), p();
  }, [fe]), pe = se(function(Pe) {
    var j1 = u.current;
    if (j1) {
      var X1 = (typeof j1 == "function" ? j1() : j1) || document.body, p1 = typeof ne == "function" ? ne(X1) : ne;
      if (p1) {
        var L1 = typeof p1 == "object" ? p1 : void 0;
        u.current = null, Pe ? Promise.resolve().then(function() {
          return X1.focus(L1);
        }) : X1.focus(L1);
      }
    }
  }, [ne]), me = se(function(Pe) {
    c.current && tA.useMedium(Pe);
  }, []), Be = nA.useMedium, We = se(function(Pe) {
    l.current !== Pe && (l.current = Pe, a(Pe));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof k < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), Oe(function() {
    !l.current && typeof K != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var ie = He((r = {}, r[XT] = v && "disabled", r[Au] = _, r), J), f1 = y !== !0, s1 = f1 && y !== "tail", Ye = YT([n, We]), B1 = we(function() {
    return {
      observed: l,
      shards: ae,
      enabled: !v,
      active: c.current
    };
  }, [v, c.current, ae, i]);
  return /* @__PURE__ */ w.createElement(m0, null, f1 && [
    /* @__PURE__ */ w.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: v ? -1 : 0,
      style: j8
    }),
    oe ? /* @__PURE__ */ w.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: v ? -1 : 1,
      style: j8
    }) : null
  ], !v && /* @__PURE__ */ w.createElement(Me, {
    id: Te,
    sideCar: TQ,
    observed: i,
    disabled: v,
    persistentFocus: T,
    crossFrame: L,
    autoFocus: M,
    whiteList: $,
    shards: ae,
    onActivation: Ie,
    onDeactivation: Q,
    returnFocus: pe,
    focusOptions: ee,
    noFocusGuards: y
  }), /* @__PURE__ */ w.createElement(K, He({
    ref: Ye
  }, ie, {
    className: F,
    onBlur: Be,
    onFocus: me
  }), /* @__PURE__ */ w.createElement(AQ.Provider, {
    value: B1
  }, h)), s1 && /* @__PURE__ */ w.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: v ? -1 : 0,
    style: j8
  }));
});
Nf.propTypes = process.env.NODE_ENV !== "production" ? {
  children: pt.node,
  disabled: pt.bool,
  returnFocus: pt.oneOfType([pt.bool, pt.object, pt.func]),
  focusOptions: pt.object,
  noFocusGuards: pt.bool,
  hasPositiveIndices: pt.bool,
  allowTextSelection: pt.bool,
  autoFocus: pt.bool,
  persistentFocus: pt.bool,
  crossFrame: pt.bool,
  group: pt.string,
  className: pt.string,
  whiteList: pt.func,
  shards: pt.arrayOf(pt.any),
  as: pt.oneOfType([pt.string, pt.func, pt.object]),
  lockProps: pt.object,
  onActivation: pt.func,
  onDeactivation: pt.func,
  sideCar: pt.any.isRequired
} : {};
function ws(e, t) {
  return ws = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, ws(e, t);
}
function rA(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ws(e, t);
}
function Ja(e) {
  "@babel/helpers - typeof";
  return Ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ja(e);
}
function LQ(e, t) {
  if (Ja(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ja(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function oA(e) {
  var t = LQ(e, "string");
  return Ja(t) == "symbol" ? t : t + "";
}
function os(e, t, n) {
  return (t = oA(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function EQ(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof t != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function n(r) {
    return r.displayName || r.name || "Component";
  }
  return function(o) {
    if (process.env.NODE_ENV !== "production" && typeof o != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var i = [], a;
    function l() {
      a = e(i.map(function(u) {
        return u.props;
      })), t(a);
    }
    var c = /* @__PURE__ */ function(u) {
      rA(f, u);
      function f() {
        return u.apply(this, arguments) || this;
      }
      f.peek = function() {
        return a;
      };
      var p = f.prototype;
      return p.componentDidMount = function() {
        i.push(this), l();
      }, p.componentDidUpdate = function() {
        l();
      }, p.componentWillUnmount = function() {
        var C = i.indexOf(this);
        i.splice(C, 1), l();
      }, p.render = function() {
        return /* @__PURE__ */ w.createElement(o, this.props);
      }, f;
    }(oH);
    return os(c, "displayName", "SideEffect(" + n(o) + ")"), c;
  };
}
var Vo = function(e) {
  for (var t = Array(e.length), n = 0; n < e.length; ++n)
    t[n] = e[n];
  return t;
}, Qa = function(e) {
  return Array.isArray(e) ? e : [e];
}, iA = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, MQ = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var t = window.getComputedStyle(e, null);
  return !t || !t.getPropertyValue ? !1 : t.getPropertyValue("display") === "none" || t.getPropertyValue("visibility") === "hidden";
}, aA = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, sA = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, BQ = function(e) {
  return e.hasAttribute("inert");
}, kQ = function(e, t) {
  return !e || sA(e) || !MQ(e) && !BQ(e) && t(aA(e));
}, lA = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = kQ(t, lA.bind(void 0, e));
  return e.set(t, r), r;
}, RQ = function(e, t) {
  return e && !sA(e) ? PQ(e) ? t(aA(e)) : !1 : !0;
}, cA = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = RQ(t, cA.bind(void 0, e));
  return e.set(t, r), r;
}, uA = function(e) {
  return e.dataset;
}, _Q = function(e) {
  return e.tagName === "BUTTON";
}, dA = function(e) {
  return e.tagName === "INPUT";
}, fA = function(e) {
  return dA(e) && e.type === "radio";
}, FQ = function(e) {
  return !((dA(e) || _Q(e)) && (e.type === "hidden" || e.disabled));
}, PQ = function(e) {
  var t = e.getAttribute(bQ);
  return ![!0, "true", ""].includes(t);
}, Df = function(e) {
  var t;
  return !!(e && (!((t = uA(e)) === null || t === void 0) && t.focusGuard));
}, Iu = function(e) {
  return !Df(e);
}, VQ = function(e) {
  return !!e;
}, HQ = function(e, t) {
  var n = Math.max(0, e.tabIndex), r = Math.max(0, t.tabIndex), o = n - r, i = e.index - t.index;
  if (o) {
    if (!n)
      return 1;
    if (!r)
      return -1;
  }
  return o || i;
}, OQ = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, Zf = function(e, t, n) {
  return Vo(e).map(function(r, o) {
    var i = OQ(r);
    return {
      node: r,
      index: o,
      tabIndex: n && i === -1 ? (r.dataset || {}).focusGuard ? 0 : -1 : i
    };
  }).filter(function(r) {
    return !t || r.tabIndex >= 0;
  }).sort(HQ);
}, NQ = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], zf = NQ.join(","), DQ = "".concat(zf, ", [data-focus-guard]"), pA = function(e, t) {
  return Vo((e.shadowRoot || e).children).reduce(function(n, r) {
    return n.concat(r.matches(t ? DQ : zf) ? [r] : [], pA(r));
  }, []);
}, ZQ = function(e, t) {
  var n;
  return e instanceof HTMLIFrameElement && (!((n = e.contentDocument) === null || n === void 0) && n.body) ? Ss([e.contentDocument.body], t) : [e];
}, Ss = function(e, t) {
  return e.reduce(function(n, r) {
    var o, i = pA(r, t), a = (o = []).concat.apply(o, i.map(function(l) {
      return ZQ(l, t);
    }));
    return n.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      a,
      // add if node is tabbable itself
      r.parentNode ? Vo(r.parentNode.querySelectorAll(zf)).filter(function(l) {
        return l === r;
      }) : []
    );
  }, []);
}, zQ = function(e) {
  var t = e.querySelectorAll("[".concat(gQ, "]"));
  return Vo(t).map(function(n) {
    return Ss([n]);
  }).reduce(function(n, r) {
    return n.concat(r);
  }, []);
}, Gf = function(e, t) {
  return Vo(e).filter(function(n) {
    return lA(t, n);
  }).filter(function(n) {
    return FQ(n);
  });
}, jb = function(e, t) {
  return t === void 0 && (t = /* @__PURE__ */ new Map()), Vo(e).filter(function(n) {
    return cA(t, n);
  });
}, Wf = function(e, t, n) {
  return Zf(Gf(Ss(e, n), t), !0, n);
}, A0 = function(e, t) {
  return Zf(Gf(Ss(e), t), !1);
}, GQ = function(e, t) {
  return Gf(zQ(e), t);
}, Wa = function(e, t) {
  return e.shadowRoot ? Wa(e.shadowRoot, t) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, t) ? !0 : Vo(e.children).some(function(n) {
    var r;
    if (n instanceof HTMLIFrameElement) {
      var o = (r = n.contentDocument) === null || r === void 0 ? void 0 : r.body;
      return o ? Wa(o, t) : !1;
    }
    return Wa(n, t);
  });
}, WQ = function(e) {
  for (var t = /* @__PURE__ */ new Set(), n = e.length, r = 0; r < n; r += 1)
    for (var o = r + 1; o < n; o += 1) {
      var i = e[r].compareDocumentPosition(e[o]);
      (i & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && t.add(o), (i & Node.DOCUMENT_POSITION_CONTAINS) > 0 && t.add(r);
    }
  return e.filter(function(a, l) {
    return !t.has(l);
  });
}, hA = function(e) {
  return e.parentNode ? hA(e.parentNode) : e;
}, $f = function(e) {
  var t = Qa(e);
  return t.filter(Boolean).reduce(function(n, r) {
    var o = r.getAttribute(Au);
    return n.push.apply(n, o ? WQ(Vo(hA(r).querySelectorAll("[".concat(Au, '="').concat(o, '"]:not([').concat(XT, '="disabled"])')))) : [r]), n;
  }, []);
}, $Q = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, I0 = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var t = e.activeElement;
    return t.shadowRoot ? I0(t.shadowRoot) : t instanceof HTMLIFrameElement && $Q(function() {
      return t.contentWindow.document;
    }) ? I0(t.contentWindow.document) : t;
  }
}, UQ = function(e, t) {
  return e === t;
}, jQ = function(e, t) {
  return !!Vo(e.querySelectorAll("iframe")).some(function(n) {
    return UQ(n, t);
  });
}, mA = function(e, t) {
  return t === void 0 && (t = I0(iA(e).ownerDocument)), !t || t.dataset && t.dataset.focusGuard ? !1 : $f(e).some(function(n) {
    return Wa(n, t) || jQ(n, t);
  });
}, XQ = function(e) {
  e === void 0 && (e = document);
  var t = I0(e);
  return t ? Vo(e.querySelectorAll("[".concat(CQ, "]"))).some(function(n) {
    return Wa(n, t);
  }) : !1;
}, YQ = function(e, t) {
  return t.filter(fA).filter(function(n) {
    return n.name === e.name;
  }).filter(function(n) {
    return n.checked;
  })[0] || e;
}, Uf = function(e, t) {
  return fA(e) && e.name ? YQ(e, t) : e;
}, JQ = function(e) {
  var t = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    return t.add(Uf(n, e));
  }), e.filter(function(n) {
    return t.has(n);
  });
}, Xb = function(e) {
  return e[0] && e.length > 1 ? Uf(e[0], e) : e[0];
}, Yb = function(e, t) {
  return e.indexOf(Uf(t, e));
}, Lu = "NEW_FOCUS", QQ = function(e, t, n, r, o) {
  var i = e.length, a = e[0], l = e[i - 1], c = Df(r);
  if (!(r && e.indexOf(r) >= 0)) {
    var u = r !== void 0 ? n.indexOf(r) : -1, f = o ? n.indexOf(o) : u, p = o ? e.indexOf(o) : -1;
    if (u === -1)
      return p !== -1 ? p : Lu;
    if (p === -1)
      return Lu;
    var h = u - f, C = n.indexOf(a), v = n.indexOf(l), b = JQ(n), y = r !== void 0 ? b.indexOf(r) : -1, x = o ? b.indexOf(o) : y, T = b.filter(function(_) {
      return _.tabIndex >= 0;
    }), A = r !== void 0 ? T.indexOf(r) : -1, L = o ? T.indexOf(o) : A, I = A >= 0 && L >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      L - A
    ) : (
      // or else measure in focusable space
      x - y
    );
    if (!h && p >= 0 || t.length === 0)
      return p;
    var M = Yb(e, t[0]), k = Yb(e, t[t.length - 1]);
    if (u <= C && c && Math.abs(h) > 1)
      return k;
    if (u >= v && c && Math.abs(h) > 1)
      return M;
    if (h && Math.abs(I) > 1)
      return p;
    if (u <= C)
      return k;
    if (u > v)
      return M;
    if (h)
      return Math.abs(h) > 1 ? p : (i + p + h) % i;
  }
}, qQ = function(e) {
  return function(t) {
    var n, r = (n = uA(t)) === null || n === void 0 ? void 0 : n.autofocus;
    return (
      // @ts-expect-error
      t.autofocus || //
      r !== void 0 && r !== "false" || //
      e.indexOf(t) >= 0
    );
  };
}, Jb = function(e, t, n) {
  var r = e.map(function(i) {
    var a = i.node;
    return a;
  }), o = jb(r.filter(qQ(n)));
  return o && o.length ? Xb(o) : Xb(jb(t));
}, Eu = function(e, t) {
  return t === void 0 && (t = []), t.push(e), e.parentNode && Eu(e.parentNode.host || e.parentNode, t), t;
}, X8 = function(e, t) {
  for (var n = Eu(e), r = Eu(t), o = 0; o < n.length; o += 1) {
    var i = n[o];
    if (r.indexOf(i) >= 0)
      return i;
  }
  return !1;
}, CA = function(e, t, n) {
  var r = Qa(e), o = Qa(t), i = r[0], a = !1;
  return o.filter(Boolean).forEach(function(l) {
    a = X8(a || l, l) || a, n.filter(Boolean).forEach(function(c) {
      var u = X8(i, c);
      u && (!a || Wa(u, a) ? a = u : a = X8(u, a));
    });
  }), a;
}, Qb = function(e, t) {
  return e.reduce(function(n, r) {
    return n.concat(GQ(r, t));
  }, []);
}, KQ = function(e, t) {
  var n = /* @__PURE__ */ new Map();
  return t.forEach(function(r) {
    return n.set(r.node, r);
  }), e.map(function(r) {
    return n.get(r);
  }).filter(VQ);
}, eq = function(e, t) {
  var n = I0(Qa(e).length > 0 ? document : iA(e).ownerDocument), r = $f(e).filter(Iu), o = CA(n || e, e, r), i = /* @__PURE__ */ new Map(), a = A0(r, i), l = a.filter(function(v) {
    var b = v.node;
    return Iu(b);
  });
  if (l[0]) {
    var c = A0([o], i).map(function(v) {
      var b = v.node;
      return b;
    }), u = KQ(c, l), f = u.map(function(v) {
      var b = v.node;
      return b;
    }), p = u.filter(function(v) {
      var b = v.tabIndex;
      return b >= 0;
    }).map(function(v) {
      var b = v.node;
      return b;
    }), h = QQ(f, p, c, n, t);
    if (h === Lu) {
      var C = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        Jb(a, p, Qb(r, i)) || Jb(a, f, Qb(r, i))
      );
      if (C)
        return { node: C };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return h === void 0 ? h : u[h];
  }
}, tq = function(e) {
  var t = $f(e).filter(Iu), n = CA(e, e, t), r = Zf(Ss([n], !0), !0, !0), o = Ss(t, !1);
  return r.map(function(i) {
    var a = i.node, l = i.index;
    return {
      node: a,
      index: l,
      lockItem: o.indexOf(a) >= 0,
      guard: Df(a)
    };
  });
}, jf = function(e, t) {
  e && ("focus" in e && e.focus(t), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, Y8 = 0, J8 = !1, gA = function(e, t, n) {
  n === void 0 && (n = {});
  var r = eq(e, t);
  if (!J8 && r) {
    if (Y8 > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), J8 = !0, setTimeout(function() {
        J8 = !1;
      }, 1);
      return;
    }
    Y8++, jf(r.node, n.focusOptions), Y8--;
  }
};
function k5(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var t = e ? new WeakRef(e) : null;
  return function() {
    return t?.deref() || null;
  };
}
var nq = function(e) {
  if (!e)
    return null;
  for (var t = [], n = e; n && n !== document.body; )
    t.push({
      current: k5(n),
      parent: k5(n.parentElement),
      left: k5(n.previousElementSibling),
      right: k5(n.nextElementSibling)
    }), n = n.parentElement;
  return {
    element: k5(e),
    stack: t,
    ownerDocument: e.ownerDocument
  };
}, rq = function(e) {
  var t, n, r, o, i;
  if (e)
    for (var a = e.stack, l = e.ownerDocument, c = /* @__PURE__ */ new Map(), u = 0, f = a; u < f.length; u++) {
      var p = f[u], h = (t = p.parent) === null || t === void 0 ? void 0 : t.call(p);
      if (h && l.contains(h)) {
        for (var C = (n = p.left) === null || n === void 0 ? void 0 : n.call(p), v = p.current(), b = h.contains(v) ? v : void 0, y = (r = p.right) === null || r === void 0 ? void 0 : r.call(p), x = Wf([h], c), T = (
          // that is element itself
          (i = (o = b ?? C?.nextElementSibling) !== null && o !== void 0 ? o : (
            // or somebody to the right, still close enough
            y
          )) !== null && i !== void 0 ? i : (
            // or somebody to the left, something?
            C
          )
        ); T; ) {
          for (var A = 0, L = x; A < L.length; A++) {
            var I = L[A];
            if (T?.contains(I.node))
              return I.node;
          }
          T = T.nextElementSibling;
        }
        if (x.length)
          return x[0].node;
      }
    }
}, bA = function(e) {
  var t = nq(e);
  return function() {
    return rq(t);
  };
}, oq = function(e, t, n) {
  if (!e || !t)
    return console.error("no element or scope given"), {};
  var r = Qa(t);
  if (r.every(function(a) {
    return !Wa(a, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var o = n ? Wf(r, /* @__PURE__ */ new Map()) : A0(r, /* @__PURE__ */ new Map()), i = o.findIndex(function(a) {
    var l = a.node;
    return l === e;
  });
  if (i !== -1)
    return {
      prev: o[i - 1],
      next: o[i + 1],
      first: o[0],
      last: o[o.length - 1]
    };
}, iq = function(e, t) {
  var n = t ? Wf(Qa(e), /* @__PURE__ */ new Map()) : A0(Qa(e), /* @__PURE__ */ new Map());
  return {
    first: n[0],
    last: n[n.length - 1]
  };
}, aq = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, vA = function(e, t, n) {
  t === void 0 && (t = {});
  var r = aq(t), o = oq(e, r.scope, r.onlyTabbable);
  if (o) {
    var i = n(o, r.cycle);
    i && jf(i.node, r.focusOptions);
  }
}, sq = function(e, t) {
  t === void 0 && (t = {}), vA(e, t, function(n, r) {
    var o = n.next, i = n.first;
    return o || r && i;
  });
}, lq = function(e, t) {
  t === void 0 && (t = {}), vA(e, t, function(n, r) {
    var o = n.prev, i = n.last;
    return o || r && i;
  });
}, yA = function(e, t, n) {
  var r, o = iq(e, (r = t.onlyTabbable) !== null && r !== void 0 ? r : !0), i = o[n];
  i && jf(i.node, t.focusOptions);
}, cq = function(e, t) {
  t === void 0 && (t = {}), yA(e, t, "first");
}, uq = function(e, t) {
  t === void 0 && (t = {}), yA(e, t, "last");
};
function Xf(e) {
  setTimeout(e, 1);
}
var dq = function(t) {
  return t && "current" in t ? t.current : t;
}, xA = function() {
  return document && document.activeElement === document.body;
}, fq = function() {
  return xA() || XQ();
}, ds = null, zn = null, qb = function() {
  return null;
}, fs = null, L0 = !1, Yf = !1, pq = function() {
  return !0;
}, hq = function(t) {
  return (ds.whiteList || pq)(t);
}, mq = function(t, n) {
  fs = {
    observerNode: t,
    portaledElement: n
  };
}, Cq = function(t) {
  return fs && fs.portaledElement === t;
};
function Kb(e, t, n, r) {
  var o = null, i = e;
  do {
    var a = r[i];
    if (a.guard)
      a.node.dataset.focusAutoGuard && (o = a);
    else if (a.lockItem) {
      if (i !== e)
        return;
      o = null;
    } else
      break;
  } while ((i += n) !== t);
  o && (o.node.tabIndex = 0);
}
var gq = function(t) {
  return t ? !!L0 : L0 === "meanwhile";
}, bq = function e(t, n, r) {
  return n && (n.host === t && (!n.activeElement || r.contains(n.activeElement)) || n.parentNode && e(t, n.parentNode, r));
}, vq = function(t, n) {
  return n.some(function(r) {
    return bq(t, r, r);
  });
}, wA = function(t) {
  return A0(t, /* @__PURE__ */ new Map());
}, yq = function(t) {
  return !wA([t.parentNode]).some(function(n) {
    return n.node === t;
  });
}, s9 = function() {
  var t = !1;
  if (ds) {
    var n = ds, r = n.observed, o = n.persistentFocus, i = n.autoFocus, a = n.shards, l = n.crossFrame, c = n.focusOptions, u = n.noFocusGuards, f = r || fs && fs.portaledElement;
    if (xA() && zn && zn !== document.body && (!document.body.contains(zn) || yq(zn))) {
      var p = qb();
      p && p.focus();
    }
    var h = document && document.activeElement;
    if (f) {
      var C = [f].concat(a.map(dq).filter(Boolean)), v = function() {
        if (!gq(l) || !u || !zn || Yf)
          return !1;
        var A = wA(C), L = A.findIndex(function(I) {
          var M = I.node;
          return M === zn;
        });
        return L === 0 || L === A.length - 1;
      };
      if ((!h || hq(h)) && (o || v() || !fq() || !zn && i) && (f && !(mA(C) || h && vq(h, C) || Cq(h)) && (document && !zn && h && !i ? (h.blur && h.blur(), document.body.focus()) : (t = gA(C, zn, {
        focusOptions: c
      }), fs = {})), zn = document && document.activeElement, zn !== document.body && (qb = bA(zn)), L0 = !1), document && h !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var b = document && document.activeElement, y = tq(C), x = y.map(function(T) {
          var A = T.node;
          return A;
        }).indexOf(b);
        x > -1 && (y.filter(function(T) {
          var A = T.guard, L = T.node;
          return A && L.dataset.focusAutoGuard;
        }).forEach(function(T) {
          var A = T.node;
          return A.removeAttribute("tabIndex");
        }), Kb(x, y.length, 1, y), Kb(x, -1, -1, y));
      }
    }
  }
  return t;
}, SA = function(t) {
  s9() && t && (t.stopPropagation(), t.preventDefault());
}, Jf = function() {
  return Xf(s9);
}, xq = function(t) {
  var n = t.target, r = t.currentTarget;
  r.contains(n) || mq(r, n);
}, wq = function() {
  return null;
};
process.env.NODE_ENV !== "production" && jT.node.isRequired;
var TA = function() {
  Yf = !0;
}, AA = function() {
  Yf = !1, L0 = "just", Xf(function() {
    L0 = "meanwhile";
  });
}, Sq = function() {
  document.addEventListener("focusin", SA), document.addEventListener("focusout", Jf), window.addEventListener("focus", TA), window.addEventListener("blur", AA);
}, Tq = function() {
  document.removeEventListener("focusin", SA), document.removeEventListener("focusout", Jf), window.removeEventListener("focus", TA), window.removeEventListener("blur", AA);
};
function Aq(e) {
  return e.filter(function(t) {
    var n = t.disabled;
    return !n;
  });
}
var IA = {
  moveFocusInside: gA,
  focusInside: mA,
  focusNextElement: sq,
  focusPrevElement: lq,
  focusFirstElement: cq,
  focusLastElement: uq,
  captureFocusRestore: bA
};
function Iq(e) {
  var t = e.slice(-1)[0];
  t && !ds && Sq();
  var n = ds, r = n && t && t.id === n.id;
  ds = t, n && !r && (n.onDeactivation(), e.filter(function(o) {
    var i = o.id;
    return i === n.id;
  }).length || n.returnFocus(!t)), t ? (zn = null, (!r || n.observed !== t.observed) && t.onActivation(IA), s9(), Xf(s9)) : (Tq(), zn = null);
}
tA.assignSyncMedium(xq);
nA.assignMedium(Jf);
SQ.assignMedium(function(e) {
  return e(IA);
});
const Lq = EQ(Aq, Iq)(wq);
var Mu = /* @__PURE__ */ ro(function(t, n) {
  return /* @__PURE__ */ w.createElement(Nf, He({
    sideCar: Lq,
    ref: n
  }, t));
}), LA = Nf.propTypes || {};
LA.sideCar;
var Eq = $T(LA, ["sideCar"]);
Mu.propTypes = process.env.NODE_ENV !== "production" ? Eq : {};
function EA(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function Qf(e) {
  var t;
  if (!EA(e))
    return !1;
  const n = (t = e.ownerDocument.defaultView) != null ? t : window;
  return e instanceof n.HTMLElement;
}
function Mq(e) {
  var t, n;
  return (n = (t = MA(e)) == null ? void 0 : t.defaultView) != null ? n : window;
}
function MA(e) {
  return EA(e) ? e.ownerDocument : document;
}
function Bq(e) {
  return MA(e).activeElement;
}
function kq(e) {
  const t = e.ownerDocument.defaultView || window, { overflow: n, overflowX: r, overflowY: o } = t.getComputedStyle(e);
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function Rq(e) {
  return e.localName === "html" ? e : e.assignedSlot || e.parentElement || e.ownerDocument.documentElement;
}
function BA(e) {
  return ["html", "body", "#document"].includes(e.localName) ? e.ownerDocument.body : Qf(e) && kq(e) ? e : BA(Rq(e));
}
var kA = (e) => e.hasAttribute("tabindex"), _q = (e) => kA(e) && e.tabIndex === -1;
function Fq(e) {
  return !!e.getAttribute("disabled") || !!e.getAttribute("aria-disabled");
}
function RA(e) {
  return e.parentElement && RA(e.parentElement) ? !0 : e.hidden;
}
function Pq(e) {
  const t = e.getAttribute("contenteditable");
  return t !== "false" && t != null;
}
function _A(e) {
  if (!Qf(e) || RA(e) || Fq(e))
    return !1;
  const { localName: t } = e;
  if (["input", "select", "textarea", "button"].indexOf(t) >= 0)
    return !0;
  const r = {
    a: () => e.hasAttribute("href"),
    audio: () => e.hasAttribute("controls"),
    video: () => e.hasAttribute("controls")
  };
  return t in r ? r[t]() : Pq(e) ? !0 : kA(e);
}
function Vq(e) {
  return e ? Qf(e) && _A(e) && !_q(e) : !1;
}
var Hq = [
  "input:not(:disabled):not([disabled])",
  "select:not(:disabled):not([disabled])",
  "textarea:not(:disabled):not([disabled])",
  "embed",
  "iframe",
  "object",
  "a[href]",
  "area[href]",
  "button:not(:disabled):not([disabled])",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "*[tabindex]:not([aria-disabled])",
  "*[contenteditable]"
], Oq = Hq.join(), Nq = (e) => e.offsetWidth > 0 && e.offsetHeight > 0;
function FA(e) {
  const t = Array.from(
    e.querySelectorAll(Oq)
  );
  return t.unshift(e), t.filter((n) => _A(n) && Nq(n));
}
var ev, Dq = (ev = Mu.default) != null ? ev : Mu, PA = (e) => {
  const {
    initialFocusRef: t,
    finalFocusRef: n,
    contentRef: r,
    restoreFocus: o,
    children: i,
    isDisabled: a,
    autoFocus: l,
    persistentFocus: c,
    lockFocusAcrossFrames: u
  } = e, f = se(() => {
    t?.current ? t.current.focus() : r?.current && FA(r.current).length === 0 && requestAnimationFrame(() => {
      var v;
      (v = r.current) == null || v.focus();
    });
  }, [t, r]), p = se(() => {
    var C;
    (C = n?.current) == null || C.focus();
  }, [n]);
  return /* @__PURE__ */ g(
    Dq,
    {
      crossFrame: u,
      persistentFocus: c,
      autoFocus: l,
      disabled: a,
      onActivation: f,
      onDeactivation: p,
      returnFocus: o && !n,
      children: i
    }
  );
};
PA.displayName = "FocusLock";
var Zq = p$ ? z0 : Oe;
function tv(e, t = []) {
  const n = Re(e);
  return Zq(() => {
    n.current = e;
  }), se((...r) => {
    var o;
    return (o = n.current) == null ? void 0 : o.call(n, ...r);
  }, t);
}
function zq(e, t) {
  const n = dr();
  return we(
    () => e || [t, n].filter(Boolean).join("-"),
    [e, t, n]
  );
}
function Gq(e, t) {
  const n = e !== void 0;
  return [n, n && typeof e < "u" ? e : t];
}
function wo(e = {}) {
  const {
    onClose: t,
    onOpen: n,
    isOpen: r,
    id: o
  } = e, i = tv(n), a = tv(t), [l, c] = ze(e.defaultIsOpen || !1), [u, f] = Gq(r, l), p = zq(o, "disclosure"), h = se(() => {
    u || c(!1), a?.();
  }, [u, a]), C = se(() => {
    u || c(!0), i?.();
  }, [u, i]), v = se(() => {
    (f ? h : C)();
  }, [f, C, h]);
  return {
    isOpen: !!f,
    onOpen: C,
    onClose: h,
    onToggle: v,
    isControlled: u,
    getButtonProps: (b = {}) => ({
      ...b,
      "aria-expanded": f,
      "aria-controls": p,
      onClick: b$(b.onClick, v)
    }),
    getDisclosureProps: (b = {}) => ({
      ...b,
      hidden: !f,
      id: p
    })
  };
}
var Q8, nv;
function Wq() {
  return nv || (nv = 1, Q8 = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++)
      n.push(e.getRangeAt(r));
    switch (t.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        t.blur();
        break;
      default:
        t = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(o) {
        e.addRange(o);
      }), t && t.focus();
    };
  }), Q8;
}
var q8, rv;
function $q() {
  if (rv) return q8;
  rv = 1;
  var e = Wq(), t = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, n = "Copy to clipboard: #{key}, Enter";
  function r(i) {
    var a = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return i.replace(/#{\s*key\s*}/g, a);
  }
  function o(i, a) {
    var l, c, u, f, p, h, C = !1;
    a || (a = {}), l = a.debug || !1;
    try {
      u = e(), f = document.createRange(), p = document.getSelection(), h = document.createElement("span"), h.textContent = i, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(b) {
        if (b.stopPropagation(), a.format)
          if (b.preventDefault(), typeof b.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var y = t[a.format] || t.default;
            window.clipboardData.setData(y, i);
          } else
            b.clipboardData.clearData(), b.clipboardData.setData(a.format, i);
        a.onCopy && (b.preventDefault(), a.onCopy(b.clipboardData));
      }), document.body.appendChild(h), f.selectNodeContents(h), p.addRange(f);
      var v = document.execCommand("copy");
      if (!v)
        throw new Error("copy command was unsuccessful");
      C = !0;
    } catch (b) {
      l && console.error("unable to copy using execCommand: ", b), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(a.format || "text", i), a.onCopy && a.onCopy(window.clipboardData), C = !0;
      } catch (y) {
        l && console.error("unable to copy using clipboardData: ", y), l && console.error("falling back to prompt"), c = r("message" in a ? a.message : n), window.prompt(c, i);
      }
    } finally {
      p && (typeof p.removeRange == "function" ? p.removeRange(f) : p.removeAllRanges()), h && document.body.removeChild(h), u();
    }
    return C;
  }
  return q8 = o, q8;
}
var Uq = $q();
const jq = /* @__PURE__ */ k9(Uq);
function Xq(e, t = {}) {
  const [n, r] = ze(!1), [o, i] = ze(e);
  Oe(() => i(e), [e]);
  const { timeout: a = 1500, ...l } = typeof t == "number" ? { timeout: t } : t, c = se(() => {
    const u = jq(o, l);
    r(u);
  }, [o, l]);
  return Oe(() => {
    let u = null;
    return n && (u = window.setTimeout(() => {
      r(!1);
    }, a)), () => {
      u && window.clearTimeout(u);
    };
  }, [a, n]), {
    value: o,
    setValue: i,
    onCopy: c,
    hasCopied: n
  };
}
var [Yq, Jq] = tn({
  name: "InputGroupStylesContext",
  errorMessage: `useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in "<InputGroup />" `
}), qf = Le(
  function(t, n) {
    const r = i2("Input", t), { children: o, className: i, ...a } = fr(t), l = v1("chakra-input__group", i), c = {}, u = Pf(o), f = r.field;
    u.forEach((h) => {
      var C, v;
      r && (f && h.type.id === "InputLeftElement" && (c.paddingStart = (C = f.height) != null ? C : f.h), f && h.type.id === "InputRightElement" && (c.paddingEnd = (v = f.height) != null ? v : f.h), h.type.id === "InputRightAddon" && (c.borderEndRadius = 0), h.type.id === "InputLeftAddon" && (c.borderStartRadius = 0));
    });
    const p = u.map((h) => {
      var C, v;
      const b = lS({
        size: ((C = h.props) == null ? void 0 : C.size) || t.size,
        variant: ((v = h.props) == null ? void 0 : v.variant) || t.variant
      });
      return h.type.id !== "Input" ? ko(h, b) : ko(h, Object.assign(b, c, h.props));
    });
    return /* @__PURE__ */ g(
      je.div,
      {
        className: l,
        ref: n,
        __css: {
          width: "100%",
          display: "flex",
          position: "relative",
          isolation: "isolate"
        },
        "data-group": !0,
        ...a,
        children: /* @__PURE__ */ g(Yq, { value: r, children: p })
      }
    );
  }
);
qf.displayName = "InputGroup";
var Qq = je("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
}), j9 = Le(function(t, n) {
  var r, o;
  const { placement: i = "left", ...a } = t, l = Jq(), c = l.field, f = {
    [i === "left" ? "insetStart" : "insetEnd"]: "0",
    width: (r = c?.height) != null ? r : c?.h,
    height: (o = c?.height) != null ? o : c?.h,
    fontSize: c?.fontSize,
    ...l.element
  };
  return /* @__PURE__ */ g(Qq, { ref: n, __css: f, ...a });
});
j9.id = "InputElement";
j9.displayName = "InputElement";
var Kf = Le(
  function(t, n) {
    const { className: r, ...o } = t, i = v1("chakra-input__left-element", r);
    return /* @__PURE__ */ g(
      j9,
      {
        ref: n,
        placement: "left",
        className: i,
        ...o
      }
    );
  }
);
Kf.id = "InputLeftElement";
Kf.displayName = "InputLeftElement";
var ep = Le(
  function(t, n) {
    const { className: r, ...o } = t, i = v1("chakra-input__right-element", r);
    return /* @__PURE__ */ g(
      j9,
      {
        ref: n,
        placement: "right",
        className: i,
        ...o
      }
    );
  }
);
ep.id = "InputRightElement";
ep.displayName = "InputRightElement";
var K0 = Le(function(t, n) {
  const { htmlSize: r, ...o } = t, i = i2("Input", o), a = fr(o), l = eQ(a), c = v1("chakra-input", t.className);
  return /* @__PURE__ */ g(
    je.input,
    {
      size: r,
      ...l,
      __css: i.field,
      ref: n,
      className: c
    }
  );
});
K0.displayName = "Input";
K0.id = "Input";
var Ts = Le(function(t, n) {
  const r = aa("Link", t), { className: o, isExternal: i, ...a } = fr(t);
  return /* @__PURE__ */ g(
    je.a,
    {
      target: i ? "_blank" : void 0,
      rel: i ? "noopener" : void 0,
      ref: n,
      className: v1("chakra-link", o),
      ...a,
      __css: r
    }
  );
});
Ts.displayName = "Link";
var VA = Object.freeze([
  "base",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl"
]);
function qq(e, t) {
  return Array.isArray(e) ? e.map((n) => n === null ? null : t(n)) : wn(e) ? Object.keys(e).reduce((n, r) => (n[r] = t(e[r]), n), {}) : e != null ? t(e) : null;
}
function Kq(e, t = VA) {
  const n = {};
  return e.forEach((r, o) => {
    const i = t[o];
    r != null && (n[i] = r);
  }), n;
}
var _n = Le(function(t, n) {
  const r = aa("Text", t), { className: o, align: i, decoration: a, casing: l, ...c } = fr(t), u = lS({
    textAlign: t.align,
    textDecoration: t.decoration,
    textTransform: t.casing
  });
  return /* @__PURE__ */ g(
    je.p,
    {
      ref: n,
      className: v1("chakra-text", t.className),
      ...u,
      ...c,
      __css: r
    }
  );
});
_n.displayName = "Text";
var HA = (e) => /* @__PURE__ */ g(
  je.div,
  {
    className: "chakra-stack__item",
    ...e,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...e.__css
    }
  }
);
HA.displayName = "StackItem";
function eK(e) {
  const { spacing: t, direction: n } = e, r = {
    column: {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": qq(
      n,
      (o) => r[o]
    )
  };
}
var OA = Le((e, t) => {
  const {
    isInline: n,
    direction: r,
    align: o,
    justify: i,
    spacing: a = "0.5rem",
    wrap: l,
    children: c,
    divider: u,
    className: f,
    shouldWrapChildren: p,
    ...h
  } = e, C = n ? "row" : r ?? "column", v = we(
    () => eK({ spacing: a, direction: C }),
    [a, C]
  ), b = !!u, y = !p && !b, x = we(() => {
    const A = Pf(c);
    return y ? A : A.map((L, I) => {
      const M = typeof L.key < "u" ? L.key : I, k = I + 1 === A.length, F = p ? /* @__PURE__ */ g(HA, { children: L }, M) : L;
      if (!b)
        return F;
      const $ = ko(
        u,
        {
          __css: v
        }
      );
      return /* @__PURE__ */ X(m0, { children: [
        F,
        k ? null : $
      ] }, M);
    });
  }, [
    u,
    v,
    b,
    y,
    p,
    c
  ]), T = v1("chakra-stack", f);
  return /* @__PURE__ */ g(
    je.div,
    {
      ref: t,
      display: "flex",
      alignItems: o,
      justifyContent: i,
      flexDirection: C,
      flexWrap: l,
      gap: b ? void 0 : a,
      className: T,
      ...h,
      children: x
    }
  );
});
OA.displayName = "Stack";
var tp = Le((e, t) => /* @__PURE__ */ g(OA, { align: "center", ...e, direction: "row", ref: t }));
tp.displayName = "HStack";
var h1 = je("div");
h1.displayName = "Box";
var NA = Le(function(t, n) {
  const { size: r, centerContent: o = !0, ...i } = t;
  return /* @__PURE__ */ g(
    h1,
    {
      ref: n,
      boxSize: r,
      __css: {
        ...o ? { display: "flex", alignItems: "center", justifyContent: "center" } : {},
        flexShrink: 0,
        flexGrow: 0
      },
      ...i
    }
  );
});
NA.displayName = "Square";
var np = Le(function(t, n) {
  const { size: r, ...o } = t;
  return /* @__PURE__ */ g(NA, { size: r, ref: n, borderRadius: "9999px", ...o });
});
np.displayName = "Circle";
var pi = je("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
pi.displayName = "Center";
var tK = {
  horizontal: {
    insetStart: "50%",
    transform: "translateX(-50%)"
  },
  vertical: {
    top: "50%",
    transform: "translateY(-50%)"
  },
  both: {
    insetStart: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  }
};
Le(
  function(t, n) {
    const { axis: r = "both", ...o } = t;
    return /* @__PURE__ */ g(
      je.div,
      {
        ref: n,
        __css: tK[r],
        ...o,
        position: "absolute"
      }
    );
  }
);
var re = Le(function(t, n) {
  const { direction: r, align: o, justify: i, wrap: a, basis: l, grow: c, shrink: u, ...f } = t, p = {
    display: "flex",
    flexDirection: r,
    alignItems: o,
    justifyContent: i,
    flexWrap: a,
    flexBasis: l,
    flexGrow: c,
    flexShrink: u
  };
  return /* @__PURE__ */ g(je.div, { ref: n, __css: p, ...f });
});
re.displayName = "Flex";
function nK(e, t = {}) {
  const { ssr: n = !0, fallback: r } = t, { getWindow: o } = _$(), i = Array.isArray(e) ? e : [e];
  let a = Array.isArray(r) ? r : [r];
  a = a.filter((u) => u != null);
  const [l, c] = ze(() => i.map((u, f) => ({
    media: u,
    matches: n ? !!a[f] : o().matchMedia(u).matches
  })));
  return Oe(() => {
    const u = o();
    c(
      i.map((h) => ({
        media: h,
        matches: u.matchMedia(h).matches
      }))
    );
    const f = i.map((h) => u.matchMedia(h)), p = (h) => {
      c((C) => C.slice().map((v) => v.media === h.media ? { ...v, matches: h.matches } : v));
    };
    return f.forEach((h) => {
      typeof h.addListener == "function" ? h.addListener(p) : h.addEventListener("change", p);
    }), () => {
      f.forEach((h) => {
        typeof h.removeListener == "function" ? h.removeListener(p) : h.removeEventListener("change", p);
      });
    };
  }, [o]), l.map((u) => u.matches);
}
function rK(e, t, n = VA) {
  let r = Object.keys(e).indexOf(t);
  if (r !== -1)
    return e[t];
  let o = n.indexOf(t);
  for (; o >= 0; ) {
    const i = n[o];
    if (e.hasOwnProperty(i)) {
      r = o;
      break;
    }
    o -= 1;
  }
  if (r !== -1) {
    const i = n[r];
    return e[i];
  }
}
function oK(e) {
  var t, n;
  const r = wn(e) ? e : { fallback: e ?? "base" }, i = Xe().__breakpoints.details.map(
    ({ minMaxQuery: u, breakpoint: f }) => ({
      breakpoint: f,
      query: u.replace("@media screen and ", "")
    })
  ), a = i.map((u) => u.breakpoint === r.fallback), c = nK(
    i.map((u) => u.query),
    { fallback: a, ssr: r.ssr }
  ).findIndex((u) => u == !0);
  return (n = (t = i[c]) == null ? void 0 : t.breakpoint) != null ? n : r.fallback;
}
function Gt(e, t) {
  var n;
  const r = wn(t) ? t : { fallback: "base" }, o = oK(r), i = Xe();
  if (!o)
    return;
  const a = Array.from(((n = i.__breakpoints) == null ? void 0 : n.keys) || []), l = Array.isArray(e) ? Object.fromEntries(
    Object.entries(Kq(e, a)).map(
      ([c, u]) => [c, u]
    )
  ) : e;
  return rK(l, o, a);
}
function iK(e) {
  const { key: t } = e;
  return t.length === 1 || t.length > 1 && /[^a-zA-Z0-9]/.test(t);
}
function aK(e = {}) {
  const { timeout: t = 300, preventDefault: n = () => !0 } = e, [r, o] = ze([]), i = Re(), a = () => {
    i.current && (clearTimeout(i.current), i.current = null);
  }, l = () => {
    a(), i.current = setTimeout(() => {
      o([]), i.current = null;
    }, t);
  };
  Oe(() => a, []);
  function c(u) {
    return (f) => {
      if (f.key === "Backspace") {
        const p = [...r];
        p.pop(), o(p);
        return;
      }
      if (iK(f)) {
        const p = r.concat(f.key);
        n(f) && (f.preventDefault(), f.stopPropagation()), o(p), u(p.join("")), l();
      }
    };
  }
  return c;
}
function sK(e, t, n, r) {
  if (t == null)
    return r;
  if (!r)
    return e.find(
      (a) => n(a).toLowerCase().startsWith(t.toLowerCase())
    );
  const o = e.filter(
    (i) => n(i).toLowerCase().startsWith(t.toLowerCase())
  );
  if (o.length > 0) {
    let i;
    return o.includes(r) ? (i = o.indexOf(r) + 1, i === o.length && (i = 0), o[i]) : (i = e.indexOf(o[0]), e[i]);
  }
  return r;
}
function lK() {
  const e = Re(/* @__PURE__ */ new Map()), t = e.current, n = se((o, i, a, l) => {
    e.current.set(a, { type: i, el: o, options: l }), o.addEventListener(i, a, l);
  }, []), r = se(
    (o, i, a, l) => {
      o.removeEventListener(i, a, l), e.current.delete(a);
    },
    []
  );
  return Oe(
    () => () => {
      t.forEach((o, i) => {
        r(o.el, o.type, i, o.options);
      });
    },
    [r, t]
  ), { add: n, remove: r };
}
function K8(e) {
  const t = e.target, { tagName: n, isContentEditable: r } = t;
  return n !== "INPUT" && n !== "TEXTAREA" && r !== !0;
}
function cK(e = {}) {
  const {
    ref: t,
    isDisabled: n,
    isFocusable: r,
    clickOnEnter: o = !0,
    clickOnSpace: i = !0,
    onMouseDown: a,
    onMouseUp: l,
    onClick: c,
    onKeyDown: u,
    onKeyUp: f,
    tabIndex: p,
    onMouseOver: h,
    onMouseLeave: C,
    ...v
  } = e, [b, y] = ze(!0), [x, T] = ze(!1), A = lK(), L = (J) => {
    J && J.tagName !== "BUTTON" && y(!1);
  }, I = b ? p : p || 0, M = n && !r, k = se(
    (J) => {
      if (n) {
        J.stopPropagation(), J.preventDefault();
        return;
      }
      J.currentTarget.focus(), c?.(J);
    },
    [n, c]
  ), _ = se(
    (J) => {
      x && K8(J) && (J.preventDefault(), J.stopPropagation(), T(!1), A.remove(document, "keyup", _, !1));
    },
    [x, A]
  ), F = se(
    (J) => {
      if (u?.(J), n || J.defaultPrevented || J.metaKey || !K8(J.nativeEvent) || b)
        return;
      const Me = o && J.key === "Enter";
      i && J.key === " " && (J.preventDefault(), T(!0)), Me && (J.preventDefault(), J.currentTarget.click()), A.add(document, "keyup", _, !1);
    },
    [
      n,
      b,
      u,
      o,
      i,
      A,
      _
    ]
  ), $ = se(
    (J) => {
      if (f?.(J), n || J.defaultPrevented || J.metaKey || !K8(J.nativeEvent) || b)
        return;
      i && J.key === " " && (J.preventDefault(), T(!1), J.currentTarget.click());
    },
    [i, b, n, f]
  ), oe = se(
    (J) => {
      J.button === 0 && (T(!1), A.remove(document, "mouseup", oe, !1));
    },
    [A]
  ), te = se(
    (J) => {
      if (J.button !== 0)
        return;
      if (n) {
        J.stopPropagation(), J.preventDefault();
        return;
      }
      b || T(!0), J.currentTarget.focus({ preventScroll: !0 }), A.add(document, "mouseup", oe, !1), a?.(J);
    },
    [n, b, a, A, oe]
  ), ae = se(
    (J) => {
      J.button === 0 && (b || T(!1), l?.(J));
    },
    [l, b]
  ), be = se(
    (J) => {
      if (n) {
        J.preventDefault();
        return;
      }
      h?.(J);
    },
    [n, h]
  ), K = se(
    (J) => {
      x && (J.preventDefault(), T(!1)), C?.(J);
    },
    [x, C]
  ), ue = Kt(t, L);
  return b ? {
    ...v,
    ref: ue,
    type: "button",
    "aria-disabled": M ? void 0 : n,
    disabled: M,
    onClick: k,
    onMouseDown: a,
    onMouseUp: l,
    onKeyUp: f,
    onKeyDown: u,
    onMouseOver: h,
    onMouseLeave: C
  } : {
    ...v,
    ref: ue,
    role: "button",
    "data-active": Xi(x),
    "aria-disabled": n ? "true" : void 0,
    tabIndex: M ? void 0 : I,
    onClick: k,
    onMouseDown: te,
    onMouseUp: ae,
    onKeyUp: $,
    onKeyDown: F,
    onMouseOver: be,
    onMouseLeave: K
  };
}
function uK(e) {
  const t = e.current;
  if (!t)
    return !1;
  const n = Bq(t);
  return !n || t.contains(n) ? !1 : !!Vq(n);
}
function DA(e, t) {
  const { shouldFocus: n, visible: r, focusRef: o } = t, i = n && !r;
  vs(() => {
    if (!i || uK(e))
      return;
    const a = o?.current || e.current;
    let l;
    if (a)
      return l = requestAnimationFrame(() => {
        a.focus({ preventScroll: !0 });
      }), () => {
        cancelAnimationFrame(l);
      };
  }, [i, e, o]);
}
var dK = {
  preventScroll: !0,
  shouldFocus: !1
};
function fK(e, t = dK) {
  const { focusRef: n, preventScroll: r, shouldFocus: o, visible: i } = t, a = pK(e) ? e.current : e, l = o && i, c = Re(l), u = Re(i);
  Xa(() => {
    !u.current && i && (c.current = l), u.current = i;
  }, [i, l]);
  const f = se(() => {
    if (!(!i || !a || !c.current) && (c.current = !1, !a.contains(document.activeElement)))
      if (n?.current)
        requestAnimationFrame(() => {
          var p;
          (p = n.current) == null || p.focus({ preventScroll: r });
        });
      else {
        const p = FA(a);
        p.length > 0 && requestAnimationFrame(() => {
          p[0].focus({ preventScroll: r });
        });
      }
  }, [i, r, a, n]);
  vs(() => {
    f();
  }, [f]), us(a, "transitionend", f);
}
function pK(e) {
  return "current" in e;
}
var $2 = (e, t) => ({
  var: e,
  varRef: t ? `var(${e}, ${t})` : `var(${e})`
}), $t = {
  arrowShadowColor: $2("--popper-arrow-shadow-color"),
  arrowSize: $2("--popper-arrow-size", "8px"),
  arrowSizeHalf: $2("--popper-arrow-size-half"),
  arrowBg: $2("--popper-arrow-bg"),
  transformOrigin: $2("--popper-transform-origin"),
  arrowOffset: $2("--popper-arrow-offset")
};
function hK(e) {
  if (e.includes("top"))
    return "1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("bottom"))
    return "-1px -1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("right"))
    return "-1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("left"))
    return "1px -1px 0px 0 var(--popper-arrow-shadow-color)";
}
var mK = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
}, CK = (e) => mK[e], ov = {
  scroll: !0,
  resize: !0
};
function gK(e) {
  let t;
  return typeof e == "object" ? t = {
    enabled: !0,
    options: { ...ov, ...e }
  } : t = {
    enabled: e,
    options: ov
  }, t;
}
var bK = {
  name: "matchWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => () => {
    const t = e.elements.reference;
    e.elements.popper.style.width = `${t.offsetWidth}px`;
  }
}, vK = {
  name: "transformOrigin",
  enabled: !0,
  phase: "write",
  fn: ({ state: e }) => {
    iv(e);
  },
  effect: ({ state: e }) => () => {
    iv(e);
  }
}, iv = (e) => {
  e.elements.popper.style.setProperty(
    $t.transformOrigin.var,
    CK(e.placement)
  );
}, yK = {
  name: "positionArrow",
  enabled: !0,
  phase: "afterWrite",
  fn: ({ state: e }) => {
    xK(e);
  }
}, xK = (e) => {
  var t;
  if (!e.placement)
    return;
  const n = wK(e.placement);
  if ((t = e.elements) != null && t.arrow && n) {
    Object.assign(e.elements.arrow.style, {
      [n.property]: n.value,
      width: $t.arrowSize.varRef,
      height: $t.arrowSize.varRef,
      zIndex: -1
    });
    const r = {
      [$t.arrowSizeHalf.var]: `calc(${$t.arrowSize.varRef} / 2 - 1px)`,
      [$t.arrowOffset.var]: `calc(${$t.arrowSizeHalf.varRef} * -1)`
    };
    for (const o in r)
      e.elements.arrow.style.setProperty(o, r[o]);
  }
}, wK = (e) => {
  if (e.startsWith("top"))
    return { property: "bottom", value: $t.arrowOffset.varRef };
  if (e.startsWith("bottom"))
    return { property: "top", value: $t.arrowOffset.varRef };
  if (e.startsWith("left"))
    return { property: "right", value: $t.arrowOffset.varRef };
  if (e.startsWith("right"))
    return { property: "left", value: $t.arrowOffset.varRef };
}, SK = {
  name: "innerArrow",
  enabled: !0,
  phase: "main",
  requires: ["arrow"],
  fn: ({ state: e }) => {
    av(e);
  },
  effect: ({ state: e }) => () => {
    av(e);
  }
}, av = (e) => {
  if (!e.elements.arrow)
    return;
  const t = e.elements.arrow.querySelector(
    "[data-popper-arrow-inner]"
  );
  if (!t)
    return;
  const n = hK(e.placement);
  n && t.style.setProperty("--popper-arrow-default-shadow", n), Object.assign(t.style, {
    transform: "rotate(45deg)",
    background: $t.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: "var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"
  });
}, TK = {
  "start-start": { ltr: "left-start", rtl: "right-start" },
  "start-end": { ltr: "left-end", rtl: "right-end" },
  "end-start": { ltr: "right-start", rtl: "left-start" },
  "end-end": { ltr: "right-end", rtl: "left-end" },
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
}, AK = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};
function IK(e, t = "ltr") {
  var n, r;
  const o = ((n = TK[e]) == null ? void 0 : n[t]) || e;
  return t === "ltr" ? o : (r = AK[e]) != null ? r : o;
}
var Wn = "top", Pr = "bottom", Vr = "right", $n = "left", rp = "auto", e3 = [Wn, Pr, Vr, $n], As = "start", E0 = "end", LK = "clippingParents", ZA = "viewport", R5 = "popper", EK = "reference", sv = /* @__PURE__ */ e3.reduce(function(e, t) {
  return e.concat([t + "-" + As, t + "-" + E0]);
}, []), zA = /* @__PURE__ */ [].concat(e3, [rp]).reduce(function(e, t) {
  return e.concat([t, t + "-" + As, t + "-" + E0]);
}, []), MK = "beforeRead", BK = "read", kK = "afterRead", RK = "beforeMain", _K = "main", FK = "afterMain", PK = "beforeWrite", VK = "write", HK = "afterWrite", OK = [MK, BK, kK, RK, _K, FK, PK, VK, HK];
function Ro(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function cr(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function qa(e) {
  var t = cr(e).Element;
  return e instanceof t || e instanceof Element;
}
function _r(e) {
  var t = cr(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function op(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = cr(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function NK(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !_r(i) || !Ro(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var l = o[a];
      l === !1 ? i.removeAttribute(a) : i.setAttribute(a, l === !0 ? "" : l);
    }));
  });
}
function DK(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), l = a.reduce(function(c, u) {
        return c[u] = "", c;
      }, {});
      !_r(o) || !Ro(o) || (Object.assign(o.style, l), Object.keys(i).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const ZK = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: NK,
  effect: DK,
  requires: ["computeStyles"]
};
function Lo(e) {
  return e.split("-")[0];
}
var $a = Math.max, l9 = Math.min, Is = Math.round;
function Bu() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function GA() {
  return !/^((?!chrome|android).)*safari/i.test(Bu());
}
function Ls(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && _r(e) && (o = e.offsetWidth > 0 && Is(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Is(r.height) / e.offsetHeight || 1);
  var a = qa(e) ? cr(e) : window, l = a.visualViewport, c = !GA() && n, u = (r.left + (c && l ? l.offsetLeft : 0)) / o, f = (r.top + (c && l ? l.offsetTop : 0)) / i, p = r.width / o, h = r.height / i;
  return {
    width: p,
    height: h,
    top: f,
    right: u + p,
    bottom: f + h,
    left: u,
    x: u,
    y: f
  };
}
function ip(e) {
  var t = Ls(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function WA(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && op(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function hi(e) {
  return cr(e).getComputedStyle(e);
}
function zK(e) {
  return ["table", "td", "th"].indexOf(Ro(e)) >= 0;
}
function la(e) {
  return ((qa(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function X9(e) {
  return Ro(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (op(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    la(e)
  );
}
function lv(e) {
  return !_r(e) || // https://github.com/popperjs/popper-core/issues/837
  hi(e).position === "fixed" ? null : e.offsetParent;
}
function GK(e) {
  var t = /firefox/i.test(Bu()), n = /Trident/i.test(Bu());
  if (n && _r(e)) {
    var r = hi(e);
    if (r.position === "fixed")
      return null;
  }
  var o = X9(e);
  for (op(o) && (o = o.host); _r(o) && ["html", "body"].indexOf(Ro(o)) < 0; ) {
    var i = hi(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function t3(e) {
  for (var t = cr(e), n = lv(e); n && zK(n) && hi(n).position === "static"; )
    n = lv(n);
  return n && (Ro(n) === "html" || Ro(n) === "body" && hi(n).position === "static") ? t : n || GK(e) || t;
}
function ap(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function s0(e, t, n) {
  return $a(e, l9(t, n));
}
function WK(e, t, n) {
  var r = s0(e, t, n);
  return r > n ? n : r;
}
function $A() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function UA(e) {
  return Object.assign({}, $A(), e);
}
function jA(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var $K = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, UA(typeof t != "number" ? t : jA(t, e3));
};
function UK(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, l = Lo(n.placement), c = ap(l), u = [$n, Vr].indexOf(l) >= 0, f = u ? "height" : "width";
  if (!(!i || !a)) {
    var p = $K(o.padding, n), h = ip(i), C = c === "y" ? Wn : $n, v = c === "y" ? Pr : Vr, b = n.rects.reference[f] + n.rects.reference[c] - a[c] - n.rects.popper[f], y = a[c] - n.rects.reference[c], x = t3(i), T = x ? c === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, A = b / 2 - y / 2, L = p[C], I = T - h[f] - p[v], M = T / 2 - h[f] / 2 + A, k = s0(L, M, I), _ = c;
    n.modifiersData[r] = (t = {}, t[_] = k, t.centerOffset = k - M, t);
  }
}
function jK(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || WA(t.elements.popper, o) && (t.elements.arrow = o));
}
const XK = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: UK,
  effect: jK,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Es(e) {
  return e.split("-")[1];
}
var YK = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function JK(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: Is(n * o) / o || 0,
    y: Is(r * o) / o || 0
  };
}
function cv(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, l = e.position, c = e.gpuAcceleration, u = e.adaptive, f = e.roundOffsets, p = e.isFixed, h = a.x, C = h === void 0 ? 0 : h, v = a.y, b = v === void 0 ? 0 : v, y = typeof f == "function" ? f({
    x: C,
    y: b
  }) : {
    x: C,
    y: b
  };
  C = y.x, b = y.y;
  var x = a.hasOwnProperty("x"), T = a.hasOwnProperty("y"), A = $n, L = Wn, I = window;
  if (u) {
    var M = t3(n), k = "clientHeight", _ = "clientWidth";
    if (M === cr(n) && (M = la(n), hi(M).position !== "static" && l === "absolute" && (k = "scrollHeight", _ = "scrollWidth")), M = M, o === Wn || (o === $n || o === Vr) && i === E0) {
      L = Pr;
      var F = p && M === I && I.visualViewport ? I.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        M[k]
      );
      b -= F - r.height, b *= c ? 1 : -1;
    }
    if (o === $n || (o === Wn || o === Pr) && i === E0) {
      A = Vr;
      var $ = p && M === I && I.visualViewport ? I.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        M[_]
      );
      C -= $ - r.width, C *= c ? 1 : -1;
    }
  }
  var oe = Object.assign({
    position: l
  }, u && YK), te = f === !0 ? JK({
    x: C,
    y: b
  }, cr(n)) : {
    x: C,
    y: b
  };
  if (C = te.x, b = te.y, c) {
    var ae;
    return Object.assign({}, oe, (ae = {}, ae[L] = T ? "0" : "", ae[A] = x ? "0" : "", ae.transform = (I.devicePixelRatio || 1) <= 1 ? "translate(" + C + "px, " + b + "px)" : "translate3d(" + C + "px, " + b + "px, 0)", ae));
  }
  return Object.assign({}, oe, (t = {}, t[L] = T ? b + "px" : "", t[A] = x ? C + "px" : "", t.transform = "", t));
}
function QK(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i, l = n.roundOffsets, c = l === void 0 ? !0 : l, u = {
    placement: Lo(t.placement),
    variation: Es(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, cv(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, cv(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const qK = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: QK,
  data: {}
};
var q4 = {
  passive: !0
};
function KK(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, l = a === void 0 ? !0 : a, c = cr(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(f) {
    f.addEventListener("scroll", n.update, q4);
  }), l && c.addEventListener("resize", n.update, q4), function() {
    i && u.forEach(function(f) {
      f.removeEventListener("scroll", n.update, q4);
    }), l && c.removeEventListener("resize", n.update, q4);
  };
}
const eee = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: KK,
  data: {}
};
var tee = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Il(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return tee[t];
  });
}
var nee = {
  start: "end",
  end: "start"
};
function uv(e) {
  return e.replace(/start|end/g, function(t) {
    return nee[t];
  });
}
function sp(e) {
  var t = cr(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function lp(e) {
  return Ls(la(e)).left + sp(e).scrollLeft;
}
function ree(e, t) {
  var n = cr(e), r = la(e), o = n.visualViewport, i = r.clientWidth, a = r.clientHeight, l = 0, c = 0;
  if (o) {
    i = o.width, a = o.height;
    var u = GA();
    (u || !u && t === "fixed") && (l = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l + lp(e),
    y: c
  };
}
function oee(e) {
  var t, n = la(e), r = sp(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = $a(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = $a(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -r.scrollLeft + lp(e), c = -r.scrollTop;
  return hi(o || n).direction === "rtl" && (l += $a(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function cp(e) {
  var t = hi(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function XA(e) {
  return ["html", "body", "#document"].indexOf(Ro(e)) >= 0 ? e.ownerDocument.body : _r(e) && cp(e) ? e : XA(X9(e));
}
function l0(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = XA(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = cr(r), a = o ? [i].concat(i.visualViewport || [], cp(r) ? r : []) : r, l = t.concat(a);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(l0(X9(a)))
  );
}
function ku(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function iee(e, t) {
  var n = Ls(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function dv(e, t, n) {
  return t === ZA ? ku(ree(e, n)) : qa(t) ? iee(t, n) : ku(oee(la(e)));
}
function aee(e) {
  var t = l0(X9(e)), n = ["absolute", "fixed"].indexOf(hi(e).position) >= 0, r = n && _r(e) ? t3(e) : e;
  return qa(r) ? t.filter(function(o) {
    return qa(o) && WA(o, r) && Ro(o) !== "body";
  }) : [];
}
function see(e, t, n, r) {
  var o = t === "clippingParents" ? aee(e) : [].concat(t), i = [].concat(o, [n]), a = i[0], l = i.reduce(function(c, u) {
    var f = dv(e, u, r);
    return c.top = $a(f.top, c.top), c.right = l9(f.right, c.right), c.bottom = l9(f.bottom, c.bottom), c.left = $a(f.left, c.left), c;
  }, dv(e, a, r));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function YA(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Lo(r) : null, i = r ? Es(r) : null, a = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, c;
  switch (o) {
    case Wn:
      c = {
        x: a,
        y: t.y - n.height
      };
      break;
    case Pr:
      c = {
        x: a,
        y: t.y + t.height
      };
      break;
    case Vr:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case $n:
      c = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var u = o ? ap(o) : null;
  if (u != null) {
    var f = u === "y" ? "height" : "width";
    switch (i) {
      case As:
        c[u] = c[u] - (t[f] / 2 - n[f] / 2);
        break;
      case E0:
        c[u] = c[u] + (t[f] / 2 - n[f] / 2);
        break;
    }
  }
  return c;
}
function M0(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, a = i === void 0 ? e.strategy : i, l = n.boundary, c = l === void 0 ? LK : l, u = n.rootBoundary, f = u === void 0 ? ZA : u, p = n.elementContext, h = p === void 0 ? R5 : p, C = n.altBoundary, v = C === void 0 ? !1 : C, b = n.padding, y = b === void 0 ? 0 : b, x = UA(typeof y != "number" ? y : jA(y, e3)), T = h === R5 ? EK : R5, A = e.rects.popper, L = e.elements[v ? T : h], I = see(qa(L) ? L : L.contextElement || la(e.elements.popper), c, f, a), M = Ls(e.elements.reference), k = YA({
    reference: M,
    element: A,
    strategy: "absolute",
    placement: o
  }), _ = ku(Object.assign({}, A, k)), F = h === R5 ? _ : M, $ = {
    top: I.top - F.top + x.top,
    bottom: F.bottom - I.bottom + x.bottom,
    left: I.left - F.left + x.left,
    right: F.right - I.right + x.right
  }, oe = e.modifiersData.offset;
  if (h === R5 && oe) {
    var te = oe[o];
    Object.keys($).forEach(function(ae) {
      var be = [Vr, Pr].indexOf(ae) >= 0 ? 1 : -1, K = [Wn, Pr].indexOf(ae) >= 0 ? "y" : "x";
      $[ae] += te[K] * be;
    });
  }
  return $;
}
function lee(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, l = n.flipVariations, c = n.allowedAutoPlacements, u = c === void 0 ? zA : c, f = Es(r), p = f ? l ? sv : sv.filter(function(v) {
    return Es(v) === f;
  }) : e3, h = p.filter(function(v) {
    return u.indexOf(v) >= 0;
  });
  h.length === 0 && (h = p);
  var C = h.reduce(function(v, b) {
    return v[b] = M0(e, {
      placement: b,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[Lo(b)], v;
  }, {});
  return Object.keys(C).sort(function(v, b) {
    return C[v] - C[b];
  });
}
function cee(e) {
  if (Lo(e) === rp)
    return [];
  var t = Il(e);
  return [uv(e), t, uv(t)];
}
function uee(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, l = a === void 0 ? !0 : a, c = n.fallbackPlacements, u = n.padding, f = n.boundary, p = n.rootBoundary, h = n.altBoundary, C = n.flipVariations, v = C === void 0 ? !0 : C, b = n.allowedAutoPlacements, y = t.options.placement, x = Lo(y), T = x === y, A = c || (T || !v ? [Il(y)] : cee(y)), L = [y].concat(A).reduce(function(xe, Te) {
      return xe.concat(Lo(Te) === rp ? lee(t, {
        placement: Te,
        boundary: f,
        rootBoundary: p,
        padding: u,
        flipVariations: v,
        allowedAutoPlacements: b
      }) : Te);
    }, []), I = t.rects.reference, M = t.rects.popper, k = /* @__PURE__ */ new Map(), _ = !0, F = L[0], $ = 0; $ < L.length; $++) {
      var oe = L[$], te = Lo(oe), ae = Es(oe) === As, be = [Wn, Pr].indexOf(te) >= 0, K = be ? "width" : "height", ue = M0(t, {
        placement: oe,
        boundary: f,
        rootBoundary: p,
        altBoundary: h,
        padding: u
      }), J = be ? ae ? Vr : $n : ae ? Pr : Wn;
      I[K] > M[K] && (J = Il(J));
      var Me = Il(J), _e = [];
      if (i && _e.push(ue[te] <= 0), l && _e.push(ue[J] <= 0, ue[Me] <= 0), _e.every(function(xe) {
        return xe;
      })) {
        F = oe, _ = !1;
        break;
      }
      k.set(oe, _e);
    }
    if (_)
      for (var ne = v ? 3 : 1, ee = function(Te) {
        var Ie = L.find(function(Q) {
          var pe = k.get(Q);
          if (pe)
            return pe.slice(0, Te).every(function(me) {
              return me;
            });
        });
        if (Ie)
          return F = Ie, "break";
      }, ye = ne; ye > 0; ye--) {
        var fe = ee(ye);
        if (fe === "break") break;
      }
    t.placement !== F && (t.modifiersData[r]._skip = !0, t.placement = F, t.reset = !0);
  }
}
const dee = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: uee,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function fv(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function pv(e) {
  return [Wn, Vr, Pr, $n].some(function(t) {
    return e[t] >= 0;
  });
}
function fee(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = M0(t, {
    elementContext: "reference"
  }), l = M0(t, {
    altBoundary: !0
  }), c = fv(a, r), u = fv(l, o, i), f = pv(c), p = pv(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: u,
    isReferenceHidden: f,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": p
  });
}
const pee = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: fee
};
function hee(e, t, n) {
  var r = Lo(e), o = [$n, Wn].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = i[0], l = i[1];
  return a = a || 0, l = (l || 0) * o, [$n, Vr].indexOf(r) >= 0 ? {
    x: l,
    y: a
  } : {
    x: a,
    y: l
  };
}
function mee(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = zA.reduce(function(f, p) {
    return f[p] = hee(p, t.rects, i), f;
  }, {}), l = a[t.placement], c = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = a;
}
const Cee = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: mee
};
function gee(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = YA({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const bee = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: gee,
  data: {}
};
function vee(e) {
  return e === "x" ? "y" : "x";
}
function yee(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, l = a === void 0 ? !1 : a, c = n.boundary, u = n.rootBoundary, f = n.altBoundary, p = n.padding, h = n.tether, C = h === void 0 ? !0 : h, v = n.tetherOffset, b = v === void 0 ? 0 : v, y = M0(t, {
    boundary: c,
    rootBoundary: u,
    padding: p,
    altBoundary: f
  }), x = Lo(t.placement), T = Es(t.placement), A = !T, L = ap(x), I = vee(L), M = t.modifiersData.popperOffsets, k = t.rects.reference, _ = t.rects.popper, F = typeof b == "function" ? b(Object.assign({}, t.rects, {
    placement: t.placement
  })) : b, $ = typeof F == "number" ? {
    mainAxis: F,
    altAxis: F
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, F), oe = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, te = {
    x: 0,
    y: 0
  };
  if (M) {
    if (i) {
      var ae, be = L === "y" ? Wn : $n, K = L === "y" ? Pr : Vr, ue = L === "y" ? "height" : "width", J = M[L], Me = J + y[be], _e = J - y[K], ne = C ? -_[ue] / 2 : 0, ee = T === As ? k[ue] : _[ue], ye = T === As ? -_[ue] : -k[ue], fe = t.elements.arrow, xe = C && fe ? ip(fe) : {
        width: 0,
        height: 0
      }, Te = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : $A(), Ie = Te[be], Q = Te[K], pe = s0(0, k[ue], xe[ue]), me = A ? k[ue] / 2 - ne - pe - Ie - $.mainAxis : ee - pe - Ie - $.mainAxis, Be = A ? -k[ue] / 2 + ne + pe + Q + $.mainAxis : ye + pe + Q + $.mainAxis, We = t.elements.arrow && t3(t.elements.arrow), ie = We ? L === "y" ? We.clientTop || 0 : We.clientLeft || 0 : 0, f1 = (ae = oe?.[L]) != null ? ae : 0, s1 = J + me - f1 - ie, Ye = J + Be - f1, B1 = s0(C ? l9(Me, s1) : Me, J, C ? $a(_e, Ye) : _e);
      M[L] = B1, te[L] = B1 - J;
    }
    if (l) {
      var Pe, j1 = L === "x" ? Wn : $n, X1 = L === "x" ? Pr : Vr, p1 = M[I], L1 = I === "y" ? "height" : "width", Ct = p1 + y[j1], Z1 = p1 - y[X1], r1 = [Wn, $n].indexOf(x) !== -1, ut = (Pe = oe?.[I]) != null ? Pe : 0, rn = r1 ? Ct : p1 - k[L1] - _[L1] - ut + $.altAxis, on = r1 ? p1 + k[L1] + _[L1] - ut - $.altAxis : Z1, ln = C && r1 ? WK(rn, p1, on) : s0(C ? rn : Ct, p1, C ? on : Z1);
      M[I] = ln, te[I] = ln - p1;
    }
    t.modifiersData[r] = te;
  }
}
const xee = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: yee,
  requiresIfExists: ["offset"]
};
function wee(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function See(e) {
  return e === cr(e) || !_r(e) ? sp(e) : wee(e);
}
function Tee(e) {
  var t = e.getBoundingClientRect(), n = Is(t.width) / e.offsetWidth || 1, r = Is(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Aee(e, t, n) {
  n === void 0 && (n = !1);
  var r = _r(t), o = _r(t) && Tee(t), i = la(t), a = Ls(e, o, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Ro(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  cp(i)) && (l = See(t)), _r(t) ? (c = Ls(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = lp(i))), {
    x: a.left + l.scrollLeft - c.x,
    y: a.top + l.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function Iee(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(l) {
      if (!n.has(l)) {
        var c = t.get(l);
        c && o(c);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function Lee(e) {
  var t = Iee(e);
  return OK.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function Eee(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Mee(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var hv = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function mv() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Bee(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? hv : o;
  return function(l, c, u) {
    u === void 0 && (u = i);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, hv, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, p = [], h = !1, C = {
      state: f,
      setOptions: function(x) {
        var T = typeof x == "function" ? x(f.options) : x;
        b(), f.options = Object.assign({}, i, f.options, T), f.scrollParents = {
          reference: qa(l) ? l0(l) : l.contextElement ? l0(l.contextElement) : [],
          popper: l0(c)
        };
        var A = Lee(Mee([].concat(r, f.options.modifiers)));
        return f.orderedModifiers = A.filter(function(L) {
          return L.enabled;
        }), v(), C.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var x = f.elements, T = x.reference, A = x.popper;
          if (mv(T, A)) {
            f.rects = {
              reference: Aee(T, t3(A), f.options.strategy === "fixed"),
              popper: ip(A)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function($) {
              return f.modifiersData[$.name] = Object.assign({}, $.data);
            });
            for (var L = 0; L < f.orderedModifiers.length; L++) {
              if (f.reset === !0) {
                f.reset = !1, L = -1;
                continue;
              }
              var I = f.orderedModifiers[L], M = I.fn, k = I.options, _ = k === void 0 ? {} : k, F = I.name;
              typeof M == "function" && (f = M({
                state: f,
                options: _,
                name: F,
                instance: C
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Eee(function() {
        return new Promise(function(y) {
          C.forceUpdate(), y(f);
        });
      }),
      destroy: function() {
        b(), h = !0;
      }
    };
    if (!mv(l, c))
      return C;
    C.setOptions(u).then(function(y) {
      !h && u.onFirstUpdate && u.onFirstUpdate(y);
    });
    function v() {
      f.orderedModifiers.forEach(function(y) {
        var x = y.name, T = y.options, A = T === void 0 ? {} : T, L = y.effect;
        if (typeof L == "function") {
          var I = L({
            state: f,
            name: x,
            instance: C,
            options: A
          }), M = function() {
          };
          p.push(I || M);
        }
      });
    }
    function b() {
      p.forEach(function(y) {
        return y();
      }), p = [];
    }
    return C;
  };
}
var kee = [eee, bee, qK, ZK, Cee, dee, xee, XK, pee], Ree = /* @__PURE__ */ Bee({
  defaultModifiers: kee
});
function up(e = {}) {
  const {
    enabled: t = !0,
    modifiers: n,
    placement: r = "bottom",
    strategy: o = "absolute",
    arrowPadding: i = 8,
    eventListeners: a = !0,
    offset: l,
    gutter: c = 8,
    flip: u = !0,
    boundary: f = "clippingParents",
    preventOverflow: p = !0,
    matchWidth: h,
    direction: C = "ltr"
  } = e, v = Re(null), b = Re(null), y = Re(null), x = IK(r, C), T = Re(() => {
  }), A = se(() => {
    var $;
    !t || !v.current || !b.current || (($ = T.current) == null || $.call(T), y.current = Ree(v.current, b.current, {
      placement: x,
      modifiers: [
        SK,
        yK,
        vK,
        {
          ...bK,
          enabled: !!h
        },
        {
          name: "eventListeners",
          ...gK(a)
        },
        {
          name: "arrow",
          options: { padding: i }
        },
        {
          name: "offset",
          options: {
            offset: l ?? [0, c]
          }
        },
        {
          name: "flip",
          enabled: !!u,
          options: { padding: 8 }
        },
        {
          name: "preventOverflow",
          enabled: !!p,
          options: { boundary: f }
        },
        ...n ?? []
      ],
      strategy: o
    }), y.current.forceUpdate(), T.current = y.current.destroy);
  }, [
    x,
    t,
    n,
    h,
    a,
    i,
    l,
    c,
    u,
    p,
    f,
    o
  ]);
  Oe(() => () => {
    var $;
    !v.current && !b.current && (($ = y.current) == null || $.destroy(), y.current = null);
  }, []);
  const L = se(
    ($) => {
      v.current = $, A();
    },
    [A]
  ), I = se(
    ($ = {}, oe = null) => ({
      ...$,
      ref: Kt(L, oe)
    }),
    [L]
  ), M = se(
    ($) => {
      b.current = $, A();
    },
    [A]
  ), k = se(
    ($ = {}, oe = null) => ({
      ...$,
      ref: Kt(M, oe),
      style: {
        ...$.style,
        position: o,
        minWidth: h ? void 0 : "max-content",
        inset: "0 auto auto 0"
      }
    }),
    [o, M, h]
  ), _ = se(($ = {}, oe = null) => {
    const { size: te, shadowColor: ae, bg: be, style: K, ...ue } = $;
    return {
      ...ue,
      ref: oe,
      "data-popper-arrow": "",
      style: _ee($)
    };
  }, []), F = se(
    ($ = {}, oe = null) => ({
      ...$,
      ref: oe,
      "data-popper-arrow-inner": ""
    }),
    []
  );
  return {
    update() {
      var $;
      ($ = y.current) == null || $.update();
    },
    forceUpdate() {
      var $;
      ($ = y.current) == null || $.forceUpdate();
    },
    transformOrigin: $t.transformOrigin.varRef,
    referenceRef: L,
    popperRef: M,
    getPopperProps: k,
    getArrowProps: _,
    getArrowInnerProps: F,
    getReferenceProps: I
  };
}
function _ee(e) {
  const { size: t, shadowColor: n, bg: r, style: o } = e, i = { ...o, position: "absolute" };
  return t && (i["--popper-arrow-size"] = t), n && (i["--popper-arrow-shadow-color"] = n), r && (i["--popper-arrow-bg"] = r), i;
}
function dp(e = {}) {
  const {
    onClose: t,
    onOpen: n,
    isOpen: r,
    id: o
  } = e, i = qi(n), a = qi(t), [l, c] = ze(e.defaultIsOpen || !1), u = r !== void 0 ? r : l, f = r !== void 0, p = dr(), h = o ?? `disclosure-${p}`, C = se(() => {
    f || c(!1), a?.();
  }, [f, a]), v = se(() => {
    f || c(!0), i?.();
  }, [f, i]), b = se(() => {
    u ? C() : v();
  }, [u, v, C]);
  function y(T = {}) {
    return {
      ...T,
      "aria-expanded": u,
      "aria-controls": h,
      onClick(A) {
        var L;
        (L = T.onClick) == null || L.call(T, A), b();
      }
    };
  }
  function x(T = {}) {
    return {
      ...T,
      hidden: !u,
      id: h
    };
  }
  return {
    isOpen: u,
    onOpen: v,
    onClose: C,
    onToggle: b,
    isControlled: f,
    getButtonProps: y,
    getDisclosureProps: x
  };
}
function Fee(e) {
  const { ref: t, handler: n, enabled: r = !0 } = e, o = qi(n), a = Re({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }).current;
  Oe(() => {
    if (!r)
      return;
    const l = (p) => {
      ec(p, t) && (a.isPointerDown = !0);
    }, c = (p) => {
      if (a.ignoreEmulatedMouseEvents) {
        a.ignoreEmulatedMouseEvents = !1;
        return;
      }
      a.isPointerDown && n && ec(p, t) && (a.isPointerDown = !1, o(p));
    }, u = (p) => {
      a.ignoreEmulatedMouseEvents = !0, n && a.isPointerDown && ec(p, t) && (a.isPointerDown = !1, o(p));
    }, f = JA(t.current);
    return f.addEventListener("mousedown", l, !0), f.addEventListener("mouseup", c, !0), f.addEventListener("touchstart", l, !0), f.addEventListener("touchend", u, !0), () => {
      f.removeEventListener("mousedown", l, !0), f.removeEventListener("mouseup", c, !0), f.removeEventListener("touchstart", l, !0), f.removeEventListener("touchend", u, !0);
    };
  }, [n, t, o, a, r]);
}
function ec(e, t) {
  var n;
  const r = e.target;
  return r && !JA(r).contains(r) ? !1 : !((n = t.current) != null && n.contains(r));
}
function JA(e) {
  var t;
  return (t = e?.ownerDocument) != null ? t : document;
}
function QA(e) {
  const { isOpen: t, ref: n } = e, [r, o] = ze(t), [i, a] = ze(!1);
  return Oe(() => {
    i || (o(t), a(!0));
  }, [t, i, r]), us(
    () => n.current,
    "animationend",
    () => {
      o(t);
    }
  ), {
    present: !(t ? !1 : !r),
    onComplete() {
      var c;
      const u = Mq(n.current), f = new u.CustomEvent("animationend", { bubbles: !0 });
      (c = n.current) == null || c.dispatchEvent(f);
    }
  };
}
function qA(e) {
  const { wasSelected: t, enabled: n, isSelected: r, mode: o = "unmount" } = e;
  return !!(!n || r || o === "keepMounted" && t);
}
var [
  Pee,
  Vee,
  Hee,
  Oee
] = RT(), [Nee, n3] = tn({
  strict: !1,
  name: "MenuContext"
});
function Dee(e, ...t) {
  const n = dr(), r = e || n;
  return we(() => t.map((o) => `${o}-${r}`), [r, t]);
}
function KA(e) {
  var t;
  return (t = e?.ownerDocument) != null ? t : document;
}
function Cv(e) {
  return KA(e).activeElement === e;
}
function Zee(e = {}) {
  const {
    id: t,
    closeOnSelect: n = !0,
    closeOnBlur: r = !0,
    initialFocusRef: o,
    autoSelect: i = !0,
    isLazy: a,
    isOpen: l,
    defaultIsOpen: c,
    onClose: u,
    onOpen: f,
    placement: p = "bottom-start",
    lazyBehavior: h = "unmount",
    direction: C,
    computePositionOnMount: v = !1,
    ...b
  } = e, y = Re(null), x = Re(null), T = Hee(), A = se(() => {
    requestAnimationFrame(() => {
      var fe;
      (fe = y.current) == null || fe.focus({ preventScroll: !1 });
    });
  }, []), L = se(() => {
    const fe = setTimeout(() => {
      var xe;
      if (o)
        (xe = o.current) == null || xe.focus();
      else {
        const Te = T.firstEnabled();
        Te && ae(Te.index);
      }
    });
    Me.current.add(fe);
  }, [T, o]), I = se(() => {
    const fe = setTimeout(() => {
      const xe = T.lastEnabled();
      xe && ae(xe.index);
    });
    Me.current.add(fe);
  }, [T]), M = se(() => {
    f?.(), i ? L() : A();
  }, [i, L, A, f]), { isOpen: k, onOpen: _, onClose: F, onToggle: $ } = dp({
    isOpen: l,
    defaultIsOpen: c,
    onClose: u,
    onOpen: M
  });
  Fee({
    enabled: k && r,
    ref: y,
    handler: (fe) => {
      var xe;
      (xe = x.current) != null && xe.contains(fe.target) || F();
    }
  });
  const oe = up({
    ...b,
    enabled: k || v,
    placement: p,
    direction: C
  }), [te, ae] = ze(-1);
  vs(() => {
    k || ae(-1);
  }, [k]), DA(y, {
    focusRef: x,
    visible: k,
    shouldFocus: !0
  });
  const be = QA({ isOpen: k, ref: y }), [K, ue] = Dee(t, "menu-button", "menu-list"), J = se(() => {
    _(), A();
  }, [_, A]), Me = Re(/* @__PURE__ */ new Set([]));
  Yee(() => {
    Me.current.forEach((fe) => clearTimeout(fe)), Me.current.clear();
  });
  const _e = se(() => {
    _(), L();
  }, [L, _]), ne = se(() => {
    _(), I();
  }, [_, I]), ee = se(() => {
    var fe, xe;
    const Te = KA(y.current), Ie = (fe = y.current) == null ? void 0 : fe.contains(Te.activeElement);
    if (!(k && !Ie))
      return;
    const pe = (xe = T.item(te)) == null ? void 0 : xe.node;
    pe?.focus();
  }, [k, te, T]), ye = Re(null);
  return {
    openAndFocusMenu: J,
    openAndFocusFirstItem: _e,
    openAndFocusLastItem: ne,
    onTransitionEnd: ee,
    unstable__animationState: be,
    descendants: T,
    popper: oe,
    buttonId: K,
    menuId: ue,
    forceUpdate: oe.forceUpdate,
    orientation: "vertical",
    isOpen: k,
    onToggle: $,
    onOpen: _,
    onClose: F,
    menuRef: y,
    buttonRef: x,
    focusedIndex: te,
    closeOnSelect: n,
    closeOnBlur: r,
    autoSelect: i,
    setFocusedIndex: ae,
    isLazy: a,
    lazyBehavior: h,
    initialFocusRef: o,
    rafId: ye
  };
}
function zee(e = {}, t = null) {
  const n = n3(), { onToggle: r, popper: o, openAndFocusFirstItem: i, openAndFocusLastItem: a } = n, l = se(
    (c) => {
      const u = c.key, p = {
        Enter: i,
        ArrowDown: i,
        ArrowUp: a
      }[u];
      p && (c.preventDefault(), c.stopPropagation(), p(c));
    },
    [i, a]
  );
  return {
    ...e,
    ref: Kt(n.buttonRef, t, o.referenceRef),
    id: n.buttonId,
    "data-active": Xi(n.isOpen),
    "aria-expanded": n.isOpen,
    "aria-haspopup": "menu",
    "aria-controls": n.menuId,
    onClick: it(e.onClick, r),
    onKeyDown: it(e.onKeyDown, l)
  };
}
function Ru(e) {
  var t;
  return jee(e) && !!((t = e?.getAttribute("role")) != null && t.startsWith("menuitem"));
}
function Gee(e = {}, t = null) {
  const n = n3();
  if (!n)
    throw new Error(
      "useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>"
    );
  const {
    focusedIndex: r,
    setFocusedIndex: o,
    menuRef: i,
    isOpen: a,
    onClose: l,
    menuId: c,
    isLazy: u,
    lazyBehavior: f,
    unstable__animationState: p
  } = n, h = Vee(), C = aK({
    preventDefault: (x) => x.key !== " " && Ru(x.target)
  }), v = se(
    (x) => {
      if (!x.currentTarget.contains(x.target))
        return;
      const T = x.key, L = {
        Tab: (M) => M.preventDefault(),
        Escape: l,
        ArrowDown: () => {
          const M = h.nextEnabled(r);
          M && o(M.index);
        },
        ArrowUp: () => {
          const M = h.prevEnabled(r);
          M && o(M.index);
        }
      }[T];
      if (L) {
        x.preventDefault(), L(x);
        return;
      }
      const I = C((M) => {
        const k = sK(
          h.values(),
          M,
          (_) => {
            var F, $;
            return ($ = (F = _?.node) == null ? void 0 : F.textContent) != null ? $ : "";
          },
          h.item(r)
        );
        if (k) {
          const _ = h.indexOf(k.node);
          o(_);
        }
      });
      Ru(x.target) && I(x);
    },
    [
      h,
      r,
      C,
      l,
      o
    ]
  ), b = Re(!1);
  a && (b.current = !0);
  const y = qA({
    wasSelected: b.current,
    enabled: u,
    mode: f,
    isSelected: p.present
  });
  return {
    ...e,
    ref: Kt(i, t),
    children: y ? e.children : null,
    tabIndex: -1,
    role: "menu",
    id: c,
    style: {
      ...e.style,
      transformOrigin: "var(--popper-transform-origin)"
    },
    "aria-orientation": "vertical",
    onKeyDown: it(e.onKeyDown, v)
  };
}
function Wee(e = {}) {
  const { popper: t, isOpen: n } = n3();
  return t.getPopperProps({
    ...e,
    style: {
      visibility: n ? "visible" : "hidden",
      ...e.style
    }
  });
}
function eI(e = {}, t = null) {
  const {
    onMouseEnter: n,
    onMouseMove: r,
    onMouseLeave: o,
    onClick: i,
    onFocus: a,
    isDisabled: l,
    isFocusable: c,
    closeOnSelect: u,
    type: f,
    ...p
  } = e, h = n3(), {
    setFocusedIndex: C,
    focusedIndex: v,
    closeOnSelect: b,
    onClose: y,
    menuRef: x,
    isOpen: T,
    menuId: A,
    rafId: L
  } = h, I = Re(null), M = `${A}-menuitem-${dr()}`, { index: k, register: _ } = Oee({
    disabled: l && !c
  }), F = se(
    (J) => {
      n?.(J), !l && C(k);
    },
    [C, k, l, n]
  ), $ = se(
    (J) => {
      r?.(J), I.current && !Cv(I.current) && F(J);
    },
    [F, r]
  ), oe = se(
    (J) => {
      o?.(J), !l && C(-1);
    },
    [C, l, o]
  ), te = se(
    (J) => {
      i?.(J), Ru(J.currentTarget) && (u ?? b) && y();
    },
    [y, i, b, u]
  ), ae = se(
    (J) => {
      a?.(J), C(k);
    },
    [C, a, k]
  ), be = k === v, K = l && !c;
  vs(() => {
    T && (be && !K && I.current ? (L.current && cancelAnimationFrame(L.current), L.current = requestAnimationFrame(() => {
      var J;
      (J = I.current) == null || J.focus(), L.current = null;
    })) : x.current && !Cv(x.current) && x.current.focus({ preventScroll: !0 }));
  }, [be, K, x, T]);
  const ue = cK({
    onClick: te,
    onFocus: ae,
    onMouseEnter: F,
    onMouseMove: $,
    onMouseLeave: oe,
    ref: Kt(_, I, t),
    isDisabled: l,
    isFocusable: c
  });
  return {
    ...p,
    ...ue,
    type: f ?? ue.type,
    id: M,
    role: "menuitem",
    tabIndex: be ? 0 : -1
  };
}
function $ee(e = {}, t = null) {
  const { type: n = "radio", isChecked: r, ...o } = e;
  return {
    ...eI(o, t),
    role: `menuitem${n}`,
    "aria-checked": r
  };
}
function Uee(e = {}) {
  const {
    children: t,
    type: n = "radio",
    value: r,
    defaultValue: o,
    onChange: i,
    ...a
  } = e, c = n === "radio" ? "" : [], [u, f] = _J({
    defaultValue: o ?? c,
    value: r,
    onChange: i
  }), p = se(
    (v) => {
      if (n === "radio" && typeof u == "string" && f(v), n === "checkbox" && Array.isArray(u)) {
        const b = u.includes(v) ? u.filter((y) => y !== v) : u.concat(v);
        f(b);
      }
    },
    [u, f, n]
  ), C = Pf(t).map((v) => {
    if (v.type.id !== "MenuItemOption")
      return v;
    const b = (x) => {
      var T, A;
      p(v.props.value), (A = (T = v.props).onClick) == null || A.call(T, x);
    }, y = n === "radio" ? v.props.value === u : u.includes(v.props.value);
    return ko(v, {
      type: n,
      onClick: b,
      isChecked: y
    });
  });
  return {
    ...a,
    children: C
  };
}
function jee(e) {
  var t;
  if (!Xee(e))
    return !1;
  const n = (t = e.ownerDocument.defaultView) != null ? t : window;
  return e instanceof n.HTMLElement;
}
function Xee(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function Yee(e, t = []) {
  return Oe(
    () => () => e(),
    t
  );
}
var [Jee, r3] = tn({
  name: "MenuStylesContext",
  errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
}), fp = (e) => {
  const { children: t } = e, n = i2("Menu", e), r = fr(e), { direction: o } = Xe(), { descendants: i, ...a } = Zee({ ...r, direction: o }), l = we(() => a, [a]), { isOpen: c, onClose: u, forceUpdate: f } = l;
  return /* @__PURE__ */ g(Pee, { value: i, children: /* @__PURE__ */ g(Nee, { value: l, children: /* @__PURE__ */ g(Jee, { value: n, children: Er(t, { isOpen: c, onClose: u, forceUpdate: f }) }) }) });
};
fp.displayName = "Menu";
var tI = Le(
  (e, t) => {
    const n = r3();
    return /* @__PURE__ */ g(
      je.span,
      {
        ref: t,
        ...e,
        __css: n.command,
        className: "chakra-menu__command"
      }
    );
  }
);
tI.displayName = "MenuCommand";
var nI = Le(
  (e, t) => {
    const { type: n, ...r } = e, o = r3(), i = r.as || n ? n ?? void 0 : "button", a = we(
      () => ({
        textDecoration: "none",
        color: "inherit",
        userSelect: "none",
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "start",
        flex: "0 0 auto",
        outline: 0,
        ...o.item
      }),
      [o.item]
    );
    return /* @__PURE__ */ g(je.button, { ref: t, type: i, ...r, __css: a });
  }
), pp = (e) => {
  const { className: t, children: n, ...r } = e, o = Ps.only(n), i = G0(o) ? ko(o, {
    focusable: "false",
    "aria-hidden": !0,
    className: v1("chakra-menu__icon", o.props.className)
  }) : null, a = v1("chakra-menu__icon-wrapper", t);
  return /* @__PURE__ */ g(
    je.span,
    {
      className: a,
      ...r,
      __css: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
      },
      children: i
    }
  );
};
pp.displayName = "MenuIcon";
var rI = Le((e, t) => {
  const {
    icon: n,
    iconSpacing: r = "0.75rem",
    command: o,
    commandSpacing: i = "0.75rem",
    children: a,
    ...l
  } = e, c = eI(l, t), f = n || o ? /* @__PURE__ */ g("span", { style: { pointerEvents: "none", flex: 1 }, children: a }) : a;
  return /* @__PURE__ */ X(
    nI,
    {
      ...c,
      className: v1("chakra-menu__menuitem", c.className),
      children: [
        n && /* @__PURE__ */ g(pp, { fontSize: "0.8em", marginEnd: r, children: n }),
        f,
        o && /* @__PURE__ */ g(tI, { marginStart: i, children: o })
      ]
    }
  );
});
rI.displayName = "MenuItem";
var Qee = {
  enter: {
    visibility: "visible",
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    transitionEnd: {
      visibility: "hidden"
    },
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.1,
      easings: "easeOut"
    }
  }
}, qee = je(Po.div), hp = Le(function(t, n) {
  var r, o;
  const { rootProps: i, motionProps: a, ...l } = t, {
    isOpen: c,
    onTransitionEnd: u,
    unstable__animationState: f
  } = n3(), p = Gee(l, n), h = Wee(i), C = r3();
  return /* @__PURE__ */ g(
    je.div,
    {
      ...h,
      __css: { zIndex: (o = t.zIndex) != null ? o : (r = C.list) == null ? void 0 : r.zIndex },
      children: /* @__PURE__ */ g(
        qee,
        {
          variants: Qee,
          initial: !1,
          animate: c ? "enter" : "exit",
          __css: { outline: 0, ...C.list },
          ...a,
          className: v1("chakra-menu__menu-list", p.className),
          ...p,
          onUpdate: u,
          onAnimationComplete: yw(
            f.onComplete,
            p.onAnimationComplete
          )
        }
      )
    }
  );
});
hp.displayName = "MenuList";
var oI = Le((e, t) => {
  const { title: n, children: r, className: o, ...i } = e, a = v1("chakra-menu__group__title", o), l = r3();
  return /* @__PURE__ */ X("div", { ref: t, className: "chakra-menu__group", role: "group", children: [
    n && /* @__PURE__ */ g(je.p, { className: a, ...i, __css: l.groupTitle, children: n }),
    r
  ] });
});
oI.displayName = "MenuGroup";
var iI = (e) => {
  const { className: t, title: n, ...r } = e, o = Uee(r);
  return /* @__PURE__ */ g(
    oI,
    {
      title: n,
      className: v1("chakra-menu__option-group", t),
      ...o
    }
  );
};
iI.displayName = "MenuOptionGroup";
var Kee = Le((e, t) => {
  const n = r3();
  return /* @__PURE__ */ g(
    je.button,
    {
      ref: t,
      ...e,
      __css: {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        outline: 0,
        ...n.button
      }
    }
  );
}), mp = Le(
  (e, t) => {
    const { children: n, as: r, ...o } = e, i = zee(o, t);
    return /* @__PURE__ */ g(
      r || Kee,
      {
        ...i,
        className: v1("chakra-menu__menu-button", e.className),
        children: /* @__PURE__ */ g(
          je.span,
          {
            __css: { pointerEvents: "none", flex: "1 1 auto", minW: 0 },
            children: e.children
          }
        )
      }
    );
  }
);
mp.displayName = "MenuButton";
var e1e = (e) => /* @__PURE__ */ g("svg", { viewBox: "0 0 14 14", width: "1em", height: "1em", ...e, children: /* @__PURE__ */ g(
  "polygon",
  {
    fill: "currentColor",
    points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
  }
) }), Cp = Le(
  (e, t) => {
    const { icon: n, iconSpacing: r = "0.75rem", ...o } = e, i = $ee(o, t);
    return /* @__PURE__ */ X(
      nI,
      {
        ...i,
        className: v1("chakra-menu__menuitem-option", o.className),
        children: [
          n !== null && /* @__PURE__ */ g(
            pp,
            {
              fontSize: "0.8em",
              marginEnd: r,
              opacity: e.isChecked ? 1 : 0,
              children: n || /* @__PURE__ */ g(e1e, {})
            }
          ),
          /* @__PURE__ */ g("span", { style: { flex: 1 }, children: i.children })
        ]
      }
    );
  }
);
Cp.id = "MenuItemOption";
Cp.displayName = "MenuItemOption";
var t1e = {
  slideInBottom: {
    ...xu,
    custom: { offsetY: 16, reverse: !0 }
  },
  slideInRight: {
    ...xu,
    custom: { offsetX: 16, reverse: !0 }
  },
  scale: {
    ...OT,
    custom: { initialScale: 0.95, reverse: !0 }
  },
  none: {}
}, n1e = je(Po.section), r1e = (e) => t1e[e || "none"], aI = ro(
  (e, t) => {
    const { preset: n, motionProps: r = r1e(n), ...o } = e;
    return /* @__PURE__ */ g(n1e, { ref: t, ...r, ...o });
  }
);
aI.displayName = "ModalTransition";
var o1e = Object.defineProperty, i1e = (e, t, n) => t in e ? o1e(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, a1e = (e, t, n) => (i1e(e, t + "", n), n), s1e = class {
  constructor() {
    a1e(this, "modals"), this.modals = /* @__PURE__ */ new Map();
  }
  add(e) {
    return this.modals.set(e, this.modals.size + 1), this.modals.size;
  }
  remove(e) {
    this.modals.delete(e);
  }
  isTopModal(e) {
    return e ? this.modals.get(e) === this.modals.size : !1;
  }
}, _u = new s1e();
function sI(e, t) {
  const [n, r] = ze(0);
  return Oe(() => {
    const o = e.current;
    if (o) {
      if (t) {
        const i = _u.add(o);
        r(i);
      }
      return () => {
        _u.remove(o), r(0);
      };
    }
  }, [t, e]), n;
}
var l1e = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, U2 = /* @__PURE__ */ new WeakMap(), K4 = /* @__PURE__ */ new WeakMap(), el = {}, tc = 0, lI = function(e) {
  return e && (e.host || lI(e.parentNode));
}, c1e = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = lI(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, u1e = function(e, t, n, r) {
  var o = c1e(t, Array.isArray(e) ? e : [e]);
  el[n] || (el[n] = /* @__PURE__ */ new WeakMap());
  var i = el[n], a = [], l = /* @__PURE__ */ new Set(), c = new Set(o), u = function(p) {
    !p || l.has(p) || (l.add(p), u(p.parentNode));
  };
  o.forEach(u);
  var f = function(p) {
    !p || c.has(p) || Array.prototype.forEach.call(p.children, function(h) {
      if (l.has(h))
        f(h);
      else
        try {
          var C = h.getAttribute(r), v = C !== null && C !== "false", b = (U2.get(h) || 0) + 1, y = (i.get(h) || 0) + 1;
          U2.set(h, b), i.set(h, y), a.push(h), b === 1 && v && K4.set(h, !0), y === 1 && h.setAttribute(n, "true"), v || h.setAttribute(r, "true");
        } catch (x) {
          console.error("aria-hidden: cannot operate on ", h, x);
        }
    });
  };
  return f(t), l.clear(), tc++, function() {
    a.forEach(function(p) {
      var h = U2.get(p) - 1, C = i.get(p) - 1;
      U2.set(p, h), i.set(p, C), h || (K4.has(p) || p.removeAttribute(r), K4.delete(p)), C || p.removeAttribute(n);
    }), tc--, tc || (U2 = /* @__PURE__ */ new WeakMap(), U2 = /* @__PURE__ */ new WeakMap(), K4 = /* @__PURE__ */ new WeakMap(), el = {});
  };
}, d1e = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = l1e(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), u1e(r, o, n, "aria-hidden")) : function() {
    return null;
  };
};
function f1e(e) {
  const {
    isOpen: t,
    onClose: n,
    id: r,
    closeOnOverlayClick: o = !0,
    closeOnEsc: i = !0,
    useInert: a = !0,
    onOverlayClick: l,
    onEsc: c
  } = e, u = Re(null), f = Re(null), [p, h, C] = h1e(
    r,
    "chakra-modal",
    "chakra-modal--header",
    "chakra-modal--body"
  );
  p1e(u, t && a);
  const v = sI(u, t), b = Re(null), y = se((F) => {
    b.current = F.target;
  }, []), x = se(
    (F) => {
      F.key === "Escape" && (F.stopPropagation(), i && n?.(), c?.());
    },
    [i, n, c]
  ), [T, A] = ze(!1), [L, I] = ze(!1), M = se(
    (F = {}, $ = null) => ({
      role: "dialog",
      ...F,
      ref: Kt($, u),
      id: p,
      tabIndex: -1,
      "aria-modal": !0,
      "aria-labelledby": T ? h : void 0,
      "aria-describedby": L ? C : void 0,
      onClick: it(
        F.onClick,
        (oe) => oe.stopPropagation()
      )
    }),
    [C, L, p, h, T]
  ), k = se(
    (F) => {
      F.stopPropagation(), b.current === F.target && _u.isTopModal(u.current) && (o && n?.(), l?.());
    },
    [n, o, l]
  ), _ = se(
    (F = {}, $ = null) => ({
      ...F,
      ref: Kt($, f),
      onClick: it(F.onClick, k),
      onKeyDown: it(F.onKeyDown, x),
      onMouseDown: it(F.onMouseDown, y)
    }),
    [x, y, k]
  );
  return {
    isOpen: t,
    onClose: n,
    headerId: h,
    bodyId: C,
    setBodyMounted: I,
    setHeaderMounted: A,
    dialogRef: u,
    overlayRef: f,
    getDialogProps: M,
    getDialogContainerProps: _,
    index: v
  };
}
function p1e(e, t) {
  const n = e.current;
  Oe(() => {
    if (!(!e.current || !t))
      return d1e(e.current);
  }, [t, e, n]);
}
function h1e(e, ...t) {
  const n = dr(), r = e || n;
  return we(() => t.map((o) => `${o}-${r}`), [r, t]);
}
var [m1e, o3] = tn({
  name: "ModalStylesContext",
  errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
}), [C1e, Ms] = tn({
  strict: !0,
  name: "ModalContext",
  errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
}), i3 = (e) => {
  const t = {
    scrollBehavior: "outside",
    autoFocus: !0,
    trapFocus: !0,
    returnFocusOnClose: !0,
    blockScrollOnMount: !0,
    allowPinchZoom: !1,
    motionPreset: "scale",
    lockFocusAcrossFrames: !0,
    ...e
  }, {
    portalProps: n,
    children: r,
    autoFocus: o,
    trapFocus: i,
    initialFocusRef: a,
    finalFocusRef: l,
    returnFocusOnClose: c,
    blockScrollOnMount: u,
    allowPinchZoom: f,
    preserveScrollBarGap: p,
    motionPreset: h,
    lockFocusAcrossFrames: C,
    onCloseComplete: v
  } = t, b = i2("Modal", t), x = {
    ...f1e(t),
    autoFocus: o,
    trapFocus: i,
    initialFocusRef: a,
    finalFocusRef: l,
    returnFocusOnClose: c,
    blockScrollOnMount: u,
    allowPinchZoom: f,
    preserveScrollBarGap: p,
    motionPreset: h,
    lockFocusAcrossFrames: C
  };
  return /* @__PURE__ */ g(C1e, { value: x, children: /* @__PURE__ */ g(m1e, { value: b, children: /* @__PURE__ */ g(l2, { onExitComplete: v, children: x.isOpen && /* @__PURE__ */ g(o2, { ...n, children: r }) }) }) });
};
i3.displayName = "Modal";
var Ll = "right-scroll-bar-position", El = "width-before-scroll-bar", g1e = "with-scroll-bars-hidden", b1e = "--removed-body-scroll-bar-size", cI = KT(), nc = function() {
}, Y9 = Se.forwardRef(function(e, t) {
  var n = Se.useRef(null), r = Se.useState({
    onScrollCapture: nc,
    onWheelCapture: nc,
    onTouchMoveCapture: nc
  }), o = r[0], i = r[1], a = e.forwardProps, l = e.children, c = e.className, u = e.removeScrollBar, f = e.enabled, p = e.shards, h = e.sideCar, C = e.noIsolation, v = e.inert, b = e.allowPinchZoom, y = e.as, x = y === void 0 ? "div" : y, T = e.gapMode, A = JT(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), L = h, I = YT([n, t]), M = xo(xo({}, A), o);
  return Se.createElement(
    Se.Fragment,
    null,
    f && Se.createElement(L, { sideCar: cI, removeScrollBar: u, shards: p, noIsolation: C, inert: v, setCallbacks: i, allowPinchZoom: !!b, lockRef: n, gapMode: T }),
    a ? Se.cloneElement(Se.Children.only(l), xo(xo({}, M), { ref: I })) : Se.createElement(x, xo({}, M, { className: c, ref: I }), l)
  );
});
Y9.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Y9.classNames = {
  fullWidth: El,
  zeroRight: Ll
};
var v1e = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function y1e() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = v1e();
  return t && e.setAttribute("nonce", t), e;
}
function x1e(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function w1e(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var S1e = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = y1e()) && (x1e(t, n), w1e(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, T1e = function() {
  var e = S1e();
  return function(t, n) {
    Se.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, uI = function() {
  var e = T1e(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, A1e = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, rc = function(e) {
  return parseInt(e || "", 10) || 0;
}, I1e = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [rc(n), rc(r), rc(o)];
}, L1e = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return A1e;
  var t = I1e(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, E1e = uI(), ps = "data-scroll-locked", M1e = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, l = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(g1e, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(l, "px ").concat(r, `;
  }
  body[`).concat(ps, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(l, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ll, ` {
    right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(El, ` {
    margin-right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(Ll, " .").concat(Ll, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(El, " .").concat(El, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(ps, `] {
    `).concat(b1e, ": ").concat(l, `px;
  }
`);
}, gv = function() {
  var e = parseInt(document.body.getAttribute(ps) || "0", 10);
  return isFinite(e) ? e : 0;
}, B1e = function() {
  Se.useEffect(function() {
    return document.body.setAttribute(ps, (gv() + 1).toString()), function() {
      var e = gv() - 1;
      e <= 0 ? document.body.removeAttribute(ps) : document.body.setAttribute(ps, e.toString());
    };
  }, []);
}, k1e = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  B1e();
  var i = Se.useMemo(function() {
    return L1e(o);
  }, [o]);
  return Se.createElement(E1e, { styles: M1e(i, !t, o, n ? "" : "!important") });
}, Fu = !1;
if (typeof window < "u")
  try {
    var tl = Object.defineProperty({}, "passive", {
      get: function() {
        return Fu = !0, !0;
      }
    });
    window.addEventListener("test", tl, tl), window.removeEventListener("test", tl, tl);
  } catch {
    Fu = !1;
  }
var j2 = Fu ? { passive: !1 } : !1, R1e = function(e) {
  return e.tagName === "TEXTAREA";
}, dI = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !R1e(e) && n[t] === "visible")
  );
}, _1e = function(e) {
  return dI(e, "overflowY");
}, F1e = function(e) {
  return dI(e, "overflowX");
}, bv = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = fI(e, r);
    if (o) {
      var i = pI(e, r), a = i[1], l = i[2];
      if (a > l)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, P1e = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, V1e = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, fI = function(e, t) {
  return e === "v" ? _1e(t) : F1e(t);
}, pI = function(e, t) {
  return e === "v" ? P1e(t) : V1e(t);
}, H1e = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, O1e = function(e, t, n, r, o) {
  var i = H1e(e, window.getComputedStyle(t).direction), a = i * r, l = n.target, c = t.contains(l), u = !1, f = a > 0, p = 0, h = 0;
  do {
    var C = pI(e, l), v = C[0], b = C[1], y = C[2], x = b - y - i * v;
    (v || x) && fI(e, l) && (p += x, h += v), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (t.contains(l) || t === l)
  );
  return (f && (Math.abs(p) < 1 || !o) || !f && (Math.abs(h) < 1 || !o)) && (u = !0), u;
}, nl = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, vv = function(e) {
  return [e.deltaX, e.deltaY];
}, yv = function(e) {
  return e && "current" in e ? e.current : e;
}, N1e = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, D1e = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Z1e = 0, X2 = [];
function z1e(e) {
  var t = Se.useRef([]), n = Se.useRef([0, 0]), r = Se.useRef(), o = Se.useState(Z1e++)[0], i = Se.useState(uI)[0], a = Se.useRef(e);
  Se.useEffect(function() {
    a.current = e;
  }, [e]), Se.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var b = xQ([e.lockRef.current], (e.shards || []).map(yv), !0).filter(Boolean);
      return b.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), b.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = Se.useCallback(function(b, y) {
    if ("touches" in b && b.touches.length === 2 || b.type === "wheel" && b.ctrlKey)
      return !a.current.allowPinchZoom;
    var x = nl(b), T = n.current, A = "deltaX" in b ? b.deltaX : T[0] - x[0], L = "deltaY" in b ? b.deltaY : T[1] - x[1], I, M = b.target, k = Math.abs(A) > Math.abs(L) ? "h" : "v";
    if ("touches" in b && k === "h" && M.type === "range")
      return !1;
    var _ = bv(k, M);
    if (!_)
      return !0;
    if (_ ? I = k : (I = k === "v" ? "h" : "v", _ = bv(k, M)), !_)
      return !1;
    if (!r.current && "changedTouches" in b && (A || L) && (r.current = I), !I)
      return !0;
    var F = r.current || I;
    return O1e(F, y, b, F === "h" ? A : L, !0);
  }, []), c = Se.useCallback(function(b) {
    var y = b;
    if (!(!X2.length || X2[X2.length - 1] !== i)) {
      var x = "deltaY" in y ? vv(y) : nl(y), T = t.current.filter(function(I) {
        return I.name === y.type && (I.target === y.target || y.target === I.shadowParent) && N1e(I.delta, x);
      })[0];
      if (T && T.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!T) {
        var A = (a.current.shards || []).map(yv).filter(Boolean).filter(function(I) {
          return I.contains(y.target);
        }), L = A.length > 0 ? l(y, A[0]) : !a.current.noIsolation;
        L && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = Se.useCallback(function(b, y, x, T) {
    var A = { name: b, delta: y, target: x, should: T, shadowParent: G1e(x) };
    t.current.push(A), setTimeout(function() {
      t.current = t.current.filter(function(L) {
        return L !== A;
      });
    }, 1);
  }, []), f = Se.useCallback(function(b) {
    n.current = nl(b), r.current = void 0;
  }, []), p = Se.useCallback(function(b) {
    u(b.type, vv(b), b.target, l(b, e.lockRef.current));
  }, []), h = Se.useCallback(function(b) {
    u(b.type, nl(b), b.target, l(b, e.lockRef.current));
  }, []);
  Se.useEffect(function() {
    return X2.push(i), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", c, j2), document.addEventListener("touchmove", c, j2), document.addEventListener("touchstart", f, j2), function() {
      X2 = X2.filter(function(b) {
        return b !== i;
      }), document.removeEventListener("wheel", c, j2), document.removeEventListener("touchmove", c, j2), document.removeEventListener("touchstart", f, j2);
    };
  }, []);
  var C = e.removeScrollBar, v = e.inert;
  return Se.createElement(
    Se.Fragment,
    null,
    v ? Se.createElement(i, { styles: D1e(o) }) : null,
    C ? Se.createElement(k1e, { gapMode: e.gapMode }) : null
  );
}
function G1e(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const W1e = wQ(cI, z1e);
var hI = Se.forwardRef(function(e, t) {
  return Se.createElement(Y9, xo({}, e, { ref: t, sideCar: W1e }));
});
hI.classNames = Y9.classNames;
function $1e(e) {
  const {
    autoFocus: t,
    trapFocus: n,
    dialogRef: r,
    initialFocusRef: o,
    blockScrollOnMount: i,
    allowPinchZoom: a,
    finalFocusRef: l,
    returnFocusOnClose: c,
    preserveScrollBarGap: u,
    lockFocusAcrossFrames: f,
    isOpen: p
  } = Ms(), [h, C] = uT();
  Oe(() => {
    !h && C && setTimeout(C);
  }, [h, C]);
  const v = sI(r, p);
  return /* @__PURE__ */ g(
    PA,
    {
      autoFocus: t,
      isDisabled: !n,
      initialFocusRef: o,
      finalFocusRef: l,
      restoreFocus: c,
      contentRef: r,
      lockFocusAcrossFrames: f,
      children: /* @__PURE__ */ g(
        hI,
        {
          removeScrollBar: !u,
          allowPinchZoom: a,
          enabled: v === 1 && i,
          forwardProps: !0,
          children: e.children
        }
      )
    }
  );
}
var a3 = Le(
  (e, t) => {
    const {
      className: n,
      children: r,
      containerProps: o,
      motionProps: i,
      ...a
    } = e, { getDialogProps: l, getDialogContainerProps: c } = Ms(), u = l(a, t), f = c(o), p = v1("chakra-modal__content", n), h = o3(), C = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...h.dialog
    }, v = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...h.dialogContainer
    }, { motionPreset: b } = Ms();
    return /* @__PURE__ */ g($1e, { children: /* @__PURE__ */ g(
      je.div,
      {
        ...f,
        className: "chakra-modal__content-container",
        tabIndex: -1,
        __css: v,
        children: /* @__PURE__ */ g(
          aI,
          {
            preset: b,
            motionProps: i,
            className: p,
            ...u,
            __css: C,
            children: r
          }
        )
      }
    ) });
  }
);
a3.displayName = "ModalContent";
var mI = Le(
  (e, t) => {
    const { className: n, ...r } = e, o = v1("chakra-modal__footer", n), a = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      ...o3().footer
    };
    return /* @__PURE__ */ g(
      je.footer,
      {
        ref: t,
        ...r,
        __css: a,
        className: o
      }
    );
  }
);
mI.displayName = "ModalFooter";
var U1e = je(Po.div), s3 = Le(
  (e, t) => {
    const { className: n, transition: r, motionProps: o, ...i } = e, a = v1("chakra-modal__overlay", n), c = {
      pos: "fixed",
      left: "0",
      top: "0",
      w: "100vw",
      h: "100vh",
      ...o3().overlay
    }, { motionPreset: u } = Ms();
    return /* @__PURE__ */ g(
      U1e,
      {
        ...o || (u === "none" ? {} : HT),
        __css: c,
        ref: t,
        className: a,
        ...i
      }
    );
  }
);
s3.displayName = "ModalOverlay";
var CI = Le((e, t) => {
  const { className: n, ...r } = e, { bodyId: o, setBodyMounted: i } = Ms();
  Oe(() => (i(!0), () => i(!1)), [i]);
  const a = v1("chakra-modal__body", n), l = o3();
  return /* @__PURE__ */ g(
    je.div,
    {
      ref: t,
      className: a,
      id: o,
      ...r,
      __css: l.body
    }
  );
});
CI.displayName = "ModalBody";
var gI = Le(
  (e, t) => {
    const { onClick: n, className: r, ...o } = e, { onClose: i } = Ms(), a = v1("chakra-modal__close-btn", r), l = o3();
    return /* @__PURE__ */ g(
      _f,
      {
        ref: t,
        __css: l.closeButton,
        className: a,
        onClick: it(n, (c) => {
          c.stopPropagation(), i();
        }),
        ...o
      }
    );
  }
);
gI.displayName = "ModalCloseButton";
var [j1e, l3] = tn({
  name: "PopoverContext",
  errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
}), [X1e, gp] = tn({
  name: "PopoverStylesContext",
  errorMessage: `usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Popover />" `
});
function bI(e) {
  const t = Ps.only(e.children), { getTriggerProps: n } = l3();
  return ko(t, n(t.props, t.ref));
}
bI.displayName = "PopoverTrigger";
var Y2 = {
  click: "click",
  hover: "hover"
};
function Y1e(e = {}) {
  const {
    closeOnBlur: t = !0,
    closeOnEsc: n = !0,
    initialFocusRef: r,
    id: o,
    returnFocusOnClose: i = !0,
    autoFocus: a = !0,
    arrowSize: l,
    arrowShadowColor: c,
    trigger: u = Y2.click,
    openDelay: f = 200,
    closeDelay: p = 200,
    isLazy: h,
    lazyBehavior: C = "unmount",
    computePositionOnMount: v,
    ...b
  } = e, { isOpen: y, onClose: x, onOpen: T, onToggle: A } = dp(e), L = Re(null), I = Re(null), M = Re(null), k = Re(!1), _ = Re(!1);
  y && (_.current = !0);
  const [F, $] = ze(!1), [oe, te] = ze(!1), ae = dr(), be = o ?? ae, [K, ue, J, Me] = [
    "popover-trigger",
    "popover-content",
    "popover-header",
    "popover-body"
  ].map((Ye) => `${Ye}-${be}`), {
    referenceRef: _e,
    getArrowProps: ne,
    getPopperProps: ee,
    getArrowInnerProps: ye,
    forceUpdate: fe
  } = up({
    ...b,
    enabled: y || !!v
  }), xe = QA({ isOpen: y, ref: M });
  lQ({
    enabled: y,
    ref: I
  }), DA(M, {
    focusRef: I,
    visible: y,
    shouldFocus: i && u === Y2.click
  }), fK(M, {
    focusRef: r,
    visible: y,
    shouldFocus: a && u === Y2.click
  });
  const Te = qA({
    wasSelected: _.current,
    enabled: h,
    mode: C,
    isSelected: xe.present
  }), Ie = se(
    (Ye = {}, B1 = null) => {
      const Pe = {
        ...Ye,
        style: {
          ...Ye.style,
          transformOrigin: $t.transformOrigin.varRef,
          [$t.arrowSize.var]: l ? `${l}px` : void 0,
          [$t.arrowShadowColor.var]: c
        },
        ref: Kt(M, B1),
        children: Te ? Ye.children : null,
        id: ue,
        tabIndex: -1,
        role: "dialog",
        onKeyDown: it(Ye.onKeyDown, (j1) => {
          n && j1.key === "Escape" && x();
        }),
        onBlur: it(Ye.onBlur, (j1) => {
          const X1 = xv(j1), p1 = oc(M.current, X1), L1 = oc(I.current, X1);
          y && t && (!p1 && !L1) && x();
        }),
        "aria-labelledby": F ? J : void 0,
        "aria-describedby": oe ? Me : void 0
      };
      return u === Y2.hover && (Pe.role = "tooltip", Pe.onMouseEnter = it(Ye.onMouseEnter, () => {
        k.current = !0;
      }), Pe.onMouseLeave = it(
        Ye.onMouseLeave,
        (j1) => {
          j1.nativeEvent.relatedTarget !== null && (k.current = !1, setTimeout(() => x(), p));
        }
      )), Pe;
    },
    [
      Te,
      ue,
      F,
      J,
      oe,
      Me,
      u,
      n,
      x,
      y,
      t,
      p,
      c,
      l
    ]
  ), Q = se(
    (Ye = {}, B1 = null) => ee(
      {
        ...Ye,
        style: {
          visibility: y ? "visible" : "hidden",
          ...Ye.style
        }
      },
      B1
    ),
    [y, ee]
  ), pe = se(
    (Ye, B1 = null) => ({
      ...Ye,
      ref: Kt(B1, L, _e)
    }),
    [L, _e]
  ), me = Re(), Be = Re(), We = se(
    (Ye) => {
      L.current == null && _e(Ye);
    },
    [_e]
  ), ie = se(
    (Ye = {}, B1 = null) => {
      const Pe = {
        ...Ye,
        ref: Kt(I, B1, We),
        id: K,
        "aria-haspopup": "dialog",
        "aria-expanded": y,
        "aria-controls": ue
      };
      return u === Y2.click && (Pe.onClick = it(Ye.onClick, A)), u === Y2.hover && (Pe.onFocus = it(Ye.onFocus, () => {
        me.current === void 0 && T();
      }), Pe.onBlur = it(Ye.onBlur, (j1) => {
        const X1 = xv(j1), p1 = !oc(M.current, X1);
        y && t && p1 && x();
      }), Pe.onKeyDown = it(Ye.onKeyDown, (j1) => {
        j1.key === "Escape" && x();
      }), Pe.onMouseEnter = it(Ye.onMouseEnter, () => {
        k.current = !0, me.current = window.setTimeout(() => T(), f);
      }), Pe.onMouseLeave = it(Ye.onMouseLeave, () => {
        k.current = !1, me.current && (clearTimeout(me.current), me.current = void 0), Be.current = window.setTimeout(() => {
          k.current === !1 && x();
        }, p);
      })), Pe;
    },
    [
      K,
      y,
      ue,
      u,
      We,
      A,
      T,
      t,
      x,
      f,
      p
    ]
  );
  Oe(() => () => {
    me.current && clearTimeout(me.current), Be.current && clearTimeout(Be.current);
  }, []);
  const f1 = se(
    (Ye = {}, B1 = null) => ({
      ...Ye,
      id: J,
      ref: Kt(B1, (Pe) => {
        $(!!Pe);
      })
    }),
    [J]
  ), s1 = se(
    (Ye = {}, B1 = null) => ({
      ...Ye,
      id: Me,
      ref: Kt(B1, (Pe) => {
        te(!!Pe);
      })
    }),
    [Me]
  );
  return {
    forceUpdate: fe,
    isOpen: y,
    onAnimationComplete: xe.onComplete,
    onClose: x,
    getAnchorProps: pe,
    getArrowProps: ne,
    getArrowInnerProps: ye,
    getPopoverPositionerProps: Q,
    getPopoverProps: Ie,
    getTriggerProps: ie,
    getHeaderProps: f1,
    getBodyProps: s1
  };
}
function oc(e, t) {
  return e === t || e?.contains(t);
}
function xv(e) {
  var t;
  const n = e.currentTarget.ownerDocument.activeElement;
  return (t = e.relatedTarget) != null ? t : n;
}
function vI(e) {
  const t = i2("Popover", e), { children: n, ...r } = fr(e), o = Xe(), i = Y1e({ ...r, direction: o.direction });
  return /* @__PURE__ */ g(j1e, { value: i, children: /* @__PURE__ */ g(X1e, { value: t, children: Er(n, {
    isOpen: i.isOpen,
    onClose: i.onClose,
    forceUpdate: i.forceUpdate
  }) }) });
}
vI.displayName = "Popover";
var ic = (e, t) => t ? `${e}.${t}, ${t}` : void 0;
function yI(e) {
  var t;
  const { bg: n, bgColor: r, backgroundColor: o, shadow: i, boxShadow: a, shadowColor: l } = e, { getArrowProps: c, getArrowInnerProps: u } = l3(), f = gp(), p = (t = n ?? r) != null ? t : o, h = i ?? a;
  return /* @__PURE__ */ g(
    je.div,
    {
      ...c(),
      className: "chakra-popover__arrow-positioner",
      children: /* @__PURE__ */ g(
        je.div,
        {
          className: v1("chakra-popover__arrow", e.className),
          ...u(e),
          __css: {
            "--popper-arrow-shadow-color": ic("colors", l),
            "--popper-arrow-bg": ic("colors", p),
            "--popper-arrow-shadow": ic("shadows", h),
            ...f.arrow
          }
        }
      )
    }
  );
}
yI.displayName = "PopoverArrow";
var xI = Le(
  function(t, n) {
    const { getBodyProps: r } = l3(), o = gp();
    return /* @__PURE__ */ g(
      je.div,
      {
        ...r(t, n),
        className: v1("chakra-popover__body", t.className),
        __css: o.body
      }
    );
  }
);
xI.displayName = "PopoverBody";
function J1e(e) {
  if (e)
    return {
      enter: {
        ...e.enter,
        visibility: "visible"
      },
      exit: {
        ...e.exit,
        transitionEnd: {
          visibility: "hidden"
        }
      }
    };
}
var Q1e = {
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
      ease: [0.4, 0, 1, 1]
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.15,
      ease: [0, 0, 0.2, 1]
    }
  }
}, q1e = je(Po.section), wI = Le(function(t, n) {
  const { variants: r = Q1e, ...o } = t, { isOpen: i } = l3();
  return /* @__PURE__ */ g(
    q1e,
    {
      ref: n,
      variants: J1e(r),
      initial: !1,
      animate: i ? "enter" : "exit",
      ...o
    }
  );
});
wI.displayName = "PopoverTransition";
var SI = Le(
  function(t, n) {
    const { rootProps: r, motionProps: o, ...i } = t, { getPopoverProps: a, getPopoverPositionerProps: l, onAnimationComplete: c } = l3(), u = gp(), f = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      ...u.content
    };
    return /* @__PURE__ */ g(
      je.div,
      {
        ...l(r),
        __css: u.popper,
        className: "chakra-popover__popper",
        children: /* @__PURE__ */ g(
          wI,
          {
            ...o,
            ...a(i, n),
            onAnimationComplete: yw(
              c,
              i.onAnimationComplete
            ),
            className: v1("chakra-popover__content", t.className),
            __css: f
          }
        )
      }
    );
  }
);
SI.displayName = "PopoverContent";
function K1e() {
  const e = Re(!0);
  return Oe(() => {
    e.current = !1;
  }, []), e.current;
}
function ete(e) {
  const t = Re();
  return Oe(() => {
    t.current = e;
  }, [e]), t.current;
}
var tte = je("div", {
  baseStyle: {
    boxShadow: "none",
    backgroundClip: "padding-box",
    cursor: "default",
    color: "transparent",
    pointerEvents: "none",
    userSelect: "none",
    "&::before, &::after, *": {
      visibility: "hidden"
    }
  }
}), Pu = a1("skeleton-start-color"), Vu = a1("skeleton-end-color"), nte = W0({
  from: { opacity: 0 },
  to: { opacity: 1 }
}), rte = W0({
  from: {
    borderColor: Pu.reference,
    background: Pu.reference
  },
  to: {
    borderColor: Vu.reference,
    background: Vu.reference
  }
}), Vt = Le((e, t) => {
  const n = {
    ...e,
    fadeDuration: typeof e.fadeDuration == "number" ? e.fadeDuration : 0.4,
    speed: typeof e.speed == "number" ? e.speed : 0.8
  }, r = aa("Skeleton", n), o = K1e(), {
    startColor: i = "",
    endColor: a = "",
    isLoaded: l,
    fadeDuration: c,
    speed: u,
    className: f,
    fitContent: p,
    ...h
  } = fr(n), [C, v] = PH("colors", [
    i,
    a
  ]), b = ete(l), y = v1("chakra-skeleton", f), x = {
    ...C && { [Pu.variable]: C },
    ...v && { [Vu.variable]: v }
  };
  if (l) {
    const T = o || b ? "none" : `${nte} ${c}s`;
    return /* @__PURE__ */ g(
      je.div,
      {
        ref: t,
        className: y,
        __css: { animation: T },
        ...h
      }
    );
  }
  return /* @__PURE__ */ g(
    tte,
    {
      ref: t,
      className: y,
      ...h,
      __css: {
        width: p ? "fit-content" : void 0,
        ...r,
        ...x,
        _dark: { ...r._dark, ...x },
        animation: `${u}s linear infinite alternate ${rte}`
      }
    }
  );
});
Vt.displayName = "Skeleton";
var J9 = ({
  size: e = "2rem",
  ...t
}) => /* @__PURE__ */ g(Vt, { borderRadius: "full", boxSize: e, ...t });
J9.displayName = "SkeletonCircle";
var ote = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: { duration: 0.15, easings: "easeInOut" },
      scale: { duration: 0.2, easings: "easeInOut" }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: { easings: "easeOut", duration: 0.2 },
      scale: { duration: 0.2, ease: [0.175, 0.885, 0.4, 1.1] }
    }
  }
}, Hu = (e) => {
  var t;
  return ((t = e.current) == null ? void 0 : t.ownerDocument) || document;
}, Ml = (e) => {
  var t, n;
  return ((n = (t = e.current) == null ? void 0 : t.ownerDocument) == null ? void 0 : n.defaultView) || window;
};
function ite(e = {}) {
  const {
    openDelay: t = 0,
    closeDelay: n = 0,
    closeOnClick: r = !0,
    closeOnMouseDown: o,
    closeOnScroll: i,
    closeOnPointerDown: a = o,
    closeOnEsc: l = !0,
    onOpen: c,
    onClose: u,
    placement: f,
    id: p,
    isOpen: h,
    defaultIsOpen: C,
    arrowSize: v = 10,
    arrowShadowColor: b,
    arrowPadding: y,
    modifiers: x,
    isDisabled: T,
    gutter: A,
    offset: L,
    direction: I,
    ...M
  } = e, { isOpen: k, onOpen: _, onClose: F } = dp({
    isOpen: h,
    defaultIsOpen: C,
    onOpen: c,
    onClose: u
  }), { referenceRef: $, getPopperProps: oe, getArrowInnerProps: te, getArrowProps: ae } = up({
    enabled: k,
    placement: f,
    arrowPadding: y,
    modifiers: x,
    gutter: A,
    offset: L,
    direction: I
  }), be = dr(), ue = `tooltip-${p ?? be}`, J = Re(null), Me = Re(), _e = se(() => {
    Me.current && (clearTimeout(Me.current), Me.current = void 0);
  }, []), ne = Re(), ee = se(() => {
    ne.current && (clearTimeout(ne.current), ne.current = void 0);
  }, []), ye = se(() => {
    ee(), F();
  }, [F, ee]), fe = ate(J, ye), xe = se(() => {
    if (!T && !Me.current) {
      fe();
      const ie = Ml(J);
      Me.current = ie.setTimeout(_, t);
    }
  }, [fe, T, _, t]), Te = se(() => {
    _e();
    const ie = Ml(J);
    ne.current = ie.setTimeout(ye, n);
  }, [n, ye, _e]), Ie = se(() => {
    k && r && Te();
  }, [r, Te, k]), Q = se(() => {
    k && a && Te();
  }, [a, Te, k]), pe = se(
    (ie) => {
      k && ie.key === "Escape" && Te();
    },
    [k, Te]
  );
  us(
    () => Hu(J),
    "keydown",
    l ? pe : void 0
  ), us(
    () => {
      const ie = J.current;
      if (!ie)
        return null;
      const f1 = BA(ie);
      return f1.localName === "body" ? Ml(J) : f1;
    },
    "scroll",
    () => {
      k && i && ye();
    },
    { passive: !0, capture: !0 }
  ), Oe(() => {
    T && (_e(), k && F());
  }, [T, k, F, _e]), Oe(() => () => {
    _e(), ee();
  }, [_e, ee]), us(() => J.current, "pointerleave", Te);
  const me = se(
    (ie = {}, f1 = null) => ({
      ...ie,
      ref: Kt(J, f1, $),
      onPointerEnter: it(ie.onPointerEnter, (Ye) => {
        Ye.pointerType !== "touch" && xe();
      }),
      onClick: it(ie.onClick, Ie),
      onPointerDown: it(ie.onPointerDown, Q),
      onFocus: it(ie.onFocus, xe),
      onBlur: it(ie.onBlur, Te),
      "aria-describedby": k ? ue : void 0
    }),
    [
      xe,
      Te,
      Q,
      k,
      ue,
      Ie,
      $
    ]
  ), Be = se(
    (ie = {}, f1 = null) => oe(
      {
        ...ie,
        style: {
          ...ie.style,
          [$t.arrowSize.var]: v ? `${v}px` : void 0,
          [$t.arrowShadowColor.var]: b
        }
      },
      f1
    ),
    [oe, v, b]
  ), We = se(
    (ie = {}, f1 = null) => {
      const s1 = {
        ...ie.style,
        position: "relative",
        transformOrigin: $t.transformOrigin.varRef
      };
      return {
        ref: f1,
        ...M,
        ...ie,
        id: ue,
        role: "tooltip",
        style: s1
      };
    },
    [M, ue]
  );
  return {
    isOpen: k,
    show: xe,
    hide: Te,
    getTriggerProps: me,
    getTooltipProps: We,
    getTooltipPositionerProps: Be,
    getArrowProps: ae,
    getArrowInnerProps: te
  };
}
var ac = "chakra-ui:close-tooltip";
function ate(e, t) {
  return Oe(() => {
    const n = Hu(e);
    return n.addEventListener(ac, t), () => n.removeEventListener(ac, t);
  }, [t, e]), () => {
    const n = Hu(e), r = Ml(e);
    n.dispatchEvent(new r.CustomEvent(ac));
  };
}
function ste(e, t = []) {
  const n = Object.assign({}, e);
  for (const r of t)
    r in n && delete n[r];
  return n;
}
function lte(e, t) {
  const n = {};
  for (const r of t)
    r in e && (n[r] = e[r]);
  return n;
}
var cte = je(Po.div), TI = Le((e, t) => {
  var n, r;
  const o = aa("Tooltip", e), i = fr(e), a = Xe(), {
    children: l,
    label: c,
    shouldWrapChildren: u,
    "aria-label": f,
    hasArrow: p,
    bg: h,
    portalProps: C,
    background: v,
    backgroundColor: b,
    bgColor: y,
    motionProps: x,
    ...T
  } = i, A = (r = (n = v ?? b) != null ? n : h) != null ? r : y;
  if (A) {
    o.bg = A;
    const oe = Lw(a, "colors", A);
    o[$t.arrowBg.var] = oe;
  }
  const L = ite({ ...T, direction: a.direction }), I = typeof l == "string" || u;
  let M;
  if (I)
    M = /* @__PURE__ */ g(
      je.span,
      {
        display: "inline-block",
        tabIndex: 0,
        ...L.getTriggerProps(),
        children: l
      }
    );
  else {
    const oe = Ps.only(l);
    M = ko(
      oe,
      L.getTriggerProps(oe.props, oe.ref)
    );
  }
  const k = !!f, _ = L.getTooltipProps({}, t), F = k ? ste(_, ["role", "id"]) : _, $ = lte(_, ["role", "id"]);
  return c ? /* @__PURE__ */ X(st, { children: [
    M,
    /* @__PURE__ */ g(l2, { children: L.isOpen && /* @__PURE__ */ g(o2, { ...C, children: /* @__PURE__ */ g(
      je.div,
      {
        ...L.getTooltipPositionerProps(),
        __css: {
          zIndex: o.zIndex,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ X(
          cte,
          {
            variants: ote,
            initial: "exit",
            animate: "enter",
            exit: "exit",
            ...x,
            ...F,
            __css: o,
            children: [
              c,
              k && /* @__PURE__ */ g(je.span, { srOnly: !0, ...$, children: f }),
              p && /* @__PURE__ */ g(
                je.div,
                {
                  "data-popper-arrow": !0,
                  className: "chakra-tooltip__arrow-wrapper",
                  children: /* @__PURE__ */ g(
                    je.div,
                    {
                      "data-popper-arrow-inner": !0,
                      className: "chakra-tooltip__arrow",
                      __css: { bg: o.bg }
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ) }) })
  ] }) : /* @__PURE__ */ g(st, { children: l });
});
TI.displayName = "Tooltip";
var Ka = 1e6, wv = 1e6, c3 = "[big.js] ", u3 = c3 + "Invalid ", Q9 = u3 + "decimal places", ute = u3 + "rounding mode", AI = c3 + "Division by zero", at = {}, ci = void 0;
function c2(e, t, n, r) {
  var o = e.c;
  if (n === ci && (n = e.constructor.RM), n !== 0 && n !== 1 && n !== 2 && n !== 3)
    throw Error(ute);
  if (t < 1)
    r = n === 3 && (r || !!o[0]) || t === 0 && (n === 1 && o[0] >= 5 || n === 2 && (o[0] > 5 || o[0] === 5 && (r || o[1] !== ci))), o.length = 1, r ? (e.e = e.e - t + 1, o[0] = 1) : o[0] = e.e = 0;
  else if (t < o.length) {
    if (r = n === 1 && o[t] >= 5 || n === 2 && (o[t] > 5 || o[t] === 5 && (r || o[t + 1] !== ci || o[t - 1] & 1)) || n === 3 && (r || !!o[0]), o.length = t, r) {
      for (; ++o[--t] > 9; )
        if (o[t] = 0, t === 0) {
          ++e.e, o.unshift(1);
          break;
        }
    }
    for (t = o.length; !o[--t]; ) o.pop();
  }
  return e;
}
function u2(e, t, n) {
  var r = e.e, o = e.c.join(""), i = o.length;
  if (t)
    o = o.charAt(0) + (i > 1 ? "." + o.slice(1) : "") + (r < 0 ? "e" : "e+") + r;
  else if (r < 0) {
    for (; ++r; ) o = "0" + o;
    o = "0." + o;
  } else if (r > 0)
    if (++r > i)
      for (r -= i; r--; ) o += "0";
    else r < i && (o = o.slice(0, r) + "." + o.slice(r));
  else i > 1 && (o = o.charAt(0) + "." + o.slice(1));
  return e.s < 0 && n ? "-" + o : o;
}
at.abs = function() {
  var e = new this.constructor(this);
  return e.s = 1, e;
};
at.cmp = function(e) {
  var t, n = this, r = n.c, o = (e = new n.constructor(e)).c, i = n.s, a = e.s, l = n.e, c = e.e;
  if (!r[0] || !o[0]) return r[0] ? i : o[0] ? -a : 0;
  if (i != a) return i;
  if (t = i < 0, l != c) return l > c ^ t ? 1 : -1;
  for (a = (l = r.length) < (c = o.length) ? l : c, i = -1; ++i < a; )
    if (r[i] != o[i]) return r[i] > o[i] ^ t ? 1 : -1;
  return l == c ? 0 : l > c ^ t ? 1 : -1;
};
at.div = function(e) {
  var t = this, n = t.constructor, r = t.c, o = (e = new n(e)).c, i = t.s == e.s ? 1 : -1, a = n.DP;
  if (a !== ~~a || a < 0 || a > Ka)
    throw Error(Q9);
  if (!o[0])
    throw Error(AI);
  if (!r[0])
    return e.s = i, e.c = [e.e = 0], e;
  var l, c, u, f, p, h = o.slice(), C = l = o.length, v = r.length, b = r.slice(0, l), y = b.length, x = e, T = x.c = [], A = 0, L = a + (x.e = t.e - e.e) + 1;
  for (x.s = i, i = L < 0 ? 0 : L, h.unshift(0); y++ < l; ) b.push(0);
  do {
    for (u = 0; u < 10; u++) {
      if (l != (y = b.length))
        f = l > y ? 1 : -1;
      else
        for (p = -1, f = 0; ++p < l; )
          if (o[p] != b[p]) {
            f = o[p] > b[p] ? 1 : -1;
            break;
          }
      if (f < 0) {
        for (c = y == l ? o : h; y; ) {
          if (b[--y] < c[y]) {
            for (p = y; p && !b[--p]; ) b[p] = 9;
            --b[p], b[y] += 10;
          }
          b[y] -= c[y];
        }
        for (; !b[0]; ) b.shift();
      } else
        break;
    }
    T[A++] = f ? u : ++u, b[0] && f ? b[y] = r[C] || 0 : b = [r[C]];
  } while ((C++ < v || b[0] !== ci) && i--);
  return !T[0] && A != 1 && (T.shift(), x.e--, L--), A > L && c2(x, L, n.RM, b[0] !== ci), x;
};
at.eq = function(e) {
  return this.cmp(e) === 0;
};
at.gt = function(e) {
  return this.cmp(e) > 0;
};
at.gte = function(e) {
  return this.cmp(e) > -1;
};
at.lt = function(e) {
  return this.cmp(e) < 0;
};
at.lte = function(e) {
  return this.cmp(e) < 1;
};
at.minus = at.sub = function(e) {
  var t, n, r, o, i = this, a = i.constructor, l = i.s, c = (e = new a(e)).s;
  if (l != c)
    return e.s = -c, i.plus(e);
  var u = i.c.slice(), f = i.e, p = e.c, h = e.e;
  if (!u[0] || !p[0])
    return p[0] ? e.s = -c : u[0] ? e = new a(i) : e.s = 1, e;
  if (l = f - h) {
    for ((o = l < 0) ? (l = -l, r = u) : (h = f, r = p), r.reverse(), c = l; c--; ) r.push(0);
    r.reverse();
  } else
    for (n = ((o = u.length < p.length) ? u : p).length, l = c = 0; c < n; c++)
      if (u[c] != p[c]) {
        o = u[c] < p[c];
        break;
      }
  if (o && (r = u, u = p, p = r, e.s = -e.s), (c = (n = p.length) - (t = u.length)) > 0) for (; c--; ) u[t++] = 0;
  for (c = t; n > l; ) {
    if (u[--n] < p[n]) {
      for (t = n; t && !u[--t]; ) u[t] = 9;
      --u[t], u[n] += 10;
    }
    u[n] -= p[n];
  }
  for (; u[--c] === 0; ) u.pop();
  for (; u[0] === 0; )
    u.shift(), --h;
  return u[0] || (e.s = 1, u = [h = 0]), e.c = u, e.e = h, e;
};
at.mod = function(e) {
  var t, n = this, r = n.constructor, o = n.s, i = (e = new r(e)).s;
  if (!e.c[0])
    throw Error(AI);
  return n.s = e.s = 1, t = e.cmp(n) == 1, n.s = o, e.s = i, t ? new r(n) : (o = r.DP, i = r.RM, r.DP = r.RM = 0, n = n.div(e), r.DP = o, r.RM = i, this.minus(n.times(e)));
};
at.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s, e;
};
at.plus = at.add = function(e) {
  var t, n, r, o = this, i = o.constructor;
  if (e = new i(e), o.s != e.s)
    return e.s = -e.s, o.minus(e);
  var a = o.e, l = o.c, c = e.e, u = e.c;
  if (!l[0] || !u[0])
    return u[0] || (l[0] ? e = new i(o) : e.s = o.s), e;
  if (l = l.slice(), t = a - c) {
    for (t > 0 ? (c = a, r = u) : (t = -t, r = l), r.reverse(); t--; ) r.push(0);
    r.reverse();
  }
  for (l.length - u.length < 0 && (r = u, u = l, l = r), t = u.length, n = 0; t; l[t] %= 10) n = (l[--t] = l[t] + u[t] + n) / 10 | 0;
  for (n && (l.unshift(n), ++c), t = l.length; l[--t] === 0; ) l.pop();
  return e.c = l, e.e = c, e;
};
at.pow = function(e) {
  var t = this, n = new t.constructor("1"), r = n, o = e < 0;
  if (e !== ~~e || e < -wv || e > wv)
    throw Error(u3 + "exponent");
  for (o && (e = -e); e & 1 && (r = r.times(t)), e >>= 1, !!e; )
    t = t.times(t);
  return o ? n.div(r) : r;
};
at.prec = function(e, t) {
  if (e !== ~~e || e < 1 || e > Ka)
    throw Error(u3 + "precision");
  return c2(new this.constructor(this), e, t);
};
at.round = function(e, t) {
  if (e === ci) e = 0;
  else if (e !== ~~e || e < -Ka || e > Ka)
    throw Error(Q9);
  return c2(new this.constructor(this), e + this.e + 1, t);
};
at.sqrt = function() {
  var e, t, n, r = this, o = r.constructor, i = r.s, a = r.e, l = new o("0.5");
  if (!r.c[0]) return new o(r);
  if (i < 0)
    throw Error(c3 + "No square root");
  i = Math.sqrt(+u2(r, !0, !0)), i === 0 || i === 1 / 0 ? (t = r.c.join(""), t.length + a & 1 || (t += "0"), i = Math.sqrt(t), a = ((a + 1) / 2 | 0) - (a < 0 || a & 1), e = new o((i == 1 / 0 ? "5e" : (i = i.toExponential()).slice(0, i.indexOf("e") + 1)) + a)) : e = new o(i + ""), a = e.e + (o.DP += 4);
  do
    n = e, e = l.times(n.plus(r.div(n)));
  while (n.c.slice(0, a).join("") !== e.c.slice(0, a).join(""));
  return c2(e, (o.DP -= 4) + e.e + 1, o.RM);
};
at.times = at.mul = function(e) {
  var t, n = this, r = n.constructor, o = n.c, i = (e = new r(e)).c, a = o.length, l = i.length, c = n.e, u = e.e;
  if (e.s = n.s == e.s ? 1 : -1, !o[0] || !i[0])
    return e.c = [e.e = 0], e;
  for (e.e = c + u, a < l && (t = o, o = i, i = t, u = a, a = l, l = u), t = new Array(u = a + l); u--; ) t[u] = 0;
  for (c = l; c--; ) {
    for (l = 0, u = a + c; u > c; )
      l = t[u] + i[c] * o[u - c - 1] + l, t[u--] = l % 10, l = l / 10 | 0;
    t[u] = l;
  }
  for (l ? ++e.e : t.shift(), c = t.length; !t[--c]; ) t.pop();
  return e.c = t, e;
};
at.toExponential = function(e, t) {
  var n = this, r = n.c[0];
  if (e !== ci) {
    if (e !== ~~e || e < 0 || e > Ka)
      throw Error(Q9);
    for (n = c2(new n.constructor(n), ++e, t); n.c.length < e; ) n.c.push(0);
  }
  return u2(n, !0, !!r);
};
at.toFixed = function(e, t) {
  var n = this, r = n.c[0];
  if (e !== ci) {
    if (e !== ~~e || e < 0 || e > Ka)
      throw Error(Q9);
    for (n = c2(new n.constructor(n), e + n.e + 1, t), e = e + n.e + 1; n.c.length < e; ) n.c.push(0);
  }
  return u2(n, !1, !!r);
};
at[Symbol.for("nodejs.util.inspect.custom")] = at.toJSON = at.toString = function() {
  var e = this, t = e.constructor;
  return u2(e, e.e <= t.NE || e.e >= t.PE, !!e.c[0]);
};
at.toNumber = function() {
  var e = +u2(this, !0, !0);
  if (this.constructor.strict === !0 && !this.eq(e.toString()))
    throw Error(c3 + "Imprecise conversion");
  return e;
};
at.toPrecision = function(e, t) {
  var n = this, r = n.constructor, o = n.c[0];
  if (e !== ci) {
    if (e !== ~~e || e < 1 || e > Ka)
      throw Error(u3 + "precision");
    for (n = c2(new r(n), e, t); n.c.length < e; ) n.c.push(0);
  }
  return u2(n, e <= n.e || n.e <= r.NE || n.e >= r.PE, !!o);
};
at.valueOf = function() {
  var e = this, t = e.constructor;
  if (t.strict === !0)
    throw Error(c3 + "valueOf disallowed");
  return u2(e, e.e <= t.NE || e.e >= t.PE, !0);
};
const dte = (e) => {
  for (var t = 0, n = 0; n < e.length; n++) {
    var r = e.charCodeAt(n);
    t = (t << 5) - t + r, t = t & t;
  }
  return Math.abs(t);
}, fte = (e, t) => Math.floor(e / Math.pow(10, t) % 10), rl = (e, t, n) => {
  let r = e % t;
  return n && fte(e, n) % 2 === 0 ? -r : r;
}, pte = (e, t, n) => t[e % n], hte = 3, bn = 80, mte = ["#F4E196", "#A6BF91", "#5F9982", "#78576B", "#400428"], Cte = (e, t) => {
  const n = dte(e), r = t && t.length;
  return Array.from({ length: hte }, (i, a) => ({
    color: pte(n + a, t, r),
    translateX: rl(n * (a + 1), bn / 10, 1),
    translateY: rl(n * (a + 1), bn / 10, 2),
    scale: 1.2 + rl(n * (a + 1), bn / 20, 1) / 10,
    rotate: rl(n * (a + 1), 360, 1)
  }));
};
Le(({ value: e, size: t, colors: n = mte, ...r }, o) => {
  const i = Gt(t) ?? t, a = Cte(e, n), l = dr();
  return X("svg", { ref: o, viewBox: "0 0 " + bn + " " + bn, fill: "none", role: "img", xmlns: "http://www.w3.org/2000/svg", width: i, height: i, ...r, children: [g("mask", { id: l, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: bn, height: bn, children: g("rect", { width: bn, height: bn, rx: bn * 2, fill: "#FFFFFF" }) }), X("g", { mask: `url(#${l})`, children: [g("rect", { width: bn, height: bn, fill: a[0].color }), g("path", { filter: "url(#prefix__filter0_f)", d: "M32.414 59.35L50.376 70.5H72.5v-71H33.728L26.5 13.381l19.057 27.08L32.414 59.35z", fill: a[1].color, transform: "translate(" + a[1].translateX + " " + a[1].translateY + ") rotate(" + a[1].rotate + " " + bn / 2 + " " + bn / 2 + ") scale(" + a[2].scale + ")" }), g("path", { filter: "url(#prefix__filter0_f)", style: {
    mixBlendMode: "overlay"
  }, d: "M22.216 24L0 46.75l14.108 38.129L78 86l-3.081-59.276-22.378 4.005 12.972 20.186-23.35 27.395L22.215 24z", fill: a[2].color, transform: "translate(" + a[2].translateX + " " + a[2].translateY + ") rotate(" + a[2].rotate + " " + bn / 2 + " " + bn / 2 + ") scale(" + a[2].scale + ")" })] }), g("defs", { children: X("filter", { id: "prefix__filter0_f", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [g("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), g("feBlend", { in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), g("feGaussianBlur", { stdDeviation: 7, result: "effect1_foregroundBlur" })] }) })] });
});
const II = {
  base: "0px",
  sm: "375px",
  md: "768px",
  lg: "1280px",
  xl: "1440px",
  // Must always provide value for '2xl' if using pixels.
  "2xl": "1440px"
};
function LI(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function B0(e) {
  return B0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, B0(e);
}
function gte(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function bp() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (bp = function() {
    return !!e;
  })();
}
function bte(e, t, n) {
  if (bp()) return Reflect.construct.apply(null, arguments);
  var r = [null];
  r.push.apply(r, t);
  var o = new (e.bind.apply(e, r))();
  return n && ws(o, n.prototype), o;
}
function Ou(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Ou = function(r) {
    if (r === null || !gte(r)) return r;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(r)) return t.get(r);
      t.set(r, o);
    }
    function o() {
      return bte(r, arguments, B0(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), ws(o, r);
  }, Ou(e);
}
var vte = {
  1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
  2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
  3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
  4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
  5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
  6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
  7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
  8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
  9: `Please provide a number of steps to the modularScale helper.

`,
  10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
  12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
  13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
  14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  16: `You must provide a template to this method.

`,
  17: `You passed an unsupported selector state to this method.

`,
  18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  23: `fontFace expects a name of a font-family.

`,
  24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  25: `fontFace expects localFonts to be an array.

`,
  26: `fontFace expects fileFormats to be an array.

`,
  27: `radialGradient requries at least 2 color-stops to properly render.

`,
  28: `Please supply a filename to retinaImage() as the first argument.

`,
  29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
  32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
  33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
  34: `borderRadius expects a radius value as a string or number as the second argument.

`,
  35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  36: `Property must be a string value.

`,
  37: `Syntax Error at %s.

`,
  38: `Formula contains a function that needs parentheses at %s.

`,
  39: `Formula is missing closing parenthesis at %s.

`,
  40: `Formula has too many closing parentheses at %s.

`,
  41: `All values in a formula must have the same unit or be unitless.

`,
  42: `Please provide a number of steps to the modularScale helper.

`,
  43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
  45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
  46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
  47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
  51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
  52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  53: `fontFace expects localFonts to be an array.

`,
  54: `fontFace expects fileFormats to be an array.

`,
  55: `fontFace expects a name of a font-family.

`,
  56: `linearGradient requries at least 2 color-stops to properly render.

`,
  57: `radialGradient requries at least 2 color-stops to properly render.

`,
  58: `Please supply a filename to retinaImage() as the first argument.

`,
  59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  61: `Property must be a string value.

`,
  62: `borderRadius expects a radius value as a string or number as the second argument.

`,
  63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
  65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
  66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
  67: `You must provide a template to this method.

`,
  68: `You passed an unsupported selector state to this method.

`,
  69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
  70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
  71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
  72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
  73: `Please provide a valid CSS variable.

`,
  74: `CSS variable not found and no default was provided.

`,
  75: `important requires a valid style object, got a %s instead.

`,
  76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
  77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
  78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function yte() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t[0], o = [], i;
  for (i = 1; i < t.length; i += 1)
    o.push(t[i]);
  return o.forEach(function(a) {
    r = r.replace(/%[a-z]/, a);
  }), r;
}
var So = /* @__PURE__ */ function(e) {
  rA(t, e);
  function t(n) {
    var r;
    if (process.env.NODE_ENV === "production")
      r = e.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + n + " for more information.") || this;
    else {
      for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++)
        i[a - 1] = arguments[a];
      r = e.call(this, yte.apply(void 0, [vte[n]].concat(i))) || this;
    }
    return LI(r);
  }
  return t;
}(/* @__PURE__ */ Ou(Error));
function sc(e) {
  return Math.round(e * 255);
}
function xte(e, t, n) {
  return sc(e) + "," + sc(t) + "," + sc(n);
}
function c9(e, t, n, r) {
  if (r === void 0 && (r = xte), t === 0)
    return r(n, n, n);
  var o = (e % 360 + 360) % 360 / 60, i = (1 - Math.abs(2 * n - 1)) * t, a = i * (1 - Math.abs(o % 2 - 1)), l = 0, c = 0, u = 0;
  o >= 0 && o < 1 ? (l = i, c = a) : o >= 1 && o < 2 ? (l = a, c = i) : o >= 2 && o < 3 ? (c = i, u = a) : o >= 3 && o < 4 ? (c = a, u = i) : o >= 4 && o < 5 ? (l = a, u = i) : o >= 5 && o < 6 && (l = i, u = a);
  var f = n - i / 2, p = l + f, h = c + f, C = u + f;
  return r(p, h, C);
}
var Sv = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function wte(e) {
  if (typeof e != "string") return e;
  var t = e.toLowerCase();
  return Sv[t] ? "#" + Sv[t] : e;
}
var Ste = /^#[a-fA-F0-9]{6}$/, Tte = /^#[a-fA-F0-9]{8}$/, Ate = /^#[a-fA-F0-9]{3}$/, Ite = /^#[a-fA-F0-9]{4}$/, lc = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, Lte = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, Ete = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, Mte = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function Bs(e) {
  if (typeof e != "string")
    throw new So(3);
  var t = wte(e);
  if (t.match(Ste))
    return {
      red: parseInt("" + t[1] + t[2], 16),
      green: parseInt("" + t[3] + t[4], 16),
      blue: parseInt("" + t[5] + t[6], 16)
    };
  if (t.match(Tte)) {
    var n = parseFloat((parseInt("" + t[7] + t[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + t[1] + t[2], 16),
      green: parseInt("" + t[3] + t[4], 16),
      blue: parseInt("" + t[5] + t[6], 16),
      alpha: n
    };
  }
  if (t.match(Ate))
    return {
      red: parseInt("" + t[1] + t[1], 16),
      green: parseInt("" + t[2] + t[2], 16),
      blue: parseInt("" + t[3] + t[3], 16)
    };
  if (t.match(Ite)) {
    var r = parseFloat((parseInt("" + t[4] + t[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + t[1] + t[1], 16),
      green: parseInt("" + t[2] + t[2], 16),
      blue: parseInt("" + t[3] + t[3], 16),
      alpha: r
    };
  }
  var o = lc.exec(t);
  if (o)
    return {
      red: parseInt("" + o[1], 10),
      green: parseInt("" + o[2], 10),
      blue: parseInt("" + o[3], 10)
    };
  var i = Lte.exec(t.substring(0, 50));
  if (i)
    return {
      red: parseInt("" + i[1], 10),
      green: parseInt("" + i[2], 10),
      blue: parseInt("" + i[3], 10),
      alpha: parseFloat("" + i[4]) > 1 ? parseFloat("" + i[4]) / 100 : parseFloat("" + i[4])
    };
  var a = Ete.exec(t);
  if (a) {
    var l = parseInt("" + a[1], 10), c = parseInt("" + a[2], 10) / 100, u = parseInt("" + a[3], 10) / 100, f = "rgb(" + c9(l, c, u) + ")", p = lc.exec(f);
    if (!p)
      throw new So(4, t, f);
    return {
      red: parseInt("" + p[1], 10),
      green: parseInt("" + p[2], 10),
      blue: parseInt("" + p[3], 10)
    };
  }
  var h = Mte.exec(t.substring(0, 50));
  if (h) {
    var C = parseInt("" + h[1], 10), v = parseInt("" + h[2], 10) / 100, b = parseInt("" + h[3], 10) / 100, y = "rgb(" + c9(C, v, b) + ")", x = lc.exec(y);
    if (!x)
      throw new So(4, t, y);
    return {
      red: parseInt("" + x[1], 10),
      green: parseInt("" + x[2], 10),
      blue: parseInt("" + x[3], 10),
      alpha: parseFloat("" + h[4]) > 1 ? parseFloat("" + h[4]) / 100 : parseFloat("" + h[4])
    };
  }
  throw new So(5);
}
function Bte(e) {
  var t = e.red / 255, n = e.green / 255, r = e.blue / 255, o = Math.max(t, n, r), i = Math.min(t, n, r), a = (o + i) / 2;
  if (o === i)
    return e.alpha !== void 0 ? {
      hue: 0,
      saturation: 0,
      lightness: a,
      alpha: e.alpha
    } : {
      hue: 0,
      saturation: 0,
      lightness: a
    };
  var l, c = o - i, u = a > 0.5 ? c / (2 - o - i) : c / (o + i);
  switch (o) {
    case t:
      l = (n - r) / c + (n < r ? 6 : 0);
      break;
    case n:
      l = (r - t) / c + 2;
      break;
    default:
      l = (t - n) / c + 4;
      break;
  }
  return l *= 60, e.alpha !== void 0 ? {
    hue: l,
    saturation: u,
    lightness: a,
    alpha: e.alpha
  } : {
    hue: l,
    saturation: u,
    lightness: a
  };
}
function ca(e) {
  return Bte(Bs(e));
}
var kte = function(t) {
  return t.length === 7 && t[1] === t[2] && t[3] === t[4] && t[5] === t[6] ? "#" + t[1] + t[3] + t[5] : t;
}, Nu = kte;
function ka(e) {
  var t = e.toString(16);
  return t.length === 1 ? "0" + t : t;
}
function cc(e) {
  return ka(Math.round(e * 255));
}
function Rte(e, t, n) {
  return Nu("#" + cc(e) + cc(t) + cc(n));
}
function EI(e, t, n) {
  return c9(e, t, n, Rte);
}
function _te(e, t, n) {
  if (typeof e == "object" && t === void 0 && n === void 0)
    return EI(e.hue, e.saturation, e.lightness);
  throw new So(1);
}
function Fte(e, t, n, r) {
  if (typeof e == "object" && t === void 0 && n === void 0 && r === void 0)
    return e.alpha >= 1 ? EI(e.hue, e.saturation, e.lightness) : "rgba(" + c9(e.hue, e.saturation, e.lightness) + "," + e.alpha + ")";
  throw new So(2);
}
function MI(e, t, n) {
  if (typeof e == "number" && typeof t == "number" && typeof n == "number")
    return Nu("#" + ka(e) + ka(t) + ka(n));
  if (typeof e == "object" && t === void 0 && n === void 0)
    return Nu("#" + ka(e.red) + ka(e.green) + ka(e.blue));
  throw new So(6);
}
function De(e, t, n, r) {
  if (typeof e == "string" && typeof t == "number") {
    var o = Bs(e);
    return "rgba(" + o.red + "," + o.green + "," + o.blue + "," + t + ")";
  } else if (typeof e == "object" && t === void 0 && n === void 0 && r === void 0)
    return e.alpha >= 1 ? MI(e.red, e.green, e.blue) : "rgba(" + e.red + "," + e.green + "," + e.blue + "," + e.alpha + ")";
  throw new So(7);
}
var Pte = function(t) {
  return typeof t.red == "number" && typeof t.green == "number" && typeof t.blue == "number" && (typeof t.alpha != "number" || typeof t.alpha > "u");
}, Vte = function(t) {
  return typeof t.red == "number" && typeof t.green == "number" && typeof t.blue == "number" && typeof t.alpha == "number";
}, Hte = function(t) {
  return typeof t.hue == "number" && typeof t.saturation == "number" && typeof t.lightness == "number" && (typeof t.alpha != "number" || typeof t.alpha > "u");
}, Ote = function(t) {
  return typeof t.hue == "number" && typeof t.saturation == "number" && typeof t.lightness == "number" && typeof t.alpha == "number";
};
function ua(e) {
  if (typeof e != "object") throw new So(8);
  if (Vte(e)) return De(e);
  if (Pte(e)) return MI(e);
  if (Ote(e)) return Fte(e);
  if (Hte(e)) return _te(e);
  throw new So(8);
}
function BI(e, t, n) {
  return function() {
    var o = n.concat(Array.prototype.slice.call(arguments));
    return o.length >= t ? e.apply(this, o) : BI(e, t, o);
  };
}
function pr(e) {
  return BI(e, e.length, []);
}
function Nte(e, t) {
  if (t === "transparent") return t;
  var n = ca(t);
  return ua(He({}, n, {
    hue: n.hue + parseFloat(e)
  }));
}
pr(Nte);
function Vs(e, t, n) {
  return Math.max(e, Math.min(t, n));
}
function Dte(e, t) {
  if (t === "transparent") return t;
  var n = ca(t);
  return ua(He({}, n, {
    lightness: Vs(0, 1, n.lightness - parseFloat(e))
  }));
}
var Zte = pr(Dte), zte = Zte;
function Gte(e, t) {
  if (t === "transparent") return t;
  var n = ca(t);
  return ua(He({}, n, {
    saturation: Vs(0, 1, n.saturation - parseFloat(e))
  }));
}
pr(Gte);
function Wte(e, t) {
  if (t === "transparent") return t;
  var n = ca(t);
  return ua(He({}, n, {
    lightness: Vs(0, 1, n.lightness + parseFloat(e))
  }));
}
var $te = pr(Wte), Ute = $te;
function jte(e, t, n) {
  if (t === "transparent") return n;
  if (n === "transparent") return t;
  if (e === 0) return n;
  var r = Bs(t), o = He({}, r, {
    alpha: typeof r.alpha == "number" ? r.alpha : 1
  }), i = Bs(n), a = He({}, i, {
    alpha: typeof i.alpha == "number" ? i.alpha : 1
  }), l = o.alpha - a.alpha, c = parseFloat(e) * 2 - 1, u = c * l === -1 ? c : c + l, f = 1 + c * l, p = (u / f + 1) / 2, h = 1 - p, C = {
    red: Math.floor(o.red * p + a.red * h),
    green: Math.floor(o.green * p + a.green * h),
    blue: Math.floor(o.blue * p + a.blue * h),
    alpha: o.alpha * parseFloat(e) + a.alpha * (1 - parseFloat(e))
  };
  return De(C);
}
var Xte = pr(jte), kI = Xte;
function Yte(e, t) {
  if (t === "transparent") return t;
  var n = Bs(t), r = typeof n.alpha == "number" ? n.alpha : 1, o = He({}, n, {
    alpha: Vs(0, 1, (r * 100 + parseFloat(e) * 100) / 100)
  });
  return De(o);
}
pr(Yte);
function Jte(e, t) {
  if (t === "transparent") return t;
  var n = ca(t);
  return ua(He({}, n, {
    saturation: Vs(0, 1, n.saturation + parseFloat(e))
  }));
}
pr(Jte);
function Qte(e, t) {
  return t === "transparent" ? t : ua(He({}, ca(t), {
    hue: parseFloat(e)
  }));
}
pr(Qte);
function qte(e, t) {
  return t === "transparent" ? t : ua(He({}, ca(t), {
    lightness: parseFloat(e)
  }));
}
pr(qte);
function Kte(e, t) {
  return t === "transparent" ? t : ua(He({}, ca(t), {
    saturation: parseFloat(e)
  }));
}
pr(Kte);
function ene(e, t) {
  return t === "transparent" ? t : kI(parseFloat(e), "rgb(0, 0, 0)", t);
}
pr(ene);
function tne(e, t) {
  return t === "transparent" ? t : kI(parseFloat(e), "rgb(255, 255, 255)", t);
}
pr(tne);
function nne(e, t) {
  if (t === "transparent") return t;
  var n = Bs(t), r = typeof n.alpha == "number" ? n.alpha : 1, o = He({}, n, {
    alpha: Vs(0, 1, +(r * 100 - parseFloat(e) * 100).toFixed(2) / 100)
  });
  return De(o);
}
pr(nne);
const q = {
  // Multiples of 4 up to 20px with some exceptions, multiples of 8 beyond with no exceptions.
  0: "0px",
  "0.25": "1px",
  "0.5": "2px",
  1: "4px",
  2: "8px",
  3: "12px",
  "3.5": "14px",
  4: "16px",
  5: "20px",
  6: "24px",
  8: "32px",
  10: "40px",
  12: "48px",
  14: "56px",
  16: "64px",
  18: "72px",
  20: "80px",
  24: "96px",
  30: "120px",
  40: "160px",
  50: "200px"
}, Z = {
  logo: "#F0B90B",
  white: "#FFFFFF",
  black: "#000000",
  graphite: {
    100: "#F7F7F8",
    200: "#F1F2F3",
    300: "#E1E2E5",
    400: "#C4C5CB",
    500: "#8C8F9B",
    600: "#5C5F6A",
    700: "#373943",
    800: "#1E2026",
    900: "#181A1E",
    1e3: "#14151A"
  },
  yellow: {
    100: "#FFFDEB",
    200: "#FFFAC2",
    300: "#FFF68F",
    400: "#FFF15C",
    500: "#FFE900",
    600: "#EBD600",
    700: "#C2B100",
    800: "#948700",
    900: "#857900",
    1e3: "#665800"
  },
  green: {
    100: "#F1FEF8",
    200: "#BFF8DC",
    300: "#8CF2C1",
    400: "#53EAA1",
    500: "#18DC7E",
    600: "#15C16E",
    700: "#12A55E",
    800: "#0E8149",
    900: "#115F39",
    1e3: "#143D29"
  },
  red: {
    100: "#FDE2E4",
    200: "#FDC4C7",
    300: "#FC9CA2",
    400: "#FF7A84",
    500: "#F8545F",
    600: "#EF2A37",
    700: "#D31724",
    800: "#A91E27",
    900: "#821119",
    1e3: "#541C20"
  },
  orange: {
    100: "#FFEADB",
    200: "#FFD2B2",
    300: "#FFBA89",
    400: "#FFA260",
    500: "#FF8A38",
    600: "#E55F00",
    700: "#BC4E00",
    800: "#933D00",
    900: "#5C2600",
    1e3: "#3D1A00"
  },
  // Projects.
  greenfield: {
    100: "#E5FFF0",
    200: "#B8FFD4",
    300: "#8AFFB9",
    400: "#5CFF9E",
    500: "#00FF67",
    600: "#00D657",
    700: "#00A844",
    800: "#007A31",
    900: "#004D1F",
    1e3: "#002911"
  }
}, RI = {
  primitives: {
    logo: Z.logo,
    white: Z.white,
    black: Z.black
  },
  background: {
    1: Z.graphite[900],
    2: Z.graphite[800],
    3: Z.graphite[1e3],
    brand: Z.yellow[500]
  },
  border: {
    1: Z.graphite[900],
    2: Z.graphite[800],
    3: Z.graphite[700],
    4: Z.graphite[600],
    inverse: Z.white,
    brand: Z.yellow[500],
    disabled: De(Z.graphite[600], 0.45)
  },
  layer: {
    1: {
      default: Z.graphite[1e3],
      hover: Z.graphite[900],
      active: Z.graphite[800]
    },
    2: {
      default: Z.graphite[900],
      hover: Z.graphite[800],
      active: Z.graphite[700]
    },
    3: {
      default: Z.graphite[800],
      hover: Z.graphite[700],
      active: Z.graphite[600]
    },
    4: {
      default: Z.graphite[700],
      hover: Z.graphite[600],
      active: Z.graphite[500]
    },
    inverse: Z.graphite[100],
    disabled: De(Z.graphite[100], 0.2)
  },
  support: {
    success: {
      1: Z.green[200],
      2: Z.green[400],
      3: Z.green[500],
      4: Z.green[700],
      5: Z.green[900]
    },
    warning: {
      1: Z.orange[100],
      2: Z.orange[400],
      3: Z.orange[500],
      4: Z.orange[700],
      5: Z.orange[900]
    },
    danger: {
      1: Z.red[200],
      2: Z.red[400],
      3: Z.red[500],
      4: Z.red[700],
      5: Z.red[900]
    },
    brand: {
      1: Z.yellow[200],
      2: Z.yellow[400],
      3: Z.yellow[500],
      4: Z.yellow[800],
      5: Z.yellow[1e3]
    },
    primary: {
      1: Z.graphite[300],
      2: Z.graphite[400],
      3: Z.graphite[500],
      4: Z.graphite[600],
      5: Z.graphite[700]
    }
  },
  shadow: {
    // 1: `${sizes['0']} ${sizes['4']} ${sizes['12']} ${rgba(primitives.black, 0.24)}`,
    // 2: `${sizes['0']} ${sizes['4']} ${sizes['12']} ${rgba(primitives.black, 0.16)}`,
    // 3: `${sizes['0']} ${sizes['6']} ${sizes['16']} ${rgba(primitives.black, 0.48)}`,
    // 4: `${sizes['0']} ${sizes['1']} ${sizes['2']} ${rgba(primitives.black, 0.56)}`,
    1: `${q[0]} ${q[1]} ${q[2]} ${De(Z.black, 0.16)}`,
    2: `${q[0]} ${q[1]} ${q[2]} ${De(Z.black, 0.24)}`,
    3: `${q[0]} ${q[2]} ${q[4]} ${De(Z.black, 0.24)}`,
    4: `${q[0]} ${q[1]} ${q[2]} ${De(Z.black, 0.16)},${q[0]} ${q[4]} ${q[12]} ${De(Z.black, 0.48)}`,
    5: `${q[0]} ${q[1]} ${q[2]} ${De(Z.black, 0.16)},${q[0]} ${q[6]} ${q[16]} ${De(Z.black, 0.56)}`
  },
  gradient: {
    1: `linear-gradient(180deg, ${Z.graphite[1e3]} 0%, ${Z.black} 100%)`
  },
  overlay: De(Z.graphite[1e3], 0.6),
  button: {
    primary: {
      default: Z.graphite[100],
      subtle: Z.graphite[600],
      hover: Z.graphite[300],
      active: Z.white
    },
    brand: {
      default: Z.yellow[500],
      subtle: De(Z.yellow[1e3], 0.25),
      hover: Z.yellow[600],
      active: Z.yellow[400]
    },
    success: {
      default: Z.green[500],
      subtle: De(Z.green[1e3], 0.5),
      hover: Z.green[600],
      active: Z.green[400]
    },
    warning: {
      default: Z.orange[500],
      subtle: De(Z.orange[1e3], 0.5),
      hover: Z.orange[600],
      active: Z.orange[400]
    },
    danger: {
      default: Z.red[500],
      subtle: De(Z.red[1e3], 0.45),
      hover: Z.red[600],
      active: Z.red[400]
    },
    greenfield: {
      default: Z.greenfield[500],
      subtle: De(Z.greenfield[1e3], 0.6),
      hover: Z.greenfield[600],
      active: Z.greenfield[400]
    },
    disabled: De(Z.graphite[100], 0.45)
  },
  input: {
    1: Z.graphite[700]
  },
  text: {
    primary: Z.white,
    secondary: Z.graphite[400],
    tertiary: Z.graphite[500],
    placeholder: Z.graphite[500],
    inverse: Z.graphite[900],
    disabled: De(Z.graphite[100], 0.45),
    brand: Z.yellow[500],
    greenfield: Z.greenfield[500],
    warning: Z.orange[400],
    danger: Z.red[400],
    on: {
      color: {
        primary: Z.graphite[900],
        disabled: De(Z.graphite[900], 0.45)
      }
    }
  }
}, rne = {
  primitives: {
    logo: Z.logo,
    white: Z.white,
    black: Z.black
  },
  background: {
    1: Z.white,
    2: Z.graphite[100],
    3: Z.graphite[200],
    brand: Z.yellow[500]
  },
  border: {
    1: Z.graphite[100],
    2: Z.graphite[200],
    3: Z.graphite[300],
    4: Z.graphite[300],
    inverse: Z.graphite[900],
    brand: Z.yellow[600],
    disabled: Z.graphite[400]
  },
  layer: {
    1: {
      default: Z.white,
      hover: Z.graphite[300],
      active: Z.graphite[400]
    },
    2: {
      default: Z.graphite[200],
      hover: Z.graphite[300],
      active: Z.graphite[400]
    },
    3: {
      default: Z.white,
      hover: Z.graphite[300],
      active: Z.graphite[400]
    },
    4: {
      default: Z.graphite[200],
      hover: Z.graphite[300],
      active: Z.graphite[400]
    },
    inverse: Z.graphite[900],
    disabled: De(Z.graphite[900], 0.15)
  },
  support: {
    success: {
      1: Z.green[900],
      2: Z.green[800],
      3: Z.green[600],
      4: Z.green[400],
      5: Z.green[200]
    },
    warning: {
      1: Z.orange[900],
      2: Z.orange[800],
      3: Z.orange[600],
      4: Z.orange[400],
      5: Z.orange[100]
    },
    danger: {
      1: Z.red[900],
      2: Z.red[800],
      3: Z.red[600],
      4: Z.red[400],
      5: Z.red[200]
    },
    brand: {
      1: Z.yellow[1e3],
      2: Z.yellow[800],
      3: Z.yellow[600],
      4: Z.yellow[500],
      5: Z.yellow[200]
    },
    primary: {
      1: Z.graphite[700],
      2: Z.graphite[600],
      3: Z.graphite[500],
      4: Z.graphite[400],
      5: Z.graphite[300]
    }
  },
  shadow: {
    // 1: `${sizes['0']} ${sizes['4']} ${sizes['12']} ${rgba(primitives.black, 0.24)}`,
    // 2: `${sizes['0']} ${sizes['2']} ${sizes['8']} ${rgba(primitives.black, 0.16)}`,
    // 3: `${sizes['0']} ${sizes['6']} ${sizes['16']} ${rgba(primitives.black, 0.32)}`,
    // 4: `${sizes['0']} ${sizes['1']} ${sizes['2']} ${rgba(primitives.black, 0.4)}`,
    1: `${q[0]} ${q[1]} ${q[2]} ${De(Z.black, 0.16)}`,
    2: `${q[0]} ${q[1]} ${q[2]} ${De(Z.black, 0.24)}`,
    3: `${q[0]} ${q[2]} ${q[4]} ${De(Z.black, 0.24)}`,
    4: `${q[0]} ${q[1]} ${q[2]} ${De(Z.black, 0.16)}, ${q[0]} ${q[4]} ${q[12]} ${De(Z.black, 0.24)}`,
    5: `${q[0]} ${q[1]} ${q[2]} ${De(Z.black, 0.16)}, ${q[0]} ${q[6]} ${q[16]} ${De(Z.black, 0.48)}`
  },
  gradient: {
    ...RI.gradient
  },
  overlay: De(Z.graphite[1e3], 0.2),
  button: {
    primary: {
      default: Z.graphite[900],
      subtle: Z.graphite[300],
      hover: Z.graphite[800],
      active: Z.graphite[700]
    },
    brand: {
      default: Z.yellow[700],
      subtle: Z.yellow[200],
      hover: Z.yellow[800],
      active: Z.yellow[900]
    },
    success: {
      default: Z.green[700],
      subtle: Z.green[200],
      hover: Z.green[800],
      active: Z.green[900]
    },
    warning: {
      default: Z.orange[600],
      subtle: Z.orange[200],
      hover: Z.orange[700],
      active: Z.orange[800]
    },
    danger: {
      default: Z.red[700],
      subtle: Z.red[100],
      hover: Z.red[800],
      active: Z.red[900]
    },
    greenfield: {
      default: Z.greenfield[700],
      subtle: Z.greenfield[200],
      hover: Z.greenfield[800],
      active: Z.greenfield[900]
    },
    disabled: De(Z.graphite[900], 0.4)
  },
  input: {
    1: Z.graphite[100]
  },
  text: {
    primary: Z.graphite[900],
    secondary: Z.graphite[600],
    tertiary: Z.graphite[600],
    placeholder: Z.graphite[500],
    inverse: Z.white,
    disabled: De(Z.graphite[900], 0.3),
    brand: Z.graphite[900],
    greenfield: Z.greenfield[700],
    warning: Z.orange[700],
    danger: Z.red[800],
    on: {
      color: {
        primary: Z.white,
        disabled: De(Z.white, 0.4)
      }
    }
  }
}, j = {
  light: rne,
  dark: RI
}, one = {
  initialColorMode: "light",
  useSystemColorMode: !0
}, ine = {};
var ane = (e) => /!(important)?$/.test(e), Tv = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, sne = (e, t) => (n) => {
  const r = String(t), o = ane(r), i = Tv(r), a = e ? `${e}.${i}` : i;
  let l = wn(n.__cssMap) && a in n.__cssMap ? n.__cssMap[a].varRef : t;
  return l = Tv(l), o ? `${l} !important` : l;
};
function vp(e) {
  const { scale: t, transform: n, compose: r } = e;
  return (i, a) => {
    var l;
    const c = sne(t, i)(a);
    let u = (l = n?.(c, a)) != null ? l : c;
    return r && (u = r(u, a)), u;
  };
}
var ol = (...e) => (t) => e.reduce((n, r) => r(n), t);
function Tr(e, t) {
  return (n) => {
    const r = { property: n, scale: e };
    return r.transform = vp({
      scale: e,
      transform: t
    }), r;
  };
}
var lne = ({ rtl: e, ltr: t }) => (n) => n.direction === "rtl" ? e : t;
function cne(e) {
  const { property: t, scale: n, transform: r } = e;
  return {
    scale: n,
    property: lne(t),
    transform: n ? vp({
      scale: n,
      compose: r
    }) : r
  };
}
var _I = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function une() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ..._I
  ].join(" ");
}
function dne() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ..._I
  ].join(" ");
}
var fne = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, pne = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function hne(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
var mne = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, Du = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, Cne = new Set(Object.values(Du)), Zu = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), gne = (e) => e.trim();
function bne(e, t) {
  if (e == null || Zu.has(e))
    return e;
  if (!(zu(e) || Zu.has(e)))
    return `url('${e}')`;
  const o = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), i = o?.[1], a = o?.[2];
  if (!i || !a)
    return e;
  const l = i.includes("-gradient") ? i : `${i}-gradient`, [c, ...u] = a.split(",").map(gne).filter(Boolean);
  if (u?.length === 0)
    return e;
  const f = c in Du ? Du[c] : c;
  u.unshift(f);
  const p = u.map((h) => {
    if (Cne.has(h))
      return h;
    const C = h.indexOf(" "), [v, b] = C !== -1 ? [h.substr(0, C), h.substr(C + 1)] : [h], y = zu(b) ? b : b && b.split(" "), x = `colors.${v}`, T = x in t.__cssMap ? t.__cssMap[x].varRef : v;
    return y ? [
      T,
      ...Array.isArray(y) ? y : [y]
    ].join(" ") : T;
  });
  return `${l}(${p.join(", ")})`;
}
var zu = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), vne = (e, t) => bne(e, t ?? {});
function yne(e) {
  return /^var\(--.+\)$/.test(e);
}
var xne = (e) => {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}, uo = (e) => (t) => `${e}(${t})`, _1 = {
  filter(e) {
    return e !== "auto" ? e : fne;
  },
  backdropFilter(e) {
    return e !== "auto" ? e : pne;
  },
  ring(e) {
    return hne(_1.px(e));
  },
  bgClip(e) {
    return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
  },
  transform(e) {
    return e === "auto" ? une() : e === "auto-gpu" ? dne() : e;
  },
  vh(e) {
    return e === "$100vh" ? "var(--chakra-vh)" : e;
  },
  px(e) {
    if (e == null)
      return e;
    const { unitless: t } = xne(e);
    return t || typeof e == "number" ? `${e}px` : e;
  },
  fraction(e) {
    return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
  },
  float(e, t) {
    const n = { left: "right", right: "left" };
    return t.direction === "rtl" ? n[e] : e;
  },
  degree(e) {
    if (yne(e) || e == null)
      return e;
    const t = typeof e == "string" && !e.endsWith("deg");
    return typeof e == "number" || t ? `${e}deg` : e;
  },
  gradient: vne,
  blur: uo("blur"),
  opacity: uo("opacity"),
  brightness: uo("brightness"),
  contrast: uo("contrast"),
  dropShadow: uo("drop-shadow"),
  grayscale: uo("grayscale"),
  hueRotate: (e) => uo("hue-rotate")(_1.degree(e)),
  invert: uo("invert"),
  saturate: uo("saturate"),
  sepia: uo("sepia"),
  bgImage(e) {
    return e == null || zu(e) || Zu.has(e) ? e : `url(${e})`;
  },
  outline(e) {
    const t = String(e) === "0" || String(e) === "none";
    return e !== null && t ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: e };
  },
  flexDirection(e) {
    var t;
    const { space: n, divide: r } = (t = mne[e]) != null ? t : {}, o = { flexDirection: e };
    return n && (o[n] = 1), r && (o[r] = 1), o;
  }
}, W = {
  borderWidths: Tr("borderWidths"),
  borderStyles: Tr("borderStyles"),
  colors: Tr("colors"),
  borders: Tr("borders"),
  gradients: Tr("gradients", _1.gradient),
  radii: Tr("radii", _1.px),
  space: Tr("space", ol(_1.vh, _1.px)),
  spaceT: Tr("space", ol(_1.vh, _1.px)),
  degreeT(e) {
    return { property: e, transform: _1.degree };
  },
  prop(e, t, n) {
    return {
      property: e,
      scale: t,
      ...t && {
        transform: vp({ scale: t, transform: n })
      }
    };
  },
  propT(e, t) {
    return { property: e, transform: t };
  },
  sizes: Tr("sizes", ol(_1.vh, _1.px)),
  sizesT: Tr("sizes", ol(_1.vh, _1.fraction)),
  shadows: Tr("shadows"),
  logical: cne,
  blur: Tr("blur", _1.blur)
}, Bl = {
  background: W.colors("background"),
  backgroundColor: W.colors("backgroundColor"),
  backgroundImage: W.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: _1.bgClip },
  bgSize: W.prop("backgroundSize"),
  bgPosition: W.prop("backgroundPosition"),
  bg: W.colors("background"),
  bgColor: W.colors("backgroundColor"),
  bgPos: W.prop("backgroundPosition"),
  bgRepeat: W.prop("backgroundRepeat"),
  bgAttachment: W.prop("backgroundAttachment"),
  bgGradient: W.gradients("backgroundImage"),
  bgClip: { transform: _1.bgClip }
};
Object.assign(Bl, {
  bgImage: Bl.backgroundImage,
  bgImg: Bl.backgroundImage
});
var W1 = {
  border: W.borders("border"),
  borderWidth: W.borderWidths("borderWidth"),
  borderStyle: W.borderStyles("borderStyle"),
  borderColor: W.colors("borderColor"),
  borderRadius: W.radii("borderRadius"),
  borderTop: W.borders("borderTop"),
  borderBlockStart: W.borders("borderBlockStart"),
  borderTopLeftRadius: W.radii("borderTopLeftRadius"),
  borderStartStartRadius: W.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: W.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: W.radii("borderTopRightRadius"),
  borderStartEndRadius: W.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: W.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: W.borders("borderRight"),
  borderInlineEnd: W.borders("borderInlineEnd"),
  borderBottom: W.borders("borderBottom"),
  borderBlockEnd: W.borders("borderBlockEnd"),
  borderBottomLeftRadius: W.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: W.radii("borderBottomRightRadius"),
  borderLeft: W.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: W.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: W.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: W.borders(["borderLeft", "borderRight"]),
  borderInline: W.borders("borderInline"),
  borderY: W.borders(["borderTop", "borderBottom"]),
  borderBlock: W.borders("borderBlock"),
  borderTopWidth: W.borderWidths("borderTopWidth"),
  borderBlockStartWidth: W.borderWidths("borderBlockStartWidth"),
  borderTopColor: W.colors("borderTopColor"),
  borderBlockStartColor: W.colors("borderBlockStartColor"),
  borderTopStyle: W.borderStyles("borderTopStyle"),
  borderBlockStartStyle: W.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: W.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: W.borderWidths("borderBlockEndWidth"),
  borderBottomColor: W.colors("borderBottomColor"),
  borderBlockEndColor: W.colors("borderBlockEndColor"),
  borderBottomStyle: W.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: W.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: W.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: W.borderWidths("borderInlineStartWidth"),
  borderLeftColor: W.colors("borderLeftColor"),
  borderInlineStartColor: W.colors("borderInlineStartColor"),
  borderLeftStyle: W.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: W.borderStyles("borderInlineStartStyle"),
  borderRightWidth: W.borderWidths("borderRightWidth"),
  borderInlineEndWidth: W.borderWidths("borderInlineEndWidth"),
  borderRightColor: W.colors("borderRightColor"),
  borderInlineEndColor: W.colors("borderInlineEndColor"),
  borderRightStyle: W.borderStyles("borderRightStyle"),
  borderInlineEndStyle: W.borderStyles("borderInlineEndStyle"),
  borderTopRadius: W.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: W.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: W.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: W.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(W1, {
  rounded: W1.borderRadius,
  roundedTop: W1.borderTopRadius,
  roundedTopLeft: W1.borderTopLeftRadius,
  roundedTopRight: W1.borderTopRightRadius,
  roundedTopStart: W1.borderStartStartRadius,
  roundedTopEnd: W1.borderStartEndRadius,
  roundedBottom: W1.borderBottomRadius,
  roundedBottomLeft: W1.borderBottomLeftRadius,
  roundedBottomRight: W1.borderBottomRightRadius,
  roundedBottomStart: W1.borderEndStartRadius,
  roundedBottomEnd: W1.borderEndEndRadius,
  roundedLeft: W1.borderLeftRadius,
  roundedRight: W1.borderRightRadius,
  roundedStart: W1.borderInlineStartRadius,
  roundedEnd: W1.borderInlineEndRadius,
  borderStart: W1.borderInlineStart,
  borderEnd: W1.borderInlineEnd,
  borderTopStartRadius: W1.borderStartStartRadius,
  borderTopEndRadius: W1.borderStartEndRadius,
  borderBottomStartRadius: W1.borderEndStartRadius,
  borderBottomEndRadius: W1.borderEndEndRadius,
  borderStartRadius: W1.borderInlineStartRadius,
  borderEndRadius: W1.borderInlineEndRadius,
  borderStartWidth: W1.borderInlineStartWidth,
  borderEndWidth: W1.borderInlineEndWidth,
  borderStartColor: W1.borderInlineStartColor,
  borderEndColor: W1.borderInlineEndColor,
  borderStartStyle: W1.borderInlineStartStyle,
  borderEndStyle: W1.borderInlineEndStyle
});
var wne = {
  color: W.colors("color"),
  textColor: W.colors("color"),
  fill: W.colors("fill"),
  stroke: W.colors("stroke")
}, Gu = {
  boxShadow: W.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: W.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: W.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(Gu, {
  shadow: Gu.boxShadow
});
var Sne = {
  filter: { transform: _1.filter },
  blur: W.blur("--chakra-blur"),
  brightness: W.propT("--chakra-brightness", _1.brightness),
  contrast: W.propT("--chakra-contrast", _1.contrast),
  hueRotate: W.propT("--chakra-hue-rotate", _1.hueRotate),
  invert: W.propT("--chakra-invert", _1.invert),
  saturate: W.propT("--chakra-saturate", _1.saturate),
  dropShadow: W.propT("--chakra-drop-shadow", _1.dropShadow),
  backdropFilter: { transform: _1.backdropFilter },
  backdropBlur: W.blur("--chakra-backdrop-blur"),
  backdropBrightness: W.propT(
    "--chakra-backdrop-brightness",
    _1.brightness
  ),
  backdropContrast: W.propT("--chakra-backdrop-contrast", _1.contrast),
  backdropHueRotate: W.propT(
    "--chakra-backdrop-hue-rotate",
    _1.hueRotate
  ),
  backdropInvert: W.propT("--chakra-backdrop-invert", _1.invert),
  backdropSaturate: W.propT("--chakra-backdrop-saturate", _1.saturate)
}, u9 = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: _1.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: W.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: W.space("gap"),
  rowGap: W.space("rowGap"),
  columnGap: W.space("columnGap")
};
Object.assign(u9, {
  flexDir: u9.flexDirection
});
var FI = {
  gridGap: W.space("gridGap"),
  gridColumnGap: W.space("gridColumnGap"),
  gridRowGap: W.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, Tne = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: _1.outline },
  outlineOffset: !0,
  outlineColor: W.colors("outlineColor")
}, Ir = {
  width: W.sizesT("width"),
  inlineSize: W.sizesT("inlineSize"),
  height: W.sizes("height"),
  blockSize: W.sizes("blockSize"),
  boxSize: W.sizes(["width", "height"]),
  minWidth: W.sizes("minWidth"),
  minInlineSize: W.sizes("minInlineSize"),
  minHeight: W.sizes("minHeight"),
  minBlockSize: W.sizes("minBlockSize"),
  maxWidth: W.sizes("maxWidth"),
  maxInlineSize: W.sizes("maxInlineSize"),
  maxHeight: W.sizes("maxHeight"),
  maxBlockSize: W.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (e, t) => {
      var n, r, o;
      return { [`@media screen and (min-width: ${(o = (r = (n = t.__breakpoints) == null ? void 0 : n.get(e)) == null ? void 0 : r.minW) != null ? o : e})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (e, t) => {
      var n, r, o;
      return { [`@media screen and (max-width: ${(o = (r = (n = t.__breakpoints) == null ? void 0 : n.get(e)) == null ? void 0 : r._minW) != null ? o : e})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: W.propT("float", _1.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Ir, {
  w: Ir.width,
  h: Ir.height,
  minW: Ir.minWidth,
  maxW: Ir.maxWidth,
  minH: Ir.minHeight,
  maxH: Ir.maxHeight,
  overscroll: Ir.overscrollBehavior,
  overscrollX: Ir.overscrollBehaviorX,
  overscrollY: Ir.overscrollBehaviorY
});
var Ane = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: W.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: W.prop("listStyleImage")
};
function Ine(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
var Lne = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, i, a) => {
    if (typeof r > "u")
      return e(r, o, i);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const l = t.get(r);
    if (l.has(o))
      return l.get(o);
    const c = e(r, o, i, a);
    return l.set(o, c), c;
  };
}, Ene = Lne(Ine), Mne = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, Bne = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, uc = (e, t, n) => {
  const r = {}, o = Ene(e, t, {});
  for (const i in o)
    i in n && n[i] != null || (r[i] = o[i]);
  return r;
}, kne = {
  srOnly: {
    transform(e) {
      return e === !0 ? Mne : e === "focusable" ? Bne : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (e, t, n) => uc(t, `layerStyles.${e}`, n)
  },
  textStyle: {
    processResult: !0,
    transform: (e, t, n) => uc(t, `textStyles.${e}`, n)
  },
  apply: {
    processResult: !0,
    transform: (e, t, n) => uc(t, e, n)
  }
}, c0 = {
  position: !0,
  pos: W.prop("position"),
  zIndex: W.prop("zIndex", "zIndices"),
  inset: W.spaceT("inset"),
  insetX: W.spaceT(["left", "right"]),
  insetInline: W.spaceT("insetInline"),
  insetY: W.spaceT(["top", "bottom"]),
  insetBlock: W.spaceT("insetBlock"),
  top: W.spaceT("top"),
  insetBlockStart: W.spaceT("insetBlockStart"),
  bottom: W.spaceT("bottom"),
  insetBlockEnd: W.spaceT("insetBlockEnd"),
  left: W.spaceT("left"),
  insetInlineStart: W.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: W.spaceT("right"),
  insetInlineEnd: W.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(c0, {
  insetStart: c0.insetInlineStart,
  insetEnd: c0.insetInlineEnd
});
var Rne = {
  ring: { transform: _1.ring },
  ringColor: W.colors("--chakra-ring-color"),
  ringOffset: W.prop("--chakra-ring-offset-width"),
  ringOffsetColor: W.colors("--chakra-ring-offset-color"),
  ringInset: W.prop("--chakra-ring-inset")
}, xt = {
  margin: W.spaceT("margin"),
  marginTop: W.spaceT("marginTop"),
  marginBlockStart: W.spaceT("marginBlockStart"),
  marginRight: W.spaceT("marginRight"),
  marginInlineEnd: W.spaceT("marginInlineEnd"),
  marginBottom: W.spaceT("marginBottom"),
  marginBlockEnd: W.spaceT("marginBlockEnd"),
  marginLeft: W.spaceT("marginLeft"),
  marginInlineStart: W.spaceT("marginInlineStart"),
  marginX: W.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: W.spaceT("marginInline"),
  marginY: W.spaceT(["marginTop", "marginBottom"]),
  marginBlock: W.spaceT("marginBlock"),
  padding: W.space("padding"),
  paddingTop: W.space("paddingTop"),
  paddingBlockStart: W.space("paddingBlockStart"),
  paddingRight: W.space("paddingRight"),
  paddingBottom: W.space("paddingBottom"),
  paddingBlockEnd: W.space("paddingBlockEnd"),
  paddingLeft: W.space("paddingLeft"),
  paddingInlineStart: W.space("paddingInlineStart"),
  paddingInlineEnd: W.space("paddingInlineEnd"),
  paddingX: W.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: W.space("paddingInline"),
  paddingY: W.space(["paddingTop", "paddingBottom"]),
  paddingBlock: W.space("paddingBlock")
};
Object.assign(xt, {
  m: xt.margin,
  mt: xt.marginTop,
  mr: xt.marginRight,
  me: xt.marginInlineEnd,
  marginEnd: xt.marginInlineEnd,
  mb: xt.marginBottom,
  ml: xt.marginLeft,
  ms: xt.marginInlineStart,
  marginStart: xt.marginInlineStart,
  mx: xt.marginX,
  my: xt.marginY,
  p: xt.padding,
  pt: xt.paddingTop,
  py: xt.paddingY,
  px: xt.paddingX,
  pb: xt.paddingBottom,
  pl: xt.paddingLeft,
  ps: xt.paddingInlineStart,
  paddingStart: xt.paddingInlineStart,
  pr: xt.paddingRight,
  pe: xt.paddingInlineEnd,
  paddingEnd: xt.paddingInlineEnd
});
var _ne = {
  textDecorationColor: W.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: W.shadows("textShadow")
}, Fne = {
  clipPath: !0,
  transform: W.propT("transform", _1.transform),
  transformOrigin: !0,
  translateX: W.spaceT("--chakra-translate-x"),
  translateY: W.spaceT("--chakra-translate-y"),
  skewX: W.degreeT("--chakra-skew-x"),
  skewY: W.degreeT("--chakra-skew-y"),
  scaleX: W.prop("--chakra-scale-x"),
  scaleY: W.prop("--chakra-scale-y"),
  scale: W.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: W.degreeT("--chakra-rotate")
}, Pne = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: W.prop("transitionDuration", "transition.duration"),
  transitionProperty: W.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: W.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, Vne = {
  fontFamily: W.prop("fontFamily", "fonts"),
  fontSize: W.prop("fontSize", "fontSizes", _1.px),
  fontWeight: W.prop("fontWeight", "fontWeights"),
  lineHeight: W.prop("lineHeight", "lineHeights"),
  letterSpacing: W.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(e) {
      if (e === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, Hne = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: W.spaceT("scrollMargin"),
  scrollMarginTop: W.spaceT("scrollMarginTop"),
  scrollMarginBottom: W.spaceT("scrollMarginBottom"),
  scrollMarginLeft: W.spaceT("scrollMarginLeft"),
  scrollMarginRight: W.spaceT("scrollMarginRight"),
  scrollMarginX: W.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: W.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: W.spaceT("scrollPadding"),
  scrollPaddingTop: W.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: W.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: W.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: W.spaceT("scrollPaddingRight"),
  scrollPaddingX: W.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: W.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function PI(e) {
  return wn(e) && e.reference ? e.reference : String(e);
}
var q9 = (e, ...t) => t.map(PI).join(` ${e} `).replace(/calc/g, ""), Av = (...e) => `calc(${q9("+", ...e)})`, Iv = (...e) => `calc(${q9("-", ...e)})`, Wu = (...e) => `calc(${q9("*", ...e)})`, Lv = (...e) => `calc(${q9("/", ...e)})`, Ev = (e) => {
  const t = PI(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : Wu(t, -1);
}, _5 = Object.assign(
  (e) => ({
    add: (...t) => _5(Av(e, ...t)),
    subtract: (...t) => _5(Iv(e, ...t)),
    multiply: (...t) => _5(Wu(e, ...t)),
    divide: (...t) => _5(Lv(e, ...t)),
    negate: () => _5(Ev(e)),
    toString: () => e.toString()
  }),
  {
    add: Av,
    subtract: Iv,
    multiply: Wu,
    divide: Lv,
    negate: Ev
  }
);
function One(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function Nne(e) {
  const t = One(e.toString());
  return Zne(Dne(t));
}
function Dne(e) {
  return e.includes("\\.") ? e : !Number.isInteger(parseFloat(e.toString())) ? e.replace(".", "\\.") : e;
}
function Zne(e) {
  return e.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function zne(e, t = "") {
  return [t, e].filter(Boolean).join("-");
}
function Gne(e, t) {
  return `var(${e}${t ? `, ${t}` : ""})`;
}
function Wne(e, t = "") {
  return Nne(`--${zne(e, t)}`);
}
function ur(e, t, n) {
  const r = Wne(e, n);
  return {
    variable: r,
    reference: Gne(r, t)
  };
}
function $ne(e, t) {
  const n = {};
  for (const r of t) {
    if (Array.isArray(r)) {
      const [o, i] = r;
      n[o] = ur(`${e}-${o}`, i);
      continue;
    }
    n[r] = ur(`${e}-${r}`);
  }
  return n;
}
var dn = {
  hover: (e, t) => `${e}:hover ${t}, ${e}[data-hover] ${t}`,
  focus: (e, t) => `${e}:focus ${t}, ${e}[data-focus] ${t}`,
  focusVisible: (e, t) => `${e}:focus-visible ${t}`,
  focusWithin: (e, t) => `${e}:focus-within ${t}`,
  active: (e, t) => `${e}:active ${t}, ${e}[data-active] ${t}`,
  disabled: (e, t) => `${e}:disabled ${t}, ${e}[data-disabled] ${t}`,
  invalid: (e, t) => `${e}:invalid ${t}, ${e}[data-invalid] ${t}`,
  checked: (e, t) => `${e}:checked ${t}, ${e}[data-checked] ${t}`,
  indeterminate: (e, t) => `${e}:indeterminate ${t}, ${e}[aria-checked=mixed] ${t}, ${e}[data-indeterminate] ${t}`,
  readOnly: (e, t) => `${e}:read-only ${t}, ${e}[readonly] ${t}, ${e}[data-read-only] ${t}`,
  expanded: (e, t) => `${e}:read-only ${t}, ${e}[aria-expanded=true] ${t}, ${e}[data-expanded] ${t}`,
  placeholderShown: (e, t) => `${e}:placeholder-shown ${t}`
}, zi = (e) => VI((t) => e(t, "&"), "[role=group]", "[data-group]", ".group"), ei = (e) => VI((t) => e(t, "~ &"), "[data-peer]", ".peer"), VI = (e, ...t) => t.map(e).join(", "), HI = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: zi(dn.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: ei(dn.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: zi(dn.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: ei(dn.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: zi(dn.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: ei(dn.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: zi(dn.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: ei(dn.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: zi(dn.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: ei(dn.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: zi(dn.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: ei(dn.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: zi(dn.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: ei(dn.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: zi(dn.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: ei(dn.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: ei(dn.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]"
}, Une = Object.keys(
  HI
), OI = nr(
  {},
  Bl,
  W1,
  wne,
  u9,
  Ir,
  Sne,
  Rne,
  Tne,
  FI,
  kne,
  c0,
  Gu,
  xt,
  Hne,
  Vne,
  _ne,
  Fne,
  Ane,
  Pne
);
Object.assign({}, xt, Ir, u9, FI, c0);
[...Object.keys(OI), ...Une];
({ ...OI, ...HI });
function bi(e) {
  return {
    definePartsStyle(t) {
      return t;
    },
    defineMultiStyleConfig(t) {
      return { parts: e, ...t };
    }
  };
}
function Je(e, t) {
  return (n) => n.colorMode === "dark" ? t : e;
}
function jne(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function Xne(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function NI(e) {
  const t = Xne(e.toString());
  return t.includes("\\.") ? e : jne(e) ? t.replace(".", "\\.") : e;
}
function Yne(e, t = "") {
  return [t, NI(e)].filter(Boolean).join("-");
}
function Jne(e, t) {
  return `var(${NI(e)}${t ? `, ${t}` : ""})`;
}
function Qne(e, t = "") {
  return `--${Yne(e, t)}`;
}
function Hs(e, t) {
  const n = Qne(e, void 0);
  return {
    variable: n,
    reference: Jne(n, qne(void 0))
  };
}
function qne(e) {
  return typeof e == "string" ? e : e?.reference;
}
const Kne = {
  global: (e) => ({
    body: {
      color: Je(j.light.text.primary, j.dark.text.primary)(e),
      bg: Je(j.light.background[1], j.dark.background[1])(e),
      fontSize: "1rem",
      margin: 0,
      WebkitOverflowScrolling: "touch"
    },
    // Add hover styles here,
    // If we add `_hover` to custom `Button` component, the theme `_hover` styles get overridden.
    ".chakra-button": {
      _hover: {
        ".chakra-button__right-addon": {
          borderColor: De(Je(j.light.border[1], j.dark.border[1])(e), 0.15)
        }
      }
    },
    ".chakra-toast": {
      ".chakra-toast__inner": {
        minW: "325px"
      }
    },
    // The arrow gets covered since we add a shadow to tooltips.
    // Need to override the inline styles from Popper.
    ".chakra-tooltip__arrow-wrapper": {
      zIndex: `${Mr.zIndices.popover + 1} !important`
    }
  })
}, Ge = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  // Multiples of 4 up to 20px with some exceptions, multiples of 8 beyond with no exceptions.
  fontSizes: {
    2: "0.5rem",
    3: "0.75rem",
    "3.5": "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    18: "4.5rem",
    20: "5rem",
    22: "5.5rem"
    // 88
  },
  fontWeights: {
    100: 100,
    200: 200,
    300: 300,
    400: 400,
    500: 500,
    600: 600,
    700: 700,
    800: 800,
    900: 900
  },
  fonts: {
    body: `'Space Grotesk', -apple-system, '.SFNSText-Regular', 'San Francisco', BlinkMacSystemFont,
    '.PingFang-SC-Regular', 'Microsoft YaHei', 'Segoe UI', 'Helvetica Neue', Helvetica, Arial,
    sans-serif`,
    heading: `'Space Grotesk', -apple-system, '.SFNSText-Regular', 'San Francisco', BlinkMacSystemFont,
    '.PingFang-SC-Regular', 'Microsoft YaHei', 'Segoe UI', 'Helvetica Neue', Helvetica, Arial,
    sans-serif`,
    mono: `'Space Grotesk', -apple-system, '.SFNSText-Regular', 'San Francisco', BlinkMacSystemFont,
    '.PingFang-SC-Regular', 'Microsoft YaHei', 'Segoe UI', 'Helvetica Neue', Helvetica, Arial,
    sans-serif`
  }
}, Yt = {
  breakpoints: II,
  colors: j,
  config: one,
  shadows: ine,
  sizes: q,
  styles: Kne,
  ...Ge
}, { definePartsStyle: ere, defineMultiStyleConfig: tre } = bi(Rw.keys), nre = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, rre = {
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {},
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: q[4],
  py: q[2]
}, ore = {
  pt: q[2],
  px: q[4],
  pb: q[5]
}, ire = {
  fontSize: Ge.fontSizes[5]
}, are = ere({
  container: nre,
  button: rre,
  panel: ore,
  icon: ire
}), sre = tre({ baseStyle: are }), Ln = {
  ZEN_DOTS: "'Zen Dots', sans-serif",
  SPACE_GROTESK: "'Space Grotesk', sans-serif"
}, hs = {
  display: {
    lg: {
      fontFamily: Ln.ZEN_DOTS,
      fontSize: Ge.fontSizes[20],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[22],
      letterSpacing: Ge.letterSpacings.wider
    },
    md: {
      fontFamily: Ln.ZEN_DOTS,
      fontSize: Ge.fontSizes[16],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[18],
      letterSpacing: Ge.letterSpacings.wider
    },
    sm: {
      fontFamily: Ln.ZEN_DOTS,
      fontSize: Ge.fontSizes[12],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[14],
      letterSpacing: Ge.letterSpacings.wider
    },
    xs: {
      fontFamily: Ln.ZEN_DOTS,
      fontSize: Ge.fontSizes[8],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[10],
      letterSpacing: Ge.letterSpacings.wider
    },
    "2xs": {
      fontFamily: Ln.ZEN_DOTS,
      fontSize: Ge.fontSizes[6],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[8],
      letterSpacing: Ge.letterSpacings.wider
    }
  },
  heading: {
    lg: {
      fontFamily: Ln.SPACE_GROTESK,
      fontSize: Ge.fontSizes[12],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[14]
    },
    md: {
      fontFamily: Ln.SPACE_GROTESK,
      fontSize: Ge.fontSizes[8],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[10]
    },
    sm: {
      fontFamily: Ln.SPACE_GROTESK,
      fontSize: Ge.fontSizes[6],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[8]
    },
    xs: {
      fontFamily: Ln.SPACE_GROTESK,
      fontSize: Ge.fontSizes[5],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[7]
    }
  },
  body: {
    lg: {
      fontFamily: Ln.SPACE_GROTESK,
      fontSize: Ge.fontSizes[5],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[7]
    },
    md: {
      fontFamily: Ln.SPACE_GROTESK,
      fontSize: Ge.fontSizes[4],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[6]
    },
    sm: {
      fontFamily: Ln.SPACE_GROTESK,
      fontSize: Ge.fontSizes["3.5"],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[5]
    }
  },
  label: {
    lg: {
      fontFamily: Ln.SPACE_GROTESK,
      fontSize: Ge.fontSizes[4],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[6]
    },
    md: {
      fontFamily: Ln.SPACE_GROTESK,
      fontSize: Ge.fontSizes["3.5"],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[4]
    },
    sm: {
      fontFamily: Ln.SPACE_GROTESK,
      fontSize: Ge.fontSizes[3],
      fontWeight: "400",
      lineHeight: Ge.fontSizes[4]
    }
  }
}, DI = {
  variant: "solid",
  size: "md",
  colorScheme: "primary"
}, kl = {
  lg: {
    ...hs.label.lg,
    fontWeight: "500",
    px: q[3],
    py: q[2]
  },
  md: {
    ...hs.label.md,
    fontWeight: "500",
    px: q[3],
    py: q[2]
  },
  sm: {
    ...hs.label.sm,
    fontWeight: "500",
    px: q[2],
    py: q[1]
  }
}, Ot = $ne("badge", ["bg", "color", "shadow"]), ra = (e) => e === "primary" ? 1 : 2, lre = {
  textTransform: "none",
  borderRadius: q[1],
  bg: Ot.bg.reference,
  color: Ot.color.reference,
  boxShadow: Ot.shadow.reference
}, cre = (e) => {
  const t = e.colorScheme;
  return {
    [Ot.bg.variable]: j.light.support[t][ra(t)],
    [Ot.color.variable]: j.light.text.on.color.primary,
    _dark: {
      [Ot.bg.variable]: j.dark.support[t][ra(t)],
      [Ot.color.variable]: j.dark.text.on.color.primary
    }
  };
}, ure = (e) => {
  const t = e.colorScheme;
  return {
    [Ot.bg.variable]: j.light.support.primary[5],
    [Ot.color.variable]: j.light.support[t][ra(t)],
    _dark: {
      [Ot.bg.variable]: j.dark.support.primary[5],
      [Ot.color.variable]: j.dark.support[t][ra(t)]
    }
  };
}, dre = (e) => {
  const t = e.colorScheme;
  return {
    [Ot.bg.variable]: j.light.support.primary[5],
    [Ot.color.variable]: j.light.text.secondary,
    svg: {
      color: j.light.support[t][ra(t)]
    },
    _dark: {
      [Ot.bg.variable]: j.dark.support.primary[5],
      [Ot.color.variable]: j.dark.text.secondary,
      svg: {
        color: j.dark.support[t][ra(t)]
      }
    }
  };
}, fre = (e) => {
  const t = e.colorScheme;
  return {
    [Ot.color.variable]: j.light.support[t][ra(t)],
    _dark: {
      [Ot.color.variable]: j.dark.support[t][ra(t)]
    },
    [Ot.shadow.variable]: `inset 0 0 0px 1px ${Ot.color.reference}`
  };
}, pre = {
  solid: cre,
  subtle: ure,
  outline: fre,
  grayscale: dre
}, $5 = {
  baseStyle: lre,
  variants: pre,
  sizes: kl,
  defaultProps: DI
}, hre = {
  variant: "solid",
  size: "md",
  colorScheme: "primary"
}, vn = {
  "2xl": {
    h: Yt.sizes[16],
    fontSize: Yt.fontSizes[4],
    lineHeight: Yt.fontSizes[6]
  },
  xl: {
    h: Yt.sizes[14],
    fontSize: Yt.fontSizes[4],
    lineHeight: Yt.fontSizes[6]
  },
  lg: {
    h: Yt.sizes[12],
    fontSize: Yt.fontSizes[4],
    lineHeight: Yt.fontSizes[6]
  },
  md: {
    h: Yt.sizes[10],
    fontSize: Yt.fontSizes["3.5"],
    lineHeight: Yt.fontSizes[4]
  },
  sm: {
    h: Yt.sizes[8],
    fontSize: Yt.fontSizes["3.5"],
    lineHeight: Yt.fontSizes[4]
  },
  xs: {
    h: Yt.sizes[6],
    fontSize: Yt.fontSizes["3.5"],
    lineHeight: Yt.fontSizes[4]
  }
}, d3 = (e) => ({
  // boxShadow: `0 0 0 1px ${mode(
  //   colors.light.border.secondary[10],
  //   colors.dark.border.secondary[10],
  // )(props)}, 0 0 0 3px ${mode(
  //   colors.light.border.brand[10],
  //   colors.dark.border.brand[10],
  // )(props)}`,
}), mre = (e) => {
  const t = e.colorScheme, n = {
    _disabled: {
      bg: Je(j.light.button.disabled, j.dark.button.disabled)(e),
      color: Je(j.light.text.on.color.disabled, j.dark.text.on.color.disabled)(e),
      opacity: 1,
      cursor: "not-allowed"
    }
  };
  return {
    ...n,
    color: Je(j.light.button[t].default, j.dark.button[t].default)(e),
    bg: Je(j.light.button[t].subtle, j.dark.button[t].subtle)(e),
    _hover: {
      ...n,
      color: Je(j.light.text.on.color.primary, j.dark.text.on.color.primary)(e),
      bg: Je(j.light.button[t].hover, j.dark.button[t].hover)(e)
    },
    _active: {
      ...n,
      color: Je(j.light.text.on.color.primary, j.dark.text.on.color.primary)(e),
      bg: Je(j.light.button[t].active, j.dark.button[t].active)(e)
    },
    _focus: {
      ...n,
      ...d3(e)
    }
  };
}, Cre = (e) => {
  const t = e.colorScheme, n = {
    _disabled: {
      bg: Je(j.light.button.disabled, j.dark.button.disabled)(e),
      color: Je(j.light.text.on.color.disabled, j.dark.text.on.color.disabled)(e),
      opacity: 1,
      cursor: "not-allowed"
    }
  };
  return {
    ...n,
    color: Je(j.light.button[t].default, j.dark.button[t].default)(e),
    bg: "transparent",
    _hover: {
      ...n,
      color: Je(j.light.text.on.color.primary, j.dark.text.on.color.primary)(e),
      bg: Je(j.light.button[t].hover, j.dark.button[t].hover)(e)
    },
    _active: {
      ...n,
      color: Je(j.light.text.on.color.primary, j.dark.text.on.color.primary)(e),
      bg: Je(j.light.button[t].active, j.dark.button[t].active)(e)
    },
    _focus: {
      ...n,
      ...d3(e)
    }
  };
}, gre = (e) => {
  const t = e.colorScheme, n = {
    borderWidth: "1px",
    _disabled: {
      borderColor: Je(j.light.button.disabled, j.dark.button.disabled)(e),
      color: Je(j.light.text.disabled, j.dark.text.disabled)(e),
      opacity: 1,
      cursor: "not-allowed"
    }
  };
  return {
    ...n,
    bg: "transparent",
    borderColor: Je(j.light.button[t].default, j.dark.button[t].default)(e),
    color: Je(j.light.button[t].default, j.dark.button[t].default)(e),
    _hover: {
      ...n,
      bg: Je(j.light.button[t].hover, j.dark.button[t].hover)(e),
      borderColor: "transparent",
      color: Je(j.light.text.on.color.primary, j.dark.text.on.color.primary)(e)
    },
    _active: {
      ...n,
      bg: Je(j.light.button[t].active, j.dark.button[t].active)(e),
      borderColor: "transparent",
      color: Je(j.light.text.on.color.primary, j.dark.text.on.color.primary)(e)
    },
    _focus: {
      ...n,
      ...d3(e)
    }
  };
}, bre = (e) => {
  const t = e.colorScheme, n = {
    _disabled: {
      bg: Je(j.light.button.disabled, j.dark.button.disabled)(e),
      color: Je(j.light.text.on.color.disabled, j.dark.text.on.color.disabled)(e),
      opacity: 1,
      cursor: "not-allowed"
    }
  };
  return {
    ...n,
    bg: Je(j.light.button[t].default, j.dark.button[t].default)(e),
    color: Je(j.light.text.on.color.primary, j.dark.text.on.color.primary)(e),
    _hover: {
      ...n,
      bg: Je(j.light.button[t].hover, j.dark.button[t].hover)(e)
    },
    _active: {
      ...n,
      bg: Je(j.light.button[t].active, j.dark.button[t].active)(e)
    },
    _focus: {
      ...n,
      ...d3(e)
    }
  };
}, vre = (e) => {
  const t = e.colorScheme, n = {
    minW: "min-content",
    height: "min-content",
    padding: 0,
    _disabled: {
      color: Je(j.light.text.disabled, j.dark.text.disabled)(e),
      opacity: 1,
      cursor: "not-allowed"
    }
  };
  return {
    ...n,
    color: Je(j.light.button[t].default, j.dark.button[t].default)(e),
    _hover: {
      ...n,
      color: Je(j.light.button[t].hover, j.dark.button[t].hover)(e)
    },
    _active: {
      ...n,
      color: Je(j.light.button[t].active, j.dark.button[t].active)(e)
    },
    _focus: {
      ...n,
      ...d3(e)
    }
  };
}, yre = {
  solid: bre,
  subtle: mre,
  ghost: Cre,
  outline: gre,
  text: vre
  // unstyled: variantUnstyled,
}, xre = {
  baseStyle: {
    fontWeight: "500",
    _hover: {
      _disabled: {
        bg: "initial"
      }
    }
  },
  variants: yre,
  sizes: {
    "2xl": {
      ...vn["2xl"],
      minW: q[30],
      px: q[8],
      borderRadius: q[2]
    },
    xl: {
      ...vn.xl,
      minW: q[30],
      px: q[6],
      borderRadius: q[2]
    },
    lg: {
      ...vn.lg,
      minW: q[24],
      px: q[6],
      borderRadius: q[2]
    },
    md: {
      ...vn.md,
      minW: q[18],
      px: q[4],
      borderRadius: q[2]
    },
    sm: {
      ...vn.sm,
      minW: q[16],
      px: q[4],
      borderRadius: q[2]
    },
    xs: {
      ...vn.xs,
      minW: q[14],
      px: q[2],
      borderRadius: q[2]
    }
  },
  defaultProps: hre
}, wre = {
  borderColor: j.light.border[3],
  _dark: {
    borderColor: j.dark.border[3]
  }
}, Sre = {
  borderStyle: "solid"
}, Tre = {
  borderStyle: "dashed"
}, Are = {
  solid: Sre,
  dashed: Tre
}, Ire = {
  baseStyle: wre,
  variants: Are,
  defaultProps: {
    variant: "solid"
  }
}, { definePartsStyle: Lre, defineMultiStyleConfig: Ere } = bi(_w.keys), dc = ur("form-control-color"), Mre = () => ({
  mt: q[2],
  [dc.variable]: j.light.text.tertiary,
  _dark: {
    [dc.variable]: j.dark.text.tertiary
  },
  color: dc.reference,
  fontSize: Ge.fontSizes["3.5"],
  lineHeight: Ge.fontSizes[4]
}), Bre = Lre(() => ({
  container: {
    width: "100%",
    position: "relative"
  },
  helperText: Mre()
})), kre = Ere({
  baseStyle: Bre
}), { definePartsStyle: Rre, defineMultiStyleConfig: _re } = bi(Fw.keys), Fre = (e) => ({
  color: Je(j.light.text.danger, j.dark.text.danger)(e),
  mt: q[2],
  fontSize: Ge.fontSizes["3.5"]
}), Pre = {}, Vre = Rre((e) => ({
  text: Fre(e),
  icon: Pre
})), Hre = _re({
  baseStyle: Vre
}), Ore = (e) => ({
  fontSize: Ge.fontSizes["3.5"],
  fontWeight: "400",
  lineHeight: Ge.fontSizes[4],
  color: Je(j.light.text.tertiary, j.dark.text.tertiary)(e),
  mb: q[3],
  opacity: 1,
  _disabled: {
    color: Je(j.light.text.disabled, j.dark.text.disabled)(e),
    opacity: 1
  }
}), Nre = {
  baseStyle: Ore
}, Dre = {
  size: "md",
  variant: "outline"
}, fo = {
  "2xl": {
    fontSize: Ge.fontSizes[4],
    lineHeight: Ge.fontSizes[6],
    px: q[6],
    h: q[16],
    borderRadius: q[2]
  },
  xl: {
    fontSize: Ge.fontSizes[4],
    lineHeight: Ge.fontSizes[6],
    px: q[4],
    h: q[14],
    borderRadius: q[2]
  },
  lg: {
    fontSize: Ge.fontSizes[4],
    lineHeight: Ge.fontSizes[6],
    px: q[4],
    h: q[12],
    borderRadius: q[2]
  },
  md: {
    fontSize: Ge.fontSizes["3.5"],
    lineHeight: Ge.fontSizes[4],
    px: q[4],
    h: q[10],
    borderRadius: q[2]
  },
  sm: {
    fontSize: Ge.fontSizes["3.5"],
    lineHeight: Ge.fontSizes[4],
    px: q[4],
    h: q[8],
    borderRadius: q[2]
  },
  // TODO: Size `xs` not in Figma.
  xs: {
    fontSize: Ge.fontSizes[3],
    px: q[2],
    h: q[6],
    borderRadius: q[1]
  }
}, { definePartsStyle: Fa, defineMultiStyleConfig: Zre } = bi(Pw.keys), zre = Fa({
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
}), Gre = Fa((e) => {
  const t = {
    borderColor: Je(j.light.text.danger, j.dark.text.danger)(e),
    boxShadow: "none",
    _focus: {
      boxShadow: `0 0 0 1px ${Je(j.light.text.danger, j.dark.text.danger)(e)}`
    }
  }, n = {
    bg: Je(j.light.input[1], j.dark.input[1])(e),
    border: "1px solid",
    borderColor: Je(j.light.border[4], j.dark.border[4])(e),
    boxShadow: "none",
    color: Je(j.light.text.primary, j.dark.text.primary)(e),
    _invalid: {
      ...t
    }
  };
  return {
    field: {
      ...n,
      _active: {
        ...n
      },
      _hover: {
        ...n
      },
      _readOnly: {
        ...n
      },
      _disabled: {
        ...n,
        opacity: 0.5,
        cursor: "not-allowed"
      },
      _invalid: {
        ...t
      },
      _focus: {
        ...n,
        borderColor: Je(j.light.border.brand, j.dark.border.brand)(e),
        boxShadow: `0 0 0 1px ${Je(j.light.border.brand, j.dark.border.brand)(e)}`
      },
      _focusVisible: {
        ...n,
        borderColor: Je(j.light.border.brand, j.dark.border.brand)(e),
        boxShadow: `0 0 0 1px ${Je(j.light.border.brand, j.dark.border.brand)(e)}`
      },
      _placeholder: {
        color: Je(j.light.text.placeholder, j.dark.text.placeholder)(e),
        opacity: 1
      }
    },
    addon: {}
  };
}), Wre = {
  outline: Gre
}, Ui = Zre({
  baseStyle: zre,
  sizes: {
    "2xl": Fa({
      field: fo["2xl"],
      addon: fo["2xl"]
    }),
    xl: Fa({
      field: fo.xl,
      addon: fo.xl
    }),
    lg: Fa({
      field: fo.lg,
      addon: fo.lg
    }),
    md: Fa({
      field: fo.md,
      addon: fo.md
    }),
    sm: Fa({
      field: fo.sm,
      addon: fo.sm
    })
  },
  variants: Wre,
  defaultProps: Dre
}), $re = (e) => ({
  color: Je(j.light.button.brand.default, j.dark.button.brand.default)(e),
  textDecoration: "underline",
  _hover: {
    color: Je(j.light.button.brand.hover, j.dark.button.brand.hover)(e)
  },
  _active: {
    color: Je(j.light.button.brand.active, j.dark.button.brand.active)(e)
  },
  _focusVisible: {
    boxShadow: "none"
  }
}), Ure = {
  baseStyle: $re
}, { defineMultiStyleConfig: jre, definePartsStyle: $u } = bi(Vw.keys), fc = ur("modal-bg"), pc = ur("modal-shadow"), ji = ur("modal-color"), Xre = (e) => ({
  bg: Je(j.light.overlay, j.dark.overlay)(e),
  zIndex: "modal"
}), Yre = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    borderRadius: q[4],
    my: t ? "auto" : q[4],
    // mx: isCentered ? 'auto' : undefined,
    mx: q[4],
    maxH: n === "inside" ? "calc(100% - 7.5rem)" : void 0,
    [fc.variable]: j.light.background[1],
    [pc.variable]: j.light.shadow[4],
    [ji.variable]: j.light.text.primary,
    _dark: {
      [fc.variable]: j.dark.background[1],
      [pc.variable]: j.dark.shadow[4],
      [ji.variable]: j.dark.text.primary
    },
    bg: fc.reference,
    boxShadow: pc.reference,
    color: ji.reference
  };
}, Jre = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
}, Qre = {
  // Include close button size.
  px: { base: q[4], md: q[10] },
  pt: { base: q[4], md: q[12] },
  pb: 0,
  fontSize: { base: Ge.fontSizes[5], md: Ge.fontSizes[6] },
  lineHeight: { base: Ge.fontSizes[7], md: Ge.fontSizes[8] },
  fontWeight: "700"
}, qre = {
  position: "absolute",
  top: { base: q[4], md: q[6] },
  insetEnd: { base: q[4], md: q[6] },
  // Button with `ghost` variant.
  [ji.variable]: j.light.button.primary.default,
  _dark: {
    [ji.variable]: j.dark.button.primary.default
  },
  color: ji.reference,
  _hover: {
    bg: "transparent",
    [ji.variable]: j.light.button.primary.hover,
    _dark: {
      [ji.variable]: j.dark.button.primary.hover
    }
  },
  _focusVisible: {
    boxShadow: "none"
  }
}, Kre = {
  px: { base: q[4], md: q[10] },
  pt: q[2],
  pb: q[6]
}, eoe = {
  px: { base: q[4], md: q[10] },
  pt: 0,
  pb: { base: q[8], md: q[10] }
}, toe = $u((e) => ({
  overlay: Xre(e),
  dialogContainer: Jre(e),
  dialog: Yre(e),
  header: Qre,
  closeButton: qre,
  body: Kre,
  footer: eoe
}));
function Xr(e) {
  return $u(e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "$100vh",
      my: "0",
      borderRadius: "0"
    }
  } : {
    dialog: { maxW: e }
  });
}
const noe = {
  xs: Xr("xs"),
  sm: Xr("sm"),
  md: Xr("md"),
  lg: Xr("lg"),
  xl: Xr("xl"),
  "2xl": Xr("2xl"),
  "3xl": Xr("3xl"),
  "4xl": Xr("4xl"),
  "5xl": Xr("5xl"),
  "6xl": Xr("6xl"),
  full: Xr("full")
}, roe = jre({
  baseStyle: toe,
  sizes: noe,
  defaultProps: { size: "md" }
}), { defineMultiStyleConfig: ooe, definePartsStyle: ioe } = bi(Hw.keys), il = Hs("popper-bg"), aoe = Hs("popper-arrow-bg"), hc = Hs("popper-color"), soe = {
  [il.variable]: j.light.background[1],
  [aoe.variable]: il.reference,
  [hc.variable]: j.light.text.primary,
  _dark: {
    [il.variable]: j.dark.background[1],
    [hc.variable]: j.dark.text.primary
  },
  bg: il.reference,
  color: hc.reference,
  border: "none",
  _focusVisible: {
    boxShadow: "none"
  }
}, loe = {
  px: q[3],
  py: q[2]
}, coe = {
  fontSize: Ge.fontSizes["3.5"],
  lineHeight: q[5],
  px: q[3],
  py: q[2]
}, uoe = {
  px: q[3],
  py: q[2]
}, doe = {
  position: "absolute",
  borderRadius: "md",
  top: q[1],
  insetEnd: q[2],
  padding: q[2]
}, foe = ioe({
  content: soe,
  header: loe,
  body: coe,
  footer: uoe,
  closeButton: doe
}), poe = ooe({
  baseStyle: foe
}), mc = ur("skeleton-start-color"), Cc = ur("skeleton-end-color"), hoe = () => ({
  [mc.variable]: j.light.layer.disabled,
  [Cc.variable]: Ute(0.6, j.light.layer.disabled),
  _dark: {
    [mc.variable]: j.dark.layer.disabled,
    [Cc.variable]: zte(0.4, j.dark.layer.disabled)
  },
  background: mc.reference,
  borderColor: Cc.reference,
  borderRadius: q[2],
  opacity: 1
}), moe = {
  baseStyle: hoe
}, { defineMultiStyleConfig: Coe, definePartsStyle: Rl } = bi(Ow.keys), goe = Rl({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: q[4],
    textAlign: "start"
  }
}), boe = Coe({
  baseStyle: goe,
  sizes: {
    sm: Rl({
      th: {
        px: q[4],
        py: q[1]
      },
      td: {
        px: q[4],
        py: q[2]
      },
      caption: {
        px: q[4],
        py: q[2]
      }
    }),
    md: Rl({
      th: {
        px: q[6],
        py: q[3]
      },
      td: {
        px: q[6],
        py: q[4]
      },
      caption: {
        px: q[6],
        py: q[2]
      }
    }),
    lg: Rl({
      th: {
        px: q[8],
        py: q[4]
      },
      td: {
        px: q[8],
        py: q[5]
      },
      caption: {
        px: q[6],
        py: q[2]
      }
    })
  },
  defaultProps: {
    size: "md"
  }
}), Qt = ur("tabs-color"), Bn = ur("tabs-bg"), { defineMultiStyleConfig: voe, definePartsStyle: ri } = bi(Nw.keys), yoe = (e) => {
  const { isFitted: t } = e;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 1
    }
  };
}, xoe = {}, woe = ri((e) => ({
  tab: yoe(e),
  tabpanel: xoe
})), Soe = ri((e) => {
  const t = e.colorScheme, { orientation: n } = e, r = n === "vertical", o = r ? "borderStart" : "borderBottom", i = r ? "marginStart" : "marginBottom", a = {
    [Qt.variable]: j.light.text.disabled,
    borderColor: "transparent",
    _selected: {
      _dark: {
        [Qt.variable]: j.dark.text.disabled,
        borderColor: "transparent"
      }
    },
    _active: {
      bg: "none",
      _dark: {
        bg: "none"
      }
    }
  };
  return {
    tablist: {
      [o]: "2px solid",
      borderColor: Je(j.light.border[3], j.dark.border[3])(e)
    },
    tab: {
      fontWeight: "700",
      [o]: "2px solid",
      borderColor: "transparent",
      [i]: "-2px",
      color: Je(j.light.text.tertiary, j.dark.text.tertiary)(e),
      bg: Bn.reference,
      _selected: {
        [o]: "3px solid",
        borderColor: "currentColor",
        [i]: "-3px",
        color: Qt.reference,
        [Qt.variable]: j.light.button[t].default,
        _dark: {
          [Qt.variable]: j.dark.button[t].default
        },
        _disabled: {
          ...a
        }
      },
      _active: {
        [Bn.variable]: "none",
        _dark: {
          [Bn.variable]: "none"
        }
      },
      _disabled: {
        ...a
      }
    }
  };
}), Toe = ri((e) => {
  const t = e.colorScheme, n = {
    fontWeight: "400",
    [Qt.variable]: j.light.text.disabled,
    [Bn.variable]: j.light.layer[4].default,
    _dark: {
      [Qt.variable]: j.dark.text.disabled,
      [Bn.variable]: j.dark.layer[4].default
    },
    _selected: {},
    _active: {}
  };
  return {
    tablist: {
      border: `1px solid ${Je(j.light.border[4], j.dark.border[4])(e)}`,
      borderRadius: q[2],
      overflow: "hidden"
    },
    tab: {
      fontWeight: "400",
      [Qt.variable]: j.light.text.tertiary,
      [Bn.variable]: j.light.layer[4].default,
      _dark: {
        [Qt.variable]: j.dark.text.tertiary,
        [Bn.variable]: j.dark.layer[4].default
      },
      _selected: {
        fontWeight: "700",
        [Qt.variable]: j.light.text.on.color.primary,
        [Bn.variable]: j.light.button[t].default,
        _dark: {
          [Qt.variable]: j.dark.text.on.color.primary,
          [Bn.variable]: j.dark.button[t].default
        },
        _disabled: {
          ...n
        }
      },
      _active: {},
      _disabled: {
        ...n
      },
      color: Qt.reference,
      bg: Bn.reference
    }
  };
}), Aoe = ri((e) => {
  const t = e.colorScheme, n = {
    [Qt.variable]: j.light.text.disabled,
    [Bn.variable]: "none",
    _dark: {
      [Qt.variable]: j.dark.text.disabled,
      [Bn.variable]: "none"
    }
  };
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "700",
      [Qt.variable]: j.light.text.primary,
      _dark: {
        [Qt.variable]: j.dark.text.primary
      },
      _selected: {
        [Qt.variable]: j.light.text.on.color.primary,
        [Bn.variable]: j.light.button[t].default,
        _dark: {
          [Qt.variable]: j.dark.text.on.color.primary,
          [Bn.variable]: j.dark.button[t].default
        },
        _disabled: {
          ...n
        }
      },
      _disabled: {
        ...n
      },
      color: Qt.reference,
      bg: Bn.reference
    }
  };
}), Ioe = {
  line: Soe,
  outline: Toe,
  solid: Aoe
}, Loe = voe({
  baseStyle: woe,
  // Uses button sizing.
  sizes: {
    sm: ri({
      tablist: {
        h: vn.sm.h
      },
      tab: {
        ...vn.sm,
        py: 0,
        px: q[4]
      }
    }),
    md: ri({
      tablist: {
        h: vn.md.h
      },
      tab: {
        ...vn.md,
        py: 0,
        px: q[4]
      }
    }),
    lg: ri({
      tablist: {
        h: vn.lg.h
      },
      tab: {
        ...vn.lg,
        py: 0,
        px: q[4]
      }
    }),
    xl: ri({
      tablist: {
        h: vn.xl.h
      },
      tab: {
        ...vn.xl,
        py: 0,
        px: q[4]
      }
    }),
    "2xl": ri({
      tablist: {
        h: vn["2xl"].h
      },
      tab: {
        ...vn["2xl"],
        py: 0,
        px: q[4]
      }
    })
  },
  variants: Ioe,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "primary"
  }
}), { defineMultiStyleConfig: Eoe, definePartsStyle: Ji } = bi(Dw.keys), Mv = ur("tag-bg"), Bv = ur("tag-color"), kv = ur("tag-shadow"), Moe = {
  [Bv.variable]: Ot.color.reference,
  [Mv.variable]: Ot.bg.reference,
  [kv.variable]: Ot.shadow.reference,
  color: Bv.reference,
  bg: Mv.reference,
  boxShadow: kv.reference,
  borderRadius: q[10]
}, Boe = Ji({
  container: Moe
}), koe = {
  subtle: Ji((e) => ({
    container: $5.variants?.subtle(e)
  })),
  solid: Ji((e) => ({
    container: $5.variants?.solid(e)
  })),
  outline: Ji((e) => ({
    container: $5.variants?.outline(e)
  })),
  grayscale: Ji((e) => ({
    container: $5.variants?.grayscale(e)
  }))
}, Roe = Eoe({
  variants: koe,
  baseStyle: Boe,
  sizes: {
    lg: Ji({
      container: {
        ...kl.lg
      }
    }),
    md: Ji({
      container: {
        ...kl.md
      }
    }),
    sm: Ji({
      container: {
        ...kl.sm
      }
    })
  },
  defaultProps: DI
}), _oe = {
  ...Ui.baseStyle?.field,
  paddingY: q[2],
  minHeight: q[5],
  verticalAlign: "top"
}, Foe = {
  outline: (e) => Ui.variants?.outline(e).field ?? {}
}, Poe = {
  baseStyle: _oe,
  sizes: {
    sm: Ui.sizes?.sm.field ?? {},
    md: Ui.sizes?.md.field ?? {},
    lg: Ui.sizes?.lg.field ?? {},
    xl: Ui.sizes?.xl.field ?? {},
    "2xl": Ui.sizes?.["2xl"].field ?? {}
  },
  variants: Foe,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}, al = Hs("tooltip-bg"), gc = Hs("tooltip-fg"), Voe = Hs("popper-arrow-bg"), Hoe = {
  bg: al.reference,
  color: gc.reference,
  [al.variable]: j.light.layer.inverse,
  [gc.variable]: j.light.text.inverse,
  boxShadow: j.light.shadow[4],
  _dark: {
    [al.variable]: j.dark.layer.inverse,
    [gc.variable]: j.dark.text.inverse,
    boxShadow: j.dark.shadow[4]
  },
  [Voe.variable]: al.reference,
  px: q[2],
  py: q["0.5"],
  borderRadius: q[1],
  zIndex: "tooltip"
}, Ooe = {
  baseStyle: Hoe,
  sizes: {
    sm: {
      fontSize: Ge.fontSizes[3],
      lineHeight: q[4],
      px: q[2],
      py: q[1]
    },
    md: {
      fontSize: Ge.fontSizes[3],
      lineHeight: q[4],
      px: q[2],
      py: q[1]
    },
    lg: {
      fontSize: Ge.fontSizes[4],
      lineHeight: q[6],
      px: q[4],
      py: q[2]
    }
  },
  defaultProps: {
    size: "md"
  }
}, Noe = {
  Accordion: sre,
  Badge: $5,
  Button: xre,
  Divider: Ire,
  Form: kre,
  FormError: Hre,
  FormLabel: Nre,
  Input: Ui,
  Link: Ure,
  Modal: roe,
  Popover: poe,
  Skeleton: moe,
  Table: boe,
  Tabs: Loe,
  Tag: Roe,
  Textarea: Poe,
  Tooltip: Ooe
}, Doe = {
  components: Noe,
  ...Yt
}, H = u$(Doe), fn = {
  BUTTON: "chakra-button",
  BUTTON__ICON: "chakra-button__icon",
  BUTTON__RIGHT_ADDON: "chakra-button__right-addon",
  DIVIDER: "chakra-divider",
  FORM__HELPER_TEXT: "chakra-form__helper-text",
  FORM__LABEL: "chakra-form__label",
  FORM_CONTROL: "chakra-form-control",
  ICON: "chakra-icon",
  INPUT__GROUP: "chakra-input__group",
  INPUT__RIGHT_ELEMENT: "chakra-input__right-element",
  SELECT__DROPDOWN_ICON_DOWN: "chakra-select__dropdown-icon-down",
  SELECT__DROPDOWN_ICON_UP: "chakra-select__dropdown-icon-up"
};
P({
  displayName: "AccountCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.02308 17.2923C6.87308 16.6616 7.79903 16.1635 8.80095 15.7981C9.80287 15.4327 10.8692 15.25 12 15.25C13.1307 15.25 14.1971 15.4327 15.199 15.7981C16.2009 16.1635 17.1269 16.6616 17.9769 17.2923C18.5987 16.609 19.0913 15.818 19.4548 14.9192C19.8182 14.0205 20 13.0474 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1041 4.77917 14.2166 4 12 4C9.78331 4 7.89581 4.77917 6.33748 6.3375C4.77914 7.89583 3.99998 9.78333 3.99998 12C3.99998 13.0474 4.18171 14.0205 4.54518 14.9192C4.90864 15.818 5.40128 16.609 6.02308 17.2923ZM12.0003 12.75C11.0873 12.75 10.3173 12.4366 9.69038 11.8099C9.06346 11.1832 8.75 10.4133 8.75 9.5003C8.75 8.58728 9.06336 7.81732 9.69008 7.1904C10.3168 6.56348 11.0867 6.25002 11.9997 6.25002C12.9127 6.25002 13.6827 6.56338 14.3096 7.1901C14.9365 7.81683 15.25 8.5867 15.25 9.4997C15.25 10.4127 14.9366 11.1827 14.3099 11.8096C13.6831 12.4365 12.9133 12.75 12.0003 12.75ZM12 21.5C10.6807 21.5 9.44325 21.2519 8.2875 20.7557C7.13173 20.2596 6.12628 19.5839 5.27115 18.7288C4.41603 17.8737 3.7404 16.8682 3.24425 15.7125C2.74808 14.5567 2.5 13.3192 2.5 12C2.5 10.6808 2.74808 9.44327 3.24425 8.28752C3.7404 7.13176 4.41603 6.12631 5.27115 5.27117C6.12628 4.41606 7.13173 3.74042 8.2875 3.24427C9.44325 2.74811 10.6807 2.50002 12 2.50002C13.3192 2.50002 14.5567 2.74811 15.7125 3.24427C16.8682 3.74042 17.8737 4.41606 18.7288 5.27117C19.5839 6.12631 20.2596 7.13176 20.7557 8.28752C21.2519 9.44327 21.5 10.6808 21.5 12C21.5 13.3192 21.2519 14.5567 20.7557 15.7125C20.2596 16.8682 19.5839 17.8737 18.7288 18.7288C17.8737 19.5839 16.8682 20.2596 15.7125 20.7557C14.5567 21.2519 13.3192 21.5 12 21.5ZM12 20C12.9025 20 13.7727 19.8548 14.6105 19.5644C15.4484 19.274 16.1923 18.868 16.8423 18.3462C16.1923 17.8436 15.458 17.4519 14.6394 17.1712C13.8208 16.8904 12.941 16.75 12 16.75C11.0589 16.75 10.1775 16.8888 9.35573 17.1663C8.53393 17.4439 7.80123 17.8372 7.15765 18.3462C7.80765 18.868 8.55157 19.274 9.3894 19.5644C10.2272 19.8548 11.0974 20 12 20ZM12 11.25C12.4974 11.25 12.9134 11.0827 13.2481 10.7481C13.5827 10.4135 13.75 9.99743 13.75 9.5C13.75 9.00257 13.5827 8.58653 13.2481 8.2519C12.9134 7.91728 12.4974 7.74997 12 7.74997C11.5025 7.74997 11.0865 7.91728 10.7519 8.2519C10.4173 8.58653 10.25 9.00257 10.25 9.5C10.25 9.99743 10.4173 10.4135 10.7519 10.7481C11.0865 11.0827 11.5025 11.25 12 11.25Z", fill: "currentColor" })
});
P({
  displayName: "AddIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.25 12.75H6.25C6.0375 12.75 5.85938 12.6781 5.71563 12.5343C5.57188 12.3905 5.5 12.2123 5.5 11.9997C5.5 11.7871 5.57188 11.609 5.71563 11.4654C5.85938 11.3218 6.0375 11.25 6.25 11.25H11.25V6.25002C11.25 6.03752 11.3219 5.8594 11.4657 5.71565C11.6095 5.5719 11.7877 5.50002 12.0003 5.50002C12.2129 5.50002 12.391 5.5719 12.5346 5.71565C12.6782 5.8594 12.7499 6.03752 12.7499 6.25002V11.25H17.75C17.9625 11.25 18.1406 11.3219 18.2843 11.4657C18.4281 11.6095 18.5 11.7877 18.5 12.0003C18.5 12.2129 18.4281 12.391 18.2843 12.5346C18.1406 12.6782 17.9625 12.75 17.75 12.75H12.7499V17.75C12.7499 17.9625 12.678 18.1406 12.5342 18.2843C12.3904 18.4281 12.2122 18.5 11.9997 18.5C11.7871 18.5 11.609 18.4281 11.4654 18.2843C11.3218 18.1406 11.25 17.9625 11.25 17.75V12.75Z", fill: "currentColor" })
});
P({
  displayName: "AdjustIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.17644 5C7.90944 5 6.88232 6.02711 6.88232 7.29412C6.88232 8.56112 7.90944 9.58824 9.17644 9.58824C10.4434 9.58824 11.4706 8.56112 11.4706 7.29412C11.4706 6.02711 10.4434 5 9.17644 5ZM4 7.82355H4.91464C5.17552 9.94534 6.98412 11.5882 9.17644 11.5882C11.548 11.5882 13.4706 9.66569 13.4706 7.29412C13.4706 4.92254 11.548 3 9.17644 3C7.32144 3 5.74115 4.17623 5.14074 5.82355H4C3.44772 5.82355 3 6.27126 3 6.82355C3 7.37583 3.44772 7.82355 4 7.82355ZM15.2941 5.82355C14.7418 5.82355 14.2941 6.27126 14.2941 6.82355C14.2941 7.37583 14.7418 7.82355 15.2941 7.82355H20C20.5523 7.82355 21 7.37583 21 6.82355C21 6.27126 20.5523 5.82355 20 5.82355H15.2941ZM3 17.1765C3 16.6242 3.44772 16.1765 4 16.1765H8.70588C9.25817 16.1765 9.70588 16.6242 9.70588 17.1765C9.70588 17.7287 9.25817 18.1765 8.70588 18.1765H4C3.44772 18.1765 3 17.7287 3 17.1765ZM18.8592 18.1765C18.2588 19.8238 16.6785 21 14.8235 21C12.452 21 10.5294 19.0774 10.5294 16.7059C10.5294 14.3343 12.452 12.4117 14.8235 12.4117C17.0159 12.4117 18.8245 14.0547 19.0853 16.1765H20C20.5523 16.1765 21 16.6242 21 17.1765C21 17.7287 20.5523 18.1765 20 18.1765H18.8592ZM12.5294 16.7059C12.5294 15.4389 13.5565 14.4117 14.8235 14.4117C16.0905 14.4117 17.1177 15.4389 17.1177 16.7059C17.1177 17.9729 16.0905 19 14.8235 19C13.5565 19 12.5294 17.9729 12.5294 16.7059Z", fill: "currentColor" })
});
P({
  displayName: "ApprovalIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.0817 11.038C13.9044 11.422 14.9114 11.614 16.1029 11.614C17.2898 11.614 18.2978 11.422 19.1267 11.038C19.9557 10.654 20.3701 10.1864 20.3701 9.63497V4.979C20.3701 4.43004 19.9525 3.96297 19.1173 3.57778C18.2821 3.19259 17.2773 3 16.1029 3C14.924 3 13.92 3.19259 13.0911 3.57778C12.2621 3.96297 11.8476 4.43004 11.8476 4.979V9.63497C11.8476 10.1864 12.259 10.654 13.0817 11.038ZM18.0799 5.58788C17.4492 5.75939 16.792 5.84515 16.1085 5.84515C15.4095 5.84515 14.7455 5.75939 14.1165 5.58788C13.4875 5.41638 13.1005 5.21342 12.9555 4.979C13.105 4.75724 13.4994 4.55858 14.1386 4.38304C14.7779 4.20749 15.4346 4.11971 16.1085 4.11971C16.775 4.11971 17.4279 4.20634 18.0671 4.37961C18.7064 4.55287 19.1048 4.75267 19.2623 4.979C19.1048 5.21342 18.7107 5.41638 18.0799 5.58788ZM17.0415 8.10143C16.7421 8.14009 16.4312 8.15941 16.1089 8.15941C15.7866 8.15941 15.4748 8.14009 15.1737 8.10143C14.8726 8.06277 14.5869 8.00996 14.3168 7.94301C14.0466 7.87606 13.7981 7.78853 13.5713 7.68041C13.3445 7.57229 13.1392 7.4515 12.9555 7.31806V6.298C13.1484 6.39851 13.3652 6.49006 13.6056 6.57265C13.846 6.65524 14.0986 6.72421 14.3634 6.77956C14.6281 6.83492 14.9075 6.87621 15.2016 6.90344C15.4956 6.93069 15.7961 6.94431 16.1029 6.94431C16.4188 6.94431 16.7231 6.93069 17.0158 6.90344C17.3086 6.87621 17.5879 6.83606 17.854 6.783C18.12 6.72992 18.3705 6.66254 18.6055 6.58085C18.8404 6.49916 19.0594 6.40488 19.2623 6.298V7.31806C19.0773 7.45652 18.8686 7.57856 18.6362 7.68418C18.4037 7.78979 18.1547 7.87606 17.889 7.94301C17.6234 8.00996 17.3408 8.06277 17.0415 8.10143ZM17.1351 10.4201C16.7864 10.4696 16.4456 10.4943 16.1127 10.4943C15.7798 10.4943 15.438 10.468 15.0871 10.4154C14.7363 10.3629 14.4132 10.2974 14.1178 10.2188C13.8224 10.1403 13.5682 10.0484 13.3552 9.94337C13.1423 9.83828 13.009 9.73548 12.9555 9.63497V8.58485C13.1439 8.6945 13.3584 8.79291 13.5988 8.88007C13.8393 8.96723 14.093 9.04078 14.36 9.1007C14.627 9.16062 14.9075 9.20534 15.2016 9.23486C15.4956 9.26438 15.7961 9.27914 16.1029 9.27914C16.4143 9.27914 16.7163 9.26438 17.009 9.23486C17.3018 9.20534 17.5834 9.1629 17.854 9.10755C18.1246 9.05219 18.3773 8.98024 18.6123 8.8917C18.8472 8.80316 19.0639 8.70316 19.2623 8.5917V9.61072C19.2066 9.72149 19.0736 9.83042 18.8635 9.9375C18.6534 10.0446 18.4 10.1394 18.1032 10.2221C17.8065 10.3047 17.4838 10.3707 17.1351 10.4201Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.29839 19.0457L13.8059 20.9316C13.9695 20.9801 14.1381 21.0028 14.3116 20.9997C14.485 20.9966 14.6505 20.9689 14.808 20.9167L20.6308 19.0905C20.9223 18.9923 21.1401 18.8592 21.2841 18.6913C21.428 18.5235 21.5 18.3021 21.5 18.0273C21.5 17.3097 21.2831 16.7262 20.8494 16.2767C20.4157 15.8271 19.8544 15.6023 19.1654 15.6023H16.7661C16.7661 15.0452 16.6222 14.5599 16.3343 14.1464C16.0464 13.7329 15.6846 13.4447 15.2491 13.2818L9.65703 11.2001C9.56722 11.1677 9.47095 11.141 9.36821 11.1199C9.26547 11.0987 9.16427 11.0882 9.06461 11.0882H4.23481C3.7562 11.0882 3.34741 11.2595 3.00845 11.6021C2.66948 11.9447 2.5 12.3578 2.5 12.8416V18.6242C2.5 19.1079 2.66948 19.5211 3.00845 19.8637C3.34741 20.2063 3.7562 20.3776 4.23481 20.3776H5.56358C5.93884 20.3776 6.29441 20.2561 6.6303 20.0129C6.96619 19.7698 7.18889 19.4474 7.29839 19.0457ZM14.2636 19.5252C14.239 19.5252 14.2113 19.519 14.1805 19.5065L7.29839 17.5423V12.5431H9.07385C9.09231 12.5431 9.10922 12.5447 9.12459 12.5478C9.13998 12.5509 9.1569 12.5556 9.17536 12.5618L14.7434 14.6286C14.9181 14.6895 15.059 14.8071 15.1661 14.9812C15.2731 15.1553 15.3266 15.3623 15.3266 15.6023H15.0719C14.4986 15.5924 14.0323 15.5678 13.673 15.5286C13.3137 15.4895 12.9889 15.4233 12.6985 15.33L11.4509 14.8879C11.2565 14.8257 11.071 14.8397 10.8945 14.9299C10.7179 15.02 10.5989 15.1602 10.5374 15.3505C10.4759 15.547 10.4872 15.7385 10.5715 15.925C10.6558 16.1115 10.7951 16.2359 10.9895 16.2981L12.4955 16.7961C12.8043 16.9056 13.1052 16.9764 13.398 17.0088C13.6908 17.0411 14.047 17.0573 14.4666 17.0573H19.1654C19.3573 17.0573 19.5308 17.116 19.6858 17.2336C19.8409 17.3511 19.943 17.5199 19.9922 17.74L14.3466 19.5065C14.3159 19.519 14.2882 19.5252 14.2636 19.5252ZM4.02255 18.8387C3.96719 18.7827 3.93952 18.7112 3.93952 18.6242V12.8416C3.93952 12.7545 3.96719 12.683 4.02255 12.6271C4.07793 12.5711 4.14868 12.5431 4.23481 12.5431H5.8589V18.6242C5.8589 18.7299 5.83121 18.8061 5.77584 18.8527C5.72047 18.8993 5.64971 18.9227 5.56358 18.9227H4.23481C4.14868 18.9227 4.07793 18.8947 4.02255 18.8387Z", fill: "currentColor" })
  )
});
P({
  displayName: "AppsIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M5.99999 20.1155C5.55578 20.1155 5.17549 19.9573 4.85914 19.641C4.54281 19.3246 4.38464 18.9443 4.38464 18.5001C4.38464 18.0559 4.54281 17.6756 4.85914 17.3593C5.17549 17.0429 5.55578 16.8848 5.99999 16.8848C6.44421 16.8848 6.82449 17.0429 7.14084 17.3593C7.45718 17.6756 7.61534 18.0559 7.61534 18.5001C7.61534 18.9443 7.45718 19.3246 7.14084 19.641C6.82449 19.9573 6.44421 20.1155 5.99999 20.1155ZM12 20.1155C11.5558 20.1155 11.1755 19.9573 10.8591 19.641C10.5428 19.3246 10.3846 18.9443 10.3846 18.5001C10.3846 18.0559 10.5428 17.6756 10.8591 17.3593C11.1755 17.0429 11.5558 16.8848 12 16.8848C12.4442 16.8848 12.8245 17.0429 13.1408 17.3593C13.4572 17.6756 13.6153 18.0559 13.6153 18.5001C13.6153 18.9443 13.4572 19.3246 13.1408 19.641C12.8245 19.9573 12.4442 20.1155 12 20.1155ZM18 20.1155C17.5558 20.1155 17.1755 19.9573 16.8591 19.641C16.5428 19.3246 16.3846 18.9443 16.3846 18.5001C16.3846 18.0559 16.5428 17.6756 16.8591 17.3593C17.1755 17.0429 17.5558 16.8848 18 16.8848C18.4442 16.8848 18.8245 17.0429 19.1408 17.3593C19.4572 17.6756 19.6153 18.0559 19.6153 18.5001C19.6153 18.9443 19.4572 19.3246 19.1408 19.641C18.8245 19.9573 18.4442 20.1155 18 20.1155ZM5.99999 14.1155C5.55578 14.1155 5.17549 13.9573 4.85914 13.641C4.54281 13.3246 4.38464 12.9443 4.38464 12.5001C4.38464 12.0559 4.54281 11.6756 4.85914 11.3593C5.17549 11.0429 5.55578 10.8848 5.99999 10.8848C6.44421 10.8848 6.82449 11.0429 7.14084 11.3593C7.45718 11.6756 7.61534 12.0559 7.61534 12.5001C7.61534 12.9443 7.45718 13.3246 7.14084 13.641C6.82449 13.9573 6.44421 14.1155 5.99999 14.1155ZM12 14.1155C11.5558 14.1155 11.1755 13.9573 10.8591 13.641C10.5428 13.3246 10.3846 12.9443 10.3846 12.5001C10.3846 12.0559 10.5428 11.6756 10.8591 11.3593C11.1755 11.0429 11.5558 10.8848 12 10.8848C12.4442 10.8848 12.8245 11.0429 13.1408 11.3593C13.4572 11.6756 13.6153 12.0559 13.6153 12.5001C13.6153 12.9443 13.4572 13.3246 13.1408 13.641C12.8245 13.9573 12.4442 14.1155 12 14.1155ZM18 14.1155C17.5558 14.1155 17.1755 13.9573 16.8591 13.641C16.5428 13.3246 16.3846 12.9443 16.3846 12.5001C16.3846 12.0559 16.5428 11.6756 16.8591 11.3593C17.1755 11.0429 17.5558 10.8848 18 10.8848C18.4442 10.8848 18.8245 11.0429 19.1408 11.3593C19.4572 11.6756 19.6153 12.0559 19.6153 12.5001C19.6153 12.9443 19.4572 13.3246 19.1408 13.641C18.8245 13.9573 18.4442 14.1155 18 14.1155ZM5.99999 8.11547C5.55578 8.11547 5.17549 7.9573 4.85914 7.64097C4.54281 7.32462 4.38464 6.94433 4.38464 6.50012C4.38464 6.0559 4.54281 5.67562 4.85914 5.35927C5.17549 5.04293 5.55578 4.88477 5.99999 4.88477C6.44421 4.88477 6.82449 5.04293 7.14084 5.35927C7.45718 5.67562 7.61534 6.0559 7.61534 6.50012C7.61534 6.94433 7.45718 7.32462 7.14084 7.64097C6.82449 7.9573 6.44421 8.11547 5.99999 8.11547ZM12 8.11547C11.5558 8.11547 11.1755 7.9573 10.8591 7.64097C10.5428 7.32462 10.3846 6.94433 10.3846 6.50012C10.3846 6.0559 10.5428 5.67562 10.8591 5.35927C11.1755 5.04293 11.5558 4.88477 12 4.88477C12.4442 4.88477 12.8245 5.04293 13.1408 5.35927C13.4572 5.67562 13.6153 6.0559 13.6153 6.50012C13.6153 6.94433 13.4572 7.32462 13.1408 7.64097C12.8245 7.9573 12.4442 8.11547 12 8.11547ZM18 8.11547C17.5558 8.11547 17.1755 7.9573 16.8591 7.64097C16.5428 7.32462 16.3846 6.94433 16.3846 6.50012C16.3846 6.0559 16.5428 5.67562 16.8591 5.35927C17.1755 5.04293 17.5558 4.88477 18 4.88477C18.4442 4.88477 18.8245 5.04293 19.1408 5.35927C19.4572 5.67562 19.6153 6.0559 19.6153 6.50012C19.6153 6.94433 19.4572 7.32462 19.1408 7.64097C18.8245 7.9573 18.4442 8.11547 18 8.11547Z", fill: "currentColor" })
});
P({
  displayName: "AreaChartIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M13.3519 4.72892L16.8269 7.50007H18.9808C19.4025 7.50007 19.7612 7.64783 20.0567 7.94335C20.3522 8.23885 20.5 8.59749 20.5 9.01927V19.5H3.5V9.8078C3.5 9.4296 3.66571 9.15845 3.99712 8.99435C4.32852 8.83025 4.64487 8.86037 4.94615 9.08472L7.11538 10.7116L11.1692 5.03277C11.4256 4.67509 11.7683 4.4658 12.1971 4.4049C12.6259 4.344 13.0109 4.45201 13.3519 4.72892ZM4.99997 11V14.6L7.99998 17L12 11.5L19 16.95V9.00005H16.3L12.4 5.87505L7.44998 12.825L4.99997 11Z", fill: "currentColor" })
});
P({
  displayName: "Arrow360RightIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.27855 19.4691C9.08348 19.6655 8.76601 19.666 8.57029 19.4703L8.20136 19.1014C8.00696 18.907 8.00598 18.5921 8.19917 18.3965L9.85 16.725C7.58333 16.475 5.70833 15.925 4.225 15.075C2.74167 14.225 2 13.15 2 11.85C2 10.5333 2.97083 9.41251 4.9125 8.48751C6.85417 7.56251 9.21667 7.10001 12 7.10001C14.8 7.10001 17.1667 7.56251 19.1 8.48751C21.0333 9.41251 22 10.5333 22 11.85C22 12.8333 21.4667 13.7 20.4 14.45C19.4596 15.1113 18.247 15.6429 16.7625 16.0451C16.4512 16.1294 16.15 15.8909 16.15 15.5684V14.9654C16.15 14.736 16.3064 14.5368 16.5276 14.4759C17.6847 14.1573 18.6171 13.757 19.325 13.275C20.1083 12.7417 20.5 12.2667 20.5 11.85C20.5 11.3167 19.8042 10.6417 18.4125 9.82501C17.0208 9.00834 14.8833 8.60001 12 8.60001C9.13333 8.60001 7 9.00834 5.6 9.82501C4.2 10.6417 3.5 11.3167 3.5 11.85C3.5 12.6 3.97917 13.2458 4.9375 13.7875C5.89583 14.3292 7.55833 14.825 9.925 15.275L8.21223 13.6035C8.01289 13.409 8.01094 13.0891 8.20789 12.8921L8.5726 12.5274C8.76741 12.3326 9.0831 12.3321 9.27855 12.5262L12.75 15.975L9.27855 19.4691Z", fill: "currentColor" })
});
P({
  displayName: "ArrowDownIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.88847 13.5212C7.04359 13.366 7.22436 13.291 7.43077 13.2962C7.63717 13.3013 7.81793 13.3814 7.97305 13.5365L11.25 16.8135L11.25 5.04807C11.25 4.83559 11.3219 4.65747 11.4657 4.51372C11.6095 4.36997 11.7877 4.2981 12.0003 4.2981C12.2129 4.2981 12.391 4.36997 12.5346 4.51372C12.6782 4.65747 12.75 4.83559 12.75 5.04807L12.75 16.8135L16.0519 13.5115C16.1989 13.3628 16.3735 13.2885 16.5756 13.2885C16.7778 13.2885 16.9564 13.366 17.1115 13.5212C17.2667 13.6763 17.3442 13.8545 17.3442 14.0558C17.3442 14.257 17.2667 14.4352 17.1115 14.5904L12.6327 19.0692C12.5391 19.1628 12.4399 19.2288 12.3352 19.2673C12.2305 19.3057 12.1184 19.325 11.9987 19.325C11.8791 19.325 11.7673 19.3057 11.6635 19.2673C11.5596 19.2288 11.4609 19.1628 11.3673 19.0692L6.86347 14.5654C6.72501 14.4301 6.65577 14.2611 6.65577 14.0582C6.65577 13.8553 6.73334 13.6763 6.88847 13.5212Z", fill: "currentColor" })
});
P({
  displayName: "ArrowDownCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.25 12.8539L9.91727 11.5212C9.77881 11.3827 9.60638 11.3135 9.39998 11.3135C9.19358 11.3135 9.02114 11.3827 8.88268 11.5212C8.74423 11.6596 8.675 11.8342 8.675 12.0449C8.675 12.2556 8.74423 12.4291 8.88268 12.5654L11.3769 15.0596C11.5577 15.2404 11.7686 15.3308 12.0096 15.3308C12.2506 15.3308 12.4615 15.2404 12.6423 15.0596L15.1365 12.5654C15.275 12.4291 15.3442 12.2556 15.3442 12.0449C15.3442 11.8342 15.275 11.6596 15.1365 11.5212C14.9981 11.3827 14.8235 11.3135 14.6128 11.3135C14.4021 11.3135 14.2286 11.3827 14.0923 11.5212L12.7596 12.8539V9.04808C12.7596 8.8356 12.6877 8.65748 12.5439 8.51373C12.4001 8.36998 12.2219 8.29811 12.0093 8.29811C11.7967 8.29811 11.617 8.36998 11.4702 8.51373C11.3234 8.65748 11.25 8.8356 11.25 9.04808V12.8539ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5766 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45271 3.248 8.29658C3.74667 7.14043 4.42342 6.13475 5.27825 5.27953C6.1331 4.4243 7.13834 3.74724 8.29398 3.24836C9.44959 2.74947 10.6844 2.50003 11.9983 2.50003C13.3122 2.50003 14.5473 2.74936 15.7034 3.24803C16.8596 3.7467 17.8652 4.42345 18.7205 5.27828C19.5757 6.13313 20.2527 7.13837 20.7516 8.29401C21.2505 9.44962 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8653 18.7217 18.7205C17.8669 19.5757 16.8616 20.2528 15.706 20.7517C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.87501 17.675 6.32501C16.125 4.77501 14.2333 4.00001 12 4.00001C9.76664 4.00001 7.87498 4.77501 6.32498 6.32501C4.77498 7.87501 3.99998 9.76667 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20Z", fill: "currentColor" })
});
P({
  displayName: "ArrowDownTriangleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.5 20L12.2735 10L0.726497 10L6.5 20ZM5.5 -4.37114e-08L5.5 11L7.5 11L7.5 4.37114e-08L5.5 -4.37114e-08Z", fill: "currentColor" })
});
P({
  displayName: "ArrowLeftIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M10.4788 6.88847C10.634 7.04359 10.709 7.22436 10.7038 7.43077C10.6987 7.63717 10.6186 7.81793 10.4635 7.97305L7.18651 11.25L18.9519 11.25C19.1644 11.25 19.3425 11.3219 19.4863 11.4657C19.63 11.6095 19.7019 11.7877 19.7019 12.0003C19.7019 12.2129 19.63 12.391 19.4863 12.5346C19.3425 12.6782 19.1644 12.75 18.9519 12.75L7.18651 12.75L10.4885 16.0519C10.6372 16.1989 10.7115 16.3735 10.7115 16.5756C10.7115 16.7778 10.634 16.9564 10.4788 17.1115C10.3237 17.2667 10.1455 17.3442 9.94423 17.3442C9.74296 17.3442 9.56476 17.2667 9.40963 17.1115L4.93078 12.6327C4.8372 12.5391 4.77117 12.4399 4.7327 12.3352C4.69425 12.2305 4.67503 12.1184 4.67503 11.9987C4.67503 11.8791 4.69425 11.7673 4.7327 11.6635C4.77117 11.5596 4.8372 11.4609 4.93078 11.3673L9.43463 6.86347C9.56988 6.72501 9.73895 6.65577 9.94183 6.65577C10.1447 6.65577 10.3237 6.73334 10.4788 6.88847Z", fill: "currentColor" })
});
P({
  displayName: "ArrowNavigationLeftIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12.15 4.91154C12.2948 5.05641 12.3698 5.23205 12.375 5.43847C12.3801 5.64487 12.3102 5.8205 12.1654 5.96537L6.8807 11.25L18.4884 11.25C18.7012 11.25 18.8794 11.3218 19.023 11.4654C19.1666 11.609 19.2384 11.7872 19.2384 12C19.2384 12.2128 19.1666 12.391 19.023 12.5346C18.8794 12.6782 18.7012 12.75 18.4884 12.75L6.8807 12.75L12.1654 18.0346C12.3102 18.1795 12.3801 18.3551 12.375 18.5615C12.3698 18.7679 12.2948 18.9436 12.15 19.0884C12.0051 19.2333 11.8295 19.3057 11.6231 19.3057C11.4167 19.3057 11.241 19.2333 11.0962 19.0884L4.64038 12.6327C4.54679 12.5493 4.48077 12.4532 4.4423 12.3442C4.40385 12.2353 4.38463 12.1205 4.38463 12C4.38463 11.8859 4.40385 11.7753 4.4423 11.6683C4.48077 11.5612 4.54679 11.4609 4.64038 11.3673L11.0962 4.91154C11.241 4.76668 11.4167 4.69424 11.6231 4.69424C11.8295 4.69424 12.0051 4.76668 12.15 4.91154Z", fill: "currentColor" })
});
P({
  displayName: "ArrowNavigationRightIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.4731 19.0884C11.3282 18.9436 11.2532 18.7679 11.2481 18.5615C11.243 18.3551 11.3128 18.1795 11.4577 18.0346L16.7423 12.75H5.13462C4.9218 12.75 4.7436 12.6782 4.60002 12.5346C4.45644 12.391 4.38464 12.2128 4.38464 12C4.38464 11.7872 4.45644 11.609 4.60002 11.4654C4.7436 11.3218 4.9218 11.25 5.13462 11.25H16.7423L11.4577 5.96537C11.3128 5.8205 11.243 5.64487 11.2481 5.43847C11.2532 5.23205 11.3282 5.05641 11.4731 4.91154C11.618 4.76668 11.7936 4.69424 12 4.69424C12.2064 4.69424 12.382 4.76668 12.5269 4.91154L18.9827 11.3673C19.0763 11.4507 19.1423 11.5468 19.1807 11.6558C19.2192 11.7647 19.2384 11.8795 19.2384 12C19.2384 12.1141 19.2192 12.2247 19.1807 12.3317C19.1423 12.4388 19.0763 12.5391 18.9827 12.6327L12.5269 19.0884C12.382 19.2333 12.2064 19.3057 12 19.3057C11.7936 19.3057 11.618 19.2333 11.4731 19.0884Z", fill: "currentColor" })
});
P({
  displayName: "ArrowNavigationTopRightIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M16.5904 8.55378L7.28267 17.8673C7.13396 18.016 6.95736 18.0904 6.75288 18.0904C6.54839 18.0904 6.37179 18.016 6.22308 17.8673C6.07436 17.7186 6 17.542 6 17.3375C6 17.133 6.07436 16.9564 6.22308 16.8077L15.5366 7.49995H7.34038C7.12788 7.49995 6.94976 7.42805 6.80603 7.28425C6.66228 7.14043 6.5904 6.96223 6.5904 6.74965C6.5904 6.53705 6.66228 6.35896 6.80603 6.21538C6.94976 6.07179 7.12788 6 7.34038 6H17.1865C17.4426 6 17.6573 6.08662 17.8305 6.25985C18.0037 6.43308 18.0904 6.64774 18.0904 6.90383V16.75C18.0904 16.9625 18.0184 17.1406 17.8746 17.2843C17.7308 17.4281 17.5526 17.5 17.34 17.5C17.1274 17.5 16.9494 17.4281 16.8058 17.2843C16.6622 17.1406 16.5904 16.9625 16.5904 16.75V8.55378Z", fill: "currentColor" })
});
P({
  displayName: "ArrowRightIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M13.5212 17.1115C13.366 16.9564 13.291 16.7756 13.2962 16.5692C13.3013 16.3628 13.3814 16.1821 13.5365 16.027L16.8135 12.75H5.04807C4.83559 12.75 4.65747 12.6781 4.51372 12.5343C4.36997 12.3905 4.2981 12.2123 4.2981 11.9997C4.2981 11.7871 4.36997 11.609 4.51372 11.4654C4.65747 11.3218 4.83559 11.25 5.04807 11.25H16.8135L13.5115 7.94805C13.3628 7.80105 13.2885 7.62648 13.2885 7.42435C13.2885 7.22222 13.366 7.04359 13.5212 6.88848C13.6763 6.73334 13.8545 6.65578 14.0558 6.65578C14.257 6.65578 14.4352 6.73334 14.5904 6.88848L19.0692 11.3673C19.1628 11.4609 19.2288 11.5601 19.2673 11.6648C19.3057 11.7695 19.325 11.8816 19.325 12.0013C19.325 12.1209 19.3057 12.2327 19.2673 12.3365C19.2288 12.4404 19.1628 12.5391 19.0692 12.6327L14.5654 17.1365C14.4301 17.275 14.2611 17.3442 14.0582 17.3442C13.8553 17.3442 13.6763 17.2667 13.5212 17.1115Z", fill: "currentColor" })
});
P({
  displayName: "ArrowRightTriangleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M22.5 12L12.5 6.2265L12.5 17.7735L22.5 12ZM2.5 13L13.5 13L13.5 11L2.5 11L2.5 13Z", fill: "currentColor" })
});
P({
  displayName: "ArrowTopIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M17.1115 10.4788C16.9564 10.634 16.7756 10.709 16.5692 10.7038C16.3628 10.6987 16.1821 10.6186 16.027 10.4635L12.75 7.18651L12.75 18.9519C12.75 19.1644 12.6781 19.3425 12.5343 19.4863C12.3905 19.63 12.2123 19.7019 11.9997 19.7019C11.7871 19.7019 11.609 19.63 11.4654 19.4863C11.3218 19.3425 11.25 19.1644 11.25 18.9519L11.25 7.18651L7.94805 10.4885C7.80105 10.6372 7.62648 10.7115 7.42435 10.7115C7.22222 10.7115 7.04359 10.634 6.88848 10.4788C6.73334 10.3237 6.65578 10.1455 6.65578 9.94423C6.65578 9.74296 6.73334 9.56476 6.88848 9.40963L11.3673 4.93078C11.4609 4.8372 11.5601 4.77117 11.6648 4.7327C11.7695 4.69425 11.8816 4.67503 12.0013 4.67503C12.1209 4.67503 12.2327 4.69425 12.3365 4.7327C12.4404 4.77117 12.5391 4.8372 12.6327 4.93078L17.1365 9.43463C17.275 9.56988 17.3442 9.73895 17.3442 9.94183C17.3442 10.1447 17.2667 10.3237 17.1115 10.4788Z", fill: "currentColor" })
});
const Zoe = P({
  displayName: "ArrowTopRightIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M16.69 14.5388C16.4706 14.5388 16.2898 14.464 16.1475 14.3144C16.0051 14.1648 15.934 13.9803 15.934 13.761L15.934 9.12666L7.61456 17.4461C7.46431 17.5963 7.28752 17.6714 7.08419 17.6714C6.88085 17.6713 6.70402 17.5962 6.5537 17.4458C6.40337 17.2955 6.32826 17.1188 6.32838 16.9156C6.3285 16.7124 6.40368 16.5357 6.55393 16.3854L14.8733 8.06603L10.2037 8.06601C9.99456 8.06723 9.81854 7.99637 9.67561 7.85344C9.53268 7.71051 9.46122 7.52935 9.46124 7.30997C9.46122 7.09059 9.53238 6.90974 9.67471 6.76741C9.81703 6.62509 9.99788 6.55394 10.2173 6.55394L16.5513 6.55394C16.6837 6.55394 16.8005 6.57735 16.9017 6.62419C17.0029 6.67103 17.0958 6.73676 17.1804 6.82136C17.2651 6.90598 17.3305 6.99859 17.3767 7.0992C17.4229 7.19984 17.4461 7.31633 17.4461 7.44867L17.4461 13.8181C17.4483 14.0116 17.3777 14.1801 17.2343 14.3236C17.0908 14.467 16.9094 14.5388 16.69 14.5388Z", fill: "currentColor" })
});
P({
  displayName: "ArrowTopRightCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M13.1341 11.9265L13.1341 13.8113C13.1341 14.0071 13.2071 14.178 13.353 14.3239C13.499 14.4699 13.6699 14.5428 13.8657 14.5428C14.0615 14.5428 14.2339 14.4684 14.3828 14.3194C14.5318 14.1704 14.6056 13.9988 14.604 13.8045L14.604 10.2771C14.604 10.0215 14.5188 9.80844 14.3484 9.638C14.178 9.46758 13.9649 9.38236 13.7093 9.38236L10.1819 9.38236C9.98762 9.38084 9.81598 9.45457 9.66701 9.60355C9.51803 9.75252 9.44355 9.92492 9.44356 10.1207C9.44355 10.3165 9.51803 10.4889 9.66701 10.6379C9.81598 10.7869 9.98762 10.8606 10.1819 10.8591L12.0667 10.8591L9.37555 13.5502C9.22531 13.7005 9.15021 13.8773 9.15025 14.0806C9.15029 14.2839 9.22547 14.4608 9.3758 14.6111C9.52612 14.7614 9.70401 14.8376 9.90946 14.8398C10.1149 14.8419 10.2927 14.7679 10.443 14.6176L13.1341 11.9265ZM18.7163 5.28132C19.6454 6.21041 20.3424 7.26002 20.8073 8.43014C21.2722 9.60027 21.5048 10.7899 21.5051 11.9991C21.5053 13.2083 21.2733 14.3979 20.8089 15.5678C20.3445 16.7377 19.6478 17.7872 18.7187 18.7163C17.7896 19.6454 16.74 20.3424 15.5699 20.8073C14.3997 21.2722 13.2101 21.5048 12.0009 21.5051C10.7917 21.5053 9.60211 21.2733 8.43219 20.8089C7.26228 20.3445 6.21278 19.6478 5.28369 18.7187C4.3546 17.7896 3.6576 16.74 3.1927 15.5699C2.72779 14.3997 2.4952 13.2101 2.49493 12.0009C2.49466 10.7917 2.72672 9.60211 3.19111 8.43219C3.65549 7.26228 4.35223 6.21278 5.28132 5.28369C6.21041 4.3546 7.26001 3.65761 8.43013 3.19271C9.60027 2.72779 10.7899 2.4952 11.9991 2.49493C13.2083 2.49466 14.3979 2.72672 15.5678 3.19111C16.7377 3.65549 17.7872 4.35223 18.7163 5.28132ZM17.6569 6.34315C16.0776 4.76394 14.192 3.97434 12 3.97434C9.80797 3.97434 7.92235 4.76394 6.34314 6.34315C4.76394 7.92235 3.97434 9.80797 3.97434 12C3.97434 14.192 4.76394 16.0777 6.34315 17.6569C7.92235 19.2361 9.80797 20.0257 12 20.0257C14.192 20.0257 16.0776 19.2361 17.6569 17.6569C19.2361 16.0777 20.0257 14.192 20.0257 12C20.0257 9.80797 19.2361 7.92235 17.6569 6.34315Z", fill: "currentColor" })
});
P({
  displayName: "ArticleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M4.3077 20.5C3.80257 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V5.30773C2.5 4.80259 2.675 4.37502 3.025 4.02502C3.375 3.67502 3.80257 3.50002 4.3077 3.50002H19.6923C20.1974 3.50002 20.625 3.67502 20.975 4.02502C21.325 4.37502 21.5 4.80259 21.5 5.30773V18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5H4.3077ZM4.3077 19H19.6923C19.7692 19 19.8397 18.968 19.9038 18.9039C19.9679 18.8397 20 18.7692 20 18.6923V5.30773C20 5.23079 19.9679 5.16027 19.9038 5.09615C19.8397 5.03205 19.7692 5 19.6923 5H4.3077C4.23077 5 4.16024 5.03205 4.09613 5.09615C4.03202 5.16027 3.99998 5.23079 3.99998 5.30773V18.6923C3.99998 18.7692 4.03202 18.8397 4.09613 18.9039C4.16024 18.968 4.23077 19 4.3077 19ZM7.1346 16.6154H16.8654C17.0782 16.6154 17.2564 16.5436 17.4 16.4C17.5435 16.2564 17.6153 16.0782 17.6153 15.8654C17.6153 15.6526 17.5435 15.4744 17.4 15.3308C17.2564 15.1872 17.0782 15.1154 16.8654 15.1154H7.1346C6.92178 15.1154 6.74358 15.1872 6.6 15.3308C6.45642 15.4744 6.38463 15.6526 6.38463 15.8654C6.38463 16.0782 6.45642 16.2564 6.6 16.4C6.74358 16.5436 6.92178 16.6154 7.1346 16.6154ZM7.1346 12.75H9.32693C9.53974 12.75 9.71794 12.6782 9.86153 12.5346C10.0051 12.391 10.0769 12.2128 10.0769 12V8.13463C10.0769 7.92181 10.0051 7.74361 9.86153 7.60003C9.71794 7.45644 9.53974 7.38465 9.32693 7.38465H7.1346C6.92178 7.38465 6.74358 7.45644 6.6 7.60003C6.45642 7.74361 6.38463 7.92181 6.38463 8.13463V12C6.38463 12.2128 6.45642 12.391 6.6 12.5346C6.74358 12.6782 6.92178 12.75 7.1346 12.75ZM13.0192 12.75H16.8654C17.0782 12.75 17.2564 12.6782 17.4 12.5346C17.5435 12.391 17.6153 12.2128 17.6153 12C17.6153 11.7872 17.5435 11.609 17.4 11.4654C17.2564 11.3218 17.0782 11.25 16.8654 11.25H13.0192C12.8064 11.25 12.6282 11.3218 12.4846 11.4654C12.341 11.609 12.2692 11.7872 12.2692 12C12.2692 12.2128 12.341 12.391 12.4846 12.5346C12.6282 12.6782 12.8064 12.75 13.0192 12.75ZM13.0192 8.8846H16.8654C17.0782 8.8846 17.2564 8.81281 17.4 8.66923C17.5435 8.52564 17.6153 8.34744 17.6153 8.13463C17.6153 7.92181 17.5435 7.74361 17.4 7.60003C17.2564 7.45644 17.0782 7.38465 16.8654 7.38465H13.0192C12.8064 7.38465 12.6282 7.45644 12.4846 7.60003C12.341 7.74361 12.2692 7.92181 12.2692 8.13463C12.2692 8.34744 12.341 8.52564 12.4846 8.66923C12.6282 8.81281 12.8064 8.8846 13.0192 8.8846Z", fill: "currentColor" })
});
P({
  displayName: "ArticleShortcutIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M18.693 20.5H10.7122C10.4997 20.5 10.3216 20.428 10.1779 20.2842C10.0341 20.1404 9.96223 19.9622 9.96223 19.7496C9.96223 19.537 10.0341 19.3589 10.1779 19.2154C10.3216 19.0718 10.4997 19 10.7122 19H18.693C18.7699 19 18.8404 18.9679 18.9046 18.9038C18.9687 18.8397 19.0007 18.7692 19.0007 18.6923V5.3077C19.0007 5.23077 18.9687 5.16024 18.9046 5.09613C18.8404 5.03203 18.7699 4.99998 18.693 4.99998H5.30843C5.23149 4.99998 5.16097 5.03203 5.09685 5.09613C5.03275 5.16024 5.0007 5.23077 5.0007 5.3077V8.46155C5.0007 8.67405 4.92879 8.85217 4.78498 8.9959C4.64118 9.13965 4.46298 9.21153 4.25038 9.21153C4.03779 9.21153 3.85971 9.13965 3.71613 8.9959C3.57253 8.85217 3.50073 8.67405 3.50073 8.46155V5.3077C3.50073 4.80257 3.67573 4.375 4.02573 4.025C4.37573 3.675 4.80329 3.5 5.30843 3.5H18.693C19.1981 3.5 19.6257 3.675 19.9757 4.025C20.3257 4.375 20.5007 4.80257 20.5007 5.3077V18.6923C20.5007 19.1974 20.3257 19.625 19.9757 19.975C19.6257 20.325 19.1981 20.5 18.693 20.5ZM6.9238 21.5C5.67644 21.5 4.61459 21.0627 3.73828 20.1883C2.86198 19.3138 2.42383 18.2543 2.42383 17.0096C2.42383 16.0819 2.67447 15.252 3.17575 14.5196C3.67704 13.7873 4.32768 13.2487 5.12768 12.9038H3.25073C3.03823 12.9038 2.8601 12.8319 2.71635 12.6881C2.5726 12.5443 2.50073 12.3661 2.50073 12.1535C2.50073 11.9409 2.5726 11.7628 2.71635 11.6192C2.8601 11.4756 3.03823 11.4039 3.25073 11.4039H6.86608C7.12216 11.4039 7.33682 11.4905 7.51005 11.6637C7.6833 11.8369 7.76993 12.0516 7.76993 12.3077V15.9231C7.76993 16.1356 7.69802 16.3137 7.5542 16.4574C7.41039 16.6012 7.23219 16.673 7.0196 16.673C6.807 16.673 6.62891 16.6012 6.48533 16.4574C6.34174 16.3137 6.26995 16.1356 6.26995 15.9231V14.075C5.5891 14.2207 5.02786 14.5668 4.58623 15.1133C4.14459 15.6598 3.92378 16.2883 3.92378 16.9988C3.92378 17.8367 4.21705 18.5464 4.8036 19.1279C5.39014 19.7093 6.09687 20 6.9238 20C7.1363 20 7.31442 20.0719 7.45815 20.2157C7.6019 20.3595 7.67378 20.5377 7.67378 20.7503C7.67378 20.9629 7.6019 21.141 7.45815 21.2846C7.31442 21.4282 7.1363 21.5 6.9238 21.5ZM10.7122 16.75H13.0007C13.2132 16.75 13.3913 16.6781 13.5351 16.5343C13.6788 16.3904 13.7507 16.2122 13.7507 15.9997C13.7507 15.7871 13.6788 15.609 13.5351 15.4654C13.3913 15.3218 13.2132 15.25 13.0007 15.25H10.7122C10.4997 15.25 10.3216 15.3219 10.1779 15.4657C10.0341 15.6095 9.96223 15.7877 9.96223 16.0003C9.96223 16.2129 10.0341 16.391 10.1779 16.5346C10.3216 16.6782 10.4997 16.75 10.7122 16.75ZM10.7122 12.75H16.0007C16.2132 12.75 16.3913 12.6781 16.5351 12.5343C16.6788 12.3904 16.7507 12.2122 16.7507 11.9997C16.7507 11.7871 16.6788 11.609 16.5351 11.4654C16.3913 11.3218 16.2132 11.25 16.0007 11.25H10.7122C10.4997 11.25 10.3216 11.3219 10.1779 11.4657C10.0341 11.6095 9.96223 11.7877 9.96223 12.0003C9.96223 12.2129 10.0341 12.391 10.1779 12.5346C10.3216 12.6782 10.4997 12.75 10.7122 12.75ZM8.0007 8.74995H16.0007C16.2132 8.74995 16.3913 8.67805 16.5351 8.53425C16.6788 8.39043 16.7507 8.21223 16.7507 7.99965C16.7507 7.78705 16.6788 7.60896 16.5351 7.46538C16.3913 7.32179 16.2132 7.25 16.0007 7.25H8.0007C7.7882 7.25 7.61009 7.3219 7.46635 7.4657C7.3226 7.60952 7.25073 7.78772 7.25073 8.0003C7.25073 8.2129 7.3226 8.39099 7.46635 8.53458C7.61009 8.67816 7.7882 8.74995 8.0007 8.74995Z", fill: "currentColor" })
});
P({
  displayName: "AssignBoardIcon",
  viewBox: "0 0 32 32",
  path: w.createElement("path", { d: "M14.108 18.154L11.0107 15.0563C10.826 14.8719 10.5939 14.7774 10.3143 14.773C10.035 14.7688 9.79866 14.8632 9.60533 15.0563C9.41221 15.2497 9.31566 15.4839 9.31566 15.759C9.31566 16.0341 9.41221 16.2683 9.60533 16.4617L13.2643 20.1203C13.5054 20.3614 13.7867 20.482 14.108 20.482C14.4293 20.482 14.7105 20.3614 14.9517 20.1203L22.3697 12.7027C22.5541 12.518 22.6485 12.2859 22.653 12.0063C22.6572 11.727 22.5628 11.4907 22.3697 11.2973C22.1763 11.1042 21.9421 11.0077 21.667 11.0077C21.3919 11.0077 21.1577 11.1042 20.9643 11.2973L14.108 18.154ZM7.07733 27.3333C6.41244 27.3333 5.84444 27.0979 5.37333 26.627C4.90244 26.1559 4.66699 25.5879 4.66699 24.923V7.077C4.66699 6.41211 4.90244 5.84411 5.37333 5.373C5.84444 4.90211 6.41244 4.66667 7.07733 4.66667H13.0107C13.0944 3.92644 13.4175 3.297 13.98 2.77833C14.5422 2.25944 15.2157 2 16.0003 2C16.7934 2 17.4712 2.25944 18.0337 2.77833C18.5961 3.297 18.9149 3.92644 18.99 4.66667H24.9233C25.5882 4.66667 26.1562 4.90211 26.6273 5.373C27.0982 5.84411 27.3337 6.41211 27.3337 7.077V24.923C27.3337 25.5879 27.0982 26.1559 26.6273 26.627C26.1562 27.0979 25.5882 27.3333 24.9233 27.3333H7.07733ZM7.07733 25.3333H24.9233C25.026 25.3333 25.12 25.2906 25.2053 25.205C25.2909 25.1197 25.3337 25.0257 25.3337 24.923V7.077C25.3337 6.97433 25.2909 6.88033 25.2053 6.795C25.12 6.70944 25.026 6.66667 24.9233 6.66667H7.07733C6.97466 6.66667 6.88066 6.70944 6.79533 6.795C6.70977 6.88033 6.66699 6.97433 6.66699 7.077V24.923C6.66699 25.0257 6.70977 25.1197 6.79533 25.205C6.88066 25.2906 6.97466 25.3333 7.07733 25.3333ZM16.0003 5.795C16.2892 5.795 16.5281 5.70056 16.717 5.51167C16.9059 5.32278 17.0003 5.08389 17.0003 4.795C17.0003 4.50611 16.9059 4.26722 16.717 4.07833C16.5281 3.88944 16.2892 3.795 16.0003 3.795C15.7114 3.795 15.4725 3.88944 15.2837 4.07833C15.0948 4.26722 15.0003 4.50611 15.0003 4.795C15.0003 5.08389 15.0948 5.32278 15.2837 5.51167C15.4725 5.70056 15.7114 5.795 16.0003 5.795Z", fill: "currentColor" })
});
P({
  displayName: "BankIcon",
  viewBox: "0 0 40 40",
  path: w.createElement("path", { d: "M9.58417 27.0838V17.0837C9.58417 16.7295 9.70402 16.4326 9.94371 16.1931C10.1834 15.9535 10.4804 15.8337 10.8347 15.8337C11.189 15.8337 11.4858 15.9535 11.7252 16.1931C11.9645 16.4326 12.0841 16.7295 12.0841 17.0837V27.0838C12.0841 27.4379 11.9643 27.7348 11.7246 27.9744C11.4849 28.214 11.1879 28.3338 10.8336 28.3338C10.4793 28.3338 10.1825 28.214 9.94313 27.9744C9.70382 27.7348 9.58417 27.4379 9.58417 27.0838ZM18.7508 27.0838V17.0837C18.7508 16.7295 18.8706 16.4326 19.1103 16.1931C19.35 15.9535 19.647 15.8337 20.0013 15.8337C20.3556 15.8337 20.6524 15.9535 20.8918 16.1931C21.1311 16.4326 21.2507 16.7295 21.2507 17.0837V27.0838C21.2507 27.4379 21.1309 27.7348 20.8912 27.9744C20.6515 28.214 20.3545 28.3338 20.0002 28.3338C19.6459 28.3338 19.3491 28.214 19.1098 27.9744C18.8704 27.7348 18.7508 27.4379 18.7508 27.0838ZM5.86621 34.1671C5.51204 34.1671 5.21517 34.0472 4.97559 33.8075C4.736 33.5678 4.61621 33.2708 4.61621 32.9165C4.61621 32.5622 4.736 32.2654 4.97559 32.0261C5.21517 31.7867 5.51204 31.6671 5.86621 31.6671H34.1353C34.4895 31.6671 34.7863 31.7869 35.0259 32.0266C35.2655 32.2663 35.3853 32.5633 35.3853 32.9176C35.3853 33.2719 35.2655 33.5687 35.0259 33.8081C34.7863 34.0474 34.4895 34.1671 34.1353 34.1671H5.86621ZM27.9174 27.0838V17.0837C27.9174 16.7295 28.0372 16.4326 28.2769 16.1931C28.5166 15.9535 28.8136 15.8337 29.1679 15.8337C29.5222 15.8337 29.819 15.9535 30.0584 16.1931C30.2977 16.4326 30.4173 16.7295 30.4173 17.0837V27.0838C30.4173 27.4379 30.2975 27.7348 30.0578 27.9744C29.8181 28.214 29.5211 28.3338 29.1668 28.3338C28.8125 28.3338 28.5157 28.214 28.2763 27.9744C28.037 27.7348 27.9174 27.4379 27.9174 27.0838ZM34.1994 12.5004H5.6835C5.38703 12.5004 5.13503 12.3968 4.9275 12.1897C4.71997 11.9826 4.61621 11.7311 4.61621 11.4352V10.7842C4.61621 10.5672 4.67057 10.3802 4.77929 10.2231C4.88799 10.066 5.03128 9.93837 5.20917 9.84018L18.677 3.25047C19.0931 3.04963 19.5337 2.94922 19.9987 2.94922C20.4637 2.94922 20.9057 3.04963 21.3245 3.25047L34.725 9.79851C34.9344 9.90534 35.0968 10.0549 35.2122 10.2472C35.3276 10.4395 35.3853 10.6461 35.3853 10.8669V11.3186C35.3853 11.6599 35.2736 11.9422 35.0503 12.1654C34.8271 12.3887 34.5434 12.5004 34.1994 12.5004ZM10.5264 10.0004H29.4751L20.2251 5.51326C20.1504 5.4812 20.0756 5.46518 20.0008 5.46518C19.9259 5.46518 19.8512 5.4812 19.7764 5.51326L10.5264 10.0004Z", fill: "currentColor" })
});
P({
  displayName: "BlogIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.75 7.5C2.75 6.25736 3.75736 5.25 5 5.25H17.0708C18.3135 5.25 19.3208 6.25736 19.3208 7.5V8.35323C20.4311 8.64532 21.25 9.65607 21.25 10.8581V17.5C21.25 18.7426 20.2426 19.75 19 19.75L5 19.75C3.75736 19.75 2.75 18.7426 2.75 17.5V7.5ZM19.3208 9.99123V16.6167C19.3208 17.0309 18.985 17.3667 18.5708 17.3667C18.1566 17.3667 17.8208 17.0309 17.8208 16.6167V7.5C17.8208 7.08579 17.485 6.75 17.0708 6.75H5C4.58579 6.75 4.25 7.08579 4.25 7.5V17.5C4.25 17.9142 4.58579 18.25 5 18.25L19 18.25C19.4142 18.25 19.75 17.9142 19.75 17.5V10.8581C19.75 10.5046 19.5817 10.1904 19.3208 9.99123ZM6 9.5C6 8.94772 6.44772 8.5 7 8.5H15C15.5523 8.5 16 8.94772 16 9.5V12.5C16 13.0523 15.5523 13.5 15 13.5H7C6.44772 13.5 6 13.0523 6 12.5V9.5ZM7 14.75C6.58579 14.75 6.25 15.0858 6.25 15.5C6.25 15.9142 6.58579 16.25 7 16.25H15.0001C15.4143 16.25 15.7501 15.9142 15.7501 15.5C15.7501 15.0858 15.4143 14.75 15.0001 14.75H7Z", fill: "currentColor" })
});
P({
  displayName: "BookIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.34784 4.34784C5.08332 4.34784 3.89163 4.60254 2.99174 5.05479C2.12527 5.49025 1.34784 6.21452 1.34784 7.2174V19.7826C1.34784 20.1428 1.63983 20.4348 2.00001 20.4348C2.3602 20.4348 2.65219 20.1428 2.65219 19.7826C2.65219 19.529 2.8629 19.1446 3.57745 18.7854C4.2586 18.4431 5.24081 18.2174 6.34784 18.2174C7.45486 18.2174 8.43708 18.4431 9.11822 18.7854C9.83278 19.1446 10.0435 19.529 10.0435 19.7826C10.0435 20.1428 10.3355 20.4348 10.6957 20.4348C11.0558 20.4348 11.3478 20.1428 11.3478 19.7826V7.2174C11.3478 6.21452 10.5704 5.49025 9.70393 5.05479C8.80405 4.60254 7.61235 4.34784 6.34784 4.34784ZM17.6522 4.34784C16.3877 4.34784 15.196 4.60254 14.2961 5.05479C13.4296 5.49025 12.6522 6.21452 12.6522 7.2174V19.7826C12.6522 20.1428 12.9442 20.4348 13.3044 20.4348C13.6645 20.4348 13.9565 20.1428 13.9565 19.7826C13.9565 19.529 14.1673 19.1446 14.8818 18.7854C15.5629 18.4431 16.5452 18.2174 17.6522 18.2174C18.7592 18.2174 19.7414 18.4431 20.4226 18.7854C21.1371 19.1446 21.3478 19.529 21.3478 19.7826C21.3478 20.1428 21.6398 20.4348 22 20.4348C22.3602 20.4348 22.6522 20.1428 22.6522 19.7826V7.2174C22.6522 6.21452 21.8748 5.49025 21.0083 5.05479C20.1084 4.60254 18.9167 4.34784 17.6522 4.34784Z", fill: "currentColor" })
});
P({
  displayName: "BuildIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M18.1144 20.8365C17.8266 20.8365 17.5536 20.7836 17.2952 20.6779C17.0369 20.5721 16.7987 20.4102 16.5808 20.1923L11.1769 14.773C10.8244 14.9256 10.4659 15.0432 10.1017 15.1259C9.73745 15.2086 9.35098 15.25 8.9423 15.25C7.34508 15.25 5.98745 14.6909 4.8694 13.5729C3.75135 12.4548 3.19232 11.0972 3.19232 9.49998C3.19232 8.98331 3.25802 8.4894 3.38942 8.01825C3.52084 7.54712 3.7077 7.09873 3.95 6.67308L7.5423 10.2462L9.68847 8.09998L6.13465 4.5269C6.56028 4.2846 7.00576 4.09454 7.4711 3.95673C7.93645 3.81891 8.42685 3.75 8.9423 3.75C10.5395 3.75 11.8971 4.30903 13.0152 5.42708C14.1332 6.54513 14.6923 7.90276 14.6923 9.49998C14.6923 9.92178 14.6525 10.3147 14.573 10.6788C14.4936 11.0429 14.3743 11.3949 14.2153 11.7346L19.65 17.1385C19.8679 17.3564 20.0298 17.5949 20.1356 17.8539C20.2413 18.1129 20.2942 18.3863 20.2942 18.6741C20.2942 18.9619 20.2388 19.2375 20.1279 19.501C20.017 19.7644 19.8588 19.9989 19.6533 20.2044C19.4332 20.4245 19.1936 20.5849 18.9346 20.6856C18.6756 20.7862 18.4022 20.8365 18.1144 20.8365ZM17.6654 19.1539C17.7872 19.2757 17.9398 19.334 18.1231 19.3289C18.3064 19.3237 18.459 19.2603 18.5808 19.1385C18.7026 19.0167 18.7635 18.8641 18.7635 18.6808C18.7635 18.4974 18.7026 18.3449 18.5808 18.2231L12.3712 12.0288C12.6519 11.6827 12.859 11.2888 12.9923 10.8471C13.1257 10.4054 13.1923 9.95639 13.1923 9.49998C13.1923 8.39099 12.7962 7.40957 12.0038 6.55573C11.2115 5.70188 10.2089 5.28328 8.9961 5.29995L11.173 7.4769C11.3474 7.65127 11.4378 7.85575 11.4442 8.09035C11.4506 8.32497 11.3666 8.52946 11.1923 8.70383L8.16537 11.7307C7.99102 11.9051 7.78333 11.9923 7.5423 11.9923C7.30128 11.9923 7.09359 11.9051 6.91922 11.7307L4.74227 9.55378C4.74484 10.8371 5.17625 11.8574 6.03652 12.6144C6.89677 13.3715 7.86536 13.75 8.9423 13.75C9.37991 13.75 9.81752 13.6849 10.2551 13.5548C10.6927 13.4247 11.0929 13.2211 11.4558 12.9442L17.6654 19.1539Z", fill: "currentColor" })
});
P({
  displayName: "BuyIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.27854 3.87868C4.84114 3.31607 5.60421 3 6.39986 3H10.743C11.5387 3 12.3017 3.31607 12.8643 3.87868L20.2929 11.3073C21.4645 12.4788 21.4645 14.3783 20.2929 15.5499L14.5499 21.2929C13.3783 22.4645 11.4788 22.4645 10.3073 21.2929L2.87868 13.8643C2.31607 13.3017 2 12.5387 2 11.743V7.39986C2 6.60421 2.31607 5.84115 2.87868 5.27854L4.27854 3.87868ZM6.39986 5C6.13464 5 5.88029 5.10536 5.69275 5.29289L4.29289 6.69275C4.10536 6.88029 4 7.13464 4 7.39986V11.743C4 12.0082 4.10536 12.2626 4.29289 12.4501L11.7215 19.8787C12.112 20.2692 12.7452 20.2692 13.1357 19.8787L18.8787 14.1357C19.2692 13.7452 19.2692 13.112 18.8787 12.7215L11.4501 5.29289C11.2626 5.10536 11.0082 5 10.743 5H6.39986Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.21423 8.17859C7.6422 8.17859 7.17847 8.64232 7.17847 9.21436C7.17847 9.78639 7.6422 10.2501 8.21423 10.2501C8.78627 10.2501 9.25 9.78639 9.25 9.21436C9.25 8.64232 8.78627 8.17859 8.21423 8.17859ZM5.67847 9.21436C5.67847 7.81389 6.81377 6.67859 8.21423 6.67859C9.6147 6.67859 10.75 7.81389 10.75 9.21436C10.75 10.6148 9.6147 11.7501 8.21423 11.7501C6.81377 11.7501 5.67847 10.6148 5.67847 9.21436Z", fill: "currentColor" })
  )
});
P({
  displayName: "CalculatorIcon",
  viewBox: "0 0 40 40",
  path: w.createElement(
    "svg",
    { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    w.createElement(
      "mask",
      {
        id: "mask0_14178_154988",
        // style="mask-type:alpha"
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
      },
      w.createElement("rect", { width: "40", height: "40", fill: "#D9D9D9" })
    ),
    w.createElement(
      "g",
      { mask: "url(#mask0_14178_154988)" },
      w.createElement("path", { d: "M13.5894 29.7435H15.5766V26.4101H18.9099V24.423H15.5766V21.0896H13.5894V24.423H10.256V26.4101H13.5894V29.7435ZM21.9227 28.4935H29.7432V26.5063H21.9227V28.4935ZM21.9227 24.3268H29.7432V22.3396H21.9227V24.3268ZM23.4996 17.8653L25.833 15.5319L28.1663 17.8653L29.5637 16.4678L27.2304 14.0832L29.5637 11.7499L28.1663 10.3525L25.833 12.6858L23.4996 10.3525L22.1022 11.7499L24.4355 14.0832L22.1022 16.4678L23.4996 17.8653ZM10.6727 15.0768H18.4932V13.0896H10.6727V15.0768ZM8.84584 34.1665C8.00395 34.1665 7.29134 33.8748 6.70801 33.2915C6.12467 32.7082 5.83301 31.9956 5.83301 31.1537V8.84609C5.83301 8.0042 6.12467 7.29159 6.70801 6.70825C7.29134 6.12492 8.00395 5.83325 8.84584 5.83325H31.1534C31.9953 5.83325 32.7079 6.12492 33.2913 6.70825C33.8746 7.29159 34.1663 8.0042 34.1663 8.84609V31.1537C34.1663 31.9956 33.8746 32.7082 33.2913 33.2915C32.7079 33.8748 31.9953 34.1665 31.1534 34.1665H8.84584ZM8.84584 31.6665H31.1534C31.2816 31.6665 31.3992 31.6131 31.506 31.5063C31.6129 31.3994 31.6663 31.2819 31.6663 31.1537V8.84609C31.6663 8.71786 31.6129 8.60032 31.506 8.49346C31.3992 8.38663 31.2816 8.33321 31.1534 8.33321H8.84584C8.71762 8.33321 8.60008 8.38663 8.49322 8.49346C8.38638 8.60032 8.33297 8.71786 8.33297 8.84609V31.1537C8.33297 31.2819 8.38638 31.3994 8.49322 31.5063C8.60008 31.6131 8.71762 31.6665 8.84584 31.6665Z", fill: "currentColor" })
    )
  )
});
P({
  displayName: "CalendarIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.4 4.88889C8.4 4.39797 7.99706 4 7.5 4C7.00294 4 6.6 4.39797 6.6 4.88889V5.77778H5.7C4.20883 5.77778 3 6.97168 3 8.44444V17.3333C3 18.8061 4.20883 20 5.7 20H18.3C19.7912 20 21 18.8061 21 17.3333V8.44444C21 6.97169 19.7912 5.77778 18.3 5.77778H17.4V4.88889C17.4 4.39797 16.9971 4 16.5 4C16.0029 4 15.6 4.39797 15.6 4.88889V5.77778H8.4V4.88889ZM4.8 12V17.3333C4.8 17.8243 5.20294 18.2222 5.7 18.2222H18.3C18.7971 18.2222 19.2 17.8243 19.2 17.3333V12H4.8Z", fill: "currentColor" })
});
P({
  displayName: "CalendarClockIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M4.99997 8.80787H19V6.30784C19 6.23091 18.9679 6.16038 18.9038 6.09627C18.8397 6.03217 18.7692 6.00012 18.6922 6.00012H5.3077C5.23077 6.00012 5.16024 6.03217 5.09612 6.09627C5.03202 6.16038 4.99997 6.23091 4.99997 6.30784V8.80787ZM5.3077 21.5001C4.80257 21.5001 4.375 21.3251 4.025 20.9751C3.675 20.6251 3.5 20.1975 3.5 19.6924V6.30784C3.5 5.80271 3.675 5.37514 4.025 5.02514C4.375 4.67514 4.80257 4.50014 5.3077 4.50014H6.69232V3.15397C6.69232 2.93475 6.76573 2.75174 6.91253 2.60494C7.05931 2.45816 7.24232 2.38477 7.46155 2.38477C7.68077 2.38477 7.86378 2.45816 8.01058 2.60494C8.15736 2.75174 8.23075 2.93475 8.23075 3.15397V4.50014H15.8077V3.13474C15.8077 2.92192 15.8794 2.74372 16.023 2.60014C16.1666 2.45656 16.3448 2.38477 16.5576 2.38477C16.7704 2.38477 16.9486 2.45656 17.0922 2.60014C17.2358 2.74372 17.3076 2.92192 17.3076 3.13474V4.50014H18.6922C19.1974 4.50014 19.625 4.67514 19.975 5.02514C20.325 5.37514 20.5 5.80271 20.5 6.30784V11.7713C20.2602 11.6661 20.0153 11.5812 19.7654 11.5165C19.5154 11.4517 19.2602 11.4008 19 11.3636V10.3078H4.99997V19.6924C4.99997 19.7693 5.03202 19.8398 5.09612 19.904C5.16024 19.9681 5.23077 20.0001 5.3077 20.0001H11.8096C11.8942 20.277 11.9965 20.5389 12.1164 20.7857C12.2362 21.0325 12.3724 21.2706 12.525 21.5001H5.3077ZM18.1923 22.5001C16.9436 22.5001 15.8814 22.0623 15.0058 21.1866C14.1301 20.311 13.6923 19.2488 13.6923 18.0001C13.6923 16.7514 14.1301 15.6892 15.0058 14.8136C15.8814 13.938 16.9436 13.5001 18.1923 13.5001C19.441 13.5001 20.5032 13.938 21.3788 14.8136C22.2544 15.6892 22.6922 16.7514 22.6922 18.0001C22.6922 19.2488 22.2544 20.311 21.3788 21.1866C20.5032 22.0623 19.441 22.5001 18.1923 22.5001ZM18.6346 17.8193V15.5001C18.6346 15.3796 18.591 15.2758 18.5038 15.1886C18.4167 15.1014 18.3128 15.0578 18.1923 15.0578C18.0718 15.0578 17.9679 15.1014 17.8807 15.1886C17.7936 15.2758 17.75 15.3796 17.75 15.5001V17.804C17.75 17.9245 17.7718 18.0392 17.8154 18.1482C17.859 18.2572 17.9275 18.3584 18.0211 18.452L19.5461 19.977C19.6333 20.0642 19.7356 20.1094 19.8529 20.1126C19.9702 20.1158 20.0756 20.0706 20.1692 19.977C20.2628 19.8834 20.3096 19.7796 20.3096 19.6655C20.3096 19.5514 20.2628 19.4475 20.1692 19.354L18.6346 17.8193Z", fill: "currentColor" })
});
P({
  displayName: "CalendarLineIcon",
  viewBox: "0 0 16 16",
  path: w.createElement("path", { id: "calendar_line", d: "M3.53716 14.3334C3.20041 14.3334 2.91536 14.2167 2.68203 13.9834C2.4487 13.7501 2.33203 13.465 2.33203 13.1283V4.20523C2.33203 3.86847 2.4487 3.58343 2.68203 3.35009C2.91536 3.11676 3.20041 3.00009 3.53716 3.00009H4.46025V2.10264C4.46025 1.9565 4.50918 1.83449 4.60705 1.73663C4.7049 1.63877 4.82691 1.58984 4.97306 1.58984C5.11921 1.58984 5.24121 1.63877 5.33908 1.73663C5.43694 1.83449 5.48586 1.9565 5.48586 2.10264V3.00009H10.5371V2.08983C10.5371 1.94795 10.585 1.82915 10.6807 1.73343C10.7764 1.6377 10.8952 1.58984 11.0371 1.58984C11.179 1.58984 11.2978 1.6377 11.3935 1.73343C11.4892 1.82915 11.5371 1.94795 11.5371 2.08983V3.00009H12.4602C12.797 3.00009 13.082 3.11676 13.3153 3.35009C13.5487 3.58343 13.6653 3.86847 13.6653 4.20523V13.1283C13.6653 13.465 13.5487 13.7501 13.3153 13.9834C13.082 14.2167 12.797 14.3334 12.4602 14.3334H3.53716ZM3.53716 13.3334H12.4602C12.5115 13.3334 12.5585 13.312 12.6012 13.2693C12.644 13.2266 12.6653 13.1795 12.6653 13.1283V6.87189H3.33201V13.1283C3.33201 13.1795 3.35338 13.2266 3.39611 13.2693C3.43886 13.312 3.48588 13.3334 3.53716 13.3334ZM3.33201 5.87191H12.6653V4.20523C12.6653 4.15394 12.644 4.10692 12.6012 4.06418C12.5585 4.02144 12.5115 4.00008 12.4602 4.00008H3.53716C3.48588 4.00008 3.43886 4.02144 3.39611 4.06418C3.35338 4.10692 3.33201 4.15394 3.33201 4.20523V5.87191Z", fill: "currentColor" })
});
P({
  displayName: "CapIcon",
  viewBox: "0 0 40 40",
  path: w.createElement("path", { d: "M9.34894 29.7498C8.82984 29.4374 8.42302 29.0159 8.1285 28.4853C7.83395 27.9548 7.68667 27.3597 7.68667 26.7V18.4403L4.17257 16.3388C3.88368 16.1606 3.67153 15.9438 3.53612 15.6885C3.40071 15.4331 3.33301 15.1494 3.33301 14.8372C3.33301 14.5251 3.40071 14.2415 3.53612 13.9865C3.67153 13.7314 3.88368 13.5148 4.17257 13.3366L17.6139 5.41661C17.8525 5.27312 18.0982 5.16782 18.351 5.10071C18.6039 5.03357 18.8634 5 19.1296 5C19.3958 5 19.6553 5.03357 19.9082 5.10071C20.161 5.16782 20.407 5.27296 20.646 5.41613L35.8268 14.3507C36.0976 14.5094 36.3052 14.724 36.4497 14.9945C36.5941 15.265 36.6663 15.5569 36.6663 15.8702V27.1028C36.6663 27.5073 36.5398 27.8464 36.2866 28.1201C36.0334 28.3938 35.7197 28.5306 35.3455 28.5306C34.9712 28.5306 34.6577 28.3938 34.4049 28.1201C34.1521 27.8464 34.0257 27.5073 34.0257 27.1028V16.4193L30.5726 18.4403V26.7C30.5726 27.3597 30.4253 27.9548 30.1307 28.4853C29.8362 29.0159 29.4294 29.4374 28.9103 29.7498L20.6497 34.579C20.4082 34.7254 20.161 34.8322 19.9082 34.8993C19.6553 34.9664 19.3958 35 19.1296 35C18.8634 35 18.6039 34.9664 18.351 34.8993C18.0982 34.8322 17.8511 34.7254 17.6095 34.579L9.34894 29.7498ZM18.9265 21.7721C19.0055 21.8209 19.076 21.8453 19.1381 21.8453C19.2001 21.8453 19.2707 21.8209 19.3497 21.7721L31.1718 14.8377L19.3497 7.92164C19.2707 7.87281 19.2001 7.84839 19.1381 7.84839C19.076 7.84839 19.0055 7.87281 18.9265 7.92164L7.08741 14.8377L18.9265 21.7721ZM18.9096 32.1077C18.9885 32.1565 19.0619 32.1809 19.1296 32.1809C19.1973 32.1809 19.2707 32.1565 19.3497 32.1077L27.678 27.2419C27.7682 27.1809 27.8331 27.1107 27.8727 27.0314C27.9122 26.952 27.9319 26.8513 27.9319 26.7293V19.9634L20.6768 24.2726C20.4353 24.4191 20.1848 24.5259 19.9252 24.593C19.6657 24.6601 19.4005 24.6937 19.1296 24.6937C18.8588 24.6937 18.5936 24.6601 18.334 24.593C18.0745 24.5259 17.8239 24.4191 17.5824 24.2726L10.3273 19.9634V26.7293C10.3273 26.8269 10.3471 26.9215 10.3866 27.0131C10.4261 27.1046 10.491 27.1809 10.5813 27.2419L18.9096 32.1077Z", fill: "currentColor" })
});
const yp = P({
  displayName: "CaretDownIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.87308 9.21733C7.01795 9.07244 7.19358 9 7.39998 9C7.60638 9 7.78202 9.07244 7.92688 9.21733L12 13.2904L16.0731 9.21733C16.218 9.07244 16.3936 9 16.6 9C16.8064 9 16.982 9.07244 17.1269 9.21733C17.2718 9.36219 17.3442 9.53783 17.3442 9.74423C17.3442 9.95063 17.2718 10.1263 17.1269 10.2711L12.6327 14.7653C12.5391 14.8589 12.4404 14.925 12.3365 14.9634C12.2327 15.0019 12.1205 15.0211 12 15.0211C11.8795 15.0211 11.7673 15.0019 11.6635 14.9634C11.5596 14.925 11.4609 14.8589 11.3673 14.7653L6.87308 10.2711C6.7282 10.1263 6.65576 9.95062 6.65576 9.74422C6.65576 9.53782 6.7282 9.36219 6.87308 9.21733Z", fill: "currentColor" })
});
P({
  displayName: "CaretLeftIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M14.7827 6.8731C14.9276 7.01797 15 7.1936 15 7.4C15 7.6064 14.9276 7.78203 14.7827 7.9269L10.7096 12L14.7827 16.0731C14.9276 16.218 15 16.3936 15 16.6C15 16.8064 14.9276 16.982 14.7827 17.1269C14.6378 17.2718 14.4622 17.3442 14.2558 17.3442C14.0494 17.3442 13.8737 17.2718 13.7289 17.1269L9.23465 12.6327C9.14105 12.5391 9.07502 12.4404 9.03657 12.3365C8.99811 12.2327 8.97887 12.1205 8.97887 12C8.97887 11.8795 8.99811 11.7673 9.03657 11.6635C9.07502 11.5596 9.14105 11.4609 9.23465 11.3673L13.7289 6.8731C13.8737 6.72822 14.0494 6.65577 14.2558 6.65577C14.4622 6.65577 14.6378 6.72822 14.7827 6.8731Z", fill: "currentColor" })
});
P({
  displayName: "CaretRightIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M9.21733 17.1269C9.07244 16.982 9 16.8064 9 16.6C9 16.3936 9.07244 16.218 9.21733 16.0731L13.2904 12L9.21733 7.9269C9.07244 7.78203 9 7.6064 9 7.4C9 7.1936 9.07244 7.01797 9.21733 6.8731C9.36219 6.72822 9.53783 6.65578 9.74423 6.65578C9.95063 6.65578 10.1263 6.72822 10.2711 6.8731L14.7653 11.3673C14.8589 11.4609 14.925 11.5596 14.9634 11.6635C15.0019 11.7673 15.0211 11.8795 15.0211 12C15.0211 12.1205 15.0019 12.2327 14.9634 12.3365C14.925 12.4404 14.8589 12.5391 14.7653 12.6327L10.2711 17.1269C10.1263 17.2718 9.95063 17.3442 9.74423 17.3442C9.53783 17.3442 9.36219 17.2718 9.21733 17.1269Z", fill: "currentColor" })
});
const zoe = P({
  displayName: "CaretUpIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M17.1269 14.7827C16.982 14.9276 16.8064 15 16.6 15C16.3936 15 16.218 14.9276 16.0731 14.7827L12 10.7096L7.92689 14.7827C7.78202 14.9276 7.60639 15 7.39999 15C7.19359 15 7.01795 14.9276 6.87309 14.7827C6.7282 14.6378 6.65576 14.4622 6.65576 14.2558C6.65576 14.0494 6.7282 13.8737 6.87309 13.7289L11.3673 9.23465C11.4609 9.14105 11.5596 9.07502 11.6635 9.03657C11.7673 8.99811 11.8795 8.97887 12 8.97887C12.1205 8.97887 12.2327 8.99811 12.3365 9.03657C12.4404 9.07502 12.5391 9.14105 12.6327 9.23465L17.1269 13.7289C17.2718 13.8737 17.3442 14.0494 17.3442 14.2558C17.3442 14.4622 17.2718 14.6378 17.1269 14.7827Z", fill: "currentColor" })
});
P({
  displayName: "CashIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M3.90285 19C3.37113 19 2.92106 18.8115 2.55263 18.4346C2.18421 18.0577 2 17.5972 2 17.0532V6.94676C2 6.40277 2.18421 5.94231 2.55263 5.56539C2.92106 5.18846 3.37113 5 3.90285 5H20.0972C20.6289 5 21.0789 5.18846 21.4474 5.56539C21.8158 5.94231 22 6.40277 22 6.94676V17.0532C22 17.5972 21.8158 18.0577 21.4474 18.4346C21.0789 18.8115 20.6289 19 20.0972 19H3.90285ZM3.90285 17.3846H20.0972C20.1781 17.3846 20.2524 17.3501 20.3199 17.2811C20.3873 17.212 20.4211 17.1361 20.4211 17.0532V6.94676C20.4211 6.86391 20.3873 6.78796 20.3199 6.71891C20.2524 6.64988 20.1781 6.61536 20.0972 6.61536H3.90285C3.82186 6.61536 3.74763 6.64988 3.68014 6.71891C3.61266 6.78796 3.57893 6.86391 3.57893 6.94676V17.0532C3.57893 17.1361 3.61266 17.212 3.68014 17.2811C3.74763 17.3501 3.82186 17.3846 3.90285 17.3846ZM17.9514 14.858H15.9474C15.7666 14.858 15.6168 14.9187 15.498 15.0402C15.3792 15.1618 15.3198 15.315 15.3198 15.5C15.3198 15.685 15.3792 15.8383 15.498 15.9598C15.6168 16.0813 15.7666 16.142 15.9474 16.142H18.2551C18.5263 16.142 18.7527 16.0492 18.9342 15.8635C19.1157 15.6778 19.2065 15.4462 19.2065 15.1686V12.8077C19.2065 12.6227 19.1471 12.4694 19.0284 12.3479C18.9096 12.2264 18.7598 12.1657 18.579 12.1657C18.3981 12.1657 18.2483 12.2264 18.1296 12.3479C18.0108 12.4694 17.9514 12.6227 17.9514 12.8077V14.858ZM12 14.8994C12.7827 14.8994 13.4507 14.6163 14.004 14.0503C14.5573 13.4842 14.834 12.8008 14.834 12C14.834 11.1992 14.5573 10.5158 14.004 9.94972C13.4507 9.38365 12.7827 9.10062 12 9.10062C11.2173 9.10062 10.5493 9.38365 9.99597 9.94972C9.44267 10.5158 9.16602 11.1992 9.16602 12C9.16602 12.8008 9.44267 13.4842 9.99597 14.0503C10.5493 14.6163 11.2173 14.8994 12 14.8994ZM6.04856 9.142H8.05262C8.23345 9.142 8.38324 9.08125 8.50202 8.95975C8.62077 8.83824 8.68015 8.68498 8.68015 8.49999C8.68015 8.31499 8.62077 8.16173 8.50202 8.04022C8.38324 7.91872 8.23345 7.85798 8.05262 7.85798H5.74493C5.47367 7.85798 5.24728 7.95083 5.06577 8.13652C4.88426 8.32222 4.79351 8.55383 4.79351 8.83136V11.1923C4.79351 11.3773 4.85288 11.5306 4.97164 11.6521C5.09041 11.7736 5.24021 11.8343 5.42104 11.8343C5.60186 11.8343 5.75166 11.7736 5.87043 11.6521C5.98919 11.5306 6.04856 11.3773 6.04856 11.1923V9.142Z", fill: "currentColor" })
});
P({
  displayName: "CellTowerIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M7.47979 14.4596C6.87659 13.8436 6.43332 13.1481 6.14999 12.3731C5.86665 11.5981 5.72499 10.8071 5.72499 10C5.72499 9.19295 5.86249 8.40609 6.13749 7.63943C6.41249 6.87278 6.85992 6.1731 7.47979 5.5404L8.42496 6.48557C7.95638 6.97339 7.61167 7.52563 7.39084 8.1423C7.17 8.75897 7.05959 9.3782 7.05959 10C7.05959 10.6077 7.1684 11.2162 7.38601 11.8255C7.60365 12.4348 7.94996 12.9978 8.42496 13.5144L7.47979 14.4596ZM18.7413 16.6807L17.7961 15.7356C18.6224 14.8945 19.2363 13.9909 19.6379 13.0245C20.0395 12.0582 20.2403 11.05 20.2403 10C20.2403 8.95 20.0395 7.94182 19.6379 6.97547C19.2363 6.00914 18.6224 5.10546 17.7961 4.26443L18.7413 3.31925C19.7221 4.29553 20.4395 5.34168 20.8937 6.4577C21.3479 7.57372 21.5749 8.75448 21.5749 10C21.5749 11.2455 21.358 12.4263 20.924 13.5423C20.49 14.6583 19.7624 15.7045 18.7413 16.6807ZM5.25864 16.6807C4.283 15.7211 3.56682 14.6792 3.11009 13.5548C2.65335 12.4305 2.42499 11.2455 2.42499 10C2.42499 8.75448 2.64919 7.57372 3.09759 6.4577C3.54599 5.34168 4.26634 4.29553 5.25864 3.31925L6.20381 4.26443C5.37753 5.10546 4.76359 6.00914 4.36199 6.97547C3.96039 7.94182 3.75959 8.95 3.75959 10C3.75959 11.05 3.96039 12.0582 4.36199 13.0245C4.76359 13.9909 5.37753 14.8945 6.20381 15.7356L5.25864 16.6807ZM16.5201 14.4596L15.575 13.5144C16.0435 13.0266 16.3883 12.4744 16.6091 11.8577C16.8299 11.241 16.9403 10.6218 16.9403 10C16.9403 9.41153 16.8299 8.80945 16.6091 8.19375C16.3883 7.57805 16.0435 7.00866 15.575 6.48557L16.5201 5.5404C17.14 6.1731 17.5977 6.87518 17.8932 7.64665C18.1887 8.41812 18.316 9.20578 18.2749 10.0096C18.2749 10.8167 18.139 11.6019 17.8672 12.3654C17.5955 13.1288 17.1464 13.8269 16.5201 14.4596ZM7.61154 21.1201L10.7183 11.8154C10.4388 11.6141 10.2144 11.3599 10.0452 11.0529C9.87595 10.7458 9.79134 10.3949 9.79134 10C9.79134 9.38013 10.0045 8.86042 10.4307 8.44088C10.857 8.02133 11.3801 7.81155 12 7.81155C12.6198 7.81155 13.1437 8.02133 13.5716 8.44088C13.9995 8.86042 14.2134 9.38013 14.2134 10C14.2134 10.3949 14.1312 10.7426 13.9668 11.0433C13.8023 11.3439 13.574 11.6013 13.2817 11.8154L16.3932 21.1201H14.8326L14.1826 19.1701H9.83266L9.17689 21.1201H7.61154ZM10.3259 17.6711H13.6788L12 12.6154L10.3259 17.6711Z", fill: "currentColor" })
});
P({
  displayName: "CheckboxIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30773C3.5 4.8026 3.675 4.37503 4.025 4.02503C4.375 3.67503 4.80257 3.50003 5.3077 3.50003H18.6923C19.1974 3.50003 19.625 3.67503 19.975 4.02503C20.325 4.37503 20.5 4.8026 20.5 5.30773V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM5.3077 19H18.6923C18.7692 19 18.8397 18.968 18.9038 18.9039C18.9679 18.8397 19 18.7692 19 18.6923V5.30773C19 5.2308 18.9679 5.16027 18.9038 5.09616C18.8397 5.03206 18.7692 5.00001 18.6923 5.00001H5.3077C5.23077 5.00001 5.16024 5.03206 5.09612 5.09616C5.03202 5.16027 4.99997 5.2308 4.99997 5.30773V18.6923C4.99997 18.7692 5.03202 18.8397 5.09612 18.9039C5.16024 18.968 5.23077 19 5.3077 19Z", fill: "currentColor" })
});
P({
  displayName: "CheckboxCheckedIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M10.6 13.7462L8.27688 11.4231C8.13842 11.2846 7.96439 11.2138 7.75478 11.2106C7.54518 11.2074 7.36794 11.2782 7.22308 11.4231C7.07819 11.568 7.00575 11.7436 7.00575 11.95C7.00575 12.1564 7.07819 12.332 7.22308 12.4769L9.9673 15.2211C10.1481 15.4019 10.359 15.4923 10.6 15.4923C10.841 15.4923 11.0519 15.4019 11.2327 15.2211L16.7961 9.65768C16.9346 9.51923 17.0054 9.3452 17.0086 9.13558C17.0118 8.92596 16.941 8.74872 16.7961 8.60386C16.6513 8.45899 16.4756 8.38656 16.2692 8.38656C16.0628 8.38656 15.8872 8.45899 15.7423 8.60386L10.6 13.7462ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30773C3.5 4.8026 3.675 4.37503 4.025 4.02503C4.375 3.67503 4.80257 3.50003 5.3077 3.50003H18.6923C19.1974 3.50003 19.625 3.67503 19.975 4.02503C20.325 4.37503 20.5 4.8026 20.5 5.30773V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM5.3077 19H18.6923C18.7692 19 18.8397 18.968 18.9038 18.9039C18.9679 18.8397 19 18.7692 19 18.6923V5.30773C19 5.2308 18.9679 5.16027 18.9038 5.09616C18.8397 5.03206 18.7692 5.00001 18.6923 5.00001H5.3077C5.23077 5.00001 5.16024 5.03206 5.09612 5.09616C5.03202 5.16027 4.99997 5.2308 4.99997 5.30773V18.6923C4.99997 18.7692 5.03202 18.8397 5.09612 18.9039C5.16024 18.968 5.23077 19 5.3077 19Z", fill: "currentColor" })
});
P({
  displayName: "CheckedCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M12.6697 21.5C11.3557 21.5 10.1206 21.2507 8.96447 20.752C7.8083 20.2533 6.80264 19.5766 5.94747 18.7218C5.0923 17.8669 4.41522 16.8617 3.91622 15.706C3.41739 14.5503 3.16797 13.3156 3.16797 12.0017C3.16797 10.6877 3.4173 9.45267 3.91597 8.2965C4.41464 7.14033 5.09139 6.13467 5.94622 5.2795C6.80105 4.42433 7.8063 3.74725 8.96197 3.24825C10.1176 2.74942 11.3524 2.5 12.6662 2.5C13.9802 2.5 15.2153 2.74933 16.3715 3.248C17.5276 3.74667 18.5333 4.42342 19.3885 5.27825C20.2436 6.13308 20.9207 7.13833 21.4197 8.294C21.9186 9.44967 22.168 10.6844 22.168 11.9983C22.168 13.3123 21.9186 14.5473 21.42 15.7035C20.9213 16.8597 20.2446 17.8653 19.3897 18.7205C18.5349 19.5757 17.5296 20.2528 16.374 20.7518C15.2183 21.2506 13.9836 21.5 12.6697 21.5ZM12.668 20C14.9013 20 16.793 19.225 18.343 17.675C19.893 16.125 20.668 14.2333 20.668 12C20.668 9.76667 19.893 7.875 18.343 6.325C16.793 4.775 14.9013 4 12.668 4C10.4346 4 8.54297 4.775 6.99297 6.325C5.44297 7.875 4.66797 9.76667 4.66797 12C4.66797 14.2333 5.44297 16.125 6.99297 17.675C8.54297 19.225 10.4346 20 12.668 20Z", fill: "currentColor" }),
    w.createElement("path", { d: "M11.2575 13.8051L16.3998 8.6628C16.5382 8.52433 16.7123 8.4535 16.9219 8.4503C17.1315 8.4471 17.3088 8.51793 17.4536 8.6628C17.5985 8.80767 17.6709 8.9833 17.6709 9.1897C17.6709 9.39612 17.5985 9.57176 17.4536 9.71662L11.8901 15.2801C11.7094 15.4608 11.4985 15.5512 11.2575 15.5512C11.0165 15.5512 10.8056 15.4608 10.6248 15.2801L7.88057 12.5358C7.74211 12.3974 7.67127 12.2234 7.66807 12.0137C7.66486 11.8041 7.73569 11.6269 7.88057 11.482C8.02544 11.3372 8.20107 11.2647 8.40747 11.2647C8.61387 11.2647 8.78951 11.3372 8.93437 11.482L11.2575 13.8051Z", fill: "currentColor" })
  )
});
P({
  displayName: "ChecklistIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3.6C8 3.26863 8.26863 3 8.6 3H15.2C15.5314 3 15.8 3.26863 15.8 3.6V4.79998H17.6C18.5941 4.79998 19.4 5.60587 19.4 6.59998V19.2C19.4 20.1941 18.5941 21 17.6 21H6.8C5.80589 21 5 20.1941 5 19.2V6.59998C5 5.60587 5.80589 4.79998 6.8 4.79998H8V3.6ZM16.3819 10.6732C16.6432 10.3518 16.5945 9.87944 16.2732 9.61811C15.9518 9.35679 15.4794 9.40548 15.2181 9.72686C14.1709 11.0147 13.0524 12.3568 12.1609 13.3742C11.7139 13.8844 11.3315 14.3043 11.047 14.5931C11.0211 14.6194 10.9964 14.6442 10.9729 14.6675C10.8563 14.557 10.7197 14.4192 10.5665 14.2594C10.3473 14.0306 10.1086 13.772 9.86367 13.5066L9.86076 13.5034C9.61908 13.2416 9.37138 12.9732 9.14149 12.7333C8.85489 12.4342 8.38013 12.4241 8.08107 12.7107C7.78201 12.9973 7.77191 13.4721 8.05851 13.7711C8.27769 13.9998 8.51643 14.2585 8.76133 14.5239L8.76425 14.527C9.00588 14.7889 9.25366 15.0574 9.48351 15.2972C9.71166 15.5353 9.93723 15.7611 10.1329 15.9312C10.2294 16.0152 10.3362 16.101 10.4444 16.17C10.5153 16.2153 10.7278 16.35 11 16.35C11.2412 16.35 11.4237 16.2372 11.4697 16.2088L11.4732 16.2066C11.5514 16.1585 11.6247 16.1015 11.6866 16.0499C11.8129 15.9446 11.9595 15.8042 12.1155 15.6458C12.431 15.3256 12.8361 14.8798 13.2891 14.3628C14.1976 13.3258 15.3291 11.9679 16.3819 10.6732ZM11.2509 14.9053L11.248 14.9034C11.2694 14.9142 11.2717 14.9186 11.2509 14.9053Z", fill: "currentColor" })
});
const Goe = P({
  displayName: "CircleSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "currentColor" })
});
P({
  displayName: "CircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12.1697 21.7109C10.8557 21.7109 9.62064 21.4616 8.46447 20.9629C7.3083 20.4643 6.30264 19.7875 5.44747 18.9327C4.5923 18.0779 3.91522 17.0726 3.41622 15.9169C2.91739 14.7613 2.66797 13.5265 2.66797 12.2127C2.66797 10.8987 2.9173 9.6636 3.41597 8.50744C3.91464 7.35127 4.59139 6.3456 5.44622 5.49044C6.30105 4.63527 7.3063 3.95819 8.46197 3.45919C9.61764 2.96035 10.8524 2.71094 12.1662 2.71094C13.4802 2.71094 14.7153 2.96027 15.8715 3.45894C17.0276 3.9576 18.0333 4.63435 18.8885 5.48919C19.7436 6.34402 20.4207 7.34927 20.9197 8.50494C21.4186 9.6606 21.668 10.8954 21.668 12.2092C21.668 13.5232 21.4186 14.7583 20.92 15.9144C20.4213 17.0706 19.7446 18.0763 18.8897 18.9314C18.0349 19.7866 17.0296 20.4637 15.874 20.9627C14.7183 21.4615 13.4836 21.7109 12.1697 21.7109ZM12.168 20.2109C14.4013 20.2109 16.293 19.4359 17.843 17.8859C19.393 16.3359 20.168 14.4443 20.168 12.2109C20.168 9.9776 19.393 8.08594 17.843 6.53594C16.293 4.98594 14.4013 4.21094 12.168 4.21094C9.93464 4.21094 8.04297 4.98594 6.49297 6.53594C4.94297 8.08594 4.16797 9.9776 4.16797 12.2109C4.16797 14.4443 4.94297 16.3359 6.49297 17.8859C8.04297 19.4359 9.93464 20.2109 12.168 20.2109Z", fill: "currentColor" })
});
P({
  displayName: "ClockIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20.8C16.8601 20.8 20.8 16.8601 20.8 12C20.8 7.13991 16.8601 3.20001 12 3.20001C7.13991 3.20001 3.20001 7.13991 3.20001 12C3.20001 16.8601 7.13991 20.8 12 20.8ZM12 22.8C17.9647 22.8 22.8 17.9647 22.8 12C22.8 6.03534 17.9647 1.20001 12 1.20001C6.03534 1.20001 1.20001 6.03534 1.20001 12C1.20001 17.9647 6.03534 22.8 12 22.8Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6.20001C12.5523 6.20001 13 6.64773 13 7.20001V11H15.6C16.1523 11 16.6 11.4477 16.6 12C16.6 12.5523 16.1523 13 15.6 13H11V7.20001C11 6.64773 11.4477 6.20001 12 6.20001Z", fill: "currentColor" })
  )
});
const d2 = P({
  displayName: "CloseIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12 13.0538L6.92689 18.1269C6.78844 18.2654 6.6144 18.3362 6.40479 18.3394C6.19519 18.3426 6.01795 18.2718 5.87309 18.1269C5.7282 17.982 5.65576 17.8064 5.65576 17.6C5.65576 17.3936 5.7282 17.218 5.87309 17.0731L10.9462 12L5.87309 6.9269C5.73462 6.78845 5.66379 6.61442 5.66059 6.4048C5.65737 6.1952 5.7282 6.01797 5.87309 5.8731C6.01795 5.72822 6.19359 5.65578 6.39999 5.65578C6.60639 5.65578 6.78202 5.72822 6.92689 5.8731L12 10.9462L17.0731 5.8731C17.2115 5.73463 17.3856 5.6638 17.5952 5.6606C17.8048 5.65738 17.982 5.72822 18.1269 5.8731C18.2718 6.01797 18.3442 6.1936 18.3442 6.4C18.3442 6.6064 18.2718 6.78203 18.1269 6.9269L13.0538 12L18.1269 17.0731C18.2654 17.2116 18.3362 17.3856 18.3394 17.5952C18.3426 17.8048 18.2718 17.982 18.1269 18.1269C17.982 18.2718 17.8064 18.3442 17.6 18.3442C17.3936 18.3442 17.218 18.2718 17.0731 18.1269L12 13.0538Z", fill: "currentColor" })
});
P({
  displayName: "CloseCircleSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.6666 12C22.6666 17.891 17.891 22.6666 12 22.6666C6.10894 22.6666 1.33331 17.891 1.33331 12C1.33331 6.10894 6.10894 1.33331 12 1.33331C17.891 1.33331 22.6666 6.10894 22.6666 12ZM16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289Z", fill: "currentColor" })
});
P({
  displayName: "CloudIcon",
  viewBox: "0 0 40 40",
  path: w.createElement("path", { d: "M17.2243 24.1667L14.5705 21.5128C14.3226 21.2649 14.0325 21.1383 13.7003 21.133C13.368 21.1277 13.0726 21.2543 12.8141 21.5128C12.5555 21.7713 12.4262 22.0683 12.4262 22.4038C12.4262 22.7393 12.5555 23.0363 12.8141 23.2948L16.1955 26.7018C16.4968 27.0031 16.8483 27.1537 17.25 27.1537C17.6517 27.1537 18.0031 27.0031 18.3044 26.7018L25.1858 19.8205C25.4337 19.5726 25.5603 19.274 25.5656 18.9246C25.571 18.5753 25.4444 18.2713 25.1858 18.0128C24.9273 17.7543 24.626 17.625 24.282 17.625C23.938 17.625 23.6367 17.7543 23.3782 18.0128L17.2243 24.1667ZM10.8333 32.4999C8.5299 32.4999 6.56517 31.6997 4.93908 30.0993C3.31303 28.4989 2.5 26.547 2.5 24.2435C2.5 22.2051 3.15278 20.3921 4.45833 18.8045C5.76389 17.2169 7.42949 16.2778 9.45513 15.9872C9.98932 13.4957 11.242 11.4583 13.2131 9.875C15.1843 8.29167 17.4465 7.5 20 7.5C23.0149 7.5 25.5742 8.55182 27.6778 10.6555C29.7814 12.7591 30.8333 15.3183 30.8333 18.3333V19.1667H31.3461C33.1025 19.3034 34.5672 20.0096 35.7403 21.2852C36.9134 22.5609 37.4999 24.0769 37.4999 25.8333C37.4999 27.6922 36.8536 29.2681 35.5608 30.5608C34.2681 31.8536 32.6922 32.4999 30.8333 32.4999H10.8333ZM10.8333 30H30.8333C32 30 32.9861 29.5972 33.7916 28.7916C34.5972 27.9861 35 27 35 25.8333C35 24.6666 34.5972 23.6805 33.7916 22.875C32.9861 22.0694 32 21.6666 30.8333 21.6666H28.3333V18.3333C28.3333 16.0277 27.5208 14.0625 25.8958 12.4375C24.2708 10.8125 22.3055 9.99996 20 9.99996C17.6944 9.99996 15.7291 10.8125 14.1041 12.4375C12.4791 14.0625 11.6666 16.0277 11.6666 18.3333H10.8333C9.22218 18.3333 7.84718 18.9027 6.70829 20.0416C5.5694 21.1805 4.99996 22.5555 4.99996 24.1666C4.99996 25.7777 5.5694 27.1527 6.70829 28.2916C7.84718 29.4305 9.22218 30 10.8333 30Z", fill: "currentColor" })
});
P({
  displayName: "CodeIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.68349 18.9344C9.15961 18.7595 8.87665 18.1931 9.05149 17.6692L13.0515 5.68346C13.2263 5.15958 13.7927 4.87662 14.3166 5.05146C14.8405 5.22629 15.1235 5.79271 14.9486 6.31659L10.9486 18.3024C10.7738 18.8263 10.2074 19.1092 9.68349 18.9344ZM0.585815 12L1.29292 11.2929L5.29292 7.29289C5.68345 6.90237 6.31661 6.90237 6.70714 7.29289C7.09766 7.68342 7.09766 8.31658 6.70714 8.70711L3.41424 12L6.70714 15.2929C7.09766 15.6834 7.09766 16.3166 6.70714 16.7071C6.31661 17.0976 5.68345 17.0976 5.29292 16.7071L1.29292 12.7071L0.585815 12ZM22.7071 11.2929L23.4142 12L22.7071 12.7071L18.7071 16.7071C18.3166 17.0976 17.6834 17.0976 17.2929 16.7071C16.9024 16.3166 16.9024 15.6834 17.2929 15.2929L20.5858 12L17.2929 8.70711C16.9024 8.31658 16.9024 7.68342 17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289L22.7071 11.2929Z", fill: "currentColor" })
});
P({
  displayName: "CodeCircleSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.7211 9.20605C13.8349 8.80777 13.6043 8.39266 13.206 8.27887C12.8078 8.16507 12.3926 8.39569 12.2789 8.79397L10.2789 15.794C10.1651 16.1922 10.3957 16.6074 10.794 16.7212C11.1922 16.8349 11.6073 16.6043 11.7211 16.2061L13.7211 9.20605ZM15.4801 9.42384C15.1619 9.15867 14.689 9.20166 14.4238 9.51987C14.1587 9.83808 14.2017 10.311 14.5199 10.5762L16.8285 12.5L14.5199 14.4238C14.2017 14.689 14.1587 15.1619 14.4238 15.4801C14.689 15.7984 15.1619 15.8413 15.4801 15.5762L18.4801 13.0762L19.1715 12.5L18.4801 11.9238L15.4801 9.42384ZM9.57616 9.51987C9.31099 9.20166 8.83807 9.15867 8.51986 9.42384L5.51986 11.9238L4.82846 12.5L5.51986 13.0762L8.51986 15.5762C8.83807 15.8413 9.31099 15.7984 9.57616 15.4801C9.84134 15.1619 9.79834 14.689 9.48014 14.4238L7.17154 12.5L9.48014 10.5762C9.79834 10.311 9.84134 9.83808 9.57616 9.51987Z", fill: "currentColor" })
});
P({
  displayName: "CodeSquareIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.25 12L10 10.25C10.15 10.1 10.225 9.91667 10.225 9.7C10.225 9.48333 10.15 9.3 10 9.15C9.85 9 9.66667 8.925 9.45 8.925C9.23333 8.925 9.05 9 8.9 9.15L6.575 11.475C6.49167 11.5583 6.43333 11.6417 6.4 11.725C6.36667 11.8083 6.35 11.9 6.35 12C6.35 12.1 6.36667 12.1917 6.4 12.275C6.43333 12.3583 6.49167 12.4417 6.575 12.525L8.925 14.875C9.075 15.025 9.25833 15.1 9.475 15.1C9.69167 15.1 9.875 15.025 10.025 14.875C10.175 14.725 10.25 14.5417 10.25 14.325C10.25 14.1083 10.175 13.925 10.025 13.775L8.25 12ZM15.75 12L13.975 13.775C13.825 13.925 13.75 14.1083 13.75 14.325C13.75 14.5417 13.825 14.725 13.975 14.875C14.125 15.025 14.3083 15.1 14.525 15.1C14.7417 15.1 14.925 15.025 15.075 14.875L17.425 12.525C17.5083 12.4417 17.5667 12.3583 17.6 12.275C17.6333 12.1917 17.65 12.1 17.65 12C17.65 11.9 17.6333 11.8083 17.6 11.725C17.5667 11.6417 17.5083 11.5583 17.425 11.475L15.075 9.125C15.0083 9.04167 14.925 8.98333 14.825 8.95C14.725 8.91667 14.625 8.9 14.525 8.9C14.425 8.9 14.3292 8.91667 14.2375 8.95C14.1458 8.98333 14.0583 9.04167 13.975 9.125C13.825 9.275 13.75 9.45833 13.75 9.675C13.75 9.89167 13.825 10.075 13.975 10.225L15.75 12ZM4.5 21C4.1 21 3.75 20.85 3.45 20.55C3.15 20.25 3 19.9 3 19.5V4.5C3 4.1 3.15 3.75 3.45 3.45C3.75 3.15 4.1 3 4.5 3H19.5C19.9 3 20.25 3.15 20.55 3.45C20.85 3.75 21 4.1 21 4.5V19.5C21 19.9 20.85 20.25 20.55 20.55C20.25 20.85 19.9 21 19.5 21H4.5ZM4.5 19.5H19.5V4.5H4.5V19.5Z", fill: "currentColor" })
});
P({
  displayName: "CollapseIcon",
  viewBox: "0 0 20 20",
  path: w.createElement("path", { d: "M12.5 3.63535C12.5 3.46967 12.3657 3.33535 12.2 3.33535H11.1333C10.9676 3.33535 10.8333 3.46967 10.8333 3.63535V8.8687C10.8333 9.03439 10.9676 9.1687 11.1333 9.1687H16.3667C16.5323 9.1687 16.6667 9.03439 16.6667 8.8687V7.80202C16.6667 7.63633 16.5324 7.50202 16.3667 7.50202H14.4028C14.1355 7.50202 14.0016 7.17888 14.1906 6.98989L17.0438 4.13673C17.1609 4.01958 17.1609 3.82963 17.0438 3.71247L16.2895 2.95823C16.1724 2.84107 15.9824 2.84107 15.8653 2.95823L13.0121 5.81137C12.8231 6.00036 12.5 5.86651 12.5 5.59924V3.63535ZM3.3334 12.202C3.3334 12.3676 3.46771 12.502 3.6334 12.502H5.59729C5.86456 12.502 5.99841 12.8251 5.80942 13.0141L2.95627 15.8672C2.83912 15.9844 2.83912 16.1743 2.95627 16.2915L3.71052 17.0457C3.82767 17.1629 4.01762 17.1629 4.13478 17.0457L6.98793 14.1926C7.17692 14.0036 7.50007 14.1374 7.50007 14.4047V16.3686C7.50007 16.5343 7.63438 16.6686 7.80007 16.6686H8.86675C9.03243 16.6686 9.16675 16.5343 9.16675 16.3686V11.1353C9.16675 10.9696 9.03243 10.8353 8.86675 10.8353H3.6334C3.46771 10.8353 3.3334 10.9696 3.3334 11.1353V12.202Z", fill: "currentColor" })
});
P({
  displayName: "CommunityIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M4.61979 14.0818L6.75054 11.951L4.61979 9.82029L2.48904 11.951L4.61979 14.0818ZM17.9659 13.6722L20.1005 10.2491L22.2447 13.6722H17.9659ZM12.3539 12.8452C11.6337 12.8452 11.0204 12.5928 10.514 12.088C10.0076 11.5832 9.75441 10.9703 9.75441 10.2491C9.75441 9.51355 10.0068 8.89697 10.5116 8.39939C11.0164 7.90181 11.6294 7.65302 12.3505 7.65302C13.0861 7.65302 13.7027 7.90148 14.2003 8.39841C14.6979 8.89535 14.9467 9.51112 14.9467 10.2457C14.9467 10.9659 14.6982 11.5792 14.2013 12.0856C13.7043 12.592 13.0885 12.8452 12.3539 12.8452ZM12.3505 9.15296C12.048 9.15296 11.7896 9.25802 11.5755 9.46812C11.3614 9.67822 11.2544 9.93855 11.2544 10.2491C11.2544 10.5517 11.3614 10.81 11.5755 11.0241C11.7896 11.2382 12.0496 11.3453 12.3553 11.3453C12.6611 11.3453 12.9195 11.2382 13.1304 11.0241C13.3412 10.81 13.4467 10.5501 13.4467 10.2443C13.4467 9.93855 13.3416 9.68021 13.1316 9.46931C12.9215 9.25841 12.6611 9.15296 12.3505 9.15296ZM0.850586 18.1337V16.9145C0.850586 16.2388 1.19915 15.6898 1.89629 15.2673C2.59344 14.8449 3.49815 14.6337 4.61044 14.6337C4.8141 14.6337 5.00953 14.6395 5.19671 14.651C5.38389 14.6625 5.56274 14.685 5.73324 14.7183C5.54479 15.0132 5.40184 15.327 5.30441 15.6597C5.20698 15.9925 5.15826 16.3469 5.15826 16.7231V18.1337H0.850586ZM6.85056 18.1337V16.7587C6.85056 15.8036 7.35879 15.0375 8.37526 14.4606C9.39171 13.8837 10.7177 13.5952 12.3532 13.5952C14.004 13.5952 15.3329 13.8837 16.3399 14.4606C17.347 15.0375 17.8505 15.8036 17.8505 16.7587V18.1337H6.85056ZM20.1005 14.6337C21.2255 14.6337 22.1318 14.8449 22.8193 15.2673C23.5068 15.6898 23.8505 16.2388 23.8505 16.9145V18.1337H19.5428V16.7231C19.5428 16.3469 19.4983 15.9925 19.4092 15.6597C19.3201 15.327 19.1864 15.0132 19.0082 14.7183C19.1787 14.685 19.3556 14.6625 19.5388 14.651C19.7221 14.6395 19.9093 14.6337 20.1005 14.6337ZM12.3494 15.0952C11.3104 15.0952 10.4175 15.233 9.67071 15.5087C8.92393 15.7843 8.50951 16.1241 8.42746 16.5279V16.6337H16.289V16.5279C16.1967 16.1241 15.7813 15.7843 15.0429 15.5087C14.3044 15.233 13.4066 15.0952 12.3494 15.0952Z", fill: "currentColor" })
});
P({
  displayName: "ConnectIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.2938 4.31859C17.3412 2.36597 14.1754 2.36597 12.2228 4.31859L10.2934 6.24794C9.90291 6.63847 9.90291 7.27163 10.2934 7.66216C10.684 8.05268 11.3171 8.05268 11.7076 7.66216L13.637 5.73281C14.8086 4.56123 16.7081 4.56123 17.8796 5.73281C19.0512 6.90438 19.0512 8.80387 17.8796 9.97545L15.9503 11.9048C15.5598 12.2953 15.5598 12.9285 15.9503 13.319C16.3408 13.7095 16.974 13.7095 17.3645 13.319L19.2938 11.3897C21.2465 9.43704 21.2465 6.27121 19.2938 4.31859ZM8.17211 11.1977C8.56263 10.8072 8.56263 10.174 8.17211 9.78348C7.78159 9.39295 7.14842 9.39295 6.7579 9.78348L4.56963 11.9717C2.61701 13.9244 2.61701 17.0902 4.56963 19.0428C6.52225 20.9954 9.68807 20.9954 11.6407 19.0428L13.829 16.8545C14.2195 16.464 14.2195 15.8309 13.829 15.4403C13.4384 15.0498 12.8053 15.0498 12.4148 15.4403L10.2265 17.6286C9.05491 18.8002 7.15542 18.8002 5.98384 17.6286C4.81227 16.457 4.81227 14.5575 5.98384 13.386L8.17211 11.1977ZM9.29291 13.2919C8.90238 13.6824 8.90238 14.3156 9.29291 14.7061C9.68343 15.0966 10.3166 15.0966 10.7071 14.7061L14.7071 10.7061C15.0976 10.3156 15.0976 9.68242 14.7071 9.29189C14.3166 8.90137 13.6834 8.90137 13.2929 9.29189L9.29291 13.2919Z", fill: "currentColor" })
});
P({
  displayName: "ContractIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 3.5C7.94772 3.5 7.5 3.94772 7.5 4.5V11.5001H4.5C3.94772 11.5001 3.5 11.9478 3.5 12.5001V17.5001C3.5 19.1574 4.84272 20.5001 6.5 20.5001L6.5237 20.5H17.5C19.1573 20.5 20.5 19.1573 20.5 17.5V4.5C20.5 3.94772 20.0523 3.5 19.5 3.5H8.5ZM6.51369 18.5H6.5L6.4906 18.5C5.94222 18.495 5.5 18.0497 5.5 17.5001V13.5001H7.5V17.5001C7.5 18.0482 7.06008 18.4927 6.51369 18.5ZM9.32943 18.5H17.5C18.0527 18.5 18.5 18.0527 18.5 17.5V5.5H9.5V12.5V12.5001V17.5001C9.5 17.8507 9.4399 18.1873 9.32943 18.5ZM10.75 7.50009C10.75 7.08588 11.0858 6.75009 11.5 6.75009H16.5C16.9142 6.75009 17.25 7.08588 17.25 7.50009C17.25 7.91431 16.9142 8.25009 16.5 8.25009H11.5C11.0858 8.25009 10.75 7.91431 10.75 7.50009ZM11.5 9.75015C11.0858 9.75015 10.75 10.0859 10.75 10.5002C10.75 10.9144 11.0858 11.2502 11.5 11.2502H16.5C16.9142 11.2502 17.25 10.9144 17.25 10.5002C17.25 10.0859 16.9142 9.75015 16.5 9.75015H11.5ZM10.75 13.4998C10.75 13.0856 11.0858 12.7498 11.5 12.7498H16.5C16.9142 12.7498 17.25 13.0856 17.25 13.4998C17.25 13.9141 16.9142 14.2498 16.5 14.2498H11.5C11.0858 14.2498 10.75 13.9141 10.75 13.4998ZM11.5 15.7499C11.0858 15.7499 10.75 16.0857 10.75 16.4999C10.75 16.9141 11.0858 17.2499 11.5 17.2499H13.5C13.9142 17.2499 14.25 16.9141 14.25 16.4999C14.25 16.0857 13.9142 15.7499 13.5 15.7499H11.5Z", fill: "currentColor" })
});
P({
  displayName: "ConversionPathIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M19 20.75C18.3756 20.75 17.8195 20.5625 17.3317 20.1875C16.8439 19.8125 16.5224 19.3333 16.3673 18.75H11C9.96408 18.75 9.08011 18.3839 8.34808 17.6519C7.61603 16.9198 7.25 16.0359 7.25 15C7.25 13.9641 7.61603 13.0801 8.34808 12.3481C9.08011 11.616 9.96408 11.25 11 11.25H13C13.6187 11.25 14.1484 11.0295 14.5891 10.5885C15.0297 10.1475 15.25 9.61737 15.25 8.9981C15.25 8.37883 15.0297 7.84933 14.5891 7.40958C14.1484 6.96983 13.6187 6.74995 13 6.74995H7.63265C7.46727 7.33328 7.14323 7.81245 6.66055 8.18745C6.17785 8.56245 5.62433 8.74995 4.99998 8.74995C4.23609 8.74995 3.58679 8.4827 3.05208 7.9482C2.51736 7.4137 2.25 6.76467 2.25 6.0011C2.25 5.23753 2.51736 4.58812 3.05208 4.05287C3.58679 3.51762 4.23609 3.25 4.99998 3.25C5.62433 3.25 6.17785 3.4375 6.66055 3.8125C7.14323 4.1875 7.46727 4.66667 7.63265 5.25H13C14.0359 5.25 14.9198 5.61603 15.6519 6.34808C16.3839 7.08011 16.75 7.96408 16.75 8.99998C16.75 10.0359 16.3839 10.9198 15.6519 11.6519C14.9198 12.3839 14.0359 12.75 13 12.75H11C10.3812 12.75 9.85153 12.9705 9.4109 13.4115C8.97027 13.8525 8.74995 14.3826 8.74995 15.0019C8.74995 15.6211 8.97027 16.1506 9.4109 16.5904C9.85153 17.0301 10.3812 17.25 11 17.25H16.3673C16.5327 16.6667 16.8567 16.1875 17.3394 15.8125C17.8221 15.4375 18.3756 15.25 19 15.25C19.7639 15.25 20.4132 15.5173 20.9479 16.0518C21.4826 16.5863 21.75 17.2353 21.75 17.9989C21.75 18.7624 21.4826 19.4118 20.9479 19.9471C20.4132 20.4823 19.7639 20.75 19 20.75ZM4.99998 7.25C5.34741 7.25 5.64261 7.12853 5.88558 6.88558C6.12853 6.64261 6.25 6.34741 6.25 5.99997C6.25 5.65254 6.12853 5.35734 5.88558 5.11437C5.64261 4.87142 5.34741 4.74995 4.99998 4.74995C4.65254 4.74995 4.35734 4.87142 4.11438 5.11437C3.87143 5.35734 3.74995 5.65254 3.74995 5.99997C3.74995 6.34741 3.87143 6.64261 4.11438 6.88558C4.35734 7.12853 4.65254 7.25 4.99998 7.25Z", fill: "currentColor" })
});
P({
  displayName: "CookieIcon",
  viewBox: "0 0 20 20",
  path: w.createElement(
    "g",
    null,
    w.createElement("path", { d: "M10 18.8496C8.87389 18.8496 7.81729 18.6362 6.83021 18.2094C5.84299 17.7826 4.98375 17.2035 4.2525 16.4721C3.52111 15.7408 2.94201 14.8816 2.51521 13.8944C2.0884 12.9073 1.875 11.8507 1.875 10.7246C1.875 9.59432 2.10764 8.51126 2.57292 7.47543C3.03819 6.43959 3.67604 5.53626 4.48646 4.76543C5.29674 3.9946 6.25 3.41022 7.34625 3.0123C8.44236 2.61425 9.62556 2.48793 10.8958 2.63335C11.0668 2.65571 11.1998 2.72779 11.2948 2.8496C11.3899 2.9714 11.4444 3.13057 11.4583 3.3271C11.5021 4.28543 11.8453 5.08057 12.4879 5.71251C13.1306 6.34446 13.9401 6.69036 14.9167 6.75022C15.1389 6.76411 15.3103 6.83279 15.431 6.95626C15.5517 7.0796 15.6164 7.26091 15.625 7.50022C15.6474 8.11022 15.8378 8.62814 16.1962 9.05397C16.5547 9.47966 17.023 9.78973 17.601 9.98418C17.7634 10.0429 17.8913 10.1303 17.9848 10.2463C18.0783 10.3622 18.125 10.5014 18.125 10.6638C18.1207 11.779 17.9033 12.8346 17.4727 13.8304C17.0422 14.8261 16.4612 15.6961 15.73 16.4402C14.9986 17.1842 14.1404 17.7718 13.1554 18.2029C12.1704 18.634 11.1186 18.8496 10 18.8496ZM10 17.5996C11.7479 17.5996 13.2968 16.9829 14.6467 15.7494C15.9965 14.5159 16.7367 12.9483 16.8671 11.0467C16.1512 10.7465 15.5914 10.3299 15.1875 9.79668C14.7836 9.26362 14.5283 8.64397 14.4215 7.93772C13.3147 7.81161 12.378 7.3773 11.6115 6.6348C10.8448 5.8923 10.3979 4.9596 10.2708 3.83668C9.18639 3.78765 8.20403 3.96237 7.32375 4.36084C6.44333 4.75932 5.6925 5.29265 5.07125 5.96085C4.45 6.62918 3.97035 7.38321 3.63229 8.22293C3.2941 9.06265 3.125 9.89654 3.125 10.7246C3.125 12.6253 3.79569 14.2463 5.13708 15.5875C6.47833 16.9289 8.09931 17.5996 10 17.5996ZM8.75 8.97772C9.07583 8.97772 9.35229 8.86293 9.57937 8.63335C9.80632 8.40362 9.91979 8.12848 9.91979 7.80793C9.91979 7.4821 9.80632 7.20564 9.57937 6.97855C9.35229 6.75161 9.07583 6.63814 8.75 6.63814C8.42944 6.63814 8.15431 6.75161 7.92458 6.97855C7.695 7.20564 7.58021 7.4821 7.58021 7.80793C7.58021 8.12848 7.695 8.40362 7.92458 8.63335C8.15431 8.86293 8.42944 8.97772 8.75 8.97772ZM7.08333 13.1444C7.40917 13.1444 7.68563 13.0296 7.91271 12.8C8.13965 12.5703 8.25312 12.2952 8.25312 11.9746C8.25312 11.6488 8.13965 11.3723 7.91271 11.1452C7.68563 10.9183 7.40917 10.8048 7.08333 10.8048C6.76278 10.8048 6.48764 10.9183 6.25792 11.1452C6.02833 11.3723 5.91354 11.6488 5.91354 11.9746C5.91354 12.2952 6.02833 12.5703 6.25792 12.8C6.48764 13.0296 6.76278 13.1444 7.08333 13.1444ZM12.5 13.9777C12.7147 13.9777 12.894 13.9046 13.0377 13.7583C13.1813 13.612 13.2531 13.434 13.2531 13.2246C13.2531 13.0099 13.1813 12.8306 13.0377 12.6869C12.894 12.5433 12.7147 12.4715 12.5 12.4715C12.2906 12.4715 12.1126 12.5433 11.9662 12.6869C11.82 12.8306 11.7469 13.0099 11.7469 13.2246C11.7469 13.434 11.82 13.612 11.9662 13.7583C12.1126 13.9046 12.2906 13.9777 12.5 13.9777Z", fill: "currentColor" })
  )
});
P({
  displayName: "CopyIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.50427 20C6.09275 20 5.73915 19.8522 5.44349 19.5565C5.14783 19.2608 5 18.9073 5 18.4957V7.22249H6.50427V18.4957H15.3453V20H6.50427ZM9.12913 17.3645C8.72054 17.3645 8.36946 17.2177 8.07589 16.9241C7.78232 16.6305 7.63553 16.2795 7.63553 15.8709V5.50427C7.63553 5.09275 7.78232 4.73915 8.07589 4.44349C8.36946 4.14783 8.72054 4 9.12913 4H17.2332C17.6447 4 17.9983 4.14783 18.294 4.44349C18.5897 4.73915 18.7375 5.09275 18.7375 5.50427V15.8709C18.7375 16.2795 18.5897 16.6305 18.294 16.9241C17.9983 17.2177 17.6447 17.3645 17.2332 17.3645H9.12913ZM9.12913 15.8709H17.2332V5.50427H9.12913V15.8709Z", fill: "currentColor" })
});
P({
  displayName: "CoreIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M15 12C15 13.657 13.657 15 12 15C10.343 15 9 13.657 9 12C9 10.343 10.343 9 12 9C12.7148 9 13.3711 9.24961 13.8867 9.6668C14.5664 10.2164 15 11.0578 15 12Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.17188 16.4449C3.42656 15.1336 3 13.616 3 12C3 10.384 3.42656 8.86641 4.17188 7.55508C3.81328 7.13555 3.6 6.59531 3.6 6C3.6 4.67461 4.67344 3.6 6 3.6C6.30234 3.6 6.59063 3.65508 6.85547 3.75586C6.92578 3.78164 6.99141 3.81094 7.05469 3.84375L7.13203 3.88242C7.28203 3.96328 7.425 4.06055 7.55625 4.17188C8.86641 3.42539 10.3828 3 12 3C13.6172 3 15.1336 3.42539 16.4438 4.17188C16.5773 4.05703 16.7227 3.95742 16.8797 3.87422C16.9594 3.83203 17.0414 3.79453 17.1281 3.76172C17.3977 3.65742 17.693 3.6 18 3.6C18.7945 3.6 19.4977 3.98555 19.9336 4.57852C20.0273 4.70742 20.1094 4.8457 20.1773 4.99219C20.3203 5.29805 20.4 5.64023 20.4 6C20.4 6.59531 20.1867 7.13555 19.8281 7.55508C20.5734 8.86641 21 10.384 21 12C21 12.4664 20.9648 12.9246 20.8969 13.3723C20.7258 14.475 20.3578 15.5121 19.8281 16.4449C19.8727 16.4965 19.9125 16.5492 19.9523 16.6043C20.0906 16.8 20.2031 17.0168 20.2805 17.2488C20.3578 17.4844 20.4 17.7363 20.4 18C20.4 19.3254 19.3266 20.4 18 20.4C17.4047 20.4 16.8633 20.1867 16.4438 19.8281C15.1336 20.5746 13.6172 21 12 21C10.3828 21 8.86641 20.5746 7.55625 19.8281C7.13672 20.1867 6.59531 20.4 6 20.4C4.67344 20.4 3.6 19.3254 3.6 18C3.6 17.4047 3.81328 16.8645 4.17188 16.4449ZM14.1539 19.1871C13.4719 19.391 12.7477 19.5 12 19.5C10.6688 19.5 9.41953 19.1543 8.33672 18.5461C8.37656 18.3715 8.4 18.1863 8.4 18C8.4 16.6746 7.32656 15.6 6 15.6C5.8125 15.6 5.62734 15.6246 5.45391 15.6645C4.84688 14.5805 4.5 13.3313 4.5 12C4.5 10.6688 4.84688 9.41953 5.45391 8.33555C5.62734 8.37539 5.8125 8.4 6 8.4C7.32656 8.4 8.4 7.32539 8.4 6C8.4 5.81367 8.37656 5.62852 8.33672 5.45391C9.41953 4.8457 10.6688 4.5 12 4.5C12.8578 4.5 13.6828 4.64297 14.4492 4.90781C14.8734 5.0543 15.2789 5.23711 15.6633 5.45391C15.6234 5.62852 15.6 5.81367 15.6 6C15.6 7.32539 16.6734 8.4 18 8.4C18.0938 8.4 18.1875 8.39297 18.2789 8.38125C18.3422 8.37422 18.4031 8.36484 18.4641 8.35313L18.5461 8.33555C19.1531 9.41953 19.5 10.6688 19.5 12C19.5 13.3313 19.1531 14.5805 18.5461 15.6645C18.3727 15.6246 18.1852 15.6 18 15.6C17.3836 15.6 16.8211 15.832 16.3969 16.2129C15.907 16.6523 15.6 17.2898 15.6 18C15.6 18.1863 15.6234 18.3715 15.6633 18.5461C15.1898 18.8121 14.6836 19.0277 14.1539 19.1871Z", fill: "currentColor" })
  )
});
P({
  displayName: "CorporateIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M3.88465 20.5769C3.46287 20.5769 3.10423 20.4291 2.80873 20.1336C2.51323 19.8381 2.36548 19.4795 2.36548 19.0577V4.59612C2.36548 4.17434 2.51323 3.81569 2.80873 3.52017C3.10423 3.22467 3.46287 3.07693 3.88465 3.07693H10.3462C10.768 3.07693 11.1267 3.22467 11.4222 3.52017C11.7177 3.81569 11.8654 4.17434 11.8654 4.59612V7.07693H20.1155C20.5372 7.07693 20.8959 7.22468 21.1914 7.52017C21.4869 7.81569 21.6347 8.17434 21.6347 8.59612V19.0577C21.6347 19.4795 21.4869 19.8381 21.1914 20.1336C20.8959 20.4291 20.5372 20.5769 20.1155 20.5769H3.88465ZM3.86543 19.0769H10.3655V16.5769H3.86543V19.0769ZM3.86543 15.0769H10.3655V12.5769H3.86543V15.0769ZM3.86543 11.0769H10.3655V8.5769H3.86543V11.0769ZM3.86543 7.07693H10.3655V4.5769H3.86543V7.07693ZM11.8654 19.0769H20.1347V8.5769H11.8654V19.0769ZM14.8077 12.5769C14.5952 12.5769 14.4171 12.505 14.2734 12.3612C14.1296 12.2174 14.0578 12.0392 14.0578 11.8266C14.0578 11.614 14.1296 11.4359 14.2734 11.2923C14.4171 11.1487 14.5952 11.0769 14.8077 11.0769H17.0001C17.2126 11.0769 17.3907 11.1488 17.5344 11.2927C17.6782 11.4365 17.75 11.6147 17.75 11.8273C17.75 12.0398 17.6782 12.2179 17.5344 12.3615C17.3907 12.5051 17.2126 12.5769 17.0001 12.5769H14.8077ZM14.8077 16.5769C14.5952 16.5769 14.4171 16.505 14.2734 16.3612C14.1296 16.2174 14.0578 16.0392 14.0578 15.8266C14.0578 15.614 14.1296 15.4359 14.2734 15.2923C14.4171 15.1487 14.5952 15.0769 14.8077 15.0769H17.0001C17.2126 15.0769 17.3907 15.1488 17.5344 15.2927C17.6782 15.4365 17.75 15.6147 17.75 15.8273C17.75 16.0398 17.6782 16.2179 17.5344 16.3615C17.3907 16.5051 17.2126 16.5769 17.0001 16.5769H14.8077Z", fill: "currentColor" })
});
P({
  displayName: "CubeIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.25 19.5693V12.4308L4.99997 8.81153V15.7769C4.99997 15.8282 5.0128 15.8763 5.03845 15.9212C5.06408 15.966 5.10254 16.0045 5.15383 16.0366L11.25 19.5693ZM12.75 19.5693L18.8461 16.0366C18.8974 16.0045 18.9359 15.966 18.9615 15.9212C18.9872 15.8763 19 15.8282 19 15.7769V8.81153L12.75 12.4308V19.5693ZM12 11.1385L18.175 7.56925L12.1538 4.08655C12.1025 4.0545 12.0513 4.03848 12 4.03848C11.9487 4.03848 11.8974 4.0545 11.8461 4.08655L5.82495 7.56925L12 11.1385ZM4.40385 17.3538C4.11923 17.1897 3.89744 16.9705 3.73847 16.6961C3.57949 16.4218 3.5 16.1205 3.5 15.7923V8.2077C3.5 7.8795 3.57949 7.57823 3.73847 7.30388C3.89744 7.02951 4.11923 6.81028 4.40385 6.64618L11.0961 2.79428C11.3807 2.63018 11.682 2.54813 12 2.54813C12.3179 2.54813 12.6192 2.63018 12.9038 2.79428L19.5961 6.64618C19.8807 6.81028 20.1025 7.02951 20.2615 7.30388C20.4205 7.57823 20.5 7.8795 20.5 8.2077V15.7923C20.5 16.1205 20.4205 16.4218 20.2615 16.6961C20.1025 16.9705 19.8807 17.1897 19.5961 17.3538L12.9038 21.2057C12.6192 21.3698 12.3179 21.4519 12 21.4519C11.682 21.4519 11.3807 21.3698 11.0961 21.2057L4.40385 17.3538Z", fill: "currentColor" })
});
P({
  displayName: "CustomerServiceIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.7352 20.5V19H19.0428C19.1262 19 19.1983 18.9744 19.2592 18.9231C19.3201 18.8718 19.3506 18.8045 19.3506 18.7211V11.7269C19.3506 9.81537 18.6666 8.20608 17.2986 6.89903C15.9307 5.592 14.2813 4.93848 12.3506 4.93848C10.4198 4.93848 8.77044 5.592 7.40249 6.89903C6.03454 8.20608 5.35056 9.81537 5.35056 11.7269V17.6154H4.60059C4.1211 17.6154 3.70957 17.4484 3.36599 17.1144C3.02239 16.7804 2.85059 16.3737 2.85059 15.8942V13.9519C2.85059 13.6276 2.94289 13.3304 3.12751 13.0606C3.31213 12.7907 3.55315 12.5737 3.85059 12.4096L3.89676 11.1327C3.97879 10.0443 4.26148 9.03593 4.74481 8.10773C5.22814 7.17952 5.84801 6.3715 6.60441 5.68368C7.36083 4.99586 8.2339 4.45997 9.22364 4.07601C10.2134 3.69202 11.2557 3.50003 12.3506 3.50003C13.4454 3.50003 14.4852 3.69202 15.4698 4.07601C16.4544 4.45997 17.3275 4.99331 18.089 5.67601C18.8505 6.35869 19.4704 7.16413 19.9486 8.09233C20.4268 9.02053 20.7121 10.0289 20.8044 11.1173L20.8505 12.3693C21.1416 12.5064 21.381 12.7026 21.5688 12.9577C21.7566 13.2128 21.8505 13.4974 21.8505 13.8115V16.0442C21.8505 16.3583 21.7566 16.6429 21.5688 16.8981C21.381 17.1532 21.1416 17.3493 20.8505 17.4865V18.7211C20.8505 19.2134 20.6739 19.633 20.3207 19.9798C19.9675 20.3266 19.5416 20.5 19.0428 20.5H11.7352ZM9.54289 13.7692C9.29802 13.7692 9.08937 13.6862 8.91694 13.5202C8.7445 13.3542 8.65829 13.1487 8.65829 12.9039C8.65829 12.659 8.7445 12.4519 8.91694 12.2827C9.08937 12.1135 9.29802 12.0289 9.54289 12.0289C9.78775 12.0289 9.9964 12.1135 10.1688 12.2827C10.3413 12.4519 10.4275 12.659 10.4275 12.9039C10.4275 13.1487 10.3413 13.3542 10.1688 13.5202C9.9964 13.6862 9.78775 13.7692 9.54289 13.7692ZM15.1582 13.7692C14.9134 13.7692 14.7047 13.6862 14.5323 13.5202C14.3599 13.3542 14.2736 13.1487 14.2736 12.9039C14.2736 12.659 14.3599 12.4519 14.5323 12.2827C14.7047 12.1135 14.9134 12.0289 15.1582 12.0289C15.4031 12.0289 15.6118 12.1135 15.7842 12.2827C15.9566 12.4519 16.0428 12.659 16.0428 12.9039C16.0428 13.1487 15.9566 13.3542 15.7842 13.5202C15.6118 13.6862 15.4031 13.7692 15.1582 13.7692ZM6.72174 12.2C6.61789 10.5679 7.12558 9.17148 8.24481 8.01058C9.36404 6.8497 10.7493 6.26926 12.4006 6.26926C13.7877 6.26926 15.0118 6.69842 16.0727 7.55676C17.1335 8.41507 17.7775 9.52628 18.0044 10.8904C16.5839 10.8737 15.2714 10.5006 14.0669 9.77116C12.8624 9.04167 11.9378 8.04168 11.2929 6.77118C11.039 8.01476 10.507 9.11411 9.69674 10.0692C8.88647 11.0243 7.8948 11.7346 6.72174 12.2Z", fill: "currentColor" })
});
P({
  displayName: "DataIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.79036 6.066C5.44895 6.73671 5 7.47826 5 8C5 8.52174 5.44895 9.26329 6.79036 9.934C8.07196 10.5748 9.91244 11 12 11C14.0876 11 15.928 10.5748 17.2096 9.934C18.5511 9.26329 19 8.52174 19 8C19 7.47826 18.5511 6.73671 17.2096 6.066C15.928 5.4252 14.0876 5 12 5C9.91244 5 8.07196 5.4252 6.79036 6.066ZM5.89593 4.27715C7.50977 3.47023 9.66928 3 12 3C14.3307 3 16.4902 3.47023 18.1041 4.27715C19.6581 5.05416 21 6.3126 21 8C21 8.46704 20.8972 8.90123 20.7155 9.30144C20.8915 9.48169 21 9.72818 21 10V12.4085C21 12.7541 20.9406 13.1014 20.8216 13.4297C20.9341 13.5915 21 13.788 21 14V16.4085C21 17.2739 20.6274 18.1495 19.8806 18.7117C17.9962 20.13 15.8242 21 12 21C8.17576 21 6.00383 20.13 4.11943 18.7117C3.37258 18.1495 3 17.2739 3 16.4085V14C3 13.788 3.06594 13.5915 3.17843 13.4297C3.05944 13.1014 3 12.7541 3 12.4085V10C3 9.72818 3.10845 9.48169 3.28445 9.30144C3.1028 8.90123 3 8.46704 3 8C3 6.3126 4.34191 5.05416 5.89593 4.27715ZM5 15.3171V16.4085C5 16.7165 5.13142 16.9701 5.32215 17.1137C6.82026 18.2413 8.55733 19 12 19C15.4427 19 17.1797 18.2413 18.6778 17.1137C18.8686 16.9701 19 16.7165 19 16.4085V15.3171C17.3005 16.3735 15.2451 17 12 17C8.75486 17 6.6995 16.3735 5 15.3171ZM18.1041 11.7229C18.4141 11.5678 18.7158 11.3936 19 11.2006V12.4085C19 12.7165 18.8686 12.9701 18.6778 13.1137C17.1797 14.2413 15.4427 15 12 15C8.55733 15 6.82026 14.2413 5.32215 13.1137C5.13142 12.9701 5 12.7165 5 12.4085V11.2006C5.28422 11.3936 5.58585 11.5678 5.89593 11.7229C7.50977 12.5298 9.66928 13 12 13C14.3307 13 16.4902 12.5298 18.1041 11.7229Z", fill: "currentColor" })
});
P({
  displayName: "DatasetIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M7.25 16.75H10.75V13.25H7.25V16.75ZM13.25 16.75H16.75V13.25H13.25V16.75ZM7.25 10.75H10.75V7.25H7.25V10.75ZM13.25 10.75H16.75V7.25H13.25V10.75ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.3077C3.5 4.80257 3.675 4.375 4.025 4.025C4.375 3.675 4.80257 3.5 5.3077 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80257 20.5 5.3077V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM5.3077 19H18.6923C18.7692 19 18.8397 18.9679 18.9038 18.9038C18.9679 18.8397 19 18.7692 19 18.6923V5.3077C19 5.23077 18.9679 5.16024 18.9038 5.09613C18.8397 5.03203 18.7692 4.99998 18.6923 4.99998H5.3077C5.23077 4.99998 5.16024 5.03203 5.09612 5.09613C5.03202 5.16024 4.99997 5.23077 4.99997 5.3077V18.6923C4.99997 18.7692 5.03202 18.8397 5.09612 18.9038C5.16024 18.9679 5.23077 19 5.3077 19Z", fill: "currentColor" })
});
P({
  displayName: "DeleteIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.76331 2.45234C9.94806 2.17008 10.2627 2 10.6 2H13.4C13.7374 2 14.052 2.17008 14.2367 2.45234L14.8739 3.42584L19 3.42584C19.5523 3.42584 20 3.87356 20 4.42584C20 4.97813 19.5523 5.42584 19 5.42584L14.3542 5.42584C14.3409 5.42611 14.3276 5.42611 14.3143 5.42584L9.68567 5.42584C9.6724 5.42611 9.65912 5.42611 9.64583 5.42584L5 5.42584C4.44772 5.42584 4 4.97813 4 4.42584C4 3.87356 4.44772 3.42584 5 3.42584L9.12611 3.42584L9.76331 2.45234ZM10.6667 10.1299C10.6667 9.5776 10.219 9.12988 9.66669 9.12988C9.1144 9.12988 8.66669 9.5776 8.66669 10.1299L8.66669 17.2595C8.66669 17.8118 9.1144 18.2595 9.66669 18.2595C10.219 18.2595 10.6667 17.8118 10.6667 17.2595L10.6667 10.1299ZM14.3333 9.12988C14.8855 9.12988 15.3333 9.5776 15.3333 10.1299V17.2595C15.3333 17.8118 14.8855 18.2595 14.3333 18.2595C13.781 18.2595 13.3333 17.8118 13.3333 17.2595V10.1299C13.3333 9.5776 13.781 9.12988 14.3333 9.12988ZM4 20.3701C4 21.5668 4.97005 22.5368 6.16667 22.5368H17.8333C19.0299 22.5368 20 21.5668 20 20.3701L20 8.70347C20 8.15119 19.5523 7.70347 19 7.70347C18.4477 7.70347 18 8.15119 18 8.70347L18 20.3701C18 20.4622 17.9254 20.5368 17.8333 20.5368H6.16667C6.07462 20.5368 6 20.4622 6 20.3701L6 8.70347C6 8.15119 5.55229 7.70347 5 7.70347C4.44772 7.70347 4 8.15119 4 8.70347V20.3701Z", fill: "currentColor" })
});
P({
  displayName: "DesktopIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.36686 2.84595C1.61197 2.84595 1 3.45791 1 4.21281V16.3286C1 17.0835 1.61196 17.6955 2.36686 17.6955H11.137V19.1123H7.80602C7.25373 19.1123 6.80602 19.56 6.80602 20.1123C6.80602 20.6646 7.25373 21.1123 7.80602 21.1123H16.4683C17.0205 21.1123 17.4683 20.6646 17.4683 20.1123C17.4683 19.56 17.0205 19.1123 16.4683 19.1123H13.137V17.6955H21.9075C22.6624 17.6955 23.2743 17.0835 23.2743 16.3286V4.21281C23.2743 3.45791 22.6624 2.84595 21.9075 2.84595H2.36686ZM4.14772 4.7849C3.59543 4.7849 3.14772 5.23261 3.14772 5.7849V14.3123C3.14772 14.8646 3.59543 15.3123 4.14772 15.3123H20.3314C20.8837 15.3123 21.3314 14.8646 21.3314 14.3123V5.7849C21.3314 5.23261 20.8837 4.7849 20.3314 4.7849H4.14772Z", fill: "currentColor" })
});
P({
  displayName: "DevelopCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM14.2211 9.20605C14.3349 8.80777 14.1043 8.39266 13.706 8.27887C13.3078 8.16507 12.8926 8.39569 12.7789 8.79397L10.7789 15.794C10.6651 16.1922 10.8957 16.6074 11.294 16.7212C11.6922 16.8349 12.1073 16.6043 12.2211 16.2061L14.2211 9.20605ZM15.9801 9.42384C15.6619 9.15867 15.189 9.20166 14.9238 9.51987C14.6587 9.83808 14.7017 10.311 15.0199 10.5762L17.3285 12.5L15.0199 14.4238C14.7017 14.689 14.6587 15.1619 14.9238 15.4801C15.189 15.7984 15.6619 15.8413 15.9801 15.5762L18.9801 13.0762L19.6715 12.5L18.9801 11.9238L15.9801 9.42384ZM10.0762 9.51987C9.81099 9.20166 9.33807 9.15867 9.01986 9.42384L6.01986 11.9238L5.32846 12.5L6.01986 13.0762L9.01986 15.5762C9.33807 15.8413 9.81099 15.7984 10.0762 15.4801C10.3413 15.1619 10.2983 14.689 9.98014 14.4238L7.67154 12.5L9.98014 10.5762C10.2983 10.311 10.3413 9.83808 10.0762 9.51987Z", fill: "currentColor" })
});
P({
  displayName: "DeveloperIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.9873 17.7V22H14.9492V20H17.4386C17.8535 20 18.2062 19.8542 18.4966 19.5625C18.7871 19.2708 18.9323 18.9167 18.9323 18.5V15H21.2474C21.4964 15 21.6955 14.9042 21.8449 14.7125C21.9943 14.5208 22.0357 14.3083 21.9694 14.075L20.6002 8.625C20.1189 6.65833 19.0775 5.0625 17.476 3.8375C15.8744 2.6125 14.0364 2 11.9619 2C9.47248 2 7.35648 2.875 5.61389 4.625C3.87129 6.375 3 8.5 3 11C3 12.2833 3.26139 13.5042 3.78417 14.6625C4.30695 15.8208 5.04132 16.8333 5.9873 17.7ZM6.59998 9.99999L10.0125 13.4L11.0625 12.35L8.69998 9.98749L11.0625 7.62499L10.0125 6.58749L6.59998 9.99999ZM12.9375 12.375L13.9875 13.4125L17.4 9.99999L13.9875 6.59999L12.9375 7.64999L15.3 10.0125L12.9375 12.375Z", fill: "currentColor" })
});
P({
  displayName: "DifferenceIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M 7.410156 14.984375 L 8.894531 14.984375 L 8.894531 11.183594 L 7.410156 11.183594 L 7.410156 12.351562 L 5.972656 12.351562 L 5.972656 13.820312 L 7.410156 13.820312 Z M 10.332031 13.820312 L 18.003906 13.820312 L 18.003906 12.351562 L 10.332031 12.351562 Z M 15.082031 10.71875 L 16.566406 10.71875 L 16.566406 9.550781 L 18.003906 9.550781 L 18.003906 8.058594 L 16.566406 8.058594 L 16.566406 6.894531 L 15.082031 6.894531 Z M 5.972656 9.550781 L 13.640625 9.550781 L 13.640625 8.058594 L 5.972656 8.058594 Z M 8.082031 21 L 8.082031 18.878906 L 4.054688 18.878906 C 3.429688 18.878906 2.898438 18.660156 2.460938 18.226562 C 2.019531 17.789062 1.800781 17.269531 1.800781 16.664062 L 1.800781 5.214844 C 1.800781 4.609375 2.019531 4.089844 2.460938 3.652344 C 2.898438 3.21875 3.429688 3 4.054688 3 L 19.921875 3 C 20.546875 3 21.082031 3.21875 21.527344 3.652344 C 21.976562 4.089844 22.199219 4.609375 22.199219 5.214844 L 22.199219 16.664062 C 22.199219 17.269531 21.976562 17.789062 21.527344 18.226562 C 21.082031 18.660156 20.546875 18.878906 19.921875 18.878906 L 15.917969 18.878906 L 15.917969 21 Z M 8.082031 21", fill: "currentColor" })
});
P({
  displayName: "DisconnectIcon",
  viewBox: "0 0 16 16",
  path: w.createElement(
    "svg",
    { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    w.createElement(
      "g",
      { id: "disconnect" },
      w.createElement("path", { id: "link_off", d: "M12.8753 10.6069L12.1189 9.82999C12.5676 9.70777 12.9298 9.46738 13.2054 9.10883C13.481 8.75028 13.6189 8.3367 13.6189 7.86808C13.6189 7.3102 13.4223 6.83361 13.0291 6.43831C12.6359 6.04301 12.1616 5.84536 11.606 5.84536H9.56757C9.4259 5.84536 9.30715 5.79743 9.21132 5.70156C9.11549 5.60568 9.06758 5.48688 9.06758 5.34516C9.06758 5.20342 9.11549 5.0847 9.21132 4.98898C9.30715 4.89325 9.4259 4.84539 9.56757 4.84539H11.606C12.4396 4.84539 13.1501 5.14039 13.7376 5.73038C14.3251 6.32038 14.6188 7.03392 14.6188 7.87101C14.6188 8.46161 14.4603 9.00114 14.1432 9.48959C13.8261 9.97805 13.4035 10.3505 12.8753 10.6069ZM10.5676 8.26588L9.6727 7.37103H10.2727C10.4144 7.37103 10.5331 7.41919 10.6289 7.51551C10.7248 7.61183 10.7727 7.73119 10.7727 7.87358C10.7727 7.95733 10.7545 8.03307 10.718 8.10079C10.6815 8.16851 10.6314 8.22354 10.5676 8.26588ZM14.0676 14.3556C13.971 14.4522 13.8539 14.5005 13.7163 14.5005C13.5787 14.5005 13.4616 14.4522 13.365 14.3556L1.80092 2.79151C1.70861 2.69921 1.66138 2.58319 1.65925 2.44344C1.65711 2.30371 1.70433 2.18555 1.80092 2.08896C1.89749 1.99238 2.01458 1.94409 2.15218 1.94409C2.28978 1.94409 2.40687 1.99238 2.50345 2.08896L14.0676 13.6531C14.1599 13.7454 14.2071 13.8614 14.2092 14.0012C14.2114 14.1409 14.1642 14.259 14.0676 14.3556ZM4.97783 10.8966C4.14074 10.8966 3.4272 10.6016 2.8372 10.0116C2.2472 9.42164 1.9522 8.7081 1.9522 7.87101C1.9522 7.12999 2.19088 6.47977 2.66823 5.92037C3.14559 5.36098 3.74452 5.02316 4.46503 4.90693H4.61888L5.55733 5.84536H4.97783C4.418 5.84536 3.94043 6.04301 3.54513 6.43831C3.14983 6.83361 2.95218 7.31118 2.95218 7.87101C2.95218 8.43084 3.14983 8.90841 3.54513 9.30371C3.94043 9.69901 4.41901 9.89666 4.98085 9.89666H7.00347C7.14513 9.89666 7.26388 9.94459 7.35972 10.0405C7.45554 10.1363 7.50345 10.2551 7.50345 10.3969C7.50345 10.5386 7.45554 10.6573 7.35972 10.753C7.26388 10.8488 7.14513 10.8966 7.00347 10.8966H4.97783ZM6.29833 8.37099C6.15668 8.37099 6.03793 8.32306 5.9421 8.22719C5.84627 8.13131 5.79835 8.01251 5.79835 7.87079C5.79835 7.72906 5.84627 7.61033 5.9421 7.51461C6.03793 7.41889 6.15668 7.37103 6.29833 7.37103H7.09323L8.07655 8.37099H6.29833Z", fill: "currentColor" })
    )
  )
});
P({
  displayName: "DislikeIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M3.7173 15.2481C3.26543 15.2481 2.86624 15.0772 2.51975 14.7353C2.17325 14.3934 2 13.9995 2 13.5537V12.0395C2 11.9412 2.01279 11.8357 2.03836 11.7233C2.06393 11.6109 2.09255 11.506 2.12421 11.4086L4.84676 5.06968C4.98289 4.76996 5.21111 4.51675 5.53142 4.31005C5.85175 4.10335 6.18598 4 6.53411 4H16.524V15.2481L10.9976 20.6541C10.8088 20.8403 10.5902 20.9515 10.3417 20.9875C10.0933 21.0236 9.85516 20.9815 9.62741 20.8614C9.39966 20.7412 9.23281 20.5705 9.12686 20.3494C9.02088 20.1283 8.99835 19.8994 9.05926 19.6627L10.0823 15.2481H3.7173ZM15.0991 14.6497V5.406H6.53076C6.46377 5.406 6.39525 5.42403 6.32522 5.46008C6.25518 5.49614 6.20188 5.55623 6.16534 5.64036L3.42496 11.9674V13.5537C3.42496 13.6378 3.45237 13.7069 3.50718 13.761C3.562 13.8151 3.63204 13.8421 3.7173 13.8421H11.8836L10.6925 18.9795L15.0991 14.6497ZM19.2827 4C19.7549 4 20.1592 4.16592 20.4955 4.49776C20.8318 4.82958 21 5.22847 21 5.69444V13.5537C21 14.0196 20.8318 14.4185 20.4955 14.7504C20.1592 15.0822 19.7549 15.2481 19.2827 15.2481H16.524V13.8421H19.2827C19.3679 13.8421 19.438 13.8151 19.4928 13.761C19.5476 13.7069 19.575 13.6378 19.575 13.5537V5.69444C19.575 5.61032 19.5476 5.54121 19.4928 5.48712C19.438 5.43304 19.3679 5.406 19.2827 5.406H16.524V4H19.2827Z", fill: "currentColor" })
});
P({
  displayName: "DocumentIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M7.25 16.75H13.75V15.25H7.25V16.75ZM7.25 12.75H16.75V11.25H7.25V12.75ZM7.25 8.74995H16.75V7.25H7.25V8.74995ZM5.3077 20.5C4.80257 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.3077C3.5 4.80257 3.675 4.375 4.025 4.025C4.375 3.675 4.80257 3.5 5.3077 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80257 20.5 5.3077V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.3077ZM5.3077 19H18.6923C18.7692 19 18.8397 18.9679 18.9038 18.9038C18.9679 18.8397 19 18.7692 19 18.6923V5.3077C19 5.23077 18.9679 5.16024 18.9038 5.09613C18.8397 5.03203 18.7692 4.99997 18.6923 4.99997H5.3077C5.23077 4.99997 5.16024 5.03203 5.09612 5.09613C5.03202 5.16024 4.99997 5.23077 4.99997 5.3077V18.6923C4.99997 18.7692 5.03202 18.8397 5.09612 18.9038C5.16024 18.9679 5.23077 19 5.3077 19Z", fill: "currentColor" })
});
P({
  displayName: "DocumentationIcon",
  viewBox: "0 0 40 40",
  path: w.createElement("path", { d: "M11.6663 5C9.82539 5 8.33301 6.49238 8.33301 8.33333V31.6667C8.33301 33.5076 9.82539 35 11.6663 35H28.333C30.174 35 31.6663 33.5076 31.6663 31.6667V8.33333C31.6663 6.49238 30.174 5 28.333 5H11.6663ZM13.333 10.4167C12.6427 10.4167 12.083 10.9763 12.083 11.6667C12.083 12.357 12.6427 12.9167 13.333 12.9167H26.6663C27.3567 12.9167 27.9163 12.357 27.9163 11.6667C27.9163 10.9763 27.3567 10.4167 26.6663 10.4167H13.333ZM12.083 18.3333C12.083 17.643 12.6427 17.0833 13.333 17.0833H26.6663C27.3567 17.0833 27.9163 17.643 27.9163 18.3333C27.9163 19.0237 27.3567 19.5833 26.6663 19.5833H13.333C12.6427 19.5833 12.083 19.0237 12.083 18.3333ZM13.333 23.75C12.6427 23.75 12.083 24.3096 12.083 25C12.083 25.6904 12.6427 26.25 13.333 26.25H21.6663C22.3567 26.25 22.9163 25.6904 22.9163 25C22.9163 24.3096 22.3567 23.75 21.6663 23.75H13.333Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" })
});
P({
  displayName: "DocumentMoneyIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M5.5 22C5.1 22 4.75 21.85 4.45 21.55C4.15 21.25 4 20.9 4 20.5V3.5C4 3.1 4.15 2.75 4.45 2.45C4.75 2.15 5.1 2 5.5 2H14.525L20 7.475V20.5C20 20.9 19.85 21.25 19.55 21.55C19.25 21.85 18.9 22 18.5 22H5.5ZM11.25 18.975H12.75V17.975H14.25C14.4667 17.975 14.6458 17.9042 14.7875 17.7625C14.9292 17.6208 15 17.4417 15 17.225V13.975C15 13.7583 14.9292 13.5792 14.7875 13.4375C14.6458 13.2958 14.4667 13.225 14.25 13.225H10.5V11.475H15V9.975H12.75V8.975H11.25V9.975H9.75C9.53333 9.975 9.35417 10.0458 9.2125 10.1875C9.07083 10.3292 9 10.5083 9 10.725V13.975C9 14.1917 9.07083 14.3708 9.2125 14.5125C9.35417 14.6542 9.53333 14.725 9.75 14.725H13.5V16.475H9V17.975H11.25V18.975ZM13.9 7.475H17.875L13.9 3.5V7.475Z", fill: "currentColor" })
});
P({
  displayName: "DoubleArrowDownIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12.5 16.5116L16.573 12.4538C16.7115 12.3155 16.883 12.2422 17.0875 12.2338C17.292 12.2255 17.4718 12.2988 17.627 12.4538C17.7718 12.5988 17.8442 12.7745 17.8442 12.9808C17.8442 13.1872 17.7718 13.3628 17.627 13.5078L13.1327 18.0021C13.0391 18.0956 12.9403 18.1616 12.8365 18.2001C12.7326 18.2386 12.6205 18.2578 12.5 18.2578C12.3795 18.2578 12.2673 18.2386 12.1635 18.2001C12.0596 18.1616 11.9609 18.0956 11.8672 18.0021L7.37298 13.5078C7.23465 13.3693 7.16131 13.1978 7.15298 12.9933C7.14465 12.7888 7.21798 12.609 7.37298 12.4538C7.51798 12.309 7.69365 12.2366 7.89998 12.2366C8.10632 12.2366 8.28198 12.309 8.42698 12.4538L12.5 16.5116ZM12.5 10.5308L16.573 6.47308C16.7115 6.33475 16.883 6.26141 17.0875 6.25308C17.292 6.24475 17.4718 6.31808 17.627 6.47308C17.7718 6.61808 17.8442 6.79375 17.8442 7.00008C17.8442 7.20641 17.7718 7.38208 17.627 7.52708L13.1327 12.0213C13.0391 12.1148 12.9403 12.1808 12.8365 12.2193C12.7326 12.2578 12.6205 12.2771 12.5 12.2771C12.3795 12.2771 12.2673 12.2578 12.1635 12.2193C12.0596 12.1808 11.9609 12.1148 11.8672 12.0213L7.37298 7.52708C7.23465 7.38858 7.16131 7.21708 7.15298 7.01258C7.14465 6.80808 7.21798 6.62825 7.37298 6.47308C7.51798 6.32825 7.69365 6.25583 7.89998 6.25583C8.10632 6.25583 8.28198 6.32825 8.42698 6.47308L12.5 10.5308Z", fill: "currentColor" })
});
P({
  displayName: "EarthIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M22 11.99C22 6.47552 17.5199 2 12 2C6.47996 2 2 6.47552 2 11.99C2 17.0849 5.82 21.2807 10.76 21.9002C11.04 21.96 11.38 22 11.78 22C11.9 22 12 22 12.1 21.9801C17.58 21.9002 22 17.4645 22 11.99ZM20.58 12.1298C20.56 11.6304 20.48 11.1509 20.38 10.6713C20.38 10.5115 20.3999 10.3516 20.38 10.1918C20.5 10.7712 20.56 11.3706 20.56 11.99C20.58 12.03 20.58 12.07 20.58 12.1298ZM3.42 11.99C3.42 11.3907 3.48 10.7913 3.59996 10.2318C3.98 10.6313 4.84004 10.6114 5.05996 10.032C5.44 10.2518 5.96 10.2917 5.96 10.7512C5.96 12.2497 6.02004 13.8482 7.38 13.8681C7.42 13.8681 8.14 14.1478 8.48 15.027C8.6 15.3266 9.06004 15.027 9.58 15.027C9.83996 15.027 9.58 15.4666 9.58 16.3856C9.58 17.3247 11.58 18.7433 11.58 18.7433C11.58 19.3626 11.6 19.8622 11.64 20.2618C11.18 20.2618 10.8 20.3217 10.5 20.4216C6.47996 19.7023 3.42 16.2058 3.42 11.99ZM14.12 20.2818C14.0799 20.062 13.88 19.9421 13.52 20.042C13.8 18.8432 13.94 18.1639 14.54 17.6444C15.4 16.9051 14.64 16.086 14 16.1858C13.48 16.2658 13.82 15.5465 13.36 15.5066C12.9 15.4666 12.3 14.5675 11.64 14.2478C11.3 14.088 10.94 13.6284 10.4 13.6284C9.91996 13.6085 9.22004 14.028 9.22004 13.7083C9.22004 12.6694 9.12 11.9102 9.10004 11.6104C9.08004 11.3706 8.94 11.5305 9.58004 11.5505C9.94004 11.5505 9.76 10.8512 10.1 10.8113C10.44 10.7913 11.26 11.131 11.46 10.9911C11.66 10.8712 12.88 14.1878 12.88 11.5505C12.88 11.2309 12.72 10.6914 12.88 10.3916C13.52 9.21288 14.14 8.2538 14.08 8.114C14.04 8.03408 13.42 7.97408 12.92 8.13392C12.7401 8.19392 12.98 8.4536 12.72 8.51356C11.8 8.73328 11 8.2738 11.28 7.83428C11.5601 7.39476 12.62 7.63448 12.72 6.75528C12.7801 6.25584 12.82 5.65648 12.84 5.21684C14.08 5.41664 13.94 3.61848 12.1 3.41868C15.8 3.45856 18.9399 5.85616 20.1 9.17288C20.04 9.11288 19.98 9.09296 19.9 9.07292C19.3399 7.69428 18 8.69328 18.46 9.91208C16.0199 11.7903 16.64 13.089 17.44 13.8482C17.86 14.2478 18.26 14.8272 18.52 15.2668C18.24 16.1059 19.58 15.7662 20.24 14.3477C19.4 17.2647 17.06 19.5224 14.12 20.2818Z", fill: "currentColor" })
});
P({
  displayName: "EarthSearchIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.7297 21.4899C10.4528 21.454 9.25225 21.1812 8.12812 20.6716C7.00397 20.162 6.02673 19.4813 5.19639 18.6296C4.36606 17.7779 3.70912 16.7821 3.22557 15.6421C2.74202 14.5022 2.50024 13.2882 2.50024 12.0002C2.50024 10.6874 2.74993 9.45306 3.24929 8.2973C3.74864 7.14153 4.42589 6.13609 5.28102 5.28097C6.13614 4.42584 7.14158 3.7486 8.29734 3.24925C9.45311 2.74988 10.6874 2.5002 12.0002 2.5002C14.4071 2.5002 16.4921 3.27552 18.2553 4.82617C20.0186 6.3768 21.0649 8.31045 21.3944 10.6271H20.1175C19.8893 9.20704 19.3329 7.93428 18.4483 6.80885C17.5637 5.68341 16.4425 4.84719 15.0848 4.30017V4.74632C15.0848 5.31427 14.8873 5.80369 14.4922 6.2146C14.0971 6.62549 13.6156 6.83095 13.0476 6.83095H10.963V8.91554C10.963 9.19888 10.8593 9.43467 10.6518 9.62292C10.4443 9.81117 10.1989 9.90529 9.91559 9.90529H7.87842V12.0002H10.1669V15.0579H8.91559L3.96689 10.1155C3.90321 10.4292 3.85224 10.7423 3.81399 11.0546C3.77574 11.367 3.75662 11.6822 3.75662 12.0002C3.75662 14.2151 4.51987 16.1228 6.04637 17.7232C7.57287 19.3237 9.46731 20.1604 11.7297 20.2335V21.4899ZM20.6938 20.5784L17.7367 17.6508C17.4124 17.882 17.0603 18.061 16.6803 18.1879C16.3004 18.3149 15.9071 18.3783 15.5002 18.3783C14.4207 18.3783 13.5045 18.0019 12.7515 17.2489C11.9985 16.4959 11.622 15.5797 11.622 14.5002C11.622 13.4207 11.9985 12.5045 12.7515 11.7515C13.5045 10.9985 14.4207 10.622 15.5002 10.622C16.5797 10.622 17.4959 10.9985 18.2489 11.7515C19.0019 12.5045 19.3784 13.4207 19.3784 14.5002C19.3784 14.9134 19.3116 15.3116 19.1781 15.6947C19.0445 16.0778 18.8624 16.435 18.6316 16.7662L21.5784 19.6938C21.7053 19.8143 21.7705 19.9601 21.7739 20.1312C21.7773 20.3024 21.7156 20.4549 21.5887 20.5886C21.4682 20.7091 21.3206 20.7677 21.146 20.7642C20.9715 20.7608 20.8207 20.6989 20.6938 20.5784ZM15.5002 17.122C16.2318 17.122 16.8517 16.8679 17.3598 16.3598C17.868 15.8517 18.122 15.2318 18.122 14.5002C18.122 13.7686 17.868 13.1487 17.3598 12.6405C16.8517 12.1324 16.2318 11.8784 15.5002 11.8784C14.7686 11.8784 14.1487 12.1324 13.6406 12.6405C13.1325 13.1487 12.8784 13.7686 12.8784 14.5002C12.8784 15.2318 13.1325 15.8517 13.6406 16.3598C14.1487 16.8679 14.7686 17.122 15.5002 17.122Z", fill: "currentColor" })
});
P({
  displayName: "EcosystemIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M 7.078125 21 C 6.441406 21 5.898438 20.785156 5.460938 20.355469 C 5.019531 19.925781 4.800781 19.394531 4.800781 18.769531 C 4.800781 18.144531 5.019531 17.613281 5.460938 17.183594 C 5.898438 16.753906 6.441406 16.539062 7.078125 16.539062 C 7.265625 16.539062 7.429688 16.554688 7.570312 16.589844 C 7.710938 16.621094 7.851562 16.667969 8 16.734375 L 9.699219 14.660156 C 9.445312 14.359375 9.253906 14.019531 9.121094 13.632812 C 8.988281 13.25 8.953125 12.847656 9.019531 12.429688 L 6.601562 11.628906 C 6.398438 11.953125 6.136719 12.207031 5.808594 12.390625 C 5.484375 12.574219 5.105469 12.664062 4.679688 12.664062 C 4.039062 12.664062 3.5 12.449219 3.058594 12.019531 C 2.621094 11.589844 2.398438 11.0625 2.398438 10.433594 C 2.398438 9.808594 2.621094 9.28125 3.058594 8.851562 C 3.5 8.417969 4.039062 8.203125 4.679688 8.203125 C 5.320312 8.203125 5.859375 8.417969 6.300781 8.851562 C 6.738281 9.28125 6.960938 9.808594 6.960938 10.433594 L 6.960938 10.511719 L 9.398438 11.335938 C 9.640625 10.917969 9.929688 10.597656 10.269531 10.375 C 10.609375 10.15625 10.988281 9.996094 11.398438 9.90625 L 11.398438 7.382812 C 10.878906 7.238281 10.46875 6.957031 10.171875 6.542969 C 9.871094 6.125 9.71875 5.6875 9.71875 5.230469 C 9.71875 4.605469 9.941406 4.074219 10.378906 3.644531 C 10.820312 3.214844 11.359375 3 12 3 C 12.640625 3 13.179688 3.214844 13.621094 3.644531 C 14.058594 4.074219 14.28125 4.605469 14.28125 5.230469 C 14.28125 5.6875 14.125 6.125 13.820312 6.542969 C 13.511719 6.957031 13.105469 7.238281 12.601562 7.382812 L 12.601562 9.90625 C 13.011719 9.996094 13.394531 10.15625 13.738281 10.375 C 14.085938 10.597656 14.378906 10.917969 14.621094 11.335938 L 17.039062 10.511719 L 17.039062 10.433594 C 17.039062 9.808594 17.261719 9.28125 17.699219 8.851562 C 18.140625 8.417969 18.679688 8.203125 19.320312 8.203125 C 19.960938 8.203125 20.5 8.417969 20.941406 8.851562 C 21.378906 9.28125 21.601562 9.808594 21.601562 10.433594 C 21.601562 11.0625 21.378906 11.589844 20.941406 12.019531 C 20.5 12.449219 19.960938 12.664062 19.320312 12.664062 C 18.894531 12.664062 18.511719 12.574219 18.179688 12.390625 C 17.847656 12.207031 17.585938 11.953125 17.398438 11.628906 L 14.980469 12.429688 C 15.046875 12.847656 15.015625 13.25 14.890625 13.632812 C 14.761719 14.019531 14.566406 14.359375 14.300781 14.660156 L 16 16.734375 C 16.148438 16.667969 16.289062 16.621094 16.429688 16.589844 C 16.570312 16.554688 16.734375 16.539062 16.921875 16.539062 C 17.558594 16.539062 18.101562 16.753906 18.539062 17.183594 C 18.980469 17.613281 19.199219 18.144531 19.199219 18.769531 C 19.199219 19.394531 18.980469 19.925781 18.539062 20.355469 C 18.101562 20.785156 17.558594 21 16.921875 21 C 16.28125 21 15.738281 20.785156 15.300781 20.355469 C 14.859375 19.925781 14.640625 19.394531 14.640625 18.769531 C 14.640625 18.507812 14.675781 18.273438 14.75 18.066406 C 14.824219 17.855469 14.925781 17.65625 15.058594 17.457031 L 13.359375 15.386719 C 12.933594 15.605469 12.476562 15.71875 11.988281 15.71875 C 11.503906 15.71875 11.046875 15.605469 10.621094 15.386719 L 8.941406 17.476562 C 9.074219 17.675781 9.175781 17.871094 9.25 18.074219 C 9.324219 18.277344 9.359375 18.507812 9.359375 18.769531 C 9.359375 19.394531 9.140625 19.925781 8.699219 20.355469 C 8.261719 20.785156 7.71875 21 7.078125 21 Z M 7.078125 21", fill: "currentColor" })
});
P({
  displayName: "EditIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.77833 13.2975L15.8571 5.21874L17.0143 6.37595L8.93554 14.4548L7.48902 14.7441L7.77833 13.2975ZM16.837 3.37016C16.2958 2.82901 15.4184 2.82901 14.8773 3.37016L6.28765 11.9598C6.05831 12.1891 5.90198 12.4812 5.83837 12.7993L4.93951 17.2936L9.43381 16.3947C9.75185 16.3311 10.044 16.1748 10.2733 15.9454L18.8629 7.3558C19.4041 6.81465 19.4041 5.93726 18.8629 5.39611L16.837 3.37016ZM4.28571 18.5902C3.57563 18.5902 3 19.1658 3 19.8759V20.5188H21V19.8759C21 19.1658 20.4244 18.5902 19.7143 18.5902H4.28571Z", fill: "currentColor" })
});
P({
  displayName: "EllipsisIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("circle", { cx: "6", cy: "12", r: "1.5", fill: "currentColor" }),
    w.createElement("circle", { cx: "12", cy: "12", r: "1.5", fill: "currentColor" }),
    w.createElement("circle", { cx: "18", cy: "12", r: "1.5", fill: "currentColor" })
  )
});
P({
  displayName: "EmailIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.16956 20.4804C3.43114 20.4804 2.80486 20.2234 2.29073 19.7092C1.7766 19.1951 1.51953 18.5688 1.51953 17.8304V6.16956C1.51953 5.43114 1.7766 4.80486 2.29073 4.29073C2.80486 3.7766 3.43114 3.51953 4.16956 3.51953H19.8304C20.5688 3.51953 21.1951 3.7766 21.7092 4.29073C22.2234 4.80486 22.4804 5.43114 22.4804 6.16956V17.8304C22.4804 18.5688 22.2234 19.1951 21.7092 19.7092C21.1951 20.2234 20.5688 20.4804 19.8304 20.4804H4.16956ZM12 13.6076L19.8304 8.60763V6.16956L12 11.1696L4.16956 6.16956V8.60763L12 13.6076Z", fill: "currentColor" })
});
P({
  displayName: "EncryptedIcon",
  viewBox: "0 0 32 32",
  path: w.createElement("path", { d: "M15.5436 19.6667H17.4564C17.6371 19.6667 17.7938 19.5914 17.9265 19.4407C18.0592 19.2901 18.1034 19.1244 18.0589 18.9436L17.4256 15.4564C17.8444 15.277 18.1816 14.9947 18.4371 14.6098C18.6927 14.2248 18.8205 13.7994 18.8205 13.3334C18.8205 12.6952 18.5931 12.149 18.1384 11.6945C17.6838 11.2401 17.1372 11.0129 16.4987 11.0129C15.8602 11.0129 15.3141 11.2401 14.8602 11.6945C14.4064 12.149 14.1795 12.6952 14.1795 13.3334C14.1795 13.7994 14.3072 14.2248 14.5628 14.6098C14.8184 14.9947 15.1555 15.277 15.5743 15.4564L14.941 18.9436C14.8966 19.1244 14.9407 19.2901 15.0734 19.4407C15.2061 19.5914 15.3628 19.6667 15.5436 19.6667ZM16.5 28.4949C16.3615 28.4949 16.2256 28.4838 16.0923 28.4615C15.9589 28.4393 15.8298 28.406 15.7048 28.3615C12.8931 27.3615 10.656 25.5885 8.9936 23.0423C7.3312 20.4962 6.5 17.7488 6.5 14.8V8.79495C6.5 8.28848 6.64562 7.83266 6.93687 7.42748C7.22811 7.0223 7.60471 6.72856 8.06667 6.54625L15.6564 3.71292C15.9419 3.61036 16.2231 3.55908 16.5 3.55908C16.7769 3.55908 17.0581 3.61036 17.3435 3.71292L24.9333 6.54625C25.3952 6.72856 25.7718 7.0223 26.0631 7.42748C26.3543 7.83266 26.4999 8.28848 26.4999 8.79495V14.8C26.4999 17.7488 25.6687 20.4962 24.0063 23.0423C22.344 25.5885 20.1069 27.3615 17.2951 28.3615C17.1701 28.406 17.041 28.4393 16.9077 28.4615C16.7743 28.4838 16.6384 28.4949 16.5 28.4949ZM16.5 26.5334C18.8111 25.8001 20.7222 24.3334 22.2333 22.1334C23.7444 19.9334 24.5 17.4889 24.5 14.8V8.78211C24.5 8.69665 24.4765 8.61973 24.4294 8.55135C24.3824 8.48295 24.3162 8.43166 24.2307 8.39748L16.641 5.56415C16.5983 5.54706 16.5513 5.53852 16.5 5.53852C16.4487 5.53852 16.4017 5.54706 16.3589 5.56415L8.76923 8.39748C8.68374 8.43166 8.6175 8.48295 8.5705 8.55135C8.52348 8.61973 8.49997 8.69665 8.49997 8.78211V14.8C8.49997 17.4889 9.25552 19.9334 10.7666 22.1334C12.2777 24.3334 14.1889 25.8001 16.5 26.5334Z", fill: "currentColor" })
});
P({
  displayName: "EventIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M5.30773 22.0001C4.8026 22.0001 4.37503 21.8251 4.02503 21.4751C3.67503 21.1251 3.50003 20.6975 3.50003 20.1924V6.80784C3.50003 6.30271 3.67503 5.87514 4.02503 5.52514C4.37503 5.17514 4.8026 5.00014 5.30773 5.00014H6.69236V3.65397C6.69236 3.43475 6.76576 3.25174 6.91256 3.10494C7.05934 2.95816 7.24235 2.88477 7.46158 2.88477C7.6808 2.88477 7.86381 2.95816 8.01061 3.10494C8.15739 3.25174 8.23078 3.43475 8.23078 3.65397V5.00014H15.8077V3.63474C15.8077 3.42192 15.8795 3.24372 16.0231 3.10014C16.1666 2.95656 16.3448 2.88477 16.5577 2.88477C16.7705 2.88477 16.9487 2.95656 17.0923 3.10014C17.2359 3.24372 17.3077 3.42192 17.3077 3.63474V5.00014H18.6923C19.1974 5.00014 19.625 5.17514 19.975 5.52514C20.325 5.87514 20.5 6.30271 20.5 6.80784V20.1924C20.5 20.6975 20.325 21.1251 19.975 21.4751C19.625 21.8251 19.1974 22.0001 18.6923 22.0001H5.30773ZM5.30773 20.5001H18.6923C18.7692 20.5001 18.8397 20.4681 18.9039 20.404C18.968 20.3398 19 20.2693 19 20.1924V10.8078H5.00001V20.1924C5.00001 20.2693 5.03206 20.3398 5.09616 20.404C5.16027 20.4681 5.2308 20.5001 5.30773 20.5001ZM5.00001 9.30787H19V6.80784C19 6.73091 18.968 6.66038 18.9039 6.59627C18.8397 6.53217 18.7692 6.50012 18.6923 6.50012H5.30773C5.2308 6.50012 5.16027 6.53217 5.09616 6.59627C5.03206 6.66038 5.00001 6.73091 5.00001 6.80784V9.30787ZM12 14.577C11.7551 14.577 11.5465 14.4908 11.3741 14.3184C11.2016 14.146 11.1154 13.9373 11.1154 13.6924C11.1154 13.4476 11.2016 13.2389 11.3741 13.0665C11.5465 12.8941 11.7551 12.8078 12 12.8078C12.2449 12.8078 12.4535 12.8941 12.626 13.0665C12.7984 13.2389 12.8846 13.4476 12.8846 13.6924C12.8846 13.9373 12.7984 14.146 12.626 14.3184C12.4535 14.4908 12.2449 14.577 12 14.577ZM8.00001 14.577C7.75514 14.577 7.54649 14.4908 7.37406 14.3184C7.20162 14.146 7.11541 13.9373 7.11541 13.6924C7.11541 13.4476 7.20162 13.2389 7.37406 13.0665C7.54649 12.8941 7.75514 12.8078 8.00001 12.8078C8.24487 12.8078 8.45352 12.8941 8.62596 13.0665C8.79839 13.2389 8.88461 13.4476 8.88461 13.6924C8.88461 13.9373 8.79839 14.146 8.62596 14.3184C8.45352 14.4908 8.24487 14.577 8.00001 14.577ZM16 14.577C15.7551 14.577 15.5465 14.4908 15.3741 14.3184C15.2016 14.146 15.1154 13.9373 15.1154 13.6924C15.1154 13.4476 15.2016 13.2389 15.3741 13.0665C15.5465 12.8941 15.7551 12.8078 16 12.8078C16.2449 12.8078 16.4535 12.8941 16.626 13.0665C16.7984 13.2389 16.8846 13.4476 16.8846 13.6924C16.8846 13.9373 16.7984 14.146 16.626 14.3184C16.4535 14.4908 16.2449 14.577 16 14.577ZM12 18.5001C11.7551 18.5001 11.5465 18.4139 11.3741 18.2415C11.2016 18.069 11.1154 17.8604 11.1154 17.6155C11.1154 17.3706 11.2016 17.162 11.3741 16.9896C11.5465 16.8171 11.7551 16.7309 12 16.7309C12.2449 16.7309 12.4535 16.8171 12.626 16.9896C12.7984 17.162 12.8846 17.3706 12.8846 17.6155C12.8846 17.8604 12.7984 18.069 12.626 18.2415C12.4535 18.4139 12.2449 18.5001 12 18.5001ZM8.00001 18.5001C7.75514 18.5001 7.54649 18.4139 7.37406 18.2415C7.20162 18.069 7.11541 17.8604 7.11541 17.6155C7.11541 17.3706 7.20162 17.162 7.37406 16.9896C7.54649 16.8171 7.75514 16.7309 8.00001 16.7309C8.24487 16.7309 8.45352 16.8171 8.62596 16.9896C8.79839 17.162 8.88461 17.3706 8.88461 17.6155C8.88461 17.8604 8.79839 18.069 8.62596 18.2415C8.45352 18.4139 8.24487 18.5001 8.00001 18.5001ZM16 18.5001C15.7551 18.5001 15.5465 18.4139 15.3741 18.2415C15.2016 18.069 15.1154 17.8604 15.1154 17.6155C15.1154 17.3706 15.2016 17.162 15.3741 16.9896C15.5465 16.8171 15.7551 16.7309 16 16.7309C16.2449 16.7309 16.4535 16.8171 16.626 16.9896C16.7984 17.162 16.8846 17.3706 16.8846 17.6155C16.8846 17.8604 16.7984 18.069 16.626 18.2415C16.4535 18.4139 16.2449 18.5001 16 18.5001Z", fill: "currentColor" })
});
P({
  displayName: "ExchangeIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12.15 16.3423C12.7192 16.3423 13.2301 16.2003 13.6827 15.9163C14.1353 15.6324 14.3616 15.1769 14.3616 14.55C14.3616 14.0282 14.167 13.6125 13.7779 13.3029C13.3888 12.9932 12.6629 12.6436 11.6 12.2538C10.5718 11.8846 9.83016 11.4711 9.37504 11.0134C8.91991 10.5557 8.69234 9.95126 8.69234 9.19998C8.69234 8.55511 8.92503 7.96473 9.39042 7.42883C9.8558 6.89293 10.5064 6.55126 11.3423 6.40383V5.87498C11.3423 5.69293 11.4106 5.53363 11.5471 5.3971C11.6837 5.26057 11.843 5.1923 12.025 5.1923C12.2071 5.1923 12.3664 5.26057 12.5029 5.3971C12.6394 5.53363 12.7077 5.69293 12.7077 5.87498V6.40383C13.1782 6.43716 13.616 6.59004 14.0212 6.86248C14.4263 7.13491 14.757 7.47305 15.0135 7.8769C15.1045 8.01537 15.1128 8.16312 15.0385 8.32015C14.9641 8.4772 14.8391 8.58778 14.6635 8.65188C14.4981 8.71598 14.3311 8.72431 14.1625 8.67688C13.9939 8.62944 13.8558 8.53329 13.7481 8.38843C13.5558 8.15638 13.3202 7.96823 13.0414 7.824C12.7625 7.67977 12.4321 7.60765 12.05 7.60765C11.4282 7.60765 10.9407 7.75509 10.5875 8.04998C10.2343 8.34484 10.0577 8.72818 10.0577 9.19998C10.0577 9.67178 10.2301 10.0391 10.575 10.3019C10.9199 10.5647 11.6179 10.8756 12.6692 11.2346C13.8692 11.6679 14.6756 12.1538 15.0885 12.6923C15.5013 13.2308 15.7077 13.85 15.7077 14.55C15.7077 15.0269 15.6195 15.4455 15.4433 15.8058C15.267 16.166 15.0365 16.4689 14.7519 16.7144C14.4673 16.9599 14.1433 17.1538 13.7798 17.2961C13.4163 17.4384 13.0423 17.5384 12.6577 17.5961V18.125C12.6577 18.307 12.5894 18.4663 12.4529 18.6029C12.3164 18.7394 12.1571 18.8077 11.975 18.8077C11.793 18.8077 11.6337 18.7394 11.4971 18.6029C11.3606 18.4663 11.2923 18.307 11.2923 18.125V17.5461C10.6782 17.4128 10.1462 17.174 9.69619 16.8298C9.24619 16.4855 8.88145 16.0365 8.60197 15.4827C8.52118 15.307 8.52054 15.1333 8.60004 14.9615C8.67952 14.7897 8.80708 14.6718 8.98272 14.6077C9.1481 14.5436 9.31668 14.5445 9.48847 14.6106C9.66026 14.6766 9.79167 14.7872 9.88269 14.9423C10.1417 15.4013 10.4664 15.7493 10.8567 15.9865C11.2471 16.2237 11.6782 16.3423 12.15 16.3423ZM12 22.5C10.05 22.5 8.28046 22.0173 6.69134 21.0519C5.10224 20.0865 3.85577 18.7929 2.95194 17.1711V19.4038C2.95194 19.6166 2.88015 19.7948 2.73657 19.9384C2.59297 20.082 2.41476 20.1538 2.20194 20.1538C1.98914 20.1538 1.81094 20.082 1.66734 19.9384C1.52376 19.7948 1.45197 19.6166 1.45197 19.4038V15.5576C1.45197 15.2999 1.53818 15.0849 1.71062 14.9125C1.88305 14.74 2.09812 14.6538 2.35582 14.6538H6.20197C6.41477 14.6538 6.59297 14.7256 6.73657 14.8692C6.88015 15.0128 6.95194 15.191 6.95194 15.4038C6.95194 15.6166 6.88015 15.7948 6.73657 15.9384C6.59297 16.082 6.41477 16.1538 6.20197 16.1538H4.11152C4.8346 17.6102 5.90319 18.782 7.31729 19.6692C8.73141 20.5564 10.2923 21 12 21C14.3244 21 16.3308 20.2327 18.0192 18.6981C19.7077 17.1634 20.6814 15.2481 20.9404 12.9519C20.9673 12.7429 21.0551 12.5737 21.2039 12.4442C21.3526 12.3147 21.5314 12.25 21.7404 12.25C21.9532 12.25 22.1324 12.3215 22.2779 12.4644C22.4234 12.6074 22.4827 12.7782 22.4557 12.9769C22.3327 14.3166 21.9756 15.5637 21.3846 16.7182C20.7936 17.8727 20.0304 18.8785 19.0952 19.7355C18.1599 20.5926 17.0868 21.2676 15.876 21.7605C14.6651 22.2535 13.3731 22.5 12 22.5ZM12 2.99998C9.71412 2.99998 7.71892 3.75607 6.01444 5.26825C4.30996 6.78042 3.32502 8.70381 3.05964 11.0384C3.03271 11.2474 2.94488 11.4182 2.79617 11.5509C2.64747 11.6836 2.46863 11.75 2.25967 11.75C2.04043 11.75 1.85967 11.6785 1.71737 11.5355C1.57505 11.3926 1.51736 11.2186 1.54429 11.0134C1.68019 9.64804 2.04846 8.38651 2.64909 7.22883C3.24972 6.07114 4.01767 5.06858 4.95294 4.22115C5.88819 3.37372 6.95806 2.70833 8.16254 2.225C9.36702 1.74167 10.6462 1.5 12 1.5C13.9308 1.5 15.7003 1.9843 17.3087 2.9529C18.917 3.9215 20.1635 5.22633 21.0481 6.86738V4.59618C21.0481 4.38336 21.1199 4.20516 21.2635 4.06158C21.4071 3.91799 21.5853 3.8462 21.7981 3.8462C22.0109 3.8462 22.1891 3.91799 22.3327 4.06158C22.4763 4.20516 22.5481 4.38336 22.5481 4.59618V8.44233C22.5481 8.70001 22.4618 8.91507 22.2894 9.0875C22.117 9.25993 21.9019 9.34615 21.6442 9.34615H17.7981C17.5853 9.34615 17.4071 9.27436 17.2635 9.13078C17.1199 8.98719 17.0481 8.80899 17.0481 8.59618C17.0481 8.38336 17.1199 8.20516 17.2635 8.06158C17.4071 7.91799 17.5853 7.8462 17.7981 7.8462H19.8885C19.1847 6.4154 18.1241 5.25 16.7068 4.35C15.2894 3.44998 13.7205 2.99998 12 2.99998Z", fill: "currentColor" })
});
P({
  displayName: "ExchangeArrowIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M9.7808 15.5865H3.25C3.03718 15.5865 2.85898 15.5147 2.7154 15.3711C2.5718 15.2275 2.5 15.0493 2.5 14.8365C2.5 14.6237 2.5718 14.4455 2.7154 14.3019C2.85898 14.1583 3.03718 14.0865 3.25 14.0865H9.7808L7.47308 11.7788C7.33461 11.6404 7.26378 11.4689 7.26058 11.2644C7.25736 11.0599 7.32819 10.8801 7.47308 10.725C7.62819 10.5699 7.80639 10.4923 8.00768 10.4923C8.20894 10.4923 8.38714 10.5699 8.54227 10.725L12.0211 14.2038C12.1147 14.2974 12.1807 14.3961 12.2192 14.5C12.2576 14.6038 12.2769 14.716 12.2769 14.8365C12.2769 14.957 12.2576 15.0692 12.2192 15.173C12.1807 15.2769 12.1147 15.3756 12.0211 15.4692L8.52688 18.9634C8.37817 19.1121 8.20414 19.1855 8.00478 19.1836C7.80543 19.1817 7.62819 19.1032 7.47308 18.948C7.32819 18.7929 7.25319 18.6173 7.24808 18.4211C7.24294 18.225 7.31794 18.0494 7.47308 17.8942L9.7808 15.5865ZM14.2192 9.90385L16.5269 12.2116C16.6653 12.35 16.7362 12.5215 16.7394 12.726C16.7426 12.9305 16.6718 13.1103 16.5269 13.2654C16.3718 13.4205 16.1936 13.4981 15.9923 13.4981C15.791 13.4981 15.6128 13.4205 15.4577 13.2654L11.9789 9.78655C11.8853 9.69295 11.8192 9.59423 11.7808 9.4904C11.7423 9.38655 11.7231 9.27437 11.7231 9.15385C11.7231 9.03335 11.7423 8.92117 11.7808 8.81732C11.8192 8.71347 11.8853 8.61476 11.9789 8.52117L15.4731 5.02695C15.6218 4.87823 15.7958 4.80483 15.9952 4.80675C16.1945 4.80868 16.3718 4.88721 16.5269 5.04232C16.6718 5.19746 16.7468 5.3731 16.7519 5.56925C16.757 5.7654 16.682 5.94103 16.5269 6.09615L14.2192 8.40388H20.75C20.9628 8.40388 21.141 8.47567 21.2846 8.61925C21.4282 8.76283 21.5 8.94103 21.5 9.15385C21.5 9.36667 21.4282 9.54487 21.2846 9.68845C21.141 9.83205 20.9628 9.90385 20.75 9.90385H14.2192Z", fill: "currentColor" })
});
P({
  displayName: "ExclamationIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.9966 14.2821C11.8177 14.2821 11.6688 14.2219 11.55 14.1015C11.4312 13.9811 11.3718 13.8319 11.3718 13.6539V6.16675C11.3718 5.98877 11.4323 5.83957 11.5534 5.71917C11.6744 5.59877 11.8244 5.53857 12.0034 5.53857C12.1823 5.53857 12.3312 5.59877 12.45 5.71917C12.5688 5.83957 12.6282 5.98877 12.6282 6.16675V13.6539C12.6282 13.8319 12.5677 13.9811 12.4466 14.1015C12.3256 14.2219 12.1756 14.2821 11.9966 14.2821ZM11.9966 18.4616C11.8177 18.4616 11.6688 18.401 11.55 18.28C11.4312 18.1589 11.3718 18.009 11.3718 17.83C11.3718 17.6511 11.4323 17.5022 11.5534 17.3834C11.6744 17.2646 11.8244 17.2052 12.0034 17.2052C12.1823 17.2052 12.3312 17.2657 12.45 17.3868C12.5688 17.5078 12.6282 17.6578 12.6282 17.8367C12.6282 18.0157 12.5677 18.1646 12.4466 18.2834C12.3256 18.4022 12.1756 18.4616 11.9966 18.4616Z", fill: "currentColor" })
});
P({
  displayName: "ExitIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M5.8077 21C5.30257 21 4.875 20.825 4.525 20.475C4.175 20.125 4 19.6974 4 19.1923V16.3846C4 16.1718 4.0718 15.9936 4.2154 15.85C4.35898 15.7064 4.53718 15.6346 4.75 15.6346C4.96282 15.6346 5.14102 15.7064 5.2846 15.85C5.42818 15.9936 5.49997 16.1718 5.49997 16.3846V19.1923C5.49997 19.2692 5.53202 19.3397 5.59612 19.4038C5.66024 19.4679 5.73077 19.5 5.8077 19.5H19.1923C19.2692 19.5 19.3397 19.4679 19.4038 19.4038C19.4679 19.3397 19.5 19.2692 19.5 19.1923V5.8077C19.5 5.73077 19.4679 5.66024 19.4038 5.59613C19.3397 5.53203 19.2692 5.49998 19.1923 5.49998H5.8077C5.73077 5.49998 5.66024 5.53203 5.59612 5.59613C5.53202 5.66024 5.49997 5.73077 5.49997 5.8077V8.61538C5.49997 8.82819 5.42818 9.00639 5.2846 9.14998C5.14102 9.29356 4.96282 9.36535 4.75 9.36535C4.53718 9.36535 4.35898 9.29356 4.2154 9.14998C4.0718 9.00639 4 8.82819 4 8.61538V5.8077C4 5.30257 4.175 4.875 4.525 4.525C4.875 4.175 5.30257 4 5.8077 4H19.1923C19.6974 4 20.125 4.175 20.475 4.525C20.825 4.875 21 5.30257 21 5.8077V19.1923C21 19.6974 20.825 20.125 20.475 20.475C20.125 20.825 19.6974 21 19.1923 21H5.8077ZM12.7462 13.25H4.75C4.53718 13.25 4.35898 13.1782 4.2154 13.0346C4.0718 12.891 4 12.7128 4 12.5C4 12.2872 4.0718 12.109 4.2154 11.9654C4.35898 11.8218 4.53718 11.75 4.75 11.75H12.7462L10.6462 9.64998C10.4974 9.50126 10.424 9.32723 10.426 9.12788C10.4279 8.92853 10.5013 8.75128 10.6462 8.59615C10.8013 8.44103 10.9795 8.36091 11.1808 8.35578C11.382 8.35064 11.5602 8.42564 11.7154 8.58078L15.0019 11.8673C15.0955 11.9609 15.1615 12.0596 15.2 12.1635C15.2384 12.2673 15.2577 12.3795 15.2577 12.5C15.2577 12.6205 15.2384 12.7327 15.2 12.8365C15.1615 12.9404 15.0955 13.0391 15.0019 13.1327L11.7154 16.4192C11.5666 16.5679 11.3901 16.6413 11.1856 16.6394C10.9811 16.6374 10.8013 16.5589 10.6462 16.4038C10.5013 16.2487 10.4263 16.073 10.4212 15.8769C10.416 15.6807 10.491 15.5051 10.6462 15.35L12.7462 13.25Z", fill: "currentColor" })
});
P({
  displayName: "ExpandIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 12.3636C18.4477 12.3636 18 11.9159 18 11.3636V7.41422L7.41421 18H11.3636C11.9159 18 12.3636 18.4477 12.3636 19C12.3636 19.5523 11.9159 20 11.3636 20H5H4V19V12.6364C4 12.0841 4.44772 11.6364 5 11.6364C5.55228 11.6364 6 12.0841 6 12.6364V16.5858L16.5858 6L12.6364 6C12.0841 6 11.6364 5.55229 11.6364 5C11.6364 4.44772 12.0841 4 12.6364 4L19 4L20 4V5L20 11.3636C20 11.9159 19.5523 12.3636 19 12.3636Z", fill: "currentColor" })
});
P({
  displayName: "ExperimentIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M4.9991 20.5C4.36126 20.5 3.90791 20.2153 3.63902 19.6461C3.37012 19.0769 3.43503 18.5474 3.83375 18.0577L9.49912 11.1731V4.99998H8.30682C8.09432 4.99998 7.9162 4.92807 7.77245 4.78425C7.6287 4.64045 7.55682 4.46225 7.55682 4.24965C7.55682 4.03707 7.6287 3.85898 7.77245 3.7154C7.9162 3.5718 8.09432 3.5 8.30682 3.5H15.6914C15.9039 3.5 16.082 3.57191 16.2257 3.71573C16.3695 3.85954 16.4414 4.03774 16.4414 4.25033C16.4414 4.46293 16.3695 4.64102 16.2257 4.7846C16.082 4.92818 15.9039 4.99998 15.6914 4.99998H14.4991V11.1731L20.1644 18.0577C20.5632 18.5474 20.6281 19.0769 20.3592 19.6461C20.0903 20.2153 19.6369 20.5 18.9991 20.5H4.9991ZM6.9991 18H16.9991L13.5991 14H10.3991L6.9991 18ZM4.9991 19H18.9991L12.9991 11.7V4.99998H10.9991V11.7L4.9991 19Z", fill: "currentColor" })
});
P({
  displayName: "ExploreIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.82696 17.173L13.7308 13.7307L17.1731 6.82693L10.2693 10.2692L6.82696 17.173ZM12 13C11.7167 13 11.4792 12.9041 11.2875 12.7125C11.0958 12.5208 11 12.2833 11 12C11 11.7166 11.0958 11.4791 11.2875 11.2875C11.4792 11.0958 11.7167 11 12 11C12.2833 11 12.5208 11.0958 12.7125 11.2875C12.9042 11.4791 13 11.7166 13 12C13 12.2833 12.9042 12.5208 12.7125 12.7125C12.5208 12.9041 12.2833 13 12 13ZM12.0017 21.5C10.6877 21.5 9.45271 21.2506 8.29658 20.752C7.14043 20.2533 6.13475 19.5765 5.27953 18.7217C4.4243 17.8669 3.74724 16.8616 3.24836 15.706C2.74947 14.5504 2.50003 13.3156 2.50003 12.0017C2.50003 10.6877 2.74936 9.45268 3.24803 8.29655C3.7467 7.1404 4.42345 6.13472 5.27828 5.2795C6.13313 4.42427 7.13837 3.74721 8.29401 3.24833C9.44962 2.74944 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.1331 20.2528 7.13834 20.7517 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5766 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99997 12 3.99997C9.76667 3.99997 7.87501 4.77498 6.32501 6.32498C4.77501 7.87498 4.00001 9.76664 4.00001 12C4.00001 14.2333 4.77501 16.125 6.32501 17.675C7.87501 19.225 9.76667 20 12 20Z", fill: "currentColor" })
});
P({
  displayName: "ExplorerIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.0064 15.5922C17.2438 14.2548 18 12.4657 18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C11.9527 18 13.309 17.587 14.4577 16.8719L15.5023 17.9165C15.4795 18.3277 15.6252 18.7465 15.9393 19.0607L17.9393 21.0607C18.5251 21.6464 19.4749 21.6464 20.0607 21.0607C20.6464 20.4749 20.6464 19.5251 20.0607 18.9393L18.0607 16.9393C17.7465 16.6252 17.3277 16.4795 16.9165 16.5023L16.0064 15.5922ZM14.3254 8.14773C14.5064 8.52031 14.9552 8.67561 15.3277 8.49462C15.7003 8.31362 15.8556 7.86486 15.6746 7.49228C14.9891 6.08112 13.7436 4.99249 12.2247 4.51543C11.8296 4.39132 11.4086 4.61105 11.2845 5.00623C11.1603 5.40141 11.3801 5.82239 11.7753 5.94651C12.8958 6.29845 13.8182 7.10367 14.3254 8.14773ZM16.5 9.75C16.5 10.1642 16.1642 10.5 15.75 10.5C15.3358 10.5 15 10.1642 15 9.75C15 9.33579 15.3358 9 15.75 9C16.1642 9 16.5 9.33579 16.5 9.75Z", fill: "currentColor" })
});
P({
  displayName: "ExternalLinkIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 11.0909C18.4477 11.0909 18 10.6432 18 10.0909V7.41426L13.3435 12.0707C12.953 12.4613 12.3198 12.4613 11.9293 12.0707C11.5388 11.6802 11.5388 11.0471 11.9293 10.6565L16.5858 6L13.9091 6C13.3568 6 12.9091 5.55229 12.9091 5C12.9091 4.44772 13.3568 4 13.9091 4H20L20 10.0909C20 10.6432 19.5523 11.0909 19 11.0909ZM4 6.5455H7.54545C8.09774 6.5455 8.54545 6.99321 8.54545 7.5455C8.54545 8.09778 8.09774 8.5455 7.54545 8.5455H6V18H15.4545V16.4546C15.4545 15.9023 15.9023 15.4546 16.4545 15.4546C17.0068 15.4546 17.4545 15.9023 17.4545 16.4546V20H4V6.5455Z", fill: "currentColor" })
});
P({
  displayName: "EyeCloseIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.28685 8.38285C3.94607 7.94888 3.31772 7.87246 2.88327 8.21285C2.44853 8.55347 2.37223 9.18202 2.71285 9.61676L2.715 9.61949L2.71855 9.624L2.72986 9.63821C2.73924 9.64995 2.75232 9.6662 2.76901 9.68665C2.80236 9.72755 2.85017 9.7853 2.91172 9.85749C3.03474 10.0018 3.21307 10.2043 3.44102 10.4456C3.67421 10.6925 3.96086 10.9816 4.29484 11.2916L2.73557 13.1406C2.37952 13.5628 2.43315 14.1937 2.85534 14.5497C3.27754 14.9057 3.90843 14.8521 4.26448 14.4299L5.83509 12.5675C6.5636 13.1015 7.41493 13.6303 8.3595 14.0449L7.46276 15.8384C7.21577 16.3324 7.41599 16.9331 7.90997 17.1801C8.40395 17.427 9.00462 17.2268 9.25161 16.7328L10.2817 14.6726C10.8354 14.7903 11.4095 14.8572 12 14.8572C12.5905 14.8572 13.1647 14.7903 13.7183 14.6726L14.7484 16.7328C14.9954 17.2268 15.5961 17.427 16.0901 17.1801C16.584 16.9331 16.7843 16.3324 16.5373 15.8384L15.6405 14.0449C16.5851 13.6303 17.4364 13.1015 18.1649 12.5675L19.7356 14.4299C20.0916 14.8521 20.7225 14.9057 21.1447 14.5497C21.5669 14.1937 21.6205 13.5628 21.2645 13.1406L19.7052 11.2916C20.0392 10.9816 20.3258 10.6925 20.559 10.4456C20.7869 10.2043 20.9653 10.0018 21.0883 9.85749C21.1498 9.7853 21.1977 9.72755 21.231 9.68665C21.2477 9.6662 21.2608 9.64995 21.2702 9.63821L21.2815 9.624L21.285 9.61949L21.2863 9.6179C21.2865 9.61764 21.2872 9.61677 20.5556 9.04354L21.2872 9.61676C21.6278 9.18202 21.5515 8.55347 21.1168 8.21285C20.6821 7.87234 20.0539 7.94848 19.7132 8.38286L19.7077 8.38968L19.6812 8.42247C19.6566 8.45272 19.618 8.49933 19.5663 8.55995C19.4629 8.68128 19.3072 8.85823 19.1051 9.07226C18.6996 9.50151 18.113 10.0736 17.3908 10.6437C15.9209 11.804 14.0152 12.8572 12 12.8572C9.98478 12.8572 8.07909 11.804 6.60922 10.6437C5.88703 10.0736 5.30041 9.50151 4.89495 9.07226C4.69278 8.85823 4.53712 8.68128 4.43369 8.55995C4.38201 8.49933 4.34347 8.45272 4.31879 8.42247L4.29229 8.38968L4.28685 8.38285ZM2.71285 9.61676L2.71285 9.61675C2.71276 9.61661 2.71394 9.61569 2.81103 9.53967L2.81119 9.53954L2.81121 9.53953L3.50001 9.00001L2.71285 9.61676Z", fill: "currentColor" })
});
P({
  displayName: "EyeOpenIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.76584 12C3.83811 12.0882 3.91854 12.1846 4.00676 12.2878C4.46457 12.8235 5.12602 13.5363 5.93993 14.2465C7.59952 15.6945 9.74246 17 12 17C14.2575 17 16.4005 15.6945 18.0601 14.2465C18.874 13.5363 19.5354 12.8235 19.9932 12.2878C20.0815 12.1846 20.1619 12.0882 20.2342 12C20.1619 11.9118 20.0815 11.8154 19.9932 11.7122C19.5354 11.1765 18.874 10.4637 18.0601 9.7535C16.4005 8.30548 14.2575 7 12 7C9.74246 7 7.59952 8.30548 5.93993 9.7535C5.12602 10.4637 4.46457 11.1765 4.00676 11.7122C3.91854 11.8154 3.83811 11.9118 3.76584 12ZM21.5 12C22.3158 11.4217 22.3156 11.4214 22.3154 11.4212L22.3137 11.4187L22.31 11.4136L22.298 11.3969C22.288 11.383 22.2738 11.3635 22.2556 11.3388C22.2191 11.2895 22.1666 11.2194 22.0988 11.1314C21.9632 10.9557 21.7661 10.7082 21.5136 10.4128C21.01 9.8235 20.2802 9.03634 19.375 8.2465C17.5962 6.69452 14.9892 5 12 5C9.01084 5 6.40378 6.69452 4.62504 8.2465C3.7198 9.03634 2.99 9.8235 2.48636 10.4128C2.23394 10.7082 2.03676 10.9557 1.90119 11.1314C1.83337 11.2194 1.78086 11.2895 1.74445 11.3388C1.72624 11.3635 1.71205 11.383 1.70198 11.3969L1.68996 11.4136L1.68629 11.4187L1.68504 11.4205C1.68485 11.4208 1.68419 11.4217 2.5 12L1.68419 11.4217L1.27423 12L1.68419 12.5783L2.5 12C1.68419 12.5783 1.68399 12.578 1.68419 12.5783L1.68629 12.5813L1.68996 12.5864L1.70198 12.6031C1.71205 12.617 1.72624 12.6365 1.74445 12.6612C1.78086 12.7105 1.83337 12.7806 1.90119 12.8686C2.03676 13.0443 2.23394 13.2918 2.48636 13.5872C2.99 14.1765 3.7198 14.9637 4.62504 15.7535C6.40378 17.3055 9.01084 19 12 19C14.9892 19 17.5962 17.3055 19.375 15.7535C20.2802 14.9637 21.01 14.1765 21.5136 13.5872C21.7661 13.2918 21.9632 13.0443 22.0988 12.8686C22.1666 12.7806 22.2191 12.7105 22.2556 12.6612C22.2738 12.6365 22.288 12.617 22.298 12.6031L22.31 12.5864L22.3137 12.5813L22.315 12.5795C22.3152 12.5792 22.3158 12.5783 21.5 12ZM21.5 12L22.3158 12.5783L22.7258 12L22.3154 11.4212L21.5 12Z", fill: "currentColor" }),
    w.createElement("path", { d: "M12 6C11.11 6 10.24 6.26392 9.49994 6.75839C8.75991 7.25285 8.18314 7.95566 7.84254 8.77792C7.50195 9.60019 7.41283 10.505 7.58647 11.3779C7.7601 12.2508 8.18869 13.0526 8.81802 13.682C9.44736 14.3113 10.2492 14.7399 11.1221 14.9135C11.995 15.0872 12.8998 14.9981 13.7221 14.6575C14.5443 14.3169 15.2471 13.7401 15.7416 13.0001C16.2361 12.26 16.5 11.39 16.5 10.5H12V6Z", fill: "currentColor" })
  )
});
P({
  displayName: "FactCheckIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M4.3077 20.5C3.80257 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V5.30773C2.5 4.80259 2.675 4.37502 3.025 4.02502C3.375 3.67502 3.80257 3.50002 4.3077 3.50002H19.6923C20.1974 3.50002 20.625 3.67502 20.975 4.02502C21.325 4.37502 21.5 4.80259 21.5 5.30773V18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5H4.3077ZM4.3077 19H19.6923C19.7692 19 19.8397 18.968 19.9038 18.9039C19.9679 18.8397 20 18.7692 20 18.6923V5.30773C20 5.23079 19.9679 5.16027 19.9038 5.09615C19.8397 5.03205 19.7692 5 19.6923 5H4.3077C4.23077 5 4.16024 5.03205 4.09613 5.09615C4.03203 5.16027 3.99998 5.23079 3.99998 5.30773V18.6923C3.99998 18.7692 4.03203 18.8397 4.09613 18.9039C4.16024 18.968 4.23077 19 4.3077 19ZM8.99998 16.75C9.21279 16.75 9.39099 16.6782 9.53458 16.5346C9.67816 16.391 9.74995 16.2128 9.74995 16C9.74995 15.7872 9.67816 15.609 9.53458 15.4654C9.39099 15.3218 9.21279 15.25 8.99998 15.25H5.99998C5.78716 15.25 5.60896 15.3218 5.46538 15.4654C5.32179 15.609 5.25 15.7872 5.25 16C5.25 16.2128 5.32179 16.391 5.46538 16.5346C5.60896 16.6782 5.78716 16.75 5.99998 16.75H8.99998ZM14.55 12.5308L13.6519 11.6327C13.5032 11.484 13.3275 11.4106 13.125 11.4125C12.9224 11.4144 12.7468 11.493 12.5981 11.6481C12.4596 11.7968 12.3894 11.9724 12.3875 12.175C12.3856 12.3776 12.459 12.5532 12.6077 12.7019L13.9173 14.0115C14.0981 14.1923 14.309 14.2827 14.55 14.2827C14.791 14.2827 15.0019 14.1923 15.1827 14.0115L18.6173 10.5769C18.766 10.4282 18.842 10.2542 18.8452 10.0548C18.8484 9.85545 18.7724 9.67822 18.6173 9.5231C18.4621 9.36797 18.2839 9.2904 18.0827 9.2904C17.8814 9.2904 17.7032 9.36797 17.5481 9.5231L14.55 12.5308ZM8.99998 12.75C9.21279 12.75 9.39099 12.6782 9.53458 12.5346C9.67816 12.391 9.74995 12.2128 9.74995 12C9.74995 11.7872 9.67816 11.609 9.53458 11.4654C9.39099 11.3218 9.21279 11.25 8.99998 11.25H5.99998C5.78716 11.25 5.60896 11.3218 5.46538 11.4654C5.32179 11.609 5.25 11.7872 5.25 12C5.25 12.2128 5.32179 12.391 5.46538 12.5346C5.60896 12.6782 5.78716 12.75 5.99998 12.75H8.99998ZM8.99998 8.74998C9.21279 8.74998 9.39099 8.67818 9.53458 8.5346C9.67816 8.39102 9.74995 8.21282 9.74995 8C9.74995 7.78718 9.67816 7.60898 9.53458 7.4654C9.39099 7.32182 9.21279 7.25003 8.99998 7.25003H5.99998C5.78716 7.25003 5.60896 7.32182 5.46538 7.4654C5.32179 7.60898 5.25 7.78718 5.25 8C5.25 8.21282 5.32179 8.39102 5.46538 8.5346C5.60896 8.67818 5.78716 8.74998 5.99998 8.74998H8.99998Z", fill: "currentColor" })
});
P({
  displayName: "FaucetIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.02777 5.74998L9.48611 5.74998V7.07956C8.52096 7.44061 7.65942 8.07291 7.07211 8.88192H3.5V8.02775C3.5 7.61354 3.16421 7.27775 2.75 7.27775C2.33579 7.27775 2 7.61354 2 8.02775V15.5139C2 15.9281 2.33579 16.2639 2.75 16.2639C3.16421 16.2639 3.5 15.9281 3.5 15.5139V14.6597H7.08888C7.82627 16.0885 9.16138 17.3333 11.3056 17.3333C13.4497 17.3333 14.7848 16.0885 15.5222 14.6597H15.5833C15.9407 14.6597 16.1299 14.7737 16.2348 14.8876C16.349 15.0116 16.4375 15.2175 16.4375 15.5139V15.5833C16.4375 16.5411 17.2069 17.3191 18.1613 17.3331C18.0832 17.4321 18.0019 17.5381 17.9204 17.6488C17.708 17.9372 17.4827 18.2727 17.3074 18.61C17.1434 18.9255 16.9722 19.3366 16.9722 19.7505C16.9722 21.0554 18.0084 22.1458 19.3264 22.1458C20.6443 22.1458 21.6806 21.0554 21.6806 19.7505C21.6806 19.3366 21.5094 18.9255 21.3454 18.61C21.1701 18.2727 20.9448 17.9372 20.7324 17.6488C20.6509 17.5381 20.5696 17.4321 20.4915 17.3331C21.4459 17.3191 22.2153 16.5411 22.2153 15.5833V15.5139C22.2153 13.1079 21.265 11.1735 19.7647 10.0928C19.0533 9.58033 18.4579 9.25768 17.7187 9.08096C17.1036 8.9339 16.4187 8.89642 15.542 8.88604C14.9546 8.07505 14.0918 7.44122 13.125 7.07956V5.74998L15.5833 5.74998C15.9975 5.74998 16.3333 5.41419 16.3333 4.99998C16.3333 4.58576 15.9975 4.24998 15.5833 4.24998L13.097 4.24998C12.9461 3.39746 12.2014 2.75 11.3056 2.75C10.4097 2.75 9.66507 3.39746 9.51407 4.24998L7.02777 4.24998C6.61356 4.24998 6.27777 4.58576 6.27777 4.99998C6.27777 5.41419 6.61356 5.74998 7.02777 5.74998ZM10.9861 6.49306V5.74998H11.625V6.49306H10.9861ZM3.5 13.1597H8.06358L8.25685 13.6186C8.78733 14.8781 9.73337 15.8333 11.3056 15.8333C12.8777 15.8333 13.8238 14.8781 14.3543 13.6186L14.5475 13.1597H15.5833C16.2954 13.1597 16.9083 13.4048 17.3381 13.8715C17.7587 14.3281 17.9375 14.9242 17.9375 15.5139V15.5833C17.9375 15.7214 18.0494 15.8333 18.1875 15.8333H20.4653C20.6034 15.8333 20.7153 15.7214 20.7153 15.5833V15.5139C20.7153 13.4973 19.9272 12.0585 18.888 11.3099C18.2655 10.8615 17.8504 10.6547 17.3699 10.5398C16.8568 10.4172 16.2266 10.3878 15.1316 10.3829L14.7032 10.381L14.4872 10.0111C13.8887 8.98608 12.5958 8.24303 11.3056 8.24303C10.0156 8.24303 8.72307 8.98567 8.12438 10.0103L7.90723 10.3819H3.5V13.1597ZM19.1282 18.5383C19.1948 18.4479 19.2615 18.3606 19.3264 18.2781C19.3912 18.3606 19.458 18.4479 19.5246 18.5383C19.7132 18.7944 19.8889 19.0602 20.0144 19.3017C20.1512 19.565 20.1806 19.7101 20.1806 19.7505C20.1806 20.263 19.7803 20.6458 19.3264 20.6458C18.8724 20.6458 18.4722 20.263 18.4722 19.7505C18.4722 19.7101 18.5015 19.565 18.6384 19.3017C18.7638 19.0602 18.9396 18.7944 19.1282 18.5383Z", fill: "currentColor" })
});
P({
  displayName: "FilterIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.3848 19.5C11.1335 19.5 10.9232 19.4154 10.754 19.2461C10.5847 19.0769 10.5001 18.8666 10.5001 18.6154V12.8269L4.90208 5.7154C4.70978 5.45898 4.6819 5.19232 4.81843 4.9154C4.95497 4.63848 5.18541 4.50002 5.50976 4.50002H18.4905C18.8148 4.50002 19.0452 4.63848 19.1818 4.9154C19.3183 5.19232 19.2904 5.45898 19.0981 5.7154L13.5001 12.8269V18.6154C13.5001 18.8666 13.4155 19.0769 13.2462 19.2461C13.077 19.4154 12.8667 19.5 12.6155 19.5H11.3848ZM12.0001 12.3L16.9501 6H7.05011L12.0001 12.3Z", fill: "currentColor" })
});
P({
  displayName: "FinanceIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M8.34608 12.9577V7.25002C8.34608 6.99392 8.4327 6.77926 8.60593 6.60603C8.77917 6.43279 8.99383 6.34617 9.24993 6.34617H9.86528C10.0887 6.34617 10.2759 6.42173 10.4271 6.57285C10.5782 6.72397 10.6537 6.91122 10.6537 7.13462V12.9577L10.5768 12.8807C10.2765 12.5846 9.91748 12.4365 9.49968 12.4365C9.0819 12.4365 8.72301 12.5846 8.42301 12.8807L8.34608 12.9577ZM13.0191 14.823V3.25002C13.0191 2.99392 13.1058 2.77926 13.279 2.60603C13.4522 2.43279 13.6669 2.34617 13.923 2.34617H14.5383C14.7617 2.34617 14.949 2.42173 15.1001 2.57285C15.2512 2.72397 15.3268 2.91122 15.3268 3.13462V12.5154L13.0191 14.823ZM3.65381 17.6191V11.25C3.65381 10.9939 3.74043 10.7793 3.91366 10.606C4.08689 10.4328 4.30155 10.3462 4.55763 10.3462H5.17301C5.39639 10.3462 5.58364 10.4217 5.73476 10.5729C5.88587 10.724 5.96143 10.9112 5.96143 11.1346V15.3115L3.65381 17.6191ZM5.39636 20.8C5.06796 20.8 4.8387 20.6471 4.70858 20.3414C4.57845 20.0356 4.63326 19.7628 4.87301 19.5231L8.87683 15.5192C9.04093 15.3551 9.2406 15.2648 9.47583 15.2481C9.71105 15.2314 9.91972 15.3051 10.1018 15.4692L13.0191 17.9769L19.1961 11.8H17.9999C17.7874 11.8 17.6093 11.7281 17.4655 11.5843C17.3218 11.4405 17.2499 11.2623 17.2499 11.0497C17.2499 10.8371 17.3218 10.659 17.4655 10.5154C17.6093 10.3718 17.7874 10.3 17.9999 10.3H20.8461C21.1021 10.3 21.3168 10.3866 21.49 10.5599C21.6633 10.7331 21.7499 10.9478 21.7499 11.2038V14.05C21.7499 14.2625 21.678 14.4406 21.5342 14.5843C21.3904 14.7281 21.2122 14.8 20.9996 14.8C20.787 14.8 20.6089 14.7281 20.4653 14.5843C20.3217 14.4406 20.2499 14.2625 20.2499 14.05V12.8538L13.673 19.4307C13.5089 19.5949 13.3092 19.6852 13.074 19.7019C12.8388 19.7186 12.6301 19.6448 12.448 19.4807L9.53068 16.9731L5.92681 20.5769C5.86366 20.6389 5.78473 20.6915 5.69001 20.7349C5.59528 20.7783 5.49739 20.8 5.39636 20.8Z", fill: "currentColor" })
});
P({
  displayName: "FlagIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    w.createElement("path", { d: "M4 22V3H13.7183L14.2567 5.40294H21V15.7412H13.7467L13.2083 13.3662H5.7V22H4Z", fill: "currentColor" })
  )
});
P({
  displayName: "FlexibilityIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { id: "flex_wrap_2", d: "M2 20.596V14.1155C2 13.8593 2.08667 13.6447 2.26 13.4715C2.43317 13.2982 2.64783 13.2115 2.904 13.2115H6.48075C6.73692 13.2115 6.95158 13.2982 7.12475 13.4715C7.29792 13.6447 7.3845 13.8593 7.3845 14.1155V20.596C7.3845 20.8522 7.29792 21.0668 7.12475 21.24C6.95158 21.4133 6.73692 21.5 6.48075 21.5H2.904C2.64783 21.5 2.43317 21.4133 2.26 21.24C2.08667 21.0668 2 20.8522 2 20.596ZM9.80775 20.596V14.1155C9.80775 13.8593 9.89433 13.6447 10.0675 13.4715C10.2408 13.2982 10.4555 13.2115 10.7115 13.2115H14.2885C14.5445 13.2115 14.7592 13.2982 14.9325 13.4715C15.1057 13.6447 15.1923 13.8593 15.1923 14.1155V20.596C15.1923 20.8522 15.1057 21.0668 14.9325 21.24C14.7592 21.4133 14.5445 21.5 14.2885 21.5H10.7115C10.4555 21.5 10.2408 21.4133 10.0675 21.24C9.89433 21.0668 9.80775 20.8522 9.80775 20.596ZM17.6155 20.596V14.1155C17.6155 13.8593 17.7021 13.6447 17.8753 13.4715C18.0484 13.2982 18.2631 13.2115 18.5193 13.2115H22.096C22.3522 13.2115 22.5668 13.2982 22.74 13.4715C22.9133 13.6447 23 13.8593 23 14.1155V20.596C23 20.8522 22.9133 21.0668 22.74 21.24C22.5668 21.4133 22.3522 21.5 22.096 21.5H18.5193C18.2631 21.5 18.0484 21.4133 17.8753 21.24C17.7021 21.0668 17.6155 20.8522 17.6155 20.596ZM11.3077 20H13.6923V14.7115H11.3077V20ZM2 9.8845V3.404C2 3.14783 2.08667 2.93317 2.26 2.76C2.43317 2.58667 2.64783 2.5 2.904 2.5H6.48075C6.73692 2.5 6.95158 2.58667 7.12475 2.76C7.29792 2.93317 7.3845 3.14783 7.3845 3.404V9.8845C7.3845 10.1407 7.29792 10.3553 7.12475 10.5285C6.95158 10.7018 6.73692 10.7885 6.48075 10.7885H2.904C2.64783 10.7885 2.43317 10.7018 2.26 10.5285C2.08667 10.3553 2 10.1407 2 9.8845ZM9.80775 9.8845V3.404C9.80775 3.14783 9.89433 2.93317 10.0675 2.76C10.2408 2.58667 10.4555 2.5 10.7115 2.5H14.2885C14.5445 2.5 14.7592 2.58667 14.9325 2.76C15.1057 2.93317 15.1923 3.14783 15.1923 3.404V9.8845C15.1923 10.1407 15.1057 10.3553 14.9325 10.5285C14.7592 10.7018 14.5445 10.7885 14.2885 10.7885H10.7115C10.4555 10.7885 10.2408 10.7018 10.0675 10.5285C9.89433 10.3553 9.80775 10.1407 9.80775 9.8845ZM17.6155 9.8845V3.404C17.6155 3.14783 17.7021 2.93317 17.8753 2.76C18.0484 2.58667 18.2631 2.5 18.5193 2.5H22.096C22.3522 2.5 22.5668 2.58667 22.74 2.76C22.9133 2.93317 23 3.14783 23 3.404V9.8845C23 10.1407 22.9133 10.3553 22.74 10.5285C22.5668 10.7018 22.3522 10.7885 22.096 10.7885H18.5193C18.2631 10.7885 18.0484 10.7018 17.8753 10.5285C17.7021 10.3553 17.6155 10.1407 17.6155 9.8845ZM3.5 9.2885H5.88475V4H3.5V9.2885ZM19.2115 9.2885H21.5V4H19.2115V9.2885Z", fill: "currentColor" })
});
P({
  displayName: "ForumIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("rect", { width: "24", height: "24", fill: "none" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18.4716C16.5 18.4716 21 17.8207 21 11.3113C21 6.99723 17.7857 3.5 12 3.5C6.21429 3.5 3 6.99723 3 11.3113C3 13.6353 3 16.2689 6.67347 20.5C7.48277 18.4716 8.46429 18.4716 9.06122 18.4716H12ZM8.46429 12.6422C9.12365 12.6422 9.65816 12.101 9.65816 11.4333C9.65816 10.7657 9.12365 10.2244 8.46429 10.2244C7.80493 10.2244 7.27041 10.7657 7.27041 11.4333C7.27041 12.101 7.80493 12.6422 8.46429 12.6422ZM13.5339 11.4333C13.5339 12.101 12.9994 12.6422 12.3401 12.6422C11.6807 12.6422 11.1462 12.101 11.1462 11.4333C11.1462 10.7657 11.6807 10.2244 12.3401 10.2244C12.9994 10.2244 13.5339 10.7657 13.5339 11.4333ZM16.2158 12.6422C16.8752 12.6422 17.4097 12.101 17.4097 11.4333C17.4097 10.7657 16.8752 10.2244 16.2158 10.2244C15.5565 10.2244 15.022 10.7657 15.022 11.4333C15.022 12.101 15.5565 12.6422 16.2158 12.6422Z", fill: "currentColor" })
  )
});
P({
  displayName: "FrameSourceIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M5.30773 20.5C4.8026 20.5 4.37503 20.325 4.02503 19.975C3.67503 19.625 3.50003 19.1974 3.50003 18.6923V15.75C3.50003 15.5372 3.57183 15.359 3.71543 15.2154C3.85901 15.0718 4.03721 15 4.25003 15C4.46285 15 4.64105 15.0718 4.78463 15.2154C4.92821 15.359 5.00001 15.5372 5.00001 15.75V18.6923C5.00001 18.7692 5.03206 18.8397 5.09616 18.9039C5.16027 18.968 5.2308 19 5.30773 19H8.25003C8.46285 19 8.64105 19.0718 8.78463 19.2154C8.92821 19.359 9.00001 19.5372 9.00001 19.75C9.00001 19.9628 8.92821 20.141 8.78463 20.2846C8.64105 20.4282 8.46285 20.5 8.25003 20.5H5.30773ZM15.75 20.5C15.5372 20.5 15.359 20.4282 15.2154 20.2846C15.0718 20.141 15 19.9628 15 19.75C15 19.5372 15.0718 19.359 15.2154 19.2154C15.359 19.0718 15.5372 19 15.75 19H18.6923C18.7692 19 18.8397 18.968 18.9039 18.9039C18.968 18.8397 19 18.7692 19 18.6923V15.75C19 15.5372 19.0718 15.359 19.2154 15.2154C19.359 15.0718 19.5372 15 19.75 15C19.9628 15 20.141 15.0718 20.2846 15.2154C20.4282 15.359 20.5 15.5372 20.5 15.75V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H15.75ZM7.46921 12L9.12691 13.6577C9.26537 13.7962 9.33461 13.9676 9.33461 14.1721C9.33461 14.3766 9.26537 14.5532 9.12691 14.7019C8.97821 14.857 8.80001 14.933 8.59231 14.9298C8.38462 14.9266 8.20642 14.8506 8.05771 14.7019L5.98848 12.6327C5.80771 12.4519 5.71733 12.241 5.71733 12C5.71733 11.759 5.80771 11.5481 5.98848 11.3673L8.07311 9.2827C8.22181 9.13398 8.39744 9.06059 8.60001 9.06253C8.80257 9.06444 8.97821 9.14297 9.12691 9.2981C9.26537 9.4468 9.33556 9.62243 9.33748 9.825C9.33941 10.0276 9.26602 10.2032 9.11731 10.3519L7.46921 12ZM16.5308 12L14.8731 10.3423C14.7346 10.2038 14.6654 10.0324 14.6654 9.82788C14.6654 9.62339 14.7346 9.4468 14.8731 9.2981C15.0218 9.14297 15.2 9.067 15.4077 9.0702C15.6154 9.07342 15.7936 9.14938 15.9423 9.2981L18.0115 11.3673C18.1923 11.5481 18.2827 11.759 18.2827 12C18.2827 12.241 18.1923 12.4519 18.0115 12.6327L15.9269 14.7173C15.7782 14.866 15.6026 14.9394 15.4 14.9375C15.1974 14.9356 15.0218 14.857 14.8731 14.7019C14.7346 14.5532 14.6644 14.3776 14.6625 14.175C14.6606 13.9724 14.734 13.7968 14.8827 13.6481L16.5308 12ZM4.25003 9C4.03721 9 3.85901 8.92821 3.71543 8.78463C3.57183 8.64104 3.50003 8.46284 3.50003 8.25003V5.30773C3.50003 4.80259 3.67503 4.37502 4.02503 4.02502C4.37503 3.67502 4.8026 3.50002 5.30773 3.50002H8.25003C8.46285 3.50002 8.64105 3.57183 8.78463 3.71543C8.92821 3.85901 9.00001 4.03721 9.00001 4.25002C9.00001 4.46284 8.92821 4.64104 8.78463 4.78463C8.64105 4.92821 8.46285 5 8.25003 5H5.30773C5.2308 5 5.16027 5.03205 5.09616 5.09615C5.03206 5.16027 5.00001 5.23079 5.00001 5.30773V8.25003C5.00001 8.46284 4.92821 8.64104 4.78463 8.78463C4.64105 8.92821 4.46285 9 4.25003 9ZM19.75 9C19.5372 9 19.359 8.92821 19.2154 8.78463C19.0718 8.64104 19 8.46284 19 8.25003V5.30773C19 5.23079 18.968 5.16027 18.9039 5.09615C18.8397 5.03205 18.7692 5 18.6923 5H15.75C15.5372 5 15.359 4.92821 15.2154 4.78463C15.0718 4.64104 15 4.46284 15 4.25002C15 4.03721 15.0718 3.85901 15.2154 3.71543C15.359 3.57183 15.5372 3.50002 15.75 3.50002H18.6923C19.1974 3.50002 19.625 3.67502 19.975 4.02502C20.325 4.37502 20.5 4.80259 20.5 5.30773V8.25003C20.5 8.46284 20.4282 8.64104 20.2846 8.78463C20.141 8.92821 19.9628 9 19.75 9Z", fill: "currentColor" })
});
P({
  displayName: "GameControllerIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M4.5308 18.5C3.8519 18.5 3.32609 18.2602 2.95337 17.7807C2.58066 17.3013 2.43981 16.7359 2.53082 16.0846L3.60005 8.52693C3.73063 7.64958 4.11872 6.92576 4.76432 6.35547C5.40992 5.78517 6.17182 5.50002 7.05002 5.50002H16.95C17.8282 5.50002 18.5901 5.78517 19.2357 6.35547C19.8813 6.92576 20.2694 7.64958 20.4 8.52693L21.4692 16.0846C21.5602 16.7359 21.4194 17.3013 21.0467 17.7807C20.674 18.2602 20.1481 18.5 19.4692 18.5C19.1834 18.5 18.9209 18.4519 18.6818 18.3557C18.4427 18.2596 18.2206 18.1089 18.0154 17.9038L15.6116 15.5H8.38847L5.98462 17.9038C5.77949 18.1089 5.55737 18.2596 5.31827 18.3557C5.07917 18.4519 4.81668 18.5 4.5308 18.5ZM4.9308 16.85L7.7808 14H16.2192L19.0693 16.85C19.1026 16.8833 19.2295 16.9333 19.45 17C19.6334 17 19.7792 16.9458 19.8875 16.8375C19.9959 16.7292 20.0334 16.5833 20 16.4L18.897 8.7C18.83 8.21667 18.6121 7.8125 18.2434 7.4875C17.8747 7.1625 17.4436 7 16.95 7H7.05002C6.55644 7 6.12531 7.1625 5.75662 7.4875C5.38794 7.8125 5.17008 8.21667 5.10305 8.7L4.00002 16.4C3.96669 16.5833 4.00419 16.7292 4.11252 16.8375C4.22086 16.9458 4.36669 17 4.55002 17C4.59617 17 4.7231 16.95 4.9308 16.85ZM17 12.9038C17.2513 12.9038 17.4648 12.816 17.6404 12.6404C17.816 12.4647 17.9039 12.2513 17.9039 12C17.9039 11.7487 17.816 11.5353 17.6404 11.3596C17.4648 11.184 17.2513 11.0962 17 11.0962C16.7487 11.0962 16.5353 11.184 16.3596 11.3596C16.184 11.5353 16.0962 11.7487 16.0962 12C16.0962 12.2513 16.184 12.4647 16.3596 12.6404C16.5353 12.816 16.7487 12.9038 17 12.9038ZM15 9.90385C15.2513 9.90385 15.4648 9.81602 15.6404 9.64037C15.816 9.46474 15.9039 9.25128 15.9039 9C15.9039 8.74872 15.816 8.53526 15.6404 8.35963C15.4648 8.18398 15.2513 8.09615 15 8.09615C14.7487 8.09615 14.5353 8.18398 14.3596 8.35963C14.184 8.53526 14.0962 8.74872 14.0962 9C14.0962 9.25128 14.184 9.46474 14.3596 9.64037C14.5353 9.81602 14.7487 9.90385 15 9.90385ZM8.49957 12.8462C8.67166 12.8462 8.81412 12.7898 8.92695 12.6772C9.03977 12.5646 9.09617 12.4222 9.09617 12.25V11.0962H10.25C10.4222 11.0962 10.5646 11.0399 10.6772 10.9274C10.7899 10.8148 10.8462 10.6725 10.8462 10.5005C10.8462 10.3284 10.7899 10.1859 10.6772 10.0731C10.5646 9.96026 10.4222 9.90385 10.25 9.90385H9.09617V8.75C9.09617 8.57778 9.03991 8.43538 8.92737 8.32278C8.81486 8.21016 8.67256 8.15385 8.50047 8.15385C8.32839 8.15385 8.18593 8.21016 8.0731 8.32278C7.96028 8.43538 7.90387 8.57778 7.90387 8.75V9.90385H6.75002C6.57781 9.90385 6.4354 9.96012 6.3228 10.0726C6.21018 10.1852 6.15387 10.3275 6.15387 10.4995C6.15387 10.6716 6.21018 10.8141 6.3228 10.9269C6.4354 11.0397 6.57781 11.0962 6.75002 11.0962H7.90387V12.25C7.90387 12.4222 7.96014 12.5646 8.07267 12.6772C8.18519 12.7898 8.32749 12.8462 8.49957 12.8462Z", fill: "currentColor" })
});
P({
  displayName: "GasDropIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.25 13.846V17.5998C11.25 17.7921 11.3436 17.912 11.5307 17.9594C11.7179 18.0068 11.859 17.953 11.9538 17.7979L14.9082 12.8429C15.0052 12.6885 15.0095 12.5351 14.9211 12.3825C14.8326 12.2299 14.7026 12.1537 14.5309 12.1537H12.7499V8.39983C12.7499 8.20753 12.6564 8.08766 12.4692 8.04021C12.282 7.99278 12.141 8.04663 12.0461 8.20176L9.0918 13.1567C8.99472 13.3111 8.99041 13.4645 9.07888 13.6171C9.16733 13.7697 9.29738 13.846 9.46905 13.846H11.25ZM11.9982 21.4998C9.85708 21.4998 8.07211 20.7643 6.64327 19.2935C5.21442 17.8226 4.5 15.9918 4.5 13.8012C4.5 12.831 4.71987 11.8577 5.15962 10.8811C5.59936 9.90458 6.14903 8.96741 6.80865 8.06961C7.46827 7.17181 8.18173 6.3273 8.94903 5.53608C9.71633 4.74487 10.4288 4.05651 11.0865 3.47101C11.2134 3.35049 11.356 3.26107 11.5141 3.20273C11.6723 3.1444 11.8343 3.11523 12 3.11523C12.1657 3.11523 12.3276 3.1444 12.4858 3.20273C12.644 3.26107 12.7865 3.35049 12.9134 3.47101C13.5711 4.05651 14.2836 4.74487 15.0509 5.53608C15.8182 6.3273 16.5317 7.17181 17.1913 8.06961C17.8509 8.96741 18.4006 9.90458 18.8403 10.8811C19.2801 11.8577 19.5 12.831 19.5 13.8012C19.5 15.9918 18.7849 17.8226 17.3549 19.2935C15.9249 20.7643 14.1393 21.4998 11.9982 21.4998ZM12 19.9998C13.7333 19.9998 15.1666 19.4123 16.3 18.2373C17.4333 17.0623 18 15.5831 18 13.7998C18 12.5831 17.4958 11.2081 16.4875 9.67481C15.4791 8.14148 13.9833 6.46648 12 4.64981C10.0166 6.46648 8.52081 8.14148 7.51247 9.67481C6.50414 11.2081 5.99997 12.5831 5.99997 13.7998C5.99997 15.5831 6.56664 17.0623 7.69997 18.2373C8.83331 19.4123 10.2666 19.9998 12 19.9998Z", fill: "currentColor" })
});
P({
  displayName: "GlobeIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M 12 21.996094 C 10.601562 21.996094 9.292969 21.734375 8.074219 21.210938 C 6.859375 20.683594 5.800781 19.972656 4.902344 19.074219 C 4 18.171875 3.292969 17.109375 2.777344 15.886719 C 2.257812 14.660156 2 13.347656 2 11.949219 C 2 10.546875 2.257812 9.242188 2.777344 8.035156 C 3.292969 6.828125 4 5.773438 4.902344 4.875 C 5.800781 3.972656 6.859375 3.269531 8.074219 2.761719 C 9.292969 2.253906 10.601562 1.996094 12 1.996094 C 13.402344 1.996094 14.710938 2.253906 15.925781 2.761719 C 17.144531 3.269531 18.199219 3.972656 19.101562 4.875 C 20 5.773438 20.710938 6.828125 21.226562 8.035156 C 21.742188 9.242188 22 10.546875 22 11.949219 C 22 13.347656 21.742188 14.660156 21.226562 15.886719 C 20.710938 17.109375 20 18.171875 19.101562 19.074219 C 18.199219 19.972656 17.144531 20.683594 15.925781 21.210938 C 14.710938 21.734375 13.402344 21.996094 12 21.996094 Z M 12 20.546875 C 12.585938 19.949219 13.070312 19.261719 13.464844 18.484375 C 13.855469 17.710938 14.175781 16.789062 14.425781 15.722656 L 9.601562 15.722656 C 9.835938 16.722656 10.148438 17.625 10.539062 18.421875 C 10.929688 19.222656 11.417969 19.929688 12 20.546875 Z M 9.875 20.25 C 9.460938 19.613281 9.101562 18.929688 8.800781 18.199219 C 8.5 17.464844 8.25 16.640625 8.050781 15.722656 L 4.300781 15.722656 C 4.933594 16.90625 5.667969 17.835938 6.5 18.511719 C 7.335938 19.183594 8.460938 19.765625 9.875 20.25 Z M 14.152344 20.222656 C 15.351562 19.839844 16.429688 19.265625 17.386719 18.5 C 18.347656 17.730469 19.117188 16.804688 19.699219 15.722656 L 15.976562 15.722656 C 15.757812 16.625 15.503906 17.441406 15.214844 18.171875 C 14.921875 18.90625 14.566406 19.589844 14.152344 20.222656 Z M 3.800781 14.222656 L 7.777344 14.222656 C 7.726562 13.773438 7.695312 13.367188 7.6875 13.011719 C 7.679688 12.652344 7.675781 12.296875 7.675781 11.949219 C 7.675781 11.53125 7.683594 11.160156 7.699219 10.835938 C 7.71875 10.511719 7.75 10.148438 7.800781 9.75 L 3.800781 9.75 C 3.683594 10.148438 3.605469 10.507812 3.5625 10.824219 C 3.523438 11.140625 3.5 11.515625 3.5 11.949219 C 3.5 12.382812 3.523438 12.769531 3.5625 13.109375 C 3.605469 13.453125 3.683594 13.824219 3.800781 14.222656 Z M 9.324219 14.222656 L 14.699219 14.222656 C 14.769531 13.707031 14.808594 13.285156 14.824219 12.960938 C 14.84375 12.636719 14.851562 12.296875 14.851562 11.949219 C 14.851562 11.613281 14.84375 11.292969 14.824219 10.984375 C 14.808594 10.675781 14.769531 10.265625 14.699219 9.75 L 9.324219 9.75 C 9.257812 10.265625 9.21875 10.675781 9.199219 10.984375 C 9.183594 11.292969 9.175781 11.613281 9.175781 11.949219 C 9.175781 12.296875 9.183594 12.636719 9.199219 12.960938 C 9.21875 13.285156 9.257812 13.707031 9.324219 14.222656 Z M 16.199219 14.222656 L 20.199219 14.222656 C 20.316406 13.824219 20.398438 13.453125 20.4375 13.109375 C 20.480469 12.769531 20.5 12.382812 20.5 11.949219 C 20.5 11.515625 20.480469 11.140625 20.4375 10.824219 C 20.398438 10.507812 20.316406 10.148438 20.199219 9.75 L 16.226562 9.75 C 16.277344 10.332031 16.308594 10.777344 16.324219 11.085938 C 16.34375 11.394531 16.351562 11.679688 16.351562 11.949219 C 16.351562 12.316406 16.339844 12.660156 16.3125 12.984375 C 16.289062 13.3125 16.25 13.722656 16.199219 14.222656 Z M 15.949219 8.25 L 19.699219 8.25 C 19.152344 7.097656 18.398438 6.140625 17.4375 5.371094 C 16.480469 4.605469 15.375 4.066406 14.125 3.75 C 14.542969 4.363281 14.898438 5.03125 15.1875 5.746094 C 15.480469 6.464844 15.734375 7.296875 15.949219 8.25 Z M 9.601562 8.25 L 14.449219 8.25 C 14.269531 7.363281 13.960938 6.511719 13.527344 5.6875 C 13.09375 4.859375 12.585938 4.132812 12 3.496094 C 11.46875 3.949219 11.019531 4.539062 10.652344 5.273438 C 10.285156 6.007812 9.933594 7 9.601562 8.25 Z M 4.300781 8.25 L 8.074219 8.25 C 8.257812 7.347656 8.492188 6.542969 8.777344 5.835938 C 9.058594 5.128906 9.417969 4.441406 9.851562 3.773438 C 8.601562 4.089844 7.507812 4.621094 6.574219 5.371094 C 5.644531 6.121094 4.882812 7.082031 4.300781 8.25 Z M 4.300781 8.25 ", fill: "currentColor" })
});
P({
  displayName: "GroupIcon",
  viewBox: "0 0 32 32",
  path: w.createElement("path", { d: "M2.89551 22.7796C2.89551 22.0924 3.07286 21.4792 3.42757 20.9399C3.78226 20.4006 4.25595 19.981 4.84864 19.6811C6.11577 19.0613 7.38993 18.5835 8.67111 18.2476C9.95231 17.9117 11.3604 17.7438 12.8955 17.7438C14.4305 17.7438 15.8386 17.9117 17.1198 18.2476C18.401 18.5835 19.6752 19.0613 20.9423 19.6811C21.535 19.981 22.0087 20.4006 22.3634 20.9399C22.7181 21.4792 22.8954 22.0924 22.8954 22.7796V23.7181C22.8954 24.2548 22.6984 24.7266 22.3044 25.1334C21.9104 25.5402 21.4322 25.7437 20.8698 25.7437H4.92111C4.35873 25.7437 3.88054 25.5466 3.48654 25.1526C3.09254 24.7586 2.89554 24.2804 2.89554 23.7181L2.89551 22.7796ZM28.0749 25.7437H25.0467C25.2142 25.4377 25.342 25.112 25.43 24.7667C25.5181 24.4214 25.5621 24.0718 25.5621 23.7181V22.6155C25.5621 21.7403 25.3478 20.9062 24.9192 20.1132C24.4906 19.3202 23.8827 18.6398 23.0955 18.072C23.9895 18.2053 24.8382 18.4117 25.6416 18.6912C26.445 18.9707 27.2116 19.301 27.9415 19.6822C28.6304 20.0497 29.1625 20.4829 29.5377 20.9817C29.9129 21.4805 30.1005 22.0251 30.1005 22.6155V23.7181C30.1005 24.2804 29.9035 24.7586 29.5095 25.1526C29.1155 25.5466 28.6373 25.7437 28.0749 25.7437ZM12.8955 15.5898C11.6122 15.5898 10.5136 15.1329 9.59967 14.219C8.68579 13.3051 8.22884 12.2065 8.22884 10.9232C8.22884 9.63989 8.68579 8.54129 9.59967 7.62743C10.5136 6.71354 11.6122 6.25659 12.8955 6.25659C14.1788 6.25659 15.2774 6.71354 16.1913 7.62743C17.1051 8.54129 17.5621 9.63989 17.5621 10.9232C17.5621 12.2065 17.1051 13.3051 16.1913 14.219C15.2774 15.1329 14.1788 15.5898 12.8955 15.5898ZM24.4082 10.9232C24.4082 12.2065 23.9512 13.3051 23.0373 14.219C22.1235 15.1329 21.0249 15.5898 19.7415 15.5898C19.5911 15.5898 19.3997 15.5727 19.1672 15.5386C18.9347 15.5044 18.7433 15.4668 18.5929 15.4258C19.1187 14.7936 19.5228 14.0923 19.8052 13.3219C20.0876 12.5514 20.2287 11.7513 20.2287 10.9216C20.2287 10.0919 20.0847 9.29504 19.7967 8.53093C19.5087 7.76684 19.1074 7.06343 18.5929 6.42069C18.7843 6.35232 18.9758 6.30787 19.1672 6.28736C19.3587 6.26685 19.5501 6.25659 19.7415 6.25659C21.0249 6.25659 22.1235 6.71354 23.0373 7.62743C23.9512 8.54129 24.4082 9.63989 24.4082 10.9232ZM4.89547 23.7437H20.8955V22.7796C20.8955 22.501 20.8258 22.2531 20.6865 22.036C20.5472 21.8189 20.3262 21.6292 20.0237 21.4668C18.9262 20.901 17.7963 20.4723 16.6339 20.1809C15.4715 19.8894 14.2254 19.7437 12.8955 19.7437C11.5656 19.7437 10.3194 19.8894 9.15701 20.1809C7.99463 20.4723 6.86472 20.901 5.76727 21.4668C5.46472 21.6292 5.24377 21.8189 5.10444 22.036C4.96513 22.2531 4.89547 22.501 4.89547 22.7796V23.7437ZM12.8955 13.5899C13.6288 13.5899 14.2566 13.3288 14.7788 12.8066C15.301 12.2843 15.5621 11.6566 15.5621 10.9232C15.5621 10.1899 15.301 9.56211 14.7788 9.03989C14.2566 8.51767 13.6288 8.25656 12.8955 8.25656C12.1621 8.25656 11.5344 8.51767 11.0121 9.03989C10.4899 9.56211 10.2288 10.1899 10.2288 10.9232C10.2288 11.6566 10.4899 12.2843 11.0121 12.8066C11.5344 13.3288 12.1621 13.5899 12.8955 13.5899Z", fill: "currentColor" })
});
P({
  displayName: "GroupAddIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12.4657 11.9869C12.8914 11.524 13.2061 10.9926 13.4099 10.3927C13.6138 9.79266 13.7157 9.17407 13.7157 8.53691C13.7157 7.89974 13.6138 7.28116 13.4099 6.68116C13.2061 6.08116 12.8914 5.54975 12.4657 5.08693C13.3439 5.18821 14.0731 5.56738 14.6532 6.22443C15.2333 6.88146 15.5234 7.65229 15.5234 8.53691C15.5234 9.42151 15.2333 10.1923 14.6532 10.8494C14.0731 11.5064 13.3439 11.8856 12.4657 11.9869ZM17.3272 19.6522C17.4499 19.5476 17.5453 19.4168 17.6135 19.2599C17.6816 19.1029 17.7157 18.9273 17.7157 18.733V17.3061C17.7157 16.761 17.6048 16.2423 17.383 15.7501C17.1612 15.258 16.8465 14.8356 16.4388 14.4831C17.2055 14.7382 17.9112 15.0824 18.5561 15.5158C19.201 15.9491 19.5234 16.5459 19.5234 17.3061V18.7484C19.5234 19.0045 19.4368 19.2191 19.2635 19.3924C19.0903 19.5656 18.8756 19.6522 18.6195 19.6522H17.3272ZM20.273 13.0946C20.0604 13.0946 19.8823 13.0227 19.7388 12.8789C19.5952 12.7352 19.5234 12.5571 19.5234 12.3446V11.0946H18.2734C18.0609 11.0946 17.8827 11.0227 17.739 10.8789C17.5953 10.735 17.5234 10.5568 17.5234 10.3443C17.5234 10.1317 17.5953 9.95357 17.739 9.80998C17.8827 9.6664 18.0609 9.59461 18.2734 9.59461H19.5234V8.34458C19.5234 8.13208 19.5953 7.95396 19.7391 7.81021C19.8829 7.66647 20.0611 7.59461 20.2737 7.59461C20.4863 7.59461 20.6644 7.66647 20.808 7.81021C20.9515 7.95396 21.0233 8.13208 21.0233 8.34458V9.59461H22.2734C22.4859 9.59461 22.664 9.66651 22.8077 9.81031C22.9515 9.95412 23.0233 10.1323 23.0233 10.3449C23.0233 10.5575 22.9515 10.7356 22.8077 10.8792C22.664 11.0228 22.4859 11.0946 22.2734 11.0946H21.0233V12.3446C21.0233 12.5571 20.9514 12.7352 20.8076 12.8789C20.6638 13.0227 20.4856 13.0946 20.273 13.0946ZM8.21574 12.0369C7.25326 12.0369 6.42931 11.6942 5.74389 11.0088C5.05849 10.3233 4.71579 9.49939 4.71579 8.53691C4.71579 7.57441 5.05849 6.75046 5.74389 6.06506C6.42931 5.37964 7.25326 5.03693 8.21574 5.03693C9.17824 5.03693 10.0022 5.37964 10.6876 6.06506C11.373 6.75046 11.7157 7.57441 11.7157 8.53691C11.7157 9.49939 11.373 10.3233 10.6876 11.0088C10.0022 11.6942 9.17824 12.0369 8.21574 12.0369ZM1.61961 19.6522C1.36353 19.6522 1.14886 19.5656 0.975615 19.3924C0.802398 19.2191 0.71579 19.0045 0.71579 18.7484V17.4292C0.71579 16.9394 0.848798 16.4859 1.11481 16.0686C1.38085 15.6513 1.7363 15.3305 2.18116 15.1061C3.16961 14.6215 4.16672 14.2581 5.17249 14.0158C6.17826 13.7735 7.19267 13.6523 8.21574 13.6523C9.23881 13.6523 10.2532 13.7735 11.259 14.0158C12.2648 14.2581 13.2619 14.6215 14.2503 15.1061C14.6952 15.3305 15.0506 15.6513 15.3167 16.0686C15.5827 16.4859 15.7157 16.9394 15.7157 17.4292V18.7484C15.7157 19.0045 15.6291 19.2191 15.4559 19.3924C15.2826 19.5656 15.0679 19.6522 14.8119 19.6522H1.61961ZM8.21574 10.5369C8.76574 10.5369 9.23657 10.3411 9.62824 9.94941C10.0199 9.55774 10.2157 9.08691 10.2157 8.53691C10.2157 7.98691 10.0199 7.51607 9.62824 7.12441C9.23657 6.73274 8.76574 6.53691 8.21574 6.53691C7.66574 6.53691 7.19491 6.73274 6.80324 7.12441C6.41157 7.51607 6.21574 7.98691 6.21574 8.53691C6.21574 9.08691 6.41157 9.55774 6.80324 9.94941C7.19491 10.3411 7.66574 10.5369 8.21574 10.5369ZM2.21574 18.1523H14.2157V17.4292C14.2157 17.2266 14.1571 17.0391 14.0398 16.8667C13.9225 16.6942 13.7632 16.5535 13.5619 16.4446C12.7004 16.0202 11.8219 15.6987 10.9264 15.4801C10.031 15.2615 9.12746 15.1523 8.21574 15.1523C7.30404 15.1523 6.40047 15.2615 5.50504 15.4801C4.60962 15.6987 3.73114 16.0202 2.86959 16.4446C2.66831 16.5535 2.50901 16.6942 2.39171 16.8667C2.2744 17.0391 2.21574 17.2266 2.21574 17.4292V18.1523Z", fill: "currentColor" })
});
P({
  displayName: "GrowthIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M8.34608 12.9577V7.25002C8.34608 6.99392 8.4327 6.77926 8.60593 6.60603C8.77917 6.43279 8.99383 6.34617 9.24993 6.34617H9.86528C10.0887 6.34617 10.2759 6.42173 10.4271 6.57285C10.5782 6.72397 10.6537 6.91122 10.6537 7.13462V12.9577L10.5768 12.8807C10.2765 12.5846 9.91748 12.4365 9.49968 12.4365C9.0819 12.4365 8.72301 12.5846 8.42301 12.8807L8.34608 12.9577ZM13.0191 14.823V3.25002C13.0191 2.99392 13.1058 2.77926 13.279 2.60603C13.4522 2.43279 13.6669 2.34617 13.923 2.34617H14.5383C14.7617 2.34617 14.949 2.42173 15.1001 2.57285C15.2512 2.72397 15.3268 2.91122 15.3268 3.13462V12.5154L13.0191 14.823ZM3.65381 17.6191V11.25C3.65381 10.9939 3.74043 10.7793 3.91366 10.606C4.08689 10.4328 4.30155 10.3462 4.55763 10.3462H5.17301C5.39639 10.3462 5.58364 10.4217 5.73476 10.5729C5.88587 10.724 5.96143 10.9112 5.96143 11.1346V15.3115L3.65381 17.6191ZM5.39636 20.8C5.06796 20.8 4.8387 20.6471 4.70858 20.3414C4.57845 20.0356 4.63326 19.7628 4.87301 19.5231L8.87683 15.5192C9.04093 15.3551 9.2406 15.2648 9.47583 15.2481C9.71105 15.2314 9.91972 15.3051 10.1018 15.4692L13.0191 17.9769L19.1961 11.8H17.9999C17.7874 11.8 17.6093 11.7281 17.4655 11.5843C17.3218 11.4405 17.2499 11.2623 17.2499 11.0497C17.2499 10.8371 17.3218 10.659 17.4655 10.5154C17.6093 10.3718 17.7874 10.3 17.9999 10.3H20.8461C21.1021 10.3 21.3168 10.3866 21.49 10.5599C21.6633 10.7331 21.7499 10.9478 21.7499 11.2038V14.05C21.7499 14.2625 21.678 14.4406 21.5342 14.5843C21.3904 14.7281 21.2122 14.8 20.9996 14.8C20.787 14.8 20.6089 14.7281 20.4653 14.5843C20.3217 14.4406 20.2499 14.2625 20.2499 14.05V12.8538L13.673 19.4307C13.5089 19.5949 13.3092 19.6852 13.074 19.7019C12.8388 19.7186 12.6301 19.6448 12.448 19.4807L9.53068 16.9731L5.92681 20.5769C5.86366 20.6389 5.78473 20.6915 5.69001 20.7349C5.59528 20.7783 5.49739 20.8 5.39636 20.8Z", fill: "currentColor" })
});
P({
  displayName: "HandIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.17041 5.31518C5.80614 4.8117 5.91899 4.10826 6.42247 3.74399C6.92594 3.37972 7.62939 3.49257 7.99366 3.99604L12.3557 10.0251C12.4958 10.2187 12.7712 10.2639 12.9723 10.135C13.19 9.99537 13.2367 9.70706 13.0851 9.49753L9.73869 4.87228C9.37442 4.36881 9.48727 3.66536 9.99075 3.30109C10.4942 2.93682 11.1977 3.04967 11.5619 3.55315L15.6823 9.24811C15.7194 9.29275 15.7576 9.33855 15.7969 9.38544C15.9293 9.54345 16.0738 9.71389 16.2266 9.89413C16.4891 10.2037 16.9986 10.0465 17.0389 9.64264L17.2295 7.7321C17.3014 7.01129 17.9137 6.44667 18.6359 6.43517C19.4007 6.42299 20.008 7.03303 19.9924 7.79773L19.914 11.6356C19.9099 12.9958 19.9 14.7066 19.876 15.0402C19.7545 16.7257 19.3445 18.5049 17.2165 20.0615C15.5514 21.2794 13.0155 21.2965 12.0171 21.1558C9.72927 20.8335 7.80407 18.494 6.66373 16.7466L2.84285 11.4655C2.47858 10.962 2.59143 10.2586 3.09491 9.89433C3.59838 9.53006 4.30183 9.64291 4.6661 10.1464L7.0156 13.3938C7.15436 13.5855 7.40624 13.6444 7.60701 13.5191C7.82809 13.381 7.89764 13.0773 7.74486 12.8661L4.12574 7.86396C3.76147 7.36049 3.87432 6.65704 4.37779 6.29277C4.88127 5.9285 5.58471 6.04135 5.94898 6.54483L9.69069 11.7164C9.82986 11.9088 10.0939 11.9605 10.2948 11.8339C10.5148 11.6954 10.5724 11.3994 10.42 11.1888L6.17041 5.31518Z", fill: "currentColor" })
});
P({
  displayName: "HandCheckIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12.9249 8.9366L18.0826 3.80388C18.2211 3.66543 18.391 3.59524 18.5922 3.59332C18.7935 3.59139 18.9685 3.66478 19.1172 3.8135C19.2557 3.95197 19.3249 4.126 19.3249 4.3356C19.3249 4.54522 19.2557 4.71925 19.1172 4.8577L13.5576 10.4173C13.3768 10.5981 13.1659 10.6885 12.9249 10.6885C12.6839 10.6885 12.473 10.5981 12.2923 10.4173L9.55763 7.6827C9.40891 7.53398 9.33552 7.35835 9.33745 7.1558C9.33937 6.95323 9.4179 6.77759 9.57303 6.62888C9.72173 6.49043 9.89736 6.42024 10.0999 6.41832C10.3025 6.41639 10.4781 6.48978 10.6268 6.6385L12.9249 8.9366ZM13.873 20.602C13.9051 20.6148 13.9339 20.6212 13.9596 20.6212C13.9852 20.6212 14.014 20.6148 14.0461 20.602L19.9288 18.7808C19.8775 18.5539 19.7711 18.3798 19.6096 18.2586C19.448 18.1375 19.2673 18.0769 19.0673 18.0769H14.1711C13.7339 18.0769 13.3628 18.0603 13.0576 18.0269C12.7525 17.9936 12.439 17.9205 12.1173 17.8077L10.548 17.2942C10.3454 17.2301 10.2002 17.1019 10.1124 16.9096C10.0246 16.7173 10.0128 16.5199 10.0769 16.3173C10.141 16.1212 10.265 15.9766 10.449 15.8837C10.6329 15.7908 10.8262 15.7763 11.0288 15.8404L12.3288 16.2962C12.6313 16.3924 12.9698 16.4606 13.3442 16.501C13.7185 16.5414 14.2044 16.5667 14.8019 16.577H15.0673C15.0673 16.3295 15.0115 16.1161 14.8999 15.9366C14.7884 15.7571 14.6416 15.6359 14.4596 15.5731L8.65763 13.4424C8.6384 13.4359 8.62076 13.4311 8.60473 13.4279C8.58871 13.4247 8.57109 13.4231 8.55185 13.4231H6.70183V18.5769L13.873 20.602ZM13.4826 22.0711L6.70183 20.1269C6.58773 20.541 6.35568 20.8734 6.00568 21.124C5.65568 21.3747 5.28517 21.5 4.89415 21.5H3.50958C3.01086 21.5 2.5849 21.3234 2.2317 20.9702C1.8785 20.617 1.7019 20.191 1.7019 19.6923V13.7308C1.7019 13.2321 1.8785 12.8062 2.2317 12.453C2.5849 12.0998 3.01086 11.9232 3.50958 11.9232H8.54223C8.64608 11.9232 8.75153 11.934 8.85858 11.9558C8.96563 11.9776 9.06595 12.0052 9.15953 12.0385L14.9865 14.1847C15.4403 14.3526 15.8172 14.6497 16.1172 15.076C16.4172 15.5023 16.5672 16.0026 16.5672 16.577H19.0673C19.7852 16.577 20.3701 16.8087 20.822 17.2722C21.2739 17.7356 21.4999 18.3372 21.4999 19.0769C21.4999 19.3603 21.4249 19.5885 21.2749 19.7615C21.1249 19.9346 20.898 20.0718 20.5942 20.1731L14.5269 22.0558C14.3628 22.1096 14.1903 22.1381 14.0096 22.1413C13.8288 22.1445 13.6531 22.1211 13.4826 22.0711ZM3.20188 19.6923C3.20188 19.782 3.23072 19.8558 3.2884 19.9135C3.3461 19.9712 3.41983 20 3.50958 20H4.89415C4.9839 20 5.05763 19.976 5.11533 19.9279C5.17303 19.8798 5.20188 19.8013 5.20188 19.6923V13.4231H3.50958C3.41983 13.4231 3.3461 13.452 3.2884 13.5097C3.23072 13.5674 3.20188 13.6411 3.20188 13.7308V19.6923Z", fill: "currentColor" })
});
P({
  displayName: "HardwareIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.6221 1.64645C17.4269 1.45118 17.1103 1.45118 16.915 1.64645L12.8016 5.75989L12.4353 5.39363C12.0448 5.00311 11.4116 5.00311 11.0211 5.39363L2.61433 13.8004C1.44276 14.972 1.44276 16.8715 2.61433 18.043L5.66621 21.0949C6.83779 22.2665 8.73728 22.2665 9.90885 21.0949L18.3156 12.6882C18.7061 12.2976 18.7061 11.6645 18.3156 11.2739L18.2401 11.1984L22.3536 7.08499C22.5488 6.88973 22.5488 6.57314 22.3536 6.37788L17.6221 1.64645ZM17.533 10.4913L21.2929 6.73144L17.2686 2.70711L13.5087 6.467L17.533 10.4913ZM17.6221 5.50773C17.8174 5.31247 17.8174 4.99588 17.6221 4.80062C17.4269 4.60536 17.1103 4.60536 16.915 4.80062L15.8636 5.85205C15.6683 6.04731 15.6683 6.3639 15.8636 6.55916C16.0588 6.75442 16.3754 6.75442 16.5707 6.55916L17.6221 5.50773ZM19.1993 6.37801C19.3945 6.57328 19.3945 6.88986 19.1993 7.08512L18.1478 8.13655C17.9526 8.33181 17.636 8.33181 17.4407 8.13655C17.2455 7.94129 17.2455 7.62471 17.4407 7.42944L18.4922 6.37801C18.6874 6.18275 19.004 6.18275 19.1993 6.37801Z", fill: "currentColor" })
});
P({
  displayName: "HeadsetIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3C7.55556 3 4 6.27273 4 10.3636V15.372C4 16.023 4.28095 16.6473 4.78105 17.1076C5.28115 17.5679 5.95942 17.8265 6.66667 17.8265H8.83333C9.10948 17.8265 9.33333 17.6027 9.33333 17.3265V12.5C9.33333 12.2239 9.10948 12 8.83333 12H6.27778C6.00164 12 5.77778 11.7761 5.77778 11.5V10.3636C5.77778 8.84467 6.43333 7.38791 7.60022 6.31384C8.76712 5.23977 10.3498 4.63636 12 4.63636C13.6502 4.63636 15.2329 5.23977 16.3998 6.31384C17.5667 7.38791 18.2222 8.84467 18.2222 10.3636V11.5C18.2222 11.7761 17.9984 12 17.7222 12H15.1667C14.8905 12 14.6667 12.2239 14.6667 12.5V17.3265C14.6667 17.6027 14.8905 17.8265 15.1667 17.8265H17.7222C17.9984 17.8265 18.2222 18.0504 18.2222 18.3265V18.8636C18.2222 19.1398 17.9984 19.3636 17.7222 19.3636H12.5C12.2239 19.3636 12 19.5875 12 19.8636V20.5C12 20.7761 12.2239 21 12.5 21H17.3333C18.0406 21 18.7189 20.7414 19.219 20.2811C19.719 19.8208 20 19.1964 20 18.5455V10.3636C20 6.27273 16.4178 3 12 3Z", fill: "currentColor" })
});
P({
  displayName: "HeartIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.6471 21.197L12 21.5L12.3529 21.197C19.9412 14.8333 22 12.5909 22 8.95455C22 5.92424 19.6471 3.5 16.7059 3.5C15.2979 3.5 14.2507 3.97511 13.4357 4.58765C12.8547 5.02432 12.3917 5.53083 12 5.98485C11.6083 5.53083 11.1453 5.02432 10.5643 4.58765C9.74928 3.97511 8.70214 3.5 7.29412 3.5C4.35294 3.5 2 5.92424 2 8.95455C2 12.5909 4.05882 14.8333 11.6471 21.197ZM12 18.8797C15.2639 16.1197 17.2575 14.2919 18.4665 12.7959C19.6841 11.2892 20 10.2526 20 8.95455C20 6.97211 18.4866 5.5 16.7059 5.5C15.2223 5.5 14.3838 6.28351 13.5143 7.29132L12 9.04654L10.4857 7.29132C9.61621 6.28351 8.77771 5.5 7.29412 5.5C5.51337 5.5 4 6.97211 4 8.95455C4 10.2526 4.31586 11.2892 5.53348 12.7959C6.74247 14.2919 8.7361 16.1197 12 18.8797Z", fill: "currentColor" })
});
P({
  displayName: "HeartSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M21 12.3397C19.6325 16.898 13.2781 19.7941 12.1663 20.2701C12.0575 20.3167 11.9407 20.3199 11.8296 20.2793C10.7062 19.8684 4.36583 17.3477 3.00001 12.3397C1.53434 6.96553 6.7519 2.54618 11.656 6.54473C11.8543 6.70639 12.1458 6.7062 12.3445 6.54508C17.2485 2.56888 22.4656 7.45425 21 12.3397Z", fill: "currentColor" })
});
P({
  displayName: "HubIcon",
  viewBox: "0 0 32 32",
  path: w.createElement("path", { d: "M9.19261 28C8.32615 28 7.58923 27.6991 6.98186 27.0972C6.37448 26.4954 6.07079 25.7646 6.07079 24.9049C6.07079 24.0452 6.37421 23.314 6.98103 22.7114C7.58788 22.1087 8.32475 21.8074 9.19165 21.8074C9.43439 21.8074 9.67288 21.8373 9.90711 21.8972C10.1413 21.9571 10.3624 22.0376 10.5705 22.1387L12.8204 19.3606C12.3491 18.8511 12.0239 18.2809 11.845 17.6501C11.666 17.0193 11.6297 16.3849 11.7358 15.7469L8.46682 14.6729C8.18168 15.1276 7.80676 15.4921 7.34206 15.7663C6.87735 16.0406 6.35903 16.1777 5.78707 16.1777C4.92026 16.1777 4.18346 15.8768 3.57669 15.275C2.96992 14.6732 2.66652 13.9424 2.6665 13.0827C2.6665 12.223 2.96977 11.4918 3.57629 10.8891C4.18282 10.2865 4.91931 9.98515 5.78577 9.98515C6.65223 9.98515 7.38915 10.2862 7.99652 10.8882C8.6039 11.4903 8.9076 12.2213 8.90762 13.0814C8.90762 13.1478 8.9058 13.2034 8.90217 13.2481C8.89854 13.2929 8.89672 13.3377 8.89672 13.3824L12.1548 14.5062C12.4676 13.9317 12.8971 13.4387 13.4434 13.0274C13.9897 12.616 14.6163 12.3518 15.3234 12.2349V8.77906C14.5931 8.60873 14.0031 8.24244 13.5536 7.68021C13.1041 7.11798 12.8793 6.47738 12.8793 5.75842C12.8793 4.90253 13.1826 4.17326 13.7891 3.57061C14.3956 2.96795 15.1321 2.66663 15.9986 2.66663C16.865 2.66663 17.602 2.96765 18.2093 3.5697C18.8167 4.17176 19.1204 4.90282 19.1204 5.7629C19.1204 6.47888 18.8927 7.11798 18.4374 7.68021C17.982 8.24244 17.395 8.60873 16.6763 8.77906V12.2349C17.3834 12.3518 18.0082 12.616 18.5508 13.0274C19.0935 13.4387 19.5248 13.9317 19.8449 14.5062L23.103 13.3824C23.0957 13.3304 23.0921 13.2839 23.0921 13.2427V13.0814C23.0921 12.2213 23.3953 11.4903 24.0019 10.8882C24.6084 10.2862 25.3449 9.98515 26.2114 9.98515C27.0778 9.98515 27.8147 10.2861 28.4221 10.8879C29.0295 11.4897 29.3332 12.2204 29.3332 13.0802C29.3332 13.9399 29.0298 14.6711 28.423 15.2737C27.8162 15.8764 27.0794 16.1777 26.2126 16.1777C25.643 16.1777 25.1224 16.0406 24.6507 15.7663C24.179 15.4921 23.8064 15.1276 23.5329 14.6729L20.2639 15.7469C20.3701 16.3849 20.3337 17.0164 20.1548 17.6414C19.9758 18.2664 19.6506 18.8359 19.1793 19.3498L21.4292 22.1105C21.6373 22.0167 21.8584 21.9427 22.0926 21.8886C22.3268 21.8344 22.5653 21.8074 22.8081 21.8074C23.675 21.8074 24.4118 22.1083 25.0187 22.7101C25.6255 23.3119 25.9289 24.0427 25.9289 24.9024C25.9289 25.7621 25.6256 26.4933 25.0191 27.096C24.4126 27.6986 23.6761 27.9999 22.8096 27.9999C21.9432 27.9999 21.2063 27.6989 20.5989 27.0969C19.9915 26.4948 19.6878 25.7637 19.6878 24.9037C19.6878 24.5486 19.7457 24.2069 19.8613 23.8784C19.977 23.55 20.1497 23.2487 20.3796 22.9744L18.1297 20.1747C17.4852 20.5558 16.7742 20.7463 15.9966 20.7463C15.219 20.7463 14.5043 20.5558 13.8526 20.1747L11.6201 22.9744C11.8427 23.2487 12.0137 23.55 12.133 23.8784C12.2522 24.2069 12.3119 24.5486 12.3119 24.9037C12.3119 25.7637 12.0086 26.4948 11.4021 27.0969C10.7956 27.6989 10.0591 27.9999 9.19261 28ZM5.78707 14.4888C6.18133 14.4888 6.5163 14.3521 6.79201 14.0785C7.0677 13.805 7.20554 13.4726 7.20554 13.0814C7.20554 12.6902 7.0677 12.3578 6.79201 12.0843C6.5163 11.8108 6.18133 11.674 5.78707 11.674C5.39282 11.674 5.05784 11.8108 4.78214 12.0843C4.50647 12.3579 4.36863 12.6902 4.36863 13.0814C4.36863 13.4726 4.50648 13.805 4.78217 14.0785C5.05785 14.3521 5.39282 14.4888 5.78707 14.4888ZM9.19133 26.3111C9.58558 26.3111 9.92056 26.1743 10.1963 25.9008C10.472 25.6272 10.6098 25.2948 10.6098 24.9036C10.6098 24.5124 10.472 24.1801 10.1963 23.9065C9.92056 23.633 9.58558 23.4962 9.19133 23.4962C8.79708 23.4962 8.4621 23.633 8.1864 23.9065C7.91071 24.1801 7.77286 24.5125 7.77286 24.9037C7.77286 25.2948 7.91071 25.6272 8.1864 25.9008C8.4621 26.1743 8.79708 26.3111 9.19133 26.3111ZM15.9999 7.17031C16.3941 7.17031 16.7291 7.03353 17.0048 6.75999C17.2805 6.48643 17.4183 6.15406 17.4183 5.76287C17.4183 5.37169 17.2805 5.03931 17.0048 4.76575C16.7291 4.49222 16.3941 4.35546 15.9999 4.35546C15.6056 4.35546 15.2706 4.49223 14.9949 4.76578C14.7192 5.03934 14.5814 5.37171 14.5814 5.7629C14.5814 6.15408 14.7192 6.48646 14.9949 6.76002C15.2706 7.03356 15.6056 7.17031 15.9999 7.17031ZM15.9999 19.0575C16.7287 19.0575 17.3474 18.8052 17.8558 18.3007C18.3643 17.7962 18.6185 17.1824 18.6185 16.4592C18.6185 15.736 18.3643 15.1221 17.8558 14.6176C17.3474 14.1132 16.7287 13.8609 15.9999 13.8609C15.271 13.8609 14.6523 14.1132 14.1439 14.6177C13.6354 15.1222 13.3812 15.736 13.3812 16.4592C13.3812 17.1824 13.6354 17.7962 14.1439 18.3007C14.6523 18.8052 15.271 19.0575 15.9999 19.0575ZM22.8084 26.3111C23.2026 26.3111 23.5376 26.1743 23.8133 25.9008C24.089 25.6272 24.2268 25.2948 24.2268 24.9036C24.2268 24.5124 24.089 24.1801 23.8133 23.9065C23.5376 23.633 23.2026 23.4962 22.8084 23.4962C22.4141 23.4962 22.0791 23.633 21.8034 23.9065C21.5277 24.1801 21.3899 24.5125 21.3899 24.9037C21.3899 25.2948 21.5277 25.6272 21.8034 25.9008C22.0791 26.1743 22.4141 26.3111 22.8084 26.3111ZM26.2126 14.4888C26.6069 14.4888 26.9419 14.3521 27.2176 14.0785C27.4933 13.805 27.6311 13.4726 27.6311 13.0814C27.6311 12.6902 27.4933 12.3578 27.2176 12.0843C26.9419 11.8108 26.6069 11.674 26.2126 11.674C25.8184 11.674 25.4834 11.8108 25.2077 12.0843C24.932 12.3579 24.7942 12.6902 24.7942 13.0814C24.7942 13.4726 24.932 13.805 25.2077 14.0785C25.4834 14.3521 25.8184 14.4888 26.2126 14.4888Z", fill: "currentColor" })
});
P({
  displayName: "IdeaIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12 20.9422C11.5987 20.9422 11.2439 20.8364 10.9356 20.6249C10.6272 20.4134 10.4115 20.1358 10.2884 19.7922H9.99997C9.59101 19.7922 9.23877 19.6445 8.94327 19.349C8.64776 19.0535 8.5 18.7012 8.5 18.2923V15.0115C7.49103 14.4 6.69712 13.5801 6.11827 12.5519C5.53942 11.5237 5.25 10.423 5.25 9.24998C5.25 7.36794 5.90448 5.77243 7.21345 4.46345C8.52243 3.15448 10.1179 2.5 12 2.5C13.882 2.5 15.4775 3.15448 16.7865 4.46345C18.0955 5.77243 18.75 7.36794 18.75 9.24998C18.75 10.4436 18.4605 11.5493 17.8817 12.5673C17.3028 13.5852 16.5089 14.4 15.5 15.0115V18.2923C15.5 18.7012 15.3522 19.0535 15.0567 19.349C14.7612 19.6445 14.4089 19.7922 14 19.7922H13.7115C13.5884 20.1358 13.3727 20.4134 13.0644 20.6249C12.7561 20.8364 12.4013 20.9422 12 20.9422ZM9.99997 18.2923H14V17.3538H9.99997V18.2923ZM9.99997 16.4692H14V15.5H9.99997V16.4692ZM9.79997 14H11.4038V11.0884L9.26153 8.94613L10.1 8.10768L12 10.0077L13.9 8.10768L14.7384 8.94613L12.5961 11.0884V14H14.2C15.1 13.5666 15.8333 12.9291 16.4 12.0875C16.9666 11.2458 17.25 10.3 17.25 9.24998C17.25 7.78331 16.7416 6.54164 15.725 5.52498C14.7083 4.50831 13.4666 3.99998 12 3.99998C10.5333 3.99998 9.29164 4.50831 8.27497 5.52498C7.25831 6.54164 6.74997 7.78331 6.74997 9.24998C6.74997 10.3 7.03331 11.2458 7.59997 12.0875C8.16664 12.9291 8.89997 13.5666 9.79997 14Z", fill: "currentColor" })
});
P({
  displayName: "ImageIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM5 4C4.44772 4 4 4.44772 4 5V14.8284L5.3803 13.7242C6.35949 12.9408 7.7226 12.8492 8.79787 13.4943L10.2275 14.3521C10.6502 14.6057 11.1946 14.5135 11.5102 14.1348L13.1025 12.2241C14.2318 10.8689 16.281 10.7759 17.5284 12.0233L20 14.4949V5C20 4.44772 19.5523 4 19 4H5ZM4 19V17.3897L6.62969 15.2859C6.95609 15.0248 7.41046 14.9943 7.76888 15.2093L9.19849 16.0671C10.4666 16.8279 12.0999 16.5512 13.0466 15.4151L14.6389 13.5044C15.0154 13.0527 15.6984 13.0217 16.1142 13.4375L20 17.3233V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19ZM9.47723 8.72724C9.47723 8.23772 9.87407 7.84088 10.3636 7.84088C10.8531 7.84088 11.25 8.23772 11.25 8.72724C11.25 9.21677 10.8531 9.61361 10.3636 9.61361C9.87407 9.61361 9.47723 9.21677 9.47723 8.72724ZM10.3636 6.34088C9.04565 6.34088 7.97723 7.40929 7.97723 8.72724C7.97723 10.0452 9.04565 11.1136 10.3636 11.1136C11.6815 11.1136 12.75 10.0452 12.75 8.72724C12.75 7.40929 11.6815 6.34088 10.3636 6.34088Z", fill: "currentColor" })
});
P({
  displayName: "IndexInfoIcon",
  viewBox: "0 0 16 16",
  path: w.createElement("path", { id: "format_indent_increase", d: "M2.64258 13.3724C2.50091 13.3724 2.38216 13.3244 2.28633 13.2285C2.19049 13.1327 2.14258 13.0139 2.14258 12.8721C2.14258 12.7304 2.19049 12.6117 2.28633 12.516C2.38216 12.4202 2.50091 12.3724 2.64258 12.3724H12.9759C13.1175 12.3724 13.2363 12.4203 13.3321 12.5162C13.428 12.6121 13.4759 12.7309 13.4759 12.8726C13.4759 13.0143 13.428 13.133 13.3321 13.2288C13.2363 13.3245 13.1175 13.3724 12.9759 13.3724H2.64258ZM7.97591 10.789C7.83425 10.789 7.7155 10.7411 7.61966 10.6452C7.52383 10.5493 7.47591 10.4305 7.47591 10.2888C7.47591 10.1471 7.52383 10.0284 7.61966 9.93265C7.7155 9.83691 7.83425 9.78905 7.97591 9.78905H12.9759C13.1175 9.78905 13.2363 9.83699 13.3321 9.93286C13.428 10.0287 13.4759 10.1475 13.4759 10.2893C13.4759 10.431 13.428 10.5497 13.3321 10.6454C13.2363 10.7412 13.1175 10.789 12.9759 10.789H7.97591ZM7.97591 8.2057C7.83425 8.2057 7.7155 8.15776 7.61966 8.0619C7.52383 7.96602 7.47591 7.84722 7.47591 7.7055C7.47591 7.56376 7.52383 7.44504 7.61966 7.34931C7.7155 7.25359 7.83425 7.20573 7.97591 7.20573H12.9759C13.1175 7.20573 13.2363 7.25366 13.3321 7.34953C13.428 7.44541 13.4759 7.56421 13.4759 7.70593C13.4759 7.84766 13.428 7.96639 13.3321 8.06211C13.2363 8.15784 13.1175 8.2057 12.9759 8.2057H7.97591ZM7.97591 5.62238C7.83425 5.62238 7.7155 5.57444 7.61966 5.47856C7.52383 5.38268 7.47591 5.26389 7.47591 5.12216C7.47591 4.98043 7.52383 4.8617 7.61966 4.76598C7.7155 4.67026 7.83425 4.6224 7.97591 4.6224H12.9759C13.1175 4.6224 13.2363 4.67034 13.3321 4.76621C13.428 4.86208 13.4759 4.98088 13.4759 5.12261C13.4759 5.26433 13.428 5.38306 13.3321 5.47878C13.2363 5.57451 13.1175 5.62238 12.9759 5.62238H7.97591ZM2.64258 3.03905C2.50091 3.03905 2.38216 2.99111 2.28633 2.89523C2.19049 2.79936 2.14258 2.68056 2.14258 2.53883C2.14258 2.39711 2.19049 2.27839 2.28633 2.18266C2.38216 2.08693 2.50091 2.03906 2.64258 2.03906H12.9759C13.1175 2.03906 13.2363 2.087 13.3321 2.18288C13.428 2.27876 13.4759 2.39756 13.4759 2.53928C13.4759 2.68101 13.428 2.79974 13.3321 2.89546C13.2363 2.99119 13.1175 3.03905 12.9759 3.03905H2.64258ZM2.65796 9.45953C2.55967 9.55782 2.44921 9.5823 2.32656 9.53298C2.20391 9.48366 2.14258 9.38995 2.14258 9.25185V6.15958C2.14258 6.02148 2.20391 5.92777 2.32656 5.87845C2.44921 5.82912 2.55967 5.85361 2.65796 5.9519L4.19768 7.49161C4.26008 7.55245 4.29128 7.62342 4.29128 7.70455C4.29128 7.78567 4.26008 7.85743 4.19768 7.91981L2.65796 9.45953Z", fill: "currentColor" })
});
const Woe = P({
  displayName: "InfoIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12 7C11.6167 7 11.2958 6.87083 11.0375 6.6125C10.7792 6.35417 10.65 6.03333 10.65 5.65C10.65 5.26667 10.7792 4.94583 11.0375 4.6875C11.2958 4.42917 11.6167 4.3 12 4.3C12.3833 4.3 12.7042 4.42917 12.9625 4.6875C13.2208 4.94583 13.35 5.26667 13.35 5.65C13.35 6.03333 13.2208 6.35417 12.9625 6.6125C12.7042 6.87083 12.3833 7 12 7ZM12.0029 19.7C11.7676 19.7 11.5667 19.6174 11.4 19.4521C11.2333 19.2868 11.15 19.0861 11.15 18.85V10.85C11.15 10.6139 11.2323 10.4132 11.397 10.2479C11.5618 10.0826 11.7618 10 11.997 10C12.2323 10 12.4333 10.0826 12.6 10.2479C12.7667 10.4132 12.85 10.6139 12.85 10.85V18.85C12.85 19.0861 12.7676 19.2868 12.6029 19.4521C12.4382 19.6174 12.2382 19.7 12.0029 19.7Z", fill: "currentColor" })
}), K9 = P({
  displayName: "InfoCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12.0003 16.75C12.2129 16.75 12.391 16.6781 12.5346 16.5344C12.6782 16.3906 12.75 16.2125 12.75 16V11.75C12.75 11.5375 12.6781 11.3594 12.5343 11.2156C12.3905 11.0719 12.2123 11 11.9997 11C11.7871 11 11.609 11.0719 11.4654 11.2156C11.3218 11.3594 11.25 11.5375 11.25 11.75V16C11.25 16.2125 11.3219 16.3906 11.4657 16.5344C11.6095 16.6781 11.7877 16.75 12.0003 16.75ZM12 9.28848C12.2288 9.28848 12.4207 9.21108 12.5755 9.05628C12.7303 8.90148 12.8077 8.70965 12.8077 8.4808C12.8077 8.25197 12.7303 8.06014 12.5755 7.90533C12.4207 7.75053 12.2288 7.67312 12 7.67312C11.7711 7.67312 11.5793 7.75053 11.4245 7.90533C11.2697 8.06014 11.1923 8.25197 11.1923 8.4808C11.1923 8.70965 11.2697 8.90148 11.4245 9.05628C11.5793 9.21108 11.7711 9.28848 12 9.28848ZM12.0017 21.5C10.6877 21.5 9.45271 21.2506 8.29657 20.752C7.14042 20.2533 6.13474 19.5766 5.27952 18.7217C4.42429 17.8669 3.74723 16.8616 3.24835 15.706C2.74946 14.5504 2.50002 13.3156 2.50002 12.0017C2.50002 10.6877 2.74936 9.45271 3.24802 8.29658C3.74669 7.14042 4.42344 6.13474 5.27827 5.27952C6.13312 4.42429 7.13836 3.74723 8.294 3.24835C9.44962 2.74947 10.6844 2.50002 11.9983 2.50002C13.3123 2.50002 14.5473 2.74936 15.7034 3.24802C16.8596 3.74669 17.8653 4.42344 18.7205 5.27828C19.5757 6.13313 20.2528 7.13837 20.7516 8.294C21.2505 9.44962 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5766 17.8653 18.7217 18.7205C17.8669 19.5757 16.8616 20.2528 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76666 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76666 20 12 20Z", fill: "currentColor" })
});
P({
  displayName: "InstallationKitIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M9.59998 19.5C7.50631 19.5 5.73289 18.7736 4.27973 17.3207C2.82656 15.8679 2.09998 14.0948 2.09998 12.0015C2.09998 9.90817 2.82656 8.13458 4.27973 6.68075C5.73289 5.22692 7.50631 4.5 9.59998 4.5H15.6C17.6936 4.5 19.4671 5.22642 20.9202 6.67925C22.3734 8.13208 23.1 9.90517 23.1 11.9985C23.1 14.0918 22.3734 15.8654 20.9202 17.3193C19.4671 18.7731 17.6936 19.5 15.6 19.5H9.59998ZM9.59998 18H15.6C17.2666 18 18.6833 17.4167 19.85 16.25C21.0166 15.0833 21.6 13.6667 21.6 12C21.6 10.3333 21.0166 8.91667 19.85 7.75C18.6833 6.58333 17.2666 6 15.6 6H9.59998C7.93331 6 6.51664 6.58333 5.34998 7.75C4.18331 8.91667 3.59998 10.3333 3.59998 12C3.59998 13.6667 4.18331 15.0833 5.34998 16.25C6.51664 17.4167 7.93331 18 9.59998 18ZM12.6 13.75C13.0858 13.75 13.499 13.5798 13.8395 13.2395C14.1798 12.899 14.35 12.4858 14.35 12C14.35 11.5142 14.1798 11.101 13.8395 10.7605C13.499 10.4202 13.0858 10.25 12.6 10.25C12.1141 10.25 11.701 10.4202 11.3605 10.7605C11.0201 11.101 10.85 11.5142 10.85 12C10.85 12.4858 11.0201 12.899 11.3605 13.2395C11.701 13.5798 12.1141 13.75 12.6 13.75ZM11.6 8.75H13.6C13.8125 8.75 13.9906 8.67808 14.1342 8.53425C14.2781 8.39042 14.35 8.21225 14.35 7.99975C14.35 7.78708 14.2781 7.609 14.1342 7.4655C13.9906 7.32183 13.8125 7.25 13.6 7.25H11.6C11.3875 7.25 11.2094 7.32192 11.0657 7.46575C10.9219 7.60958 10.85 7.78775 10.85 8.00025C10.85 8.21292 10.9219 8.391 11.0657 8.5345C11.2094 8.67817 11.3875 8.75 11.6 8.75ZM11.6 16.75H13.6C13.8125 16.75 13.9906 16.6781 14.1342 16.5343C14.2781 16.3904 14.35 16.2122 14.35 15.9998C14.35 15.7871 14.2781 15.609 14.1342 15.4655C13.9906 15.3218 13.8125 15.25 13.6 15.25H11.6C11.3875 15.25 11.2094 15.3219 11.0657 15.4658C10.9219 15.6096 10.85 15.7878 10.85 16.0003C10.85 16.2129 10.9219 16.391 11.0657 16.5345C11.2094 16.6782 11.3875 16.75 11.6 16.75ZM16.6002 13.75C16.8129 13.75 16.991 13.6781 17.1345 13.5343C17.2781 13.3906 17.35 13.2125 17.35 13V11C17.35 10.7875 17.2781 10.6094 17.1342 10.4658C16.9904 10.3219 16.8122 10.25 16.5997 10.25C16.3871 10.25 16.209 10.3219 16.0655 10.4658C15.9218 10.6094 15.85 10.7875 15.85 11V13C15.85 13.2125 15.9219 13.3906 16.0657 13.5343C16.2096 13.6781 16.3877 13.75 16.6002 13.75ZM8.60023 13.75C8.81289 13.75 8.99098 13.6781 9.13448 13.5343C9.27814 13.3906 9.34998 13.2125 9.34998 13V11C9.34998 10.7875 9.27806 10.6094 9.13423 10.4658C8.99039 10.3219 8.81223 10.25 8.59973 10.25C8.38706 10.25 8.20898 10.3219 8.06548 10.4658C7.92181 10.6094 7.84998 10.7875 7.84998 11V13C7.84998 13.2125 7.92189 13.3906 8.06573 13.5343C8.20956 13.6781 8.38773 13.75 8.60023 13.75Z", fill: "currentColor" })
});
P({
  displayName: "InstantMixIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M5.74962 19.5C5.53704 19.5 5.35896 19.4281 5.21537 19.2843C5.07179 19.1406 5 18.9625 5 18.75V12.4423H3.74998C3.53747 12.4423 3.35935 12.3703 3.2156 12.2266C3.07187 12.0827 3 11.9045 3 11.692C3 11.4794 3.07187 11.3013 3.2156 11.1577C3.35935 11.0141 3.53747 10.9423 3.74998 10.9423H7.74997C7.96247 10.9423 8.14059 11.0142 8.28432 11.158C8.42807 11.3018 8.49995 11.48 8.49995 11.6926C8.49995 11.9052 8.42807 12.0833 8.28432 12.2269C8.14059 12.3705 7.96247 12.4423 7.74997 12.4423H6.49995V18.75C6.49995 18.9625 6.42804 19.1406 6.28422 19.2843C6.14042 19.4281 5.96222 19.5 5.74962 19.5ZM5.74962 8.55765C5.53704 8.55765 5.35896 8.48578 5.21537 8.34203C5.07179 8.19829 5 8.02017 5 7.80768V4.74998C5 4.53748 5.0719 4.35935 5.2157 4.2156C5.35952 4.07187 5.53772 4 5.7503 4C5.9629 4 6.14099 4.07187 6.28457 4.2156C6.42816 4.35935 6.49995 4.53748 6.49995 4.74998V7.80768C6.49995 8.02017 6.42804 8.19829 6.28422 8.34203C6.14042 8.48578 5.96222 8.55765 5.74962 8.55765ZM9.8269 8.55765C9.6144 8.55765 9.43628 8.48574 9.29255 8.34193C9.1488 8.19813 9.07692 8.01993 9.07692 7.80733C9.07692 7.59474 9.1488 7.41666 9.29255 7.27308C9.43628 7.12949 9.6144 7.0577 9.8269 7.0577H11.0769V4.74998C11.0769 4.53748 11.1488 4.35935 11.2926 4.2156C11.4364 4.07187 11.6146 4 11.8272 4C12.0398 4 12.2179 4.07187 12.3615 4.2156C12.5051 4.35935 12.5769 4.53748 12.5769 4.74998V7.0577H13.8269C14.0394 7.0577 14.2175 7.1296 14.3613 7.2734C14.505 7.41722 14.5769 7.59542 14.5769 7.808C14.5769 8.0206 14.505 8.19869 14.3613 8.34228C14.2175 8.48586 14.0394 8.55765 13.8269 8.55765H9.8269ZM11.8266 19.5C11.614 19.5 11.4359 19.4281 11.2923 19.2843C11.1487 19.1406 11.0769 18.9625 11.0769 18.75V11.6923C11.0769 11.4798 11.1488 11.3017 11.2926 11.1579C11.4364 11.0142 11.6146 10.9423 11.8272 10.9423C12.0398 10.9423 12.2179 11.0142 12.3615 11.1579C12.5051 11.3017 12.5769 11.4798 12.5769 11.6923V18.75C12.5769 18.9625 12.505 19.1406 12.3612 19.2843C12.2174 19.4281 12.0392 19.5 11.8266 19.5ZM17.9035 19.5C17.6909 19.5 17.5128 19.4281 17.3692 19.2843C17.2256 19.1406 17.1538 18.9625 17.1538 18.75V16.4423H15.9038C15.6913 16.4423 15.5132 16.3703 15.3695 16.2266C15.2257 16.0827 15.1538 15.9045 15.1538 15.692C15.1538 15.4794 15.2257 15.3013 15.3695 15.1577C15.5132 15.0141 15.6913 14.9423 15.9038 14.9423H19.9038C20.1163 14.9423 20.2945 15.0142 20.4382 15.158C20.5819 15.3018 20.6538 15.48 20.6538 15.6926C20.6538 15.9052 20.5819 16.0833 20.4382 16.2269C20.2945 16.3705 20.1163 16.4423 19.9038 16.4423H18.6538V18.75C18.6538 18.9625 18.5819 19.1406 18.4381 19.2843C18.2943 19.4281 18.1161 19.5 17.9035 19.5ZM17.9035 12.5577C17.6909 12.5577 17.5128 12.4858 17.3692 12.342C17.2256 12.1983 17.1538 12.0202 17.1538 11.8077V4.74998C17.1538 4.53748 17.2258 4.35935 17.3696 4.2156C17.5134 4.07187 17.6916 4 17.9042 4C18.1168 4 18.2948 4.07187 18.4384 4.2156C18.582 4.35935 18.6538 4.53748 18.6538 4.74998V11.8077C18.6538 12.0202 18.5819 12.1983 18.4381 12.342C18.2943 12.4858 18.1161 12.5577 17.9035 12.5577Z", fill: "currentColor" })
});
P({
  displayName: "JoystickIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.86434 19C3.24541 19 2.76085 18.7723 2.41067 18.317C2.06049 17.8616 1.93426 17.2321 2.03198 16.4286L3.20469 7.45536C3.33499 6.50893 3.73811 5.69643 4.41405 5.01786C5.08998 4.33929 5.85957 4 6.72281 4H17.3016C18.1649 4 18.9345 4.33929 19.6104 5.01786C20.2863 5.69643 20.6894 6.50893 20.8197 7.45536L21.968 16.4286C22.0657 17.2321 21.9395 17.8616 21.5893 18.317C21.2391 18.7723 20.7546 19 20.1357 19C19.761 19 19.4434 18.933 19.1828 18.7991C18.9222 18.6652 18.7024 18.5 18.5232 18.3036L15.9823 15.5179H8.01768L5.47681 18.3036C5.29765 18.5 5.07777 18.6652 4.81716 18.7991C4.55656 18.933 4.23895 19 3.86434 19ZM17.3749 12.5714C17.6355 12.5714 17.8635 12.4643 18.059 12.25C18.2544 12.0357 18.3522 11.7857 18.3522 11.5C18.3522 11.2143 18.2544 10.9643 18.059 10.75C17.8635 10.5357 17.6355 10.4286 17.3749 10.4286C17.1143 10.4286 16.8863 10.5357 16.6908 10.75C16.4954 10.9643 16.3977 11.2143 16.3977 11.5C16.3977 11.7857 16.4954 12.0357 16.6908 12.25C16.8863 12.4643 17.1143 12.5714 17.3749 12.5714ZM15.2982 9.08929C15.5588 9.08929 15.7869 8.98214 15.9823 8.76786C16.1778 8.55357 16.2755 8.30357 16.2755 8.01786C16.2755 7.73214 16.1778 7.48214 15.9823 7.26786C15.7869 7.05357 15.5588 6.94643 15.2982 6.94643C15.0376 6.94643 14.8096 7.05357 14.6142 7.26786C14.4187 7.48214 14.321 7.73214 14.321 8.01786C14.321 8.30357 14.4187 8.55357 14.6142 8.76786C14.8096 8.98214 15.0376 9.08929 15.2982 9.08929ZM7.60235 12.4375H8.82392V10.4286H10.6563V9.08929H8.82392V7.08036H7.60235V9.08929H5.76999V10.4286H7.60235V12.4375Z", fill: "currentColor" })
});
P({
  displayName: "LedgerIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.6699 3.97326C10.6708 3.15986 10.0117 2.5 9.19826 2.5H4.48885C3.67667 2.5 3.01803 3.15794 3.01716 3.97012L3 20.0267C2.99989 20.1284 3.0101 20.2277 3.02963 20.3236C3.16633 20.9948 3.75996 21.5 4.47169 21.5L9 21.5L9.18109 21.5C9.18189 21.5 9.18269 21.5 9.18349 21.5H19.5283C20.8934 21.5 22 20.3934 22 19.0283L22 14.9717C22 13.6066 20.8934 12.5 19.5283 12.5L10.6608 12.5L10.6699 3.97326ZM10.6587 14.5L10.6533 19.5H19.5283C19.7888 19.5 20 19.2888 20 19.0283L20 14.9717C20 14.7112 19.7888 14.5 19.5283 14.5L10.6587 14.5ZM7.04061 18.7088C8.00535 18.6108 8.75819 17.796 8.75819 16.8054C8.75819 15.7488 7.90162 14.8922 6.845 14.8922C5.78837 14.8922 4.9318 15.7488 4.9318 16.8054C4.9318 17.8621 5.78837 18.7186 6.845 18.7186C6.91103 18.7186 6.97629 18.7153 7.04061 18.7088Z", fill: "currentColor" })
});
P({
  displayName: "LikeIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M19.2827 8.7519C19.7345 8.7519 20.1337 8.92285 20.4802 9.26474C20.8267 9.60662 21 10.0005 21 10.4463V11.9605C21 12.0589 20.9872 12.1643 20.9616 12.2767C20.936 12.3892 20.9074 12.494 20.8758 12.5914L18.1532 18.9303C18.0171 19.23 17.7889 19.4832 17.4686 19.69C17.1482 19.8967 16.814 20 16.4659 20H6.47596V8.7519L12.0024 3.34597C12.1912 3.1597 12.4098 3.04854 12.6583 3.01248C12.9067 2.97642 13.1448 3.01849 13.3726 3.13867C13.6003 3.25884 13.7672 3.42948 13.8731 3.65058C13.9791 3.8717 14.0016 4.10062 13.9407 4.33735L12.9177 8.7519H19.2827ZM7.90094 9.35035V18.594H16.4692C16.5362 18.594 16.6047 18.576 16.6748 18.5399C16.7448 18.5039 16.7981 18.4438 16.8346 18.3596L19.575 12.0326V10.4463C19.575 10.3622 19.5476 10.2931 19.4928 10.239C19.438 10.1849 19.3679 10.1579 19.2827 10.1579H11.1163L12.3075 5.02051L7.90094 9.35035ZM3.71732 20C3.24506 20 2.84078 19.8341 2.50447 19.5022C2.16816 19.1704 2 18.7715 2 18.3056V10.4463C2 9.98037 2.16816 9.58147 2.50447 9.24965C2.84078 8.91782 3.24506 8.7519 3.71732 8.7519H6.47596V10.1579H3.71732C3.63206 10.1579 3.56202 10.1849 3.5072 10.239C3.45239 10.2931 3.42498 10.3622 3.42498 10.4463V18.3056C3.42498 18.3897 3.45239 18.4588 3.5072 18.5129C3.56202 18.567 3.63206 18.594 3.71732 18.594H6.47596V20H3.71732Z", fill: "currentColor" })
});
P({
  displayName: "ListIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 7.29999C4.94036 7.29999 5.5 6.74034 5.5 6.04999C5.5 5.35963 4.94036 4.79999 4.25 4.79999C3.55964 4.79999 3 5.35963 3 6.04999C3 6.74034 3.55964 7.29999 4.25 7.29999ZM9.07123 5.01425C8.51895 5.01425 8.07123 5.46196 8.07123 6.01425C8.07123 6.56653 8.51895 7.01425 9.07123 7.01425H19.9994C20.5517 7.01425 20.9994 6.56653 20.9994 6.01425C20.9994 5.46196 20.5517 5.01425 19.9994 5.01425H9.07123ZM9.07123 11.0854C8.51895 11.0854 8.07123 11.5331 8.07123 12.0854C8.07123 12.6377 8.51895 13.0854 9.07123 13.0854H19.9994C20.5517 13.0854 20.9994 12.6377 20.9994 12.0854C20.9994 11.5331 20.5517 11.0854 19.9994 11.0854H9.07123ZM8.07123 18.1567C8.07123 17.6044 8.51895 17.1567 9.07123 17.1567H19.9994C20.5517 17.1567 20.9994 17.6044 20.9994 18.1567C20.9994 18.7089 20.5517 19.1567 19.9994 19.1567H9.07123C8.51895 19.1567 8.07123 18.7089 8.07123 18.1567ZM5.5 12.1212C5.5 12.8116 4.94036 13.3712 4.25 13.3712C3.55964 13.3712 3 12.8116 3 12.1212C3 11.4309 3.55964 10.8712 4.25 10.8712C4.94036 10.8712 5.5 11.4309 5.5 12.1212ZM4.25 19.4424C4.94036 19.4424 5.5 18.8827 5.5 18.1924C5.5 17.502 4.94036 16.9424 4.25 16.9424C3.55964 16.9424 3 17.502 3 18.1924C3 18.8827 3.55964 19.4424 4.25 19.4424Z", fill: "currentColor" })
});
P({
  displayName: "LocationIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C12 22 19.1724 14.2245 19.1724 10.2633C19.1724 6.30211 15.9612 3.09091 12 3.09091C8.03878 3.09091 4.82758 6.30211 4.82758 10.2633C4.82758 14.2245 12 22 12 22ZM12 13.5235C13.8005 13.5235 15.2602 12.0639 15.2602 10.2633C15.2602 8.46276 13.8005 7.00312 12 7.00312C10.1994 7.00312 8.73981 8.46276 8.73981 10.2633C8.73981 12.0639 10.1994 13.5235 12 13.5235Z", fill: "currentColor" })
});
P({
  displayName: "LockIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.30773 21.5C5.80901 21.5 5.38306 21.3234 5.02986 20.9701C4.67664 20.6169 4.50003 20.191 4.50003 19.6923V10.3077C4.50003 9.80901 4.67664 9.38305 5.02986 9.02985C5.38306 8.67663 5.80901 8.50002 6.30773 8.50002H7.50003V6.50002C7.50003 5.25132 7.93785 4.18916 8.81348 3.31353C9.68913 2.43789 10.7513 2.00007 12 2.00007C13.2487 2.00007 14.3109 2.43789 15.1865 3.31353C16.0622 4.18916 16.5 5.25132 16.5 6.50002V8.50002H17.6923C18.191 8.50002 18.617 8.67663 18.9702 9.02985C19.3234 9.38305 19.5 9.80901 19.5 10.3077V19.6923C19.5 20.191 19.3234 20.6169 18.9702 20.9701C18.617 21.3234 18.191 21.5 17.6923 21.5H6.30773ZM6.30773 20H17.6923C17.782 20 17.8558 19.9711 17.9135 19.9135C17.9712 19.8558 18 19.782 18 19.6923V10.3077C18 10.218 17.9712 10.1442 17.9135 10.0865C17.8558 10.0288 17.782 10 17.6923 10H6.30773C6.21798 10 6.14426 10.0288 6.08656 10.0865C6.02886 10.1442 6.00001 10.218 6.00001 10.3077V19.6923C6.00001 19.782 6.02886 19.8558 6.08656 19.9135C6.14426 19.9711 6.21798 20 6.30773 20ZM12 16.75C12.4859 16.75 12.899 16.5798 13.2394 16.2394C13.5798 15.899 13.75 15.4859 13.75 15C13.75 14.5141 13.5798 14.101 13.2394 13.7606C12.899 13.4202 12.4859 13.25 12 13.25C11.5141 13.25 11.101 13.4202 10.7606 13.7606C10.4202 14.101 10.25 14.5141 10.25 15C10.25 15.4859 10.4202 15.899 10.7606 16.2394C11.101 16.5798 11.5141 16.75 12 16.75ZM9.00001 8.50002H15V6.50002C15 5.66669 14.7083 4.95836 14.125 4.37502C13.5417 3.79169 12.8333 3.50002 12 3.50002C11.1667 3.50002 10.4583 3.79169 9.87501 4.37502C9.29167 4.95836 9.00001 5.66669 9.00001 6.50002V8.50002Z", fill: "currentColor" })
});
P({
  displayName: "MagnifierIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M18.6489 19.7716L14.3528 15.4711C13.8277 15.9051 13.2238 16.2448 12.5411 16.4901C11.8585 16.7354 11.1523 16.858 10.4225 16.858C8.6275 16.858 7.10833 16.2359 5.865 14.9916C4.62167 13.7473 4 12.227 4 10.4307C4 8.63429 4.62151 7.11342 5.86452 5.86804C7.10754 4.62268 8.62633 4 10.4209 4C12.2154 4 13.7348 4.62229 14.9789 5.86688C16.223 7.11147 16.8451 8.63218 16.8451 10.429C16.8451 11.1797 16.7192 11.8968 16.4674 12.5801C16.2156 13.2635 15.8796 13.8578 15.4595 14.3633L19.7819 18.69C19.9273 18.8327 20 19.0079 20 19.2155C20 19.4231 19.9178 19.6092 19.7534 19.7738C19.6027 19.9246 19.419 20 19.2022 20C18.9855 20 18.801 19.9239 18.6489 19.7716ZM10.4225 15.2811C11.7757 15.2811 12.9219 14.8111 13.861 13.871C14.8002 12.9309 15.2697 11.7836 15.2697 10.429C15.2697 9.07446 14.8002 7.92713 13.861 6.98703C12.9219 6.04693 11.7757 5.57688 10.4225 5.57688C9.06933 5.57688 7.92317 6.04693 6.98402 6.98703C6.04488 7.92713 5.57532 9.07446 5.57532 10.429C5.57532 11.7836 6.04488 12.9309 6.98402 13.871C7.92317 14.8111 9.06933 15.2811 10.4225 15.2811Z", fill: "currentColor" })
});
P({
  displayName: "MapIcon",
  viewBox: "0 0 40 40",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.6667 13.3333C26.6667 17.0152 20 23.8095 20 23.8095C20 23.8095 13.3333 17.0152 13.3333 13.3333C13.3333 9.65143 16.3181 6.66666 20 6.66666C23.6819 6.66666 26.6667 9.65143 26.6667 13.3333ZM22.8571 13.3333C22.8571 14.9113 21.578 16.1905 20 16.1905C18.422 16.1905 17.1429 14.9113 17.1429 13.3333C17.1429 11.7554 18.422 10.4762 20 10.4762C21.578 10.4762 22.8571 11.7554 22.8571 13.3333ZM20 26.6667C20 26.6667 21.6222 25.2523 23.4351 23.3333H30.7143L35 33.3333H5L9.28571 23.3333H16.5649C18.3778 25.2523 20 26.6667 20 26.6667Z", fill: "currentColor" })
  )
});
P({
  displayName: "MedalIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.3225 12.6179L11.7221 11.5803L13.0976 12.6179C13.2424 12.7306 13.3872 12.7386 13.532 12.6421C13.6768 12.5455 13.7251 12.4088 13.6768 12.2318L13.1459 10.5185L14.6179 9.3843C14.7466 9.27168 14.7828 9.13494 14.7265 8.97406C14.6702 8.81318 14.5536 8.73274 14.3766 8.73274H12.615L12.06 6.947C12.0117 6.77003 11.9031 6.68155 11.7342 6.68155C11.5653 6.68155 11.4486 6.77003 11.3843 6.947L10.8051 8.73274H9.06766C8.89069 8.73274 8.77405 8.81318 8.71775 8.97406C8.66144 9.13494 8.69764 9.27168 8.82634 9.3843L10.2984 10.5185L9.76747 12.2318C9.71921 12.4088 9.76747 12.5455 9.91226 12.6421C10.0571 12.7386 10.1938 12.7306 10.3225 12.6179ZM6.99233 21.9569C6.7671 22.0373 6.54992 22.0052 6.34077 21.8604C6.13163 21.7156 6.02706 21.5145 6.02706 21.2571V14.9346C5.30311 14.1785 4.78428 13.3499 4.47057 12.449C4.15686 11.5481 4 10.6391 4 9.72214C4 7.5342 4.74004 5.70019 6.22012 4.22012C7.70019 2.74004 9.5342 2 11.7221 2C13.9101 2 15.7441 2.74004 17.2242 4.22012C18.7042 5.70019 19.4443 7.5342 19.4443 9.72214C19.4443 10.6391 19.2874 11.5481 18.9737 12.449C18.66 13.3499 18.1412 14.1785 17.4172 14.9346V21.2571C17.4172 21.5145 17.3127 21.7156 17.1035 21.8604C16.8944 22.0052 16.6772 22.0373 16.452 21.9569L11.7221 20.3642L6.99233 21.9569ZM11.7221 15.9964C13.4757 15.9964 14.9598 15.3891 16.1744 14.1744C17.3891 12.9598 17.9964 11.4757 17.9964 9.72214C17.9964 7.96857 17.3891 6.48447 16.1744 5.26984C14.9598 4.05522 13.4757 3.4479 11.7221 3.4479C9.96857 3.4479 8.48447 4.05522 7.26984 5.26984C6.05522 6.48447 5.4479 7.96857 5.4479 9.72214C5.4479 11.4757 6.05522 12.9598 7.26984 14.1744C8.48447 15.3891 9.96857 15.9964 11.7221 15.9964ZM7.47496 20.2436L11.7221 18.9163L15.9693 20.2436V16.117C15.3258 16.5836 14.634 16.9214 13.894 17.1306C13.154 17.3397 12.43 17.4443 11.7221 17.4443C11.0143 17.4443 10.2903 17.3397 9.55029 17.1306C8.81025 16.9214 8.11848 16.5836 7.47496 16.117V20.2436Z", fill: "currentColor" })
});
P({
  displayName: "MenuIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 6.5C20 7.05228 19.5523 7.5 19 7.5L5 7.5C4.44772 7.5 4 7.05229 4 6.5C4 5.94772 4.44772 5.5 5 5.5H19C19.5523 5.5 20 5.94772 20 6.5ZM20 12C20 12.5523 19.5523 13 19 13L5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11L19 11C19.5523 11 20 11.4477 20 12ZM19 18.5C19.5523 18.5 20 18.0523 20 17.5C20 16.9477 19.5523 16.5 19 16.5L5 16.5C4.44772 16.5 4 16.9477 4 17.5C4 18.0523 4.44772 18.5 5 18.5L19 18.5Z", fill: "currentColor" })
});
P({
  displayName: "MessageIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M8.34615 14.0576H15.6538V13.7C15.6538 13.0692 15.3144 12.5545 14.6355 12.1558C13.9567 11.757 13.0782 11.5577 12 11.5577C10.9218 11.5577 10.0433 11.757 9.36443 12.1558C8.68558 12.5545 8.34615 13.0692 8.34615 13.7V14.0576ZM12 10.2499C12.4859 10.2499 12.899 10.0798 13.2394 9.73937C13.5798 9.39901 13.75 8.98587 13.75 8.49997C13.75 8.01407 13.5798 7.60094 13.2394 7.26058C12.899 6.92019 12.4859 6.75 12 6.75C11.5141 6.75 11.1009 6.92019 10.7606 7.26058C10.4202 7.60094 10.25 8.01407 10.25 8.49997C10.25 8.98587 10.4202 9.39901 10.7606 9.73937C11.1009 10.0798 11.5141 10.2499 12 10.2499ZM2.5 21.5384V4.8077C2.5 4.30257 2.675 3.875 3.025 3.525C3.375 3.175 3.80257 3 4.3077 3H19.6923C20.1974 3 20.625 3.175 20.975 3.525C21.325 3.875 21.5 4.30257 21.5 4.8077V16.1922C21.5 16.6974 21.325 17.125 20.975 17.475C20.625 17.825 20.1974 18 19.6923 18H6.03845L2.5 21.5384ZM3.99998 17.9154L5.41538 16.5H19.6923C19.782 16.5 19.8557 16.4711 19.9134 16.4134C19.9711 16.3557 20 16.282 20 16.1922V4.8077C20 4.71795 19.9711 4.64423 19.9134 4.58652C19.8557 4.52882 19.782 4.49997 19.6923 4.49997H4.3077C4.21795 4.49997 4.14423 4.52882 4.08653 4.58652C4.02883 4.64423 3.99998 4.71795 3.99998 4.8077V17.9154ZM3.99998 4.8077V4.49997V17.9154V4.8077Z", fill: "currentColor" })
});
P({
  displayName: "MigrateColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fill: "url(#a)", d: "M9.062 15.083a.76.76 0 0 0 1.08-1.07l-.739-.747a1.79 1.79 0 0 1 .006-2.525l.728-.729a.76.76 0 1 0-1.075-1.075L7.41 10.591a2 2 0 0 0-.005 2.823l1.658 1.67Zm4.8.005a.76.76 0 0 0 1.075 0l1.674-1.674a2 2 0 0 0 0-2.828l-1.649-1.649a.76.76 0 0 0-1.075 1.075l.726.726a1.785 1.785 0 0 1 0 2.524l-.75.75a.76.76 0 0 0 0 1.075ZM4.5 21c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 3 19.5v-15c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 4.5 3h3.44c.967 0 1.742-.819 2.485-1.438C10.875 1.188 11.4 1 12 1s1.125.188 1.575.563C14.318 2.18 15.093 3 16.06 3h3.44c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062v15c0 .417-.146.77-.438 1.063A1.446 1.446 0 0 1 19.5 21h-15ZM12 4.075a.84.84 0 0 0 .613-.263.84.84 0 0 0 .262-.612.84.84 0 0 0-.262-.613.84.84 0 0 0-.613-.262.84.84 0 0 0-.613.262.84.84 0 0 0-.262.613.84.84 0 0 0 .262.612.84.84 0 0 0 .613.263Z" }),
    w.createElement(
      "defs",
      null,
      w.createElement(
        "linearGradient",
        { id: "a", x1: "17.145", x2: "-24.551", y1: "-45.131", y2: "-31.107", gradientUnits: "userSpaceOnUse" },
        w.createElement("stop", { stopColor: "#00FFA3" }),
        w.createElement("stop", { offset: "1", stopColor: "#DC1FFF" })
      )
    )
  )
});
P({
  displayName: "MindpressIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.58862 4.56043C3.38298 4.41255 3.0963 4.55951 3.0963 4.81279V9.13244L6.99764 11.7333L6.99884 11.7341L8.33112 12.6134L8.30011 12.5713L11.4786 10.2341L3.58862 4.56043ZM12.0029 9.84541L3.95157 4.05569C3.33466 3.61207 2.47461 4.05294 2.47461 4.81279V19.5117C2.47461 20.2923 3.37635 20.7274 3.9874 20.2417L6.78499 18.018C7.00756 17.841 7.13726 17.5723 7.13726 17.288V12.5704L11.4748 15.4331C11.8004 15.648 12.2253 15.6375 12.5399 15.4068L16.3589 12.6062V17.5751C16.3589 17.8794 16.5074 18.1646 16.7567 18.3391L19.6579 20.3699C20.276 20.8026 21.1252 20.3604 21.1252 19.606V4.8463C21.1252 4.07705 20.2463 3.63862 19.6318 4.10133L12.0029 9.84541ZM16.3589 11.8353V7.34377L12.1913 10.4818L8.83759 12.9477L11.8172 14.9143C11.9257 14.9859 12.0674 14.9824 12.1723 14.9055L16.3589 11.8353ZM16.9275 6.91566H16.9806V17.5751C16.9806 17.6765 17.0301 17.7716 17.1132 17.8298L20.0144 19.8606C20.2204 20.0048 20.5035 19.8574 20.5035 19.606V4.8463C20.5035 4.58988 20.2106 4.44374 20.0057 4.59798L16.9275 6.91566ZM6.51557 12.1591L3.0963 9.87961V19.5117C3.0963 19.7719 3.39688 19.9169 3.60056 19.755L6.39815 17.5313C6.47234 17.4723 6.51557 17.3827 6.51557 17.288V12.1591Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.85796 10.5422C5.02964 10.5422 5.16881 10.6813 5.16881 10.853V14.5831C5.16881 14.7548 5.02964 14.894 4.85796 14.894C4.68629 14.894 4.54712 14.7548 4.54712 14.5831V10.853C4.54712 10.6813 4.68629 10.5422 4.85796 10.5422Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.52692 6.32878C2.62214 6.18594 2.81514 6.14734 2.95798 6.24257L6.06641 8.31486C6.20925 8.41008 6.24785 8.60308 6.15263 8.74592C6.0574 8.88876 5.8644 8.92736 5.72156 8.83213L2.61313 6.75984C2.47029 6.66461 2.43169 6.47162 2.52692 6.32878Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.33497 10.2579C8.43475 10.1182 8.62889 10.0858 8.76859 10.1856L10.2192 11.2218C10.3589 11.3215 10.3912 11.5157 10.2915 11.6554C10.1917 11.7951 9.99754 11.8274 9.85784 11.7276L8.40724 10.6915C8.26754 10.5917 8.23519 10.3976 8.33497 10.2579Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.9893 12.1283C13.0862 12.27 13.0497 12.4634 12.908 12.5603L10.4212 14.2592C10.2795 14.356 10.0861 14.3196 9.98922 14.1778C9.89238 14.0361 9.92879 13.8427 10.0705 13.7458L12.5573 12.0469C12.6991 11.9501 12.8925 11.9865 12.9893 12.1283Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.9306 9.44028C17.0241 9.58423 16.9833 9.77676 16.8393 9.87029L15.1815 10.9475C15.0375 11.041 14.845 11.0001 14.7514 10.8562C14.6579 10.7122 14.6988 10.5197 14.8427 10.4262L16.5006 9.34898C16.6445 9.25545 16.8371 9.29632 16.9306 9.44028Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.7422 4.94699C18.9139 4.94699 19.0531 5.08616 19.0531 5.25783V8.55795C19.0531 8.72962 18.9139 8.86879 18.7422 8.86879C18.5706 8.86879 18.4314 8.72962 18.4314 8.55795V5.25783C18.4314 5.08616 18.5706 4.94699 18.7422 4.94699Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.7421 8.88434C18.5704 8.88434 18.4313 9.02351 18.4313 9.19518C18.4313 9.36686 18.5704 9.50602 18.7421 9.50602C18.9138 9.50602 19.0529 9.36686 19.0529 9.19518C19.0529 9.02351 18.9138 8.88434 18.7421 8.88434ZM17.8096 9.19518C17.8096 8.68016 18.2271 8.26265 18.7421 8.26265C19.2571 8.26265 19.6746 8.68016 19.6746 9.19518C19.6746 9.7102 19.2571 10.1277 18.7421 10.1277C18.2271 10.1277 17.8096 9.7102 17.8096 9.19518Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.3542 11.5783C13.1825 11.5783 13.0433 11.7175 13.0433 11.8892C13.0433 12.0608 13.1825 12.2 13.3542 12.2C13.5258 12.2 13.665 12.0608 13.665 11.8892C13.665 11.7175 13.5258 11.5783 13.3542 11.5783ZM12.4216 11.8892C12.4216 11.3741 12.8391 10.9566 13.3542 10.9566C13.8692 10.9566 14.2867 11.3741 14.2867 11.8892C14.2867 12.4042 13.8692 12.8217 13.3542 12.8217C12.8391 12.8217 12.4216 12.4042 12.4216 11.8892Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.51578 8.67711C6.34411 8.67711 6.20494 8.81628 6.20494 8.98795C6.20494 9.15963 6.34411 9.2988 6.51578 9.2988C6.68746 9.2988 6.82663 9.15963 6.82663 8.98795C6.82663 8.81628 6.68746 8.67711 6.51578 8.67711ZM5.58325 8.98795C5.58325 8.47293 6.00076 8.05542 6.51578 8.05542C7.0308 8.05542 7.44831 8.47293 7.44831 8.98795C7.44831 9.50297 7.0308 9.92048 6.51578 9.92048C6.00076 9.92048 5.58325 9.50297 5.58325 8.98795Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.85782 14.894C4.68615 14.894 4.54698 15.0331 4.54698 15.2048C4.54698 15.3765 4.68615 15.5157 4.85782 15.5157C5.0295 15.5157 5.16867 15.3765 5.16867 15.2048C5.16867 15.0331 5.0295 14.894 4.85782 14.894ZM3.92529 15.2048C3.92529 14.6898 4.3428 14.2723 4.85782 14.2723C5.37285 14.2723 5.79035 14.6898 5.79035 15.2048C5.79035 15.7198 5.37285 16.1373 4.85782 16.1373C4.3428 16.1373 3.92529 15.7198 3.92529 15.2048Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.7421 15.9301C18.5704 15.9301 18.4313 16.0693 18.4313 16.241C18.4313 16.4126 18.5704 16.5518 18.7421 16.5518C18.9138 16.5518 19.0529 16.4126 19.0529 16.241C19.0529 16.0693 18.9138 15.9301 18.7421 15.9301ZM17.8096 16.241C17.8096 15.7259 18.2271 15.3084 18.7421 15.3084C19.2571 15.3084 19.6746 15.7259 19.6746 16.241C19.6746 16.756 19.2571 17.1735 18.7421 17.1735C18.2271 17.1735 17.8096 16.756 17.8096 16.241Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.7422 11.3711C18.9139 11.3711 19.0531 11.5103 19.0531 11.6819L19.0531 14.1687C19.0531 14.3403 18.9139 14.4795 18.7422 14.4795C18.5706 14.4795 18.4314 14.3403 18.4314 14.1687L18.4314 11.6819C18.4314 11.5103 18.5706 11.3711 18.7422 11.3711Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.7422 16.759C18.9139 16.759 19.0531 16.8982 19.0531 17.0699L19.0531 19.3494C19.0531 19.5211 18.9139 19.6602 18.7422 19.6602C18.5706 19.6602 18.4314 19.5211 18.4314 19.3494L18.4314 17.0699C18.4314 16.8982 18.5706 16.759 18.7422 16.759Z", fill: "currentColor" }),
    w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.85796 16.9663C5.02964 16.9663 5.16881 17.1054 5.16881 17.2771L5.16881 19.1422C5.16881 19.3138 5.02964 19.453 4.85796 19.453C4.68629 19.453 4.54712 19.3138 4.54712 19.1422L4.54712 17.2771C4.54712 17.1054 4.68629 16.9663 4.85796 16.9663Z", fill: "currentColor" })
  )
});
P({
  displayName: "MinusIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.25 12.75C6.0375 12.75 5.85938 12.6781 5.71563 12.5343C5.57188 12.3905 5.5 12.2123 5.5 11.9997C5.5 11.7871 5.57188 11.609 5.71563 11.4654C5.85938 11.3218 6.0375 11.25 6.25 11.25H17.75C17.9625 11.25 18.1406 11.3219 18.2843 11.4657C18.4281 11.6095 18.5 11.7877 18.5 12.0003C18.5 12.2129 18.4281 12.391 18.2843 12.5346C18.1406 12.6782 17.9625 12.75 17.75 12.75H6.25Z", fill: "currentColor" })
});
P({
  displayName: "MoneyCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.7923 19.3077H13.1577V18.0961C13.9333 17.991 14.6355 17.6996 15.2644 17.2221C15.8932 16.7445 16.2077 16.0205 16.2077 15.05C16.2077 14.35 16.0012 13.7308 15.5884 13.1923C15.1756 12.6538 14.3692 12.1679 13.1692 11.7346C12.1179 11.3756 11.4198 11.0647 11.075 10.8019C10.7301 10.5391 10.5577 10.1718 10.5577 9.69998C10.5577 9.22818 10.7343 8.84484 11.0875 8.54998C11.4407 8.25509 11.9282 8.10765 12.55 8.10765C13.0705 8.10765 13.4904 8.23041 13.8096 8.47593C14.1288 8.72144 14.3743 9.02945 14.5461 9.39995L15.7807 8.90383C15.5717 8.37178 15.231 7.91633 14.7586 7.53748C14.2862 7.15864 13.7692 6.94743 13.2077 6.90383V5.6923H11.8423V6.90383C10.9897 7.06793 10.3349 7.41376 9.87788 7.94133C9.42083 8.46889 9.1923 9.05511 9.1923 9.69998C9.1923 10.4513 9.41987 11.0557 9.875 11.5134C10.3301 11.9711 11.0718 12.3846 12.1 12.7538C13.1628 13.1436 13.8888 13.4932 14.2779 13.8029C14.667 14.1125 14.8615 14.5282 14.8615 15.05C14.8615 15.6769 14.6352 16.1324 14.1827 16.4163C13.7301 16.7003 13.2192 16.8423 12.65 16.8423C12.0872 16.8423 11.5836 16.6731 11.1394 16.3346C10.6952 15.9962 10.3538 15.5013 10.1154 14.85L8.85 15.3654C9.10897 16.1077 9.48108 16.6974 9.96635 17.1346C10.4516 17.5718 11.0603 17.8756 11.7923 18.0461V19.3077ZM12.5 22C11.1872 22 9.95287 21.7503 8.7971 21.2509C7.64133 20.7516 6.63589 20.0743 5.78078 19.2192C4.92564 18.3641 4.2484 17.3586 3.74905 16.2029C3.24968 15.0471 3 13.8128 3 12.5C3 11.1872 3.24968 9.95287 3.74905 8.7971C4.2484 7.64133 4.92564 6.63589 5.78078 5.78078C6.63589 4.92564 7.64133 4.2484 8.7971 3.74905C9.95287 3.24968 11.1872 3 12.5 3C13.8128 3 15.0471 3.24968 16.2029 3.74905C17.3586 4.2484 18.3641 4.92564 19.2192 5.78078C20.0743 6.63589 20.7516 7.64133 21.2509 8.7971C21.7503 9.95287 22 11.1872 22 12.5C22 13.8128 21.7503 15.0471 21.2509 16.2029C20.7516 17.3586 20.0743 18.3641 19.2192 19.2192C18.3641 20.0743 17.3586 20.7516 16.2029 21.2509C15.0471 21.7503 13.8128 22 12.5 22ZM12.5 20.5C14.7333 20.5 16.625 19.725 18.175 18.175C19.725 16.625 20.5 14.7333 20.5 12.5C20.5 10.2666 19.725 8.37498 18.175 6.82498C16.625 5.27498 14.7333 4.49998 12.5 4.49998C10.2666 4.49998 8.37498 5.27498 6.82498 6.82498C5.27498 8.37498 4.49998 10.2666 4.49998 12.5C4.49998 14.7333 5.27498 16.625 6.82498 18.175C8.37498 19.725 10.2666 20.5 12.5 20.5Z", fill: "currentColor" })
});
P({
  displayName: "MonitorStatsIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M2.11514 15.6807L5.76639 9.80443C5.93013 9.54635 6.16133 9.40639 6.46 9.38456C6.75867 9.36273 7.01161 9.46416 7.21884 9.68888L9.41574 12.264L12.6411 6.99437C12.8112 6.70932 13.0641 6.56518 13.3999 6.56196C13.7357 6.55875 13.9937 6.69454 14.1741 6.96933L15.7704 9.38261C15.4839 9.40572 15.215 9.44521 14.9636 9.50106C14.7123 9.55692 14.4619 9.63235 14.2125 9.72736L13.443 8.57364L10.2887 13.7354C10.125 13.9935 9.89123 14.136 9.58744 14.163C9.28365 14.19 9.02816 14.086 8.82095 13.851L6.61445 11.2662L3.38913 16.4877C3.27785 16.6739 3.11348 16.7898 2.89603 16.8354C2.67858 16.8809 2.48224 16.8344 2.307 16.6957C2.142 16.584 2.04351 16.4309 2.01153 16.2364C1.97955 16.0419 2.01409 15.8566 2.11514 15.6807ZM21.9332 22L18.6619 18.7354C18.3485 18.9627 18.0025 19.1347 17.6239 19.2516C17.2452 19.3684 16.8526 19.4268 16.4458 19.4268C15.333 19.4268 14.3896 19.0384 13.6158 18.2616C12.8419 17.4848 12.455 16.5378 12.455 15.4207C12.455 14.3036 12.8419 13.3567 13.6158 12.5798C14.3896 11.803 15.333 11.4146 16.4458 11.4146C17.5586 11.4146 18.502 11.803 19.2758 12.5798C20.0497 13.3567 20.4366 14.3036 20.4366 15.4207C20.4366 15.8355 20.3768 16.2345 20.2572 16.6177C20.1376 17.001 19.9614 17.3551 19.7286 17.6799L23 20.9292L21.9332 22ZM16.4458 17.9246C17.1442 17.9246 17.7345 17.6825 18.2167 17.1984C18.699 16.7144 18.9401 16.1218 18.9401 15.4207C18.9401 14.7196 18.699 14.1271 18.2167 13.643C17.7345 13.1589 17.1442 12.9169 16.4458 12.9169C15.7474 12.9169 15.1571 13.1589 14.6749 13.643C14.1926 14.1271 13.9515 14.7196 13.9515 15.4207C13.9515 16.1218 14.1926 16.7144 14.6749 17.1984C15.1571 17.6825 15.7474 17.9246 16.4458 17.9246ZM18.4738 9.7389C18.2346 9.64389 17.9894 9.5659 17.738 9.50492C17.4867 9.44392 17.2261 9.40508 16.9562 9.38839L21.3711 2.36031C21.4824 2.18441 21.6442 2.0711 21.8565 2.02037C22.0688 1.96966 22.2626 2.01364 22.4378 2.15232C22.6028 2.26402 22.7039 2.41713 22.741 2.61165C22.7781 2.80618 22.7461 2.9914 22.6451 3.1673L18.4738 9.7389Z", fill: "currentColor" })
});
P({
  displayName: "MortarboardIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.45159 4.39892C10.554 3.86703 12.3414 3.86703 13.4438 4.39892L20.0686 7.59523C20.4323 7.77075 20.6761 7.98225 20.7998 8.206C20.9151 8.2894 21 8.40213 21 8.55327V13.6757C21 14.1472 20.6301 14.5295 20.1739 14.5295C19.7177 14.5295 19.3478 14.1472 19.3478 13.6757V9.86911L13.4438 12.7177C12.3414 13.2496 10.554 13.2496 9.45159 12.7177L2.82681 9.52137C1.7244 8.98948 1.7244 8.12712 2.82681 7.59523L9.45159 4.39892ZM4.59141 12.0802L4.59141 15.692C4.59141 16.0532 4.88882 16.3996 5.41822 16.6551L9.4516 18.6011C10.554 19.133 12.3414 19.133 13.4438 18.6011L17.4772 16.6551C18.0065 16.3996 18.304 16.0532 18.304 15.692V12.0802L13.4438 14.4252C12.3414 14.957 10.554 14.957 9.45159 14.4252L4.59141 12.0802Z", fill: "currentColor" })
});
P({
  displayName: "NetworkIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5144 1.12584C11.8164 0.958052 12.1836 0.958052 12.4856 1.12584L21.4856 6.12584C21.8031 6.30221 22 6.63683 22 7V17C22 17.3632 21.8031 17.6978 21.4856 17.8742L12.4856 22.8742C12.1836 23.0419 11.8164 23.0419 11.5144 22.8742L2.51436 17.8742C2.19689 17.6978 2 17.3632 2 17V7C2 6.63683 2.19689 6.30221 2.51436 6.12584L11.5144 1.12584ZM4 8.61381L11 12.0933V20.3005L4 16.4116V8.61381ZM13 20.3005L20 16.4116V8.61381L13 12.0933V20.3005ZM12 10.357L18.8523 6.95082L12 3.14396L5.14765 6.95082L12 10.357Z", fill: "currentColor" })
});
P({
  displayName: "NeuronIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.5708 4.99836C19.3664 4.96137 20 4.30468 20 3.5C20 2.67157 19.3284 2 18.5 2C17.6716 2 17 2.67157 17 3.5C17 3.79583 17.0856 4.07166 17.2335 4.30405L13.4318 10.1794C13.1438 10.0637 12.8293 10 12.5 10C12.0589 10 11.6444 10.1143 11.2846 10.3148L6.92976 4.95496C6.97538 4.81147 7 4.65861 7 4.5C7 3.67157 6.32843 3 5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C5.60933 6 5.71592 5.9883 5.8186 5.9661L10.2466 11.416C10.0886 11.7439 10 12.1116 10 12.5C10 12.6645 10.0159 12.8254 10.0462 12.981L5.51621 14.3967C5.24897 14.1504 4.89205 14 4.5 14C3.67157 14 3 14.6716 3 15.5C3 16.3284 3.67157 17 4.5 17C5.21566 17 5.81427 16.4988 5.96397 15.8283L10.7871 14.321C11.1241 14.6381 11.5491 14.8627 12.0216 14.9543L12.6384 19.272C12.2523 19.5434 12 19.9922 12 20.5C12 21.3284 12.6716 22 13.5 22C14.3284 22 15 21.3284 15 20.5C15 19.8985 14.6459 19.3797 14.1348 19.1406L13.5128 14.7863C14.1784 14.4911 14.691 13.9137 14.8989 13.206L19.3668 12.1548C19.7291 12.6662 20.3256 13 21 13C22.1046 13 23 12.1046 23 11C23 9.89543 22.1046 9 21 9C19.9992 9 19.1702 9.73502 19.0232 10.6947L14.8604 11.6741C14.7939 11.4843 14.7053 11.3049 14.5975 11.1391L18.5708 4.99836Z", fill: "currentColor" })
});
P({
  displayName: "NewIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M3.3077 19.5C2.80257 19.5 2.375 19.325 2.025 18.975C1.675 18.625 1.5 18.1974 1.5 17.6923V6.30773C1.5 5.80259 1.675 5.37502 2.025 5.02502C2.375 4.67502 2.80257 4.50002 3.3077 4.50002H20.6923C21.1974 4.50002 21.625 4.67502 21.975 5.02502C22.325 5.37502 22.5 5.80259 22.5 6.30773V17.6923C22.5 18.1974 22.325 18.625 21.975 18.975C21.625 19.325 21.1974 19.5 20.6923 19.5H3.3077ZM3.3077 18H20.6923C20.782 18 20.8557 17.9711 20.9134 17.9134C20.9711 17.8557 21 17.782 21 17.6923V6.30773C21 6.21798 20.9711 6.14425 20.9134 6.08655C20.8557 6.02885 20.782 6 20.6923 6H3.3077C3.21795 6 3.14423 6.02885 3.08653 6.08655C3.02883 6.14425 2.99998 6.21798 2.99998 6.30773V17.6923C2.99998 17.782 3.02883 17.8557 3.08653 17.9134C3.14423 17.9711 3.21795 18 3.3077 18ZM4.73075 11.0961L7.21153 14.625C7.25511 14.6955 7.31224 14.75 7.38293 14.7885C7.45361 14.8269 7.53136 14.8462 7.61618 14.8462H7.87063C8.01197 14.8462 8.13298 14.7962 8.23363 14.6964C8.33426 14.5965 8.38458 14.4753 8.38458 14.3327V9.67307C8.38458 9.52077 8.33622 9.39617 8.2395 9.29925C8.14278 9.20232 8.01842 9.15385 7.86643 9.15385C7.71444 9.15385 7.58973 9.20232 7.4923 9.29925C7.39485 9.39617 7.34613 9.52077 7.34613 9.67307V12.9039L4.92498 9.375C4.87113 9.29808 4.80654 9.242 4.73123 9.20675C4.65591 9.17148 4.57306 9.15385 4.48268 9.15385H4.22633C4.06968 9.15385 3.94151 9.20411 3.84183 9.30463C3.74214 9.40514 3.6923 9.53438 3.6923 9.69233V14.3269C3.6923 14.4792 3.74066 14.6038 3.83738 14.7008C3.93411 14.7977 4.05847 14.8462 4.21045 14.8462C4.36245 14.8462 4.48717 14.7977 4.5846 14.7008C4.68203 14.6038 4.73075 14.4792 4.73075 14.3269V11.0961ZM10.1058 14.8462H12.8269C12.9792 14.8462 13.1038 14.7978 13.2007 14.7011C13.2977 14.6043 13.3461 14.48 13.3461 14.328C13.3461 14.176 13.2977 14.0513 13.2007 13.9539C13.1038 13.8564 12.9792 13.8077 12.8269 13.8077H10.8461V12.5539H12.8269C12.9792 12.5539 13.1038 12.5055 13.2007 12.4088C13.2977 12.312 13.3461 12.1877 13.3461 12.0357C13.3461 11.8837 13.2977 11.759 13.2007 11.6616C13.1038 11.5641 12.9792 11.5154 12.8269 11.5154H10.8461V10.1923H12.8269C12.9792 10.1923 13.1038 10.1439 13.2007 10.0472C13.2977 9.95049 13.3461 9.82613 13.3461 9.67415C13.3461 9.52215 13.2977 9.39743 13.2007 9.3C13.1038 9.20257 12.9792 9.15385 12.8269 9.15385H10.1058C9.98523 9.15385 9.87978 9.19904 9.7894 9.28943C9.69902 9.37981 9.65383 9.48526 9.65383 9.60578V14.3942C9.65383 14.5147 9.69902 14.6202 9.7894 14.7106C9.87978 14.801 9.98523 14.8462 10.1058 14.8462ZM15.4615 14.8462H19.4615C19.7064 14.8462 19.9086 14.7663 20.0682 14.6067C20.2278 14.4471 20.3077 14.2449 20.3077 14V9.67307C20.3077 9.52077 20.2593 9.39617 20.1626 9.29925C20.0658 9.20232 19.9415 9.15385 19.7895 9.15385C19.6375 9.15385 19.5128 9.20232 19.4154 9.29925C19.3179 9.39617 19.2692 9.52077 19.2692 9.67307V13.6539H17.9961V10.6731C17.9961 10.5208 17.9478 10.3962 17.851 10.2992C17.7543 10.2023 17.63 10.1539 17.478 10.1539C17.326 10.1539 17.2013 10.2023 17.1038 10.2992C17.0064 10.3962 16.9577 10.5208 16.9577 10.6731V13.6539H15.6538V9.67307C15.6538 9.52077 15.6055 9.39617 15.5087 9.29925C15.412 9.20232 15.2877 9.15385 15.1357 9.15385C14.9837 9.15385 14.859 9.20232 14.7615 9.29925C14.6641 9.39617 14.6154 9.52077 14.6154 9.67307V14C14.6154 14.2449 14.6952 14.4471 14.8548 14.6067C15.0144 14.7663 15.2166 14.8462 15.4615 14.8462Z", fill: "currentColor" })
});
P({
  displayName: "NewsIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 8L18.6294 4.95594C19.2862 4.69391 20 5.17765 20 5.88474V16.8837C20 17.5795 19.307 18.0627 18.6541 17.822L11 15V8ZM3 11.5C3 9.56701 4.567 8 6.5 8H10V15L8.58911 19.311C8.45461 19.722 8.07116 20 7.63872 20H5.87946C5.1992 20 4.71748 19.3355 4.92907 18.689L6.13636 15H6.5C4.567 15 3 13.433 3 11.5Z", fill: "currentColor" })
});
P({
  displayName: "NewsletterIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.8 12V4.55172H16.2V12L19.0818 10.0836C19.5417 9.77771 19.379 9.06543 18.8318 8.98963L17.6 8.81896V3.77586C17.6 3.31034 17.32 3 16.9 3H7.1C6.68 3 6.4 3.31034 6.4 3.77586V8.89655L5.2407 9.02504C4.68369 9.08678 4.50789 9.81066 4.97455 10.121L7.8 12ZM10.0002 7.33682C10.0002 7.00545 10.2688 6.73682 10.6002 6.73682L13.4002 6.73682C13.7316 6.73682 14.0002 7.00545 14.0002 7.33682C14.0002 7.66819 13.7316 7.93682 13.4002 7.93682H10.6002C10.2688 7.93682 10.0002 7.66819 10.0002 7.33682ZM10.0002 10.1936C10.0002 9.86218 10.2688 9.59355 10.6002 9.59355H13.4002C13.7316 9.59355 14.0002 9.86218 14.0002 10.1936C14.0002 10.5249 13.7316 10.7936 13.4002 10.7936H10.6002C10.2688 10.7936 10.0002 10.5249 10.0002 10.1936ZM4.37327 11.219C4.0407 11.0019 3.60001 11.2406 3.60001 11.6377V19.9003C3.60001 20.1764 3.82386 20.4003 4.10001 20.4003H19.9C20.1761 20.4003 20.4 20.1764 20.4 19.9003V11.6377C20.4 11.2406 19.9593 11.0019 19.6267 11.219L12.2733 16.018C12.1072 16.1264 11.8928 16.1264 11.7267 16.018L4.37327 11.219Z", fill: "currentColor" })
});
P({
  displayName: "NewspaperIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.75 7C2.75 5.75736 3.75736 4.75 5 4.75H17.0708C18.3135 4.75 19.3208 5.75736 19.3208 7V7.85323C20.4311 8.14532 21.25 9.15607 21.25 10.3581V17C21.25 18.2426 20.2426 19.25 19 19.25L5 19.25C3.75736 19.25 2.75 18.2426 2.75 17V7ZM19.3208 9.49123V16.1167C19.3208 16.5309 18.985 16.8667 18.5708 16.8667C18.1566 16.8667 17.8208 16.5309 17.8208 16.1167V7C17.8208 6.58579 17.485 6.25 17.0708 6.25H5C4.58579 6.25 4.25 6.58579 4.25 7V17C4.25 17.4142 4.58579 17.75 5 17.75L19 17.75C19.4142 17.75 19.75 17.4142 19.75 17V10.3581C19.75 10.0046 19.5817 9.69036 19.3208 9.49123ZM6 9C6 8.44772 6.44772 8 7 8H15C15.5523 8 16 8.44772 16 9V12C16 12.5523 15.5523 13 15 13H7C6.44772 13 6 12.5523 6 12V9ZM7 14.25C6.58579 14.25 6.25 14.5858 6.25 15C6.25 15.4142 6.58579 15.75 7 15.75H15.0001C15.4143 15.75 15.7501 15.4142 15.7501 15C15.7501 14.5858 15.4143 14.25 15.0001 14.25H7Z", fill: "currentColor" })
});
P({
  displayName: "NFTIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.4999 2.8726C11.4281 2.3367 12.5717 2.3367 13.4999 2.8726L19.3602 6.25606C20.2884 6.79195 20.8602 7.78234 20.8602 8.85413V15.621C20.8602 16.6928 20.2884 17.6832 19.3602 18.2191L13.4999 21.6026C12.5717 22.1385 11.4281 22.1385 10.4999 21.6026L4.63959 18.2191C3.71138 17.6832 3.13959 16.6928 3.13959 15.6211V8.85413C3.13959 7.78234 3.71138 6.79195 4.63959 6.25606L10.4999 2.8726ZM16.7256 8.45182L12.7499 6.15645C12.6919 6.12296 12.6322 6.09365 12.5713 6.06853C12.5408 6.05597 12.51 6.04446 12.4789 6.03399C12.0752 5.89792 11.627 5.93874 11.2499 6.15645L7.27424 8.45182C6.81013 8.71977 6.52424 9.21496 6.52424 9.75086V14.3416C6.52424 14.8775 6.81013 15.3727 7.27424 15.6406L11.2499 17.936C11.714 18.204 12.2858 18.204 12.7499 17.936L16.7256 15.6406C17.1897 15.3727 17.4756 14.8775 17.4756 14.3416V9.75086C17.4756 9.21496 17.1897 8.71977 16.7256 8.45182ZM13.1426 4.68157C12.2892 4.32989 11.3121 4.3885 10.4999 4.85741L6.52424 7.15278C5.59603 7.68868 5.02424 8.67906 5.02424 9.75086V14.3416C5.02424 15.4134 5.59603 16.4038 6.52424 16.9397L10.4999 19.235C11.4281 19.7709 12.5717 19.7709 13.4999 19.235L17.4756 16.9397C18.4038 16.4038 18.9756 15.4134 18.9756 14.3416V9.75086C18.9756 8.68744 18.4127 7.70416 17.4973 7.16543M17.4973 7.16539L17.4756 7.15278L13.4999 4.85741C13.3839 4.79043 13.2645 4.73181 13.1426 4.68157", fill: "currentColor" })
});
P({
  displayName: "PathIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.73244 6C7.38663 6.5978 6.74028 7 6 7C4.89543 7 4 6.10457 4 5C4 3.89543 4.89543 3 6 3C6.74028 3 7.38663 3.4022 7.73244 4H14.5C16.9853 4 19 6.01472 19 8.5C19 10.9853 16.9853 13 14.5 13H9.5C8.11929 13 7 14.1193 7 15.5C7 16.8807 8.11929 18 9.5 18H16.2676C16.6134 17.4022 17.2597 17 18 17C19.1046 17 20 17.8954 20 19C20 20.1046 19.1046 21 18 21C17.2597 21 16.6134 20.5978 16.2676 20H9.5C7.01472 20 5 17.9853 5 15.5C5 13.0147 7.01472 11 9.5 11H14.5C15.8807 11 17 9.88071 17 8.5C17 7.11929 15.8807 6 14.5 6H7.73244Z", fill: "currentColor" })
});
P({
  displayName: "PeopleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.53141 10.3124C6.72225 10.3124 7.68761 9.34703 7.68761 8.1562C7.68761 6.96536 6.72225 6 5.53141 6C4.34058 6 3.37522 6.96536 3.37522 8.1562C3.37522 9.34703 4.34058 10.3124 5.53141 10.3124ZM15.2343 9.2343C15.2343 11.0205 13.7863 12.4686 12 12.4686C10.2137 12.4686 8.76571 11.0205 8.76571 9.2343C8.76571 7.44804 10.2137 6 12 6C13.7863 6 15.2343 7.44804 15.2343 9.2343ZM20.6248 8.1562C20.6248 9.34703 19.6594 10.3124 18.4686 10.3124C17.2778 10.3124 16.3124 9.34703 16.3124 8.1562C16.3124 6.96536 17.2778 6 18.4686 6C19.6594 6 20.6248 6.96536 20.6248 8.1562ZM7.75993 16.0611C8.36739 14.5425 9.83822 13.5467 11.4738 13.5467H12.5262C14.1618 13.5467 15.6326 14.5425 16.2401 16.0611L16.2934 16.1944C16.8189 17.5081 15.8514 18.9372 14.4364 18.9372H9.56358C8.14865 18.9372 7.18113 17.5081 7.70662 16.1944L7.75993 16.0611ZM5.1654 11.3905C3.82374 11.3905 2.61724 12.2073 2.11896 13.453C1.68791 14.5307 2.48154 15.7029 3.64218 15.7029H6.17828L6.46621 14.983C6.86637 13.9826 7.6412 13.2091 8.59099 12.7977C7.98655 11.9287 6.98652 11.3905 5.89742 11.3905H5.1654ZM20.3578 15.7029H17.8217L17.5338 14.983C17.1336 13.9826 16.3588 13.2091 15.409 12.7977C16.0135 11.9287 17.0135 11.3905 18.1026 11.3905H18.8346C20.1763 11.3905 21.3828 12.2073 21.881 13.453C22.3121 14.5307 21.5185 15.7029 20.3578 15.7029Z", fill: "currentColor" })
});
P({
  displayName: "PolicyIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12 14.365C12.6937 14.365 13.2844 14.1313 13.7719 13.6637C14.2594 13.1962 14.5031 12.6233 14.5031 11.945C14.5031 11.2483 14.2594 10.6617 13.7719 10.185C13.2844 9.70833 12.6937 9.47 12 9.47C11.3062 9.47 10.7156 9.70833 10.2281 10.185C9.74062 10.6617 9.49687 11.2483 9.49687 11.945C9.49687 12.6233 9.74062 13.1962 10.2281 13.6637C10.7156 14.1313 11.3062 14.365 12 14.365ZM12 23C9.375 22.3583 7.21875 20.8687 5.53125 18.5312C3.84375 16.1938 3 13.6317 3 10.845V4.3L12 1L21 4.3V10.845C21 12.0367 20.8312 13.2054 20.4937 14.3512C20.1562 15.4971 19.6875 16.565 19.0875 17.555L15.4875 14.145C15.7312 13.8333 15.9094 13.485 16.0219 13.1C16.1344 12.715 16.1906 12.33 16.1906 11.945C16.1906 10.79 15.7828 9.81375 14.9672 9.01625C14.1516 8.21875 13.1625 7.82 12 7.82C10.8375 7.82 9.84844 8.21875 9.03281 9.01625C8.21719 9.81375 7.80937 10.79 7.80937 11.945C7.80937 13.0817 8.21719 14.0442 9.03281 14.8325C9.84844 15.6208 10.8375 16.015 12 16.015C12.4125 16.015 12.8156 15.9508 13.2094 15.8225C13.6031 15.6942 13.9781 15.5292 14.3344 15.3275L18.1312 18.93C17.3438 19.92 16.4344 20.7679 15.4031 21.4737C14.3719 22.1796 13.2375 22.6883 12 23Z", fill: "currentColor" })
});
P({
  displayName: "ProgramIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5501 20.2999L12 23L15.4499 20.2999L19.7749 19.7749L20.2999 15.4499L23 12L20.2999 8.5501L19.7749 4.22511L15.4499 3.70015L12 1L8.5501 3.70015L4.22511 4.22511L3.70015 8.5501L1 12L3.70015 15.4499L4.22511 19.7749L8.5501 20.2999ZM14.8073 18.7803L12 20.952L9.19267 18.7803L5.67007 18.3567L5.21969 14.8073L3.04797 12L5.21969 9.19267L5.64334 5.67007L9.19267 5.21969L12 3.04797L14.8073 5.21969L18.3299 5.67007L18.7803 9.19267L20.952 12L18.7803 14.8073L18.3567 18.3299L14.8073 18.7803Z", fill: "currentColor" }),
    w.createElement("path", { d: "M11.3571 16.8226L8.14286 14.9677C7.93929 14.8495 7.78125 14.6935 7.66875 14.5C7.55625 14.3065 7.5 14.0914 7.5 13.8548V10.1452C7.5 9.9086 7.55625 9.69355 7.66875 9.5C7.78125 9.30645 7.93929 9.15054 8.14286 9.03226L11.3571 7.17742C11.5607 7.05914 11.775 7 12 7C12.225 7 12.4393 7.05914 12.6429 7.17742L15.8571 9.03226C16.0607 9.15054 16.2188 9.30645 16.3313 9.5C16.4438 9.69355 16.5 9.9086 16.5 10.1452V13.8548C16.5 14.0914 16.4438 14.3065 16.3313 14.5C16.2188 14.6935 16.0607 14.8495 15.8571 14.9677L12.6429 16.8226C12.4393 16.9409 12.225 17 12 17C11.775 17 11.5607 16.9409 11.3571 16.8226ZM11.3571 15.3387V12.371L8.78571 10.871V13.8548L11.3571 15.3387ZM12.6429 15.3387L15.2143 13.8548V10.871L12.6429 12.371V15.3387ZM12 11.2581L14.5393 9.75806L12 8.29032L9.46071 9.75806L12 11.2581Z", fill: "currentColor" })
  )
});
P({
  displayName: "PromotionIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.9998 22.9998L8.54986 20.2996L4.22486 19.7746L3.69991 15.4497L0.999756 11.9998L3.69991 8.54986L4.22486 4.22486L8.54986 3.69991L11.9998 0.999756L15.4497 3.69991L19.7746 4.22486L20.2996 8.54986L22.9998 11.9998L20.2996 15.4497L19.7746 19.7746L15.4497 20.2996L11.9998 22.9998ZM11.9998 20.9518L14.8071 18.7801L18.3564 18.3297L18.7801 14.8071L20.9518 11.9998L18.7801 9.19242L18.3297 5.66982L14.8071 5.21944L11.9998 3.04772L9.19242 5.21944L5.6431 5.66982L5.21944 9.19242L3.04772 11.9998L5.21944 14.8071L5.66982 18.3564L9.19242 18.7801L11.9998 20.9518ZM10.284 10.2823C9.94219 10.6252 9.53057 10.7967 9.0491 10.7967C8.56747 10.7967 8.1552 10.6258 7.81229 10.284C7.46938 9.94219 7.29792 9.53057 7.29792 9.0491C7.29792 8.56747 7.46889 8.1552 7.81084 7.81229C8.15262 7.46938 8.56425 7.29792 9.04571 7.29792C9.52734 7.29792 9.93961 7.46881 10.2825 7.8106C10.6254 8.15254 10.7969 8.56425 10.7969 9.04571C10.7969 9.52718 10.6259 9.93937 10.284 10.2823ZM15.0474 16.7949C15.5288 16.7949 15.9404 16.6235 16.2822 16.2805C16.6242 15.9376 16.7951 15.5254 16.7951 15.044C16.7951 14.5625 16.6237 14.1508 16.2808 13.8088C15.9379 13.4671 15.5256 13.2962 15.044 13.2962C14.5625 13.2962 14.1509 13.4676 13.8091 13.8105C13.4671 14.1535 13.2962 14.5657 13.2962 15.0474C13.2962 15.5288 13.4676 15.9404 13.8105 16.2822C14.1535 16.624 14.5657 16.7949 15.0474 16.7949ZM16.2256 7.72812C15.9328 7.43532 15.4581 7.43532 15.1653 7.72812L7.74284 15.1506C7.45003 15.4434 7.45003 15.9181 7.74284 16.2109C8.03565 16.5037 8.51038 16.5037 8.80319 16.2109L16.2256 8.78847C16.5185 8.49567 16.5185 8.02093 16.2256 7.72812Z", fill: "currentColor" })
});
P({
  displayName: "PsychologyIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.1096 13.7019L11.1808 14.3769C11.191 14.4974 11.2383 14.5961 11.3225 14.673C11.4068 14.75 11.5101 14.7884 11.6327 14.7884H12.3673C12.4898 14.7884 12.5932 14.75 12.6775 14.673C12.7617 14.5961 12.8089 14.4974 12.8192 14.3769L12.8904 13.7019C13.0878 13.6519 13.2727 13.5791 13.4452 13.4836C13.6176 13.3881 13.7647 13.2698 13.8865 13.1288L14.4923 13.4057C14.5961 13.4557 14.7026 13.4658 14.8118 13.436C14.921 13.4061 15.0068 13.339 15.0692 13.2346L15.4365 12.6019C15.4968 12.4981 15.5154 12.3925 15.4926 12.2853C15.4697 12.1781 15.4125 12.0862 15.3211 12.0096L14.7769 11.6115C14.8487 11.4077 14.8846 11.2038 14.8846 11C14.8846 10.7961 14.8487 10.5923 14.7769 10.3884L15.3211 9.99035C15.4125 9.91377 15.4697 9.82187 15.4926 9.71465C15.5154 9.60743 15.4968 9.5019 15.4365 9.39805L15.0692 8.76538C15.0068 8.66094 14.921 8.59381 14.8118 8.56398C14.7026 8.53414 14.5961 8.54423 14.4923 8.59423L13.8865 8.87115C13.7647 8.73012 13.6176 8.61184 13.4452 8.51633C13.2727 8.42081 13.0878 8.34805 12.8904 8.29805L12.8192 7.62308C12.8089 7.50256 12.7617 7.40384 12.6775 7.32693C12.5932 7.24999 12.4898 7.21153 12.3673 7.21153H11.6327C11.5101 7.21153 11.4068 7.24999 11.3225 7.32693C11.2383 7.40384 11.191 7.50256 11.1808 7.62308L11.1096 8.29805C10.9122 8.34805 10.7272 8.42081 10.5548 8.51633C10.3824 8.61184 10.2352 8.73012 10.1134 8.87115L9.50768 8.59423C9.40383 8.54423 9.29731 8.53414 9.18813 8.56398C9.07894 8.59381 8.99315 8.66094 8.93075 8.76538L8.56345 9.39805C8.5032 9.5019 8.48451 9.60743 8.50738 9.71465C8.53024 9.82187 8.5874 9.91377 8.67885 9.99035L9.22308 10.3884C9.15128 10.5923 9.11538 10.7961 9.11538 11C9.11538 11.2038 9.15128 11.4077 9.22308 11.6115L8.67885 12.0096C8.5874 12.0862 8.53024 12.1781 8.50738 12.2853C8.48451 12.3925 8.5032 12.4981 8.56345 12.6019L8.93075 13.2346C8.99315 13.339 9.07894 13.4061 9.18813 13.436C9.29731 13.4658 9.40383 13.4557 9.50768 13.4057L10.1134 13.1288C10.2352 13.2698 10.3824 13.3881 10.5548 13.4836C10.7272 13.5791 10.9122 13.6519 11.1096 13.7019ZM11.9994 12.6827C11.5318 12.6827 11.1346 12.519 10.8077 12.1917C10.4807 11.8644 10.3173 11.467 10.3173 10.9994C10.3173 10.5318 10.4809 10.1346 10.8082 9.80765C11.1355 9.48073 11.533 9.31728 12.0006 9.31728C12.4681 9.31728 12.8654 9.48093 13.1923 9.80823C13.5192 10.1355 13.6827 10.533 13.6827 11.0006C13.6827 11.4681 13.519 11.8654 13.1917 12.1923C12.8644 12.5192 12.467 12.6827 11.9994 12.6827ZM6.5 17.4692C5.55 16.6025 4.8125 15.6093 4.2875 14.4894C3.7625 13.3695 3.5 12.2041 3.5 10.993C3.5 8.63386 4.32639 6.62857 5.97918 4.97715C7.63194 3.32572 9.63888 2.5 12 2.5C13.9423 2.5 15.6791 3.08045 17.2105 4.24135C18.7419 5.40225 19.7365 6.90833 20.1942 8.7596L21.3626 13.3742C21.4375 13.6593 21.3845 13.9182 21.2038 14.1509C21.023 14.3836 20.782 14.5 20.4807 14.5H18.5V17.6923C18.5 18.1894 18.3229 18.6149 17.9689 18.9689C17.6149 19.3229 17.1894 19.5 16.6922 19.5H14.5V20.75C14.5 20.9625 14.428 21.1406 14.2842 21.2843C14.1404 21.4281 13.9622 21.5 13.7496 21.5C13.537 21.5 13.3589 21.4281 13.2154 21.2843C13.0718 21.1406 13 20.9625 13 20.75V18.9086C13 18.6477 13.0866 18.4311 13.2598 18.2586C13.4331 18.0862 13.6477 18 13.9038 18H16.6922C16.782 18 16.8557 17.9711 16.9134 17.9134C16.9711 17.8557 17 17.782 17 17.6923V13.9038C17 13.6477 17.0866 13.4331 17.2598 13.2598C17.4331 13.0866 17.6477 13 17.9038 13H19.7L18.75 9.12498C18.3666 7.60189 17.5468 6.36696 16.2904 5.42018C15.034 4.47338 13.6038 3.99998 12 3.99998C10.0666 3.99998 8.41664 4.67591 7.04998 6.02778C5.68331 7.37964 4.99997 9.02358 4.99997 10.9596C4.99997 11.958 5.20414 12.9064 5.61247 13.8049C6.02081 14.7034 6.59998 15.5021 7.34998 16.201L7.99998 16.8V20.75C7.99998 20.9625 7.92807 21.1406 7.78425 21.2843C7.64045 21.4281 7.46225 21.5 7.24965 21.5C7.03707 21.5 6.85898 21.4281 6.7154 21.2843C6.5718 21.1406 6.5 20.9625 6.5 20.75V17.4692Z", fill: "currentColor" })
});
P({
  displayName: "PsychologyQuestionIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.49951 17.469C5.54951 16.6023 4.81201 15.609 4.28701 14.4891C3.76201 13.3693 3.49951 12.2038 3.49951 10.9928C3.49951 8.63361 4.3259 6.62832 5.97869 4.97691C7.63145 3.32547 9.63839 2.49976 11.9995 2.49976C13.9418 2.49976 15.6786 3.08021 17.21 4.24111C18.7414 5.40201 19.736 6.90809 20.1937 8.75936L21.3621 13.3739C21.437 13.6591 21.3841 13.918 21.2033 14.1507C21.0225 14.3834 20.7815 14.4997 20.4802 14.4997H18.4995V17.692C18.4995 18.1891 18.3225 18.6147 17.9684 18.9687C17.6144 19.3227 17.1889 19.4997 16.6918 19.4997H14.4995V20.7497C14.4995 20.9622 14.4276 21.1403 14.2837 21.2841C14.1399 21.4278 13.9617 21.4997 13.7491 21.4997C13.5365 21.4997 13.3584 21.4278 13.2149 21.2841C13.0713 21.1403 12.9995 20.9622 12.9995 20.7497V18.9083C12.9995 18.6475 13.0861 18.4308 13.2593 18.2584C13.4326 18.0859 13.6472 17.9997 13.9033 17.9997H16.6918C16.7815 17.9997 16.8552 17.9709 16.9129 17.9132C16.9706 17.8555 16.9995 17.7818 16.9995 17.692V13.9036C16.9995 13.6475 17.0861 13.4328 17.2593 13.2596C17.4326 13.0863 17.6472 12.9997 17.9033 12.9997H19.6995L18.7495 9.12473C18.3662 7.60165 17.5463 6.36671 16.2899 5.41993C15.0335 4.47313 13.6033 3.99973 11.9995 3.99973C10.0662 3.99973 8.41615 4.67567 7.04949 6.02753C5.68282 7.3794 4.99949 9.02334 4.99949 10.9594C4.99949 11.9577 5.20365 12.9061 5.61199 13.8047C6.02032 14.7032 6.59949 15.5019 7.34949 16.2007L7.99949 16.7997V20.7497C7.99949 20.9622 7.92758 21.1403 7.78376 21.2841C7.63996 21.4278 7.46176 21.4997 7.24916 21.4997C7.03658 21.4997 6.8585 21.4278 6.71491 21.2841C6.57131 21.1403 6.49951 20.9622 6.49951 20.7497V17.469ZM11.903 15.9036C12.1481 15.9036 12.3536 15.8207 12.5197 15.6549C12.6857 15.4891 12.7687 15.2836 12.7687 15.0385C12.7687 14.7934 12.6858 14.5879 12.52 14.4219C12.3542 14.2558 12.1488 14.1728 11.9037 14.1728C11.6586 14.1728 11.453 14.2557 11.287 14.4215C11.121 14.5873 11.038 14.7928 11.038 15.0379C11.038 15.283 11.1209 15.4885 11.2867 15.6545C11.4524 15.8206 11.6579 15.9036 11.903 15.9036ZM11.9774 7.57858C12.3896 7.57858 12.7309 7.6929 13.0014 7.92153C13.2719 8.15015 13.4072 8.44546 13.4072 8.80746C13.4072 9.07184 13.3364 9.32383 13.1947 9.56343C13.053 9.80303 12.7674 10.1459 12.338 10.5921C12.0405 10.9062 11.8178 11.1972 11.6697 11.4651C11.5216 11.7331 11.4226 12.0241 11.3726 12.3382C11.3456 12.4933 11.3884 12.6315 11.5008 12.7526C11.6133 12.8738 11.7554 12.9344 11.9274 12.9344C12.0729 12.9344 12.2072 12.8847 12.3302 12.7853C12.4533 12.686 12.5367 12.5504 12.5802 12.3786C12.6302 12.1722 12.7158 11.9667 12.837 11.7623C12.9581 11.5578 13.1386 11.3241 13.3783 11.0613C13.8796 10.51 14.2136 10.086 14.3802 9.78918C14.5469 9.49238 14.6302 9.16514 14.6302 8.80746C14.6302 8.13951 14.3786 7.57829 13.8754 7.12381C13.3722 6.66932 12.7399 6.44208 11.9783 6.44208C11.4773 6.44208 11.0036 6.56163 10.5573 6.80073C10.1111 7.03983 9.7527 7.37156 9.48219 7.79591C9.40142 7.93052 9.39565 8.07027 9.46489 8.21513C9.5341 8.36 9.64115 8.46448 9.78601 8.52858C9.9309 8.59268 10.0732 8.60358 10.2129 8.56128C10.3527 8.51898 10.4764 8.42539 10.5841 8.28051C10.7636 8.05487 10.9751 7.88148 11.2186 7.76033C11.4622 7.63917 11.7151 7.57858 11.9774 7.57858Z", fill: "currentColor" })
});
P({
  displayName: "QRCodeIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 5V8.5H8.5V5H5ZM4.38462 3C3.61991 3 3 3.61991 3 4.38462V9.11538C3 9.88009 3.61991 10.5 4.38462 10.5H9.11538C9.88009 10.5 10.5 9.88009 10.5 9.11538V4.38462C10.5 3.61991 9.88009 3 9.11538 3H4.38462Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 15.5V19H8.5V15.5H5ZM4.38462 13.5C3.61991 13.5 3 14.1199 3 14.8846V19.6154C3 20.3801 3.61991 21 4.38462 21H9.11538C9.88009 21 10.5 20.3801 10.5 19.6154V14.8846C10.5 14.1199 9.88009 13.5 9.11538 13.5H4.38462Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 5V8.5H19V5H15.5ZM14.8846 3C14.1199 3 13.5 3.61991 13.5 4.38462V9.11538C13.5 9.88009 14.1199 10.5 14.8846 10.5H19.6154C20.3801 10.5 21 9.88009 21 9.11538V4.38462C21 3.61991 20.3801 3 19.6154 3H14.8846Z", fill: "currentColor" }),
    w.createElement("path", { d: "M13.5 14.8846C13.5 14.1199 14.1199 13.5 14.8846 13.5H19.6154C20.3801 13.5 21 14.1199 21 14.8846V19.6154C21 20.3801 20.3801 21 19.6154 21H14.8846C14.1199 21 13.5 20.3801 13.5 19.6154V14.8846Z", fill: "currentColor" })
  )
});
P({
  displayName: "QuestionIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12.331 3.07999C13.963 3.07999 15.267 3.52799 16.243 4.42399C17.235 5.31999 17.731 6.54399 17.731 8.09599C17.731 9.71199 17.219 10.928 16.195 11.744C15.171 12.56 13.811 12.968 12.115 12.968L12.019 14.864H9.64299L9.52299 11.096H10.315C11.867 11.096 13.051 10.888 13.867 10.472C14.699 10.056 15.115 9.26399 15.115 8.09599C15.115 7.24799 14.867 6.58399 14.371 6.10399C13.891 5.62399 13.219 5.38399 12.355 5.38399C11.491 5.38399 10.811 5.61599 10.315 6.07999C9.81899 6.54399 9.57099 7.19199 9.57099 8.02399H7.00299C7.00299 7.06399 7.21899 6.20799 7.65099 5.45599C8.08299 4.70399 8.69899 4.11999 9.49899 3.70399C10.315 3.28799 11.259 3.07999 12.331 3.07999ZM10.795 20.168C10.299 20.168 9.88299 20 9.54699 19.664C9.21099 19.328 9.04299 18.912 9.04299 18.416C9.04299 17.92 9.21099 17.504 9.54699 17.168C9.88299 16.832 10.299 16.664 10.795 16.664C11.275 16.664 11.683 16.832 12.019 17.168C12.355 17.504 12.523 17.92 12.523 18.416C12.523 18.912 12.355 19.328 12.019 19.664C11.683 20 11.275 20.168 10.795 20.168Z", fill: "currentColor" })
});
P({
  displayName: "QuestionCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.989 18.0747C12.2745 18.0747 12.5157 17.9762 12.7125 17.7792C12.9093 17.5821 13.0078 17.3406 13.0078 17.055C13.0078 16.7695 12.9092 16.5283 12.712 16.3315C12.5148 16.1348 12.2735 16.0365 11.988 16.0365C11.7025 16.0365 11.4613 16.1351 11.2645 16.3322C11.0677 16.5294 10.9692 16.7707 10.9692 17.0562C10.9692 17.3417 11.0678 17.5829 11.265 17.7797C11.4622 17.9764 11.7035 18.0747 11.989 18.0747ZM12.0017 21.9595C10.6877 21.9595 9.45267 21.7101 8.2965 21.2115C7.14033 20.7128 6.13467 20.0361 5.2795 19.1812C4.42433 18.3264 3.74725 17.3211 3.24825 16.1655C2.74942 15.0098 2.5 13.7751 2.5 12.4612C2.5 11.1472 2.74933 9.91214 3.248 8.75597C3.74667 7.59981 4.42342 6.59414 5.27825 5.73897C6.13308 4.88381 7.13833 4.20672 8.294 3.70772C9.44967 3.20889 10.6844 2.95947 11.9983 2.95947C13.3123 2.95947 14.5473 3.20881 15.7035 3.70747C16.8597 4.20614 17.8653 4.88289 18.7205 5.73772C19.5757 6.59256 20.2528 7.59781 20.7518 8.75347C21.2506 9.90914 21.5 11.1439 21.5 12.4577C21.5 13.7717 21.2507 15.0068 20.752 16.163C20.2533 17.3191 19.5766 18.3248 18.7218 19.18C17.8669 20.0351 16.8617 20.7122 15.706 21.2112C14.5503 21.7101 13.3156 21.9595 12.0017 21.9595ZM12 20.4595C14.2333 20.4595 16.125 19.6845 17.675 18.1345C19.225 16.5845 20 14.6928 20 12.4595C20 10.2261 19.225 8.33447 17.675 6.78447C16.125 5.23447 14.2333 4.45947 12 4.45947C9.76667 4.45947 7.875 5.23447 6.325 6.78447C4.775 8.33447 4 10.2261 4 12.4595C4 14.6928 4.775 16.5845 6.325 18.1345C7.875 19.6845 9.76667 20.4595 12 20.4595ZM12.081 8.17872C12.5423 8.17872 12.9416 8.32397 13.2788 8.61447C13.6161 8.90497 13.7848 9.26806 13.7848 9.70372C13.7848 10.0704 13.677 10.3986 13.4615 10.6882C13.2462 10.9781 13 11.248 12.723 11.498C12.36 11.82 12.0404 12.1742 11.7643 12.5607C11.4881 12.9471 11.3404 13.3774 11.3212 13.8517C11.3147 14.0339 11.3788 14.1865 11.5135 14.3095C11.6482 14.4325 11.8052 14.494 11.9845 14.494C12.1768 14.494 12.3397 14.4299 12.473 14.3017C12.6063 14.1736 12.6916 14.0166 12.7288 13.8307C12.7954 13.4871 12.9374 13.181 13.1547 12.9125C13.3721 12.6438 13.6075 12.3884 13.861 12.1462C14.2255 11.7909 14.5436 11.4036 14.8152 10.9842C15.0871 10.5647 15.223 10.0969 15.223 9.58072C15.223 8.78839 14.9108 8.13739 14.2865 7.62772C13.6622 7.11822 12.9333 6.86347 12.1 6.86347C11.5052 6.86347 10.9443 6.99514 10.4173 7.25847C9.89042 7.52197 9.48017 7.90631 9.1865 8.41147C9.0955 8.56664 9.06633 8.72989 9.099 8.90122C9.1315 9.07272 9.21942 9.20289 9.36275 9.29172C9.54525 9.39322 9.73267 9.42222 9.925 9.37872C10.1173 9.33506 10.2807 9.22547 10.4152 9.04997C10.6179 8.78714 10.8632 8.57622 11.151 8.41722C11.4388 8.25822 11.7488 8.17872 12.081 8.17872Z", fill: "currentColor" })
});
P({
  displayName: "QuestionCircleSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9118 17.7249C12.2817 17.7249 12.5977 17.5939 12.8598 17.3319C13.1218 17.0698 13.2529 16.7532 13.2529 16.382C13.2529 16.0109 13.1218 15.6971 12.8598 15.4408C12.5977 15.1845 12.2817 15.0564 11.9118 15.0564C11.5419 15.0564 11.2259 15.1845 10.9639 15.4408C10.7019 15.6971 10.5708 16.0109 10.5708 16.382C10.5708 16.7532 10.7019 17.0698 10.9639 17.3319C11.2259 17.5939 11.5419 17.7249 11.9118 17.7249ZM10.9048 14.0514H12.9396C12.9396 13.5626 13.0015 13.1626 13.1253 12.8515C13.2491 12.5403 13.5668 12.1403 14.0784 11.6515C14.4649 11.274 14.7752 10.8914 15.0092 10.5037C15.2433 10.116 15.3603 9.64997 15.3603 9.10556C15.3603 8.1817 15.0433 7.47449 14.4092 6.98392C13.7752 6.49337 13.0129 6.2481 12.1224 6.2481C11.18 6.2481 10.404 6.50911 9.79454 7.03113C9.18505 7.55315 8.76001 8.17508 8.5194 8.89691L10.3904 9.61151C10.4879 9.30729 10.6645 8.99269 10.9203 8.66772C11.1762 8.34275 11.5544 8.18027 12.055 8.18027C12.456 8.18027 12.7612 8.29695 12.9707 8.5303C13.1802 8.76366 13.285 9.02034 13.285 9.30035C13.285 9.57347 13.1963 9.84243 13.019 10.1072C12.8416 10.372 12.6413 10.5968 12.4179 10.7814C11.7542 11.3836 11.336 11.8595 11.1635 12.209C10.991 12.5585 10.9048 13.1726 10.9048 14.0514ZM12 22C10.6082 22 9.3049 21.7379 8.0902 21.2138C6.87547 20.6896 5.81884 19.9783 4.92029 19.0797C4.02173 18.1812 3.31038 17.1245 2.78623 15.9098C2.26208 14.6951 2 13.3918 2 12C2 10.6082 2.26208 9.3049 2.78623 8.0902C3.31038 6.87547 4.02173 5.81884 4.92029 4.92029C5.81884 4.02173 6.87547 3.31038 8.0902 2.78623C9.3049 2.26208 10.6082 2 12 2C13.3918 2 14.6951 2.26208 15.9098 2.78623C17.1245 3.31038 18.1812 4.02173 19.0797 4.92029C19.9783 5.81884 20.6896 6.87547 21.2138 8.0902C21.7379 9.3049 22 10.6082 22 12C22 13.3918 21.7379 14.6951 21.2138 15.9098C20.6896 17.1245 19.9783 18.1812 19.0797 19.0797C18.1812 19.9783 17.1245 20.6896 15.9098 21.2138C14.6951 21.7379 13.3918 22 12 22Z", fill: "currentColor" })
});
P({
  displayName: "ReceiptIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M5.99997 21.5C5.30127 21.5 4.70993 21.258 4.22595 20.774C3.74198 20.29 3.5 19.6987 3.5 19V17.4039C3.5 17.1462 3.58623 16.9311 3.75868 16.7587C3.93111 16.5863 4.14617 16.5 4.40385 16.5H6.5V3.18657C6.5 3.08274 6.54199 3.01319 6.62598 2.97792C6.70994 2.94267 6.79039 2.9571 6.86733 3.0212L7.60193 3.6308C7.68911 3.70517 7.78334 3.74235 7.88462 3.74235C7.98591 3.74235 8.08013 3.70517 8.1673 3.6308L9.00577 2.9462C9.09296 2.87183 9.18718 2.83465 9.28845 2.83465C9.38973 2.83465 9.48397 2.87183 9.57115 2.9462L10.4096 3.6308C10.4968 3.70517 10.591 3.74235 10.6923 3.74235C10.7936 3.74235 10.8878 3.70517 10.975 3.6308L11.8135 2.9462C11.9006 2.87183 11.9949 2.83465 12.0961 2.83465C12.1974 2.83465 12.2916 2.87183 12.3788 2.9462L13.2173 3.6308C13.3045 3.70517 13.3987 3.74235 13.5 3.74235C13.6013 3.74235 13.6955 3.70517 13.7827 3.6308L14.6211 2.9462C14.7083 2.87183 14.8025 2.83465 14.9038 2.83465C15.0051 2.83465 15.0993 2.87183 15.1865 2.9462L16.025 3.6308C16.1121 3.70517 16.2064 3.74235 16.3077 3.74235C16.4089 3.74235 16.5032 3.70517 16.5904 3.6308L17.4288 2.9462C17.516 2.87183 17.6102 2.83465 17.7115 2.83465C17.8128 2.83465 17.907 2.87183 17.9942 2.9462L18.8327 3.6308C18.9198 3.70517 19.014 3.74235 19.1153 3.74235C19.2166 3.74235 19.3108 3.70517 19.398 3.6308L20.1326 3.0212C20.2096 2.9571 20.29 2.94267 20.374 2.97792C20.458 3.01319 20.5 3.08274 20.5 3.18657V19C20.5 19.6987 20.258 20.29 19.774 20.774C19.29 21.258 18.6987 21.5 18 21.5H5.99997ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9041 19.5208 19 19.2833 19 19V5H7.99998V16.5H16.0961C16.3538 16.5 16.5689 16.5863 16.7413 16.7587C16.9138 16.9311 17 17.1462 17 17.4039V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4791 19.9042 17.7166 20 18 20ZM9.94228 7.25002H14.1154C14.3282 7.25002 14.5064 7.32182 14.65 7.4654C14.7936 7.60898 14.8654 7.78718 14.8654 8C14.8654 8.21282 14.7936 8.39102 14.65 8.5346C14.5064 8.67818 14.3282 8.74998 14.1154 8.74998H9.94228C9.72946 8.74998 9.55126 8.67818 9.40768 8.5346C9.26409 8.39102 9.1923 8.21282 9.1923 8C9.1923 7.78718 9.26409 7.60898 9.40768 7.4654C9.55126 7.32182 9.72946 7.25002 9.94228 7.25002ZM9.94228 10.25H14.1154C14.3282 10.25 14.5064 10.3218 14.65 10.4654C14.7936 10.609 14.8654 10.7872 14.8654 11C14.8654 11.2128 14.7936 11.391 14.65 11.5346C14.5064 11.6782 14.3282 11.75 14.1154 11.75H9.94228C9.72946 11.75 9.55126 11.6782 9.40768 11.5346C9.26409 11.391 9.1923 11.2128 9.1923 11C9.1923 10.7872 9.26409 10.609 9.40768 10.4654C9.55126 10.3218 9.72946 10.25 9.94228 10.25ZM16.9423 8.8846C16.6974 8.8846 16.4888 8.79838 16.3163 8.62595C16.1439 8.45352 16.0577 8.24487 16.0577 8C16.0577 7.75513 16.1439 7.54648 16.3163 7.37405C16.4888 7.20162 16.6974 7.1154 16.9423 7.1154C17.1871 7.1154 17.3958 7.20162 17.5682 7.37405C17.7407 7.54648 17.8269 7.75513 17.8269 8C17.8269 8.24487 17.7407 8.45352 17.5682 8.62595C17.3958 8.79838 17.1871 8.8846 16.9423 8.8846ZM16.9423 11.8846C16.6974 11.8846 16.4888 11.7984 16.3163 11.6259C16.1439 11.4535 16.0577 11.2449 16.0577 11C16.0577 10.7551 16.1439 10.5465 16.3163 10.374C16.4888 10.2016 16.6974 10.1154 16.9423 10.1154C17.1871 10.1154 17.3958 10.2016 17.5682 10.374C17.7407 10.5465 17.8269 10.7551 17.8269 11C17.8269 11.2449 17.7407 11.4535 17.5682 11.6259C17.3958 11.7984 17.1871 11.8846 16.9423 11.8846ZM5.99997 20H15.5V18H4.99997V19C4.99997 19.2833 5.09581 19.5208 5.28747 19.7125C5.47914 19.9042 5.71664 20 5.99997 20Z", fill: "currentColor" })
});
P({
  displayName: "ReceiveIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3C12.5523 3 13 3.44772 13 4V12.4066L15.6586 9.02855C16.0002 8.59456 16.6289 8.51963 17.0629 8.8612C17.4969 9.20277 17.5718 9.83149 17.2303 10.2655L12.7922 15.9044C12.6093 16.1414 12.3225 16.2941 12 16.2941C11.6761 16.2941 11.3881 16.1401 11.2054 15.9013L6.76975 10.2655C6.42818 9.83149 6.50311 9.20277 6.9371 8.8612C7.37109 8.51963 7.99981 8.59456 8.34138 9.02855L11 12.4065V4C11 3.44772 11.4477 3 12 3ZM18.3334 20C18.3334 20.5523 17.8857 21 17.3334 21H6.66675C6.11446 21 5.66675 20.5523 5.66675 20C5.66675 19.4477 6.11446 19 6.66675 19L17.3334 19C17.8857 19 18.3334 19.4477 18.3334 20Z", fill: "currentColor" })
});
P({
  displayName: "ResourcesIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2243 3.91942C12.9403 3.41163 10.8586 3.41163 9.57471 3.91942L4.11037 6.08054C2.82643 6.58833 2.82643 7.41163 4.11037 7.91942L9.57471 10.0805C10.8587 10.5883 12.9403 10.5883 14.2243 10.0805L19.6886 7.91942C20.9726 7.41162 20.9726 6.58833 19.6886 6.08054L14.2243 3.91942ZM5.52119 9.99998L4.11037 10.558C2.82643 11.0657 2.82643 11.889 4.11037 12.3968L9.57471 14.558C10.8587 15.0657 12.9403 15.0657 14.2243 14.558L19.6886 12.3968C20.9726 11.889 20.9726 11.0657 19.6886 10.558L18.2778 9.99998L14.2243 11.6031C12.9403 12.1109 10.8587 12.1109 9.57471 11.6031L5.52119 9.99998ZM5.52119 14.5L4.11037 15.058C2.82643 15.5657 2.82643 16.389 4.11037 16.8968L9.57471 19.058C10.8587 19.5657 12.9403 19.5657 14.2243 19.058L19.6886 16.8968C20.9726 16.389 20.9726 15.5657 19.6886 15.058L18.2778 14.5L14.2243 16.1031C12.9403 16.6109 10.8587 16.6109 9.57471 16.1031L5.52119 14.5Z", fill: "currentColor" })
});
P({
  displayName: "RestakingIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M12 21C10.3362 21 8.82633 20.5863 7.47044 19.7588C6.11455 18.9313 5.05102 17.8225 4.27984 16.4324V18.3461C4.27984 18.5285 4.21858 18.6813 4.09607 18.8044C3.97354 18.9274 3.82149 18.989 3.63991 18.989C3.45834 18.989 3.30629 18.9274 3.18377 18.8044C3.06126 18.6813 3 18.5285 3 18.3461V15.0494C3 14.8286 3.07356 14.6442 3.22069 14.4964C3.36782 14.3486 3.55132 14.2747 3.7712 14.2747H7.05288C7.23445 14.2747 7.3865 14.3362 7.50902 14.4593C7.63153 14.5824 7.69279 14.7351 7.69279 14.9176C7.69279 15.1 7.63153 15.2527 7.50902 15.3758C7.3865 15.4989 7.23445 15.5604 7.05288 15.5604H5.26923C5.88619 16.8088 6.79796 17.8132 8.00452 18.5736C9.2111 19.3341 10.5429 19.7143 12 19.7143C13.9832 19.7143 15.6952 19.0566 17.1358 17.7412C18.5765 16.4258 19.4073 14.7841 19.6283 12.8159C19.6512 12.6368 19.7262 12.4918 19.8531 12.3808C19.98 12.2698 20.1325 12.2143 20.3109 12.2143C20.4924 12.2143 20.6453 12.2756 20.7695 12.3981C20.8936 12.5206 20.9442 12.667 20.9212 12.8374C20.8162 13.9857 20.5116 15.0547 20.0073 16.0442C19.503 17.0338 18.8519 17.8959 18.0539 18.6305C17.2559 19.3651 16.3403 19.9437 15.3071 20.3662C14.2739 20.7887 13.1716 21 12 21ZM12 4.2857C10.0496 4.2857 8.34721 4.93378 6.89288 6.22994C5.43855 7.52608 4.59817 9.17471 4.37173 11.1758C4.34875 11.3549 4.27381 11.5014 4.14692 11.6151C4.02005 11.7288 3.86746 11.7857 3.68916 11.7857C3.5021 11.7857 3.34787 11.7244 3.22645 11.6019C3.10502 11.4794 3.05579 11.3302 3.07878 11.1544C3.19473 9.98405 3.50895 8.90274 4.02143 7.91043C4.53392 6.91813 5.18916 6.05879 5.98717 5.33242C6.78516 4.60605 7.69801 4.03572 8.72572 3.62143C9.75343 3.20714 10.8449 3 12 3C13.6474 3 15.1573 3.41512 16.5296 4.24535C17.9019 5.07558 18.9654 6.194 19.7202 7.60062V5.65387C19.7202 5.47146 19.7814 5.31871 19.9039 5.19564C20.0265 5.07257 20.1785 5.01103 20.3601 5.01103C20.5417 5.01103 20.6937 5.07257 20.8162 5.19564C20.9387 5.31871 21 5.47146 21 5.65387V8.95058C21 9.17145 20.9264 9.35579 20.7793 9.50359C20.6322 9.65139 20.4487 9.72529 20.2288 9.72529H16.9471C16.7655 9.72529 16.6135 9.66375 16.491 9.54068C16.3685 9.41761 16.3072 9.26487 16.3072 9.08245C16.3072 8.90004 16.3685 8.74729 16.491 8.62422C16.6135 8.50115 16.7655 8.43961 16.9471 8.43961H18.7308C18.1302 7.21321 17.2253 6.21429 16.016 5.44286C14.8067 4.67142 13.468 4.2857 12 4.2857Z", fill: "currentColor" }),
    w.createElement("path", { d: "M12 16.4987C10.7513 16.4987 9.6891 16.0609 8.81345 15.1853C7.93782 14.3096 7.5 13.2475 7.5 11.9988C7.5 10.7501 7.93782 9.68788 8.81345 8.81223C9.6891 7.9366 10.7513 7.49878 12 7.49878C13.2487 7.49878 14.3109 7.9366 15.1865 8.81223C16.0621 9.68788 16.5 10.7501 16.5 11.9988C16.5 13.2475 16.0621 14.3096 15.1865 15.1853C14.3109 16.0609 13.2487 16.4987 12 16.4987ZM11.5577 12.4411V14.3064C11.5577 14.4244 11.6019 14.5276 11.6903 14.6161C11.7788 14.7045 11.882 14.7487 12 14.7487C12.1179 14.7487 12.2211 14.7045 12.3096 14.6161C12.3981 14.5276 12.4423 14.4244 12.4423 14.3064V12.4411H14.3077C14.4256 12.4411 14.5288 12.3968 14.6173 12.3084C14.7057 12.2199 14.75 12.1167 14.75 11.9988C14.75 11.8808 14.7057 11.7776 14.6173 11.6892C14.5288 11.6007 14.4256 11.5565 14.3077 11.5565H12.4423V9.69108C12.4423 9.57313 12.3981 9.46992 12.3096 9.38145C12.2211 9.293 12.1179 9.24878 12 9.24878C11.882 9.24878 11.7788 9.293 11.6903 9.38145C11.6019 9.46992 11.5577 9.57313 11.5577 9.69108V11.5565H9.6923C9.57435 11.5565 9.47114 11.6007 9.38267 11.6892C9.29422 11.7776 9.25 11.8808 9.25 11.9988C9.25 12.1167 9.29422 12.2199 9.38267 12.3084C9.47114 12.3968 9.57435 12.4411 9.6923 12.4411H11.5577Z", fill: "currentColor" })
  )
});
P({
  displayName: "RocketIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.2738 6.16172C13.0196 4.7305 15.1612 3.86692 17.4115 3.68662L20.9738 3.4012L20.6884 6.9635C20.5081 9.21384 19.6445 11.3554 18.2133 13.1013C17.2144 14.3197 15.9762 15.3005 14.5891 15.9921L14.6403 16.191L14.7247 16.5192C15.0653 17.8427 14.482 19.2309 13.2983 19.9139L10.2134 21.6938L11.581 19.5335C11.8819 19.0583 11.8989 18.4542 11.5949 17.981C11.3355 17.5771 11.0145 17.1147 10.7514 16.8517L9.13739 15.2376L7.52333 13.6236C7.01953 13.1198 6.56887 12.7987 6.23202 12.5997C5.85633 12.3778 5.40248 12.4388 5.0338 12.6722L2.68116 14.1616L4.4611 11.0767C5.14408 9.89302 6.53229 9.30969 7.85576 9.65027L8.18403 9.73475L8.38292 9.78593C9.07449 8.39879 10.0553 7.16059 11.2738 6.16172ZM16.6697 10.9335C15.7782 11.8249 14.333 11.8249 13.4415 10.9335C12.5501 10.0421 12.5501 8.59677 13.4415 7.70536C14.333 6.81394 15.7782 6.81394 16.6697 7.70536C17.5611 8.59677 17.5611 10.0421 16.6697 10.9335ZM4.02621 20.3488C4.02621 20.3488 7.3185 19.2086 8.06135 18.4657C8.8042 17.7229 8.92464 16.6389 8.33036 16.0446C7.73608 15.4504 6.65212 15.5708 5.90927 16.3137C5.16642 17.0565 4.02621 20.3488 4.02621 20.3488Z", fill: "currentColor" })
});
P({
  displayName: "RocketLaunchIcon",
  viewBox: "0 0 32 32",
  path: w.createElement("path", { d: "M10.2358 15.8C10.5981 15.0752 10.9845 14.3769 11.3947 13.7051C11.805 13.0333 12.2571 12.3701 12.7512 11.7154L10.7948 11.3231C10.7264 11.306 10.6601 11.3081 10.596 11.3295C10.5319 11.3508 10.4742 11.3871 10.4229 11.4384L7.40497 14.4564C7.37932 14.482 7.37078 14.512 7.37933 14.5462C7.38787 14.5803 7.40923 14.606 7.44343 14.6231L10.2358 15.8ZM25.905 6.2359C24.1015 6.33161 22.3678 6.78502 20.7037 7.59614C19.0396 8.40725 17.5024 9.51792 16.0921 10.9282C15.1332 11.8871 14.287 12.9 13.5537 13.9666C12.8203 15.0333 12.246 16.0632 11.8306 17.0564L15.6178 20.8231C16.6109 20.4077 17.643 19.8333 18.7139 19.1C19.7849 18.3666 20.7998 17.5205 21.7588 16.5615C23.169 15.1513 24.2797 13.6196 25.0908 11.9667C25.9019 10.3137 26.3554 8.58546 26.4511 6.78203C26.4511 6.71023 26.4408 6.64058 26.4203 6.57307C26.3998 6.50553 26.3605 6.44271 26.3024 6.3846C26.2443 6.32649 26.1814 6.28718 26.1139 6.26667C26.0464 6.24616 25.9767 6.2359 25.905 6.2359ZM18.6742 13.9923C18.2229 13.541 17.9973 12.9923 17.9973 12.3461C17.9973 11.7 18.2229 11.1513 18.6742 10.7C19.1255 10.2487 19.6776 10.0231 20.3306 10.0231C20.9836 10.0231 21.5357 10.2487 21.987 10.7C22.4383 11.1513 22.6639 11.7 22.6639 12.3461C22.6639 12.9923 22.4383 13.541 21.987 13.9923C21.5357 14.4436 20.9836 14.6692 20.3306 14.6692C19.6776 14.6692 19.1255 14.4436 18.6742 13.9923ZM16.8741 22.4307L18.0511 25.2435C18.0682 25.2777 18.0938 25.297 18.128 25.3012C18.1622 25.3055 18.1921 25.2948 18.2177 25.2692L21.2357 22.264C21.287 22.2128 21.3233 22.1551 21.3447 22.091C21.3661 22.0269 21.3682 21.9606 21.3511 21.8922L20.9588 19.9358C20.3041 20.4298 19.6408 20.8786 18.969 21.282C18.2972 21.6854 17.5989 22.0683 16.8741 22.4307ZM28.3562 5.60514C28.4399 7.93847 28.0292 10.1551 27.1241 12.2551C26.219 14.3551 24.8263 16.3453 22.946 18.2256C22.9032 18.2683 22.8626 18.3068 22.8241 18.341C22.7857 18.3752 22.7451 18.4136 22.7023 18.4564L23.3177 21.4871C23.3981 21.8888 23.378 22.2794 23.2575 22.6589C23.137 23.0384 22.934 23.3709 22.6485 23.6563L18.6921 27.6127C18.393 27.9119 18.0314 28.0247 17.6075 27.9512C17.1836 27.8777 16.8913 27.6401 16.7306 27.2384L14.9152 22.9717L9.70243 17.7461L5.4358 15.9308C5.03409 15.7701 4.7952 15.4778 4.71913 15.0538C4.64307 14.6299 4.75461 14.2684 5.05377 13.9692L9.01013 10.0128C9.2956 9.72737 9.6315 9.52651 10.0178 9.41027C10.4041 9.29405 10.7982 9.2761 11.1999 9.35643L14.2306 9.9718C14.2734 9.92907 14.3097 9.89061 14.3396 9.85643C14.3695 9.82223 14.4058 9.78377 14.4486 9.74103C16.3289 7.8607 18.3191 6.46583 20.419 5.55643C22.519 4.64703 24.7357 4.23421 27.069 4.31797C27.2297 4.33166 27.3882 4.37098 27.5446 4.43593C27.7011 4.50089 27.8417 4.59576 27.9664 4.72054C28.0912 4.84534 28.184 4.9838 28.2446 5.13593C28.3053 5.28807 28.3425 5.44447 28.3562 5.60514ZM6.5281 21.4282C7.17766 20.7786 7.96952 20.4526 8.9037 20.45C9.83788 20.4474 10.6297 20.7709 11.2793 21.4205C11.9289 22.0701 12.2502 22.8619 12.2434 23.7961C12.2366 24.7303 11.9084 25.5221 11.2588 26.1717C10.3545 27.076 9.28788 27.626 8.05883 27.8217C6.82979 28.0174 5.59306 28.1896 4.34863 28.3383C4.49734 27.0854 4.6717 25.8465 4.8717 24.6217C5.0717 23.397 5.62383 22.3324 6.5281 21.4282ZM7.9537 22.8461C7.56737 23.2324 7.29984 23.6923 7.15113 24.2256C7.00242 24.7589 6.88789 25.3076 6.80753 25.8717C7.37164 25.7914 7.92037 25.6782 8.4537 25.532C8.98703 25.3858 9.44687 25.1196 9.8332 24.7333C10.0999 24.4666 10.24 24.1465 10.2537 23.773C10.2674 23.3995 10.1409 23.0794 9.8742 22.8128C9.60753 22.5461 9.28745 22.4183 8.91397 22.4294C8.54045 22.4405 8.22037 22.5794 7.9537 22.8461Z", fill: "currentColor" })
});
P({
  displayName: "RuleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M16.525 8.53072L20.2481 4.80761C20.3968 4.6589 20.5724 4.58551 20.775 4.58744C20.9776 4.58936 21.1532 4.66788 21.3019 4.82302C21.4404 4.97405 21.5096 5.15027 21.5096 5.35167C21.5096 5.55307 21.4404 5.72811 21.3019 5.87681L17.1827 10.0114C17.0019 10.1922 16.791 10.2826 16.55 10.2826C16.309 10.2826 16.0981 10.1922 15.9173 10.0114L13.8731 7.97681C13.7346 7.83893 13.6654 7.66344 13.6654 7.45034C13.6654 7.23724 13.7344 7.06147 13.8724 6.92302C14.0104 6.78455 14.186 6.71532 14.3993 6.71532C14.6126 6.71532 14.7884 6.78455 14.9269 6.92302L16.525 8.53072ZM3 8.74989C2.7875 8.74989 2.60938 8.67799 2.46565 8.53419C2.32188 8.39037 2.25 8.21217 2.25 7.99959C2.25 7.78699 2.32187 7.6089 2.4656 7.46532C2.60935 7.32173 2.78748 7.24994 2.99998 7.24994H9.99997C10.2125 7.24994 10.3906 7.32184 10.5343 7.46564C10.6781 7.60946 10.7499 7.78766 10.7499 8.00024C10.7499 8.21284 10.6781 8.39093 10.5343 8.53451C10.3906 8.6781 10.2125 8.74989 9.99997 8.74989H3ZM17 17.0441L14.9269 19.1268C14.789 19.2653 14.6135 19.3345 14.4004 19.3345C14.1873 19.3345 14.0116 19.2655 13.8731 19.1275C13.7346 18.9895 13.6654 18.8139 13.6654 18.6006C13.6654 18.3873 13.7346 18.2115 13.8731 18.073L15.9558 15.9999L13.8731 13.9268C13.7346 13.7889 13.6654 13.6134 13.6654 13.4003C13.6654 13.1872 13.7344 13.0115 13.8724 12.873C14.0104 12.7345 14.186 12.6653 14.3993 12.6653C14.6126 12.6653 14.7884 12.7345 14.9269 12.873L17 14.9557L19.0731 12.873C19.211 12.7345 19.3865 12.6653 19.5996 12.6653C19.8127 12.6653 19.9884 12.7343 20.1269 12.8723C20.2654 13.0103 20.3346 13.186 20.3346 13.3992C20.3346 13.6125 20.2654 13.7884 20.1269 13.9268L18.0442 15.9999L20.1269 18.073C20.2654 18.2109 20.3346 18.3864 20.3346 18.5995C20.3346 18.8126 20.2656 18.9884 20.1276 19.1268C19.9896 19.2653 19.814 19.3345 19.6007 19.3345C19.3874 19.3345 19.2116 19.2653 19.0731 19.1268L17 17.0441ZM3 16.7499C2.7875 16.7499 2.60938 16.678 2.46565 16.5342C2.32188 16.3904 2.25 16.2122 2.25 15.9996C2.25 15.787 2.32187 15.6089 2.4656 15.4653C2.60935 15.3217 2.78748 15.2499 2.99998 15.2499H9.99997C10.2125 15.2499 10.3906 15.3218 10.5343 15.4656C10.6781 15.6095 10.7499 15.7877 10.7499 16.0002C10.7499 16.2128 10.6781 16.3909 10.5343 16.5345C10.3906 16.6781 10.2125 16.7499 9.99997 16.7499H3Z", fill: "currentColor" })
});
P({
  displayName: "SafeIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 11.5C15 13.1569 13.6569 14.5 12 14.5C10.3431 14.5 9 13.1569 9 11.5C9 9.84315 10.3431 8.5 12 8.5C13.6569 8.5 15 9.84315 15 11.5ZM13.5 11.5C13.5 12.3284 12.8284 13 12 13C11.1716 13 10.5 12.3284 10.5 11.5C10.5 10.6716 11.1716 10 12 10C12.8284 10 13.5 10.6716 13.5 11.5Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 5.5C6.89543 5.5 6 6.39543 6 7.5V8.5C5.44772 8.5 5 8.94772 5 9.5C5 10.0523 5.44772 10.5 6 10.5V12.5C5.44772 12.5 5 12.9477 5 13.5C5 14.0523 5.44772 14.5 6 14.5V15.5C6 16.6046 6.89543 17.5 8 17.5H16C17.1046 17.5 18 16.6046 18 15.5V7.5C18 6.39543 17.1046 5.5 16 5.5H8ZM16 7H8C7.72386 7 7.5 7.22386 7.5 7.5V15.5C7.5 15.7761 7.72386 16 8 16H16C16.2761 16 16.5 15.7761 16.5 15.5V7.5C16.5 7.22386 16.2761 7 16 7Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 2.5C4.79086 2.5 3 4.29086 3 6.5V16.5C3 18.4528 4.39935 20.0787 6.25 20.4298V21.5C6.25 21.9142 6.58579 22.25 7 22.25C7.41421 22.25 7.75 21.9142 7.75 21.5V20.5H16.25V21.5C16.25 21.9142 16.5858 22.25 17 22.25C17.4142 22.25 17.75 21.9142 17.75 21.5V20.4298C19.6006 20.0787 21 18.4528 21 16.5V6.5C21 4.29086 19.2091 2.5 17 2.5H7ZM17 4H7C5.61929 4 4.5 5.11929 4.5 6.5V16.5C4.5 17.8807 5.61929 19 7 19H17C18.3807 19 19.5 17.8807 19.5 16.5V6.5C19.5 5.11929 18.3807 4 17 4Z", fill: "currentColor" })
  )
});
P({
  displayName: "SandglassIcon",
  viewBox: "0 0 32 32",
  path: w.createElement("path", { id: "hourglass", d: "M10.5384 26.6668H21.4615V22.6668C21.4615 21.1488 20.9307 19.8506 19.8692 18.7719C18.8077 17.6933 17.5179 17.154 16 17.154C14.482 17.154 13.1923 17.6938 12.1307 18.7734C11.0692 19.853 10.5384 21.1508 10.5384 22.6668V26.6668ZM16 14.8463C17.5179 14.8463 18.8077 14.3065 19.8692 13.2269C20.9307 12.1473 21.4615 10.8495 21.4615 9.33346V5.33346H10.5384V9.33346C10.5384 10.8514 11.0692 12.1497 12.1307 13.2283C13.1923 14.307 14.482 14.8463 16 14.8463ZM7 28.6668C6.71667 28.6668 6.47917 28.5709 6.2875 28.3791C6.09583 28.1874 6 27.9498 6 27.6663C6 27.3829 6.09583 27.1454 6.2875 26.954C6.47917 26.7625 6.71667 26.6668 7 26.6668H8.53847V22.6668C8.53847 21.1659 8.94916 19.7997 9.77053 18.5681C10.5919 17.3364 11.6804 16.4805 13.036 16.0001C11.6804 15.5113 10.5919 14.6532 9.77053 13.4258C8.94916 12.1984 8.53847 10.8343 8.53847 9.33346V5.33346H7C6.71667 5.33346 6.47917 5.23758 6.2875 5.04583C6.09583 4.8541 6 4.6165 6 4.33303C6 4.04959 6.09583 3.81214 6.2875 3.6207C6.47917 3.42923 6.71667 3.3335 7 3.3335H24.9999C25.2833 3.3335 25.5208 3.42937 25.7124 3.62113C25.9041 3.81289 25.9999 4.05049 25.9999 4.33393C25.9999 4.6174 25.9041 4.85485 25.7124 5.0463C25.5208 5.23774 25.2833 5.33346 24.9999 5.33346H23.4615V9.33346C23.4615 10.8343 23.0508 12.1984 22.2294 13.4258C21.408 14.6532 20.3195 15.5113 18.964 16.0001C20.3195 16.4805 21.408 17.3364 22.2294 18.5681C23.0508 19.7997 23.4615 21.1659 23.4615 22.6668V26.6668H24.9999C25.2833 26.6668 25.5208 26.7627 25.7124 26.9544C25.9041 27.1462 25.9999 27.3838 25.9999 27.6672C25.9999 27.9507 25.9041 28.1881 25.7124 28.3796C25.5208 28.571 25.2833 28.6668 24.9999 28.6668H7Z", fill: "currentColor" })
});
P({
  displayName: "SavingIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M4.20385 18.5C3.83975 18.5 3.49295 18.3763 3.16345 18.1288C2.83397 17.8814 2.61731 17.5788 2.51347 17.2211C2.09681 15.7827 1.75995 14.5638 1.5029 13.5644C1.24585 12.565 1.04297 11.7035 0.89425 10.9798C0.745533 10.2561 0.642642 9.62467 0.585575 9.08558C0.528525 8.54648 0.5 8.01795 0.5 7.5C0.5 6.1077 0.985258 4.9263 1.95578 3.9558C2.92628 2.98528 4.10768 2.50003 5.49998 2.50003H10.75C11.2 1.90003 11.75 1.41669 12.4 1.05002C13.05 0.683358 13.75 0.500025 14.5 0.500025C14.7756 0.500025 15.0112 0.597784 15.2067 0.7933C15.4022 0.9888 15.5 1.22437 15.5 1.5C15.5 1.56795 15.4907 1.63429 15.4721 1.69903C15.4535 1.76378 15.4339 1.8282 15.4134 1.8923C15.3403 2.08845 15.2698 2.30063 15.2019 2.52885C15.1339 2.75705 15.0705 3.0468 15.0115 3.3981L17.6134 6.00003H18.5961C18.8538 6.00003 19.0688 6.08625 19.2413 6.2587C19.4137 6.43113 19.5 6.64619 19.5 6.90388V11.4519C19.5 11.6493 19.4439 11.825 19.3317 11.9788C19.2195 12.1327 19.0647 12.2449 18.8673 12.3154L16.7711 13.0058L15.5115 17.2096C15.391 17.6045 15.1718 17.9182 14.8538 18.1509C14.5359 18.3836 14.1743 18.5 13.7692 18.5H12.3077C11.809 18.5 11.383 18.3234 11.0298 17.9702C10.6766 17.617 10.5 17.191 10.5 16.6923V16.5H7.49995V16.6923C7.49995 17.191 7.32334 17.617 6.97013 17.9702C6.61693 18.3234 6.19097 18.5 5.69225 18.5H4.20385ZM4.25 17H5.69225C5.782 17 5.85572 16.9711 5.91342 16.9135C5.97113 16.8558 5.99998 16.782 5.99998 16.6923V15H12V16.6923C12 16.782 12.0288 16.8558 12.0865 16.9135C12.1442 16.9711 12.218 17 12.3077 17H13.7692C13.8397 17 13.9022 16.9808 13.9567 16.9423C14.0112 16.9038 14.0481 16.8493 14.0673 16.7788L15.55 11.85L18 11.025V7.5H17L13.5 4C13.5 3.6859 13.5224 3.36411 13.5673 3.03463C13.6122 2.70513 13.6795 2.39679 13.7692 2.10963C13.3051 2.23654 12.8849 2.47052 12.5086 2.81155C12.1323 3.15257 11.8545 3.54872 11.675 4H5.49998C4.53331 4 3.70831 4.34167 3.02498 5.025C2.34164 5.70833 1.99998 6.53333 1.99998 7.5C1.99998 8.17052 2.16857 9.3125 2.50575 10.926C2.84292 12.5394 3.31855 14.484 3.93265 16.7596C3.95188 16.8301 3.99196 16.8878 4.05288 16.9327C4.11378 16.9776 4.17948 17 4.25 17ZM14 8.8846C14.2448 8.8846 14.4535 8.79838 14.6259 8.62595C14.7984 8.45352 14.8846 8.24487 14.8846 8C14.8846 7.75513 14.7984 7.54648 14.6259 7.37405C14.4535 7.20162 14.2448 7.1154 14 7.1154C13.7551 7.1154 13.5465 7.20162 13.374 7.37405C13.2016 7.54648 13.1154 7.75513 13.1154 8C13.1154 8.24487 13.2016 8.45352 13.374 8.62595C13.5465 8.79838 13.7551 8.8846 14 8.8846ZM10.25 6.74998C10.4628 6.74998 10.641 6.67818 10.7846 6.5346C10.9282 6.39102 11 6.21282 11 6C11 5.78718 10.9282 5.60898 10.7846 5.4654C10.641 5.32182 10.4628 5.25003 10.25 5.25003H6.74995C6.53713 5.25003 6.35893 5.32182 6.21535 5.4654C6.07177 5.60898 5.99998 5.78718 5.99998 6C5.99998 6.21282 6.07177 6.39102 6.21535 6.5346C6.35893 6.67818 6.53713 6.74998 6.74995 6.74998H10.25Z", fill: "currentColor" })
});
P({
  displayName: "SearchIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM21.7071 20.2929L18.7071 17.2929C18.3166 16.9024 17.6834 16.9024 17.2929 17.2929C16.9024 17.6834 16.9024 18.3166 17.2929 18.7071L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929Z", fill: "currentColor" })
});
P({
  displayName: "SearchDocIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M4.99997 3.99998V10.1788V10.1538V20V3.99998ZM7.99997 13.75H10.7981C10.9224 13.4628 11.0673 13.1958 11.2327 12.949C11.3981 12.7022 11.5839 12.4692 11.7903 12.25H7.99997C7.78747 12.25 7.60936 12.3219 7.46563 12.4657C7.32188 12.6095 7.25 12.7877 7.25 13.0003C7.25 13.2129 7.32188 13.391 7.46563 13.5346C7.60936 13.6782 7.78747 13.75 7.99997 13.75ZM7.99997 17.75H10.2807C10.2214 17.5 10.1829 17.25 10.1651 17C10.1473 16.75 10.1487 16.5 10.1692 16.25H7.99997C7.78747 16.25 7.60936 16.3219 7.46563 16.4657C7.32188 16.6095 7.25 16.7877 7.25 17.0003C7.25 17.2129 7.32188 17.391 7.46563 17.5346C7.60936 17.6782 7.78747 17.75 7.99997 17.75ZM5.30597 21.5C4.80199 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6923V4.3077C3.5 3.80257 3.675 3.375 4.025 3.025C4.375 2.675 4.80257 2.5 5.3077 2.5H12.5019C12.7458 2.5 12.9782 2.5468 13.1993 2.6404C13.4203 2.73398 13.6128 2.86283 13.7769 3.02693L17.973 7.22303C18.1371 7.38714 18.266 7.5797 18.3595 7.8007C18.4531 8.02172 18.5 8.25416 18.5 8.49803V10.5096C18.2602 10.4147 18.0153 10.3426 17.7654 10.2933C17.5154 10.2439 17.2602 10.2058 17 10.1788V8.49995H13.3998C13.1448 8.49995 12.9311 8.4137 12.7587 8.2412C12.5862 8.0687 12.5 7.85495 12.5 7.59995V3.99998H5.3077C5.23077 3.99998 5.16024 4.03203 5.09612 4.09613C5.03202 4.16024 4.99997 4.23077 4.99997 4.3077V19.6923C4.99997 19.7692 5.03202 19.8397 5.09612 19.9038C5.16024 19.9679 5.23077 20 5.3077 20H11.2077C11.4029 20.2958 11.6226 20.5701 11.8666 20.8228C12.1106 21.0755 12.375 21.3012 12.6596 21.5H5.30597ZM16.5019 19.1538C17.2455 19.1538 17.8734 18.8971 18.3856 18.3837C18.8977 17.8702 19.1538 17.2417 19.1538 16.4981C19.1538 15.7545 18.8971 15.1266 18.3837 14.6144C17.8702 14.1022 17.2417 13.8461 16.4981 13.8461C15.7545 13.8461 15.1266 14.1028 14.6144 14.6163C14.1022 15.1297 13.8461 15.7583 13.8461 16.5019C13.8461 17.2455 14.1028 17.8734 14.6163 18.3856C15.1297 18.8977 15.7583 19.1538 16.5019 19.1538ZM22.1276 22.1269C21.9896 22.2653 21.8139 22.3346 21.6007 22.3346C21.3874 22.3346 21.2115 22.2653 21.0731 22.1269L18.8615 19.9057C18.5243 20.1519 18.1548 20.3381 17.7529 20.4644C17.3509 20.5907 16.9333 20.6538 16.5 20.6538C15.3461 20.6538 14.3654 20.25 13.5577 19.4423C12.75 18.6346 12.3461 17.6538 12.3461 16.5C12.3461 15.3461 12.75 14.3654 13.5577 13.5577C14.3654 12.75 15.3461 12.3462 16.5 12.3462C17.6538 12.3462 18.6346 12.75 19.4423 13.5577C20.25 14.3654 20.6538 15.3461 20.6538 16.5C20.6538 16.9333 20.5907 17.3509 20.4644 17.7529C20.3381 18.1548 20.1519 18.5243 19.9057 18.8615L22.1269 21.0731C22.2653 21.211 22.3346 21.3865 22.3346 21.5996C22.3346 21.8127 22.2656 21.9884 22.1276 22.1269Z", fill: "currentColor" })
});
P({
  displayName: "SearchSolidIcon",
  viewBox: "0 0 40 40",
  path: w.createElement("path", { d: "M26.6773 25.987C28.7396 23.758 30 20.7762 30 17.5C30 10.5964 24.4036 5 17.5 5C10.5964 5 5 10.5964 5 17.5C5 24.4036 10.5964 30 17.5 30C19.9212 30 22.1816 29.3116 24.0962 28.1199L25.8372 29.8609C25.7992 30.5462 26.042 31.2442 26.5656 31.7678L29.8989 35.1011C30.8752 36.0774 32.4581 36.0774 33.4344 35.1011C34.4107 34.1248 34.4107 32.5419 33.4344 31.5656L30.1011 28.2322C29.5775 27.7087 28.8796 27.4659 28.1942 27.5039L26.6773 25.987ZM23.8757 13.5796C24.1773 14.2005 24.9253 14.4594 25.5462 14.1577C26.1672 13.856 26.426 13.1081 26.1243 12.4871C24.9818 10.1352 22.906 8.32081 20.3746 7.52572C19.7159 7.31886 19.0143 7.68509 18.8074 8.34372C18.6006 9.00236 18.9668 9.70398 19.6254 9.91085C21.493 10.4974 23.0303 11.8395 23.8757 13.5796ZM27.5 16.25C27.5 16.9404 26.9404 17.5 26.25 17.5C25.5596 17.5 25 16.9404 25 16.25C25 15.5596 25.5596 15 26.25 15C26.9404 15 27.5 15.5596 27.5 16.25Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" })
});
P({
  displayName: "SeedIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1999 7.66903C10.0306 8.18615 8.13048 8.75333 6.59499 7.91567C4.19538 6.6066 2 6.49999 2 6.49999C2 6.49999 4 4.50001 5.5 3.85158C7 3.20315 9.1928 3.24529 10.5 4C12.0852 4.91523 12.264 6.54518 12.2828 6.98873C12.3212 7.06553 12.3428 7.15218 12.3428 7.24387V8.43868C12.7228 7.76578 13.3277 6.96999 14.2367 6.44517C15.5439 5.69046 17.3122 6.09358 18.9378 6.49997C20.5634 6.90637 21.9584 6.03879 21.9584 6.03879C21.9584 6.03879 20.7392 10.1029 17.4879 10.5093C15.1529 10.8011 13.2371 10.2545 12.3428 9.92325L12.3428 14.1706C12.3428 14.4862 12.087 14.7421 11.7714 14.7421C11.4558 14.7421 11.1999 14.4862 11.1999 14.1706V7.66903ZM4 17C4 15.1259 6.5777 13.5528 10.0571 13.1188V14.1705C10.0571 15.1173 10.8246 15.8848 11.7714 15.8848C12.7181 15.8848 13.4857 15.1173 13.4857 14.1705V13.0688C17.1941 13.4171 20 15.0447 20 17C20 19.2091 16.4183 21 12 21C7.58172 21 4 19.2091 4 17Z", fill: "currentColor" })
});
P({
  displayName: "SendIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.3334 20C18.3334 19.4477 17.8857 19 17.3334 19L6.66671 19C6.11442 19 5.66671 19.4477 5.66671 20C5.66671 20.5523 6.11442 21 6.66671 21H17.3334C17.8857 21 18.3334 20.5523 18.3334 20ZM12 15.9518C12.5523 15.9518 13 15.5041 13 14.9518V6.81894L15.668 10.1062C16.0161 10.535 16.6458 10.6005 17.0747 10.2524C17.5035 9.90438 17.569 9.27461 17.2209 8.84579L12.784 3.37914C12.6008 3.14813 12.3177 2.99997 12 2.99997C11.6814 2.99997 11.3976 3.14894 11.2145 3.38102L6.77913 8.84579C6.43109 9.27461 6.49657 9.90438 6.92539 10.2524C7.35421 10.6005 7.98398 10.535 8.33202 10.1062L11 6.81898V14.9518C11 15.5041 11.4477 15.9518 12 15.9518Z", fill: "currentColor" })
});
P({
  displayName: "SettingsIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12.4863C22 12.9751 21.6466 13.3923 21.1645 13.4727L19.7401 13.7102C19.3494 13.7753 19.0399 14.0672 18.9082 14.4407C18.8216 14.6863 18.7224 14.9258 18.6111 15.1586C18.4403 15.5161 18.4525 15.9415 18.6826 16.264L19.5216 17.4401C19.8054 17.8379 19.7602 18.3825 19.4147 18.728L18.727 19.4156C18.3814 19.7613 17.8364 19.8064 17.4387 19.5222L16.2642 18.6832C15.9416 18.4528 15.5159 18.4404 15.1582 18.6113C14.9255 18.7225 14.6862 18.8216 14.4407 18.9082C14.0672 19.0399 13.7753 19.3494 13.7102 19.7401L13.4727 21.1645C13.3923 21.6466 12.9751 22 12.4863 22H11.5137C11.0249 22 10.6077 21.6466 10.5273 21.1645L10.2898 19.7401C10.2247 19.3494 9.93284 19.0399 9.55928 18.9082C9.31373 18.8216 9.0743 18.7224 8.8416 18.6112C8.48401 18.4404 8.05849 18.4526 7.73592 18.6829L6.56127 19.5213C6.16349 19.8053 5.61876 19.7601 5.27318 19.4145L4.58548 18.7268C4.23991 18.3812 4.19474 17.8365 4.47867 17.4387L5.31715 16.2641C5.5474 15.9415 5.55965 15.516 5.38877 15.1584C5.27758 14.9257 5.17841 14.6863 5.09184 14.4407C4.96012 14.0672 4.65058 13.7753 4.25988 13.7102L2.83553 13.4727C2.35337 13.3923 2 12.9751 2 12.4863V11.5137C2 11.0249 2.35337 10.6077 2.83553 10.5273L4.25988 10.2898C4.65058 10.2247 4.96012 9.93284 5.09184 9.55928C5.17841 9.31373 5.27758 9.0743 5.38877 8.8416C5.55965 8.48401 5.5474 8.05849 5.31715 7.73592L4.47867 6.56127C4.19474 6.16349 4.23991 5.61876 4.58548 5.27318L5.27318 4.58548C5.61876 4.23991 6.16349 4.19474 6.56127 4.47867L7.73592 5.31715C8.05849 5.5474 8.48401 5.55965 8.8416 5.38877C9.0743 5.27758 9.31373 5.17841 9.55928 5.09184C9.93284 4.96012 10.2247 4.65058 10.2898 4.25988L10.5273 2.83553C10.6077 2.35337 11.0249 2 11.5137 2H12.4863C12.9751 2 13.3923 2.35337 13.4727 2.83553L13.7102 4.25988C13.7753 4.65058 14.0672 4.96012 14.4407 5.09184C14.6863 5.17841 14.9257 5.27758 15.1584 5.38877C15.516 5.55965 15.9415 5.5474 16.2641 5.31715L17.439 4.4785C17.8366 4.19464 18.3812 4.2397 18.7268 4.58506L19.4152 5.27296C19.7611 5.6186 19.8063 6.1637 19.522 6.56159L18.6832 7.73584C18.4528 8.05844 18.4404 8.48412 18.6113 8.84184C18.7225 9.07446 18.8216 9.31382 18.9082 9.55928C19.0399 9.93284 19.3494 10.2247 19.7401 10.2898L21.1645 10.5273C21.6466 10.6077 22 11.0249 22 11.5137V12.4863ZM15.3333 12C15.3333 13.841 13.8409 15.3334 11.9999 15.3334C10.159 15.3334 8.6666 13.841 8.6666 12C8.6666 10.1591 10.159 8.66669 11.9999 8.66669C13.8409 8.66669 15.3333 10.1591 15.3333 12Z", fill: "currentColor" })
});
P({
  displayName: "ShapesIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.875 11.0375C7.575 11.0375 7.35 10.9105 7.2 10.6565C7.05 10.4025 7.05833 10.1527 7.225 9.90686L11.4 3.34411C11.55 3.1147 11.7583 3 12.025 3C12.2917 3 12.5 3.1147 12.65 3.34411L16.825 9.90686C16.9917 10.1527 17 10.4025 16.85 10.6565C16.7 10.9105 16.475 11.0375 16.175 11.0375H7.875ZM17.65 22C16.4167 22 15.3833 21.5903 14.55 20.771C13.7167 19.9517 13.3 18.9357 13.3 17.7232C13.3 16.5106 13.7167 15.4946 14.55 14.6753C15.3833 13.856 16.4167 13.4463 17.65 13.4463C18.8833 13.4463 19.9167 13.856 20.75 14.6753C21.5833 15.4946 22 16.5106 22 17.7232C22 18.9357 21.5833 19.9517 20.75 20.771C19.9167 21.5903 18.8833 22 17.65 22ZM3.75 21.3855C3.53333 21.3855 3.35417 21.3159 3.2125 21.1766C3.07083 21.0373 3 20.8611 3 20.6481V14.6507C3 14.4377 3.07083 14.2615 3.2125 14.1223C3.35417 13.983 3.53333 13.9133 3.75 13.9133H9.85C10.0667 13.9133 10.2458 13.983 10.3875 14.1223C10.5292 14.2615 10.6 14.4377 10.6 14.6507V20.6481C10.6 20.8611 10.5292 21.0373 10.3875 21.1766C10.2458 21.3159 10.0667 21.3855 9.85 21.3855H3.75ZM17.65 20.5252C18.45 20.5252 19.125 20.2549 19.675 19.7141C20.225 19.1733 20.5 18.5097 20.5 17.7232C20.5 16.9366 20.225 16.273 19.675 15.7322C19.125 15.1915 18.45 14.9211 17.65 14.9211C16.85 14.9211 16.175 15.1915 15.625 15.7322C15.075 16.273 14.8 16.9366 14.8 17.7232C14.8 18.5097 15.075 19.1733 15.625 19.7141C16.175 20.2549 16.85 20.5252 17.65 20.5252ZM4.5 19.9107H9.1V15.3881H4.5V19.9107ZM9.225 9.56274H14.825L12.025 5.11384L9.225 9.56274Z", fill: "currentColor" })
});
P({
  displayName: "ShareIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M17.4868 21C16.7886 21 16.1949 20.7532 15.7055 20.2596C15.2161 19.766 14.9715 19.1667 14.9715 18.4615C14.9715 18.3463 14.9805 18.227 14.9987 18.1035C15.0169 17.9801 15.0441 17.8663 15.0805 17.7621L8.31823 13.7645C8.07677 14.0071 7.80189 14.1967 7.49361 14.3334C7.18533 14.4701 6.85888 14.5384 6.51427 14.5384C5.81586 14.5384 5.22221 14.2917 4.73333 13.7984C4.24444 13.305 4 12.7059 4 12.001C4 11.2962 4.24444 10.6967 4.73333 10.2027C5.22221 9.70859 5.81586 9.46155 6.51427 9.46155C6.85888 9.46155 7.18533 9.52989 7.49361 9.66656C7.80189 9.80326 8.07677 9.9929 8.31823 10.2355L15.0805 6.23786C15.0441 6.13372 15.0169 6.01992 14.9987 5.89646C14.9805 5.77301 14.9715 5.65367 14.9715 5.53844C14.9715 4.83332 15.2158 4.23396 15.7045 3.74038C16.1932 3.24679 16.7866 3 17.4847 3C18.1828 3 18.7766 3.24669 19.2659 3.74008C19.7553 4.23346 20 4.83257 20 5.5374C20 6.24224 19.7556 6.84169 19.2667 7.33577C18.7778 7.82984 18.1841 8.07688 17.4857 8.07688C17.1411 8.07688 16.8147 8.00855 16.5064 7.87187C16.1981 7.73518 15.9232 7.54553 15.6818 7.30293L8.91953 11.3006C8.95588 11.4047 8.98313 11.5183 9.00129 11.6414C9.01946 11.7644 9.02854 11.8833 9.02854 11.9981C9.02854 12.113 9.01946 12.2325 9.00129 12.3568C8.98313 12.4811 8.95588 12.5953 8.91953 12.6994L15.6818 16.697C15.9232 16.4544 16.1981 16.2648 16.5064 16.1281C16.8147 15.9914 17.1411 15.9231 17.4857 15.9231C18.1841 15.9231 18.7778 16.1698 19.2667 16.6632C19.7556 17.1566 20 17.7557 20 18.4605C20 19.1653 19.7557 19.7648 19.267 20.2589C18.7783 20.7529 18.1849 21 17.4868 21ZM17.4857 6.69229C17.8034 6.69229 18.0733 6.58016 18.2954 6.3559C18.5175 6.13162 18.6286 5.85913 18.6286 5.53842C18.6286 5.21771 18.5175 4.94522 18.2954 4.72094C18.0733 4.4967 17.8034 4.38457 17.4857 4.38457C17.1681 4.38457 16.8982 4.4967 16.676 4.72096C16.4539 4.94524 16.3428 5.21773 16.3428 5.53844C16.3428 5.85915 16.4539 6.13164 16.676 6.35592C16.8982 6.58018 17.1681 6.69229 17.4857 6.69229ZM6.51427 13.1538C6.83192 13.1538 7.10182 13.0417 7.32396 12.8174C7.54609 12.5932 7.65715 12.3207 7.65715 12C7.65715 11.6793 7.54609 11.4068 7.32396 11.1825C7.10182 10.9582 6.83192 10.8461 6.51427 10.8461C6.19662 10.8461 5.92672 10.9582 5.70458 11.1825C5.48245 11.4068 5.37139 11.6793 5.37139 12C5.37139 12.3207 5.48245 12.5932 5.70458 12.8175C5.92672 13.0417 6.19662 13.1538 6.51427 13.1538ZM17.4857 19.6154C17.8034 19.6154 18.0733 19.5033 18.2954 19.279C18.5175 19.0547 18.6286 18.7822 18.6286 18.4615C18.6286 18.1408 18.5175 17.8683 18.2954 17.644C18.0733 17.4198 17.8034 17.3077 17.4857 17.3077C17.1681 17.3077 16.8982 17.4198 16.676 17.6441C16.4539 17.8683 16.3428 18.1408 16.3428 18.4615C16.3428 18.7822 16.4539 19.0547 16.676 19.279C16.8982 19.5033 17.1681 19.6154 17.4857 19.6154Z", fill: "currentColor" })
});
P({
  displayName: "ShieldIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.3531 2.23307C11.7245 1.9223 12.2652 1.92231 12.6366 2.23309C15.2323 4.40517 18.1919 4.3885 19.3419 4.38202C19.3992 4.3817 19.452 4.3814 19.5 4.3814C19.7678 4.3814 20.0245 4.48884 20.2124 4.67964C20.4004 4.87044 20.5039 5.12867 20.4999 5.39646C20.4454 9.01301 20.3007 11.596 20.0164 13.4903C19.7323 15.3832 19.296 16.6856 18.5898 17.6689C17.8783 18.6596 16.964 19.2214 15.997 19.7568C15.8292 19.8497 15.6583 19.9426 15.4834 20.0376C14.6354 20.4985 13.6951 21.0095 12.5784 21.812C12.2297 22.0627 11.7599 22.0627 11.4112 21.812C10.2956 21.0103 9.35652 20.4995 8.50982 20.039C8.33407 19.9434 8.16231 19.85 7.99376 19.7566C7.02751 19.221 6.11439 18.6591 5.40426 17.6681C4.69962 16.6847 4.26487 15.3823 3.98185 13.4897C3.69861 11.5958 3.55458 9.01289 3.50011 5.39646C3.49608 5.12867 3.59964 4.87044 3.78759 4.67964C3.97554 4.48884 4.23217 4.3814 4.5 4.3814C4.5475 4.3814 4.59977 4.3817 4.65656 4.38202C5.79702 4.38851 8.75703 4.40533 11.3531 2.23307ZM5.51803 6.37406C5.58276 9.43548 5.72259 11.6074 5.95985 13.1939C6.22256 14.9507 6.59202 15.8919 7.02998 16.5031C7.46245 17.1067 8.0303 17.4902 8.9633 18.0073C9.11506 18.0914 9.27525 18.1784 9.44357 18.2699C10.1561 18.657 11.0144 19.1232 11.9948 19.7823C12.9766 19.1224 13.8362 18.6558 14.55 18.2683C14.7175 18.1774 14.877 18.0908 15.0282 18.0071C15.9624 17.4898 16.5317 17.1061 16.9654 16.5023C17.4044 15.891 17.775 14.9498 18.0386 13.1934C18.2767 11.6072 18.4171 9.43544 18.482 6.37426C16.9997 6.32238 14.426 6.00754 11.9948 4.26445C9.56655 6.00539 6.99663 6.32159 5.51803 6.37406Z", fill: "currentColor" })
});
P({
  displayName: "ShieldLockIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { id: "encrypted_2", d: "M11.7827 14.7496H13.2173C13.3528 14.7496 13.4704 14.6932 13.5699 14.5802C13.6694 14.4672 13.7025 14.3429 13.6692 14.2073L13.1942 11.592C13.5083 11.4574 13.7612 11.2457 13.9528 10.957C14.1445 10.6683 14.2403 10.3492 14.2403 9.99967C14.2403 9.52107 14.0698 9.11136 13.7288 8.77055C13.3878 8.42971 12.9779 8.2593 12.4991 8.2593C12.0202 8.2593 11.6106 8.42971 11.2702 8.77055C10.9298 9.11136 10.7596 9.52107 10.7596 9.99967C10.7596 10.3492 10.8554 10.6683 11.0471 10.957C11.2388 11.2457 11.4916 11.4574 11.8057 11.592L11.3307 14.2073C11.2974 14.3429 11.3305 14.4672 11.43 14.5802C11.5296 14.6932 11.6471 14.7496 11.7827 14.7496ZM12.5 21.3708C12.3961 21.3708 12.2942 21.3625 12.1942 21.3458C12.0942 21.3291 11.9973 21.3041 11.9036 21.2708C9.79479 20.5208 8.11698 19.191 6.8702 17.2814C5.6234 15.3718 5 13.3112 5 11.0997V6.59584C5 6.216 5.10922 5.87413 5.32765 5.57025C5.54608 5.26636 5.82853 5.04605 6.175 4.90932L11.8673 2.78432C12.0814 2.7074 12.2923 2.66895 12.5 2.66895C12.7077 2.66895 12.9186 2.7074 13.1327 2.78432L18.825 4.90932C19.1714 5.04605 19.4539 5.26636 19.6723 5.57025C19.8907 5.87413 20 6.216 20 6.59584V11.0997C20 13.3112 19.3765 15.3718 18.1297 17.2814C16.883 19.191 15.2052 20.5208 13.0963 21.2708C13.0026 21.3041 12.9057 21.3291 12.8057 21.3458C12.7057 21.3625 12.6038 21.3708 12.5 21.3708ZM12.5 19.8997C14.2333 19.3497 15.6666 18.2497 16.8 16.5997C17.9333 14.9497 18.5 13.1163 18.5 11.0997V6.58622C18.5 6.52212 18.4823 6.46443 18.4471 6.41315C18.4118 6.36185 18.3621 6.32338 18.298 6.29774L12.6057 4.17274C12.5737 4.15993 12.5384 4.15352 12.5 4.15352C12.4615 4.15352 12.4263 4.15993 12.3942 4.17274L6.70192 6.29774C6.63781 6.32338 6.58812 6.36185 6.55287 6.41315C6.51761 6.46443 6.49997 6.52212 6.49997 6.58622V11.0997C6.49997 13.1163 7.06664 14.9497 8.19997 16.5997C9.33331 18.2497 10.7666 19.3497 12.5 19.8997Z", fill: "currentColor" })
});
P({
  displayName: "ShieldPlusIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12 21.4794C9.83716 20.8897 8.04646 19.6166 6.62787 17.6602C5.20929 15.7038 4.5 13.5175 4.5 11.1013V6.59487C4.5 6.21502 4.60922 5.87315 4.82765 5.56927C5.04608 5.26539 5.32853 5.04508 5.675 4.90834L11.3673 2.78334C11.5814 2.70643 11.7923 2.66797 12 2.66797C12.2077 2.66797 12.4186 2.70643 12.6327 2.78334L18.325 4.90834C18.6714 5.04508 18.9539 5.26539 19.1723 5.56927C19.3907 5.87315 19.5 6.21502 19.5 6.59487V11.0103C19.2666 10.9154 19.0218 10.8298 18.7654 10.7535C18.5089 10.6773 18.2538 10.6173 18 10.5737V6.60064C18 6.53653 17.9823 6.47883 17.9471 6.42754C17.9118 6.37626 17.8621 6.33779 17.798 6.31214L12.1058 4.18717C12.0737 4.17434 12.0384 4.16792 12 4.16792C11.9615 4.16792 11.9263 4.17434 11.8942 4.18717L6.20193 6.31214C6.13781 6.33779 6.08812 6.37626 6.05287 6.42754C6.01761 6.47883 5.99997 6.53653 5.99997 6.60064V11.0987C5.99997 11.9846 6.12497 12.8497 6.37497 13.6939C6.62497 14.5381 6.96953 15.3273 7.40865 16.0612C7.84775 16.7952 8.37243 17.4542 8.9827 18.0381C9.59297 18.6221 10.2552 19.0885 10.9693 19.4372L10.9981 19.4276C11.1302 19.7942 11.3013 20.1455 11.5116 20.4814C11.7218 20.8173 11.9609 21.1224 12.2288 21.3967C12.1865 21.4096 12.1484 21.4233 12.1144 21.4381C12.0804 21.4528 12.0423 21.4666 12 21.4794ZM17 21.4987C15.7513 21.4987 14.6891 21.0609 13.8135 20.1852C12.9378 19.3096 12.5 18.2474 12.5 16.9987C12.5 15.75 12.9378 14.6878 13.8135 13.8122C14.6891 12.9365 15.7513 12.4987 17 12.4987C18.2487 12.4987 19.3109 12.9365 20.1865 13.8122C21.0621 14.6878 21.5 15.75 21.5 16.9987C21.5 18.2474 21.0621 19.3096 20.1865 20.1852C19.3109 21.0609 18.2487 21.4987 17 21.4987ZM16.5577 17.441V19.3064C16.5577 19.4243 16.6019 19.5275 16.6904 19.616C16.7788 19.7044 16.882 19.7487 17 19.7487C17.1179 19.7487 17.2211 19.7044 17.3096 19.616C17.3981 19.5275 17.4423 19.4243 17.4423 19.3064V17.441H19.3077C19.4256 17.441 19.5288 17.3968 19.6173 17.3083C19.7057 17.2198 19.75 17.1166 19.75 16.9987C19.75 16.8807 19.7057 16.7775 19.6173 16.6891C19.5288 16.6006 19.4256 16.5564 19.3077 16.5564H17.4423V14.691C17.4423 14.5731 17.3981 14.4699 17.3096 14.3814C17.2211 14.2929 17.1179 14.2487 17 14.2487C16.882 14.2487 16.7788 14.2929 16.6904 14.3814C16.6019 14.4699 16.5577 14.5731 16.5577 14.691V16.5564H14.6923C14.5744 16.5564 14.4711 16.6006 14.3827 16.6891C14.2942 16.7775 14.25 16.8807 14.25 16.9987C14.25 17.1166 14.2942 17.2198 14.3827 17.3083C14.4711 17.3968 14.5744 17.441 14.6923 17.441H16.5577Z", fill: "currentColor" })
});
P({
  displayName: "ShieldSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.9945 3C15.2298 5.41204 18.94 5.26328 20 5.26328C19.7681 18.9811 18.0014 17.1535 11.9945 21C5.98757 17.1535 4.23188 18.9811 4 5.26328C5.049 5.26328 8.75914 5.41204 11.9945 3Z", fill: "currentColor" })
});
P({
  displayName: "ShoppingCartIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M7.15385 21.5576C6.66797 21.5576 6.25483 21.3874 5.91445 21.0471C5.57407 20.7067 5.40388 20.2936 5.40388 19.8077C5.40388 19.3218 5.57407 18.9086 5.91445 18.5683C6.25483 18.2279 6.66797 18.0577 7.15385 18.0577C7.63975 18.0577 8.05289 18.2279 8.39328 18.5683C8.73366 18.9086 8.90385 19.3218 8.90385 19.8077C8.90385 20.2936 8.73366 20.7067 8.39328 21.0471C8.05289 21.3874 7.63975 21.5576 7.15385 21.5576ZM16.8462 21.5576C16.3603 21.5576 15.9471 21.3874 15.6067 21.0471C15.2663 20.7067 15.0962 20.2936 15.0962 19.8077C15.0962 19.3218 15.2663 18.9086 15.6067 18.5683C15.9471 18.2279 16.3603 18.0577 16.8462 18.0577C17.332 18.0577 17.7452 18.2279 18.0856 18.5683C18.4259 18.9086 18.5961 19.3218 18.5961 19.8077C18.5961 20.2936 18.4259 20.7067 18.0856 21.0471C17.7452 21.3874 17.332 21.5576 16.8462 21.5576ZM6.01538 5.74998L8.55 11.0577H15.3673C15.425 11.0577 15.4763 11.0433 15.5212 11.0144C15.566 10.9856 15.6045 10.9455 15.6366 10.8942L18.3192 6.0192C18.3577 5.94868 18.3609 5.88618 18.3289 5.8317C18.2968 5.7772 18.2423 5.74995 18.1654 5.74995L6.01538 5.74998ZM5.29615 4.25003H19.1807C19.5897 4.25003 19.899 4.42406 20.1086 4.77213C20.3182 5.12021 20.3282 5.47566 20.1384 5.83847L16.9346 11.6423C16.7705 11.9307 16.5535 12.1554 16.2836 12.3163C16.0138 12.4772 15.7179 12.5576 15.3962 12.5576H8.1L6.9423 14.673C6.89102 14.75 6.88942 14.8333 6.9375 14.9231C6.98558 15.0128 7.0577 15.0577 7.15385 15.0577H17.8462C18.059 15.0577 18.2372 15.1295 18.3808 15.2731C18.5243 15.4166 18.5961 15.5948 18.5961 15.8077C18.5961 16.0205 18.5243 16.1987 18.3808 16.3423C18.2372 16.4858 18.059 16.5576 17.8462 16.5576H7.15385C6.4872 16.5576 5.98624 16.2701 5.65098 15.6952C5.31573 15.1202 5.30387 14.5461 5.6154 13.9731L7.04235 11.4077L3.40388 3.74995H2.25003C2.03719 3.74995 1.85899 3.67816 1.71542 3.53457C1.57181 3.39099 1.5 3.21279 1.5 2.99998C1.5 2.78716 1.5718 2.60896 1.7154 2.46538C1.85898 2.32179 2.03718 2.25 2.25 2.25H3.77883C3.94934 2.25 4.10832 2.29519 4.25575 2.38558C4.40318 2.47596 4.51537 2.6032 4.5923 2.7673L5.29615 4.25003Z", fill: "currentColor" })
});
P({
  displayName: "SortIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M4.75 17.9211C4.5375 17.9211 4.35938 17.8492 4.21563 17.7053C4.07188 17.5615 4 17.3833 4 17.1707C4 16.9581 4.07188 16.78 4.21563 16.6365C4.35938 16.4929 4.5375 16.4211 4.75 16.4211H8.62498C8.83748 16.4211 9.0156 16.493 9.15935 16.6368C9.3031 16.7806 9.37498 16.9588 9.37498 17.1714C9.37498 17.384 9.3031 17.5621 9.15935 17.7057C9.0156 17.8493 8.83748 17.9211 8.62498 17.9211H4.75ZM4.75 13.1711C4.5375 13.1711 4.35938 13.0992 4.21563 12.9554C4.07188 12.8115 4 12.6333 4 12.4208C4 12.2082 4.07188 12.0301 4.21563 11.8865C4.35938 11.7429 4.5375 11.6711 4.75 11.6711H14.4327C14.6452 11.6711 14.8233 11.743 14.967 11.8868C15.1108 12.0306 15.1827 12.2088 15.1827 12.4214C15.1827 12.634 15.1108 12.8121 14.967 12.9557C14.8233 13.0993 14.6452 13.1711 14.4327 13.1711H4.75ZM4.75 8.42108C4.5375 8.42108 4.35938 8.34917 4.21563 8.20536C4.07188 8.06156 4 7.88336 4 7.67076C4 7.45818 4.07188 7.28009 4.21563 7.13651C4.35938 6.99291 4.5375 6.92111 4.75 6.92111H20.25C20.4625 6.92111 20.6406 6.99302 20.7843 7.13683C20.9281 7.28065 21 7.45885 21 7.67143C21 7.88403 20.9281 8.06213 20.7843 8.20571C20.6406 8.34929 20.4625 8.42108 20.25 8.42108H4.75Z", fill: "currentColor" })
});
const $oe = P({
  displayName: "SpinnerIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 6C9.10457 6 10 5.10457 10 4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4C6 5.10457 6.89543 6 8 6ZM13 4.00001C13 4.02066 12.9999 4.04128 12.9996 4.06186C16.9461 4.55379 20 7.92026 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 10.558 4.38151 9.20514 5.04911 8.0368C4.4838 7.62286 4.00868 7.09304 3.65872 6.48232C2.6105 8.06377 2 9.9606 2 12C2 17.5229 6.47715 22 12 22C17.5228 22 22 17.5229 22 12C22 6.67571 17.839 2.32327 12.5914 2.01721C12.8543 2.62513 13 3.29556 13 4.00001Z", fill: "currentColor" })
});
P({
  displayName: "StarCircleSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 18L12 14.95L16 18L14.4 13.075L18.4 10.25H13.525L12 5.175L10.45 10.25H5.575L9.575 13.075L8 18ZM12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.02917 5.825 4.9375 4.925C5.84583 4.025 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.975 18.1542 19.075 19.0625C18.175 19.9708 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z", fill: "currentColor" })
});
P({
  displayName: "StorageIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M3 19.9996V16.2996H21V19.9996H3ZM4.5 19.0496H6.3V17.2496H4.5V19.0496ZM3 7.6996V3.9996H21V7.6996H3ZM4.5 6.7496H6.3V4.9496H4.5V6.7496ZM3 13.8496V10.1496H21V13.8496H3ZM4.5 12.8996H6.3V11.0996H4.5V12.8996Z", fill: "currentColor" })
});
P({
  displayName: "StoreMarketIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M4.96155 5.74995C4.74906 5.74995 4.57095 5.67805 4.4272 5.53425C4.28345 5.39043 4.21157 5.21223 4.21157 4.99965C4.21157 4.78705 4.28345 4.60896 4.4272 4.46538C4.57095 4.32179 4.74906 4.25 4.96155 4.25H19.0385C19.251 4.25 19.4291 4.3219 19.5728 4.4657C19.7166 4.60952 19.7885 4.78772 19.7885 5.0003C19.7885 5.2129 19.7166 5.39099 19.5728 5.53457C19.4291 5.67816 19.251 5.74995 19.0385 5.74995H4.96155ZM5.15387 19.75C4.89779 19.75 4.68313 19.6633 4.5099 19.4901C4.33666 19.3169 4.25005 19.1022 4.25005 18.8461V13.75H3.94042C3.6558 13.75 3.42151 13.6387 3.23755 13.4163C3.05356 13.1939 2.9949 12.9403 3.06157 12.6557L4.06157 7.96345C4.10714 7.75535 4.21345 7.58442 4.3805 7.45065C4.54756 7.31688 4.7374 7.25 4.95002 7.25H19.05C19.2626 7.25 19.4525 7.31688 19.6195 7.45065C19.7866 7.58442 19.8929 7.75535 19.9385 7.96345L20.9385 12.6557C21.0051 12.9403 20.9465 13.1939 20.7625 13.4163C20.5785 13.6387 20.3442 13.75 20.0596 13.75H19.75V19C19.75 19.2125 19.6781 19.3906 19.5343 19.5343C19.3905 19.6781 19.2123 19.75 18.9997 19.75C18.7871 19.75 18.609 19.6781 18.4654 19.5343C18.3218 19.3906 18.25 19.2125 18.25 19V13.75H13.75V18.8461C13.75 19.1022 13.6634 19.3169 13.4901 19.4901C13.3169 19.6633 13.1023 19.75 12.8462 19.75H5.15387ZM5.75 18.25H12.25V13.75H5.75V18.25ZM4.66537 12.25H19.3347L18.5712 8.74995H5.42885L4.66537 12.25Z", fill: "currentColor" })
});
P({
  displayName: "SuitcaseIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12 15.25C12.4859 15.25 12.899 15.0798 13.2394 14.7394C13.5798 14.399 13.75 13.9859 13.75 13.5C13.75 13.0141 13.5798 12.601 13.2394 12.2606C12.899 11.9202 12.4859 11.75 12 11.75C11.5141 11.75 11.1009 11.9202 10.7606 12.2606C10.4202 12.601 10.25 13.0141 10.25 13.5C10.25 13.9859 10.4202 14.399 10.7606 14.7394C11.1009 15.0798 11.5141 15.25 12 15.25ZM4.3077 20.5C3.80257 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923L2.5 8.30773C2.5 7.80259 2.675 7.37502 3.025 7.02502C3.375 6.67502 3.80257 6.50002 4.3077 6.50002L8.5 6.50002V4.80775C8.5 4.30263 8.675 3.87507 9.025 3.52507C9.375 3.17507 9.80257 3.00007 10.3077 3.00007L13.6923 3.00007C14.1974 3.00007 14.625 3.17507 14.975 3.52507C15.325 3.87507 15.5 4.30263 15.5 4.80775V6.50002H19.6923C20.1974 6.50002 20.625 6.67502 20.975 7.02502C21.325 7.37502 21.5 7.80259 21.5 8.30773L21.5 18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5L4.3077 20.5ZM4.3077 19H19.6923C19.7692 19 19.8397 18.9679 19.9038 18.9038C19.9679 18.8397 20 18.7692 20 18.6923L20 8.30773C20 8.23079 19.9679 8.16027 19.9038 8.09615C19.8397 8.03205 19.7692 8 19.6923 8L4.3077 8C4.23077 8 4.16024 8.03205 4.09613 8.09615C4.03202 8.16027 3.99998 8.23079 3.99998 8.30773L3.99998 18.6923C3.99998 18.7692 4.03202 18.8397 4.09613 18.9038C4.16024 18.9679 4.23077 19 4.3077 19ZM9.99998 6.50002L14 6.50002V4.80775C14 4.73082 13.9679 4.6603 13.9038 4.5962C13.8397 4.53208 13.7692 4.50002 13.6923 4.50002L10.3077 4.50002C10.2308 4.50002 10.1602 4.53208 10.0961 4.5962C10.032 4.6603 9.99998 4.73082 9.99998 4.80775V6.50002Z", fill: "currentColor" })
});
P({
  displayName: "SwapSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M9.23502 17.53L10.5253 16.2396L9.09677 14.765H12.9217V12.9217H9.09677L10.5253 11.447L9.23502 10.1567L5.54839 13.8433L9.23502 17.53ZM14.765 13.8433L18.4516 10.1567L14.765 6.47005L13.4747 7.76037L14.9032 9.23502H11.0783V11.0783H14.9032L13.4747 12.553L14.765 13.8433ZM12 22C10.6022 22 9.29657 21.7382 8.08325 21.2147C6.86992 20.6911 5.81449 19.9806 4.91696 19.083C4.01943 18.1855 3.30889 17.1301 2.78535 15.9168C2.26178 14.7034 2 13.3979 2 12C2 10.6022 2.26178 9.29657 2.78535 8.08325C3.30889 6.86992 4.01943 5.81449 4.91696 4.91696C5.81449 4.01943 6.86992 3.30889 8.08325 2.78535C9.29657 2.26178 10.6022 2 12 2C13.3979 2 14.7034 2.26178 15.9168 2.78535C17.1301 3.30889 18.1855 4.01943 19.083 4.91696C19.9806 5.81449 20.6911 6.86992 21.2147 8.08325C21.7382 9.29657 22 10.6022 22 12C22 13.3979 21.7382 14.7034 21.2147 15.9168C20.6911 17.1301 19.9806 18.1855 19.083 19.083C18.1855 19.9806 17.1301 20.6911 15.9168 21.2147C14.7034 21.7382 13.3979 22 12 22Z", fill: "currentColor" })
});
P({
  displayName: "SyncHorizontalIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M16.4731 12.1269C16.318 11.9718 16.2404 11.7936 16.2404 11.5923C16.2404 11.391 16.3128 11.218 16.4577 11.0731L18.7808 8.74998H4C3.78718 8.74998 3.60898 8.67818 3.4654 8.5346C3.32182 8.39102 3.25002 8.21282 3.25002 8C3.25002 7.78718 3.32182 7.60898 3.4654 7.4654C3.60898 7.32182 3.78718 7.25003 4 7.25003H18.7808L16.4481 4.9173C16.3096 4.77883 16.2404 4.60897 16.2404 4.4077C16.2404 4.20642 16.318 4.02822 16.4731 3.8731C16.618 3.72822 16.7936 3.65578 17 3.65578C17.2064 3.65578 17.382 3.72822 17.5269 3.8731L21.0211 7.36733C21.1147 7.46091 21.1807 7.55963 21.2192 7.66348C21.2577 7.76731 21.2769 7.87948 21.2769 8C21.2769 8.12052 21.2577 8.23269 21.2192 8.33653C21.1807 8.44038 21.1147 8.53909 21.0211 8.63268L17.5173 12.1365C17.3686 12.2852 17.1936 12.357 16.9923 12.3519C16.791 12.3468 16.618 12.2718 16.4731 12.1269ZM6.4731 20.1269L2.97887 16.6327C2.88527 16.5391 2.81925 16.4404 2.7808 16.3365C2.74233 16.2327 2.7231 16.1205 2.7231 16C2.7231 15.8795 2.74233 15.7673 2.7808 15.6635C2.81925 15.5596 2.88527 15.4609 2.97887 15.3673L6.4827 11.8635C6.62117 11.725 6.79103 11.6532 6.9923 11.6481C7.19358 11.643 7.37178 11.718 7.5269 11.8731C7.68203 12.018 7.76217 12.191 7.7673 12.3923C7.77242 12.5936 7.69742 12.7718 7.5423 12.9269L5.21917 15.25H20C20.2128 15.25 20.391 15.3218 20.5346 15.4654C20.6782 15.609 20.75 15.7872 20.75 16C20.75 16.2128 20.6782 16.391 20.5346 16.5346C20.391 16.6782 20.2128 16.75 20 16.75H5.21917L7.5519 19.0827C7.69037 19.2212 7.76217 19.3936 7.7673 19.6C7.77242 19.8064 7.69742 19.982 7.5423 20.1269C7.39743 20.282 7.22179 20.3596 7.01537 20.3596C6.80897 20.3596 6.62822 20.282 6.4731 20.1269Z", fill: "currentColor" })
});
P({
  displayName: "SyncVerticalIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.8808 16.4808C12.0359 16.3257 12.2141 16.2481 12.4154 16.2481C12.6166 16.2481 12.7897 16.3205 12.9346 16.4654L15.2577 18.7885L15.2577 4.00769C15.2577 3.79487 15.3295 3.61667 15.4731 3.47309C15.6167 3.3295 15.7949 3.25771 16.0077 3.25771C16.2205 3.25771 16.3987 3.3295 16.5423 3.47309C16.6859 3.61667 16.7576 3.79487 16.7576 4.00769L16.7576 18.7885L19.0904 16.4558C19.2288 16.3173 19.3987 16.2481 19.6 16.2481C19.8013 16.2481 19.9795 16.3257 20.1346 16.4808C20.2795 16.6257 20.3519 16.8013 20.3519 17.0077C20.3519 17.2141 20.2795 17.3897 20.1346 17.5346L16.6403 21.0288C16.5468 21.1224 16.448 21.1884 16.3442 21.2269C16.2404 21.2654 16.1282 21.2846 16.0077 21.2846C15.8872 21.2846 15.775 21.2654 15.6711 21.2269C15.5673 21.1884 15.4686 21.1224 15.375 21.0288L11.8711 17.525C11.7224 17.3763 11.6506 17.2013 11.6558 17C11.6609 16.7987 11.7359 16.6257 11.8808 16.4808ZM3.88077 6.48079L7.375 2.98656C7.46858 2.89296 7.5673 2.82694 7.67115 2.78849C7.77498 2.75002 7.88716 2.73079 8.00767 2.73079C8.12819 2.73079 8.24036 2.75002 8.3442 2.78849C8.44805 2.82694 8.54676 2.89296 8.64035 2.98656L12.1442 6.49039C12.2827 6.62885 12.3545 6.79872 12.3596 6.99999C12.3647 7.20127 12.2897 7.37947 12.1346 7.53459C11.9897 7.68972 11.8166 7.76985 11.6154 7.77499C11.4141 7.7801 11.2359 7.7051 11.0808 7.54999L8.75765 5.22686L8.75765 20.0077C8.75765 20.2205 8.68585 20.3987 8.54227 20.5423C8.39869 20.6859 8.22049 20.7577 8.00767 20.7577C7.79486 20.7577 7.61666 20.6859 7.47307 20.5423C7.32949 20.3987 7.2577 20.2205 7.2577 20.0077L7.2577 5.22686L4.92497 7.55959C4.78651 7.69805 4.61407 7.76985 4.40767 7.77499C4.20127 7.7801 4.02564 7.7051 3.88077 7.54999C3.72564 7.40512 3.64807 7.22948 3.64807 7.02306C3.64807 6.81666 3.72564 6.6359 3.88077 6.48079Z", fill: "currentColor" })
});
P({
  displayName: "TaskIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.95 18.0141L16.7554 12.2087L15.1641 10.6174L10.9391 14.8424L8.82498 12.7282L7.24453 14.3087L10.95 18.0141ZM6.16956 22.4804C5.43114 22.4804 4.80486 22.2234 4.29073 21.7092C3.7766 21.1951 3.51953 20.5688 3.51953 19.8304V4.16956C3.51953 3.43114 3.7766 2.80486 4.29073 2.29073C4.80486 1.7766 5.43114 1.51953 6.16956 1.51953H14.1978L20.4804 7.80216V19.8304C20.4804 20.5688 20.2234 21.1951 19.7092 21.7092C19.1951 22.2234 18.5688 22.4804 17.8304 22.4804H6.16956ZM12.8304 9.16956H17.8304L12.8304 4.16956V9.16956Z", fill: "currentColor" })
});
P({
  displayName: "TerminalIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 20C3.1 20 2.75 19.85 2.45 19.55C2.15 19.25 2 18.9 2 18.5V5.5C2 5.1 2.15 4.75 2.45 4.45C2.75 4.15 3.1 4 3.5 4H20.5C20.9 4 21.25 4.15 21.55 4.45C21.85 4.75 22 5.1 22 5.5V18.5C22 18.9 21.85 19.25 21.55 19.55C21.25 19.85 20.9 20 20.5 20H3.5ZM3.5 18.5H20.5V7.6H3.5V18.5ZM7.5 16.7L6.45 15.65L9.025 13.05L6.425 10.45L7.5 9.4L11.15 13.05L7.5 16.7ZM12.25 16.8V15.3H17.75V16.8H12.25Z", fill: "currentColor" })
});
P({
  displayName: "ThumbtackIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M1.5 22.5L9.82437 15.8957L13.1452 19.4302C13.1452 19.4302 14.5314 19.8082 14.6167 18.7583L14.5314 15.1804L19.451 9.5014L21.594 9.37682C21.594 9.37682 23.2754 9.03807 22.057 7.56687L16.0449 1.50991C16.0449 1.50991 14.4069 1.29994 14.5314 2.81313V4.4537L8.94172 9.21024L5.49503 9.41881C5.49503 9.41881 4.23329 9.83875 4.6949 10.9334L7.93317 14.1306L1.5 22.5Z", fill: "currentColor" })
});
const xp = P({
  displayName: "TickIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M9.55001 15.5154L18.1885 6.87695C18.3372 6.72823 18.5138 6.65227 18.7183 6.64905C18.9228 6.64585 19.1026 6.72182 19.2577 6.87695C19.4128 7.03207 19.4904 7.21027 19.4904 7.41155C19.4904 7.61282 19.4128 7.79102 19.2577 7.94615L10.1827 17.0211C10.0019 17.2019 9.79102 17.2923 9.55001 17.2923C9.30899 17.2923 9.0981 17.2019 8.91733 17.0211L4.74233 12.8461C4.59361 12.6974 4.52021 12.5208 4.52213 12.3163C4.52406 12.1119 4.60259 11.9321 4.75771 11.7769C4.91284 11.6218 5.09104 11.5442 5.29231 11.5442C5.49359 11.5442 5.67179 11.6218 5.82691 11.7769L9.55001 15.5154Z", fill: "currentColor" })
});
P({
  displayName: "TimeIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11 6.5C11 5.94772 11.4477 5.5 12 5.5C12.5523 5.5 13 5.94772 13 6.5V11.5858L15.2071 13.7929C15.5976 14.1834 15.5976 14.8166 15.2071 15.2071C14.8166 15.5976 14.1834 15.5976 13.7929 15.2071L11.2929 12.7071L11 12.4142V12V6.5Z", fill: "currentColor" })
});
P({
  displayName: "TokenomicsIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.2507 20.8548C12.0956 20.9446 11.9044 20.9446 11.7493 20.8548L4.24934 16.5095C4.09501 16.42 4 16.2552 4 16.0768V7.68354C4 7.50098 4.0995 7.33293 4.25957 7.24514L11.7596 3.13186C11.9093 3.04973 12.0907 3.04973 12.2404 3.13186L19.7404 7.24514C19.9005 7.33293 20 7.50098 20 7.68354V16.0768C20 16.2552 19.905 16.42 19.7507 16.5095L12.2507 20.8548ZM9.46667 9.795C9.80741 9.45 10.1963 9.16875 10.6333 8.95125C11.0704 8.73375 11.5259 8.625 12 8.625C12.4741 8.625 12.9296 8.73375 13.3667 8.95125C13.8037 9.16875 14.1926 9.45 14.5333 9.795L17.9333 7.77L12 4.575L6.06667 7.77L9.46667 9.795ZM11.3333 19.065V15.3075C10.563 15.0975 9.92593 14.6925 9.42222 14.0925C8.91852 13.4925 8.66667 12.795 8.66667 12C8.66667 11.835 8.67778 11.6663 8.7 11.4937C8.72222 11.3212 8.76296 11.1525 8.82222 10.9875L5.33333 8.895V15.5775L11.3333 19.065ZM12 14.025C12.563 14.025 13.037 13.83 13.4222 13.44C13.8074 13.05 14 12.57 14 12C14 11.43 13.8074 10.95 13.4222 10.56C13.037 10.17 12.563 9.975 12 9.975C11.437 9.975 10.963 10.17 10.5778 10.56C10.1926 10.95 10 11.43 10 12C10 12.57 10.1926 13.05 10.5778 13.44C10.963 13.83 11.437 14.025 12 14.025ZM12.6667 19.065L18.6667 15.5775V8.895L15.1778 10.9875C15.237 11.1525 15.2778 11.3212 15.3 11.4937C15.3222 11.6663 15.3333 11.835 15.3333 12C15.3333 12.795 15.0815 13.4925 14.5778 14.0925C14.0741 14.6925 13.437 15.0975 12.6667 15.3075V19.065Z", fill: "currentColor" })
});
P({
  displayName: "TokenRecoveryIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12 22C10.6181 22 9.31886 21.7372 8.10237 21.2116C6.8857 20.686 5.82728 19.9731 4.92711 19.0729C4.02693 18.1727 3.31404 17.1143 2.78842 15.8976C2.26281 14.6811 2 13.3819 2 12C2 10.6181 2.26281 9.31886 2.78842 8.10237C3.31404 6.8857 4.02693 5.82728 4.92711 4.9271C5.82728 4.02693 6.8857 3.31404 8.10237 2.78842C9.31886 2.26281 10.6181 2 12 2C13.3819 2 14.6811 2.26281 15.8976 2.78842C17.1143 3.31404 18.1727 4.02693 19.0729 4.9271C19.9731 5.82728 20.686 6.8857 21.2116 8.10237C21.7372 9.31886 22 10.6181 22 12C22 13.3819 21.7372 14.6811 21.2116 15.8976C20.686 17.1143 19.9731 18.1727 19.0729 19.0729C18.1727 19.9731 17.1143 20.686 15.8976 21.2116C14.6811 21.7372 13.3819 22 12 22ZM11.2105 20.3724V18.8745C10.5493 18.8069 9.92175 18.6454 9.32789 18.3897C8.73421 18.1339 8.18833 17.8104 7.69026 17.4189L6.62947 18.4858C7.26246 19.0161 7.96596 19.4463 8.74 19.7763C9.51386 20.1063 10.3374 20.305 11.2105 20.3724ZM12.7895 20.3724C13.6626 20.305 14.4845 20.1063 15.255 19.7763C16.0257 19.4463 16.7275 19.0161 17.3603 18.4858L16.3097 17.4189C15.8117 17.8104 15.2658 18.1339 14.6721 18.3897C14.0782 18.6454 13.4507 18.8069 12.7895 18.8745V20.3724ZM12 17.3542C13.4832 17.3542 14.7463 16.8326 15.7895 15.7895C16.8326 14.7463 17.3542 13.4832 17.3542 12C17.3542 10.5168 16.8326 9.25368 15.7895 8.21053C14.7463 7.16737 13.4832 6.64579 12 6.64579C10.5168 6.64579 9.25368 7.16737 8.21053 8.21053C7.16737 9.25368 6.64579 10.5168 6.64579 12C6.64579 13.4832 7.16737 14.7463 8.21053 15.7895C9.25368 16.8326 10.5168 17.3542 12 17.3542ZM18.4858 17.3705C19.0161 16.7375 19.4463 16.034 19.7763 15.26C20.1063 14.4861 20.305 13.6626 20.3724 12.7895H18.8745C18.8069 13.4507 18.6454 14.0782 18.3897 14.6721C18.1339 15.2658 17.8104 15.8117 17.4189 16.3097L18.4858 17.3705ZM5.51421 17.3705L6.58105 16.2934C6.18965 15.7955 5.86605 15.2524 5.61026 14.6639C5.35465 14.0755 5.19307 13.4507 5.12553 12.7895H3.62763C3.695 13.6626 3.89368 14.4861 4.22368 15.26C4.55368 16.034 4.98386 16.7375 5.51421 17.3705ZM11.6195 15.4047L9.4979 12.5708C9.37105 12.3982 9.30763 12.2079 9.30763 12C9.30763 11.7921 9.37105 11.6018 9.4979 11.4292L11.6195 8.59526C11.7179 8.46842 11.8447 8.405 12 8.405C12.1553 8.405 12.2821 8.46842 12.3805 8.59526L14.5021 11.4292C14.6289 11.6018 14.6924 11.7921 14.6924 12C14.6924 12.2079 14.6289 12.3982 14.5021 12.5708L12.3805 15.4047C12.2821 15.5316 12.1553 15.595 12 15.595C11.8447 15.595 11.7179 15.5316 11.6195 15.4047ZM3.62763 11.2105H5.12553C5.19307 10.5493 5.35465 9.92447 5.61026 9.33605C5.86605 8.74763 6.18965 8.20447 6.58105 7.70658L5.51421 6.63974C4.98386 7.27254 4.55368 7.9743 4.22368 8.745C3.89368 9.51553 3.695 10.3374 3.62763 11.2105ZM18.8745 11.2105H20.3724C20.305 10.3374 20.1036 9.51553 19.7682 8.745C19.4329 7.9743 19.0001 7.27254 18.4697 6.63974L17.4189 7.69026C17.8104 8.18833 18.1339 8.73421 18.3897 9.3279C18.6454 9.92176 18.8069 10.5493 18.8745 11.2105ZM7.70658 6.58105C8.20447 6.18965 8.74763 5.86605 9.33605 5.61026C9.92447 5.35465 10.5493 5.19307 11.2105 5.12553V3.62763C10.3374 3.695 9.51386 3.89368 8.74 4.22368C7.96596 4.55368 7.26246 4.98386 6.62947 5.51421L7.70658 6.58105ZM16.3097 6.58105L17.3603 5.53026C16.7275 4.99991 16.0257 4.56711 15.255 4.23184C14.4845 3.8964 13.6626 3.695 12.7895 3.62763V5.12553C13.4507 5.19307 14.0782 5.35465 14.6721 5.61026C15.2658 5.86605 15.8117 6.18965 16.3097 6.58105Z", fill: "currentColor" })
});
P({
  displayName: "ToolIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 9.7778C3 8.94904 3.14875 8.15501 3.421 7.42097L7.76508 11.7651C8.15561 12.1556 8.78877 12.1556 9.1793 11.7651L11.7651 9.17926C12.1556 8.78874 12.1556 8.15558 11.7651 7.76505L7.42102 3.42098C8.15505 3.14874 8.94905 3 9.7778 3C13.5211 3 16.5556 6.03453 16.5556 9.7778C16.5556 10.5735 16.4185 11.3371 16.1666 12.0464L20.2713 16.1511C21.0523 16.9322 21.0523 18.1985 20.2713 18.9795L19.4129 19.838C18.6318 20.619 17.3655 20.619 16.5844 19.838L12.6603 15.9139C11.7856 16.3255 10.8086 16.5556 9.7778 16.5556C6.03453 16.5556 3 13.5211 3 9.7778Z", fill: "currentColor" })
});
P({
  displayName: "ToolsIcon",
  viewBox: "0 0 32 32",
  path: w.createElement("path", { d: "M24.4704 27.9804C24.3175 27.9804 24.1752 27.956 24.0435 27.9071C23.9118 27.8583 23.7866 27.7744 23.6679 27.6555L17.2721 21.2623C17.1534 21.1434 17.0696 21.018 17.0208 20.8861C16.972 20.7542 16.9477 20.6117 16.9477 20.4586C16.9477 20.3055 16.972 20.163 17.0208 20.031C17.0696 19.8991 17.1534 19.7737 17.2721 19.6548L19.6747 17.2486C19.7934 17.1297 19.9187 17.0458 20.0504 16.9969C20.1821 16.9481 20.3244 16.9236 20.4773 16.9236C20.6301 16.9236 20.7724 16.9481 20.9041 16.9969C21.0359 17.0458 21.1611 17.1297 21.2798 17.2486L27.6756 23.654C27.7943 23.7729 27.878 23.8983 27.9268 24.0302C27.9756 24.1621 28 24.3046 28 24.4577C28 24.6108 27.9756 24.7533 27.9268 24.8852C27.878 25.0171 27.7943 25.1425 27.6756 25.2614L25.2729 27.6555C25.1542 27.7744 25.029 27.8583 24.8973 27.9071C24.7655 27.956 24.6232 27.9804 24.4704 27.9804ZM24.4704 25.8062L25.8169 24.4577L20.4968 19.1296L19.1502 20.4781L24.4704 25.8062ZM7.54912 28C7.39625 28 7.25071 27.9723 7.1125 27.9169C6.97426 27.8615 6.84579 27.7744 6.72709 27.6555L4.34393 25.281C4.22521 25.1621 4.13821 25.0334 4.08292 24.895C4.02764 24.7566 4 24.6108 4 24.4577C4 24.3046 4.02764 24.1601 4.08292 24.0241C4.13821 23.8881 4.22521 23.7607 4.34393 23.6418L10.969 17.0067H13.64L14.6694 15.9758L9.36396 10.6623H7.55645L4.03659 7.13719L7.1808 3.98825L10.7007 7.5134V9.32363L16.0061 14.6371L19.7577 10.8798L17.9063 9.02558L19.5113 7.41813H16.2817L15.5768 6.72433L19.6284 2.66663L20.3211 3.36039V6.60705L21.9262 4.9996L26.6974 9.75361C27.0324 10.081 27.2849 10.4539 27.4548 10.8725C27.6248 11.291 27.7097 11.734 27.7097 12.2015C27.7097 12.6119 27.639 13.0072 27.4975 13.3875C27.356 13.7677 27.1503 14.1134 26.8804 14.4245L24.2338 11.7739L22.4458 13.5646L21.1017 12.2185L14.9645 18.365V21.0449L8.35162 27.6555C8.23292 27.7744 8.10771 27.8615 7.97598 27.9169C7.84427 27.9723 7.70199 28 7.54912 28ZM7.54912 25.794L13.3668 19.9676V18.619H12.0203L6.20259 24.4455L7.54912 25.794ZM7.54912 25.794L6.20259 24.4455L6.88561 25.11L7.54912 25.794Z", fill: "currentColor" })
});
P({
  displayName: "TrophyIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.25 19V15.5731C10.3821 15.4474 9.61763 15.108 8.95673 14.5548C8.29583 14.0016 7.84743 13.3064 7.61153 12.4692C6.45769 12.332 5.48398 11.8423 4.6904 11C3.8968 10.1577 3.5 9.15768 3.5 8V7.30773C3.5 6.81061 3.67701 6.38505 4.03102 6.03105C4.38503 5.67703 4.81058 5.50003 5.3077 5.50003H7.32693V5.30773C7.32693 4.81061 7.50392 4.38505 7.85792 4.03105C8.21193 3.67703 8.63748 3.50002 9.1346 3.50002H14.8654C15.3625 3.50002 15.788 3.67703 16.142 4.03105C16.496 4.38505 16.673 4.81061 16.673 5.30773V5.50003H18.6923C19.1894 5.50003 19.6149 5.67703 19.9689 6.03105C20.3229 6.38505 20.5 6.81061 20.5 7.30773V8C20.5 9.15768 20.1031 10.1577 19.3096 11C18.516 11.8423 17.5423 12.332 16.3884 12.4692C16.1525 13.3064 15.7041 14.0016 15.0432 14.5548C14.3823 15.108 13.6179 15.4474 12.75 15.5731V19H15.5576C15.7701 19 15.9483 19.0719 16.092 19.2157C16.2358 19.3595 16.3076 19.5377 16.3076 19.7503C16.3076 19.9629 16.2358 20.141 16.092 20.2846C15.9483 20.4282 15.7701 20.5 15.5576 20.5H8.44233C8.22983 20.5 8.0517 20.4281 7.90795 20.2843C7.7642 20.1404 7.69233 19.9622 7.69233 19.7497C7.69233 19.5371 7.7642 19.359 7.90795 19.2154C8.0517 19.0718 8.22983 19 8.44233 19H11.25ZM7.32693 10.8577V7H5.3077C5.21795 7 5.14423 7.02885 5.08653 7.08655C5.02883 7.14425 4.99997 7.21798 4.99997 7.30773V8C4.99997 8.69103 5.21857 9.30193 5.65575 9.8327C6.09293 10.3635 6.64999 10.7051 7.32693 10.8577ZM12.0023 14.1346C12.879 14.1346 13.6234 13.828 14.2355 13.2148C14.8477 12.6015 15.1538 11.8568 15.1538 10.9808V5.30773C15.1538 5.21798 15.125 5.14425 15.0673 5.08655C15.0096 5.02885 14.9359 5 14.8461 5H9.15383C9.06408 5 8.99035 5.02885 8.93265 5.08655C8.87497 5.14425 8.84613 5.21798 8.84613 5.30773V10.9808C8.84613 11.8568 9.15297 12.6015 9.76665 13.2148C10.3803 13.828 11.1255 14.1346 12.0023 14.1346ZM16.673 10.8577C17.35 10.7051 17.907 10.3635 18.3442 9.8327C18.7814 9.30193 19 8.69103 19 8V7.30773C19 7.21798 18.9711 7.14425 18.9134 7.08655C18.8557 7.02885 18.782 7 18.6923 7H16.673V10.8577Z", fill: "currentColor" })
});
P({
  displayName: "UnlockIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.30773 20H17.6923C17.782 20 17.8558 19.9711 17.9135 19.9135C17.9712 19.8558 18 19.782 18 19.6923V10.3077C18 10.218 17.9712 10.1442 17.9135 10.0865C17.8558 10.0288 17.782 10 17.6923 10H6.30773C6.21798 10 6.14425 10.0288 6.08655 10.0865C6.02885 10.1442 6 10.218 6 10.3077V19.6923C6 19.782 6.02885 19.8558 6.08655 19.9135C6.14425 19.9711 6.21798 20 6.30773 20ZM12 16.75C12.4859 16.75 12.899 16.5798 13.2394 16.2394C13.5798 15.899 13.75 15.4859 13.75 15C13.75 14.5141 13.5798 14.101 13.2394 13.7606C12.899 13.4202 12.4859 13.25 12 13.25C11.5141 13.25 11.101 13.4202 10.7606 13.7606C10.4202 14.101 10.25 14.5141 10.25 15C10.25 15.4859 10.4202 15.899 10.7606 16.2394C11.101 16.5798 11.5141 16.75 12 16.75ZM6.30773 21.5C5.80901 21.5 5.38305 21.3234 5.02985 20.9701C4.67663 20.6169 4.50003 20.191 4.50003 19.6923V10.3077C4.50003 9.80901 4.67663 9.38305 5.02985 9.02985C5.38305 8.67663 5.80901 8.50002 6.30773 8.50002H13.5V6.50002C13.5 5.25132 13.9378 4.18916 14.8135 3.31353C15.6891 2.43789 16.7513 2.00007 18 2.00007C19.1064 2.00007 20.0644 2.34558 20.874 3.0366C21.6836 3.72763 22.1916 4.58597 22.3981 5.6116C22.4557 5.82442 22.4128 6.02569 22.2692 6.21543C22.1256 6.40516 21.9525 6.50002 21.75 6.50002C21.5372 6.50002 21.3615 6.45131 21.2231 6.35388C21.0846 6.25644 20.9865 6.10645 20.9289 5.9039C20.784 5.22568 20.4426 4.65548 19.9048 4.1933C19.367 3.73112 18.7321 3.50002 18 3.50002C17.1667 3.50002 16.4583 3.79169 15.875 4.37502C15.2917 4.95836 15 5.66669 15 6.50002V8.50002H17.6923C18.191 8.50002 18.617 8.67663 18.9702 9.02985C19.3234 9.38305 19.5 9.80901 19.5 10.3077V19.6923C19.5 20.191 19.3234 20.6169 18.9702 20.9701C18.617 21.3234 18.191 21.5 17.6923 21.5H6.30773Z", fill: "currentColor" })
});
P({
  displayName: "UploadIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3176 10.622C17.7236 10.9964 18.3562 10.9707 18.7306 10.5647C19.105 10.1587 19.0794 9.52604 18.6734 9.15165L12.6779 3.62314L12 2.99804L11.3221 3.62314L5.32663 9.15165C4.92061 9.52604 4.89498 10.1587 5.26937 10.5647C5.64376 10.9707 6.27641 10.9964 6.68242 10.622L11 6.64067V14.4939C11 15.0462 11.4477 15.4939 12 15.4939C12.5523 15.4939 13 15.0462 13 14.4939V6.64067L17.3176 10.622ZM6.00528 17.2582C6.00528 16.7059 5.55756 16.2582 5.00528 16.2582C4.45299 16.2582 4.00528 16.7059 4.00528 17.2582V20.0225V21.0225H5.00528H18.9947H19.9947V20.0225V17.2582C19.9947 16.7059 19.547 16.2582 18.9947 16.2582C18.4424 16.2582 17.9947 16.7059 17.9947 17.2582V19.0225H6.00528V17.2582Z", fill: "currentColor" })
});
P({
  displayName: "UserTickIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.5288 19.3077H3.99037C3.56858 19.3077 3.20994 19.1599 2.91444 18.8644C2.61894 18.5689 2.47119 18.2102 2.47119 17.7884V17.0846C2.47119 16.5538 2.60484 16.0901 2.87214 15.6933C3.13944 15.2965 3.49425 14.9859 3.93657 14.7616C4.78657 14.3282 5.68399 13.9776 6.62884 13.7096C7.57371 13.4417 8.68781 13.3077 9.97114 13.3077C10.4711 13.3077 10.9362 13.3279 11.3663 13.3683C11.7965 13.4087 12.198 13.4693 12.5711 13.55L11.2442 14.8769C11.0609 14.8436 10.8625 14.8237 10.649 14.8173C10.4356 14.8109 10.2096 14.8077 9.97114 14.8077C8.78781 14.8077 7.75095 14.9397 6.86057 15.2038C5.97018 15.4679 5.22499 15.7666 4.62499 16.1C4.39807 16.2218 4.23237 16.3641 4.12787 16.5269C4.02338 16.6897 3.97114 16.8756 3.97114 17.0846V17.8077H10.0288L11.5288 19.3077ZM15.425 17.9462L19.9481 13.4231C20.0865 13.2846 20.2606 13.2138 20.4702 13.2106C20.6798 13.2074 20.857 13.2782 21.0019 13.4231C21.1468 13.568 21.2192 13.7436 21.2192 13.95C21.2192 14.1564 21.1468 14.332 21.0019 14.4769L16.0577 19.4211C15.8769 19.6019 15.666 19.6923 15.425 19.6923C15.184 19.6923 14.9731 19.6019 14.7923 19.4211L12.8481 17.4769C12.7096 17.3384 12.6388 17.1644 12.6356 16.9548C12.6324 16.7452 12.7032 16.568 12.8481 16.4231C12.9929 16.2782 13.1686 16.2058 13.375 16.2058C13.5814 16.2058 13.757 16.2782 13.9019 16.4231L15.425 17.9462ZM9.97114 11.6923C9.00866 11.6923 8.18471 11.3496 7.49929 10.6642C6.81389 9.97876 6.47119 9.15481 6.47119 8.19232C6.47119 7.22982 6.81389 6.40587 7.49929 5.72047C8.18471 5.03506 9.00866 4.69235 9.97114 4.69235C10.9336 4.69235 11.7576 5.03506 12.443 5.72047C13.1284 6.40587 13.4711 7.22982 13.4711 8.19232C13.4711 9.15481 13.1284 9.97876 12.443 10.6642C11.7576 11.3496 10.9336 11.6923 9.97114 11.6923ZM9.97114 10.1923C10.5211 10.1923 10.992 9.99649 11.3836 9.60482C11.7753 9.21316 11.9711 8.74232 11.9711 8.19232C11.9711 7.64232 11.7753 7.17149 11.3836 6.77982C10.992 6.38816 10.5211 6.19232 9.97114 6.19232C9.42114 6.19232 8.95031 6.38816 8.55864 6.77982C8.16698 7.17149 7.97114 7.64232 7.97114 8.19232C7.97114 8.74232 8.16698 9.21316 8.55864 9.60482C8.95031 9.99649 9.42114 10.1923 9.97114 10.1923Z", fill: "currentColor" })
});
P({
  displayName: "ValidatorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.5288 19.3077H3.99037C3.56858 19.3077 3.20994 19.1599 2.91444 18.8644C2.61894 18.5689 2.47119 18.2102 2.47119 17.7884V17.0846C2.47119 16.5538 2.60484 16.0901 2.87214 15.6933C3.13944 15.2965 3.49425 14.9859 3.93657 14.7616C4.78657 14.3282 5.68399 13.9776 6.62884 13.7096C7.57371 13.4417 8.68781 13.3077 9.97114 13.3077C10.4711 13.3077 10.9362 13.3279 11.3663 13.3683C11.7965 13.4087 12.198 13.4693 12.5711 13.55L11.2442 14.8769C11.0609 14.8436 10.8625 14.8237 10.649 14.8173C10.4356 14.8109 10.2096 14.8077 9.97114 14.8077C8.78781 14.8077 7.75095 14.9397 6.86057 15.2038C5.97018 15.4679 5.22499 15.7666 4.62499 16.1C4.39807 16.2218 4.23237 16.3641 4.12787 16.5269C4.02338 16.6897 3.97114 16.8756 3.97114 17.0846V17.8077H10.0288L11.5288 19.3077ZM15.425 17.9462L19.9481 13.4231C20.0865 13.2846 20.2606 13.2138 20.4702 13.2106C20.6798 13.2074 20.857 13.2782 21.0019 13.4231C21.1468 13.568 21.2192 13.7436 21.2192 13.95C21.2192 14.1564 21.1468 14.332 21.0019 14.4769L16.0577 19.4211C15.8769 19.6019 15.666 19.6923 15.425 19.6923C15.184 19.6923 14.9731 19.6019 14.7923 19.4211L12.8481 17.4769C12.7096 17.3384 12.6388 17.1644 12.6356 16.9548C12.6324 16.7452 12.7032 16.568 12.8481 16.4231C12.9929 16.2782 13.1686 16.2058 13.375 16.2058C13.5814 16.2058 13.757 16.2782 13.9019 16.4231L15.425 17.9462ZM9.97114 11.6923C9.00866 11.6923 8.18471 11.3496 7.49929 10.6642C6.81389 9.97876 6.47119 9.15481 6.47119 8.19232C6.47119 7.22982 6.81389 6.40587 7.49929 5.72047C8.18471 5.03506 9.00866 4.69235 9.97114 4.69235C10.9336 4.69235 11.7576 5.03506 12.443 5.72047C13.1284 6.40587 13.4711 7.22982 13.4711 8.19232C13.4711 9.15481 13.1284 9.97876 12.443 10.6642C11.7576 11.3496 10.9336 11.6923 9.97114 11.6923ZM9.97114 10.1923C10.5211 10.1923 10.992 9.99649 11.3836 9.60482C11.7753 9.21316 11.9711 8.74232 11.9711 8.19232C11.9711 7.64232 11.7753 7.17149 11.3836 6.77982C10.992 6.38816 10.5211 6.19232 9.97114 6.19232C9.42114 6.19232 8.95031 6.38816 8.55864 6.77982C8.16698 7.17149 7.97114 7.64232 7.97114 8.19232C7.97114 8.74232 8.16698 9.21316 8.55864 9.60482C8.95031 9.99649 9.42114 10.1923 9.97114 10.1923Z", fill: "currentColor" })
});
P({
  displayName: "VaultIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 7C4 5.34315 5.34315 4 7 4H16C17.6569 4 19 5.34315 19 7V16C19 17.2261 18.2644 18.2804 17.2105 18.7458V19.4469C17.2105 19.7523 16.9629 19.9999 16.6575 19.9999C16.4481 19.9999 16.2566 19.8816 16.1629 19.6942L15.8158 19H7L6.9737 18.9999L6.62653 19.6942C6.53286 19.8816 6.34138 19.9999 6.13193 19.9999C5.82653 19.9999 5.57895 19.7523 5.57895 19.4469V18.6427C4.63889 18.1362 4 17.1427 4 16V7ZM15 7H8C7.44772 7 7 7.44772 7 8V15C7 15.5523 7.44772 16 8 16H15C15.5523 16 16 15.5523 16 15V8C16 7.44772 15.5523 7 15 7ZM8 6C6.89543 6 6 6.89543 6 8V15C6 16.1046 6.89543 17 8 17H15C16.1046 17 17 16.1046 17 15V8C17 6.89543 16.1046 6 15 6H8ZM14 13C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12C13 12.5523 13.4477 13 14 13Z", fill: "currentColor" })
});
P({
  displayName: "VoiceIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M18.7042 21.3036C18.4911 21.3036 18.3128 21.2316 18.1692 21.0875C18.0256 20.9435 17.9538 20.765 17.9538 20.552C17.9538 20.4518 17.9727 20.3521 18.0105 20.253C18.0482 20.1539 18.0986 20.0733 18.1615 20.0113C18.8846 19.2883 19.4455 18.4617 19.8442 17.5315C20.2429 16.6014 20.4423 15.5976 20.4423 14.5203C20.4423 13.4592 20.2429 12.461 19.8442 11.5258C19.4455 10.5905 18.8846 9.76135 18.1615 9.03827C18.0986 8.97585 18.0482 8.8947 18.0105 8.79481C17.9727 8.69491 17.9538 8.59502 17.9538 8.49514C17.9538 8.28289 18.0259 8.10497 18.1699 7.96139C18.314 7.81779 18.4925 7.74599 18.7054 7.74599C18.8056 7.74599 18.9026 7.76768 18.9964 7.81107C19.0901 7.85443 19.1682 7.9071 19.2307 7.96907C20.0923 8.8306 20.7596 9.82355 21.2326 10.9479C21.7057 12.0723 21.9423 13.2632 21.9423 14.5209C21.9423 15.794 21.7057 16.9902 21.2326 18.1094C20.7596 19.2286 20.0923 20.219 19.2307 21.0806C19.168 21.1425 19.0897 21.1952 18.9957 21.2386C18.9017 21.2819 18.8045 21.3036 18.7042 21.3036ZM16.0742 18.6748C15.8619 18.6748 15.684 18.6028 15.5404 18.4587C15.3968 18.3147 15.325 18.1362 15.325 17.9232C15.325 17.823 15.3467 17.726 15.3901 17.6323C15.4334 17.5385 15.4861 17.4604 15.5481 17.3979C15.9301 17.0158 16.226 16.5796 16.4356 16.0892C16.6452 15.5989 16.75 15.0774 16.75 14.5248C16.75 13.9722 16.6426 13.4508 16.4279 12.9604C16.2131 12.47 15.9199 12.0338 15.5481 11.6517C15.4737 11.589 15.4179 11.5107 15.3808 11.4167C15.3436 11.3227 15.325 11.2255 15.325 11.1252C15.325 10.9121 15.397 10.7338 15.5411 10.5902C15.6851 10.4466 15.8636 10.3748 16.0766 10.3748C16.1768 10.3748 16.2765 10.3934 16.3756 10.4306C16.4748 10.4678 16.5553 10.5235 16.6173 10.5979C17.1295 11.11 17.5297 11.7021 17.8178 12.3743C18.1059 13.0464 18.25 13.7633 18.25 14.5248C18.25 15.2863 18.1059 16.0032 17.8178 16.6753C17.5297 17.3475 17.1295 17.9396 16.6173 18.4517C16.5548 18.5261 16.4737 18.5818 16.3738 18.619C16.2739 18.6562 16.174 18.6748 16.0742 18.6748ZM3 21.0806V19.5806C3.79703 19.5806 4.5854 19.5338 5.3651 19.4402C6.14478 19.3466 6.90899 19.1569 7.65773 18.871C7.73464 18.8389 7.7699 18.7796 7.7635 18.6931C7.75708 18.6065 7.69938 18.5504 7.5904 18.5248C6.81092 18.2184 6.18432 17.7299 5.7106 17.0594C5.23687 16.3889 5 15.6383 5 14.8075V12.9268H8.6923C8.78205 12.9268 8.85578 12.8979 8.91348 12.8402C8.97116 12.7825 9 12.7088 9 12.6191V10.0229H12.0288C12.1442 10.0229 12.2324 9.97646 12.2933 9.88349C12.3542 9.79054 12.359 9.69278 12.3077 9.59022L9.6077 4.09407C9.51283 3.90817 9.49842 3.71971 9.56445 3.52869C9.63047 3.33767 9.75643 3.19152 9.94233 3.09024C10.1282 2.98896 10.3199 2.97293 10.5173 3.04217C10.7147 3.1114 10.8609 3.23896 10.9557 3.42484L13.6654 8.93061C13.9602 9.53316 13.9346 10.1158 13.5886 10.6787C13.2425 11.2415 12.7309 11.5229 12.0538 11.5229H10.5V12.6767C10.5 13.1626 10.3298 13.5758 9.9894 13.9162C9.64902 14.2565 9.23588 14.4267 8.75 14.4267H6.49998V14.8267C6.49998 15.4229 6.69197 15.9418 7.07595 16.3835C7.45992 16.8251 7.93972 17.121 8.51538 17.271L8.81538 17.346C9.41153 17.4998 9.74004 17.8908 9.80093 18.519C9.86183 19.1472 9.60189 19.6024 9.02113 19.8844C8.08524 20.3447 7.10961 20.6591 6.09423 20.8277C5.07884 20.9963 4.04743 21.0806 3 21.0806Z", fill: "currentColor" })
});
P({
  displayName: "WalletIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M15.5654 13.4246C15.9987 13.4246 16.3571 13.283 16.6404 12.9996C16.9237 12.7163 17.0654 12.358 17.0654 11.9246C17.0654 11.4913 16.9237 11.133 16.6404 10.8496C16.3571 10.5663 15.9987 10.4246 15.5654 10.4246C15.1321 10.4246 14.7737 10.5663 14.4904 10.8496C14.2071 11.133 14.0654 11.4913 14.0654 11.9246C14.0654 12.358 14.2071 12.7163 14.4904 12.9996C14.7737 13.283 15.1321 13.4246 15.5654 13.4246ZM4.87311 20.4246C4.36798 20.4246 3.94041 20.2496 3.59041 19.8996C3.24041 19.5496 3.06541 19.122 3.06541 18.6169V5.23236C3.06541 4.72723 3.24041 4.29966 3.59041 3.94966C3.94041 3.59966 4.36798 3.42466 4.87311 3.42466H18.2577C18.7628 3.42466 19.1904 3.59966 19.5404 3.94966C19.8904 4.29966 20.0654 4.72723 20.0654 5.23236V7.95351H18.5654V5.23236C18.5654 5.14261 18.5365 5.06888 18.4788 5.01118C18.4211 4.95348 18.3474 4.92463 18.2577 4.92463H4.87311C4.78336 4.92463 4.70964 4.95348 4.65194 5.01118C4.59424 5.06888 4.56539 5.14261 4.56539 5.23236V18.6169C4.56539 18.7067 4.59424 18.7804 4.65194 18.8381C4.70964 18.8958 4.78336 18.9246 4.87311 18.9246H18.2577C18.3474 18.9246 18.4211 18.8958 18.4788 18.8381C18.5365 18.7804 18.5654 18.7067 18.5654 18.6169V15.8958H20.0654V18.6169C20.0654 19.122 19.8904 19.5496 19.5404 19.8996C19.1904 20.2496 18.7628 20.4246 18.2577 20.4246H4.87311ZM12.8731 16.4246C12.368 16.4246 11.9404 16.2496 11.5904 15.8996C11.2404 15.5496 11.0654 15.122 11.0654 14.6169V9.23236C11.0654 8.72723 11.2404 8.29966 11.5904 7.94966C11.9404 7.59966 12.368 7.42466 12.8731 7.42466H19.2577C19.7628 7.42466 20.1904 7.59966 20.5404 7.94966C20.8904 8.29966 21.0654 8.72723 21.0654 9.23236V14.6169C21.0654 15.122 20.8904 15.5496 20.5404 15.8996C20.1904 16.2496 19.7628 16.4246 19.2577 16.4246H12.8731ZM19.2577 14.9246C19.3474 14.9246 19.4211 14.8958 19.4788 14.8381C19.5365 14.7804 19.5654 14.7067 19.5654 14.6169V9.23236C19.5654 9.14261 19.5365 9.06889 19.4788 9.01119C19.4211 8.95349 19.3474 8.92463 19.2577 8.92463H12.8731C12.7834 8.92463 12.7096 8.95349 12.6519 9.01119C12.5942 9.06889 12.5654 9.14261 12.5654 9.23236V14.6169C12.5654 14.7067 12.5942 14.7804 12.6519 14.8381C12.7096 14.8958 12.7834 14.9246 12.8731 14.9246H19.2577Z", fill: "currentColor" })
});
const Uoe = P({
  displayName: "WarningIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M11.9997 14.0385C11.7871 14.0385 11.609 13.9666 11.4654 13.8228C11.3218 13.6791 11.25 13.501 11.25 13.2885V6.28847C11.25 6.07599 11.3219 5.89787 11.4657 5.75412C11.6095 5.61037 11.7877 5.5385 12.0003 5.5385C12.2129 5.5385 12.391 5.61037 12.5346 5.75412C12.6782 5.89787 12.75 6.07599 12.75 6.28847V13.2885C12.75 13.501 12.6781 13.6791 12.5343 13.8228C12.3905 13.9666 12.2123 14.0385 11.9997 14.0385ZM11.9997 18.4615C11.7871 18.4615 11.609 18.3896 11.4654 18.2458C11.3218 18.102 11.25 17.9238 11.25 17.7112C11.25 17.4986 11.3219 17.3205 11.4657 17.1769C11.6095 17.0333 11.7877 16.9615 12.0003 16.9615C12.2129 16.9615 12.391 17.0334 12.5346 17.1773C12.6782 17.3211 12.75 17.4993 12.75 17.7118C12.75 17.9244 12.6781 18.1025 12.5343 18.2461C12.3905 18.3897 12.2123 18.4615 11.9997 18.4615Z", fill: "currentColor" })
});
P({
  displayName: "WarningCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0243 12.9951C12.3155 12.9951 12.5625 12.8939 12.765 12.6913C12.967 12.4893 13.068 12.2427 13.068 11.9515V8.04369C13.068 7.76861 12.967 7.5301 12.765 7.32816C12.5625 7.12557 12.3155 7.02427 12.0243 7.02427C11.733 7.02427 11.4864 7.12557 11.2845 7.32816C11.0819 7.5301 10.9806 7.7767 10.9806 8.06796V11.9757C10.9806 12.2508 11.0819 12.4893 11.2845 12.6913C11.4864 12.8939 11.733 12.9951 12.0243 12.9951ZM12 16.9757C12.2913 16.9757 12.534 16.8786 12.7282 16.6845C12.9223 16.4903 13.0194 16.2476 13.0194 15.9563C13.0194 15.6651 12.9223 15.4223 12.7282 15.2282C12.534 15.034 12.2913 14.9369 12 14.9369C11.7087 14.9369 11.466 15.034 11.2718 15.2282C11.0777 15.4223 10.9806 15.6651 10.9806 15.9563C10.9806 16.2476 11.0777 16.4903 11.2718 16.6845C11.466 16.8786 11.7087 16.9757 12 16.9757ZM12 22C10.6084 22 9.30583 21.7372 8.09223 21.2117C6.87864 20.6854 5.82298 19.9735 4.92524 19.0757C4.02686 18.1773 3.31489 17.1214 2.78932 15.9078C2.26311 14.6942 2 13.3916 2 12C2 10.6084 2.26311 9.30162 2.78932 8.07961C3.31489 6.85825 4.02686 5.79838 4.92524 4.9C5.82298 4.00227 6.87864 3.2945 8.09223 2.7767C9.30583 2.2589 10.6084 2 12 2C13.3916 2 14.6984 2.2589 15.9204 2.7767C17.1417 3.2945 18.2013 4.00227 19.099 4.9C19.9974 5.79838 20.7055 6.85825 21.2233 8.07961C21.7411 9.30162 22 10.6084 22 12C22 13.3916 21.7411 14.6942 21.2233 15.9078C20.7055 17.1214 19.9974 18.1773 19.099 19.0757C18.2013 19.9735 17.1417 20.6854 15.9204 21.2117C14.6984 21.7372 13.3916 22 12 22ZM12 19.9126C14.2006 19.9126 16.0696 19.144 17.6068 17.6068C19.144 16.0696 19.9126 14.2006 19.9126 12C19.9126 9.79935 19.144 7.93042 17.6068 6.3932C16.0696 4.85599 14.2006 4.08738 12 4.08738C9.79935 4.08738 7.93042 4.85599 6.3932 6.3932C4.85599 7.93042 4.08738 9.79935 4.08738 12C4.08738 14.2006 4.85599 16.0696 6.3932 17.6068C7.93042 19.144 9.79935 19.9126 12 19.9126Z", fill: "currentColor" })
});
P({
  displayName: "WarningCircleSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM11.2143 6.28571H12.7857V14.1429H11.2143V6.28571ZM12 18.4286C11.4286 18.4286 10.9286 17.9286 10.9286 17.3571C10.9286 16.7857 11.4286 16.2857 12 16.2857C12.5714 16.2857 13.0714 16.7857 13.0714 17.3571C13.0714 17.9286 12.5714 18.4286 12 18.4286Z", fill: "currentColor" })
});
P({
  displayName: "WarningPageIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.76733 16.05C6.97969 16.05 7.1598 15.9759 7.30765 15.8276C7.45552 15.6792 7.52945 15.5 7.52945 15.2897C7.52945 15.0795 7.45529 14.8994 7.30698 14.7494C7.15868 14.5994 6.97941 14.5244 6.76918 14.5244C6.55894 14.5244 6.37883 14.5996 6.22883 14.7501C6.07883 14.9006 6.00383 15.0799 6.00383 15.2879C6.00383 15.5002 6.07908 15.6804 6.22958 15.8282C6.38008 15.9761 6.55933 16.05 6.76733 16.05ZM6.77003 12.9667C6.94896 12.9667 7.09783 12.9065 7.21663 12.7861C7.33543 12.6657 7.39483 12.5165 7.39483 12.3385V8.51408C7.39483 8.33609 7.3343 8.1869 7.21325 8.0665C7.0922 7.9461 6.94221 7.8859 6.76328 7.8859C6.58433 7.8859 6.43545 7.9461 6.31665 8.0665C6.19785 8.1869 6.13845 8.33609 6.13845 8.51408V12.3385C6.13845 12.5165 6.19898 12.6657 6.32003 12.7861C6.44108 12.9065 6.59108 12.9667 6.77003 12.9667ZM11 14.6013H17.2333C17.4113 14.6013 17.5605 14.5408 17.6809 14.4197C17.8013 14.2987 17.8615 14.1487 17.8615 13.9697C17.8615 13.7908 17.8013 13.6419 17.6809 13.5231C17.5605 13.4043 17.4113 13.3449 17.2333 13.3449H11C10.822 13.3449 10.6728 13.4054 10.5524 13.5265C10.432 13.6475 10.3718 13.7975 10.3718 13.9765C10.3718 14.1554 10.432 14.3043 10.5524 14.4231C10.6728 14.5419 10.822 14.6013 11 14.6013ZM11 10.4692H17.2333C17.4113 10.4692 17.5605 10.4087 17.6809 10.2876C17.8013 10.1666 17.8615 10.0166 17.8615 9.83765C17.8615 9.65872 17.8013 9.50985 17.6809 9.39105C17.5605 9.27225 17.4113 9.21285 17.2333 9.21285H11C10.822 9.21285 10.6728 9.27337 10.5524 9.3944C10.432 9.51545 10.3718 9.66545 10.3718 9.8444C10.3718 10.0234 10.432 10.1722 10.5524 10.291C10.6728 10.4098 10.822 10.4692 11 10.4692ZM3.96923 19.5C3.53943 19.5 3.17129 19.3467 2.86483 19.0403C2.55838 18.7338 2.40515 18.3657 2.40515 17.9359V6.06413C2.40515 5.63433 2.55838 5.26619 2.86483 4.95973C3.17129 4.65326 3.53943 4.50003 3.96923 4.50003H20.0307C20.4605 4.50003 20.8287 4.65326 21.1351 4.95973C21.4416 5.26619 21.5948 5.63433 21.5948 6.06413V17.9359C21.5948 18.3657 21.4416 18.7338 21.1351 19.0403C20.8287 19.3467 20.4605 19.5 20.0307 19.5H3.96923ZM3.96923 18.2436H20.0307C20.1077 18.2436 20.1782 18.2115 20.2423 18.1474C20.3064 18.0833 20.3385 18.0128 20.3385 17.9359V6.06413C20.3385 5.98719 20.3064 5.91668 20.2423 5.85258C20.1782 5.78846 20.1077 5.7564 20.0307 5.7564H3.96923C3.89229 5.7564 3.82178 5.78846 3.75768 5.85258C3.69358 5.91668 3.66153 5.98719 3.66153 6.06413V17.9359C3.66153 18.0128 3.69358 18.0833 3.75768 18.1474C3.82178 18.2115 3.89229 18.2436 3.96923 18.2436Z", fill: "currentColor" })
});
P({
  displayName: "WarningTriangleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8742 5.63261C12.4932 4.9468 11.5068 4.9468 11.1258 5.63261L5.02487 16.6144C4.65458 17.2809 5.13655 18.1 5.89903 18.1H18.101C18.8635 18.1 19.3454 17.2809 18.9751 16.6144L12.8742 5.63261ZM9.37753 4.66133C10.5205 2.6039 13.4795 2.6039 14.6225 4.66133L20.7234 15.6431C21.8343 17.6427 20.3884 20.1 18.101 20.1H5.89903C3.61158 20.1 2.16567 17.6427 3.27656 15.6431L9.37753 4.66133ZM12 8.20014C12.5523 8.20014 13 8.64785 13 9.20014V12.8001C13 13.3524 12.5523 13.8001 12 13.8001C11.4477 13.8001 11 13.3524 11 12.8001V9.20014C11 8.64785 11.4477 8.20014 12 8.20014ZM13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16Z", fill: "currentColor" })
});
P({
  displayName: "WarningTriangleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M12.0014 5.11428H11.9986L3.89193 19.6644L3.89329 19.6667H20.1067L20.1081 19.6644L12.0014 5.11428ZM11.1964 9.00001H12.8036V15H11.1964V9.00001ZM12 18.3333C11.7881 18.3333 11.5809 18.2747 11.4047 18.1648C11.2286 18.0549 11.0912 17.8987 11.0101 17.716C10.929 17.5333 10.9078 17.3322 10.9492 17.1382C10.9905 16.9443 11.0925 16.7661 11.2424 16.6262C11.3922 16.4864 11.5831 16.3911 11.791 16.3526C11.9988 16.314 12.2142 16.3338 12.41 16.4095C12.6058 16.4851 12.7731 16.6133 12.8909 16.7778C13.0086 16.9422 13.0714 17.1356 13.0714 17.3333C13.0714 17.5986 12.9585 17.8529 12.7576 18.0404C12.5567 18.228 12.2842 18.3333 12 18.3333Z", fill: "currentColor" }),
    w.createElement("path", { d: "M21.2857 21H2.71429C2.59157 21 2.47092 20.9705 2.36398 20.9143C2.25703 20.8581 2.16739 20.7772 2.10371 20.6793C2.04002 20.5814 2.00444 20.4698 2.00039 20.3553C1.99634 20.2409 2.02395 20.1273 2.08058 20.0257L11.3663 3.35908C11.4266 3.25083 11.5176 3.16011 11.6293 3.0968C11.7411 3.03348 11.8693 3 12 3C12.1307 3 12.2589 3.03348 12.3707 3.0968C12.4824 3.16011 12.5734 3.25083 12.6337 3.35908L21.9194 20.0257C21.976 20.1273 22.0037 20.2409 21.9996 20.3553C21.9956 20.4698 21.96 20.5814 21.8963 20.6793C21.8326 20.7772 21.743 20.8581 21.636 20.9143C21.5291 20.9705 21.4084 21 21.2857 21ZM3.89329 19.6667H20.1067L20.1081 19.6644L12.0014 5.11428H11.9986L3.89193 19.6644L3.89329 19.6667Z", fill: "currentColor" })
  )
});
P({
  displayName: "WarningTriangleSolidColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M10.285 4.19165C11.0618 2.89697 12.9382 2.89697 13.715 4.19165L22.1826 18.3043C22.9824 19.6374 22.0222 21.3333 20.4676 21.3333H3.53239C1.9778 21.3333 1.01757 19.6374 1.8174 18.3043L10.285 4.19165Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0001 8.11102C13.2001 8.11102 13.6001 8.8888 13.6001 9.66658C13.6001 10.4444 13.2001 14.3332 13.2001 14.3332C13.2001 14.9776 12.6628 15.4999 12.0001 15.4999C11.3373 15.4999 10.8001 14.9776 10.8001 14.3332C10.8001 14.3332 10.4001 10.4444 10.4001 9.66658C10.4001 8.8888 10.8001 8.11102 12.0001 8.11102Z", fill: "#14151A" }),
    w.createElement("path", { d: "M13.6001 18.2222C13.6001 19.0814 12.8837 19.7778 12.0001 19.7778C11.1164 19.7778 10.4001 19.0814 10.4001 18.2222C10.4001 17.3631 11.1164 16.6667 12.0001 16.6667C12.8837 16.6667 13.6001 17.3631 13.6001 18.2222Z", fill: "#14151A" })
  )
});
P({
  displayName: "WebsiteIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M10.0635 19.7231C9.68017 19.1346 9.33915 18.4949 9.04043 17.8039C8.7417 17.1128 8.50131 16.4026 8.31926 15.6731H4.92691C5.46154 16.7179 6.16347 17.5888 7.03271 18.2856C7.90196 18.9824 8.91222 19.4616 10.0635 19.7231ZM4.29808 14.1731H8.01541C7.95259 13.8013 7.90708 13.4369 7.87888 13.0798C7.85068 12.7228 7.83658 12.3628 7.83658 12C7.83658 11.6372 7.85068 11.2772 7.87888 10.9202C7.90708 10.5631 7.95259 10.1987 8.01541 9.8269H4.29808C4.20193 10.1667 4.12821 10.5199 4.07693 10.8865C4.02565 11.2532 4.00001 11.6244 4.00001 12C4.00001 12.3757 4.02565 12.7468 4.07693 13.1135C4.12821 13.4801 4.20193 13.8334 4.29808 14.1731ZM4.92691 8.32695H8.31926C8.48849 7.59105 8.72567 6.87278 9.03081 6.17213C9.33594 5.47148 9.68017 4.83973 10.0635 4.2769C8.94427 4.52562 7.94041 5.00318 7.05193 5.7096C6.16346 6.41602 5.45512 7.28847 4.92691 8.32695ZM9.85961 8.32695H14.1404C13.9212 7.51028 13.6372 6.75772 13.2885 6.06925C12.9398 5.38078 12.5103 4.69808 12 4.02115C11.4897 4.67243 11.0635 5.34231 10.7212 6.03078C10.3788 6.71924 10.0917 7.48463 9.85961 8.32695ZM15.6808 8.32695H19.0731C18.5449 7.28847 17.8365 6.41442 16.9481 5.7048C16.0596 4.99518 15.0557 4.51922 13.9365 4.2769C14.2878 4.83332 14.616 5.46185 14.9211 6.1625C15.2263 6.86315 15.4795 7.58463 15.6808 8.32695ZM12 21.5C10.6974 21.5 9.46828 21.2503 8.31253 20.7509C7.15676 20.2516 6.14875 19.5718 5.28848 18.7115C4.42823 17.8513 3.74843 16.8432 3.24908 15.6875C2.74971 14.5317 2.50003 13.3026 2.50003 12C2.50003 10.6872 2.74971 9.45546 3.24908 8.30483C3.74843 7.15419 4.42823 6.14874 5.28848 5.28848C6.14875 4.42823 7.15676 3.74843 8.31253 3.24908C9.46828 2.74971 10.6974 2.50002 12 2.50002C13.3128 2.50002 14.5445 2.74971 15.6952 3.24908C16.8458 3.74843 17.8513 4.42823 18.7115 5.28848C19.5718 6.14874 20.2516 7.15419 20.7509 8.30483C21.2503 9.45546 21.5 10.6872 21.5 12C21.5 12.1731 21.4958 12.3494 21.4875 12.5289C21.4792 12.7083 21.4634 12.8846 21.4404 13.0577H19.9154C19.9487 12.8846 19.9712 12.7109 19.9827 12.5366C19.9942 12.3622 20 12.1833 20 12C20 11.6244 19.9744 11.2532 19.9231 10.8865C19.8718 10.5199 19.7981 10.1667 19.7019 9.8269H15.9846C16.0474 10.1987 16.0929 10.5631 16.1211 10.9202C16.1493 11.2772 16.1634 11.6372 16.1634 12C16.1634 12.1833 16.1618 12.3606 16.1586 12.5317C16.1554 12.7029 16.1455 12.8782 16.1288 13.0577H14.6289C14.6455 12.8846 14.6555 12.7109 14.6587 12.5366C14.6619 12.3622 14.6635 12.1833 14.6635 12C14.6635 11.6244 14.6494 11.2612 14.6212 10.9106C14.593 10.5599 14.5474 10.1987 14.4846 9.8269H9.51538C9.45256 10.1987 9.40705 10.5599 9.37883 10.9106C9.35063 11.2612 9.33653 11.6244 9.33653 12C9.33653 12.3757 9.35063 12.7388 9.37883 13.0894C9.40705 13.4401 9.45256 13.8013 9.51538 14.1731H13.0577V15.6731H9.85961C10.0917 16.509 10.3836 17.2792 10.7356 17.9837C11.0875 18.6881 11.509 19.3532 12 19.9789C12.1962 19.7186 12.3808 19.4526 12.5539 19.1808C12.7269 18.909 12.8949 18.6314 13.0577 18.3481V21.4404C12.8846 21.4634 12.7109 21.4791 12.5366 21.4875C12.3622 21.4958 12.1833 21.5 12 21.5ZM16.75 17.8192V19.65C16.75 19.8628 16.6782 20.041 16.5346 20.1846C16.391 20.3282 16.2128 20.4 16 20.4C15.7872 20.4 15.609 20.3282 15.4654 20.1846C15.3218 20.041 15.25 19.8628 15.25 19.65V16.1539C15.25 15.8962 15.3362 15.6811 15.5087 15.5087C15.6811 15.3362 15.8962 15.25 16.1539 15.25H19.65C19.8628 15.25 20.041 15.3218 20.1846 15.4654C20.3282 15.609 20.4 15.7872 20.4 16C20.4 16.2128 20.3282 16.391 20.1846 16.5346C20.041 16.6782 19.8628 16.75 19.65 16.75H17.7942L20.4769 19.4231C20.6154 19.5616 20.6846 19.7346 20.6846 19.9423C20.6846 20.15 20.6154 20.3282 20.4769 20.4769C20.3282 20.632 20.15 20.708 19.9423 20.7048C19.7346 20.7016 19.5564 20.6256 19.4077 20.4769L16.75 17.8192Z", fill: "currentColor" })
});
P({
  displayName: "ZoomOutIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { id: "zoom_out_map_2", d: "M6.55375 19H8.75C8.9625 19 9.14067 19.0719 9.2845 19.2158C9.42817 19.3596 9.5 19.5378 9.5 19.7502C9.5 19.9629 9.42817 20.141 9.2845 20.2845C9.14067 20.4282 8.9625 20.5 8.75 20.5H4.904C4.64783 20.5 4.43317 20.4133 4.26 20.24C4.08667 20.0668 4 19.8522 4 19.596V15.75C4 15.5375 4.07192 15.3593 4.21575 15.2155C4.35958 15.0718 4.53775 15 4.75025 15C4.96292 15 5.141 15.0718 5.2845 15.2155C5.42817 15.3593 5.5 15.5375 5.5 15.75V17.9462L8.323 15.123C8.4615 14.9847 8.63558 14.9138 8.84525 14.9105C9.05492 14.9073 9.23217 14.9782 9.377 15.123C9.52183 15.2678 9.59425 15.4435 9.59425 15.65C9.59425 15.8563 9.52183 16.032 9.377 16.177L6.55375 19ZM18.4462 19L15.623 16.177C15.4847 16.0385 15.4138 15.8644 15.4105 15.6547C15.4073 15.4451 15.4782 15.2678 15.623 15.123C15.7678 14.9782 15.9435 14.9058 16.15 14.9058C16.3563 14.9058 16.532 14.9782 16.677 15.123L19.5 17.9462V15.75C19.5 15.5375 19.5719 15.3593 19.7158 15.2155C19.8596 15.0718 20.0378 15 20.2502 15C20.4629 15 20.641 15.0718 20.7845 15.2155C20.9282 15.3593 21 15.5375 21 15.75V19.596C21 19.8522 20.9133 20.0668 20.74 20.24C20.5668 20.4133 20.3522 20.5 20.096 20.5H16.25C16.0375 20.5 15.8593 20.4281 15.7155 20.2843C15.5718 20.1404 15.5 19.9622 15.5 19.7498C15.5 19.5371 15.5718 19.359 15.7155 19.2155C15.8593 19.0718 16.0375 19 16.25 19H18.4462ZM5.5 6.05375V8.25C5.5 8.4625 5.42808 8.64067 5.28425 8.7845C5.14042 8.92817 4.96225 9 4.74975 9C4.53708 9 4.359 8.92817 4.2155 8.7845C4.07183 8.64067 4 8.4625 4 8.25V4.404C4 4.14783 4.08667 3.93317 4.26 3.76C4.43317 3.58667 4.64783 3.5 4.904 3.5H8.75C8.9625 3.5 9.14067 3.57192 9.2845 3.71575C9.42817 3.85958 9.5 4.03775 9.5 4.25025C9.5 4.46292 9.42817 4.641 9.2845 4.7845C9.14067 4.92817 8.9625 5 8.75 5H6.55375L9.377 7.823C9.51533 7.9615 9.58617 8.13558 9.5895 8.34525C9.59267 8.55492 9.52183 8.73217 9.377 8.877C9.23217 9.02183 9.0565 9.09425 8.85 9.09425C8.64367 9.09425 8.468 9.02183 8.323 8.877L5.5 6.05375ZM19.5 6.05375L16.677 8.877C16.5385 9.01533 16.3644 9.08617 16.1547 9.0895C15.9451 9.09267 15.7678 9.02183 15.623 8.877C15.4782 8.73217 15.4057 8.5565 15.4057 8.35C15.4057 8.14367 15.4782 7.968 15.623 7.823L18.4462 5H16.25C16.0375 5 15.8593 4.92808 15.7155 4.78425C15.5718 4.64042 15.5 4.46225 15.5 4.24975C15.5 4.03708 15.5718 3.859 15.7155 3.7155C15.8593 3.57183 16.0375 3.5 16.25 3.5H20.096C20.3522 3.5 20.5668 3.58667 20.74 3.76C20.9133 3.93317 21 4.14783 21 4.404V8.25C21 8.4625 20.9281 8.64067 20.7843 8.7845C20.6404 8.92817 20.4622 9 20.2498 9C20.0371 9 19.859 8.92817 19.7155 8.7845C19.5718 8.64067 19.5 8.4625 19.5 8.25V6.05375Z", fill: "currentColor" })
});
P({
  displayName: "AltLayerIcon",
  viewBox: "0 0 32 32",
  path: w.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M2.25029 10.2537C1.91657 10.5157 1.91657 11.0137 2.25029 11.2757L3.98107 12.6344C4.22611 12.8268 4.57465 12.8255 4.8182 12.6313L14.6908 4.75989C14.8466 4.63562 14.9371 4.44906 14.9371 4.25199V1.65564C14.9371 1.10691 14.2903 0.801842 13.8537 1.14463L2.25029 10.2537ZM5.23148 18.1911C4.98793 18.3853 4.63937 18.3865 4.39434 18.1942L2.80399 16.9457C2.47189 16.685 2.46997 16.19 2.80005 15.9268L13.8497 7.11687C14.2855 6.76939 14.9371 7.07372 14.9371 7.62477V10.1412C14.9371 10.3383 14.8466 10.5249 14.6908 10.6491L5.23148 18.1911ZM3.21332 21.4865C2.88324 21.7497 2.88515 22.2448 3.21725 22.5054L13.8536 30.8553C14.2903 31.1982 14.9371 30.8931 14.9371 30.3444V26.4707V21.2353V13.514C14.9371 12.963 14.2855 12.6586 13.8497 13.0061L3.21332 21.4865ZM16.271 30.1262C16.271 30.7093 16.9893 31.0013 17.4094 30.589L31.8047 16.4627C32.0651 16.2072 32.0651 15.7929 31.8047 15.5373L17.4094 1.41135C16.9893 0.999098 16.271 1.29108 16.271 1.8741V30.1262Z", fill: "currentColor" })
});
P({
  displayName: "AndroidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.9821 1.19753C16.0482 1.09847 16.0214 0.964633 15.9223 0.898593C15.8233 0.832553 15.6894 0.859321 15.6234 0.958381L14.5611 2.55182C13.7879 2.25264 12.9201 2.08392 11.9944 2.08392C11.0687 2.08392 10.2009 2.25264 9.42768 2.55183L8.36538 0.958381C8.29934 0.859321 8.1655 0.832553 8.06644 0.898593C7.96738 0.964633 7.94062 1.09847 8.00666 1.19753L9.02412 2.72372C7.17353 3.58694 5.9585 5.22703 5.95848 7.04194H18.0303C18.0303 5.22703 16.8153 3.58694 14.9647 2.72372L15.9821 1.19753ZM9.40757 4.02405C9.76478 4.02405 10.0543 4.31366 10.0543 4.67075C10.0543 5.02796 9.76478 5.31745 9.40757 5.31745C9.05036 5.31745 8.76087 5.02796 8.76087 4.67075C8.76087 4.31366 9.05036 4.02405 9.40757 4.02405ZM15.2279 4.67075C15.2279 4.31366 14.9384 4.02405 14.5812 4.02405C14.224 4.02405 13.9345 4.31366 13.9345 4.67075C13.9345 5.02796 14.224 5.31745 14.5812 5.31745C14.9384 5.31745 15.2279 5.02796 15.2279 4.67075ZM5.95848 17.3893V7.9043H18.0303V17.3893C18.0303 18.1434 17.4191 18.7545 16.665 18.7545H15.7309V21.9576C15.7309 22.6719 15.1518 23.251 14.4375 23.251C13.7232 23.251 13.1441 22.6719 13.1441 21.9576V18.7545H10.8447V21.8443C10.8447 22.5586 10.2656 23.1377 9.55129 23.1377C8.83696 23.1377 8.25788 22.5586 8.25788 21.8443V18.7545H7.32375C6.56972 18.7545 5.95848 18.1433 5.95848 17.3893ZM5.09621 9.19764C5.09621 8.48331 4.51713 7.90424 3.8028 7.90424C3.08847 7.90424 2.5094 8.48331 2.5094 9.19764V14.7306C2.5094 15.4449 3.08847 16.024 3.8028 16.024C4.51713 16.024 5.09621 15.4449 5.09621 14.7306V9.19764ZM20.186 7.90424C20.9003 7.90424 21.4794 8.48331 21.4794 9.19764V14.7306C21.4794 15.4449 20.9003 16.024 20.186 16.024C19.4716 16.024 18.8926 15.4449 18.8926 14.7306V9.19764C18.8926 8.48331 19.4716 7.90424 20.186 7.90424Z", fill: "currentColor" })
});
P({
  displayName: "AppleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M15.2417 4.36526C14.4565 5.24693 13.2002 5.94234 11.9438 5.84299C11.7868 4.65087 12.4019 3.38424 13.1216 2.60191C13.9069 1.6954 15.281 1.04967 16.3934 1C16.5243 2.24179 16.0139 3.45875 15.2417 4.36526ZM16.3803 6.07894C14.5612 5.97959 13.0039 7.05995 12.1401 7.05995C11.2633 7.05995 9.94151 6.12861 8.50194 6.15344C6.6305 6.17828 4.88994 7.18413 3.93459 8.78605C1.97154 11.9899 3.42419 16.7335 5.32181 19.3413C6.25098 20.6328 7.36337 22.0484 8.82911 21.9987C10.2163 21.9491 10.766 21.1419 12.4411 21.1419C14.1293 21.1419 14.6136 21.9987 16.0793 21.9739C17.5974 21.9491 18.5527 20.6824 19.4819 19.391C20.542 17.9256 20.9738 16.4976 21 16.4231C20.9738 16.3982 18.0685 15.3427 18.0423 12.1637C18.0162 9.50629 20.3326 8.23966 20.4373 8.16515C19.1286 6.32729 17.087 6.12861 16.3803 6.07894Z", fill: "currentColor" })
});
P({
  displayName: "AvengerDAOIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.19999 14.1V9.91944C9.19999 9.2567 9.73728 8.71944 10.4 8.71944H12.0369L12.0273 8.69999H12.5C13.3695 8.69999 14.1605 9.03632 14.75 9.58595C14.96 9.78177 15.294 9.80596 15.4971 9.60294L17.6971 7.4029C17.9203 7.1797 17.9321 6.81908 17.7048 6.6C16.3561 5.29971 14.5214 4.5 12.5 4.5H6.2C5.53726 4.5 5 5.03726 5 5.7V5.71945V18.3V18.3195C5 18.8945 5.40443 19.3749 5.94434 19.4922C5.96789 19.4901 5.99141 19.488 6.0149 19.4858C6.07523 19.4952 6.13705 19.5 6.2 19.5H12.5C14.6207 19.5 16.5358 18.6198 17.9 17.2048C18.1816 16.9128 18.1527 16.4527 17.8658 16.1658L15.8801 14.1801C15.6151 13.9151 15.1696 13.9759 14.914 14.25C14.3116 14.896 13.453 15.3 12.5 15.3H10.4C9.73725 15.3 9.19999 14.7628 9.19999 14.1ZM20.3474 12.7798L19.0746 14.0526C18.606 14.5212 17.8462 14.5212 17.3776 14.0526L16.1048 12.7798C15.6362 12.3112 15.6362 11.5514 16.1048 11.0828L17.3776 9.80999C17.8462 9.34136 18.606 9.34136 19.0746 9.80999L20.3474 11.0828C20.816 11.5514 20.816 12.3112 20.3474 12.7798Z", fill: "currentColor" })
});
P({
  displayName: "BinanceIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M8.11597 10.4041L12 6.52016L15.8859 10.4062L18.1459 8.14608L12 2L5.85595 8.14408L8.11597 10.4041ZM4.26009 9.7398L6.52007 11.9998L4.25997 14.2599L2 11.9999L4.26009 9.7398ZM8.11597 13.5958L12 17.4797L15.8858 13.5939L18.1471 15.8528L18.1459 15.8539L12 22L5.85587 15.8559L5.85271 15.8528L8.11597 13.5958ZM22 12.0002L19.74 14.2602L17.4801 12.0002L19.74 9.7402L22 12.0002Z", fill: "currentColor" }),
    w.createElement("path", { d: "M14.2923 11.9992H14.2933L12 9.70581L10.3051 11.4007H10.305L10.1104 11.5954L9.70863 11.9972L9.70551 12.0003L9.70863 12.0035L12 14.2948L14.2931 12.0015L14.2944 12.0003L14.2923 11.9992Z", fill: "currentColor" })
  )
});
P({
  displayName: "BinanceCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.9998 8.16076L14.7081 10.8711L16.2899 9.28914L11.9998 5L7.70974 9.28914L9.28987 10.8711L11.9998 8.16076ZM5 11.9999L6.58079 10.4189L8.16159 11.9999L6.58079 13.581L5 11.9999ZM15.8384 11.9999L17.4192 10.4189L19 11.9999L17.4192 13.581L15.8384 11.9999ZM11.9998 15.8376L9.28987 13.1289L7.70974 14.7093L11.9998 19L16.2899 14.7093L14.7081 13.1289L11.9998 15.8376ZM10.4195 11.9999L12.0003 10.4189L13.5811 11.9999L12.0003 13.581L10.4195 11.9999Z", fill: "currentColor" })
  )
});
P({
  displayName: "BitqueryIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4.84336V3H6.5H13.6154C15.4103 3 19 4 19 8C19 9.94264 18.2452 11.1305 17.3222 11.8569C18.3849 12.8486 19 14.2442 19 15.7181C19 18.6352 16.6352 21 13.7181 21H10.1111C7.28832 21 5 18.7117 5 15.8889V4.84336ZM16.0656 10.904C16.4171 10.6936 16.7304 10.4191 16.9707 10.0586C17.2574 9.62844 17.5 8.98752 17.5 8C17.5 6.53736 16.8838 5.73955 16.1471 5.24698C15.3298 4.70059 14.2941 4.5 13.6154 4.5H7.1L16.0656 10.904ZM6.5 15.8889V5.91478L15.9163 12.6407C16.9102 13.3506 17.5 14.4968 17.5 15.7181C17.5 17.8068 15.8068 19.5 13.7181 19.5H10.1111C8.11675 19.5 6.5 17.8833 6.5 15.8889Z", fill: "currentColor" })
});
P({
  displayName: "BitqueryColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("rect", { x: "4.81429", y: "3", width: "14.6571", height: "18", fill: "url(#pattern0)" }),
    w.createElement(
      "defs",
      null,
      w.createElement(
        "pattern",
        { id: "pattern0", patternContentUnits: "objectBoundingBox", width: "1", height: "1" },
        w.createElement("use", { xlinkHref: "#image0_316_146", transform: "scale(0.00877193 0.00714286)" })
      ),
      w.createElement("image", { id: "image0_316_146", width: "515", height: "140", xlinkHref: "data:image/png;base64,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" })
    )
  )
});
P({
  displayName: "BlockScoutIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.6425 5.976C15.7635 5.976 15.608 6.2575 14.7015 6.4985C15.0545 5.8185 15.751 5.35 16.5625 5.35C17.332 5.35 17.998 5.771 18.3665 6.393C17.91 6.1505 17.3415 5.976 16.6425 5.976ZM5.602 6.48C5.958 5.8105 6.6485 5.35 7.453 5.35C8.2505 5.35 8.9365 5.803 9.295 6.463C8.497 6.231 8.319 5.976 7.482 5.976C6.701 5.976 6.083 6.1935 5.602 6.48Z", fill: "black" }),
    w.createElement("path", { d: "M16.6425 5.976C15.7635 5.976 15.608 6.2575 14.7015 6.4985C15.0545 5.8185 15.751 5.35 16.5625 5.35C17.332 5.35 17.998 5.771 18.3665 6.393C17.91 6.1505 17.3415 5.976 16.6425 5.976ZM5.602 6.48C5.958 5.8105 6.6485 5.35 7.453 5.35C8.2505 5.35 8.9365 5.803 9.295 6.463C8.497 6.231 8.319 5.976 7.482 5.976C6.701 5.976 6.083 6.1935 5.602 6.48Z", fill: "black" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5145 12.1975C19.924 11.231 18.87 10.5845 17.664 10.5845C15.976 10.5845 14.5835 11.848 14.3505 13.4905L12.0135 13.9805V13.967L9.6625 13.475C9.4225 11.84 8.0305 10.5845 6.3435 10.5845C5.141 10.5845 4.0885 11.2245 3.495 12.184L2.4805 11.9715L4.2165 8.317C4.2165 8.317 5.1185 6.402 7.4475 6.402C8.6555 6.402 8.4855 6.9335 10.8115 7.157C10.8115 8.3675 12.0135 8.4245 12.0135 8.4245V8.4285C12.0135 8.4285 13.215 8.371 13.215 7.1585C15.5415 6.9345 15.371 6.402 16.5795 6.402C18.9085 6.402 19.8105 8.32 19.8105 8.32L21.546 11.9815L20.5145 12.1975ZM12.0235 11.4435C11.553 11.4435 11.172 11.8285 11.172 12.303C11.172 12.7775 11.553 13.1625 12.0235 13.1625C12.4935 13.1625 12.875 12.7775 12.875 12.303C12.875 11.8285 12.4935 11.4435 12.0235 11.4435Z", fill: "black" }),
    w.createElement("path", { d: "M20.5145 12.1975C19.924 11.231 18.87 10.5845 17.664 10.5845C15.976 10.5845 14.5835 11.848 14.3505 13.4905L12.0135 13.9805V13.967L9.6625 13.475C9.4225 11.84 8.0305 10.5845 6.3435 10.5845C5.141 10.5845 4.0885 11.2245 3.495 12.184L2.4805 11.9715L4.2165 8.317C4.2165 8.317 5.1185 6.402 7.4475 6.402C8.6555 6.402 8.4855 6.9335 10.8115 7.157C10.8115 8.3675 12.0135 8.4245 12.0135 8.4245V8.4285C12.0135 8.4285 13.215 8.371 13.215 7.1585C15.5415 6.9345 15.371 6.402 16.5795 6.402C18.9085 6.402 19.8105 8.32 19.8105 8.32L21.546 11.9815L20.5145 12.1975ZM12.0235 11.4435C11.553 11.4435 11.172 11.8285 11.172 12.303C11.172 12.7775 11.553 13.1625 12.0235 13.1625C12.4935 13.1625 12.875 12.7775 12.875 12.303C12.875 11.8285 12.4935 11.4435 12.0235 11.4435Z", fill: "black" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.482 14.412C13.482 14.412 12.7435 14.3045 12.0135 14.3045C11.275 14.3045 10.5445 14.412 10.5445 14.412L9.20951 10.6905C9.20951 10.6905 10.6095 10.4475 12.0135 10.4475C13.413 10.4475 14.817 10.6905 14.817 10.6905L13.482 14.412ZM12.0235 11.4435C11.553 11.4435 11.172 11.8285 11.172 12.303C11.172 12.7775 11.553 13.1625 12.0235 13.1625C12.4935 13.1625 12.875 12.7775 12.875 12.303C12.875 11.8285 12.4935 11.4435 12.0235 11.4435Z", fill: "black" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0155 13.553C11.3425 13.553 10.797 12.997 10.797 12.311C10.797 11.625 11.3425 11.069 12.0155 11.069C12.6885 11.069 13.2345 11.625 13.2345 12.311C13.2345 12.997 12.6885 13.553 12.0155 13.553ZM12.0235 11.4435C11.553 11.4435 11.172 11.8285 11.172 12.303C11.172 12.7775 11.553 13.1625 12.0235 13.1625C12.4935 13.1625 12.875 12.7775 12.875 12.303C12.875 11.8285 12.4935 11.4435 12.0235 11.4435Z", fill: "black" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.6635 7.6155V10.016H14.363V7.6155L13.749 7.7505C13.749 7.7505 13.261 8.991 12.0135 8.991C10.7655 8.991 10.2775 7.7505 10.2775 7.7505L9.6635 7.6155Z", fill: "black" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.664 18.35C15.2695 18.35 13.328 16.3875 13.328 13.967C13.328 11.5465 15.2695 9.5845 17.664 9.5845C20.0585 9.5845 22 11.5465 22 13.967C22 16.3875 20.0585 18.35 17.664 18.35ZM17.664 10.5845C15.813 10.5845 14.3125 12.1025 14.3125 13.975C14.3125 15.8475 15.813 17.3655 17.664 17.3655C19.515 17.3655 21.0155 15.8475 21.0155 13.975C21.0155 12.1025 19.515 10.5845 17.664 10.5845Z", fill: "black" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.664 16.4125C16.331 16.4125 15.25 15.321 15.25 13.975C15.25 13.671 15.312 13.383 15.4125 13.1145C15.53 13.264 15.703 13.3655 15.906 13.3655C16.077 13.3644 16.2405 13.2955 16.3607 13.1739C16.4809 13.0523 16.5479 12.888 16.547 12.717C16.547 12.437 16.369 12.2035 16.123 12.113C16.542 11.759 17.075 11.5375 17.664 11.5375C18.9975 11.5375 20.078 12.629 20.078 13.975C20.078 15.321 18.9975 16.4125 17.664 16.4125ZM17.664 13.522C17.546 13.5219 17.4328 13.5688 17.3493 13.6522C17.2658 13.7356 17.2188 13.8487 17.2188 13.9668C17.2187 14.0848 17.2655 14.198 17.3489 14.2815C17.4323 14.365 17.5455 14.4119 17.6635 14.412C17.7219 14.412 17.7798 14.4006 17.8338 14.3782C17.8878 14.3559 17.9369 14.3231 17.9782 14.2818C18.0196 14.2405 18.0524 14.1915 18.0748 14.1375C18.0972 14.0835 18.1087 14.0257 18.1088 13.9673C18.1088 13.9088 18.0973 13.8509 18.075 13.7969C18.0526 13.7429 18.0199 13.6939 17.9786 13.6525C17.9373 13.6112 17.8883 13.5784 17.8343 13.556C17.7803 13.5336 17.7224 13.522 17.664 13.522Z", fill: "black" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.336 18.35C3.9415 18.35 2 16.3875 2 13.967C2 11.5465 3.9415 9.5845 6.336 9.5845C8.7305 9.5845 10.672 11.5465 10.672 13.967C10.672 16.3875 8.7305 18.35 6.336 18.35ZM6.3435 10.5845C4.4885 10.5845 2.9845 12.1025 2.9845 13.975C2.9845 15.8475 4.4885 17.3655 6.3435 17.3655C8.199 17.3655 9.703 15.8475 9.703 13.975C9.703 12.1025 8.199 10.5845 6.3435 10.5845Z", fill: "black" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.3435 16.4125C5.006 16.4125 3.922 15.321 3.922 13.975C3.922 13.6655 3.985 13.3715 4.0895 13.099C4.2065 13.257 4.384 13.3655 4.5935 13.3655C4.74567 13.3646 4.89261 13.3098 5.00833 13.211C5.12406 13.1122 5.20112 12.9757 5.2259 12.8255C5.25067 12.6754 5.22156 12.5213 5.14371 12.3906C5.06587 12.2598 4.9443 12.1608 4.8005 12.111C5.2205 11.758 5.754 11.5375 6.3435 11.5375C7.6815 11.5375 8.7655 12.629 8.7655 13.975C8.7655 15.321 7.6815 16.4125 6.3435 16.4125ZM6.3435 13.522C6.28554 13.5225 6.22824 13.5343 6.17488 13.557C6.12152 13.5796 6.07314 13.6125 6.03251 13.6538C5.99187 13.6951 5.95979 13.7441 5.93808 13.7978C5.91637 13.8516 5.90547 13.909 5.906 13.967C5.906 14.213 6.102 14.4125 6.3435 14.4125C6.40148 14.412 6.45879 14.4 6.51215 14.3774C6.56552 14.3547 6.61389 14.3217 6.65452 14.2804C6.69515 14.239 6.72723 14.19 6.74893 14.1363C6.77063 14.0825 6.78153 14.025 6.781 13.967C6.78153 13.909 6.77062 13.8516 6.74892 13.7978C6.72721 13.7441 6.69512 13.6951 6.65449 13.6538C6.61386 13.6125 6.56548 13.5796 6.51211 13.557C6.45875 13.5343 6.40145 13.5225 6.3435 13.522Z", fill: "black" })
  )
});
P({
  displayName: "BlockScoutColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.6425 5.976C15.7635 5.976 15.608 6.2575 14.7015 6.4985C15.0545 5.8185 15.751 5.35 16.5625 5.35C17.332 5.35 17.998 5.771 18.3665 6.393C17.91 6.1505 17.3415 5.976 16.6425 5.976ZM5.602 6.48C5.958 5.8105 6.6485 5.35 7.453 5.35C8.2505 5.35 8.9365 5.803 9.295 6.463C8.497 6.231 8.319 5.976 7.482 5.976C6.701 5.976 6.083 6.1935 5.602 6.48Z", fill: "#8957C8" }),
    w.createElement("path", { d: "M16.6425 5.976C15.7635 5.976 15.608 6.2575 14.7015 6.4985C15.0545 5.8185 15.751 5.35 16.5625 5.35C17.332 5.35 17.998 5.771 18.3665 6.393C17.91 6.1505 17.3415 5.976 16.6425 5.976ZM5.602 6.48C5.958 5.8105 6.6485 5.35 7.453 5.35C8.2505 5.35 8.9365 5.803 9.295 6.463C8.497 6.231 8.319 5.976 7.482 5.976C6.701 5.976 6.083 6.1935 5.602 6.48Z", fill: "url(#paint0_linear_332_27)" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5145 12.1975C19.924 11.231 18.87 10.5845 17.664 10.5845C15.976 10.5845 14.5835 11.848 14.3505 13.4905L12.0135 13.9805V13.967L9.6625 13.475C9.4225 11.84 8.0305 10.5845 6.3435 10.5845C5.141 10.5845 4.0885 11.2245 3.495 12.184L2.4805 11.9715L4.2165 8.317C4.2165 8.317 5.1185 6.402 7.4475 6.402C8.6555 6.402 8.4855 6.9335 10.8115 7.157C10.8115 8.3675 12.0135 8.4245 12.0135 8.4245V8.4285C12.0135 8.4285 13.215 8.371 13.215 7.1585C15.5415 6.9345 15.371 6.402 16.5795 6.402C18.9085 6.402 19.8105 8.32 19.8105 8.32L21.546 11.9815L20.5145 12.1975ZM12.0235 11.4435C11.553 11.4435 11.172 11.8285 11.172 12.303C11.172 12.7775 11.553 13.1625 12.0235 13.1625C12.4935 13.1625 12.875 12.7775 12.875 12.303C12.875 11.8285 12.4935 11.4435 12.0235 11.4435Z", fill: "#704AD5" }),
    w.createElement("path", { d: "M20.5145 12.1975C19.924 11.231 18.87 10.5845 17.664 10.5845C15.976 10.5845 14.5835 11.848 14.3505 13.4905L12.0135 13.9805V13.967L9.6625 13.475C9.4225 11.84 8.0305 10.5845 6.3435 10.5845C5.141 10.5845 4.0885 11.2245 3.495 12.184L2.4805 11.9715L4.2165 8.317C4.2165 8.317 5.1185 6.402 7.4475 6.402C8.6555 6.402 8.4855 6.9335 10.8115 7.157C10.8115 8.3675 12.0135 8.4245 12.0135 8.4245V8.4285C12.0135 8.4285 13.215 8.371 13.215 7.1585C15.5415 6.9345 15.371 6.402 16.5795 6.402C18.9085 6.402 19.8105 8.32 19.8105 8.32L21.546 11.9815L20.5145 12.1975ZM12.0235 11.4435C11.553 11.4435 11.172 11.8285 11.172 12.303C11.172 12.7775 11.553 13.1625 12.0235 13.1625C12.4935 13.1625 12.875 12.7775 12.875 12.303C12.875 11.8285 12.4935 11.4435 12.0235 11.4435Z", fill: "url(#paint1_linear_332_27)" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.482 14.412C13.482 14.412 12.7435 14.3045 12.0135 14.3045C11.275 14.3045 10.5445 14.412 10.5445 14.412L9.20951 10.6905C9.20951 10.6905 10.6095 10.4475 12.0135 10.4475C13.413 10.4475 14.817 10.6905 14.817 10.6905L13.482 14.412ZM12.0235 11.4435C11.553 11.4435 11.172 11.8285 11.172 12.303C11.172 12.7775 11.553 13.1625 12.0235 13.1625C12.4935 13.1625 12.875 12.7775 12.875 12.303C12.875 11.8285 12.4935 11.4435 12.0235 11.4435Z", fill: "#A47ED8" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0155 13.553C11.3425 13.553 10.797 12.997 10.797 12.311C10.797 11.625 11.3425 11.069 12.0155 11.069C12.6885 11.069 13.2345 11.625 13.2345 12.311C13.2345 12.997 12.6885 13.553 12.0155 13.553ZM12.0235 11.4435C11.553 11.4435 11.172 11.8285 11.172 12.303C11.172 12.7775 11.553 13.1625 12.0235 13.1625C12.4935 13.1625 12.875 12.7775 12.875 12.303C12.875 11.8285 12.4935 11.4435 12.0235 11.4435Z", fill: "#B89AE3" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.6635 7.6155V10.016H14.363V7.6155L13.749 7.7505C13.749 7.7505 13.261 8.991 12.0135 8.991C10.7655 8.991 10.2775 7.7505 10.2775 7.7505L9.6635 7.6155Z", fill: "#9D74D4" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.664 18.35C15.2695 18.35 13.328 16.3875 13.328 13.967C13.328 11.5465 15.2695 9.5845 17.664 9.5845C20.0585 9.5845 22 11.5465 22 13.967C22 16.3875 20.0585 18.35 17.664 18.35ZM17.664 10.5845C15.813 10.5845 14.3125 12.1025 14.3125 13.975C14.3125 15.8475 15.813 17.3655 17.664 17.3655C19.515 17.3655 21.0155 15.8475 21.0155 13.975C21.0155 12.1025 19.515 10.5845 17.664 10.5845Z", fill: "#8958C8" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.664 16.4125C16.331 16.4125 15.25 15.321 15.25 13.975C15.25 13.671 15.312 13.383 15.4125 13.1145C15.53 13.264 15.703 13.3655 15.906 13.3655C16.077 13.3644 16.2405 13.2955 16.3607 13.1739C16.4809 13.0523 16.5479 12.888 16.547 12.717C16.547 12.437 16.369 12.2035 16.123 12.113C16.542 11.759 17.075 11.5375 17.664 11.5375C18.9975 11.5375 20.078 12.629 20.078 13.975C20.078 15.321 18.9975 16.4125 17.664 16.4125ZM17.664 13.522C17.546 13.5219 17.4328 13.5688 17.3493 13.6522C17.2658 13.7356 17.2188 13.8487 17.2188 13.9668C17.2187 14.0848 17.2655 14.198 17.3489 14.2815C17.4323 14.365 17.5455 14.4119 17.6635 14.412C17.7219 14.412 17.7798 14.4006 17.8338 14.3782C17.8878 14.3559 17.9369 14.3231 17.9782 14.2818C18.0196 14.2405 18.0524 14.1915 18.0748 14.1375C18.0972 14.0835 18.1087 14.0257 18.1088 13.9673C18.1088 13.9088 18.0973 13.8509 18.075 13.7969C18.0526 13.7429 18.0199 13.6939 17.9786 13.6525C17.9373 13.6112 17.8883 13.5784 17.8343 13.556C17.7803 13.5336 17.7224 13.522 17.664 13.522Z", fill: "#80D6A1" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.336 18.35C3.9415 18.35 2 16.3875 2 13.967C2 11.5465 3.9415 9.5845 6.336 9.5845C8.7305 9.5845 10.672 11.5465 10.672 13.967C10.672 16.3875 8.7305 18.35 6.336 18.35ZM6.3435 10.5845C4.4885 10.5845 2.9845 12.1025 2.9845 13.975C2.9845 15.8475 4.4885 17.3655 6.3435 17.3655C8.199 17.3655 9.703 15.8475 9.703 13.975C9.703 12.1025 8.199 10.5845 6.3435 10.5845Z", fill: "#8958C8" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.3435 16.4125C5.006 16.4125 3.922 15.321 3.922 13.975C3.922 13.6655 3.985 13.3715 4.0895 13.099C4.2065 13.257 4.384 13.3655 4.5935 13.3655C4.74567 13.3646 4.89261 13.3098 5.00833 13.211C5.12406 13.1122 5.20112 12.9757 5.2259 12.8255C5.25067 12.6754 5.22156 12.5213 5.14371 12.3906C5.06587 12.2598 4.9443 12.1608 4.8005 12.111C5.2205 11.758 5.754 11.5375 6.3435 11.5375C7.6815 11.5375 8.7655 12.629 8.7655 13.975C8.7655 15.321 7.6815 16.4125 6.3435 16.4125ZM6.3435 13.522C6.28554 13.5225 6.22824 13.5343 6.17488 13.557C6.12152 13.5796 6.07314 13.6125 6.03251 13.6538C5.99187 13.6951 5.95979 13.7441 5.93808 13.7978C5.91637 13.8516 5.90547 13.909 5.906 13.967C5.906 14.213 6.102 14.4125 6.3435 14.4125C6.40148 14.412 6.45879 14.4 6.51215 14.3774C6.56552 14.3547 6.61389 14.3217 6.65452 14.2804C6.69515 14.239 6.72723 14.19 6.74893 14.1363C6.77063 14.0825 6.78153 14.025 6.781 13.967C6.78153 13.909 6.77062 13.8516 6.74892 13.7978C6.72721 13.7441 6.69512 13.6951 6.65449 13.6538C6.61386 13.6125 6.56548 13.5796 6.51211 13.557C6.45875 13.5343 6.40145 13.5225 6.3435 13.522Z", fill: "#80D6A1" }),
    w.createElement(
      "defs",
      null,
      w.createElement(
        "linearGradient",
        { id: "paint0_linear_332_27", x1: "5.602", y1: "5.35", x2: "18.3665", y2: "5.35", gradientUnits: "userSpaceOnUse" },
        w.createElement("stop", { stopColor: "#7E49C2" }),
        w.createElement("stop", { offset: "0.5", stopColor: "#C4AAEA" }),
        w.createElement("stop", { offset: "1", stopColor: "#7E49C2" })
      ),
      w.createElement(
        "linearGradient",
        { id: "paint1_linear_332_27", x1: "2.4805", y1: "6.402", x2: "21.546", y2: "6.402", gradientUnits: "userSpaceOnUse" },
        w.createElement("stop", { stopColor: "#7E49C2" }),
        w.createElement("stop", { offset: "0.5", stopColor: "#C4AAEA" }),
        w.createElement("stop", { offset: "1", stopColor: "#7E49C2" })
      )
    )
  )
});
P({
  displayName: "BNBChainIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M6.47406 4.68961L12 1.5L17.5259 4.68961L15.4943 5.86794L12 3.85666L8.50566 5.86794L6.47406 4.68961ZM17.5259 8.71218L15.4943 7.53385L12 9.54514L8.50566 7.53385L6.47406 8.71218V11.0688L9.9684 13.0801V17.1027L12 18.281L14.0316 17.1027V13.0801L17.5259 11.0688V8.71218ZM17.5259 15.0914V12.7348L15.4943 13.9131V16.2697L17.5259 15.0914ZM18.9684 15.9244L15.4741 17.9356V20.2923L21 17.1027V10.7235L18.9684 11.9018V15.9244ZM16.9368 6.7009L18.9684 7.87922V10.2359L21 9.05755V6.7009L18.9684 5.52257L16.9368 6.7009ZM9.9684 18.7889V21.1456L12 22.3239L14.0316 21.1456V18.7889L12 19.9672L9.9684 18.7889ZM6.47406 15.0914L8.50566 16.2697V13.9131L6.47406 12.7348V15.0914ZM9.9684 6.7009L12 7.87922L14.0316 6.7009L12 5.52257L9.9684 6.7009ZM5.0316 7.87922L7.0632 6.7009L5.0316 5.52257L3 6.7009V9.05755L5.0316 10.2359V7.87922ZM5.0316 11.9018L3 10.7235V17.1027L8.52594 20.2923V17.9356L5.0316 15.9244V11.9018Z", fill: "currentColor" })
});
P({
  displayName: "BNBChainCircleIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 5L8.31604 7.14439L9.67044 7.93659L12 6.58439L14.3296 7.93659L15.684 7.14439L12 5ZM14.3296 9.05658L15.684 9.84878V11.4332L13.3544 12.7854V15.4898L12 16.282L10.6456 15.4898V12.7854L8.31604 11.4332V9.84878L9.67044 9.05658L12 10.4088L14.3296 9.05658ZM15.684 12.5532V14.1376L14.3296 14.9298V13.3454L15.684 12.5532ZM14.316 16.0498L16.6456 14.6976V11.9932L18 11.201V15.4898L14.316 17.6341V16.0498ZM16.6456 9.28878L15.2912 8.49659L16.6456 7.70439L18 8.49659V10.081L16.6456 10.8732V9.28878ZM10.6456 18.2078V16.6234L12 17.4156L13.3544 16.6234V18.2078L12 19L10.6456 18.2078ZM9.67044 14.9298L8.31604 14.1376V12.5532L9.67044 13.3454V14.9298ZM12 9.28878L10.6456 8.49659L12 7.70439L13.3544 8.49659L12 9.28878ZM8.7088 8.49659L7.3544 9.28878V10.8732L6 10.081V8.49659L7.3544 7.70439L8.7088 8.49659ZM6 11.201L7.3544 11.9932V14.6976L9.68396 16.0498V17.6341L6 15.4898V11.201Z", fill: "currentColor" })
});
P({
  displayName: "BNBChainCircleSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 5L8.31604 7.14439L9.67044 7.93659L12 6.58439L14.3296 7.93659L15.684 7.14439L12 5ZM14.3296 9.05658L15.684 9.84878V11.4332L13.3544 12.7854V15.4898L12 16.282L10.6456 15.4898V12.7854L8.31604 11.4332V9.84878L9.67044 9.05658L12 10.4088L14.3296 9.05658ZM15.684 12.5532V14.1376L14.3296 14.9298V13.3454L15.684 12.5532ZM14.316 16.0498L16.6456 14.6976V11.9932L18 11.201V15.4898L14.316 17.6341V16.0498ZM16.6456 9.28878L15.2912 8.49659L16.6456 7.70439L18 8.49659V10.081L16.6456 10.8732V9.28878ZM10.6456 18.2078V16.6234L12 17.4156L13.3544 16.6234V18.2078L12 19L10.6456 18.2078ZM9.67044 14.9298L8.31604 14.1376V12.5532L9.67044 13.3454V14.9298ZM12 9.28878L10.6456 8.49659L12 7.70439L13.3544 8.49659L12 9.28878ZM8.7088 8.49659L7.3544 9.28878V10.8732L6 10.081V8.49659L7.3544 7.70439L8.7088 8.49659ZM6 11.201L7.3544 11.9932V14.6976L9.68396 16.0498V17.6341L6 15.4898V11.201Z", fill: "currentColor" })
});
P({
  displayName: "BNBChainCircleSolidColorDarkIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z", fill: "black" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.9522 4.01593L7.72519 6.47643L9.27925 7.3854L11.9522 5.83388L14.6252 7.3854L16.1792 6.47643L11.9522 4.01593ZM14.6252 8.6705L16.1792 9.57947V11.3974L13.5063 12.9489V16.052L11.9522 16.961L10.3982 16.052V12.9489L7.72519 11.3974V9.57947L9.27925 8.6705L11.9522 10.222L14.6252 8.6705ZM14.6252 13.5915L16.1792 12.6825V14.5005L14.6252 15.4094V13.5915ZM14.6097 16.6945L17.2826 15.143V12.04L18.8367 11.131V16.052L14.6097 18.5125V16.6945ZM17.2826 8.93692L15.7286 8.02795L17.2826 7.11898L18.8367 8.02795V9.84589L17.2826 10.7549V8.93692ZM10.3982 19.1707V17.3528L11.9522 18.2617L13.5063 17.3528V19.1707L11.9522 20.0797L10.3982 19.1707ZM9.27925 15.4094L7.72519 14.5005V12.6825L9.27925 13.5915V15.4094ZM11.9522 8.93692L10.3982 8.02795L11.9522 7.11898L13.5063 8.02795L11.9522 8.93692ZM8.17585 8.02795L6.6218 8.93692V10.7549L5.06775 9.84589V8.02795L6.6218 7.11898L8.17585 8.02795ZM5.06775 11.131L6.6218 12.04V15.143L9.29477 16.6945V18.5125L5.06775 16.052V11.131Z", fill: "#F0B90B" })
  )
});
P({
  displayName: "BNBChainCircleSolidColorDarkInverseIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z", fill: "#F0B90B" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.9522 4.01593L7.72519 6.47643L9.27925 7.3854L11.9522 5.83388L14.6252 7.3854L16.1792 6.47643L11.9522 4.01593ZM14.6252 8.6705L16.1792 9.57947V11.3974L13.5063 12.9489V16.052L11.9522 16.961L10.3982 16.052V12.9489L7.72519 11.3974V9.57947L9.27925 8.6705L11.9522 10.222L14.6252 8.6705ZM14.6252 13.5915L16.1792 12.6825V14.5005L14.6252 15.4094V13.5915ZM14.6097 16.6945L17.2826 15.143V12.04L18.8367 11.131V16.052L14.6097 18.5125V16.6945ZM17.2826 8.93692L15.7286 8.02795L17.2826 7.11898L18.8367 8.02795V9.84589L17.2826 10.7549V8.93692ZM10.3982 19.1707V17.3528L11.9522 18.2617L13.5063 17.3528V19.1707L11.9522 20.0797L10.3982 19.1707ZM9.27925 15.4094L7.72519 14.5005V12.6825L9.27925 13.5915V15.4094ZM11.9522 8.93692L10.3982 8.02795L11.9522 7.11898L13.5063 8.02795L11.9522 8.93692ZM8.17585 8.02795L6.6218 8.93692V10.7549L5.06775 9.84589V8.02795L6.6218 7.11898L8.17585 8.02795ZM5.06775 11.131L6.6218 12.04V15.143L9.29477 16.6945V18.5125L5.06775 16.052V11.131Z", fill: "black" })
  )
});
P({
  displayName: "BNBChainCircleSolidColorLightIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z", fill: "white" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.9522 4.01593L7.72519 6.47643L9.27925 7.3854L11.9522 5.83388L14.6252 7.3854L16.1792 6.47643L11.9522 4.01593ZM14.6252 8.6705L16.1792 9.57947V11.3974L13.5063 12.9489V16.052L11.9522 16.961L10.3982 16.052V12.9489L7.72519 11.3974V9.57947L9.27925 8.6705L11.9522 10.222L14.6252 8.6705ZM14.6252 13.5915L16.1792 12.6825V14.5005L14.6252 15.4094V13.5915ZM14.6097 16.6945L17.2826 15.143V12.04L18.8367 11.131V16.052L14.6097 18.5125V16.6945ZM17.2826 8.93692L15.7286 8.02795L17.2826 7.11898L18.8367 8.02795V9.84589L17.2826 10.7549V8.93692ZM10.3982 19.1707V17.3528L11.9522 18.2617L13.5063 17.3528V19.1707L11.9522 20.0797L10.3982 19.1707ZM9.27925 15.4094L7.72519 14.5005V12.6825L9.27925 13.5915V15.4094ZM11.9522 8.93692L10.3982 8.02795L11.9522 7.11898L13.5063 8.02795L11.9522 8.93692ZM8.17585 8.02795L6.6218 8.93692V10.7549L5.06775 9.84589V8.02795L6.6218 7.11898L8.17585 8.02795ZM5.06775 11.131L6.6218 12.04V15.143L9.29477 16.6945V18.5125L5.06775 16.052V11.131Z", fill: "#F0B90B" })
  )
});
P({
  displayName: "BNBChainCircleSolidColorLightInverseIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z", fill: "#F0B90B" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.9522 4.01593L7.72519 6.47643L9.27925 7.3854L11.9522 5.83388L14.6252 7.3854L16.1792 6.47643L11.9522 4.01593ZM14.6252 8.6705L16.1792 9.57947V11.3974L13.5063 12.9489V16.052L11.9522 16.961L10.3982 16.052V12.9489L7.72519 11.3974V9.57947L9.27925 8.6705L11.9522 10.222L14.6252 8.6705ZM14.6252 13.5915L16.1792 12.6825V14.5005L14.6252 15.4094V13.5915ZM14.6097 16.6945L17.2826 15.143V12.04L18.8367 11.131V16.052L14.6097 18.5125V16.6945ZM17.2826 8.93692L15.7286 8.02795L17.2826 7.11898L18.8367 8.02795V9.84589L17.2826 10.7549V8.93692ZM10.3982 19.1707V17.3528L11.9522 18.2617L13.5063 17.3528V19.1707L11.9522 20.0797L10.3982 19.1707ZM9.27925 15.4094L7.72519 14.5005V12.6825L9.27925 13.5915V15.4094ZM11.9522 8.93692L10.3982 8.02795L11.9522 7.11898L13.5063 8.02795L11.9522 8.93692ZM8.17585 8.02795L6.6218 8.93692V10.7549L5.06775 9.84589V8.02795L6.6218 7.11898L8.17585 8.02795ZM5.06775 11.131L6.6218 12.04V15.143L9.29477 16.6945V18.5125L5.06775 16.052V11.131Z", fill: "white" })
  )
});
P({
  displayName: "BscScanIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C12.2566 3.75 12.5104 3.76171 12.761 3.78463C14.0139 3.89921 15.1858 4.29394 16.2135 4.90563C16.2906 4.95151 16.3668 4.9986 16.4423 5.04689C16.7691 5.25616 17.0803 5.48783 17.3735 5.73976C18.4815 6.69164 19.3342 7.93262 19.814 9.34592C19.0712 10.246 18.0191 11.19 16.75 12.087V8C16.75 7.58579 16.4142 7.25 16 7.25C15.5858 7.25 15.25 7.58579 15.25 8V13C15.25 13.0207 15.2508 13.0412 15.2525 13.0615C14.7556 13.3594 14.2363 13.6473 13.6986 13.9215C13.3873 14.0802 13.0708 14.2338 12.75 14.3815V10C12.75 9.58579 12.4142 9.25 12 9.25C11.5858 9.25 11.25 9.58579 11.25 10V15L11.2502 15.0164C10.4312 15.333 9.59357 15.6081 8.75 15.8314V12C8.75 11.5858 8.41421 11.25 8 11.25C7.58579 11.25 7.25 11.5858 7.25 12V16C7.25 16.0577 7.25652 16.1139 7.26885 16.1678C6.52545 16.308 5.78317 16.4038 5.05061 16.4482C4.48895 15.5728 4.08831 14.5844 3.8904 13.5242C3.81539 13.1226 3.76958 12.7107 3.75503 12.2909C3.75169 12.1944 3.75 12.0974 3.75 12ZM21.3688 9.29206C20.8852 7.61621 19.9642 6.12569 18.7373 4.95234C18.2391 4.47591 17.6905 4.05173 17.1002 3.68872C15.6166 2.77629 13.8699 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 12.7966 2.34554 13.5709 2.52578 14.3121C2.82235 15.5312 3.34825 16.661 4.05491 17.6526L4.28874 17.9807L4.69141 17.9669C7.99611 17.8535 11.4377 16.7579 14.3799 15.2578C17.3142 13.7618 19.8313 11.8227 21.2463 9.95254L21.473 9.65298L21.3688 9.29206ZM8.59651 19.5175C7.91577 19.6818 7.19647 19.8447 6.43559 20.0073C8.01353 21.1059 9.93154 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 11.6829 21.7349 11.3694 21.7053 11.0601C21.2012 11.9909 20.6836 12.822 20.1002 13.5729C19.3659 17.3769 16.0185 20.25 12 20.25C10.7865 20.25 9.63416 19.988 8.59651 19.5175Z", fill: "currentColor" })
});
P({
  displayName: "BscScanColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement(
      "g",
      { clipPath: "url(#clip0_316_276)" },
      w.createElement("path", { d: "M6.15592 11.5216C6.15594 11.41 6.17801 11.2994 6.22086 11.1963C6.26371 11.0932 6.3265 10.9996 6.40563 10.9208C6.48475 10.842 6.57865 10.7797 6.68193 10.7373C6.78521 10.6949 6.89584 10.6734 7.00747 10.6739L8.41926 10.6785C8.64436 10.6785 8.86024 10.768 9.01942 10.9272C9.17859 11.0864 9.26801 11.3024 9.26801 11.5276V16.8683C9.42702 16.8211 9.63051 16.7708 9.85444 16.7181C10.0096 16.6816 10.1478 16.5937 10.2468 16.4687C10.3458 16.3438 10.3997 16.189 10.3997 16.0296V9.40532C10.3997 9.18011 10.4891 8.96414 10.6483 8.80488C10.8074 8.64562 11.0233 8.55613 11.2484 8.55609H12.6645C12.8896 8.55613 13.1055 8.64562 13.2647 8.80488C13.4238 8.96414 13.5133 9.18011 13.5133 9.40532V15.5537C13.5133 15.5537 13.8675 15.4103 14.2124 15.2646C14.3406 15.2103 14.4499 15.1196 14.5268 15.0036C14.6038 14.8876 14.6448 14.7515 14.6449 14.6123V7.28257C14.6449 7.05741 14.7343 6.84147 14.8935 6.68224C15.0526 6.52302 15.2684 6.43354 15.4935 6.4335H16.9081C17.1331 6.43372 17.3487 6.52327 17.5077 6.68248C17.6667 6.84168 17.756 7.05752 17.756 7.28257V13.3184C18.9825 12.4292 20.2253 11.3598 21.2117 10.0739C21.3548 9.88724 21.4495 9.66805 21.4873 9.43589C21.5252 9.20372 21.505 8.9658 21.4285 8.74334C20.972 7.42929 20.2462 6.22506 19.2977 5.20771C18.3492 4.19035 17.1988 3.38228 15.9202 2.8352C14.6416 2.28812 13.2629 2.01408 11.8724 2.03061C10.4818 2.04715 9.11002 2.35389 7.84478 2.93122C6.57953 3.50855 5.44869 4.34375 4.52463 5.38337C3.60056 6.42299 2.90362 7.64414 2.47839 8.96867C2.05316 10.2932 1.90902 11.692 2.05519 13.0754C2.20136 14.4589 2.63461 15.7966 3.32723 17.0029C3.4479 17.211 3.62544 17.3804 3.83897 17.491C4.05251 17.6017 4.29319 17.6491 4.53272 17.6276C4.80031 17.6041 5.13349 17.5708 5.52961 17.5243C5.70201 17.5047 5.86117 17.4223 5.97679 17.2929C6.0924 17.1634 6.15639 16.996 6.15658 16.8224V11.5216", fill: "#12161C" }),
      w.createElement("path", { d: "M6.12579 20.0873C7.61687 21.1725 9.37896 21.8238 11.2171 21.9693C13.0553 22.1148 14.8978 21.7488 16.5409 20.9117C18.1841 20.0746 19.5637 18.7991 20.5271 17.2264C21.4906 15.6536 22.0003 13.8449 22 12.0003C22 11.7695 21.9893 11.5424 21.974 11.3159C18.3221 16.7646 11.5792 19.3118 6.12579 20.0873Z", fill: "#F0B90B" })
    ),
    w.createElement(
      "defs",
      null,
      w.createElement(
        "clipPath",
        { id: "clip0_316_276" },
        w.createElement("rect", { width: "20", height: "20", fill: "white", transform: "translate(2 2)" })
      )
    )
  )
});
P({
  displayName: "BscTraceIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0575 1.96676C11.2178 1.29689 12.6473 1.29689 13.8075 1.96676L19.0298 4.98183C20.19 5.6517 20.9048 6.88968 20.9048 8.22943V14.2596C20.9048 15.5993 20.19 16.8373 19.0298 17.5072L16.1479 19.171L16.3991 20.1758C16.4358 20.3228 16.5938 20.4035 16.7344 20.3473L17.4966 20.0424C17.8812 19.8886 18.3176 20.0757 18.4715 20.4602C18.6253 20.8448 18.4382 21.2813 18.0537 21.4351L17.2915 21.74C16.3069 22.1338 15.201 21.5684 14.9438 20.5396L14.7967 19.9511L13.8075 20.5222C12.6473 21.1921 11.2178 21.1921 10.0575 20.5222L8.44061 19.5887L7.97673 20.4928C7.9106 20.6217 7.96753 20.7797 8.10069 20.8367L9.67181 21.5101C10.0525 21.6732 10.2289 22.1142 10.0657 22.4949C9.90257 22.8756 9.46166 23.052 9.08093 22.8888L7.50981 22.2155C6.57769 21.816 6.17921 20.7104 6.64214 19.8081L7.13998 18.8378L4.83527 17.5072C3.67501 16.8373 2.96027 15.5993 2.96027 14.2596V8.22943C2.96027 6.88968 3.67501 5.6517 4.83527 4.98183L10.0575 1.96676ZM10.8075 19.2232L9.12619 18.2525L9.74959 17.0374C9.93868 16.6689 9.7932 16.2169 9.42467 16.0278C9.05613 15.8387 8.60409 15.9842 8.415 16.3527L7.82556 17.5016L5.58527 16.2081C4.88911 15.8062 4.46027 15.0634 4.46027 14.2596V8.22943C4.46027 7.42558 4.88911 6.68279 5.58527 6.28087L10.8075 3.2658C11.5037 2.86387 12.3614 2.86387 13.0575 3.2658L18.2798 6.28087C18.3054 6.29568 18.3307 6.31095 18.3556 6.32667C17.9637 6.3208 17.5601 6.41921 17.1817 6.64289L13.0017 9.11349C11.8601 9.78823 11.1598 11.0157 11.1598 12.3418V17.8462C11.1598 18.5392 11.4576 19.1243 11.9092 19.5245C11.5285 19.5206 11.1486 19.4201 10.8075 19.2232ZM17.3525 12.6224C17.8572 12.6224 18.2713 12.0465 18.2713 11.3347C18.2713 10.6229 17.8572 10.047 17.3525 10.047C16.8477 10.047 16.4336 10.6229 16.4336 11.3347C16.4336 12.0465 16.8477 12.6224 17.3525 12.6224ZM14.8644 14.091C15.3691 14.091 15.7832 13.5151 15.7832 12.8033C15.7832 12.0915 15.3691 11.5156 14.8644 11.5156C14.3596 11.5156 13.9455 12.0915 13.9455 12.8033C13.9455 13.5151 14.3596 14.091 14.8644 14.091ZM17.9449 7.9342C18.4448 7.63869 19.0765 7.99909 19.0765 8.57985V13.7575C19.0765 14.5087 18.7016 15.2104 18.077 15.6279L13.8266 18.4696C13.3283 18.8028 12.6598 18.4456 12.6598 17.8462V12.3418C12.6598 11.5461 13.08 10.8096 13.7649 10.4048L17.9449 7.9342Z", fill: "currentColor" })
});
P({
  displayName: "BscTraceColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M15.5895 16.1296L13.7873 16.6116C13.6785 16.6407 13.6139 16.7521 13.643 16.8608L14.4621 19.9117C14.6761 20.7092 15.4966 21.1821 16.2946 20.9686L17.8833 20.5438C18.4518 20.3917 18.7891 19.8079 18.6366 19.2398C18.4841 18.6716 17.8995 18.3343 17.3309 18.4864L17.019 18.5698C16.7288 18.6474 16.4306 18.4758 16.3528 18.1858L15.8394 16.2737C15.8102 16.1649 15.6984 16.1005 15.5895 16.1296Z", fill: "#773E15" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.1835 16.9835C13.0859 16.62 13.3024 16.2486 13.6642 16.1519L15.4664 15.6699C15.8288 15.573 16.202 15.7876 16.2994 16.1504L16.8128 18.0626C16.8223 18.0982 16.859 18.12 16.8959 18.1101L17.2078 18.0267C18.0303 17.8068 18.876 18.2947 19.0966 19.1165C19.3172 19.9384 18.8293 20.783 18.0068 21.0029L16.4181 21.4278C15.3663 21.7091 14.2848 21.0858 14.0025 20.0344L13.1835 16.9835ZM14.1736 17.0004L14.9221 19.7885C15.068 20.332 15.6272 20.6546 16.1715 20.509L17.7601 20.0841C18.0748 20 18.2614 19.6769 18.177 19.3625C18.0927 19.048 17.7691 18.8614 17.4545 18.9455L17.1426 19.0289C16.5991 19.1743 16.0393 18.8529 15.8932 18.3085L15.4504 16.659L14.1736 17.0004Z", fill: "#2D1504" }),
    w.createElement("path", { d: "M5.07206 5.95346L11.1226 2.53226C11.5589 2.28554 12.0929 2.28554 12.5293 2.53226L18.5798 5.95346C19.0274 6.20657 19.3041 6.68063 19.3041 7.1944V14.1271C19.3041 14.6374 19.031 15.1089 18.588 15.3633L12.5484 18.8317C12.102 19.088 11.552 19.0844 11.109 18.8222L5.04752 15.2341C4.61373 14.9774 4.34772 14.511 4.34772 14.0074V7.1944C4.34772 6.68063 4.62444 6.20657 5.07206 5.95346Z", fill: "#F0940B" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.4715 3.0796C12.1789 2.91427 11.8209 2.91427 11.5284 3.07961L5.44294 6.51856C5.14279 6.68817 4.95725 7.00585 4.95725 7.35017V14.1985C4.95725 14.536 5.13562 14.8485 5.42648 15.0206L11.5229 18.6272C11.8199 18.803 12.1887 18.8054 12.488 18.6336L18.5625 15.1472C18.8595 14.9767 19.0426 14.6608 19.0426 14.3187V7.35017C19.0426 7.00585 18.8571 6.68817 18.5569 6.51856L12.4715 3.0796ZM11.0568 2.24801C11.6419 1.91733 12.358 1.91733 12.9431 2.248L19.0285 5.68696C19.6288 6.02618 19.9998 6.66155 19.9998 7.35017V14.3187C19.9998 15.0028 19.6337 15.6347 19.0396 15.9757L12.9652 19.462C12.3665 19.8056 11.6289 19.8007 11.0349 19.4493L4.93844 15.8427C4.35672 15.4985 4 14.8736 4 14.1985V7.35017C4 6.66155 4.37107 6.02619 4.97136 5.68696L11.0568 2.24801Z", fill: "#F0940B" }),
    w.createElement("path", { d: "M11.3042 17.2479V11.2865C11.3042 10.6079 11.6589 9.98082 12.2344 9.64178L17.2134 6.70845C18.1429 6.16087 19.3042 6.84607 19.3042 7.94204V14.1669C19.3042 14.6751 19.039 15.1448 18.6084 15.3994L13.3968 18.4804C12.4673 19.0299 11.3042 18.3449 11.3042 17.2479Z", fill: "#FFCD1B" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.0681 6.42722C18.3715 5.69204 20 6.61199 20 8.08348V14.3516C20 15.034 19.6282 15.6646 19.0243 16.0065L13.5432 19.109C12.2398 19.8467 10.6088 18.927 10.6088 17.4542V11.4513C10.6088 10.597 11.075 9.80777 11.8316 9.38096L17.0681 6.42722ZM19.0225 8.08348C19.0225 7.34773 18.2082 6.88776 17.5566 7.25534L12.32 10.2091C11.866 10.4652 11.5863 10.9388 11.5863 11.4513V17.4542C11.5863 18.1905 12.4018 18.6505 13.0535 18.2816L18.5346 15.1791C18.8365 15.0081 19.0225 14.6928 19.0225 14.3516V8.08348Z", fill: "#F0940B" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.4715 3.0796C12.1789 2.91427 11.8209 2.91427 11.5284 3.07961L5.44294 6.51856C5.14279 6.68817 4.95725 7.00585 4.95725 7.35017V14.1985C4.95725 14.536 5.13562 14.8485 5.42648 15.0206L11.5229 18.6272C11.8199 18.8029 12.1887 18.8054 12.488 18.6336L18.5625 15.1472C18.8595 14.9767 19.0426 14.6608 19.0426 14.3187V7.35017C19.0426 7.00585 18.8571 6.68817 18.5569 6.51856L12.4715 3.0796ZM11.0568 2.24801C11.6419 1.91733 12.358 1.91733 12.9431 2.248L19.0285 5.68696C19.6288 6.02618 19.9998 6.66155 19.9998 7.35017V14.3187C19.9998 15.0028 19.6337 15.6347 19.0396 15.9757L12.9652 19.462C12.3665 19.8056 11.6289 19.8007 11.0349 19.4493L4.93844 15.8427C4.35672 15.4985 4 14.8736 4 14.1985V7.35017C4 6.66155 4.37107 6.02619 4.97136 5.68696L11.0568 2.24801Z", fill: "#2D1504" }),
    w.createElement("path", { d: "M15.1644 12.573C15.1644 13.3163 14.7335 13.9187 14.202 13.9187C13.6704 13.9187 13.2395 13.3163 13.2395 12.573C13.2395 11.8299 13.6704 11.2273 14.202 11.2273C14.7335 11.2273 15.1644 11.8299 15.1644 12.573Z", fill: "white" }),
    w.createElement("path", { d: "M17.859 11.0351C17.859 11.7783 17.428 12.3808 16.8965 12.3808C16.365 12.3808 15.9341 11.7783 15.9341 11.0351C15.9341 10.2919 16.365 9.68946 16.8965 9.68946C17.428 9.68946 17.859 10.2919 17.859 11.0351Z", fill: "white" }),
    w.createElement("path", { d: "M10.1853 15.8365L8.49114 15.0564C8.38883 15.0093 8.26778 15.0537 8.22065 15.1559C7.87829 15.8989 7.04479 17.7136 6.44667 19.015C6.10182 19.7653 6.43016 20.6529 7.18039 20.9984L8.67382 21.686C9.20831 21.9321 9.84161 21.6986 10.0883 21.1645C10.335 20.6304 10.1017 19.9978 9.56719 19.7518L9.27247 19.6161C9.00023 19.4907 8.88061 19.1698 9.00543 18.8974C9.35453 18.1355 10.014 16.6967 10.2858 16.1058C10.3328 16.0035 10.2876 15.8835 10.1853 15.8365Z", fill: "#773E15" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.78833 14.9573C7.94603 14.615 8.35072 14.4679 8.69071 14.6244L10.385 15.4045C10.7225 15.5599 10.8766 15.9602 10.7184 16.304C10.4468 16.8946 9.78752 18.333 9.43836 19.095C9.42315 19.1281 9.43711 19.1681 9.47204 19.1841L9.76676 19.3198C10.54 19.6758 10.8775 20.5908 10.5206 21.3634C10.1638 22.1361 9.24766 22.4738 8.47442 22.1178L6.98097 21.4302C5.99229 20.975 5.55972 19.8054 6.01413 18.8167C6.16894 18.4799 6.33954 18.1086 6.51332 17.7304C7.01085 16.6477 7.53449 15.5081 7.78833 14.9573ZM8.5391 15.6021C8.26164 16.2049 7.81054 17.1866 7.37886 18.1261C7.20499 18.5045 7.03428 18.8759 6.87933 19.2131C6.64405 19.7251 6.86814 20.3308 7.37994 20.5664L8.87339 21.254C9.16919 21.3902 9.51964 21.261 9.6562 20.9654C9.79271 20.6698 9.66357 20.3198 9.36777 20.1836L9.07306 20.048C8.56354 19.8133 8.33824 19.2112 8.5727 18.6996C8.87976 18.0295 9.4272 16.8351 9.73961 16.1549L8.5391 15.6021Z", fill: "#2D1504" })
  )
});
P({
  displayName: "ChainListIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("rect", { width: "24", height: "24", fill: "none" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V5ZM10.25 7C10.25 6.58579 10.5858 6.25 11 6.25L16 6.25C16.4142 6.25 16.75 6.58579 16.75 7C16.75 7.41421 16.4142 7.75 16 7.75L11 7.75C10.5858 7.75 10.25 7.41421 10.25 7ZM11 10.25C10.5858 10.25 10.25 10.5858 10.25 11C10.25 11.4142 10.5858 11.75 11 11.75H16C16.4142 11.75 16.75 11.4142 16.75 11C16.75 10.5858 16.4142 10.25 16 10.25L11 10.25ZM10.25 15C10.25 14.5858 10.5858 14.25 11 14.25H16C16.4142 14.25 16.75 14.5858 16.75 15C16.75 15.4142 16.4142 15.75 16 15.75H11C10.5858 15.75 10.25 15.4142 10.25 15ZM8 8C8.55228 8 9 7.55228 9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7C7 7.55228 7.44772 8 8 8ZM9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11ZM8 16C8.55228 16 9 15.5523 9 15C9 14.4477 8.55228 14 8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16Z", fill: "currentColor" })
  )
});
P({
  displayName: "CoinMarketCapIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.6516 13.9025C18.333 14.1039 17.9578 14.1288 17.6726 13.968C17.3104 13.7634 17.1112 13.2844 17.1112 12.6182V10.625C17.1112 9.66247 16.7306 8.97756 16.0943 8.79264C15.0159 8.47848 14.2049 9.79793 13.9001 10.2935L11.9982 13.3771V9.6081C11.9768 8.74094 11.6952 8.22225 11.1605 8.06584C10.8067 7.96246 10.2773 8.0039 9.76304 8.79085L5.50211 15.6328C4.93167 14.5498 4.6343 13.344 4.63584 12.12C4.63584 7.99856 7.93871 4.64578 11.9982 4.64578C16.0577 4.64578 19.3602 7.99856 19.3602 12.12C19.3602 12.1271 19.362 12.1334 19.3624 12.1401C19.3624 12.1472 19.3611 12.1534 19.3615 12.1606C19.3998 12.9587 19.1414 13.5932 18.6516 13.9025ZM20.996 12.1205V12.0995L20.9956 12.079C20.9728 7.05965 16.9458 2.98499 11.9978 2.98499C7.03679 2.98499 3 7.08283 3 12.12C3 17.1568 7.03679 21.255 11.9982 21.255C14.2749 21.255 16.4477 20.3897 18.1156 18.8189C18.4471 18.507 18.4667 17.9816 18.1592 17.6456C18.0869 17.5658 17.9993 17.5012 17.9017 17.4557C17.804 17.4102 17.6983 17.3846 17.5907 17.3804C17.483 17.3763 17.3756 17.3936 17.2748 17.4315C17.1739 17.4694 17.0816 17.527 17.0033 17.601C15.6514 18.8813 13.8601 19.5946 11.9982 19.5942C9.82454 19.5942 7.86875 18.6322 6.51988 17.1064L10.3624 10.9365V13.7808C10.3624 15.147 10.8922 15.5887 11.3365 15.7179C11.7812 15.8471 12.4608 15.7589 13.1742 14.6003L15.2877 11.174C15.3555 11.0635 15.4178 10.9681 15.4749 10.8857V12.6182C15.4749 13.8953 15.9864 14.9167 16.8781 15.4198C17.682 15.8734 18.6926 15.8324 19.5161 15.3128C20.5143 14.6823 21.0522 13.5206 20.996 12.1205Z", fill: "currentColor" })
});
P({
  displayName: "DAppIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.455 3.70711C16.8455 3.31658 17.4787 3.31658 17.8692 3.70711L21.2929 7.13077C21.6834 7.52129 21.6834 8.15446 21.2929 8.54498L17.8692 11.9686C17.4787 12.3592 16.8455 12.3592 16.455 11.9686L13.0313 8.54498C12.6408 8.15446 12.6408 7.52129 13.0313 7.13077L16.455 3.70711ZM14.2334 7.83787L17.1621 4.90919L20.0908 7.83787L17.1621 10.7666L14.2334 7.83787Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 5.18916C4 4.63688 4.44772 4.18916 5 4.18916H10.135C10.6873 4.18916 11.135 4.63688 11.135 5.18916V10.3241C11.135 10.8764 10.6873 11.3241 10.135 11.3241H5C4.44772 11.3241 4 10.8764 4 10.3241V5.18916ZM5.35 9.97413V5.53916H9.78497V9.97413H5.35Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 14.7025C4 14.1502 4.44772 13.7025 5 13.7025H10.135C10.6873 13.7025 11.135 14.1502 11.135 14.7025V19.8374C11.135 20.3897 10.6873 20.8374 10.135 20.8374H5C4.44772 20.8374 4 20.3897 4 19.8374V14.7025ZM5.35 19.4874V15.0525H9.78497V19.4874H5.35Z", fill: "currentColor" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.6759 13.865C14.1236 13.865 13.6759 14.3127 13.6759 14.865V20C13.6759 20.5523 14.1236 21 14.6759 21H19.8109C20.3632 21 20.8109 20.5523 20.8109 20V14.865C20.8109 14.3127 20.3632 13.865 19.8109 13.865H14.6759ZM15.0259 15.215V19.65H19.4609V15.215H15.0259Z", fill: "currentColor" })
  )
});
P({
  displayName: "DAppColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("rect", { x: "5", y: "5", width: "6", height: "6", rx: "1", fill: "#F0B90B" }),
    w.createElement("rect", { x: "5", y: "13", width: "6", height: "6", rx: "1", fill: "#F0B90B" }),
    w.createElement("rect", { x: "13.1367", y: "13.1367", width: "6", height: "6", rx: "1", fill: "#F0B90B" }),
    w.createElement("rect", { x: "16.0684", y: "4", width: "5.75346", height: "5.75346", rx: "1", transform: "rotate(45 16.0684 4)", fill: "#F8D12F" })
  )
});
P({
  displayName: "DAppIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("rect", { x: "5", y: "5", width: "6", height: "6", rx: "1", fill: "currentColor" }),
    w.createElement("rect", { x: "5", y: "13", width: "6", height: "6", rx: "1", fill: "currentColor" }),
    w.createElement("rect", { x: "13.1367", y: "13.1367", width: "6", height: "6", rx: "1", fill: "currentColor" }),
    w.createElement("rect", { x: "16.0684", y: "4", width: "5.75346", height: "5.75346", rx: "1", transform: "rotate(45 16.0684 4)", fill: "currentColor" })
  )
});
P({
  displayName: "DCellarIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.9286 3.5H6.5V6.5H3.5V4.92869C3.5 4.13962 4.13968 3.5 4.9286 3.5ZM4.9286 2H6.5H8V3.5V6.5V8H6.5H3.5H2V6.5V4.92869C2 3.31122 3.31123 2 4.9286 2ZM10.283 4.25H9.53302V5V9.48459L4.99823 9.49528L4.25 9.49705V10.2453V15.717V18.3818C4.25 20.242 5.75799 21.75 7.61818 21.75H10.283H15.717H16C19.1756 21.75 21.75 19.1756 21.75 16V15.717V10.2075V10C21.75 6.82436 19.1756 4.25 16 4.25H15.717H10.283ZM5.75 10.9935L9.53302 10.9846V14.967H5.75V10.9935ZM11.033 10.9811V14.967H14.967V10.9718L13.0018 10.9764L11.033 10.9811ZM5.75 16.467H9.53302V20.25H7.61818C6.58641 20.25 5.75 19.4136 5.75 18.3818V16.467ZM11.033 16.467V20.25H14.967V16.467H11.033ZM20.2246 16.467C20.0089 18.4411 18.4411 20.0089 16.467 20.2246V16.467H20.2246ZM20.25 14.967H16.467V10.9682L20.25 10.9593V14.967ZM20.2159 9.45939L16.467 9.46824V5.77536C18.4165 5.98843 19.9697 7.52 20.2159 9.45939ZM11.033 5.75H14.967V9.47177L12.9982 9.47642L11.033 9.48105V5.75Z", fill: "currentColor" })
});
P({
  displayName: "DexIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.52055 14.4794C8.77213 11.3047 11.3047 8.77213 14.4794 8.52055C14.2365 5.70749 11.876 3.5 9 3.5C5.96243 3.5 3.5 5.96243 3.5 9C3.5 11.876 5.70749 14.2365 8.52055 14.4794ZM15 20.5C18.0376 20.5 20.5 18.0376 20.5 15C20.5 11.9624 18.0376 9.5 15 9.5C11.9624 9.5 9.5 11.9624 9.5 15C9.5 18.0376 11.9624 20.5 15 20.5Z", fill: "currentColor" }),
    w.createElement("path", { d: "M11.5536 12.9678C11.7214 12.6836 11.9274 12.4157 12.1716 12.1716C13.7337 10.6095 16.2663 10.6095 17.8284 12.1716C19.3905 13.7337 19.3905 16.2663 17.8284 17.8284C16.2663 19.3905 13.7337 19.3905 12.1716 17.8284C11.9274 17.5843 11.7214 17.3164 11.5536 17.0322", stroke: "white", strokeLinecap: "round" })
  )
});
P({
  displayName: "DexColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.4794 8.52055C11.3047 8.77213 8.77213 11.3047 8.52055 14.4794C5.70749 14.2365 3.5 11.876 3.5 9C3.5 5.96243 5.96243 3.5 9 3.5C11.876 3.5 14.2365 5.70749 14.4794 8.52055Z", fill: "#F0B90B" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 20.5C18.0376 20.5 20.5 18.0376 20.5 15C20.5 11.9624 18.0376 9.5 15 9.5C11.9624 9.5 9.5 11.9624 9.5 15C9.5 18.0376 11.9624 20.5 15 20.5ZM11.9841 13.2221C12.1307 12.9738 12.3109 12.7393 12.5251 12.5251C13.892 11.1583 16.108 11.1583 17.4749 12.5251C18.8417 13.892 18.8417 16.108 17.4749 17.4749C16.108 18.8417 13.892 18.8417 12.5251 17.4749C12.3109 17.2607 12.1307 17.0262 11.9841 16.7779C11.8437 16.5402 11.5371 16.4613 11.2993 16.6017C11.0615 16.7421 10.9826 17.0487 11.1231 17.2865C11.3121 17.6066 11.5439 17.9078 11.818 18.182C13.5754 19.9393 16.4246 19.9393 18.182 18.182C19.9393 16.4246 19.9393 13.5754 18.182 11.818C16.4246 10.0607 13.5754 10.0607 11.818 11.818C11.5439 12.0922 11.3121 12.3934 11.1231 12.7135C10.9826 12.9513 11.0615 13.2579 11.2993 13.3983C11.5371 13.5387 11.8437 13.4598 11.9841 13.2221Z", fill: "#F8D12F" })
  )
});
P({
  displayName: "DiscordIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M18.2379 6.26906C17.0906 5.73109 15.8603 5.33473 14.574 5.10772C14.5506 5.10334 14.5272 5.11429 14.5151 5.13618C14.3569 5.42378 14.1817 5.79897 14.0589 6.09386C12.6754 5.88219 11.299 5.88219 9.94385 6.09386C9.82109 5.79241 9.63947 5.42378 9.48054 5.13618C9.46847 5.11502 9.44507 5.10407 9.42164 5.10772C8.13604 5.334 6.90578 5.73036 5.75781 6.26906C5.74787 6.27344 5.73935 6.28075 5.7337 6.29023C3.40015 9.85309 2.76089 13.3284 3.07449 16.7606C3.07591 16.7774 3.08513 16.7934 3.09791 16.8036C4.63751 17.9591 6.12889 18.6606 7.59256 19.1256C7.61599 19.1329 7.64081 19.1241 7.65572 19.1044C8.00195 18.6212 8.31059 18.1117 8.57521 17.5759C8.59083 17.5445 8.57592 17.5073 8.544 17.4949C8.05445 17.3051 7.58831 17.0737 7.1399 16.811C7.10444 16.7898 7.1016 16.7379 7.13422 16.7131C7.22858 16.6409 7.32297 16.5657 7.41307 16.4898C7.42937 16.4759 7.45209 16.473 7.47125 16.4817C10.4171 17.8562 13.6063 17.8562 16.5173 16.4817C16.5365 16.4722 16.5592 16.4752 16.5762 16.489C16.6663 16.5649 16.7607 16.6409 16.8558 16.7131C16.8884 16.7379 16.8863 16.7898 16.8508 16.811C16.4024 17.0788 15.9362 17.3051 15.446 17.4942C15.4141 17.5066 15.3999 17.5445 15.4155 17.5759C15.6858 18.111 15.9944 18.6205 16.3343 19.1037C16.3485 19.1241 16.374 19.1329 16.3974 19.1256C17.8682 18.6606 19.3596 17.9591 20.8992 16.8036C20.9127 16.7934 20.9212 16.7781 20.9226 16.7613C21.2979 12.7933 20.294 9.34652 18.2613 6.29095C18.2563 6.28075 18.2478 6.27344 18.2379 6.26906ZM9.01512 14.6707C8.12823 14.6707 7.39745 13.8386 7.39745 12.8167C7.39745 11.7947 8.11406 10.9626 9.01512 10.9626C9.92326 10.9626 10.647 11.8021 10.6328 12.8167C10.6328 13.8386 9.91616 14.6707 9.01512 14.6707ZM14.9962 14.6707C14.1093 14.6707 13.3785 13.8386 13.3785 12.8167C13.3785 11.7947 14.0951 10.9626 14.9962 10.9626C15.9043 10.9626 16.628 11.8021 16.6138 12.8167C16.6138 13.8386 15.9043 14.6707 14.9962 14.6707Z", fill: "currentColor" })
});
P({
  displayName: "DiscordColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M18.2379 6.26906C17.0906 5.73109 15.8603 5.33473 14.574 5.10772C14.5506 5.10334 14.5272 5.11429 14.5151 5.13618C14.3569 5.42378 14.1817 5.79897 14.0589 6.09386C12.6754 5.88219 11.299 5.88219 9.94385 6.09386C9.82109 5.79241 9.63947 5.42378 9.48054 5.13618C9.46847 5.11502 9.44507 5.10407 9.42164 5.10772C8.13604 5.334 6.90578 5.73036 5.75781 6.26906C5.74787 6.27344 5.73935 6.28075 5.7337 6.29023C3.40015 9.85309 2.76089 13.3284 3.07449 16.7606C3.07591 16.7774 3.08513 16.7934 3.09791 16.8036C4.63751 17.9591 6.12889 18.6606 7.59256 19.1256C7.61599 19.1329 7.64081 19.1241 7.65572 19.1044C8.00195 18.6212 8.31059 18.1117 8.57521 17.5759C8.59083 17.5445 8.57592 17.5073 8.544 17.4949C8.05445 17.3051 7.58831 17.0737 7.1399 16.811C7.10444 16.7898 7.1016 16.7379 7.13422 16.7131C7.22858 16.6409 7.32297 16.5657 7.41307 16.4898C7.42937 16.4759 7.45209 16.473 7.47125 16.4817C10.4171 17.8562 13.6063 17.8562 16.5173 16.4817C16.5365 16.4722 16.5592 16.4752 16.5762 16.489C16.6663 16.5649 16.7607 16.6409 16.8558 16.7131C16.8884 16.7379 16.8863 16.7898 16.8508 16.811C16.4024 17.0788 15.9362 17.3051 15.446 17.4942C15.4141 17.5066 15.3999 17.5445 15.4155 17.5759C15.6858 18.111 15.9944 18.6205 16.3343 19.1037C16.3485 19.1241 16.374 19.1329 16.3974 19.1256C17.8682 18.6606 19.3596 17.9591 20.8992 16.8036C20.9127 16.7934 20.9212 16.7781 20.9226 16.7613C21.2979 12.7933 20.294 9.34652 18.2613 6.29095C18.2563 6.28075 18.2478 6.27344 18.2379 6.26906ZM9.01512 14.6707C8.12823 14.6707 7.39745 13.8386 7.39745 12.8167C7.39745 11.7947 8.11406 10.9626 9.01512 10.9626C9.92326 10.9626 10.647 11.8021 10.6328 12.8167C10.6328 13.8386 9.91616 14.6707 9.01512 14.6707ZM14.9962 14.6707C14.1093 14.6707 13.3785 13.8386 13.3785 12.8167C13.3785 11.7947 14.0951 10.9626 14.9962 10.9626C15.9043 10.9626 16.628 11.8021 16.6138 12.8167C16.6138 13.8386 15.9043 14.6707 14.9962 14.6707Z", fill: "#4B47FF" })
});
P({
  displayName: "FacebookIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M16.6971 8.66102H13.2514V7.51905C13.2514 5.81045 13.9178 5.15499 15.647 5.15499C16.1825 5.15499 16.6169 5.16762 16.8658 5.19302V2.26221C16.3934 2.13104 15.2421 2 14.5757 2C11.054 2 9.43033 3.66626 9.43033 7.2653V8.65672H7.25415V11.8879H9.43033V22H13.2556V11.8921H16.1067L16.6971 8.66102Z", fill: "currentColor" })
});
P({
  displayName: "GitHubIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.9629 3.78869C17.5944 3.8683 16.9356 4.10643 15.9525 4.79682C15.7663 4.92762 15.5307 4.96678 15.3122 4.90327C14.5106 4.67032 13.6537 4.55254 12.7934 4.55254C11.9331 4.55254 11.0762 4.67032 10.2745 4.90327C10.0571 4.96644 9.82285 4.92804 9.637 4.79877C8.65331 4.11457 7.99274 3.87499 7.62129 3.79342C7.61604 3.79227 7.61085 3.79115 7.60572 3.79006C7.33559 4.84751 7.59429 5.58866 7.65459 5.74443C7.75567 6.0055 7.70292 6.30112 7.51781 6.51114C6.94087 7.16567 6.58666 8.0048 6.58666 9.04528C6.58666 11.0459 7.16819 12.1356 7.90154 12.7749C8.66641 13.4416 9.72225 13.7318 10.8883 13.8672C11.1812 13.9012 11.4271 14.1037 11.5165 14.3847C11.606 14.6657 11.5224 14.973 11.3031 15.1701C11.144 15.313 10.9262 15.6312 10.8499 16.2171C10.8169 16.4704 10.6572 16.6895 10.4261 16.7985C10.3263 16.8456 10.2034 16.8982 10.0618 16.9487C10.2314 16.951 10.3969 17.0108 10.5298 17.1209C10.702 17.2634 10.8016 17.4752 10.8016 17.6986C10.8016 18.1674 10.805 18.6228 10.8084 18.9954C10.8094 19.1059 10.8104 19.2099 10.8114 19.3051C10.8135 19.5273 10.8153 19.7016 10.8153 19.7985C10.8153 19.833 10.816 19.8668 10.8172 19.8992C10.8626 19.9212 10.9159 19.9449 10.9777 19.9692C11.305 20.0981 11.8826 20.25 12.7934 20.25C13.704 20.25 14.2858 20.0981 14.6178 19.9684C14.6646 19.9502 14.7066 19.9322 14.7442 19.9151V19.7985C14.7442 19.6687 14.7458 19.4439 14.7478 19.1482C14.7488 19.0036 14.7499 18.8421 14.751 18.6663C14.7544 18.1281 14.7578 17.4498 14.7578 16.698C14.7578 15.7976 14.4699 15.3481 14.2724 15.1722C14.0518 14.9757 13.9671 14.668 14.0561 14.3862C14.1451 14.1045 14.3913 13.9012 14.6848 13.8672C15.8528 13.7316 16.912 13.4443 17.68 12.7787C18.4155 12.1413 19.0001 11.0524 19.0001 9.04528C19.0001 7.99194 18.6467 7.16661 18.0689 6.51114C17.8838 6.30112 17.8311 6.0055 17.9321 5.74443C17.9925 5.58842 18.2519 4.8452 17.9797 3.78512C17.9742 3.78627 17.9686 3.78746 17.9629 3.78869ZM18.7634 2.31717C18.9737 2.38853 19.1416 2.54948 19.2218 2.75663C19.7485 4.1171 19.6222 5.23077 19.4664 5.85377C20.1163 6.72098 20.5001 7.78523 20.5001 9.04528C20.5001 11.3648 19.8092 12.9184 18.6624 13.9123C17.8768 14.5931 16.9344 14.9593 16.0053 15.1674C16.1664 15.6009 16.2578 16.1135 16.2578 16.698C16.2578 17.4542 16.2544 18.1359 16.251 18.6758C16.2499 18.8573 16.2487 19.0219 16.2477 19.1678C16.2457 19.4583 16.2442 19.674 16.2442 19.7985V20.3333C16.2442 20.5404 16.1586 20.7391 16.0076 20.8809L16.0068 20.8816L16.006 20.8823L16.0044 20.8838L16.001 20.887L15.9933 20.894C15.9877 20.899 15.9814 20.9045 15.9743 20.9106C15.96 20.9229 15.9426 20.9373 15.9218 20.9535C15.8803 20.986 15.8255 21.0257 15.7564 21.07C15.6178 21.1586 15.423 21.2643 15.1635 21.3657C14.6429 21.569 13.8742 21.75 12.7934 21.75C11.7126 21.75 10.9466 21.569 10.4282 21.3649C10.1697 21.2632 9.976 21.1569 9.83812 21.0675C9.7693 21.0229 9.71476 20.9828 9.67333 20.9499C9.65262 20.9334 9.63522 20.9188 9.62096 20.9063C9.61384 20.9001 9.60751 20.8944 9.60194 20.8893L9.59418 20.8821L9.59072 20.8789L9.58911 20.8774L9.58832 20.8766L9.36685 20.4602L9.36665 20.459L9.36636 20.4573L9.36561 20.4527L9.36349 20.4395C9.36182 20.4289 9.35966 20.4147 9.35719 20.3972C9.35226 20.3624 9.34601 20.3143 9.33986 20.256C9.32768 20.1407 9.31525 19.9795 9.31525 19.7985C9.31525 19.7093 9.31367 19.5478 9.31155 19.3318C9.31059 19.2347 9.30953 19.1266 9.30846 19.0091C9.30718 18.869 9.3059 18.7169 9.30479 18.5564C8.27362 18.636 7.48813 18.4624 6.89464 18.1186C6.14454 17.684 5.82335 17.0482 5.67777 16.6314C5.6352 16.5228 5.50008 16.2449 5.31818 15.9591C5.22731 15.8164 5.13444 15.6871 5.04745 15.5856C5.00436 15.5353 4.96698 15.4969 4.93632 15.4691C4.90987 15.4451 4.89427 15.4344 4.88997 15.4316C4.75465 15.3557 4.6093 15.256 4.47961 15.1431C4.36221 15.041 4.18679 14.8679 4.08474 14.6364C4.03021 14.5128 3.97429 14.3215 4.01269 14.0955C4.05449 13.8495 4.19184 13.6571 4.35964 13.5298C4.63637 13.3198 4.98904 13.2883 5.23854 13.2844C5.92216 13.2735 6.46343 13.5991 6.82589 13.9134C7.19091 14.2299 7.44273 14.592 7.56964 14.8018L7.57783 14.8157C7.94838 15.4591 8.37105 15.6257 8.72098 15.6589C8.97404 15.683 9.44606 15.5727 9.44606 15.5727C9.44606 15.5727 9.52239 15.2953 9.57008 15.167C8.64063 14.9576 7.69962 14.5887 6.91594 13.9056C5.77371 12.91 5.08666 11.3572 5.08666 9.04528C5.08666 7.79856 5.46996 6.72453 6.12044 5.85415C5.96459 5.23123 5.83808 4.11738 6.36489 2.75663C6.44641 2.54607 6.61844 2.38344 6.83325 2.31388C6.83325 2.31388 6.8327 2.31406 6.83473 2.31341L6.83623 2.31293L6.8393 2.31195L6.84573 2.30996L6.85968 2.30582C6.86948 2.303 6.88025 2.30008 6.892 2.29713C6.91551 2.29121 6.94288 2.28516 6.97416 2.2795C7.03681 2.26817 7.11454 2.25852 7.20764 2.25453C7.39434 2.24654 7.63867 2.2615 7.94302 2.32833C8.49535 2.44962 9.24013 2.74041 10.2005 3.36945C11.0415 3.15758 11.9188 3.05254 12.7934 3.05254C13.6673 3.05254 14.5439 3.15743 15.3843 3.36897C16.3452 2.73409 17.0914 2.44234 17.6462 2.3225C17.9521 2.25644 18.1979 2.24307 18.3861 2.25288C18.4798 2.25777 18.5582 2.26836 18.6213 2.28056C18.6529 2.28665 18.6805 2.29312 18.7042 2.29941C18.716 2.30256 18.7269 2.30565 18.7367 2.30864L18.7508 2.31302L18.7573 2.31512L18.7604 2.31615L18.7619 2.31666C18.7639 2.31734 18.7634 2.31717 18.7634 2.31717ZM9.36685 20.4602C9.39394 20.6188 9.47133 20.7646 9.58756 20.8759L9.47721 20.668L9.36685 20.4602Z", fill: "currentColor" })
});
P({
  displayName: "GitHubCircleSolidIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.475 2 2 6.58819 2 12.2529C2 16.7899 4.8625 20.6219 8.8375 21.9804C9.3375 22.0701 9.525 21.7625 9.525 21.4934C9.525 21.2499 9.5125 20.4425 9.5125 19.5838C7 20.058 6.35 18.9558 6.15 18.3791C6.0375 18.0843 5.55 17.1743 5.125 16.9308C4.775 16.7386 4.275 16.2644 5.1125 16.2516C5.9 16.2388 6.4625 16.9949 6.65 17.3025C7.55 18.8533 8.9875 18.4175 9.5625 18.1484C9.65 17.4819 9.9125 17.0334 10.2 16.777C7.975 16.5207 5.65 15.6364 5.65 11.7147C5.65 10.5997 6.0375 9.67689 6.675 8.95918C6.575 8.70286 6.225 7.65193 6.775 6.24215C6.775 6.24215 7.6125 5.97301 9.525 7.29308C10.325 7.06239 11.175 6.94704 12.025 6.94704C12.875 6.94704 13.725 7.06239 14.525 7.29308C16.4375 5.9602 17.275 6.24215 17.275 6.24215C17.825 7.65193 17.475 8.70286 17.375 8.95918C18.0125 9.67689 18.4 10.5868 18.4 11.7147C18.4 15.6492 16.0625 16.5207 13.8375 16.777C14.2 17.0975 14.5125 17.7126 14.5125 18.6738C14.5125 20.0452 14.5 21.1474 14.5 21.4934C14.5 21.7625 14.6875 22.0829 15.1875 21.9804C19.1375 20.6219 22 16.777 22 12.2529C22 6.58819 17.525 2 12 2Z", fill: "currentColor" })
});
P({
  displayName: "GitHubColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("circle", { cx: "12", cy: "12", r: "9", fill: "white" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3C7.0275 3 3 7.0275 3 12C3 15.9825 5.57625 19.3463 9.15375 20.5387C9.60375 20.6175 9.7725 20.3475 9.7725 20.1112C9.7725 19.8975 9.76125 19.1888 9.76125 18.435C7.5 18.8513 6.915 17.8837 6.735 17.3775C6.63375 17.1187 6.195 16.32 5.8125 16.1062C5.4975 15.9375 5.0475 15.5212 5.80125 15.51C6.51 15.4987 7.01625 16.1625 7.185 16.4325C7.995 17.7937 9.28875 17.4113 9.80625 17.175C9.885 16.59 10.1213 16.1962 10.38 15.9712C8.3775 15.7463 6.285 14.97 6.285 11.5275C6.285 10.5487 6.63375 9.73875 7.2075 9.10875C7.1175 8.88375 6.8025 7.96125 7.2975 6.72375C7.2975 6.72375 8.05125 6.4875 9.7725 7.64625C10.4925 7.44375 11.2575 7.3425 12.0225 7.3425C12.7875 7.3425 13.5525 7.44375 14.2725 7.64625C15.9938 6.47625 16.7475 6.72375 16.7475 6.72375C17.2425 7.96125 16.9275 8.88375 16.8375 9.10875C17.4113 9.73875 17.76 10.5375 17.76 11.5275C17.76 14.9812 15.6562 15.7463 13.6538 15.9712C13.98 16.2525 14.2613 16.7925 14.2613 17.6363C14.2613 18.84 14.25 19.8075 14.25 20.1112C14.25 20.3475 14.4187 20.6287 14.8688 20.5387C18.4237 19.3463 21 15.9712 21 12C21 7.0275 16.9725 3 12 3Z", fill: "#5681D3" })
  )
});
P({
  displayName: "InstagramIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M8.24854 3C5.35429 3 3 5.35646 3 8.25146V15.7515C3 18.6457 5.35646 21 8.25146 21H15.7515C18.6457 21 21 18.6435 21 15.7485V8.24854C21 5.35429 18.6435 3 15.7485 3H8.24854ZM17.25 6C17.664 6 18 6.336 18 6.75C18 7.164 17.664 7.5 17.25 7.5C16.836 7.5 16.5 7.164 16.5 6.75C16.5 6.336 16.836 6 17.25 6ZM12 7.5C14.4818 7.5 16.5 9.51825 16.5 12C16.5 14.4818 14.4818 16.5 12 16.5C9.51825 16.5 7.5 14.4818 7.5 12C7.5 9.51825 9.51825 7.5 12 7.5ZM12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9Z", fill: "currentColor" })
});
P({
  displayName: "LinkedInIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM15.8289 18.5H18.5V13.0128C18.5 10.6911 17.1839 9.56855 15.3456 9.56855C13.5065 9.56855 12.7325 11.0007 12.7325 11.0007V9.83333H10.1583V18.5H12.7325V13.9505C12.7325 12.7315 13.2937 12.0061 14.3677 12.0061C15.3549 12.0061 15.8289 12.7032 15.8289 13.9505V18.5ZM5.5 7.09925C5.5 7.98241 6.21051 8.6985 7.08734 8.6985C7.96416 8.6985 8.67425 7.98241 8.67425 7.09925C8.67425 6.21609 7.96416 5.5 7.08734 5.5C6.21051 5.5 5.5 6.21609 5.5 7.09925ZM8.44235 18.5H5.75814V9.83333H8.44235V18.5Z", fill: "currentColor" })
});
P({
  displayName: "LinkedInColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21Z", fill: "#007EBB" }),
    w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.5 18.5H15.8289V13.9505C15.8289 12.7032 15.3549 12.0061 14.3677 12.0061C13.2937 12.0061 12.7325 12.7315 12.7325 13.9505V18.5H10.1583V9.83333H12.7325V11.0007C12.7325 11.0007 13.5065 9.56855 15.3456 9.56855C17.1839 9.56855 18.5 10.6911 18.5 13.0128V18.5ZM7.08734 8.6985C6.21051 8.6985 5.5 7.98241 5.5 7.09925C5.5 6.21609 6.21051 5.5 7.08734 5.5C7.96416 5.5 8.67425 6.21609 8.67425 7.09925C8.67425 7.98241 7.96416 8.6985 7.08734 8.6985ZM5.75814 18.5H8.44235V9.83333H5.75814V18.5Z", fill: "white" })
  )
});
P({
  displayName: "AltLayerIcon",
  viewBox: "0 0 32 32",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement(
      "g",
      { id: "logo.ODMGqaVg 2", "clip-path": "url(#clip0_24840_2534)" },
      w.createElement(
        "g",
        { id: "Mask group" },
        w.createElement(
          "mask",
          {
            id: "mask0_24840_2534",
            // style="mask-type:luminance"
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "134",
            height: "32"
          },
          w.createElement(
            "g",
            { id: "Group" },
            w.createElement("path", { id: "Vector", d: "M133.269 0H0.25V32H133.269V0Z", fill: "white" })
          )
        ),
        w.createElement(
          "g",
          { mask: "url(#mask0_24840_2534)" },
          w.createElement(
            "g",
            { id: "Group_2" },
            w.createElement(
              "g",
              { id: "Mask group_2" },
              w.createElement(
                "mask",
                {
                  id: "mask1_24840_2534",
                  // style="mask-type:luminance"
                  maskUnits: "userSpaceOnUse",
                  x: "0",
                  y: "0",
                  width: "134",
                  height: "32"
                },
                w.createElement(
                  "g",
                  { id: "Group_3" },
                  w.createElement("path", { id: "Vector_2", d: "M133.076 0H0.25V32H133.076V0Z", fill: "white" })
                )
              ),
              w.createElement(
                "g",
                { mask: "url(#mask1_24840_2534)" },
                w.createElement(
                  "g",
                  { id: "Group_4" },
                  w.createElement("path", { id: "Vector_3", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.95419 8.31885L2.95123 5.24518C2.34579 6.31333 1.82852 7.43443 1.40825 8.59911L6.09599 10.206C6.33993 9.55824 6.62502 8.92606 6.95125 8.31885H6.95419ZM10.8014 3.61338L7.18931 0.000976562C6.07836 0.988162 5.07321 2.0999 4.1915 3.31754L8.17976 6.37873C8.94097 5.34484 9.81972 4.41372 10.7984 3.61027L10.8014 3.61338ZM5.43177 12.442L0.744027 10.835C0.453064 12.0371 0.262026 13.2641 0.173856 14.5035H5.11141C5.17608 13.8091 5.28188 13.1208 5.43177 12.442ZM5.89319 21.3297L1.21133 22.9366C1.6081 24.1387 2.11067 25.3003 2.71024 26.4058L6.72494 23.3259C6.40459 22.6782 6.12832 22.0054 5.89613 21.3142V21.3266L5.89319 21.3297ZM7.88586 25.3158L3.90642 28.3677C4.82927 29.7099 5.90202 30.9337 7.0982 32.0112L10.7014 28.405C9.63462 27.5113 8.68822 26.468 7.88586 25.3034V25.3158ZM5.07615 17.2253H0.165039C0.22088 18.3931 0.370772 19.5547 0.608833 20.6944L5.32009 19.0782C5.20547 18.4616 5.12317 17.8388 5.07321 17.2097V17.2222L5.07615 17.2253Z", fill: "white" }),
                  w.createElement("path", { id: "Vector_4", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.8562 5.93945C17.5815 5.93945 15.3802 6.80208 13.652 8.3716C11.9238 9.94111 10.7805 12.1117 10.4308 14.494H15.2655C15.6182 13.3168 16.3617 12.3141 17.3581 11.6726C18.3544 11.0311 19.5388 10.7944 20.688 11.0062C21.8372 11.2179 22.8746 11.8625 23.6094 12.8248C24.3441 13.784 24.7233 14.9953 24.6792 16.2317C24.6351 17.468 24.1708 18.6451 23.3713 19.5451C22.5719 20.4451 21.4904 21.0087 20.3295 21.1271C19.1686 21.2486 18.0047 20.9184 17.0553 20.1991C16.1061 19.4798 15.436 18.4209 15.1656 17.2189H10.3926C10.6072 19.1528 11.3448 20.9808 12.5146 22.4817C13.6872 23.9828 15.242 25.0914 16.9966 25.6768C18.7483 26.2624 20.6263 26.2966 22.3955 25.7796C24.1678 25.2596 25.7578 24.2101 26.9804 22.7558C28.2002 21.3015 28.9996 19.5015 29.2787 17.577C29.558 15.6525 29.3052 13.6812 28.5528 11.9062C27.8005 10.1311 26.5778 8.62072 25.0348 7.56504C23.4919 6.50623 21.6932 5.94568 19.8533 5.94568L19.8562 5.93945Z", fill: "white" })
                )
              )
            )
          )
        )
      )
    ),
    w.createElement(
      "defs",
      null,
      w.createElement(
        "clipPath",
        { id: "clip0_24840_2534" },
        w.createElement("rect", { width: "29", height: "32", fill: "white", transform: "translate(0.25)" })
      )
    )
  )
});
P({
  displayName: "MetaMaskColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { d: "M20.6478 2.67419L13.1525 8.24105L14.5386 4.95668L20.6478 2.67419Z", fill: "#E2761B", stroke: "#E2761B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M3.34463 2.67419L10.7797 8.29378L9.46139 4.95668L3.34463 2.67419Z", fill: "#E4761B", stroke: "#E4761B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M17.951 15.5782L15.9548 18.6365L20.226 19.8117L21.4539 15.646L17.951 15.5782Z", fill: "#E4761B", stroke: "#E4761B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M2.55367 15.646L3.77401 19.8117L8.0452 18.6365L6.04896 15.5782L2.55367 15.646Z", fill: "#E4761B", stroke: "#E4761B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M7.80414 10.4105L6.61394 12.2109L10.855 12.3992L10.7043 7.8418L7.80414 10.4105Z", fill: "#E4761B", stroke: "#E4761B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M16.1883 10.4105L13.2505 7.78906L13.1525 12.3992L17.3861 12.2109L16.1883 10.4105Z", fill: "#E4761B", stroke: "#E4761B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M8.0452 18.6365L10.5913 17.3936L8.39171 15.6761L8.0452 18.6365Z", fill: "#E4761B", stroke: "#E4761B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M13.4011 17.3936L15.9548 18.6365L15.6008 15.6761L13.4011 17.3936Z", fill: "#E4761B", stroke: "#E4761B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M15.9548 18.6365L13.4011 17.3936L13.6045 19.0584L13.5819 19.7589L15.9548 18.6365Z", fill: "#D7C1B3", stroke: "#D7C1B3", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M8.0452 18.6365L10.4181 19.7589L10.403 19.0584L10.5913 17.3936L8.0452 18.6365Z", fill: "#D7C1B3", stroke: "#D7C1B3", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M10.4557 14.5763L8.33145 13.951L9.83051 13.2655L10.4557 14.5763Z", fill: "#233447", stroke: "#233447", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M13.5367 14.5763L14.162 13.2655L15.6686 13.951L13.5367 14.5763Z", fill: "#233447", stroke: "#233447", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M8.0452 18.6365L8.40678 15.5782L6.04896 15.646L8.0452 18.6365Z", fill: "#CD6116", stroke: "#CD6116", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M15.5932 15.5782L15.9548 18.6365L17.951 15.646L15.5932 15.5782Z", fill: "#CD6116", stroke: "#CD6116", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M17.3861 12.2109L13.1525 12.3993L13.5443 14.5763L14.1695 13.2656L15.6761 13.951L17.3861 12.2109Z", fill: "#CD6116", stroke: "#CD6116", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M8.33145 13.951L9.83804 13.2656L10.4557 14.5763L10.855 12.3993L6.61394 12.2109L8.33145 13.951Z", fill: "#CD6116", stroke: "#CD6116", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M6.61394 12.2109L8.39171 15.6761L8.33145 13.951L6.61394 12.2109Z", fill: "#E4751F", stroke: "#E4751F", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M15.6761 13.951L15.6008 15.6761L17.3861 12.2109L15.6761 13.951Z", fill: "#E4751F", stroke: "#E4751F", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M10.855 12.3993L10.4557 14.5763L10.9529 17.145L11.0659 13.7627L10.855 12.3993Z", fill: "#E4751F", stroke: "#E4751F", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M13.1525 12.3993L12.9492 13.7552L13.0395 17.145L13.5443 14.5763L13.1525 12.3993Z", fill: "#E4751F", stroke: "#E4751F", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M13.5443 14.5763L13.0395 17.145L13.4011 17.3936L15.6008 15.6761L15.6761 13.951L13.5443 14.5763Z", fill: "#F6851B", stroke: "#F6851B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M8.33145 13.951L8.39172 15.6761L10.5913 17.3936L10.9529 17.145L10.4557 14.5763L8.33145 13.951Z", fill: "#F6851B", stroke: "#F6851B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M13.5819 19.7589L13.6045 19.0584L13.4162 18.8927H10.5763L10.403 19.0584L10.4181 19.7589L8.0452 18.6365L8.87382 19.3145L10.5537 20.4821H13.4388L15.1262 19.3145L15.9548 18.6365L13.5819 19.7589Z", fill: "#C0AD9E", stroke: "#C0AD9E", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M13.4011 17.3936L13.0395 17.145H10.9529L10.5913 17.3936L10.403 19.0584L10.5763 18.8927H13.4162L13.6045 19.0584L13.4011 17.3936Z", fill: "#161616", stroke: "#161616", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M20.9642 8.60263L21.6045 5.52919L20.6478 2.67419L13.4011 8.05273L16.1883 10.4105L20.1281 11.5631L21.0019 10.5461L20.6252 10.2749L21.2279 9.72504L20.7608 9.36346L21.3635 8.90395L20.9642 8.60263Z", fill: "#763D16", stroke: "#763D16", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M2.39548 5.52919L3.03578 8.60263L2.629 8.90395L3.23164 9.36346L2.77213 9.72504L3.37476 10.2749L2.99812 10.5461L3.86441 11.5631L7.80414 10.4105L10.5913 8.05273L3.34463 2.67419L2.39548 5.52919Z", fill: "#763D16", stroke: "#763D16", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M20.1281 11.5631L16.1883 10.4106L17.3861 12.2109L15.6008 15.6761L17.951 15.646H21.4539L20.1281 11.5631Z", fill: "#F6851B", stroke: "#F6851B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M7.80414 10.4106L3.86441 11.5631L2.55367 15.646H6.04896L8.39171 15.6761L6.61394 12.2109L7.80414 10.4106Z", fill: "#F6851B", stroke: "#F6851B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" }),
    w.createElement("path", { d: "M13.1525 12.3992L13.4011 8.05273L14.5461 4.95668H9.4614L10.5913 8.05273L10.855 12.3992L10.9454 13.7702L10.9529 17.145H13.0396L13.0546 13.7702L13.1525 12.3992Z", fill: "#F6851B", stroke: "#F6851B", strokeWidth: "0.0753296", strokeLinecap: "round", strokeLinejoin: "round" })
  )
});
P({
  displayName: "MovementLabsIcon",
  viewBox: "0 0 32 32",
  path: w.createElement("path", { id: "Vector", d: "M27.4717 10.8751L27.5167 10.8561C27.6507 10.7988 27.7491 10.7674 27.8265 10.7576L27.9116 10.7432C28.086 10.7073 28.266 10.6894 28.446 10.6894C29.5288 10.6894 30.433 10.352 31.0609 9.71377C31.5126 9.25431 31.7969 8.65799 31.8963 7.96773L31.9514 7.96844V4H25.3383V6.87113C25.3223 7.078 25.3236 7.26833 25.325 7.43685C25.3264 7.6219 25.3275 7.79675 25.3052 7.92938L25.2989 7.9716C25.2242 8.53239 24.9532 9.05307 24.536 9.4376C24.1087 9.83163 23.9088 9.91818 23.8429 9.93682C23.7766 9.95582 23.6803 9.94702 23.4019 9.90938C23.1619 9.87701 22.833 9.83269 22.4318 9.83269C20.718 9.83269 19.2816 11.1266 19.0904 12.8438C19.0478 13.2343 19.0719 13.5264 19.0893 13.7392C19.1089 13.976 19.1148 14.0474 19.0328 14.2831C18.8703 14.7464 18.5242 15.1764 18.0586 15.4933C17.5929 15.8103 17.0567 15.9852 16.5495 15.9852L16.5 15.9845L16.4504 15.9852C15.9432 15.9852 15.4071 15.8107 14.9414 15.4933C14.4754 15.1764 14.1293 14.7464 13.9675 14.2842C13.8851 14.0474 13.8907 13.9756 13.9106 13.7385C13.9281 13.5257 13.9521 13.234 13.9096 12.8424C13.7188 11.1263 12.2823 9.83233 10.5685 9.83233C10.1673 9.83233 9.83838 9.87666 9.59664 9.90938C9.32037 9.94667 9.22374 9.95547 9.15746 9.93647C9.09153 9.91747 8.89165 9.83128 8.46434 9.4369C8.04714 9.05272 7.77644 8.53204 7.70144 7.97125L7.69517 7.92903C7.68435 7.86465 7.67912 7.79042 7.67668 7.70985V4H1.06215V7.36367C1.05448 8.3111 1.35762 9.12379 1.93807 9.71413C2.56561 10.3523 3.46978 10.6894 4.55255 10.6894C4.73255 10.6894 4.9122 10.7076 5.08731 10.7435L5.17208 10.7576C5.24917 10.7678 5.34754 10.7991 5.48253 10.8565L5.52684 10.8751C5.97508 11.0538 6.36787 11.3532 6.66263 11.7413C7.38819 12.6954 7.39029 14.0305 6.66821 14.9874C6.4317 15.3012 6.12403 15.563 5.77904 15.7449L5.74799 15.7618C5.65346 15.8138 5.56904 15.8525 5.4916 15.8796C5.45707 15.8916 5.42602 15.9014 5.39707 15.9099L5.36428 15.9197C5.10336 16.0042 4.83022 16.0467 4.5529 16.0467C2.45643 16.0467 1.04785 17.347 1.04785 19.2823C1.04785 20.793 1.73086 21.5769 2.30364 21.9684C3.0027 22.4462 3.84582 22.5816 4.65302 22.6562L4.70883 22.6626C4.92301 22.6907 5.1037 22.735 5.31126 22.8103L5.41137 22.8487L5.42847 22.855C5.97194 23.0422 6.42717 23.4246 6.71077 23.9322C6.87088 24.219 6.98181 24.5944 7.02297 24.9887C7.03902 25.1439 7.04983 25.2941 7.06029 25.4426C7.06832 25.5555 7.07739 25.6822 7.0896 25.8095V28.7232H13.7027V24.8325L13.656 24.8318C13.5471 24.0835 13.1948 23.3982 12.6374 22.8659C12.5882 22.8195 12.5429 22.7801 12.5066 22.7487L12.4842 22.7294C11.7726 22.1074 10.8472 22.0909 10.1712 22.0785H10.1638C10.0508 22.0764 9.94373 22.0743 9.84919 22.0698L9.74768 22.0539L9.53036 22.005L9.3256 21.9413L9.10479 21.8527C8.87351 21.7468 8.65759 21.6089 8.46608 21.4446L8.42317 21.4073C7.81133 20.8556 7.50784 20.1756 7.49529 19.3288C7.49703 18.7237 7.68889 18.1502 8.05027 17.67C8.40259 17.2021 8.90177 16.8538 9.45571 16.6891C10.0166 16.5227 11.0628 16.5185 11.5672 16.6811C12.4863 16.9769 13.1387 17.8276 13.1899 18.7979C13.1941 18.8781 13.191 18.9622 13.1875 19.0607C13.177 19.3453 13.1627 19.7351 13.3256 20.228C13.7864 21.5994 15.0611 22.5243 16.501 22.5299C17.9372 22.5243 19.2114 21.599 19.6733 20.2256C19.8355 19.7355 19.8212 19.3457 19.8107 19.0597C19.8072 18.9622 19.8041 18.8781 19.8083 18.7983C19.8596 17.828 20.5119 16.9769 21.431 16.6814C21.9355 16.5189 22.9813 16.5231 23.5422 16.6895C24.0965 16.8545 24.596 17.2028 24.948 17.6707C25.3093 18.1509 25.5012 18.7244 25.5029 19.3295C25.4904 20.1763 25.1869 20.8564 24.5747 21.4083L24.5356 21.4425C24.341 21.6092 24.1247 21.7475 23.8934 21.8534L23.673 21.942L23.4682 22.0057L23.2903 22.0472L23.1494 22.0705C23.0552 22.075 22.9478 22.0771 22.8347 22.0793H22.8274C22.1514 22.0916 21.2259 22.1081 20.5161 22.7287L20.4916 22.7502C20.4554 22.7815 20.4104 22.8205 20.3601 22.868C19.8233 23.3806 19.4766 24.0381 19.3555 24.7569H19.2962V28.7243H25.9093V25.8106C25.9215 25.6836 25.9306 25.5566 25.9386 25.4436C25.9491 25.2976 25.9599 25.1467 25.976 24.9905C26.0171 24.5954 26.128 24.22 26.2882 23.9333C26.5718 23.426 27.027 23.0436 27.5705 22.856L27.6877 22.8114C27.8952 22.7364 28.0759 22.6921 28.2904 22.6636L28.3459 22.6573C29.1531 22.5827 29.9962 22.4472 30.6953 21.9695C31.7334 21.2602 31.9511 20.1172 31.9511 19.2834C31.9511 17.3481 30.5425 16.0478 28.446 16.0478C28.1687 16.0478 27.8956 16.0049 27.6346 15.9208L27.6019 15.9109C27.5729 15.9025 27.5419 15.8926 27.5094 15.8814C27.4299 15.8539 27.3455 15.8149 27.2488 15.7618L27.2199 15.7459C26.8749 15.564 26.5672 15.3023 26.3304 14.9885C25.6083 14.0316 25.6104 12.6964 26.336 11.7423C26.6307 11.3546 27.0235 11.0549 27.4717 10.8765V10.8751Z", fill: "currentColor" })
});
P({
  displayName: "NodeRealIcon",
  viewBox: "0 0 32 32",
  path: w.createElement(
    w.Fragment,
    null,
    w.createElement("path", { id: "Vector_2", d: "M13.5796 20.8406C10.1481 22.1638 6.52743 22.93 2.85449 23.1103V8.89062C3.40086 8.99454 3.90897 9.09845 4.42802 9.21877L13.3611 14.2285C13.2725 16.4349 13.3455 18.6449 13.5796 20.8406Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_3", d: "M16.5137 15.9999V19.5493C15.8963 19.8556 15.268 20.1454 14.6342 20.4134C14.4495 18.5601 14.3819 16.6969 14.432 14.835L16.5137 15.9999Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_4", d: "M13.7106 21.9609C14.1048 25.0077 14.8041 28.0071 15.7977 30.9138L3.72852 24.1486C7.1442 23.9076 10.5067 23.1706 13.7106 21.9609Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_5", d: "M16.5136 20.7695V29.5912C15.6812 26.9715 15.0941 24.2801 14.7598 21.5516C15.3498 21.3055 15.9344 21.0485 16.5136 20.7695Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_6", d: "M21.2616 16.6837C19.7613 17.7694 18.1732 18.7281 16.5137 19.5495V16.0001L18.5079 14.9062C19.4476 15.4568 20.3655 16.0493 21.2616 16.6837Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_7", d: "M29.6755 23.9362L16.9999 31.046C16.8251 30.5647 16.6666 30.0834 16.5137 29.5967V20.7695C18.5122 19.815 20.4165 18.6742 22.2013 17.3623C23.6263 18.4224 24.9908 19.5618 26.2881 20.775L29.6755 23.9362Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_8", d: "M22.1908 16C21.3493 15.3875 20.4861 14.8133 19.6064 14.2663L29.0148 8.99414L28.9656 9.05977C27.0428 11.6791 24.7623 14.0153 22.1908 16Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_9", d: "M30.1729 9.27344V22.9079L27.0367 19.971C25.7869 18.8075 24.4756 17.7122 23.1084 16.6895C25.6609 14.6795 27.929 12.3319 29.8505 9.71096L30.1729 9.27344Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_10", d: "M4.42773 9.22363C7.54082 9.91432 10.5746 10.9241 13.481 12.2371C13.4209 12.8989 13.3826 13.5661 13.3608 14.2333L4.42773 9.22363Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_11", d: "M15.7975 1.08594C14.6894 4.32343 13.9472 7.675 13.5848 11.078C10.3788 9.66695 7.02769 8.6124 3.5918 7.93325L15.7975 1.08594Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_12", d: "M14.5354 12.7188C15.896 13.3794 17.2218 14.1095 18.5075 14.9064L16.5132 16.0002L14.4316 14.8353C14.448 14.1352 14.4808 13.4352 14.5354 12.7188Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_13", d: "M29.692 8.07525L29.0144 8.99405L19.6061 14.2663C18.0046 13.2696 16.3463 12.3675 14.6396 11.5645C14.9903 7.94634 15.7829 4.3849 16.9999 0.959961L29.692 8.07525Z", fill: "currentColor" }),
    w.createElement("path", { id: "Vector_14", d: "M2.82715 23.1094H2.85449V23.6563L2.82715 23.1094Z", fill: "currentColor" })
  )
});
P({
  displayName: "RedditIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 11.8011C23 10.488 21.9073 9.4206 20.5644 9.4206C19.909 9.4206 19.315 9.678 18.8778 10.092C17.2186 9.0201 14.9737 8.3379 12.4877 8.2506L13.8471 4.0485L17.5284 4.8954L17.5229 4.9476C17.5229 6.0213 18.4167 6.8943 19.5157 6.8943C20.6139 6.8943 21.5068 6.0213 21.5068 4.9476C21.5068 3.8739 20.613 3 19.5157 3C18.6724 3 17.9538 3.5166 17.6632 4.2411L13.6949 3.3276C13.5217 3.2862 13.3457 3.3843 13.2916 3.5517L11.7754 8.238C9.17392 8.2686 6.81717 8.9562 5.08375 10.0605C4.64925 9.6663 4.07267 9.4197 3.43467 9.4197C2.09175 9.4197 1 10.488 1 11.8011C1 12.6741 1.48858 13.431 2.20725 13.845C2.15958 14.0988 2.12842 14.3553 2.12842 14.6163C2.12842 18.1362 6.53575 21 11.9542 21C17.3726 21 21.7808 18.1362 21.7808 14.6163C21.7808 14.3697 21.7542 14.1267 21.7121 13.8873C22.4748 13.485 23 12.7065 23 11.8011ZM7.21133 13.4355C7.21133 12.6543 7.86217 12.018 8.6615 12.018C9.46083 12.018 10.1108 12.6543 10.1108 13.4355C10.1108 14.2167 9.46083 14.8521 8.6615 14.8521C7.86217 14.8521 7.21133 14.2167 7.21133 13.4355ZM15.5173 17.6376C14.7867 18.3513 13.6399 18.6987 12.0119 18.6987L12 18.696L11.9881 18.6987C10.3592 18.6987 9.21242 18.3513 8.48275 17.6376C8.34983 17.508 8.34983 17.2965 8.48275 17.1669C8.61567 17.0364 8.832 17.0364 8.96492 17.1669C9.56075 17.7492 10.5498 18.0318 11.9881 18.0318L12 18.0345L12.0119 18.0318C13.4502 18.0318 14.4392 17.7483 15.0351 17.166C15.168 17.0355 15.3843 17.0364 15.5173 17.166C15.6502 17.2965 15.6502 17.5071 15.5173 17.6376ZM15.344 14.8521C14.5447 14.8521 13.8948 14.2167 13.8948 13.4355C13.8948 12.6543 14.5447 12.018 15.344 12.018C16.1433 12.018 16.7933 12.6543 16.7933 13.4355C16.7933 14.2167 16.1433 14.8521 15.344 14.8521Z", fill: "currentColor" })
});
P({
  displayName: "TelegramIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { opacity: "0.9", fillRule: "evenodd", clipRule: "evenodd", d: "M4.38474 11.4694C9.12086 9.35919 12.2738 7.95703 13.857 7.27678C18.3631 5.34707 19.3103 5.01388 19.9192 5C20.0545 5 20.3522 5.02777 20.5552 5.19436C20.7176 5.33319 20.7582 5.51366 20.7853 5.65249C20.8123 5.79132 20.8394 6.08286 20.8123 6.30498C20.5687 8.94271 19.5133 15.3427 18.972 18.2858C18.742 19.5353 18.2954 19.9518 17.8624 19.9934C16.9152 20.0767 16.198 19.3548 15.2914 18.744C13.857 17.786 13.0586 17.1891 11.6648 16.2451C10.0546 15.1622 11.0965 14.5652 12.0167 13.5934C12.2602 13.3436 16.4145 9.45637 16.4957 9.1093C16.5092 9.06766 16.5092 8.90106 16.4145 8.81776C16.3198 8.73447 16.1844 8.76223 16.0762 8.79C15.9273 8.81777 13.654 10.3726 9.22912 13.4407C8.57959 13.8989 7.99772 14.121 7.46998 14.1071C6.88812 14.0932 5.77851 13.7739 4.93954 13.4963C3.92466 13.1631 3.11275 12.9826 3.18041 12.3995C3.22101 12.0941 3.62696 11.7887 4.38474 11.4694Z", fill: "currentColor" })
});
P({
  displayName: "TelegramColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { opacity: "0.9", fillRule: "evenodd", clipRule: "evenodd", d: "M4.38474 11.4694C9.12086 9.35919 12.2738 7.95703 13.857 7.27678C18.3631 5.34707 19.3103 5.01388 19.9192 5C20.0545 5 20.3522 5.02777 20.5552 5.19436C20.7176 5.33319 20.7582 5.51366 20.7853 5.65249C20.8123 5.79132 20.8394 6.08286 20.8123 6.30498C20.5687 8.94271 19.5133 15.3427 18.972 18.2858C18.742 19.5353 18.2954 19.9518 17.8624 19.9934C16.9152 20.0767 16.198 19.3548 15.2914 18.744C13.857 17.786 13.0586 17.1891 11.6648 16.2451C10.0546 15.1622 11.0965 14.5652 12.0167 13.5934C12.2602 13.3436 16.4145 9.45637 16.4957 9.1093C16.5092 9.06766 16.5092 8.90106 16.4145 8.81776C16.3198 8.73447 16.1844 8.76223 16.0762 8.79C15.9273 8.81777 13.654 10.3726 9.22912 13.4407C8.57959 13.8989 7.99772 14.121 7.46998 14.1071C6.88812 14.0932 5.77851 13.7739 4.93954 13.4963C3.92466 13.1631 3.11275 12.9826 3.18041 12.3995C3.22101 12.0941 3.62696 11.7887 4.38474 11.4694Z", fill: "#42B0EE" })
});
P({
  displayName: "TrustWalletColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
    w.createElement("path", { d: "M4 5.6001L11.9998 3V21C6.28561 18.5999 4 13.9999 4 11.4001V5.6001Z", fill: "#48FF91" }),
    w.createElement("path", { d: "M20 5.6001L12.0002 3V21C17.7144 18.5999 20 13.9999 20 11.4001V5.6001Z", fill: "url(#paint0_linear_6562_8924)" }),
    w.createElement(
      "defs",
      null,
      w.createElement(
        "linearGradient",
        { id: "paint0_linear_6562_8924", x1: "11.627", y1: "23.2523", x2: "18.175", y2: "-0.431276", gradientUnits: "userSpaceOnUse" },
        w.createElement("stop", { offset: "0.26", stopColor: "#48FF91" }),
        w.createElement("stop", { offset: "0.66", stopColor: "#0094FF" }),
        w.createElement("stop", { offset: "0.8", stopColor: "#0038FF" }),
        w.createElement("stop", { offset: "0.89", stopColor: "#0500FF" })
      )
    )
  )
});
P({
  displayName: "TwitterIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M20 6.65724C19.3746 6.93839 18.7023 7.12832 17.9969 7.21376C18.7169 6.77637 19.27 6.08376 19.5304 5.25841C18.8564 5.6635 18.11 5.95756 17.3155 6.11605C16.6794 5.42913 15.7729 5 14.7698 5C12.8437 5 11.282 6.58239 11.282 8.53422C11.282 8.81123 11.3128 9.08101 11.3723 9.33967C8.47364 9.19229 5.90375 7.78518 4.18351 5.64688C3.88329 6.16886 3.71125 6.77594 3.71125 7.42368C3.71125 8.6499 4.32699 9.73167 5.26284 10.3655C4.69113 10.3471 4.15334 10.1881 3.68312 9.92341C3.68272 9.93814 3.68272 9.95295 3.68272 9.96785C3.68272 11.6802 4.88496 13.1086 6.4805 13.4335C6.18785 13.5143 5.87972 13.5575 5.56165 13.5575C5.33691 13.5575 5.11846 13.5352 4.90545 13.4941C5.34932 14.8981 6.63733 15.92 8.16359 15.9484C6.96993 16.8964 5.46611 17.4614 3.83198 17.4614C3.55046 17.4614 3.27285 17.4447 3 17.412C4.54352 18.4149 6.3768 19 8.34642 19C14.7616 19 18.2698 13.6146 18.2698 8.94396C18.2698 8.79073 18.2664 8.63835 18.2597 8.48667C18.9411 7.98846 19.5324 7.36605 19.9999 6.65724H20Z", fill: "currentColor" })
});
P({
  displayName: "TwitterColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { d: "M21.2143 6.77562C20.5442 7.07684 19.8239 7.28034 19.0681 7.37189C19.8396 6.90325 20.4322 6.16117 20.7111 5.27687C19.989 5.71089 19.1893 6.02596 18.3381 6.19577C17.6565 5.45978 16.6853 5 15.6105 5C13.5468 5 11.8735 6.69542 11.8735 8.78666C11.8735 9.08346 11.9066 9.37251 11.9703 9.64965C8.86462 9.49174 6.11116 7.98413 4.26805 5.69308C3.94639 6.25234 3.76206 6.90279 3.76206 7.5968C3.76206 8.9106 4.42178 10.0696 5.42448 10.7487C4.81193 10.729 4.23572 10.5587 3.73191 10.2751C3.73149 10.2909 3.73149 10.3067 3.73149 10.3227C3.73149 12.1574 5.0196 13.6878 6.72911 14.0359C6.41555 14.1225 6.08541 14.1687 5.74462 14.1687C5.50383 14.1687 5.26978 14.1449 5.04155 14.1008C5.51713 15.6052 6.89714 16.7 8.53242 16.7304C7.2535 17.7461 5.64226 18.3516 3.89141 18.3516C3.58978 18.3516 3.29234 18.3336 3 18.2986C4.65377 19.3731 6.618 20 8.72831 20C15.6018 20 19.3606 14.2299 19.3606 9.22567C19.3606 9.06149 19.3569 8.89824 19.3497 8.73572C20.0797 8.20192 20.7132 7.53505 21.2142 6.77562H21.2143Z", fill: "#19A0EC" })
});
P({
  displayName: "XIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.82538 3H2.56026L3.31225 4.01738L9.89642 12.9251L2.5 20.954H4.15658L10.633 13.9216L15.6769 20.7455L15.8682 21.0043H16.19H20.2353H21.5004L20.7484 19.9869L13.7575 10.529L20.6639 3.02979H19.0122L13.0213 9.53298L8.38374 3.25881L8.19244 3H7.87061H3.82538ZM16.5119 19.7281L5.09051 4.27618H7.54878L18.9701 19.7281H16.5119Z", fill: "currentColor" })
});
P({
  displayName: "YouTubeIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.4931 5.4082C20.3403 5.63266 21.0012 6.28983 21.2303 7.12907C21.8295 9.52332 21.7905 14.05 21.2429 16.4816C21.0163 17.3209 20.3529 17.9755 19.5057 18.2025C17.1139 18.7886 6.40137 18.7163 4.14808 18.2025C3.30089 17.978 2.64001 17.3209 2.41091 16.4816C1.8457 14.1996 1.88472 9.37368 2.39832 7.14154C2.62491 6.3023 3.28831 5.64762 4.13549 5.42067C7.3329 4.75975 18.3551 4.97299 19.4931 5.4082ZM10.3205 8.78201L14.859 11.8077L10.3205 14.8333V8.78201Z", fill: "currentColor" })
});
P({
  displayName: "YouTubeColorIcon",
  viewBox: "0 0 24 24",
  path: w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7896 5.41512C20.6511 5.64338 21.3232 6.31169 21.5562 7.16515C22.1656 9.59999 22.1259 14.2033 21.569 16.6762C21.3386 17.5297 20.6639 18.1955 19.8024 18.4263C17.3701 19.0223 6.47597 18.9487 4.18449 18.4263C3.32294 18.198 2.65086 17.5297 2.41787 16.6762C1.84308 14.3555 1.88277 9.44781 2.40507 7.17783C2.6355 6.32437 3.31014 5.6586 4.17169 5.4278C7.42328 4.75568 18.6323 4.97253 19.7896 5.41512ZM10.4615 8.84612L15.0769 11.923L10.4615 15V8.84612Z", fill: "#DF2F2F" })
});
const joe = W0`
  from {
      transform: rotate(0deg);
  }
  to { 
      transform: rotate(360deg);
  }
`, ZI = Le((e, t) => g($oe, { ref: t, sx: {
  animationName: `${joe}`,
  animationDuration: "1s",
  animationTimingFunction: "linear",
  animationIterationCount: "infinite"
}, ...e })), zI = H.components.Button;
zI.defaultProps;
zI.sizes;
const Xoe = H.components.Button, Rv = Xoe.defaultProps, GI = {
  [fn.BUTTON__ICON]: {
    mr: {
      "2xl": H.sizes[3],
      xl: H.sizes[2],
      lg: H.sizes[2],
      md: H.sizes[2],
      sm: H.sizes[2],
      xs: H.sizes[1]
    }
  },
  [fn.ICON]: {
    fontSize: {
      "2xl": H.fontSizes[6],
      xl: H.fontSizes[6],
      lg: H.fontSizes[6],
      md: H.fontSizes[4],
      sm: H.fontSizes[4],
      xs: H.fontSizes[3]
    }
  }
}, Yoe = GI[fn.BUTTON__ICON], Joe = GI[fn.ICON], Hr = Le(({ isLoading: e, size: t = Rv.size, variant: n = Rv.variant, ...r }, o) => {
  const { colorMode: i } = Ee();
  return g(U9, { ref: o, isLoading: e, size: t, variant: n, spinner: g(ZI, {}), ...r, sx: {
    [`.${fn.BUTTON__ICON}`]: {
      ...Yoe
    },
    [`.${fn.ICON}`]: {
      ...Joe
    },
    ...e && (n === "solid" || n === "subtle") && {
      color: `${H.colors[i].text.on.color.primary} !important`
    },
    ...r.sx
  } });
}), _v = {
  variant: "solid",
  colorScheme: "primary"
};
Le((e, t) => g(re, { ref: t, flexDirection: "column", px: { base: H.sizes[5], md: H.sizes[14] }, py: { base: H.sizes[8], md: H.sizes[14] }, w: { base: "100%", lg: "auto" }, ...e }));
const Qoe = (e, t, n) => {
  const r = {};
  return n.forEach((o) => {
    r[o] = {}, Object.entries(e).forEach(([i, a]) => {
      r[o][i] = t[a][o];
    });
  }), r;
}, Fv = ["fontFamily", "fontSize", "fontWeight", "lineHeight", "letterSpacing"], mt = Le(({ variant: e, size: t, ...n }, r) => {
  const o = hs[e], i = we(() => Qoe(typeof t == "string" ? { base: t } : t, o, Fv), [t, o]), l = { ...Fv.reduce((c, u) => ({ ...c, [u]: i[u] }), {}), ...n };
  return g(_n, { ref: r, ...l });
});
Le(({ variant: e, size: t, ...n }, r) => {
  const { colorMode: o } = Ee();
  return g(mt, { ref: r, variant: "body", size: { base: "md", md: "lg" }, color: H.colors[o].text.secondary, ...n });
});
Le((e, t) => g(tp, { ref: t, mt: { base: H.sizes[8], md: H.sizes[10] }, spacing: { base: H.sizes[4] }, ...e }));
Le(({ variant: e, size: t, ...n }, r) => {
  const { colorMode: o } = Ee();
  return g(mt, { ref: r, variant: "display", size: { base: "2xs", md: "xs" }, color: H.colors[o].text.primary, mb: { base: H.sizes[4], md: H.sizes[6] }, ...n });
});
Le(({ colorScheme: e = _v.colorScheme, variant: t = _v.variant, ...n }, r) => {
  const { colorMode: o } = Ee(), i = Gt(e) ?? e, a = Gt(t) ?? t;
  return g(re, { ref: r, flexDirection: { base: "column", lg: "row" }, alignItems: { base: "start", lg: "center" }, justifyContent: { base: "center", lg: "start" }, borderColor: H.colors[o].border[3], borderStyle: "solid", borderWidth: a === "outline" ? H.sizes["0.5"] : 0, bg: H.colors[o].layer[2].default, borderRadius: H.sizes[8], boxShadow: `0px ${H.sizes[1]} 0px 0px ${H.colors[o].support[i][3]}, ${H.colors[o].shadow[4]}`, transition: "transform 0.4s ease-in-out", _hover: {
    transform: "scale(0.95)"
  }, ...n });
});
const Pv = {
  variant: "solid",
  colorScheme: "primary"
};
Le((e, t) => g(re, { ref: t, position: "absolute", flexDirection: "column", px: { base: H.sizes[5], md: H.sizes[10], lg: H.sizes[8] }, pb: { base: H.sizes[8], md: H.sizes[12], lg: H.sizes[12] }, w: { base: "100%", lg: "auto" }, ...e }));
Le(({ variant: e, size: t, ...n }, r) => {
  const { colorMode: o } = Ee();
  return g(mt, { ref: r, variant: "body", size: { base: "md", md: "lg" }, color: H.colors[o].text.secondary, ...n });
});
Le((e, t) => g(tp, { ref: t, mt: { base: H.sizes[6], md: H.sizes[10], lg: H.sizes[8] }, spacing: { base: H.sizes[4] }, ...e }));
Le(({ variant: e, size: t, ...n }, r) => {
  const { colorMode: o } = Ee();
  return g(mt, { ref: r, variant: "display", size: { base: "xs", md: "sm", lg: "sm" }, color: H.colors[o].text.primary, mb: { base: H.sizes[4], md: H.sizes[6], lg: H.sizes[6] }, ...n });
});
Le(({ children: e, colorScheme: t = Pv.colorScheme, size: n, variant: r = Pv.variant, ...o }, i) => {
  const { colorMode: a } = Ee(), l = Gt(t) ?? t, c = Gt(n) ?? n, u = Gt(r) ?? r, { d: f, width: p, height: h } = we(() => ({
    sm: {
      d: "M1 26.0923C1 19.0775 3.08741 12.7668 6.41309 8.23379C9.7392 3.70021 14.2516 1 19.1429 1H109.827C114.214 1 118.521 3.21802 121.887 7.3653L150.554 42.6818C154.225 47.2045 159.067 49.7866 164.166 49.7866H315.857C320.748 49.7866 325.261 52.4868 328.587 57.0204C331.913 61.5534 334 67.8641 334 74.8789V397.908C334 404.922 331.913 411.233 328.587 415.766C325.261 420.3 320.748 423 315.857 423H19.1429C14.2516 423 9.7392 420.3 6.41309 415.766C3.08741 411.233 1 404.923 1 397.908V26.0923Z",
      width: 335,
      height: 424
    },
    md: {
      d: "M1 32C1 15.0581 17.8793 1 39.1429 1H224.572C234.076 1 243.217 3.88575 250.225 9.06426L308.842 52.3769C316.224 57.8314 325.79 60.8326 335.683 60.8326H645.857C667.121 60.8326 684 74.8907 684 91.8326V488C684 504.942 667.121 519 645.857 519H39.1429C17.8793 519 1 504.942 1 488V32Z",
      width: 685,
      height: 520
    },
    lg: {
      d: "M1 32C1 14.8792 14.8792 1 32 1H183.592C191.273 1 198.68 3.85151 204.379 9.00187L252.299 52.3145C258.365 57.7972 266.251 60.8326 274.427 60.8326H528C545.121 60.8326 559 74.7118 559 91.8326V488C559 505.121 545.121 519 528 519H32C14.8792 519 1 505.121 1 488V32Z",
      width: 560,
      height: 520
    }
  })[c], [c]);
  return X(re, { ref: i, position: "relative", filter: `drop-shadow(${H.colors[a].shadow[4]})`, transition: "transform 0.4s ease-in-out", _hover: {
    transform: "scale(0.95)"
  }, ...o, children: [g(h1, { as: "svg", viewBox: `0 0 ${p} ${h}`, fill: "none", xmlns: "http://www.w3.org/2000/svg", position: "absolute", w: o.w || o.width, h: o.h || o.height, preserveAspectRatio: "none", stroke: H.colors[a].border[3], strokeWidth: u === "outline" ? H.sizes["0.5"] : 0, filter: `drop-shadow(${H.sizes[0]} ${H.sizes[1]} ${H.sizes[0]} ${H.colors[a].support[l][3]});`, children: g("path", { d: f, fill: H.colors[a].layer[2].default }) }), e] });
});
var Uu = function(e, t) {
  return Uu = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, Uu(e, t);
};
function Dr(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Uu(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Ue = function() {
  return Ue = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Ue.apply(this, arguments);
};
function k0(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function bo(e, t, n) {
  if (arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var bc, Vv;
function qoe() {
  if (Vv) return bc;
  Vv = 1;
  var e = Vf(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = r, i[e.Memo] = o;
  function a(v) {
    return e.isMemo(v) ? o : i[v.$$typeof] || t;
  }
  var l = Object.defineProperty, c = Object.getOwnPropertyNames, u = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, p = Object.getPrototypeOf, h = Object.prototype;
  function C(v, b, y) {
    if (typeof b != "string") {
      if (h) {
        var x = p(b);
        x && x !== h && C(v, x, y);
      }
      var T = c(b);
      u && (T = T.concat(u(b)));
      for (var A = a(v), L = a(b), I = 0; I < T.length; ++I) {
        var M = T[I];
        if (!n[M] && !(y && y[M]) && !(L && L[M]) && !(A && A[M])) {
          var k = f(b, M);
          try {
            l(v, M, k);
          } catch {
          }
        }
      }
    }
    return v;
  }
  return bc = C, bc;
}
qoe();
function WI(e, t, n) {
  if (n === void 0 && (n = Error), !e)
    throw new n(t);
}
var R1;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(R1 || (R1 = {}));
var St;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(St || (St = {}));
var ks;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(ks || (ks = {}));
function Hv(e) {
  return e.type === St.literal;
}
function Koe(e) {
  return e.type === St.argument;
}
function $I(e) {
  return e.type === St.number;
}
function UI(e) {
  return e.type === St.date;
}
function jI(e) {
  return e.type === St.time;
}
function XI(e) {
  return e.type === St.select;
}
function YI(e) {
  return e.type === St.plural;
}
function eie(e) {
  return e.type === St.pound;
}
function JI(e) {
  return e.type === St.tag;
}
function QI(e) {
  return !!(e && typeof e == "object" && e.type === ks.number);
}
function ju(e) {
  return !!(e && typeof e == "object" && e.type === ks.dateTime);
}
var qI = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, tie = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function nie(e) {
  var t = {};
  return e.replace(tie, function(n) {
    var r = n.length;
    switch (n[0]) {
      // Era
      case "G":
        t.era = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      // Year
      case "y":
        t.year = r === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      // Quarter
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      // Month
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][r - 1];
        break;
      // Week
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][r - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      // Weekday
      case "E":
        t.weekday = r === 4 ? "short" : r === 5 ? "narrow" : "short";
        break;
      case "e":
        if (r < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "c":
        if (r < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      // Period
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      // am, pm, noon, midnight
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      // Hour
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      // Minute
      case "m":
        t.minute = ["numeric", "2-digit"][r - 1];
        break;
      // Second
      case "s":
        t.second = ["numeric", "2-digit"][r - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      // Zone
      case "z":
        t.timeZoneName = r < 4 ? "short" : "long";
        break;
      case "Z":
      // 1..3, 4, 5: The ISO8601 varios formats
      case "O":
      // 1, 4: miliseconds in day short, long
      case "v":
      // 1, 4: generic non-location format
      case "V":
      // 1, 2, 3, 4: time zone ID or city
      case "X":
      // 1, 2, 3, 4: The ISO8601 varios formats
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var rie = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function oie(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(rie).filter(function(h) {
    return h.length > 0;
  }), n = [], r = 0, o = t; r < o.length; r++) {
    var i = o[r], a = i.split("/");
    if (a.length === 0)
      throw new Error("Invalid number skeleton");
    for (var l = a[0], c = a.slice(1), u = 0, f = c; u < f.length; u++) {
      var p = f[u];
      if (p.length === 0)
        throw new Error("Invalid number skeleton");
    }
    n.push({ stem: l, options: c });
  }
  return n;
}
function iie(e) {
  return e.replace(/^(.*?)-/, "");
}
var Ov = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, KI = /^(@+)?(\+|#+)?[rs]?$/g, aie = /(\*)(0+)|(#+)(0+)|(0+)/g, eL = /^(0+)$/;
function Nv(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(KI, function(n, r, o) {
    return typeof o != "string" ? (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length) : o === "+" ? t.minimumSignificantDigits = r.length : r[0] === "#" ? t.maximumSignificantDigits = r.length : (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length + (typeof o == "string" ? o.length : 0)), "";
  }), t;
}
function tL(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function sie(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var n = e.slice(0, 2);
    if (n === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : n === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !eL.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function Dv(e) {
  var t = {}, n = tL(e);
  return n || t;
}
function lie(e) {
  for (var t = {}, n = 0, r = e; n < r.length; n++) {
    var o = r[n];
    switch (o.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = o.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = iie(o.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = Ue(Ue(Ue({}, t), { notation: "scientific" }), o.options.reduce(function(c, u) {
          return Ue(Ue({}, c), Dv(u));
        }, {}));
        continue;
      case "engineering":
        t = Ue(Ue(Ue({}, t), { notation: "engineering" }), o.options.reduce(function(c, u) {
          return Ue(Ue({}, c), Dv(u));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(o.options[0]);
        continue;
      // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
      case "integer-width":
        if (o.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        o.options[0].replace(aie, function(c, u, f, p, h, C) {
          if (u)
            t.minimumIntegerDigits = f.length;
          else {
            if (p && h)
              throw new Error("We currently do not support maximum integer digits");
            if (C)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (eL.test(o.stem)) {
      t.minimumIntegerDigits = o.stem.length;
      continue;
    }
    if (Ov.test(o.stem)) {
      if (o.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      o.stem.replace(Ov, function(c, u, f, p, h, C) {
        return f === "*" ? t.minimumFractionDigits = u.length : p && p[0] === "#" ? t.maximumFractionDigits = p.length : h && C ? (t.minimumFractionDigits = h.length, t.maximumFractionDigits = h.length + C.length) : (t.minimumFractionDigits = u.length, t.maximumFractionDigits = u.length), "";
      });
      var i = o.options[0];
      i === "w" ? t = Ue(Ue({}, t), { trailingZeroDisplay: "stripIfInteger" }) : i && (t = Ue(Ue({}, t), Nv(i)));
      continue;
    }
    if (KI.test(o.stem)) {
      t = Ue(Ue({}, t), Nv(o.stem));
      continue;
    }
    var a = tL(o.stem);
    a && (t = Ue(Ue({}, t), a));
    var l = sie(o.stem);
    l && (t = Ue(Ue({}, t), l));
  }
  return t;
}
var sl = {
  AX: [
    "H"
  ],
  BQ: [
    "H"
  ],
  CP: [
    "H"
  ],
  CZ: [
    "H"
  ],
  DK: [
    "H"
  ],
  FI: [
    "H"
  ],
  ID: [
    "H"
  ],
  IS: [
    "H"
  ],
  ML: [
    "H"
  ],
  NE: [
    "H"
  ],
  RU: [
    "H"
  ],
  SE: [
    "H"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  AS: [
    "h",
    "H"
  ],
  BT: [
    "h",
    "H"
  ],
  DJ: [
    "h",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  GH: [
    "h",
    "H"
  ],
  IN: [
    "h",
    "H"
  ],
  LS: [
    "h",
    "H"
  ],
  PG: [
    "h",
    "H"
  ],
  PW: [
    "h",
    "H"
  ],
  SO: [
    "h",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  VU: [
    "h",
    "H"
  ],
  WS: [
    "h",
    "H"
  ],
  "001": [
    "H",
    "h"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  JP: [
    "H",
    "h",
    "K"
  ],
  AD: [
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AT: [
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BR: [
    "H",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CI: [
    "H",
    "hB"
  ],
  CV: [
    "H",
    "hB"
  ],
  DE: [
    "H",
    "hB"
  ],
  EE: [
    "H",
    "hB"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GF: [
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  HR: [
    "H",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IT: [
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  MF: [
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NC: [
    "H",
    "hB"
  ],
  NL: [
    "H",
    "hB"
  ],
  PM: [
    "H",
    "hB"
  ],
  PT: [
    "H",
    "hB"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SR: [
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TR: [
    "H",
    "hB"
  ],
  WF: [
    "H",
    "hB"
  ],
  YT: [
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CD: [
    "hB",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ]
};
function cie(e, t) {
  for (var n = "", r = 0; r < e.length; r++) {
    var o = e.charAt(r);
    if (o === "j") {
      for (var i = 0; r + 1 < e.length && e.charAt(r + 1) === o; )
        i++, r++;
      var a = 1 + (i & 1), l = i < 2 ? 1 : 3 + (i >> 1), c = "a", u = uie(t);
      for ((u == "H" || u == "k") && (l = 0); l-- > 0; )
        n += c;
      for (; a-- > 0; )
        n = u + n;
    } else o === "J" ? n += "H" : n += o;
  }
  return n;
}
function uie(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var n = e.language, r;
  n !== "root" && (r = e.maximize().region);
  var o = sl[r || ""] || sl[n || ""] || sl["".concat(n, "-001")] || sl["001"];
  return o[0];
}
var vc, die = new RegExp("^".concat(qI.source, "*")), fie = new RegExp("".concat(qI.source, "*$"));
function P1(e, t) {
  return { start: e, end: t };
}
var pie = !!String.prototype.startsWith, hie = !!String.fromCodePoint, mie = !!Object.fromEntries, Cie = !!String.prototype.codePointAt, gie = !!String.prototype.trimStart, bie = !!String.prototype.trimEnd, vie = !!Number.isSafeInteger, yie = vie ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, Xu = !0;
try {
  var xie = rL("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  Xu = ((vc = xie.exec("a")) === null || vc === void 0 ? void 0 : vc[0]) === "a";
} catch {
  Xu = !1;
}
var Zv = pie ? (
  // Native
  function(t, n, r) {
    return t.startsWith(n, r);
  }
) : (
  // For IE11
  function(t, n, r) {
    return t.slice(r, r + n.length) === n;
  }
), Yu = hie ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    for (var r = "", o = t.length, i = 0, a; o > i; ) {
      if (a = t[i++], a > 1114111)
        throw RangeError(a + " is not a valid code point");
      r += a < 65536 ? String.fromCharCode(a) : String.fromCharCode(((a -= 65536) >> 10) + 55296, a % 1024 + 56320);
    }
    return r;
  }
), zv = (
  // native
  mie ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var n = {}, r = 0, o = t; r < o.length; r++) {
        var i = o[r], a = i[0], l = i[1];
        n[a] = l;
      }
      return n;
    }
  )
), nL = Cie ? (
  // Native
  function(t, n) {
    return t.codePointAt(n);
  }
) : (
  // IE 11
  function(t, n) {
    var r = t.length;
    if (!(n < 0 || n >= r)) {
      var o = t.charCodeAt(n), i;
      return o < 55296 || o > 56319 || n + 1 === r || (i = t.charCodeAt(n + 1)) < 56320 || i > 57343 ? o : (o - 55296 << 10) + (i - 56320) + 65536;
    }
  }
), wie = gie ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(die, "");
  }
), Sie = bie ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(fie, "");
  }
);
function rL(e, t) {
  return new RegExp(e, t);
}
var Ju;
if (Xu) {
  var Gv = rL("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  Ju = function(t, n) {
    var r;
    Gv.lastIndex = n;
    var o = Gv.exec(t);
    return (r = o[1]) !== null && r !== void 0 ? r : "";
  };
} else
  Ju = function(t, n) {
    for (var r = []; ; ) {
      var o = nL(t, n);
      if (o === void 0 || oL(o) || Lie(o))
        break;
      r.push(o), n += o >= 65536 ? 2 : 1;
    }
    return Yu.apply(void 0, r);
  };
var Tie = (
  /** @class */
  function() {
    function e(t, n) {
      n === void 0 && (n = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!n.ignoreTag, this.locale = n.locale, this.requiresOtherClause = !!n.requiresOtherClause, this.shouldParseSkeletons = !!n.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, n, r) {
      for (var o = []; !this.isEOF(); ) {
        var i = this.char();
        if (i === 123) {
          var a = this.parseArgument(t, r);
          if (a.err)
            return a;
          o.push(a.val);
        } else {
          if (i === 125 && t > 0)
            break;
          if (i === 35 && (n === "plural" || n === "selectordinal")) {
            var l = this.clonePosition();
            this.bump(), o.push({
              type: St.pound,
              location: P1(l, this.clonePosition())
            });
          } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
            if (r)
              break;
            return this.error(R1.UNMATCHED_CLOSING_TAG, P1(this.clonePosition(), this.clonePosition()));
          } else if (i === 60 && !this.ignoreTag && Qu(this.peek() || 0)) {
            var a = this.parseTag(t, n);
            if (a.err)
              return a;
            o.push(a.val);
          } else {
            var a = this.parseLiteral(t, n);
            if (a.err)
              return a;
            o.push(a.val);
          }
        }
      }
      return { val: o, err: null };
    }, e.prototype.parseTag = function(t, n) {
      var r = this.clonePosition();
      this.bump();
      var o = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: St.literal,
            value: "<".concat(o, "/>"),
            location: P1(r, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var i = this.parseMessage(t + 1, n, !0);
        if (i.err)
          return i;
        var a = i.val, l = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !Qu(this.char()))
            return this.error(R1.INVALID_TAG, P1(l, this.clonePosition()));
          var c = this.clonePosition(), u = this.parseTagName();
          return o !== u ? this.error(R1.UNMATCHED_CLOSING_TAG, P1(c, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: St.tag,
              value: o,
              children: a,
              location: P1(r, this.clonePosition())
            },
            err: null
          } : this.error(R1.INVALID_TAG, P1(l, this.clonePosition())));
        } else
          return this.error(R1.UNCLOSED_TAG, P1(r, this.clonePosition()));
      } else
        return this.error(R1.INVALID_TAG, P1(r, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && Iie(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, n) {
      for (var r = this.clonePosition(), o = ""; ; ) {
        var i = this.tryParseQuote(n);
        if (i) {
          o += i;
          continue;
        }
        var a = this.tryParseUnquoted(t, n);
        if (a) {
          o += a;
          continue;
        }
        var l = this.tryParseLeftAngleBracket();
        if (l) {
          o += l;
          continue;
        }
        break;
      }
      var c = P1(r, this.clonePosition());
      return {
        val: { type: St.literal, value: o, location: c },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !Aie(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        // '{', '<', '>', '}'
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var n = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var r = this.char();
        if (r === 39)
          if (this.peek() === 39)
            n.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          n.push(r);
        this.bump();
      }
      return Yu.apply(void 0, n);
    }, e.prototype.tryParseUnquoted = function(t, n) {
      if (this.isEOF())
        return null;
      var r = this.char();
      return r === 60 || r === 123 || r === 35 && (n === "plural" || n === "selectordinal") || r === 125 && t > 0 ? null : (this.bump(), Yu(r));
    }, e.prototype.parseArgument = function(t, n) {
      var r = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(R1.EXPECT_ARGUMENT_CLOSING_BRACE, P1(r, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(R1.EMPTY_ARGUMENT, P1(r, this.clonePosition()));
      var o = this.parseIdentifierIfPossible().value;
      if (!o)
        return this.error(R1.MALFORMED_ARGUMENT, P1(r, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(R1.EXPECT_ARGUMENT_CLOSING_BRACE, P1(r, this.clonePosition()));
      switch (this.char()) {
        // Simple argument: `{name}`
        case 125:
          return this.bump(), {
            val: {
              type: St.argument,
              // value does not include the opening and closing braces.
              value: o,
              location: P1(r, this.clonePosition())
            },
            err: null
          };
        // Argument with options: `{name, format, ...}`
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(R1.EXPECT_ARGUMENT_CLOSING_BRACE, P1(r, this.clonePosition())) : this.parseArgumentOptions(t, n, o, r);
        default:
          return this.error(R1.MALFORMED_ARGUMENT, P1(r, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), n = this.offset(), r = Ju(this.message, n), o = n + r.length;
      this.bumpTo(o);
      var i = this.clonePosition(), a = P1(t, i);
      return { value: r, location: a };
    }, e.prototype.parseArgumentOptions = function(t, n, r, o) {
      var i, a = this.clonePosition(), l = this.parseIdentifierIfPossible().value, c = this.clonePosition();
      switch (l) {
        case "":
          return this.error(R1.EXPECT_ARGUMENT_TYPE, P1(a, c));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var u = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var f = this.clonePosition(), p = this.parseSimpleArgStyleIfPossible();
            if (p.err)
              return p;
            var h = Sie(p.val);
            if (h.length === 0)
              return this.error(R1.EXPECT_ARGUMENT_STYLE, P1(this.clonePosition(), this.clonePosition()));
            var C = P1(f, this.clonePosition());
            u = { style: h, styleLocation: C };
          }
          var v = this.tryParseArgumentClose(o);
          if (v.err)
            return v;
          var b = P1(o, this.clonePosition());
          if (u && Zv(u?.style, "::", 0)) {
            var y = wie(u.style.slice(2));
            if (l === "number") {
              var p = this.parseNumberSkeletonFromString(y, u.styleLocation);
              return p.err ? p : {
                val: { type: St.number, value: r, location: b, style: p.val },
                err: null
              };
            } else {
              if (y.length === 0)
                return this.error(R1.EXPECT_DATE_TIME_SKELETON, b);
              var x = y;
              this.locale && (x = cie(y, this.locale));
              var h = {
                type: ks.dateTime,
                pattern: x,
                location: u.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? nie(x) : {}
              }, T = l === "date" ? St.date : St.time;
              return {
                val: { type: T, value: r, location: b, style: h },
                err: null
              };
            }
          }
          return {
            val: {
              type: l === "number" ? St.number : l === "date" ? St.date : St.time,
              value: r,
              location: b,
              style: (i = u?.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var A = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(R1.EXPECT_SELECT_ARGUMENT_OPTIONS, P1(A, Ue({}, A)));
          this.bumpSpace();
          var L = this.parseIdentifierIfPossible(), I = 0;
          if (l !== "select" && L.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(R1.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, P1(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var p = this.tryParseDecimalInteger(R1.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, R1.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (p.err)
              return p;
            this.bumpSpace(), L = this.parseIdentifierIfPossible(), I = p.val;
          }
          var M = this.tryParsePluralOrSelectOptions(t, l, n, L);
          if (M.err)
            return M;
          var v = this.tryParseArgumentClose(o);
          if (v.err)
            return v;
          var k = P1(o, this.clonePosition());
          return l === "select" ? {
            val: {
              type: St.select,
              value: r,
              options: zv(M.val),
              location: k
            },
            err: null
          } : {
            val: {
              type: St.plural,
              value: r,
              options: zv(M.val),
              offset: I,
              pluralType: l === "plural" ? "cardinal" : "ordinal",
              location: k
            },
            err: null
          };
        }
        default:
          return this.error(R1.INVALID_ARGUMENT_TYPE, P1(a, c));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(R1.EXPECT_ARGUMENT_CLOSING_BRACE, P1(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, n = this.clonePosition(); !this.isEOF(); ) {
        var r = this.char();
        switch (r) {
          case 39: {
            this.bump();
            var o = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(R1.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, P1(o, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(n.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(n.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, n) {
      var r = [];
      try {
        r = oie(t);
      } catch {
        return this.error(R1.INVALID_NUMBER_SKELETON, n);
      }
      return {
        val: {
          type: ks.number,
          tokens: r,
          location: n,
          parsedOptions: this.shouldParseSkeletons ? lie(r) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, n, r, o) {
      for (var i, a = !1, l = [], c = /* @__PURE__ */ new Set(), u = o.value, f = o.location; ; ) {
        if (u.length === 0) {
          var p = this.clonePosition();
          if (n !== "select" && this.bumpIf("=")) {
            var h = this.tryParseDecimalInteger(R1.EXPECT_PLURAL_ARGUMENT_SELECTOR, R1.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (h.err)
              return h;
            f = P1(p, this.clonePosition()), u = this.message.slice(p.offset, this.offset());
          } else
            break;
        }
        if (c.has(u))
          return this.error(n === "select" ? R1.DUPLICATE_SELECT_ARGUMENT_SELECTOR : R1.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, f);
        u === "other" && (a = !0), this.bumpSpace();
        var C = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(n === "select" ? R1.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : R1.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, P1(this.clonePosition(), this.clonePosition()));
        var v = this.parseMessage(t + 1, n, r);
        if (v.err)
          return v;
        var b = this.tryParseArgumentClose(C);
        if (b.err)
          return b;
        l.push([
          u,
          {
            value: v.val,
            location: P1(C, this.clonePosition())
          }
        ]), c.add(u), this.bumpSpace(), i = this.parseIdentifierIfPossible(), u = i.value, f = i.location;
      }
      return l.length === 0 ? this.error(n === "select" ? R1.EXPECT_SELECT_ARGUMENT_SELECTOR : R1.EXPECT_PLURAL_ARGUMENT_SELECTOR, P1(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !a ? this.error(R1.MISSING_OTHER_CLAUSE, P1(this.clonePosition(), this.clonePosition())) : { val: l, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, n) {
      var r = 1, o = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (r = -1);
      for (var i = !1, a = 0; !this.isEOF(); ) {
        var l = this.char();
        if (l >= 48 && l <= 57)
          i = !0, a = a * 10 + (l - 48), this.bump();
        else
          break;
      }
      var c = P1(o, this.clonePosition());
      return i ? (a *= r, yie(a) ? { val: a, err: null } : this.error(n, c)) : this.error(t, c);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var n = nL(this.message, t);
      if (n === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return n;
    }, e.prototype.error = function(t, n) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: n
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (Zv(this.message, t, this.offset())) {
        for (var n = 0; n < t.length; n++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var n = this.offset(), r = this.message.indexOf(t, n);
      return r >= 0 ? (this.bumpTo(r), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var n = this.offset();
        if (n === t)
          break;
        if (n > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && oL(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), n = this.offset(), r = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
      return r ?? null;
    }, e;
  }()
);
function Qu(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function Aie(e) {
  return Qu(e) || e === 47;
}
function Iie(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function oL(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function Lie(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function qu(e) {
  e.forEach(function(t) {
    if (delete t.location, XI(t) || YI(t))
      for (var n in t.options)
        delete t.options[n].location, qu(t.options[n].value);
    else $I(t) && QI(t.style) || (UI(t) || jI(t)) && ju(t.style) ? delete t.style.location : JI(t) && qu(t.children);
  });
}
function Eie(e, t) {
  t === void 0 && (t = {}), t = Ue({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var n = new Tie(e, t).parse();
  if (n.err) {
    var r = SyntaxError(R1[n.err.kind]);
    throw r.location = n.err.location, r.originalMessage = n.err.message, r;
  }
  return t?.captureLocation || qu(n.val), n.val;
}
function Co(e, t) {
  var n = t && t.cache ? t.cache : Fie, r = t && t.serializer ? t.serializer : _ie, o = t && t.strategy ? t.strategy : Bie;
  return o(e, {
    cache: n,
    serializer: r
  });
}
function Mie(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function iL(e, t, n, r) {
  var o = Mie(r) ? r : n(r), i = t.get(o);
  return typeof i > "u" && (i = e.call(this, r), t.set(o, i)), i;
}
function aL(e, t, n) {
  var r = Array.prototype.slice.call(arguments, 3), o = n(r), i = t.get(o);
  return typeof i > "u" && (i = e.apply(this, r), t.set(o, i)), i;
}
function wp(e, t, n, r, o) {
  return n.bind(t, e, r, o);
}
function Bie(e, t) {
  var n = e.length === 1 ? iL : aL;
  return wp(e, this, n, t.cache.create(), t.serializer);
}
function kie(e, t) {
  return wp(e, this, aL, t.cache.create(), t.serializer);
}
function Rie(e, t) {
  return wp(e, this, iL, t.cache.create(), t.serializer);
}
var _ie = function() {
  return JSON.stringify(arguments);
};
function Sp() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
Sp.prototype.get = function(e) {
  return this.cache[e];
};
Sp.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var Fie = {
  create: function() {
    return new Sp();
  }
}, go = {
  variadic: kie,
  monadic: Rie
}, _o;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(_o || (_o = {}));
var da = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r, o) {
      var i = e.call(this, n) || this;
      return i.code = r, i.originalMessage = o, i;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), Wv = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r, o, i) {
      return e.call(this, 'Invalid values for "'.concat(n, '": "').concat(r, '". Options are "').concat(Object.keys(o).join('", "'), '"'), _o.INVALID_VALUE, i) || this;
    }
    return t;
  }(da)
), Pie = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r, o) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(r), _o.INVALID_VALUE, o) || this;
    }
    return t;
  }(da)
), Vie = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r) {
      return e.call(this, 'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(r, '"'), _o.MISSING_VALUE, r) || this;
    }
    return t;
  }(da)
), Mn;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(Mn || (Mn = {}));
function Hie(e) {
  return e.length < 2 ? e : e.reduce(function(t, n) {
    var r = t[t.length - 1];
    return !r || r.type !== Mn.literal || n.type !== Mn.literal ? t.push(n) : r.value += n.value, t;
  }, []);
}
function sL(e) {
  return typeof e == "function";
}
function _l(e, t, n, r, o, i, a) {
  if (e.length === 1 && Hv(e[0]))
    return [
      {
        type: Mn.literal,
        value: e[0].value
      }
    ];
  for (var l = [], c = 0, u = e; c < u.length; c++) {
    var f = u[c];
    if (Hv(f)) {
      l.push({
        type: Mn.literal,
        value: f.value
      });
      continue;
    }
    if (eie(f)) {
      typeof i == "number" && l.push({
        type: Mn.literal,
        value: n.getNumberFormat(t).format(i)
      });
      continue;
    }
    var p = f.value;
    if (!(o && p in o))
      throw new Vie(p, a);
    var h = o[p];
    if (Koe(f)) {
      (!h || typeof h == "string" || typeof h == "number") && (h = typeof h == "string" || typeof h == "number" ? String(h) : ""), l.push({
        type: typeof h == "string" ? Mn.literal : Mn.object,
        value: h
      });
      continue;
    }
    if (UI(f)) {
      var C = typeof f.style == "string" ? r.date[f.style] : ju(f.style) ? f.style.parsedOptions : void 0;
      l.push({
        type: Mn.literal,
        value: n.getDateTimeFormat(t, C).format(h)
      });
      continue;
    }
    if (jI(f)) {
      var C = typeof f.style == "string" ? r.time[f.style] : ju(f.style) ? f.style.parsedOptions : r.time.medium;
      l.push({
        type: Mn.literal,
        value: n.getDateTimeFormat(t, C).format(h)
      });
      continue;
    }
    if ($I(f)) {
      var C = typeof f.style == "string" ? r.number[f.style] : QI(f.style) ? f.style.parsedOptions : void 0;
      C && C.scale && (h = h * (C.scale || 1)), l.push({
        type: Mn.literal,
        value: n.getNumberFormat(t, C).format(h)
      });
      continue;
    }
    if (JI(f)) {
      var v = f.children, b = f.value, y = o[b];
      if (!sL(y))
        throw new Pie(b, "function", a);
      var x = _l(v, t, n, r, o, i), T = y(x.map(function(I) {
        return I.value;
      }));
      Array.isArray(T) || (T = [T]), l.push.apply(l, T.map(function(I) {
        return {
          type: typeof I == "string" ? Mn.literal : Mn.object,
          value: I
        };
      }));
    }
    if (XI(f)) {
      var A = f.options[h] || f.options.other;
      if (!A)
        throw new Wv(f.value, h, Object.keys(f.options), a);
      l.push.apply(l, _l(A.value, t, n, r, o));
      continue;
    }
    if (YI(f)) {
      var A = f.options["=".concat(h)];
      if (!A) {
        if (!Intl.PluralRules)
          throw new da(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, _o.MISSING_INTL_API, a);
        var L = n.getPluralRules(t, { type: f.pluralType }).select(h - (f.offset || 0));
        A = f.options[L] || f.options.other;
      }
      if (!A)
        throw new Wv(f.value, h, Object.keys(f.options), a);
      l.push.apply(l, _l(A.value, t, n, r, o, h - (f.offset || 0)));
      continue;
    }
  }
  return Hie(l);
}
function Oie(e, t) {
  return t ? Ue(Ue(Ue({}, e || {}), t || {}), Object.keys(e).reduce(function(n, r) {
    return n[r] = Ue(Ue({}, e[r]), t[r] || {}), n;
  }, {})) : e;
}
function Nie(e, t) {
  return t ? Object.keys(e).reduce(function(n, r) {
    return n[r] = Oie(e[r], t[r]), n;
  }, Ue({}, e)) : e;
}
function yc(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function Die(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: Co(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.NumberFormat).bind.apply(t, bo([void 0], n, !1)))();
    }, {
      cache: yc(e.number),
      strategy: go.variadic
    }),
    getDateTimeFormat: Co(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, bo([void 0], n, !1)))();
    }, {
      cache: yc(e.dateTime),
      strategy: go.variadic
    }),
    getPluralRules: Co(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.PluralRules).bind.apply(t, bo([void 0], n, !1)))();
    }, {
      cache: yc(e.pluralRules),
      strategy: go.variadic
    })
  };
}
var lL = (
  /** @class */
  function() {
    function e(t, n, r, o) {
      n === void 0 && (n = e.defaultLocale);
      var i = this;
      if (this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(a) {
        var l = i.formatToParts(a);
        if (l.length === 1)
          return l[0].value;
        var c = l.reduce(function(u, f) {
          return !u.length || f.type !== Mn.literal || typeof u[u.length - 1] != "string" ? u.push(f.value) : u[u.length - 1] += f.value, u;
        }, []);
        return c.length <= 1 ? c[0] || "" : c;
      }, this.formatToParts = function(a) {
        return _l(i.ast, i.locales, i.formatters, i.formats, a, void 0, i.message);
      }, this.resolvedOptions = function() {
        var a;
        return {
          locale: ((a = i.resolvedLocale) === null || a === void 0 ? void 0 : a.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
        };
      }, this.getAst = function() {
        return i.ast;
      }, this.locales = n, this.resolvedLocale = e.resolveLocale(n), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        this.ast = e.__parse(t, {
          ignoreTag: o?.ignoreTag,
          locale: this.resolvedLocale
        });
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = Nie(e.formats, r), this.formatters = o && o.formatters || Die(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (!(typeof Intl.Locale > "u")) {
        var n = Intl.NumberFormat.supportedLocalesOf(t);
        return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = Eie, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
), Sn;
(function(e) {
  e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})(Sn || (Sn = {}));
var Xn = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r, o) {
      var i = this, a = o ? o instanceof Error ? o : new Error(String(o)) : void 0;
      return i = e.call(this, "[@formatjs/intl Error ".concat(n, "] ").concat(r, `
`).concat(a ? `
`.concat(a.message, `
`).concat(a.stack) : "")) || this, i.code = n, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(i, t), i;
    }
    return t;
  }(Error)
), Zie = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r) {
      return e.call(this, Sn.UNSUPPORTED_FORMATTER, n, r) || this;
    }
    return t;
  }(Xn)
), zie = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r) {
      return e.call(this, Sn.INVALID_CONFIG, n, r) || this;
    }
    return t;
  }(Xn)
), $v = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r) {
      return e.call(this, Sn.MISSING_DATA, n, r) || this;
    }
    return t;
  }(Xn)
), Tp = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r, o) {
      return e.call(this, Sn.FORMAT_ERROR, "".concat(n, `
Locale: `).concat(r, `
`), o) || this;
    }
    return t;
  }(Xn)
), xc = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r, o, i) {
      var a = e.call(this, "".concat(n, `
MessageID: `).concat(o?.id, `
Default Message: `).concat(o?.defaultMessage, `
Description: `).concat(o?.description, `
`), r, i) || this;
      return a.descriptor = o, a;
    }
    return t;
  }(Tp)
), Gie = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t(n, r) {
      var o = e.call(this, Sn.MISSING_TRANSLATION, 'Missing message: "'.concat(n.id, '" for locale "').concat(r, '", using ').concat(n.defaultMessage ? "default message (".concat(typeof n.defaultMessage == "string" ? n.defaultMessage : n.defaultMessage.map(function(i) {
        var a;
        return (a = i.value) !== null && a !== void 0 ? a : JSON.stringify(i);
      }).join(), ")") : "id", " as fallback.")) || this;
      return o.descriptor = n, o;
    }
    return t;
  }(Xn)
);
function f2(e, t, n) {
  return n === void 0 && (n = {}), t.reduce(function(r, o) {
    return o in e ? r[o] = e[o] : o in n && (r[o] = n[o]), r;
  }, {});
}
var Wie = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, $ie = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, cL = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: Wie,
  onWarn: $ie
};
function uL() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function Ea(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function Uie(e) {
  e === void 0 && (e = uL());
  var t = Intl.RelativeTimeFormat, n = Intl.ListFormat, r = Intl.DisplayNames, o = Co(function() {
    for (var l, c = [], u = 0; u < arguments.length; u++)
      c[u] = arguments[u];
    return new ((l = Intl.DateTimeFormat).bind.apply(l, bo([void 0], c, !1)))();
  }, {
    cache: Ea(e.dateTime),
    strategy: go.variadic
  }), i = Co(function() {
    for (var l, c = [], u = 0; u < arguments.length; u++)
      c[u] = arguments[u];
    return new ((l = Intl.NumberFormat).bind.apply(l, bo([void 0], c, !1)))();
  }, {
    cache: Ea(e.number),
    strategy: go.variadic
  }), a = Co(function() {
    for (var l, c = [], u = 0; u < arguments.length; u++)
      c[u] = arguments[u];
    return new ((l = Intl.PluralRules).bind.apply(l, bo([void 0], c, !1)))();
  }, {
    cache: Ea(e.pluralRules),
    strategy: go.variadic
  });
  return {
    getDateTimeFormat: o,
    getNumberFormat: i,
    getMessageFormat: Co(function(l, c, u, f) {
      return new lL(l, c, u, Ue({ formatters: {
        getNumberFormat: i,
        getDateTimeFormat: o,
        getPluralRules: a
      } }, f || {}));
    }, {
      cache: Ea(e.message),
      strategy: go.variadic
    }),
    getRelativeTimeFormat: Co(function() {
      for (var l = [], c = 0; c < arguments.length; c++)
        l[c] = arguments[c];
      return new (t.bind.apply(t, bo([void 0], l, !1)))();
    }, {
      cache: Ea(e.relativeTime),
      strategy: go.variadic
    }),
    getPluralRules: a,
    getListFormat: Co(function() {
      for (var l = [], c = 0; c < arguments.length; c++)
        l[c] = arguments[c];
      return new (n.bind.apply(n, bo([void 0], l, !1)))();
    }, {
      cache: Ea(e.list),
      strategy: go.variadic
    }),
    getDisplayNames: Co(function() {
      for (var l = [], c = 0; c < arguments.length; c++)
        l[c] = arguments[c];
      return new (r.bind.apply(r, bo([void 0], l, !1)))();
    }, {
      cache: Ea(e.displayNames),
      strategy: go.variadic
    })
  };
}
function Ap(e, t, n, r) {
  var o = e && e[t], i;
  if (o && (i = o[n]), i)
    return i;
  r(new Zie("No ".concat(t, " format named: ").concat(n)));
}
function ll(e, t) {
  return Object.keys(e).reduce(function(n, r) {
    return n[r] = Ue({ timeZone: t }, e[r]), n;
  }, {});
}
function Uv(e, t) {
  var n = Object.keys(Ue(Ue({}, e), t));
  return n.reduce(function(r, o) {
    return r[o] = Ue(Ue({}, e[o] || {}), t[o] || {}), r;
  }, {});
}
function jv(e, t) {
  if (!t)
    return e;
  var n = lL.formats;
  return Ue(Ue(Ue({}, n), e), { date: Uv(ll(n.date, t), ll(e.date || {}, t)), time: Uv(ll(n.time, t), ll(e.time || {}, t)) });
}
var Ku = function(e, t, n, r, o) {
  var i = e.locale, a = e.formats, l = e.messages, c = e.defaultLocale, u = e.defaultFormats, f = e.fallbackOnEmptyString, p = e.onError, h = e.timeZone, C = e.defaultRichTextElements;
  n === void 0 && (n = { id: "" });
  var v = n.id, b = n.defaultMessage;
  WI(!!v, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
  var y = String(v), x = (
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    l && Object.prototype.hasOwnProperty.call(l, y) && l[y]
  );
  if (Array.isArray(x) && x.length === 1 && x[0].type === St.literal)
    return x[0].value;
  if (!r && x && typeof x == "string" && !C)
    return x.replace(/'\{(.*?)\}'/gi, "{$1}");
  if (r = Ue(Ue({}, C), r || {}), a = jv(a, h), u = jv(u, h), !x) {
    if (f === !1 && x === "")
      return x;
    if ((!b || i && i.toLowerCase() !== c.toLowerCase()) && p(new Gie(n, i)), b)
      try {
        var T = t.getMessageFormat(b, c, u, o);
        return T.format(r);
      } catch (A) {
        return p(new xc('Error formatting default message for: "'.concat(y, '", rendering default message verbatim'), i, n, A)), typeof b == "string" ? b : y;
      }
    return y;
  }
  try {
    var T = t.getMessageFormat(x, i, a, Ue({ formatters: t }, o || {}));
    return T.format(r);
  } catch (A) {
    p(new xc('Error formatting message: "'.concat(y, '", using ').concat(b ? "default message" : "id", " as fallback."), i, n, A));
  }
  if (b)
    try {
      var T = t.getMessageFormat(b, c, u, o);
      return T.format(r);
    } catch (A) {
      p(new xc('Error formatting the default message for: "'.concat(y, '", rendering message verbatim'), i, n, A));
    }
  return typeof x == "string" ? x : typeof b == "string" ? b : y;
}, dL = [
  "formatMatcher",
  "timeZone",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "hourCycle",
  "dateStyle",
  "timeStyle",
  "calendar",
  // 'dayPeriod',
  "numberingSystem",
  "fractionalSecondDigits"
];
function e6(e, t, n, r) {
  var o = e.locale, i = e.formats, a = e.onError, l = e.timeZone;
  r === void 0 && (r = {});
  var c = r.format, u = Ue(Ue({}, l && { timeZone: l }), c && Ap(i, t, c, a)), f = f2(r, dL, u);
  return t === "time" && !f.hour && !f.minute && !f.second && !f.timeStyle && !f.dateStyle && (f = Ue(Ue({}, f), { hour: "numeric", minute: "numeric" })), n(o, f);
}
function jie(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var o = n[0], i = n[1], a = i === void 0 ? {} : i, l = typeof o == "string" ? new Date(o || 0) : o;
  try {
    return e6(e, "date", t, a).format(l);
  } catch (c) {
    e.onError(new Xn(Sn.FORMAT_ERROR, "Error formatting date.", c));
  }
  return String(l);
}
function Xie(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var o = n[0], i = n[1], a = i === void 0 ? {} : i, l = typeof o == "string" ? new Date(o || 0) : o;
  try {
    return e6(e, "time", t, a).format(l);
  } catch (c) {
    e.onError(new Xn(Sn.FORMAT_ERROR, "Error formatting time.", c));
  }
  return String(l);
}
function Yie(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var o = n[0], i = n[1], a = n[2], l = a === void 0 ? {} : a, c = e.timeZone, u = e.locale, f = e.onError, p = f2(l, dL, c ? { timeZone: c } : {});
  try {
    return t(u, p).formatRange(o, i);
  } catch (h) {
    f(new Xn(Sn.FORMAT_ERROR, "Error formatting date time range.", h));
  }
  return String(o);
}
function Jie(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var o = n[0], i = n[1], a = i === void 0 ? {} : i, l = typeof o == "string" ? new Date(o || 0) : o;
  try {
    return e6(e, "date", t, a).formatToParts(l);
  } catch (c) {
    e.onError(new Xn(Sn.FORMAT_ERROR, "Error formatting date.", c));
  }
  return [];
}
function Qie(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var o = n[0], i = n[1], a = i === void 0 ? {} : i, l = typeof o == "string" ? new Date(o || 0) : o;
  try {
    return e6(e, "time", t, a).formatToParts(l);
  } catch (c) {
    e.onError(new Xn(Sn.FORMAT_ERROR, "Error formatting time.", c));
  }
  return [];
}
var qie = [
  "style",
  "type",
  "fallback"
];
function Kie(e, t, n, r) {
  var o = e.locale, i = e.onError, a = Intl.DisplayNames;
  a || i(new da(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, _o.MISSING_INTL_API));
  var l = f2(r, qie);
  try {
    return t(o, l).of(n);
  } catch (c) {
    i(new Xn(Sn.FORMAT_ERROR, "Error formatting display name.", c));
  }
}
var eae = [
  "type",
  "style"
], Xv = Date.now();
function tae(e) {
  return "".concat(Xv, "_").concat(e, "_").concat(Xv);
}
function nae(e, t, n, r) {
  r === void 0 && (r = {});
  var o = fL(e, t, n, r).reduce(function(i, a) {
    var l = a.value;
    return typeof l != "string" ? i.push(l) : typeof i[i.length - 1] == "string" ? i[i.length - 1] += l : i.push(l), i;
  }, []);
  return o.length === 1 ? o[0] : o;
}
function fL(e, t, n, r) {
  var o = e.locale, i = e.onError;
  r === void 0 && (r = {});
  var a = Intl.ListFormat;
  a || i(new da(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, _o.MISSING_INTL_API));
  var l = f2(r, eae);
  try {
    var c = {}, u = n.map(function(f, p) {
      if (typeof f == "object") {
        var h = tae(p);
        return c[h] = f, h;
      }
      return String(f);
    });
    return t(o, l).formatToParts(u).map(function(f) {
      return f.type === "literal" ? f : Ue(Ue({}, f), { value: c[f.value] || f.value });
    });
  } catch (f) {
    i(new Xn(Sn.FORMAT_ERROR, "Error formatting list.", f));
  }
  return n;
}
var rae = ["type"];
function oae(e, t, n, r) {
  var o = e.locale, i = e.onError;
  r === void 0 && (r = {}), Intl.PluralRules || i(new da(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, _o.MISSING_INTL_API));
  var a = f2(r, rae);
  try {
    return t(o, a).select(n);
  } catch (l) {
    i(new Tp("Error formatting plural.", o, l));
  }
  return "other";
}
var iae = ["numeric", "style"];
function aae(e, t, n) {
  var r = e.locale, o = e.formats, i = e.onError;
  n === void 0 && (n = {});
  var a = n.format, l = !!a && Ap(o, "relative", a, i) || {}, c = f2(n, iae, l);
  return t(r, c);
}
function sae(e, t, n, r, o) {
  o === void 0 && (o = {}), r || (r = "second");
  var i = Intl.RelativeTimeFormat;
  i || e.onError(new da(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, _o.MISSING_INTL_API));
  try {
    return aae(e, t, o).format(n, r);
  } catch (a) {
    e.onError(new Tp("Error formatting relative time.", e.locale, a));
  }
  return String(n);
}
var lae = [
  "style",
  "currency",
  "currencyDisplay",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  // ES2020 NumberFormat
  "compactDisplay",
  "currencyDisplay",
  "currencySign",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "numberingSystem"
];
function pL(e, t, n) {
  var r = e.locale, o = e.formats, i = e.onError;
  n === void 0 && (n = {});
  var a = n.format, l = a && Ap(o, "number", a, i) || {}, c = f2(n, lae, l);
  return t(r, c);
}
function cae(e, t, n, r) {
  r === void 0 && (r = {});
  try {
    return pL(e, t, r).format(n);
  } catch (o) {
    e.onError(new Xn(Sn.FORMAT_ERROR, "Error formatting number.", o));
  }
  return String(n);
}
function uae(e, t, n, r) {
  r === void 0 && (r = {});
  try {
    return pL(e, t, r).formatToParts(n);
  } catch (o) {
    e.onError(new Xn(Sn.FORMAT_ERROR, "Error formatting number.", o));
  }
  return [];
}
function dae(e) {
  var t = e[Object.keys(e)[0]];
  return typeof t == "string";
}
function fae(e) {
  e.onWarn && e.defaultRichTextElements && dae(e.messages || {}) && e.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function pae(e, t) {
  var n = Uie(t), r = Ue(Ue({}, cL), e), o = r.locale, i = r.defaultLocale, a = r.onError;
  return o ? !Intl.NumberFormat.supportedLocalesOf(o).length && a ? a(new $v('Missing locale data for locale: "'.concat(o, '" in Intl.NumberFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : !Intl.DateTimeFormat.supportedLocalesOf(o).length && a && a(new $v('Missing locale data for locale: "'.concat(o, '" in Intl.DateTimeFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : (a && a(new zie('"locale" was not configured, using "'.concat(i, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details'))), r.locale = r.defaultLocale || "en"), fae(r), Ue(Ue({}, r), {
    formatters: n,
    formatNumber: cae.bind(null, r, n.getNumberFormat),
    formatNumberToParts: uae.bind(null, r, n.getNumberFormat),
    formatRelativeTime: sae.bind(null, r, n.getRelativeTimeFormat),
    formatDate: jie.bind(null, r, n.getDateTimeFormat),
    formatDateToParts: Jie.bind(null, r, n.getDateTimeFormat),
    formatTime: Xie.bind(null, r, n.getDateTimeFormat),
    formatDateTimeRange: Yie.bind(null, r, n.getDateTimeFormat),
    formatTimeToParts: Qie.bind(null, r, n.getDateTimeFormat),
    formatPlural: oae.bind(null, r, n.getPluralRules),
    // @ts-expect-error TODO: will get to this later
    formatMessage: Ku.bind(null, r, n),
    // @ts-expect-error TODO: will get to this later
    $t: Ku.bind(null, r, n),
    formatList: nae.bind(null, r, n.getListFormat),
    formatListToParts: fL.bind(null, r, n.getListFormat),
    formatDisplayName: Kie.bind(null, r, n.getDisplayNames)
  });
}
function hL(e) {
  WI(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var mL = Ue(Ue({}, cL), { textComponent: Se.Fragment });
function hae(e) {
  return function(t) {
    return e(Se.Children.toArray(t));
  };
}
function ed(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var n = Object.keys(e), r = Object.keys(t), o = n.length;
  if (r.length !== o)
    return !1;
  for (var i = 0; i < o; i++) {
    var a = n[i];
    if (e[a] !== t[a] || !Object.prototype.hasOwnProperty.call(t, a))
      return !1;
  }
  return !0;
}
var Ip = Se.createContext(null);
Ip.Consumer;
var mae = Ip.Provider, Cae = mae, gae = Ip;
function n1() {
  var e = Se.useContext(gae);
  return hL(e), e;
}
var td;
(function(e) {
  e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName";
})(td || (td = {}));
var nd;
(function(e) {
  e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts";
})(nd || (nd = {}));
function CL(e) {
  var t = function(n) {
    var r = n1(), o = n.value, i = n.children, a = k0(n, ["value", "children"]), l = typeof o == "string" ? new Date(o || 0) : o, c = e === "formatDate" ? r.formatDateToParts(l, a) : r.formatTimeToParts(l, a);
    return i(c);
  };
  return t.displayName = nd[e], t;
}
function f3(e) {
  var t = function(n) {
    var r = n1(), o = n.value, i = n.children, a = k0(
      n,
      ["value", "children"]
    ), l = r[e](o, a);
    if (typeof i == "function")
      return i(l);
    var c = r.textComponent || Se.Fragment;
    return Se.createElement(c, null, l);
  };
  return t.displayName = td[e], t;
}
function wc(e) {
  return {
    locale: e.locale,
    timeZone: e.timeZone,
    fallbackOnEmptyString: e.fallbackOnEmptyString,
    formats: e.formats,
    textComponent: e.textComponent,
    messages: e.messages,
    defaultLocale: e.defaultLocale,
    defaultFormats: e.defaultFormats,
    onError: e.onError,
    onWarn: e.onWarn,
    wrapRichTextChunksInFragment: e.wrapRichTextChunksInFragment,
    defaultRichTextElements: e.defaultRichTextElements
  };
}
function gL(e) {
  return e && Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    return t[n] = sL(r) ? hae(r) : r, t;
  }, {});
}
var Yv = function(e, t, n, r) {
  for (var o = [], i = 4; i < arguments.length; i++)
    o[i - 4] = arguments[i];
  var a = gL(r), l = Ku.apply(void 0, bo([
    e,
    t,
    n,
    a
  ], o, !1));
  return Array.isArray(l) ? Se.Children.toArray(l) : l;
}, Jv = function(e, t) {
  var n = e.defaultRichTextElements, r = k0(e, ["defaultRichTextElements"]), o = gL(n), i = pae(Ue(Ue(Ue({}, mL), r), { defaultRichTextElements: o }), t), a = {
    locale: i.locale,
    timeZone: i.timeZone,
    fallbackOnEmptyString: i.fallbackOnEmptyString,
    formats: i.formats,
    defaultLocale: i.defaultLocale,
    defaultFormats: i.defaultFormats,
    messages: i.messages,
    onError: i.onError,
    defaultRichTextElements: o
  };
  return Ue(Ue({}, i), {
    // @ts-expect-error fix this
    formatMessage: Yv.bind(null, a, i.formatters),
    // @ts-expect-error fix this
    $t: Yv.bind(null, a, i.formatters)
  });
}, bae = (
  /** @class */
  function(e) {
    Dr(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.cache = uL(), n.state = {
        cache: n.cache,
        intl: Jv(wc(n.props), n.cache),
        prevConfig: wc(n.props)
      }, n;
    }
    return t.getDerivedStateFromProps = function(n, r) {
      var o = r.prevConfig, i = r.cache, a = wc(n);
      return ed(o, a) ? null : {
        intl: Jv(a, i),
        prevConfig: a
      };
    }, t.prototype.render = function() {
      return hL(this.state.intl), Se.createElement(Cae, { value: this.state.intl }, this.props.children);
    }, t.displayName = "IntlProvider", t.defaultProps = mL, t;
  }(Se.PureComponent)
);
function vae(e, t) {
  var n = e.values, r = k0(e, ["values"]), o = t.values, i = k0(t, ["values"]);
  return ed(o, n) && ed(r, i);
}
function bL(e) {
  var t = n1(), n = t.formatMessage, r = t.textComponent, o = r === void 0 ? Se.Fragment : r, i = e.id, a = e.description, l = e.defaultMessage, c = e.values, u = e.children, f = e.tagName, p = f === void 0 ? o : f, h = e.ignoreTag, C = { id: i, description: a, defaultMessage: l }, v = n(C, c, {
    ignoreTag: h
  });
  return typeof u == "function" ? u(Array.isArray(v) ? v : [v]) : p ? Se.createElement(p, null, Se.Children.toArray(v)) : Se.createElement(Se.Fragment, null, v);
}
bL.displayName = "FormattedMessage";
var vL = Se.memo(bL, vae);
vL.displayName = "MemoizedFormattedMessage";
var yae = f3("formatDate");
f3("formatTime");
f3("formatNumber");
f3("formatList");
f3("formatDisplayName");
CL("formatDate");
CL("formatTime");
const rd = ({ size: e }) => g(re, { ...e === "fill" ? {
  flex: "1"
} : {
  flexBasis: e,
  flexShrink: 0
} });
Le(({ data: e, ...t }, n) => {
  const { colorMode: r } = Ee();
  return X(re, { ref: n, as: "a", href: `https://www.bnbchain.org/en/blog/${e.slug}`, target: "_blank", flexDirection: { base: "column", md: "row" }, py: { base: H.sizes[10], md: H.sizes[10], lg: H.sizes[12] }, borderY: `1px solid ${H.colors[r].border[3]}`, transitionProperty: "border-color", transitionDelay: H.transition.duration["ultra-fast"], transitionTimingFunction: "ease-in", _hover: {
    cursor: "pointer",
    borderY: `1px solid ${H.colors[r].border.brand}`,
    zIndex: 1,
    [`.${fn.ICON}`]: {
      transform: "rotate(45deg)"
    },
    img: {
      transform: "scale(1.05)"
    }
  }, sx: {
    ":not(:first-of-type)": {
      mt: "-1px"
    }
  }, ...t, children: [g(h1, { w: { base: "100%", md: "212px", lg: "284px" }, borderRadius: H.sizes[2], overflow: "hidden", children: g(cs, { src: e.feature_image, alt: e.title, transitionProperty: "transform", transitionDuration: H.transition.duration["ultra-slow"], transitionTimingFunction: "ease-out" }) }), g(rd, { size: { base: H.sizes[6], md: H.sizes[10], lg: H.sizes[20] } }), X(re, { flexDirection: "column", justifyContent: "center", flexShrink: 0, flex: 1, children: [X(re, { justifyContent: "space-between", w: "100%", children: [g(mt, { variant: "heading", size: { base: "xs", md: "sm" }, fontWeight: "500", color: H.colors[r].text.primary, noOfLines: 2, children: e.title }), g(Zoe, { fontSize: H.sizes[8], color: H.colors[r].text.primary, ml: H.sizes[4], transitionProperty: "transform", transitionDuration: H.transition.duration["ultra-slow"], transitionTimingFunction: "ease" })] }), g(rd, { size: H.sizes[5] }), X(mt, { variant: "label", size: { base: "md", md: "lg" }, color: H.colors[r].text.secondary, children: [g(yae, { value: e.published_at, day: "2-digit", month: "short" }), " · ", g(vL, { id: "component.blog-card.reading-time", values: { value: e.reading_time || 3 } })] })] })] });
});
Le(({ variant: e, size: t, ...n }, r) => {
  const { colorMode: o } = Ee();
  return g(mt, { ref: r, variant: "body", size: { base: "md", md: "md" }, fontWeight: "500", color: H.colors[o].text.primary, textAlign: { base: "center", md: "center" }, ...n });
});
Le((e, t) => {
  const { colorMode: n } = Ee();
  return g(re, { ref: t, flexDirection: "column", alignItems: { base: "center", md: "center" }, justifyContent: "start", bg: H.colors[n].layer[2].default, color: H.colors[n].text.primary, border: `1px solid ${H.colors[n].border[2]}`, borderRadius: H.sizes[6], boxShadow: H.colors[n].shadow[4], px: { base: H.sizes[4], md: H.sizes[4] }, py: { base: H.sizes[8], md: H.sizes[8] }, sx: {
    svg: {
      fontSize: H.sizes[8],
      mb: H.sizes[4]
    }
  }, _hover: {
    cursor: "pointer",
    bg: H.colors[n].layer[2].hover
  }, ...e });
});
Le(({ variant: e, size: t, ...n }, r) => {
  const { colorMode: o } = Ee();
  return g(mt, { ref: r, variant: "body", size: { base: "md", md: "md" }, fontWeight: "500", color: H.colors[o].text.primary, textAlign: { base: "center", md: "center" }, ...n });
});
Le((e, t) => {
  const { colorMode: n } = Ee();
  return g(re, { ref: t, flexDirection: "column", alignItems: { base: "center", md: "center" }, justifyContent: "start", bg: H.colors[n].layer[2].default, color: H.colors[n].text.primary, border: `1px solid ${H.colors[n].border[2]}`, borderRadius: H.sizes[6], boxShadow: H.colors[n].shadow[4], px: { base: H.sizes[4], md: H.sizes[4] }, py: { base: H.sizes[8], md: H.sizes[8] }, transition: "transform 0.2s ease-in-out", sx: {
    svg: {
      fontSize: H.sizes[8],
      mb: H.sizes[4]
    }
  }, _hover: {
    cursor: "pointer",
    bg: H.colors[n].layer[2].hover,
    transform: `translate(0, -${H.sizes[2]})`
  }, ...e });
});
var Fl = "/", xae = (e, t) => (e.endsWith(Fl) && (e = e.slice(0, -1)), t.startsWith(Fl) || (t = Fl + t), e + t), wae = (e, t, n) => {
  let r = e.pathname === Fl ? t : xae(e.pathname, t), o = new globalThis.URL(r, e);
  if (n) for (let [i, a] of Object.entries(Mae(n))) if (a && typeof a == "object" && !Array.isArray(a)) for (let [l, c] of Object.entries(a)) o.searchParams.set(`${i}[${l}]`, String(c));
  else o.searchParams.set(i, a);
  return o;
};
function Sae(e) {
  return typeof e != "object" || !e ? !1 : "headers" in e && "ok" in e && "json" in e && typeof e.json == "function" && "text" in e && typeof e.json == "function";
}
async function Tae(e) {
  if (!(typeof e != "object" || !e)) {
    if (Sae(e)) {
      let t = e.headers.get("Content-Type")?.toLowerCase();
      if (t?.startsWith("application/json") || t?.startsWith("application/health+json")) {
        let n = await e.json();
        if (!e.ok) throw n;
        return "data" in n ? n.data : n;
      }
      if (t?.startsWith("text/html") || t?.startsWith("text/plain")) {
        let n = await e.text();
        if (!e.ok) throw n;
        return n;
      }
      return e;
    }
    return "data" in e ? e.data : e;
  }
}
var Aae = async (e, t, n = globalThis.fetch) => (t.headers = typeof t.headers == "object" && !Array.isArray(t.headers) ? t.headers : {}, n(e, t).then((r) => Tae(r).catch((o) => {
  let i = typeof o == "object" && "errors" in o ? o.errors : o;
  return Promise.reject({ errors: i, response: r });
}))), Qv = { fetch: globalThis.fetch, WebSocket: globalThis.WebSocket, URL: globalThis.URL, logger: globalThis.console }, Iae = (e, t = {}) => {
  let n = t.globals ? { ...Qv, ...t.globals } : Qv;
  return { globals: n, url: new n.URL(e), with(r) {
    return { ...this, ...r(this) };
  } };
};
function Lae(e) {
  return ["directus_activity", "directus_collections", "directus_fields", "directus_files", "directus_folders", "directus_migrations", "directus_permissions", "directus_presets", "directus_relations", "directus_revisions", "directus_roles", "directus_sessions", "directus_settings", "directus_users", "directus_webhooks", "directus_dashboards", "directus_panels", "directus_notifications", "directus_shares", "directus_flows", "directus_operations", "directus_translations", "directus_versions", "directus_extensions"].includes(e);
}
var Eae = (e) => {
  let t = (n, r = []) => {
    if (typeof n == "object") {
      let o = [];
      for (let i in n) {
        let a = n[i] ?? [];
        if (Array.isArray(a)) for (let l of a) o.push(t(l, [...r, i]));
        else if (typeof a == "object") for (let l of Object.keys(a)) {
          let c = a[l];
          for (let u of c) o.push(t(u, [...r, `${i}:${l}`]));
        }
      }
      return o.flatMap((i) => i);
    }
    return [...r, String(n)].join(".");
  };
  return e.flatMap((n) => t(n));
}, Mae = (e) => {
  let t = {};
  Array.isArray(e.fields) && e.fields.length > 0 && (t.fields = Eae(e.fields).join(",")), e.filter && Object.keys(e.filter).length > 0 && (t.filter = JSON.stringify(e.filter)), e.search && (t.search = e.search), "sort" in e && e.sort && (t.sort = typeof e.sort == "string" ? e.sort : e.sort.join(",")), typeof e.limit == "number" && e.limit >= -1 && (t.limit = String(e.limit)), typeof e.offset == "number" && e.offset >= 0 && (t.offset = String(e.offset)), typeof e.page == "number" && e.page >= 1 && (t.page = String(e.page)), e.deep && Object.keys(e.deep).length > 0 && (t.deep = JSON.stringify(e.deep)), e.alias && Object.keys(e.alias).length > 0 && (t.alias = JSON.stringify(e.alias)), e.aggregate && Object.keys(e.aggregate).length > 0 && (t.aggregate = JSON.stringify(e.aggregate)), e.groupBy && e.groupBy.length > 0 && (t.groupBy = e.groupBy.join(","));
  for (let [n, r] of Object.entries(e)) n in t || (typeof r == "string" || typeof r == "number" || typeof r == "boolean" ? t[n] = String(r) : t[n] = JSON.stringify(r));
  return t;
}, Bae = (e, t) => {
  if (e.length === 0) throw new Error(t);
}, kae = (e, t) => {
  if (Lae(String(e))) throw new Error(t);
}, Lp = (e, t) => () => (Bae(String(e), "Collection cannot be empty"), kae(e, "Cannot use readItems for core collections"), { path: `/items/${e}`, params: t ?? {}, method: "GET" }), Rae = {}, _ae = (e = {}) => (t) => {
  let n = { ...Rae, ...e };
  return { async request(r) {
    let o = r();
    if (o.headers || (o.headers = {}), "Content-Type" in o.headers ? o.headers["Content-Type"] === "multipart/form-data" && delete o.headers["Content-Type"] : o.headers["Content-Type"] = "application/json", "getToken" in this) {
      let c = await this.getToken();
      c && (o.headers || (o.headers = {}), o.headers.Authorization = `Bearer ${c}`);
    }
    let i = wae(t.url, o.path, o.params), a = { method: o.method ?? "GET", headers: o.headers ?? {} };
    "credentials" in n && (a.credentials = n.credentials), o.body && (a.body = o.body), o.onRequest && (a = await o.onRequest(a)), n.onRequest && (a = await n.onRequest(a));
    let l = await Aae(i.toString(), a, t.globals.fetch);
    return "onResponse" in o && (l = await o.onResponse(l, a)), "onResponse" in e && (l = await e.onResponse(l, a)), l;
  } };
}, yL = typeof global == "object" && global && global.Object === Object && global, Fae = typeof self == "object" && self && self.Object === Object && self, oo = yL || Fae || Function("return this")(), Or = oo.Symbol, xL = Object.prototype, Pae = xL.hasOwnProperty, Vae = xL.toString, F5 = Or ? Or.toStringTag : void 0;
function Hae(e) {
  var t = Pae.call(e, F5), n = e[F5];
  try {
    e[F5] = void 0;
    var r = !0;
  } catch {
  }
  var o = Vae.call(e);
  return r && (t ? e[F5] = n : delete e[F5]), o;
}
var Oae = Object.prototype, Nae = Oae.toString;
function Dae(e) {
  return Nae.call(e);
}
var Zae = "[object Null]", zae = "[object Undefined]", qv = Or ? Or.toStringTag : void 0;
function p2(e) {
  return e == null ? e === void 0 ? zae : Zae : qv && qv in Object(e) ? Hae(e) : Dae(e);
}
function mi(e) {
  return e != null && typeof e == "object";
}
var Gae = "[object Symbol]";
function t6(e) {
  return typeof e == "symbol" || mi(e) && p2(e) == Gae;
}
function Ep(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = Array(r); ++n < r; )
    o[n] = t(e[n], n, e);
  return o;
}
var to = Array.isArray, Wae = 1 / 0, Kv = Or ? Or.prototype : void 0, ey = Kv ? Kv.toString : void 0;
function wL(e) {
  if (typeof e == "string")
    return e;
  if (to(e))
    return Ep(e, wL) + "";
  if (t6(e))
    return ey ? ey.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Wae ? "-0" : t;
}
var $ae = /\s/;
function Uae(e) {
  for (var t = e.length; t-- && $ae.test(e.charAt(t)); )
    ;
  return t;
}
var jae = /^\s+/;
function Xae(e) {
  return e && e.slice(0, Uae(e) + 1).replace(jae, "");
}
function Nr(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var ty = NaN, Yae = /^[-+]0x[0-9a-f]+$/i, Jae = /^0b[01]+$/i, Qae = /^0o[0-7]+$/i, qae = parseInt;
function od(e) {
  if (typeof e == "number")
    return e;
  if (t6(e))
    return ty;
  if (Nr(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Nr(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Xae(e);
  var n = Jae.test(e);
  return n || Qae.test(e) ? qae(e.slice(2), n ? 2 : 8) : Yae.test(e) ? ty : +e;
}
var ny = 1 / 0, Kae = 17976931348623157e292;
function e2e(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = od(e), e === ny || e === -ny) {
    var t = e < 0 ? -1 : 1;
    return t * Kae;
  }
  return e === e ? e : 0;
}
function t2e(e) {
  var t = e2e(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
function SL(e) {
  return e;
}
var n2e = "[object AsyncFunction]", r2e = "[object Function]", o2e = "[object GeneratorFunction]", i2e = "[object Proxy]";
function TL(e) {
  if (!Nr(e))
    return !1;
  var t = p2(e);
  return t == r2e || t == o2e || t == n2e || t == i2e;
}
var Sc = oo["__core-js_shared__"], ry = function() {
  var e = /[^.]+$/.exec(Sc && Sc.keys && Sc.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function a2e(e) {
  return !!ry && ry in e;
}
var s2e = Function.prototype, l2e = s2e.toString;
function h2(e) {
  if (e != null) {
    try {
      return l2e.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var c2e = /[\\^$.*+?()[\]{}|]/g, u2e = /^\[object .+?Constructor\]$/, d2e = Function.prototype, f2e = Object.prototype, p2e = d2e.toString, h2e = f2e.hasOwnProperty, m2e = RegExp(
  "^" + p2e.call(h2e).replace(c2e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function C2e(e) {
  if (!Nr(e) || a2e(e))
    return !1;
  var t = TL(e) ? m2e : u2e;
  return t.test(h2(e));
}
function g2e(e, t) {
  return e?.[t];
}
function m2(e, t) {
  var n = g2e(e, t);
  return C2e(n) ? n : void 0;
}
var id = m2(oo, "WeakMap"), oy = Object.create, b2e = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Nr(t))
      return {};
    if (oy)
      return oy(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function v2e(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
function y2e(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var x2e = 800, w2e = 16, S2e = Date.now;
function T2e(e) {
  var t = 0, n = 0;
  return function() {
    var r = S2e(), o = w2e - (r - n);
    if (n = r, o > 0) {
      if (++t >= x2e)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function A2e(e) {
  return function() {
    return e;
  };
}
var d9 = function() {
  try {
    var e = m2(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), I2e = d9 ? function(e, t) {
  return d9(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: A2e(t),
    writable: !0
  });
} : SL, L2e = T2e(I2e);
function E2e(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
function M2e(e, t, n, r) {
  for (var o = e.length, i = n + -1; ++i < o; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
var B2e = 9007199254740991, k2e = /^(?:0|[1-9]\d*)$/;
function Mp(e, t) {
  var n = typeof e;
  return t = t ?? B2e, !!t && (n == "number" || n != "symbol" && k2e.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Bp(e, t, n) {
  t == "__proto__" && d9 ? d9(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function kp(e, t) {
  return e === t || e !== e && t !== t;
}
var R2e = Object.prototype, _2e = R2e.hasOwnProperty;
function Rp(e, t, n) {
  var r = e[t];
  (!(_2e.call(e, t) && kp(r, n)) || n === void 0 && !(t in e)) && Bp(e, t, n);
}
function p3(e, t, n, r) {
  var o = !n;
  n || (n = {});
  for (var i = -1, a = t.length; ++i < a; ) {
    var l = t[i], c = void 0;
    c === void 0 && (c = e[l]), o ? Bp(n, l, c) : Rp(n, l, c);
  }
  return n;
}
var iy = Math.max;
function F2e(e, t, n) {
  return t = iy(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, o = -1, i = iy(r.length - t, 0), a = Array(i); ++o < i; )
      a[o] = r[t + o];
    o = -1;
    for (var l = Array(t + 1); ++o < t; )
      l[o] = r[o];
    return l[t] = n(a), v2e(e, this, l);
  };
}
var P2e = 9007199254740991;
function _p(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= P2e;
}
function Fp(e) {
  return e != null && _p(e.length) && !TL(e);
}
var V2e = Object.prototype;
function Pp(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || V2e;
  return e === n;
}
function H2e(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var O2e = "[object Arguments]";
function ay(e) {
  return mi(e) && p2(e) == O2e;
}
var AL = Object.prototype, N2e = AL.hasOwnProperty, D2e = AL.propertyIsEnumerable, Vp = ay(/* @__PURE__ */ function() {
  return arguments;
}()) ? ay : function(e) {
  return mi(e) && N2e.call(e, "callee") && !D2e.call(e, "callee");
};
function Z2e() {
  return !1;
}
var IL = typeof exports == "object" && exports && !exports.nodeType && exports, sy = IL && typeof module == "object" && module && !module.nodeType && module, z2e = sy && sy.exports === IL, ly = z2e ? oo.Buffer : void 0, G2e = ly ? ly.isBuffer : void 0, f9 = G2e || Z2e, W2e = "[object Arguments]", $2e = "[object Array]", U2e = "[object Boolean]", j2e = "[object Date]", X2e = "[object Error]", Y2e = "[object Function]", J2e = "[object Map]", Q2e = "[object Number]", q2e = "[object Object]", K2e = "[object RegExp]", ese = "[object Set]", tse = "[object String]", nse = "[object WeakMap]", rse = "[object ArrayBuffer]", ose = "[object DataView]", ise = "[object Float32Array]", ase = "[object Float64Array]", sse = "[object Int8Array]", lse = "[object Int16Array]", cse = "[object Int32Array]", use = "[object Uint8Array]", dse = "[object Uint8ClampedArray]", fse = "[object Uint16Array]", pse = "[object Uint32Array]", wt = {};
wt[ise] = wt[ase] = wt[sse] = wt[lse] = wt[cse] = wt[use] = wt[dse] = wt[fse] = wt[pse] = !0;
wt[W2e] = wt[$2e] = wt[rse] = wt[U2e] = wt[ose] = wt[j2e] = wt[X2e] = wt[Y2e] = wt[J2e] = wt[Q2e] = wt[q2e] = wt[K2e] = wt[ese] = wt[tse] = wt[nse] = !1;
function hse(e) {
  return mi(e) && _p(e.length) && !!wt[p2(e)];
}
function Hp(e) {
  return function(t) {
    return e(t);
  };
}
var LL = typeof exports == "object" && exports && !exports.nodeType && exports, u0 = LL && typeof module == "object" && module && !module.nodeType && module, mse = u0 && u0.exports === LL, Tc = mse && yL.process, Rs = function() {
  try {
    var e = u0 && u0.require && u0.require("util").types;
    return e || Tc && Tc.binding && Tc.binding("util");
  } catch {
  }
}(), cy = Rs && Rs.isTypedArray, EL = cy ? Hp(cy) : hse, Cse = Object.prototype, gse = Cse.hasOwnProperty;
function ML(e, t) {
  var n = to(e), r = !n && Vp(e), o = !n && !r && f9(e), i = !n && !r && !o && EL(e), a = n || r || o || i, l = a ? H2e(e.length, String) : [], c = l.length;
  for (var u in e)
    (t || gse.call(e, u)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    Mp(u, c))) && l.push(u);
  return l;
}
function BL(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var bse = BL(Object.keys, Object), vse = Object.prototype, yse = vse.hasOwnProperty;
function xse(e) {
  if (!Pp(e))
    return bse(e);
  var t = [];
  for (var n in Object(e))
    yse.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function Os(e) {
  return Fp(e) ? ML(e) : xse(e);
}
function wse(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var Sse = Object.prototype, Tse = Sse.hasOwnProperty;
function Ase(e) {
  if (!Nr(e))
    return wse(e);
  var t = Pp(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !Tse.call(e, r)) || n.push(r);
  return n;
}
function Op(e) {
  return Fp(e) ? ML(e, !0) : Ase(e);
}
var Ise = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Lse = /^\w*$/;
function Np(e, t) {
  if (to(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || t6(e) ? !0 : Lse.test(e) || !Ise.test(e) || t != null && e in Object(t);
}
var R0 = m2(Object, "create");
function Ese() {
  this.__data__ = R0 ? R0(null) : {}, this.size = 0;
}
function Mse(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Bse = "__lodash_hash_undefined__", kse = Object.prototype, Rse = kse.hasOwnProperty;
function _se(e) {
  var t = this.__data__;
  if (R0) {
    var n = t[e];
    return n === Bse ? void 0 : n;
  }
  return Rse.call(t, e) ? t[e] : void 0;
}
var Fse = Object.prototype, Pse = Fse.hasOwnProperty;
function Vse(e) {
  var t = this.__data__;
  return R0 ? t[e] !== void 0 : Pse.call(t, e);
}
var Hse = "__lodash_hash_undefined__";
function Ose(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = R0 && t === void 0 ? Hse : t, this;
}
function e2(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
e2.prototype.clear = Ese;
e2.prototype.delete = Mse;
e2.prototype.get = _se;
e2.prototype.has = Vse;
e2.prototype.set = Ose;
function Nse() {
  this.__data__ = [], this.size = 0;
}
function n6(e, t) {
  for (var n = e.length; n--; )
    if (kp(e[n][0], t))
      return n;
  return -1;
}
var Dse = Array.prototype, Zse = Dse.splice;
function zse(e) {
  var t = this.__data__, n = n6(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Zse.call(t, n, 1), --this.size, !0;
}
function Gse(e) {
  var t = this.__data__, n = n6(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function Wse(e) {
  return n6(this.__data__, e) > -1;
}
function $se(e, t) {
  var n = this.__data__, r = n6(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function vi(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
vi.prototype.clear = Nse;
vi.prototype.delete = zse;
vi.prototype.get = Gse;
vi.prototype.has = Wse;
vi.prototype.set = $se;
var _0 = m2(oo, "Map");
function Use() {
  this.size = 0, this.__data__ = {
    hash: new e2(),
    map: new (_0 || vi)(),
    string: new e2()
  };
}
function jse(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function r6(e, t) {
  var n = e.__data__;
  return jse(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Xse(e) {
  var t = r6(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Yse(e) {
  return r6(this, e).get(e);
}
function Jse(e) {
  return r6(this, e).has(e);
}
function Qse(e, t) {
  var n = r6(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function yi(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
yi.prototype.clear = Use;
yi.prototype.delete = Xse;
yi.prototype.get = Yse;
yi.prototype.has = Jse;
yi.prototype.set = Qse;
var qse = "Expected a function";
function Dp(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(qse);
  var n = function() {
    var r = arguments, o = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(o))
      return i.get(o);
    var a = e.apply(this, r);
    return n.cache = i.set(o, a) || i, a;
  };
  return n.cache = new (Dp.Cache || yi)(), n;
}
Dp.Cache = yi;
var Kse = 500;
function e5e(e) {
  var t = Dp(e, function(r) {
    return n.size === Kse && n.clear(), r;
  }), n = t.cache;
  return t;
}
var t5e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n5e = /\\(\\)?/g, r5e = e5e(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(t5e, function(n, r, o, i) {
    t.push(o ? i.replace(n5e, "$1") : r || n);
  }), t;
});
function kL(e) {
  return e == null ? "" : wL(e);
}
function Ns(e, t) {
  return to(e) ? e : Np(e, t) ? [e] : r5e(kL(e));
}
var o5e = 1 / 0;
function Ds(e) {
  if (typeof e == "string" || t6(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -o5e ? "-0" : t;
}
function o6(e, t) {
  t = Ns(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[Ds(t[n++])];
  return n && n == r ? e : void 0;
}
function i5e(e, t, n) {
  var r = e == null ? void 0 : o6(e, t);
  return r === void 0 ? n : r;
}
function Zp(e, t) {
  for (var n = -1, r = t.length, o = e.length; ++n < r; )
    e[o + n] = t[n];
  return e;
}
var uy = Or ? Or.isConcatSpreadable : void 0;
function a5e(e) {
  return to(e) || Vp(e) || !!(uy && e && e[uy]);
}
function s5e(e, t, n, r, o) {
  var i = -1, a = e.length;
  for (n || (n = a5e), o || (o = []); ++i < a; ) {
    var l = e[i];
    n(l) ? Zp(o, l) : o[o.length] = l;
  }
  return o;
}
function l5e(e) {
  var t = e == null ? 0 : e.length;
  return t ? s5e(e) : [];
}
function RL(e) {
  return L2e(F2e(e, void 0, l5e), e + "");
}
var zp = BL(Object.getPrototypeOf, Object), c5e = "[object Object]", u5e = Function.prototype, d5e = Object.prototype, _L = u5e.toString, f5e = d5e.hasOwnProperty, p5e = _L.call(Object);
function h5e(e) {
  if (!mi(e) || p2(e) != c5e)
    return !1;
  var t = zp(e);
  if (t === null)
    return !0;
  var n = f5e.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && _L.call(n) == p5e;
}
function m5e(e, t, n) {
  var r = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), n = n > o ? o : n, n < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var i = Array(o); ++r < o; )
    i[r] = e[r + t];
  return i;
}
function C5e() {
  this.__data__ = new vi(), this.size = 0;
}
function g5e(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function b5e(e) {
  return this.__data__.get(e);
}
function v5e(e) {
  return this.__data__.has(e);
}
var y5e = 200;
function x5e(e, t) {
  var n = this.__data__;
  if (n instanceof vi) {
    var r = n.__data__;
    if (!_0 || r.length < y5e - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new yi(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function Eo(e) {
  var t = this.__data__ = new vi(e);
  this.size = t.size;
}
Eo.prototype.clear = C5e;
Eo.prototype.delete = g5e;
Eo.prototype.get = b5e;
Eo.prototype.has = v5e;
Eo.prototype.set = x5e;
function w5e(e, t) {
  return e && p3(t, Os(t), e);
}
function S5e(e, t) {
  return e && p3(t, Op(t), e);
}
var FL = typeof exports == "object" && exports && !exports.nodeType && exports, dy = FL && typeof module == "object" && module && !module.nodeType && module, T5e = dy && dy.exports === FL, fy = T5e ? oo.Buffer : void 0, py = fy ? fy.allocUnsafe : void 0;
function A5e(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = py ? py(n) : new e.constructor(n);
  return e.copy(r), r;
}
function I5e(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = 0, i = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (i[o++] = a);
  }
  return i;
}
function PL() {
  return [];
}
var L5e = Object.prototype, E5e = L5e.propertyIsEnumerable, hy = Object.getOwnPropertySymbols, Gp = hy ? function(e) {
  return e == null ? [] : (e = Object(e), I5e(hy(e), function(t) {
    return E5e.call(e, t);
  }));
} : PL;
function M5e(e, t) {
  return p3(e, Gp(e), t);
}
var B5e = Object.getOwnPropertySymbols, VL = B5e ? function(e) {
  for (var t = []; e; )
    Zp(t, Gp(e)), e = zp(e);
  return t;
} : PL;
function k5e(e, t) {
  return p3(e, VL(e), t);
}
function HL(e, t, n) {
  var r = t(e);
  return to(e) ? r : Zp(r, n(e));
}
function ad(e) {
  return HL(e, Os, Gp);
}
function Wp(e) {
  return HL(e, Op, VL);
}
var sd = m2(oo, "DataView"), ld = m2(oo, "Promise"), cd = m2(oo, "Set"), my = "[object Map]", R5e = "[object Object]", Cy = "[object Promise]", gy = "[object Set]", by = "[object WeakMap]", vy = "[object DataView]", _5e = h2(sd), F5e = h2(_0), P5e = h2(ld), V5e = h2(cd), H5e = h2(id), Jr = p2;
(sd && Jr(new sd(new ArrayBuffer(1))) != vy || _0 && Jr(new _0()) != my || ld && Jr(ld.resolve()) != Cy || cd && Jr(new cd()) != gy || id && Jr(new id()) != by) && (Jr = function(e) {
  var t = p2(e), n = t == R5e ? e.constructor : void 0, r = n ? h2(n) : "";
  if (r)
    switch (r) {
      case _5e:
        return vy;
      case F5e:
        return my;
      case P5e:
        return Cy;
      case V5e:
        return gy;
      case H5e:
        return by;
    }
  return t;
});
var O5e = Object.prototype, N5e = O5e.hasOwnProperty;
function D5e(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && N5e.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var p9 = oo.Uint8Array;
function $p(e) {
  var t = new e.constructor(e.byteLength);
  return new p9(t).set(new p9(e)), t;
}
function Z5e(e, t) {
  var n = t ? $p(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var z5e = /\w*$/;
function G5e(e) {
  var t = new e.constructor(e.source, z5e.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var yy = Or ? Or.prototype : void 0, xy = yy ? yy.valueOf : void 0;
function W5e(e) {
  return xy ? Object(xy.call(e)) : {};
}
function $5e(e, t) {
  var n = t ? $p(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var U5e = "[object Boolean]", j5e = "[object Date]", X5e = "[object Map]", Y5e = "[object Number]", J5e = "[object RegExp]", Q5e = "[object Set]", q5e = "[object String]", K5e = "[object Symbol]", e0e = "[object ArrayBuffer]", t0e = "[object DataView]", n0e = "[object Float32Array]", r0e = "[object Float64Array]", o0e = "[object Int8Array]", i0e = "[object Int16Array]", a0e = "[object Int32Array]", s0e = "[object Uint8Array]", l0e = "[object Uint8ClampedArray]", c0e = "[object Uint16Array]", u0e = "[object Uint32Array]";
function d0e(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case e0e:
      return $p(e);
    case U5e:
    case j5e:
      return new r(+e);
    case t0e:
      return Z5e(e, n);
    case n0e:
    case r0e:
    case o0e:
    case i0e:
    case a0e:
    case s0e:
    case l0e:
    case c0e:
    case u0e:
      return $5e(e, n);
    case X5e:
      return new r();
    case Y5e:
    case q5e:
      return new r(e);
    case J5e:
      return G5e(e);
    case Q5e:
      return new r();
    case K5e:
      return W5e(e);
  }
}
function f0e(e) {
  return typeof e.constructor == "function" && !Pp(e) ? b2e(zp(e)) : {};
}
var p0e = "[object Map]";
function h0e(e) {
  return mi(e) && Jr(e) == p0e;
}
var wy = Rs && Rs.isMap, m0e = wy ? Hp(wy) : h0e, C0e = "[object Set]";
function g0e(e) {
  return mi(e) && Jr(e) == C0e;
}
var Sy = Rs && Rs.isSet, b0e = Sy ? Hp(Sy) : g0e, v0e = 1, y0e = 2, x0e = 4, OL = "[object Arguments]", w0e = "[object Array]", S0e = "[object Boolean]", T0e = "[object Date]", A0e = "[object Error]", NL = "[object Function]", I0e = "[object GeneratorFunction]", L0e = "[object Map]", E0e = "[object Number]", DL = "[object Object]", M0e = "[object RegExp]", B0e = "[object Set]", k0e = "[object String]", R0e = "[object Symbol]", _0e = "[object WeakMap]", F0e = "[object ArrayBuffer]", P0e = "[object DataView]", V0e = "[object Float32Array]", H0e = "[object Float64Array]", O0e = "[object Int8Array]", N0e = "[object Int16Array]", D0e = "[object Int32Array]", Z0e = "[object Uint8Array]", z0e = "[object Uint8ClampedArray]", G0e = "[object Uint16Array]", W0e = "[object Uint32Array]", bt = {};
bt[OL] = bt[w0e] = bt[F0e] = bt[P0e] = bt[S0e] = bt[T0e] = bt[V0e] = bt[H0e] = bt[O0e] = bt[N0e] = bt[D0e] = bt[L0e] = bt[E0e] = bt[DL] = bt[M0e] = bt[B0e] = bt[k0e] = bt[R0e] = bt[Z0e] = bt[z0e] = bt[G0e] = bt[W0e] = !0;
bt[A0e] = bt[NL] = bt[_0e] = !1;
function Pl(e, t, n, r, o, i) {
  var a, l = t & v0e, c = t & y0e, u = t & x0e;
  if (n && (a = o ? n(e, r, o, i) : n(e)), a !== void 0)
    return a;
  if (!Nr(e))
    return e;
  var f = to(e);
  if (f) {
    if (a = D5e(e), !l)
      return y2e(e, a);
  } else {
    var p = Jr(e), h = p == NL || p == I0e;
    if (f9(e))
      return A5e(e, l);
    if (p == DL || p == OL || h && !o) {
      if (a = c || h ? {} : f0e(e), !l)
        return c ? k5e(e, S5e(a, e)) : M5e(e, w5e(a, e));
    } else {
      if (!bt[p])
        return o ? e : {};
      a = d0e(e, p, l);
    }
  }
  i || (i = new Eo());
  var C = i.get(e);
  if (C)
    return C;
  i.set(e, a), b0e(e) ? e.forEach(function(y) {
    a.add(Pl(y, t, n, y, e, i));
  }) : m0e(e) && e.forEach(function(y, x) {
    a.set(x, Pl(y, t, n, x, e, i));
  });
  var v = u ? c ? Wp : ad : c ? Op : Os, b = f ? void 0 : v(e);
  return E2e(b || e, function(y, x) {
    b && (x = y, y = e[x]), Rp(a, x, Pl(y, t, n, x, e, i));
  }), a;
}
var $0e = "__lodash_hash_undefined__";
function U0e(e) {
  return this.__data__.set(e, $0e), this;
}
function j0e(e) {
  return this.__data__.has(e);
}
function h9(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new yi(); ++t < n; )
    this.add(e[t]);
}
h9.prototype.add = h9.prototype.push = U0e;
h9.prototype.has = j0e;
function X0e(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function Y0e(e, t) {
  return e.has(t);
}
var J0e = 1, Q0e = 2;
function ZL(e, t, n, r, o, i) {
  var a = n & J0e, l = e.length, c = t.length;
  if (l != c && !(a && c > l))
    return !1;
  var u = i.get(e), f = i.get(t);
  if (u && f)
    return u == t && f == e;
  var p = -1, h = !0, C = n & Q0e ? new h9() : void 0;
  for (i.set(e, t), i.set(t, e); ++p < l; ) {
    var v = e[p], b = t[p];
    if (r)
      var y = a ? r(b, v, p, t, e, i) : r(v, b, p, e, t, i);
    if (y !== void 0) {
      if (y)
        continue;
      h = !1;
      break;
    }
    if (C) {
      if (!X0e(t, function(x, T) {
        if (!Y0e(C, T) && (v === x || o(v, x, n, r, i)))
          return C.push(T);
      })) {
        h = !1;
        break;
      }
    } else if (!(v === b || o(v, b, n, r, i))) {
      h = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), h;
}
function q0e(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, o) {
    n[++t] = [o, r];
  }), n;
}
function K0e(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var e3e = 1, t3e = 2, n3e = "[object Boolean]", r3e = "[object Date]", o3e = "[object Error]", i3e = "[object Map]", a3e = "[object Number]", s3e = "[object RegExp]", l3e = "[object Set]", c3e = "[object String]", u3e = "[object Symbol]", d3e = "[object ArrayBuffer]", f3e = "[object DataView]", Ty = Or ? Or.prototype : void 0, Ac = Ty ? Ty.valueOf : void 0;
function p3e(e, t, n, r, o, i, a) {
  switch (n) {
    case f3e:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case d3e:
      return !(e.byteLength != t.byteLength || !i(new p9(e), new p9(t)));
    case n3e:
    case r3e:
    case a3e:
      return kp(+e, +t);
    case o3e:
      return e.name == t.name && e.message == t.message;
    case s3e:
    case c3e:
      return e == t + "";
    case i3e:
      var l = q0e;
    case l3e:
      var c = r & e3e;
      if (l || (l = K0e), e.size != t.size && !c)
        return !1;
      var u = a.get(e);
      if (u)
        return u == t;
      r |= t3e, a.set(e, t);
      var f = ZL(l(e), l(t), r, o, i, a);
      return a.delete(e), f;
    case u3e:
      if (Ac)
        return Ac.call(e) == Ac.call(t);
  }
  return !1;
}
var h3e = 1, m3e = Object.prototype, C3e = m3e.hasOwnProperty;
function g3e(e, t, n, r, o, i) {
  var a = n & h3e, l = ad(e), c = l.length, u = ad(t), f = u.length;
  if (c != f && !a)
    return !1;
  for (var p = c; p--; ) {
    var h = l[p];
    if (!(a ? h in t : C3e.call(t, h)))
      return !1;
  }
  var C = i.get(e), v = i.get(t);
  if (C && v)
    return C == t && v == e;
  var b = !0;
  i.set(e, t), i.set(t, e);
  for (var y = a; ++p < c; ) {
    h = l[p];
    var x = e[h], T = t[h];
    if (r)
      var A = a ? r(T, x, h, t, e, i) : r(x, T, h, e, t, i);
    if (!(A === void 0 ? x === T || o(x, T, n, r, i) : A)) {
      b = !1;
      break;
    }
    y || (y = h == "constructor");
  }
  if (b && !y) {
    var L = e.constructor, I = t.constructor;
    L != I && "constructor" in e && "constructor" in t && !(typeof L == "function" && L instanceof L && typeof I == "function" && I instanceof I) && (b = !1);
  }
  return i.delete(e), i.delete(t), b;
}
var b3e = 1, Ay = "[object Arguments]", Iy = "[object Array]", cl = "[object Object]", v3e = Object.prototype, Ly = v3e.hasOwnProperty;
function y3e(e, t, n, r, o, i) {
  var a = to(e), l = to(t), c = a ? Iy : Jr(e), u = l ? Iy : Jr(t);
  c = c == Ay ? cl : c, u = u == Ay ? cl : u;
  var f = c == cl, p = u == cl, h = c == u;
  if (h && f9(e)) {
    if (!f9(t))
      return !1;
    a = !0, f = !1;
  }
  if (h && !f)
    return i || (i = new Eo()), a || EL(e) ? ZL(e, t, n, r, o, i) : p3e(e, t, c, n, r, o, i);
  if (!(n & b3e)) {
    var C = f && Ly.call(e, "__wrapped__"), v = p && Ly.call(t, "__wrapped__");
    if (C || v) {
      var b = C ? e.value() : e, y = v ? t.value() : t;
      return i || (i = new Eo()), o(b, y, n, r, i);
    }
  }
  return h ? (i || (i = new Eo()), g3e(e, t, n, r, o, i)) : !1;
}
function Up(e, t, n, r, o) {
  return e === t ? !0 : e == null || t == null || !mi(e) && !mi(t) ? e !== e && t !== t : y3e(e, t, n, r, Up, o);
}
var x3e = 1, w3e = 2;
function S3e(e, t, n, r) {
  var o = n.length, i = o;
  if (e == null)
    return !i;
  for (e = Object(e); o--; ) {
    var a = n[o];
    if (a[2] ? a[1] !== e[a[0]] : !(a[0] in e))
      return !1;
  }
  for (; ++o < i; ) {
    a = n[o];
    var l = a[0], c = e[l], u = a[1];
    if (a[2]) {
      if (c === void 0 && !(l in e))
        return !1;
    } else {
      var f = new Eo(), p;
      if (!(p === void 0 ? Up(u, c, x3e | w3e, r, f) : p))
        return !1;
    }
  }
  return !0;
}
function zL(e) {
  return e === e && !Nr(e);
}
function T3e(e) {
  for (var t = Os(e), n = t.length; n--; ) {
    var r = t[n], o = e[r];
    t[n] = [r, o, zL(o)];
  }
  return t;
}
function GL(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function A3e(e) {
  var t = T3e(e);
  return t.length == 1 && t[0][2] ? GL(t[0][0], t[0][1]) : function(n) {
    return n === e || S3e(n, e, t);
  };
}
function I3e(e, t) {
  return e != null && t in Object(e);
}
function L3e(e, t, n) {
  t = Ns(t, e);
  for (var r = -1, o = t.length, i = !1; ++r < o; ) {
    var a = Ds(t[r]);
    if (!(i = e != null && n(e, a)))
      break;
    e = e[a];
  }
  return i || ++r != o ? i : (o = e == null ? 0 : e.length, !!o && _p(o) && Mp(a, o) && (to(e) || Vp(e)));
}
function WL(e, t) {
  return e != null && L3e(e, t, I3e);
}
var E3e = 1, M3e = 2;
function B3e(e, t) {
  return Np(e) && zL(t) ? GL(Ds(e), t) : function(n) {
    var r = i5e(n, e);
    return r === void 0 && r === t ? WL(n, e) : Up(t, r, E3e | M3e);
  };
}
function k3e(e) {
  return function(t) {
    return t?.[e];
  };
}
function R3e(e) {
  return function(t) {
    return o6(t, e);
  };
}
function _3e(e) {
  return Np(e) ? k3e(Ds(e)) : R3e(e);
}
function h3(e) {
  return typeof e == "function" ? e : e == null ? SL : typeof e == "object" ? to(e) ? B3e(e[0], e[1]) : A3e(e) : _3e(e);
}
function F3e(e) {
  return function(t, n, r) {
    for (var o = -1, i = Object(t), a = r(t), l = a.length; l--; ) {
      var c = a[++o];
      if (n(i[c], c, i) === !1)
        break;
    }
    return t;
  };
}
var P3e = F3e();
function V3e(e, t) {
  return e && P3e(e, t, Os);
}
var Ic = function() {
  return oo.Date.now();
}, H3e = "Expected a function", O3e = Math.max, N3e = Math.min;
function D3e(e, t, n) {
  var r, o, i, a, l, c, u = 0, f = !1, p = !1, h = !0;
  if (typeof e != "function")
    throw new TypeError(H3e);
  t = od(t) || 0, Nr(n) && (f = !!n.leading, p = "maxWait" in n, i = p ? O3e(od(n.maxWait) || 0, t) : i, h = "trailing" in n ? !!n.trailing : h);
  function C(M) {
    var k = r, _ = o;
    return r = o = void 0, u = M, a = e.apply(_, k), a;
  }
  function v(M) {
    return u = M, l = setTimeout(x, t), f ? C(M) : a;
  }
  function b(M) {
    var k = M - c, _ = M - u, F = t - k;
    return p ? N3e(F, i - _) : F;
  }
  function y(M) {
    var k = M - c, _ = M - u;
    return c === void 0 || k >= t || k < 0 || p && _ >= i;
  }
  function x() {
    var M = Ic();
    if (y(M))
      return T(M);
    l = setTimeout(x, b(M));
  }
  function T(M) {
    return l = void 0, h && r ? C(M) : (r = o = void 0, a);
  }
  function A() {
    l !== void 0 && clearTimeout(l), u = 0, r = c = o = l = void 0;
  }
  function L() {
    return l === void 0 ? a : T(Ic());
  }
  function I() {
    var M = Ic(), k = y(M);
    if (r = arguments, o = this, c = M, k) {
      if (l === void 0)
        return v(c);
      if (p)
        return clearTimeout(l), l = setTimeout(x, t), C(c);
    }
    return l === void 0 && (l = setTimeout(x, t)), a;
  }
  return I.cancel = A, I.flush = L, I;
}
function Z3e(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var $L = /[\\^$.*+?()[\]{}|]/g, z3e = RegExp($L.source);
function G3e(e) {
  return e = kL(e), e && z3e.test(e) ? e.replace($L, "\\$&") : e;
}
function W3e(e) {
  return function(t, n, r) {
    var o = Object(t);
    if (!Fp(t)) {
      var i = h3(n);
      t = Os(t), n = function(l) {
        return i(o[l], l, o);
      };
    }
    var a = e(t, n, r);
    return a > -1 ? o[i ? t[a] : a] : void 0;
  };
}
var $3e = Math.max;
function U3e(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var o = n == null ? 0 : t2e(n);
  return o < 0 && (o = $3e(r + o, 0)), M2e(e, h3(t), o);
}
var Ey = W3e(U3e);
function j3e(e, t) {
  return t.length < 2 ? e : o6(e, m5e(t, 0, -1));
}
function UL(e, t) {
  var n = {};
  return t = h3(t), V3e(e, function(r, o, i) {
    Bp(n, o, t(r, o, i));
  }), n;
}
var X3e = "Expected a function";
function Y3e(e) {
  if (typeof e != "function")
    throw new TypeError(X3e);
  return function() {
    var t = arguments;
    switch (t.length) {
      case 0:
        return !e.call(this);
      case 1:
        return !e.call(this, t[0]);
      case 2:
        return !e.call(this, t[0], t[1]);
      case 3:
        return !e.call(this, t[0], t[1], t[2]);
    }
    return !e.apply(this, t);
  };
}
function J3e(e, t) {
  return t = Ns(t, e), e = j3e(e, t), e == null || delete e[Ds(Z3e(t))];
}
function Q3e(e) {
  return h5e(e) ? void 0 : e;
}
var q3e = 1, K3e = 2, e4e = 4, m9 = RL(function(e, t) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  t = Ep(t, function(i) {
    return i = Ns(i, e), r || (r = i.length > 1), i;
  }), p3(e, Wp(e), n), r && (n = Pl(n, q3e | K3e | e4e, Q3e));
  for (var o = t.length; o--; )
    J3e(n, t[o]);
  return n;
});
function t4e(e, t, n, r) {
  if (!Nr(e))
    return e;
  t = Ns(t, e);
  for (var o = -1, i = t.length, a = i - 1, l = e; l != null && ++o < i; ) {
    var c = Ds(t[o]), u = n;
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return e;
    if (o != a) {
      var f = l[c];
      u = void 0, u === void 0 && (u = Nr(f) ? f : Mp(t[o + 1]) ? [] : {});
    }
    Rp(l, c, u), l = l[c];
  }
  return e;
}
function jL(e, t, n) {
  for (var r = -1, o = t.length, i = {}; ++r < o; ) {
    var a = t[r], l = o6(e, a);
    n(l, a) && t4e(i, Ns(a, e), l);
  }
  return i;
}
function XL(e, t) {
  if (e == null)
    return {};
  var n = Ep(Wp(e), function(r) {
    return [r];
  });
  return t = h3(t), jL(e, n, function(r, o) {
    return t(r, o[0]);
  });
}
function n4e(e, t) {
  return XL(e, Y3e(h3(t)));
}
function r4e(e, t) {
  return jL(e, t, function(n, r) {
    return WL(e, r);
  });
}
var My = RL(function(e, t) {
  return e == null ? {} : r4e(e, t);
}), o4e = "Expected a function";
function i4e(e, t, n) {
  var r = !0, o = !0;
  if (typeof e != "function")
    throw new TypeError(o4e);
  return Nr(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), D3e(e, t, {
    leading: r,
    maxWait: t,
    trailing: o
  });
}
const a4e = "en", ud = (e, t, n) => {
  const r = Ey(e, (i) => i.languages_code === a4e), o = Ey(e, (i) => i.languages_code === n);
  return My(o ? UL(o, (i, a) => i || r?.[a] || "") : r, t);
}, YL = (e, t) => e && e.replace(new RegExp(G3e("${locale}"), "ig"), t), By = (e, t) => e.map((n) => {
  const r = ud(n.translations, ["menu"], t), o = n.items.map((i) => {
    const a = ud(i.translations, ["title"], t);
    return {
      ...m9(i, "translations"),
      title: a.title || "",
      href: YL(i.href, t),
      target: i.target,
      "data-analytics-id": i.data_analytics_id
    };
  });
  return { ...m9(n, "translations"), menu: r.menu || "", items: o };
});
let Lc = Array(), ky = Array(), Vl = Array();
const s4e = async (e, t) => {
  const n = () => typeof window < "u" ? Promise.resolve([]) : e.request(
    // @ts-ignore ts v5
    Lp("footer_nav", {
      fields: ["id", { translations: ["*"] }, { items: ["*", { translations: ["*"] }] }]
    })
  ).then((r) => Lc = r);
  try {
    if (Lc.length && Vl.length)
      return n(), By(Lc, t);
    const r = await n();
    return By(r, t);
  } catch {
    return [];
  }
}, Ry = (e, t) => e.map((n) => {
  const r = n.children.map((i) => {
    let a;
    return i?.icon?.filename_disk && (a = `${t}/${i?.icon?.filename_disk}`), {
      ...i,
      icon: a || void 0,
      "data-analytics-id": i.data_analytics_id
    };
  });
  let o;
  return n?.icon?.filename_disk && (o = `${t}/${n?.icon?.filename_disk}`), {
    children: r,
    "data-analytics-id": n.data_analytics_id,
    target: n.target,
    href: n.href,
    name: n.name,
    icon: o || void 0
  };
}), l4e = async (e, t) => {
  const n = () => typeof window < "u" ? Promise.resolve([]) : e.request(
    // @ts-ignore ts v5
    Lp("footer_media", {
      fields: ["*.*", { children: ["*.*"] }]
    })
  ).then((r) => Vl = r);
  try {
    if (Vl.length)
      return n(), Ry(Vl, t);
    const r = await n();
    return Ry(r, t);
  } catch {
    return [];
  }
}, _y = (e) => Object.prototype.toString.call(e) === "[object Object]", Hl = (e, t, n) => {
  if (!_y(e))
    return e;
  let r = UL(XL(e, (o, i) => ("languages_code" in e ? !0 : o !== null) && (i === "children" ? o?.length > 0 : !0)), (o) => typeof o == "string" ? YL(o, t) : Array.isArray(o) ? o.map((i) => Hl(i, t, n)) : _y(o) ? Hl(o, t, n) : o);
  return r?.image?.filename_disk && (r.image = `${n}/${r?.image?.filename_disk}`), r?.icon?.filename_disk && (r.icon = `${n}/${r?.icon?.filename_disk}`), r?.src?.filename_disk && (r.src = `${n}/${r?.src?.filename_disk}`), r?.thumbnail && (r = {
    ...m9(r, ["thumbnail"]),
    ...Hl(r?.thumbnail, t, n)
  }), r?.translations?.length && (r = {
    ...m9(r, ["translations"]),
    ...ud(r?.translations, Object.keys(n4e(r?.translations[0], (o, i) => i.endsWith("_id") || ["id", "languages_code"].includes(i))), t)
  }), r;
}, Fy = (e, t, n) => e.map((r) => Hl(r, t, n)), c4e = async (e, t, n) => {
  if (typeof window < "u")
    return Promise.resolve([]);
  const i = [
    "selfLink",
    "thumbnailAnalyticsId",
    { translations: ["*"] },
    { thumbnailImage: ["*.*", { translations: ["*"] }] },
    { thumbnailLink: ["*", { translations: ["*"] }] }
  ], a = ["link", "variant", "target", { translations: ["*"] }], l = [
    { options: ["analyticsId", "chain", "key", { translations: ["*"] }] },
    { translations: ["*"] }
  ], c = ["*"], u = ["*"], f = [
    "id",
    "analyticsId",
    { thumbnail: i },
    { image: c },
    "key",
    { button: u },
    { translations: ["*"] }
  ], p = [
    "id",
    { tag: a },
    "target",
    { icon: c },
    "analyticsId",
    "link",
    "subLink",
    "selfLink",
    "selfAnalyticsId",
    { thumbnail: i },
    { wallet: l },
    { button: u },
    { translations: ["*"] }
  ], h = ["id", "target", "link", "analyticsId", { tag: a }, { translations: ["*"] }], C = () => e.request(
    // @ts-ignore ts v5
    Lp("header_nav_level1", {
      fields: [...f, { children: [...p, { children: h }] }]
    })
  );
  try {
    ky.length && (C(), Fy(ky, t, n));
    const v = await C();
    return Fy(v, t, n);
  } catch {
    return [];
  }
}, u4e = async (e, t, n) => {
  const r = Iae(e).with(_ae()), o = await c4e(r, t, n), i = await s4e(r, t), a = await l4e(r, n);
  return { headerMenus: o, footerMenus: i, footerMedia: a };
};
i4e(async (e, t, n) => ({
  res: await u4e(e, t, n),
  locale: t
}), 1e4);
pn({ pathname: "" });
P({
  defaultProps: {
    w: "137px",
    h: "24px"
  },
  displayName: "Logo",
  viewBox: "0 0 137 24",
  path: X(st, { children: [g("path", { d: "M4.00392 3.6761L10.3727 0L16.7415 3.6761L14.4 5.03415L10.3727 2.7161L6.34539 5.03415L4.00392 3.6761ZM16.7415 8.31219L14.4 6.95415L10.3727 9.2722L6.34539 6.95415L4.00392 8.31219V11.0283L8.03123 13.3463V17.9824L10.3727 19.3405L12.7142 17.9824V13.3463L16.7415 11.0283V8.31219ZM16.7415 15.6644V12.9483L14.4 14.3063V17.0224L16.7415 15.6644ZM18.4039 16.6244L14.3766 18.9424V21.6585L20.7454 17.9824V10.6302L18.4039 11.9883V16.6244ZM16.0625 5.99415L18.4039 7.35219V10.0683L20.7454 8.71024V5.99415L18.4039 4.6361L16.0625 5.99415ZM8.03123 19.9259V22.642L10.3727 24L12.7142 22.642V19.9259L10.3727 21.2839L8.03123 19.9259ZM4.00392 15.6644L6.34539 17.0224V14.3063L4.00392 12.9483V15.6644ZM8.03123 5.99415L10.3727 7.35219L12.7142 5.99415L10.3727 4.6361L8.03123 5.99415ZM2.34146 7.35219L4.68293 5.99415L2.34146 4.6361L0 5.99415V8.71024L2.34146 10.0683V7.35219ZM2.34146 11.9883L0 10.6302V17.9824L6.36877 21.6585V18.9424L2.34146 16.6244V11.9883Z", fill: "#F0B90B" }), g("path", { d: "M39.205 15.0616V15.0234C39.205 13.2298 38.2509 12.333 36.7054 11.7415C37.6594 11.2073 38.4608 10.3677 38.4608 8.86029V8.82213C38.4608 6.72322 36.7817 5.36847 34.0531 5.36847H27.8518V18.7252H34.2058C37.2206 18.7252 39.205 17.504 39.205 15.0616ZM35.5414 9.3564C35.5414 10.3486 34.721 10.7684 33.4235 10.7684H30.714V7.9444H33.6143C34.8545 7.9444 35.5414 8.44051 35.5414 9.31823V9.3564ZM36.2856 14.6991C36.2856 15.6913 35.5033 16.1492 34.2058 16.1492H30.714V13.2108H34.1104C35.6178 13.2108 36.2856 13.7641 36.2856 14.6609V14.6991Z", fill: "#F0B90B" }), g("path", { d: "M53.6814 18.7252V5.36847H50.781V13.5924L44.5225 5.36847H41.813V18.7252H44.7133V10.2341L51.1817 18.7252H53.6814Z", fill: "#F0B90B" }), g("path", { d: "M68.4317 15.0616V15.0234C68.4317 13.2298 67.4776 12.333 65.9321 11.7415C66.8861 11.2073 67.6875 10.3677 67.6875 8.86029V8.82213C67.6875 6.72322 66.0084 5.36847 63.2798 5.36847H57.0785V18.7252H63.4325C66.4473 18.7252 68.4317 17.504 68.4317 15.0616ZM64.7682 9.3564C64.7682 10.3486 63.9477 10.7684 62.6502 10.7684H59.9407V7.9444H62.841C64.0812 7.9444 64.7682 8.44051 64.7682 9.31823V9.3564ZM65.5123 14.6991C65.5123 15.6913 64.73 16.1492 63.4325 16.1492H59.9407V13.2108H63.3371C64.8445 13.2108 65.5123 13.7641 65.5123 14.6609V14.6991Z", fill: "#F0B90B" }), g("path", { d: "M86.1413 16.3656L84.6339 14.8392C83.489 15.9077 82.4396 16.5755 80.7986 16.5755C78.2417 16.5755 76.3909 14.4385 76.3909 11.8053C76.3909 9.17211 78.2417 7.0732 80.7986 7.0732C82.3251 7.0732 83.4699 7.74104 84.5385 8.73325L86.0459 6.99688C84.7674 5.7757 83.2791 4.91705 80.8177 4.91705C76.7725 4.91705 73.9294 8.02725 73.9294 11.8435C73.9294 15.6978 76.8298 18.7317 80.7223 18.7317C83.2219 18.7317 84.7484 17.8158 86.1413 16.3656Z", fill: "#F0B90B" }), g("path", { d: "M97.5189 12.8738V18.5027H99.8659V5.14602H97.5189V10.6986H91.1459V5.14602H88.7989V18.5027H91.1459V12.8738H97.5189Z", fill: "#F0B90B" }), g("path", { d: "M110.394 5.05062H108.219L102.342 18.5027H104.746L106.12 15.278H112.436L113.791 18.5027H116.271L110.394 5.05062ZM111.577 13.1982H106.979L109.268 7.85553L111.577 13.1982Z", fill: "#F0B90B" }), g("path", { d: "M118.886 5.14602V18.5027H121.233V5.14602H118.886Z", fill: "#F0B90B" }), g("path", { d: "M134.33 14.3812L127.174 5.14602H124.999V18.5027H127.308V9.00038L134.673 18.5027H136.639V5.14602H134.33V14.3812Z", fill: "#F0B90B" })] })
});
const Py = ({ menu: e }) => {
  const { colorMode: t } = Ee(), { locale: n } = n1(), { isOpen: r, onOpen: o, onClose: i } = wo();
  return X(fp, { strategy: "fixed", placement: "top-end", isOpen: r, children: [g(mp, { onMouseEnter: o, onMouseLeave: () => {
    setTimeout(i, 0);
  }, color: r ? H.colors[t].text.secondary : H.colors[t].text.tertiary, children: g(re, { "data-analytics-id": e["data-analytics-id"], alignItems: "center", sx: {
    ".svg-image": {
      WebkitMaskImage: `url(${e.icon})`,
      WebkitMaskSize: "contain",
      WebkitMaskPosition: "center",
      WebkitMaskRepeat: "no-repeat",
      flexShrink: 0,
      bgColor: r ? H.colors[t].text.secondary : H.colors[t].text.tertiary,
      "&:hover": {
        bgColor: H.colors[t].text.secondary
      }
    },
    ".svg-icon": {
      color: r ? H.colors[t].text.secondary : H.colors[t].text.tertiary,
      "&:hover": {
        color: H.colors[t].text.secondary
      }
    }
  }, children: dd(e.icon) }) }), g(hp, { bg: H.colors[t].layer[3].default, borderRadius: H.sizes[2], overflow: "hidden", border: "none", boxShadow: "none", onMouseEnter: o, onMouseLeave: () => {
    setTimeout(i, 0);
  }, transition: "200ms", children: g(iI, { defaultValue: n, type: "radio", children: e.children?.map((a) => g(Cp, { icon: null, value: a.name, as: "a", href: a.href, target: a.target || "_blank", "data-analytics-id": a["data-analytics-id"] || "", px: H.sizes[4], py: H.sizes[3], w: "100%", color: H.colors[t].text.secondary, bg: H.colors[t].layer[3].default, _hover: {
    bg: H.colors[t].layer[3].hover
  }, sx: {
    ".svg-image": {
      WebkitMaskImage: `url(${a.icon})`,
      WebkitMaskSize: "contain",
      flexShrink: 0,
      bgColor: H.colors[t].text.tertiary,
      "&:hover": {
        bgColor: H.colors[t].text.secondary
      }
    },
    ".svg-icon": {
      color: H.colors[t].text.tertiary,
      "&:hover": {
        color: H.colors[t].text.secondary
      }
    }
  }, children: X(re, { alignItems: "center", children: [dd(a.icon), g(mt, { variant: "label", size: "md", ml: H.sizes[2], children: a.name })] }) }, a.name)) }) })] });
};
Zd(function({ mediaData: t }) {
  const { colorMode: n } = Ee(), r = Re(null), [o, i] = ze(0), [a, l] = ze(0);
  Oe(() => {
    const u = () => {
      const p = r.current?.parentElement?.parentElement;
      if (!p)
        return;
      const h = p.querySelector(".locale-switch-container"), C = h?.className.includes("locale-switchable"), v = Math.floor((p.offsetWidth - (window.innerWidth < 768 && C ? 0 : h?.offsetWidth || 0) - 41) / 36), b = t.length;
      i(b > v ? b - v + 1 : 0);
    };
    return window.addEventListener("resize", u), u(), l(1), () => {
      window.removeEventListener("resize", u);
    };
  }, [t.length]);
  const c = {
    href: "/",
    icon: "https://cms-static.bnbchain.org/dcms/static/290c8ba1-987a-4cb7-9b81-8f2517801148.svg",
    "data-analytics-id": "",
    target: "_blank",
    children: t.slice(-o).map((u) => ({
      href: u.href,
      icon: u.icon,
      "data-analytics-id": u["data-analytics-id"] || "",
      name: u.name || "",
      target: u.target
    }))
  };
  return X(re, { opacity: a, ref: r, gap: H.sizes[4], children: [t.slice(0, t.length - o).map((u, f) => u.children?.length ? g(Py, { menu: u }, f) : g(re, { as: "a", "data-analytics-id": u["data-analytics-id"], href: u.href, target: u.target || "_blank", alignItems: "center", h: H.sizes[5], w: H.sizes[5], sx: {
    ".svg-image": {
      WebkitMaskImage: `url(${u.icon})`,
      WebkitMaskSize: "contain",
      flexShrink: 0,
      bgColor: H.colors[n].text.tertiary,
      "&:hover": {
        bgColor: H.colors[n].text.secondary
      }
    },
    ".svg-icon": {
      color: H.colors[n].text.tertiary,
      "&:hover": {
        color: H.colors[n].text.secondary
      }
    }
  }, children: dd(u.icon) }, f)), o > 0 && g(Py, { menu: c })] });
});
const dd = (e) => e ? typeof e == "string" ? g(h1, { className: "svg-image", h: H.sizes[5], w: H.sizes[5], cursor: "pointer" }) : g(e, { className: "svg-icon", h: H.sizes[5], w: H.sizes[5], cursor: "pointer" }) : g(st, {});
Le((e, t) => {
  const { colorMode: n } = Ee();
  return g(GT, { ref: t, color: H.colors[n].text.warning, ...e });
});
Le(({ isWarning: e = !1, ...t }, n) => g(zT, { ref: n, ...t, sx: {
  ...t.isDisabled && {
    [`.${fn.FORM__HELPER_TEXT}, .${fn.FORM__LABEL}`]: {
      opacity: 0.5
    }
  },
  ...t.sx
} }));
P({
  defaultProps: {
    w: "137px",
    h: "24px"
  },
  displayName: "Primary",
  viewBox: "0 0 137 24",
  path: X(st, { children: [g("path", { d: "M4.00392 3.6761L10.3727 0L16.7415 3.6761L14.4 5.03415L10.3727 2.7161L6.34539 5.03415L4.00392 3.6761ZM16.7415 8.31219L14.4 6.95415L10.3727 9.2722L6.34539 6.95415L4.00392 8.31219V11.0283L8.03123 13.3463V17.9824L10.3727 19.3405L12.7142 17.9824V13.3463L16.7415 11.0283V8.31219ZM16.7415 15.6644V12.9483L14.4 14.3063V17.0224L16.7415 15.6644ZM18.4039 16.6244L14.3766 18.9424V21.6585L20.7454 17.9824V10.6302L18.4039 11.9883V16.6244ZM16.0625 5.99415L18.4039 7.35219V10.0683L20.7454 8.71024V5.99415L18.4039 4.6361L16.0625 5.99415ZM8.03123 19.9259V22.642L10.3727 24L12.7142 22.642V19.9259L10.3727 21.2839L8.03123 19.9259ZM4.00392 15.6644L6.34539 17.0224V14.3063L4.00392 12.9483V15.6644ZM8.03123 5.99415L10.3727 7.35219L12.7142 5.99415L10.3727 4.6361L8.03123 5.99415ZM2.34146 7.35219L4.68293 5.99415L2.34146 4.6361L0 5.99415V8.71024L2.34146 10.0683V7.35219ZM2.34146 11.9883L0 10.6302V17.9824L6.36877 21.6585V18.9424L2.34146 16.6244V11.9883Z", fill: "#F0B90B" }), g("path", { d: "M39.205 15.0616V15.0234C39.205 13.2298 38.2509 12.333 36.7054 11.7415C37.6594 11.2073 38.4608 10.3677 38.4608 8.86029V8.82213C38.4608 6.72322 36.7817 5.36847 34.0531 5.36847H27.8518V18.7252H34.2058C37.2206 18.7252 39.205 17.504 39.205 15.0616ZM35.5414 9.3564C35.5414 10.3486 34.721 10.7684 33.4235 10.7684H30.714V7.9444H33.6143C34.8545 7.9444 35.5414 8.44051 35.5414 9.31823V9.3564ZM36.2856 14.6991C36.2856 15.6913 35.5033 16.1492 34.2058 16.1492H30.714V13.2108H34.1104C35.6178 13.2108 36.2856 13.7641 36.2856 14.6609V14.6991Z", fill: "#F0B90B" }), g("path", { d: "M53.6814 18.7252V5.36847H50.781V13.5924L44.5225 5.36847H41.813V18.7252H44.7133V10.2341L51.1817 18.7252H53.6814Z", fill: "#F0B90B" }), g("path", { d: "M68.4317 15.0616V15.0234C68.4317 13.2298 67.4776 12.333 65.9321 11.7415C66.8861 11.2073 67.6875 10.3677 67.6875 8.86029V8.82213C67.6875 6.72322 66.0084 5.36847 63.2798 5.36847H57.0785V18.7252H63.4325C66.4473 18.7252 68.4317 17.504 68.4317 15.0616ZM64.7682 9.3564C64.7682 10.3486 63.9477 10.7684 62.6502 10.7684H59.9407V7.9444H62.841C64.0812 7.9444 64.7682 8.44051 64.7682 9.31823V9.3564ZM65.5123 14.6991C65.5123 15.6913 64.73 16.1492 63.4325 16.1492H59.9407V13.2108H63.3371C64.8445 13.2108 65.5123 13.7641 65.5123 14.6609V14.6991Z", fill: "#F0B90B" }), g("path", { d: "M86.1413 16.3656L84.6339 14.8392C83.489 15.9077 82.4396 16.5755 80.7986 16.5755C78.2417 16.5755 76.3909 14.4385 76.3909 11.8053C76.3909 9.17211 78.2417 7.0732 80.7986 7.0732C82.3251 7.0732 83.4699 7.74104 84.5385 8.73325L86.0459 6.99688C84.7674 5.7757 83.2791 4.91705 80.8177 4.91705C76.7725 4.91705 73.9294 8.02725 73.9294 11.8435C73.9294 15.6978 76.8298 18.7317 80.7223 18.7317C83.2219 18.7317 84.7484 17.8158 86.1413 16.3656Z", fill: "#F0B90B" }), g("path", { d: "M97.5189 12.8738V18.5027H99.8659V5.14602H97.5189V10.6986H91.1459V5.14602H88.7989V18.5027H91.1459V12.8738H97.5189Z", fill: "#F0B90B" }), g("path", { d: "M110.394 5.05062H108.219L102.342 18.5027H104.746L106.12 15.278H112.436L113.791 18.5027H116.271L110.394 5.05062ZM111.577 13.1982H106.979L109.268 7.85553L111.577 13.1982Z", fill: "#F0B90B" }), g("path", { d: "M118.886 5.14602V18.5027H121.233V5.14602H118.886Z", fill: "#F0B90B" }), g("path", { d: "M134.33 14.3812L127.174 5.14602H124.999V18.5027H127.308V9.00038L134.673 18.5027H136.639V5.14602H134.33V14.3812Z", fill: "#F0B90B" })] })
});
P({
  defaultProps: {
    w: "204px",
    h: "24px"
  },
  displayName: "Greenfield",
  viewBox: "0 0 204 24",
  path: X(st, { children: [g("path", { d: "M4.01452 3.6761L10.4001 0L16.7857 3.6761L14.4381 5.03415L10.4001 2.7161L6.36217 5.03415L4.01452 3.6761ZM16.7857 8.31219L14.4381 6.95415L10.4001 9.2722L6.36217 6.95415L4.01452 8.31219V11.0283L8.05247 13.3463V17.9824L10.4001 19.3405L12.7478 17.9824V13.3463L16.7857 11.0283V8.31219ZM16.7857 15.6644V12.9483L14.4381 14.3063V17.0224L16.7857 15.6644ZM18.4526 16.6244L14.4146 18.9424V21.6585L20.8003 17.9824V10.6302L18.4526 11.9883V16.6244ZM16.1049 5.99415L18.4526 7.35219V10.0683L20.8003 8.71024V5.99415L18.4526 4.6361L16.1049 5.99415ZM8.05247 19.9259V22.642L10.4001 24L12.7478 22.642V19.9259L10.4001 21.2839L8.05247 19.9259ZM4.01452 15.6644L6.36217 17.0224V14.3063L4.01452 12.9483V15.6644ZM8.05247 5.99415L10.4001 7.35219L12.7478 5.99415L10.4001 4.6361L8.05247 5.99415ZM2.34766 7.35219L4.69531 5.99415L2.34766 4.6361L0 5.99415V8.71024L2.34766 10.0683V7.35219ZM2.34766 11.9883L0 10.6302V17.9824L6.38561 21.6585V18.9424L2.34766 16.6244V11.9883Z", fill: "#F0B90B" }), g("path", { d: "M39.4512 15.337V15.2988C39.4512 13.5058 38.4974 12.6092 36.9524 12.0179C37.9061 11.4838 38.7073 10.6445 38.7073 9.13759V9.09944C38.7073 7.00119 37.0287 5.64687 34.3009 5.64687H28.1016V18.9994H34.4535C37.4674 18.9994 39.4512 17.7786 39.4512 15.337ZM35.7888 9.63354C35.7888 10.6254 34.9686 11.0451 33.6715 11.0451H30.9628V8.22199H33.8622C35.1021 8.22199 35.7888 8.71794 35.7888 9.59539V9.63354ZM36.5327 14.9745C36.5327 15.9664 35.7506 16.4242 34.4535 16.4242H30.9628V13.4867H34.3582C35.8651 13.4867 36.5327 14.0399 36.5327 14.9364V14.9745Z", fill: "#F0B90B" }), g("path", { d: "M53.923 18.9994V5.64687H51.0236V13.8682L44.767 5.64687H42.0584V18.9994H44.9578V10.511L51.4242 18.9994H53.923Z", fill: "#F0B90B" }), g("path", { d: "M68.6687 15.337V15.2988C68.6687 13.5058 67.715 12.6092 66.1699 12.0179C67.1237 11.4838 67.9248 10.6445 67.9248 9.13759V9.09944C67.9248 7.00119 66.2462 5.64687 63.5185 5.64687H57.3191V18.9994H63.6711C66.6849 18.9994 68.6687 17.7786 68.6687 15.337ZM65.0063 9.63354C65.0063 10.6254 64.1861 11.0451 62.889 11.0451H60.1804V8.22199H63.0798C64.3196 8.22199 65.0063 8.71794 65.0063 9.59539V9.63354ZM65.7503 14.9745C65.7503 15.9664 64.9682 16.4242 63.6711 16.4242H60.1804V13.4867H63.5757C65.0826 13.4867 65.7503 14.0399 65.7503 14.9364V14.9745Z", fill: "#F0B90B" }), g("path", { d: "M86.7229 17.1491V11.541H81.0386V13.5821H84.453V16.0809C83.6328 16.6913 82.4883 17.0919 81.2293 17.0919C78.5016 17.0919 76.6895 15.0699 76.6895 12.304C76.6895 9.70984 78.5588 7.57344 81.0195 7.57344C82.7172 7.57344 83.7281 8.12662 84.7582 9.00407L86.246 7.23009C84.8726 6.06652 83.442 5.41797 81.1149 5.41797C77.09 5.41797 74.2288 8.58442 74.2288 12.3422C74.2288 16.2526 76.9756 19.2283 81.153 19.2283C83.5183 19.2283 85.4067 18.2745 86.7229 17.1491Z", fill: "#F0B90B" }), g("path", { d: "M101.3 18.9994L97.6945 13.9445C99.5638 13.4295 100.88 12.0942 100.88 9.88152C100.88 7.26824 98.9916 5.64687 95.9205 5.64687H89.9691V18.9994H92.3153V14.3451H95.2529L98.5338 18.9994H101.3ZM98.4956 10.015C98.4956 11.3884 97.4274 12.2659 95.7488 12.2659H92.3153V7.78327H95.7297C97.4656 7.78327 98.4956 8.54627 98.4956 10.015Z", fill: "#F0B90B" }), g("path", { d: "M113.844 5.64687H103.945V18.9994H113.94V16.9011H106.291V13.315H112.986V11.2168H106.291V7.74512H113.844V5.64687Z", fill: "#F0B90B" }), g("path", { d: "M126.814 5.64687H116.914V18.9994H126.909V16.9011H119.26V13.315H125.956V11.2168H119.26V7.74512H126.814V5.64687Z", fill: "#F0B90B" }), g("path", { d: "M139.211 14.8792L132.058 5.64687H129.884V18.9994H132.192V9.50002L139.555 18.9994H141.519V5.64687H139.211V14.8792Z", fill: "#F0B90B" }), g("path", { d: "M155.082 5.64687H145.144V18.9994H147.491V13.563H154.224V11.4266H147.491V7.78327H155.082V5.64687Z", fill: "#F0B90B" }), g("path", { d: "M157.987 5.64687V18.9994H160.333V5.64687H157.987Z", fill: "#F0B90B" }), g("path", { d: "M173.998 5.64687H164.098V18.9994H174.093V16.9011H166.444V13.315H173.139V11.2168H166.444V7.74512H173.998V5.64687Z", fill: "#F0B90B" }), g("path", { d: "M177.067 18.9994H186.433V16.863H179.414V5.64687H177.067V18.9994Z", fill: "#F0B90B" }), g("path", { d: "M201.143 12.304C201.143 8.52719 198.243 5.64687 194.047 5.64687H189.068V18.9994H194.047C198.243 18.9994 201.143 16.0809 201.143 12.304ZM198.682 12.3422C198.682 14.9745 196.851 16.863 194.047 16.863H191.414V7.78327H194.047C196.851 7.78327 198.682 9.70984 198.682 12.3422Z", fill: "#F0B90B" })] })
});
const d4e = {
  [fn.BUTTON__ICON]: {
    "2xl": {
      mr: H.sizes[3]
    },
    xl: {
      mr: H.sizes[2]
    },
    lg: {
      mr: H.sizes[2]
    },
    md: {
      mr: H.sizes[2]
    },
    sm: {
      mr: H.sizes[2]
    },
    xs: {
      mr: H.sizes[1]
    }
  },
  [fn.ICON]: {
    "2xl": {
      fontSize: H.fontSizes[6]
    },
    xl: {
      fontSize: H.fontSizes[6]
    },
    lg: {
      fontSize: H.fontSizes[6]
    },
    md: {
      fontSize: H.fontSizes[4]
    },
    sm: {
      fontSize: H.fontSizes[4]
    },
    xs: {
      fontSize: H.fontSizes[3]
    }
  }
}, JL = H.components.Button, f4e = JL.defaultProps, p4e = JL.sizes, h4e = d4e[fn.ICON], m4e = Le(({ size: e = f4e.size, ...t }, n) => {
  const r = Gt(e) ?? e, o = p4e[r];
  return g(DT, { ref: n, w: o.h, h: o.h, minW: o.h, borderRadius: o.borderRadius, ...t, sx: {
    [`.${fn.ICON}`]: {
      ...h4e[r]
    },
    ...t.sx
  } });
}), Vy = {
  variant: "solid",
  size: "md",
  colorScheme: "primary"
};
Le(({
  colorScheme: e = Vy.colorScheme,
  size: t = Vy.size,
  // variant = DEFAULT_PROPS.variant,
  children: n,
  ...r
}, o) => {
  const { colorMode: i } = Ee(), a = Gt(t) ?? t, l = Gt(e) ?? e, c = we(() => {
    if (a === "sm")
      return {
        inner: H.sizes[10],
        outer: H.sizes[16],
        icon: H.sizes[8]
      };
    if (a === "md")
      return {
        inner: H.sizes[14],
        outer: H.sizes[20],
        icon: H.sizes[10]
      };
    if (a === "lg")
      return {
        inner: H.sizes[18],
        outer: H.sizes[24],
        icon: H.sizes[12]
      };
    throw new Error(`Size "${a}" is not valid.`);
  }, [a]);
  return g(pi, { ref: o, w: c.outer, h: c.outer, borderRadius: "50%", bg: H.colors[i].support[l][5], ...r, children: g(pi, { w: c.inner, h: c.inner, borderRadius: "50%", bg: H.colors[i].support[l][4], sx: {
    svg: {
      color: H.colors[i].support[l][1],
      fontSize: c.icon
    }
  }, children: n }) });
});
const C9 = {
  info: "primary",
  success: "success",
  warning: "warning",
  danger: "danger"
}, C4e = {
  info: g(Woe, {}),
  success: g(xp, {}),
  warning: g(Uoe, {}),
  danger: g(d2, {})
}, g4e = Le(({ size: e = H.sizes[4], status: t, ...n }, r) => {
  const { colorMode: o } = Ee(), i = Gt(e) ?? e;
  return g(pi, { ref: r, background: H.colors[o].support[C9[t]][4], color: H.colors[o].support[C9[t]][1], borderRadius: "50%", w: i, h: i, sx: {
    svg: {
      fontSize: `calc(${i} * 0.7)`
    }
  }, flexShrink: 0, ...n, children: C4e[t] });
}), QL = pn({ isExpanded: !1, isDisabled: !1 });
Le(({ icon: e, children: t, ...n }, r) => {
  const { colorMode: o } = Ee(), { isExpanded: i } = N1(QL);
  return X(FT, { ref: r, w: "100%", display: "flex", alignItems: "center", px: { base: H.sizes[5], md: H.sizes[6] }, pt: H.sizes[4], pb: i ? H.sizes[2] : H.sizes[4], transition: "padding 0.2s linear", _hover: {
    ...!i && {
      bg: { lg: H.colors[o].layer[2].hover },
      // Hide dividers on hover.
      outline: { lg: `${H.sizes[1]} solid ${H.colors[o].layer[2].hover}` },
      outlineOffset: { lg: H.sizes[0] }
    }
  }, sx: {
    svg: {
      fontSize: { base: H.sizes[6], md: H.sizes[8] },
      color: H.colors[o].text.primary
    }
  }, ...n, children: [t, e] });
});
Le(({ children: e, ...t }, n) => g(VT, { ref: n, ...t, children: ({ isExpanded: r, isDisabled: o }) => g(QL.Provider, { value: { isExpanded: r, isDisabled: o }, children: typeof e == "function" ? e({
  isExpanded: r,
  isDisabled: o
}) : e }) }));
Le(({ variant: e, size: t, children: n, ...r }, o) => {
  const { colorMode: i } = Ee();
  return g(mt, { ref: o, as: "div", variant: "heading", size: { base: "xs", md: "sm" }, fontWeight: "500", color: H.colors[i].text.tertiary, textAlign: "left", w: { base: H.sizes[10], md: H.sizes[12] }, flexShrink: 0, ...r, children: typeof n == "number" ? `${n}`.padStart(2, "0") : n });
});
Le((e, t) => {
  const { colorMode: n } = Ee(), r = Gt({
    base: "sm",
    md: "md"
  }) || "md";
  return g(NT, { ref: t, mx: { base: H.sizes[5], md: H.sizes[6] }, pl: { base: H.sizes[10], md: H.sizes[12] }, pr: { base: 0, md: "44px" }, pt: 0, pb: H.sizes[5], color: H.colors[n].text.secondary, ...hs.body[r], ...e });
});
Le(({ variant: e, size: t, ...n }, r) => {
  const { colorMode: o } = Ee();
  return g(mt, { ref: r, as: "div", variant: "body", size: { base: "md", md: "lg" }, fontWeight: "500", color: H.colors[o].text.primary, textAlign: "left", wordBreak: "break-word", flex: 1, mt: H.sizes["0.5"], ...n });
});
function Hy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function e1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hy(Object(n), !0).forEach(function(r) {
      os(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hy(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function b4e(e) {
  if (Array.isArray(e)) return e;
}
function v4e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, l = [], c = !0, u = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); c = !0) ;
    } catch (f) {
      u = !0, o = f;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw o;
      }
    }
    return l;
  }
}
function fd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function qL(e, t) {
  if (e) {
    if (typeof e == "string") return fd(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? fd(e, t) : void 0;
  }
}
function y4e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ui(e, t) {
  return b4e(e) || v4e(e, t) || qL(e, t) || y4e();
}
function xi(e, t) {
  if (e == null) return {};
  var n, r, o = $T(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var x4e = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function w4e(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, o = r === void 0 ? !1 : r, i = e.defaultValue, a = i === void 0 ? null : i, l = e.inputValue, c = e.menuIsOpen, u = e.onChange, f = e.onInputChange, p = e.onMenuClose, h = e.onMenuOpen, C = e.value, v = xi(e, x4e), b = ze(l !== void 0 ? l : n), y = ui(b, 2), x = y[0], T = y[1], A = ze(c !== void 0 ? c : o), L = ui(A, 2), I = L[0], M = L[1], k = ze(C !== void 0 ? C : a), _ = ui(k, 2), F = _[0], $ = _[1], oe = se(function(Me, _e) {
    typeof u == "function" && u(Me, _e), $(Me);
  }, [u]), te = se(function(Me, _e) {
    var ne;
    typeof f == "function" && (ne = f(Me, _e)), T(ne !== void 0 ? ne : Me);
  }, [f]), ae = se(function() {
    typeof h == "function" && h(), M(!0);
  }, [h]), be = se(function() {
    typeof p == "function" && p(), M(!1);
  }, [p]), K = l !== void 0 ? l : x, ue = c !== void 0 ? c : I, J = C !== void 0 ? C : F;
  return e1(e1({}, v), {}, {
    inputValue: K,
    menuIsOpen: ue,
    onChange: oe,
    onInputChange: te,
    onMenuClose: be,
    onMenuOpen: ae,
    value: J
  });
}
function S4e(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Oy(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, oA(r.key), r);
  }
}
function T4e(e, t, n) {
  return Oy(e.prototype, t), Oy(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function A4e(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && ws(e, t);
}
function I4e(e, t) {
  if (t && (Ja(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return LI(e);
}
function L4e(e) {
  var t = bp();
  return function() {
    var n, r = B0(e);
    if (t) {
      var o = B0(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);
    return I4e(this, n);
  };
}
function E4e(e) {
  if (Array.isArray(e)) return fd(e);
}
function M4e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function B4e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jp(e) {
  return E4e(e) || M4e(e) || qL(e) || B4e();
}
function k4e(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
const R4e = Math.min, _4e = Math.max, g9 = Math.round, ul = Math.floor, b9 = (e) => ({
  x: e,
  y: e
});
function F4e(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function i6() {
  return typeof window < "u";
}
function KL(e) {
  return tE(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ci(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function eE(e) {
  var t;
  return (t = (tE(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function tE(e) {
  return i6() ? e instanceof Node || e instanceof Ci(e).Node : !1;
}
function P4e(e) {
  return i6() ? e instanceof Element || e instanceof Ci(e).Element : !1;
}
function Xp(e) {
  return i6() ? e instanceof HTMLElement || e instanceof Ci(e).HTMLElement : !1;
}
function Ny(e) {
  return !i6() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ci(e).ShadowRoot;
}
function nE(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Yp(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function V4e() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function H4e(e) {
  return ["html", "body", "#document"].includes(KL(e));
}
function Yp(e) {
  return Ci(e).getComputedStyle(e);
}
function O4e(e) {
  if (KL(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ny(e) && e.host || // Fallback.
    eE(e)
  );
  return Ny(t) ? t.host : t;
}
function rE(e) {
  const t = O4e(e);
  return H4e(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Xp(t) && nE(t) ? t : rE(t);
}
function v9(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = rE(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Ci(o);
  if (i) {
    const l = pd(a);
    return t.concat(a, a.visualViewport || [], nE(o) ? o : [], l && n ? v9(l) : []);
  }
  return t.concat(o, v9(o, [], n));
}
function pd(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function N4e(e) {
  const t = Yp(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Xp(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, l = g9(n) !== i || g9(r) !== a;
  return l && (n = i, r = a), {
    width: n,
    height: r,
    $: l
  };
}
function Jp(e) {
  return P4e(e) ? e : e.contextElement;
}
function Dy(e) {
  const t = Jp(e);
  if (!Xp(t))
    return b9(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = N4e(t);
  let a = (i ? g9(n.width) : n.width) / r, l = (i ? g9(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: a,
    y: l
  };
}
const D4e = /* @__PURE__ */ b9(0);
function Z4e(e) {
  const t = Ci(e);
  return !V4e() || !t.visualViewport ? D4e : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function z4e(e, t, n) {
  return !1;
}
function Zy(e, t, n, r) {
  t === void 0 && (t = !1);
  const o = e.getBoundingClientRect(), i = Jp(e);
  let a = b9(1);
  t && (a = Dy(e));
  const l = z4e() ? Z4e(i) : b9(0);
  let c = (o.left + l.x) / a.x, u = (o.top + l.y) / a.y, f = o.width / a.x, p = o.height / a.y;
  if (i) {
    const h = Ci(i), C = r;
    let v = h, b = pd(v);
    for (; b && r && C !== v; ) {
      const y = Dy(b), x = b.getBoundingClientRect(), T = Yp(b), A = x.left + (b.clientLeft + parseFloat(T.paddingLeft)) * y.x, L = x.top + (b.clientTop + parseFloat(T.paddingTop)) * y.y;
      c *= y.x, u *= y.y, f *= y.x, p *= y.y, c += A, u += L, v = Ci(b), b = pd(v);
    }
  }
  return F4e({
    width: f,
    height: p,
    x: c,
    y: u
  });
}
function G4e(e, t) {
  let n = null, r;
  const o = eE(e);
  function i() {
    var l;
    clearTimeout(r), (l = n) == null || l.disconnect(), n = null;
  }
  function a(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), i();
    const {
      left: u,
      top: f,
      width: p,
      height: h
    } = e.getBoundingClientRect();
    if (l || t(), !p || !h)
      return;
    const C = ul(f), v = ul(o.clientWidth - (u + p)), b = ul(o.clientHeight - (f + h)), y = ul(u), T = {
      rootMargin: -C + "px " + -v + "px " + -b + "px " + -y + "px",
      threshold: _4e(0, R4e(1, c)) || 1
    };
    let A = !0;
    function L(I) {
      const M = I[0].intersectionRatio;
      if (M !== c) {
        if (!A)
          return a();
        M ? a(!1, M) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      A = !1;
    }
    try {
      n = new IntersectionObserver(L, {
        ...T,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(L, T);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function W4e(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, u = Jp(e), f = o || i ? [...u ? v9(u) : [], ...v9(t)] : [];
  f.forEach((x) => {
    o && x.addEventListener("scroll", n, {
      passive: !0
    }), i && x.addEventListener("resize", n);
  });
  const p = u && l ? G4e(u, n) : null;
  let h = -1, C = null;
  a && (C = new ResizeObserver((x) => {
    let [T] = x;
    T && T.target === u && C && (C.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var A;
      (A = C) == null || A.observe(t);
    })), n();
  }), u && !c && C.observe(u), C.observe(t));
  let v, b = c ? Zy(e) : null;
  c && y();
  function y() {
    const x = Zy(e);
    b && (x.x !== b.x || x.y !== b.y || x.width !== b.width || x.height !== b.height) && n(), b = x, v = requestAnimationFrame(y);
  }
  return n(), () => {
    var x;
    f.forEach((T) => {
      o && T.removeEventListener("scroll", n), i && T.removeEventListener("resize", n);
    }), p?.(), (x = C) == null || x.disconnect(), C = null, c && cancelAnimationFrame(v);
  };
}
var hd = z0, $4e = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], y9 = function() {
};
function U4e(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function j4e(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    r[o - 2] = arguments[o];
  var i = [].concat(r);
  if (t && e)
    for (var a in t)
      t.hasOwnProperty(a) && t[a] && i.push("".concat(U4e(e, a)));
  return i.filter(function(l) {
    return l;
  }).map(function(l) {
    return String(l).trim();
  }).join(" ");
}
var zy = function(t) {
  return nle(t) ? t.filter(Boolean) : Ja(t) === "object" && t !== null ? [t] : [];
}, oE = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = xi(t, $4e);
  return e1({}, n);
}, Nt = function(t, n, r) {
  var o = t.cx, i = t.getStyles, a = t.getClassNames, l = t.className;
  return {
    css: i(n, t),
    className: o(r ?? {}, a(n, t), l)
  };
};
function a6(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function X4e(e) {
  return a6(e) ? window.innerHeight : e.clientHeight;
}
function iE(e) {
  return a6(e) ? window.pageYOffset : e.scrollTop;
}
function x9(e, t) {
  if (a6(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function Y4e(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed") return document.documentElement;
  for (var o = e; o = o.parentElement; )
    if (t = getComputedStyle(o), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return o;
  return document.documentElement;
}
function J4e(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function dl(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : y9, o = iE(e), i = t - o, a = 10, l = 0;
  function c() {
    l += a;
    var u = J4e(l, o, i, n);
    x9(e, u), l < n ? window.requestAnimationFrame(c) : r(e);
  }
  c();
}
function Gy(e, t) {
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), o = t.offsetHeight / 3;
  r.bottom + o > n.bottom ? x9(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + o, e.scrollHeight)) : r.top - o < n.top && x9(e, Math.max(t.offsetTop - o, 0));
}
function Q4e(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function Wy() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function q4e() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var aE = !1, K4e = {
  get passive() {
    return aE = !0;
  }
}, fl = typeof window < "u" ? window : {};
fl.addEventListener && fl.removeEventListener && (fl.addEventListener("p", y9, K4e), fl.removeEventListener("p", y9, !1));
var ele = aE;
function tle(e) {
  return e != null;
}
function nle(e) {
  return Array.isArray(e);
}
function pl(e, t, n) {
  return e ? t : n;
}
var rle = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  var i = Object.entries(t).filter(function(a) {
    var l = ui(a, 1), c = l[0];
    return !r.includes(c);
  });
  return i.reduce(function(a, l) {
    var c = ui(l, 2), u = c[0], f = c[1];
    return a[u] = f, a;
  }, {});
}, ole = ["children", "innerProps"], ile = ["children", "innerProps"];
function ale(e) {
  var t = e.maxHeight, n = e.menuEl, r = e.minHeight, o = e.placement, i = e.shouldScroll, a = e.isFixedPosition, l = e.controlHeight, c = Y4e(n), u = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent) return u;
  var f = c.getBoundingClientRect(), p = f.height, h = n.getBoundingClientRect(), C = h.bottom, v = h.height, b = h.top, y = n.offsetParent.getBoundingClientRect(), x = y.top, T = a ? window.innerHeight : X4e(c), A = iE(c), L = parseInt(getComputedStyle(n).marginBottom, 10), I = parseInt(getComputedStyle(n).marginTop, 10), M = x - I, k = T - b, _ = M + A, F = p - A - b, $ = C - T + A + L, oe = A + b - I, te = 160;
  switch (o) {
    case "auto":
    case "bottom":
      if (k >= v)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (F >= v && !a)
        return i && dl(c, $, te), {
          placement: "bottom",
          maxHeight: t
        };
      if (!a && F >= r || a && k >= r) {
        i && dl(c, $, te);
        var ae = a ? k - L : F - L;
        return {
          placement: "bottom",
          maxHeight: ae
        };
      }
      if (o === "auto" || a) {
        var be = t, K = a ? M : _;
        return K >= r && (be = Math.min(K - L - l, t)), {
          placement: "top",
          maxHeight: be
        };
      }
      if (o === "bottom")
        return i && x9(c, $), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (M >= v)
        return {
          placement: "top",
          maxHeight: t
        };
      if (_ >= v && !a)
        return i && dl(c, oe, te), {
          placement: "top",
          maxHeight: t
        };
      if (!a && _ >= r || a && M >= r) {
        var ue = t;
        return (!a && _ >= r || a && M >= r) && (ue = a ? M - I : _ - I), i && dl(c, oe, te), {
          placement: "top",
          maxHeight: ue
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(o, '".'));
  }
  return u;
}
function sle(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var sE = function(t) {
  return t === "auto" ? "bottom" : t;
}, lle = function(t, n) {
  var r, o = t.placement, i = t.theme, a = i.borderRadius, l = i.spacing, c = i.colors;
  return e1((r = {
    label: "menu"
  }, os(r, sle(o), "100%"), os(r, "position", "absolute"), os(r, "width", "100%"), os(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: c.neutral0,
    borderRadius: a,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: l.menuGutter,
    marginTop: l.menuGutter
  });
}, lE = /* @__PURE__ */ pn(null), cle = function(t) {
  var n = t.children, r = t.minMenuHeight, o = t.maxMenuHeight, i = t.menuPlacement, a = t.menuPosition, l = t.menuShouldScrollIntoView, c = t.theme, u = N1(lE) || {}, f = u.setPortalPlacement, p = Re(null), h = ze(o), C = ui(h, 2), v = C[0], b = C[1], y = ze(null), x = ui(y, 2), T = x[0], A = x[1], L = c.spacing.controlHeight;
  return hd(function() {
    var I = p.current;
    if (I) {
      var M = a === "fixed", k = l && !M, _ = ale({
        maxHeight: o,
        menuEl: I,
        minHeight: r,
        placement: i,
        shouldScroll: k,
        isFixedPosition: M,
        controlHeight: L
      });
      b(_.maxHeight), A(_.placement), f?.(_.placement);
    }
  }, [o, i, a, l, r, f, L]), n({
    ref: p,
    placerProps: e1(e1({}, t), {}, {
      placement: T || sE(i),
      maxHeight: v
    })
  });
}, ule = function(t) {
  var n = t.children, r = t.innerRef, o = t.innerProps;
  return qe("div", He({}, Nt(t, "menu", {
    menu: !0
  }), {
    ref: r
  }, o), n);
}, dle = ule, fle = function(t, n) {
  var r = t.maxHeight, o = t.theme.spacing.baseUnit;
  return e1({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: o,
    paddingTop: o
  });
}, ple = function(t) {
  var n = t.children, r = t.innerProps, o = t.innerRef, i = t.isMulti;
  return qe("div", He({}, Nt(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": i
  }), {
    ref: o
  }, r), n);
}, cE = function(t, n) {
  var r = t.theme, o = r.spacing.baseUnit, i = r.colors;
  return e1({
    textAlign: "center"
  }, n ? {} : {
    color: i.neutral40,
    padding: "".concat(o * 2, "px ").concat(o * 3, "px")
  });
}, hle = cE, mle = cE, Cle = function(t) {
  var n = t.children, r = n === void 0 ? "No options" : n, o = t.innerProps, i = xi(t, ole);
  return qe("div", He({}, Nt(e1(e1({}, i), {}, {
    children: r,
    innerProps: o
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), r);
}, gle = function(t) {
  var n = t.children, r = n === void 0 ? "Loading..." : n, o = t.innerProps, i = xi(t, ile);
  return qe("div", He({}, Nt(e1(e1({}, i), {}, {
    children: r,
    innerProps: o
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), r);
}, ble = function(t) {
  var n = t.rect, r = t.offset, o = t.position;
  return {
    left: n.left,
    position: o,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, vle = function(t) {
  var n = t.appendTo, r = t.children, o = t.controlElement, i = t.innerProps, a = t.menuPlacement, l = t.menuPosition, c = Re(null), u = Re(null), f = ze(sE(a)), p = ui(f, 2), h = p[0], C = p[1], v = we(function() {
    return {
      setPortalPlacement: C
    };
  }, []), b = ze(null), y = ui(b, 2), x = y[0], T = y[1], A = se(function() {
    if (o) {
      var k = Q4e(o), _ = l === "fixed" ? 0 : window.pageYOffset, F = k[h] + _;
      (F !== x?.offset || k.left !== x?.rect.left || k.width !== x?.rect.width) && T({
        offset: F,
        rect: k
      });
    }
  }, [o, l, h, x?.offset, x?.rect.left, x?.rect.width]);
  hd(function() {
    A();
  }, [A]);
  var L = se(function() {
    typeof u.current == "function" && (u.current(), u.current = null), o && c.current && (u.current = W4e(o, c.current, A, {
      elementResize: "ResizeObserver" in window
    }));
  }, [o, A]);
  hd(function() {
    L();
  }, [L]);
  var I = se(function(k) {
    c.current = k, L();
  }, [L]);
  if (!n && l !== "fixed" || !x) return null;
  var M = qe("div", He({
    ref: I
  }, Nt(e1(e1({}, t), {}, {
    offset: x.offset,
    position: l,
    rect: x.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), i), r);
  return qe(lE.Provider, {
    value: v
  }, n ? /* @__PURE__ */ zd(M, n) : M);
}, yle = function(t) {
  var n = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, xle = function(t) {
  var n = t.children, r = t.innerProps, o = t.isDisabled, i = t.isRtl;
  return qe("div", He({}, Nt(t, "container", {
    "--is-disabled": o,
    "--is-rtl": i
  }), r), n);
}, wle = function(t, n) {
  var r = t.theme.spacing, o = t.isMulti, i = t.hasValue, a = t.selectProps.controlShouldRenderValue;
  return e1({
    alignItems: "center",
    display: o && i && a ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, Sle = function(t) {
  var n = t.children, r = t.innerProps, o = t.isMulti, i = t.hasValue;
  return qe("div", He({}, Nt(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": o,
    "value-container--has-value": i
  }), r), n);
}, Tle = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, Ale = function(t) {
  var n = t.children, r = t.innerProps;
  return qe("div", He({}, Nt(t, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, $y, Ile = ["size"], Lle = ["innerProps", "isRtl", "size"];
function Ele() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Mle = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Ele
}, uE = function(t) {
  var n = t.size, r = xi(t, Ile);
  return qe("svg", He({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: Mle
  }, r));
}, Qp = function(t) {
  return qe(uE, He({
    size: 20
  }, t), qe("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, dE = function(t) {
  return qe(uE, He({
    size: 20
  }, t), qe("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, fE = function(t, n) {
  var r = t.isFocused, o = t.theme, i = o.spacing.baseUnit, a = o.colors;
  return e1({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? a.neutral60 : a.neutral20,
    padding: i * 2,
    ":hover": {
      color: r ? a.neutral80 : a.neutral40
    }
  });
}, Ble = fE, kle = function(t) {
  var n = t.children, r = t.innerProps;
  return qe("div", He({}, Nt(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || qe(dE, null));
}, Rle = fE, _le = function(t) {
  var n = t.children, r = t.innerProps;
  return qe("div", He({}, Nt(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || qe(Qp, null));
}, Fle = function(t, n) {
  var r = t.isDisabled, o = t.theme, i = o.spacing.baseUnit, a = o.colors;
  return e1({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? a.neutral10 : a.neutral20,
    marginBottom: i * 2,
    marginTop: i * 2
  });
}, Ple = function(t) {
  var n = t.innerProps;
  return qe("span", He({}, n, Nt(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, Vle = W0($y || ($y = k4e([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), Hle = function(t, n) {
  var r = t.isFocused, o = t.size, i = t.theme, a = i.colors, l = i.spacing.baseUnit;
  return e1({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: o,
    lineHeight: 1,
    marginRight: o,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? a.neutral60 : a.neutral20,
    padding: l * 2
  });
}, Ec = function(t) {
  var n = t.delay, r = t.offset;
  return qe("span", {
    css: /* @__PURE__ */ uw({
      animation: "".concat(Vle, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, Ole = function(t) {
  var n = t.innerProps, r = t.isRtl, o = t.size, i = o === void 0 ? 4 : o, a = xi(t, Lle);
  return qe("div", He({}, Nt(e1(e1({}, a), {}, {
    innerProps: n,
    isRtl: r,
    size: i
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), qe(Ec, {
    delay: 0,
    offset: r
  }), qe(Ec, {
    delay: 160,
    offset: !0
  }), qe(Ec, {
    delay: 320,
    offset: !r
  }));
}, Nle = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, i = t.theme, a = i.colors, l = i.borderRadius, c = i.spacing;
  return e1({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: c.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? a.neutral5 : a.neutral0,
    borderColor: r ? a.neutral10 : o ? a.primary : a.neutral20,
    borderRadius: l,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: o ? "0 0 0 1px ".concat(a.primary) : void 0,
    "&:hover": {
      borderColor: o ? a.primary : a.neutral30
    }
  });
}, Dle = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, i = t.innerRef, a = t.innerProps, l = t.menuIsOpen;
  return qe("div", He({
    ref: i
  }, Nt(t, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": o,
    "control--menu-is-open": l
  }), a, {
    "aria-disabled": r || void 0
  }), n);
}, Zle = Dle, zle = ["data"], Gle = function(t, n) {
  var r = t.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, Wle = function(t) {
  var n = t.children, r = t.cx, o = t.getStyles, i = t.getClassNames, a = t.Heading, l = t.headingProps, c = t.innerProps, u = t.label, f = t.theme, p = t.selectProps;
  return qe("div", He({}, Nt(t, "group", {
    group: !0
  }), c), qe(a, He({}, l, {
    selectProps: p,
    theme: f,
    getStyles: o,
    getClassNames: i,
    cx: r
  }), u), qe("div", null, n));
}, $le = function(t, n) {
  var r = t.theme, o = r.colors, i = r.spacing;
  return e1({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: o.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: i.baseUnit * 3,
    paddingRight: i.baseUnit * 3,
    textTransform: "uppercase"
  });
}, Ule = function(t) {
  var n = oE(t);
  n.data;
  var r = xi(n, zle);
  return qe("div", He({}, Nt(t, "groupHeading", {
    "group-heading": !0
  }), r));
}, jle = Wle, Xle = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Yle = function(t, n) {
  var r = t.isDisabled, o = t.value, i = t.theme, a = i.spacing, l = i.colors;
  return e1(e1({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: o ? "translateZ(0)" : ""
  }, Jle), n ? {} : {
    margin: a.baseUnit / 2,
    paddingBottom: a.baseUnit / 2,
    paddingTop: a.baseUnit / 2,
    color: l.neutral80
  });
}, pE = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, Jle = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": e1({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, pE)
}, Qle = function(t) {
  return e1({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, pE);
}, qle = function(t) {
  var n = t.cx, r = t.value, o = oE(t), i = o.innerRef, a = o.isDisabled, l = o.isHidden, c = o.inputClassName, u = xi(o, Xle);
  return qe("div", He({}, Nt(t, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), qe("input", He({
    className: n({
      input: !0
    }, c),
    ref: i,
    style: Qle(l),
    disabled: a
  }, u)));
}, Kle = qle, e9e = function(t, n) {
  var r = t.theme, o = r.spacing, i = r.borderRadius, a = r.colors;
  return e1({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: a.neutral10,
    borderRadius: i / 2,
    margin: o.baseUnit / 2
  });
}, t9e = function(t, n) {
  var r = t.theme, o = r.borderRadius, i = r.colors, a = t.cropWithEllipsis;
  return e1({
    overflow: "hidden",
    textOverflow: a || a === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: o / 2,
    color: i.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, n9e = function(t, n) {
  var r = t.theme, o = r.spacing, i = r.borderRadius, a = r.colors, l = t.isFocused;
  return e1({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: i / 2,
    backgroundColor: l ? a.dangerLight : void 0,
    paddingLeft: o.baseUnit,
    paddingRight: o.baseUnit,
    ":hover": {
      backgroundColor: a.dangerLight,
      color: a.danger
    }
  });
}, hE = function(t) {
  var n = t.children, r = t.innerProps;
  return qe("div", r, n);
}, r9e = hE, o9e = hE;
function i9e(e) {
  var t = e.children, n = e.innerProps;
  return qe("div", He({
    role: "button"
  }, n), t || qe(Qp, {
    size: 14
  }));
}
var a9e = function(t) {
  var n = t.children, r = t.components, o = t.data, i = t.innerProps, a = t.isDisabled, l = t.removeProps, c = t.selectProps, u = r.Container, f = r.Label, p = r.Remove;
  return qe(u, {
    data: o,
    innerProps: e1(e1({}, Nt(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": a
    })), i),
    selectProps: c
  }, qe(f, {
    data: o,
    innerProps: e1({}, Nt(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: c
  }, n), qe(p, {
    data: o,
    innerProps: e1(e1({}, Nt(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, l),
    selectProps: c
  }));
}, s9e = a9e, l9e = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, i = t.isSelected, a = t.theme, l = a.spacing, c = a.colors;
  return e1({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: i ? c.primary : o ? c.primary25 : "transparent",
    color: r ? c.neutral20 : i ? c.neutral0 : "inherit",
    padding: "".concat(l.baseUnit * 2, "px ").concat(l.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : i ? c.primary : c.primary50
    }
  });
}, c9e = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, i = t.isSelected, a = t.innerRef, l = t.innerProps;
  return qe("div", He({}, Nt(t, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": o,
    "option--is-selected": i
  }), {
    ref: a,
    "aria-disabled": r
  }, l), n);
}, u9e = c9e, d9e = function(t, n) {
  var r = t.theme, o = r.spacing, i = r.colors;
  return e1({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: i.neutral50,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, f9e = function(t) {
  var n = t.children, r = t.innerProps;
  return qe("div", He({}, Nt(t, "placeholder", {
    placeholder: !0
  }), r), n);
}, p9e = f9e, h9e = function(t, n) {
  var r = t.isDisabled, o = t.theme, i = o.spacing, a = o.colors;
  return e1({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? a.neutral40 : a.neutral80,
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2
  });
}, m9e = function(t) {
  var n = t.children, r = t.isDisabled, o = t.innerProps;
  return qe("div", He({}, Nt(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), o), n);
}, C9e = m9e, g9e = {
  ClearIndicator: _le,
  Control: Zle,
  DropdownIndicator: kle,
  DownChevron: dE,
  CrossIcon: Qp,
  Group: jle,
  GroupHeading: Ule,
  IndicatorsContainer: Ale,
  IndicatorSeparator: Ple,
  Input: Kle,
  LoadingIndicator: Ole,
  Menu: dle,
  MenuList: ple,
  MenuPortal: vle,
  LoadingMessage: gle,
  NoOptionsMessage: Cle,
  MultiValue: s9e,
  MultiValueContainer: r9e,
  MultiValueLabel: o9e,
  MultiValueRemove: i9e,
  Option: u9e,
  Placeholder: p9e,
  SelectContainer: xle,
  SingleValue: C9e,
  ValueContainer: Sle
}, b9e = function(t) {
  return e1(e1({}, g9e), t.components);
}, Uy = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function v9e(e, t) {
  return !!(e === t || Uy(e) && Uy(t));
}
function y9e(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!v9e(e[n], t[n]))
      return !1;
  return !0;
}
function x9e(e, t) {
  t === void 0 && (t = y9e);
  var n = null;
  function r() {
    for (var o = [], i = 0; i < arguments.length; i++)
      o[i] = arguments[i];
    if (n && n.lastThis === this && t(o, n.lastArgs))
      return n.lastResult;
    var a = e.apply(this, o);
    return n = {
      lastResult: a,
      lastArgs: o,
      lastThis: this
    }, a;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function w9e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var S9e = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: w9e
}, T9e = function(t) {
  return qe("span", He({
    css: S9e
  }, t));
}, jy = T9e, A9e = {
  guidance: function(t) {
    var n = t.isSearchable, r = t.isMulti, o = t.tabSelectsValue, i = t.context, a = t.isInitialFocus;
    switch (i) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return a ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, r = t.label, o = r === void 0 ? "" : r, i = t.labels, a = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(o, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(i.length > 1 ? "s" : "", " ").concat(i.join(","), ", selected.");
      case "select-option":
        return a ? "option ".concat(o, " is disabled. Select another option.") : "option ".concat(o, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, r = t.focused, o = t.options, i = t.label, a = i === void 0 ? "" : i, l = t.selectValue, c = t.isDisabled, u = t.isSelected, f = t.isAppleDevice, p = function(b, y) {
      return b && b.length ? "".concat(b.indexOf(y) + 1, " of ").concat(b.length) : "";
    };
    if (n === "value" && l)
      return "value ".concat(a, " focused, ").concat(p(l, r), ".");
    if (n === "menu" && f) {
      var h = c ? " disabled" : "", C = "".concat(u ? " selected" : "").concat(h);
      return "".concat(a).concat(C, ", ").concat(p(o, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, I9e = function(t) {
  var n = t.ariaSelection, r = t.focusedOption, o = t.focusedValue, i = t.focusableOptions, a = t.isFocused, l = t.selectValue, c = t.selectProps, u = t.id, f = t.isAppleDevice, p = c.ariaLiveMessages, h = c.getOptionLabel, C = c.inputValue, v = c.isMulti, b = c.isOptionDisabled, y = c.isSearchable, x = c.menuIsOpen, T = c.options, A = c.screenReaderStatus, L = c.tabSelectsValue, I = c.isLoading, M = c["aria-label"], k = c["aria-live"], _ = we(function() {
    return e1(e1({}, A9e), p || {});
  }, [p]), F = we(function() {
    var K = "";
    if (n && _.onChange) {
      var ue = n.option, J = n.options, Me = n.removedValue, _e = n.removedValues, ne = n.value, ee = function(pe) {
        return Array.isArray(pe) ? null : pe;
      }, ye = Me || ue || ee(ne), fe = ye ? h(ye) : "", xe = J || _e || void 0, Te = xe ? xe.map(h) : [], Ie = e1({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: ye && b(ye, l),
        label: fe,
        labels: Te
      }, n);
      K = _.onChange(Ie);
    }
    return K;
  }, [n, _, b, l, h]), $ = we(function() {
    var K = "", ue = r || o, J = !!(r && l && l.includes(r));
    if (ue && _.onFocus) {
      var Me = {
        focused: ue,
        label: h(ue),
        isDisabled: b(ue, l),
        isSelected: J,
        options: i,
        context: ue === r ? "menu" : "value",
        selectValue: l,
        isAppleDevice: f
      };
      K = _.onFocus(Me);
    }
    return K;
  }, [r, o, h, b, _, i, l, f]), oe = we(function() {
    var K = "";
    if (x && T.length && !I && _.onFilter) {
      var ue = A({
        count: i.length
      });
      K = _.onFilter({
        inputValue: C,
        resultsMessage: ue
      });
    }
    return K;
  }, [i, C, x, _, T, A, I]), te = n?.action === "initial-input-focus", ae = we(function() {
    var K = "";
    if (_.guidance) {
      var ue = o ? "value" : x ? "menu" : "input";
      K = _.guidance({
        "aria-label": M,
        context: ue,
        isDisabled: r && b(r, l),
        isMulti: v,
        isSearchable: y,
        tabSelectsValue: L,
        isInitialFocus: te
      });
    }
    return K;
  }, [M, r, o, v, b, y, x, _, l, L, te]), be = qe(m0, null, qe("span", {
    id: "aria-selection"
  }, F), qe("span", {
    id: "aria-focused"
  }, $), qe("span", {
    id: "aria-results"
  }, oe), qe("span", {
    id: "aria-guidance"
  }, ae));
  return qe(m0, null, qe(jy, {
    id: u
  }, te && be), qe(jy, {
    "aria-live": k,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, a && !te && be));
}, L9e = I9e, md = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], E9e = new RegExp("[" + md.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), mE = {};
for (var Mc = 0; Mc < md.length; Mc++)
  for (var Bc = md[Mc], kc = 0; kc < Bc.letters.length; kc++)
    mE[Bc.letters[kc]] = Bc.base;
var CE = function(t) {
  return t.replace(E9e, function(n) {
    return mE[n];
  });
}, M9e = x9e(CE), Xy = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, B9e = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, k9e = function(t) {
  return function(n, r) {
    if (n.data.__isNew__) return !0;
    var o = e1({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: B9e,
      trim: !0,
      matchFrom: "any"
    }, t), i = o.ignoreCase, a = o.ignoreAccents, l = o.stringify, c = o.trim, u = o.matchFrom, f = c ? Xy(r) : r, p = c ? Xy(l(n)) : l(n);
    return i && (f = f.toLowerCase(), p = p.toLowerCase()), a && (f = M9e(f), p = CE(p)), u === "start" ? p.substr(0, f.length) === f : p.indexOf(f) > -1;
  };
}, R9e = ["innerRef"];
function _9e(e) {
  var t = e.innerRef, n = xi(e, R9e), r = rle(n, "onExited", "in", "enter", "exit", "appear");
  return qe("input", He({
    ref: t
  }, r, {
    css: /* @__PURE__ */ uw({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}
var F9e = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function P9e(e) {
  var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, o = e.onTopArrive, i = e.onTopLeave, a = Re(!1), l = Re(!1), c = Re(0), u = Re(null), f = se(function(y, x) {
    if (u.current !== null) {
      var T = u.current, A = T.scrollTop, L = T.scrollHeight, I = T.clientHeight, M = u.current, k = x > 0, _ = L - I - A, F = !1;
      _ > x && a.current && (r && r(y), a.current = !1), k && l.current && (i && i(y), l.current = !1), k && x > _ ? (n && !a.current && n(y), M.scrollTop = L, F = !0, a.current = !0) : !k && -x > A && (o && !l.current && o(y), M.scrollTop = 0, F = !0, l.current = !0), F && F9e(y);
    }
  }, [n, r, o, i]), p = se(function(y) {
    f(y, y.deltaY);
  }, [f]), h = se(function(y) {
    c.current = y.changedTouches[0].clientY;
  }, []), C = se(function(y) {
    var x = c.current - y.changedTouches[0].clientY;
    f(y, x);
  }, [f]), v = se(function(y) {
    if (y) {
      var x = ele ? {
        passive: !1
      } : !1;
      y.addEventListener("wheel", p, x), y.addEventListener("touchstart", h, x), y.addEventListener("touchmove", C, x);
    }
  }, [C, h, p]), b = se(function(y) {
    y && (y.removeEventListener("wheel", p, !1), y.removeEventListener("touchstart", h, !1), y.removeEventListener("touchmove", C, !1));
  }, [C, h, p]);
  return Oe(function() {
    if (t) {
      var y = u.current;
      return v(y), function() {
        b(y);
      };
    }
  }, [t, v, b]), function(y) {
    u.current = y;
  };
}
var Yy = ["boxSizing", "height", "overflow", "paddingRight", "position"], Jy = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function Qy(e) {
  e.cancelable && e.preventDefault();
}
function qy(e) {
  e.stopPropagation();
}
function Ky() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function ex() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var tx = !!(typeof window < "u" && window.document && window.document.createElement), P5 = 0, J2 = {
  capture: !1,
  passive: !1
};
function V9e(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, o = Re({}), i = Re(null), a = se(function(c) {
    if (tx) {
      var u = document.body, f = u && u.style;
      if (r && Yy.forEach(function(v) {
        var b = f && f[v];
        o.current[v] = b;
      }), r && P5 < 1) {
        var p = parseInt(o.current.paddingRight, 10) || 0, h = document.body ? document.body.clientWidth : 0, C = window.innerWidth - h + p || 0;
        Object.keys(Jy).forEach(function(v) {
          var b = Jy[v];
          f && (f[v] = b);
        }), f && (f.paddingRight = "".concat(C, "px"));
      }
      u && ex() && (u.addEventListener("touchmove", Qy, J2), c && (c.addEventListener("touchstart", Ky, J2), c.addEventListener("touchmove", qy, J2))), P5 += 1;
    }
  }, [r]), l = se(function(c) {
    if (tx) {
      var u = document.body, f = u && u.style;
      P5 = Math.max(P5 - 1, 0), r && P5 < 1 && Yy.forEach(function(p) {
        var h = o.current[p];
        f && (f[p] = h);
      }), u && ex() && (u.removeEventListener("touchmove", Qy, J2), c && (c.removeEventListener("touchstart", Ky, J2), c.removeEventListener("touchmove", qy, J2)));
    }
  }, [r]);
  return Oe(function() {
    if (t) {
      var c = i.current;
      return a(c), function() {
        l(c);
      };
    }
  }, [t, a, l]), function(c) {
    i.current = c;
  };
}
function H9e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var O9e = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, N9e = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: H9e
};
function D9e(e) {
  var t = e.children, n = e.lockEnabled, r = e.captureEnabled, o = r === void 0 ? !0 : r, i = e.onBottomArrive, a = e.onBottomLeave, l = e.onTopArrive, c = e.onTopLeave, u = P9e({
    isEnabled: o,
    onBottomArrive: i,
    onBottomLeave: a,
    onTopArrive: l,
    onTopLeave: c
  }), f = V9e({
    isEnabled: n
  }), p = function(C) {
    u(C), f(C);
  };
  return qe(m0, null, n && qe("div", {
    onClick: O9e,
    css: N9e
  }), t(p));
}
function Z9e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var z9e = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: Z9e
}, G9e = function(t) {
  var n = t.name, r = t.onFocus;
  return qe("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: z9e,
    value: "",
    onChange: function() {
    }
  });
}, W9e = G9e;
function qp(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function $9e() {
  return qp(/^iPhone/i);
}
function gE() {
  return qp(/^Mac/i);
}
function U9e() {
  return qp(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  gE() && navigator.maxTouchPoints > 1;
}
function j9e() {
  return $9e() || U9e();
}
function X9e() {
  return gE() || j9e();
}
var Y9e = function(t) {
  return t.label;
}, J9e = function(t) {
  return t.label;
}, Q9e = function(t) {
  return t.value;
}, q9e = function(t) {
  return !!t.isDisabled;
}, K9e = {
  clearIndicator: Rle,
  container: yle,
  control: Nle,
  dropdownIndicator: Ble,
  group: Gle,
  groupHeading: $le,
  indicatorsContainer: Tle,
  indicatorSeparator: Fle,
  input: Yle,
  loadingIndicator: Hle,
  loadingMessage: mle,
  menu: lle,
  menuList: fle,
  menuPortal: ble,
  multiValue: e9e,
  multiValueLabel: t9e,
  multiValueRemove: n9e,
  noOptionsMessage: hle,
  option: l9e,
  placeholder: d9e,
  singleValue: h9e,
  valueContainer: wle
}, e6e = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, t6e = 4, bE = 4, n6e = 38, r6e = bE * 2, o6e = {
  baseUnit: bE,
  controlHeight: n6e,
  menuGutter: r6e
}, Rc = {
  borderRadius: t6e,
  colors: e6e,
  spacing: o6e
}, i6e = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: Wy(),
  captureMenuScroll: !Wy(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: k9e(),
  formatGroupLabel: Y9e,
  getOptionLabel: J9e,
  getOptionValue: Q9e,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: q9e,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !q4e(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function nx(e, t, n, r) {
  var o = xE(e, t, n), i = wE(e, t, n), a = yE(e, t), l = w9(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: o,
    isSelected: i,
    label: a,
    value: l,
    index: r
  };
}
function Ol(e, t) {
  return e.options.map(function(n, r) {
    if ("options" in n) {
      var o = n.options.map(function(a, l) {
        return nx(e, a, t, l);
      }).filter(function(a) {
        return ox(e, a);
      });
      return o.length > 0 ? {
        type: "group",
        data: n,
        options: o,
        index: r
      } : void 0;
    }
    var i = nx(e, n, t, r);
    return ox(e, i) ? i : void 0;
  }).filter(tle);
}
function vE(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, jp(n.options.map(function(r) {
      return r.data;
    }))) : t.push(n.data), t;
  }, []);
}
function rx(e, t) {
  return e.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, jp(r.options.map(function(o) {
      return {
        data: o.data,
        id: "".concat(t, "-").concat(r.index, "-").concat(o.index)
      };
    }))) : n.push({
      data: r.data,
      id: "".concat(t, "-").concat(r.index)
    }), n;
  }, []);
}
function a6e(e, t) {
  return vE(Ol(e, t));
}
function ox(e, t) {
  var n = e.inputValue, r = n === void 0 ? "" : n, o = t.data, i = t.isSelected, a = t.label, l = t.value;
  return (!TE(e) || !i) && SE(e, {
    label: a,
    value: l,
    data: o
  }, r);
}
function s6e(e, t) {
  var n = e.focusedValue, r = e.selectValue, o = r.indexOf(n);
  if (o > -1) {
    var i = t.indexOf(n);
    if (i > -1)
      return n;
    if (o < t.length)
      return t[o];
  }
  return null;
}
function l6e(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var _c = function(t, n) {
  var r, o = (r = t.find(function(i) {
    return i.data === n;
  })) === null || r === void 0 ? void 0 : r.id;
  return o || null;
}, yE = function(t, n) {
  return t.getOptionLabel(n);
}, w9 = function(t, n) {
  return t.getOptionValue(n);
};
function xE(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function wE(e, t, n) {
  if (n.indexOf(t) > -1) return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var r = w9(e, t);
  return n.some(function(o) {
    return w9(e, o) === r;
  });
}
function SE(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var TE = function(t) {
  var n = t.hideSelectedOptions, r = t.isMulti;
  return n === void 0 ? r : n;
}, c6e = 1, AE = /* @__PURE__ */ function(e) {
  A4e(n, e);
  var t = L4e(n);
  function n(r) {
    var o;
    if (S4e(this, n), o = t.call(this, r), o.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, o.blockOptionHover = !1, o.isComposing = !1, o.commonProps = void 0, o.initialTouchX = 0, o.initialTouchY = 0, o.openAfterFocus = !1, o.scrollToFocusedOptionOnUpdate = !1, o.userIsDragging = void 0, o.isAppleDevice = X9e(), o.controlRef = null, o.getControlRef = function(c) {
      o.controlRef = c;
    }, o.focusedOptionRef = null, o.getFocusedOptionRef = function(c) {
      o.focusedOptionRef = c;
    }, o.menuListRef = null, o.getMenuListRef = function(c) {
      o.menuListRef = c;
    }, o.inputRef = null, o.getInputRef = function(c) {
      o.inputRef = c;
    }, o.focus = o.focusInput, o.blur = o.blurInput, o.onChange = function(c, u) {
      var f = o.props, p = f.onChange, h = f.name;
      u.name = h, o.ariaOnChange(c, u), p(c, u);
    }, o.setValue = function(c, u, f) {
      var p = o.props, h = p.closeMenuOnSelect, C = p.isMulti, v = p.inputValue;
      o.onInputChange("", {
        action: "set-value",
        prevInputValue: v
      }), h && (o.setState({
        inputIsHiddenAfterUpdate: !C
      }), o.onMenuClose()), o.setState({
        clearFocusValueOnUpdate: !0
      }), o.onChange(c, {
        action: u,
        option: f
      });
    }, o.selectOption = function(c) {
      var u = o.props, f = u.blurInputOnSelect, p = u.isMulti, h = u.name, C = o.state.selectValue, v = p && o.isOptionSelected(c, C), b = o.isOptionDisabled(c, C);
      if (v) {
        var y = o.getOptionValue(c);
        o.setValue(C.filter(function(x) {
          return o.getOptionValue(x) !== y;
        }), "deselect-option", c);
      } else if (!b)
        p ? o.setValue([].concat(jp(C), [c]), "select-option", c) : o.setValue(c, "select-option");
      else {
        o.ariaOnChange(c, {
          action: "select-option",
          option: c,
          name: h
        });
        return;
      }
      f && o.blurInput();
    }, o.removeValue = function(c) {
      var u = o.props.isMulti, f = o.state.selectValue, p = o.getOptionValue(c), h = f.filter(function(v) {
        return o.getOptionValue(v) !== p;
      }), C = pl(u, h, h[0] || null);
      o.onChange(C, {
        action: "remove-value",
        removedValue: c
      }), o.focusInput();
    }, o.clearValue = function() {
      var c = o.state.selectValue;
      o.onChange(pl(o.props.isMulti, [], null), {
        action: "clear",
        removedValues: c
      });
    }, o.popValue = function() {
      var c = o.props.isMulti, u = o.state.selectValue, f = u[u.length - 1], p = u.slice(0, u.length - 1), h = pl(c, p, p[0] || null);
      f && o.onChange(h, {
        action: "pop-value",
        removedValue: f
      });
    }, o.getFocusedOptionId = function(c) {
      return _c(o.state.focusableOptionsWithIds, c);
    }, o.getFocusableOptionsWithIds = function() {
      return rx(Ol(o.props, o.state.selectValue), o.getElementId("option"));
    }, o.getValue = function() {
      return o.state.selectValue;
    }, o.cx = function() {
      for (var c = arguments.length, u = new Array(c), f = 0; f < c; f++)
        u[f] = arguments[f];
      return j4e.apply(void 0, [o.props.classNamePrefix].concat(u));
    }, o.getOptionLabel = function(c) {
      return yE(o.props, c);
    }, o.getOptionValue = function(c) {
      return w9(o.props, c);
    }, o.getStyles = function(c, u) {
      var f = o.props.unstyled, p = K9e[c](u, f);
      p.boxSizing = "border-box";
      var h = o.props.styles[c];
      return h ? h(p, u) : p;
    }, o.getClassNames = function(c, u) {
      var f, p;
      return (f = (p = o.props.classNames)[c]) === null || f === void 0 ? void 0 : f.call(p, u);
    }, o.getElementId = function(c) {
      return "".concat(o.state.instancePrefix, "-").concat(c);
    }, o.getComponents = function() {
      return b9e(o.props);
    }, o.buildCategorizedOptions = function() {
      return Ol(o.props, o.state.selectValue);
    }, o.getCategorizedOptions = function() {
      return o.props.menuIsOpen ? o.buildCategorizedOptions() : [];
    }, o.buildFocusableOptions = function() {
      return vE(o.buildCategorizedOptions());
    }, o.getFocusableOptions = function() {
      return o.props.menuIsOpen ? o.buildFocusableOptions() : [];
    }, o.ariaOnChange = function(c, u) {
      o.setState({
        ariaSelection: e1({
          value: c
        }, u)
      });
    }, o.onMenuMouseDown = function(c) {
      c.button === 0 && (c.stopPropagation(), c.preventDefault(), o.focusInput());
    }, o.onMenuMouseMove = function(c) {
      o.blockOptionHover = !1;
    }, o.onControlMouseDown = function(c) {
      if (!c.defaultPrevented) {
        var u = o.props.openMenuOnClick;
        o.state.isFocused ? o.props.menuIsOpen ? c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && o.onMenuClose() : u && o.openMenu("first") : (u && (o.openAfterFocus = !0), o.focusInput()), c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && c.preventDefault();
      }
    }, o.onDropdownIndicatorMouseDown = function(c) {
      if (!(c && c.type === "mousedown" && c.button !== 0) && !o.props.isDisabled) {
        var u = o.props, f = u.isMulti, p = u.menuIsOpen;
        o.focusInput(), p ? (o.setState({
          inputIsHiddenAfterUpdate: !f
        }), o.onMenuClose()) : o.openMenu("first"), c.preventDefault();
      }
    }, o.onClearIndicatorMouseDown = function(c) {
      c && c.type === "mousedown" && c.button !== 0 || (o.clearValue(), c.preventDefault(), o.openAfterFocus = !1, c.type === "touchend" ? o.focusInput() : setTimeout(function() {
        return o.focusInput();
      }));
    }, o.onScroll = function(c) {
      typeof o.props.closeMenuOnScroll == "boolean" ? c.target instanceof HTMLElement && a6(c.target) && o.props.onMenuClose() : typeof o.props.closeMenuOnScroll == "function" && o.props.closeMenuOnScroll(c) && o.props.onMenuClose();
    }, o.onCompositionStart = function() {
      o.isComposing = !0;
    }, o.onCompositionEnd = function() {
      o.isComposing = !1;
    }, o.onTouchStart = function(c) {
      var u = c.touches, f = u && u.item(0);
      f && (o.initialTouchX = f.clientX, o.initialTouchY = f.clientY, o.userIsDragging = !1);
    }, o.onTouchMove = function(c) {
      var u = c.touches, f = u && u.item(0);
      if (f) {
        var p = Math.abs(f.clientX - o.initialTouchX), h = Math.abs(f.clientY - o.initialTouchY), C = 5;
        o.userIsDragging = p > C || h > C;
      }
    }, o.onTouchEnd = function(c) {
      o.userIsDragging || (o.controlRef && !o.controlRef.contains(c.target) && o.menuListRef && !o.menuListRef.contains(c.target) && o.blurInput(), o.initialTouchX = 0, o.initialTouchY = 0);
    }, o.onControlTouchEnd = function(c) {
      o.userIsDragging || o.onControlMouseDown(c);
    }, o.onClearIndicatorTouchEnd = function(c) {
      o.userIsDragging || o.onClearIndicatorMouseDown(c);
    }, o.onDropdownIndicatorTouchEnd = function(c) {
      o.userIsDragging || o.onDropdownIndicatorMouseDown(c);
    }, o.handleInputChange = function(c) {
      var u = o.props.inputValue, f = c.currentTarget.value;
      o.setState({
        inputIsHiddenAfterUpdate: !1
      }), o.onInputChange(f, {
        action: "input-change",
        prevInputValue: u
      }), o.props.menuIsOpen || o.onMenuOpen();
    }, o.onInputFocus = function(c) {
      o.props.onFocus && o.props.onFocus(c), o.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (o.openAfterFocus || o.props.openMenuOnFocus) && o.openMenu("first"), o.openAfterFocus = !1;
    }, o.onInputBlur = function(c) {
      var u = o.props.inputValue;
      if (o.menuListRef && o.menuListRef.contains(document.activeElement)) {
        o.inputRef.focus();
        return;
      }
      o.props.onBlur && o.props.onBlur(c), o.onInputChange("", {
        action: "input-blur",
        prevInputValue: u
      }), o.onMenuClose(), o.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, o.onOptionHover = function(c) {
      if (!(o.blockOptionHover || o.state.focusedOption === c)) {
        var u = o.getFocusableOptions(), f = u.indexOf(c);
        o.setState({
          focusedOption: c,
          focusedOptionId: f > -1 ? o.getFocusedOptionId(c) : null
        });
      }
    }, o.shouldHideSelectedOptions = function() {
      return TE(o.props);
    }, o.onValueInputFocus = function(c) {
      c.preventDefault(), c.stopPropagation(), o.focus();
    }, o.onKeyDown = function(c) {
      var u = o.props, f = u.isMulti, p = u.backspaceRemovesValue, h = u.escapeClearsValue, C = u.inputValue, v = u.isClearable, b = u.isDisabled, y = u.menuIsOpen, x = u.onKeyDown, T = u.tabSelectsValue, A = u.openMenuOnFocus, L = o.state, I = L.focusedOption, M = L.focusedValue, k = L.selectValue;
      if (!b && !(typeof x == "function" && (x(c), c.defaultPrevented))) {
        switch (o.blockOptionHover = !0, c.key) {
          case "ArrowLeft":
            if (!f || C) return;
            o.focusValue("previous");
            break;
          case "ArrowRight":
            if (!f || C) return;
            o.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (C) return;
            if (M)
              o.removeValue(M);
            else {
              if (!p) return;
              f ? o.popValue() : v && o.clearValue();
            }
            break;
          case "Tab":
            if (o.isComposing || c.shiftKey || !y || !T || !I || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            A && o.isOptionSelected(I, k))
              return;
            o.selectOption(I);
            break;
          case "Enter":
            if (c.keyCode === 229)
              break;
            if (y) {
              if (!I || o.isComposing) return;
              o.selectOption(I);
              break;
            }
            return;
          case "Escape":
            y ? (o.setState({
              inputIsHiddenAfterUpdate: !1
            }), o.onInputChange("", {
              action: "menu-close",
              prevInputValue: C
            }), o.onMenuClose()) : v && h && o.clearValue();
            break;
          case " ":
            if (C)
              return;
            if (!y) {
              o.openMenu("first");
              break;
            }
            if (!I) return;
            o.selectOption(I);
            break;
          case "ArrowUp":
            y ? o.focusOption("up") : o.openMenu("last");
            break;
          case "ArrowDown":
            y ? o.focusOption("down") : o.openMenu("first");
            break;
          case "PageUp":
            if (!y) return;
            o.focusOption("pageup");
            break;
          case "PageDown":
            if (!y) return;
            o.focusOption("pagedown");
            break;
          case "Home":
            if (!y) return;
            o.focusOption("first");
            break;
          case "End":
            if (!y) return;
            o.focusOption("last");
            break;
          default:
            return;
        }
        c.preventDefault();
      }
    }, o.state.instancePrefix = "react-select-" + (o.props.instanceId || ++c6e), o.state.selectValue = zy(r.value), r.menuIsOpen && o.state.selectValue.length) {
      var i = o.getFocusableOptionsWithIds(), a = o.buildFocusableOptions(), l = a.indexOf(o.state.selectValue[0]);
      o.state.focusableOptionsWithIds = i, o.state.focusedOption = a[l], o.state.focusedOptionId = _c(i, a[l]);
    }
    return o;
  }
  return T4e(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && Gy(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var i = this.props, a = i.isDisabled, l = i.menuIsOpen, c = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (c && !a && o.isDisabled || // ensure focus is on the Input when the menu opens
      c && l && !o.menuIsOpen) && this.focusInput(), c && a && !o.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !c && !a && o.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (Gy(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(o, i) {
      this.props.onInputChange(o, i);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(o) {
      var i = this, a = this.state, l = a.selectValue, c = a.isFocused, u = this.buildFocusableOptions(), f = o === "first" ? 0 : u.length - 1;
      if (!this.props.isMulti) {
        var p = u.indexOf(l[0]);
        p > -1 && (f = p);
      }
      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: u[f],
        focusedOptionId: this.getFocusedOptionId(u[f])
      }, function() {
        return i.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(o) {
      var i = this.state, a = i.selectValue, l = i.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = a.indexOf(l);
        l || (c = -1);
        var u = a.length - 1, f = -1;
        if (a.length) {
          switch (o) {
            case "previous":
              c === 0 ? f = 0 : c === -1 ? f = u : f = c - 1;
              break;
            case "next":
              c > -1 && c < u && (f = c + 1);
              break;
          }
          this.setState({
            inputIsHidden: f !== -1,
            focusedValue: a[f]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", i = this.props.pageSize, a = this.state.focusedOption, l = this.getFocusableOptions();
      if (l.length) {
        var c = 0, u = l.indexOf(a);
        a || (u = -1), o === "up" ? c = u > 0 ? u - 1 : l.length - 1 : o === "down" ? c = (u + 1) % l.length : o === "pageup" ? (c = u - i, c < 0 && (c = 0)) : o === "pagedown" ? (c = u + i, c > l.length - 1 && (c = l.length - 1)) : o === "last" && (c = l.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: l[c],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(l[c])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(Rc) : e1(e1({}, Rc), this.props.theme) : Rc;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var o = this.clearValue, i = this.cx, a = this.getStyles, l = this.getClassNames, c = this.getValue, u = this.selectOption, f = this.setValue, p = this.props, h = p.isMulti, C = p.isRtl, v = p.options, b = this.hasValue();
      return {
        clearValue: o,
        cx: i,
        getStyles: a,
        getClassNames: l,
        getValue: c,
        hasValue: b,
        isMulti: h,
        isRtl: C,
        options: v,
        selectOption: u,
        selectProps: p,
        setValue: f,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var o = this.state.selectValue;
      return o.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var o = this.props, i = o.isClearable, a = o.isMulti;
      return i === void 0 ? a : i;
    }
  }, {
    key: "isOptionDisabled",
    value: function(o, i) {
      return xE(this.props, o, i);
    }
  }, {
    key: "isOptionSelected",
    value: function(o, i) {
      return wE(this.props, o, i);
    }
  }, {
    key: "filterOption",
    value: function(o, i) {
      return SE(this.props, o, i);
    }
  }, {
    key: "formatOptionLabel",
    value: function(o, i) {
      if (typeof this.props.formatOptionLabel == "function") {
        var a = this.props.inputValue, l = this.state.selectValue;
        return this.props.formatOptionLabel(o, {
          context: i,
          inputValue: a,
          selectValue: l
        });
      } else
        return this.getOptionLabel(o);
    }
  }, {
    key: "formatGroupLabel",
    value: function(o) {
      return this.props.formatGroupLabel(o);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var o = this.props, i = o.isDisabled, a = o.isSearchable, l = o.inputId, c = o.inputValue, u = o.tabIndex, f = o.form, p = o.menuIsOpen, h = o.required, C = this.getComponents(), v = C.Input, b = this.state, y = b.inputIsHidden, x = b.ariaSelection, T = this.commonProps, A = l || this.getElementId("input"), L = e1(e1(e1({
          "aria-autocomplete": "list",
          "aria-expanded": p,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": h,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, p && {
          "aria-controls": this.getElementId("listbox")
        }), !a && {
          "aria-readonly": !0
        }), this.hasValue() ? x?.action === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return a ? /* @__PURE__ */ Se.createElement(v, He({}, T, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: A,
          innerRef: this.getInputRef,
          isDisabled: i,
          isHidden: y,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: u,
          form: f,
          type: "text",
          value: c
        }, L)) : /* @__PURE__ */ Se.createElement(_9e, He({
          id: A,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: y9,
          onFocus: this.onInputFocus,
          disabled: i,
          tabIndex: u,
          inputMode: "none",
          form: f,
          value: ""
        }, L));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var o = this, i = this.getComponents(), a = i.MultiValue, l = i.MultiValueContainer, c = i.MultiValueLabel, u = i.MultiValueRemove, f = i.SingleValue, p = i.Placeholder, h = this.commonProps, C = this.props, v = C.controlShouldRenderValue, b = C.isDisabled, y = C.isMulti, x = C.inputValue, T = C.placeholder, A = this.state, L = A.selectValue, I = A.focusedValue, M = A.isFocused;
      if (!this.hasValue() || !v)
        return x ? null : /* @__PURE__ */ Se.createElement(p, He({}, h, {
          key: "placeholder",
          isDisabled: b,
          isFocused: M,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), T);
      if (y)
        return L.map(function(_, F) {
          var $ = _ === I, oe = "".concat(o.getOptionLabel(_), "-").concat(o.getOptionValue(_));
          return /* @__PURE__ */ Se.createElement(a, He({}, h, {
            components: {
              Container: l,
              Label: c,
              Remove: u
            },
            isFocused: $,
            isDisabled: b,
            key: oe,
            index: F,
            removeProps: {
              onClick: function() {
                return o.removeValue(_);
              },
              onTouchEnd: function() {
                return o.removeValue(_);
              },
              onMouseDown: function(ae) {
                ae.preventDefault();
              }
            },
            data: _
          }), o.formatOptionLabel(_, "value"));
        });
      if (x)
        return null;
      var k = L[0];
      return /* @__PURE__ */ Se.createElement(f, He({}, h, {
        data: k,
        isDisabled: b
      }), this.formatOptionLabel(k, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var o = this.getComponents(), i = o.ClearIndicator, a = this.commonProps, l = this.props, c = l.isDisabled, u = l.isLoading, f = this.state.isFocused;
      if (!this.isClearable() || !i || c || !this.hasValue() || u)
        return null;
      var p = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ Se.createElement(i, He({}, a, {
        innerProps: p,
        isFocused: f
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var o = this.getComponents(), i = o.LoadingIndicator, a = this.commonProps, l = this.props, c = l.isDisabled, u = l.isLoading, f = this.state.isFocused;
      if (!i || !u) return null;
      var p = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ Se.createElement(i, He({}, a, {
        innerProps: p,
        isDisabled: c,
        isFocused: f
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var o = this.getComponents(), i = o.DropdownIndicator, a = o.IndicatorSeparator;
      if (!i || !a) return null;
      var l = this.commonProps, c = this.props.isDisabled, u = this.state.isFocused;
      return /* @__PURE__ */ Se.createElement(a, He({}, l, {
        isDisabled: c,
        isFocused: u
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var o = this.getComponents(), i = o.DropdownIndicator;
      if (!i) return null;
      var a = this.commonProps, l = this.props.isDisabled, c = this.state.isFocused, u = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ Se.createElement(i, He({}, a, {
        innerProps: u,
        isDisabled: l,
        isFocused: c
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var o = this, i = this.getComponents(), a = i.Group, l = i.GroupHeading, c = i.Menu, u = i.MenuList, f = i.MenuPortal, p = i.LoadingMessage, h = i.NoOptionsMessage, C = i.Option, v = this.commonProps, b = this.state.focusedOption, y = this.props, x = y.captureMenuScroll, T = y.inputValue, A = y.isLoading, L = y.loadingMessage, I = y.minMenuHeight, M = y.maxMenuHeight, k = y.menuIsOpen, _ = y.menuPlacement, F = y.menuPosition, $ = y.menuPortalTarget, oe = y.menuShouldBlockScroll, te = y.menuShouldScrollIntoView, ae = y.noOptionsMessage, be = y.onMenuScrollToTop, K = y.onMenuScrollToBottom;
      if (!k) return null;
      var ue = function(fe, xe) {
        var Te = fe.type, Ie = fe.data, Q = fe.isDisabled, pe = fe.isSelected, me = fe.label, Be = fe.value, We = b === Ie, ie = Q ? void 0 : function() {
          return o.onOptionHover(Ie);
        }, f1 = Q ? void 0 : function() {
          return o.selectOption(Ie);
        }, s1 = "".concat(o.getElementId("option"), "-").concat(xe), Ye = {
          id: s1,
          onClick: f1,
          onMouseMove: ie,
          onMouseOver: ie,
          tabIndex: -1,
          role: "option",
          "aria-selected": o.isAppleDevice ? void 0 : pe
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ Se.createElement(C, He({}, v, {
          innerProps: Ye,
          data: Ie,
          isDisabled: Q,
          isSelected: pe,
          key: s1,
          label: me,
          type: Te,
          value: Be,
          isFocused: We,
          innerRef: We ? o.getFocusedOptionRef : void 0
        }), o.formatOptionLabel(fe.data, "menu"));
      }, J;
      if (this.hasOptions())
        J = this.getCategorizedOptions().map(function(ye) {
          if (ye.type === "group") {
            var fe = ye.data, xe = ye.options, Te = ye.index, Ie = "".concat(o.getElementId("group"), "-").concat(Te), Q = "".concat(Ie, "-heading");
            return /* @__PURE__ */ Se.createElement(a, He({}, v, {
              key: Ie,
              data: fe,
              options: xe,
              Heading: l,
              headingProps: {
                id: Q,
                data: ye.data
              },
              label: o.formatGroupLabel(ye.data)
            }), ye.options.map(function(pe) {
              return ue(pe, "".concat(Te, "-").concat(pe.index));
            }));
          } else if (ye.type === "option")
            return ue(ye, "".concat(ye.index));
        });
      else if (A) {
        var Me = L({
          inputValue: T
        });
        if (Me === null) return null;
        J = /* @__PURE__ */ Se.createElement(p, v, Me);
      } else {
        var _e = ae({
          inputValue: T
        });
        if (_e === null) return null;
        J = /* @__PURE__ */ Se.createElement(h, v, _e);
      }
      var ne = {
        minMenuHeight: I,
        maxMenuHeight: M,
        menuPlacement: _,
        menuPosition: F,
        menuShouldScrollIntoView: te
      }, ee = /* @__PURE__ */ Se.createElement(cle, He({}, v, ne), function(ye) {
        var fe = ye.ref, xe = ye.placerProps, Te = xe.placement, Ie = xe.maxHeight;
        return /* @__PURE__ */ Se.createElement(c, He({}, v, ne, {
          innerRef: fe,
          innerProps: {
            onMouseDown: o.onMenuMouseDown,
            onMouseMove: o.onMenuMouseMove
          },
          isLoading: A,
          placement: Te
        }), /* @__PURE__ */ Se.createElement(D9e, {
          captureEnabled: x,
          onTopArrive: be,
          onBottomArrive: K,
          lockEnabled: oe
        }, function(Q) {
          return /* @__PURE__ */ Se.createElement(u, He({}, v, {
            innerRef: function(me) {
              o.getMenuListRef(me), Q(me);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": v.isMulti,
              id: o.getElementId("listbox")
            },
            isLoading: A,
            maxHeight: Ie,
            focusedOption: b
          }), J);
        }));
      });
      return $ || F === "fixed" ? /* @__PURE__ */ Se.createElement(f, He({}, v, {
        appendTo: $,
        controlElement: this.controlRef,
        menuPlacement: _,
        menuPosition: F
      }), ee) : ee;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var o = this, i = this.props, a = i.delimiter, l = i.isDisabled, c = i.isMulti, u = i.name, f = i.required, p = this.state.selectValue;
      if (f && !this.hasValue() && !l)
        return /* @__PURE__ */ Se.createElement(W9e, {
          name: u,
          onFocus: this.onValueInputFocus
        });
      if (!(!u || l))
        if (c)
          if (a) {
            var h = p.map(function(b) {
              return o.getOptionValue(b);
            }).join(a);
            return /* @__PURE__ */ Se.createElement("input", {
              name: u,
              type: "hidden",
              value: h
            });
          } else {
            var C = p.length > 0 ? p.map(function(b, y) {
              return /* @__PURE__ */ Se.createElement("input", {
                key: "i-".concat(y),
                name: u,
                type: "hidden",
                value: o.getOptionValue(b)
              });
            }) : /* @__PURE__ */ Se.createElement("input", {
              name: u,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ Se.createElement("div", null, C);
          }
        else {
          var v = p[0] ? this.getOptionValue(p[0]) : "";
          return /* @__PURE__ */ Se.createElement("input", {
            name: u,
            type: "hidden",
            value: v
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var o = this.commonProps, i = this.state, a = i.ariaSelection, l = i.focusedOption, c = i.focusedValue, u = i.isFocused, f = i.selectValue, p = this.getFocusableOptions();
      return /* @__PURE__ */ Se.createElement(L9e, He({}, o, {
        id: this.getElementId("live-region"),
        ariaSelection: a,
        focusedOption: l,
        focusedValue: c,
        isFocused: u,
        selectValue: f,
        focusableOptions: p,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var o = this.getComponents(), i = o.Control, a = o.IndicatorsContainer, l = o.SelectContainer, c = o.ValueContainer, u = this.props, f = u.className, p = u.id, h = u.isDisabled, C = u.menuIsOpen, v = this.state.isFocused, b = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ Se.createElement(l, He({}, b, {
        className: f,
        innerProps: {
          id: p,
          onKeyDown: this.onKeyDown
        },
        isDisabled: h,
        isFocused: v
      }), this.renderLiveRegion(), /* @__PURE__ */ Se.createElement(i, He({}, b, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: h,
        isFocused: v,
        menuIsOpen: C
      }), /* @__PURE__ */ Se.createElement(c, He({}, b, {
        isDisabled: h
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ Se.createElement(a, He({}, b, {
        isDisabled: h
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, i) {
      var a = i.prevProps, l = i.clearFocusValueOnUpdate, c = i.inputIsHiddenAfterUpdate, u = i.ariaSelection, f = i.isFocused, p = i.prevWasFocused, h = i.instancePrefix, C = o.options, v = o.value, b = o.menuIsOpen, y = o.inputValue, x = o.isMulti, T = zy(v), A = {};
      if (a && (v !== a.value || C !== a.options || b !== a.menuIsOpen || y !== a.inputValue)) {
        var L = b ? a6e(o, T) : [], I = b ? rx(Ol(o, T), "".concat(h, "-option")) : [], M = l ? s6e(i, T) : null, k = l6e(i, L), _ = _c(I, k);
        A = {
          selectValue: T,
          focusedOption: k,
          focusedOptionId: _,
          focusableOptionsWithIds: I,
          focusedValue: M,
          clearFocusValueOnUpdate: !1
        };
      }
      var F = c != null && o !== a ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {}, $ = u, oe = f && p;
      return f && !oe && ($ = {
        value: pl(x, T, T[0] || null),
        options: T,
        action: "initial-input-focus"
      }, oe = !p), u?.action === "initial-input-focus" && ($ = null), e1(e1(e1({}, A), F), {}, {
        prevProps: o,
        ariaSelection: $,
        prevWasFocused: oe
      });
    }
  }]), n;
}(iH);
AE.defaultProps = i6e;
var u6e = /* @__PURE__ */ ro(function(e, t) {
  var n = w4e(e);
  return /* @__PURE__ */ Se.createElement(AE, He({
    ref: t
  }, n));
}), d6e = u6e;
const IE = pn({ styles: {} }), f6e = () => X(st, { children: [g(yp, { w: Mr.sizes[4], h: Mr.sizes[4], className: fn.SELECT__DROPDOWN_ICON_DOWN, display: "none" }), g(zoe, { w: Mr.sizes[4], h: Mr.sizes[4], className: fn.SELECT__DROPDOWN_ICON_UP, display: "none" })] }), p6e = () => null, h6e = () => {
  const { colorMode: e } = Ee();
  return g(re, { mx: H.sizes[4], h: H.sizes[10], color: H.colors[e].text.tertiary, alignItems: "center", justifyContent: "center", children: g(ZI, { fontSize: H.sizes[6] }) });
}, m6e = ({ innerRef: e, innerProps: t, children: n, ...r }) => {
  const { colorMode: o } = Ee(), { styles: i } = N1(IE);
  return X(re, { ref: e, alignItems: "center", ...F9(i)(H), borderRadius: 0, _hover: { backgroundColor: H.colors[o].layer[4].hover }, _active: { backgroundColor: H.colors[o].layer[4].hover }, ...r.isSelected ? {
    backgroundColor: H.colors[o].layer[4].hover
  } : {
    backgroundColor: H.colors[o].layer[4].default
  }, ...t, children: [n, r.isSelected && X(st, { children: [g(rd, { size: "fill" }), g(pi, { p: H.sizes[1], children: g(xp, { fontSize: H.sizes[4] }) })] })] });
}, C6e = () => {
  const { colorMode: e } = Ee(), { formatMessage: t } = n1();
  return g(re, { ...hs.body.sm, mx: H.sizes[4], h: H.sizes[10], color: H.colors[e].text.tertiary, alignItems: "center", children: t({ id: "component.select.message-no-options" }) });
}, LE = H.components.Input, g6e = LE.defaultProps, b6e = LE.sizes;
ro(({ size: e = g6e.size, components: t, styles: n, ...r }, o) => {
  const { colorMode: i } = Ee(), a = Gt(e) ?? e, l = b6e[a].field, c = we(() => ({
    control: (f, p) => ({
      ...f,
      alignItems: "start",
      minHeight: 0,
      backgroundColor: H.colors[i].input[1],
      borderColor: H.colors[i].border[4],
      color: H.colors[i].text.primary,
      ":hover, :active": {
        borderColor: H.colors[i].border[4]
      },
      ...F9(l)(H),
      ...p.isFocused ? {
        borderColor: H.colors[i].border.brand,
        boxShadow: `0 0 0 1px ${H.colors[i].border.brand}`,
        ":hover, :active": {
          borderColor: H.colors[i].border.brand
        }
      } : {},
      [p.menuIsOpen ? `.${fn.SELECT__DROPDOWN_ICON_UP}` : `.${fn.SELECT__DROPDOWN_ICON_DOWN}`]: {
        display: "block"
      }
    }),
    valueContainer: (f, p) => ({
      ...f,
      padding: 0,
      height: "100%"
    }),
    indicatorsContainer: (f, p) => ({
      ...f,
      fontSize: H.sizes[6],
      color: H.colors[i].text.secondary
    }),
    indicatorSeparator: () => ({
      display: "none"
    }),
    dropdownIndicator: (f, p) => ({
      ...f,
      margin: 0,
      padding: 0
    }),
    input: (f, p) => ({
      ...f,
      margin: 0,
      padding: 0,
      color: H.colors[i].text.primary
    }),
    singleValue: (f, p) => ({
      ...f,
      color: H.colors[i].text.primary
    }),
    menu: (f, p) => ({
      ...f,
      backgroundColor: H.colors[i].input[1],
      borderRadius: H.sizes[2],
      overflow: "hidden"
    }),
    menuList: (f, p) => ({
      ...f
    }),
    ...n
  }), [i, l, n]), u = we(() => ({
    DropdownIndicator: f6e,
    LoadingIndicator: p6e,
    LoadingMessage: h6e,
    Option: m6e,
    NoOptionsMessage: C6e,
    ...t
  }), [t]);
  return g(IE.Provider, { value: { styles: l }, children: g(d6e, { ref: o, styles: c, components: u, ...r }) });
});
Le((e, t) => g(U1, { ref: t, as: Goe, fontSize: Mr.sizes["1.5"], verticalAlign: "top", mr: Mr.sizes[2], ...e }));
const EE = pn({ orientation: "horizontal" });
Le(({ size: e, ...t }, n) => {
  const { colorMode: r } = Ee();
  return g(re, { ref: n, flex: 1, flexBasis: e, opacity: 0.1, borderColor: H.colors[r].border[4], borderStyle: "solid", borderWidth: H.sizes["0.5"], ...t });
});
Le((e, t) => g(re, { ref: t, flex: 1, ...e }));
Le((e, t) => {
  const { orientation: n, size: r } = N1(EE);
  return g(re, { ref: t, alignItems: "center", justifyContent: "center", flexDirection: n === "horizontal" ? "row" : "column", sx: {
    ...r === "fill" && {
      ":not(:last-of-type)": {
        flex: 1
      }
    }
  }, ...e });
});
Le((e, t) => {
  const { colorMode: n } = Ee();
  return g(re, { ref: t, w: H.sizes[4], h: H.sizes[4], borderColor: H.colors[n].border[4], borderStyle: "solid", borderWidth: H.sizes[1], borderRadius: "50%", ...e });
});
Le(({ orientation: e, size: t, ...n }, r) => {
  const { colorMode: o } = Ee();
  return g(EE.Provider, { value: { orientation: e, size: t }, children: g(re, { ref: r, borderColor: H.colors[o].border[3], flexDirection: e === "horizontal" ? "row" : "column", w: "100%", h: "100%", ...n }) });
});
const ME = pn({ status: "info" }), v6e = {
  variant: "solid"
};
Le((e, t) => g(U9, { ref: t, variant: "ghost", alignSelf: "center", minW: "auto", w: H.sizes[6], h: H.sizes[6], p: 0, borderRadius: "50%", sx: {
  svg: {
    w: H.sizes[4],
    h: H.sizes[4]
  }
}, ...e, children: g(d2, {}) }));
const y6e = Le((e, t) => g(re, { ref: t, flex: 1, flexDirection: "column", p: Mr.sizes[4], ml: `-${Mr.sizes[1]}`, pointerEvents: "none", ...e }));
Le(({ variant: e, size: t, ...n }, r) => {
  const { colorMode: o } = Ee();
  return g(mt, { ref: r, variant: "body", size: { base: "md" }, color: H.colors[o].text.primary, ...n });
});
Le((e, t) => {
  const { colorMode: n } = Ee();
  return g(re, { ref: t, borderColor: H.colors[n].border[3], borderStyle: "solid", borderWidth: "1px", mx: H.sizes[3], my: `-${H.sizes[4]}`, ...e });
});
const x6e = Le((e, t) => {
  const { status: n } = N1(ME);
  return g(g4e, { ref: t, status: n, size: H.sizes[6], ...e });
}), w6e = Le((e, t) => g(re, { ref: t, p: Mr.sizes[4], mr: `-${Mr.sizes[4]}`, ...e }));
Le((e, t) => g(re, { ref: t, p: Mr.sizes[4], ...e }));
const S6e = Le(({ variant: e, size: t, ...n }, r) => {
  const { colorMode: o } = Ee();
  return g(mt, { ref: r, variant: "body", size: { base: "md" }, fontWeight: "700", color: H.colors[o].text.primary, mb: { base: H.sizes[1] }, ...n });
}), T6e = Le(({ status: e, variant: t = v6e.variant, ...n }, r) => {
  const { colorMode: o } = Ee(), i = Gt(e) ?? e, a = Gt(t) ?? t;
  return g(ME.Provider, { value: { status: i }, children: g(re, { ref: r, bg: H.colors[o].layer[3].default, color: H.colors[o].text.primary, borderRadius: H.sizes[2], overflow: "hidden", ...a === "left-accent" && {
    boxShadow: `-${H.sizes[1]} ${H.sizes[0]} ${H.sizes[0]} ${H.sizes[0]} ${H.colors[o].support[C9[i]][4]}, ${H.colors[o].shadow[2]}`
  }, ...a === "bottom-accent" && {
    boxShadow: `${H.sizes[0]} ${H.sizes[1]} ${H.sizes[0]} ${H.sizes[0]} ${H.colors[o].support[C9[i]][4]}, ${H.colors[o].shadow[2]}`,
    mb: H.sizes[1]
  }, ...n }) });
});
var U5 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var A6e = U5.exports, ix;
function I6e() {
  return ix || (ix = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", o = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", l = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", u = 500, f = "__lodash_placeholder__", p = 1, h = 2, C = 4, v = 1, b = 2, y = 1, x = 2, T = 4, A = 8, L = 16, I = 32, M = 64, k = 128, _ = 256, F = 512, $ = 30, oe = "...", te = 800, ae = 16, be = 1, K = 2, ue = 3, J = 1 / 0, Me = 9007199254740991, _e = 17976931348623157e292, ne = NaN, ee = 4294967295, ye = ee - 1, fe = ee >>> 1, xe = [
        ["ary", k],
        ["bind", y],
        ["bindKey", x],
        ["curry", A],
        ["curryRight", L],
        ["flip", F],
        ["partial", I],
        ["partialRight", M],
        ["rearg", _]
      ], Te = "[object Arguments]", Ie = "[object Array]", Q = "[object AsyncFunction]", pe = "[object Boolean]", me = "[object Date]", Be = "[object DOMException]", We = "[object Error]", ie = "[object Function]", f1 = "[object GeneratorFunction]", s1 = "[object Map]", Ye = "[object Number]", B1 = "[object Null]", Pe = "[object Object]", j1 = "[object Promise]", X1 = "[object Proxy]", p1 = "[object RegExp]", L1 = "[object Set]", Ct = "[object String]", Z1 = "[object Symbol]", r1 = "[object Undefined]", ut = "[object WeakMap]", rn = "[object WeakSet]", on = "[object ArrayBuffer]", ln = "[object DataView]", Ca = "[object Float32Array]", wi = "[object Float64Array]", No = "[object Int8Array]", Si = "[object Int16Array]", Js = "[object Int32Array]", Qs = "[object Uint8Array]", Zr = "[object Uint8ClampedArray]", Ti = "[object Uint16Array]", qs = "[object Uint32Array]", I3 = /\b__p \+= '';/g, B6 = /\b(__p \+=) '' \+/g, L3 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ai = /&(?:amp|lt|gt|quot|#39);/g, E3 = /[&<>"']/g, Do = RegExp(Ai.source), k6 = RegExp(E3.source), R6 = /<%-([\s\S]+?)%>/g, _6 = /<%([\s\S]+?)%>/g, M3 = /<%=([\s\S]+?)%>/g, F6 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, zr = /^\w*$/, P6 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ks = /[\\^$.*+?()[\]{}|]/g, V6 = RegExp(Ks.source), e5 = /^\s+/, H6 = /\s/, Ii = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, O6 = /\{\n\/\* \[wrapped with (.+)\] \*/, N6 = /,? & /, D6 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Z6 = /[()=,{}\[\]\/\s]/, z6 = /\\(\\)?/g, Li = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, B3 = /\w*$/, G6 = /^[-+]0x[0-9a-f]+$/i, W6 = /^0b[01]+$/i, $6 = /^\[object .+?Constructor\]$/, U6 = /^0o[0-7]+$/i, j6 = /^(?:0|[1-9]\d*)$/, t5 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, T2 = /($^)/, A2 = /['\n\r\u2028\u2029\\]/g, Ei = "\\ud800-\\udfff", X6 = "\\u0300-\\u036f", I2 = "\\ufe20-\\ufe2f", k3 = "\\u20d0-\\u20ff", R3 = X6 + I2 + k3, _3 = "\\u2700-\\u27bf", F3 = "a-z\\xdf-\\xf6\\xf8-\\xff", P3 = "\\xac\\xb1\\xd7\\xf7", Y6 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", J6 = "\\u2000-\\u206f", Q6 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", V3 = "A-Z\\xc0-\\xd6\\xd8-\\xde", H3 = "\\ufe0e\\ufe0f", O3 = P3 + Y6 + J6 + Q6, n5 = "['’]", q6 = "[" + Ei + "]", N3 = "[" + O3 + "]", L2 = "[" + R3 + "]", ga = "\\d+", r5 = "[" + _3 + "]", D3 = "[" + F3 + "]", Z3 = "[^" + Ei + O3 + ga + _3 + F3 + V3 + "]", E2 = "\\ud83c[\\udffb-\\udfff]", K6 = "(?:" + L2 + "|" + E2 + ")", z3 = "[^" + Ei + "]", o5 = "(?:\\ud83c[\\udde6-\\uddff]){2}", M2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Mi = "[" + V3 + "]", G3 = "\\u200d", W3 = "(?:" + D3 + "|" + Z3 + ")", i5 = "(?:" + Mi + "|" + Z3 + ")", $3 = "(?:" + n5 + "(?:d|ll|m|re|s|t|ve))?", U3 = "(?:" + n5 + "(?:D|LL|M|RE|S|T|VE))?", j3 = K6 + "?", ba = "[" + H3 + "]?", a5 = "(?:" + G3 + "(?:" + [z3, o5, M2].join("|") + ")" + ba + j3 + ")*", s5 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", l5 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", X3 = ba + j3 + a5, Y3 = "(?:" + [r5, o5, M2].join("|") + ")" + X3, c5 = "(?:" + [z3 + L2 + "?", L2, o5, M2, q6].join("|") + ")", J3 = RegExp(n5, "g"), Zo = RegExp(L2, "g"), zo = RegExp(E2 + "(?=" + E2 + ")|" + c5 + X3, "g"), e7 = RegExp([
        Mi + "?" + D3 + "+" + $3 + "(?=" + [N3, Mi, "$"].join("|") + ")",
        i5 + "+" + U3 + "(?=" + [N3, Mi + W3, "$"].join("|") + ")",
        Mi + "?" + W3 + "+" + $3,
        Mi + "+" + U3,
        l5,
        s5,
        ga,
        Y3
      ].join("|"), "g"), Q3 = RegExp("[" + G3 + Ei + R3 + H3 + "]"), t7 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, q3 = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], n7 = -1, dt = {};
      dt[Ca] = dt[wi] = dt[No] = dt[Si] = dt[Js] = dt[Qs] = dt[Zr] = dt[Ti] = dt[qs] = !0, dt[Te] = dt[Ie] = dt[on] = dt[pe] = dt[ln] = dt[me] = dt[We] = dt[ie] = dt[s1] = dt[Ye] = dt[Pe] = dt[p1] = dt[L1] = dt[Ct] = dt[ut] = !1;
      var et = {};
      et[Te] = et[Ie] = et[on] = et[ln] = et[pe] = et[me] = et[Ca] = et[wi] = et[No] = et[Si] = et[Js] = et[s1] = et[Ye] = et[Pe] = et[p1] = et[L1] = et[Ct] = et[Z1] = et[Qs] = et[Zr] = et[Ti] = et[qs] = !0, et[We] = et[ie] = et[ut] = !1;
      var r7 = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, V = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, z = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, ce = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Ne = parseFloat, E1 = parseInt, Y1 = typeof Yi == "object" && Yi && Yi.Object === Object && Yi, gt = typeof self == "object" && self && self.Object === Object && self, l1 = Y1 || gt || Function("return this")(), ot = t && !t.nodeType && t, Ut = ot && !0 && e && !e.nodeType && e, hn = Ut && Ut.exports === ot, Go = hn && Y1.process, mn = function() {
        try {
          var U = Ut && Ut.require && Ut.require("util").types;
          return U || Go && Go.binding && Go.binding("util");
        } catch {
        }
      }(), B2 = mn && mn.isArrayBuffer, u5 = mn && mn.isDate, Lh = mn && mn.isMap, Eh = mn && mn.isRegExp, Mh = mn && mn.isSet, Bh = mn && mn.isTypedArray;
      function Yn(U, he, le) {
        switch (le.length) {
          case 0:
            return U.call(he);
          case 1:
            return U.call(he, le[0]);
          case 2:
            return U.call(he, le[0], le[1]);
          case 3:
            return U.call(he, le[0], le[1], le[2]);
        }
        return U.apply(he, le);
      }
      function yB(U, he, le, Ve) {
        for (var m1 = -1, z1 = U == null ? 0 : U.length; ++m1 < z1; ) {
          var jt = U[m1];
          he(Ve, jt, le(jt), U);
        }
        return Ve;
      }
      function mr(U, he) {
        for (var le = -1, Ve = U == null ? 0 : U.length; ++le < Ve && he(U[le], le, U) !== !1; )
          ;
        return U;
      }
      function xB(U, he) {
        for (var le = U == null ? 0 : U.length; le-- && he(U[le], le, U) !== !1; )
          ;
        return U;
      }
      function kh(U, he) {
        for (var le = -1, Ve = U == null ? 0 : U.length; ++le < Ve; )
          if (!he(U[le], le, U))
            return !1;
        return !0;
      }
      function Bi(U, he) {
        for (var le = -1, Ve = U == null ? 0 : U.length, m1 = 0, z1 = []; ++le < Ve; ) {
          var jt = U[le];
          he(jt, le, U) && (z1[m1++] = jt);
        }
        return z1;
      }
      function K3(U, he) {
        var le = U == null ? 0 : U.length;
        return !!le && k2(U, he, 0) > -1;
      }
      function o7(U, he, le) {
        for (var Ve = -1, m1 = U == null ? 0 : U.length; ++Ve < m1; )
          if (le(he, U[Ve]))
            return !0;
        return !1;
      }
      function At(U, he) {
        for (var le = -1, Ve = U == null ? 0 : U.length, m1 = Array(Ve); ++le < Ve; )
          m1[le] = he(U[le], le, U);
        return m1;
      }
      function ki(U, he) {
        for (var le = -1, Ve = he.length, m1 = U.length; ++le < Ve; )
          U[m1 + le] = he[le];
        return U;
      }
      function i7(U, he, le, Ve) {
        var m1 = -1, z1 = U == null ? 0 : U.length;
        for (Ve && z1 && (le = U[++m1]); ++m1 < z1; )
          le = he(le, U[m1], m1, U);
        return le;
      }
      function wB(U, he, le, Ve) {
        var m1 = U == null ? 0 : U.length;
        for (Ve && m1 && (le = U[--m1]); m1--; )
          le = he(le, U[m1], m1, U);
        return le;
      }
      function a7(U, he) {
        for (var le = -1, Ve = U == null ? 0 : U.length; ++le < Ve; )
          if (he(U[le], le, U))
            return !0;
        return !1;
      }
      var SB = s7("length");
      function TB(U) {
        return U.split("");
      }
      function AB(U) {
        return U.match(D6) || [];
      }
      function Rh(U, he, le) {
        var Ve;
        return le(U, function(m1, z1, jt) {
          if (he(m1, z1, jt))
            return Ve = z1, !1;
        }), Ve;
      }
      function e4(U, he, le, Ve) {
        for (var m1 = U.length, z1 = le + (Ve ? 1 : -1); Ve ? z1-- : ++z1 < m1; )
          if (he(U[z1], z1, U))
            return z1;
        return -1;
      }
      function k2(U, he, le) {
        return he === he ? HB(U, he, le) : e4(U, _h, le);
      }
      function IB(U, he, le, Ve) {
        for (var m1 = le - 1, z1 = U.length; ++m1 < z1; )
          if (Ve(U[m1], he))
            return m1;
        return -1;
      }
      function _h(U) {
        return U !== U;
      }
      function Fh(U, he) {
        var le = U == null ? 0 : U.length;
        return le ? c7(U, he) / le : ne;
      }
      function s7(U) {
        return function(he) {
          return he == null ? n : he[U];
        };
      }
      function l7(U) {
        return function(he) {
          return U == null ? n : U[he];
        };
      }
      function Ph(U, he, le, Ve, m1) {
        return m1(U, function(z1, jt, ft) {
          le = Ve ? (Ve = !1, z1) : he(le, z1, jt, ft);
        }), le;
      }
      function LB(U, he) {
        var le = U.length;
        for (U.sort(he); le--; )
          U[le] = U[le].value;
        return U;
      }
      function c7(U, he) {
        for (var le, Ve = -1, m1 = U.length; ++Ve < m1; ) {
          var z1 = he(U[Ve]);
          z1 !== n && (le = le === n ? z1 : le + z1);
        }
        return le;
      }
      function u7(U, he) {
        for (var le = -1, Ve = Array(U); ++le < U; )
          Ve[le] = he(le);
        return Ve;
      }
      function EB(U, he) {
        return At(he, function(le) {
          return [le, U[le]];
        });
      }
      function Vh(U) {
        return U && U.slice(0, Dh(U) + 1).replace(e5, "");
      }
      function Jn(U) {
        return function(he) {
          return U(he);
        };
      }
      function d7(U, he) {
        return At(he, function(le) {
          return U[le];
        });
      }
      function d5(U, he) {
        return U.has(he);
      }
      function Hh(U, he) {
        for (var le = -1, Ve = U.length; ++le < Ve && k2(he, U[le], 0) > -1; )
          ;
        return le;
      }
      function Oh(U, he) {
        for (var le = U.length; le-- && k2(he, U[le], 0) > -1; )
          ;
        return le;
      }
      function MB(U, he) {
        for (var le = U.length, Ve = 0; le--; )
          U[le] === he && ++Ve;
        return Ve;
      }
      var BB = l7(r7), kB = l7(V);
      function RB(U) {
        return "\\" + ce[U];
      }
      function _B(U, he) {
        return U == null ? n : U[he];
      }
      function R2(U) {
        return Q3.test(U);
      }
      function FB(U) {
        return t7.test(U);
      }
      function PB(U) {
        for (var he, le = []; !(he = U.next()).done; )
          le.push(he.value);
        return le;
      }
      function f7(U) {
        var he = -1, le = Array(U.size);
        return U.forEach(function(Ve, m1) {
          le[++he] = [m1, Ve];
        }), le;
      }
      function Nh(U, he) {
        return function(le) {
          return U(he(le));
        };
      }
      function Ri(U, he) {
        for (var le = -1, Ve = U.length, m1 = 0, z1 = []; ++le < Ve; ) {
          var jt = U[le];
          (jt === he || jt === f) && (U[le] = f, z1[m1++] = le);
        }
        return z1;
      }
      function t4(U) {
        var he = -1, le = Array(U.size);
        return U.forEach(function(Ve) {
          le[++he] = Ve;
        }), le;
      }
      function VB(U) {
        var he = -1, le = Array(U.size);
        return U.forEach(function(Ve) {
          le[++he] = [Ve, Ve];
        }), le;
      }
      function HB(U, he, le) {
        for (var Ve = le - 1, m1 = U.length; ++Ve < m1; )
          if (U[Ve] === he)
            return Ve;
        return -1;
      }
      function OB(U, he, le) {
        for (var Ve = le + 1; Ve--; )
          if (U[Ve] === he)
            return Ve;
        return Ve;
      }
      function _2(U) {
        return R2(U) ? DB(U) : SB(U);
      }
      function Gr(U) {
        return R2(U) ? ZB(U) : TB(U);
      }
      function Dh(U) {
        for (var he = U.length; he-- && H6.test(U.charAt(he)); )
          ;
        return he;
      }
      var NB = l7(z);
      function DB(U) {
        for (var he = zo.lastIndex = 0; zo.test(U); )
          ++he;
        return he;
      }
      function ZB(U) {
        return U.match(zo) || [];
      }
      function zB(U) {
        return U.match(e7) || [];
      }
      var GB = function U(he) {
        he = he == null ? l1 : F2.defaults(l1.Object(), he, F2.pick(l1, q3));
        var le = he.Array, Ve = he.Date, m1 = he.Error, z1 = he.Function, jt = he.Math, ft = he.Object, p7 = he.RegExp, WB = he.String, Cr = he.TypeError, n4 = le.prototype, $B = z1.prototype, P2 = ft.prototype, r4 = he["__core-js_shared__"], o4 = $B.toString, tt = P2.hasOwnProperty, UB = 0, Zh = function() {
          var s = /[^.]+$/.exec(r4 && r4.keys && r4.keys.IE_PROTO || "");
          return s ? "Symbol(src)_1." + s : "";
        }(), i4 = P2.toString, jB = o4.call(ft), XB = l1._, YB = p7(
          "^" + o4.call(tt).replace(Ks, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), a4 = hn ? he.Buffer : n, _i = he.Symbol, s4 = he.Uint8Array, zh = a4 ? a4.allocUnsafe : n, l4 = Nh(ft.getPrototypeOf, ft), Gh = ft.create, Wh = P2.propertyIsEnumerable, c4 = n4.splice, $h = _i ? _i.isConcatSpreadable : n, f5 = _i ? _i.iterator : n, va = _i ? _i.toStringTag : n, u4 = function() {
          try {
            var s = Ta(ft, "defineProperty");
            return s({}, "", {}), s;
          } catch {
          }
        }(), JB = he.clearTimeout !== l1.clearTimeout && he.clearTimeout, QB = Ve && Ve.now !== l1.Date.now && Ve.now, qB = he.setTimeout !== l1.setTimeout && he.setTimeout, d4 = jt.ceil, f4 = jt.floor, h7 = ft.getOwnPropertySymbols, KB = a4 ? a4.isBuffer : n, Uh = he.isFinite, ek = n4.join, tk = Nh(ft.keys, ft), Xt = jt.max, Cn = jt.min, nk = Ve.now, rk = he.parseInt, jh = jt.random, ok = n4.reverse, m7 = Ta(he, "DataView"), p5 = Ta(he, "Map"), C7 = Ta(he, "Promise"), V2 = Ta(he, "Set"), h5 = Ta(he, "WeakMap"), m5 = Ta(ft, "create"), p4 = h5 && new h5(), H2 = {}, ik = Aa(m7), ak = Aa(p5), sk = Aa(C7), lk = Aa(V2), ck = Aa(h5), h4 = _i ? _i.prototype : n, C5 = h4 ? h4.valueOf : n, Xh = h4 ? h4.toString : n;
        function B(s) {
          if (_t(s) && !C1(s) && !(s instanceof M1)) {
            if (s instanceof gr)
              return s;
            if (tt.call(s, "__wrapped__"))
              return Ym(s);
          }
          return new gr(s);
        }
        var O2 = /* @__PURE__ */ function() {
          function s() {
          }
          return function(d) {
            if (!Mt(d))
              return {};
            if (Gh)
              return Gh(d);
            s.prototype = d;
            var m = new s();
            return s.prototype = n, m;
          };
        }();
        function m4() {
        }
        function gr(s, d) {
          this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!d, this.__index__ = 0, this.__values__ = n;
        }
        B.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: R6,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: _6,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: M3,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: B
          }
        }, B.prototype = m4.prototype, B.prototype.constructor = B, gr.prototype = O2(m4.prototype), gr.prototype.constructor = gr;
        function M1(s) {
          this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ee, this.__views__ = [];
        }
        function uk() {
          var s = new M1(this.__wrapped__);
          return s.__actions__ = On(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = On(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = On(this.__views__), s;
        }
        function dk() {
          if (this.__filtered__) {
            var s = new M1(this);
            s.__dir__ = -1, s.__filtered__ = !0;
          } else
            s = this.clone(), s.__dir__ *= -1;
          return s;
        }
        function fk() {
          var s = this.__wrapped__.value(), d = this.__dir__, m = C1(s), S = d < 0, E = m ? s.length : 0, R = TR(0, E, this.__views__), O = R.start, D = R.end, Y = D - O, Ce = S ? D : O - 1, ge = this.__iteratees__, ve = ge.length, Fe = 0, $e = Cn(Y, this.__takeCount__);
          if (!m || !S && E == Y && $e == Y)
            return bm(s, this.__actions__);
          var o1 = [];
          e:
            for (; Y-- && Fe < $e; ) {
              Ce += d;
              for (var w1 = -1, i1 = s[Ce]; ++w1 < ve; ) {
                var I1 = ge[w1], k1 = I1.iteratee, Kn = I1.type, In = k1(i1);
                if (Kn == K)
                  i1 = In;
                else if (!In) {
                  if (Kn == be)
                    continue e;
                  break e;
                }
              }
              o1[Fe++] = i1;
            }
          return o1;
        }
        M1.prototype = O2(m4.prototype), M1.prototype.constructor = M1;
        function ya(s) {
          var d = -1, m = s == null ? 0 : s.length;
          for (this.clear(); ++d < m; ) {
            var S = s[d];
            this.set(S[0], S[1]);
          }
        }
        function pk() {
          this.__data__ = m5 ? m5(null) : {}, this.size = 0;
        }
        function hk(s) {
          var d = this.has(s) && delete this.__data__[s];
          return this.size -= d ? 1 : 0, d;
        }
        function mk(s) {
          var d = this.__data__;
          if (m5) {
            var m = d[s];
            return m === c ? n : m;
          }
          return tt.call(d, s) ? d[s] : n;
        }
        function Ck(s) {
          var d = this.__data__;
          return m5 ? d[s] !== n : tt.call(d, s);
        }
        function gk(s, d) {
          var m = this.__data__;
          return this.size += this.has(s) ? 0 : 1, m[s] = m5 && d === n ? c : d, this;
        }
        ya.prototype.clear = pk, ya.prototype.delete = hk, ya.prototype.get = mk, ya.prototype.has = Ck, ya.prototype.set = gk;
        function Wo(s) {
          var d = -1, m = s == null ? 0 : s.length;
          for (this.clear(); ++d < m; ) {
            var S = s[d];
            this.set(S[0], S[1]);
          }
        }
        function bk() {
          this.__data__ = [], this.size = 0;
        }
        function vk(s) {
          var d = this.__data__, m = C4(d, s);
          if (m < 0)
            return !1;
          var S = d.length - 1;
          return m == S ? d.pop() : c4.call(d, m, 1), --this.size, !0;
        }
        function yk(s) {
          var d = this.__data__, m = C4(d, s);
          return m < 0 ? n : d[m][1];
        }
        function xk(s) {
          return C4(this.__data__, s) > -1;
        }
        function wk(s, d) {
          var m = this.__data__, S = C4(m, s);
          return S < 0 ? (++this.size, m.push([s, d])) : m[S][1] = d, this;
        }
        Wo.prototype.clear = bk, Wo.prototype.delete = vk, Wo.prototype.get = yk, Wo.prototype.has = xk, Wo.prototype.set = wk;
        function $o(s) {
          var d = -1, m = s == null ? 0 : s.length;
          for (this.clear(); ++d < m; ) {
            var S = s[d];
            this.set(S[0], S[1]);
          }
        }
        function Sk() {
          this.size = 0, this.__data__ = {
            hash: new ya(),
            map: new (p5 || Wo)(),
            string: new ya()
          };
        }
        function Tk(s) {
          var d = E4(this, s).delete(s);
          return this.size -= d ? 1 : 0, d;
        }
        function Ak(s) {
          return E4(this, s).get(s);
        }
        function Ik(s) {
          return E4(this, s).has(s);
        }
        function Lk(s, d) {
          var m = E4(this, s), S = m.size;
          return m.set(s, d), this.size += m.size == S ? 0 : 1, this;
        }
        $o.prototype.clear = Sk, $o.prototype.delete = Tk, $o.prototype.get = Ak, $o.prototype.has = Ik, $o.prototype.set = Lk;
        function xa(s) {
          var d = -1, m = s == null ? 0 : s.length;
          for (this.__data__ = new $o(); ++d < m; )
            this.add(s[d]);
        }
        function Ek(s) {
          return this.__data__.set(s, c), this;
        }
        function Mk(s) {
          return this.__data__.has(s);
        }
        xa.prototype.add = xa.prototype.push = Ek, xa.prototype.has = Mk;
        function Wr(s) {
          var d = this.__data__ = new Wo(s);
          this.size = d.size;
        }
        function Bk() {
          this.__data__ = new Wo(), this.size = 0;
        }
        function kk(s) {
          var d = this.__data__, m = d.delete(s);
          return this.size = d.size, m;
        }
        function Rk(s) {
          return this.__data__.get(s);
        }
        function _k(s) {
          return this.__data__.has(s);
        }
        function Fk(s, d) {
          var m = this.__data__;
          if (m instanceof Wo) {
            var S = m.__data__;
            if (!p5 || S.length < o - 1)
              return S.push([s, d]), this.size = ++m.size, this;
            m = this.__data__ = new $o(S);
          }
          return m.set(s, d), this.size = m.size, this;
        }
        Wr.prototype.clear = Bk, Wr.prototype.delete = kk, Wr.prototype.get = Rk, Wr.prototype.has = _k, Wr.prototype.set = Fk;
        function Yh(s, d) {
          var m = C1(s), S = !m && Ia(s), E = !m && !S && Oi(s), R = !m && !S && !E && z2(s), O = m || S || E || R, D = O ? u7(s.length, WB) : [], Y = D.length;
          for (var Ce in s)
            (d || tt.call(s, Ce)) && !(O && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Ce == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            E && (Ce == "offset" || Ce == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            R && (Ce == "buffer" || Ce == "byteLength" || Ce == "byteOffset") || // Skip index properties.
            Yo(Ce, Y))) && D.push(Ce);
          return D;
        }
        function Jh(s) {
          var d = s.length;
          return d ? s[L7(0, d - 1)] : n;
        }
        function Pk(s, d) {
          return M4(On(s), wa(d, 0, s.length));
        }
        function Vk(s) {
          return M4(On(s));
        }
        function g7(s, d, m) {
          (m !== n && !$r(s[d], m) || m === n && !(d in s)) && Uo(s, d, m);
        }
        function g5(s, d, m) {
          var S = s[d];
          (!(tt.call(s, d) && $r(S, m)) || m === n && !(d in s)) && Uo(s, d, m);
        }
        function C4(s, d) {
          for (var m = s.length; m--; )
            if ($r(s[m][0], d))
              return m;
          return -1;
        }
        function Hk(s, d, m, S) {
          return Fi(s, function(E, R, O) {
            d(S, E, m(E), O);
          }), S;
        }
        function Qh(s, d) {
          return s && so(d, an(d), s);
        }
        function Ok(s, d) {
          return s && so(d, Dn(d), s);
        }
        function Uo(s, d, m) {
          d == "__proto__" && u4 ? u4(s, d, {
            configurable: !0,
            enumerable: !0,
            value: m,
            writable: !0
          }) : s[d] = m;
        }
        function b7(s, d) {
          for (var m = -1, S = d.length, E = le(S), R = s == null; ++m < S; )
            E[m] = R ? n : q7(s, d[m]);
          return E;
        }
        function wa(s, d, m) {
          return s === s && (m !== n && (s = s <= m ? s : m), d !== n && (s = s >= d ? s : d)), s;
        }
        function br(s, d, m, S, E, R) {
          var O, D = d & p, Y = d & h, Ce = d & C;
          if (m && (O = E ? m(s, S, E, R) : m(s)), O !== n)
            return O;
          if (!Mt(s))
            return s;
          var ge = C1(s);
          if (ge) {
            if (O = IR(s), !D)
              return On(s, O);
          } else {
            var ve = gn(s), Fe = ve == ie || ve == f1;
            if (Oi(s))
              return xm(s, D);
            if (ve == Pe || ve == Te || Fe && !E) {
              if (O = Y || Fe ? {} : Dm(s), !D)
                return Y ? mR(s, Ok(O, s)) : hR(s, Qh(O, s));
            } else {
              if (!et[ve])
                return E ? s : {};
              O = LR(s, ve, D);
            }
          }
          R || (R = new Wr());
          var $e = R.get(s);
          if ($e)
            return $e;
          R.set(s, O), mC(s) ? s.forEach(function(i1) {
            O.add(br(i1, d, m, i1, s, R));
          }) : pC(s) && s.forEach(function(i1, I1) {
            O.set(I1, br(i1, d, m, I1, s, R));
          });
          var o1 = Ce ? Y ? O7 : H7 : Y ? Dn : an, w1 = ge ? n : o1(s);
          return mr(w1 || s, function(i1, I1) {
            w1 && (I1 = i1, i1 = s[I1]), g5(O, I1, br(i1, d, m, I1, s, R));
          }), O;
        }
        function Nk(s) {
          var d = an(s);
          return function(m) {
            return qh(m, s, d);
          };
        }
        function qh(s, d, m) {
          var S = m.length;
          if (s == null)
            return !S;
          for (s = ft(s); S--; ) {
            var E = m[S], R = d[E], O = s[E];
            if (O === n && !(E in s) || !R(O))
              return !1;
          }
          return !0;
        }
        function Kh(s, d, m) {
          if (typeof s != "function")
            throw new Cr(a);
          return T5(function() {
            s.apply(n, m);
          }, d);
        }
        function b5(s, d, m, S) {
          var E = -1, R = K3, O = !0, D = s.length, Y = [], Ce = d.length;
          if (!D)
            return Y;
          m && (d = At(d, Jn(m))), S ? (R = o7, O = !1) : d.length >= o && (R = d5, O = !1, d = new xa(d));
          e:
            for (; ++E < D; ) {
              var ge = s[E], ve = m == null ? ge : m(ge);
              if (ge = S || ge !== 0 ? ge : 0, O && ve === ve) {
                for (var Fe = Ce; Fe--; )
                  if (d[Fe] === ve)
                    continue e;
                Y.push(ge);
              } else R(d, ve, S) || Y.push(ge);
            }
          return Y;
        }
        var Fi = Im(ao), em = Im(y7, !0);
        function Dk(s, d) {
          var m = !0;
          return Fi(s, function(S, E, R) {
            return m = !!d(S, E, R), m;
          }), m;
        }
        function g4(s, d, m) {
          for (var S = -1, E = s.length; ++S < E; ) {
            var R = s[S], O = d(R);
            if (O != null && (D === n ? O === O && !qn(O) : m(O, D)))
              var D = O, Y = R;
          }
          return Y;
        }
        function Zk(s, d, m, S) {
          var E = s.length;
          for (m = y1(m), m < 0 && (m = -m > E ? 0 : E + m), S = S === n || S > E ? E : y1(S), S < 0 && (S += E), S = m > S ? 0 : gC(S); m < S; )
            s[m++] = d;
          return s;
        }
        function tm(s, d) {
          var m = [];
          return Fi(s, function(S, E, R) {
            d(S, E, R) && m.push(S);
          }), m;
        }
        function cn(s, d, m, S, E) {
          var R = -1, O = s.length;
          for (m || (m = MR), E || (E = []); ++R < O; ) {
            var D = s[R];
            d > 0 && m(D) ? d > 1 ? cn(D, d - 1, m, S, E) : ki(E, D) : S || (E[E.length] = D);
          }
          return E;
        }
        var v7 = Lm(), nm = Lm(!0);
        function ao(s, d) {
          return s && v7(s, d, an);
        }
        function y7(s, d) {
          return s && nm(s, d, an);
        }
        function b4(s, d) {
          return Bi(d, function(m) {
            return Jo(s[m]);
          });
        }
        function Sa(s, d) {
          d = Vi(d, s);
          for (var m = 0, S = d.length; s != null && m < S; )
            s = s[lo(d[m++])];
          return m && m == S ? s : n;
        }
        function rm(s, d, m) {
          var S = d(s);
          return C1(s) ? S : ki(S, m(s));
        }
        function Tn(s) {
          return s == null ? s === n ? r1 : B1 : va && va in ft(s) ? SR(s) : VR(s);
        }
        function x7(s, d) {
          return s > d;
        }
        function zk(s, d) {
          return s != null && tt.call(s, d);
        }
        function Gk(s, d) {
          return s != null && d in ft(s);
        }
        function Wk(s, d, m) {
          return s >= Cn(d, m) && s < Xt(d, m);
        }
        function w7(s, d, m) {
          for (var S = m ? o7 : K3, E = s[0].length, R = s.length, O = R, D = le(R), Y = 1 / 0, Ce = []; O--; ) {
            var ge = s[O];
            O && d && (ge = At(ge, Jn(d))), Y = Cn(ge.length, Y), D[O] = !m && (d || E >= 120 && ge.length >= 120) ? new xa(O && ge) : n;
          }
          ge = s[0];
          var ve = -1, Fe = D[0];
          e:
            for (; ++ve < E && Ce.length < Y; ) {
              var $e = ge[ve], o1 = d ? d($e) : $e;
              if ($e = m || $e !== 0 ? $e : 0, !(Fe ? d5(Fe, o1) : S(Ce, o1, m))) {
                for (O = R; --O; ) {
                  var w1 = D[O];
                  if (!(w1 ? d5(w1, o1) : S(s[O], o1, m)))
                    continue e;
                }
                Fe && Fe.push(o1), Ce.push($e);
              }
            }
          return Ce;
        }
        function $k(s, d, m, S) {
          return ao(s, function(E, R, O) {
            d(S, m(E), R, O);
          }), S;
        }
        function v5(s, d, m) {
          d = Vi(d, s), s = Wm(s, d);
          var S = s == null ? s : s[lo(yr(d))];
          return S == null ? n : Yn(S, s, m);
        }
        function om(s) {
          return _t(s) && Tn(s) == Te;
        }
        function Uk(s) {
          return _t(s) && Tn(s) == on;
        }
        function jk(s) {
          return _t(s) && Tn(s) == me;
        }
        function y5(s, d, m, S, E) {
          return s === d ? !0 : s == null || d == null || !_t(s) && !_t(d) ? s !== s && d !== d : Xk(s, d, m, S, y5, E);
        }
        function Xk(s, d, m, S, E, R) {
          var O = C1(s), D = C1(d), Y = O ? Ie : gn(s), Ce = D ? Ie : gn(d);
          Y = Y == Te ? Pe : Y, Ce = Ce == Te ? Pe : Ce;
          var ge = Y == Pe, ve = Ce == Pe, Fe = Y == Ce;
          if (Fe && Oi(s)) {
            if (!Oi(d))
              return !1;
            O = !0, ge = !1;
          }
          if (Fe && !ge)
            return R || (R = new Wr()), O || z2(s) ? Hm(s, d, m, S, E, R) : xR(s, d, Y, m, S, E, R);
          if (!(m & v)) {
            var $e = ge && tt.call(s, "__wrapped__"), o1 = ve && tt.call(d, "__wrapped__");
            if ($e || o1) {
              var w1 = $e ? s.value() : s, i1 = o1 ? d.value() : d;
              return R || (R = new Wr()), E(w1, i1, m, S, R);
            }
          }
          return Fe ? (R || (R = new Wr()), wR(s, d, m, S, E, R)) : !1;
        }
        function Yk(s) {
          return _t(s) && gn(s) == s1;
        }
        function S7(s, d, m, S) {
          var E = m.length, R = E, O = !S;
          if (s == null)
            return !R;
          for (s = ft(s); E--; ) {
            var D = m[E];
            if (O && D[2] ? D[1] !== s[D[0]] : !(D[0] in s))
              return !1;
          }
          for (; ++E < R; ) {
            D = m[E];
            var Y = D[0], Ce = s[Y], ge = D[1];
            if (O && D[2]) {
              if (Ce === n && !(Y in s))
                return !1;
            } else {
              var ve = new Wr();
              if (S)
                var Fe = S(Ce, ge, Y, s, d, ve);
              if (!(Fe === n ? y5(ge, Ce, v | b, S, ve) : Fe))
                return !1;
            }
          }
          return !0;
        }
        function im(s) {
          if (!Mt(s) || kR(s))
            return !1;
          var d = Jo(s) ? YB : $6;
          return d.test(Aa(s));
        }
        function Jk(s) {
          return _t(s) && Tn(s) == p1;
        }
        function Qk(s) {
          return _t(s) && gn(s) == L1;
        }
        function qk(s) {
          return _t(s) && P4(s.length) && !!dt[Tn(s)];
        }
        function am(s) {
          return typeof s == "function" ? s : s == null ? Zn : typeof s == "object" ? C1(s) ? cm(s[0], s[1]) : lm(s) : EC(s);
        }
        function T7(s) {
          if (!S5(s))
            return tk(s);
          var d = [];
          for (var m in ft(s))
            tt.call(s, m) && m != "constructor" && d.push(m);
          return d;
        }
        function Kk(s) {
          if (!Mt(s))
            return PR(s);
          var d = S5(s), m = [];
          for (var S in s)
            S == "constructor" && (d || !tt.call(s, S)) || m.push(S);
          return m;
        }
        function A7(s, d) {
          return s < d;
        }
        function sm(s, d) {
          var m = -1, S = Nn(s) ? le(s.length) : [];
          return Fi(s, function(E, R, O) {
            S[++m] = d(E, R, O);
          }), S;
        }
        function lm(s) {
          var d = D7(s);
          return d.length == 1 && d[0][2] ? zm(d[0][0], d[0][1]) : function(m) {
            return m === s || S7(m, s, d);
          };
        }
        function cm(s, d) {
          return z7(s) && Zm(d) ? zm(lo(s), d) : function(m) {
            var S = q7(m, s);
            return S === n && S === d ? K7(m, s) : y5(d, S, v | b);
          };
        }
        function v4(s, d, m, S, E) {
          s !== d && v7(d, function(R, O) {
            if (E || (E = new Wr()), Mt(R))
              eR(s, d, O, m, v4, S, E);
            else {
              var D = S ? S(W7(s, O), R, O + "", s, d, E) : n;
              D === n && (D = R), g7(s, O, D);
            }
          }, Dn);
        }
        function eR(s, d, m, S, E, R, O) {
          var D = W7(s, m), Y = W7(d, m), Ce = O.get(Y);
          if (Ce) {
            g7(s, m, Ce);
            return;
          }
          var ge = R ? R(D, Y, m + "", s, d, O) : n, ve = ge === n;
          if (ve) {
            var Fe = C1(Y), $e = !Fe && Oi(Y), o1 = !Fe && !$e && z2(Y);
            ge = Y, Fe || $e || o1 ? C1(D) ? ge = D : Dt(D) ? ge = On(D) : $e ? (ve = !1, ge = xm(Y, !0)) : o1 ? (ve = !1, ge = wm(Y, !0)) : ge = [] : A5(Y) || Ia(Y) ? (ge = D, Ia(D) ? ge = bC(D) : (!Mt(D) || Jo(D)) && (ge = Dm(Y))) : ve = !1;
          }
          ve && (O.set(Y, ge), E(ge, Y, S, R, O), O.delete(Y)), g7(s, m, ge);
        }
        function um(s, d) {
          var m = s.length;
          if (m)
            return d += d < 0 ? m : 0, Yo(d, m) ? s[d] : n;
        }
        function dm(s, d, m) {
          d.length ? d = At(d, function(R) {
            return C1(R) ? function(O) {
              return Sa(O, R.length === 1 ? R[0] : R);
            } : R;
          }) : d = [Zn];
          var S = -1;
          d = At(d, Jn(t1()));
          var E = sm(s, function(R, O, D) {
            var Y = At(d, function(Ce) {
              return Ce(R);
            });
            return { criteria: Y, index: ++S, value: R };
          });
          return LB(E, function(R, O) {
            return pR(R, O, m);
          });
        }
        function tR(s, d) {
          return fm(s, d, function(m, S) {
            return K7(s, S);
          });
        }
        function fm(s, d, m) {
          for (var S = -1, E = d.length, R = {}; ++S < E; ) {
            var O = d[S], D = Sa(s, O);
            m(D, O) && x5(R, Vi(O, s), D);
          }
          return R;
        }
        function nR(s) {
          return function(d) {
            return Sa(d, s);
          };
        }
        function I7(s, d, m, S) {
          var E = S ? IB : k2, R = -1, O = d.length, D = s;
          for (s === d && (d = On(d)), m && (D = At(s, Jn(m))); ++R < O; )
            for (var Y = 0, Ce = d[R], ge = m ? m(Ce) : Ce; (Y = E(D, ge, Y, S)) > -1; )
              D !== s && c4.call(D, Y, 1), c4.call(s, Y, 1);
          return s;
        }
        function pm(s, d) {
          for (var m = s ? d.length : 0, S = m - 1; m--; ) {
            var E = d[m];
            if (m == S || E !== R) {
              var R = E;
              Yo(E) ? c4.call(s, E, 1) : B7(s, E);
            }
          }
          return s;
        }
        function L7(s, d) {
          return s + f4(jh() * (d - s + 1));
        }
        function rR(s, d, m, S) {
          for (var E = -1, R = Xt(d4((d - s) / (m || 1)), 0), O = le(R); R--; )
            O[S ? R : ++E] = s, s += m;
          return O;
        }
        function E7(s, d) {
          var m = "";
          if (!s || d < 1 || d > Me)
            return m;
          do
            d % 2 && (m += s), d = f4(d / 2), d && (s += s);
          while (d);
          return m;
        }
        function S1(s, d) {
          return $7(Gm(s, d, Zn), s + "");
        }
        function oR(s) {
          return Jh(G2(s));
        }
        function iR(s, d) {
          var m = G2(s);
          return M4(m, wa(d, 0, m.length));
        }
        function x5(s, d, m, S) {
          if (!Mt(s))
            return s;
          d = Vi(d, s);
          for (var E = -1, R = d.length, O = R - 1, D = s; D != null && ++E < R; ) {
            var Y = lo(d[E]), Ce = m;
            if (Y === "__proto__" || Y === "constructor" || Y === "prototype")
              return s;
            if (E != O) {
              var ge = D[Y];
              Ce = S ? S(ge, Y, D) : n, Ce === n && (Ce = Mt(ge) ? ge : Yo(d[E + 1]) ? [] : {});
            }
            g5(D, Y, Ce), D = D[Y];
          }
          return s;
        }
        var hm = p4 ? function(s, d) {
          return p4.set(s, d), s;
        } : Zn, aR = u4 ? function(s, d) {
          return u4(s, "toString", {
            configurable: !0,
            enumerable: !1,
            value: t8(d),
            writable: !0
          });
        } : Zn;
        function sR(s) {
          return M4(G2(s));
        }
        function vr(s, d, m) {
          var S = -1, E = s.length;
          d < 0 && (d = -d > E ? 0 : E + d), m = m > E ? E : m, m < 0 && (m += E), E = d > m ? 0 : m - d >>> 0, d >>>= 0;
          for (var R = le(E); ++S < E; )
            R[S] = s[S + d];
          return R;
        }
        function lR(s, d) {
          var m;
          return Fi(s, function(S, E, R) {
            return m = d(S, E, R), !m;
          }), !!m;
        }
        function y4(s, d, m) {
          var S = 0, E = s == null ? S : s.length;
          if (typeof d == "number" && d === d && E <= fe) {
            for (; S < E; ) {
              var R = S + E >>> 1, O = s[R];
              O !== null && !qn(O) && (m ? O <= d : O < d) ? S = R + 1 : E = R;
            }
            return E;
          }
          return M7(s, d, Zn, m);
        }
        function M7(s, d, m, S) {
          var E = 0, R = s == null ? 0 : s.length;
          if (R === 0)
            return 0;
          d = m(d);
          for (var O = d !== d, D = d === null, Y = qn(d), Ce = d === n; E < R; ) {
            var ge = f4((E + R) / 2), ve = m(s[ge]), Fe = ve !== n, $e = ve === null, o1 = ve === ve, w1 = qn(ve);
            if (O)
              var i1 = S || o1;
            else Ce ? i1 = o1 && (S || Fe) : D ? i1 = o1 && Fe && (S || !$e) : Y ? i1 = o1 && Fe && !$e && (S || !w1) : $e || w1 ? i1 = !1 : i1 = S ? ve <= d : ve < d;
            i1 ? E = ge + 1 : R = ge;
          }
          return Cn(R, ye);
        }
        function mm(s, d) {
          for (var m = -1, S = s.length, E = 0, R = []; ++m < S; ) {
            var O = s[m], D = d ? d(O) : O;
            if (!m || !$r(D, Y)) {
              var Y = D;
              R[E++] = O === 0 ? 0 : O;
            }
          }
          return R;
        }
        function Cm(s) {
          return typeof s == "number" ? s : qn(s) ? ne : +s;
        }
        function Qn(s) {
          if (typeof s == "string")
            return s;
          if (C1(s))
            return At(s, Qn) + "";
          if (qn(s))
            return Xh ? Xh.call(s) : "";
          var d = s + "";
          return d == "0" && 1 / s == -J ? "-0" : d;
        }
        function Pi(s, d, m) {
          var S = -1, E = K3, R = s.length, O = !0, D = [], Y = D;
          if (m)
            O = !1, E = o7;
          else if (R >= o) {
            var Ce = d ? null : vR(s);
            if (Ce)
              return t4(Ce);
            O = !1, E = d5, Y = new xa();
          } else
            Y = d ? [] : D;
          e:
            for (; ++S < R; ) {
              var ge = s[S], ve = d ? d(ge) : ge;
              if (ge = m || ge !== 0 ? ge : 0, O && ve === ve) {
                for (var Fe = Y.length; Fe--; )
                  if (Y[Fe] === ve)
                    continue e;
                d && Y.push(ve), D.push(ge);
              } else E(Y, ve, m) || (Y !== D && Y.push(ve), D.push(ge));
            }
          return D;
        }
        function B7(s, d) {
          return d = Vi(d, s), s = Wm(s, d), s == null || delete s[lo(yr(d))];
        }
        function gm(s, d, m, S) {
          return x5(s, d, m(Sa(s, d)), S);
        }
        function x4(s, d, m, S) {
          for (var E = s.length, R = S ? E : -1; (S ? R-- : ++R < E) && d(s[R], R, s); )
            ;
          return m ? vr(s, S ? 0 : R, S ? R + 1 : E) : vr(s, S ? R + 1 : 0, S ? E : R);
        }
        function bm(s, d) {
          var m = s;
          return m instanceof M1 && (m = m.value()), i7(d, function(S, E) {
            return E.func.apply(E.thisArg, ki([S], E.args));
          }, m);
        }
        function k7(s, d, m) {
          var S = s.length;
          if (S < 2)
            return S ? Pi(s[0]) : [];
          for (var E = -1, R = le(S); ++E < S; )
            for (var O = s[E], D = -1; ++D < S; )
              D != E && (R[E] = b5(R[E] || O, s[D], d, m));
          return Pi(cn(R, 1), d, m);
        }
        function vm(s, d, m) {
          for (var S = -1, E = s.length, R = d.length, O = {}; ++S < E; ) {
            var D = S < R ? d[S] : n;
            m(O, s[S], D);
          }
          return O;
        }
        function R7(s) {
          return Dt(s) ? s : [];
        }
        function _7(s) {
          return typeof s == "function" ? s : Zn;
        }
        function Vi(s, d) {
          return C1(s) ? s : z7(s, d) ? [s] : Xm(J1(s));
        }
        var cR = S1;
        function Hi(s, d, m) {
          var S = s.length;
          return m = m === n ? S : m, !d && m >= S ? s : vr(s, d, m);
        }
        var ym = JB || function(s) {
          return l1.clearTimeout(s);
        };
        function xm(s, d) {
          if (d)
            return s.slice();
          var m = s.length, S = zh ? zh(m) : new s.constructor(m);
          return s.copy(S), S;
        }
        function F7(s) {
          var d = new s.constructor(s.byteLength);
          return new s4(d).set(new s4(s)), d;
        }
        function uR(s, d) {
          var m = d ? F7(s.buffer) : s.buffer;
          return new s.constructor(m, s.byteOffset, s.byteLength);
        }
        function dR(s) {
          var d = new s.constructor(s.source, B3.exec(s));
          return d.lastIndex = s.lastIndex, d;
        }
        function fR(s) {
          return C5 ? ft(C5.call(s)) : {};
        }
        function wm(s, d) {
          var m = d ? F7(s.buffer) : s.buffer;
          return new s.constructor(m, s.byteOffset, s.length);
        }
        function Sm(s, d) {
          if (s !== d) {
            var m = s !== n, S = s === null, E = s === s, R = qn(s), O = d !== n, D = d === null, Y = d === d, Ce = qn(d);
            if (!D && !Ce && !R && s > d || R && O && Y && !D && !Ce || S && O && Y || !m && Y || !E)
              return 1;
            if (!S && !R && !Ce && s < d || Ce && m && E && !S && !R || D && m && E || !O && E || !Y)
              return -1;
          }
          return 0;
        }
        function pR(s, d, m) {
          for (var S = -1, E = s.criteria, R = d.criteria, O = E.length, D = m.length; ++S < O; ) {
            var Y = Sm(E[S], R[S]);
            if (Y) {
              if (S >= D)
                return Y;
              var Ce = m[S];
              return Y * (Ce == "desc" ? -1 : 1);
            }
          }
          return s.index - d.index;
        }
        function Tm(s, d, m, S) {
          for (var E = -1, R = s.length, O = m.length, D = -1, Y = d.length, Ce = Xt(R - O, 0), ge = le(Y + Ce), ve = !S; ++D < Y; )
            ge[D] = d[D];
          for (; ++E < O; )
            (ve || E < R) && (ge[m[E]] = s[E]);
          for (; Ce--; )
            ge[D++] = s[E++];
          return ge;
        }
        function Am(s, d, m, S) {
          for (var E = -1, R = s.length, O = -1, D = m.length, Y = -1, Ce = d.length, ge = Xt(R - D, 0), ve = le(ge + Ce), Fe = !S; ++E < ge; )
            ve[E] = s[E];
          for (var $e = E; ++Y < Ce; )
            ve[$e + Y] = d[Y];
          for (; ++O < D; )
            (Fe || E < R) && (ve[$e + m[O]] = s[E++]);
          return ve;
        }
        function On(s, d) {
          var m = -1, S = s.length;
          for (d || (d = le(S)); ++m < S; )
            d[m] = s[m];
          return d;
        }
        function so(s, d, m, S) {
          var E = !m;
          m || (m = {});
          for (var R = -1, O = d.length; ++R < O; ) {
            var D = d[R], Y = S ? S(m[D], s[D], D, m, s) : n;
            Y === n && (Y = s[D]), E ? Uo(m, D, Y) : g5(m, D, Y);
          }
          return m;
        }
        function hR(s, d) {
          return so(s, Z7(s), d);
        }
        function mR(s, d) {
          return so(s, Om(s), d);
        }
        function w4(s, d) {
          return function(m, S) {
            var E = C1(m) ? yB : Hk, R = d ? d() : {};
            return E(m, s, t1(S, 2), R);
          };
        }
        function N2(s) {
          return S1(function(d, m) {
            var S = -1, E = m.length, R = E > 1 ? m[E - 1] : n, O = E > 2 ? m[2] : n;
            for (R = s.length > 3 && typeof R == "function" ? (E--, R) : n, O && An(m[0], m[1], O) && (R = E < 3 ? n : R, E = 1), d = ft(d); ++S < E; ) {
              var D = m[S];
              D && s(d, D, S, R);
            }
            return d;
          });
        }
        function Im(s, d) {
          return function(m, S) {
            if (m == null)
              return m;
            if (!Nn(m))
              return s(m, S);
            for (var E = m.length, R = d ? E : -1, O = ft(m); (d ? R-- : ++R < E) && S(O[R], R, O) !== !1; )
              ;
            return m;
          };
        }
        function Lm(s) {
          return function(d, m, S) {
            for (var E = -1, R = ft(d), O = S(d), D = O.length; D--; ) {
              var Y = O[s ? D : ++E];
              if (m(R[Y], Y, R) === !1)
                break;
            }
            return d;
          };
        }
        function CR(s, d, m) {
          var S = d & y, E = w5(s);
          function R() {
            var O = this && this !== l1 && this instanceof R ? E : s;
            return O.apply(S ? m : this, arguments);
          }
          return R;
        }
        function Em(s) {
          return function(d) {
            d = J1(d);
            var m = R2(d) ? Gr(d) : n, S = m ? m[0] : d.charAt(0), E = m ? Hi(m, 1).join("") : d.slice(1);
            return S[s]() + E;
          };
        }
        function D2(s) {
          return function(d) {
            return i7(IC(AC(d).replace(J3, "")), s, "");
          };
        }
        function w5(s) {
          return function() {
            var d = arguments;
            switch (d.length) {
              case 0:
                return new s();
              case 1:
                return new s(d[0]);
              case 2:
                return new s(d[0], d[1]);
              case 3:
                return new s(d[0], d[1], d[2]);
              case 4:
                return new s(d[0], d[1], d[2], d[3]);
              case 5:
                return new s(d[0], d[1], d[2], d[3], d[4]);
              case 6:
                return new s(d[0], d[1], d[2], d[3], d[4], d[5]);
              case 7:
                return new s(d[0], d[1], d[2], d[3], d[4], d[5], d[6]);
            }
            var m = O2(s.prototype), S = s.apply(m, d);
            return Mt(S) ? S : m;
          };
        }
        function gR(s, d, m) {
          var S = w5(s);
          function E() {
            for (var R = arguments.length, O = le(R), D = R, Y = Z2(E); D--; )
              O[D] = arguments[D];
            var Ce = R < 3 && O[0] !== Y && O[R - 1] !== Y ? [] : Ri(O, Y);
            if (R -= Ce.length, R < m)
              return _m(
                s,
                d,
                S4,
                E.placeholder,
                n,
                O,
                Ce,
                n,
                n,
                m - R
              );
            var ge = this && this !== l1 && this instanceof E ? S : s;
            return Yn(ge, this, O);
          }
          return E;
        }
        function Mm(s) {
          return function(d, m, S) {
            var E = ft(d);
            if (!Nn(d)) {
              var R = t1(m, 3);
              d = an(d), m = function(D) {
                return R(E[D], D, E);
              };
            }
            var O = s(d, m, S);
            return O > -1 ? E[R ? d[O] : O] : n;
          };
        }
        function Bm(s) {
          return Xo(function(d) {
            var m = d.length, S = m, E = gr.prototype.thru;
            for (s && d.reverse(); S--; ) {
              var R = d[S];
              if (typeof R != "function")
                throw new Cr(a);
              if (E && !O && L4(R) == "wrapper")
                var O = new gr([], !0);
            }
            for (S = O ? S : m; ++S < m; ) {
              R = d[S];
              var D = L4(R), Y = D == "wrapper" ? N7(R) : n;
              Y && G7(Y[0]) && Y[1] == (k | A | I | _) && !Y[4].length && Y[9] == 1 ? O = O[L4(Y[0])].apply(O, Y[3]) : O = R.length == 1 && G7(R) ? O[D]() : O.thru(R);
            }
            return function() {
              var Ce = arguments, ge = Ce[0];
              if (O && Ce.length == 1 && C1(ge))
                return O.plant(ge).value();
              for (var ve = 0, Fe = m ? d[ve].apply(this, Ce) : ge; ++ve < m; )
                Fe = d[ve].call(this, Fe);
              return Fe;
            };
          });
        }
        function S4(s, d, m, S, E, R, O, D, Y, Ce) {
          var ge = d & k, ve = d & y, Fe = d & x, $e = d & (A | L), o1 = d & F, w1 = Fe ? n : w5(s);
          function i1() {
            for (var I1 = arguments.length, k1 = le(I1), Kn = I1; Kn--; )
              k1[Kn] = arguments[Kn];
            if ($e)
              var In = Z2(i1), er = MB(k1, In);
            if (S && (k1 = Tm(k1, S, E, $e)), R && (k1 = Am(k1, R, O, $e)), I1 -= er, $e && I1 < Ce) {
              var Zt = Ri(k1, In);
              return _m(
                s,
                d,
                S4,
                i1.placeholder,
                m,
                k1,
                Zt,
                D,
                Y,
                Ce - I1
              );
            }
            var Ur = ve ? m : this, qo = Fe ? Ur[s] : s;
            return I1 = k1.length, D ? k1 = HR(k1, D) : o1 && I1 > 1 && k1.reverse(), ge && Y < I1 && (k1.length = Y), this && this !== l1 && this instanceof i1 && (qo = w1 || w5(qo)), qo.apply(Ur, k1);
          }
          return i1;
        }
        function km(s, d) {
          return function(m, S) {
            return $k(m, s, d(S), {});
          };
        }
        function T4(s, d) {
          return function(m, S) {
            var E;
            if (m === n && S === n)
              return d;
            if (m !== n && (E = m), S !== n) {
              if (E === n)
                return S;
              typeof m == "string" || typeof S == "string" ? (m = Qn(m), S = Qn(S)) : (m = Cm(m), S = Cm(S)), E = s(m, S);
            }
            return E;
          };
        }
        function P7(s) {
          return Xo(function(d) {
            return d = At(d, Jn(t1())), S1(function(m) {
              var S = this;
              return s(d, function(E) {
                return Yn(E, S, m);
              });
            });
          });
        }
        function A4(s, d) {
          d = d === n ? " " : Qn(d);
          var m = d.length;
          if (m < 2)
            return m ? E7(d, s) : d;
          var S = E7(d, d4(s / _2(d)));
          return R2(d) ? Hi(Gr(S), 0, s).join("") : S.slice(0, s);
        }
        function bR(s, d, m, S) {
          var E = d & y, R = w5(s);
          function O() {
            for (var D = -1, Y = arguments.length, Ce = -1, ge = S.length, ve = le(ge + Y), Fe = this && this !== l1 && this instanceof O ? R : s; ++Ce < ge; )
              ve[Ce] = S[Ce];
            for (; Y--; )
              ve[Ce++] = arguments[++D];
            return Yn(Fe, E ? m : this, ve);
          }
          return O;
        }
        function Rm(s) {
          return function(d, m, S) {
            return S && typeof S != "number" && An(d, m, S) && (m = S = n), d = Qo(d), m === n ? (m = d, d = 0) : m = Qo(m), S = S === n ? d < m ? 1 : -1 : Qo(S), rR(d, m, S, s);
          };
        }
        function I4(s) {
          return function(d, m) {
            return typeof d == "string" && typeof m == "string" || (d = xr(d), m = xr(m)), s(d, m);
          };
        }
        function _m(s, d, m, S, E, R, O, D, Y, Ce) {
          var ge = d & A, ve = ge ? O : n, Fe = ge ? n : O, $e = ge ? R : n, o1 = ge ? n : R;
          d |= ge ? I : M, d &= ~(ge ? M : I), d & T || (d &= ~(y | x));
          var w1 = [
            s,
            d,
            E,
            $e,
            ve,
            o1,
            Fe,
            D,
            Y,
            Ce
          ], i1 = m.apply(n, w1);
          return G7(s) && $m(i1, w1), i1.placeholder = S, Um(i1, s, d);
        }
        function V7(s) {
          var d = jt[s];
          return function(m, S) {
            if (m = xr(m), S = S == null ? 0 : Cn(y1(S), 292), S && Uh(m)) {
              var E = (J1(m) + "e").split("e"), R = d(E[0] + "e" + (+E[1] + S));
              return E = (J1(R) + "e").split("e"), +(E[0] + "e" + (+E[1] - S));
            }
            return d(m);
          };
        }
        var vR = V2 && 1 / t4(new V2([, -0]))[1] == J ? function(s) {
          return new V2(s);
        } : o8;
        function Fm(s) {
          return function(d) {
            var m = gn(d);
            return m == s1 ? f7(d) : m == L1 ? VB(d) : EB(d, s(d));
          };
        }
        function jo(s, d, m, S, E, R, O, D) {
          var Y = d & x;
          if (!Y && typeof s != "function")
            throw new Cr(a);
          var Ce = S ? S.length : 0;
          if (Ce || (d &= ~(I | M), S = E = n), O = O === n ? O : Xt(y1(O), 0), D = D === n ? D : y1(D), Ce -= E ? E.length : 0, d & M) {
            var ge = S, ve = E;
            S = E = n;
          }
          var Fe = Y ? n : N7(s), $e = [
            s,
            d,
            m,
            S,
            E,
            ge,
            ve,
            R,
            O,
            D
          ];
          if (Fe && FR($e, Fe), s = $e[0], d = $e[1], m = $e[2], S = $e[3], E = $e[4], D = $e[9] = $e[9] === n ? Y ? 0 : s.length : Xt($e[9] - Ce, 0), !D && d & (A | L) && (d &= ~(A | L)), !d || d == y)
            var o1 = CR(s, d, m);
          else d == A || d == L ? o1 = gR(s, d, D) : (d == I || d == (y | I)) && !E.length ? o1 = bR(s, d, m, S) : o1 = S4.apply(n, $e);
          var w1 = Fe ? hm : $m;
          return Um(w1(o1, $e), s, d);
        }
        function Pm(s, d, m, S) {
          return s === n || $r(s, P2[m]) && !tt.call(S, m) ? d : s;
        }
        function Vm(s, d, m, S, E, R) {
          return Mt(s) && Mt(d) && (R.set(d, s), v4(s, d, n, Vm, R), R.delete(d)), s;
        }
        function yR(s) {
          return A5(s) ? n : s;
        }
        function Hm(s, d, m, S, E, R) {
          var O = m & v, D = s.length, Y = d.length;
          if (D != Y && !(O && Y > D))
            return !1;
          var Ce = R.get(s), ge = R.get(d);
          if (Ce && ge)
            return Ce == d && ge == s;
          var ve = -1, Fe = !0, $e = m & b ? new xa() : n;
          for (R.set(s, d), R.set(d, s); ++ve < D; ) {
            var o1 = s[ve], w1 = d[ve];
            if (S)
              var i1 = O ? S(w1, o1, ve, d, s, R) : S(o1, w1, ve, s, d, R);
            if (i1 !== n) {
              if (i1)
                continue;
              Fe = !1;
              break;
            }
            if ($e) {
              if (!a7(d, function(I1, k1) {
                if (!d5($e, k1) && (o1 === I1 || E(o1, I1, m, S, R)))
                  return $e.push(k1);
              })) {
                Fe = !1;
                break;
              }
            } else if (!(o1 === w1 || E(o1, w1, m, S, R))) {
              Fe = !1;
              break;
            }
          }
          return R.delete(s), R.delete(d), Fe;
        }
        function xR(s, d, m, S, E, R, O) {
          switch (m) {
            case ln:
              if (s.byteLength != d.byteLength || s.byteOffset != d.byteOffset)
                return !1;
              s = s.buffer, d = d.buffer;
            case on:
              return !(s.byteLength != d.byteLength || !R(new s4(s), new s4(d)));
            case pe:
            case me:
            case Ye:
              return $r(+s, +d);
            case We:
              return s.name == d.name && s.message == d.message;
            case p1:
            case Ct:
              return s == d + "";
            case s1:
              var D = f7;
            case L1:
              var Y = S & v;
              if (D || (D = t4), s.size != d.size && !Y)
                return !1;
              var Ce = O.get(s);
              if (Ce)
                return Ce == d;
              S |= b, O.set(s, d);
              var ge = Hm(D(s), D(d), S, E, R, O);
              return O.delete(s), ge;
            case Z1:
              if (C5)
                return C5.call(s) == C5.call(d);
          }
          return !1;
        }
        function wR(s, d, m, S, E, R) {
          var O = m & v, D = H7(s), Y = D.length, Ce = H7(d), ge = Ce.length;
          if (Y != ge && !O)
            return !1;
          for (var ve = Y; ve--; ) {
            var Fe = D[ve];
            if (!(O ? Fe in d : tt.call(d, Fe)))
              return !1;
          }
          var $e = R.get(s), o1 = R.get(d);
          if ($e && o1)
            return $e == d && o1 == s;
          var w1 = !0;
          R.set(s, d), R.set(d, s);
          for (var i1 = O; ++ve < Y; ) {
            Fe = D[ve];
            var I1 = s[Fe], k1 = d[Fe];
            if (S)
              var Kn = O ? S(k1, I1, Fe, d, s, R) : S(I1, k1, Fe, s, d, R);
            if (!(Kn === n ? I1 === k1 || E(I1, k1, m, S, R) : Kn)) {
              w1 = !1;
              break;
            }
            i1 || (i1 = Fe == "constructor");
          }
          if (w1 && !i1) {
            var In = s.constructor, er = d.constructor;
            In != er && "constructor" in s && "constructor" in d && !(typeof In == "function" && In instanceof In && typeof er == "function" && er instanceof er) && (w1 = !1);
          }
          return R.delete(s), R.delete(d), w1;
        }
        function Xo(s) {
          return $7(Gm(s, n, qm), s + "");
        }
        function H7(s) {
          return rm(s, an, Z7);
        }
        function O7(s) {
          return rm(s, Dn, Om);
        }
        var N7 = p4 ? function(s) {
          return p4.get(s);
        } : o8;
        function L4(s) {
          for (var d = s.name + "", m = H2[d], S = tt.call(H2, d) ? m.length : 0; S--; ) {
            var E = m[S], R = E.func;
            if (R == null || R == s)
              return E.name;
          }
          return d;
        }
        function Z2(s) {
          var d = tt.call(B, "placeholder") ? B : s;
          return d.placeholder;
        }
        function t1() {
          var s = B.iteratee || n8;
          return s = s === n8 ? am : s, arguments.length ? s(arguments[0], arguments[1]) : s;
        }
        function E4(s, d) {
          var m = s.__data__;
          return BR(d) ? m[typeof d == "string" ? "string" : "hash"] : m.map;
        }
        function D7(s) {
          for (var d = an(s), m = d.length; m--; ) {
            var S = d[m], E = s[S];
            d[m] = [S, E, Zm(E)];
          }
          return d;
        }
        function Ta(s, d) {
          var m = _B(s, d);
          return im(m) ? m : n;
        }
        function SR(s) {
          var d = tt.call(s, va), m = s[va];
          try {
            s[va] = n;
            var S = !0;
          } catch {
          }
          var E = i4.call(s);
          return S && (d ? s[va] = m : delete s[va]), E;
        }
        var Z7 = h7 ? function(s) {
          return s == null ? [] : (s = ft(s), Bi(h7(s), function(d) {
            return Wh.call(s, d);
          }));
        } : i8, Om = h7 ? function(s) {
          for (var d = []; s; )
            ki(d, Z7(s)), s = l4(s);
          return d;
        } : i8, gn = Tn;
        (m7 && gn(new m7(new ArrayBuffer(1))) != ln || p5 && gn(new p5()) != s1 || C7 && gn(C7.resolve()) != j1 || V2 && gn(new V2()) != L1 || h5 && gn(new h5()) != ut) && (gn = function(s) {
          var d = Tn(s), m = d == Pe ? s.constructor : n, S = m ? Aa(m) : "";
          if (S)
            switch (S) {
              case ik:
                return ln;
              case ak:
                return s1;
              case sk:
                return j1;
              case lk:
                return L1;
              case ck:
                return ut;
            }
          return d;
        });
        function TR(s, d, m) {
          for (var S = -1, E = m.length; ++S < E; ) {
            var R = m[S], O = R.size;
            switch (R.type) {
              case "drop":
                s += O;
                break;
              case "dropRight":
                d -= O;
                break;
              case "take":
                d = Cn(d, s + O);
                break;
              case "takeRight":
                s = Xt(s, d - O);
                break;
            }
          }
          return { start: s, end: d };
        }
        function AR(s) {
          var d = s.match(O6);
          return d ? d[1].split(N6) : [];
        }
        function Nm(s, d, m) {
          d = Vi(d, s);
          for (var S = -1, E = d.length, R = !1; ++S < E; ) {
            var O = lo(d[S]);
            if (!(R = s != null && m(s, O)))
              break;
            s = s[O];
          }
          return R || ++S != E ? R : (E = s == null ? 0 : s.length, !!E && P4(E) && Yo(O, E) && (C1(s) || Ia(s)));
        }
        function IR(s) {
          var d = s.length, m = new s.constructor(d);
          return d && typeof s[0] == "string" && tt.call(s, "index") && (m.index = s.index, m.input = s.input), m;
        }
        function Dm(s) {
          return typeof s.constructor == "function" && !S5(s) ? O2(l4(s)) : {};
        }
        function LR(s, d, m) {
          var S = s.constructor;
          switch (d) {
            case on:
              return F7(s);
            case pe:
            case me:
              return new S(+s);
            case ln:
              return uR(s, m);
            case Ca:
            case wi:
            case No:
            case Si:
            case Js:
            case Qs:
            case Zr:
            case Ti:
            case qs:
              return wm(s, m);
            case s1:
              return new S();
            case Ye:
            case Ct:
              return new S(s);
            case p1:
              return dR(s);
            case L1:
              return new S();
            case Z1:
              return fR(s);
          }
        }
        function ER(s, d) {
          var m = d.length;
          if (!m)
            return s;
          var S = m - 1;
          return d[S] = (m > 1 ? "& " : "") + d[S], d = d.join(m > 2 ? ", " : " "), s.replace(Ii, `{
/* [wrapped with ` + d + `] */
`);
        }
        function MR(s) {
          return C1(s) || Ia(s) || !!($h && s && s[$h]);
        }
        function Yo(s, d) {
          var m = typeof s;
          return d = d ?? Me, !!d && (m == "number" || m != "symbol" && j6.test(s)) && s > -1 && s % 1 == 0 && s < d;
        }
        function An(s, d, m) {
          if (!Mt(m))
            return !1;
          var S = typeof d;
          return (S == "number" ? Nn(m) && Yo(d, m.length) : S == "string" && d in m) ? $r(m[d], s) : !1;
        }
        function z7(s, d) {
          if (C1(s))
            return !1;
          var m = typeof s;
          return m == "number" || m == "symbol" || m == "boolean" || s == null || qn(s) ? !0 : zr.test(s) || !F6.test(s) || d != null && s in ft(d);
        }
        function BR(s) {
          var d = typeof s;
          return d == "string" || d == "number" || d == "symbol" || d == "boolean" ? s !== "__proto__" : s === null;
        }
        function G7(s) {
          var d = L4(s), m = B[d];
          if (typeof m != "function" || !(d in M1.prototype))
            return !1;
          if (s === m)
            return !0;
          var S = N7(m);
          return !!S && s === S[0];
        }
        function kR(s) {
          return !!Zh && Zh in s;
        }
        var RR = r4 ? Jo : a8;
        function S5(s) {
          var d = s && s.constructor, m = typeof d == "function" && d.prototype || P2;
          return s === m;
        }
        function Zm(s) {
          return s === s && !Mt(s);
        }
        function zm(s, d) {
          return function(m) {
            return m == null ? !1 : m[s] === d && (d !== n || s in ft(m));
          };
        }
        function _R(s) {
          var d = _4(s, function(S) {
            return m.size === u && m.clear(), S;
          }), m = d.cache;
          return d;
        }
        function FR(s, d) {
          var m = s[1], S = d[1], E = m | S, R = E < (y | x | k), O = S == k && m == A || S == k && m == _ && s[7].length <= d[8] || S == (k | _) && d[7].length <= d[8] && m == A;
          if (!(R || O))
            return s;
          S & y && (s[2] = d[2], E |= m & y ? 0 : T);
          var D = d[3];
          if (D) {
            var Y = s[3];
            s[3] = Y ? Tm(Y, D, d[4]) : D, s[4] = Y ? Ri(s[3], f) : d[4];
          }
          return D = d[5], D && (Y = s[5], s[5] = Y ? Am(Y, D, d[6]) : D, s[6] = Y ? Ri(s[5], f) : d[6]), D = d[7], D && (s[7] = D), S & k && (s[8] = s[8] == null ? d[8] : Cn(s[8], d[8])), s[9] == null && (s[9] = d[9]), s[0] = d[0], s[1] = E, s;
        }
        function PR(s) {
          var d = [];
          if (s != null)
            for (var m in ft(s))
              d.push(m);
          return d;
        }
        function VR(s) {
          return i4.call(s);
        }
        function Gm(s, d, m) {
          return d = Xt(d === n ? s.length - 1 : d, 0), function() {
            for (var S = arguments, E = -1, R = Xt(S.length - d, 0), O = le(R); ++E < R; )
              O[E] = S[d + E];
            E = -1;
            for (var D = le(d + 1); ++E < d; )
              D[E] = S[E];
            return D[d] = m(O), Yn(s, this, D);
          };
        }
        function Wm(s, d) {
          return d.length < 2 ? s : Sa(s, vr(d, 0, -1));
        }
        function HR(s, d) {
          for (var m = s.length, S = Cn(d.length, m), E = On(s); S--; ) {
            var R = d[S];
            s[S] = Yo(R, m) ? E[R] : n;
          }
          return s;
        }
        function W7(s, d) {
          if (!(d === "constructor" && typeof s[d] == "function") && d != "__proto__")
            return s[d];
        }
        var $m = jm(hm), T5 = qB || function(s, d) {
          return l1.setTimeout(s, d);
        }, $7 = jm(aR);
        function Um(s, d, m) {
          var S = d + "";
          return $7(s, ER(S, OR(AR(S), m)));
        }
        function jm(s) {
          var d = 0, m = 0;
          return function() {
            var S = nk(), E = ae - (S - m);
            if (m = S, E > 0) {
              if (++d >= te)
                return arguments[0];
            } else
              d = 0;
            return s.apply(n, arguments);
          };
        }
        function M4(s, d) {
          var m = -1, S = s.length, E = S - 1;
          for (d = d === n ? S : d; ++m < d; ) {
            var R = L7(m, E), O = s[R];
            s[R] = s[m], s[m] = O;
          }
          return s.length = d, s;
        }
        var Xm = _R(function(s) {
          var d = [];
          return s.charCodeAt(0) === 46 && d.push(""), s.replace(P6, function(m, S, E, R) {
            d.push(E ? R.replace(z6, "$1") : S || m);
          }), d;
        });
        function lo(s) {
          if (typeof s == "string" || qn(s))
            return s;
          var d = s + "";
          return d == "0" && 1 / s == -J ? "-0" : d;
        }
        function Aa(s) {
          if (s != null) {
            try {
              return o4.call(s);
            } catch {
            }
            try {
              return s + "";
            } catch {
            }
          }
          return "";
        }
        function OR(s, d) {
          return mr(xe, function(m) {
            var S = "_." + m[0];
            d & m[1] && !K3(s, S) && s.push(S);
          }), s.sort();
        }
        function Ym(s) {
          if (s instanceof M1)
            return s.clone();
          var d = new gr(s.__wrapped__, s.__chain__);
          return d.__actions__ = On(s.__actions__), d.__index__ = s.__index__, d.__values__ = s.__values__, d;
        }
        function NR(s, d, m) {
          (m ? An(s, d, m) : d === n) ? d = 1 : d = Xt(y1(d), 0);
          var S = s == null ? 0 : s.length;
          if (!S || d < 1)
            return [];
          for (var E = 0, R = 0, O = le(d4(S / d)); E < S; )
            O[R++] = vr(s, E, E += d);
          return O;
        }
        function DR(s) {
          for (var d = -1, m = s == null ? 0 : s.length, S = 0, E = []; ++d < m; ) {
            var R = s[d];
            R && (E[S++] = R);
          }
          return E;
        }
        function ZR() {
          var s = arguments.length;
          if (!s)
            return [];
          for (var d = le(s - 1), m = arguments[0], S = s; S--; )
            d[S - 1] = arguments[S];
          return ki(C1(m) ? On(m) : [m], cn(d, 1));
        }
        var zR = S1(function(s, d) {
          return Dt(s) ? b5(s, cn(d, 1, Dt, !0)) : [];
        }), GR = S1(function(s, d) {
          var m = yr(d);
          return Dt(m) && (m = n), Dt(s) ? b5(s, cn(d, 1, Dt, !0), t1(m, 2)) : [];
        }), WR = S1(function(s, d) {
          var m = yr(d);
          return Dt(m) && (m = n), Dt(s) ? b5(s, cn(d, 1, Dt, !0), n, m) : [];
        });
        function $R(s, d, m) {
          var S = s == null ? 0 : s.length;
          return S ? (d = m || d === n ? 1 : y1(d), vr(s, d < 0 ? 0 : d, S)) : [];
        }
        function UR(s, d, m) {
          var S = s == null ? 0 : s.length;
          return S ? (d = m || d === n ? 1 : y1(d), d = S - d, vr(s, 0, d < 0 ? 0 : d)) : [];
        }
        function jR(s, d) {
          return s && s.length ? x4(s, t1(d, 3), !0, !0) : [];
        }
        function XR(s, d) {
          return s && s.length ? x4(s, t1(d, 3), !0) : [];
        }
        function YR(s, d, m, S) {
          var E = s == null ? 0 : s.length;
          return E ? (m && typeof m != "number" && An(s, d, m) && (m = 0, S = E), Zk(s, d, m, S)) : [];
        }
        function Jm(s, d, m) {
          var S = s == null ? 0 : s.length;
          if (!S)
            return -1;
          var E = m == null ? 0 : y1(m);
          return E < 0 && (E = Xt(S + E, 0)), e4(s, t1(d, 3), E);
        }
        function Qm(s, d, m) {
          var S = s == null ? 0 : s.length;
          if (!S)
            return -1;
          var E = S - 1;
          return m !== n && (E = y1(m), E = m < 0 ? Xt(S + E, 0) : Cn(E, S - 1)), e4(s, t1(d, 3), E, !0);
        }
        function qm(s) {
          var d = s == null ? 0 : s.length;
          return d ? cn(s, 1) : [];
        }
        function JR(s) {
          var d = s == null ? 0 : s.length;
          return d ? cn(s, J) : [];
        }
        function QR(s, d) {
          var m = s == null ? 0 : s.length;
          return m ? (d = d === n ? 1 : y1(d), cn(s, d)) : [];
        }
        function qR(s) {
          for (var d = -1, m = s == null ? 0 : s.length, S = {}; ++d < m; ) {
            var E = s[d];
            S[E[0]] = E[1];
          }
          return S;
        }
        function Km(s) {
          return s && s.length ? s[0] : n;
        }
        function KR(s, d, m) {
          var S = s == null ? 0 : s.length;
          if (!S)
            return -1;
          var E = m == null ? 0 : y1(m);
          return E < 0 && (E = Xt(S + E, 0)), k2(s, d, E);
        }
        function e_(s) {
          var d = s == null ? 0 : s.length;
          return d ? vr(s, 0, -1) : [];
        }
        var t_ = S1(function(s) {
          var d = At(s, R7);
          return d.length && d[0] === s[0] ? w7(d) : [];
        }), n_ = S1(function(s) {
          var d = yr(s), m = At(s, R7);
          return d === yr(m) ? d = n : m.pop(), m.length && m[0] === s[0] ? w7(m, t1(d, 2)) : [];
        }), r_ = S1(function(s) {
          var d = yr(s), m = At(s, R7);
          return d = typeof d == "function" ? d : n, d && m.pop(), m.length && m[0] === s[0] ? w7(m, n, d) : [];
        });
        function o_(s, d) {
          return s == null ? "" : ek.call(s, d);
        }
        function yr(s) {
          var d = s == null ? 0 : s.length;
          return d ? s[d - 1] : n;
        }
        function i_(s, d, m) {
          var S = s == null ? 0 : s.length;
          if (!S)
            return -1;
          var E = S;
          return m !== n && (E = y1(m), E = E < 0 ? Xt(S + E, 0) : Cn(E, S - 1)), d === d ? OB(s, d, E) : e4(s, _h, E, !0);
        }
        function a_(s, d) {
          return s && s.length ? um(s, y1(d)) : n;
        }
        var s_ = S1(eC);
        function eC(s, d) {
          return s && s.length && d && d.length ? I7(s, d) : s;
        }
        function l_(s, d, m) {
          return s && s.length && d && d.length ? I7(s, d, t1(m, 2)) : s;
        }
        function c_(s, d, m) {
          return s && s.length && d && d.length ? I7(s, d, n, m) : s;
        }
        var u_ = Xo(function(s, d) {
          var m = s == null ? 0 : s.length, S = b7(s, d);
          return pm(s, At(d, function(E) {
            return Yo(E, m) ? +E : E;
          }).sort(Sm)), S;
        });
        function d_(s, d) {
          var m = [];
          if (!(s && s.length))
            return m;
          var S = -1, E = [], R = s.length;
          for (d = t1(d, 3); ++S < R; ) {
            var O = s[S];
            d(O, S, s) && (m.push(O), E.push(S));
          }
          return pm(s, E), m;
        }
        function U7(s) {
          return s == null ? s : ok.call(s);
        }
        function f_(s, d, m) {
          var S = s == null ? 0 : s.length;
          return S ? (m && typeof m != "number" && An(s, d, m) ? (d = 0, m = S) : (d = d == null ? 0 : y1(d), m = m === n ? S : y1(m)), vr(s, d, m)) : [];
        }
        function p_(s, d) {
          return y4(s, d);
        }
        function h_(s, d, m) {
          return M7(s, d, t1(m, 2));
        }
        function m_(s, d) {
          var m = s == null ? 0 : s.length;
          if (m) {
            var S = y4(s, d);
            if (S < m && $r(s[S], d))
              return S;
          }
          return -1;
        }
        function C_(s, d) {
          return y4(s, d, !0);
        }
        function g_(s, d, m) {
          return M7(s, d, t1(m, 2), !0);
        }
        function b_(s, d) {
          var m = s == null ? 0 : s.length;
          if (m) {
            var S = y4(s, d, !0) - 1;
            if ($r(s[S], d))
              return S;
          }
          return -1;
        }
        function v_(s) {
          return s && s.length ? mm(s) : [];
        }
        function y_(s, d) {
          return s && s.length ? mm(s, t1(d, 2)) : [];
        }
        function x_(s) {
          var d = s == null ? 0 : s.length;
          return d ? vr(s, 1, d) : [];
        }
        function w_(s, d, m) {
          return s && s.length ? (d = m || d === n ? 1 : y1(d), vr(s, 0, d < 0 ? 0 : d)) : [];
        }
        function S_(s, d, m) {
          var S = s == null ? 0 : s.length;
          return S ? (d = m || d === n ? 1 : y1(d), d = S - d, vr(s, d < 0 ? 0 : d, S)) : [];
        }
        function T_(s, d) {
          return s && s.length ? x4(s, t1(d, 3), !1, !0) : [];
        }
        function A_(s, d) {
          return s && s.length ? x4(s, t1(d, 3)) : [];
        }
        var I_ = S1(function(s) {
          return Pi(cn(s, 1, Dt, !0));
        }), L_ = S1(function(s) {
          var d = yr(s);
          return Dt(d) && (d = n), Pi(cn(s, 1, Dt, !0), t1(d, 2));
        }), E_ = S1(function(s) {
          var d = yr(s);
          return d = typeof d == "function" ? d : n, Pi(cn(s, 1, Dt, !0), n, d);
        });
        function M_(s) {
          return s && s.length ? Pi(s) : [];
        }
        function B_(s, d) {
          return s && s.length ? Pi(s, t1(d, 2)) : [];
        }
        function k_(s, d) {
          return d = typeof d == "function" ? d : n, s && s.length ? Pi(s, n, d) : [];
        }
        function j7(s) {
          if (!(s && s.length))
            return [];
          var d = 0;
          return s = Bi(s, function(m) {
            if (Dt(m))
              return d = Xt(m.length, d), !0;
          }), u7(d, function(m) {
            return At(s, s7(m));
          });
        }
        function tC(s, d) {
          if (!(s && s.length))
            return [];
          var m = j7(s);
          return d == null ? m : At(m, function(S) {
            return Yn(d, n, S);
          });
        }
        var R_ = S1(function(s, d) {
          return Dt(s) ? b5(s, d) : [];
        }), __ = S1(function(s) {
          return k7(Bi(s, Dt));
        }), F_ = S1(function(s) {
          var d = yr(s);
          return Dt(d) && (d = n), k7(Bi(s, Dt), t1(d, 2));
        }), P_ = S1(function(s) {
          var d = yr(s);
          return d = typeof d == "function" ? d : n, k7(Bi(s, Dt), n, d);
        }), V_ = S1(j7);
        function H_(s, d) {
          return vm(s || [], d || [], g5);
        }
        function O_(s, d) {
          return vm(s || [], d || [], x5);
        }
        var N_ = S1(function(s) {
          var d = s.length, m = d > 1 ? s[d - 1] : n;
          return m = typeof m == "function" ? (s.pop(), m) : n, tC(s, m);
        });
        function nC(s) {
          var d = B(s);
          return d.__chain__ = !0, d;
        }
        function D_(s, d) {
          return d(s), s;
        }
        function B4(s, d) {
          return d(s);
        }
        var Z_ = Xo(function(s) {
          var d = s.length, m = d ? s[0] : 0, S = this.__wrapped__, E = function(R) {
            return b7(R, s);
          };
          return d > 1 || this.__actions__.length || !(S instanceof M1) || !Yo(m) ? this.thru(E) : (S = S.slice(m, +m + (d ? 1 : 0)), S.__actions__.push({
            func: B4,
            args: [E],
            thisArg: n
          }), new gr(S, this.__chain__).thru(function(R) {
            return d && !R.length && R.push(n), R;
          }));
        });
        function z_() {
          return nC(this);
        }
        function G_() {
          return new gr(this.value(), this.__chain__);
        }
        function W_() {
          this.__values__ === n && (this.__values__ = CC(this.value()));
          var s = this.__index__ >= this.__values__.length, d = s ? n : this.__values__[this.__index__++];
          return { done: s, value: d };
        }
        function $_() {
          return this;
        }
        function U_(s) {
          for (var d, m = this; m instanceof m4; ) {
            var S = Ym(m);
            S.__index__ = 0, S.__values__ = n, d ? E.__wrapped__ = S : d = S;
            var E = S;
            m = m.__wrapped__;
          }
          return E.__wrapped__ = s, d;
        }
        function j_() {
          var s = this.__wrapped__;
          if (s instanceof M1) {
            var d = s;
            return this.__actions__.length && (d = new M1(this)), d = d.reverse(), d.__actions__.push({
              func: B4,
              args: [U7],
              thisArg: n
            }), new gr(d, this.__chain__);
          }
          return this.thru(U7);
        }
        function X_() {
          return bm(this.__wrapped__, this.__actions__);
        }
        var Y_ = w4(function(s, d, m) {
          tt.call(s, m) ? ++s[m] : Uo(s, m, 1);
        });
        function J_(s, d, m) {
          var S = C1(s) ? kh : Dk;
          return m && An(s, d, m) && (d = n), S(s, t1(d, 3));
        }
        function Q_(s, d) {
          var m = C1(s) ? Bi : tm;
          return m(s, t1(d, 3));
        }
        var q_ = Mm(Jm), K_ = Mm(Qm);
        function eF(s, d) {
          return cn(k4(s, d), 1);
        }
        function tF(s, d) {
          return cn(k4(s, d), J);
        }
        function nF(s, d, m) {
          return m = m === n ? 1 : y1(m), cn(k4(s, d), m);
        }
        function rC(s, d) {
          var m = C1(s) ? mr : Fi;
          return m(s, t1(d, 3));
        }
        function oC(s, d) {
          var m = C1(s) ? xB : em;
          return m(s, t1(d, 3));
        }
        var rF = w4(function(s, d, m) {
          tt.call(s, m) ? s[m].push(d) : Uo(s, m, [d]);
        });
        function oF(s, d, m, S) {
          s = Nn(s) ? s : G2(s), m = m && !S ? y1(m) : 0;
          var E = s.length;
          return m < 0 && (m = Xt(E + m, 0)), V4(s) ? m <= E && s.indexOf(d, m) > -1 : !!E && k2(s, d, m) > -1;
        }
        var iF = S1(function(s, d, m) {
          var S = -1, E = typeof d == "function", R = Nn(s) ? le(s.length) : [];
          return Fi(s, function(O) {
            R[++S] = E ? Yn(d, O, m) : v5(O, d, m);
          }), R;
        }), aF = w4(function(s, d, m) {
          Uo(s, m, d);
        });
        function k4(s, d) {
          var m = C1(s) ? At : sm;
          return m(s, t1(d, 3));
        }
        function sF(s, d, m, S) {
          return s == null ? [] : (C1(d) || (d = d == null ? [] : [d]), m = S ? n : m, C1(m) || (m = m == null ? [] : [m]), dm(s, d, m));
        }
        var lF = w4(function(s, d, m) {
          s[m ? 0 : 1].push(d);
        }, function() {
          return [[], []];
        });
        function cF(s, d, m) {
          var S = C1(s) ? i7 : Ph, E = arguments.length < 3;
          return S(s, t1(d, 4), m, E, Fi);
        }
        function uF(s, d, m) {
          var S = C1(s) ? wB : Ph, E = arguments.length < 3;
          return S(s, t1(d, 4), m, E, em);
        }
        function dF(s, d) {
          var m = C1(s) ? Bi : tm;
          return m(s, F4(t1(d, 3)));
        }
        function fF(s) {
          var d = C1(s) ? Jh : oR;
          return d(s);
        }
        function pF(s, d, m) {
          (m ? An(s, d, m) : d === n) ? d = 1 : d = y1(d);
          var S = C1(s) ? Pk : iR;
          return S(s, d);
        }
        function hF(s) {
          var d = C1(s) ? Vk : sR;
          return d(s);
        }
        function mF(s) {
          if (s == null)
            return 0;
          if (Nn(s))
            return V4(s) ? _2(s) : s.length;
          var d = gn(s);
          return d == s1 || d == L1 ? s.size : T7(s).length;
        }
        function CF(s, d, m) {
          var S = C1(s) ? a7 : lR;
          return m && An(s, d, m) && (d = n), S(s, t1(d, 3));
        }
        var gF = S1(function(s, d) {
          if (s == null)
            return [];
          var m = d.length;
          return m > 1 && An(s, d[0], d[1]) ? d = [] : m > 2 && An(d[0], d[1], d[2]) && (d = [d[0]]), dm(s, cn(d, 1), []);
        }), R4 = QB || function() {
          return l1.Date.now();
        };
        function bF(s, d) {
          if (typeof d != "function")
            throw new Cr(a);
          return s = y1(s), function() {
            if (--s < 1)
              return d.apply(this, arguments);
          };
        }
        function iC(s, d, m) {
          return d = m ? n : d, d = s && d == null ? s.length : d, jo(s, k, n, n, n, n, d);
        }
        function aC(s, d) {
          var m;
          if (typeof d != "function")
            throw new Cr(a);
          return s = y1(s), function() {
            return --s > 0 && (m = d.apply(this, arguments)), s <= 1 && (d = n), m;
          };
        }
        var X7 = S1(function(s, d, m) {
          var S = y;
          if (m.length) {
            var E = Ri(m, Z2(X7));
            S |= I;
          }
          return jo(s, S, d, m, E);
        }), sC = S1(function(s, d, m) {
          var S = y | x;
          if (m.length) {
            var E = Ri(m, Z2(sC));
            S |= I;
          }
          return jo(d, S, s, m, E);
        });
        function lC(s, d, m) {
          d = m ? n : d;
          var S = jo(s, A, n, n, n, n, n, d);
          return S.placeholder = lC.placeholder, S;
        }
        function cC(s, d, m) {
          d = m ? n : d;
          var S = jo(s, L, n, n, n, n, n, d);
          return S.placeholder = cC.placeholder, S;
        }
        function uC(s, d, m) {
          var S, E, R, O, D, Y, Ce = 0, ge = !1, ve = !1, Fe = !0;
          if (typeof s != "function")
            throw new Cr(a);
          d = xr(d) || 0, Mt(m) && (ge = !!m.leading, ve = "maxWait" in m, R = ve ? Xt(xr(m.maxWait) || 0, d) : R, Fe = "trailing" in m ? !!m.trailing : Fe);
          function $e(Zt) {
            var Ur = S, qo = E;
            return S = E = n, Ce = Zt, O = s.apply(qo, Ur), O;
          }
          function o1(Zt) {
            return Ce = Zt, D = T5(I1, d), ge ? $e(Zt) : O;
          }
          function w1(Zt) {
            var Ur = Zt - Y, qo = Zt - Ce, MC = d - Ur;
            return ve ? Cn(MC, R - qo) : MC;
          }
          function i1(Zt) {
            var Ur = Zt - Y, qo = Zt - Ce;
            return Y === n || Ur >= d || Ur < 0 || ve && qo >= R;
          }
          function I1() {
            var Zt = R4();
            if (i1(Zt))
              return k1(Zt);
            D = T5(I1, w1(Zt));
          }
          function k1(Zt) {
            return D = n, Fe && S ? $e(Zt) : (S = E = n, O);
          }
          function Kn() {
            D !== n && ym(D), Ce = 0, S = Y = E = D = n;
          }
          function In() {
            return D === n ? O : k1(R4());
          }
          function er() {
            var Zt = R4(), Ur = i1(Zt);
            if (S = arguments, E = this, Y = Zt, Ur) {
              if (D === n)
                return o1(Y);
              if (ve)
                return ym(D), D = T5(I1, d), $e(Y);
            }
            return D === n && (D = T5(I1, d)), O;
          }
          return er.cancel = Kn, er.flush = In, er;
        }
        var vF = S1(function(s, d) {
          return Kh(s, 1, d);
        }), yF = S1(function(s, d, m) {
          return Kh(s, xr(d) || 0, m);
        });
        function xF(s) {
          return jo(s, F);
        }
        function _4(s, d) {
          if (typeof s != "function" || d != null && typeof d != "function")
            throw new Cr(a);
          var m = function() {
            var S = arguments, E = d ? d.apply(this, S) : S[0], R = m.cache;
            if (R.has(E))
              return R.get(E);
            var O = s.apply(this, S);
            return m.cache = R.set(E, O) || R, O;
          };
          return m.cache = new (_4.Cache || $o)(), m;
        }
        _4.Cache = $o;
        function F4(s) {
          if (typeof s != "function")
            throw new Cr(a);
          return function() {
            var d = arguments;
            switch (d.length) {
              case 0:
                return !s.call(this);
              case 1:
                return !s.call(this, d[0]);
              case 2:
                return !s.call(this, d[0], d[1]);
              case 3:
                return !s.call(this, d[0], d[1], d[2]);
            }
            return !s.apply(this, d);
          };
        }
        function wF(s) {
          return aC(2, s);
        }
        var SF = cR(function(s, d) {
          d = d.length == 1 && C1(d[0]) ? At(d[0], Jn(t1())) : At(cn(d, 1), Jn(t1()));
          var m = d.length;
          return S1(function(S) {
            for (var E = -1, R = Cn(S.length, m); ++E < R; )
              S[E] = d[E].call(this, S[E]);
            return Yn(s, this, S);
          });
        }), Y7 = S1(function(s, d) {
          var m = Ri(d, Z2(Y7));
          return jo(s, I, n, d, m);
        }), dC = S1(function(s, d) {
          var m = Ri(d, Z2(dC));
          return jo(s, M, n, d, m);
        }), TF = Xo(function(s, d) {
          return jo(s, _, n, n, n, d);
        });
        function AF(s, d) {
          if (typeof s != "function")
            throw new Cr(a);
          return d = d === n ? d : y1(d), S1(s, d);
        }
        function IF(s, d) {
          if (typeof s != "function")
            throw new Cr(a);
          return d = d == null ? 0 : Xt(y1(d), 0), S1(function(m) {
            var S = m[d], E = Hi(m, 0, d);
            return S && ki(E, S), Yn(s, this, E);
          });
        }
        function LF(s, d, m) {
          var S = !0, E = !0;
          if (typeof s != "function")
            throw new Cr(a);
          return Mt(m) && (S = "leading" in m ? !!m.leading : S, E = "trailing" in m ? !!m.trailing : E), uC(s, d, {
            leading: S,
            maxWait: d,
            trailing: E
          });
        }
        function EF(s) {
          return iC(s, 1);
        }
        function MF(s, d) {
          return Y7(_7(d), s);
        }
        function BF() {
          if (!arguments.length)
            return [];
          var s = arguments[0];
          return C1(s) ? s : [s];
        }
        function kF(s) {
          return br(s, C);
        }
        function RF(s, d) {
          return d = typeof d == "function" ? d : n, br(s, C, d);
        }
        function _F(s) {
          return br(s, p | C);
        }
        function FF(s, d) {
          return d = typeof d == "function" ? d : n, br(s, p | C, d);
        }
        function PF(s, d) {
          return d == null || qh(s, d, an(d));
        }
        function $r(s, d) {
          return s === d || s !== s && d !== d;
        }
        var VF = I4(x7), HF = I4(function(s, d) {
          return s >= d;
        }), Ia = om(/* @__PURE__ */ function() {
          return arguments;
        }()) ? om : function(s) {
          return _t(s) && tt.call(s, "callee") && !Wh.call(s, "callee");
        }, C1 = le.isArray, OF = B2 ? Jn(B2) : Uk;
        function Nn(s) {
          return s != null && P4(s.length) && !Jo(s);
        }
        function Dt(s) {
          return _t(s) && Nn(s);
        }
        function NF(s) {
          return s === !0 || s === !1 || _t(s) && Tn(s) == pe;
        }
        var Oi = KB || a8, DF = u5 ? Jn(u5) : jk;
        function ZF(s) {
          return _t(s) && s.nodeType === 1 && !A5(s);
        }
        function zF(s) {
          if (s == null)
            return !0;
          if (Nn(s) && (C1(s) || typeof s == "string" || typeof s.splice == "function" || Oi(s) || z2(s) || Ia(s)))
            return !s.length;
          var d = gn(s);
          if (d == s1 || d == L1)
            return !s.size;
          if (S5(s))
            return !T7(s).length;
          for (var m in s)
            if (tt.call(s, m))
              return !1;
          return !0;
        }
        function GF(s, d) {
          return y5(s, d);
        }
        function WF(s, d, m) {
          m = typeof m == "function" ? m : n;
          var S = m ? m(s, d) : n;
          return S === n ? y5(s, d, n, m) : !!S;
        }
        function J7(s) {
          if (!_t(s))
            return !1;
          var d = Tn(s);
          return d == We || d == Be || typeof s.message == "string" && typeof s.name == "string" && !A5(s);
        }
        function $F(s) {
          return typeof s == "number" && Uh(s);
        }
        function Jo(s) {
          if (!Mt(s))
            return !1;
          var d = Tn(s);
          return d == ie || d == f1 || d == Q || d == X1;
        }
        function fC(s) {
          return typeof s == "number" && s == y1(s);
        }
        function P4(s) {
          return typeof s == "number" && s > -1 && s % 1 == 0 && s <= Me;
        }
        function Mt(s) {
          var d = typeof s;
          return s != null && (d == "object" || d == "function");
        }
        function _t(s) {
          return s != null && typeof s == "object";
        }
        var pC = Lh ? Jn(Lh) : Yk;
        function UF(s, d) {
          return s === d || S7(s, d, D7(d));
        }
        function jF(s, d, m) {
          return m = typeof m == "function" ? m : n, S7(s, d, D7(d), m);
        }
        function XF(s) {
          return hC(s) && s != +s;
        }
        function YF(s) {
          if (RR(s))
            throw new m1(i);
          return im(s);
        }
        function JF(s) {
          return s === null;
        }
        function QF(s) {
          return s == null;
        }
        function hC(s) {
          return typeof s == "number" || _t(s) && Tn(s) == Ye;
        }
        function A5(s) {
          if (!_t(s) || Tn(s) != Pe)
            return !1;
          var d = l4(s);
          if (d === null)
            return !0;
          var m = tt.call(d, "constructor") && d.constructor;
          return typeof m == "function" && m instanceof m && o4.call(m) == jB;
        }
        var Q7 = Eh ? Jn(Eh) : Jk;
        function qF(s) {
          return fC(s) && s >= -Me && s <= Me;
        }
        var mC = Mh ? Jn(Mh) : Qk;
        function V4(s) {
          return typeof s == "string" || !C1(s) && _t(s) && Tn(s) == Ct;
        }
        function qn(s) {
          return typeof s == "symbol" || _t(s) && Tn(s) == Z1;
        }
        var z2 = Bh ? Jn(Bh) : qk;
        function KF(s) {
          return s === n;
        }
        function eP(s) {
          return _t(s) && gn(s) == ut;
        }
        function tP(s) {
          return _t(s) && Tn(s) == rn;
        }
        var nP = I4(A7), rP = I4(function(s, d) {
          return s <= d;
        });
        function CC(s) {
          if (!s)
            return [];
          if (Nn(s))
            return V4(s) ? Gr(s) : On(s);
          if (f5 && s[f5])
            return PB(s[f5]());
          var d = gn(s), m = d == s1 ? f7 : d == L1 ? t4 : G2;
          return m(s);
        }
        function Qo(s) {
          if (!s)
            return s === 0 ? s : 0;
          if (s = xr(s), s === J || s === -J) {
            var d = s < 0 ? -1 : 1;
            return d * _e;
          }
          return s === s ? s : 0;
        }
        function y1(s) {
          var d = Qo(s), m = d % 1;
          return d === d ? m ? d - m : d : 0;
        }
        function gC(s) {
          return s ? wa(y1(s), 0, ee) : 0;
        }
        function xr(s) {
          if (typeof s == "number")
            return s;
          if (qn(s))
            return ne;
          if (Mt(s)) {
            var d = typeof s.valueOf == "function" ? s.valueOf() : s;
            s = Mt(d) ? d + "" : d;
          }
          if (typeof s != "string")
            return s === 0 ? s : +s;
          s = Vh(s);
          var m = W6.test(s);
          return m || U6.test(s) ? E1(s.slice(2), m ? 2 : 8) : G6.test(s) ? ne : +s;
        }
        function bC(s) {
          return so(s, Dn(s));
        }
        function oP(s) {
          return s ? wa(y1(s), -Me, Me) : s === 0 ? s : 0;
        }
        function J1(s) {
          return s == null ? "" : Qn(s);
        }
        var iP = N2(function(s, d) {
          if (S5(d) || Nn(d)) {
            so(d, an(d), s);
            return;
          }
          for (var m in d)
            tt.call(d, m) && g5(s, m, d[m]);
        }), vC = N2(function(s, d) {
          so(d, Dn(d), s);
        }), H4 = N2(function(s, d, m, S) {
          so(d, Dn(d), s, S);
        }), aP = N2(function(s, d, m, S) {
          so(d, an(d), s, S);
        }), sP = Xo(b7);
        function lP(s, d) {
          var m = O2(s);
          return d == null ? m : Qh(m, d);
        }
        var cP = S1(function(s, d) {
          s = ft(s);
          var m = -1, S = d.length, E = S > 2 ? d[2] : n;
          for (E && An(d[0], d[1], E) && (S = 1); ++m < S; )
            for (var R = d[m], O = Dn(R), D = -1, Y = O.length; ++D < Y; ) {
              var Ce = O[D], ge = s[Ce];
              (ge === n || $r(ge, P2[Ce]) && !tt.call(s, Ce)) && (s[Ce] = R[Ce]);
            }
          return s;
        }), uP = S1(function(s) {
          return s.push(n, Vm), Yn(yC, n, s);
        });
        function dP(s, d) {
          return Rh(s, t1(d, 3), ao);
        }
        function fP(s, d) {
          return Rh(s, t1(d, 3), y7);
        }
        function pP(s, d) {
          return s == null ? s : v7(s, t1(d, 3), Dn);
        }
        function hP(s, d) {
          return s == null ? s : nm(s, t1(d, 3), Dn);
        }
        function mP(s, d) {
          return s && ao(s, t1(d, 3));
        }
        function CP(s, d) {
          return s && y7(s, t1(d, 3));
        }
        function gP(s) {
          return s == null ? [] : b4(s, an(s));
        }
        function bP(s) {
          return s == null ? [] : b4(s, Dn(s));
        }
        function q7(s, d, m) {
          var S = s == null ? n : Sa(s, d);
          return S === n ? m : S;
        }
        function vP(s, d) {
          return s != null && Nm(s, d, zk);
        }
        function K7(s, d) {
          return s != null && Nm(s, d, Gk);
        }
        var yP = km(function(s, d, m) {
          d != null && typeof d.toString != "function" && (d = i4.call(d)), s[d] = m;
        }, t8(Zn)), xP = km(function(s, d, m) {
          d != null && typeof d.toString != "function" && (d = i4.call(d)), tt.call(s, d) ? s[d].push(m) : s[d] = [m];
        }, t1), wP = S1(v5);
        function an(s) {
          return Nn(s) ? Yh(s) : T7(s);
        }
        function Dn(s) {
          return Nn(s) ? Yh(s, !0) : Kk(s);
        }
        function SP(s, d) {
          var m = {};
          return d = t1(d, 3), ao(s, function(S, E, R) {
            Uo(m, d(S, E, R), S);
          }), m;
        }
        function TP(s, d) {
          var m = {};
          return d = t1(d, 3), ao(s, function(S, E, R) {
            Uo(m, E, d(S, E, R));
          }), m;
        }
        var AP = N2(function(s, d, m) {
          v4(s, d, m);
        }), yC = N2(function(s, d, m, S) {
          v4(s, d, m, S);
        }), IP = Xo(function(s, d) {
          var m = {};
          if (s == null)
            return m;
          var S = !1;
          d = At(d, function(R) {
            return R = Vi(R, s), S || (S = R.length > 1), R;
          }), so(s, O7(s), m), S && (m = br(m, p | h | C, yR));
          for (var E = d.length; E--; )
            B7(m, d[E]);
          return m;
        });
        function LP(s, d) {
          return xC(s, F4(t1(d)));
        }
        var EP = Xo(function(s, d) {
          return s == null ? {} : tR(s, d);
        });
        function xC(s, d) {
          if (s == null)
            return {};
          var m = At(O7(s), function(S) {
            return [S];
          });
          return d = t1(d), fm(s, m, function(S, E) {
            return d(S, E[0]);
          });
        }
        function MP(s, d, m) {
          d = Vi(d, s);
          var S = -1, E = d.length;
          for (E || (E = 1, s = n); ++S < E; ) {
            var R = s == null ? n : s[lo(d[S])];
            R === n && (S = E, R = m), s = Jo(R) ? R.call(s) : R;
          }
          return s;
        }
        function BP(s, d, m) {
          return s == null ? s : x5(s, d, m);
        }
        function kP(s, d, m, S) {
          return S = typeof S == "function" ? S : n, s == null ? s : x5(s, d, m, S);
        }
        var wC = Fm(an), SC = Fm(Dn);
        function RP(s, d, m) {
          var S = C1(s), E = S || Oi(s) || z2(s);
          if (d = t1(d, 4), m == null) {
            var R = s && s.constructor;
            E ? m = S ? new R() : [] : Mt(s) ? m = Jo(R) ? O2(l4(s)) : {} : m = {};
          }
          return (E ? mr : ao)(s, function(O, D, Y) {
            return d(m, O, D, Y);
          }), m;
        }
        function _P(s, d) {
          return s == null ? !0 : B7(s, d);
        }
        function FP(s, d, m) {
          return s == null ? s : gm(s, d, _7(m));
        }
        function PP(s, d, m, S) {
          return S = typeof S == "function" ? S : n, s == null ? s : gm(s, d, _7(m), S);
        }
        function G2(s) {
          return s == null ? [] : d7(s, an(s));
        }
        function VP(s) {
          return s == null ? [] : d7(s, Dn(s));
        }
        function HP(s, d, m) {
          return m === n && (m = d, d = n), m !== n && (m = xr(m), m = m === m ? m : 0), d !== n && (d = xr(d), d = d === d ? d : 0), wa(xr(s), d, m);
        }
        function OP(s, d, m) {
          return d = Qo(d), m === n ? (m = d, d = 0) : m = Qo(m), s = xr(s), Wk(s, d, m);
        }
        function NP(s, d, m) {
          if (m && typeof m != "boolean" && An(s, d, m) && (d = m = n), m === n && (typeof d == "boolean" ? (m = d, d = n) : typeof s == "boolean" && (m = s, s = n)), s === n && d === n ? (s = 0, d = 1) : (s = Qo(s), d === n ? (d = s, s = 0) : d = Qo(d)), s > d) {
            var S = s;
            s = d, d = S;
          }
          if (m || s % 1 || d % 1) {
            var E = jh();
            return Cn(s + E * (d - s + Ne("1e-" + ((E + "").length - 1))), d);
          }
          return L7(s, d);
        }
        var DP = D2(function(s, d, m) {
          return d = d.toLowerCase(), s + (m ? TC(d) : d);
        });
        function TC(s) {
          return e8(J1(s).toLowerCase());
        }
        function AC(s) {
          return s = J1(s), s && s.replace(t5, BB).replace(Zo, "");
        }
        function ZP(s, d, m) {
          s = J1(s), d = Qn(d);
          var S = s.length;
          m = m === n ? S : wa(y1(m), 0, S);
          var E = m;
          return m -= d.length, m >= 0 && s.slice(m, E) == d;
        }
        function zP(s) {
          return s = J1(s), s && k6.test(s) ? s.replace(E3, kB) : s;
        }
        function GP(s) {
          return s = J1(s), s && V6.test(s) ? s.replace(Ks, "\\$&") : s;
        }
        var WP = D2(function(s, d, m) {
          return s + (m ? "-" : "") + d.toLowerCase();
        }), $P = D2(function(s, d, m) {
          return s + (m ? " " : "") + d.toLowerCase();
        }), UP = Em("toLowerCase");
        function jP(s, d, m) {
          s = J1(s), d = y1(d);
          var S = d ? _2(s) : 0;
          if (!d || S >= d)
            return s;
          var E = (d - S) / 2;
          return A4(f4(E), m) + s + A4(d4(E), m);
        }
        function XP(s, d, m) {
          s = J1(s), d = y1(d);
          var S = d ? _2(s) : 0;
          return d && S < d ? s + A4(d - S, m) : s;
        }
        function YP(s, d, m) {
          s = J1(s), d = y1(d);
          var S = d ? _2(s) : 0;
          return d && S < d ? A4(d - S, m) + s : s;
        }
        function JP(s, d, m) {
          return m || d == null ? d = 0 : d && (d = +d), rk(J1(s).replace(e5, ""), d || 0);
        }
        function QP(s, d, m) {
          return (m ? An(s, d, m) : d === n) ? d = 1 : d = y1(d), E7(J1(s), d);
        }
        function qP() {
          var s = arguments, d = J1(s[0]);
          return s.length < 3 ? d : d.replace(s[1], s[2]);
        }
        var KP = D2(function(s, d, m) {
          return s + (m ? "_" : "") + d.toLowerCase();
        });
        function eV(s, d, m) {
          return m && typeof m != "number" && An(s, d, m) && (d = m = n), m = m === n ? ee : m >>> 0, m ? (s = J1(s), s && (typeof d == "string" || d != null && !Q7(d)) && (d = Qn(d), !d && R2(s)) ? Hi(Gr(s), 0, m) : s.split(d, m)) : [];
        }
        var tV = D2(function(s, d, m) {
          return s + (m ? " " : "") + e8(d);
        });
        function nV(s, d, m) {
          return s = J1(s), m = m == null ? 0 : wa(y1(m), 0, s.length), d = Qn(d), s.slice(m, m + d.length) == d;
        }
        function rV(s, d, m) {
          var S = B.templateSettings;
          m && An(s, d, m) && (d = n), s = J1(s), d = H4({}, d, S, Pm);
          var E = H4({}, d.imports, S.imports, Pm), R = an(E), O = d7(E, R), D, Y, Ce = 0, ge = d.interpolate || T2, ve = "__p += '", Fe = p7(
            (d.escape || T2).source + "|" + ge.source + "|" + (ge === M3 ? Li : T2).source + "|" + (d.evaluate || T2).source + "|$",
            "g"
          ), $e = "//# sourceURL=" + (tt.call(d, "sourceURL") ? (d.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++n7 + "]") + `
`;
          s.replace(Fe, function(i1, I1, k1, Kn, In, er) {
            return k1 || (k1 = Kn), ve += s.slice(Ce, er).replace(A2, RB), I1 && (D = !0, ve += `' +
__e(` + I1 + `) +
'`), In && (Y = !0, ve += `';
` + In + `;
__p += '`), k1 && (ve += `' +
((__t = (` + k1 + `)) == null ? '' : __t) +
'`), Ce = er + i1.length, i1;
          }), ve += `';
`;
          var o1 = tt.call(d, "variable") && d.variable;
          if (!o1)
            ve = `with (obj) {
` + ve + `
}
`;
          else if (Z6.test(o1))
            throw new m1(l);
          ve = (Y ? ve.replace(I3, "") : ve).replace(B6, "$1").replace(L3, "$1;"), ve = "function(" + (o1 || "obj") + `) {
` + (o1 ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (D ? ", __e = _.escape" : "") + (Y ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ve + `return __p
}`;
          var w1 = LC(function() {
            return z1(R, $e + "return " + ve).apply(n, O);
          });
          if (w1.source = ve, J7(w1))
            throw w1;
          return w1;
        }
        function oV(s) {
          return J1(s).toLowerCase();
        }
        function iV(s) {
          return J1(s).toUpperCase();
        }
        function aV(s, d, m) {
          if (s = J1(s), s && (m || d === n))
            return Vh(s);
          if (!s || !(d = Qn(d)))
            return s;
          var S = Gr(s), E = Gr(d), R = Hh(S, E), O = Oh(S, E) + 1;
          return Hi(S, R, O).join("");
        }
        function sV(s, d, m) {
          if (s = J1(s), s && (m || d === n))
            return s.slice(0, Dh(s) + 1);
          if (!s || !(d = Qn(d)))
            return s;
          var S = Gr(s), E = Oh(S, Gr(d)) + 1;
          return Hi(S, 0, E).join("");
        }
        function lV(s, d, m) {
          if (s = J1(s), s && (m || d === n))
            return s.replace(e5, "");
          if (!s || !(d = Qn(d)))
            return s;
          var S = Gr(s), E = Hh(S, Gr(d));
          return Hi(S, E).join("");
        }
        function cV(s, d) {
          var m = $, S = oe;
          if (Mt(d)) {
            var E = "separator" in d ? d.separator : E;
            m = "length" in d ? y1(d.length) : m, S = "omission" in d ? Qn(d.omission) : S;
          }
          s = J1(s);
          var R = s.length;
          if (R2(s)) {
            var O = Gr(s);
            R = O.length;
          }
          if (m >= R)
            return s;
          var D = m - _2(S);
          if (D < 1)
            return S;
          var Y = O ? Hi(O, 0, D).join("") : s.slice(0, D);
          if (E === n)
            return Y + S;
          if (O && (D += Y.length - D), Q7(E)) {
            if (s.slice(D).search(E)) {
              var Ce, ge = Y;
              for (E.global || (E = p7(E.source, J1(B3.exec(E)) + "g")), E.lastIndex = 0; Ce = E.exec(ge); )
                var ve = Ce.index;
              Y = Y.slice(0, ve === n ? D : ve);
            }
          } else if (s.indexOf(Qn(E), D) != D) {
            var Fe = Y.lastIndexOf(E);
            Fe > -1 && (Y = Y.slice(0, Fe));
          }
          return Y + S;
        }
        function uV(s) {
          return s = J1(s), s && Do.test(s) ? s.replace(Ai, NB) : s;
        }
        var dV = D2(function(s, d, m) {
          return s + (m ? " " : "") + d.toUpperCase();
        }), e8 = Em("toUpperCase");
        function IC(s, d, m) {
          return s = J1(s), d = m ? n : d, d === n ? FB(s) ? zB(s) : AB(s) : s.match(d) || [];
        }
        var LC = S1(function(s, d) {
          try {
            return Yn(s, n, d);
          } catch (m) {
            return J7(m) ? m : new m1(m);
          }
        }), fV = Xo(function(s, d) {
          return mr(d, function(m) {
            m = lo(m), Uo(s, m, X7(s[m], s));
          }), s;
        });
        function pV(s) {
          var d = s == null ? 0 : s.length, m = t1();
          return s = d ? At(s, function(S) {
            if (typeof S[1] != "function")
              throw new Cr(a);
            return [m(S[0]), S[1]];
          }) : [], S1(function(S) {
            for (var E = -1; ++E < d; ) {
              var R = s[E];
              if (Yn(R[0], this, S))
                return Yn(R[1], this, S);
            }
          });
        }
        function hV(s) {
          return Nk(br(s, p));
        }
        function t8(s) {
          return function() {
            return s;
          };
        }
        function mV(s, d) {
          return s == null || s !== s ? d : s;
        }
        var CV = Bm(), gV = Bm(!0);
        function Zn(s) {
          return s;
        }
        function n8(s) {
          return am(typeof s == "function" ? s : br(s, p));
        }
        function bV(s) {
          return lm(br(s, p));
        }
        function vV(s, d) {
          return cm(s, br(d, p));
        }
        var yV = S1(function(s, d) {
          return function(m) {
            return v5(m, s, d);
          };
        }), xV = S1(function(s, d) {
          return function(m) {
            return v5(s, m, d);
          };
        });
        function r8(s, d, m) {
          var S = an(d), E = b4(d, S);
          m == null && !(Mt(d) && (E.length || !S.length)) && (m = d, d = s, s = this, E = b4(d, an(d)));
          var R = !(Mt(m) && "chain" in m) || !!m.chain, O = Jo(s);
          return mr(E, function(D) {
            var Y = d[D];
            s[D] = Y, O && (s.prototype[D] = function() {
              var Ce = this.__chain__;
              if (R || Ce) {
                var ge = s(this.__wrapped__), ve = ge.__actions__ = On(this.__actions__);
                return ve.push({ func: Y, args: arguments, thisArg: s }), ge.__chain__ = Ce, ge;
              }
              return Y.apply(s, ki([this.value()], arguments));
            });
          }), s;
        }
        function wV() {
          return l1._ === this && (l1._ = XB), this;
        }
        function o8() {
        }
        function SV(s) {
          return s = y1(s), S1(function(d) {
            return um(d, s);
          });
        }
        var TV = P7(At), AV = P7(kh), IV = P7(a7);
        function EC(s) {
          return z7(s) ? s7(lo(s)) : nR(s);
        }
        function LV(s) {
          return function(d) {
            return s == null ? n : Sa(s, d);
          };
        }
        var EV = Rm(), MV = Rm(!0);
        function i8() {
          return [];
        }
        function a8() {
          return !1;
        }
        function BV() {
          return {};
        }
        function kV() {
          return "";
        }
        function RV() {
          return !0;
        }
        function _V(s, d) {
          if (s = y1(s), s < 1 || s > Me)
            return [];
          var m = ee, S = Cn(s, ee);
          d = t1(d), s -= ee;
          for (var E = u7(S, d); ++m < s; )
            d(m);
          return E;
        }
        function FV(s) {
          return C1(s) ? At(s, lo) : qn(s) ? [s] : On(Xm(J1(s)));
        }
        function PV(s) {
          var d = ++UB;
          return J1(s) + d;
        }
        var VV = T4(function(s, d) {
          return s + d;
        }, 0), HV = V7("ceil"), OV = T4(function(s, d) {
          return s / d;
        }, 1), NV = V7("floor");
        function DV(s) {
          return s && s.length ? g4(s, Zn, x7) : n;
        }
        function ZV(s, d) {
          return s && s.length ? g4(s, t1(d, 2), x7) : n;
        }
        function zV(s) {
          return Fh(s, Zn);
        }
        function GV(s, d) {
          return Fh(s, t1(d, 2));
        }
        function WV(s) {
          return s && s.length ? g4(s, Zn, A7) : n;
        }
        function $V(s, d) {
          return s && s.length ? g4(s, t1(d, 2), A7) : n;
        }
        var UV = T4(function(s, d) {
          return s * d;
        }, 1), jV = V7("round"), XV = T4(function(s, d) {
          return s - d;
        }, 0);
        function YV(s) {
          return s && s.length ? c7(s, Zn) : 0;
        }
        function JV(s, d) {
          return s && s.length ? c7(s, t1(d, 2)) : 0;
        }
        return B.after = bF, B.ary = iC, B.assign = iP, B.assignIn = vC, B.assignInWith = H4, B.assignWith = aP, B.at = sP, B.before = aC, B.bind = X7, B.bindAll = fV, B.bindKey = sC, B.castArray = BF, B.chain = nC, B.chunk = NR, B.compact = DR, B.concat = ZR, B.cond = pV, B.conforms = hV, B.constant = t8, B.countBy = Y_, B.create = lP, B.curry = lC, B.curryRight = cC, B.debounce = uC, B.defaults = cP, B.defaultsDeep = uP, B.defer = vF, B.delay = yF, B.difference = zR, B.differenceBy = GR, B.differenceWith = WR, B.drop = $R, B.dropRight = UR, B.dropRightWhile = jR, B.dropWhile = XR, B.fill = YR, B.filter = Q_, B.flatMap = eF, B.flatMapDeep = tF, B.flatMapDepth = nF, B.flatten = qm, B.flattenDeep = JR, B.flattenDepth = QR, B.flip = xF, B.flow = CV, B.flowRight = gV, B.fromPairs = qR, B.functions = gP, B.functionsIn = bP, B.groupBy = rF, B.initial = e_, B.intersection = t_, B.intersectionBy = n_, B.intersectionWith = r_, B.invert = yP, B.invertBy = xP, B.invokeMap = iF, B.iteratee = n8, B.keyBy = aF, B.keys = an, B.keysIn = Dn, B.map = k4, B.mapKeys = SP, B.mapValues = TP, B.matches = bV, B.matchesProperty = vV, B.memoize = _4, B.merge = AP, B.mergeWith = yC, B.method = yV, B.methodOf = xV, B.mixin = r8, B.negate = F4, B.nthArg = SV, B.omit = IP, B.omitBy = LP, B.once = wF, B.orderBy = sF, B.over = TV, B.overArgs = SF, B.overEvery = AV, B.overSome = IV, B.partial = Y7, B.partialRight = dC, B.partition = lF, B.pick = EP, B.pickBy = xC, B.property = EC, B.propertyOf = LV, B.pull = s_, B.pullAll = eC, B.pullAllBy = l_, B.pullAllWith = c_, B.pullAt = u_, B.range = EV, B.rangeRight = MV, B.rearg = TF, B.reject = dF, B.remove = d_, B.rest = AF, B.reverse = U7, B.sampleSize = pF, B.set = BP, B.setWith = kP, B.shuffle = hF, B.slice = f_, B.sortBy = gF, B.sortedUniq = v_, B.sortedUniqBy = y_, B.split = eV, B.spread = IF, B.tail = x_, B.take = w_, B.takeRight = S_, B.takeRightWhile = T_, B.takeWhile = A_, B.tap = D_, B.throttle = LF, B.thru = B4, B.toArray = CC, B.toPairs = wC, B.toPairsIn = SC, B.toPath = FV, B.toPlainObject = bC, B.transform = RP, B.unary = EF, B.union = I_, B.unionBy = L_, B.unionWith = E_, B.uniq = M_, B.uniqBy = B_, B.uniqWith = k_, B.unset = _P, B.unzip = j7, B.unzipWith = tC, B.update = FP, B.updateWith = PP, B.values = G2, B.valuesIn = VP, B.without = R_, B.words = IC, B.wrap = MF, B.xor = __, B.xorBy = F_, B.xorWith = P_, B.zip = V_, B.zipObject = H_, B.zipObjectDeep = O_, B.zipWith = N_, B.entries = wC, B.entriesIn = SC, B.extend = vC, B.extendWith = H4, r8(B, B), B.add = VV, B.attempt = LC, B.camelCase = DP, B.capitalize = TC, B.ceil = HV, B.clamp = HP, B.clone = kF, B.cloneDeep = _F, B.cloneDeepWith = FF, B.cloneWith = RF, B.conformsTo = PF, B.deburr = AC, B.defaultTo = mV, B.divide = OV, B.endsWith = ZP, B.eq = $r, B.escape = zP, B.escapeRegExp = GP, B.every = J_, B.find = q_, B.findIndex = Jm, B.findKey = dP, B.findLast = K_, B.findLastIndex = Qm, B.findLastKey = fP, B.floor = NV, B.forEach = rC, B.forEachRight = oC, B.forIn = pP, B.forInRight = hP, B.forOwn = mP, B.forOwnRight = CP, B.get = q7, B.gt = VF, B.gte = HF, B.has = vP, B.hasIn = K7, B.head = Km, B.identity = Zn, B.includes = oF, B.indexOf = KR, B.inRange = OP, B.invoke = wP, B.isArguments = Ia, B.isArray = C1, B.isArrayBuffer = OF, B.isArrayLike = Nn, B.isArrayLikeObject = Dt, B.isBoolean = NF, B.isBuffer = Oi, B.isDate = DF, B.isElement = ZF, B.isEmpty = zF, B.isEqual = GF, B.isEqualWith = WF, B.isError = J7, B.isFinite = $F, B.isFunction = Jo, B.isInteger = fC, B.isLength = P4, B.isMap = pC, B.isMatch = UF, B.isMatchWith = jF, B.isNaN = XF, B.isNative = YF, B.isNil = QF, B.isNull = JF, B.isNumber = hC, B.isObject = Mt, B.isObjectLike = _t, B.isPlainObject = A5, B.isRegExp = Q7, B.isSafeInteger = qF, B.isSet = mC, B.isString = V4, B.isSymbol = qn, B.isTypedArray = z2, B.isUndefined = KF, B.isWeakMap = eP, B.isWeakSet = tP, B.join = o_, B.kebabCase = WP, B.last = yr, B.lastIndexOf = i_, B.lowerCase = $P, B.lowerFirst = UP, B.lt = nP, B.lte = rP, B.max = DV, B.maxBy = ZV, B.mean = zV, B.meanBy = GV, B.min = WV, B.minBy = $V, B.stubArray = i8, B.stubFalse = a8, B.stubObject = BV, B.stubString = kV, B.stubTrue = RV, B.multiply = UV, B.nth = a_, B.noConflict = wV, B.noop = o8, B.now = R4, B.pad = jP, B.padEnd = XP, B.padStart = YP, B.parseInt = JP, B.random = NP, B.reduce = cF, B.reduceRight = uF, B.repeat = QP, B.replace = qP, B.result = MP, B.round = jV, B.runInContext = U, B.sample = fF, B.size = mF, B.snakeCase = KP, B.some = CF, B.sortedIndex = p_, B.sortedIndexBy = h_, B.sortedIndexOf = m_, B.sortedLastIndex = C_, B.sortedLastIndexBy = g_, B.sortedLastIndexOf = b_, B.startCase = tV, B.startsWith = nV, B.subtract = XV, B.sum = YV, B.sumBy = JV, B.template = rV, B.times = _V, B.toFinite = Qo, B.toInteger = y1, B.toLength = gC, B.toLower = oV, B.toNumber = xr, B.toSafeInteger = oP, B.toString = J1, B.toUpper = iV, B.trim = aV, B.trimEnd = sV, B.trimStart = lV, B.truncate = cV, B.unescape = uV, B.uniqueId = PV, B.upperCase = dV, B.upperFirst = e8, B.each = rC, B.eachRight = oC, B.first = Km, r8(B, function() {
          var s = {};
          return ao(B, function(d, m) {
            tt.call(B.prototype, m) || (s[m] = d);
          }), s;
        }(), { chain: !1 }), B.VERSION = r, mr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
          B[s].placeholder = B;
        }), mr(["drop", "take"], function(s, d) {
          M1.prototype[s] = function(m) {
            m = m === n ? 1 : Xt(y1(m), 0);
            var S = this.__filtered__ && !d ? new M1(this) : this.clone();
            return S.__filtered__ ? S.__takeCount__ = Cn(m, S.__takeCount__) : S.__views__.push({
              size: Cn(m, ee),
              type: s + (S.__dir__ < 0 ? "Right" : "")
            }), S;
          }, M1.prototype[s + "Right"] = function(m) {
            return this.reverse()[s](m).reverse();
          };
        }), mr(["filter", "map", "takeWhile"], function(s, d) {
          var m = d + 1, S = m == be || m == ue;
          M1.prototype[s] = function(E) {
            var R = this.clone();
            return R.__iteratees__.push({
              iteratee: t1(E, 3),
              type: m
            }), R.__filtered__ = R.__filtered__ || S, R;
          };
        }), mr(["head", "last"], function(s, d) {
          var m = "take" + (d ? "Right" : "");
          M1.prototype[s] = function() {
            return this[m](1).value()[0];
          };
        }), mr(["initial", "tail"], function(s, d) {
          var m = "drop" + (d ? "" : "Right");
          M1.prototype[s] = function() {
            return this.__filtered__ ? new M1(this) : this[m](1);
          };
        }), M1.prototype.compact = function() {
          return this.filter(Zn);
        }, M1.prototype.find = function(s) {
          return this.filter(s).head();
        }, M1.prototype.findLast = function(s) {
          return this.reverse().find(s);
        }, M1.prototype.invokeMap = S1(function(s, d) {
          return typeof s == "function" ? new M1(this) : this.map(function(m) {
            return v5(m, s, d);
          });
        }), M1.prototype.reject = function(s) {
          return this.filter(F4(t1(s)));
        }, M1.prototype.slice = function(s, d) {
          s = y1(s);
          var m = this;
          return m.__filtered__ && (s > 0 || d < 0) ? new M1(m) : (s < 0 ? m = m.takeRight(-s) : s && (m = m.drop(s)), d !== n && (d = y1(d), m = d < 0 ? m.dropRight(-d) : m.take(d - s)), m);
        }, M1.prototype.takeRightWhile = function(s) {
          return this.reverse().takeWhile(s).reverse();
        }, M1.prototype.toArray = function() {
          return this.take(ee);
        }, ao(M1.prototype, function(s, d) {
          var m = /^(?:filter|find|map|reject)|While$/.test(d), S = /^(?:head|last)$/.test(d), E = B[S ? "take" + (d == "last" ? "Right" : "") : d], R = S || /^find/.test(d);
          E && (B.prototype[d] = function() {
            var O = this.__wrapped__, D = S ? [1] : arguments, Y = O instanceof M1, Ce = D[0], ge = Y || C1(O), ve = function(I1) {
              var k1 = E.apply(B, ki([I1], D));
              return S && Fe ? k1[0] : k1;
            };
            ge && m && typeof Ce == "function" && Ce.length != 1 && (Y = ge = !1);
            var Fe = this.__chain__, $e = !!this.__actions__.length, o1 = R && !Fe, w1 = Y && !$e;
            if (!R && ge) {
              O = w1 ? O : new M1(this);
              var i1 = s.apply(O, D);
              return i1.__actions__.push({ func: B4, args: [ve], thisArg: n }), new gr(i1, Fe);
            }
            return o1 && w1 ? s.apply(this, D) : (i1 = this.thru(ve), o1 ? S ? i1.value()[0] : i1.value() : i1);
          });
        }), mr(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
          var d = n4[s], m = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", S = /^(?:pop|shift)$/.test(s);
          B.prototype[s] = function() {
            var E = arguments;
            if (S && !this.__chain__) {
              var R = this.value();
              return d.apply(C1(R) ? R : [], E);
            }
            return this[m](function(O) {
              return d.apply(C1(O) ? O : [], E);
            });
          };
        }), ao(M1.prototype, function(s, d) {
          var m = B[d];
          if (m) {
            var S = m.name + "";
            tt.call(H2, S) || (H2[S] = []), H2[S].push({ name: d, func: m });
          }
        }), H2[S4(n, x).name] = [{
          name: "wrapper",
          func: n
        }], M1.prototype.clone = uk, M1.prototype.reverse = dk, M1.prototype.value = fk, B.prototype.at = Z_, B.prototype.chain = z_, B.prototype.commit = G_, B.prototype.next = W_, B.prototype.plant = U_, B.prototype.reverse = j_, B.prototype.toJSON = B.prototype.valueOf = B.prototype.value = X_, B.prototype.first = B.prototype.head, f5 && (B.prototype[f5] = $_), B;
      }, F2 = GB();
      Ut ? ((Ut.exports = F2)._ = F2, ot._ = F2) : l1._ = F2;
    }).call(A6e);
  }(U5, U5.exports)), U5.exports;
}
var ax = I6e();
function ct(e) {
  return (t) => ({
    type: e,
    payload: t
  });
}
const BE = ct(
  "transfer/setSelectedToken"
), j5 = ct("transfer/toToken"), kE = ct("transfer/setFromChain"), oa = ct("transfer/setSendValue"), RE = ct("transfer/setToChain"), L6e = ct("transfer/setSlippage"), kn = ct(
  "transfer/setTransferActionInfo"
), Cd = ct("transfer/setError"), or = ct(
  "transfer/setIsGlobalFeeLoading"
), gd = ct(
  "transfer/setIsTransferable"
), Mo = ct(
  "transfer/setIsRefreshing"
), V1 = ct(
  "transfer/setEstimatedAmount"
), Ht = ct("transfer/setRouteError"), s6 = ct("transfer/setToAccount"), Lr = ct("transfer/setRouteFees"), bd = ct(
  "transfer/setIsToAddressChecked"
), Kp = ct(
  "transfer/setIsRoutesModalOpen"
), vd = ct("transfer/toTokens"), d0 = ct(
  "transfer/setIsManuallyReload"
), yd = ct("transfer/setIsFailedGetQuoteModalOpen"), F0 = ct(
  "transfer/setIsSummaryModalOpen"
), xd = ct(
  "transfer/setIsFeeTimeoutModalOpen"
), _E = ct(
  "transfer/setRefreshAnimationProgress"
);
function FE(e, t) {
  const n = {};
  return t({
    addCase(o, i) {
      const a = o(void 0).type;
      n[a] = i;
    }
  }), {
    getInitialState() {
      return e;
    },
    getReducer() {
      return n;
    }
  };
}
const E6e = {
  fromChain: void 0,
  sendValue: "",
  toChain: void 0,
  selectedToken: void 0,
  slippage: 1e4,
  // 1% for cBridge
  transferActionInfo: void 0,
  error: {
    text: "",
    bridgeType: void 0
  },
  routeError: void 0,
  isGlobalFeeLoading: !1,
  isTransferable: !0,
  isRefreshing: !1,
  estimatedAmount: void 0,
  routeFees: void 0,
  isToAddressChecked: !1,
  toAccount: {
    address: ""
  },
  isRoutesModalOpen: !1,
  toTokens: [],
  isManuallyReload: !1,
  isFailedGetQuoteModalOpen: !1,
  isFeeTimeoutModalOpen: !1,
  isSummaryModalOpen: !1,
  refreshAnimationProgress: 0
}, M6e = FE(E6e, (e) => {
  e.addCase(BE, (t, { payload: n }) => ({
    ...t,
    selectedToken: n
  })), e.addCase(j5, (t, { payload: n }) => ({
    ...t,
    toToken: n
  })), e.addCase(kE, (t, { payload: n }) => ({
    ...t,
    fromChain: n
  })), e.addCase(oa, (t, { payload: n }) => ({
    ...t,
    sendValue: n
  })), e.addCase(RE, (t, { payload: n }) => ({
    ...t,
    toChain: n
  })), e.addCase(L6e, (t, { payload: n }) => ({
    ...t,
    slippage: n
  })), e.addCase(kn, (t, { payload: n }) => ({
    ...t,
    transferActionInfo: n
  })), e.addCase(Cd, (t, { payload: n }) => ({
    ...t,
    error: n
  })), e.addCase(or, (t, { payload: n }) => ({
    ...t,
    isGlobalFeeLoading: n
  })), e.addCase(gd, (t, { payload: n }) => ({
    ...t,
    isTransferable: n
  })), e.addCase(Mo, (t, { payload: n }) => ({
    ...t,
    isRefreshing: n
  })), e.addCase(bd, (t, { payload: n }) => ({
    ...t,
    isToAddressChecked: n
  })), e.addCase(V1, (t, { payload: n }) => ({
    ...t,
    estimatedAmount: { ...t.estimatedAmount, ...n }
  })), e.addCase(Ht, (t, { payload: n }) => ({
    ...t,
    routeError: { ...t.routeError, ...n }
  })), e.addCase(Lr, (t, { payload: n }) => ({
    ...t,
    routeFees: { ...t.routeFees, ...n }
  })), e.addCase(s6, (t, { payload: n }) => ({
    ...t,
    toAccount: {
      ...t.toAccount,
      ...n
    }
  })), e.addCase(Kp, (t, { payload: n }) => ({
    ...t,
    isRoutesModalOpen: n
  })), e.addCase(vd, (t, { payload: n }) => ({
    ...t,
    toTokens: n
  })), e.addCase(d0, (t, { payload: n }) => ({
    ...t,
    isManuallyReload: n
  })), e.addCase(yd, (t, { payload: n }) => ({
    ...t,
    isFailedGetQuoteModalOpen: n
  })), e.addCase(xd, (t, { payload: n }) => ({
    ...t,
    isFeeTimeoutModalOpen: n
  })), e.addCase(F0, (t, { payload: n }) => ({
    ...t,
    isSummaryModalOpen: n
  })), e.addCase(_E, (t, { payload: n }) => ({
    ...t,
    refreshAnimationProgress: n
  }));
}), PE = ct(
  "aggregator/setTokenPrices"
), VE = ct(
  "aggregator/setTokenBalances"
), HE = ct(
  "aggregator/setIsLoadingTokenPrices"
), OE = ct(
  "aggregator/setIsLoadingTokenBalances"
), wd = ct(
  "aggregator/setCBridgeMaxMinSendAmt"
), B6e = {
  tokenPrices: {
    cmcPrices: {},
    llamaPrices: {}
  },
  tokenBalances: {},
  isLoadingTokenPrices: !1,
  isLoadingTokenBalances: !1,
  bridgeMaxMin: {
    cBridge: { max: "0", min: "0" }
  }
}, k6e = FE(B6e, (e) => {
  e.addCase(PE, (t, { payload: n }) => ({
    ...t,
    tokenPrices: {
      cmcPrices: n?.cmcPrices ?? {},
      llamaPrices: n?.llamaPrices ?? {}
    }
  })), e.addCase(VE, (t, { payload: n }) => ({
    ...t,
    tokenBalances: n ?? {}
  })), e.addCase(HE, (t, { payload: n }) => ({
    ...t,
    isLoadingTokenPrices: n
  })), e.addCase(OE, (t, { payload: n }) => ({
    ...t,
    isLoadingTokenBalances: n
  })), e.addCase(wd, (t, { payload: n }) => ({
    ...t,
    bridgeMaxMin: {
      ...t.bridgeMaxMin,
      cBridge: n
    }
  }));
}), NE = {
  transfer: M6e,
  aggregator: k6e
};
function R6e() {
  return Object.fromEntries(
    Object.entries(NE).map(([t, n]) => [t, n.getInitialState()])
  );
}
function _6e() {
  const e = Object.values(NE).reduce(
    (t, n) => ({
      ...t,
      ...n.getReducer()
    }),
    {}
  );
  return (t, n = {}) => {
    const { type: r, payload: o } = n, i = r.split("/")[0], a = e[r](t[i], { payload: o });
    return {
      ...t,
      [i]: {
        ...a
      }
    };
  };
}
const eh = w.createContext({});
function F6e(e) {
  const [t, n] = lw(_6e(), R6e()), r = we(
    () => ({
      state: t,
      dispatch: n
    }),
    [t]
  );
  return /* @__PURE__ */ g(eh.Provider, { value: r, ...e });
}
function D1() {
  return N1(eh).dispatch;
}
function N(e) {
  const { state: t } = N1(eh);
  return e(t);
}
const P6e = ({ children: e }) => {
  const { theme: t } = Lt(), n = we(() => ({
    ...H,
    breakpoints: t.breakpoints,
    config: {
      ...H.config,
      initialColorMode: t.colorMode,
      useSystemColorMode: !1
    },
    colors: {
      ...H.colors,
      ...t.colors
    }
  }), [t.breakpoints, t.colorMode, t.colors]);
  return /* @__PURE__ */ g(
    xJ,
    {
      colorModeManager: {
        type: "localStorage",
        get: () => t.colorMode,
        set: () => {
        }
      },
      theme: n,
      toastOptions: {
        defaultOptions: {
          position: "top"
        }
      },
      children: e
    }
  );
};
function V6e(e) {
  const { children: t } = e, n = Lt(), r = we(() => {
    const { assetPrefix: o, transfer: i } = n, {
      chainConfigs: a,
      providers: l,
      brandChains: c,
      externalChains: u,
      displayTokenSymbols: f,
      chainSorter: p,
      tokenSorter: h
    } = i;
    return {
      aggregator: new QV({
        providers: l,
        brandChains: c,
        externalChains: u,
        displayTokenSymbols: f,
        assetPrefix: o,
        chainConfigs: a,
        chainSorter: p,
        tokenSorter: h
      })
    };
  }, [n]);
  return /* @__PURE__ */ g(DE.Provider, { value: r, children: t });
}
const DE = w.createContext({});
function C2() {
  return N1(DE).aggregator;
}
const _s = 1500, sx = {
  cBridge: "https://celerscan.com/tx/",
  deBridge: "https://app.debridge.finance/orders?s=",
  // meson: 'https://testnet-explorer.meson.fi/swap/',
  meson: "https://explorer.meson.fi/swap/"
}, H6e = "https://mainnet.stargate-api.com/v1/buses/bus-drive-settings", Ha = "0x6836CbaCbBd1E798cC56802AC7d8BDf6Da0d0980", O6e = "TTb3A6ASFejJuGcM1UVcRCJA23WGiJKSiY", lx = "J7JYXS8PMMBgfFKP1bqUu7mGgWyWUDL9xqfYujznc61r", ZE = "https://cbridge-prod2.celer.app", zE = "https://deswap.debridge.finance/v1.0", N6e = "https://mainnet.stargate-api.com/v1/metadata?version=v2", D6e = "https://relayer.meson.fi/api/v1", Z6e = "https://stats-api.dln.trade/api", z6e = {
  1: "ETH",
  10: "ETH",
  56: "BNB",
  137: "MATIC",
  250: "FTM",
  8453: "ETH",
  42161: "ETH",
  43114: "ETH",
  59144: "ETH",
  // 7565164: 'SOL',
  100000001: "NEON",
  1380012617: "ETH"
}, P0 = {
  SECOND: 1e3,
  MINUTE: 1e3 * 60,
  HOUR: 1e3 * 60 * 60,
  DAY: 1e3 * 60 * 60 * 24
}, cx = 1e-4, l6 = 8 * 1e3, th = 0.05, G6e = "0x0000000000000000000000000000000000000000", W6e = "11111111111111111111111111111111";
function GE() {
  const e = N((o) => o.transfer.fromChain), t = N((o) => o.transfer.toChain), n = C2();
  return we(() => e?.id && t?.id ? n.getTokens({ fromChainId: e.id, toChainId: t.id }) : [], [n, e?.id, t?.id]);
}
function WE(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: $6e } = Object.prototype, { getPrototypeOf: nh } = Object, c6 = /* @__PURE__ */ ((e) => (t) => {
  const n = $6e.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), io = (e) => (e = e.toLowerCase(), (t) => c6(t) === e), u6 = (e) => (t) => typeof t === e, { isArray: Zs } = Array, V0 = u6("undefined");
function U6e(e) {
  return e !== null && !V0(e) && e.constructor !== null && !V0(e.constructor) && ir(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const $E = io("ArrayBuffer");
function j6e(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && $E(e.buffer), t;
}
const X6e = u6("string"), ir = u6("function"), UE = u6("number"), d6 = (e) => e !== null && typeof e == "object", Y6e = (e) => e === !0 || e === !1, Nl = (e) => {
  if (c6(e) !== "object")
    return !1;
  const t = nh(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, J6e = io("Date"), Q6e = io("File"), q6e = io("Blob"), K6e = io("FileList"), e7e = (e) => d6(e) && ir(e.pipe), t7e = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ir(e.append) && ((t = c6(e)) === "formdata" || // detect form-data instance
  t === "object" && ir(e.toString) && e.toString() === "[object FormData]"));
}, n7e = io("URLSearchParams"), [r7e, o7e, i7e, a7e] = ["ReadableStream", "Request", "Response", "Headers"].map(io), s7e = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function m3(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), Zs(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let l;
    for (r = 0; r < a; r++)
      l = i[r], t.call(null, e[l], l, e);
  }
}
function jE(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const Oa = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, XE = (e) => !V0(e) && e !== Oa;
function Sd() {
  const { caseless: e } = XE(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && jE(t, o) || o;
    Nl(t[i]) && Nl(r) ? t[i] = Sd(t[i], r) : Nl(r) ? t[i] = Sd({}, r) : Zs(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && m3(arguments[r], n);
  return t;
}
const l7e = (e, t, n, { allOwnKeys: r } = {}) => (m3(t, (o, i) => {
  n && ir(o) ? e[i] = WE(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), c7e = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), u7e = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, d7e = (e, t, n, r) => {
  let o, i, a;
  const l = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!r || r(a, e, t)) && !l[a] && (t[a] = e[a], l[a] = !0);
    e = n !== !1 && nh(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, f7e = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, p7e = (e) => {
  if (!e) return null;
  if (Zs(e)) return e;
  let t = e.length;
  if (!UE(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, h7e = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && nh(Uint8Array)), m7e = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, C7e = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, g7e = io("HTMLFormElement"), b7e = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), ux = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), v7e = io("RegExp"), YE = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  m3(n, (o, i) => {
    let a;
    (a = t(o, i, e)) !== !1 && (r[i] = a || o);
  }), Object.defineProperties(e, r);
}, y7e = (e) => {
  YE(e, (t, n) => {
    if (ir(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (ir(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, x7e = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return Zs(e) ? r(e) : r(String(e).split(t)), n;
}, w7e = () => {
}, S7e = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, Fc = "abcdefghijklmnopqrstuvwxyz", dx = "0123456789", JE = {
  DIGIT: dx,
  ALPHA: Fc,
  ALPHA_DIGIT: Fc + Fc.toUpperCase() + dx
}, T7e = (e = 16, t = JE.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function A7e(e) {
  return !!(e && ir(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const I7e = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (d6(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = Zs(r) ? [] : {};
        return m3(r, (a, l) => {
          const c = n(a, o + 1);
          !V0(c) && (i[l] = c);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, L7e = io("AsyncFunction"), E7e = (e) => e && (d6(e) || ir(e)) && ir(e.then) && ir(e.catch), QE = ((e, t) => e ? setImmediate : t ? ((n, r) => (Oa.addEventListener("message", ({ source: o, data: i }) => {
  o === Oa && i === n && r.length && r.shift()();
}, !1), (o) => {
  r.push(o), Oa.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  ir(Oa.postMessage)
), M7e = typeof queueMicrotask < "u" ? queueMicrotask.bind(Oa) : typeof process < "u" && process.nextTick || QE, de = {
  isArray: Zs,
  isArrayBuffer: $E,
  isBuffer: U6e,
  isFormData: t7e,
  isArrayBufferView: j6e,
  isString: X6e,
  isNumber: UE,
  isBoolean: Y6e,
  isObject: d6,
  isPlainObject: Nl,
  isReadableStream: r7e,
  isRequest: o7e,
  isResponse: i7e,
  isHeaders: a7e,
  isUndefined: V0,
  isDate: J6e,
  isFile: Q6e,
  isBlob: q6e,
  isRegExp: v7e,
  isFunction: ir,
  isStream: e7e,
  isURLSearchParams: n7e,
  isTypedArray: h7e,
  isFileList: K6e,
  forEach: m3,
  merge: Sd,
  extend: l7e,
  trim: s7e,
  stripBOM: c7e,
  inherits: u7e,
  toFlatObject: d7e,
  kindOf: c6,
  kindOfTest: io,
  endsWith: f7e,
  toArray: p7e,
  forEachEntry: m7e,
  matchAll: C7e,
  isHTMLForm: g7e,
  hasOwnProperty: ux,
  hasOwnProp: ux,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: YE,
  freezeMethods: y7e,
  toObjectSet: x7e,
  toCamelCase: b7e,
  noop: w7e,
  toFiniteNumber: S7e,
  findKey: jE,
  global: Oa,
  isContextDefined: XE,
  ALPHABET: JE,
  generateString: T7e,
  isSpecCompliantForm: A7e,
  toJSONObject: I7e,
  isAsyncFn: L7e,
  isThenable: E7e,
  setImmediate: QE,
  asap: M7e
};
function b1(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o, this.status = o.status ? o.status : null);
}
de.inherits(b1, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: de.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const qE = b1.prototype, KE = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  KE[e] = { value: e };
});
Object.defineProperties(b1, KE);
Object.defineProperty(qE, "isAxiosError", { value: !0 });
b1.from = (e, t, n, r, o, i) => {
  const a = Object.create(qE);
  return de.toFlatObject(e, a, function(c) {
    return c !== Error.prototype;
  }, (l) => l !== "isAxiosError"), b1.call(a, e.message, t, n, r, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const B7e = null;
function Td(e) {
  return de.isPlainObject(e) || de.isArray(e);
}
function eM(e) {
  return de.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function fx(e, t, n) {
  return e ? e.concat(t).map(function(o, i) {
    return o = eM(o), !n && i ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function k7e(e) {
  return de.isArray(e) && !e.some(Td);
}
const R7e = de.toFlatObject(de, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function f6(e, t, n) {
  if (!de.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = de.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(b, y) {
    return !de.isUndefined(y[b]);
  });
  const r = n.metaTokens, o = n.visitor || f, i = n.dots, a = n.indexes, c = (n.Blob || typeof Blob < "u" && Blob) && de.isSpecCompliantForm(t);
  if (!de.isFunction(o))
    throw new TypeError("visitor must be a function");
  function u(v) {
    if (v === null) return "";
    if (de.isDate(v))
      return v.toISOString();
    if (!c && de.isBlob(v))
      throw new b1("Blob is not supported. Use a Buffer instead.");
    return de.isArrayBuffer(v) || de.isTypedArray(v) ? c && typeof Blob == "function" ? new Blob([v]) : Buffer.from(v) : v;
  }
  function f(v, b, y) {
    let x = v;
    if (v && !y && typeof v == "object") {
      if (de.endsWith(b, "{}"))
        b = r ? b : b.slice(0, -2), v = JSON.stringify(v);
      else if (de.isArray(v) && k7e(v) || (de.isFileList(v) || de.endsWith(b, "[]")) && (x = de.toArray(v)))
        return b = eM(b), x.forEach(function(A, L) {
          !(de.isUndefined(A) || A === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? fx([b], L, i) : a === null ? b : b + "[]",
            u(A)
          );
        }), !1;
    }
    return Td(v) ? !0 : (t.append(fx(y, b, i), u(v)), !1);
  }
  const p = [], h = Object.assign(R7e, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: Td
  });
  function C(v, b) {
    if (!de.isUndefined(v)) {
      if (p.indexOf(v) !== -1)
        throw Error("Circular reference detected in " + b.join("."));
      p.push(v), de.forEach(v, function(x, T) {
        (!(de.isUndefined(x) || x === null) && o.call(
          t,
          x,
          de.isString(T) ? T.trim() : T,
          b,
          h
        )) === !0 && C(x, b ? b.concat(T) : [T]);
      }), p.pop();
    }
  }
  if (!de.isObject(e))
    throw new TypeError("data must be an object");
  return C(e), t;
}
function px(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function rh(e, t) {
  this._pairs = [], e && f6(e, this, t);
}
const tM = rh.prototype;
tM.append = function(t, n) {
  this._pairs.push([t, n]);
};
tM.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, px);
  } : px;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function _7e(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function nM(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || _7e;
  de.isFunction(n) && (n = {
    serialize: n
  });
  const o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = de.isURLSearchParams(t) ? t.toString() : new rh(t, n).toString(r), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class hx {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    de.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const rM = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, F7e = typeof URLSearchParams < "u" ? URLSearchParams : rh, P7e = typeof FormData < "u" ? FormData : null, V7e = typeof Blob < "u" ? Blob : null, H7e = {
  isBrowser: !0,
  classes: {
    URLSearchParams: F7e,
    FormData: P7e,
    Blob: V7e
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, oh = typeof window < "u" && typeof document < "u", Ad = typeof navigator == "object" && navigator || void 0, O7e = oh && (!Ad || ["ReactNative", "NativeScript", "NS"].indexOf(Ad.product) < 0), N7e = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", D7e = oh && window.location.href || "http://localhost", Z7e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: oh,
  hasStandardBrowserEnv: O7e,
  hasStandardBrowserWebWorkerEnv: N7e,
  navigator: Ad,
  origin: D7e
}, Symbol.toStringTag, { value: "Module" })), yn = {
  ...Z7e,
  ...H7e
};
function z7e(e, t) {
  return f6(e, new yn.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return yn.isNode && de.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function G7e(e) {
  return de.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function W7e(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function oM(e) {
  function t(n, r, o, i) {
    let a = n[i++];
    if (a === "__proto__") return !0;
    const l = Number.isFinite(+a), c = i >= n.length;
    return a = !a && de.isArray(o) ? o.length : a, c ? (de.hasOwnProp(o, a) ? o[a] = [o[a], r] : o[a] = r, !l) : ((!o[a] || !de.isObject(o[a])) && (o[a] = []), t(n, r, o[a], i) && de.isArray(o[a]) && (o[a] = W7e(o[a])), !l);
  }
  if (de.isFormData(e) && de.isFunction(e.entries)) {
    const n = {};
    return de.forEachEntry(e, (r, o) => {
      t(G7e(r), o, n, 0);
    }), n;
  }
  return null;
}
function $7e(e, t, n) {
  if (de.isString(e))
    try {
      return (t || JSON.parse)(e), de.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const C3 = {
  transitional: rM,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, i = de.isObject(t);
    if (i && de.isHTMLForm(t) && (t = new FormData(t)), de.isFormData(t))
      return o ? JSON.stringify(oM(t)) : t;
    if (de.isArrayBuffer(t) || de.isBuffer(t) || de.isStream(t) || de.isFile(t) || de.isBlob(t) || de.isReadableStream(t))
      return t;
    if (de.isArrayBufferView(t))
      return t.buffer;
    if (de.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let l;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return z7e(t, this.formSerializer).toString();
      if ((l = de.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return f6(
          l ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return i || o ? (n.setContentType("application/json", !1), $7e(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || C3.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (de.isResponse(t) || de.isReadableStream(t))
      return t;
    if (t && de.isString(t) && (r && !this.responseType || o)) {
      const a = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (l) {
        if (a)
          throw l.name === "SyntaxError" ? b1.from(l, b1.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: yn.classes.FormData,
    Blob: yn.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
de.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  C3.headers[e] = {};
});
const U7e = de.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), j7e = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), n = a.substring(0, o).trim().toLowerCase(), r = a.substring(o + 1).trim(), !(!n || t[n] && U7e[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, mx = Symbol("internals");
function V5(e) {
  return e && String(e).trim().toLowerCase();
}
function Dl(e) {
  return e === !1 || e == null ? e : de.isArray(e) ? e.map(Dl) : String(e);
}
function X7e(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Y7e = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Pc(e, t, n, r, o) {
  if (de.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!de.isString(t)) {
    if (de.isString(r))
      return t.indexOf(r) !== -1;
    if (de.isRegExp(r))
      return r.test(t);
  }
}
function J7e(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Q7e(e, t) {
  const n = de.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, a) {
        return this[r].call(this, t, o, i, a);
      },
      configurable: !0
    });
  });
}
class Un {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function i(l, c, u) {
      const f = V5(c);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const p = de.findKey(o, f);
      (!p || o[p] === void 0 || u === !0 || u === void 0 && o[p] !== !1) && (o[p || c] = Dl(l));
    }
    const a = (l, c) => de.forEach(l, (u, f) => i(u, f, c));
    if (de.isPlainObject(t) || t instanceof this.constructor)
      a(t, n);
    else if (de.isString(t) && (t = t.trim()) && !Y7e(t))
      a(j7e(t), n);
    else if (de.isHeaders(t))
      for (const [l, c] of t.entries())
        i(c, l, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = V5(t), t) {
      const r = de.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return X7e(o);
        if (de.isFunction(n))
          return n.call(this, o, r);
        if (de.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = V5(t), t) {
      const r = de.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Pc(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function i(a) {
      if (a = V5(a), a) {
        const l = de.findKey(r, a);
        l && (!n || Pc(r, r[l], l, n)) && (delete r[l], o = !0);
      }
    }
    return de.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || Pc(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return de.forEach(this, (o, i) => {
      const a = de.findKey(r, i);
      if (a) {
        n[a] = Dl(o), delete n[i];
        return;
      }
      const l = t ? J7e(i) : String(i).trim();
      l !== i && delete n[i], n[l] = Dl(o), r[l] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return de.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && de.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[mx] = this[mx] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(a) {
      const l = V5(a);
      r[l] || (Q7e(o, a), r[l] = !0);
    }
    return de.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
Un.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
de.reduceDescriptors(Un.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
de.freezeMethods(Un);
function Vc(e, t) {
  const n = this || C3, r = t || n, o = Un.from(r.headers);
  let i = r.data;
  return de.forEach(e, function(l) {
    i = l.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function iM(e) {
  return !!(e && e.__CANCEL__);
}
function zs(e, t, n) {
  b1.call(this, e ?? "canceled", b1.ERR_CANCELED, t, n), this.name = "CanceledError";
}
de.inherits(zs, b1, {
  __CANCEL__: !0
});
function aM(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new b1(
    "Request failed with status code " + n.status,
    [b1.ERR_BAD_REQUEST, b1.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function q7e(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function K7e(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const u = Date.now(), f = r[i];
    a || (a = u), n[o] = c, r[o] = u;
    let p = i, h = 0;
    for (; p !== o; )
      h += n[p++], p = p % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), u - a < t)
      return;
    const C = f && u - f;
    return C ? Math.round(h * 1e3 / C) : void 0;
  };
}
function e8e(e, t) {
  let n = 0, r = 1e3 / t, o, i;
  const a = (u, f = Date.now()) => {
    n = f, o = null, i && (clearTimeout(i), i = null), e.apply(null, u);
  };
  return [(...u) => {
    const f = Date.now(), p = f - n;
    p >= r ? a(u, f) : (o = u, i || (i = setTimeout(() => {
      i = null, a(o);
    }, r - p)));
  }, () => o && a(o)];
}
const S9 = (e, t, n = 3) => {
  let r = 0;
  const o = K7e(50, 250);
  return e8e((i) => {
    const a = i.loaded, l = i.lengthComputable ? i.total : void 0, c = a - r, u = o(c), f = a <= l;
    r = a;
    const p = {
      loaded: a,
      total: l,
      progress: l ? a / l : void 0,
      bytes: c,
      rate: u || void 0,
      estimated: u && l && f ? (l - a) / u : void 0,
      event: i,
      lengthComputable: l != null,
      [t ? "download" : "upload"]: !0
    };
    e(p);
  }, n);
}, Cx = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, gx = (e) => (...t) => de.asap(() => e(...t)), t8e = yn.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, yn.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(yn.origin),
  yn.navigator && /(msie|trident)/i.test(yn.navigator.userAgent)
) : () => !0, n8e = yn.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, i) {
      const a = [e + "=" + encodeURIComponent(t)];
      de.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), de.isString(r) && a.push("path=" + r), de.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function r8e(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function o8e(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function sM(e, t) {
  return e && !r8e(t) ? o8e(e, t) : t;
}
const bx = (e) => e instanceof Un ? { ...e } : e;
function t2(e, t) {
  t = t || {};
  const n = {};
  function r(u, f, p, h) {
    return de.isPlainObject(u) && de.isPlainObject(f) ? de.merge.call({ caseless: h }, u, f) : de.isPlainObject(f) ? de.merge({}, f) : de.isArray(f) ? f.slice() : f;
  }
  function o(u, f, p, h) {
    if (de.isUndefined(f)) {
      if (!de.isUndefined(u))
        return r(void 0, u, p, h);
    } else return r(u, f, p, h);
  }
  function i(u, f) {
    if (!de.isUndefined(f))
      return r(void 0, f);
  }
  function a(u, f) {
    if (de.isUndefined(f)) {
      if (!de.isUndefined(u))
        return r(void 0, u);
    } else return r(void 0, f);
  }
  function l(u, f, p) {
    if (p in t)
      return r(u, f);
    if (p in e)
      return r(void 0, u);
  }
  const c = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: l,
    headers: (u, f, p) => o(bx(u), bx(f), p, !0)
  };
  return de.forEach(Object.keys(Object.assign({}, e, t)), function(f) {
    const p = c[f] || o, h = p(e[f], t[f], f);
    de.isUndefined(h) && p !== l || (n[f] = h);
  }), n;
}
const lM = (e) => {
  const t = t2({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: i, headers: a, auth: l } = t;
  t.headers = a = Un.from(a), t.url = nM(sM(t.baseURL, t.url), e.params, e.paramsSerializer), l && a.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  );
  let c;
  if (de.isFormData(n)) {
    if (yn.hasStandardBrowserEnv || yn.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((c = a.getContentType()) !== !1) {
      const [u, ...f] = c ? c.split(";").map((p) => p.trim()).filter(Boolean) : [];
      a.setContentType([u || "multipart/form-data", ...f].join("; "));
    }
  }
  if (yn.hasStandardBrowserEnv && (r && de.isFunction(r) && (r = r(t)), r || r !== !1 && t8e(t.url))) {
    const u = o && i && n8e.read(i);
    u && a.set(o, u);
  }
  return t;
}, i8e = typeof XMLHttpRequest < "u", a8e = i8e && function(e) {
  return new Promise(function(n, r) {
    const o = lM(e);
    let i = o.data;
    const a = Un.from(o.headers).normalize();
    let { responseType: l, onUploadProgress: c, onDownloadProgress: u } = o, f, p, h, C, v;
    function b() {
      C && C(), v && v(), o.cancelToken && o.cancelToken.unsubscribe(f), o.signal && o.signal.removeEventListener("abort", f);
    }
    let y = new XMLHttpRequest();
    y.open(o.method.toUpperCase(), o.url, !0), y.timeout = o.timeout;
    function x() {
      if (!y)
        return;
      const A = Un.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), I = {
        data: !l || l === "text" || l === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: A,
        config: e,
        request: y
      };
      aM(function(k) {
        n(k), b();
      }, function(k) {
        r(k), b();
      }, I), y = null;
    }
    "onloadend" in y ? y.onloadend = x : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(x);
    }, y.onabort = function() {
      y && (r(new b1("Request aborted", b1.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function() {
      r(new b1("Network Error", b1.ERR_NETWORK, e, y)), y = null;
    }, y.ontimeout = function() {
      let L = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const I = o.transitional || rM;
      o.timeoutErrorMessage && (L = o.timeoutErrorMessage), r(new b1(
        L,
        I.clarifyTimeoutError ? b1.ETIMEDOUT : b1.ECONNABORTED,
        e,
        y
      )), y = null;
    }, i === void 0 && a.setContentType(null), "setRequestHeader" in y && de.forEach(a.toJSON(), function(L, I) {
      y.setRequestHeader(I, L);
    }), de.isUndefined(o.withCredentials) || (y.withCredentials = !!o.withCredentials), l && l !== "json" && (y.responseType = o.responseType), u && ([h, v] = S9(u, !0), y.addEventListener("progress", h)), c && y.upload && ([p, C] = S9(c), y.upload.addEventListener("progress", p), y.upload.addEventListener("loadend", C)), (o.cancelToken || o.signal) && (f = (A) => {
      y && (r(!A || A.type ? new zs(null, e, y) : A), y.abort(), y = null);
    }, o.cancelToken && o.cancelToken.subscribe(f), o.signal && (o.signal.aborted ? f() : o.signal.addEventListener("abort", f)));
    const T = q7e(o.url);
    if (T && yn.protocols.indexOf(T) === -1) {
      r(new b1("Unsupported protocol " + T + ":", b1.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(i || null);
  });
}, s8e = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), o;
    const i = function(u) {
      if (!o) {
        o = !0, l();
        const f = u instanceof Error ? u : this.reason;
        r.abort(f instanceof b1 ? f : new zs(f instanceof Error ? f.message : f));
      }
    };
    let a = t && setTimeout(() => {
      a = null, i(new b1(`timeout ${t} of ms exceeded`, b1.ETIMEDOUT));
    }, t);
    const l = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", i));
    const { signal: c } = r;
    return c.unsubscribe = () => de.asap(l), c;
  }
}, l8e = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + t, yield e.slice(r, o), r = o;
}, c8e = async function* (e, t) {
  for await (const n of u8e(e))
    yield* l8e(n, t);
}, u8e = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, vx = (e, t, n, r) => {
  const o = c8e(e, t);
  let i = 0, a, l = (c) => {
    a || (a = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: f } = await o.next();
        if (u) {
          l(), c.close();
          return;
        }
        let p = f.byteLength;
        if (n) {
          let h = i += p;
          n(h);
        }
        c.enqueue(new Uint8Array(f));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(c) {
      return l(c), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, p6 = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", cM = p6 && typeof ReadableStream == "function", d8e = p6 && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), uM = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, f8e = cM && uM(() => {
  let e = !1;
  const t = new Request(yn.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), yx = 64 * 1024, Id = cM && uM(() => de.isReadableStream(new Response("").body)), T9 = {
  stream: Id && ((e) => e.body)
};
p6 && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !T9[t] && (T9[t] = de.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new b1(`Response type '${t}' is not supported`, b1.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const p8e = async (e) => {
  if (e == null)
    return 0;
  if (de.isBlob(e))
    return e.size;
  if (de.isSpecCompliantForm(e))
    return (await new Request(yn.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (de.isArrayBufferView(e) || de.isArrayBuffer(e))
    return e.byteLength;
  if (de.isURLSearchParams(e) && (e = e + ""), de.isString(e))
    return (await d8e(e)).byteLength;
}, h8e = async (e, t) => {
  const n = de.toFiniteNumber(e.getContentLength());
  return n ?? p8e(t);
}, m8e = p6 && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: o,
    cancelToken: i,
    timeout: a,
    onDownloadProgress: l,
    onUploadProgress: c,
    responseType: u,
    headers: f,
    withCredentials: p = "same-origin",
    fetchOptions: h
  } = lM(e);
  u = u ? (u + "").toLowerCase() : "text";
  let C = s8e([o, i && i.toAbortSignal()], a), v;
  const b = C && C.unsubscribe && (() => {
    C.unsubscribe();
  });
  let y;
  try {
    if (c && f8e && n !== "get" && n !== "head" && (y = await h8e(f, r)) !== 0) {
      let I = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), M;
      if (de.isFormData(r) && (M = I.headers.get("content-type")) && f.setContentType(M), I.body) {
        const [k, _] = Cx(
          y,
          S9(gx(c))
        );
        r = vx(I.body, yx, k, _);
      }
    }
    de.isString(p) || (p = p ? "include" : "omit");
    const x = "credentials" in Request.prototype;
    v = new Request(t, {
      ...h,
      signal: C,
      method: n.toUpperCase(),
      headers: f.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: x ? p : void 0
    });
    let T = await fetch(v);
    const A = Id && (u === "stream" || u === "response");
    if (Id && (l || A && b)) {
      const I = {};
      ["status", "statusText", "headers"].forEach((F) => {
        I[F] = T[F];
      });
      const M = de.toFiniteNumber(T.headers.get("content-length")), [k, _] = l && Cx(
        M,
        S9(gx(l), !0)
      ) || [];
      T = new Response(
        vx(T.body, yx, k, () => {
          _ && _(), b && b();
        }),
        I
      );
    }
    u = u || "text";
    let L = await T9[de.findKey(T9, u) || "text"](T, e);
    return !A && b && b(), await new Promise((I, M) => {
      aM(I, M, {
        data: L,
        headers: Un.from(T.headers),
        status: T.status,
        statusText: T.statusText,
        config: e,
        request: v
      });
    });
  } catch (x) {
    throw b && b(), x && x.name === "TypeError" && /fetch/i.test(x.message) ? Object.assign(
      new b1("Network Error", b1.ERR_NETWORK, e, v),
      {
        cause: x.cause || x
      }
    ) : b1.from(x, x && x.code, e, v);
  }
}), Ld = {
  http: B7e,
  xhr: a8e,
  fetch: m8e
};
de.forEach(Ld, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const xx = (e) => `- ${e}`, C8e = (e) => de.isFunction(e) || e === null || e === !1, dM = {
  getAdapter: (e) => {
    e = de.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let a;
      if (r = n, !C8e(n) && (r = Ld[(a = String(n)).toLowerCase()], r === void 0))
        throw new b1(`Unknown adapter '${a}'`);
      if (r)
        break;
      o[a || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(o).map(
        ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? i.length > 1 ? `since :
` + i.map(xx).join(`
`) : " " + xx(i[0]) : "as no adapter specified";
      throw new b1(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Ld
};
function Hc(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new zs(null, e);
}
function wx(e) {
  return Hc(e), e.headers = Un.from(e.headers), e.data = Vc.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), dM.getAdapter(e.adapter || C3.adapter)(e).then(function(r) {
    return Hc(e), r.data = Vc.call(
      e,
      e.transformResponse,
      r
    ), r.headers = Un.from(r.headers), r;
  }, function(r) {
    return iM(r) || (Hc(e), r && r.response && (r.response.data = Vc.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = Un.from(r.response.headers))), Promise.reject(r);
  });
}
const fM = "1.7.9", h6 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  h6[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Sx = {};
h6.transitional = function(t, n, r) {
  function o(i, a) {
    return "[Axios v" + fM + "] Transitional option '" + i + "'" + a + (r ? ". " + r : "");
  }
  return (i, a, l) => {
    if (t === !1)
      throw new b1(
        o(a, " has been removed" + (n ? " in " + n : "")),
        b1.ERR_DEPRECATED
      );
    return n && !Sx[a] && (Sx[a] = !0, console.warn(
      o(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, a, l) : !0;
  };
};
h6.spelling = function(t) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function g8e(e, t, n) {
  if (typeof e != "object")
    throw new b1("options must be an object", b1.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], a = t[i];
    if (a) {
      const l = e[i], c = l === void 0 || a(l, i, e);
      if (c !== !0)
        throw new b1("option " + i + " must be " + c, b1.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new b1("Unknown option " + i, b1.ERR_BAD_OPTION);
  }
}
const Zl = {
  assertOptions: g8e,
  validators: h6
}, po = Zl.validators;
class Ua {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new hx(),
      response: new hx()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = t2(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: i } = n;
    r !== void 0 && Zl.assertOptions(r, {
      silentJSONParsing: po.transitional(po.boolean),
      forcedJSONParsing: po.transitional(po.boolean),
      clarifyTimeoutError: po.transitional(po.boolean)
    }, !1), o != null && (de.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : Zl.assertOptions(o, {
      encode: po.function,
      serialize: po.function
    }, !0)), Zl.assertOptions(n, {
      baseUrl: po.spelling("baseURL"),
      withXsrfToken: po.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = i && de.merge(
      i.common,
      i[n.method]
    );
    i && de.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (v) => {
        delete i[v];
      }
    ), n.headers = Un.concat(a, i);
    const l = [];
    let c = !0;
    this.interceptors.request.forEach(function(b) {
      typeof b.runWhen == "function" && b.runWhen(n) === !1 || (c = c && b.synchronous, l.unshift(b.fulfilled, b.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(b) {
      u.push(b.fulfilled, b.rejected);
    });
    let f, p = 0, h;
    if (!c) {
      const v = [wx.bind(this), void 0];
      for (v.unshift.apply(v, l), v.push.apply(v, u), h = v.length, f = Promise.resolve(n); p < h; )
        f = f.then(v[p++], v[p++]);
      return f;
    }
    h = l.length;
    let C = n;
    for (p = 0; p < h; ) {
      const v = l[p++], b = l[p++];
      try {
        C = v(C);
      } catch (y) {
        b.call(this, y);
        break;
      }
    }
    try {
      f = wx.call(this, C);
    } catch (v) {
      return Promise.reject(v);
    }
    for (p = 0, h = u.length; p < h; )
      f = f.then(u[p++], u[p++]);
    return f;
  }
  getUri(t) {
    t = t2(this.defaults, t);
    const n = sM(t.baseURL, t.url);
    return nM(n, t.params, t.paramsSerializer);
  }
}
de.forEach(["delete", "get", "head", "options"], function(t) {
  Ua.prototype[t] = function(n, r) {
    return this.request(t2(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
de.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, a, l) {
      return this.request(t2(l || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  Ua.prototype[t] = n(), Ua.prototype[t + "Form"] = n(!0);
});
class ih {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const a = new Promise((l) => {
        r.subscribe(l), i = l;
      }).then(o);
      return a.cancel = function() {
        r.unsubscribe(i);
      }, a;
    }, t(function(i, a, l) {
      r.reason || (r.reason = new zs(i, a, l), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new ih(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
function b8e(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function v8e(e) {
  return de.isObject(e) && e.isAxiosError === !0;
}
const Ed = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Ed).forEach(([e, t]) => {
  Ed[t] = e;
});
function pM(e) {
  const t = new Ua(e), n = WE(Ua.prototype.request, t);
  return de.extend(n, Ua.prototype, t, { allOwnKeys: !0 }), de.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return pM(t2(e, o));
  }, n;
}
const Rt = pM(C3);
Rt.Axios = Ua;
Rt.CanceledError = zs;
Rt.CancelToken = ih;
Rt.isCancel = iM;
Rt.VERSION = fM;
Rt.toFormData = f6;
Rt.AxiosError = b1;
Rt.Cancel = Rt.CanceledError;
Rt.all = function(t) {
  return Promise.all(t);
};
Rt.spread = b8e;
Rt.isAxiosError = v8e;
Rt.mergeConfig = t2;
Rt.AxiosHeaders = Un;
Rt.formToJSON = (e) => oM(de.isHTMLForm(e) ? new FormData(e) : e);
Rt.getAdapter = dM.getAdapter;
Rt.HttpStatusCode = Ed;
Rt.default = Rt;
const Gs = [
  {
    inputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "address", name: "from", type: "address" },
      { indexed: !0, internalType: "address", name: "to", type: "address" },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    constant: !0,
    inputs: [],
    name: "_decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "_name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "_symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "burn",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "decimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "subtractedValue", type: "uint256" }
    ],
    name: "decreaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "getOwner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "addedValue", type: "uint256" }
    ],
    name: "increaseAllowance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "mint",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      { internalType: "address", name: "sender", type: "address" },
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !1,
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  }
];
async function hM({
  chainType: e,
  tokens: t,
  chainConfig: n,
  evmParams: r,
  solanaParams: o,
  tronParams: i
}) {
  const a = t?.filter((l) => l.isCompatible);
  return e === "solana" ? await w8e({
    account: o.account,
    tokens: a,
    connection: o.connection
  }) : e === "tron" ? await x8e({
    account: i.account,
    tokens: a,
    tronWeb: i.tronWeb
  }) : await y8e({
    account: r.account,
    chain: r.chain,
    tokens: a,
    chainConfig: n
  });
}
async function y8e({
  account: e,
  chain: t,
  tokens: n,
  chainConfig: r
}) {
  try {
    if (!t || !e || !n?.length)
      return {};
    const o = r?.rpcUrls?.default.http?.[0], i = fH({
      chain: t,
      transport: pH(o)
    }), a = n.map((f) => ({
      abi: Gs,
      address: f.address,
      functionName: "balanceOf",
      args: [e]
    })), [l, c] = await Promise.allSettled([
      i.multicall({
        allowFailure: !0,
        contracts: a
      }),
      i.getBalance({
        address: e
      })
    ]), u = {};
    return l.status === "fulfilled" && (l.value?.map((p) => p.result) ?? []).map((p, h) => {
      const C = n[h], v = C.address?.toLowerCase();
      u[v] = typeof p > "u" ? void 0 : x1(BigInt(p), C.decimals);
    }), c.status === "fulfilled" && (u[G6e] = x1(
      BigInt(c.value),
      t.nativeCurrency.decimals
    )), u;
  } catch (o) {
    return console.log("[getEvmTokenBalances] error:", o), {};
  }
}
async function x8e({
  account: e,
  tokens: t,
  tronWeb: n
}) {
  try {
    if (!e || !t?.length || !n)
      return {};
    const r = {}, i = n.fullNode.host.includes("nile") ? "https://nileapi.tronscan.org/api" : "https://apilist.tronscan.org/api";
    return ((await Rt({
      url: `${i}/account/tokens`,
      params: {
        address: e,
        start: 0,
        limit: 50
      }
    })).data?.data ?? []).forEach((c) => {
      const u = t.find(
        (f) => ja(f.address, c.tokenId) || f.displaySymbol.toUpperCase() === "TRX" && c.tokenId === "_"
      );
      u && (r[u.address?.toLowerCase()] = x1(
        BigInt(c.balance),
        u.decimals
      ));
    }), t.forEach((c) => {
      const u = c.address.toLowerCase();
      r[u] = r[u] ?? "0";
    }), r;
  } catch (r) {
    return console.log("[getTronTokenBalances] error:", r), {};
  }
}
async function w8e({
  account: e,
  tokens: t,
  connection: n
}) {
  try {
    if (!e || !t?.length || !n)
      return {};
    const [r, o] = await Promise.allSettled([
      n.getTokenAccountsByOwner(new Uc(e), {
        programId: vH
      }),
      n.getBalance(new Uc(e))
    ]), i = {};
    return r.status === "fulfilled" && r.value?.value?.forEach((a) => {
      const l = bH.AccountLayout.decode(a.account.data), c = t.find((u) => ja(u.address, l.mint.toBase58()));
      c && (i[c.address?.toLowerCase()] = x1(l.amount, c.decimals));
    }), o.status === "fulfilled" && (i[W6e] = String(o.value / pw)), t.forEach((a) => {
      const l = a.address?.toLowerCase();
      i[l] = i[l] ?? "0";
    }), i;
  } catch (r) {
    return console.log("[getTronTokenBalances] error:", r), {};
  }
}
function g3() {
  const e = Lt();
  return we(() => {
    const n = e.transfer.chainConfigs.find((r) => r.chainType === "tron");
    if (n)
      return new CH({
        fullHost: n.rpcUrls.default.http?.[0]
      });
  }, [e.transfer.chainConfigs]);
}
function Ho() {
  const { connected: e, publicKey: t } = $d(), r = Lt().transfer.chainConfigs.find((o) => o.chainType === "solana");
  return {
    publicKey: t,
    address: t?.toBase58(),
    isConnected: e,
    chainId: e ? r?.id : void 0
  };
}
const mM = w.createContext({});
function S8e(e) {
  const { children: t } = e, { address: n, connected: r, wallet: o } = r2(), [i, a] = ze();
  Oe(() => {
    const c = o?.adapter;
    if (!c) return;
    const u = (p) => {
      const h = Number(p.chainId);
      a(h);
    };
    return r ? (async () => {
      const p = await c.network?.();
      u(p);
    })() : a(void 0), c.on("chainChanged", u), () => {
      c.off("chainChanged", u);
    };
  }, [r, o?.adapter]);
  const l = we(() => ({
    address: n || void 0,
    isConnected: r,
    chainId: i || qV
  }), [n, i, r]);
  return /* @__PURE__ */ g(mM.Provider, { value: l, children: t });
}
function hr() {
  return N1(mM);
}
function T8e() {
  const e = Lt(), { address: t } = lt(), { address: n } = Ho(), { address: r } = hr(), o = dw(), { connection: i } = U0(), a = g3(), l = N((C) => C.transfer.fromChain), c = N((C) => C.transfer.toChain), u = D1(), f = GE(), { isLoading: p, data: h } = gi({
    enabled: !!l?.id && !!c?.id,
    refetchInterval: l6,
    queryKey: ["tokenBalances", l?.id, c?.id, t, n, r],
    queryFn: async () => {
      const C = e.transfer.chainConfigs?.find(
        (b) => b.id === l?.id
      );
      return await hM({
        chainType: l?.chainType,
        tokens: f,
        chainConfig: C,
        evmParams: {
          account: t,
          chain: o?.find((b) => b.id === l?.id)
        },
        solanaParams: {
          account: n,
          connection: i
        },
        tronParams: {
          account: r,
          tronWeb: a
        }
      });
    }
  });
  return Oe(() => {
    u(VE(h)), u(OE(p));
  }, [h, u, p]), null;
}
function ah() {
  const e = N((n) => n.aggregator.tokenBalances);
  return {
    getTokenBalance: se(
      (n = {}) => {
        const r = n.address ?? n.address;
        if (r)
          return e[r.toLowerCase()];
      },
      [e]
    )
  };
}
function A8e() {
  const e = D1(), { fetchApiTokenPrices: t } = Ws(), { isLoading: n, data: r } = gi({
    staleTime: P0.MINUTE * 5,
    refetchInterval: P0.MINUTE * 5,
    queryKey: ["tokenPrices"],
    queryFn: async () => t()
  });
  return Oe(() => {
    e(PE(r)), e(HE(n));
  }, [r, e, n]), null;
}
function Ws() {
  const e = N((a) => a.aggregator.tokenPrices), t = Lt(), { serverEndpoint: n } = t.http, r = se(
    ({
      chainId: a,
      chainType: l,
      tokenAddress: c,
      tokenSymbol: u
    } = {}) => {
      if (a && l && c) {
        const { cmcPrices: f, llamaPrices: p } = e;
        let h = "";
        di(c, l) ? h = `${a}` : l === "evm" ? h = `${a}:${c.toLowerCase()}` : h = `${a}:${c}`;
        const v = `1:${u?.toLowerCase()}`;
        let b = f[h]?.price ?? p[h]?.price ?? f[v]?.price ?? p[v]?.price;
        return b !== void 0 && (b = Number(b)), b;
      }
    },
    [e]
  ), o = se(async () => {
    const [a, l] = await Promise.allSettled([
      Rt.get(`${n}/api/token/v2/cmc`),
      Rt.get(`${n}/api/token/v2/llama`)
    ]), c = a.status === "fulfilled" ? a.value.data.data : {}, u = l.status === "fulfilled" ? l.value.data.data : {};
    return {
      cmcPrices: c,
      llamaPrices: u
    };
  }, [n]), i = se(
    async ({
      chainId: a,
      chainType: l,
      tokenAddress: c,
      tokenSymbol: u
    }) => {
      const { data: f } = await Rt.get(`${n}/api/token/v2/price`, {
        params: {
          chainId: a,
          tokenAddress: di(c, l) ? void 0 : c,
          tokenSymbol: u
        }
      });
      return f;
    },
    [n]
  );
  return {
    getTokenPrice: r,
    fetchTokenPrice: i,
    fetchApiTokenPrices: o
  };
}
function qt({ id: e, params: t }) {
  typeof window > "u" || !window.dataLayer || window.dataLayer.push({
    event: e,
    ...t
  });
}
const CM = (e) => {
  const { formatMessage: t } = n1(), { colorMode: n } = Ee(), r = Xe(), o = N((a) => a.transfer.fromChain), { onClickConnectWalletButton: i } = Lt();
  return /* @__PURE__ */ g(
    Hr,
    {
      className: "bccb-widget-wallet-connect-button",
      size: "lg",
      h: "56px",
      w: "100%",
      onClick: () => {
        i?.({ chainType: o.chainType, chainId: o.id }), qt({
          id: "click_bridge_goal",
          params: {
            item_name: "Connect Wallet"
          }
        });
      },
      color: r.colors[n].button.wallet.text,
      background: r.colors[n].button.wallet.background.default,
      _hover: {
        background: r.colors[n].button.wallet.background.hover
      },
      ...e,
      children: /* @__PURE__ */ g("span", { children: t({ id: "transfer.button.wallet-connect" }) })
    }
  );
}, gM = w.createContext({});
function I8e(e) {
  const { children: t } = e, n = N((a) => a.transfer.isGlobalFeeLoading) ?? !1, r = N((a) => a.transfer.isRefreshing) ?? !1, o = Lt(), i = we(() => ({
    config: o,
    isGlobalFeeLoading: n,
    isRefreshing: r
  }), [o, n, r]);
  return /* @__PURE__ */ g(gM.Provider, { value: i, children: t });
}
function gfe() {
  return N1(gM);
}
const Md = {
  language: "en",
  messages: {
    "seo.title": "BNB Chain Bridge | Cross-Chain Transfer",
    "seo.description": "Bridge and transfer your assets between networks (Ethereum, Polygon and etc.) and BNB Chain blockchain ecosystem.",
    "header.network-status.wrong": "Wrong network",
    "support.stargate.soon": "We will support Stargate soon",
    "route.title": "Select Bridge Routes",
    "from.section.title": "From",
    "from.section.balance.title": "Balance:",
    "from.section.balance.button.max": "Max:",
    "to.section.title": "To",
    "to.section.estimated-amount": "Est. Amount Receive",
    "to.section.account.label": "Destination Address",
    "to.section.account.placeholder": "Enter {network} Address",
    "to.section.account.invalid": "Invalid address.",
    "to.section.confirm.text": "I confirmed the address is correct and not an exchange or contract address. Any tokens sent to an incorrect address will be unrecoverable.",
    "you.send.title": "You Send",
    "you.receive.title": "You Receive",
    "select.received-token.title": "Select Received Token",
    "route.button.change-routes": "Change Routes",
    "route.title.select.routes": "Select Bridge Routes",
    "route.fees.title": "Fees:",
    "route.time.title": "Time:",
    "route.allowed-send-amount": "The amount you send must be greater than {min} and less than {max} {symbol}",
    "route.token-address.tips": "Please double check the received token address before making the transaction.",
    "route.no-found.title": "No Available Routes",
    "route.no-found.desc": "Low liquidity, small input, or incompatible network/token. Adjust and retry.",
    "route.adjust.title": "Adjust Send Amount",
    "route.adjust.desc": "The current bridge routes have limitations on the send amount. Please adjust and try again.",
    "route.adjust.link": "See Route Limitations",
    "route.option.cBridge.title": "cBridge",
    "route.option.deBridge.title": "deBridge",
    "route.option.stargate.title": "Stargate",
    "route.option.layerZero.title": "LayerZero",
    "route.option.meson.title": "Meson",
    "route.option.tag.best-time": "Fastest",
    "route.option.tag.highest-amount": "Best Return",
    "route.option.info.estimated-time": "Est. Time:",
    "route.option.info.gas-fee": "Gas Fee:",
    "route.option.info.native-fee": "Native Fee:",
    "route.option.info.debridge-fee": "deBridge Fee:",
    "route.option.info.market-maker-fee": "Market Maker Gas Costs:",
    "route.option.info.base-fee": "Base Fee:",
    "route.option.info.lp-fee": "Liquidity Providers:",
    "route.option.info.service-fee": "Service Fee:",
    "route.option.info.protocol-fee": "Protocol Fee:",
    "route.error.amount.max": "Your send amount must be less than {max}",
    "route.error.amount.min": "Your send amount must be greater than {min}",
    "route.error.amount.digits": "The send amount must be less than 6 digits",
    "transfer.button.confirm": "Send",
    "transfer.button.approve": "Approve",
    "transfer.button.switch-network": "Switch Network in Wallet",
    "transfer.button.wallet-connect": "Connect Wallet",
    "transfer.button.switch-wallet": "Switch Wallet",
    "transfer.button.confirm-summary": "Confirm Transfer",
    "transfer.button.confirm-loading": "Reloading Quotation",
    "transfer.warning.confirm.to.address": "Please double check the received token address:",
    "transfer.warning.confirm.to.native.token.address": "Please double check the token received is native token:",
    "transfer.warning.sol.balance": "At least {min} SOL is required to proceed with this transaction.",
    "modal.approve.title": "Approve Token",
    "modal.approve.desc.1": "Please approve at least ",
    "modal.approve.desc.2": " and initiate the transfer",
    "modal.approve.button.confirm": "Approve",
    "modal.approve.button.close": "Deny",
    "modal.fail.title": "Transaction Failed",
    "modal.fail.desc": `Your transaction failed to submit.
Please try again.`,
    "modal.fail.button.close": "Try Again",
    "modal.submit.title": "Transaction Submitted",
    "modal.submit.desc": "Your on-chain transaction has been submitted successfully",
    "modal.submit.button.view-tx": "View Transaction",
    "modal.submit.button.close": "Make Another Transaction",
    "modal.confirm.title": "Waiting for Confirmation",
    "modal.confirm.desc": "Confirm this transaction in your wallet",
    "modal.summary.title": "Confirm Transaction",
    "modal.quote.error.title": "Failed to Get the Quotation",
    "modal.quote.error.desc": "We’ve encountered an unknown issue on this route. Please try again later.",
    "modal.quote.error.button.close": "OK",
    "modal.fee-timeout.error.title": "Failed to Find the Route!",
    "modal.fee-timeout.error.desc": "We’ve encountered an unknown issue. Please try again later.",
    "modal.fee-timeout.error.button.close": "OK",
    "select-modal.tag.incompatible": "Incompatible",
    "select-modal.search.no-result.title": "No result found",
    "select-modal.search.no-result.warning": "Try adjusting your search request to find what you’re looking for",
    "select-modal.token.title": "Choose Token",
    "select-modal.token.placeholder": "Search token by name or address",
    "select-modal.token.column.name": "Name",
    "select-modal.token.column.balance": "Wallet Balance",
    "select-modal.token.incompatible.tooltip": "This token is incompatible by the source or destination network you’ve selected. Please change the network settings",
    "select-modal.source.title": "Source Network",
    "select-modal.source.placeholder": "Search network by name",
    "select-modal.destination.title": "Destination Network",
    "select-modal.destination.placeholder": "Search network by name",
    "select-modal.destination.incompatible.tooltip": "The token you’ve selected is incompatible with this network. Please select another token.",
    "wallet.network.switch-network": "Please switch the network",
    "wallet.network.connect-wallet": "Please connect the wallet",
    "wallet.network.unknown-network": "Unsupported Network",
    "wallet.network.unknown-network-mobile": "Network",
    "wallet.button.connect-wallet": "Connect Wallet",
    "wallet.network.wrong-network": "Wrong network",
    "wallet.error.switch-network": "An error occurred when attempting to switch the network. Please select another network or try again.",
    "wallet.switching-modal.title": "Switch Network in Wallet",
    "wallet.switching-modal.desc": "Please go to the settings page and switch the network to TRON Mainnet"
  }
}, bM = {
  primitives: {
    logo: "#F0B90B",
    white: "#FFFFFF",
    black: "#000000"
  },
  input: {
    1: "#373943",
    background: "#1E2026",
    title: "#8C8F9B",
    border: {
      default: "#373943",
      hover: "#5C5F6A",
      active: "#FFE900"
    }
  },
  text: {
    primary: "#FFFFFF",
    secondary: "#C4C5CB",
    tertiary: "#8C8F9B",
    placeholder: "#8C8F9B",
    inverse: "#181A1E",
    disabled: De("#F7F7F8", 0.45),
    brand: "#FFE900",
    warning: "#FFEADB",
    danger: "#F8545F",
    route: { title: "#8C8F9B" },
    network: {
      title: "#8C8F9B"
    },
    on: {
      color: {
        primary: "#181A1E",
        disabled: De("#181A1E", 0.45)
      }
    }
  },
  button: {
    wallet: {
      text: "#181A1E",
      background: { default: "#FFE900", hover: "#EBD600" }
    },
    refresh: {
      text: "#665800"
    },
    select: {
      text: "#FFFFFF",
      arrow: "#C4C5CB",
      border: "#373943",
      background: { default: "#1E2026", hover: "#373943" }
    },
    primary: {
      default: "#F7F7F8",
      subtle: "#5C5F6A",
      hover: "#E1E2E5",
      active: "#FFFFFF"
    },
    brand: {
      default: "#FFE900",
      subtle: De("#665800", 0.25),
      hover: "#EBD600",
      active: "#FFF15C"
    },
    success: {
      default: "#18DC7E",
      subtle: De("#143D29", 0.5),
      hover: "#15C16E",
      active: "#53EAA1"
    },
    danger: {
      default: "#F8545F",
      subtle: De("#541C20", 0.45),
      hover: "#EF2A37",
      active: "#FF7A84"
    },
    exchange: {
      default: "#373943",
      hover: "#E1E2E5"
    },
    disabled: De("#F7F7F8", 0.45)
  },
  modal: {
    title: "#C4C5CB",
    item: {
      text: { primary: "#FFFFFF", secondary: "#C4C5CB" },
      background: { default: "#1E2026", hover: "#373943" }
    },
    back: {
      default: "#8C8F9B",
      hover: "#FFFFFF"
    },
    close: {
      default: "#8C8F9B",
      hover: "#FFFFFF"
    }
  },
  background: {
    1: "#181A1E",
    2: "#1E2026",
    3: "#14151A",
    brand: "#FFE900",
    modal: "#1E2026",
    main: "#181A1E",
    route: "#1E2026",
    warning: "#5C2600",
    tag: "#373943",
    body: "#14151A"
  },
  receive: {
    background: "#373943"
  },
  border: {
    1: "#181A1E",
    2: "#1E2026",
    3: "#373943",
    4: "#5C5F6A",
    inverse: "#FFFFFF",
    brand: "#FFE900",
    disabled: De("#5C5F6A", 0.45)
  },
  route: {
    background: { highlight: "rgba(255, 233, 0, 0.06)" },
    border: "#373943"
  },
  layer: {
    1: {
      default: "#14151A",
      hover: "#181A1E",
      active: "#1E2026"
    },
    2: {
      default: "#181A1E",
      hover: "#1E2026",
      active: "#373943"
    },
    3: {
      default: "#1E2026",
      hover: "#373943",
      active: "#5C5F6A"
    },
    4: {
      default: "#373943",
      hover: "#5C5F6A",
      active: "#8C8F9B"
    },
    inverse: "#F7F7F8",
    disabled: De("#F7F7F8", 0.2)
  },
  support: {
    success: {
      1: "#BFF8DC",
      2: "#53EAA1",
      3: "#18DC7E",
      4: "#12A55E",
      5: "#115F39"
    },
    warning: {
      1: "#FFEADB",
      2: "#FFA260",
      3: "#FF8A38",
      4: "#BC4E00",
      5: "#5C2600"
    },
    danger: {
      3: "#F8545F"
    },
    brand: {
      1: "#FFFAC2",
      2: "#FFF15C",
      3: "#FFE900",
      4: "#948700",
      5: "#665800"
    },
    primary: {
      1: "#E1E2E5",
      2: "#C4C5CB",
      3: "#8C8F9B",
      4: "#5C5F6A",
      5: "#373943"
    }
  },
  shadow: {
    1: `0px 4px 8px ${De("#000000", 0.16)}`,
    2: `0px 4px 8px ${De("#000000", 0.24)}`,
    3: `0px 8px 16px ${De("#000000", 0.24)}`,
    4: `0px 4px 8px ${De("#000000", 0.16)},0px 16px 48px ${De("#000000", 0.48)}`,
    5: `0px 4px 8px ${De("#000000", 0.16)},0px 24px 64px ${De("#000000", 0.56)}`
  },
  gradient: {
    1: "linear-gradient(180deg, #14151A 0%, #000000 100%)"
  },
  overlay: De("#14151A", 0.6),
  popover: {
    background: "#373943",
    selected: "#5C5F6A",
    shadow: " 0px 4px 8px 0px rgba(0, 0, 0, 0.48)",
    separator: "#5C5F6A"
  }
}, L8e = {
  primitives: {
    logo: "#F0B90B",
    white: "#FFFFFF",
    black: "#000000"
  },
  input: {
    1: "#F7F7F8",
    background: "#FFFFFF",
    title: "#8C8F9B",
    border: {
      default: "#E1E2E5",
      hover: "#E1E2E5",
      active: "#FFE900"
    }
  },
  text: {
    primary: "#181A1E",
    secondary: "#5C5F6A",
    tertiary: "#5C5F6A",
    placeholder: "#8C8F9B",
    inverse: "#FFFFFF",
    disabled: De("#181A1E", 0.3),
    brand: "#181A1E",
    warning: "#BC4E00",
    danger: "#EF2A37",
    route: { title: "#5C5F6A" },
    network: {
      title: "#8C8F9B"
    },
    on: {
      color: {
        primary: "#FFFFFF",
        disabled: De("#FFFFFF", 0.4)
      }
    }
  },
  button: {
    wallet: {
      text: "#181A1E",
      background: { default: "#FFE900", hover: "#E1E2E5" }
    },
    refresh: {
      text: "#FFFAC2"
    },
    select: {
      text: "#FFFFFF",
      arrow: "#C4C5CB",
      border: "#373943",
      background: { default: "#1E2026", hover: "#373943" }
    },
    primary: {
      default: "#181A1E",
      subtle: "#E1E2E5",
      hover: "#1E2026",
      active: "#373943"
    },
    brand: {
      default: "#C2B100",
      subtle: "#FFFAC2",
      hover: "#948700",
      active: "#857900"
    },
    success: {
      default: "#12A55E",
      subtle: "#BFF8DC",
      hover: "#0E8149",
      active: "#115F39"
    },
    danger: {
      default: "#D31724",
      subtle: "#FDE2E4",
      hover: "#A91E27",
      active: "#821119"
    },
    exchange: {
      default: "#F7F7F8",
      hover: "#373943"
    },
    disabled: De("#181A1E", 0.4)
  },
  receive: {
    background: "#373943"
  },
  route: {
    background: { highlight: "rgba(255, 233, 0, 0.06)" },
    border: "#373943"
  },
  modal: {
    title: "#5C5F6A",
    item: {
      text: { primary: "#181A1E", secondary: "#5C5F6A" },
      background: { default: "#F7F7F8", hover: "#F7F7F8" }
    },
    back: {
      default: "#8C8F9B",
      hover: "#181A1E"
    },
    close: {
      default: "#8C8F9B",
      hover: "#181A1E"
    }
  },
  background: {
    1: "#FFFFFF",
    2: "#F7F7F8",
    3: "#F1F2F3",
    brand: "#FFE900",
    modal: "#F7F7F8",
    main: "#FFFFFF",
    route: "#F7F7F8",
    warning: "#FFEADB",
    tag: "#E1E2E5",
    body: "#F1F2F3"
  },
  border: {
    1: "#F7F7F8",
    2: "#F1F2F3",
    3: "#E1E2E5",
    4: "#E1E2E5",
    inverse: "#181A1E",
    brand: "#EBD600",
    disabled: "#C4C5CB"
  },
  layer: {
    1: {
      default: "#FFFFFF",
      hover: "#E1E2E5",
      active: "#C4C5CB"
    },
    2: {
      default: "#F1F2F3",
      hover: "#E1E2E5",
      active: "#C4C5CB"
    },
    3: {
      default: "#FFFFFF",
      hover: "#E1E2E5",
      active: "#C4C5CB"
    },
    4: {
      default: "#F1F2F3",
      hover: "#E1E2E5",
      active: "#C4C5CB"
    },
    inverse: "#181A1E",
    disabled: De("#181A1E", 0.15)
  },
  support: {
    success: {
      1: "#115F39",
      2: "#0E8149",
      3: "#15C16E",
      4: "#53EAA1",
      5: "#BFF8DC"
    },
    warning: {
      1: "#5C2600",
      2: "#933D00",
      3: "#E55F00",
      4: "#FFA260",
      5: "#FFEADB"
    },
    danger: {
      // 1: '#821119',
      // 2: '#A91E27',
      3: "#EF2A37"
      // 4: '#FF7A84',
      // 5: '#FDC4C7',
    },
    brand: {
      1: "#665800",
      2: "#948700",
      3: "#EBD600",
      4: "#FFE900",
      5: "#FFFAC2"
    },
    primary: {
      1: "#373943",
      2: "#5C5F6A",
      3: "#8C8F9B",
      4: "#C4C5CB",
      5: "#E1E2E5"
    }
  },
  shadow: {
    1: `0 4px 8px ${De("#000000", 0.16)}`,
    2: `0 4px 8px ${De("#000000", 0.24)}`,
    3: `0 8px 16px ${De("#000000", 0.24)}`,
    4: `0 4px 8px ${De("#000000", 0.16)}, 0 16px 48px ${De("#000000", 0.24)}`,
    5: `0 4px 8px ${De("#000000", 0.16)}, 0 24px 64px ${De("#000000", 0.48)}`
  },
  gradient: {
    ...bM.gradient
  },
  overlay: De("#14151A", 0.2),
  popover: {
    background: "#F7F7F8",
    selected: "#E1E2E5",
    shadow: " 0px 4px 8px 0px rgba(0, 0, 0, 0.48)",
    separator: "#E1E2E5"
  }
};
function bfe(e) {
  const { config: t, children: n } = e, {
    bridgeTitle: r,
    assetPrefix: o,
    locale: i,
    theme: a,
    http: l,
    components: c,
    transfer: u,
    onClickConnectWalletButton: f,
    onError: p
  } = t ?? {}, h = we(() => ({
    bridgeTitle: r ?? "BNB Chain Cross-Chain Bridge",
    assetPrefix: o ?? "https://static.bnbchain.org/bnb-chain-bridge/static",
    locale: {
      language: i?.language ?? Md.language,
      messages: {
        ...Md.messages,
        ...i?.messages
      }
    },
    theme: {
      colorMode: a?.colorMode ?? "dark",
      breakpoints: II,
      colors: {
        dark: ax.merge(bM, a?.colors?.dark),
        light: ax.merge(L8e, a?.colors?.light)
      }
    },
    http: {
      refetchingInterval: 3e4,
      apiTimeOut: 6e4,
      mesonEndpoint: "https://relayer.meson.fi/api/v1",
      ...l
    },
    components: {
      connectWalletButton: /* @__PURE__ */ g(CM, {}),
      ...c
    },
    transfer: {
      defaultFromChainId: 1,
      defaultToChainId: 56,
      defaultTokenAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
      defaultAmount: "",
      displayTokenSymbols: {},
      brandChains: [],
      externalChains: [],
      dollarUpperLimit: 2e5,
      chainOrders: [],
      tokenOrders: [],
      chainSorter(v, b) {
        if (v.isCompatible && !b.isCompatible)
          return -1;
        if (!v.isCompatible && b.isCompatible)
          return 1;
        const y = u?.chainOrders?.indexOf(v.id) ?? -1, x = u?.chainOrders?.indexOf(b.id) ?? -1;
        return y > -1 && x === -1 ? -1 : y === -1 && x > -1 ? 1 : y > -1 && x > -1 ? y - x : v.name < b.name ? -1 : 1;
      },
      tokenSorter(v, b) {
        if (v.isCompatible && !b.isCompatible)
          return -1;
        if (!v.isCompatible && b.isCompatible)
          return 1;
        const y = u?.tokenOrders?.map((A) => A?.toUpperCase()) ?? [], x = y?.indexOf(v.displaySymbol.toUpperCase()) ?? -1, T = y?.indexOf(b.displaySymbol.toUpperCase()) ?? -1;
        return x > -1 && T === -1 ? -1 : x === -1 && T > -1 ? 1 : x > -1 && T > -1 ? x - T : v.name < b.name ? -1 : 1;
      },
      chainConfigs: [],
      providers: [],
      ...u
    },
    onClickConnectWalletButton: f,
    onError: p
  }), [
    o,
    r,
    c,
    l,
    i?.language,
    i?.messages,
    f,
    p,
    a?.colorMode,
    a?.colors?.dark,
    a?.colors?.light,
    u
  ]);
  return /* @__PURE__ */ g(vM.Provider, { value: h, children: /* @__PURE__ */ g(F6e, { children: /* @__PURE__ */ g(bae, { locale: h.locale.language, messages: h.locale.messages, children: /* @__PURE__ */ g(P6e, { children: /* @__PURE__ */ g(V6e, { children: /* @__PURE__ */ X(S8e, { children: [
    /* @__PURE__ */ g(T8e, {}),
    /* @__PURE__ */ g(A8e, {}),
    /* @__PURE__ */ g(I8e, { children: n })
  ] }) }) }) }) }) });
}
const vM = w.createContext({});
function Lt() {
  return N1(vM);
}
const b3 = ({ tokenAddress: e }) => {
  const { address: t } = lt(), n = N((u) => u.transfer.selectedToken), r = N((u) => u.transfer.fromChain), { data: o } = $0({ address: t, chainId: r?.id }), {
    data: i,
    isError: a,
    error: l,
    refetch: c
  } = fw({
    abi: Gs,
    address: e,
    functionName: "balanceOf",
    //
    args: [t],
    query: {
      staleTime: 1e4,
      enabled: !!t && !!e && n && !di(e)
    }
  });
  return {
    balance: di(e) ? o?.value : i,
    isError: a,
    error: l,
    refetch: c
  };
}, sh = ({
  tokenAddress: e,
  sender: t
}) => {
  const { address: n, chain: r } = lt(), o = N((x) => x.transfer.fromChain), i = N((x) => x.transfer.selectedToken), a = N((x) => x.transfer.sendValue), l = N((x) => x.transfer.toToken), [c, u] = ze(null), { balance: f } = b3({
    tokenAddress: i?.address
  }), {
    data: p,
    isLoading: h,
    isError: C,
    error: v,
    refetch: b
  } = fw({
    abi: Gs,
    address: e,
    functionName: "allowance",
    args: [n, t],
    chainId: o?.id,
    query: {
      staleTime: 8e3,
      enabled: !!n && !!i && !!o && !!r && !!e && !!Number(a) && !!l && !!t && o?.chainType !== "tron"
    }
  });
  Oe(() => {
    typeof p == "bigint" && u(p);
  }, [p]), Oe(() => {
    let x = !0;
    if (x)
      try {
        if (!n || !i || r?.id !== o?.id || p === null || !t || !f || o?.chainType === "tron")
          return;
        const T = setInterval(async () => {
          b({
            cancelRefetch: !n || !i || r?.id !== o?.id
          }).then(({ data: A }) => {
            typeof A == "bigint" && A && u(A);
          }).catch(() => {
          });
        }, 8e3);
        return () => {
          x = !1, T && clearInterval(T);
        };
      } catch (T) {
        console.log(T);
      }
  }, [b, n, f, i, o, r, p, t]);
  const y = we(() => {
    if (!i || !c)
      return !0;
    try {
      return !(en(a, i.decimals) <= c);
    } catch (x) {
      return console.log(x), !0;
    }
  }, [i, a, c]);
  return {
    allowance: c,
    isAllowanceLow: y,
    isLoading: h,
    isError: C,
    error: v
  };
}, yM = () => {
  const { address: e, signTransaction: t } = r2(), n = g3(), r = async ({
    tronBridgeAddress: a,
    trc20Address: l,
    amount: c
  }) => {
    if (!e || !n) return;
    const u = [
      { type: "address", value: a },
      { type: "uint256", value: n.toSun(Number(c)) }
    ], f = await n.transactionBuilder.triggerSmartContract(
      l,
      "approve(address,uint256)",
      {},
      u,
      e
    ), p = await t(f.transaction), h = await n.trx.sendRawTransaction(p);
    return console.log(f.transaction, p, h), h;
  }, o = se(
    async ({ trc20Address: a }) => !e || !n ? void 0 : (n.setAddress(e), await (await n.contract().at(a)).methods.balanceOf(e).call()),
    [e, n]
  ), i = se(
    async ({
      trc20Address: a,
      tronBridgeAddress: l
    }) => !e || !n ? void 0 : (n.setAddress(e), await (await n.contract().at(a)).methods.allowance(e, l).call()),
    [e, n]
  );
  return { approveTrc20: r, getTrc20Balance: o, getTrc20Allowance: i };
}, xM = () => {
  const { getTrc20Allowance: e } = yM(), [t, n] = ze(null), r = N((c) => c.transfer.fromChain), o = N((c) => c.transfer.selectedToken), i = N((c) => c.transfer.transferActionInfo), a = N((c) => c.transfer.sendValue), l = se(async () => {
    if (!(r?.chainType !== "tron" || !o?.address || !i?.bridgeAddress || !Number(a)))
      try {
        const c = await e({
          trc20Address: o?.address,
          tronBridgeAddress: i?.bridgeAddress
        });
        return typeof c == "bigint" && c !== null ? n(c) : typeof c?.[0] == "bigint" && n(c?.[0]), console.log("Tron token allowance", c), { allowance: c };
      } catch (c) {
        console.error(c);
      }
  }, [
    r,
    o?.address,
    i?.bridgeAddress,
    e,
    a
  ]);
  return Oe(() => {
    let c = !0;
    if (!c) return;
    l();
    const u = setInterval(() => {
      l();
    }, 5e3);
    return () => {
      u && clearInterval(u), c = !1;
    };
  }, [l]), t;
};
function m6() {
  const e = N((i) => i.transfer.selectedToken), t = N((i) => i.transfer.fromChain), n = N((i) => i.transfer.toChain), r = N((i) => i.transfer.toAccount);
  return we(() => {
    const i = !!e && t?.chainType == "tron" && !!n || n?.chainType === "tron" && !!t, a = t?.chainType == "tron" && Dd(r.address) || n?.chainType == "tron" && KV(r.address);
    return {
      isTronTransfer: i,
      isTronAvailableToAccount: a
    };
  }, [t, e, r.address, n]);
}
const wM = () => {
  const e = g3(), [t, n] = ze(null), r = N((a) => a.transfer.toAccount), { isTronTransfer: o } = m6(), i = se(async () => {
    if (!(!e || !r?.address || !o))
      try {
        const a = await e.trx.getContract(r?.address);
        n(!!a?.bytecode);
      } catch (a) {
        return console.log(a), n(!1), !1;
      }
  }, [r, e, o]);
  return Oe(() => {
    let a = !0;
    return a && i(), () => {
      a = !1;
    };
  }, [r, i]), {
    isTronContract: t
  };
};
function lh() {
  const e = N((l) => l.transfer.fromChain), t = N((l) => l.transfer.toChain), n = N((l) => l.transfer.toAccount), { connection: r } = U0(), { data: o } = Gd({
    address: n.address,
    chainId: t?.id
  }), i = we(() => {
    const l = e?.chainType == "solana" && t, c = t?.chainType === "solana" && e, u = l || c, f = l && Dd(n.address) || c && eH(n.address);
    return {
      fromChainIsSolana: l,
      toChainIsSolana: c,
      isSolanaTransfer: u,
      isAvailableInput: f
    };
  }, [e, n.address, t]), { data: a = !1 } = gi({
    queryKey: ["useIsSolanaProgram", n.address],
    enabled: i.toChainIsSolana && i.isAvailableInput,
    queryFn: async () => {
      if (!n.address) return !1;
      const l = await r.getAccountInfo(new Uc(n.address));
      return !!l && l.executable;
    }
  });
  return {
    isSolanaTransfer: i.isSolanaTransfer,
    isSolanaProgram: a,
    isSolanaAvailableToAccount: i.isAvailableInput && (i.fromChainIsSolana && !o || i.toChainIsSolana && !a)
  };
}
const SM = ({ onOpenFailedModal: e }) => {
  const t = N((l) => l.transfer.fromChain), n = N((l) => l.transfer.toChain), r = N((l) => l.transfer.selectedToken), o = N((l) => l.transfer.sendValue), i = N((l) => l.transfer.transferActionInfo);
  return { handleFailure: se(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (l) => {
      qt({
        id: "transaction_bridge_fail",
        params: {
          item_category: t?.name,
          item_category2: n?.name,
          token: r?.displaySymbol,
          value: o,
          item_variant: i?.bridgeType,
          message: JSON.stringify(l.message || l),
          page_location: JSON.stringify(l.message || l)
        }
      }), e();
    },
    [
      t?.name,
      e,
      r?.displaySymbol,
      o,
      n?.name,
      i?.bridgeType
    ]
  ) };
};
function E8e({
  onOpenFailedModal: e,
  onOpenApproveModal: t,
  onOpenSummaryModal: n,
  onCloseConfirmingModal: r,
  setChosenBridge: o
}) {
  const { data: i } = Wd(), { formatMessage: a } = n1(), l = Xe(), { colorMode: c } = Ee(), { address: u } = lt(), { address: f } = r2(), { isTronAvailableToAccount: p, isTronTransfer: h } = m6(), { isSolanaTransfer: C, isSolanaAvailableToAccount: v } = lh(), b = N((ee) => ee.transfer.sendValue), y = N((ee) => ee.transfer.transferActionInfo), x = N((ee) => ee.transfer.selectedToken), T = N((ee) => ee.transfer.isGlobalFeeLoading), A = N((ee) => ee.transfer.isTransferable), L = N((ee) => ee.transfer.fromChain), I = N((ee) => ee.transfer.toChain), M = N((ee) => ee.transfer.toAccount), k = N((ee) => ee.transfer.isToAddressChecked), _ = eo({ chainId: L?.id }), [F, $] = ze(!1), { allowance: oe } = sh({
    tokenAddress: x?.address,
    sender: y?.bridgeAddress
  }), { isTronContract: te } = wM(), { data: ae } = Gd({
    address: M.address,
    chainId: I?.id
  }), { handleFailure: be } = SM({ onOpenFailedModal: e }), K = xM(), { isConnected: ue } = lt(), { isConnected: J } = hr(), Me = L?.chainType === "evm" && oe !== null && x?.decimals && Number(b) > Number(x1(oe, x?.decimals || 18)) && y?.bridgeAddress !== x?.address && x?.address !== "0x0000000000000000000000000000000000000000" || L?.chainType === "tron" && K !== null && Number(b) > Number(x1(K, x?.meson?.raw?.decimals || 6)) || L?.chainType === "solana" && !1, _e = se(async () => {
    if (!(!x || !y?.bridgeType || !y?.bridgeAddress && L?.chainType !== "solana" || (!i || !_ || !u || oe === null && x?.address !== "0x0000000000000000000000000000000000000000" || !ue) && L?.chainType !== "tron" && L?.chainType !== "solana" || (!J || !f || K === null) && L?.chainType === "tron"))
      try {
        if (o(""), $(!0), Me && y.bridgeAddress !== x?.address && x?.address !== "0x0000000000000000000000000000000000000000") {
          console.log(
            "sendValue",
            b,
            "allowance",
            oe,
            "selectedToken?.decimal",
            x?.decimals
          ), t(), qt({
            id: "click_bridge_goal",
            params: {
              item_name: "Approval"
            }
          });
          return;
        }
        n();
      } catch (ee) {
        console.error(ee, ee.message), be(ee);
      } finally {
        r(), $(!1);
      }
  }, [
    x,
    y?.bridgeType,
    y?.bridgeAddress,
    L,
    i,
    _,
    u,
    oe,
    ue,
    J,
    f,
    K,
    b,
    o,
    Me,
    n,
    t,
    r,
    be
  ]), ne = F || T || !b || !Number(b) || !y || !A || h && (!k || !M?.address || !p) || te === !0 || !!ae || C && (!k || !M.address || !v);
  return /* @__PURE__ */ g(
    re,
    {
      className: `bccb-widget-transfer-button${ne ? " disabled" : ""}`,
      flexDir: "column",
      w: "100%",
      children: /* @__PURE__ */ g(
        Hr,
        {
          className: ne ? "disabled" : "",
          bg: l.colors[c].button.brand.default,
          size: "lg",
          fontWeight: 500,
          h: "56px",
          w: "100%",
          _hover: {
            bg: l.colors[c].button.brand.hover,
            _disabled: { bg: l.colors[c].button.disabled }
          },
          onClick: _e,
          isDisabled: ne,
          children: a(Me ? { id: "transfer.button.approve" } : { id: "transfer.button.confirm" })
        }
      )
    }
  );
}
function M8e(e) {
  return /* @__PURE__ */ X(U1, { width: "81px", height: "80px", viewBox: "0 0 81 80", fill: "none", ...e, children: [
    /* @__PURE__ */ g("rect", { x: "0.5", width: "80", height: "80", rx: "40", fill: "#BFF8DC" }),
    /* @__PURE__ */ g("rect", { x: "12.5", y: "12", width: "56", height: "56", rx: "28", fill: "#53EAA1" }),
    /* @__PURE__ */ g(
      "path",
      {
        d: "M36.9189 45.859L51.3164 31.4616C51.5642 31.2137 51.8586 31.0871 52.1994 31.0818C52.5402 31.0764 52.8398 31.203 53.0984 31.4616C53.3569 31.7201 53.4862 32.0171 53.4862 32.3526C53.4862 32.688 53.3569 32.985 53.0984 33.2436L37.9734 48.3686C37.6721 48.6698 37.3206 48.8205 36.9189 48.8205C36.5172 48.8205 36.1657 48.6698 35.8645 48.3686L28.9061 41.4103C28.6583 41.1624 28.5359 40.8681 28.5391 40.5273C28.5423 40.1865 28.6732 39.8868 28.9317 39.6283C29.1903 39.3697 29.4873 39.2404 29.8227 39.2404C30.1582 39.2404 30.4552 39.3697 30.7137 39.6283L36.9189 45.859Z",
        fill: "#115F39"
      }
    )
  ] });
}
function B8e(e) {
  return /* @__PURE__ */ X(U1, { width: "81px", height: "80px", viewBox: "0 0 81 80", fill: "none", ...e, children: [
    /* @__PURE__ */ g("rect", { x: "0.5", width: "80", height: "80", rx: "40", fill: "#FDC4C7" }),
    /* @__PURE__ */ g("rect", { x: "13", y: "12", width: "56", height: "56", rx: "28", fill: "#FF7A84" }),
    /* @__PURE__ */ g(
      "path",
      {
        d: "M41.0034 41.7564L32.5482 50.2115C32.3175 50.4423 32.0274 50.5603 31.6781 50.5656C31.3287 50.571 31.0333 50.453 30.7919 50.2115C30.5504 49.97 30.4297 49.6773 30.4297 49.3333C30.4297 48.9893 30.5504 48.6966 30.7919 48.4551L39.247 40L30.7919 31.5448C30.5611 31.3141 30.4431 31.024 30.4377 30.6746C30.4324 30.3253 30.5504 30.0299 30.7919 29.7885C31.0333 29.547 31.3261 29.4263 31.6701 29.4263C32.0141 29.4263 32.3068 29.547 32.5482 29.7885L41.0034 38.2436L49.4586 29.7885C49.6893 29.5577 49.9794 29.4396 50.3287 29.4343C50.6781 29.4289 50.9735 29.547 51.2149 29.7885C51.4564 30.0299 51.5771 30.3226 51.5771 30.6666C51.5771 31.0106 51.4564 31.3034 51.2149 31.5448L42.7598 40L51.2149 48.4551C51.4457 48.6859 51.5637 48.976 51.5691 49.3253C51.5744 49.6746 51.4564 49.97 51.2149 50.2115C50.9735 50.453 50.6807 50.5737 50.3367 50.5737C49.9927 50.5737 49.7 50.453 49.4586 50.2115L41.0034 41.7564Z",
        fill: "#821119"
      }
    )
  ] });
}
function k8e(e) {
  return /* @__PURE__ */ X(U1, { width: "81px", height: "80px", viewBox: "0 0 81 80", fill: "none", ...e, children: [
    /* @__PURE__ */ g("rect", { x: "0.5", width: "80", height: "80", rx: "40", fill: "#E1E2E5" }),
    /* @__PURE__ */ g("rect", { x: "13", y: "12", width: "56", height: "56", rx: "28", fill: "#C4C5CB" }),
    /* @__PURE__ */ g(
      "path",
      {
        d: "M41.0026 56.6666C38.6994 56.6666 36.534 56.2286 34.5066 55.3526C32.4788 54.4765 30.7147 53.2884 29.2144 51.7881C27.7142 50.2878 26.526 48.5238 25.65 46.496C24.7739 44.4685 24.3359 42.3031 24.3359 39.9999C24.3359 37.6967 24.7739 35.5314 25.65 33.5039C26.526 31.4761 27.7142 29.7121 29.2144 28.2118C30.7147 26.7115 32.4788 25.5233 34.5066 24.6473C36.534 23.7713 38.6994 23.3333 41.0026 23.3333C43.3058 23.3333 45.4712 23.7713 47.4987 24.6473C49.5264 25.5233 51.2905 26.7115 52.7908 28.2118C54.2911 29.7121 55.4792 31.4761 56.3552 33.5039C57.2313 35.5314 57.6693 37.6967 57.6693 39.9999C57.6693 42.3031 57.2313 44.4685 56.3552 46.496C55.4792 48.5238 54.2911 50.2878 52.7908 51.7881C51.2905 53.2884 49.5264 54.4765 47.4987 55.3526C45.4712 56.2286 43.3058 56.6666 41.0026 56.6666ZM39.6868 53.9539V51.4574C38.5848 51.3448 37.5389 51.0755 36.5491 50.6495C35.5596 50.2232 34.6498 49.6838 33.8197 49.0315L32.0517 50.8096C33.1067 51.6935 34.2792 52.4104 35.5693 52.9604C36.859 53.5104 38.2316 53.8416 39.6868 53.9539ZM42.3184 53.9539C43.7737 53.8416 45.1434 53.5104 46.4276 52.9604C47.7121 52.4104 48.8817 51.6935 49.9364 50.8096L48.1855 49.0315C47.3554 49.6838 46.4456 50.2232 45.4561 50.6495C44.4663 51.0755 43.4204 51.3448 42.3184 51.4574V53.9539ZM41.0026 48.9236C43.4745 48.9236 45.5798 48.0543 47.3184 46.3157C49.057 44.5771 49.9263 42.4718 49.9263 39.9999C49.9263 37.528 49.057 35.4227 47.3184 33.6841C45.5798 31.9455 43.4745 31.0762 41.0026 31.0762C38.5307 31.0762 36.4254 31.9455 34.6868 33.6841C32.9482 35.4227 32.0789 37.528 32.0789 39.9999C32.0789 42.4718 32.9482 44.5771 34.6868 46.3157C36.4254 48.0543 38.5307 48.9236 41.0026 48.9236ZM51.8123 48.9508C52.6962 47.8958 53.4131 46.7233 53.9631 45.4333C54.5131 44.1435 54.8443 42.771 54.9566 41.3157H52.4601C52.3475 42.4178 52.0782 43.4637 51.6522 44.4534C51.2259 45.4429 50.6865 46.3527 50.0342 47.1828L51.8123 48.9508ZM30.193 48.9508L31.971 47.1556C31.3187 46.3258 30.7794 45.4205 30.353 44.4398C29.927 43.4591 29.6577 42.4178 29.5451 41.3157H27.0487C27.1609 42.771 27.4921 44.1435 28.0421 45.4333C28.5921 46.7233 29.309 47.8958 30.193 48.9508ZM40.3684 45.6745L36.8324 40.9512C36.621 40.6635 36.5153 40.3464 36.5153 39.9999C36.5153 39.6534 36.621 39.3363 36.8324 39.0486L40.3684 34.3254C40.5324 34.114 40.7438 34.0083 41.0026 34.0083C41.2614 34.0083 41.4728 34.114 41.6368 34.3254L45.1728 39.0486C45.3842 39.3363 45.4899 39.6534 45.4899 39.9999C45.4899 40.3464 45.3842 40.6635 45.1728 40.9512L41.6368 45.6745C41.4728 45.8859 41.2614 45.9916 41.0026 45.9916C40.7438 45.9916 40.5324 45.8859 40.3684 45.6745ZM27.0487 38.6841H29.5451C29.6577 37.5821 29.927 36.5407 30.353 35.56C30.7794 34.5793 31.3187 33.674 31.971 32.8442L30.193 31.0661C29.309 32.1208 28.5921 33.2904 28.0421 34.5749C27.4921 35.8591 27.1609 37.2289 27.0487 38.6841ZM52.4601 38.6841H54.9566C54.8443 37.2289 54.5086 35.8591 53.9495 34.5749C53.3908 33.2904 52.6694 32.1208 51.7855 31.0661L50.0342 32.817C50.6865 33.6471 51.2259 34.5569 51.6522 35.5464C52.0782 36.5362 52.3475 37.5821 52.4601 38.6841ZM33.8469 30.9683C34.6767 30.316 35.582 29.7767 36.5627 29.3504C37.5434 28.9243 38.5848 28.655 39.6868 28.5425V26.046C38.2316 26.1583 36.859 26.4894 35.5693 27.0394C34.2792 27.5894 33.1067 28.3064 32.0517 29.1903L33.8469 30.9683ZM48.1855 30.9683L49.9364 29.217C48.8817 28.3331 47.7121 27.6118 46.4276 27.053C45.1434 26.4939 43.7737 26.1583 42.3184 26.046V28.5425C43.4204 28.655 44.4663 28.9243 45.4561 29.3504C46.4456 29.7767 47.3554 30.316 48.1855 30.9683Z",
        fill: "#373943"
      }
    )
  ] });
}
function R8e(e) {
  return /* @__PURE__ */ X(
    U1,
    {
      width: "81px",
      height: "80px",
      viewBox: "0 0 81 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ g("rect", { x: "0.5", width: "80", height: "80", rx: "40", fill: "#E1E2E5" }),
        /* @__PURE__ */ g("rect", { x: "12.5", y: "12", width: "56", height: "56", rx: "28", fill: "#C4C5CB" }),
        /* @__PURE__ */ g(
          "path",
          {
            d: "M34.9922 51.7895H47.0078V47.3684C47.0078 45.6906 46.424 44.2556 45.2563 43.0634C44.0886 41.8712 42.6698 41.2751 41 41.2751C39.3302 41.2751 37.9114 41.8718 36.7437 43.0653C35.576 44.2585 34.9922 45.6928 34.9922 47.3684V51.7895ZM31.1 54C30.7883 54 30.5271 53.894 30.3164 53.6821C30.1055 53.4701 30 53.2075 30 52.8944C30 52.581 30.1055 52.3185 30.3164 52.1071C30.5271 51.8953 30.7883 51.7895 31.1 51.7895H32.7925V47.3684C32.7925 45.7095 33.2443 44.1995 34.1477 42.8383C35.0512 41.4769 36.2485 40.5308 37.7396 40C36.2485 39.4596 35.0512 38.5112 34.1477 37.1547C33.2443 35.7982 32.7925 34.2905 32.7925 32.6316V28.2105H31.1C30.7883 28.2105 30.5271 28.1045 30.3164 27.8926C30.1055 27.6806 30 27.4181 30 27.1049C30 26.7915 30.1055 26.5291 30.3164 26.3176C30.5271 26.1059 30.7883 26 31.1 26H50.9C51.2117 26 51.4729 26.106 51.6836 26.3179C51.8945 26.5299 52 26.7925 52 27.1056C52 27.419 51.8945 27.6815 51.6836 27.8929C51.4729 28.1047 51.2117 28.2105 50.9 28.2105H49.2075V32.6316C49.2075 34.2905 48.7557 35.7982 47.8523 37.1547C46.9488 38.5112 45.7515 39.4596 44.2604 40C45.7515 40.5308 46.9488 41.4769 47.8523 42.8383C48.7557 44.1995 49.2075 45.7095 49.2075 47.3684V51.7895H50.9C51.2117 51.7895 51.4729 51.8955 51.6836 52.1074C51.8945 52.3194 52 52.5819 52 52.8951C52 53.2085 51.8945 53.4709 51.6836 53.6824C51.4729 53.8941 51.2117 54 50.9 54H31.1Z",
            fill: "#373943"
          }
        )
      ]
    }
  );
}
const _8e = {
  success: /* @__PURE__ */ g(M8e, {}),
  error: /* @__PURE__ */ g(B8e, {}),
  approve: /* @__PURE__ */ g(k8e, {}),
  confirming: /* @__PURE__ */ g(R8e, {})
};
function g2(e) {
  const {
    type: t = "success",
    title: n,
    description: r,
    buttonText: o = "OK",
    mainButtonText: i = "",
    onButtonClick: a,
    onMainButtonClick: l,
    closeButton: c,
    isOpen: u,
    mainButtonIsDisabled: f = !1,
    closeButtonIsDisabled: p = !1,
    onClose: h,
    className: C,
    mainButtonProps: v,
    bodyProps: b,
    footerProps: y,
    ...x
  } = e, T = _8e[t], A = () => {
    a?.(), h();
  };
  return /* @__PURE__ */ g(i3, { isOpen: u, onClose: h, isCentered: !0, ...x, children: /* @__PURE__ */ X(jd, { children: [
    /* @__PURE__ */ g(s3, { className: `${C}-overlay` }),
    /* @__PURE__ */ X(a3, { className: C, borderRadius: "20px", maxW: "435px", children: [
      /* @__PURE__ */ g(
        gI,
        {
          className: "bccb-widget-modal-close-button",
          top: "24px",
          right: { base: "24px", md: "24px" },
          onClick: A,
          children: /* @__PURE__ */ g(d2, { boxSize: "24px" })
        }
      ),
      /* @__PURE__ */ X(
        CI,
        {
          className: "bccb-widget-modal-body",
          pt: "48px",
          px: "40px",
          pb: "24px",
          display: "flex",
          flexDir: "column",
          alignItems: "center",
          ...b,
          children: [
            /* @__PURE__ */ g(re, { className: "bccb-widget-modal-body-icon", children: T }),
            /* @__PURE__ */ g(
              re,
              {
                className: "bccb-widget-modal-body-title",
                mt: "24px",
                fontSize: "24px",
                fontWeight: 700,
                lineHeight: "32px",
                color: H.colors.light.text.primary,
                textAlign: "center",
                whiteSpace: "nowrap",
                children: n
              }
            ),
            r && /* @__PURE__ */ g(
              re,
              {
                className: "bccb-widget-modal-body-description",
                mt: "8px",
                textAlign: "center",
                color: H.colors.light.text.tertiary,
                display: "inline-block",
                whiteSpace: "pre-line",
                children: r
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ X(
        mI,
        {
          className: "bccb-widget-modal-footer",
          px: "40px",
          pb: "40px",
          justifyContent: "center",
          flexDir: "column",
          gap: "16px",
          ...y,
          children: [
            i && /* @__PURE__ */ g(
              Hr,
              {
                className: "bccb-widget-modal-main-button",
                size: "lg",
                w: "100%",
                fontSize: "16px",
                lineHeight: 1.5,
                onClick: l,
                isDisabled: f,
                ...v,
                children: i
              }
            ),
            c || /* @__PURE__ */ g(
              Hr,
              {
                className: "bccb-widget-modal-second-button",
                size: "lg",
                w: "100%",
                fontSize: "16px",
                lineHeight: 1.5,
                onClick: A,
                isDisabled: p,
                children: o
              }
            )
          ]
        }
      )
    ] })
  ] }) });
}
function $s(e) {
  return /* @__PURE__ */ g(
    U1,
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16px",
      height: "16px",
      viewBox: "0 0 16 16",
      fill: "none",
      ...e,
      children: /* @__PURE__ */ g(
        "path",
        {
          d: "M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H7.33333C7.52222 2 7.68056 2.06389 7.80833 2.19167C7.93611 2.31944 8 2.47778 8 2.66667C8 2.85556 7.93611 3.01389 7.80833 3.14167C7.68056 3.26944 7.52222 3.33333 7.33333 3.33333H3.33333V12.6667H12.6667V8.66667C12.6667 8.47778 12.7306 8.31944 12.8583 8.19167C12.9861 8.06389 13.1444 8 13.3333 8C13.5222 8 13.6806 8.06389 13.8083 8.19167C13.9361 8.31944 14 8.47778 14 8.66667V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM12.6667 4.26667L6.93333 10C6.81111 10.1222 6.65556 10.1833 6.46667 10.1833C6.27778 10.1833 6.12222 10.1222 6 10C5.87778 9.87778 5.81667 9.72222 5.81667 9.53333C5.81667 9.34444 5.87778 9.18889 6 9.06667L11.7333 3.33333H10C9.81111 3.33333 9.65278 3.26944 9.525 3.14167C9.39722 3.01389 9.33333 2.85556 9.33333 2.66667C9.33333 2.47778 9.39722 2.31944 9.525 2.19167C9.65278 2.06389 9.81111 2 10 2H13.3333C13.5222 2 13.6806 2.06389 13.8083 2.19167C13.9361 2.31944 14 2.47778 14 2.66667V6C14 6.18889 13.9361 6.34722 13.8083 6.475C13.6806 6.60278 13.5222 6.66667 13.3333 6.66667C13.1444 6.66667 12.9861 6.60278 12.8583 6.475C12.7306 6.34722 12.6667 6.18889 12.6667 6V4.26667Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function F8e(e) {
  const { hash: t, chosenBridge: n, ...r } = e, o = D1(), { formatMessage: i } = n1(), a = N((h) => h.transfer.fromChain), { chain: l, address: c } = lt(), { address: u } = hr(), { address: f } = Ho(), p = we(() => a?.chainType === "solana" ? f : a?.chainType === "tron" ? u : c, [c, a?.chainType, f, u]);
  return /* @__PURE__ */ g(
    g2,
    {
      className: "bccb-widget-transaction-submitted-modal",
      title: i({ id: "modal.submit.title" }),
      description: i({ id: "modal.submit.desc" }),
      onButtonClick: () => {
        o(oa("")), o(V1(void 0)), o(kn(void 0));
      },
      onMainButtonClick: () => {
        if (window && n) {
          if (n === "cBridge" || n === "meson")
            window.open(`${sx[n]}${t}`);
          else if (n === "deBridge")
            window.open(`${sx[n]}${p}`);
          else if ((n === "stargate" || n === "layerZero") && l?.blockExplorers) {
            const h = l?.blockExplorers.default.url?.replace(/\/$/, "") ?? "";
            window.open(`${h}/tx/${t}`);
          }
        }
      },
      mainButtonProps: {
        leftIcon: /* @__PURE__ */ g($s, { w: "20px", h: "20px" })
      },
      mainButtonText: i({ id: "modal.submit.button.view-tx" }),
      closeButton: /* @__PURE__ */ g(
        Hr,
        {
          className: "bccb-widget-modal-second-button",
          size: "lg",
          variant: "outline",
          w: "100%",
          fontSize: "16px",
          lineHeight: 1.5,
          onClick: () => {
            o(oa("")), o(V1(void 0)), o(kn(void 0)), r.onClose();
          },
          children: i({ id: "modal.submit.button.close" })
        }
      ),
      ...r
    }
  );
}
function P8e(e) {
  const { ...t } = e, { formatMessage: n } = n1();
  return /* @__PURE__ */ g(
    g2,
    {
      className: "bccb-widget-transaction-failed-modal",
      type: "error",
      title: n({ id: "modal.fail.title" }),
      description: n({ id: "modal.fail.desc" }),
      buttonText: n({ id: "modal.fail.button.close" }),
      ...t
    }
  );
}
const fa = () => {
  const e = Lt();
  return we(() => {
    const n = e.http.apiTimeOut;
    return new tH({
      bridgeConfigs: [
        {
          bridgeType: "cBridge",
          endpoint: ZE,
          timeout: n
        },
        {
          bridgeType: "deBridge",
          endpoint: zE,
          statsEndpoint: Z6e,
          timeout: n
        },
        {
          bridgeType: "stargate",
          endpoint: H6e,
          timeout: n
        },
        {
          bridgeType: "layerZero",
          endpoint: ""
        },
        {
          bridgeType: "meson",
          endpoint: e.http.mesonEndpoint,
          timeout: n
        }
      ]
    });
  }, [e.http.apiTimeOut, e.http.mesonEndpoint]);
};
function TM() {
  const { connector: e } = lt();
  return {
    async waitForTxReceipt(t) {
      const { publicClient: n, hash: r, timeout: o, confirmations: i } = t;
      return await n.waitForTransactionReceipt({
        hash: r,
        timeout: o ?? e?.id === "walletConnect" ? P0.SECOND * 20 : P0.MINUTE,
        confirmations: i
      });
    }
  };
}
const V8e = () => {
  const { address: e } = lt(), [t, n] = ze(!1), r = N((u) => u.transfer.fromChain), { data: o } = Wd(), i = eo({ chainId: r?.id }), a = fa(), { waitForTxReceipt: l } = TM();
  return {
    approveErc20Token: se(
      async (u, f, p) => {
        if (!(!e || !o || !p || !f || !i))
          try {
            n(!0);
            const h = await a.approveToken({
              walletClient: o,
              tokenAddress: u,
              amount: p,
              address: e,
              spender: f
            }), C = await l({
              publicClient: i,
              hash: h,
              confirmations: 3
            });
            return console.log("approve tx:", C), h;
          } catch (h) {
            console.log(h, h.message);
          } finally {
            n(!1);
          }
      },
      [e, o, i, a]
    ),
    isLoadingApprove: t
  };
};
function H8e(e) {
  const { onOpenConfirmingModal: t, onCloseConfirmingModal: n, ...r } = e, [o, i] = ze(!1), { approveErc20Token: a, isLoadingApprove: l } = V8e(), { formatMessage: c } = n1(), { isConnected: u } = lt(), { isConnected: f } = hr(), { approveTrc20: p } = yM(), { colorMode: h } = Ee(), C = N((A) => A.transfer.selectedToken), v = N((A) => A.transfer.transferActionInfo), b = N((A) => A.transfer.sendValue), y = N((A) => A.transfer.fromChain), x = N((A) => A.transfer.toChain);
  Oe(() => {
    l ? t() : n();
  }, [l, t, n]);
  const T = (A) => {
    qt({
      id: "click_bridge_approvalModal",
      params: {
        item_category: y?.name,
        item_category2: x?.name,
        token: C.displaySymbol,
        value: b,
        item_variant: A
      }
    });
  };
  return /* @__PURE__ */ g(
    g2,
    {
      className: "bccb-widget-transaction-approve-modal",
      type: "approve",
      title: c({ id: "modal.approve.title" }),
      description: /* @__PURE__ */ X(st, { children: [
        c({ id: "modal.approve.desc.1" }),
        " ",
        /* @__PURE__ */ X(
          mt,
          {
            display: "inline-block",
            size: "md",
            variant: "body",
            color: H.colors[h].text.inverse,
            fontWeight: 500,
            children: [
              b,
              " ",
              C?.symbol
            ]
          }
        ),
        " ",
        c({ id: "modal.approve.desc.2" })
      ] }),
      mainButtonText: c({ id: "modal.approve.button.confirm" }),
      mainButtonIsDisabled: o,
      onMainButtonClick: async () => {
        if (C && v?.bridgeAddress)
          try {
            T("Approve"), i(!0), u && y?.chainType !== "tron" ? await a(
              C.address,
              v?.bridgeAddress,
              en(b, C.decimals)
            ) && r.onClose() : f && y?.chainType === "tron" && await p({
              tronBridgeAddress: v.bridgeAddress,
              trc20Address: C.address,
              amount: b
            }) && r.onClose();
          } catch (A) {
            console.log(A), r.onClose();
          } finally {
            i(!1);
          }
      },
      closeButton: /* @__PURE__ */ g(
        Hr,
        {
          className: "bccb-widget-modal-second-button",
          size: "lg",
          variant: "outline",
          w: "100%",
          fontSize: "16px",
          lineHeight: 1.5,
          onClick: () => {
            T("Deny"), r.onClose();
          },
          children: c({ id: "modal.approve.button.close" })
        }
      ),
      ...r
    }
  );
}
function O8e(e) {
  const { ...t } = e, { formatMessage: n } = n1();
  return /* @__PURE__ */ g(
    g2,
    {
      className: "bccb-widget-transaction-confirming-modal",
      type: "confirming",
      title: n({ id: "modal.confirm.title" }),
      description: n({ id: "modal.confirm.desc" }),
      closeButton: /* @__PURE__ */ g(st, {}),
      bodyProps: {
        pb: 0
      },
      ...t
    }
  );
}
const AM = {
  SWITCH_EVM_CHAIN: "switchEvmChain",
  SWITCH_TRON_CHAIN: "switchTronChain"
};
function IM(e) {
  const t = vJ(), { connector: n } = lt(), { formatMessage: r } = n1(), { onError: o } = Lt();
  return cH({
    ...e,
    mutation: {
      ...e?.mutation,
      onError: (a, ...l) => {
        const c = r({ id: "wallet.error.switch-network" });
        let u;
        (n?.id === "walletConnect" || n?.id === "trust" || n?.id === "binanceWeb3Wallet" || n?.id === "BinanceW3WSDK") && (a?.message?.includes("The JSON sent is not a valid Request object") || a?.message?.includes("Error Calling Method: switchEthereumChain") || a?.details?.includes("not support") || n?.id === "BinanceW3WSDK" && a.code === 4902) && (u = c), u && !o && t({
          render() {
            return /* @__PURE__ */ X(T6e, { variant: "bottom-accent", status: "info", children: [
              /* @__PURE__ */ g(w6e, { children: /* @__PURE__ */ g(x6e, {}) }),
              /* @__PURE__ */ g(y6e, { children: /* @__PURE__ */ g(S6e, { children: u }) })
            ] });
          }
        }), o?.({
          type: AM.SWITCH_EVM_CHAIN,
          message: u,
          error: a
        }), e?.mutation?.onError?.(a, ...l);
      }
    }
  });
}
function LM(e) {
  const { wallet: t } = r2(), { onError: n } = Lt();
  return {
    async switchChain({ chainId: r }) {
      const o = `0x${r?.toString(16)}`;
      try {
        e?.mutation?.onMutate?.(), await t?.adapter?.switchChain(o) || e?.mutation?.onSuccess?.({ chainId: r });
      } catch (i) {
        n?.({
          type: AM.SWITCH_TRON_CHAIN,
          message: void 0,
          error: i
        }), e?.mutation?.onError?.(i);
      }
      e?.mutation?.onSettled?.();
    }
  };
}
function N8e(e) {
  const { formatMessage: t } = n1(), { isOpen: n, onClose: r } = e;
  return /* @__PURE__ */ g(
    g2,
    {
      className: "bccb-widget-header-switching-tips-modal",
      title: t({ id: "wallet.switching-modal.title" }),
      description: t({ id: "wallet.switching-modal.desc" }),
      isOpen: n,
      type: "error",
      onClose: r
    }
  );
}
const EM = (e) => {
  const { formatMessage: t } = n1(), n = Xe(), { colorMode: r } = Ee(), o = N((p) => p.transfer.fromChain), { switchChain: i } = IM(), { switchChain: a } = LM(), { isOpen: l, onClose: c, onOpen: u } = wo(), f = () => {
    o?.chainType === "evm" && i({
      chainId: o.id
    }), o?.chainType === "tron" && (nH() ? u() : a({
      chainId: o.id
    }));
  };
  return /* @__PURE__ */ X(st, { children: [
    /* @__PURE__ */ g(
      Hr,
      {
        className: "bccb-widget-switch-network-button",
        size: "lg",
        h: "56px",
        w: "100%",
        color: n.colors[r].button.wallet.text,
        background: n.colors[r].support.warning[3],
        _hover: {
          background: n.colors[r].support.warning[2]
        },
        onClick: () => {
          f(), qt({
            id: "click_bridge_goal",
            params: {
              item_name: "Switch Network"
            }
          });
        },
        ...e,
        children: t({ id: "transfer.button.switch-network" })
      }
    ),
    /* @__PURE__ */ g(N8e, { isOpen: l, onClose: c })
  ] });
};
function MM() {
  const e = N((l) => l.transfer.fromChain), t = lt(), n = hr(), r = e?.chainType === "evm" && t.isConnected && e.id !== t.chainId, o = e?.chainType === "tron" && n.isConnected && e.id !== n.chainId, i = !1;
  return {
    evmNeedSwitchChain: r,
    tronNeedSwitchChain: o,
    solanaNeedSwitchChain: i,
    needSwitchChain: r || o || i
  };
}
function Us() {
  const e = N((i) => i.transfer.fromChain), t = lt(), n = hr(), r = Ho();
  return e?.chainType === "evm" && t.isConnected || e?.chainType === "tron" && n.isConnected || e?.chainType === "solana" && r.isConnected;
}
function D8e(e) {
  const { children: t } = e, { needSwitchChain: n } = MM(), r = Us(), o = Lt();
  return n ? /* @__PURE__ */ g(EM, {}) : r ? /* @__PURE__ */ g(st, { children: t }) : o.components.connectWalletButton;
}
const Vn = () => {
  const e = N((i) => i.transfer.toToken), t = N((i) => i.transfer.selectedToken), n = se(() => ({
    cBridge: e?.cBridge?.raw?.token.decimal || 0,
    deBridge: e?.deBridge?.raw?.decimals || 0,
    stargate: t?.stargate?.raw?.token?.decimals || 0,
    layerZero: t?.layerZero?.raw?.decimals || 0,
    meson: t?.meson?.raw?.decimals || 0
  }), [e, t]), r = se(() => ({
    cBridge: e?.cBridge?.raw?.token.address || "",
    deBridge: e?.deBridge?.raw?.address || "",
    stargate: e?.stargate?.raw?.token?.address || "",
    layerZero: e?.layerZero?.raw?.address || "",
    meson: e?.meson?.raw?.addr || ""
  }), [e]), o = se(() => ({
    cBridge: e?.cBridge?.raw?.token.symbol || "",
    deBridge: e?.deBridge?.raw?.symbol || "",
    stargate: e?.stargate?.raw?.token?.symbol || "",
    layerZero: e?.layerZero?.raw?.symbol || "",
    meson: e?.meson?.raw?.id?.toUpperCase() || ""
  }), [
    e?.cBridge?.raw?.token.symbol,
    e?.deBridge?.raw?.symbol,
    e?.stargate?.raw?.token?.symbol,
    e?.layerZero?.raw?.symbol,
    e?.meson?.raw?.id
  ]);
  return { toTokenInfo: e, getToDecimals: n, getToTokenAddress: r, getToTokenSymbol: o };
}, C6 = () => {
  const { address: e } = lt(), t = fa(), n = N((h) => h.transfer.selectedToken), r = N((h) => h.transfer.fromChain), o = N((h) => h.transfer.toChain), i = N((h) => h.transfer.sendValue), a = N((h) => h.transfer.slippage), l = we(() => n?.isPegged || !1, [n]), c = we(() => {
    try {
      return !r || l && !n?.cBridge?.peggedConfig || !l && !r?.cBridge?.raw || !t?.cBridge ? null : t.cBridge.getTransferAddress({
        fromChainId: r?.id,
        isPegged: l,
        peggedConfig: n?.cBridge?.peggedConfig,
        chainConfig: r?.cBridge?.raw
      });
    } catch (h) {
      console.log(h);
    }
  }, [n, r, l, t?.cBridge]), u = we(() => n?.cBridge?.peggedConfig?.org_chain_id === r?.id ? "deposit" : n?.cBridge?.peggedConfig?.pegged_chain_id === r?.id ? "withdraw" : "", [n, r?.id]), f = we(() => {
    if (!i || i === "0" || !o || !n || !e || !t?.cBridge)
      return null;
    const h = (/* @__PURE__ */ new Date()).getTime();
    let C = 0n;
    try {
      n.isPegged === !1 ? C = en(
        String(i),
        n?.cBridge?.raw?.token.decimal
      ) : u === "deposit" ? C = en(
        String(i),
        n?.cBridge?.peggedConfig?.org_token.token.decimal
      ) : u === "withdraw" && (C = en(
        String(i),
        n?.cBridge?.peggedConfig?.pegged_token.token.decimal
      ));
    } catch (v) {
      console.log(v);
    }
    return t.cBridge.getTransferParams({
      amount: C,
      isPegged: l,
      toChainId: o.id,
      tokenAddress: n?.address,
      address: e,
      maxSlippage: a,
      transferType: u || void 0,
      peggedConfig: n.cBridge?.peggedConfig,
      nonce: h
    });
  }, [
    i,
    o,
    n,
    e,
    l,
    u,
    a,
    t?.cBridge
  ]);
  return { args: we(() => {
    const h = n?.cBridge?.peggedConfig;
    if (!f || l && !u || !e || !c || !t?.cBridge)
      return null;
    const C = t.cBridge.getABI({
      isPegged: l,
      transferType: u || void 0,
      peggedConfig: h
    }), v = t.cBridge.getTransferFunction({
      isPegged: l,
      transferType: u || void 0
    });
    return {
      address: c,
      abi: C,
      functionName: v,
      account: e,
      args: f
    };
  }, [c, u, n, l, e, f, t?.cBridge]), bridgeAddress: c };
}, F1 = (e, t = 18, n = !0) => {
  const r = G8e(e, t);
  return Number(r).toLocaleString("fullwide", {
    maximumFractionDigits: t,
    useGrouping: n
  });
};
function Z8e(e) {
  return Object.keys(e).length === 0 ? "" : Object.keys(e).reduce((t, n) => e[t] < e[n] ? t : n);
}
function z8e(e) {
  return Object.keys(e).length === 0 ? "" : Object.keys(e).reduce((t, n) => e[t].isSorting !== e[n].isSorting ? e[t].isSorting === !0 ? t : n : e[t].value > e[n].value ? t : n);
}
function G8e(e, t = 8) {
  const r = W8e(Number(e)).split(".");
  if (r.length < 2) return e;
  const o = r[1].slice(0, t);
  return r[0] + "." + o;
}
const W8e = (e) => {
  let t = e.toString();
  if (Math.abs(e) < 1) {
    const n = parseInt(e.toString().split("e-")[1]);
    n && (e *= Math.pow(10, n - 1), t = "0." + new Array(n).join("0") + e.toString().substring(2));
  } else {
    let n = parseInt(e.toString().split("+")[1]);
    n > 20 && (n -= 20, e /= Math.pow(10, n), t = e.toString(), t += new Array(n + 1).join("0"));
  }
  return t;
}, g6 = () => {
  const e = C2(), t = N((n) => n.transfer.fromChain);
  if (t?.id) {
    if (e.nativeCurrencies[t.id])
      return e.nativeCurrencies[t.id].symbol;
    const n = t?.cBridge?.raw?.gas_token_symbol;
    return n || z6e[t.id];
  }
  return null;
};
function $8e(e, t = 6, n = 6) {
  if (!e)
    return "";
  const r = e.substring(0, t), o = e.substring(e.length - n, e.length);
  return e.length > r.length + o.length ? `${r}...${o}` : e;
}
function Tx(e, t = 6, n = 4) {
  return $8e(e, t, n);
}
function U8e(e) {
  return JSON.parse(
    JSON.stringify(
      e,
      (t, n) => typeof n == "bigint" ? n.toString() : n
      // return everything else unchanged
    )
  );
}
function v3(e, t) {
  return !e || !t ? "" : e?.replace("{0}", t);
}
function ms(e) {
  return Number(e) < cx && Number(e) !== 0 ? `< ${cx}` : F1(Number(e), 4);
}
function BM(e) {
  const t = e.reduce((r, o) => {
    const i = o.symbol, a = Number(o.value);
    return i && !r[i] && (r[i] = 0), r[i] += a, r;
  }, {}), n = Object.keys(t).map((r) => `${ms(t[r])} ${r}`).join(" + ");
  return n || "";
}
function Ax(e) {
  return Array.from(e).map((t) => t.charCodeAt(0).toString(16).padStart(2, "0")).join("");
}
function Ix(e) {
  return e.every(
    (t) => t.status === "rejected" && t?.reason?.message?.includes("timeout") || t.status === "fulfilled" && t.value === null
  );
}
const b6 = () => {
  const { toTokenInfo: e } = Vn(), { args: t, bridgeAddress: n } = C6(), r = N((y) => y.aggregator.bridgeMaxMin.cBridge), o = g6(), { formatMessage: i } = n1(), a = D1(), { address: l, chain: c } = lt(), u = N((y) => y.transfer.sendValue), f = N((y) => y.transfer.selectedToken), p = N((y) => y.transfer.fromChain), h = eo({ chainId: p?.id }), { balance: C } = b3({
    tokenAddress: f?.address
  }), v = we(() => !Number(u) || !f || !e ? !1 : !!(Number(r?.min) && Number(r?.max) && (Number(u) <= Number(r.min) || Number(u) >= Number(r.max))), [r, u, f, e]), b = se(
    async (y) => {
      let x = "", T = null;
      const A = [];
      let L = !1;
      const I = f?.cBridge?.raw?.token.decimal ?? 18, M = en(u, I);
      if (y?.base_fee) {
        const k = x1(y?.base_fee, e?.decimals || 18);
        T = k, A.push({
          label: i({ id: "route.option.info.base-fee" }),
          value: `${F1(Number(k), 8)} ${e?.symbol}`,
          name: "baseFee"
        });
      }
      if (y?.perc_fee) {
        const k = x1(y?.perc_fee, e?.decimals || 18);
        T = T ? Number(T) + Number(k) : Number(k), A.push({
          label: i({ id: "route.option.info.protocol-fee" }),
          value: `${F1(Number(k), 8)} ${e?.symbol}`,
          name: "protocolFee"
        });
      }
      try {
        if (Number(r.min) < Number(u) && Number(r.max) > Number(u) && c && p?.id === c?.id && l && f?.address) {
          const k = await h.readContract({
            address: f?.address,
            abi: Gs,
            functionName: "allowance",
            args: [l, n],
            chainId: p?.id,
            enabled: !!l && !!f?.address && p && c && p?.id === c?.id
          });
          if (t && h && C && Number(C) >= Number(M) && k && k >= M) {
            const _ = await h.estimateContractGas(t), F = await h.getGasPrice();
            if (_ && F) {
              const $ = Number(x1(BigInt(_) * F, 18));
              x += `${ms($)} ${o}`, A.push({
                label: i({ id: "route.option.info.gas-fee" }),
                value: `${F1($, 8)} ${o}`,
                name: "gasFee"
              });
            }
          }
        }
      } catch (k) {
        console.log(k, k.message), a(Ht({ cBridge: "Failed to get gas fee" })), L = !0;
      }
      return T !== null && (x = x ? x + ` + ${String(ms(T))} ${e?.symbol}` : `${String(ms(T))} ${e?.symbol}`), a(
        Lr({
          cBridge: {
            summary: x || "--",
            breakdown: A
          }
        })
      ), {
        summary: x || "--",
        breakdown: A,
        isFailedToGetGas: L
      };
    },
    [
      e,
      i,
      a,
      o,
      t,
      h,
      C,
      l,
      f,
      c,
      p,
      u,
      n,
      r
    ]
  );
  return {
    isAllowSendError: v,
    bridgeAddress: n,
    cBridgeFeeSorting: b,
    cBridgeAllowedAmt: r
  };
}, v6 = () => {
  const { isAllowSendError: e } = b6(), t = N((l) => l.transfer.estimatedAmount), n = N((l) => l.transfer.sendValue), r = N((l) => l.transfer.routeError), { getToDecimals: o } = Vn(), i = se(
    (l) => {
      if (t) {
        if (l === "deBridge" && t[l]?.estimation && o().deBridge)
          return x1(
            BigInt(t?.deBridge?.estimation?.dstChainTokenOut?.amount),
            o().deBridge
          );
        if (l === "cBridge" && t?.cBridge?.estimated_receive_amt && o().cBridge)
          return x1(
            t?.cBridge?.estimated_receive_amt,
            o().cBridge
          );
        if (l === "stargate" && t?.stargate?.[2].amountReceivedLD && o().stargate)
          return x1(
            BigInt(t?.stargate?.[2].amountReceivedLD),
            o().stargate || 18
          );
        if (l === "layerZero" && n && t?.layerZero)
          return n;
        if (l === "meson" && t?.meson)
          return t?.meson;
      }
      return null;
    },
    [t, n, o]
  ), a = se(() => {
    const l = {
      deBridge: {
        value: Number(i("deBridge")) ?? 0,
        isSorting: !r?.deBridge
      },
      cBridge: {
        value: Number(i("cBridge")) ?? 0,
        isSorting: !r?.cBridge && !e
      },
      stargate: {
        value: Number(i("stargate")) ?? 0,
        isSorting: !r?.stargate
      },
      layerZero: {
        value: Number(i("layerZero")) ?? 0,
        isSorting: !r?.layerZero
      },
      meson: {
        value: Number(i("meson")) ?? 0,
        isSorting: !r?.meson
      }
    };
    return Object.fromEntries(
      Object.entries(l).sort(([, u], [, f]) => u.isSorting !== f.isSorting ? u.isSorting === !0 ? -1 : 1 : f.value - u.value)
    );
  }, [i, r, e]);
  return { getReceiveAmount: i, getSortedReceiveAmount: a };
};
function kM(e) {
  return /* @__PURE__ */ g(
    U1,
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "25px",
      height: "12px",
      viewBox: "0 0 25 12",
      fill: "none",
      ...e,
      children: /* @__PURE__ */ g(
        "path",
        {
          d: "M24.5304 6.52734C24.8233 6.23441 24.8232 5.75953 24.5303 5.46668L19.7567 0.694287C19.4638 0.40143 18.9889 0.401488 18.6961 0.694417C18.4032 0.987346 18.4033 1.46222 18.6962 1.75508L22.9393 5.9972L18.6972 10.2404C18.4044 10.5333 18.4044 11.0082 18.6973 11.301C18.9903 11.5939 19.4651 11.5938 19.758 11.3009L24.5304 6.52734ZM9.15527e-05 6.75L24.0001 6.74707L23.9999 5.24707L-9.15527e-05 5.25L9.15527e-05 6.75Z",
          fill: "url(#paint0_linear_2473_21184_)",
          fillOpacity: e?.iconopacity ?? "0.3"
        }
      )
    }
  );
}
function Bo(e) {
  const { boxSize: t = "32px", alt: n = "app-image", src: r, fallbackBgColor: o, ...i } = e, { colorMode: a } = Ee(), [l, c] = ze(!r);
  return Oe(() => {
    c(!r);
  }, [r]), /* @__PURE__ */ g(st, { children: l ? /* @__PURE__ */ g(
    np,
    {
      className: "default-icon",
      size: t,
      ...i,
      bg: o ?? H.colors[a].support.primary[3]
    }
  ) : /* @__PURE__ */ g(
    cs,
    {
      src: r,
      alt: n,
      boxSize: t,
      borderRadius: "full",
      loading: "lazy",
      onError: () => {
        c(!0);
      },
      ...i
    }
  ) });
}
const Lx = ({
  chainIconUrl: e,
  tokenIconUrl: t,
  chainName: n,
  amount: r,
  tokenSymbol: o,
  isLongText: i
}) => {
  const a = N((l) => l.transfer.isGlobalFeeLoading);
  return /* @__PURE__ */ X(
    re,
    {
      flexDir: "row",
      justifyContent: "space-between",
      w: "100%",
      alignItems: "center",
      gap: "16px",
      className: "bccb-widget-transaction-summary-modal-token-info",
      children: [
        /* @__PURE__ */ X(re, { flexShrink: 1, flexDir: "row", alignItems: "center", gap: "14px", children: [
          /* @__PURE__ */ X(
            re,
            {
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0,
              w: "32px",
              h: "32px",
              position: "relative",
              children: [
                /* @__PURE__ */ g(
                  Bo,
                  {
                    position: "absolute",
                    bottom: "-4px",
                    right: "-4px",
                    boxSize: "16px",
                    src: t,
                    flexShrink: 0,
                    className: "bccb-widget-transaction-summary-modal-token-icon"
                  }
                ),
                /* @__PURE__ */ g(
                  Bo,
                  {
                    boxSize: "32px",
                    src: e,
                    flexShrink: 0,
                    className: "bccb-widget-transaction-summary-modal-chain-icon"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ X(
            re,
            {
              flexDir: "column",
              justifyContent: i ? "flex-start" : "center",
              whiteSpace: "wrap",
              className: "bccb-widget-transaction-summary-modal-chain-name",
              children: [
                /* @__PURE__ */ g(re, { fontSize: "16px", fontWeight: 700, children: n }),
                i && !a && /* @__PURE__ */ g(Ex, { amount: r ?? "--", tokenSymbol: o ?? "" })
              ]
            }
          )
        ] }),
        !i && !a && /* @__PURE__ */ g(Ex, { amount: r ?? "--", tokenSymbol: o ?? "" }),
        a && /* @__PURE__ */ g(
          Vt,
          {
            className: "bccb-widget-transaction-summary-modal-loading-skeleton",
            height: "24px",
            maxW: "120px",
            w: "100%",
            borderRadius: "4px"
          }
        )
      ]
    }
  );
}, Ex = ({ amount: e, tokenSymbol: t }) => {
  const { colorMode: n } = Ee(), r = Xe();
  return /* @__PURE__ */ X(
    re,
    {
      flex: 1,
      wordBreak: "break-all",
      alignItems: "center",
      justifyContent: "flex-end",
      fontSize: "14px",
      lineHeight: "14px",
      fontWeight: 700,
      className: "bccb-widget-transaction-summary-modal-token-amount",
      color: Number(e?.replace(" ", "")) < 0 ? r.colors[n].support.danger[3] : r.colors[n].support.success[3],
      children: [
        e,
        " ",
        t
      ]
    }
  );
};
function j8e(e) {
  return /* @__PURE__ */ X(
    U1,
    {
      width: "24px",
      height: "24px",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ g(
          "path",
          {
            d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
            fill: e.iconbgcolor ?? "#E1E2E5"
          }
        ),
        /* @__PURE__ */ g(
          "path",
          {
            d: "M11.9982 8.59998C11.7513 8.59998 11.5454 8.51695 11.3806 8.35088C11.2158 8.18483 11.1334 7.97835 11.1334 7.73145C11.1334 7.48455 11.2164 7.27869 11.3825 7.11387C11.5485 6.94906 11.755 6.86665 12.0019 6.86665C12.2488 6.86665 12.4547 6.94968 12.6195 7.11573C12.7843 7.2818 12.8667 7.48828 12.8667 7.73518C12.8667 7.98208 12.7837 8.18794 12.6176 8.35277C12.4516 8.51758 12.2451 8.59998 11.9982 8.59998ZM12.0001 17.1333C11.8519 17.1333 11.726 17.0815 11.6223 16.9778C11.5186 16.8741 11.4667 16.7481 11.4667 16.6V11.2C11.4667 11.0518 11.5186 10.9259 11.6223 10.8222C11.726 10.7185 11.8519 10.6667 12.0001 10.6667C12.1482 10.6667 12.2741 10.7185 12.3778 10.8222C12.4815 10.9259 12.5334 11.0518 12.5334 11.2V16.6C12.5334 16.7481 12.4815 16.8741 12.3778 16.9778C12.2741 17.0815 12.1482 17.1333 12.0001 17.1333Z",
            fill: e.iconcolor ?? "#373943"
          }
        )
      ]
    }
  );
}
const RM = ({ text: e, ...t }) => {
  const { colorMode: n } = Ee(), r = Xe();
  return /* @__PURE__ */ X(
    re,
    {
      mt: "12px",
      px: "8px",
      py: "4px",
      gap: "8px",
      borderRadius: "8px",
      alignItems: "center",
      bg: De(r.colors[n].support.warning[4], 0.24),
      color: r.colors[n].support.warning[2],
      fontSize: "12px",
      fontWeight: 400,
      w: "100%",
      ...t,
      children: [
        /* @__PURE__ */ g(
          j8e,
          {
            transform: "rotate(180deg)",
            w: "16px",
            h: "16px",
            iconcolor: r.colors[n].text.warning,
            iconbgcolor: r.colors[n].support.warning[4]
          }
        ),
        e
      ]
    }
  );
};
function n2(e) {
  const { address: t, transform: n, isTruncated: r = !0, headLen: o, tailLen: i } = e;
  if (!t)
    return "";
  if (Dd(t)) {
    let a = t;
    return n === "lowerCase" && (a = t.toLowerCase()), n === "upperCase" && (a = `0x${t.replace("0x", "").toUpperCase()}`), r ? Tx(a, o ?? 6, i ?? 4) : a;
  }
  return r ? Tx(t, o ?? 4, i ?? 4) : t;
}
const X8e = () => {
  const { colorMode: e } = Ee(), t = Xe(), { getSortedReceiveAmount: n } = v6(), { formatMessage: r } = n1(), o = Gt({ base: !0, md: !1 }) ?? !1, i = N((A) => A.transfer.fromChain), a = N((A) => A.transfer.toChain), l = N((A) => A.transfer.selectedToken), c = N((A) => A.transfer.sendValue), u = N((A) => A.transfer.transferActionInfo), { getToTokenAddress: f, toTokenInfo: p, getToTokenSymbol: h } = Vn(), C = we(
    () => u?.bridgeType,
    [u]
  ), v = we(() => {
    if (!Number(c)) return null;
    if (C) {
      const A = n();
      return Number(A[C].value);
    }
    return null;
  }, [n, C, c]), b = we(() => C ? f()[C] : "", [C, f]), y = we(
    () => di(b, a?.chainType),
    [b, a?.chainType]
  ), x = we(() => {
    if (o) return !0;
    try {
      if (c && l?.symbol)
        return c.length + l.symbol.length - 1 > 16;
    } catch {
    }
    return !1;
  }, [c, l?.symbol, o]), T = we(() => {
    if (o) return !0;
    try {
      if (v && p?.symbol)
        return String(v).length + p?.symbol.length - 1 > 16;
    } catch {
    }
    return !1;
  }, [v, p?.symbol, o]);
  return /* @__PURE__ */ X(
    re,
    {
      flexDir: "column",
      alignItems: "center",
      padding: "12px",
      gap: "4px",
      borderRadius: "8px",
      bg: t.colors[e].background.modal,
      className: "bccb-widget-transaction-summary-modal-summary-wrapper",
      children: [
        /* @__PURE__ */ g(
          Lx,
          {
            chainIconUrl: i?.icon,
            tokenIconUrl: l?.icon,
            chainName: i?.name,
            amount: c ? `- ${c}` : "",
            tokenSymbol: l?.symbol ?? "",
            isLongText: x || T
          }
        ),
        /* @__PURE__ */ g(
          kM,
          {
            w: "24px",
            h: "24px",
            mb: { base: "-4px" },
            transform: "rotate(90deg)",
            iconopacity: "1"
          }
        ),
        /* @__PURE__ */ g(
          Lx,
          {
            chainIconUrl: a?.icon,
            tokenIconUrl: p?.icon,
            chainName: a?.name,
            amount: v ? `+ ${v}` : "",
            tokenSymbol: p?.symbol ?? "",
            isLongText: x || T
          }
        ),
        /* @__PURE__ */ g(
          RM,
          {
            text: /* @__PURE__ */ g("span", { children: y ? /* @__PURE__ */ X(st, { children: [
              /* @__PURE__ */ g("span", { style: { marginRight: "2px" }, children: r({ id: "transfer.warning.confirm.to.native.token.address" }) }),
              /* @__PURE__ */ g("span", { children: h()?.[C]?.toUpperCase() ?? "" })
            ] }) : /* @__PURE__ */ X(st, { children: [
              /* @__PURE__ */ g("span", { style: { marginRight: "2px" }, children: r({ id: "transfer.warning.confirm.to.address" }) }),
              b ? /* @__PURE__ */ g(
                Ts,
                {
                  isExternal: !0,
                  href: v3(a?.tokenUrlPattern, b),
                  display: "inline-block",
                  overflowWrap: "break-word",
                  pointerEvents: "all",
                  color: "currentColor",
                  children: o ? n2({ address: b, isTruncated: !0 }) : b
                }
              ) : null
            ] }) })
          }
        )
      ]
    }
  );
}, Y8e = () => {
  const { fetchTokenPrice: e } = Ws();
  return { validateTokenPrice: se(
    async ({
      chainId: n,
      chainType: r,
      tokenAddress: o,
      tokenSymbol: i
    }) => {
      const { data: a } = await e({
        chainId: n,
        chainType: r,
        tokenAddress: o,
        tokenSymbol: i
      });
      return a;
    },
    [e]
  ) };
}, J8e = ({
  onClose: e,
  onOpenSubmittedModal: t,
  onOpenFailedModal: n,
  onOpenConfirmingModal: r,
  onCloseConfirmingModal: o,
  setHash: i,
  setChosenBridge: a
}) => {
  const { data: l } = Wd(), { args: c } = C6(), u = fa(), { formatMessage: f } = n1(), p = Xe(), { colorMode: h } = Ee(), { validateTokenPrice: C } = Y8e(), { address: v } = lt(), { address: b, signTransaction: y } = r2(), { isTronAvailableToAccount: x, isTronTransfer: T } = m6(), { signMessageAsync: A } = uH(), { handleFailure: L } = SM({ onOpenFailedModal: n }), { connection: I } = U0(), { sendTransaction: M } = $d(), k = N((Q) => Q.transfer.sendValue), _ = N((Q) => Q.transfer.transferActionInfo), F = N((Q) => Q.transfer.selectedToken), $ = N((Q) => Q.transfer.isGlobalFeeLoading), oe = N((Q) => Q.transfer.isTransferable), te = N((Q) => Q.transfer.toToken), ae = N((Q) => Q.transfer.fromChain), be = N((Q) => Q.transfer.toChain), K = N((Q) => Q.transfer.toAccount), ue = eo({ chainId: ae?.id }), J = eo({ chainId: be?.id }), [Me, _e] = ze(!1), { allowance: ne } = sh({
    tokenAddress: F?.address,
    sender: _?.bridgeAddress
  }), ee = xM(), { isConnected: ye } = lt(), { isConnected: fe } = hr(), { waitForTxReceipt: xe } = TM(), Te = se(async () => {
    if (!(!ae || !F || !_?.bridgeType || !_?.bridgeAddress && ae?.chainType !== "solana" || (!l || !ue || !v || ne === null && F?.address !== "0x0000000000000000000000000000000000000000" || !ye) && ae?.chainType !== "tron" && ae?.chainType !== "solana" || (!fe || !b || ee === null) && ae?.chainType === "tron"))
      try {
        if (await C({
          chainId: ae.id,
          chainType: ae.chainType,
          tokenAddress: F.address,
          tokenSymbol: F.symbol
        }) === void 0)
          throw new Error(
            `Can not get token price from API server: ${k} ${F.symbol}`
          );
        if (i(null), a(""), _e(!0), e(), r(), qt({
          id: "click_bridge_goal",
          params: {
            item_name: "Send"
          }
        }), _.bridgeType === "cBridge" && c && ae && v)
          try {
            if (!await u.cBridge.validateCBridgeToken({
              isPegged: F.isPegged,
              fromChainId: ae.id,
              fromTokenAddress: F?.cBridge?.raw?.token.address,
              fromTokenSymbol: F?.cBridge?.raw?.token?.symbol,
              fromTokenDecimals: F.cBridge?.raw?.token.decimal,
              bridgeAddress: _.bridgeAddress,
              toChainId: be?.id,
              toTokenAddress: te?.cBridge?.raw?.token.address,
              toTokenSymbol: te?.cBridge?.raw?.token.symbol,
              toTokenDecimals: te?.cBridge?.raw?.token.decimal,
              amount: Number(k),
              cBridgeEndpoint: `${ZE}/v2/getTransferConfigsForAll`
            })) {
              L({
                fromTokenAddress: F.address,
                bridgeAddress: _.bridgeAddress,
                fromChainId: ae.id,
                isPegged: F.isPegged,
                fromTokenSymbol: F.symbol,
                toChainId: be?.id,
                toTokenAddress: te?.cBridge?.raw?.token.address,
                toTokenSymbol: te?.cBridge?.raw?.token.symbol,
                decimals: F.decimals,
                amount: Number(k),
                message: "(Token Validation Failed) - Invalid cBridge token!!"
              });
              return;
            }
            const me = await u.cBridge.sendToken({
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              walletClient: l,
              publicClient: ue,
              bridgeAddress: _.bridgeAddress,
              fromChainId: ae?.id,
              isPegged: F.isPegged,
              address: v,
              peggedConfig: F?.cBridge?.peggedConfig,
              args: c.args
            });
            await xe({
              publicClient: ue,
              hash: me
            }), me && (qt({
              id: "transaction_bridge_success",
              params: {
                item_category: ae?.name,
                item_category2: be?.name,
                token: F.displaySymbol,
                value: k,
                item_variant: "cBridge"
              }
            }), o(), i(me), a("cBridge"), t()), console.log("cBridge tx", me);
          } catch (pe) {
            console.log(pe), L(pe);
          }
        else if (_.bridgeType === "deBridge")
          try {
            let pe;
            if (!await u.deBridge.validateDeBridgeToken({
              fromChainId: ae?.id,
              toChainId: be?.id,
              fromTokenSymbol: F?.deBridge?.raw?.symbol,
              fromTokenAddress: F.deBridge?.raw?.address,
              fromTokenDecimals: F.deBridge?.raw?.decimals,
              toTokenSymbol: te?.deBridge?.raw?.symbol,
              toTokenAddress: te?.deBridge?.raw?.address,
              toTokenDecimals: te?.deBridge?.raw?.decimals,
              amount: Number(k),
              fromChainType: ae?.chainType,
              fromBridgeAddress: _.bridgeAddress,
              toChainType: be?.chainType,
              deBridgeEndpoint: zE
            })) {
              L({
                message: "(Token Validation Failed) - Invalid deBridge token!!",
                fromChainId: ae?.id,
                tokenSymbol: F.symbol,
                tokenAddress: F.address
              });
              return;
            }
            if (ae?.chainType === "evm" && _.value && v && (pe = await u.deBridge.sendToken({
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              walletClient: l,
              bridgeAddress: _.bridgeAddress,
              data: _.data,
              amount: BigInt(_.value),
              address: v
            }), await xe({
              publicClient: ue,
              hash: pe
            })), ae?.chainType === "solana") {
              const { blockhash: Be } = await I.getLatestBlockhash(), We = _.data?.slice(2), ie = gH.deserialize(Buffer.from(We, "hex"));
              ie.message.recentBlockhash = Be, pe = await M(ie, I), console.log("---solana---"), console.log("blockhash: ", Be), console.log("data:", We), console.log("tx:", ie), console.log("hash:", pe);
            }
            pe && (qt({
              id: "transaction_bridge_success",
              params: {
                item_category: ae?.name,
                item_category2: be?.name,
                token: F.displaySymbol,
                value: k,
                item_variant: "deBridge"
              }
            }), o(), a("deBridge"), i(pe), t());
          } catch (pe) {
            console.log(pe), L(pe);
          }
        else if (_.bridgeType === "stargate" && v) {
          if (!await u.stargate.validateStargateToken({
            fromBridgeAddress: _.bridgeAddress,
            toBridgeAddress: te?.stargate?.raw?.address,
            fromTokenAddress: F?.stargate?.raw?.token?.address,
            fromTokenSymbol: F?.stargate?.raw?.token?.symbol,
            fromTokenDecimals: F?.stargate?.raw?.token?.decimals,
            fromChainId: ae?.id,
            toTokenAddress: te?.stargate?.raw?.token?.address,
            toTokenSymbol: te?.stargate?.raw?.token?.symbol,
            toTokenDecimals: te?.stargate?.raw?.token?.decimals,
            toChainId: be?.id,
            amount: Number(k),
            dstEndpointId: te?.stargate?.raw?.endpointID,
            toPublicClient: J,
            fromPublicClient: ue,
            stargateEndpoint: N6e
          })) {
            L({
              messages: "(Token Validation Failed) - Invalid Stargate token!!",
              fromChainId: ae?.id,
              tokenAddress: F.address,
              bridgeAddress: _.bridgeAddress,
              tokenSymbol: F.symbol
            });
            return;
          }
          const me = await u.stargate.sendToken({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            walletClient: l,
            publicClient: ue,
            bridgeAddress: _.bridgeAddress,
            tokenAddress: F.address,
            endPointId: te?.stargate?.raw?.endpointID,
            receiver: v,
            amount: en(k, F.decimals)
          });
          me && (qt({
            id: "transaction_bridge_success",
            params: {
              item_category: ae?.name,
              item_category2: be?.name,
              token: F.displaySymbol,
              value: k,
              item_variant: "stargate"
            }
          }), o(), a("stargate"), i(me), t());
        } else if (_.bridgeType === "layerZero" && v) {
          if (!await u.layerZero.validateLayerZeroToken({
            fromPublicClient: ue,
            toPublicClient: J,
            bridgeAddress: _.bridgeAddress,
            fromTokenAddress: F.layerZero?.raw?.address,
            fromTokenSymbol: F.layerZero?.raw?.symbol,
            fromTokenDecimals: F.layerZero?.raw?.decimals,
            toTokenAddress: te?.layerZero?.raw?.address,
            toTokenDecimals: te?.layerZero?.raw?.decimals,
            toTokenSymbol: te?.layerZero?.raw?.symbol,
            toBridgeAddress: te?.layerZero?.raw?.bridgeAddress,
            dstEndpoint: te?.layerZero?.raw?.endpointID,
            amount: Number(k)
          })) {
            L({
              messages: "(Token Validation Failed) - Invalid LayerZero token!!",
              fromChainId: ae?.id,
              tokenAddress: F.layerZero?.raw?.address,
              bridgeAddress: _.bridgeAddress,
              tokenSymbol: F.symbol
            });
            return;
          }
          const me = await u.layerZero.sendToken({
            bridgeAddress: _.bridgeAddress,
            dstEndpoint: te?.layerZero?.raw?.endpointID,
            userAddress: v,
            amount: en(k, F.decimals),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            walletClient: l,
            publicClient: ue
          });
          me && (qt({
            id: "transaction_bridge_success",
            params: {
              item_category: ae?.name,
              item_category2: be?.name,
              token: F.displaySymbol,
              value: k,
              item_variant: "layerZero"
            }
          }), o(), a("layerZero"), i(me), t());
        } else if (_.bridgeType === "meson") {
          if (!await u.meson.validateMesonToken({
            fromChainId: ae?.id,
            toChainId: be?.id,
            fromTokenAddress: F.meson?.raw?.addr ?? "0x0000000000000000000000000000000000000000",
            fromTokenSymbol: F.meson?.raw?.id,
            fromTokenDecimals: F.meson?.raw?.decimals,
            fromChainType: ae?.chainType,
            toChainType: be?.chainType,
            toTokenAddress: te?.meson?.raw?.addr ?? "0x0000000000000000000000000000000000000000",
            toTokenSymbol: te?.meson?.raw?.id,
            toTokenDecimals: te?.meson?.raw?.decimals,
            amount: Number(k),
            mesonEndpoint: D6e
          })) {
            L({
              message: "(Token Validation Failed) Invalid Meson token!!",
              fromChainId: ae?.id,
              tokenAddress: F.address,
              tokenSymbol: F.symbol
            });
            return;
          }
          let me = "", Be = "", We = "", ie = "";
          ae?.chainType === "tron" && b ? me = b : ae?.chainType !== "tron" && v && (me = v), T && x && K?.address ? Be = K.address : v && (Be = v);
          const f1 = await u.meson.getUnsignedMessage({
            fromToken: `${ae?.meson?.raw?.id}:${F?.meson?.raw?.id}`,
            toToken: `${be?.meson?.raw?.id}:${te?.meson?.raw?.id}`,
            amount: k,
            fromAddress: me,
            recipient: Be
          });
          if (f1?.result) {
            const s1 = f1.result, Ye = s1.encoded, B1 = s1.signingRequest.message;
            if (ae?.chainType === "tron") {
              const j1 = Ax(`TRON Signed Message:
32`);
              We = B1.replace(j1, "");
            } else {
              const j1 = Ax(`Ethereum Signed Message:
52`);
              We = B1.replace(j1, "");
            }
            ae?.chainType != "tron" ? ie = await A({
              account: v,
              message: {
                raw: We
              }
            }) : ie = String(await y(We));
            const Pe = await u.meson.sendToken({
              fromAddress: me,
              recipient: Be,
              signature: ie,
              encodedData: Ye
            });
            if (console.log("Meson swap id", Pe), Pe?.result?.swapId && (a("meson"), i(Pe?.result?.swapId)), Pe?.error)
              throw new Error(Pe?.error.message);
            qt({
              id: "transaction_bridge_success",
              params: {
                item_category: ae?.name,
                item_category2: be?.name,
                token: F.displaySymbol,
                value: k,
                item_variant: "meson"
              }
            }), o(), t();
          } else
            throw new Error(f1?.error.message);
        }
      } catch (Q) {
        console.error(Q, Q.message), L(Q);
      } finally {
        o(), _e(!1);
      }
  }, [
    e,
    F,
    _?.bridgeType,
    _?.bridgeAddress,
    _?.value,
    _?.data,
    ae,
    l,
    ue,
    J,
    v,
    ne,
    ye,
    fe,
    b,
    ee,
    be?.name,
    be?.meson?.raw?.id,
    k,
    n,
    i,
    a,
    r,
    c,
    u.cBridge,
    u.deBridge,
    u.stargate,
    u.layerZero,
    u.meson,
    o,
    t,
    I,
    M,
    te?.stargate?.raw,
    te?.layerZero?.raw,
    te?.meson?.raw,
    te?.cBridge?.raw,
    te?.deBridge?.raw,
    be?.id,
    be?.chainType,
    T,
    x,
    K.address,
    A,
    y,
    L,
    C
  ]), Ie = Me || $ || !_ || !oe;
  return /* @__PURE__ */ g(re, { className: "bccb-widget-transfer-summary-button", flexDir: "column", w: "100%", mt: "24px", children: /* @__PURE__ */ g(
    Hr,
    {
      bg: p.colors[h].button.brand.default,
      size: "lg",
      fontWeight: 500,
      h: "44px",
      w: "100%",
      _hover: {
        bg: p.colors[h].button.brand.hover,
        _disabled: { bg: p.colors[h].button.disabled }
      },
      onClick: Te,
      isDisabled: Ie,
      children: f({
        id: Ie ? "transfer.button.confirm-loading" : "transfer.button.confirm-summary"
      })
    }
  ) });
};
function Q8e(e) {
  return /* @__PURE__ */ g(
    U1,
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16px",
      height: "16px",
      viewBox: "0 0 16 16",
      fill: "none",
      ...e,
      children: /* @__PURE__ */ g(
        "path",
        {
          d: "M2.52912 14C2.3792 14 2.25351 13.9492 2.15203 13.8477C2.05068 13.7462 2 13.6204 2 13.4704C2 13.3203 2.05068 13.1946 2.15203 13.0933C2.25351 12.9919 2.3792 12.9412 2.52912 12.9412H3.30921V8.52941H2.52912C2.3792 8.52941 2.25351 8.47865 2.15203 8.37712C2.05068 8.27559 2 8.14982 2 7.99982C2 7.84971 2.05068 7.724 2.15203 7.62271C2.25351 7.52129 2.3792 7.47059 2.52912 7.47059H3.30921V3.05882H2.52912C2.3792 3.05882 2.25351 3.00806 2.15203 2.90653C2.05068 2.805 2 2.67924 2 2.52924C2 2.37912 2.05068 2.25341 2.15203 2.15212C2.25351 2.05071 2.3792 2 2.52912 2H13.4709C13.6208 2 13.7464 2.05076 13.8478 2.15229C13.9493 2.25382 14 2.37959 14 2.52959C14 2.67971 13.9493 2.80541 13.8478 2.90671C13.7464 3.00812 13.6208 3.05882 13.4709 3.05882H12.6975V7.47059H13.4709C13.6208 7.47059 13.7464 7.52135 13.8478 7.62288C13.9493 7.72441 14 7.85018 14 8.00018C14 8.15029 13.9493 8.276 13.8478 8.37729C13.7464 8.47871 13.6208 8.52941 13.4709 8.52941H12.6975V12.9412H13.4709C13.6208 12.9412 13.7464 12.9919 13.8478 13.0935C13.9493 13.195 14 13.3208 14 13.4708C14 13.6209 13.9493 13.7466 13.8478 13.8479C13.7464 13.9493 13.6208 14 13.4709 14H2.52912ZM4.36744 12.9412H11.6393V8.52941H11.4629C11.313 8.52941 11.1873 8.47865 11.086 8.37712C10.9845 8.27559 10.9338 8.14982 10.9338 7.99982C10.9338 7.84971 10.9845 7.724 11.086 7.62271C11.1873 7.52129 11.313 7.47059 11.4629 7.47059H11.6393V3.05882H4.36744V7.47059H4.54381C4.69373 7.47059 4.81937 7.52135 4.92072 7.62288C5.02219 7.72441 5.07293 7.85018 5.07293 8.00018C5.07293 8.15029 5.02219 8.276 4.92072 8.37729C4.81937 8.47871 4.69373 8.52941 4.54381 8.52941H4.36744V12.9412ZM8.00247 10.5996C8.54123 10.5996 8.99938 10.4138 9.37694 10.0423C9.75461 9.67077 9.94344 9.22124 9.94344 8.69371C9.94344 8.481 9.91922 8.29682 9.87078 8.14118C9.82245 7.98553 9.72274 7.80724 9.57165 7.60629L8.48784 6.32177C8.35839 6.17 8.19513 6.09412 7.99806 6.09412C7.80111 6.09412 7.63873 6.16971 7.51092 6.32088L6.43505 7.59553C6.28396 7.79635 6.18425 7.97506 6.13592 8.13165C6.08748 8.28812 6.06326 8.47435 6.06326 8.69035C6.06326 9.21929 6.2518 9.66971 6.62888 10.0416C7.00597 10.4136 7.46383 10.5996 8.00247 10.5996Z",
          fill: "currentColor"
        }
      )
    }
  );
}
const q8e = ({ title: e, value: t }) => {
  const n = Xe();
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-route-info-tooltip-fee",
      flexDir: "row",
      color: n.colors.light.text.primary,
      gap: "4px",
      children: [
        /* @__PURE__ */ g(h1, { fontSize: "12px", fontWeight: 400, children: e }),
        /* @__PURE__ */ g(h1, { fontSize: "12px", fontWeight: 700, children: t })
      ]
    }
  );
}, y6 = (e) => {
  const { iconProps: t, children: n, isDisabled: r = !1, ...o } = e, i = Gt({ base: !0, md: !1 }) ?? !1, { isOpen: a, onOpen: l, onToggle: c, onClose: u } = wo(), f = we(() => {
    const p = n || /* @__PURE__ */ g(K9, { display: "inline", w: "16px", h: "16px" });
    return w.cloneElement(p, {
      ...t,
      ...i && {
        onMouseEnter: l,
        onMouseLeave: u,
        onClick: (h) => {
          c(), p.props.onClick?.(h);
        }
      }
    });
  }, [n, t, i, u, l, c]);
  return o.label ? r ? /* @__PURE__ */ g(st, { children: f }) : /* @__PURE__ */ g(
    TI,
    {
      hasArrow: !0,
      className: "bccb-widget-info-tooltip",
      placement: "top",
      ...i && {
        isOpen: a
      },
      ...o,
      children: f
    }
  ) : null;
}, b2 = ({ bridgeType: e, isError: t }) => {
  const n = Xe(), { colorMode: r } = Ee(), { formatMessage: o } = n1(), i = N((l) => l.transfer.routeFees), a = we(() => {
    let l = "";
    const c = [];
    return e === "cBridge" && i?.cBridge ? (l = i?.cBridge.summary, c.push(...i?.cBridge.breakdown)) : e === "deBridge" && i?.deBridge ? (l = i?.deBridge.summary, c.push(...i?.deBridge.breakdown)) : e === "stargate" && i?.stargate ? (l = i?.stargate.summary, c.push(...i?.stargate.breakdown)) : e === "layerZero" && i?.layerZero ? (l = i?.layerZero.summary, c.push(...i?.layerZero.breakdown)) : e === "meson" && i?.meson && (l = i?.meson.summary, c.push(...i?.meson.breakdown)), { summary: l || "--", breakdown: c };
  }, [e, i]);
  return /* @__PURE__ */ X(
    h1,
    {
      className: "bccb-widget-route-fee-info",
      color: n.colors[r].text.tertiary,
      display: "inline-block",
      lineHeight: "16px",
      opacity: t ? 0.5 : 1,
      sx: {
        ">svg": {
          verticalAlign: "-3px"
        }
      },
      children: [
        /* @__PURE__ */ g(Q8e, { w: "16px", h: "16px", mr: "4px" }),
        /* @__PURE__ */ g(
          h1,
          {
            className: "bccb-widget-route-info-label",
            mr: "4px",
            as: "span",
            display: "inline",
            fontSize: "14px",
            lineHeight: "16px",
            fontWeight: 400,
            children: o({ id: "route.fees.title" })
          }
        ),
        /* @__PURE__ */ g(
          h1,
          {
            className: "bccb-widget-route-info-text",
            mr: "4px",
            as: "span",
            display: "inline",
            fontSize: "14px",
            lineHeight: "16px",
            fontWeight: 500,
            children: a.summary
          }
        ),
        /* @__PURE__ */ g(
          y6,
          {
            label: a.breakdown && a.breakdown?.length > 0 ? a.breakdown.map((l, c) => l.value !== "0" && l.value !== null ? /* @__PURE__ */ g(
              q8e,
              {
                title: l.label,
                value: l.value
              },
              `${e}-${c}-fee`
            ) : null) : null
          }
        )
      ]
    }
  );
};
function K8e(e) {
  if (!e)
    return "-";
  const t = parseInt(e.toString());
  if (t < 60)
    return `${t}s`;
  const n = Math.floor(t / 60), o = t - n * 60 <= 30 ? n : n + 1;
  return `${o}${o > 1 ? " mins" : " min"}`;
}
const ece = (e) => new Promise((t) => setTimeout(t, e));
function tce(e) {
  return /* @__PURE__ */ g(
    U1,
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16px",
      height: "16px",
      viewBox: "0 0 16 16",
      fill: "none",
      ...e,
      children: /* @__PURE__ */ g(
        "path",
        {
          d: "M8.49999 7.79734V5.1665C8.49999 5.02484 8.45205 4.90606 8.35616 4.81017C8.26027 4.71439 8.14149 4.6665 7.99982 4.6665C7.85805 4.6665 7.73932 4.71439 7.64366 4.81017C7.54788 4.90606 7.49999 5.02484 7.49999 5.1665V7.95117C7.49999 8.02962 7.51455 8.10562 7.54366 8.17917C7.57266 8.25273 7.61838 8.32073 7.68082 8.38317L9.96416 10.6665C10.0564 10.7588 10.1724 10.8061 10.3122 10.8082C10.4519 10.8103 10.5701 10.7631 10.6667 10.6665C10.7632 10.5699 10.8115 10.4528 10.8115 10.3152C10.8115 10.1776 10.7632 10.0606 10.6667 9.964L8.49999 7.79734ZM8.00116 14.3332C7.12516 14.3332 6.30177 14.1669 5.53099 13.8345C4.76021 13.5021 4.08977 13.0509 3.51966 12.481C2.94955 11.9111 2.49816 11.2409 2.16549 10.4705C1.83293 9.70006 1.66666 8.87689 1.66666 8.001C1.66666 7.125 1.83288 6.30161 2.16532 5.53084C2.49777 4.76006 2.94893 4.08961 3.51882 3.5195C4.08871 2.94939 4.75888 2.498 5.52932 2.16534C6.29977 1.83278 7.12293 1.6665 7.99882 1.6665C8.87482 1.6665 9.69821 1.83273 10.469 2.16517C11.2398 2.49761 11.9102 2.94878 12.4803 3.51867C13.0504 4.08856 13.5018 4.75873 13.8345 5.52917C14.167 6.29962 14.3333 7.12278 14.3333 7.99867C14.3333 8.87467 14.1671 9.69806 13.8347 10.4688C13.5022 11.2396 13.051 11.9101 12.4812 12.4802C11.9113 13.0503 11.2411 13.5017 10.4707 13.8343C9.70021 14.1669 8.87705 14.3332 8.00116 14.3332ZM7.99999 13.3332C9.47777 13.3332 10.7361 12.8137 11.775 11.7748C12.8139 10.7359 13.3333 9.47762 13.3333 7.99984C13.3333 6.52206 12.8139 5.26373 11.775 4.22484C10.7361 3.18595 9.47777 2.6665 7.99999 2.6665C6.52221 2.6665 5.26388 3.18595 4.22499 4.22484C3.1861 5.26373 2.66666 6.52206 2.66666 7.99984C2.66666 9.47762 3.1861 10.7359 4.22499 11.7748C5.26388 12.8137 6.52221 13.3332 7.99999 13.3332Z",
          fill: "currentColor"
        }
      )
    }
  );
}
const _M = () => {
  const e = N((a) => a.transfer.selectedToken), { toTokenInfo: t } = Vn(), n = fa(), r = e?.stargate?.raw?.endpointID, o = t?.stargate?.raw?.endpointID, i = r?.toString().startsWith("30") && o?.toString().startsWith("30");
  return gi({
    queryKey: ["stargate-bus-wait-time", r, o],
    queryFn: async () => await n.stargate.getBusQueueTime({
      fromEndpointId: String(r),
      toEndpointId: String(o)
    }),
    enabled: !!r && !!o && i,
    staleTime: 1e3 * 30
  });
}, FM = ({
  srcChainId: e,
  dstChainId: t,
  isEnabled: n = !1
}) => {
  const r = fa();
  return gi({
    queryKey: ["cbridge-transfer-waiting-time", e, t],
    queryFn: async () => await r.cBridge.getEstimatedWaitingTime({
      srcChainId: e,
      dstChainId: t
    }),
    enabled: !!e && !!t && n && !!r?.cBridge
  });
}, v2 = ({
  bridgeType: e,
  isError: t,
  ...n
}) => {
  const r = Xe(), { colorMode: o } = Ee(), { formatMessage: i } = n1(), a = N((h) => h.transfer.estimatedAmount), l = N((h) => h.transfer.fromChain), c = N((h) => h.transfer.toChain), { data: u } = _M(), { data: f } = FM({
    srcChainId: l?.id,
    dstChainId: c?.id,
    isEnabled: e === "cBridge"
  }), p = we(() => e === "cBridge" ? f?.median_transfer_latency_in_second : e === "deBridge" ? a?.deBridge?.order?.approximateFulfillmentDelay : e === "stargate" && u?.avgWaitTime ? u?.avgWaitTime / 1e3 : null, [e, f, a, u]);
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-route-estimated-time",
      gap: "4px",
      flexDir: "row",
      alignItems: "center",
      opacity: t ? 0.5 : 1,
      color: r.colors[o].text.tertiary,
      lineHeight: "16px",
      ...n,
      children: [
        /* @__PURE__ */ g(tce, { w: "16px", h: "16px" }),
        /* @__PURE__ */ g(h1, { className: "bccb-widget-route-info-label", fontSize: ["14px"], fontWeight: 400, children: i({ id: "route.time.title" }) }),
        p ? /* @__PURE__ */ X(h1, { className: "bccb-widget-route-info-text", fontSize: "14px", fontWeight: 500, children: [
          "~",
          K8e(p)
        ] }) : "--"
      ]
    }
  );
}, nce = () => {
  const e = Xe(), { colorMode: t } = Ee(), n = N((i) => i.transfer.transferActionInfo), r = N((i) => i.transfer.isGlobalFeeLoading), o = we(() => n?.bridgeType, [n]);
  return /* @__PURE__ */ g(
    h1,
    {
      mt: "8px",
      p: "12px",
      h: ["auto", "auto", "60px"],
      borderRadius: "8px",
      bg: e.colors[t].background.modal,
      className: "bccb-widget-transaction-summary-modal-fee-summary",
      children: r ? /* @__PURE__ */ X(re, { flexDir: "column", gap: "8px", children: [
        /* @__PURE__ */ g(Vt, { height: "12px", maxW: "333px", w: "100%", borderRadius: "4px" }),
        /* @__PURE__ */ g(Vt, { height: "12px", maxW: "371px", w: "100%", borderRadius: "4px" })
      ] }) : /* @__PURE__ */ X(st, { children: [
        /* @__PURE__ */ g(b2, { bridgeType: o }),
        /* @__PURE__ */ g(v2, { bridgeType: o })
      ] })
    }
  );
}, Oc = 2 * Math.PI * 20.5, rce = (e) => {
  const t = N((a) => a.transfer.isGlobalFeeLoading), n = N((a) => a.transfer.isRefreshing), r = N(
    (a) => a.transfer.refreshAnimationProgress
  ), o = Math.random().toString(36).substring(7), i = Oc - r * Oc;
  return /* @__PURE__ */ X(
    U1,
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "42px",
      height: "42px",
      viewBox: "0 0 42 42",
      fill: "none",
      ...e,
      children: [
        /* @__PURE__ */ g(
          "circle",
          {
            className: !t && !n ? "refreshBorder" : "",
            cx: "21",
            cy: "21",
            r: "20.5",
            fill: "currentColor",
            stroke: "#FFE900",
            strokeDasharray: Oc,
            strokeDashoffset: i
          }
        ),
        /* @__PURE__ */ g(
          "mask",
          {
            id: `mask0_28149_328880_${o}`,
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "11",
            y: "11",
            width: "20",
            height: "20",
            children: /* @__PURE__ */ g("rect", { x: "11", y: "11", width: "20", height: "20", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ g("g", { mask: `url(#mask0_28149_328880_${o})`, children: /* @__PURE__ */ g(
          "path",
          {
            d: "M21.0447 27.4596C19.2423 27.4596 17.7084 26.8325 16.443 25.5782C15.1775 24.3239 14.5447 22.7982 14.5447 21.0013V20.3507L13.4422 21.4532C13.3268 21.5686 13.1817 21.6276 13.007 21.6303C12.8324 21.6329 12.6847 21.5739 12.5639 21.4532C12.4432 21.3325 12.3828 21.1862 12.3828 21.0142C12.3828 20.8421 12.4432 20.6957 12.5639 20.5751L14.6424 18.4965C14.7931 18.3458 14.9689 18.2705 15.1697 18.2705C15.3705 18.2705 15.5463 18.3458 15.697 18.4965L17.7755 20.5751C17.8908 20.6905 17.9498 20.8355 17.9526 21.0101C17.9552 21.1848 17.8962 21.3325 17.7755 21.4532C17.6547 21.5739 17.5083 21.6342 17.3364 21.6342C17.1644 21.6342 17.018 21.5739 16.8972 21.4532L15.7947 20.3507V21.0013C15.7947 22.4489 16.3043 23.6789 17.3234 24.6913C18.3427 25.7035 19.5832 26.2096 21.0447 26.2096C21.2883 26.2096 21.5311 26.1931 21.773 26.1601C22.0151 26.1269 22.2536 26.0702 22.4886 25.9901C22.666 25.9367 22.8334 25.9423 22.9909 26.0069C23.1486 26.0715 23.2669 26.1813 23.3459 26.3363C23.425 26.4998 23.43 26.6624 23.3611 26.8242C23.2923 26.986 23.1691 27.0937 22.9918 27.1471C22.6777 27.2582 22.3567 27.3381 22.0286 27.3867C21.7007 27.4353 21.3727 27.4596 21.0447 27.4596ZM20.9614 15.793C20.7177 15.793 20.475 15.8095 20.233 15.8426C19.9909 15.8757 19.7524 15.9324 19.5174 16.0126C19.34 16.0659 19.1705 16.0603 19.0086 15.9957C18.8468 15.9311 18.7264 15.8213 18.6472 15.6663C18.5682 15.5114 18.5618 15.3531 18.628 15.1913C18.6943 15.0294 18.8118 14.9217 18.9805 14.8684C19.3032 14.7573 19.6298 14.6753 19.9605 14.6223C20.2912 14.5694 20.6248 14.543 20.9614 14.543C22.7637 14.543 24.2976 15.1701 25.563 16.4244C26.8286 17.6787 27.4614 19.2044 27.4614 21.0013V21.6519L28.5639 20.5494C28.6793 20.434 28.8243 20.375 28.9991 20.3723C29.1736 20.3697 29.3214 20.4287 29.4422 20.5494C29.5629 20.6701 29.6232 20.8164 29.6232 20.9884C29.6232 21.1605 29.5629 21.3069 29.4422 21.4276L27.3636 23.5061C27.213 23.6568 27.0372 23.7321 26.8364 23.7321C26.6355 23.7321 26.4598 23.6568 26.3091 23.5061L24.2305 21.4276C24.1152 21.3121 24.0562 21.1671 24.0534 20.9926C24.0508 20.8178 24.1098 20.6701 24.2305 20.5494C24.3514 20.4287 24.4977 20.3684 24.6697 20.3684C24.8416 20.3684 24.988 20.4287 25.1089 20.5494L26.2114 21.6519V21.0013C26.2114 19.5537 25.7018 18.3237 24.6826 17.3113C23.6633 16.2991 22.4229 15.793 20.9614 15.793Z",
            fill: "#FFE900"
          }
        ) })
      ]
    }
  );
}, ch = ({
  iconProps: e,
  boxProps: t
}) => {
  const { colorMode: n } = Ee(), r = Xe(), o = D1(), i = N((u) => u.transfer.isGlobalFeeLoading), a = N((u) => u.transfer.transferActionInfo), l = N((u) => u.transfer.isRefreshing), c = Lt();
  return a ? /* @__PURE__ */ g(
    h1,
    {
      className: "bccb-widget-refreshing-button",
      cursor: !i && !l ? "pointer" : "not-allowed",
      color: r.colors[n].button.refresh.text,
      _hover: {
        color: !i && !l ? r.colors[n].support.brand[4] : r.colors[n].button.refresh.text
      },
      onClick: () => {
        o(d0(!0)), o(Mo(!0));
      },
      ...t,
      children: c.components.refreshingIcon ?? /* @__PURE__ */ g(rce, { ...e })
    }
  ) : null;
};
function oce(e) {
  const {
    isOpen: t,
    onClose: n,
    onOpenSubmittedModal: r,
    onOpenFailedModal: o,
    onOpenConfirmingModal: i,
    onCloseConfirmingModal: a,
    setHash: l,
    setChosenBridge: c
  } = e, u = Xe(), { colorMode: f } = Ee(), { formatMessage: p } = n1(), h = N((C) => C.transfer.isGlobalFeeLoading);
  return /* @__PURE__ */ X(i3, { isOpen: t, onClose: n, size: { md: "lg" }, isCentered: !0, children: [
    /* @__PURE__ */ g(
      s3,
      {
        bg: "black",
        className: "bccb-widget-transaction-summary-modal-overlap",
        w: "100%"
      }
    ),
    /* @__PURE__ */ X(
      a3,
      {
        className: "bccb-widget-transaction-summary-modal-content",
        background: u.colors[f].background.body,
        p: 0,
        w: ["100%", "435px"],
        overflow: ["auto", "auto", "auto", "hidden"],
        mx: "20px",
        children: [
          /* @__PURE__ */ X(
            re,
            {
              className: "bccb-widget-transaction-summary-modal-header",
              h: "64px",
              px: "20px",
              py: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              lineHeight: 1.4,
              fontWeight: 500,
              fontSize: "20px",
              borderBottom: `1px solid ${u.colors[f].border[3]}`,
              flexShrink: 0,
              children: [
                /* @__PURE__ */ g(re, { boxSize: "24px", children: h ? /* @__PURE__ */ g(J9, { className: "skeleton", w: "24px", h: "24px" }) : /* @__PURE__ */ g(
                  ch,
                  {
                    iconProps: {
                      h: "24px",
                      w: "24px"
                    }
                  }
                ) }),
                p({ id: "modal.summary.title" }),
                /* @__PURE__ */ g(
                  d2,
                  {
                    boxSize: "24px",
                    onClick: n,
                    cursor: "pointer",
                    color: u.colors[f].modal.close.default,
                    _hover: {
                      color: u.colors[f].modal.close.hover
                    }
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ g(
            re,
            {
              className: "bccb-widget-transaction-summary-modal-wrapper",
              flexDir: "column",
              p: ["20px", "20px", "20px 20px 24px"],
              flex: 1,
              children: /* @__PURE__ */ X(re, { flexDir: "column", mt: 0, flex: 1, overflowY: "auto", children: [
                /* @__PURE__ */ g(X8e, {}),
                /* @__PURE__ */ g(nce, {}),
                /* @__PURE__ */ g(
                  J8e,
                  {
                    onClose: n,
                    onOpenSubmittedModal: r,
                    onOpenFailedModal: o,
                    onOpenConfirmingModal: i,
                    onCloseConfirmingModal: a,
                    setHash: l,
                    setChosenBridge: c
                  }
                )
              ] })
            }
          )
        ]
      }
    )
  ] });
}
function x6() {
  const { connection: e } = U0(), { publicKey: t } = Ho();
  return gi({
    queryKey: ["useSolanaBalance", t],
    refetchInterval: l6,
    enabled: !!t,
    queryFn: async () => {
      const n = await e.getBalance(t);
      return {
        formatted: String(n / pw),
        symbol: "SOL",
        value: BigInt(n)
      };
    }
  });
}
const ice = ({ text: e, ...t }) => {
  const { data: n } = x6(), r = Number(n?.formatted);
  return N((i) => i.transfer.fromChain)?.chainType === "solana" && r < th ? /* @__PURE__ */ g(RM, { text: e, ...t }) : null;
}, ace = (e) => {
  const { ...t } = e, { formatMessage: n } = n1();
  return /* @__PURE__ */ g(
    g2,
    {
      className: "bccb-widget-quote-error-modal",
      type: "error",
      title: n({ id: "modal.quote.error.title" }),
      description: n({ id: "modal.quote.error.desc" }),
      buttonText: n({ id: "modal.quote.error.button.close" }),
      bodyProps: {
        px: ["16px", "16px", "40px"]
      },
      footerProps: {
        pb: ["32px", "32px", "40px"],
        px: ["16px", "16px", "40px"]
      },
      ...t
    }
  );
}, sce = (e) => {
  const { ...t } = e, { formatMessage: n } = n1();
  return /* @__PURE__ */ g(
    g2,
    {
      className: "bccb-widget-fee-timeout-modal",
      type: "error",
      title: n({ id: "modal.fee-timeout.error.title" }),
      description: n({ id: "modal.fee-timeout.error.desc" }),
      buttonText: n({ id: "modal.fee-timeout.error.button.close" }),
      bodyProps: {
        px: ["16px", "16px", "40px"]
      },
      footerProps: {
        pb: ["32px", "32px", "40px"],
        px: ["16px", "16px", "40px"]
      },
      ...t
    }
  );
}, PM = () => {
  const e = D1(), t = se(() => {
    e(yd(!0));
  }, [e]), n = se(() => {
    e(yd(!1));
  }, [e]);
  return {
    onOpenFailedGetQuoteModal: t,
    onCloseFailedGetQuoteModal: n
  };
}, lce = () => {
  const e = D1(), t = se(() => {
    e(F0(!0));
  }, [e]), n = se(() => {
    e(F0(!1));
  }, [e]);
  return {
    onOpenSummaryModal: t,
    onCloseSummaryModal: n
  };
}, VM = () => {
  const e = D1(), t = se(() => {
    e(xd(!0));
  }, [e]), n = se(() => {
    e(xd(!1)), e(oa(""));
  }, [e]);
  return {
    onOpenFeeTimeoutModal: t,
    onCloseFeeTimeoutModal: n
  };
}, cce = () => {
  const [e, t] = ze(null), [n, r] = ze(null), { formatMessage: o } = n1(), i = N(
    (_) => _.transfer.isFailedGetQuoteModalOpen
  ), a = N((_) => _.transfer.isFeeTimeoutModalOpen), l = N((_) => _.transfer.isSummaryModalOpen), {
    isOpen: c,
    onOpen: u,
    onClose: f
  } = wo(), {
    isOpen: p,
    onOpen: h,
    onClose: C
  } = wo(), {
    isOpen: v,
    onOpen: b,
    onClose: y
  } = wo(), {
    isOpen: x,
    onOpen: T,
    onClose: A
  } = wo(), { onCloseFailedGetQuoteModal: L } = PM(), { onCloseFeeTimeoutModal: I } = VM(), { onCloseSummaryModal: M, onOpenSummaryModal: k } = lce();
  return /* @__PURE__ */ X(st, { children: [
    /* @__PURE__ */ X(
      re,
      {
        className: "bccb-widget-transfer-button-container",
        mt: { base: "8px", md: "16px" },
        flexDir: "column",
        children: [
          /* @__PURE__ */ g(D8e, { children: /* @__PURE__ */ g(
            E8e,
            {
              onOpenFailedModal: h,
              onOpenApproveModal: b,
              onCloseConfirmingModal: A,
              onOpenSummaryModal: k,
              setChosenBridge: r
            }
          ) }),
          /* @__PURE__ */ g(
            ice,
            {
              text: o(
                { id: "transfer.warning.sol.balance" },
                { min: th }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ g(
      F8e,
      {
        isOpen: c,
        onClose: f,
        hash: e || "",
        chosenBridge: n || ""
      }
    ),
    /* @__PURE__ */ g(P8e, { isOpen: p, onClose: C }),
    /* @__PURE__ */ g(
      H8e,
      {
        isOpen: v,
        onClose: y,
        onOpenConfirmingModal: T,
        onCloseConfirmingModal: A
      }
    ),
    /* @__PURE__ */ g(O8e, { isOpen: x, onClose: A }),
    /* @__PURE__ */ g(
      oce,
      {
        isOpen: l,
        onClose: M,
        onOpenSubmittedModal: u,
        onOpenFailedModal: h,
        onOpenApproveModal: b,
        onOpenConfirmingModal: T,
        onCloseConfirmingModal: A,
        setHash: t,
        setChosenBridge: r
      }
    ),
    /* @__PURE__ */ g(
      ace,
      {
        isOpen: i,
        onClose: L
      }
    ),
    /* @__PURE__ */ g(sce, { isOpen: a, onClose: I })
  ] });
};
function HM(e) {
  const { isActive: t = !1, chain: n, ...r } = e, o = Xe(), { colorMode: i } = Ee();
  return /* @__PURE__ */ X(
    Hr,
    {
      className: "bccb-widget-network-button",
      borderRadius: "8px",
      flexShrink: 0,
      h: "48px",
      padding: "12px",
      justifyContent: "space-between",
      gap: "8px",
      background: o.colors[i].input.background,
      color: o.colors[i].text.primary,
      transitionDuration: "normal",
      outline: t ? `2px solid ${o.colors[i].input.border.active}` : `1px solid ${o.colors[i].input.border.default}`,
      _hover: {
        outline: "2px solid",
        outlineColor: o.colors[i].input.border.hover
      },
      _active: {},
      ...r,
      children: [
        /* @__PURE__ */ X(re, { gap: "8px", alignItems: "center", position: "relative", overflow: "hidden", children: [
          /* @__PURE__ */ g(
            Bo,
            {
              boxSize: "24px",
              src: n?.icon,
              fallbackBgColor: o.colors[i].support.primary[4]
            }
          ),
          /* @__PURE__ */ g(
            re,
            {
              className: "bccb-widget-network-name",
              flexDir: "column",
              alignItems: "flex-start",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textAlign: "left",
              sx: {
                p: {
                  w: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }
              },
              children: /* @__PURE__ */ g(_n, { fontSize: "16px", lineHeight: "24px", fontWeight: 400, children: n?.name ?? "" })
            }
          )
        ] }),
        /* @__PURE__ */ g(yp, { w: "24px", h: "24px", color: o.colors[i].button.select.arrow })
      ]
    }
  );
}
const w6 = 0, pa = 1, js = 2, OM = 4;
function NM(e, t) {
  return (n) => e(t(n));
}
function uce(e, t) {
  return t(e);
}
function DM(e, t) {
  return (n) => e(t, n);
}
function Mx(e, t) {
  return () => e(t);
}
function S6(e, t) {
  return t(e), e;
}
function Et(...e) {
  return e;
}
function dce(e) {
  e();
}
function Bx(e) {
  return () => e;
}
function fce(...e) {
  return () => {
    e.map(dce);
  };
}
function uh(e) {
  return e !== void 0;
}
function Xs() {
}
function nt(e, t) {
  return e(pa, t);
}
function T1(e, t) {
  e(w6, t);
}
function dh(e) {
  e(js);
}
function xn(e) {
  return e(OM);
}
function Qe(e, t) {
  return nt(e, DM(t, w6));
}
function Fo(e, t) {
  const n = e(pa, (r) => {
    n(), t(r);
  });
  return n;
}
function H1() {
  const e = [];
  return (t, n) => {
    switch (t) {
      case js:
        e.splice(0, e.length);
        return;
      case pa:
        return e.push(n), () => {
          const r = e.indexOf(n);
          r > -1 && e.splice(r, 1);
        };
      case w6:
        e.slice().forEach((r) => {
          r(n);
        });
        return;
      default:
        throw new Error(`unrecognized action ${t}`);
    }
  };
}
function ke(e) {
  let t = e;
  const n = H1();
  return (r, o) => {
    switch (r) {
      case pa:
        o(t);
        break;
      case w6:
        t = o;
        break;
      case OM:
        return t;
    }
    return n(r, o);
  };
}
function pce(e) {
  let t, n;
  const r = () => t && t();
  return function(o, i) {
    switch (o) {
      case pa:
        return i ? n === i ? void 0 : (r(), n = i, t = nt(e, i), t) : (r(), Xs);
      case js:
        r(), n = null;
        return;
      default:
        throw new Error(`unrecognized action ${o}`);
    }
  };
}
function ar(e) {
  return S6(H1(), (t) => Qe(e, t));
}
function Fn(e, t) {
  return S6(ke(t), (n) => Qe(e, n));
}
function hce(...e) {
  return (t) => e.reduceRight(uce, t);
}
function Ae(e, ...t) {
  const n = hce(...t);
  return (r, o) => {
    switch (r) {
      case pa:
        return nt(e, n(o));
      case js:
        dh(e);
        return;
    }
  };
}
function ZM(e, t) {
  return e === t;
}
function It(e = ZM) {
  let t;
  return (n) => (r) => {
    e(t, r) || (t = r, n(r));
  };
}
function d1(e) {
  return (t) => (n) => {
    e(n) && t(n);
  };
}
function Ze(e) {
  return (t) => NM(t, e);
}
function vo(e) {
  return (t) => () => t(e);
}
function To(e, t) {
  return (n) => (r) => n(t = e(t, r));
}
function Fs(e) {
  return (t) => (n) => {
    e > 0 ? e-- : t(n);
  };
}
function Qi(e) {
  let t = null, n;
  return (r) => (o) => {
    t = o, !n && (n = setTimeout(() => {
      n = void 0, r(t);
    }, e));
  };
}
function kx(e) {
  let t, n;
  return (r) => (o) => {
    t = o, n && clearTimeout(n), n = setTimeout(() => {
      r(t);
    }, e);
  };
}
function A1(...e) {
  const t = new Array(e.length);
  let n = 0, r = null;
  const o = Math.pow(2, e.length) - 1;
  return e.forEach((i, a) => {
    const l = Math.pow(2, a);
    nt(i, (c) => {
      const u = n;
      n = n | l, t[a] = c, u !== o && n === o && r && (r(), r = null);
    });
  }), (i) => (a) => {
    const l = () => i([a].concat(t));
    n === o ? l() : r = l;
  };
}
function Rx(...e) {
  return function(t, n) {
    switch (t) {
      case pa:
        return fce(...e.map((r) => nt(r, n)));
      case js:
        return;
      default:
        throw new Error(`unrecognized action ${t}`);
    }
  };
}
function u1(e, t = ZM) {
  return Ae(e, It(t));
}
function sn(...e) {
  const t = H1(), n = new Array(e.length);
  let r = 0;
  const o = Math.pow(2, e.length) - 1;
  return e.forEach((i, a) => {
    const l = Math.pow(2, a);
    nt(i, (c) => {
      n[a] = c, r = r | l, r === o && T1(t, n);
    });
  }), function(i, a) {
    switch (i) {
      case pa:
        return r === o && a(n), nt(t, a);
      case js:
        return dh(t);
      default:
        throw new Error(`unrecognized action ${i}`);
    }
  };
}
function rt(e, t = [], { singleton: n } = { singleton: !0 }) {
  return {
    id: mce(),
    constructor: e,
    dependencies: t,
    singleton: n
  };
}
const mce = () => Symbol();
function Cce(e) {
  const t = /* @__PURE__ */ new Map(), n = ({ id: r, constructor: o, dependencies: i, singleton: a }) => {
    if (a && t.has(r))
      return t.get(r);
    const l = o(i.map((c) => n(c)));
    return a && t.set(r, l), l;
  };
  return n(e);
}
function gce(e, t) {
  const n = {}, r = {};
  let o = 0;
  const i = e.length;
  for (; o < i; )
    r[e[o]] = 1, o += 1;
  for (const a in t)
    r.hasOwnProperty(a) || (n[a] = t[a]);
  return n;
}
const hl = typeof document < "u" ? w.useLayoutEffect : w.useEffect;
function zM(e, t, n) {
  const r = Object.keys(t.required || {}), o = Object.keys(t.optional || {}), i = Object.keys(t.methods || {}), a = Object.keys(t.events || {}), l = w.createContext({});
  function c(x, T) {
    x.propsReady && T1(x.propsReady, !1);
    for (const A of r) {
      const L = x[t.required[A]];
      T1(L, T[A]);
    }
    for (const A of o)
      if (A in T) {
        const L = x[t.optional[A]];
        T1(L, T[A]);
      }
    x.propsReady && T1(x.propsReady, !0);
  }
  function u(x) {
    return i.reduce((T, A) => (T[A] = (L) => {
      const I = x[t.methods[A]];
      T1(I, L);
    }, T), {});
  }
  function f(x) {
    return a.reduce((T, A) => (T[A] = pce(x[t.events[A]]), T), {});
  }
  const p = w.forwardRef((x, T) => {
    const { children: A, ...L } = x, [I] = w.useState(() => S6(Cce(e), (_) => c(_, L))), [M] = w.useState(Mx(f, I));
    hl(() => {
      for (const _ of a)
        _ in L && nt(M[_], L[_]);
      return () => {
        Object.values(M).map(dh);
      };
    }, [L, M, I]), hl(() => {
      c(I, L);
    }), w.useImperativeHandle(T, Bx(u(I)));
    const k = n;
    return /* @__PURE__ */ g(l.Provider, { value: I, children: n ? /* @__PURE__ */ g(k, { ...gce([...r, ...o, ...a], L), children: A }) : A });
  }), h = (x) => w.useCallback(DM(T1, w.useContext(l)[x]), [x]), C = (x) => {
    const A = w.useContext(l)[x], L = w.useCallback(
      (I) => nt(A, I),
      [A]
    );
    return w.useSyncExternalStore(
      L,
      () => xn(A),
      () => xn(A)
    );
  }, v = (x) => {
    const A = w.useContext(l)[x], [L, I] = w.useState(Mx(xn, A));
    return hl(
      () => nt(A, (M) => {
        M !== L && I(Bx(M));
      }),
      [A, L]
    ), L;
  }, b = w.version.startsWith("18") ? C : v;
  return {
    Component: p,
    usePublisher: h,
    useEmitterValue: b,
    useEmitter: (x, T) => {
      const L = w.useContext(l)[x];
      hl(() => nt(L, T), [T, L]);
    }
  };
}
const GM = typeof document < "u" ? w.useLayoutEffect : w.useEffect;
var sr = /* @__PURE__ */ ((e) => (e[e.DEBUG = 0] = "DEBUG", e[e.INFO = 1] = "INFO", e[e.WARN = 2] = "WARN", e[e.ERROR = 3] = "ERROR", e))(sr || {});
const bce = {
  0: "debug",
  1: "log",
  2: "warn",
  3: "error"
}, vce = () => typeof globalThis > "u" ? window : globalThis, ha = rt(
  () => {
    const e = ke(
      3
      /* ERROR */
    );
    return {
      log: ke((n, r, o = 1) => {
        var i;
        const a = (i = vce().VIRTUOSO_LOG_LEVEL) != null ? i : xn(e);
        o >= a && console[bce[o]](
          "%creact-virtuoso: %c%s %o",
          "color: #0253b3; font-weight: bold",
          "color: initial",
          n,
          r
        );
      }),
      logLevel: e
    };
  },
  [],
  { singleton: !0 }
);
function fh(e, t, n) {
  const r = w.useRef(null);
  let o = (i) => {
  };
  if (typeof ResizeObserver < "u") {
    const i = w.useMemo(() => new ResizeObserver((a) => {
      const l = () => {
        const c = a[0].target;
        c.offsetParent !== null && e(c);
      };
      n ? l() : requestAnimationFrame(l);
    }), [e]);
    o = (a) => {
      a && t ? (i.observe(a), r.current = a) : (r.current && i.unobserve(r.current), r.current = null);
    };
  }
  return { ref: r, callbackRef: o };
}
function y2(e, t, n) {
  return fh(e, t, n).callbackRef;
}
function yce(e, t, n, r, o, i, a, l, c) {
  const u = w.useCallback(
    (f) => {
      const p = xce(f.children, t, l ? "offsetWidth" : "offsetHeight", o);
      let h = f.parentElement;
      for (; !h.dataset.virtuosoScroller; )
        h = h.parentElement;
      const C = h.lastElementChild.dataset.viewportType === "window", v = a ? l ? a.scrollLeft : a.scrollTop : C ? l ? window.pageXOffset || document.documentElement.scrollLeft : window.pageYOffset || document.documentElement.scrollTop : l ? h.scrollLeft : h.scrollTop, b = a ? l ? a.scrollWidth : a.scrollHeight : C ? l ? document.documentElement.scrollWidth : document.documentElement.scrollHeight : l ? h.scrollWidth : h.scrollHeight, y = a ? l ? a.offsetWidth : a.offsetHeight : C ? l ? window.innerWidth : window.innerHeight : l ? h.offsetWidth : h.offsetHeight;
      r({
        scrollTop: Math.max(v, 0),
        scrollHeight: b,
        viewportHeight: y
      }), i?.(
        l ? _x("column-gap", getComputedStyle(f).columnGap, o) : _x("row-gap", getComputedStyle(f).rowGap, o)
      ), p !== null && e(p);
    },
    [e, t, o, i, a, r]
  );
  return fh(u, n, c);
}
function xce(e, t, n, r) {
  const o = e.length;
  if (o === 0)
    return null;
  const i = [];
  for (let a = 0; a < o; a++) {
    const l = e.item(a);
    if (!l || l.dataset.index === void 0)
      continue;
    const c = parseInt(l.dataset.index), u = parseFloat(l.dataset.knownSize), f = t(l, n);
    if (f === 0 && r("Zero-sized element, this should not happen", { child: l }, sr.ERROR), f === u)
      continue;
    const p = i[i.length - 1];
    i.length === 0 || p.size !== f || p.endIndex !== c - 1 ? i.push({ startIndex: c, endIndex: c, size: f }) : i[i.length - 1].endIndex++;
  }
  return i;
}
function _x(e, t, n) {
  return t !== "normal" && !t?.endsWith("px") && n(`${e} was not resolved to pixel value correctly`, t, sr.WARN), t === "normal" ? 0 : parseInt(t ?? "0", 10);
}
function ia(e, t) {
  return Math.round(e.getBoundingClientRect()[t]);
}
function WM(e, t) {
  return Math.abs(e - t) < 1.01;
}
function $M(e, t, n, r = Xs, o, i) {
  const a = w.useRef(null), l = w.useRef(null), c = w.useRef(null), u = w.useCallback(
    (h) => {
      const C = h.target, v = C === window || C === document, b = i ? v ? window.pageXOffset || document.documentElement.scrollLeft : C.scrollLeft : v ? window.pageYOffset || document.documentElement.scrollTop : C.scrollTop, y = i ? v ? document.documentElement.scrollWidth : C.scrollWidth : v ? document.documentElement.scrollHeight : C.scrollHeight, x = i ? v ? window.innerWidth : C.offsetWidth : v ? window.innerHeight : C.offsetHeight, T = () => {
        e({
          scrollTop: Math.max(b, 0),
          scrollHeight: y,
          viewportHeight: x
        });
      };
      h.suppressFlushSync ? T() : lH.flushSync(T), l.current !== null && (b === l.current || b <= 0 || b === y - x) && (l.current = null, t(!0), c.current && (clearTimeout(c.current), c.current = null));
    },
    [e, t]
  );
  w.useEffect(() => {
    const h = o || a.current;
    return r(o || a.current), u({ target: h, suppressFlushSync: !0 }), h.addEventListener("scroll", u, { passive: !0 }), () => {
      r(null), h.removeEventListener("scroll", u);
    };
  }, [a, u, n, r, o]);
  function f(h) {
    const C = a.current;
    if (!C || (i ? "offsetWidth" in C && C.offsetWidth === 0 : "offsetHeight" in C && C.offsetHeight === 0))
      return;
    const v = h.behavior === "smooth";
    let b, y, x;
    C === window ? (y = Math.max(
      ia(document.documentElement, i ? "width" : "height"),
      i ? document.documentElement.scrollWidth : document.documentElement.scrollHeight
    ), b = i ? window.innerWidth : window.innerHeight, x = i ? document.documentElement.scrollLeft : document.documentElement.scrollTop) : (y = C[i ? "scrollWidth" : "scrollHeight"], b = ia(C, i ? "width" : "height"), x = C[i ? "scrollLeft" : "scrollTop"]);
    const T = y - b;
    if (h.top = Math.ceil(Math.max(Math.min(T, h.top), 0)), WM(b, y) || h.top === x) {
      e({ scrollTop: x, scrollHeight: y, viewportHeight: b }), v && t(!0);
      return;
    }
    v ? (l.current = h.top, c.current && clearTimeout(c.current), c.current = setTimeout(() => {
      c.current = null, l.current = null, t(!0);
    }, 1e3)) : l.current = null, i && (h = { left: h.top, behavior: h.behavior }), C.scrollTo(h);
  }
  function p(h) {
    i && (h = { left: h.top, behavior: h.behavior }), a.current.scrollBy(h);
  }
  return { scrollerRef: a, scrollByCallback: p, scrollToCallback: f };
}
const Hn = rt(
  () => {
    const e = H1(), t = H1(), n = ke(0), r = H1(), o = ke(0), i = H1(), a = H1(), l = ke(0), c = ke(0), u = ke(0), f = ke(0), p = H1(), h = H1(), C = ke(!1), v = ke(!1), b = ke(!1);
    return Qe(
      Ae(
        e,
        Ze(({ scrollTop: y }) => y)
      ),
      t
    ), Qe(
      Ae(
        e,
        Ze(({ scrollHeight: y }) => y)
      ),
      a
    ), Qe(t, o), {
      // input
      scrollContainerState: e,
      scrollTop: t,
      viewportHeight: i,
      headerHeight: l,
      fixedHeaderHeight: c,
      fixedFooterHeight: u,
      footerHeight: f,
      scrollHeight: a,
      smoothScrollTargetReached: r,
      horizontalDirection: v,
      skipAnimationFrameInResizeObserver: b,
      // signals
      scrollTo: p,
      scrollBy: h,
      // state
      statefulScrollTop: o,
      deviation: n,
      scrollingInProgress: C
    };
  },
  [],
  { singleton: !0 }
), H0 = { lvl: 0 };
function UM(e, t, n, r = H0, o = H0) {
  return { k: e, v: t, lvl: n, l: r, r: o };
}
function ht(e) {
  return e === H0;
}
function Cs() {
  return H0;
}
function Bd(e, t) {
  if (ht(e)) return H0;
  const { k: n, l: r, r: o } = e;
  if (t === n) {
    if (ht(r))
      return o;
    if (ht(o))
      return r;
    {
      const [i, a] = jM(r);
      return zl(Jt(e, { k: i, v: a, l: XM(r) }));
    }
  } else return t < n ? zl(Jt(e, { l: Bd(r, t) })) : zl(Jt(e, { r: Bd(o, t) }));
}
function O0(e, t) {
  if (!ht(e))
    return t === e.k ? e.v : t < e.k ? O0(e.l, t) : O0(e.r, t);
}
function no(e, t, n = "k") {
  if (ht(e))
    return [-1 / 0, void 0];
  if (Number(e[n]) === t)
    return [e.k, e.v];
  if (Number(e[n]) < t) {
    const r = no(e.r, t, n);
    return r[0] === -1 / 0 ? [e.k, e.v] : r;
  }
  return no(e.l, t, n);
}
function tr(e, t, n) {
  return ht(e) ? UM(t, n, 1) : t === e.k ? Jt(e, { k: t, v: n }) : t < e.k ? Fx(Jt(e, { l: tr(e.l, t, n) })) : Fx(Jt(e, { r: tr(e.r, t, n) }));
}
function kd(e, t, n) {
  if (ht(e))
    return [];
  const { k: r, v: o, l: i, r: a } = e;
  let l = [];
  return r > t && (l = l.concat(kd(i, t, n))), r >= t && r <= n && l.push({ k: r, v: o }), r <= n && (l = l.concat(kd(a, t, n))), l;
}
function Na(e) {
  return ht(e) ? [] : [...Na(e.l), { k: e.k, v: e.v }, ...Na(e.r)];
}
function jM(e) {
  return ht(e.r) ? [e.k, e.v] : jM(e.r);
}
function XM(e) {
  return ht(e.r) ? e.l : zl(Jt(e, { r: XM(e.r) }));
}
function Jt(e, t) {
  return UM(
    t.k !== void 0 ? t.k : e.k,
    t.v !== void 0 ? t.v : e.v,
    t.lvl !== void 0 ? t.lvl : e.lvl,
    t.l !== void 0 ? t.l : e.l,
    t.r !== void 0 ? t.r : e.r
  );
}
function Nc(e) {
  return ht(e) || e.lvl > e.r.lvl;
}
function Fx(e) {
  return Rd(JM(e));
}
function zl(e) {
  const { l: t, r: n, lvl: r } = e;
  if (n.lvl >= r - 1 && t.lvl >= r - 1)
    return e;
  if (r > n.lvl + 1) {
    if (Nc(t))
      return JM(Jt(e, { lvl: r - 1 }));
    if (!ht(t) && !ht(t.r))
      return Jt(t.r, {
        l: Jt(t, { r: t.r.l }),
        r: Jt(e, {
          l: t.r.r,
          lvl: r - 1
        }),
        lvl: r
      });
    throw new Error("Unexpected empty nodes");
  } else {
    if (Nc(e))
      return Rd(Jt(e, { lvl: r - 1 }));
    if (!ht(n) && !ht(n.l)) {
      const o = n.l, i = Nc(o) ? n.lvl - 1 : n.lvl;
      return Jt(o, {
        l: Jt(e, {
          r: o.l,
          lvl: r - 1
        }),
        r: Rd(Jt(n, { l: o.r, lvl: i })),
        lvl: o.lvl + 1
      });
    } else
      throw new Error("Unexpected empty nodes");
  }
}
function T6(e, t, n) {
  if (ht(e))
    return [];
  const r = no(e, t)[0];
  return wce(kd(e, r, n));
}
function YM(e, t) {
  const n = e.length;
  if (n === 0)
    return [];
  let { index: r, value: o } = t(e[0]);
  const i = [];
  for (let a = 1; a < n; a++) {
    const { index: l, value: c } = t(e[a]);
    i.push({ start: r, end: l - 1, value: o }), r = l, o = c;
  }
  return i.push({ start: r, end: 1 / 0, value: o }), i;
}
function wce(e) {
  return YM(e, ({ k: t, v: n }) => ({ index: t, value: n }));
}
function Rd(e) {
  const { r: t, lvl: n } = e;
  return !ht(t) && !ht(t.r) && t.lvl === n && t.r.lvl === n ? Jt(t, { l: Jt(e, { r: t.l }), lvl: n + 1 }) : e;
}
function JM(e) {
  const { l: t } = e;
  return !ht(t) && t.lvl === e.lvl ? Jt(t, { r: Jt(e, { l: t.r }) }) : e;
}
function A9(e, t, n, r = 0) {
  let o = e.length - 1;
  for (; r <= o; ) {
    const i = Math.floor((r + o) / 2), a = e[i], l = n(a, t);
    if (l === 0)
      return i;
    if (l === -1) {
      if (o - r < 2)
        return i - 1;
      o = i - 1;
    } else {
      if (o === r)
        return i;
      r = i + 1;
    }
  }
  throw new Error(`Failed binary finding record in array - ${e.join(",")}, searched for ${t}`);
}
function QM(e, t, n) {
  return e[A9(e, t, n)];
}
function Sce(e, t, n, r) {
  const o = A9(e, t, r), i = A9(e, n, r, o);
  return e.slice(o, i + 1);
}
const ph = rt(
  () => ({ recalcInProgress: ke(!1) }),
  [],
  { singleton: !0 }
);
function Tce(e) {
  const { size: t, startIndex: n, endIndex: r } = e;
  return (o) => o.start === n && (o.end === r || o.end === 1 / 0) && o.value === t;
}
function Px(e, t) {
  let n = 0, r = 0;
  for (; n < e; )
    n += t[r + 1] - t[r] - 1, r++;
  return r - (n === e ? 0 : 1);
}
function Ace(e, t) {
  let n = ht(e) ? 0 : 1 / 0;
  for (const r of t) {
    const { size: o, startIndex: i, endIndex: a } = r;
    if (n = Math.min(n, i), ht(e)) {
      e = tr(e, 0, o);
      continue;
    }
    const l = T6(e, i - 1, a + 1);
    if (l.some(Tce(r)))
      continue;
    let c = !1, u = !1;
    for (const { start: f, end: p, value: h } of l)
      c ? (a >= f || o === h) && (e = Bd(e, f)) : (u = h !== o, c = !0), p > a && a >= f && h !== o && (e = tr(e, a + 1, h));
    u && (e = tr(e, i, o));
  }
  return [e, n];
}
function Ice() {
  return {
    offsetTree: [],
    sizeTree: Cs(),
    groupOffsetTree: Cs(),
    lastIndex: 0,
    lastOffset: 0,
    lastSize: 0,
    groupIndices: []
  };
}
function hh({ index: e }, t) {
  return t === e ? 0 : t < e ? -1 : 1;
}
function Lce({ offset: e }, t) {
  return t === e ? 0 : t < e ? -1 : 1;
}
function Ece(e) {
  return { index: e.index, value: e };
}
function Mce(e, t, n, r = 0) {
  return r > 0 && (t = Math.max(t, QM(e, r, hh).offset)), YM(Sce(e, t, n, Lce), Ece);
}
function _d(e, t, n, r) {
  let o = e, i = 0, a = 0, l = 0, c = 0;
  if (t !== 0) {
    c = A9(o, t - 1, hh), l = o[c].offset;
    const f = no(n, t - 1);
    i = f[0], a = f[1], o.length && o[c].size === no(n, t)[1] && (c -= 1), o = o.slice(0, c + 1);
  } else
    o = [];
  for (const { start: u, value: f } of T6(n, t, 1 / 0)) {
    const p = u - i, h = p * a + l + p * r;
    o.push({
      offset: h,
      size: f,
      index: u
    }), i = u, l = h, a = f;
  }
  return {
    offsetTree: o,
    lastIndex: i,
    lastOffset: l,
    lastSize: a
  };
}
function Bce(e, [t, n, r, o]) {
  t.length > 0 && r("received item sizes", t, sr.DEBUG);
  const i = e.sizeTree;
  let a = i, l = 0;
  if (n.length > 0 && ht(i) && t.length === 2) {
    const h = t[0].size, C = t[1].size;
    a = n.reduce((v, b) => tr(tr(v, b, h), b + 1, C), a);
  } else
    [a, l] = Ace(a, t);
  if (a === i)
    return e;
  const { offsetTree: c, lastIndex: u, lastSize: f, lastOffset: p } = _d(e.offsetTree, l, a, o);
  return {
    sizeTree: a,
    offsetTree: c,
    lastIndex: u,
    lastOffset: p,
    lastSize: f,
    groupOffsetTree: n.reduce((h, C) => tr(h, C, N0(C, c, o)), Cs()),
    groupIndices: n
  };
}
function N0(e, t, n) {
  if (t.length === 0)
    return 0;
  const { offset: r, index: o, size: i } = QM(t, e, hh), a = e - o, l = i * a + (a - 1) * n + r;
  return l > 0 ? l + n : l;
}
function kce(e) {
  return typeof e.groupIndex < "u";
}
function qM(e, t, n) {
  if (kce(e))
    return t.groupIndices[e.groupIndex] + 1;
  {
    const r = e.index === "LAST" ? n : e.index;
    let o = KM(r, t);
    return o = Math.max(0, o, Math.min(n, o)), o;
  }
}
function KM(e, t) {
  if (!A6(t))
    return e;
  let n = 0;
  for (; t.groupIndices[n] <= e + n; )
    n++;
  return e + n;
}
function A6(e) {
  return !ht(e.groupOffsetTree);
}
function Rce(e) {
  return Na(e).map(({ k: t, v: n }, r, o) => {
    const i = o[r + 1], a = i ? i.k - 1 : 1 / 0;
    return { startIndex: t, endIndex: a, size: n };
  });
}
const _ce = {
  offsetHeight: "height",
  offsetWidth: "width"
}, Oo = rt(
  ([{ log: e }, { recalcInProgress: t }]) => {
    const n = H1(), r = H1(), o = Fn(r, 0), i = H1(), a = H1(), l = ke(0), c = ke([]), u = ke(void 0), f = ke(void 0), p = ke((I, M) => ia(I, _ce[M])), h = ke(void 0), C = ke(0), v = Ice(), b = Fn(
      Ae(n, A1(c, e, C), To(Bce, v), It()),
      v
    ), y = Fn(
      Ae(
        c,
        It(),
        To((I, M) => ({ prev: I.current, current: M }), {
          prev: [],
          current: []
        }),
        Ze(({ prev: I }) => I)
      ),
      []
    );
    Qe(
      Ae(
        c,
        d1((I) => I.length > 0),
        A1(b, C),
        Ze(([I, M, k]) => {
          const _ = I.reduce((F, $, oe) => tr(F, $, N0($, M.offsetTree, k) || oe), Cs());
          return {
            ...M,
            groupIndices: I,
            groupOffsetTree: _
          };
        })
      ),
      b
    ), Qe(
      Ae(
        r,
        A1(b),
        d1(([I, { lastIndex: M }]) => I < M),
        Ze(([I, { lastIndex: M, lastSize: k }]) => [
          {
            startIndex: I,
            endIndex: M,
            size: k
          }
        ])
      ),
      n
    ), Qe(u, f);
    const x = Fn(
      Ae(
        u,
        Ze((I) => I === void 0)
      ),
      !0
    );
    Qe(
      Ae(
        f,
        d1((I) => I !== void 0 && ht(xn(b).sizeTree)),
        Ze((I) => [{ startIndex: 0, endIndex: 0, size: I }])
      ),
      n
    );
    const T = ar(
      Ae(
        n,
        A1(b),
        To(
          ({ sizes: I }, [M, k]) => ({
            changed: k !== I,
            sizes: k
          }),
          { changed: !1, sizes: v }
        ),
        Ze((I) => I.changed)
      )
    );
    nt(
      Ae(
        l,
        To(
          (I, M) => ({ diff: I.prev - M, prev: M }),
          { diff: 0, prev: 0 }
        ),
        Ze((I) => I.diff)
      ),
      (I) => {
        const { groupIndices: M } = xn(b);
        if (I > 0)
          T1(t, !0), T1(i, I + Px(I, M));
        else if (I < 0) {
          const k = xn(y);
          k.length > 0 && (I -= Px(-I, k)), T1(a, I);
        }
      }
    ), nt(Ae(l, A1(e)), ([I, M]) => {
      I < 0 && M(
        "`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value",
        { firstItemIndex: l },
        sr.ERROR
      );
    });
    const A = ar(i);
    Qe(
      Ae(
        i,
        A1(b),
        Ze(([I, M]) => {
          const k = M.groupIndices.length > 0, _ = [], F = M.lastSize;
          if (k) {
            const $ = O0(M.sizeTree, 0);
            let oe = 0, te = 0;
            for (; oe < I; ) {
              const K = M.groupIndices[te], ue = M.groupIndices.length === te + 1 ? 1 / 0 : M.groupIndices[te + 1] - K - 1;
              _.push({
                startIndex: K,
                endIndex: K,
                size: $
              }), _.push({
                startIndex: K + 1,
                endIndex: K + 1 + ue - 1,
                size: F
              }), te++, oe += ue + 1;
            }
            const ae = Na(M.sizeTree);
            return oe !== I && ae.shift(), ae.reduce(
              (K, { k: ue, v: J }) => {
                let Me = K.ranges;
                return K.prevSize !== 0 && (Me = [
                  ...K.ranges,
                  {
                    startIndex: K.prevIndex,
                    endIndex: ue + I - 1,
                    size: K.prevSize
                  }
                ]), {
                  ranges: Me,
                  prevIndex: ue + I,
                  prevSize: J
                };
              },
              {
                ranges: _,
                prevIndex: I,
                prevSize: 0
              }
            ).ranges;
          }
          return Na(M.sizeTree).reduce(
            ($, { k: oe, v: te }) => ({
              ranges: [...$.ranges, { startIndex: $.prevIndex, endIndex: oe + I - 1, size: $.prevSize }],
              prevIndex: oe + I,
              prevSize: te
            }),
            {
              ranges: [],
              prevIndex: 0,
              prevSize: F
            }
          ).ranges;
        })
      ),
      n
    );
    const L = ar(
      Ae(
        a,
        A1(b, C),
        Ze(([I, { offsetTree: M }, k]) => {
          const _ = -I;
          return N0(_, M, k);
        })
      )
    );
    return Qe(
      Ae(
        a,
        A1(b, C),
        Ze(([I, M, k]) => {
          if (M.groupIndices.length > 0) {
            if (ht(M.sizeTree))
              return M;
            let F = Cs();
            const $ = xn(y);
            let oe = 0, te = 0, ae = 0;
            for (; oe < -I; ) {
              ae = $[te];
              const K = $[te + 1] - ae - 1;
              te++, oe += K + 1;
            }
            if (F = Na(M.sizeTree).reduce((K, { k: ue, v: J }) => tr(K, Math.max(0, ue + I), J), F), oe !== -I) {
              const K = O0(M.sizeTree, ae);
              F = tr(F, 0, K);
              const ue = no(M.sizeTree, -I + 1)[1];
              F = tr(F, 1, ue);
            }
            return {
              ...M,
              sizeTree: F,
              ..._d(M.offsetTree, 0, F, k)
            };
          } else {
            const F = Na(M.sizeTree).reduce(($, { k: oe, v: te }) => tr($, Math.max(0, oe + I), te), Cs());
            return {
              ...M,
              sizeTree: F,
              ..._d(M.offsetTree, 0, F, k)
            };
          }
        })
      ),
      b
    ), {
      // input
      data: h,
      totalCount: r,
      sizeRanges: n,
      groupIndices: c,
      defaultItemSize: f,
      fixedItemSize: u,
      unshiftWith: i,
      shiftWith: a,
      shiftWithOffset: L,
      beforeUnshiftWith: A,
      firstItemIndex: l,
      gap: C,
      // output
      sizes: b,
      listRefresh: T,
      statefulTotalCount: o,
      trackItemSizes: x,
      itemSize: p
    };
  },
  Et(ha, ph),
  { singleton: !0 }
), Fce = typeof document < "u" && "scrollBehavior" in document.documentElement.style;
function eB(e) {
  const t = typeof e == "number" ? { index: e } : e;
  return t.align || (t.align = "start"), (!t.behavior || !Fce) && (t.behavior = "auto"), t.offset || (t.offset = 0), t;
}
const y3 = rt(
  ([
    { sizes: e, totalCount: t, listRefresh: n, gap: r },
    {
      scrollingInProgress: o,
      viewportHeight: i,
      scrollTo: a,
      smoothScrollTargetReached: l,
      headerHeight: c,
      footerHeight: u,
      fixedHeaderHeight: f,
      fixedFooterHeight: p
    },
    { log: h }
  ]) => {
    const C = H1(), v = H1(), b = ke(0);
    let y = null, x = null, T = null;
    function A() {
      y && (y(), y = null), T && (T(), T = null), x && (clearTimeout(x), x = null), T1(o, !1);
    }
    return Qe(
      Ae(
        C,
        A1(e, i, t, b, c, u, h),
        A1(r, f, p),
        Ze(
          ([
            [L, I, M, k, _, F, $, oe],
            te,
            ae,
            be
          ]) => {
            const K = eB(L), { align: ue, behavior: J, offset: Me } = K, _e = k - 1, ne = qM(K, I, _e);
            let ee = N0(ne, I.offsetTree, te) + F;
            ue === "end" ? (ee += ae + no(I.sizeTree, ne)[1] - M + be, ne === _e && (ee += $)) : ue === "center" ? ee += (ae + no(I.sizeTree, ne)[1] - M + be) / 2 : ee -= _, Me && (ee += Me);
            const ye = (fe) => {
              A(), fe ? (oe("retrying to scroll to", { location: L }, sr.DEBUG), T1(C, L)) : (T1(v, !0), oe("list did not change, scroll successful", {}, sr.DEBUG));
            };
            if (A(), J === "smooth") {
              let fe = !1;
              T = nt(n, (xe) => {
                fe = fe || xe;
              }), y = Fo(l, () => {
                ye(fe);
              });
            } else
              y = Fo(Ae(n, Pce(150)), ye);
            return x = setTimeout(() => {
              A();
            }, 1200), T1(o, !0), oe("scrolling from index to", { index: ne, top: ee, behavior: J }, sr.DEBUG), { top: ee, behavior: J };
          }
        )
      ),
      a
    ), {
      scrollToIndex: C,
      scrollTargetReached: v,
      topListHeight: b
    };
  },
  Et(Oo, Hn, ha),
  { singleton: !0 }
);
function Pce(e) {
  return (t) => {
    const n = setTimeout(() => {
      t(!1);
    }, e);
    return (r) => {
      r && (t(!0), clearTimeout(n));
    };
  };
}
const D0 = "up", f0 = "down", Vce = "none", Hce = {
  atBottom: !1,
  notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
  state: {
    offsetBottom: 0,
    scrollTop: 0,
    viewportHeight: 0,
    scrollHeight: 0
  }
}, Oce = 0, x3 = rt(([{ scrollContainerState: e, scrollTop: t, viewportHeight: n, headerHeight: r, footerHeight: o, scrollBy: i }]) => {
  const a = ke(!1), l = ke(!0), c = H1(), u = H1(), f = ke(4), p = ke(Oce), h = Fn(
    Ae(
      Rx(Ae(u1(t), Fs(1), vo(!0)), Ae(u1(t), Fs(1), vo(!1), kx(100))),
      It()
    ),
    !1
  ), C = Fn(
    Ae(Rx(Ae(i, vo(!0)), Ae(i, vo(!1), kx(200))), It()),
    !1
  );
  Qe(
    Ae(
      sn(u1(t), u1(p)),
      Ze(([T, A]) => T <= A),
      It()
    ),
    l
  ), Qe(Ae(l, Qi(50)), u);
  const v = ar(
    Ae(
      sn(e, u1(n), u1(r), u1(o), u1(f)),
      To((T, [{ scrollTop: A, scrollHeight: L }, I, M, k, _]) => {
        const F = A + I - L > -_, $ = {
          viewportHeight: I,
          scrollTop: A,
          scrollHeight: L
        };
        if (F) {
          let te, ae;
          return A > T.state.scrollTop ? (te = "SCROLLED_DOWN", ae = T.state.scrollTop - A) : (te = "SIZE_DECREASED", ae = T.state.scrollTop - A || T.scrollTopDelta), {
            atBottom: !0,
            state: $,
            atBottomBecause: te,
            scrollTopDelta: ae
          };
        }
        let oe;
        return $.scrollHeight > T.state.scrollHeight ? oe = "SIZE_INCREASED" : I < T.state.viewportHeight ? oe = "VIEWPORT_HEIGHT_DECREASING" : A < T.state.scrollTop ? oe = "SCROLLING_UPWARDS" : oe = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM", {
          atBottom: !1,
          notAtBottomBecause: oe,
          state: $
        };
      }, Hce),
      It((T, A) => T && T.atBottom === A.atBottom)
    )
  ), b = Fn(
    Ae(
      e,
      To(
        (T, { scrollTop: A, scrollHeight: L, viewportHeight: I }) => {
          if (WM(T.scrollHeight, L))
            return {
              scrollTop: A,
              scrollHeight: L,
              jump: 0,
              changed: !1
            };
          {
            const M = L - (A + I) < 1;
            return T.scrollTop !== A && M ? {
              scrollHeight: L,
              scrollTop: A,
              jump: T.scrollTop - A,
              changed: !0
            } : {
              scrollHeight: L,
              scrollTop: A,
              jump: 0,
              changed: !0
            };
          }
        },
        { scrollHeight: 0, jump: 0, scrollTop: 0, changed: !1 }
      ),
      d1((T) => T.changed),
      Ze((T) => T.jump)
    ),
    0
  );
  Qe(
    Ae(
      v,
      Ze((T) => T.atBottom)
    ),
    a
  ), Qe(Ae(a, Qi(50)), c);
  const y = ke(f0);
  Qe(
    Ae(
      e,
      Ze(({ scrollTop: T }) => T),
      It(),
      To(
        (T, A) => xn(C) ? { direction: T.direction, prevScrollTop: A } : { direction: A < T.prevScrollTop ? D0 : f0, prevScrollTop: A },
        { direction: f0, prevScrollTop: 0 }
      ),
      Ze((T) => T.direction)
    ),
    y
  ), Qe(Ae(e, Qi(50), vo(Vce)), y);
  const x = ke(0);
  return Qe(
    Ae(
      h,
      d1((T) => !T),
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      vo(0)
    ),
    x
  ), Qe(
    Ae(
      t,
      Qi(100),
      A1(h),
      d1(([T, A]) => !!A),
      To(([T, A], [L]) => [A, L], [0, 0]),
      Ze(([T, A]) => A - T)
    ),
    x
  ), {
    isScrolling: h,
    isAtTop: l,
    isAtBottom: a,
    atBottomState: v,
    atTopStateChange: u,
    atBottomStateChange: c,
    scrollDirection: y,
    atBottomThreshold: f,
    atTopThreshold: p,
    scrollVelocity: x,
    lastJumpDueToItemResize: b
  };
}, Et(Hn)), ma = rt(
  ([{ log: e }]) => {
    const t = ke(!1), n = ar(
      Ae(
        t,
        d1((r) => r),
        It()
      )
    );
    return nt(t, (r) => {
      r && xn(e)("props updated", {}, sr.DEBUG);
    }), { propsReady: t, didMount: n };
  },
  Et(ha),
  { singleton: !0 }
);
function mh(e, t) {
  e == 0 ? t() : requestAnimationFrame(() => mh(e - 1, t));
}
function Ch(e, t) {
  const n = t - 1;
  return typeof e == "number" ? e : e.index === "LAST" ? n : e.index;
}
const w3 = rt(
  ([{ sizes: e, listRefresh: t, defaultItemSize: n }, { scrollTop: r }, { scrollToIndex: o, scrollTargetReached: i }, { didMount: a }]) => {
    const l = ke(!0), c = ke(0), u = ke(!0);
    return Qe(
      Ae(
        a,
        A1(c),
        d1(([f, p]) => !!p),
        vo(!1)
      ),
      l
    ), Qe(
      Ae(
        a,
        A1(c),
        d1(([f, p]) => !!p),
        vo(!1)
      ),
      u
    ), nt(
      Ae(
        sn(t, a),
        A1(l, e, n, u),
        d1(([[, f], p, { sizeTree: h }, C, v]) => f && (!ht(h) || uh(C)) && !p && !v),
        A1(c)
      ),
      ([, f]) => {
        Fo(i, () => {
          T1(u, !0);
        }), mh(4, () => {
          Fo(r, () => {
            T1(l, !0);
          }), T1(o, f);
        });
      }
    ), {
      scrolledToInitialItem: l,
      initialTopMostItemIndex: c,
      initialItemFinalLocationReached: u
    };
  },
  Et(Oo, Hn, y3, ma),
  { singleton: !0 }
);
function Vx(e) {
  return e ? e === "smooth" ? "smooth" : "auto" : !1;
}
const Nce = (e, t) => typeof e == "function" ? Vx(e(t)) : t && Vx(e), Dce = rt(
  ([
    { totalCount: e, listRefresh: t },
    { isAtBottom: n, atBottomState: r },
    { scrollToIndex: o },
    { scrolledToInitialItem: i },
    { propsReady: a, didMount: l },
    { log: c },
    { scrollingInProgress: u }
  ]) => {
    const f = ke(!1), p = H1();
    let h = null;
    function C(b) {
      T1(o, {
        index: "LAST",
        align: "end",
        behavior: b
      });
    }
    nt(
      Ae(
        sn(Ae(u1(e), Fs(1)), l),
        A1(u1(f), n, i, u),
        Ze(([[b, y], x, T, A, L]) => {
          let I = y && A, M = "auto";
          return I && (M = Nce(x, T || L), I = I && !!M), { totalCount: b, shouldFollow: I, followOutputBehavior: M };
        }),
        d1(({ shouldFollow: b }) => b)
      ),
      ({ totalCount: b, followOutputBehavior: y }) => {
        h && (h(), h = null), h = Fo(t, () => {
          xn(c)("following output to ", { totalCount: b }, sr.DEBUG), C(y), h = null;
        });
      }
    );
    function v(b) {
      const y = Fo(r, (x) => {
        b && !x.atBottom && x.notAtBottomBecause === "SIZE_INCREASED" && !h && (xn(c)("scrolling to bottom due to increased size", {}, sr.DEBUG), C("auto"));
      });
      setTimeout(y, 100);
    }
    return nt(
      Ae(
        sn(u1(f), e, a),
        d1(([b, , y]) => b && y),
        To(
          ({ value: b }, [, y]) => ({ refreshed: b === y, value: y }),
          { refreshed: !1, value: 0 }
        ),
        d1(({ refreshed: b }) => b),
        A1(f, e)
      ),
      ([, b]) => {
        xn(i) && v(b !== !1);
      }
    ), nt(p, () => {
      v(xn(f) !== !1);
    }), nt(sn(u1(f), r), ([b, y]) => {
      b && !y.atBottom && y.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING" && C("auto");
    }), { followOutput: f, autoscrollToBottom: p };
  },
  Et(Oo, x3, y3, w3, ma, ha, Hn)
);
function Zce(e) {
  return e.reduce(
    (t, n) => (t.groupIndices.push(t.totalCount), t.totalCount += n + 1, t),
    {
      totalCount: 0,
      groupIndices: []
    }
  );
}
const tB = rt(([{ totalCount: e, groupIndices: t, sizes: n }, { scrollTop: r, headerHeight: o }]) => {
  const i = H1(), a = H1(), l = ar(Ae(i, Ze(Zce)));
  return Qe(
    Ae(
      l,
      Ze((c) => c.totalCount)
    ),
    e
  ), Qe(
    Ae(
      l,
      Ze((c) => c.groupIndices)
    ),
    t
  ), Qe(
    Ae(
      sn(r, n, o),
      d1(([c, u]) => A6(u)),
      Ze(([c, u, f]) => no(u.groupOffsetTree, Math.max(c - f, 0), "v")[0]),
      It(),
      Ze((c) => [c])
    ),
    a
  ), { groupCounts: i, topItemsIndexes: a };
}, Et(Oo, Hn));
function Z0(e, t) {
  return !!(e && e[0] === t[0] && e[1] === t[1]);
}
function nB(e, t) {
  return !!(e && e.startIndex === t.startIndex && e.endIndex === t.endIndex);
}
const I9 = "top", L9 = "bottom", Hx = "none";
function Ox(e, t, n) {
  return typeof e == "number" ? n === D0 && t === I9 || n === f0 && t === L9 ? e : 0 : n === D0 ? t === I9 ? e.main : e.reverse : t === L9 ? e.main : e.reverse;
}
function Nx(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const gh = rt(
  ([{ scrollTop: e, viewportHeight: t, deviation: n, headerHeight: r, fixedHeaderHeight: o }]) => {
    const i = H1(), a = ke(0), l = ke(0), c = ke(0), u = Fn(
      Ae(
        sn(
          u1(e),
          u1(t),
          u1(r),
          u1(i, Z0),
          u1(c),
          u1(a),
          u1(o),
          u1(n),
          u1(l)
        ),
        Ze(
          ([
            f,
            p,
            h,
            [C, v],
            b,
            y,
            x,
            T,
            A
          ]) => {
            const L = f - T, I = y + x, M = Math.max(h - L, 0);
            let k = Hx;
            const _ = Nx(A, I9), F = Nx(A, L9);
            return C -= T, C += h + x, v += h + x, v -= T, C > f + I - _ && (k = D0), v < f - M + p + F && (k = f0), k !== Hx ? [
              Math.max(L - h - Ox(b, I9, k) - _, 0),
              L - M - x + p + Ox(b, L9, k) + F
            ] : null;
          }
        ),
        d1((f) => f != null),
        It(Z0)
      ),
      [0, 0]
    );
    return {
      // input
      listBoundary: i,
      overscan: c,
      topListHeight: a,
      increaseViewportBy: l,
      // output
      visibleRange: u
    };
  },
  Et(Hn),
  { singleton: !0 }
);
function zce(e, t, n) {
  if (A6(t)) {
    const r = KM(e, t);
    return [
      { index: no(t.groupOffsetTree, r)[0], size: 0, offset: 0 },
      { index: r, size: 0, offset: 0, data: n && n[0] }
    ];
  }
  return [{ index: e, size: 0, offset: 0, data: n && n[0] }];
}
const Dc = {
  items: [],
  topItems: [],
  offsetTop: 0,
  offsetBottom: 0,
  top: 0,
  bottom: 0,
  topListHeight: 0,
  totalCount: 0,
  firstItemIndex: 0
};
function Dx(e, t, n) {
  if (e.length === 0)
    return [];
  if (!A6(t))
    return e.map((u) => ({ ...u, index: u.index + n, originalIndex: u.index }));
  const r = e[0].index, o = e[e.length - 1].index, i = [], a = T6(t.groupOffsetTree, r, o);
  let l, c = 0;
  for (const u of e) {
    (!l || l.end < u.index) && (l = a.shift(), c = t.groupIndices.indexOf(l.start));
    let f;
    u.index === l.start ? f = {
      type: "group",
      index: c
    } : f = {
      index: u.index - (c + 1) + n,
      groupIndex: c
    }, i.push({
      ...f,
      size: u.size,
      offset: u.offset,
      originalIndex: u.index,
      data: u.data
    });
  }
  return i;
}
function Gl(e, t, n, r, o, i) {
  const { lastSize: a, lastOffset: l, lastIndex: c } = o;
  let u = 0, f = 0;
  if (e.length > 0) {
    u = e[0].offset;
    const b = e[e.length - 1];
    f = b.offset + b.size;
  }
  const p = n - c, h = l + p * a + (p - 1) * r, C = u, v = h - f;
  return {
    items: Dx(e, o, i),
    topItems: Dx(t, o, i),
    topListHeight: t.reduce((b, y) => y.size + b, 0),
    offsetTop: u,
    offsetBottom: v,
    top: C,
    bottom: f,
    totalCount: n,
    firstItemIndex: i
  };
}
function rB(e, t, n, r, o, i) {
  let a = 0;
  if (n.groupIndices.length > 0)
    for (const f of n.groupIndices) {
      if (f - a >= e)
        break;
      a++;
    }
  const l = e + a, c = Ch(t, l), u = Array.from({ length: l }).map((f, p) => ({
    index: p + c,
    size: 0,
    offset: 0,
    data: i[p + c]
  }));
  return Gl(u, [], l, o, n, r);
}
const x2 = rt(
  ([
    { sizes: e, totalCount: t, data: n, firstItemIndex: r, gap: o },
    i,
    { visibleRange: a, listBoundary: l, topListHeight: c },
    { scrolledToInitialItem: u, initialTopMostItemIndex: f },
    { topListHeight: p },
    h,
    { didMount: C },
    { recalcInProgress: v }
  ]) => {
    const b = ke([]), y = ke(0), x = H1();
    Qe(i.topItemsIndexes, b);
    const T = Fn(
      Ae(
        sn(
          C,
          v,
          u1(a, Z0),
          u1(t),
          u1(e),
          u1(f),
          u,
          u1(b),
          u1(r),
          u1(o),
          n
        ),
        d1(([M, k, , _, , , , , , , F]) => {
          const $ = F && F.length !== _;
          return M && !k && !$;
        }),
        Ze(
          ([
            ,
            ,
            [M, k],
            _,
            F,
            $,
            oe,
            te,
            ae,
            be,
            K
          ]) => {
            const ue = F, { sizeTree: J, offsetTree: Me } = ue, _e = xn(y);
            if (_ === 0)
              return { ...Dc, totalCount: _ };
            if (M === 0 && k === 0)
              return _e === 0 ? { ...Dc, totalCount: _ } : rB(_e, $, F, ae, be, K || []);
            if (ht(J))
              return _e > 0 ? null : Gl(
                zce(Ch($, _), ue, K),
                [],
                _,
                be,
                ue,
                ae
              );
            const ne = [];
            if (te.length > 0) {
              const Te = te[0], Ie = te[te.length - 1];
              let Q = 0;
              for (const pe of T6(J, Te, Ie)) {
                const me = pe.value, Be = Math.max(pe.start, Te), We = Math.min(pe.end, Ie);
                for (let ie = Be; ie <= We; ie++)
                  ne.push({ index: ie, size: me, offset: Q, data: K && K[ie] }), Q += me;
              }
            }
            if (!oe)
              return Gl([], ne, _, be, ue, ae);
            const ee = te.length > 0 ? te[te.length - 1] + 1 : 0, ye = Mce(Me, M, k, ee);
            if (ye.length === 0)
              return null;
            const fe = _ - 1, xe = S6([], (Te) => {
              for (const Ie of ye) {
                const Q = Ie.value;
                let pe = Q.offset, me = Ie.start;
                const Be = Q.size;
                if (Q.offset < M) {
                  me += Math.floor((M - Q.offset + be) / (Be + be));
                  const ie = me - Ie.start;
                  pe += ie * Be + ie * be;
                }
                me < ee && (pe += (ee - me) * Be, me = ee);
                const We = Math.min(Ie.end, fe);
                for (let ie = me; ie <= We && !(pe >= k); ie++)
                  Te.push({ index: ie, size: Be, offset: pe, data: K && K[ie] }), pe += Be + be;
              }
            });
            return Gl(xe, ne, _, be, ue, ae);
          }
        ),
        //@ts-expect-error filter needs to be fixed
        d1((M) => M !== null),
        It()
      ),
      Dc
    );
    Qe(
      Ae(
        n,
        d1(uh),
        Ze((M) => M?.length)
      ),
      t
    ), Qe(
      Ae(
        T,
        Ze((M) => M.topListHeight)
      ),
      p
    ), Qe(p, c), Qe(
      Ae(
        T,
        Ze((M) => [M.top, M.bottom])
      ),
      l
    ), Qe(
      Ae(
        T,
        Ze((M) => M.items)
      ),
      x
    );
    const A = ar(
      Ae(
        T,
        d1(({ items: M }) => M.length > 0),
        A1(t, n),
        d1(([{ items: M }, k]) => M[M.length - 1].originalIndex === k - 1),
        Ze(([, M, k]) => [M - 1, k]),
        It(Z0),
        Ze(([M]) => M)
      )
    ), L = ar(
      Ae(
        T,
        Qi(200),
        d1(({ items: M, topItems: k }) => M.length > 0 && M[0].originalIndex === k.length),
        Ze(({ items: M }) => M[0].index),
        It()
      )
    ), I = ar(
      Ae(
        T,
        d1(({ items: M }) => M.length > 0),
        Ze(({ items: M }) => {
          let k = 0, _ = M.length - 1;
          for (; M[k].type === "group" && k < _; )
            k++;
          for (; M[_].type === "group" && _ > k; )
            _--;
          return {
            startIndex: M[k].index,
            endIndex: M[_].index
          };
        }),
        It(nB)
      )
    );
    return { listState: T, topItemsIndexes: b, endReached: A, startReached: L, rangeChanged: I, itemsRendered: x, initialItemCount: y, ...h };
  },
  Et(
    Oo,
    tB,
    gh,
    w3,
    y3,
    x3,
    ma,
    ph
  ),
  { singleton: !0 }
), Gce = rt(
  ([{ sizes: e, firstItemIndex: t, data: n, gap: r }, { initialTopMostItemIndex: o }, { initialItemCount: i, listState: a }, { didMount: l }]) => (Qe(
    Ae(
      l,
      A1(i),
      d1(([, c]) => c !== 0),
      A1(o, e, t, r, n),
      Ze(([[, c], u, f, p, h, C = []]) => rB(c, u, f, p, h, C))
    ),
    a
  ), {}),
  Et(Oo, w3, x2, ma),
  { singleton: !0 }
), oB = rt(
  ([{ scrollVelocity: e }]) => {
    const t = ke(!1), n = H1(), r = ke(!1);
    return Qe(
      Ae(
        e,
        A1(r, t, n),
        d1(([o, i]) => !!i),
        Ze(([o, i, a, l]) => {
          const { exit: c, enter: u } = i;
          if (a) {
            if (c(o, l))
              return !1;
          } else if (u(o, l))
            return !0;
          return a;
        }),
        It()
      ),
      t
    ), nt(
      Ae(sn(t, e, n), A1(r)),
      ([[o, i, a], l]) => o && l && l.change && l.change(i, a)
    ), { isSeeking: t, scrollSeekConfiguration: r, scrollVelocity: e, scrollSeekRangeChanged: n };
  },
  Et(x3),
  { singleton: !0 }
), Wce = rt(([{ topItemsIndexes: e }]) => {
  const t = ke(0);
  return Qe(
    Ae(
      t,
      d1((n) => n > 0),
      Ze((n) => Array.from({ length: n }).map((r, o) => o))
    ),
    e
  ), { topItemCount: t };
}, Et(x2)), iB = rt(
  ([{ footerHeight: e, headerHeight: t, fixedHeaderHeight: n, fixedFooterHeight: r }, { listState: o }]) => {
    const i = H1(), a = Fn(
      Ae(
        sn(e, r, t, n, o),
        Ze(([l, c, u, f, p]) => l + c + u + f + p.offsetBottom + p.bottom)
      ),
      0
    );
    return Qe(u1(a), i), { totalListHeight: a, totalListHeightChanged: i };
  },
  Et(Hn, x2),
  { singleton: !0 }
);
function aB(e) {
  let t = !1, n;
  return () => (t || (t = !0, n = e()), n);
}
const $ce = aB(() => /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent)), Uce = rt(
  ([
    { scrollBy: e, scrollTop: t, deviation: n, scrollingInProgress: r },
    { isScrolling: o, isAtBottom: i, scrollDirection: a, lastJumpDueToItemResize: l },
    { listState: c },
    { beforeUnshiftWith: u, shiftWithOffset: f, sizes: p, gap: h },
    { log: C },
    { recalcInProgress: v }
  ]) => {
    const b = ar(
      Ae(
        c,
        A1(l),
        To(
          ([, x, T, A], [{ items: L, totalCount: I, bottom: M, offsetBottom: k }, _]) => {
            const F = M + k;
            let $ = 0;
            return T === I && x.length > 0 && L.length > 0 && (L[0].originalIndex === 0 && x[0].originalIndex === 0 || ($ = F - A, $ !== 0 && ($ += _))), [$, L, I, F];
          },
          [0, [], 0, 0]
        ),
        d1(([x]) => x !== 0),
        A1(t, a, r, i, C, v),
        d1(([, x, T, A, , , L]) => !L && !A && x !== 0 && T === D0),
        Ze(([[x], , , , , T]) => (T("Upward scrolling compensation", { amount: x }, sr.DEBUG), x))
      )
    );
    function y(x) {
      x > 0 ? (T1(e, { top: -x, behavior: "auto" }), T1(n, 0)) : (T1(n, 0), T1(e, { top: -x, behavior: "auto" }));
    }
    return nt(Ae(b, A1(n, o)), ([x, T, A]) => {
      A && $ce() ? T1(n, T - x) : y(-x);
    }), nt(
      Ae(
        sn(Fn(o, !1), n, v),
        d1(([x, T, A]) => !x && !A && T !== 0),
        Ze(([x, T]) => T),
        Qi(1)
      ),
      y
    ), Qe(
      Ae(
        f,
        Ze((x) => ({ top: -x }))
      ),
      e
    ), nt(
      Ae(
        u,
        A1(p, h),
        Ze(([x, { lastSize: T, groupIndices: A, sizeTree: L }, I]) => {
          function M(k) {
            return k * (T + I);
          }
          if (A.length === 0)
            return M(x);
          {
            let k = 0;
            const _ = O0(L, 0);
            let F = 0, $ = 0;
            for (; F < x; ) {
              F++, k += _;
              let oe = A.length === $ + 1 ? 1 / 0 : A[$ + 1] - A[$] - 1;
              F + oe > x && (k -= _, oe = x - F + 1), F += oe, k += M(oe), $++;
            }
            return k;
          }
        })
      ),
      (x) => {
        T1(n, x), requestAnimationFrame(() => {
          T1(e, { top: x }), requestAnimationFrame(() => {
            T1(n, 0), T1(v, !1);
          });
        });
      }
    ), { deviation: n };
  },
  Et(Hn, x3, x2, Oo, ha, ph)
), jce = rt(
  ([{ didMount: e }, { scrollTo: t }, { listState: n }]) => {
    const r = ke(0);
    return nt(
      Ae(
        e,
        A1(r),
        d1(([, o]) => o !== 0),
        Ze(([, o]) => ({ top: o }))
      ),
      (o) => {
        Fo(
          Ae(
            n,
            Fs(1),
            d1((i) => i.items.length > 1)
          ),
          () => {
            requestAnimationFrame(() => {
              T1(t, o);
            });
          }
        );
      }
    ), {
      initialScrollTop: r
    };
  },
  Et(ma, Hn, x2),
  { singleton: !0 }
), Xce = rt(
  ([{ viewportHeight: e }, { totalListHeight: t }]) => {
    const n = ke(!1), r = Fn(
      Ae(
        sn(n, e, t),
        d1(([o]) => o),
        Ze(([, o, i]) => Math.max(0, o - i)),
        Qi(0),
        It()
      ),
      0
    );
    return { alignToBottom: n, paddingTopAddition: r };
  },
  Et(Hn, iB),
  { singleton: !0 }
), bh = rt(([{ scrollTo: e, scrollContainerState: t }]) => {
  const n = H1(), r = H1(), o = H1(), i = ke(!1), a = ke(void 0);
  return Qe(
    Ae(
      sn(n, r),
      Ze(([{ viewportHeight: l, scrollTop: c, scrollHeight: u }, { offsetTop: f }]) => ({
        scrollTop: Math.max(0, c - f),
        scrollHeight: u,
        viewportHeight: l
      }))
    ),
    t
  ), Qe(
    Ae(
      e,
      A1(r),
      Ze(([l, { offsetTop: c }]) => ({
        ...l,
        top: l.top + c
      }))
    ),
    o
  ), {
    // config
    useWindowScroll: i,
    customScrollParent: a,
    // input
    windowScrollContainerState: n,
    windowViewportRect: r,
    // signals
    windowScrollTo: o
  };
}, Et(Hn)), Yce = ({
  itemTop: e,
  itemBottom: t,
  viewportTop: n,
  viewportBottom: r,
  locationParams: { behavior: o, align: i, ...a }
}) => e < n ? { ...a, behavior: o, align: i ?? "start" } : t > r ? { ...a, behavior: o, align: i ?? "end" } : null, Jce = rt(
  ([
    { sizes: e, totalCount: t, gap: n },
    { scrollTop: r, viewportHeight: o, headerHeight: i, fixedHeaderHeight: a, fixedFooterHeight: l, scrollingInProgress: c },
    { scrollToIndex: u }
  ]) => {
    const f = H1();
    return Qe(
      Ae(
        f,
        A1(e, o, t, i, a, l, r),
        A1(n),
        Ze(([[p, h, C, v, b, y, x, T], A]) => {
          const { done: L, behavior: I, align: M, calculateViewLocation: k = Yce, ..._ } = p, F = qM(p, h, v - 1), $ = N0(F, h.offsetTree, A) + b + y, oe = $ + no(h.sizeTree, F)[1], te = T + y, ae = T + C - x, be = k({
            itemTop: $,
            itemBottom: oe,
            viewportTop: te,
            viewportBottom: ae,
            locationParams: { behavior: I, align: M, ..._ }
          });
          return be ? L && Fo(
            Ae(
              c,
              d1((K) => K === !1),
              // skips the initial publish of false, and the cleanup call.
              // but if scrollingInProgress is true, we skip the initial publish.
              Fs(xn(c) ? 1 : 2)
            ),
            L
          ) : L && L(), be;
        }),
        d1((p) => p !== null)
      ),
      u
    ), {
      scrollIntoView: f
    };
  },
  Et(Oo, Hn, y3, x2, ha),
  { singleton: !0 }
), Qce = rt(
  ([
    { sizes: e, sizeRanges: t },
    { scrollTop: n, headerHeight: r },
    { initialTopMostItemIndex: o },
    { didMount: i },
    { useWindowScroll: a, windowScrollContainerState: l, windowViewportRect: c }
  ]) => {
    const u = H1(), f = ke(void 0), p = ke(null), h = ke(null);
    return Qe(l, p), Qe(c, h), nt(
      Ae(
        u,
        A1(e, n, a, p, h, r)
      ),
      ([C, v, b, y, x, T, A]) => {
        const L = Rce(v.sizeTree);
        y && x !== null && T !== null && (b = x.scrollTop - T.offsetTop), b -= A, C({ ranges: L, scrollTop: b });
      }
    ), Qe(Ae(f, d1(uh), Ze(qce)), o), Qe(
      Ae(
        i,
        A1(f),
        d1(([, C]) => C !== void 0),
        It(),
        Ze(([, C]) => C.ranges)
      ),
      t
    ), {
      getState: u,
      restoreStateFrom: f
    };
  },
  Et(Oo, Hn, w3, ma, bh)
);
function qce(e) {
  return { offset: e.scrollTop, index: 0, align: "start" };
}
const Kce = rt(
  ([
    e,
    t,
    n,
    r,
    o,
    i,
    a,
    l,
    c,
    u
  ]) => ({
    ...e,
    ...t,
    ...n,
    ...r,
    ...o,
    ...i,
    ...a,
    ...l,
    ...c,
    ...u
  }),
  Et(
    gh,
    Gce,
    ma,
    oB,
    iB,
    jce,
    Xce,
    bh,
    Jce,
    ha
  )
), eue = rt(
  ([
    {
      totalCount: e,
      sizeRanges: t,
      fixedItemSize: n,
      defaultItemSize: r,
      trackItemSizes: o,
      itemSize: i,
      data: a,
      firstItemIndex: l,
      groupIndices: c,
      statefulTotalCount: u,
      gap: f,
      sizes: p
    },
    { initialTopMostItemIndex: h, scrolledToInitialItem: C, initialItemFinalLocationReached: v },
    b,
    y,
    x,
    { listState: T, topItemsIndexes: A, ...L },
    { scrollToIndex: I },
    M,
    { topItemCount: k },
    { groupCounts: _ },
    F
  ]) => (Qe(L.rangeChanged, F.scrollSeekRangeChanged), Qe(
    Ae(
      F.windowViewportRect,
      Ze(($) => $.visibleHeight)
    ),
    b.viewportHeight
  ), {
    // input
    totalCount: e,
    data: a,
    firstItemIndex: l,
    sizeRanges: t,
    initialTopMostItemIndex: h,
    scrolledToInitialItem: C,
    initialItemFinalLocationReached: v,
    topItemsIndexes: A,
    topItemCount: k,
    groupCounts: _,
    fixedItemHeight: n,
    defaultItemHeight: r,
    gap: f,
    ...x,
    // output
    statefulTotalCount: u,
    listState: T,
    scrollToIndex: I,
    trackItemSizes: o,
    itemSize: i,
    groupIndices: c,
    // exported from stateFlagsSystem
    ...L,
    // the bag of IO from featureGroup1System
    ...F,
    ...b,
    sizes: p,
    ...y
  }),
  Et(
    Oo,
    w3,
    Hn,
    Qce,
    Dce,
    x2,
    y3,
    Uce,
    Wce,
    tB,
    Kce
  )
), Zc = "-webkit-sticky", Zx = "sticky", sB = aB(() => {
  if (typeof document > "u")
    return Zx;
  const e = document.createElement("div");
  return e.style.position = Zc, e.style.position === Zc ? Zc : Zx;
});
function lB(e, t, n) {
  const r = w.useRef(null), o = w.useCallback(
    (c) => {
      if (c === null || !c.offsetParent)
        return;
      const u = c.getBoundingClientRect(), f = u.width;
      let p, h;
      if (t) {
        const C = t.getBoundingClientRect(), v = u.top - C.top;
        p = C.height - Math.max(0, v), h = v + t.scrollTop;
      } else
        p = window.innerHeight - Math.max(0, u.top), h = u.top + window.pageYOffset;
      r.current = {
        offsetTop: h,
        visibleHeight: p,
        visibleWidth: f
      }, e(r.current);
    },
    [e, t]
  ), { callbackRef: i, ref: a } = fh(o, !0, n), l = w.useCallback(() => {
    o(a.current);
  }, [o, a]);
  return w.useEffect(() => {
    if (t) {
      t.addEventListener("scroll", l);
      const c = new ResizeObserver(() => {
        requestAnimationFrame(l);
      });
      return c.observe(t), () => {
        t.removeEventListener("scroll", l), c.unobserve(t);
      };
    } else
      return window.addEventListener("scroll", l), window.addEventListener("resize", l), () => {
        window.removeEventListener("scroll", l), window.removeEventListener("resize", l);
      };
  }, [l, t]), i;
}
const cB = w.createContext(void 0), uB = w.createContext(void 0);
function dB(e) {
  return e;
}
const tue = /* @__PURE__ */ rt(() => {
  const e = ke((c) => `Item ${c}`), t = ke(null), n = ke((c) => `Group ${c}`), r = ke({}), o = ke(dB), i = ke("div"), a = ke(Xs), l = (c, u = null) => Fn(
    Ae(
      r,
      Ze((f) => f[c]),
      It()
    ),
    u
  );
  return {
    context: t,
    itemContent: e,
    groupContent: n,
    components: r,
    computeItemKey: o,
    HeaderFooterTag: i,
    scrollerRef: a,
    FooterComponent: l("Footer"),
    HeaderComponent: l("Header"),
    TopItemListComponent: l("TopItemList"),
    ListComponent: l("List", "div"),
    ItemComponent: l("Item", "div"),
    GroupComponent: l("Group", "div"),
    ScrollerComponent: l("Scroller", "div"),
    EmptyPlaceholder: l("EmptyPlaceholder"),
    ScrollSeekPlaceholder: l("ScrollSeekPlaceholder")
  };
}), nue = /* @__PURE__ */ rt(([e, t]) => ({ ...e, ...t }), Et(eue, tue)), rue = ({ height: e }) => /* @__PURE__ */ g("div", { style: { height: e } }), oue = { position: sB(), zIndex: 1, overflowAnchor: "none" }, fB = { overflowAnchor: "none" }, iue = { ...fB, display: "inline-block", height: "100%" }, zx = /* @__PURE__ */ w.memo(function({ showTopList: t = !1 }) {
  const n = g1("listState"), r = Br("sizeRanges"), o = g1("useWindowScroll"), i = g1("customScrollParent"), a = Br("windowScrollContainerState"), l = Br("scrollContainerState"), c = i || o ? a : l, u = g1("itemContent"), f = g1("context"), p = g1("groupContent"), h = g1("trackItemSizes"), C = g1("itemSize"), v = g1("log"), b = Br("gap"), y = g1("horizontalDirection"), { callbackRef: x } = yce(
    r,
    C,
    h,
    t ? Xs : c,
    v,
    b,
    i,
    y,
    g1("skipAnimationFrameInResizeObserver")
  ), [T, A] = w.useState(0);
  vh("deviation", (K) => {
    T !== K && A(K);
  });
  const L = g1("EmptyPlaceholder"), I = g1("ScrollSeekPlaceholder") || rue, M = g1("ListComponent"), k = g1("ItemComponent"), _ = g1("GroupComponent"), F = g1("computeItemKey"), $ = g1("isSeeking"), oe = g1("groupIndices").length > 0, te = g1("alignToBottom"), ae = g1("initialItemFinalLocationReached"), be = t ? {} : {
    boxSizing: "border-box",
    ...y ? {
      whiteSpace: "nowrap",
      display: "inline-block",
      height: "100%",
      paddingLeft: n.offsetTop,
      paddingRight: n.offsetBottom,
      marginLeft: T !== 0 ? T : te ? "auto" : 0
    } : {
      marginTop: T !== 0 ? T : te ? "auto" : 0,
      paddingTop: n.offsetTop,
      paddingBottom: n.offsetBottom
    },
    ...ae ? {} : { visibility: "hidden" }
  };
  return !t && n.totalCount === 0 && L ? /* @__PURE__ */ g(L, { ...Rn(L, f) }) : /* @__PURE__ */ g(
    M,
    {
      ...Rn(M, f),
      ref: x,
      style: be,
      "data-testid": t ? "virtuoso-top-item-list" : "virtuoso-item-list",
      children: (t ? n.topItems : n.items).map((K) => {
        const ue = K.originalIndex, J = F(ue + n.firstItemIndex, K.data, f);
        return $ ? /* @__PURE__ */ X5(
          I,
          {
            ...Rn(I, f),
            key: J,
            index: K.index,
            height: K.size,
            type: K.type || "item",
            ...K.type === "group" ? {} : { groupIndex: K.groupIndex }
          }
        ) : K.type === "group" ? /* @__PURE__ */ X5(
          _,
          {
            ...Rn(_, f),
            key: J,
            "data-index": ue,
            "data-known-size": K.size,
            "data-item-index": K.index,
            style: oue
          },
          p(K.index, f)
        ) : /* @__PURE__ */ X5(
          k,
          {
            ...Rn(k, f),
            ...cue(k, K.data),
            key: J,
            "data-index": ue,
            "data-known-size": K.size,
            "data-item-index": K.index,
            "data-item-group-index": K.groupIndex,
            style: y ? iue : fB
          },
          oe ? u(K.index, K.groupIndex, K.data, f) : u(K.index, K.data, f)
        );
      })
    }
  );
}), aue = {
  height: "100%",
  outline: "none",
  overflowY: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch"
}, sue = {
  outline: "none",
  overflowX: "auto",
  position: "relative"
}, I6 = (e) => ({
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  ...e ? { display: "flex", flexDirection: "column" } : {}
}), lue = {
  width: "100%",
  position: sB(),
  top: 0,
  zIndex: 1
};
function Rn(e, t) {
  if (typeof e != "string")
    return { context: t };
}
function cue(e, t) {
  return { item: typeof e == "string" ? void 0 : t };
}
const uue = /* @__PURE__ */ w.memo(function() {
  const t = g1("HeaderComponent"), n = Br("headerHeight"), r = g1("HeaderFooterTag"), o = y2(
    w.useMemo(() => (a) => n(ia(a, "height")), [n]),
    !0,
    g1("skipAnimationFrameInResizeObserver")
  ), i = g1("context");
  return t ? /* @__PURE__ */ g(r, { ref: o, children: /* @__PURE__ */ g(t, { ...Rn(t, i) }) }) : null;
}), due = /* @__PURE__ */ w.memo(function() {
  const t = g1("FooterComponent"), n = Br("footerHeight"), r = g1("HeaderFooterTag"), o = y2(
    w.useMemo(() => (a) => n(ia(a, "height")), [n]),
    !0,
    g1("skipAnimationFrameInResizeObserver")
  ), i = g1("context");
  return t ? /* @__PURE__ */ g(r, { ref: o, children: /* @__PURE__ */ g(t, { ...Rn(t, i) }) }) : null;
});
function pB({ usePublisher: e, useEmitter: t, useEmitterValue: n }) {
  return w.memo(function({ style: i, children: a, ...l }) {
    const c = e("scrollContainerState"), u = n("ScrollerComponent"), f = e("smoothScrollTargetReached"), p = n("scrollerRef"), h = n("context"), C = n("horizontalDirection") || !1, { scrollerRef: v, scrollByCallback: b, scrollToCallback: y } = $M(
      c,
      f,
      u,
      p,
      void 0,
      C
    );
    return t("scrollTo", y), t("scrollBy", b), /* @__PURE__ */ g(
      u,
      {
        ref: v,
        style: { ...C ? sue : aue, ...i },
        "data-testid": "virtuoso-scroller",
        "data-virtuoso-scroller": !0,
        tabIndex: 0,
        ...l,
        ...Rn(u, h),
        children: a
      }
    );
  });
}
function hB({ usePublisher: e, useEmitter: t, useEmitterValue: n }) {
  return w.memo(function({ style: i, children: a, ...l }) {
    const c = e("windowScrollContainerState"), u = n("ScrollerComponent"), f = e("smoothScrollTargetReached"), p = n("totalListHeight"), h = n("deviation"), C = n("customScrollParent"), v = n("context"), { scrollerRef: b, scrollByCallback: y, scrollToCallback: x } = $M(
      c,
      f,
      u,
      Xs,
      C
    );
    return GM(() => (b.current = C || window, () => {
      b.current = null;
    }), [b, C]), t("windowScrollTo", x), t("scrollBy", y), /* @__PURE__ */ g(
      u,
      {
        style: { position: "relative", ...i, ...p !== 0 ? { height: p + h } : {} },
        "data-virtuoso-scroller": !0,
        ...l,
        ...Rn(u, v),
        children: a
      }
    );
  });
}
const fue = ({ children: e }) => {
  const t = w.useContext(cB), n = Br("viewportHeight"), r = Br("fixedItemHeight"), o = g1("alignToBottom"), i = g1("horizontalDirection"), a = w.useMemo(
    () => NM(n, (c) => ia(c, i ? "width" : "height")),
    [n, i]
  ), l = y2(a, !0, g1("skipAnimationFrameInResizeObserver"));
  return w.useEffect(() => {
    t && (n(t.viewportHeight), r(t.itemHeight));
  }, [t, n, r]), /* @__PURE__ */ g("div", { style: I6(o), ref: l, "data-viewport-type": "element", children: e });
}, pue = ({ children: e }) => {
  const t = w.useContext(cB), n = Br("windowViewportRect"), r = Br("fixedItemHeight"), o = g1("customScrollParent"), i = lB(
    n,
    o,
    g1("skipAnimationFrameInResizeObserver")
  ), a = g1("alignToBottom");
  return w.useEffect(() => {
    t && (r(t.itemHeight), n({ offsetTop: 0, visibleHeight: t.viewportHeight, visibleWidth: 100 }));
  }, [t, n, r]), /* @__PURE__ */ g("div", { ref: i, style: I6(a), "data-viewport-type": "window", children: e });
}, hue = ({ children: e }) => {
  const t = g1("TopItemListComponent") || "div", n = g1("headerHeight"), r = { ...lue, marginTop: `${n}px` }, o = g1("context");
  return /* @__PURE__ */ g(t, { style: r, ...Rn(t, o), children: e });
}, mue = /* @__PURE__ */ w.memo(function(t) {
  const n = g1("useWindowScroll"), r = g1("topItemsIndexes").length > 0, o = g1("customScrollParent");
  return /* @__PURE__ */ X(o || n ? bue : gue, { ...t, children: [
    r && /* @__PURE__ */ g(hue, { children: /* @__PURE__ */ g(zx, { showTopList: !0 }) }),
    /* @__PURE__ */ X(o || n ? pue : fue, { children: [
      /* @__PURE__ */ g(uue, {}),
      /* @__PURE__ */ g(zx, {}),
      /* @__PURE__ */ g(due, {})
    ] })
  ] });
}), {
  Component: Cue,
  usePublisher: Br,
  useEmitterValue: g1,
  useEmitter: vh
} = /* @__PURE__ */ zM(
  nue,
  {
    required: {},
    optional: {
      restoreStateFrom: "restoreStateFrom",
      context: "context",
      followOutput: "followOutput",
      itemContent: "itemContent",
      groupContent: "groupContent",
      overscan: "overscan",
      increaseViewportBy: "increaseViewportBy",
      totalCount: "totalCount",
      groupCounts: "groupCounts",
      topItemCount: "topItemCount",
      firstItemIndex: "firstItemIndex",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      components: "components",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      computeItemKey: "computeItemKey",
      defaultItemHeight: "defaultItemHeight",
      fixedItemHeight: "fixedItemHeight",
      itemSize: "itemSize",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "HeaderFooterTag",
      data: "data",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      alignToBottom: "alignToBottom",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel",
      horizontalDirection: "horizontalDirection",
      skipAnimationFrameInResizeObserver: "skipAnimationFrameInResizeObserver"
    },
    methods: {
      scrollToIndex: "scrollToIndex",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      autoscrollToBottom: "autoscrollToBottom",
      getState: "getState"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      totalListHeightChanged: "totalListHeightChanged",
      itemsRendered: "itemsRendered",
      groupIndices: "groupIndices"
    }
  },
  mue
), gue = /* @__PURE__ */ pB({ usePublisher: Br, useEmitterValue: g1, useEmitter: vh }), bue = /* @__PURE__ */ hB({ usePublisher: Br, useEmitterValue: g1, useEmitter: vh }), vue = Cue, Gx = {
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
}, yue = {
  items: [{ index: 0 }],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
}, { round: Wx, ceil: $x, floor: E9, min: zc, max: p0 } = Math;
function xue(e) {
  return {
    ...yue,
    items: e
  };
}
function Ux(e, t, n) {
  return Array.from({ length: t - e + 1 }).map((r, o) => {
    const i = n === null ? null : n[o + e];
    return { index: o + e, data: i };
  });
}
function wue(e, t) {
  return e && e.column === t.column && e.row === t.row;
}
function ml(e, t) {
  return e && e.width === t.width && e.height === t.height;
}
const Sue = /* @__PURE__ */ rt(
  ([
    { overscan: e, visibleRange: t, listBoundary: n },
    { scrollTop: r, viewportHeight: o, scrollBy: i, scrollTo: a, smoothScrollTargetReached: l, scrollContainerState: c, footerHeight: u, headerHeight: f },
    p,
    h,
    { propsReady: C, didMount: v },
    { windowViewportRect: b, useWindowScroll: y, customScrollParent: x, windowScrollContainerState: T, windowScrollTo: A },
    L
  ]) => {
    const I = ke(0), M = ke(0), k = ke(Gx), _ = ke({ height: 0, width: 0 }), F = ke({ height: 0, width: 0 }), $ = H1(), oe = H1(), te = ke(0), ae = ke(null), be = ke({ row: 0, column: 0 }), K = H1(), ue = H1(), J = ke(!1), Me = ke(0), _e = ke(!0), ne = ke(!1), ee = ke(!1);
    nt(
      Ae(
        v,
        A1(Me),
        d1(([Q, pe]) => !!pe)
      ),
      () => {
        T1(_e, !1);
      }
    ), nt(
      Ae(
        sn(v, _e, F, _, Me, ne),
        d1(([Q, pe, me, Be, , We]) => Q && !pe && me.height !== 0 && Be.height !== 0 && !We)
      ),
      ([, , , , Q]) => {
        T1(ne, !0), mh(1, () => {
          T1($, Q);
        }), Fo(Ae(r), () => {
          T1(n, [0, 0]), T1(_e, !0);
        });
      }
    ), Qe(
      Ae(
        ue,
        d1((Q) => Q != null && Q.scrollTop > 0),
        vo(0)
      ),
      M
    ), nt(
      Ae(
        v,
        A1(ue),
        d1(([, Q]) => Q != null)
      ),
      ([, Q]) => {
        Q && (T1(_, Q.viewport), T1(F, Q?.item), T1(be, Q.gap), Q.scrollTop > 0 && (T1(J, !0), Fo(Ae(r, Fs(1)), (pe) => {
          T1(J, !1);
        }), T1(a, { top: Q.scrollTop })));
      }
    ), Qe(
      Ae(
        _,
        Ze(({ height: Q }) => Q)
      ),
      o
    ), Qe(
      Ae(
        sn(
          u1(_, ml),
          u1(F, ml),
          u1(be, (Q, pe) => Q && Q.column === pe.column && Q.row === pe.row),
          u1(r)
        ),
        Ze(([Q, pe, me, Be]) => ({
          viewport: Q,
          item: pe,
          gap: me,
          scrollTop: Be
        }))
      ),
      K
    ), Qe(
      Ae(
        sn(
          u1(I),
          t,
          u1(be, wue),
          u1(F, ml),
          u1(_, ml),
          u1(ae),
          u1(M),
          u1(J),
          u1(_e),
          u1(Me)
        ),
        d1(([, , , , , , , Q]) => !Q),
        Ze(
          ([
            Q,
            [pe, me],
            Be,
            We,
            ie,
            f1,
            s1,
            ,
            Ye,
            B1
          ]) => {
            const { row: Pe, column: j1 } = Be, { height: X1, width: p1 } = We, { width: L1 } = ie;
            if (s1 === 0 && (Q === 0 || L1 === 0))
              return Gx;
            if (p1 === 0) {
              const No = Ch(B1, Q), Si = Math.max(No + s1 - 1, 0);
              return xue(Ux(No, Si, f1));
            }
            const Ct = mB(L1, p1, j1);
            let Z1, r1;
            Ye ? pe === 0 && me === 0 && s1 > 0 ? (Z1 = 0, r1 = s1 - 1) : (Z1 = Ct * E9((pe + Pe) / (X1 + Pe)), r1 = Ct * $x((me + Pe) / (X1 + Pe)) - 1, r1 = zc(Q - 1, p0(r1, Ct - 1)), Z1 = zc(r1, p0(0, Z1))) : (Z1 = 0, r1 = -1);
            const ut = Ux(Z1, r1, f1), { top: rn, bottom: on } = jx(ie, Be, We, ut), ln = $x(Q / Ct), wi = ln * X1 + (ln - 1) * Pe - on;
            return { items: ut, offsetTop: rn, offsetBottom: wi, top: rn, bottom: on, itemHeight: X1, itemWidth: p1 };
          }
        )
      ),
      k
    ), Qe(
      Ae(
        ae,
        d1((Q) => Q !== null),
        Ze((Q) => Q.length)
      ),
      I
    ), Qe(
      Ae(
        sn(_, F, k, be),
        d1(([Q, pe, { items: me }]) => me.length > 0 && pe.height !== 0 && Q.height !== 0),
        Ze(([Q, pe, { items: me }, Be]) => {
          const { top: We, bottom: ie } = jx(Q, Be, pe, me);
          return [We, ie];
        }),
        It(Z0)
      ),
      n
    );
    const ye = ke(!1);
    Qe(
      Ae(
        r,
        A1(ye),
        Ze(([Q, pe]) => pe || Q !== 0)
      ),
      ye
    );
    const fe = ar(
      Ae(
        u1(k),
        d1(({ items: Q }) => Q.length > 0),
        A1(I, ye),
        d1(([{ items: Q }, pe, me]) => me && Q[Q.length - 1].index === pe - 1),
        Ze(([, Q]) => Q - 1),
        It()
      )
    ), xe = ar(
      Ae(
        u1(k),
        d1(({ items: Q }) => Q.length > 0 && Q[0].index === 0),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        vo(0),
        It()
      )
    ), Te = ar(
      Ae(
        u1(k),
        A1(J),
        d1(([{ items: Q }, pe]) => Q.length > 0 && !pe),
        Ze(([{ items: Q }]) => ({
          startIndex: Q[0].index,
          endIndex: Q[Q.length - 1].index
        })),
        It(nB),
        Qi(0)
      )
    );
    Qe(Te, h.scrollSeekRangeChanged), Qe(
      Ae(
        $,
        A1(_, F, I, be),
        Ze(([Q, pe, me, Be, We]) => {
          const ie = eB(Q), { align: f1, behavior: s1, offset: Ye } = ie;
          let B1 = ie.index;
          B1 === "LAST" && (B1 = Be - 1), B1 = p0(0, B1, zc(Be - 1, B1));
          let Pe = Fd(pe, We, me, B1);
          return f1 === "end" ? Pe = Wx(Pe - pe.height + me.height) : f1 === "center" && (Pe = Wx(Pe - pe.height / 2 + me.height / 2)), Ye && (Pe += Ye), { top: Pe, behavior: s1 };
        })
      ),
      a
    );
    const Ie = Fn(
      Ae(
        k,
        Ze((Q) => Q.offsetBottom + Q.bottom)
      ),
      0
    );
    return Qe(
      Ae(
        b,
        Ze((Q) => ({ width: Q.visibleWidth, height: Q.visibleHeight }))
      ),
      _
    ), {
      // input
      data: ae,
      totalCount: I,
      viewportDimensions: _,
      itemDimensions: F,
      scrollTop: r,
      scrollHeight: oe,
      overscan: e,
      scrollBy: i,
      scrollTo: a,
      scrollToIndex: $,
      smoothScrollTargetReached: l,
      windowViewportRect: b,
      windowScrollTo: A,
      useWindowScroll: y,
      customScrollParent: x,
      windowScrollContainerState: T,
      deviation: te,
      scrollContainerState: c,
      footerHeight: u,
      headerHeight: f,
      initialItemCount: M,
      gap: be,
      restoreStateFrom: ue,
      ...h,
      initialTopMostItemIndex: Me,
      horizontalDirection: ee,
      // output
      gridState: k,
      totalListHeight: Ie,
      ...p,
      startReached: xe,
      endReached: fe,
      rangeChanged: Te,
      stateChanged: K,
      propsReady: C,
      stateRestoreInProgress: J,
      ...L
    };
  },
  Et(gh, Hn, x3, oB, ma, bh, ha)
);
function jx(e, t, n, r) {
  const { height: o } = n;
  if (o === void 0 || r.length === 0)
    return { top: 0, bottom: 0 };
  const i = Fd(e, t, n, r[0].index), a = Fd(e, t, n, r[r.length - 1].index) + o;
  return { top: i, bottom: a };
}
function Fd(e, t, n, r) {
  const o = mB(e.width, n.width, t.column), i = E9(r / o), a = i * n.height + p0(0, i - 1) * t.row;
  return a > 0 ? a + t.row : a;
}
function mB(e, t, n) {
  return p0(1, E9((e + n) / (E9(t) + n)));
}
const Tue = /* @__PURE__ */ rt(() => {
  const e = ke((p) => `Item ${p}`), t = ke({}), n = ke(null), r = ke("virtuoso-grid-item"), o = ke("virtuoso-grid-list"), i = ke(dB), a = ke("div"), l = ke(Xs), c = (p, h = null) => Fn(
    Ae(
      t,
      Ze((C) => C[p]),
      It()
    ),
    h
  ), u = ke(!1), f = ke(!1);
  return Qe(u1(f), u), {
    readyStateChanged: u,
    reportReadyState: f,
    context: n,
    itemContent: e,
    components: t,
    computeItemKey: i,
    itemClassName: r,
    listClassName: o,
    headerFooterTag: a,
    scrollerRef: l,
    FooterComponent: c("Footer"),
    HeaderComponent: c("Header"),
    ListComponent: c("List", "div"),
    ItemComponent: c("Item", "div"),
    ScrollerComponent: c("Scroller", "div"),
    ScrollSeekPlaceholder: c("ScrollSeekPlaceholder", "div")
  };
}), Aue = /* @__PURE__ */ rt(([e, t]) => ({ ...e, ...t }), Et(Sue, Tue)), Iue = /* @__PURE__ */ w.memo(function() {
  const t = Bt("gridState"), n = Bt("listClassName"), r = Bt("itemClassName"), o = Bt("itemContent"), i = Bt("computeItemKey"), a = Bt("isSeeking"), l = kr("scrollHeight"), c = Bt("ItemComponent"), u = Bt("ListComponent"), f = Bt("ScrollSeekPlaceholder"), p = Bt("context"), h = kr("itemDimensions"), C = kr("gap"), v = Bt("log"), b = Bt("stateRestoreInProgress"), y = kr("reportReadyState"), x = y2(
    w.useMemo(
      () => (T) => {
        const A = T.parentElement.parentElement.scrollHeight;
        l(A);
        const L = T.firstChild;
        if (L) {
          const { width: I, height: M } = L.getBoundingClientRect();
          h({ width: I, height: M });
        }
        C({
          row: Xx("row-gap", getComputedStyle(T).rowGap, v),
          column: Xx("column-gap", getComputedStyle(T).columnGap, v)
        });
      },
      [l, h, C, v]
    ),
    !0,
    !1
  );
  return GM(() => {
    t.itemHeight > 0 && t.itemWidth > 0 && y(!0);
  }, [t]), b ? null : /* @__PURE__ */ g(
    u,
    {
      ref: x,
      className: n,
      ...Rn(u, p),
      style: { paddingTop: t.offsetTop, paddingBottom: t.offsetBottom },
      "data-testid": "virtuoso-item-list",
      children: t.items.map((T) => {
        const A = i(T.index, T.data, p);
        return a ? /* @__PURE__ */ g(
          f,
          {
            ...Rn(f, p),
            index: T.index,
            height: t.itemHeight,
            width: t.itemWidth
          },
          A
        ) : /* @__PURE__ */ X5(
          c,
          {
            ...Rn(c, p),
            className: r,
            "data-index": T.index,
            key: A
          },
          o(T.index, T.data, p)
        );
      })
    }
  );
}), Lue = w.memo(function() {
  const t = Bt("HeaderComponent"), n = kr("headerHeight"), r = Bt("headerFooterTag"), o = y2(
    w.useMemo(() => (a) => n(ia(a, "height")), [n]),
    !0,
    !1
  ), i = Bt("context");
  return t ? /* @__PURE__ */ g(r, { ref: o, children: /* @__PURE__ */ g(t, { ...Rn(t, i) }) }) : null;
}), Eue = w.memo(function() {
  const t = Bt("FooterComponent"), n = kr("footerHeight"), r = Bt("headerFooterTag"), o = y2(
    w.useMemo(() => (a) => n(ia(a, "height")), [n]),
    !0,
    !1
  ), i = Bt("context");
  return t ? /* @__PURE__ */ g(r, { ref: o, children: /* @__PURE__ */ g(t, { ...Rn(t, i) }) }) : null;
}), Mue = ({ children: e }) => {
  const t = w.useContext(uB), n = kr("itemDimensions"), r = kr("viewportDimensions"), o = y2(
    w.useMemo(
      () => (i) => {
        r(i.getBoundingClientRect());
      },
      [r]
    ),
    !0,
    !1
  );
  return w.useEffect(() => {
    t && (r({ height: t.viewportHeight, width: t.viewportWidth }), n({ height: t.itemHeight, width: t.itemWidth }));
  }, [t, r, n]), /* @__PURE__ */ g("div", { style: I6(!1), ref: o, children: e });
}, Bue = ({ children: e }) => {
  const t = w.useContext(uB), n = kr("windowViewportRect"), r = kr("itemDimensions"), o = Bt("customScrollParent"), i = lB(n, o, !1);
  return w.useEffect(() => {
    t && (r({ height: t.itemHeight, width: t.itemWidth }), n({ offsetTop: 0, visibleHeight: t.viewportHeight, visibleWidth: t.viewportWidth }));
  }, [t, n, r]), /* @__PURE__ */ g("div", { ref: i, style: I6(!1), children: e });
}, kue = /* @__PURE__ */ w.memo(function({ ...t }) {
  const n = Bt("useWindowScroll"), r = Bt("customScrollParent");
  return /* @__PURE__ */ g(r || n ? _ue : Rue, { ...t, children: /* @__PURE__ */ X(r || n ? Bue : Mue, { children: [
    /* @__PURE__ */ g(Lue, {}),
    /* @__PURE__ */ g(Iue, {}),
    /* @__PURE__ */ g(Eue, {})
  ] }) });
}), {
  Component: vfe,
  usePublisher: kr,
  useEmitterValue: Bt,
  useEmitter: CB
} = /* @__PURE__ */ zM(
  Aue,
  {
    optional: {
      context: "context",
      totalCount: "totalCount",
      overscan: "overscan",
      itemContent: "itemContent",
      components: "components",
      computeItemKey: "computeItemKey",
      data: "data",
      initialItemCount: "initialItemCount",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      listClassName: "listClassName",
      itemClassName: "itemClassName",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel",
      restoreStateFrom: "restoreStateFrom",
      initialTopMostItemIndex: "initialTopMostItemIndex"
    },
    methods: {
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      scrollToIndex: "scrollToIndex"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      stateChanged: "stateChanged",
      readyStateChanged: "readyStateChanged"
    }
  },
  kue
), Rue = /* @__PURE__ */ pB({ usePublisher: kr, useEmitterValue: Bt, useEmitter: CB }), _ue = /* @__PURE__ */ hB({ usePublisher: kr, useEmitterValue: Bt, useEmitter: CB });
function Xx(e, t, n) {
  return t !== "normal" && !t?.endsWith("px") && n(`${e} was not resolved to pixel value correctly`, t, sr.WARN), t === "normal" ? 0 : parseInt(t ?? "0", 10);
}
function L6() {
  return {
    isMobile: Gt([!0, !0, !1])
  };
}
function yh(e) {
  const { data: t, children: n, className: r } = e, { isMobile: o } = L6(), i = we(() => {
    if (!o)
      return {
        ">div": {
          "::-webkit-scrollbar": {
            width: "8px"
          },
          "::-webkit-scrollbar-track": {
            bg: "transparent"
          },
          "::-webkit-scrollbar-thumb": {
            h: "20px",
            bg: "rgba(0, 0, 0, 0.5)",
            borderRadius: "99px"
          }
        }
      };
  }, [o]);
  return /* @__PURE__ */ g(re, { className: r, boxSize: "100%", sx: i, children: /* @__PURE__ */ g(
    vue,
    {
      style: {
        width: "100%",
        height: "100%"
      },
      totalCount: t.length,
      itemContent: (a) => n(t[a], a)
    }
  ) });
}
function gB({ tokens: e = [] }) {
  return [...e].sort((n, r) => {
    if (n.isCompatible && r.isCompatible) {
      if (n.value && r.value)
        return r.value - n.value;
      if (n.value && !r.value)
        return -1;
      if (!n.value && r.value)
        return 1;
      const o = Number(n.balance), i = Number(r.balance);
      if (o && i)
        return 0;
      if (o && !i)
        return -1;
      if (!o && i)
        return 1;
    }
    return 0;
  });
}
function w2() {
  const e = C2(), t = N((C) => C.transfer.fromChain), n = N((C) => C.transfer.toChain), r = N((C) => C.transfer.selectedToken), o = D1(), i = (C) => {
    const v = {
      fromChainId: C.fromChainId,
      toChainId: C.toChainId,
      tokenAddress: C.tokenAddress
    }, b = e.getFromChainDetail(v), y = e.getToChainDetail(v), x = e.getTokenDetail(v);
    o(kE(b)), o(RE(y)), o(BE(x));
    const T = (A) => {
      const L = e.getToTokenDetail({
        fromChainId: C.fromChainId,
        toChainId: C.toChainId,
        fromTokenAddress: C.tokenAddress,
        toTokenAddress: A
      });
      o(j5(L));
    };
    if (C.toTokenAddress)
      T(C.toTokenAddress);
    else {
      const A = e.getToTokens(v);
      A.length > 1 ? (console.log("[aggregator]", `has multiple toTokens (${A.length})`), o(vd(A)), o(j5(void 0))) : (o(vd([])), o(j5(void 0))), A.length === 1 ? T(A[0].address) : o(j5(void 0));
    }
  }, a = async (C) => {
    const { fromChainId: v, toChainId: b, tokenAddress: y } = C, x = e.getFromChains(), T = e.getToChains({ fromChainId: v }), A = e.getTokens({
      fromChainId: v,
      toChainId: b
    }), L = x.find((k) => k.id === v), I = T.find((k) => k.id === b), M = A.find((k) => ja(k.address, y));
    if (!L) {
      x?.[0]?.id && l(x?.[0].id);
      return;
    }
    if (!I || !M) {
      l(v);
      return;
    }
    i({
      fromChainId: v,
      toChainId: b,
      tokenAddress: y
    });
  }, l = async (C) => {
    const b = e.getFromChains().find((L) => L.id === C), y = e.getToChains({ fromChainId: C }), x = y.find((L) => L.isCompatible && L.id === n?.id) ?? y.find((L) => L.isCompatible && L.chainType !== "link"), T = await h({
      chainType: b.chainType,
      fromChainId: b.id,
      tokens: e.getTokens({
        fromChainId: b.id,
        toChainId: x.id
      })
    }), A = T.find(
      (L) => L.isCompatible && L.displaySymbol.toUpperCase() === r?.displaySymbol.toUpperCase()
    ) ?? T.find((L) => L.isCompatible);
    i({
      fromChainId: C,
      toChainId: x.id,
      tokenAddress: A.address
    });
  }, c = async (C) => {
    const v = t.id, b = await h({
      fromChainId: v,
      tokens: e.getTokens({
        fromChainId: v,
        toChainId: C
      })
    }), y = b.find(
      (x) => x.isCompatible && x.displaySymbol.toUpperCase() === r?.displaySymbol.toUpperCase()
    ) ?? b.find((x) => x.isCompatible);
    i({
      tokenAddress: y.address,
      fromChainId: v,
      toChainId: C
    });
  }, u = async (C) => {
    const v = t.id, b = n.id;
    i({
      tokenAddress: C,
      fromChainId: v,
      toChainId: b
    });
  }, f = async (C) => {
    const v = t.id, b = n.id, y = r.address;
    i({
      fromChainId: v,
      toChainId: b,
      tokenAddress: y,
      toTokenAddress: C
    });
  }, p = async () => {
    o(oa("")), o(s6({ address: "" }));
    const C = n.id, v = t.id, b = e.getFromChains();
    if (!b.find((I) => I.id === C)) {
      b?.[0].id && l(b?.[0].id);
      return;
    }
    if (!e.getFromChains().find((I) => I.id === v)) {
      l(C);
      return;
    }
    const A = await h({
      fromChainId: C,
      tokens: e.getTokens({
        fromChainId: C,
        toChainId: v
      })
    }), L = A.find(
      (I) => I.isCompatible && I.displaySymbol.toUpperCase() === r?.displaySymbol.toUpperCase()
    ) ?? A.find((I) => I.isCompatible);
    if (!L) {
      l(C);
      return;
    }
    i({
      fromChainId: C,
      toChainId: v,
      tokenAddress: L.address
    });
  }, { getSortedTokens: h } = Fue();
  return {
    selectDefault: a,
    selectFromChain: l,
    selectToChain: c,
    selectToken: u,
    selectToToken: f,
    exchange: p
  };
}
function Fue() {
  const e = Lt(), { getTokenPrice: t } = Ws(), { address: n } = lt(), { address: r } = Ho(), { address: o } = hr(), i = dw(), { connection: a } = U0(), l = g3();
  return {
    getSortedTokens: se(
      async ({
        fromChainId: u,
        chainType: f,
        tokens: p
      }) => {
        const h = await hM({
          chainType: f,
          tokens: p,
          chainConfig: e.transfer.chainConfigs?.find((v) => v.id === u),
          evmParams: {
            account: n,
            chain: i?.find((v) => v.id === u)
          },
          solanaParams: {
            account: r,
            connection: a
          },
          tronParams: {
            account: o,
            tronWeb: l
          }
        }), C = p.map((v) => {
          const b = h[v.address?.toLowerCase()], y = t({
            chainId: u,
            chainType: f,
            tokenAddress: v?.address,
            tokenSymbol: v?.symbol
          });
          let x;
          return b !== void 0 && y !== void 0 && (x = Number(b) * y), {
            ...v,
            balance: b,
            value: x
          };
        });
        return gB({
          tokens: C
        });
      },
      [
        e.transfer.chainConfigs,
        n,
        i,
        r,
        a,
        o,
        l,
        t
      ]
    )
  };
}
function E6(e = "") {
  e && window.open(e, "_blank", "noopener noreferrer");
}
function Pue(e) {
  return /* @__PURE__ */ g(U1, { width: "16px", height: "16px", viewBox: "0 0 16 16", fill: "currentcolor", ...e, children: /* @__PURE__ */ g("path", { d: "M12.9637 13.8135L9.62712 10.4769C9.20372 10.8075 8.74503 11.053 8.25106 11.2134C7.7571 11.3738 7.25548 11.4539 6.74622 11.4539C5.43047 11.4539 4.31048 10.9984 3.38629 10.0872C2.4621 9.1761 2 8.06283 2 6.74743C2 5.43201 2.46199 4.31191 3.38595 3.38714C4.30991 2.46238 5.42961 2 6.74502 2C8.06042 2 9.17411 2.4621 10.086 3.38629C10.998 4.31049 11.454 5.43046 11.454 6.74621C11.454 7.27028 11.3745 7.7793 11.2156 8.27327C11.0567 8.76724 10.8105 9.21211 10.4769 9.60787L13.8327 12.983C13.9522 13.1003 14.0086 13.2382 14.0022 13.3967C13.9958 13.5551 13.9324 13.6946 13.8119 13.8151C13.6886 13.9384 13.5475 14 13.3886 14C13.2297 14 13.0881 13.9378 12.9637 13.8135ZM6.74622 10.2223C7.71244 10.2223 8.53335 9.88448 9.20891 9.20891C9.88448 8.53334 10.2223 7.71244 10.2223 6.74621C10.2223 5.76716 9.88768 4.93664 9.21853 4.25465C8.54939 3.57267 7.72527 3.23168 6.74622 3.23168C5.76716 3.23168 4.93663 3.57267 4.25465 4.25465C3.57269 4.93664 3.23169 5.76716 3.23169 6.74621C3.23169 7.72527 3.57269 8.54938 4.25465 9.21853C4.93663 9.88769 5.76716 10.2223 6.74622 10.2223Z" }) });
}
function Vue(e) {
  const { placeholder: t, onChange: n, ...r } = e, o = Xe(), { colorMode: i } = Ee(), [a, l] = ze(""), c = Re(), u = (p) => {
    const h = p.target.value.trim();
    l(h), clearTimeout(c.current), c.current = setTimeout(() => {
      n(h);
    }, 500);
  }, f = () => {
    l(""), n("");
  };
  return /* @__PURE__ */ X(qf, { ...r, children: [
    /* @__PURE__ */ g(
      Kf,
      {
        justifyContent: "flex-end",
        pr: "8px",
        color: o.colors[i].text.tertiary,
        children: /* @__PURE__ */ g(Pue, {})
      }
    ),
    /* @__PURE__ */ g(
      K0,
      {
        value: a,
        fontWeight: 400,
        placeholder: t,
        onChange: u,
        maxLength: 64
      }
    ),
    a && /* @__PURE__ */ g(
      ep,
      {
        className: "bccb-widget-modal-search-right-element",
        justifyContent: "flex-start",
        pl: "8px",
        color: o.colors[i].text.tertiary,
        children: /* @__PURE__ */ g(
          Hr,
          {
            variant: "subtle",
            boxSize: "16px",
            borderRadius: "full",
            minW: 0,
            p: 0,
            onClick: f,
            transitionDuration: "normal",
            children: /* @__PURE__ */ g(d2, { boxSize: "11px" })
          }
        )
      }
    )
  ] });
}
function Hue(e) {
  return /* @__PURE__ */ g(U1, { width: "49px", height: "48px", viewBox: "0 0 49 48", fill: "none", ...e, children: /* @__PURE__ */ X("g", { clipPath: "url(#clip0_26136_34623_)", children: [
    /* @__PURE__ */ g("rect", { x: "0.5", width: "48", height: "48", rx: "24", fill: "#373943" }),
    /* @__PURE__ */ g("g", { mask: "url(#mask0_26136_34623_)", children: /* @__PURE__ */ g(
      "path",
      {
        d: "M24.1341 36.6536C22.4315 36.6057 20.8308 36.242 19.332 35.5625C17.8331 34.8831 16.5301 33.9755 15.423 32.8399C14.3159 31.7043 13.44 30.3765 12.7952 28.8566C12.1505 27.3366 11.8281 25.718 11.8281 24.0006C11.8281 22.2502 12.161 20.6045 12.8269 19.0635C13.4927 17.5224 14.3956 16.1818 15.5358 15.0417C16.676 13.9015 18.0166 12.9985 19.5576 12.3327C21.0986 11.6669 22.7443 11.334 24.4948 11.334C27.7039 11.334 30.4839 12.3678 32.8349 14.4353C35.1859 16.5028 36.581 19.081 37.0204 22.1699H35.3179C35.0136 20.2764 34.2717 18.5794 33.0922 17.0789C31.9127 15.5783 30.4179 14.4633 28.6076 13.734V14.3288C28.6076 15.0861 28.3442 15.7387 27.8174 16.2865C27.2906 16.8344 26.6486 17.1083 25.8913 17.1083H23.1119V19.8878C23.1119 20.2656 22.9735 20.58 22.6969 20.831C22.4202 21.082 22.093 21.2074 21.7153 21.2074H18.999V24.0006H22.0503V28.0776H20.3819L13.7837 21.4878C13.6987 21.906 13.6308 22.3234 13.5798 22.7399C13.5288 23.1565 13.5033 23.5767 13.5033 24.0006C13.5033 26.9539 14.521 29.4975 16.5563 31.6314C18.5916 33.7653 21.1175 34.881 24.1341 34.9784V36.6536ZM36.0862 35.4382L32.1435 31.5347C31.711 31.843 31.2415 32.0818 30.7349 32.251C30.2284 32.4202 29.7039 32.5049 29.1614 32.5049C27.7221 32.5049 26.5005 32.0029 25.4965 30.9989C24.4925 29.9949 23.9905 28.7733 23.9905 27.334C23.9905 25.8946 24.4925 24.673 25.4965 23.669C26.5005 22.665 27.7221 22.1631 29.1614 22.1631C30.6007 22.1631 31.8224 22.665 32.8264 23.669C33.8303 24.673 34.3323 25.8946 34.3323 27.334C34.3323 27.885 34.2433 28.4159 34.0652 28.9267C33.8872 29.4375 33.6443 29.9137 33.3366 30.3553L37.2657 34.2588C37.4349 34.4194 37.5218 34.6139 37.5264 34.842C37.5309 35.0702 37.4486 35.2735 37.2794 35.4519C37.1187 35.6125 36.9219 35.6906 36.6892 35.6861C36.4564 35.6815 36.2554 35.5989 36.0862 35.4382ZM29.1614 30.8297C30.1369 30.8297 30.9634 30.4909 31.6409 29.8135C32.3184 29.1359 32.6572 28.3094 32.6572 27.334C32.6572 26.3585 32.3184 25.532 31.6409 24.8545C30.9634 24.177 30.1369 23.8382 29.1614 23.8382C28.1859 23.8382 27.3594 24.177 26.6819 24.8545C26.0044 25.532 25.6657 26.3585 25.6657 27.334C25.6657 28.3094 26.0044 29.1359 26.6819 29.8135C27.3594 30.4909 28.1859 30.8297 29.1614 30.8297Z",
        fill: "#F7F7F8"
      }
    ) })
  ] }) });
}
function Oue(e) {
  const { ...t } = e, { formatMessage: n } = n1(), { colorMode: r } = Ee();
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-modal-no-result-found",
      alignItems: "center",
      flexDir: "column",
      maxW: 347,
      margin: "32px auto",
      ...t,
      children: [
        /* @__PURE__ */ g(Hue, {}),
        /* @__PURE__ */ g(
          h1,
          {
            className: "title",
            fontWeight: 700,
            fontSize: "20px",
            lineHeight: 1.4,
            mt: "16px",
            mb: "8px",
            children: n({ id: "select-modal.search.no-result.title" })
          }
        ),
        /* @__PURE__ */ g(
          _n,
          {
            className: "bccb-widget-modal-no-result-found-text",
            textAlign: "center",
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: 500,
            color: H.colors[r].text.secondary,
            children: n({ id: "select-modal.search.no-result.warning" })
          }
        )
      ]
    }
  );
}
function xh(e) {
  const { isOpen: t, title: n, children: r, onClose: o, onSearch: i, placeholder: a, isNoResult: l, className: c } = e, u = Xe(), { colorMode: f } = Ee();
  return Oe(() => {
    t || i("");
  }, [t]), /* @__PURE__ */ X(i3, { isOpen: t, onClose: o, isCentered: !0, autoFocus: !1, children: [
    /* @__PURE__ */ g(s3, { className: `${c}-overlay` }),
    /* @__PURE__ */ X(
      a3,
      {
        className: `${c}-content`,
        background: u.colors[f].background.modal,
        borderRadius: { base: "0", md: "24px" },
        p: 0,
        h: { base: "100vh", md: "665px" },
        w: { base: "100vw", md: "435px" },
        maxW: "100%",
        overflow: "hidden",
        marginInline: 0,
        children: [
          /* @__PURE__ */ X(
            re,
            {
              className: `${c}-header`,
              h: "64px",
              px: "20px",
              py: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              lineHeight: 1.4,
              fontWeight: 500,
              fontSize: "20px",
              borderBottom: `1px solid ${u.colors[f].border[3]}`,
              flexShrink: 0,
              children: [
                /* @__PURE__ */ g(re, { boxSize: "24px" }),
                n,
                /* @__PURE__ */ g(
                  d2,
                  {
                    className: `${c}-close-button`,
                    boxSize: "24px",
                    onClick: o,
                    cursor: "pointer",
                    color: u.colors[f].modal.close.default,
                    _hover: {
                      color: u.colors[f].modal.close.hover
                    }
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ X(re, { className: `${c}-body`, flexDir: "column", p: "20px 0px 16px", flex: 1, children: [
            /* @__PURE__ */ g(re, { px: "20px", mb: "20px", children: /* @__PURE__ */ g(
              Vue,
              {
                className: `${c}-search`,
                onChange: i,
                placeholder: a
              }
            ) }),
            /* @__PURE__ */ g(re, { flexDir: "column", flex: 1, overflowY: "auto", children: l ? /* @__PURE__ */ g(Oue, {}) : /* @__PURE__ */ g(st, { children: r }) })
          ] })
        ]
      }
    )
  ] });
}
function wh(e) {
  const { data: t, filter: n, sorter: r = () => 0 } = e, [o, i] = ze(""), a = (u) => {
    i(u);
  }, l = we(() => t.filter((u) => n(u, o)).sort(r), [t, n, o, r]), c = o.length > 0 && !l.length;
  return {
    onSearch: a,
    isNoResult: c,
    result: l,
    keyword: o
  };
}
const M6 = w.forwardRef((e, t) => {
  const {
    isActive: n = !1,
    isDisabled: r = !1,
    iconUrl: o,
    showTag: i = !0,
    children: a,
    onClick: l,
    incompatibleTooltip: c,
    _hover: u,
    className: f,
    ...p
  } = e, { colorMode: h } = Ee(), C = Xe(), { formatMessage: v } = n1();
  return /* @__PURE__ */ g(h1, { className: `${f}-wrapper`, ref: t, p: "0 20px 4px", children: /* @__PURE__ */ X(
    re,
    {
      className: f,
      borderRadius: "8px",
      px: "11px",
      py: "7px",
      h: "48px",
      alignItems: "center",
      border: "1px solid",
      borderColor: n ? C.colors[h].border.brand : "transparent",
      bg: n ? "rgba(255, 233, 0, 0.06)" : "transparent",
      cursor: r ? "inherit" : "pointer",
      transitionDuration: "normal",
      _hover: {
        ...u,
        bg: !n && !r ? C.colors[h].layer[3].hover : void 0
      },
      gap: "8px",
      fontSize: "14px",
      lineHeight: "16px",
      fontWeight: 500,
      onClick: r ? void 0 : l,
      ...p,
      children: [
        /* @__PURE__ */ g(
          Bo,
          {
            boxSize: "24px",
            src: o,
            filter: r ? "grayscale(100%)" : void 0,
            opacity: r ? 0.5 : 1,
            flexShrink: 0
          }
        ),
        /* @__PURE__ */ g(re, { w: "100%", overflow: "hidden", opacity: r ? 0.5 : 1, children: a }),
        i && r && /* @__PURE__ */ X(
          re,
          {
            className: `${f}-tag`,
            alignItems: "center",
            flexShrink: 0,
            fontSize: "12px",
            gap: "4px",
            color: C.colors[h].support.warning[3],
            children: [
              /* @__PURE__ */ g(
                y6,
                {
                  label: c,
                  placement: "top",
                  minW: "280px",
                  maxW: "280px",
                  iconProps: {
                    mt: "1px",
                    boxSize: "16px"
                  }
                }
              ),
              v({ id: "select-modal.tag.incompatible" })
            ]
          }
        )
      ]
    }
  ) });
});
M6.displayName = "ListItem";
function Sh() {
  const e = C2();
  return we(() => e.getFromChains(), [e]);
}
function Nue(e) {
  const { isOpen: t, onClose: n } = e, { formatMessage: r } = n1(), o = D1(), i = N((C) => C.transfer.fromChain), { selectFromChain: a } = w2(), l = Xe(), { colorMode: c } = Ee(), u = Sh(), { isNoResult: f, result: p, onSearch: h } = wh({
    filter: (C, v) => C.name.toLowerCase().includes(v?.toLowerCase()),
    sorter: (C) => i?.id === C.id ? -1 : 0,
    data: u
  });
  return /* @__PURE__ */ g(
    xh,
    {
      className: "bccb-widget-from-network-modal",
      isOpen: t,
      onClose: n,
      title: r({ id: "select-modal.source.title" }),
      onSearch: h,
      placeholder: r({ id: "select-modal.source.placeholder" }),
      isNoResult: f,
      children: /* @__PURE__ */ g(yh, { className: "bccb-widget-from-network-virtual-list", data: p, itemHeight: 52, children: (C) => /* @__PURE__ */ g(
        M6,
        {
          className: "bccb-widget-from-network-list-item" + (i?.id === C.id ? "-active" : ""),
          iconUrl: C.icon,
          isActive: i?.id === C.id,
          isDisabled: !1,
          onClick: () => {
            qt({
              id: "select_bridge_fromDropdown",
              params: {
                item_name: C.name
              }
            }), C.chainType === "link" ? E6(C.externalBridgeUrl) : (a(C.id), o(s6({ address: "" })), n());
          },
          children: /* @__PURE__ */ X(re, { alignItems: "center", children: [
            C.name,
            C.chainType === "link" && /* @__PURE__ */ g(
              $s,
              {
                ml: "4px",
                color: l.colors[c].text.secondary,
                boxSize: l.sizes[4]
              }
            )
          ] })
        },
        C.id
      ) })
    }
  );
}
function Due() {
  const { colorMode: e } = Ee(), { isOpen: t, onClose: n, onOpen: r } = wo(), { formatMessage: o } = n1(), i = N((l) => l.transfer.fromChain), a = Xe();
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-network-from",
      flexDir: "column",
      gap: "8px",
      w: "100%",
      flex: 1,
      h: "48px",
      children: [
        /* @__PURE__ */ g(
          re,
          {
            className: "bccb-widget-network-from-title",
            alignItems: "center",
            justifyContent: "space-between",
            display: { base: "flex", md: "none" },
            children: /* @__PURE__ */ g(mt, { variant: "label", size: "md", color: a.colors[e].text.placeholder, children: o({ id: "from.section.title" }) })
          }
        ),
        /* @__PURE__ */ g(
          HM,
          {
            isActive: t,
            chain: i,
            onClick: () => {
              r(), qt({
                id: "click_bridge_fromDropdown"
              });
            }
          }
        ),
        /* @__PURE__ */ g(Nue, { isOpen: t, onClose: n })
      ]
    }
  );
}
function Zue() {
  const e = N((r) => r.transfer.fromChain), t = C2();
  return we(() => e?.id ? t.getToChains({ fromChainId: e.id }) : [], [t, e?.id]);
}
function zue(e) {
  const { isOpen: t, onClose: n } = e, { formatMessage: r } = n1(), o = N((h) => h.transfer.toChain), { selectToChain: i } = w2(), a = Xe(), { colorMode: l } = Ee(), c = Zue(), { isNoResult: u, result: f, onSearch: p } = wh({
    filter: (h, C) => h.name.toLowerCase().includes(C?.toLowerCase()),
    sorter: (h) => o?.id === h.id ? -1 : 0,
    data: c
  });
  return /* @__PURE__ */ g(
    xh,
    {
      className: "bccb-widget-to-network-modal",
      isOpen: t,
      onClose: n,
      title: r({ id: "select-modal.destination.title" }),
      onSearch: p,
      placeholder: r({ id: "select-modal.destination.placeholder" }),
      isNoResult: u,
      children: /* @__PURE__ */ g(yh, { className: "bccb-widget-to-network-virtual-list", data: f, itemHeight: 52, children: (h) => /* @__PURE__ */ g(
        M6,
        {
          className: "bccb-widget-to-network-list-item" + (o?.id === h.id ? "-active" : ""),
          iconUrl: h.icon,
          isActive: o?.id === h.id,
          isDisabled: !h.isCompatible,
          incompatibleTooltip: r({
            id: "select-modal.destination.incompatible.tooltip"
          }),
          onClick: () => {
            qt({
              id: "select_bridge_toDropdown",
              params: {
                item_name: h.name
              }
            }), h.chainType === "link" ? E6(h.externalBridgeUrl) : (i(h.id), n());
          },
          children: /* @__PURE__ */ X(re, { alignItems: "center", w: "100%", children: [
            /* @__PURE__ */ g(_n, { isTruncated: !0, children: h.name }),
            h.chainType === "link" && /* @__PURE__ */ g(
              $s,
              {
                ml: "4px",
                color: a.colors[l].text.secondary,
                boxSize: a.sizes[4]
              }
            )
          ] })
        },
        h.id
      ) })
    }
  );
}
function Gue() {
  const { isOpen: e, onClose: t, onOpen: n } = wo(), { formatMessage: r } = n1(), { colorMode: o } = Ee(), i = N((a) => a.transfer.toChain);
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-network-to",
      flexDir: "column",
      gap: "8px",
      w: "100%",
      flex: 1,
      h: "48px",
      children: [
        /* @__PURE__ */ g(
          re,
          {
            className: "bccb-widget-network-to-title",
            alignItems: "center",
            justifyContent: "space-between",
            display: { base: "flex", md: "none" },
            children: /* @__PURE__ */ g(mt, { variant: "label", size: "md", color: H.colors[o].text.placeholder, children: r({ id: "to.section.title" }) })
          }
        ),
        /* @__PURE__ */ g(
          HM,
          {
            isActive: e,
            chain: i,
            onClick: () => {
              n(), qt({
                id: "click_bridge_toDropdown"
              });
            }
          }
        ),
        /* @__PURE__ */ g(zue, { isOpen: e, onClose: t })
      ]
    }
  );
}
function Wue(e) {
  return /* @__PURE__ */ X(U1, { width: "16px", height: "16px", viewBox: "0 0 16 16", fill: "currentColor", ...e, children: [
    /* @__PURE__ */ g("path", { d: "M2.49924 6.66634C2.35757 6.66634 2.23895 6.61937 2.14337 6.52541C2.04779 6.43146 2 6.31486 2 6.1756C2 6.03635 2.04779 5.91975 2.14337 5.82579C2.23895 5.73184 2.35757 5.68487 2.49924 5.68487H12.3384L10.7856 4.15847C10.6934 4.06787 10.6473 3.95672 10.6473 3.82502C10.6473 3.69331 10.699 3.57671 10.8022 3.47521C10.8987 3.38041 11.0156 3.33301 11.153 3.33301C11.2904 3.33301 11.4073 3.38041 11.5037 3.47521L13.8297 5.76162C13.892 5.82285 13.936 5.88745 13.9616 5.9554C13.9872 6.02334 14 6.09674 14 6.1756C14 6.25446 13.9872 6.32786 13.9616 6.39581C13.936 6.46376 13.892 6.52844 13.8297 6.58968C13.7663 6.6408 13.7117 6.66634 13.3996 6.66634H2.49924Z" }),
    /* @__PURE__ */ g("path", { d: "M13.5008 9.33301C13.6424 9.33301 13.7611 9.37998 13.8566 9.47394C13.9522 9.56789 14 9.68449 14 9.82375C14 9.963 13.9522 10.0796 13.8566 10.1736C13.7611 10.2675 13.6424 10.3145 13.5008 10.3145H3.66157L5.2144 11.8409C5.30657 11.9315 5.35266 12.0426 5.35266 12.1743C5.35266 12.306 5.30103 12.4226 5.19776 12.5241C5.10132 12.6189 4.98441 12.6663 4.84702 12.6663C4.70962 12.6663 4.59271 12.6189 4.49627 12.5241L2.17026 10.2377C2.10796 10.1765 2.064 10.1119 2.03841 10.0439C2.0128 9.976 2 9.9026 2 9.82375C2 9.74489 2.0128 9.67149 2.03841 9.60354C2.064 9.53559 2.10796 9.47091 2.17026 9.40967C2.23372 9.35855 2.28833 9.33301 2.60036 9.33301H13.5008Z" })
  ] });
}
function $ue(e) {
  const { colorMode: t } = Ee(), n = Xe(), { exchange: r } = w2();
  return /* @__PURE__ */ g(
    re,
    {
      className: "bccb-widget-exchange-chain-icon",
      width: "100%",
      alignSelf: "center",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50%",
      background: n.colors[t].button.exchange.default,
      color: n.colors[t].text.secondary,
      _hover: {
        color: n.colors[t].text.inverse,
        bg: n.colors[t].button.exchange.hover
      },
      transition: "normal",
      w: "24px",
      h: "24px",
      cursor: "pointer",
      m: { base: "12px 0 4px", md: "0 12px 0 12px" },
      onClick: () => r(),
      ...e,
      children: /* @__PURE__ */ g(Wue, { transform: { base: "rotate(90deg)", md: "none" } })
    }
  );
}
const Uue = () => {
  const { formatMessage: e } = n1(), { colorMode: t } = Ee(), n = Xe();
  return /* @__PURE__ */ X(re, { className: "bccb-widget-network", flexDir: "column", gap: "8px", children: [
    /* @__PURE__ */ X(re, { flexDir: "row", display: { base: "none", md: "flex" }, children: [
      /* @__PURE__ */ g(
        re,
        {
          className: "bccb-widget-network-title",
          alignItems: "center",
          justifyContent: "space-between",
          flex: 1,
          children: /* @__PURE__ */ g(
            mt,
            {
              variant: "label",
              size: "md",
              color: n.colors[t].text.network.title,
              children: e({ id: "from.section.title" })
            }
          )
        }
      ),
      /* @__PURE__ */ g(
        re,
        {
          className: "bccb-widget-network-title",
          alignItems: "center",
          justifyContent: "space-between",
          flex: 1,
          ml: "48px",
          display: { base: "none", md: "flex" },
          children: /* @__PURE__ */ g(
            mt,
            {
              variant: "label",
              size: "md",
              color: n.colors[t].text.network.title,
              children: e({ id: "to.section.title" })
            }
          )
        }
      )
    ] }),
    " ",
    /* @__PURE__ */ X(
      re,
      {
        className: "bccb-widget-network-row",
        flexDir: ["column", "column", "row"],
        justifyContent: "space-between",
        alignItems: "center",
        minW: 0,
        children: [
          /* @__PURE__ */ g(Due, {}),
          /* @__PURE__ */ g($ue, {}),
          /* @__PURE__ */ g(Gue, {})
        ]
      }
    )
  ] });
}, jue = () => {
  const e = Xe(), t = N((h) => h.transfer.selectedToken), n = N((h) => h.transfer.fromChain), r = D1(), { colorMode: o } = Ee(), { formatMessage: i } = n1(), { getTokenBalance: a } = ah(), { getTokenPrice: l } = Ws(), c = a(t), u = l({
    chainId: n?.id,
    chainType: n?.chainType,
    tokenAddress: t?.address,
    tokenSymbol: t?.symbol
  });
  return /* @__PURE__ */ g(re, { className: "bccb-widget-transfer-max", alignItems: "center", children: c !== void 0 && !!t ? /* @__PURE__ */ X(
    h1,
    {
      className: "max-text",
      onClick: () => {
        if (c && t) {
          const h = c.toString();
          r(oa(h)), qt({
            id: "click_bridge_max",
            params: {
              item_name: n?.name,
              token: t.displaySymbol,
              value: h
            }
          });
        }
      },
      color: e.colors[o].text.tertiary,
      textDecoration: "underline",
      textUnderlineOffset: "2px",
      cursor: c ? "pointer" : "auto",
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      transitionDuration: "normal",
      sx: {
        "@media (hover:hover)": {
          _hover: {
            color: c ? e.colors[o].text.primary : e.colors[o].text.tertiary
          }
        }
      },
      children: [
        i({ id: "from.section.balance.button.max" }),
        " ",
        F1(Number(c) || 0, 8),
        " ",
        t?.displaySymbol,
        u && ` ($${F1(u * Number(c || 0), 2)})`
      ]
    }
  ) : null });
}, bB = ({
  children: e,
  tokenInfo: t,
  tokenLinkUrl: n,
  isReceiveArea: r,
  chainType: o = "evm",
  offset: i,
  ...a
}) => {
  const l = t?.address ?? "", c = Xe(), u = we(
    () => di(l, o),
    [o, l]
  );
  return /* @__PURE__ */ g(
    re,
    {
      className: "bccb-widget-route-token-tooltip",
      display: "inline-block",
      w: "auto",
      ...a,
      children: /* @__PURE__ */ g(jd, { children: /* @__PURE__ */ X(
        vI,
        {
          placement: "top-start",
          trigger: "hover",
          strategy: "fixed",
          autoFocus: !1,
          offset: i,
          children: [
            /* @__PURE__ */ g(bI, { children: e }),
            /* @__PURE__ */ g(o2, { children: /* @__PURE__ */ X(
              SI,
              {
                className: "bccb-widget-route-token-tooltip-content",
                borderRadius: "4px",
                maxW: "280px",
                marginLeft: r ? "-36px" : "",
                marginBottom: r ? "-4px" : "",
                children: [
                  /* @__PURE__ */ g(yI, { className: "tooltip-arrow" }),
                  /* @__PURE__ */ g(
                    xI,
                    {
                      className: "bccb-widget-route-token-tooltip-body",
                      px: "8px",
                      py: "7px",
                      onClick: (f) => f.stopPropagation(),
                      children: /* @__PURE__ */ X(st, { children: [
                        /* @__PURE__ */ g(h1, { color: c.colors.light.text.primary, fontSize: "12px", fontWeight: 400, children: u ? "Native token" : "Token address:" }),
                        !u && /* @__PURE__ */ g(h1, { color: c.colors.light.text.primary, fontSize: "12px", fontWeight: 700, children: l && /* @__PURE__ */ g(
                          Ts,
                          {
                            isExternal: !0,
                            href: n,
                            display: "block",
                            overflowWrap: "break-word",
                            pointerEvents: "all",
                            color: "currentColor",
                            _hover: n ? {
                              color: c.colors.light.modal.item.text.primary
                            } : void 0,
                            children: l
                          }
                        ) })
                      ] })
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) })
    }
  );
};
function Xue(e) {
  const { token: t, ...n } = e, { colorMode: r } = Ee(), o = N((l) => l.transfer.fromChain), i = Xe(), a = we(() => t ? v3(o?.tokenUrlPattern, t.address) : "", [t, o?.tokenUrlPattern]);
  return /* @__PURE__ */ X(
    Hr,
    {
      className: "bccb-widget-token-select-button",
      borderRadius: "24px",
      flexShrink: 0,
      h: "32px",
      p: "4px 8px 4px 4px",
      justifyContent: "space-between",
      gap: "8px",
      transition: "all .15s",
      background: i.colors[r].layer[4].default,
      _hover: {
        background: i.colors[r].layer[4].hover
      },
      color: i.colors[r].text.primary,
      ...n,
      children: [
        /* @__PURE__ */ X(re, { gap: "8px", alignItems: "center", position: "relative", overflow: "hidden", children: [
          /* @__PURE__ */ g(
            bB,
            {
              chainType: o?.chainType,
              tokenInfo: t,
              tokenLinkUrl: a,
              offset: [-20, 6],
              "data-address": t?.address,
              "data-name": t?.name,
              "data-symbol": t?.symbol,
              "data-display-symbol": t?.displaySymbol,
              children: /* @__PURE__ */ g(h1, { children: /* @__PURE__ */ g(Bo, { src: t?.icon, w: "24px", h: "24px" }) })
            }
          ),
          /* @__PURE__ */ g(
            re,
            {
              flexDir: "column",
              alignItems: "flex-start",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textAlign: "left",
              sx: {
                p: {
                  w: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }
              },
              children: /* @__PURE__ */ g(_n, { fontSize: "16px", lineHeight: "24px", children: t?.displaySymbol })
            }
          )
        ] }),
        /* @__PURE__ */ g(yp, { w: "24px", h: "24px", color: i.colors[r].button.select.arrow })
      ]
    }
  );
}
function Yue() {
  const { fetchTokenPrice: e } = Ws(), t = Lt(), n = N((c) => c.transfer.fromChain), r = N((c) => c.transfer.selectedToken), o = N((c) => c.transfer.sendValue), { data: i, isError: a } = gi({
    staleTime: P0.MINUTE * 5,
    queryKey: [
      "tokenPrice",
      n?.id,
      n?.chainType,
      r?.address,
      !!o
    ],
    queryFn: async () => n && r && o ? (await e({
      chainId: n?.id,
      chainType: n?.chainType,
      tokenAddress: r?.address,
      tokenSymbol: r?.symbol
    })).data : null
  });
  return we(() => {
    if (r) {
      if (a)
        return {
          isError: !0
        };
      if (i) {
        const c = t.transfer.dollarUpperLimit / i, u = en(String(c), r.decimals);
        return {
          isError: !1,
          upperLimit: c,
          value: u,
          price: i,
          decimals: r.decimals
        };
      }
    }
  }, [t.transfer.dollarUpperLimit, a, i, r]);
}
const Jue = () => {
  const { data: e } = x6(), t = Us(), {
    transfer: { dollarUpperLimit: n }
  } = Lt(), r = Number(e?.formatted), o = N((c) => c.transfer.fromChain), i = N((c) => c.transfer.selectedToken), a = Yue();
  return {
    validateInput: se(
      ({
        balance: c,
        decimal: u,
        value: f,
        bridgeType: p,
        estimatedAmount: h
      }) => {
        try {
          if (!u || !f)
            return null;
          if (Number(f) < Math.pow(10, -u))
            return {
              text: "The amount is too small. Please enter a valid amount to transfer.",
              isError: !0
            };
          if (a?.isError)
            return {
              text: "This token is not available at the moment. Please try again later.",
              isError: !0
            };
          if (a?.upperLimit && Number(f) > Number(a?.upperLimit))
            return {
              text: `Transfer value over $${F1(n)} (${F1(
                a.upperLimit
              )} ${i?.symbol}) is not allowed`,
              isError: !0
            };
          if (c && f > c)
            return { text: "You have insufficient balance", isError: !0 };
          if (h?.stargate && p === "stargate" && f) {
            const C = x1(h.stargate[0].maxAmountLD, u);
            if (f > Number(C))
              return {
                text: `The amount should be less than ${F1(Number(C))}.`,
                isError: !0
              };
          }
          if (c)
            return o?.chainType === "solana" && r < th ? {
              text: "",
              // Error message has been moved to send button section
              isError: !0
            } : { text: `${F1(c)}`, isError: !1 };
          if (t)
            return { isError: !0, text: "You have insufficient balance" };
        } catch (C) {
          console.log(C);
        }
      },
      [
        o?.chainType,
        r,
        t,
        a,
        n,
        i?.symbol
      ]
    )
  };
}, Que = () => {
  const { colorMode: e } = Ee(), { validateInput: t } = Jue(), { chain: n } = lt(), r = D1(), o = N((b) => b.transfer.transferActionInfo), i = Xe(), a = N((b) => b.transfer.error), l = N((b) => b.transfer.selectedToken), c = N((b) => b.transfer.sendValue), u = N((b) => b.transfer.estimatedAmount), f = N((b) => b.aggregator.bridgeMaxMin.cBridge), { getTokenBalance: p } = ah(), [h, C] = ze("");
  Oe(() => {
    const b = p({
      address: l?.address?.toLowerCase()
    }), y = t({
      balance: b ? Number(b) : void 0,
      decimal: l?.decimals || 0,
      value: Number(c),
      // isConnected: !!chain,
      bridgeType: o?.bridgeType,
      estimatedAmount: u
    });
    y?.isError === !0 ? (r(gd(!1)), r(Cd({ text: y.text })), C(y.text)) : (C(""), r(Cd({ text: "" })), r(gd(!0)));
  }, [
    n,
    c,
    r,
    u,
    f.min,
    f.max,
    l?.decimals,
    l?.isPegged,
    o,
    t,
    p,
    l?.address
  ]);
  const v = h ?? a?.text;
  return v ? /* @__PURE__ */ g(
    h1,
    {
      className: "bccb-widget-transfer-input-error",
      color: i.colors[e].text.danger,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "16px",
      mt: "8px",
      children: v
    }
  ) : null;
}, S3 = (e, t = 500) => {
  const [n, r] = ze(e), o = Re();
  return Oe(() => (o.current = setTimeout(() => r(e), t), () => {
    clearTimeout(o.current);
  }), [e, t]), n;
};
function que(e = [], t) {
  const n = N((u) => u.transfer.fromChain), r = N((u) => u.transfer.selectedToken), o = N((u) => u.aggregator.isLoadingTokenBalances), i = N((u) => u.aggregator.isLoadingTokenPrices), { getTokenBalance: a } = ah(), { getTokenPrice: l } = Ws();
  return { data: we(() => {
    const u = e.map((p) => {
      const h = a(p), C = l({
        chainId: n?.id,
        chainType: n?.chainType,
        tokenAddress: p?.address,
        tokenSymbol: p.symbol
      });
      let v;
      return h !== void 0 && C !== void 0 && (v = Number(h) * C), {
        ...p,
        balance: h,
        value: v
      };
    });
    return gB({
      tokens: u
    }).sort((p) => ja(p.address, r?.address) && p.isCompatible ? -1 : 0);
  }, [
    e,
    a,
    l,
    n?.id,
    n?.chainType,
    r?.address
  ]), isLoading: o || i };
}
function Kue(e) {
  const { isOpen: t, onClose: n } = e, { formatMessage: r } = n1(), o = Xe(), { colorMode: i } = Ee(), a = N((I) => I.transfer.fromChain), l = N((I) => I.transfer.selectedToken), { isMobile: c } = L6(), { selectToken: u } = w2(), f = GE(), { isNoResult: p, result: h, keyword: C, onSearch: v } = wh({
    data: f,
    filter: (I, M) => I.displaySymbol?.toLowerCase().includes(M?.toLowerCase()) || I.name?.toLowerCase().includes(M?.toLowerCase()) || ja(I.address, M)
  }), { isLoading: b, data: y } = que(h), x = lt(), T = hr(), A = Ho(), L = !b && (a?.chainType === "evm" && x.isConnected || a?.chainType === "tron" && T.isConnected || a?.chainType === "solana" && A.isConnected);
  return /* @__PURE__ */ X(
    xh,
    {
      className: "bccb-widget-token-modal",
      isOpen: t,
      onClose: n,
      title: r({ id: "select-modal.token.title" }),
      onSearch: v,
      placeholder: r({ id: "select-modal.token.placeholder" }),
      isNoResult: p,
      children: [
        L && /* @__PURE__ */ X(
          re,
          {
            className: "bccb-widget-token-modal-list-header",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "16px",
            color: o.colors[i].text.secondary,
            pb: "12px",
            px: "20px",
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ g(_n, { children: r({ id: "select-modal.token.column.name" }) }),
              /* @__PURE__ */ g(_n, { children: r({ id: "select-modal.token.column.balance" }) })
            ]
          }
        ),
        /* @__PURE__ */ g(re, { flexDir: "column", flex: 1, children: /* @__PURE__ */ g(yh, { className: "bccb-widget-token-virtual-list", data: y, itemHeight: 52, children: (I) => {
          const M = !I.isCompatible, k = ja(I.address, l?.address) && I.isCompatible, _ = di(I.address, a?.chainType);
          return /* @__PURE__ */ g(
            M6,
            {
              className: "bccb-widget-token-list-item" + (k ? "-active" : M ? "-disabled" : ""),
              iconUrl: I.icon,
              isActive: k,
              isDisabled: M,
              "data-address": I.address,
              "data-name": I.name,
              "data-symbol": I.symbol,
              "data-display-symbol": I.displaySymbol,
              incompatibleTooltip: r({
                id: "select-modal.token.incompatible.tooltip"
              }),
              _hover: {
                ".token-info": {
                  transform: "translateY(-100%)"
                }
              },
              onClick: () => {
                qt({
                  id: "select_bridge_tokenDropdown",
                  params: {
                    item_name: I?.displaySymbol ?? I?.symbol
                  }
                }), u(I.address), n();
              },
              children: /* @__PURE__ */ X(re, { alignItems: "center", justifyContent: "space-between", w: "100%", gap: "12px", children: [
                /* @__PURE__ */ X(re, { flex: 1, minW: 0, flexDir: "column", gap: "0", children: [
                  /* @__PURE__ */ g(_n, { className: "bccb-widget-token-list-symbol", isTruncated: !0, children: I.displaySymbol }),
                  c && !_ && /* @__PURE__ */ g(
                    Yx,
                    {
                      tokenUrlPattern: a?.tokenUrlPattern,
                      address: I.address
                    }
                  ),
                  !c && /* @__PURE__ */ g(re, { className: "bccb-widget-token-address-link", h: "16px", overflow: "hidden", children: /* @__PURE__ */ X(
                    re,
                    {
                      flexDir: "column",
                      className: _ ? void 0 : "token-info",
                      transitionDuration: "normal",
                      whiteSpace: "nowrap",
                      w: "100%",
                      color: o.colors[i].text.secondary,
                      children: [
                        /* @__PURE__ */ g(
                          _n,
                          {
                            className: "token-name",
                            isTruncated: !0,
                            flexShrink: 0,
                            fontSize: "12px",
                            fontWeight: 500,
                            lineHeight: "16px",
                            children: I.name
                          }
                        ),
                        !_ && /* @__PURE__ */ g(
                          Yx,
                          {
                            tokenUrlPattern: a?.tokenUrlPattern,
                            address: I.address
                          }
                        )
                      ]
                    }
                  ) })
                ] }),
                !M && L && /* @__PURE__ */ X(
                  re,
                  {
                    className: "bccb-widget-token-list-token-balance",
                    flexShrink: 0,
                    flexDir: "column",
                    alignItems: "flex-end",
                    gap: "4px",
                    alignSelf: "flex-start",
                    children: [
                      /* @__PURE__ */ g(re, { children: I.balance !== void 0 ? F1(I.balance, 4) : "-" }),
                      /* @__PURE__ */ g(
                        re,
                        {
                          flexDir: "column",
                          fontSize: "12px",
                          fontWeight: 500,
                          lineHeight: "16px",
                          color: o.colors[i].text.secondary,
                          children: I.value ? `$${F1(I.value, 2)}` : ""
                        }
                      )
                    ]
                  }
                )
              ] })
            },
            I.address
          );
        } }) })
      ]
    }
  );
}
function Yx(e) {
  const { address: t, tokenUrlPattern: n } = e, r = Xe(), { colorMode: o } = Ee(), { isMobile: i } = L6();
  return /* @__PURE__ */ g(re, { className: "bccb-widget-token-list-address", children: /* @__PURE__ */ X(
    _n,
    {
      isTruncated: !0,
      flexShrink: 0,
      display: "inline-flex",
      alignItems: "center",
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      children: [
        n2({
          address: t
        }),
        !i && /* @__PURE__ */ g(
          $s,
          {
            ml: "4px",
            color: r.colors[o].text.secondary,
            boxSize: r.sizes[4],
            transitionDuration: "normal",
            _hover: {
              color: r.colors[o].text.primary
            },
            onClick: (a) => {
              if (!i) {
                a.stopPropagation();
                const l = v3(n, t);
                E6(l);
              }
            }
          }
        )
      ]
    }
  ) });
}
const ede = (e) => {
  e.key !== "1" && e.key !== "2" && e.key !== "3" && e.key !== "4" && e.key !== "5" && e.key !== "6" && e.key !== "7" && e.key !== "8" && e.key !== "9" && e.key !== "0" && e.key !== "." && e.key !== "," && e.key !== "。" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Backspace" && e.preventDefault();
}, tde = () => {
  const { colorMode: e } = Ee(), t = D1(), { formatMessage: n } = n1(), r = Re(), o = Xe(), [i, a] = ze(!1), l = N((x) => x.transfer.sendValue), c = N((x) => x.transfer.selectedToken), u = N((x) => x.transfer.isGlobalFeeLoading), f = N((x) => x.transfer.fromChain), p = N((x) => x.transfer.error), { isOpen: h, onClose: C, onOpen: v } = wo(), b = S3(l, _s), y = (x) => {
    let T = x.target.value.trim() ?? 0;
    T = T.replace("。", ".").replace(",", ".");
    const A = T.split(".")[1]?.length || 0;
    if (T.split(".").length > 2 || A > 18) return;
    T === "." && (T = "0.");
    const L = /(?:^\.(\d+))|(?:^0(\d+))/g;
    L.test(T) && T.replace(L, (...M) => M[1] || M[2] ? "0." + (M[1] || M[2]) : "");
    const I = isNaN(Number(T)) ? "0" : T;
    t(oa(I)), clearTimeout(r.current), r.current = setTimeout(() => {
      qt({
        id: "input_bridge_amount",
        params: {
          item_name: f?.name,
          token: c?.displaySymbol,
          value: I
        }
      });
    }, _s);
  };
  return Oe(() => {
    u && l === b && a(!1);
  }, [u, b, l]), /* @__PURE__ */ X(re, { className: "bccb-widget-transfer-input-container", flexDir: "column", position: "relative", children: [
    /* @__PURE__ */ X(re, { className: "bccb-widget-input-title", flexDir: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ g(
        mt,
        {
          className: "input-header-label",
          color: o.colors[e].text.network.title,
          variant: "label",
          size: "md",
          children: n({ id: "you.send.title" })
        }
      ),
      /* @__PURE__ */ g(jue, {})
    ] }),
    /* @__PURE__ */ X(
      re,
      {
        className: `bccb-widget-transfer-input-wrapper ${p?.text ? "input-error" : i ? "input-focused" : ""}`,
        flex: 1,
        mt: "8px",
        flexDir: "row",
        justifyContent: "space-between",
        alignItems: "center",
        p: "3px 12px",
        h: "48px",
        borderRadius: "8px",
        border: "1px solid",
        gap: "8px",
        borderColor: `${p?.text ? o.colors[e].text.danger : i ? o.colors[e].text.brand : o.colors[e].input.border.default}`,
        boxShadow: p?.text ? `0 0 0 1px ${o.colors[e].text.danger}` : i ? `0 0 0 1px ${o.colors[e].text.brand}` : "none",
        background: o.colors[e].input.background,
        position: "relative",
        _hover: {
          outline: "1px solid",
          outlineColor: p?.text ? o.colors[e].text.danger : i ? o.colors[e].text.brand : o.colors[e].input.border.hover,
          border: `1px solid ${p?.text ? o.colors[e].text.danger : i ? o.colors[e].text.brand : o.colors[e].input.border.hover}`
        },
        children: [
          /* @__PURE__ */ g(
            K0,
            {
              className: "bccb-widget-transfer-input",
              inputMode: "decimal",
              value: l,
              color: o.colors[e].text.primary,
              fontSize: "24px",
              onChange: y,
              placeholder: "0.0",
              onFocus: () => {
                a(!0);
              },
              onBlur: () => {
                a(!1);
              },
              border: "none",
              disabled: !c || u && l === b,
              _hover: {
                border: "none",
                background: "none"
              },
              _focus: {
                border: "none",
                background: "none"
              },
              _focusVisible: {
                border: "none",
                background: "none"
              },
              _disabled: {
                border: "none",
                background: "none"
              },
              px: 0,
              background: "none",
              borderRadius: 0,
              onKeyDown: ede,
              step: "0.000000001",
              onWheel: (x) => x.target.blur()
            }
          ),
          /* @__PURE__ */ g(
            Xue,
            {
              token: c,
              onClick: () => {
                qt({
                  id: "click_bridge_tokenDropdown"
                }), v();
              }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ g(Que, {}),
    /* @__PURE__ */ g(Kue, { isOpen: h, onClose: C })
  ] });
};
function nde(e) {
  return /* @__PURE__ */ X(
    U1,
    {
      className: "alert-icon",
      width: "16px",
      height: "17px",
      viewBox: "0 0 16 17",
      fill: "currentColor",
      color: "#FFE900",
      ...e,
      children: [
        /* @__PURE__ */ g(
          "mask",
          {
            id: "mask0_4487_75756",
            style: {
              maskType: "alpha"
            },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "16",
            height: "17",
            children: /* @__PURE__ */ g("rect", { y: "0.5", width: "16", height: "16", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ g("g", { mask: "url(#mask0_4487_75756)", children: /* @__PURE__ */ g("path", { d: "M1.81669 14.5C1.69447 14.5 1.58336 14.4694 1.48336 14.4083C1.38336 14.3472 1.30558 14.2667 1.25002 14.1667C1.19447 14.0667 1.16391 13.9583 1.15836 13.8417C1.1528 13.725 1.18336 13.6111 1.25002 13.5L7.41669 2.83333C7.48336 2.72222 7.56947 2.63889 7.67502 2.58333C7.78058 2.52778 7.88891 2.5 8.00002 2.5C8.11113 2.5 8.21947 2.52778 8.32502 2.58333C8.43058 2.63889 8.51669 2.72222 8.58336 2.83333L14.75 13.5C14.8167 13.6111 14.8472 13.725 14.8417 13.8417C14.8361 13.9583 14.8056 14.0667 14.75 14.1667C14.6945 14.2667 14.6167 14.3472 14.5167 14.4083C14.4167 14.4694 14.3056 14.5 14.1834 14.5H1.81669ZM2.96669 13.1667H13.0334L8.00002 4.5L2.96669 13.1667ZM8.00002 12.5C8.18891 12.5 8.34725 12.4361 8.47502 12.3083C8.6028 12.1806 8.66669 12.0222 8.66669 11.8333C8.66669 11.6444 8.6028 11.4861 8.47502 11.3583C8.34725 11.2306 8.18891 11.1667 8.00002 11.1667C7.81113 11.1667 7.6528 11.2306 7.52502 11.3583C7.39724 11.4861 7.33336 11.6444 7.33336 11.8333C7.33336 12.0222 7.39724 12.1806 7.52502 12.3083C7.6528 12.4361 7.81113 12.5 8.00002 12.5ZM8.00002 10.5C8.18891 10.5 8.34725 10.4361 8.47502 10.3083C8.6028 10.1806 8.66669 10.0222 8.66669 9.83333V7.83333C8.66669 7.64444 8.6028 7.48611 8.47502 7.35833C8.34725 7.23056 8.18891 7.16667 8.00002 7.16667C7.81113 7.16667 7.6528 7.23056 7.52502 7.35833C7.39724 7.48611 7.33336 7.64444 7.33336 7.83333V9.83333C7.33336 10.0222 7.39724 10.1806 7.52502 10.3083C7.6528 10.4361 7.81113 10.5 8.00002 10.5Z" }) })
      ]
    }
  );
}
const Ys = ({
  receiveAmt: e,
  toTokenInfo: t,
  isError: n,
  hoverToShowTokenAddress: r = !0
}) => {
  const o = Xe(), { colorMode: i } = Ee(), a = N((u) => u.transfer.toChain), l = v3(a?.tokenUrlPattern, t?.address), c = di(t?.address, a?.chainType);
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-route-token",
      flexDir: "row",
      gap: "8px",
      display: "inline",
      opacity: n ? 0.5 : 1,
      children: [
        /* @__PURE__ */ g(
          re,
          {
            className: "bccb-widget-route-title-amount",
            fontSize: "24px",
            fontWeight: 500,
            lineHeight: "32px",
            wordBreak: "break-all",
            display: "inline",
            mr: "8px",
            color: o.colors[i].text.primary,
            children: e
          }
        ),
        t && r && /* @__PURE__ */ g(
          bB,
          {
            chainType: a?.chainType,
            tokenInfo: t,
            tokenLinkUrl: l,
            isReceiveArea: !0,
            "data-to-address": t?.address,
            "data-to-name": t?.name,
            "data-to-symbol": t?.symbol,
            "data-to-display-symbol": t?.displaySymbol,
            children: /* @__PURE__ */ g(
              Pd,
              {
                toTokenInfo: t,
                tokenUrl: l,
                hoverToShowTokenAddress: r,
                isNative: c
              }
            )
          }
        ),
        t && !r && /* @__PURE__ */ g(
          Pd,
          {
            toTokenInfo: t,
            tokenUrl: l,
            hoverToShowTokenAddress: r,
            isNative: c
          }
        )
      ]
    }
  );
}, Pd = w.forwardRef(
  (e, t) => {
    const {
      toTokenInfo: n,
      tokenUrl: r,
      hoverToShowTokenAddress: o = !0,
      isNative: i = !1,
      ...a
    } = e, l = Xe(), { colorMode: c } = Ee(), { formatMessage: u } = n1();
    return /* @__PURE__ */ X(
      re,
      {
        className: "bccb-widget-route-token-icon",
        flexDir: "row",
        gap: "4px",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "20px",
        display: "inline-flex",
        ref: t,
        ...a,
        children: [
          /* @__PURE__ */ g(
            Bo,
            {
              src: n.icon,
              w: "16px",
              h: "16px",
              fallbackBgColor: l.colors[c].support.primary[4]
            }
          ),
          /* @__PURE__ */ g(re, { children: n.displaySymbol }),
          !o && !i && /* @__PURE__ */ X(
            re,
            {
              alignItems: "center",
              color: l.colors[c].text.tertiary,
              justifyContent: "flex-start",
              className: "bccb-widget-route-token-to-address",
              "data-to-address": n.address,
              "data-to-name": n.name,
              "data-to-symbol": n.symbol,
              "data-to-display-symbol": n.displaySymbol,
              children: [
                /* @__PURE__ */ X(
                  Ts,
                  {
                    href: r,
                    isExternal: !0,
                    color: l.colors[c].text.tertiary,
                    mx: "4px",
                    sx: {
                      "@media (hover:hover)": {
                        _hover: {
                          color: l.colors[c].text.primary
                        }
                      }
                    },
                    children: [
                      "(",
                      n2({
                        address: n.address
                      }),
                      ")"
                    ]
                  }
                ),
                /* @__PURE__ */ g(
                  y6,
                  {
                    label: u({ id: "route.token-address.tips" }),
                    maxW: "250px",
                    placement: "top",
                    hasArrow: !0,
                    children: /* @__PURE__ */ g(pi, { children: /* @__PURE__ */ g(nde, {}) })
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
);
Pd.displayName = "ToTokenInfo";
const Th = ({
  isError: e,
  allowedSendAmount: t,
  ...n
}) => {
  const r = Xe(), { colorMode: o } = Ee(), { formatMessage: i } = n1(), a = N((l) => l.transfer.selectedToken);
  return t && e ? /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-allowed-send-amount",
      flexDir: "row",
      alignItems: "center",
      color: e ? r.colors[o].route.warning : r.colors[o].text.tertiary,
      lineHeight: "16px",
      display: "inline-block",
      sx: {
        ">svg": {
          verticalAlign: "-3px"
        }
      },
      ...n,
      children: [
        /* @__PURE__ */ g(K9, { display: "inline", w: "16px", h: "16px" }),
        /* @__PURE__ */ g(h1, { ml: "4px", display: "inline", fontSize: "14px", fontWeight: 400, children: i(
          { id: "route.allowed-send-amount" },
          { symbol: a?.symbol, min: t.min, max: t.max }
        ) })
      ]
    }
  ) : null;
};
function rde(e) {
  return /* @__PURE__ */ g(
    U1,
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "34",
      height: "34",
      viewBox: "0 0 34 34",
      fill: "none",
      ...e,
      children: /* @__PURE__ */ X("g", { clipPath: "url(#clip0_3204_147712_)", children: [
        /* @__PURE__ */ X("g", { clipPath: "url(#clip1_3204_147712_)", children: [
          /* @__PURE__ */ g(
            "path",
            {
              d: "M19.968 1.32562L20.8548 3.40275C22.5954 7.48112 25.8439 10.7296 29.9222 12.4702L31.9994 13.357C32.543 13.5888 32.9843 13.9212 33.325 14.3172C32.2906 6.90039 26.4246 1.03362 19.0078 0C19.403 0.33984 19.7362 0.78198 19.968 1.32562H19.968Z",
              fill: "#999999"
            }
          ),
          /* @__PURE__ */ g(
            "path",
            {
              d: "M1.32562 13.357L3.40277 12.4702C7.48114 10.7296 10.7296 7.48112 12.471 3.40275L13.357 1.32562C13.5896 0.78198 13.9221 0.33984 14.3172 0C6.90039 1.03362 1.03442 6.90039 0 14.3172C0.34067 13.9212 0.78201 13.5888 1.32562 13.357Z",
              fill: "#999999"
            }
          ),
          /* @__PURE__ */ g(
            "path",
            {
              d: "M31.9994 19.9651L29.9222 20.8519C25.8439 22.5924 22.5954 25.8418 20.8548 29.9201L19.968 31.9965C19.7362 32.5401 19.403 32.9823 19.0078 33.3229C26.4246 32.2885 32.2906 26.4217 33.325 19.0049C32.9843 19.4009 32.543 19.7333 31.9994 19.9651H31.9994Z",
              fill: "#999999"
            }
          ),
          /* @__PURE__ */ g(
            "path",
            {
              d: "M13.357 31.9965L12.471 29.9201C10.7296 25.8418 7.48114 22.5924 3.40277 20.8519L1.32562 19.9651C0.78201 19.7333 0.34067 19.4009 0 19.0049C1.03442 26.4217 6.90039 32.2885 14.3172 33.3229C13.9221 32.9823 13.5896 32.5401 13.357 31.9965Z",
              fill: "#999999"
            }
          )
        ] }),
        /* @__PURE__ */ g(
          "path",
          {
            d: "M9.10261 15.0333L10.1263 14.5961C12.1358 13.7381 13.737 12.1378 14.5949 10.1283L15.0313 9.10457C15.6434 7.67087 17.6759 7.67087 18.288 9.10457L18.7244 10.1283C19.5823 12.1378 21.1835 13.7381 23.193 14.5961L24.2167 15.0333C25.6504 15.6453 25.6504 17.6771 24.2167 18.2892L23.193 18.7264C21.1835 19.5843 19.5823 21.1846 18.7244 23.195L18.288 24.2178C17.6759 25.6515 15.6434 25.6515 15.0313 24.2178L14.5949 23.195C13.737 21.1846 12.1358 19.5843 10.1263 18.7264L9.10261 18.2892C7.66892 17.6771 7.66892 15.6453 9.10261 15.0333Z",
            fill: "black"
          }
        )
      ] })
    }
  );
}
function ode(e) {
  return /* @__PURE__ */ X(
    U1,
    {
      width: "440",
      height: "280",
      viewBox: "0 0 440 280",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ g("circle", { cx: "89.8975", cy: "187.751", r: "70.8975", fill: "#444444" }),
        /* @__PURE__ */ g("circle", { cx: "349.536", cy: "187.751", r: "70.8975", fill: "#DDDDDD" }),
        /* @__PURE__ */ g("g", { mask: "url(#mask0_1455_365)", children: /* @__PURE__ */ X("g", { mask: "url(#mask1_1455_365)", children: [
          /* @__PURE__ */ g(
            "path",
            {
              d: "M46.0176 197.92C46.0176 102.219 123.599 24.6375 219.3 24.6375C315.001 24.6375 392.582 102.219 392.582 197.92V504.033H46.0176V197.92Z",
              fill: "#E9BCFF"
            }
          ),
          /* @__PURE__ */ g(
            "path",
            {
              d: "M65.6729 200.579C65.6729 115.606 134.557 46.7213 219.531 46.7213C304.505 46.7213 373.389 115.606 373.389 200.579V534.718H65.6729V200.579Z",
              fill: "#2C98F3"
            }
          ),
          /* @__PURE__ */ g(
            "path",
            {
              d: "M85.8828 200.181C85.8828 127.629 144.698 68.8138 217.25 68.8138C289.802 68.8138 348.617 127.629 348.617 200.181V583.922H85.8828V200.181Z",
              fill: "#58C971"
            }
          ),
          /* @__PURE__ */ g(
            "path",
            {
              d: "M110.421 202.796C110.421 142.665 159.166 93.9194 219.297 93.9194C279.428 93.9194 328.174 142.665 328.174 202.796V645.175H110.421V202.796Z",
              fill: "#FFCA42"
            }
          )
        ] }) })
      ]
    }
  );
}
const ide = () => {
  const e = N((l) => l.transfer.fromChain), t = N((l) => l.transfer.toChain), n = N((l) => l.transfer.estimatedAmount), [r, o] = ze(""), { data: i } = _M(), { data: a } = FM({
    srcChainId: e?.id,
    dstChainId: t?.id,
    isEnabled: !0
  });
  return Oe(() => {
    try {
      const l = {};
      n?.deBridge?.order?.approximateFulfillmentDelay && (l.deBridge = n?.deBridge?.order?.approximateFulfillmentDelay), i?.avgWaitTime && (l.stargate = i?.avgWaitTime / 1e3), a?.median_transfer_latency_in_second && (l.cBridge = Number(a?.median_transfer_latency_in_second));
      const c = Z8e(l);
      o(c);
    } catch (l) {
      console.log("Error in useGetBestTime: ", l);
    }
  }, [
    i?.avgWaitTime,
    n,
    a?.median_transfer_latency_in_second
  ]), r;
}, Jx = ({ bestMode: e }) => {
  const t = Xe(), { colorMode: n } = Ee(), { formatMessage: r } = n1();
  return /* @__PURE__ */ g(
    h1,
    {
      className: `bccb-widget-route-name-tag-${e}`,
      p: "4px 8px",
      borderRadius: "40px",
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      h: "24px",
      color: e === "bestTime" ? t.colors[n].support.brand[2] : e === "bestReturn" ? t.colors[n].support.success[2] : "",
      background: e === "bestTime" ? t.colors[n].support.brand[5] : e === "bestReturn" ? t.colors[n].support.success[5] : "",
      children: e === "bestTime" ? r({ id: "route.option.tag.best-time" }) : e === "bestReturn" ? r({ id: "route.option.tag.highest-amount" }) : null
    }
  );
}, S2 = w.memo(
  ({ bridgeType: e, isReceiveSection: t = !1, isError: n }) => {
    const { formatMessage: r } = n1(), { getSortedReceiveAmount: o } = v6(), i = Lt(), a = o(), l = ide(), c = z8e(a);
    return /* @__PURE__ */ X(
      re,
      {
        className: "bccb-widget-route-name",
        minH: "24px",
        flexDir: "row",
        gap: "8px",
        alignItems: "center",
        opacity: n ? 0.5 : 1,
        children: [
          e === "cBridge" ? /* @__PURE__ */ g(ode, { w: ["16px", "16px", "16px", "20px"], h: ["16px", "16px", "16px", "20px"] }) : e === "deBridge" ? /* @__PURE__ */ g(
            cs,
            {
              src: `${i.assetPrefix}/images/debridgeIcon.png`,
              alt: "deBridge",
              w: ["16px", "16px", "16px", "20px"],
              h: ["16px", "16px", "16px", "20px"],
              borderRadius: "100%"
            }
          ) : e === "stargate" ? /* @__PURE__ */ g(rde, { w: ["16px", "16px", "16px", "20px"], h: ["16px", "16px", "16px", "20px"] }) : e === "layerZero" ? /* @__PURE__ */ g(
            cs,
            {
              src: `${i.assetPrefix}/images/layerZeroIcon.png`,
              alt: "layerZero",
              w: ["16px", "16px", "16px", "20px"],
              h: ["16px", "16px", "16px", "20px"],
              borderRadius: "100%"
            }
          ) : e === "meson" ? /* @__PURE__ */ g(
            cs,
            {
              src: `${i.assetPrefix}/images/mesonIcon.png`,
              alt: "meson",
              w: ["16px", "16px", "16px", "20px"],
              h: ["16px", "16px", "16px", "20px"],
              borderRadius: "100%"
            }
          ) : null,
          /* @__PURE__ */ X(
            re,
            {
              justifyContent: [
                t ? "flex-start" : "space-between",
                t ? "flex-start" : "space-between",
                t ? "flex-start" : "space-between",
                "space-between"
              ],
              gap: "8px",
              alignItems: "center",
              flex: 1,
              children: [
                /* @__PURE__ */ g(
                  h1,
                  {
                    className: "bccb-widget-route-name-text",
                    fontSize: ["12px", "12px", "12px", "14px"],
                    lineHeight: ["16px", "16px", "16px", "20px"],
                    fontWeight: 500,
                    children: e === "cBridge" ? r({ id: "route.option.cBridge.title" }) : e === "deBridge" ? r({ id: "route.option.deBridge.title" }) : e === "stargate" ? r({ id: "route.option.stargate.title" }) : e === "layerZero" ? r({ id: "route.option.layerZero.title" }) : e === "meson" ? r({ id: "route.option.meson.title" }) : null
                  }
                ),
                /* @__PURE__ */ X(re, { gap: "4px", children: [
                  e === l && /* @__PURE__ */ g(Jx, { bestMode: "bestTime" }),
                  e === c && /* @__PURE__ */ g(Jx, { bestMode: "bestReturn" })
                ] })
              ]
            }
          )
        ]
      }
    );
  }
);
S2.displayName = "RouteName";
const ade = "logger/5.7.0";
let Qx = !1, qx = !1;
const Wl = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let Kx = Wl.default, Gc = null;
function sde() {
  try {
    const e = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((t) => {
      try {
        if ("test".normalize(t) !== "test")
          throw new Error("bad normalize");
      } catch {
        e.push(t);
      }
    }), e.length)
      throw new Error("missing " + e.join(", "));
    if ("é".normalize("NFD") !== "é")
      throw new Error("broken implementation");
  } catch (e) {
    return e.message;
  }
  return null;
}
const ew = sde();
var Vd;
(function(e) {
  e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
})(Vd || (Vd = {}));
var Yr;
(function(e) {
  e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
})(Yr || (Yr = {}));
const tw = "0123456789abcdef";
class Pt {
  constructor(t) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: t,
      writable: !1
    });
  }
  _log(t, n) {
    const r = t.toLowerCase();
    Wl[r] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !(Kx > Wl[r]) && console.log.apply(console, n);
  }
  debug(...t) {
    this._log(Pt.levels.DEBUG, t);
  }
  info(...t) {
    this._log(Pt.levels.INFO, t);
  }
  warn(...t) {
    this._log(Pt.levels.WARNING, t);
  }
  makeError(t, n, r) {
    if (qx)
      return this.makeError("censored error", n, {});
    n || (n = Pt.errors.UNKNOWN_ERROR), r || (r = {});
    const o = [];
    Object.keys(r).forEach((c) => {
      const u = r[c];
      try {
        if (u instanceof Uint8Array) {
          let f = "";
          for (let p = 0; p < u.length; p++)
            f += tw[u[p] >> 4], f += tw[u[p] & 15];
          o.push(c + "=Uint8Array(0x" + f + ")");
        } else
          o.push(c + "=" + JSON.stringify(u));
      } catch {
        o.push(c + "=" + JSON.stringify(r[c].toString()));
      }
    }), o.push(`code=${n}`), o.push(`version=${this.version}`);
    const i = t;
    let a = "";
    switch (n) {
      case Yr.NUMERIC_FAULT: {
        a = "NUMERIC_FAULT";
        const c = t;
        switch (c) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            a += "-" + c;
            break;
          case "negative-power":
          case "negative-width":
            a += "-unsupported";
            break;
          case "unbound-bitwise-result":
            a += "-unbound-result";
            break;
        }
        break;
      }
      case Yr.CALL_EXCEPTION:
      case Yr.INSUFFICIENT_FUNDS:
      case Yr.MISSING_NEW:
      case Yr.NONCE_EXPIRED:
      case Yr.REPLACEMENT_UNDERPRICED:
      case Yr.TRANSACTION_REPLACED:
      case Yr.UNPREDICTABLE_GAS_LIMIT:
        a = n;
        break;
    }
    a && (t += " [ See: https://links.ethers.org/v5-errors-" + a + " ]"), o.length && (t += " (" + o.join(", ") + ")");
    const l = new Error(t);
    return l.reason = i, l.code = n, Object.keys(r).forEach(function(c) {
      l[c] = r[c];
    }), l;
  }
  throwError(t, n, r) {
    throw this.makeError(t, n, r);
  }
  throwArgumentError(t, n, r) {
    return this.throwError(t, Pt.errors.INVALID_ARGUMENT, {
      argument: n,
      value: r
    });
  }
  assert(t, n, r, o) {
    t || this.throwError(n, r, o);
  }
  assertArgument(t, n, r, o) {
    t || this.throwArgumentError(n, r, o);
  }
  checkNormalize(t) {
    ew && this.throwError("platform missing String.prototype.normalize", Pt.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: ew
    });
  }
  checkSafeUint53(t, n) {
    typeof t == "number" && (n == null && (n = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(n, Pt.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: t
    }), t % 1 && this.throwError(n, Pt.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: t
    }));
  }
  checkArgumentCount(t, n, r) {
    r ? r = ": " + r : r = "", t < n && this.throwError("missing argument" + r, Pt.errors.MISSING_ARGUMENT, {
      count: t,
      expectedCount: n
    }), t > n && this.throwError("too many arguments" + r, Pt.errors.UNEXPECTED_ARGUMENT, {
      count: t,
      expectedCount: n
    });
  }
  checkNew(t, n) {
    (t === Object || t == null) && this.throwError("missing new", Pt.errors.MISSING_NEW, { name: n.name });
  }
  checkAbstract(t, n) {
    t === n ? this.throwError("cannot instantiate abstract class " + JSON.stringify(n.name) + " directly; use a sub-class", Pt.errors.UNSUPPORTED_OPERATION, { name: t.name, operation: "new" }) : (t === Object || t == null) && this.throwError("missing new", Pt.errors.MISSING_NEW, { name: n.name });
  }
  static globalLogger() {
    return Gc || (Gc = new Pt(ade)), Gc;
  }
  static setCensorship(t, n) {
    if (!t && n && this.globalLogger().throwError("cannot permanently disable censorship", Pt.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), Qx) {
      if (!t)
        return;
      this.globalLogger().throwError("error censorship permanent", Pt.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    qx = !!t, Qx = !!n;
  }
  static setLogLevel(t) {
    const n = Wl[t.toLowerCase()];
    if (n == null) {
      Pt.globalLogger().warn("invalid log level - " + t);
      return;
    }
    Kx = n;
  }
  static from(t) {
    return new Pt(t);
  }
}
Pt.errors = Yr;
Pt.levels = Vd;
const lde = "bytes/5.7.0", h0 = new Pt(lde);
function cde(e) {
  return !!e.toHexString;
}
function nw(e) {
  return typeof e == "number" && e == e && e % 1 === 0;
}
function ude(e) {
  if (e == null)
    return !1;
  if (e.constructor === Uint8Array)
    return !0;
  if (typeof e == "string" || !nw(e.length) || e.length < 0)
    return !1;
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (!nw(n) || n < 0 || n >= 256)
      return !1;
  }
  return !0;
}
function vB(e, t) {
  return !(typeof e != "string" || !e.match(/^0x[0-9A-Fa-f]*$/));
}
const Wc = "0123456789abcdef";
function dde(e, t) {
  if (t || (t = {}), typeof e == "number") {
    h0.checkSafeUint53(e, "invalid hexlify value");
    let n = "";
    for (; e; )
      n = Wc[e & 15] + n, e = Math.floor(e / 16);
    return n.length ? (n.length % 2 && (n = "0" + n), "0x" + n) : "0x00";
  }
  if (typeof e == "bigint")
    return e = e.toString(16), e.length % 2 ? "0x0" + e : "0x" + e;
  if (t.allowMissingPrefix && typeof e == "string" && e.substring(0, 2) !== "0x" && (e = "0x" + e), cde(e))
    return e.toHexString();
  if (vB(e))
    return e.length % 2 && (t.hexPad === "left" ? e = "0x0" + e.substring(2) : t.hexPad === "right" ? e += "0" : h0.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
  if (ude(e)) {
    let n = "0x";
    for (let r = 0; r < e.length; r++) {
      let o = e[r];
      n += Wc[(o & 240) >> 4] + Wc[o & 15];
    }
    return n;
  }
  return h0.throwArgumentError("invalid hexlify value", "value", e);
}
function fde(e, t) {
  for (typeof e != "string" ? e = dde(e) : vB(e) || h0.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && h0.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2; )
    e = "0x0" + e.substring(2);
  return e;
}
const pde = () => {
  const { address: e } = lt(), { toTokenInfo: t } = Vn(), n = N((a) => a.transfer.selectedToken), r = N((a) => a.transfer.sendValue), o = S3(r, _s);
  return { args: we(() => {
    if (!o || !t || !n)
      return null;
    const a = en(
      o,
      n?.stargate?.raw?.token?.decimals || 18
    ), l = e || Ha;
    return {
      dstEid: t?.stargate?.raw?.endpointID,
      to: fde(l, 32),
      amountLD: a,
      minAmountLD: a,
      extraOptions: "0x",
      composeMsg: "0x",
      oftCmd: "0x01"
      // '0x01' for bus, '' for taxi
    };
  }, [n, e, o, t]) };
}, hde = [
  {
    inputs: [
      { internalType: "string", name: "_lpTokenName", type: "string" },
      { internalType: "string", name: "_lpTokenSymbol", type: "string" },
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "uint8", name: "_tokenDecimals", type: "uint8" },
      { internalType: "uint8", name: "_sharedDecimals", type: "uint8" },
      { internalType: "address", name: "_endpoint", type: "address" },
      { internalType: "address", name: "_owner", type: "address" }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  { inputs: [], name: "InvalidLocalDecimals", type: "error" },
  { inputs: [], name: "Path_AlreadyHasCredit", type: "error" },
  { inputs: [], name: "Path_InsufficientCredit", type: "error" },
  { inputs: [], name: "Path_UnlimitedCredit", type: "error" },
  {
    inputs: [
      { internalType: "uint256", name: "amountLD", type: "uint256" },
      { internalType: "uint256", name: "minAmountLD", type: "uint256" }
    ],
    name: "SlippageExceeded",
    type: "error"
  },
  { inputs: [], name: "StargatePoolMigratable_BurnAmountExceedsBalance", type: "error" },
  { inputs: [], name: "Stargate_InsufficientFare", type: "error" },
  { inputs: [], name: "Stargate_InvalidAmount", type: "error" },
  { inputs: [], name: "Stargate_InvalidPath", type: "error" },
  { inputs: [], name: "Stargate_InvalidTokenDecimals", type: "error" },
  { inputs: [], name: "Stargate_LzTokenUnavailable", type: "error" },
  { inputs: [], name: "Stargate_OnlyTaxi", type: "error" },
  { inputs: [], name: "Stargate_OutflowFailed", type: "error" },
  { inputs: [], name: "Stargate_Paused", type: "error" },
  { inputs: [], name: "Stargate_RecoverTokenUnsupported", type: "error" },
  { inputs: [], name: "Stargate_ReentrantCall", type: "error" },
  { inputs: [], name: "Stargate_SlippageTooHigh", type: "error" },
  { inputs: [], name: "Stargate_Unauthorized", type: "error" },
  { inputs: [], name: "Stargate_UnreceivedTokenNotFound", type: "error" },
  { inputs: [], name: "Transfer_ApproveFailed", type: "error" },
  { inputs: [], name: "Transfer_TransferFailed", type: "error" },
  {
    anonymous: !1,
    inputs: [
      {
        components: [
          { internalType: "address", name: "feeLib", type: "address" },
          { internalType: "address", name: "planner", type: "address" },
          { internalType: "address", name: "treasurer", type: "address" },
          { internalType: "address", name: "tokenMessaging", type: "address" },
          { internalType: "address", name: "creditMessaging", type: "address" },
          { internalType: "address", name: "lzToken", type: "address" }
        ],
        indexed: !1,
        internalType: "struct StargateBase.AddressConfig",
        name: "config",
        type: "tuple"
      }
    ],
    name: "AddressConfigSet",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !1, internalType: "uint32", name: "srcEid", type: "uint32" },
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "uint64", name: "amount", type: "uint64" }
        ],
        indexed: !1,
        internalType: "struct Credit[]",
        name: "credits",
        type: "tuple[]"
      }
    ],
    name: "CreditsReceived",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !1, internalType: "uint32", name: "dstEid", type: "uint32" },
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "uint64", name: "amount", type: "uint64" }
        ],
        indexed: !1,
        internalType: "struct Credit[]",
        name: "credits",
        type: "tuple[]"
      }
    ],
    name: "CreditsSent",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "address", name: "payer", type: "address" },
      { indexed: !0, internalType: "address", name: "receiver", type: "address" },
      { indexed: !1, internalType: "uint256", name: "amountLD", type: "uint256" }
    ],
    name: "Deposited",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !1, internalType: "uint32", name: "dstEid", type: "uint32" },
      { indexed: !1, internalType: "bool", name: "oft", type: "bool" }
    ],
    name: "OFTPathSet",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "guid", type: "bytes32" },
      { indexed: !1, internalType: "uint32", name: "srcEid", type: "uint32" },
      { indexed: !0, internalType: "address", name: "toAddress", type: "address" },
      { indexed: !1, internalType: "uint256", name: "amountReceivedLD", type: "uint256" }
    ],
    name: "OFTReceived",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "bytes32", name: "guid", type: "bytes32" },
      { indexed: !1, internalType: "uint32", name: "dstEid", type: "uint32" },
      { indexed: !0, internalType: "address", name: "fromAddress", type: "address" },
      { indexed: !1, internalType: "uint256", name: "amountSentLD", type: "uint256" },
      { indexed: !1, internalType: "uint256", name: "amountReceivedLD", type: "uint256" }
    ],
    name: "OFTSent",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "address", name: "previousOwner", type: "address" },
      { indexed: !0, internalType: "address", name: "newOwner", type: "address" }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [{ indexed: !1, internalType: "uint64", name: "amountSD", type: "uint64" }],
    name: "Path_CreditBurned",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [{ indexed: !1, internalType: "bool", name: "paused", type: "bool" }],
    name: "PauseSet",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [{ indexed: !1, internalType: "uint256", name: "amount", type: "uint256" }],
    name: "PlannerFeeWithdrawn",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "address", name: "payer", type: "address" },
      { indexed: !0, internalType: "address", name: "receiver", type: "address" },
      { indexed: !1, internalType: "uint256", name: "amountLD", type: "uint256" }
    ],
    name: "Redeemed",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [{ indexed: !1, internalType: "uint64", name: "amountSD", type: "uint64" }],
    name: "TreasuryFeeAdded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !1, internalType: "address", name: "to", type: "address" },
      { indexed: !1, internalType: "uint64", name: "amountSD", type: "uint64" }
    ],
    name: "TreasuryFeeWithdrawn",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !1, internalType: "bytes32", name: "guid", type: "bytes32" },
      { indexed: !1, internalType: "uint8", name: "index", type: "uint8" },
      { indexed: !1, internalType: "uint32", name: "srcEid", type: "uint32" },
      { indexed: !1, internalType: "address", name: "receiver", type: "address" },
      { indexed: !1, internalType: "uint256", name: "amountLD", type: "uint256" },
      { indexed: !1, internalType: "bytes", name: "composeMsg", type: "bytes" }
    ],
    name: "UnreceivedTokenCached",
    type: "event"
  },
  {
    inputs: [{ internalType: "uint256", name: "_amountLD", type: "uint256" }],
    name: "addTreasuryFee",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_burnAdmin", type: "address" },
      { internalType: "uint64", name: "_burnAllowanceSD", type: "uint64" }
    ],
    name: "allowBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "approvalRequired",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "burnAdmin",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "burnAllowanceSD",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function"
  },
  { inputs: [], name: "burnLocked", outputs: [], stateMutability: "nonpayable", type: "function" },
  {
    inputs: [],
    name: "deficitOffset",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_receiver", type: "address" },
      { internalType: "uint256", name: "_amountLD", type: "uint256" }
    ],
    name: "deposit",
    outputs: [{ internalType: "uint256", name: "amountLD", type: "uint256" }],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "endpoint",
    outputs: [{ internalType: "contract ILayerZeroEndpointV2", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getAddressConfig",
    outputs: [
      {
        components: [
          { internalType: "address", name: "feeLib", type: "address" },
          { internalType: "address", name: "planner", type: "address" },
          { internalType: "address", name: "treasurer", type: "address" },
          { internalType: "address", name: "tokenMessaging", type: "address" },
          { internalType: "address", name: "creditMessaging", type: "address" },
          { internalType: "address", name: "lzToken", type: "address" }
        ],
        internalType: "struct StargateBase.AddressConfig",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getTransferGasLimit",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "localEid",
    outputs: [{ internalType: "uint32", name: "", type: "uint32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lpToken",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "oftVersion",
    outputs: [
      { internalType: "bytes4", name: "interfaceId", type: "bytes4" },
      { internalType: "uint64", name: "version", type: "uint64" }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint32", name: "eid", type: "uint32" }],
    name: "paths",
    outputs: [{ internalType: "uint64", name: "credit", type: "uint64" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "plannerFee",
    outputs: [{ internalType: "uint256", name: "available", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "poolBalance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "dstEid", type: "uint32" },
          { internalType: "bytes32", name: "to", type: "bytes32" },
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "bytes", name: "extraOptions", type: "bytes" },
          { internalType: "bytes", name: "composeMsg", type: "bytes" },
          { internalType: "bytes", name: "oftCmd", type: "bytes" }
        ],
        internalType: "struct SendParam",
        name: "_sendParam",
        type: "tuple"
      }
    ],
    name: "quoteOFT",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "uint256", name: "maxAmountLD", type: "uint256" }
        ],
        internalType: "struct OFTLimit",
        name: "limit",
        type: "tuple"
      },
      {
        components: [
          { internalType: "int256", name: "feeAmountLD", type: "int256" },
          { internalType: "string", name: "description", type: "string" }
        ],
        internalType: "struct OFTFeeDetail[]",
        name: "oftFeeDetails",
        type: "tuple[]"
      },
      {
        components: [
          { internalType: "uint256", name: "amountSentLD", type: "uint256" },
          { internalType: "uint256", name: "amountReceivedLD", type: "uint256" }
        ],
        internalType: "struct OFTReceipt",
        name: "receipt",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "dstEid", type: "uint32" },
          { internalType: "bytes32", name: "to", type: "bytes32" },
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "bytes", name: "extraOptions", type: "bytes" },
          { internalType: "bytes", name: "composeMsg", type: "bytes" },
          { internalType: "bytes", name: "oftCmd", type: "bytes" }
        ],
        internalType: "struct SendParam",
        name: "_sendParam",
        type: "tuple"
      },
      { internalType: "bool", name: "_payInLzToken", type: "bool" }
    ],
    name: "quoteRedeemSend",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "nativeFee", type: "uint256" },
          { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
        ],
        internalType: "struct MessagingFee",
        name: "fee",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "dstEid", type: "uint32" },
          { internalType: "bytes32", name: "to", type: "bytes32" },
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "bytes", name: "extraOptions", type: "bytes" },
          { internalType: "bytes", name: "composeMsg", type: "bytes" },
          { internalType: "bytes", name: "oftCmd", type: "bytes" }
        ],
        internalType: "struct SendParam",
        name: "_sendParam",
        type: "tuple"
      },
      { internalType: "bool", name: "_payInLzToken", type: "bool" }
    ],
    name: "quoteSend",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "nativeFee", type: "uint256" },
          { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
        ],
        internalType: "struct MessagingFee",
        name: "fee",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint32", name: "_srcEid", type: "uint32" },
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "uint64", name: "amount", type: "uint64" }
        ],
        internalType: "struct Credit[]",
        name: "_credits",
        type: "tuple[]"
      }
    ],
    name: "receiveCredits",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" }
        ],
        internalType: "struct Origin",
        name: "_origin",
        type: "tuple"
      },
      { internalType: "bytes32", name: "_guid", type: "bytes32" },
      { internalType: "uint8", name: "_seatNumber", type: "uint8" },
      { internalType: "address", name: "_receiver", type: "address" },
      { internalType: "uint64", name: "_amountSD", type: "uint64" }
    ],
    name: "receiveTokenBus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "bytes32", name: "sender", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" }
        ],
        internalType: "struct Origin",
        name: "_origin",
        type: "tuple"
      },
      { internalType: "bytes32", name: "_guid", type: "bytes32" },
      { internalType: "address", name: "_receiver", type: "address" },
      { internalType: "uint64", name: "_amountSD", type: "uint64" },
      { internalType: "bytes", name: "_composeMsg", type: "bytes" }
    ],
    name: "receiveTokenTaxi",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "address", name: "_to", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" }
    ],
    name: "recoverToken",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "_amountLD", type: "uint256" },
      { internalType: "address", name: "_receiver", type: "address" }
    ],
    name: "redeem",
    outputs: [{ internalType: "uint256", name: "amountLD", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "dstEid", type: "uint32" },
          { internalType: "bytes32", name: "to", type: "bytes32" },
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "bytes", name: "extraOptions", type: "bytes" },
          { internalType: "bytes", name: "composeMsg", type: "bytes" },
          { internalType: "bytes", name: "oftCmd", type: "bytes" }
        ],
        internalType: "struct SendParam",
        name: "_sendParam",
        type: "tuple"
      },
      {
        components: [
          { internalType: "uint256", name: "nativeFee", type: "uint256" },
          { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
        ],
        internalType: "struct MessagingFee",
        name: "_fee",
        type: "tuple"
      },
      { internalType: "address", name: "_refundAddress", type: "address" }
    ],
    name: "redeemSend",
    outputs: [
      {
        components: [
          { internalType: "bytes32", name: "guid", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
            ],
            internalType: "struct MessagingFee",
            name: "fee",
            type: "tuple"
          }
        ],
        internalType: "struct MessagingReceipt",
        name: "msgReceipt",
        type: "tuple"
      },
      {
        components: [
          { internalType: "uint256", name: "amountSentLD", type: "uint256" },
          { internalType: "uint256", name: "amountReceivedLD", type: "uint256" }
        ],
        internalType: "struct OFTReceipt",
        name: "oftReceipt",
        type: "tuple"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_owner", type: "address" }],
    name: "redeemable",
    outputs: [{ internalType: "uint256", name: "amountLD", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "_guid", type: "bytes32" },
      { internalType: "uint8", name: "_index", type: "uint8" },
      { internalType: "uint32", name: "_srcEid", type: "uint32" },
      { internalType: "address", name: "_receiver", type: "address" },
      { internalType: "uint256", name: "_amountLD", type: "uint256" },
      { internalType: "bytes", name: "_composeMsg", type: "bytes" }
    ],
    name: "retryReceiveToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "dstEid", type: "uint32" },
          { internalType: "bytes32", name: "to", type: "bytes32" },
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "bytes", name: "extraOptions", type: "bytes" },
          { internalType: "bytes", name: "composeMsg", type: "bytes" },
          { internalType: "bytes", name: "oftCmd", type: "bytes" }
        ],
        internalType: "struct SendParam",
        name: "_sendParam",
        type: "tuple"
      },
      {
        components: [
          { internalType: "uint256", name: "nativeFee", type: "uint256" },
          { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
        ],
        internalType: "struct MessagingFee",
        name: "_fee",
        type: "tuple"
      },
      { internalType: "address", name: "_refundAddress", type: "address" }
    ],
    name: "send",
    outputs: [
      {
        components: [
          { internalType: "bytes32", name: "guid", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
            ],
            internalType: "struct MessagingFee",
            name: "fee",
            type: "tuple"
          }
        ],
        internalType: "struct MessagingReceipt",
        name: "msgReceipt",
        type: "tuple"
      },
      {
        components: [
          { internalType: "uint256", name: "amountSentLD", type: "uint256" },
          { internalType: "uint256", name: "amountReceivedLD", type: "uint256" }
        ],
        internalType: "struct OFTReceipt",
        name: "oftReceipt",
        type: "tuple"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint32", name: "_dstEid", type: "uint32" },
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "uint64", name: "amount", type: "uint64" },
          { internalType: "uint64", name: "minAmount", type: "uint64" }
        ],
        internalType: "struct TargetCredit[]",
        name: "_credits",
        type: "tuple[]"
      }
    ],
    name: "sendCredits",
    outputs: [
      {
        components: [
          { internalType: "uint32", name: "srcEid", type: "uint32" },
          { internalType: "uint64", name: "amount", type: "uint64" }
        ],
        internalType: "struct Credit[]",
        name: "",
        type: "tuple[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint32", name: "dstEid", type: "uint32" },
          { internalType: "bytes32", name: "to", type: "bytes32" },
          { internalType: "uint256", name: "amountLD", type: "uint256" },
          { internalType: "uint256", name: "minAmountLD", type: "uint256" },
          { internalType: "bytes", name: "extraOptions", type: "bytes" },
          { internalType: "bytes", name: "composeMsg", type: "bytes" },
          { internalType: "bytes", name: "oftCmd", type: "bytes" }
        ],
        internalType: "struct SendParam",
        name: "_sendParam",
        type: "tuple"
      },
      {
        components: [
          { internalType: "uint256", name: "nativeFee", type: "uint256" },
          { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
        ],
        internalType: "struct MessagingFee",
        name: "_fee",
        type: "tuple"
      },
      { internalType: "address", name: "_refundAddress", type: "address" }
    ],
    name: "sendToken",
    outputs: [
      {
        components: [
          { internalType: "bytes32", name: "guid", type: "bytes32" },
          { internalType: "uint64", name: "nonce", type: "uint64" },
          {
            components: [
              { internalType: "uint256", name: "nativeFee", type: "uint256" },
              { internalType: "uint256", name: "lzTokenFee", type: "uint256" }
            ],
            internalType: "struct MessagingFee",
            name: "fee",
            type: "tuple"
          }
        ],
        internalType: "struct MessagingReceipt",
        name: "msgReceipt",
        type: "tuple"
      },
      {
        components: [
          { internalType: "uint256", name: "amountSentLD", type: "uint256" },
          { internalType: "uint256", name: "amountReceivedLD", type: "uint256" }
        ],
        internalType: "struct OFTReceipt",
        name: "oftReceipt",
        type: "tuple"
      },
      {
        components: [
          { internalType: "uint72", name: "ticketId", type: "uint72" },
          { internalType: "bytes", name: "passengerBytes", type: "bytes" }
        ],
        internalType: "struct Ticket",
        name: "ticket",
        type: "tuple"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "feeLib", type: "address" },
          { internalType: "address", name: "planner", type: "address" },
          { internalType: "address", name: "treasurer", type: "address" },
          { internalType: "address", name: "tokenMessaging", type: "address" },
          { internalType: "address", name: "creditMessaging", type: "address" },
          { internalType: "address", name: "lzToken", type: "address" }
        ],
        internalType: "struct StargateBase.AddressConfig",
        name: "_config",
        type: "tuple"
      }
    ],
    name: "setAddressConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "_deficitOffsetLD", type: "uint256" }],
    name: "setDeficitOffset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint32", name: "_dstEid", type: "uint32" },
      { internalType: "bool", name: "_oft", type: "bool" }
    ],
    name: "setOFTPath",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bool", name: "_paused", type: "bool" }],
    name: "setPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "_gasLimit", type: "uint256" }],
    name: "setTransferGasLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "sharedDecimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "stargateType",
    outputs: [{ internalType: "enum StargateType", name: "", type: "uint8" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "status",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "treasuryFee",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "tvl",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "guid", type: "bytes32" },
      { internalType: "uint8", name: "index", type: "uint8" }
    ],
    name: "unreceivedTokens",
    outputs: [{ internalType: "bytes32", name: "hash", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawPlannerFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_to", type: "address" },
      { internalType: "uint64", name: "_amountSD", type: "uint64" }
    ],
    name: "withdrawTreasuryFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], Ah = () => {
  const e = D1(), { toTokenInfo: t, getToDecimals: n } = Vn(), { address: r, chain: o } = lt(), { args: i } = pde(), a = fa(), { formatMessage: l } = n1(), c = g6(), u = Us(), f = N((L) => L.transfer.fromChain), { data: p } = $0({ address: r, chainId: f?.id }), h = N((L) => L.transfer.selectedToken), C = eo({ chainId: f?.id }), v = N((L) => L.transfer.sendValue), b = N((L) => L.transfer.estimatedAmount), { balance: y } = b3({
    tokenAddress: h?.address
  }), x = we(() => {
    if (b?.stargate && b?.stargate?.[0]) {
      const L = b?.stargate, I = h?.stargate?.raw?.token?.decimals ?? 18, M = Number(x1(L[0].minAmountLD, I)), k = Number(x1(L[0].maxAmountLD, I));
      return {
        min: F1(M, 8),
        max: F1(k, 8)
      };
    }
    return null;
  }, [b?.stargate, h?.stargate?.raw?.token?.decimals]), T = we(() => {
    if (b?.stargate && b?.stargate?.[0]) {
      const L = b?.stargate, I = h?.stargate?.raw?.token?.decimals ?? 18, M = Number(x1(L[0].minAmountLD, I)), k = Number(x1(L[0].maxAmountLD, I));
      return Number(v) < M || Number(v) > k;
    }
    return !1;
  }, [b?.stargate, h?.stargate?.raw?.token?.decimals, v]), A = se(
    // fees are response of quoteOFT
    async (L) => {
      let I = null;
      const M = [];
      let k = !1, _ = !1;
      const F = [], $ = r || Ha, oe = h?.stargate?.raw?.address, te = h?.stargate?.raw?.token?.decimals ?? 18, ae = h?.stargate?.raw?.sharedDecimals ?? 18, be = Number(x1(L[0].minAmountLD, te)), K = Number(x1(L[0].maxAmountLD, te)), ue = en(v, te);
      if (Number(v) >= be && Number(v) <= K && i) {
        if (v.split(".")[1]?.length > ae)
          return e(
            Ht({
              stargate: `The send amount must be less than ${ae} digits`
            })
          ), { isDisplayError: !0 };
        if (Number(L?.[2].amountReceivedLD)) {
          L?.[2].amountReceivedLD && (i.minAmountLD = BigInt(L[2].amountReceivedLD));
          const J = L?.[1].filter(
            (ee) => ee.description === "protocol fee"
          )[0]?.feeAmountLD;
          if (J) {
            const ee = x1(
              BigInt(Math.abs(Number(J))),
              n().stargate || 18
            );
            ee && t?.symbol && (F.push({
              symbol: t?.symbol,
              value: ee
            }), M.push({
              label: l({ id: "route.option.info.protocol-fee" }),
              value: `${F1(Number(ee), 8)} ${t?.symbol}` || "",
              name: "protocolFee"
            }));
          }
          const Me = await a.stargate.getQuoteSend({
            publicClient: C,
            bridgeAddress: oe,
            endPointId: i.dstEid,
            amount: i.amountLD,
            minAmount: i.minAmountLD,
            receiver: $
          });
          let _e = Me.nativeFee;
          if (h?.stargate?.raw?.token?.address === "0x0000000000000000000000000000000000000000" && (_e += i.amountLD), _e) {
            const ee = x1(Me.nativeFee, 18);
            I = I ? I + Number(ee) : Number(ee), M.push({
              label: l({ id: "route.option.info.native-fee" }),
              value: `${F1(Number(ee), 8)} ${c}`,
              name: "nativeFee"
            }), p?.value && p?.value < Number(_e) && u && (e(
              Ht({ stargate: `Insufficient ${c} to cover native fee` })
            ), _ = !0);
          }
          try {
            if (o && f?.id === o?.id && r && h?.address) {
              let ee = null;
              if (h?.stargate?.raw?.token?.address !== "0x0000000000000000000000000000000000000000" && (ee = await C.readContract({
                address: h?.stargate?.raw?.token?.address ? h?.address : "",
                abi: Gs,
                functionName: "allowance",
                args: [r, h?.stargate?.raw?.address],
                chainId: f?.id,
                enabled: !!r && !!h?.address && f && o && f?.id === o?.id
              })), i && C && i.dstEid && Number(v) && y && ee && ee >= ue) {
                const ye = await C.estimateContractGas({
                  address: oe,
                  abi: hde,
                  functionName: "sendToken",
                  args: [i, Me, $],
                  value: _e,
                  account: $
                }), fe = await C.getGasPrice();
                if (ye && fe) {
                  const xe = x1(BigInt(ye) * fe, 18);
                  I = I ? I + Number(xe) : Number(xe), M.push({
                    label: l({ id: "route.option.info.gas-fee" }),
                    value: `${F1(Number(xe), 8)} ${c}`,
                    name: "gasFee"
                  });
                }
              }
            }
          } catch (ee) {
            console.log(ee.message), e(Ht({ stargate: "Failed to get gas fee" })), k = !0;
          }
          I !== null && c && F.push({
            symbol: c,
            value: String(I)
          });
          const ne = BM(F);
          return e(
            Lr({
              stargate: {
                summary: ne,
                breakdown: M
              }
            })
          ), I = null, {
            summary: ne || "--",
            breakdown: M,
            isFailedToGetGas: k,
            isDisplayError: _
          };
        } else
          return e(
            Ht({
              stargate: "Please increase your send amount"
            })
          ), { isDisplayError: !0 };
      }
    },
    [
      i,
      C,
      r,
      h,
      v,
      t,
      e,
      a,
      l,
      c,
      n,
      o,
      p?.value,
      f,
      y,
      u
    ]
  );
  return {
    allowedSendAmount: x,
    isAllowSendError: T,
    stargateFeeSorting: A
  };
}, rw = () => /* @__PURE__ */ X(h1, { className: "bccb-widget-received-info-route-loading", children: [
  /* @__PURE__ */ X(re, { flexDir: "column", gap: "8px", display: { base: "none", lg: "flex" }, children: [
    /* @__PURE__ */ X(re, { gap: "8px", mb: "8px", children: [
      /* @__PURE__ */ g(Vt, { height: "22px", width: "160px" }),
      /* @__PURE__ */ g(Vt, { height: "22px", width: "80px" })
    ] }),
    /* @__PURE__ */ g(Vt, { height: "13px", maxW: "333px", width: "100%" }),
    /* @__PURE__ */ g(Vt, { height: "13px", maxW: "371px", width: "100%" })
  ] }),
  /* @__PURE__ */ X(
    re,
    {
      display: { base: "flex", lg: "none" },
      flexDir: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: "23px",
      children: [
        /* @__PURE__ */ X(re, { flexDir: "column", flex: 1, gap: "8px", children: [
          /* @__PURE__ */ X(re, { gap: "8px", mb: "2px", flexDir: "row", children: [
            /* @__PURE__ */ g(Vt, { height: "12px", flexBasis: "66%" }),
            /* @__PURE__ */ g(Vt, { height: "12px", flexBasis: "33%" })
          ] }),
          /* @__PURE__ */ X(re, { gap: "8px", mb: "2px", children: [
            /* @__PURE__ */ g(Vt, { height: "20px", flexBasis: "66%" }),
            /* @__PURE__ */ g(Vt, { height: "20px", flexBasis: "33%" })
          ] }),
          /* @__PURE__ */ g(re, { gap: "8px", mb: "2px", children: /* @__PURE__ */ g(Vt, { height: "16px", width: "100%", borderRadius: "4px" }) }),
          /* @__PURE__ */ g(re, { gap: "8px", mb: "2px", children: /* @__PURE__ */ g(Vt, { height: "16px", width: "100%", borderRadius: "4px" }) }),
          /* @__PURE__ */ g(re, { gap: "8px", mb: "2px", children: /* @__PURE__ */ g(Vt, { height: "16px", width: "100%", borderRadius: "4px" }) })
        ] }),
        /* @__PURE__ */ g(J9, { w: "32px", h: "32px" })
      ]
    }
  )
] }), mde = (e) => /* @__PURE__ */ g(
  U1,
  {
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ X("g", { id: "icon", clipPath: "url(#clip0_26136_34658_)", children: [
      /* @__PURE__ */ g("rect", { id: "Rectangle 43671", width: "40", height: "40", rx: "20", fill: "#5C5F6A" }),
      /* @__PURE__ */ g("g", { id: "conversion_path_off", children: /* @__PURE__ */ g("g", { mask: "url(#mask0_26136_34658_no_route_found_)", children: /* @__PURE__ */ g(
        "path",
        {
          id: "conversion_path_off_2",
          d: "M28.2481 30.3736L9.79035 11.9314C9.64168 11.7827 9.56576 11.6061 9.5626 11.4016C9.55943 11.1971 9.63535 11.0173 9.79035 10.8621C9.94551 10.707 10.1238 10.6294 10.3251 10.6294C10.5263 10.6294 10.7044 10.707 10.8596 10.8621L29.3173 29.3199C29.466 29.4686 29.5419 29.6426 29.5451 29.8419C29.5484 30.0412 29.4725 30.2185 29.3173 30.3736C29.1622 30.5288 28.984 30.6064 28.7828 30.6064C28.5815 30.6064 28.4033 30.5288 28.2481 30.3736ZM18.9981 26.7506C17.9623 26.7506 17.0783 26.3846 16.3461 25.6526C15.6141 24.9205 15.2481 24.0365 15.2481 23.0006C15.2481 21.9648 15.6141 21.0808 16.3461 20.3486C17.0783 19.6166 17.9623 19.2506 18.9981 19.2506H19.2481L20.7481 20.7506H18.9981C18.3776 20.7506 17.8474 20.9705 17.4076 21.4101C16.9679 21.85 16.7481 22.3801 16.7481 23.0006C16.7481 23.6211 16.9679 24.1513 17.4076 24.5911C17.8474 25.0308 18.3776 25.2506 18.9981 25.2506H25.2481L28.3653 28.3679C28.1577 28.4821 27.9407 28.5744 27.7143 28.6449C27.4882 28.7154 27.2494 28.7506 26.9981 28.7506C26.3738 28.7506 25.8177 28.5631 25.3298 28.1881C24.842 27.8131 24.5205 27.334 24.3653 26.7506H18.9981ZM28.9501 24.0486C29.2449 24.3436 29.4593 24.6841 29.5933 25.0699C29.7273 25.4557 29.7738 25.8481 29.7326 26.2469C29.7121 26.3674 29.6458 26.4459 29.5336 26.4824C29.4214 26.5189 29.3186 26.4904 29.2251 26.3969L26.6018 23.7736C26.5083 23.6801 26.4824 23.5773 26.5241 23.4651C26.5658 23.353 26.6468 23.2866 26.7673 23.2661C27.166 23.225 27.5558 23.2714 27.9366 23.4054C28.3173 23.5394 28.6551 23.7538 28.9501 24.0486ZM12.9981 16.7506C12.2353 16.7506 11.5863 16.483 11.0511 15.9476C10.5158 15.4125 10.2481 14.7635 10.2481 14.0006C10.2481 13.4993 10.375 13.0397 10.6288 12.6219C10.8827 12.2039 11.2167 11.8744 11.6308 11.6334L15.3751 15.3776C15.1339 15.7916 14.8012 16.124 14.3768 16.3746C13.9525 16.6253 13.4929 16.7506 12.9981 16.7506ZM23.0403 19.9236C22.8275 19.9236 22.6493 19.8519 22.5058 19.7084C22.3622 19.5647 22.2903 19.3865 22.2903 19.1736C22.2903 19.0481 22.3898 18.8424 22.5886 18.5564C22.8091 18.3744 22.9741 18.1471 23.0836 17.8746C23.1933 17.6023 23.2481 17.311 23.2481 17.0006C23.2481 16.3801 23.0283 15.85 22.5886 15.4101C22.1488 14.9705 21.6186 14.7506 20.9981 14.7506H17.8981C17.6481 14.7506 17.4606 14.6721 17.3356 14.5151C17.2106 14.358 17.1481 14.1865 17.1481 14.0006C17.1481 13.8148 17.2106 13.6433 17.3356 13.4861C17.4606 13.3291 17.6481 13.2506 17.8981 13.2506H20.9981C22.0339 13.2506 22.9179 13.6166 23.6501 14.3486C24.3821 15.0808 24.7481 15.9648 24.7481 17.0006C24.7481 17.5301 24.6452 18.0263 24.4393 18.4891C24.2337 18.952 23.95 19.3487 23.5883 19.6794C23.5243 19.7539 23.4433 19.8132 23.3451 19.8574C23.2471 19.9016 23.1455 19.9236 23.0403 19.9236Z",
          fill: "currentColor"
        }
      ) }) })
    ] })
  }
), Cde = ({ onOpen: e }) => {
  const { colorMode: t } = Ee(), { formatMessage: n } = n1(), r = Xe(), o = N((l) => l.transfer.estimatedAmount), i = Gt({ base: !0, lg: !1 }) ?? !1, a = we(() => o && Object.values(o).every((l) => l === void 0), [o]);
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-no-route-found-container",
      flexDir: "column",
      w: "100%",
      gap: "8px",
      background: r.colors[t].receive.background,
      borderRadius: "8px",
      p: [0, 0, 0, "0 16px"],
      children: [
        /* @__PURE__ */ g(re, { className: "bccb-widget-no-route-found-icon", justifyContent: "center", children: /* @__PURE__ */ g(mde, { w: "40px", h: "40px" }) }),
        /* @__PURE__ */ g(
          mt,
          {
            className: "bccb-widget-no-route-found-title",
            variant: "body",
            size: "md",
            textAlign: "center",
            fontWeight: 500,
            children: n({ id: a ? "route.no-found.title" : "route.adjust.title" })
          }
        ),
        /* @__PURE__ */ g(
          mt,
          {
            className: "bccb-widget-no-route-found-desc",
            variant: "body",
            size: "sm",
            mt: [0, 0, 0, "-4px"],
            textAlign: "center",
            color: r.colors[t].text.secondary,
            children: n(i ? { id: a ? "route.no-found.desc" : "route.adjust.desc" } : { id: "route.no-found.desc" })
          }
        ),
        !a && /* @__PURE__ */ g(
          h1,
          {
            className: "bccb-widget-no-route-found-link",
            display: { base: "block", lg: "none" },
            margin: "0 auto",
            fontSize: "14px",
            fontWeight: 500,
            textDecoration: "underline",
            color: r.colors[t].text.brand,
            cursor: "pointer",
            _hover: { color: r.colors[t].button.brand.hover },
            onClick: e,
            children: n({
              id: "route.adjust.link"
            })
          }
        )
      ]
    }
  );
};
function gde(e) {
  return /* @__PURE__ */ g(
    U1,
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16px",
      height: "16px",
      viewBox: "0 0 16 16",
      fill: "none",
      ...e,
      children: /* @__PURE__ */ g(
        "path",
        {
          d: "M10.9821 8.08443C10.8787 7.98102 10.827 7.86222 10.827 7.72803C10.827 7.59385 10.8753 7.47847 10.9718 7.3819L12.5206 5.83315H2.6667C2.52482 5.83315 2.40602 5.78528 2.3103 5.68956C2.21457 5.59384 2.16671 5.47504 2.16671 5.33316C2.16671 5.19128 2.21457 5.07248 2.3103 4.97676C2.40602 4.88104 2.52482 4.83318 2.6667 4.83318H12.5206L10.9654 3.27803C10.8731 3.18572 10.827 3.07247 10.827 2.9383C10.827 2.80411 10.8787 2.68531 10.9821 2.58189C11.0787 2.48531 11.1958 2.43701 11.3334 2.43701C11.471 2.43701 11.5881 2.48531 11.6846 2.58189L14.0141 4.91138C14.0765 4.97377 14.1205 5.03958 14.1462 5.10881C14.1718 5.17803 14.1846 5.25282 14.1846 5.33316C14.1846 5.41351 14.1718 5.48829 14.1462 5.55751C14.1205 5.62675 14.0765 5.69256 14.0141 5.75495L11.6782 8.09085C11.5791 8.18999 11.4624 8.23785 11.3282 8.23443C11.1941 8.23102 11.0787 8.18102 10.9821 8.08443ZM4.31543 13.4178L1.98595 11.0883C1.92355 11.0259 1.87953 10.9601 1.8539 10.8908C1.82825 10.8216 1.81543 10.7468 1.81543 10.6665C1.81543 10.5862 1.82825 10.5114 1.8539 10.4421C1.87953 10.3729 1.92355 10.3071 1.98595 10.2447L4.32183 7.90881C4.41414 7.8165 4.52739 7.76864 4.66156 7.76523C4.79575 7.76181 4.91455 7.81181 5.01796 7.91523C5.12139 8.01181 5.17481 8.12718 5.17823 8.26136C5.18164 8.39555 5.13164 8.51435 5.02823 8.61776L3.47948 10.1665H13.3334C13.4752 10.1665 13.594 10.2144 13.6898 10.3101C13.7855 10.4058 13.8333 10.5246 13.8333 10.6665C13.8333 10.8084 13.7855 10.9272 13.6898 11.0229C13.594 11.1186 13.4752 11.1665 13.3334 11.1665H3.47948L5.03463 12.7216C5.12694 12.8139 5.17481 12.9289 5.17823 13.0665C5.18164 13.2041 5.13164 13.3212 5.02823 13.4178C4.93165 13.5212 4.81456 13.5729 4.67695 13.5729C4.53935 13.5729 4.41884 13.5212 4.31543 13.4178Z",
          fill: "currentColor"
        }
      )
    }
  );
}
const bde = ({ onOpen: e }) => {
  const t = Xe(), n = N((i) => i.transfer.isGlobalFeeLoading), { colorMode: r } = Ee(), { formatMessage: o } = n1();
  return /* @__PURE__ */ X(
    re,
    {
      flexDir: "row",
      cursor: "pointer",
      alignItems: "center",
      gap: "1px",
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: 500,
      color: t.colors[r].text.brand,
      _hover: { color: t.colors[r].button.brand.hover },
      onClick: () => {
        n || e();
      },
      children: [
        /* @__PURE__ */ g(h1, { children: o({ id: "route.button.change-routes" }) }),
        /* @__PURE__ */ g(gde, { w: "12px", h: "12px" })
      ]
    }
  );
}, vde = () => {
  const e = D1(), { formatMessage: t } = n1(), n = N((T) => T.transfer.fromChain), r = N((T) => T.transfer.selectedToken), o = N((T) => T.transfer.sendValue), i = N((T) => T.transfer.toChain), a = C2(), l = a.getAdapter("deBridge"), c = a.getNativeCurrency(n?.id), { address: u, chain: f } = lt(), { data: p } = $0({
    address: u,
    chainId: n?.id
  }), { toTokenInfo: h } = Vn(), { balance: C } = b3({
    tokenAddress: r?.address
  }), { data: v } = x6(), b = n?.chainType === "solana" ? v : p, y = eo({ chainId: n?.id });
  return {
    deBridgeFeeSorting: se(
      async (T) => {
        const A = c?.symbol, L = c?.decimals ?? 18, I = [], M = [];
        let k = !1, _ = !1;
        if (T?.fixFee && A) {
          const te = x1(BigInt(T?.fixFee), L);
          I.push({
            symbol: A,
            value: te
          }), M.push({
            label: t({ id: "route.option.info.protocol-fee" }),
            value: `${F1(Number(te), 8)} ${A}`
          });
          const ae = r?.deBridge?.raw?.address === "0x0000000000000000000000000000000000000000" ? BigInt(T?.fixFee) + en(o, 18) : BigInt(T?.fixFee);
          b && b?.value < ae && (e(
            Ht({
              deBridge: `Insufficient ${A} to cover protocol fee`
            })
          ), _ = !0);
        }
        if (T?.estimation) {
          const te = T?.estimation.srcChainTokenOut || T?.estimation.srcChainTokenIn, ae = T?.estimation.costsDetails?.filter((J) => J.type === "DlnProtocolFee")?.[0]?.payload.feeAmount || null, be = x1(BigInt(ae), te?.decimals);
          I.push({
            symbol: te?.symbol,
            value: be
          }), M.push({
            label: t({ id: "route.option.info.debridge-fee" }),
            value: `${F1(Number(be), 8)} ${te?.symbol}`,
            name: "debridgeFee"
          });
          const K = T?.estimation?.costsDetails?.filter(
            (J) => J.type === "EstimatedOperatingExpenses"
          )?.[0], ue = T?.estimation?.srcChainTokenIn;
          if (ue) {
            const J = x1(
              BigInt(ue.approximateOperatingExpense),
              ue.decimals
            );
            I.push({
              symbol: ue?.symbol,
              value: J
            }), M.push({
              label: t({ id: "route.option.info.market-maker-fee" }),
              value: `${F1(Number(J), 8)} ${ue?.symbol}`,
              name: "marketMakerFee"
            });
          } else if (K) {
            const { chain: J, tokenIn: Me } = K ?? {}, _e = l?.getTokenByAddress({
              chainId: J,
              address: Me
            });
            if (_e) {
              const ne = x1(
                BigInt(K.payload.feeAmount),
                _e.decimals
              );
              I.push({
                symbol: _e.symbol,
                value: ne
              }), M.push({
                label: t({ id: "route.option.info.market-maker-fee" }),
                value: `${F1(Number(ne), 8)} ${_e.symbol}`,
                name: "marketMakerFee"
              });
            }
          }
        }
        const F = r?.deBridge?.raw?.decimals ?? 18, $ = en(o, F);
        try {
          if (f && n?.id === f?.id && u && r?.address && n.chainType !== "solana") {
            let te = null;
            if (r?.address !== "0x0000000000000000000000000000000000000000" && (te = await y.readContract({
              address: r?.address,
              abi: Gs,
              functionName: "allowance",
              args: [u, T?.tx.to],
              chainId: n?.id,
              enabled: !!u && !!r?.address && n && f && n?.id === f?.id
            })), n && i && Number(o) && h && f?.id === n.id && C && C >= $ && te && te >= $) {
              const ae = await y.getGasPrice(), be = await y.estimateGas({
                account: u,
                to: T?.tx.to,
                value: BigInt(T.tx.value),
                data: T?.tx.data
              });
              if (be && ae && A) {
                const K = `${x1(BigInt(be) * ae, 18)}`;
                I.push({
                  symbol: A,
                  value: K
                }), M.push({
                  label: t({ id: "route.option.info.gas-fee" }),
                  value: `${F1(Number(K), 8)} ${A}`,
                  name: "gasFee"
                });
              }
            }
          }
        } catch (te) {
          console.log(te), e(Ht({ deBridge: "Failed to get gas fee" })), k = !0;
        }
        const oe = BM(I);
        return e(
          Lr({
            deBridge: {
              summary: oe || "--",
              breakdown: M
            }
          })
        ), {
          summary: oe || "--",
          breakdown: M,
          isFailedToGetGas: k,
          isDisplayError: _
        };
      },
      [
        c?.symbol,
        c?.decimals,
        r?.deBridge?.raw?.decimals,
        r?.deBridge?.raw?.address,
        r?.address,
        o,
        e,
        t,
        b,
        l,
        f,
        n,
        u,
        i,
        h,
        C,
        y
      ]
    )
  };
}, ow = [
  {
    inputs: [
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "uint8", name: "_sharedDecimals", type: "uint8" },
      { internalType: "address", name: "_lzEndpoint", type: "address" }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      { internalType: "uint256", name: "cap", type: "uint256" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "ExceedInboundCap",
    type: "error"
  },
  {
    inputs: [
      { internalType: "uint256", name: "cap", type: "uint256" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "ExceedOutboundCap",
    type: "error"
  },
  { inputs: [], name: "NotOperator", type: "error" },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint16",
        name: "_srcChainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "_srcAddress",
        type: "bytes"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "_nonce",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "_hash",
        type: "bytes32"
      }
    ],
    name: "CallOFTReceivedSuccess",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "srcChainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "srcAddress",
        type: "bytes"
      },
      { indexed: !1, internalType: "uint64", name: "nonce", type: "uint64" }
    ],
    name: "DropFailedMessage",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "address", name: "to", type: "address" },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "FallbackWithdraw",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "_srcChainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "_srcAddress",
        type: "bytes"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "_nonce",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "_payload",
        type: "bytes"
      },
      { indexed: !1, internalType: "bytes", name: "_reason", type: "bytes" }
    ],
    name: "MessageFailed",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "_address",
        type: "address"
      }
    ],
    name: "NonContractAddress",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint16",
        name: "_srcChainId",
        type: "uint16"
      },
      { indexed: !0, internalType: "address", name: "_to", type: "address" },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "ReceiveFromChain",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "_srcChainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "_srcAddress",
        type: "bytes"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "_nonce",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "bytes32",
        name: "_payloadHash",
        type: "bytes32"
      }
    ],
    name: "RetryMessageSuccess",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint16",
        name: "_dstChainId",
        type: "uint16"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "_from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "bytes32",
        name: "_toAddress",
        type: "bytes32"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "SendToChain",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [{ indexed: !1, internalType: "uint16", name: "feeBp", type: "uint16" }],
    name: "SetDefaultFeeBp",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "dstchainId",
        type: "uint16"
      },
      { indexed: !1, internalType: "bool", name: "enabled", type: "bool" },
      { indexed: !1, internalType: "uint16", name: "feeBp", type: "uint16" }
    ],
    name: "SetFeeBp",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "feeOwner",
        type: "address"
      }
    ],
    name: "SetFeeOwner",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      { indexed: !1, internalType: "uint256", name: "cap", type: "uint256" }
    ],
    name: "SetInboundCap",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "_dstChainId",
        type: "uint16"
      },
      { indexed: !1, internalType: "uint16", name: "_type", type: "uint16" },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_minDstGas",
        type: "uint256"
      }
    ],
    name: "SetMinDstGas",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "newOperator",
        type: "address"
      }
    ],
    name: "SetOperator",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint16",
        name: "chainId",
        type: "uint16"
      },
      { indexed: !1, internalType: "uint256", name: "cap", type: "uint256" }
    ],
    name: "SetOutboundCap",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "precrime",
        type: "address"
      }
    ],
    name: "SetPrecrime",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "_remoteChainId",
        type: "uint16"
      },
      { indexed: !1, internalType: "bytes", name: "_path", type: "bytes" }
    ],
    name: "SetTrustedRemote",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint16",
        name: "_remoteChainId",
        type: "uint16"
      },
      {
        indexed: !1,
        internalType: "bytes",
        name: "_remoteAddress",
        type: "bytes"
      }
    ],
    name: "SetTrustedRemoteAddress",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bool",
        name: "_useCustomAdapterParams",
        type: "bool"
      }
    ],
    name: "SetUseCustomAdapterParams",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      { indexed: !0, internalType: "address", name: "addr", type: "address" },
      {
        indexed: !1,
        internalType: "bool",
        name: "isWhitelist",
        type: "bool"
      }
    ],
    name: "SetWhitelist",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [],
    name: "BP_DENOMINATOR",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "NO_EXTRA_GAS",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PT_SEND",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PT_SEND_AND_CALL",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "", type: "uint16" },
      { internalType: "bytes", name: "", type: "bytes" },
      { internalType: "uint64", name: "", type: "uint64" }
    ],
    name: "amountsForCall",
    outputs: [
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "bool", name: "credited", type: "bool" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_srcChainId", type: "uint16" },
      { internalType: "bytes", name: "_srcAddress", type: "bytes" },
      { internalType: "uint64", name: "_nonce", type: "uint64" },
      { internalType: "bytes32", name: "_from", type: "bytes32" },
      { internalType: "address", name: "_to", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
      { internalType: "bytes", name: "_payload", type: "bytes" },
      { internalType: "uint256", name: "_gasForCall", type: "uint256" }
    ],
    name: "callOnOFTReceived",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "chainIdToFeeBps",
    outputs: [
      { internalType: "uint16", name: "feeBP", type: "uint16" },
      { internalType: "bool", name: "enabled", type: "bool" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "chainIdToInboundCap",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "chainIdToLastReceivedTimestamp",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "chainIdToLastSentTimestamp",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "chainIdToOutboundCap",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "chainIdToReceivedTokenAmount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "chainIdToSentTokenAmount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "circulatingSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "defaultFeeBp",
    outputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "srcChainId", type: "uint16" },
      { internalType: "bytes", name: "srcAddress", type: "bytes" },
      { internalType: "uint64", name: "nonce", type: "uint64" }
    ],
    name: "dropFailedMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_dstChainId", type: "uint16" },
      { internalType: "bytes32", name: "_toAddress", type: "bytes32" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
      { internalType: "bytes", name: "_payload", type: "bytes" },
      { internalType: "uint64", name: "_dstGasForCall", type: "uint64" },
      { internalType: "bool", name: "_useZro", type: "bool" },
      { internalType: "bytes", name: "_adapterParams", type: "bytes" }
    ],
    name: "estimateSendAndCallFee",
    outputs: [
      { internalType: "uint256", name: "nativeFee", type: "uint256" },
      { internalType: "uint256", name: "zroFee", type: "uint256" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_dstChainId", type: "uint16" },
      { internalType: "bytes32", name: "_toAddress", type: "bytes32" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
      { internalType: "bool", name: "_useZro", type: "bool" },
      { internalType: "bytes", name: "_adapterParams", type: "bytes" }
    ],
    name: "estimateSendFee",
    outputs: [
      { internalType: "uint256", name: "nativeFee", type: "uint256" },
      { internalType: "uint256", name: "zroFee", type: "uint256" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "", type: "uint16" },
      { internalType: "bytes", name: "", type: "bytes" },
      { internalType: "uint64", name: "", type: "uint64" }
    ],
    name: "failedMessages",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "fallbackWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "feeOwner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_srcChainId", type: "uint16" },
      { internalType: "bytes", name: "_srcAddress", type: "bytes" }
    ],
    name: "forceResumeReceive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_version", type: "uint16" },
      { internalType: "uint16", name: "_chainId", type: "uint16" },
      { internalType: "address", name: "", type: "address" },
      { internalType: "uint256", name: "_configType", type: "uint256" }
    ],
    name: "getConfig",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "_remoteChainId", type: "uint16" }],
    name: "getTrustedRemoteAddress",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_srcChainId", type: "uint16" },
      { internalType: "bytes", name: "_srcAddress", type: "bytes" }
    ],
    name: "isTrustedRemote",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "lzEndpoint",
    outputs: [
      {
        internalType: "contract ILayerZeroEndpoint",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_srcChainId", type: "uint16" },
      { internalType: "bytes", name: "_srcAddress", type: "bytes" },
      { internalType: "uint64", name: "_nonce", type: "uint64" },
      { internalType: "bytes", name: "_payload", type: "bytes" }
    ],
    name: "lzReceive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "", type: "uint16" },
      { internalType: "uint16", name: "", type: "uint16" }
    ],
    name: "minDstGasLookup",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_srcChainId", type: "uint16" },
      { internalType: "bytes", name: "_srcAddress", type: "bytes" },
      { internalType: "uint64", name: "_nonce", type: "uint64" },
      { internalType: "bytes", name: "_payload", type: "bytes" }
    ],
    name: "nonblockingLzReceive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "operator",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "outboundAmount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "precrime",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_dstChainId", type: "uint16" },
      { internalType: "uint256", name: "_amount", type: "uint256" }
    ],
    name: "quoteOFTFee",
    outputs: [{ internalType: "uint256", name: "fee", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_srcChainId", type: "uint16" },
      { internalType: "bytes", name: "_srcAddress", type: "bytes" },
      { internalType: "uint64", name: "_nonce", type: "uint64" },
      { internalType: "bytes", name: "_payload", type: "bytes" }
    ],
    name: "retryMessage",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_from", type: "address" },
      { internalType: "uint16", name: "_dstChainId", type: "uint16" },
      { internalType: "bytes32", name: "_toAddress", type: "bytes32" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
      { internalType: "uint256", name: "_minAmount", type: "uint256" },
      { internalType: "bytes", name: "_payload", type: "bytes" },
      { internalType: "uint64", name: "_dstGasForCall", type: "uint64" },
      {
        components: [
          {
            internalType: "address payable",
            name: "refundAddress",
            type: "address"
          },
          {
            internalType: "address",
            name: "zroPaymentAddress",
            type: "address"
          },
          { internalType: "bytes", name: "adapterParams", type: "bytes" }
        ],
        internalType: "struct ICommonOFT.LzCallParams",
        name: "_callParams",
        type: "tuple"
      }
    ],
    name: "sendAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_from", type: "address" },
      { internalType: "uint16", name: "_dstChainId", type: "uint16" },
      { internalType: "bytes32", name: "_toAddress", type: "bytes32" },
      { internalType: "uint256", name: "_amount", type: "uint256" },
      { internalType: "uint256", name: "_minAmount", type: "uint256" },
      {
        components: [
          {
            internalType: "address payable",
            name: "refundAddress",
            type: "address"
          },
          {
            internalType: "address",
            name: "zroPaymentAddress",
            type: "address"
          },
          { internalType: "bytes", name: "adapterParams", type: "bytes" }
        ],
        internalType: "struct ICommonOFT.LzCallParams",
        name: "_callParams",
        type: "tuple"
      }
    ],
    name: "sendFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_version", type: "uint16" },
      { internalType: "uint16", name: "_chainId", type: "uint16" },
      { internalType: "uint256", name: "_configType", type: "uint256" },
      { internalType: "bytes", name: "_config", type: "bytes" }
    ],
    name: "setConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "_feeBp", type: "uint16" }],
    name: "setDefaultFeeBp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_dstChainId", type: "uint16" },
      { internalType: "bool", name: "_enabled", type: "bool" },
      { internalType: "uint16", name: "_feeBp", type: "uint16" }
    ],
    name: "setFeeBp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_feeOwner", type: "address" }],
    name: "setFeeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "chainId", type: "uint16" },
      { internalType: "uint256", name: "cap", type: "uint256" }
    ],
    name: "setInboundCap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_dstChainId", type: "uint16" },
      { internalType: "uint16", name: "_packetType", type: "uint16" },
      { internalType: "uint256", name: "_minGas", type: "uint256" }
    ],
    name: "setMinDstGas",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOperator", type: "address" }],
    name: "setOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "chainId", type: "uint16" },
      { internalType: "uint256", name: "cap", type: "uint256" }
    ],
    name: "setOutboundCap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "_precrime", type: "address" }],
    name: "setPrecrime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "_version", type: "uint16" }],
    name: "setReceiveVersion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "_version", type: "uint16" }],
    name: "setSendVersion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_srcChainId", type: "uint16" },
      { internalType: "bytes", name: "_path", type: "bytes" }
    ],
    name: "setTrustedRemote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint16", name: "_remoteChainId", type: "uint16" },
      { internalType: "bytes", name: "_remoteAddress", type: "bytes" }
    ],
    name: "setTrustedRemoteAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bool", name: "_useCustomAdapterParams", type: "bool" }],
    name: "setUseCustomAdapterParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "addr", type: "address" },
      { internalType: "bool", name: "isWhitelist", type: "bool" }
    ],
    name: "setWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "sharedDecimals",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint16", name: "", type: "uint16" }],
    name: "trustedRemoteLookup",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "useCustomAdapterParams",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "whitelist",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  }
], yde = () => {
  const { address: e, chain: t } = lt(), { toTokenInfo: n } = Vn(), r = D1(), o = g6(), { formatMessage: i } = n1(), a = N((b) => b.transfer.selectedToken), l = N((b) => b.transfer.sendValue), c = N((b) => b.transfer.fromChain), u = Us(), { data: f } = $0({ address: e, chainId: c?.id }), p = eo({ chainId: c?.id }), { balance: h } = b3({
    tokenAddress: a?.address
  }), { allowance: C } = sh({
    tokenAddress: a?.address,
    sender: a?.layerZero?.raw?.bridgeAddress
  });
  return {
    layerZeroFeeSorting: se(
      async (b) => {
        let y = "", x = null, T = !1, A = !1;
        const L = [], I = a?.layerZero?.raw?.bridgeAddress, M = en(
          l,
          a?.layerZero?.raw?.decimals ?? 18
        ), k = hH(e || Ha, { size: 32 }), _ = await p.readContract({
          address: I,
          abi: ow,
          functionName: "minDstGasLookup",
          args: [n?.layerZero?.raw?.endpointID, 0]
        }), $ = mH(["uint16", "uint256"], [1, _ !== 0n && _ ? _ : 200000n]), oe = [
          e,
          "0x0000000000000000000000000000000000000000",
          // zroPaymentAddress
          $
        ], te = b[0], ae = en(
          String(F1(Number(l), 8, !1)),
          a?.layerZero?.raw?.decimals ?? 18
        ), be = {
          address: I,
          abi: ow,
          functionName: "sendFrom",
          args: [
            e,
            n?.layerZero?.raw?.endpointID,
            k,
            M,
            ae,
            oe
          ],
          value: te,
          account: e
        };
        if (f?.value && f?.value >= Number(te)) {
          if (t && c?.id === t?.id && e && p && n?.layerZero?.raw?.endpointID && Number(l) && h && h >= M && C && C >= M && a?.address !== I)
            try {
              const K = await p.estimateContractGas(be), ue = await p.getGasPrice();
              if (K && ue) {
                const J = x1(BigInt(K) * ue, 18);
                x = Number(J), L.push({
                  label: i({ id: "route.option.info.gas-fee" }),
                  value: `${F1(Number(J), 8)} ${o}`
                });
              }
            } catch (K) {
              console.log(K), r(Ht({ layerZero: "Failed to get gas fee" })), T = !0;
            }
        } else u && (r(Ht({ layerZero: `Insufficient ${o} to cover native fee` })), A = !0);
        if (te) {
          const K = x1(te, 18);
          x = x ? x + Number(K) : Number(K), L.push({
            label: i({ id: "route.option.info.native-fee" }),
            value: `${F1(Number(K), 8)} ${o}`
          });
        }
        return y = x !== null ? `${ms(x)} ${o}` : "", r(
          Lr({
            layerZero: { summary: y || "--", breakdown: L }
          })
        ), {
          summary: y || "--",
          breakdown: L,
          isFailedToGetGas: T,
          isDisplayError: A
        };
      },
      [
        r,
        p,
        e,
        a,
        l,
        n,
        f?.value,
        o,
        i,
        h,
        t,
        c?.id,
        C,
        u
      ]
    )
  };
}, xde = () => {
  const e = D1(), { bridgeAddress: t } = C6(), n = N((i) => i.transfer.selectedToken), r = N((i) => i.transfer.fromChain);
  return { preSelectRoute: se(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (i, a) => {
      const [l, c, u, f, p] = i;
      a === "deBridge" && l.status === "fulfilled" ? e(
        kn({
          bridgeType: "deBridge",
          bridgeAddress: l.value.tx?.to,
          data: l.value.tx?.data,
          value: l.value.tx?.value,
          orderId: l.value.orderId
        })
      ) : a === "cBridge" && t && c.status === "fulfilled" ? e(
        kn({
          bridgeType: "cBridge",
          bridgeAddress: t
        })
      ) : a === "stargate" && n?.stargate?.raw?.address && u.status === "fulfilled" ? e(
        kn({
          bridgeType: "stargate",
          bridgeAddress: n?.stargate?.raw?.address
        })
      ) : a === "layerZero" && f.status === "fulfilled" ? e(
        kn({
          bridgeType: "layerZero",
          bridgeAddress: n?.layerZero?.raw?.bridgeAddress
        })
      ) : a === "meson" && p.status === "fulfilled" && r?.meson?.raw?.address && e(
        kn({
          bridgeType: "meson",
          bridgeAddress: r?.meson?.raw?.address
        })
      );
    },
    [
      e,
      n?.layerZero?.raw?.bridgeAddress,
      n?.stargate?.raw?.address,
      t,
      r
    ]
  ) };
}, wde = () => {
  const e = D1(), { formatMessage: t } = n1(), n = N((o) => o.transfer.selectedToken);
  return { mesonFeeSorting: se(
    async (o) => {
      let i = "";
      const a = [];
      let c = 0;
      if (o?.serviceFee) {
        const u = o?.serviceFee;
        c += Number(u), a.push({
          label: t({ id: "route.option.info.service-fee" }),
          value: `${F1(Number(u), 8)} ${n?.symbol}`,
          name: "serviceFee"
        });
      }
      if (o?.lpFee) {
        const u = o?.lpFee;
        c += Number(u), a.push({
          label: t({ id: "route.option.info.lp-fee" }),
          value: `${F1(Number(u), 8)} ${n?.symbol}`,
          name: "lpFee"
        });
      }
      return o?.totalFee && (i = `${String(ms(c))} ${n?.symbol}`), e(
        Lr({
          meson: {
            summary: i || "--",
            breakdown: a
          }
        })
      ), {
        summary: i || "--",
        breakdown: a,
        isFailedToGetGas: !1,
        isDisplayError: !1
      };
    },
    [e, t, n]
  ) };
};
let iw = Date.now();
const Ih = () => {
  const e = D1(), { preSelectRoute: t } = xde(), { getToDecimals: n } = Vn(), { address: r } = lt(), { address: o } = r2(), { address: i } = Ho(), { isSolanaAvailableToAccount: a } = lh(), l = Us(), c = fa(), {
    http: { deBridgeAccessToken: u, deBridgeReferralCode: f, feeReloadMaxTime: p = 15e3 }
  } = Lt(), h = g6(), { deBridgeFeeSorting: C } = vde(), v = Re(C);
  v.current = C;
  const { cBridgeFeeSorting: b, isAllowSendError: y } = b6(), x = Re(b);
  x.current = b;
  const T = Re(y);
  T.current = y;
  const { stargateFeeSorting: A } = Ah(), L = Re(A);
  L.current = A;
  const { layerZeroFeeSorting: I } = yde(), M = Re(I);
  M.current = I;
  const { mesonFeeSorting: k } = wde(), { onOpenFailedGetQuoteModal: _ } = PM(), { onOpenFeeTimeoutModal: F } = VM(), $ = Re(k);
  $.current = k;
  const { formatMessage: oe } = n1(), te = N((me) => me.transfer.toToken), ae = N((me) => me.transfer.selectedToken), be = N((me) => me.transfer.sendValue), K = N((me) => me.transfer.fromChain), ue = N((me) => me.transfer.toChain), J = N((me) => me.transfer.slippage), Me = N((me) => me.transfer.toAccount), _e = N((me) => me.transfer.isSummaryModalOpen), ne = Re(Me.address);
  ne.current = Me.address;
  const { data: ee } = $0({ address: r, chainId: K?.id }), ye = Re(ee);
  ye.current = ee;
  const fe = N((me) => me.transfer.transferActionInfo), xe = Re(fe?.bridgeType);
  xe.current = fe?.bridgeType;
  const Te = Re(_e);
  Te.current = _e;
  const Ie = eo({ chainId: K?.id }), Q = S3(be, _s);
  return {
    loadingBridgeFees: se(
      async (me) => {
        const { triggerType: Be = "new" } = me ?? {};
        if (e(Lr(void 0)), !ae || !K || !ue || !Q || !te) {
          e(or(!1));
          return;
        }
        e(V1(void 0)), e(
          Ht({
            deBridge: void 0,
            cBridge: void 0,
            stargate: void 0,
            layerZero: void 0,
            meson: void 0
          })
        );
        const We = [], ie = [];
        c.getSupportedBridges().forEach((s1) => {
          ae[s1] && We.push(s1);
        });
        try {
          const s1 = async () => await c.loadBridgeFees({
            bridgeType: We,
            fromChainId: K.id,
            fromAccount: r || Ha,
            toChainId: ue?.id,
            toToken: te,
            sendValue: Ye,
            fromTokenSymbol: ae.symbol,
            publicClient: Ie,
            endPointId: {
              layerZeroV1: te?.layerZero?.raw?.endpointID,
              layerZeroV2: te?.stargate?.raw?.endpointID
            },
            bridgeAddress: {
              stargate: ae?.stargate?.raw?.address,
              layerZero: ae?.layerZero?.raw?.bridgeAddress
            },
            isPegged: ae?.isPegged,
            slippage: J,
            mesonOpts: {
              fromToken: `${K?.meson?.raw?.id}:${ae?.meson?.raw?.id}`,
              toToken: `${ue?.meson?.raw?.id}:${te?.meson?.raw?.id}`,
              amount: Q,
              fromAddr: K?.chainType === "tron" ? o ?? O6e : r ?? Ha
            },
            deBridgeOpts: {
              fromChainId: K.id,
              fromTokenAddress: ae.deBridge?.raw?.address,
              amount: Ye,
              toChainId: ue?.id,
              toTokenAddress: te?.deBridge?.raw?.address,
              accesstoken: u,
              referralCode: f,
              userAddress: K.chainType === "solana" ? i || lx : r || Ha,
              toUserAddress: K.chainType === "solana" ? a ? ne.current : Ha : ue.chainType === "solana" ? a ? ne.current : lx : void 0
            }
          }), Ye = en(Q, ae.decimals), B1 = Date.now();
          iw = B1;
          let Pe;
          if (Pe = await s1(), console.log(
            "API response deBridge[0], cBridge[1], stargate[2], layerZero[3], meson[4]",
            Pe
          ), iw > B1)
            return;
          if (Ix(Pe)) {
            const r1 = Date.now();
            for (; console.log(`reload start after ${Date.now() - r1} seconds`), Pe = await s1(), !!Ix(Pe); ) {
              if (Date.now() - r1 >= p)
                throw F(), new Error(`Exceeded maximum retry time of ${p / 1e3} seconds`);
              await ece(2e3);
            }
          }
          const [X1, p1, L1, Ct, Z1] = Pe;
          if (Z1.status === "fulfilled" && Z1?.value)
            if (Z1?.value?.error) {
              const r1 = Z1?.value?.error;
              e(Lr({ meson: void 0 })), r1.code === 21 && r1.message === "amount-over-limit" ? (e(V1({ meson: "error" })), e(
                Ht({
                  meson: oe({ id: "route.error.amount.max" }, { max: r1.data.max })
                })
              )) : r1.code === 66 && r1.message === "fee-over-amount" ? (e(V1({ meson: "error" })), e(
                Ht({
                  meson: oe(
                    { id: "route.error.amount.min" },
                    { min: `${r1.data.fee} ${ae.symbol}` }
                  )
                })
              )) : r1.code === 19 && r1.message === "amount-exceeds-6-decimals" ? (e(V1({ meson: "error" })), e(
                Ht({
                  meson: oe({ id: "route.error.amount.digits" })
                })
              )) : (e(V1({ meson: "error" })), e(
                Ht({
                  meson: r1.message
                })
              ));
            } else {
              const r1 = await $.current(Z1.value.result), ut = ae?.meson?.raw?.decimals || 6, rn = en(Q, ut) - en(Z1.value.result.totalFee, ut);
              r1 && (e(
                V1({
                  meson: F1(Number(x1(rn, ut)), 8)
                })
              ), ie.push({
                type: "meson",
                value: F1(Number(x1(rn, ut)), 8),
                isIgnoreSorted: !1,
                isDisplayError: !1
              }));
            }
          else Z1.status === "rejected" ? e(V1({ meson: void 0 })) : e(V1({ meson: void 0 }));
          if (X1.status === "fulfilled" && X1?.value) {
            const r1 = await v.current(
              X1.value
            );
            r1?.isFailedToGetGas ? e(V1({ deBridge: void 0 })) : (e(
              V1({ deBridge: X1.value })
            ), ie.push({
              type: "deBridge",
              value: x1(
                BigInt(
                  X1.value?.estimation.dstChainTokenOut.amount
                ),
                n().deBridge
              ),
              isIgnoreSorted: r1?.isFailedToGetGas,
              isDisplayError: r1?.isDisplayError
            }));
          } else X1.status === "rejected" ? X1.reason.message === "ERROR_LOW_GIVE_AMOUNT" ? (e(Ht({ deBridge: "Please increase your send amount" })), e(V1({ deBridge: "error" })), e(Lr({ deBridge: void 0 }))) : e(V1({ deBridge: void 0 })) : e(V1({ deBridge: void 0 }));
          if (p1.status === "fulfilled" && p1?.value)
            if (p1?.value.err)
              e(V1({ cBridge: void 0 }));
            else if (p1.value?.err?.msg)
              e(Ht({ cBridge: p1.value?.err?.msg })), e(V1({ cBridge: "error" }));
            else {
              e(V1({ cBridge: p1.value }));
              const r1 = await x.current(p1.value);
              r1?.isFailedToGetGas && e(V1({ cBridge: void 0 })), !T.current && !r1?.isFailedToGetGas && ie.push({
                type: "cBridge",
                value: x1(
                  BigInt(p1.value?.estimated_receive_amt),
                  n().cBridge
                ),
                isIgnoreSorted: r1?.isFailedToGetGas,
                isDisplayError: !1
              });
            }
          else p1.status === "rejected" ? (e(Ht({ cBridge: p1.reason.message })), e(V1({ cBridge: "error" })), e(Lr({ cBridge: void 0 }))) : e(V1({ cBridge: void 0 }));
          if (L1.status === "fulfilled" && L1?.value) {
            const r1 = await L.current(L1.value);
            r1?.isFailedToGetGas ? e(V1({ stargate: void 0 })) : (e(V1({ stargate: U8e(L1.value) })), r1?.isDisplayError || ie.push({
              type: "stargate",
              value: x1(
                L1.value?.[2].amountReceivedLD,
                n().stargate
              ),
              isIgnoreSorted: r1?.isFailedToGetGas,
              isDisplayError: r1?.isDisplayError
            }));
          } else L1.status === "rejected" ? (e(Ht({ stargate: L1.reason.message })), e(V1({ stargate: void 0 })), e(Lr({ stargate: void 0 }))) : e(V1({ stargate: void 0 }));
          if (Ct.status === "fulfilled" && Ct?.value) {
            const r1 = Ct?.value[0];
            if (ye.current?.value && ye.current.value < Number(r1) && l)
              e(
                Ht({ layerZero: `Insufficient ${h} to cover native fee` })
              ), e(V1({ layerZero: "error" }));
            else {
              const ut = await M.current(Ct.value);
              ut?.isFailedToGetGas ? e(V1({ layerZero: void 0 })) : (e(
                V1({
                  layerZero: String(en(Q, n().layerZero))
                })
              ), ie.push({
                type: "layerZero",
                value: Q,
                isIgnoreSorted: ut?.isFailedToGetGas,
                isDisplayError: ut?.isDisplayError
              }));
            }
          } else Ct.status === "rejected" ? (e(Ht({ layerZero: Ct.reason.message })), e(V1({ layerZero: void 0 })), e(Lr({ layerZero: void 0 }))) : e(V1({ layerZero: void 0 }));
          if (xe.current && ie.length === 0 && Te.current === !0 && (e(F0(!1)), _()), ie.length > 0) {
            const r1 = ie.find(
              (rn) => !rn.isDisplayError && rn.type === xe.current
            ), ut = ie.reduce(
              (rn, on) => Number(on.value) > Number(rn.value) && on.isIgnoreSorted === !1 && on.isDisplayError === !1 ? on : rn,
              { value: "0", type: "" }
            );
            Be === "refresh" && Te.current === !0 && !r1 && (e(F0(!1)), _()), Be === "refresh" && r1 ? t(Pe, r1.type) : Number(ut?.value) > 0 && t(Pe, ut.type);
          }
          e(or(!1));
        } catch (s1) {
          console.log(s1, s1.message), e(or(!1)), e(
            V1({
              deBridge: void 0,
              cBridge: void 0,
              stargate: void 0,
              layerZero: void 0,
              meson: void 0
            })
          );
        }
      },
      [
        e,
        ae,
        K,
        ue,
        Q,
        te,
        c,
        r,
        Ie,
        J,
        o,
        u,
        f,
        i,
        a,
        p,
        F,
        oe,
        n,
        l,
        h,
        _,
        t
      ]
    )
  };
}, Sde = ({ onOpen: e }) => {
  const { getSortedReceiveAmount: t } = v6(), { toTokenInfo: n } = Vn(), r = Xe(), { colorMode: o } = Ee(), { formatMessage: i } = n1(), { loadingBridgeFees: a } = Ih(), l = D1(), c = N((F) => F.transfer.transferActionInfo), u = N((F) => F.transfer.isGlobalFeeLoading), f = N((F) => F.transfer.sendValue), p = N((F) => F.transfer.selectedToken), h = N((F) => F.transfer.estimatedAmount), C = Gt({ base: !0, lg: !1 }) ?? !1, v = N((F) => F.transfer.toToken), b = we(() => {
    if (!Number(f)) return null;
    if (c && c.bridgeType) {
      const F = c.bridgeType, $ = t();
      return Number($[F].value);
    }
    return null;
  }, [t, c, f]), y = we(() => c?.bridgeType, [c]), { isAllowSendError: x, cBridgeAllowedAmt: T } = b6(), { allowedSendAmount: A, isAllowSendError: L } = Ah(), I = we(() => T && c?.bridgeType === "cBridge" ? T : A && c?.bridgeType === "stargate" ? A : null, [T, A, c]), M = S3(f, _s);
  Oe(() => {
    if (!(!C || !v || !f))
      if (f === M) {
        if (l(kn(void 0)), !p || !Number(M)) {
          l(V1(void 0)), l(Mo(!1)), l(or(!1));
          return;
        }
        l(or(!0)), l(Mo(!0)), a(), l(Mo(!1));
      } else
        l(or(!0));
  }, [p, M, l, f, a, C, v]);
  const k = we(() => !v || !Number(f) ? !0 : u ? !1 : !Number(f) || !C && h && !Object.values(h).every((F) => F === void 0) && !b, [v, f, u, C, h, b]), _ = we(() => h && Object.values(h).every((F) => F === void 0), [h]);
  return /* @__PURE__ */ g(h1, { className: "bccb-widget-received-info-container", mb: k ? "-24px" : 0, children: /* @__PURE__ */ g($9, { in: !k, animateOpacity: !0, children: /* @__PURE__ */ X(re, { flexDir: "column", gap: "8px", children: [
    /* @__PURE__ */ X(
      re,
      {
        className: "bccb-widget-received-info-title",
        flexDir: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ g(
            mt,
            {
              variant: "label",
              size: "md",
              color: r.colors[o].text.placeholder,
              children: i({ id: "you.receive.title" })
            }
          ),
          _ ? null : /* @__PURE__ */ g(
            h1,
            {
              className: "bccb-widget-received-info-route-open",
              display: { base: "block", lg: "none" },
              children: /* @__PURE__ */ g(bde, { onOpen: e })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ g(
      re,
      {
        className: "bccb-widget-received-info-route-content",
        minH: "102px",
        borderRadius: "8px",
        p: "12px",
        flexDir: "column",
        gap: "8px",
        background: r.colors[o].receive.background,
        position: "relative",
        children: M === f ? b && !u ? /* @__PURE__ */ X(st, { children: [
          /* @__PURE__ */ g(h1, { display: { base: "bock", lg: "none" }, children: /* @__PURE__ */ g(S2, { bridgeType: y, isReceiveSection: !0 }) }),
          /* @__PURE__ */ g(
            h1,
            {
              display: { base: "block", lg: "none" },
              mb: "-12px",
              sx: {
                svg: {
                  w: "29px",
                  h: "29px"
                }
              },
              children: /* @__PURE__ */ g(
                ch,
                {
                  boxProps: {
                    position: "absolute",
                    right: "12px",
                    top: "10px"
                  }
                }
              )
            }
          ),
          y && /* @__PURE__ */ g(
            Ys,
            {
              receiveAmt: b ? F1(Number(b), 8, !1) : void 0,
              toTokenInfo: n?.[y],
              hoverToShowTokenAddress: !1
            }
          ),
          /* @__PURE__ */ X(re, { flexDir: "column", gap: "4px", children: [
            /* @__PURE__ */ g(v2, { bridgeType: y }),
            /* @__PURE__ */ g(b2, { bridgeType: y }),
            /* @__PURE__ */ g(
              Th,
              {
                allowedSendAmount: I,
                isError: y === "cBridge" ? x : y === "stargate" ? L : !1
              }
            )
          ] })
        ] }) : !b && !u ? /* @__PURE__ */ g(Cde, { onOpen: e }) : /* @__PURE__ */ g(rw, {}) : /* @__PURE__ */ g(rw, {})
      }
    )
  ] }) }) });
};
function Tde() {
  const { selectDefault: e } = w2(), t = D1(), n = Lt(), { defaultAmount: r, defaultFromChainId: o, defaultToChainId: i, defaultTokenAddress: a, providers: l } = n.transfer, c = l?.some((u) => !!u.config);
  Oe(() => {
    c && (e({
      fromChainId: o,
      toChainId: i,
      tokenAddress: a
    }), t(oa(r)));
  }, [
    r,
    o,
    i,
    a,
    c
  ]);
}
const Ade = (e) => /* @__PURE__ */ g(U1, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ g(
  "path",
  {
    d: "M9.30773 24.5C8.8026 24.5 8.37503 24.325 8.02503 23.975C7.67503 23.625 7.50003 23.1974 7.50003 22.6923V9.30772C7.50003 8.80259 7.67503 8.37502 8.02503 8.02502C8.37503 7.67502 8.8026 7.50002 9.30773 7.50002H22.6923C23.1974 7.50002 23.625 7.67502 23.975 8.02502C24.325 8.37502 24.5 8.80259 24.5 9.30772V22.6923C24.5 23.1974 24.325 23.625 23.975 23.975C23.625 24.325 23.1974 24.5 22.6923 24.5H9.30773ZM9.30773 23H22.6923C22.7692 23 22.8397 22.9679 22.9039 22.9038C22.968 22.8397 23 22.7692 23 22.6923V9.30772C23 9.23079 22.968 9.16027 22.9039 9.09615C22.8397 9.03205 22.7692 9 22.6923 9H9.30773C9.2308 9 9.16027 9.03205 9.09616 9.09615C9.03206 9.16027 9.00001 9.23079 9.00001 9.30772V22.6923C9.00001 22.7692 9.03206 22.8397 9.09616 22.9038C9.16027 22.9679 9.2308 23 9.30773 23Z",
    fill: "currentColor"
  }
) }), Ide = (e) => /* @__PURE__ */ g(U1, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ g(
  "path",
  {
    d: "M14.6 17.7462L12.2769 15.4231C12.1385 15.2846 11.9644 15.2138 11.7548 15.2106C11.5452 15.2074 11.368 15.2782 11.2231 15.4231C11.0782 15.568 11.0058 15.7436 11.0058 15.95C11.0058 16.1564 11.0782 16.332 11.2231 16.4769L13.9673 19.2211C14.1481 19.4019 14.359 19.4923 14.6 19.4923C14.841 19.4923 15.0519 19.4019 15.2327 19.2211L20.7962 13.6577C20.9346 13.5192 21.0054 13.3452 21.0087 13.1356C21.0119 12.926 20.941 12.7487 20.7962 12.6038C20.6513 12.459 20.4756 12.3865 20.2692 12.3865C20.0628 12.3865 19.8872 12.459 19.7423 12.6038L14.6 17.7462ZM9.30773 24.5C8.8026 24.5 8.37503 24.325 8.02503 23.975C7.67503 23.625 7.50003 23.1974 7.50003 22.6923V9.30772C7.50003 8.80259 7.67503 8.37502 8.02503 8.02502C8.37503 7.67502 8.8026 7.50002 9.30773 7.50002H22.6923C23.1974 7.50002 23.625 7.67502 23.975 8.02502C24.325 8.37502 24.5 8.80259 24.5 9.30772V22.6923C24.5 23.1974 24.325 23.625 23.975 23.975C23.625 24.325 23.1974 24.5 22.6923 24.5H9.30773ZM9.30773 23H22.6923C22.7692 23 22.8397 22.9679 22.9039 22.9038C22.968 22.8397 23 22.7692 23 22.6923V9.30772C23 9.23079 22.968 9.16027 22.9039 9.09615C22.8397 9.03205 22.7692 9 22.6923 9H9.30773C9.2308 9 9.16027 9.03205 9.09616 9.09615C9.03206 9.16027 9.00001 9.23079 9.00001 9.30772V22.6923C9.00001 22.7692 9.03206 22.8397 9.09616 22.9038C9.16027 22.9679 9.2308 23 9.30773 23Z",
    fill: "currentColor"
  }
) }), Lde = (e) => {
  const { onClick: t, isChecked: n } = e, r = Xe(), { colorMode: o } = Ee();
  return /* @__PURE__ */ g(
    h1,
    {
      className: "bccb-widget-to-account-checkbox",
      onClick: t,
      cursor: "pointer",
      mt: "-6px",
      children: n ? /* @__PURE__ */ g(Ide, { height: "32px", width: "32px", color: r.colors[o].text.brand }) : /* @__PURE__ */ g(
        Ade,
        {
          height: "32px",
          width: "32px",
          _hover: {
            color: r.colors[o].text.brand
          }
        }
      )
    }
  );
};
function Ede(e) {
  const { colorMode: t } = Ee(), { formatMessage: n } = n1(), r = D1(), o = Xe(), [i, a] = ze(!1), l = N((I) => I.transfer.toAccount), c = N((I) => I.transfer.toChain), { isTronTransfer: u, isTronAvailableToAccount: f } = m6(), { isTronContract: p } = wM(), { data: h } = Gd({
    address: l.address,
    chainId: c?.id
  }), { isSolanaTransfer: C, isSolanaAvailableToAccount: v } = lh(), b = Re(), [y, x] = ze(l.address), T = (I) => {
    const M = I.target.value.trim();
    x(M), clearTimeout(b.current), b.current = setTimeout(async () => {
      r(
        s6({
          address: M
        })
      );
    }, 500);
  };
  Oe(() => {
    l.address || x("");
  }, [l.address]);
  const { isInvalid: A } = we(() => u ? {
    isInvalid: !f && !!l.address || p === !0 || !!h,
    isAvailableAccount: f
  } : C ? {
    isInvalid: !!l.address && !v,
    isAvailableAccount: v
  } : {
    isInvalid: !1,
    isAvailableAccount: !1
  }, [
    u,
    C,
    f,
    l.address,
    p,
    h,
    v
  ]);
  if (!u && !C)
    return null;
  const L = () => {
    i ? (a(!1), r(bd(!1))) : (a(!0), r(bd(!0)));
  };
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-to-account-container",
      flexDirection: "column",
      color: o.colors[t].text.tertiary,
      fontSize: "14px",
      lineHeight: "16px",
      fontWeight: 400,
      ...e,
      children: [
        /* @__PURE__ */ g(h1, { className: "bccb-widget-to-account-title", children: n({ id: "to.section.account.label" }) }),
        /* @__PURE__ */ g(
          qf,
          {
            className: `bccb-widget-to-account-input ${A ? "input-error" : ""}`,
            alignItems: "center",
            mt: "12px",
            _hover: {
              outline: "2px solid",
              outlineColor: o.colors[t].input.border.hover,
              borderRadius: "8px"
            },
            children: /* @__PURE__ */ g(
              K0,
              {
                className: `${A ? "input-error" : ""}`,
                isInvalid: A,
                background: o.colors[t].input.background,
                borderColor: o.colors[t].input.border.default,
                size: "lg",
                value: y,
                placeholder: n(
                  { id: "to.section.account.placeholder" },
                  { network: c?.name ?? "" }
                ),
                onChange: T,
                _active: {},
                _focusVisible: {},
                _hover: {
                  borderColor: A ? o.colors[t].text.danger : o.colors[t].input.border.hover
                },
                _focus: {
                  boxShadow: `0 0 0 1px ${o.colors[t].text.brand}`,
                  borderColor: o.colors[t].text.brand
                },
                _invalid: {
                  boxShadow: `0 0 0 1px ${o.colors[t].text.danger}`,
                  borderColor: o.colors[t].text.danger
                }
              }
            )
          }
        ),
        A && /* @__PURE__ */ g(
          re,
          {
            className: "bccb-widget-to-account-input-error",
            mt: "8px",
            fontSize: "14px",
            color: o.colors[t].text.danger,
            children: n({ id: "to.section.account.invalid" })
          }
        ),
        /* @__PURE__ */ X(
          re,
          {
            className: "bccb-widget-to-account-confirm",
            flexDir: "row",
            mt: "12px",
            mb: "8px",
            ml: "-6px",
            gap: "2px",
            children: [
              /* @__PURE__ */ g(Lde, { onClick: L, isChecked: i }),
              /* @__PURE__ */ g(h1, { children: n({ id: "to.section.confirm.text" }) })
            ]
          }
        )
      ]
    }
  );
}
function Mde() {
  return /* @__PURE__ */ X(
    U1,
    {
      position: "absolute",
      w: 0,
      h: 0,
      viewBox: "0 0 440 280",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ g(
          "mask",
          {
            id: "mask0_1455_365",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "44",
            y: "22",
            width: "350",
            height: "174",
            children: /* @__PURE__ */ g("rect", { x: "44.8662", y: "22", width: "348.739", height: "173.412", fill: "#C4C4C4" })
          }
        ),
        /* @__PURE__ */ g(
          "mask",
          {
            id: "mask1_1455_365",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "46",
            y: "24",
            width: "347",
            height: "481",
            children: /* @__PURE__ */ g(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.297 24.6375C123.596 24.6375 46.0146 99.938 46.0146 192.826V504.033H132.91V200.862C132.91 154.555 171.586 117.016 219.295 117.016C267.005 117.016 305.681 154.555 305.681 200.862V504.033H392.579V192.826C392.579 99.9379 314.998 24.6375 219.297 24.6375Z",
                fill: "#E9BCFF"
              }
            )
          }
        ),
        /* @__PURE__ */ g("clipPath", { id: "clip0_3204_147712_", children: /* @__PURE__ */ g("rect", { width: "33.3232", height: "33.323", fill: "white" }) }),
        /* @__PURE__ */ g("clipPath", { id: "clip1_3204_147712_", children: /* @__PURE__ */ g("rect", { width: "33.3232", height: "33.323", fill: "white" }) }),
        /* @__PURE__ */ g("clipPath", { id: "clip0_26274_19335_", children: /* @__PURE__ */ g("rect", { x: "-5.75", y: "-5.25", width: "38", height: "38", rx: "19", fill: "white" }) }),
        /* @__PURE__ */ g(
          "mask",
          {
            id: "mask0_2001_23666_exchangeIcon_",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "16",
            height: "16",
            children: /* @__PURE__ */ g("rect", { width: "16", height: "16", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ g(
          "mask",
          {
            id: "mask0_26135_32299_expand_details_",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "17",
            height: "16",
            children: /* @__PURE__ */ g("rect", { x: "0.5", width: "16", height: "16", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ g(
          "mask",
          {
            id: "mask0_27981_20506_",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "16",
            height: "16",
            children: /* @__PURE__ */ g("rect", { width: "16", height: "16", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ g("mask", { id: "mask0_2473_30846_", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "16", height: "16", children: /* @__PURE__ */ g("rect", { width: "16", height: "16", fill: "#D9D9D9" }) }),
        /* @__PURE__ */ g("clipPath", { id: "clip0_27267_116884_", children: /* @__PURE__ */ g("rect", { width: "48", height: "48", fill: "white", transform: "translate(0.5)" }) }),
        /* @__PURE__ */ g(
          "mask",
          {
            id: "mask0_27267_116884_",
            maskUnits: "userSpaceOnUse",
            x: "8",
            y: "8",
            width: "33",
            height: "32",
            children: /* @__PURE__ */ g("rect", { x: "8.5", y: "8", width: "32", height: "32", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ g("clipPath", { id: "clip0_26136_34623_", children: /* @__PURE__ */ g("rect", { width: "48", height: "48", fill: "white", transform: "translate(0.5)" }) }),
        /* @__PURE__ */ g("mask", { id: "mask0_26136_34623_", maskUnits: "userSpaceOnUse", x: "8", y: "8", width: "33", height: "32", children: /* @__PURE__ */ g("rect", { x: "8.5", y: "8", width: "32", height: "32", fill: "#D9D9D9" }) }),
        /* @__PURE__ */ g("clipPath", { id: "clip0_26136_34658_", children: /* @__PURE__ */ g("rect", { width: "40", height: "40", fill: "white" }) }),
        /* @__PURE__ */ g(
          "mask",
          {
            id: "mask0_26136_34658_no_route_found_",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "8",
            y: "8",
            width: "24",
            height: "24",
            children: /* @__PURE__ */ g("rect", { id: "Bounding box", x: "8", y: "8", width: "24", height: "24", fill: "currentColor" })
          }
        ),
        /* @__PURE__ */ X(
          "linearGradient",
          {
            id: "paint0_linear_2473_21184_",
            x1: "0.498047",
            y1: "6.99854",
            x2: "23.9699",
            y2: "5.87059",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ g("stop", { stopColor: "#F7F7F8", stopOpacity: "0" }),
              /* @__PURE__ */ g("stop", { offset: "1", stopColor: "#F7F7F8" })
            ]
          }
        ),
        /* @__PURE__ */ g("mask", { id: "mask0_2324_9279_", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24", children: /* @__PURE__ */ g("rect", { width: "24", height: "24", fill: "#D9D9D9" }) })
      ]
    }
  );
}
function Bde() {
  const { formatMessage: e } = n1(), t = N((i) => i.transfer.toTokens), n = Xe(), { colorMode: r } = Ee(), o = N((i) => i.transfer.toToken);
  return t.length < 2 ? null : /* @__PURE__ */ X(h1, { className: "bccb-widget-to-token-section", children: [
    /* @__PURE__ */ g(
      mt,
      {
        className: "bccb-widget-to-token-header",
        color: n.colors[r].text.network.title,
        variant: "label",
        size: "md",
        children: e({ id: "select.received-token.title" })
      }
    ),
    /* @__PURE__ */ g(
      re,
      {
        className: "bccb-widget-to-token-list",
        flexWrap: { base: "nowrap", md: "wrap" },
        overflow: { base: "auto", md: "unset" },
        mt: "8px",
        gap: "8px",
        children: t.map((i) => /* @__PURE__ */ g(
          kde,
          {
            token: i,
            isSelected: ja(i.address, o?.address)
          },
          i.address
        ))
      }
    )
  ] });
}
function kde({ token: e, isSelected: t }) {
  const n = Xe(), { colorMode: r } = Ee(), { selectToToken: o } = w2(), { isMobile: i } = L6(), a = N((u) => u.transfer.toChain), l = N((u) => u.transfer.isGlobalFeeLoading), c = v3(a?.tokenUrlPattern, e.address);
  return /* @__PURE__ */ g(y6, { label: e.name, isDisabled: i, children: /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-to-token-item",
      "data-available-to-name": e.name,
      "data-available-to-address": e.address,
      "data-available-to-symbol": e.symbol,
      "data-available-to-display-symbol": e.displaySymbol,
      p: { base: "8px", md: "8px 12px" },
      h: "48px",
      alignItems: "center",
      gap: "4px",
      borderRadius: "8px",
      cursor: "pointer",
      onClick: () => {
        l || o(e.address);
      },
      border: "1px solid",
      borderColor: t ? n.colors[r].border.brand : n.colors[r].button.select.border,
      color: t ? n.colors[r].border.brand : n.colors[r].button.select.color,
      bg: n.colors[r].button.select.background.default,
      _hover: {
        bg: t ? void 0 : n.colors[r].button.select.background.hover
      },
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "16px",
      flexShrink: 0,
      children: [
        /* @__PURE__ */ g(
          Bo,
          {
            src: e.icon,
            boxSize: { base: "16px", md: "20px" },
            alignSelf: { base: "flex-start", md: "auto" }
          }
        ),
        /* @__PURE__ */ X(
          re,
          {
            alignItems: { base: "flex-start", md: "center" },
            gap: { base: "0", md: "4px" },
            flexDir: { base: "column", md: "row" },
            children: [
              /* @__PURE__ */ g(
                _n,
                {
                  color: t ? n.colors[r].text.primary : n.colors[r].text.tertiary,
                  children: e.displaySymbol
                }
              ),
              !di(e.address, a?.chainType) && /* @__PURE__ */ g(st, { children: i ? /* @__PURE__ */ X(
                re,
                {
                  alignItems: "center",
                  gap: "4px",
                  textDecoration: { base: "underline", md: "unset" },
                  children: [
                    n2({
                      address: e.address
                    }),
                    /* @__PURE__ */ g(pi, { boxSize: "16px", children: t && /* @__PURE__ */ g(
                      Ts,
                      {
                        isExternal: !0,
                        href: c,
                        color: "inherit",
                        _hover: { color: "inherit" },
                        children: /* @__PURE__ */ g($s, { boxSize: "100%" })
                      }
                    ) })
                  ]
                }
              ) : /* @__PURE__ */ g(Ts, { isExternal: !0, href: c, color: "inherit", _hover: { color: "inherit" }, children: n2({
                address: e.address,
                headLen: 4
              }) }) })
            ]
          }
        )
      ]
    }
  ) });
}
function yfe() {
  Tde();
  const { colorMode: e } = Ee(), t = D1(), n = Xe(), r = Lt();
  return /* @__PURE__ */ X(st, { children: [
    /* @__PURE__ */ g(Mde, {}),
    /* @__PURE__ */ X(
      re,
      {
        className: "bccb-widget-transfer-widget-wrapper",
        flexDir: "column",
        background: ["none", "none", n.colors[e].layer[2].default],
        color: n.colors[e].text.primary,
        boxShadow: ["none", "none", "0 24px 64px 0 rgba(0, 0, 0, 0.48)"],
        borderRadius: "24px",
        px: ["0", "0", "24px"],
        py: ["0", "0", "32px"],
        w: "100%",
        maxW: ["100%", "100%", "588px"],
        gap: "24px",
        position: "relative",
        children: [
          r.bridgeTitle && /* @__PURE__ */ g(
            mt,
            {
              className: "bccb-widget-transfer-widget-title",
              variant: "heading",
              size: { base: "xs", md: "sm" },
              as: "h1",
              fontWeight: 700,
              textAlign: "center",
              mb: "-4px",
              children: r.bridgeTitle
            }
          ),
          /* @__PURE__ */ g(Uue, {}),
          /* @__PURE__ */ g(tde, {}),
          /* @__PURE__ */ g(Bde, {}),
          /* @__PURE__ */ g(Ede, {}),
          /* @__PURE__ */ g(Sde, { onOpen: () => t(Kp(!0)) }),
          /* @__PURE__ */ g(re, { flexDir: "column", children: /* @__PURE__ */ g(cce, {}) }),
          r.components.routeContentBottom && /* @__PURE__ */ g(h1, { display: { base: "block", lg: "none" }, children: r.components.routeContentBottom })
        ]
      }
    )
  ] });
}
const $c = () => {
  const e = Xe(), { colorMode: t } = Ee();
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-route-skeleton",
      p: "12px",
      borderRadius: "8px",
      flexDir: "column",
      gap: "8px",
      border: `1px solid ${e.colors[t].route.border}`,
      children: [
        /* @__PURE__ */ X(re, { justifyContent: "space-between", alignItems: "center", flexDir: "row", children: [
          /* @__PURE__ */ g(Vt, { height: "12px", width: "160px", borderRadius: "8px" }),
          /* @__PURE__ */ g(Vt, { height: "24px", width: "80px", borderRadius: "100px" })
        ] }),
        /* @__PURE__ */ X(re, { gap: "8px", flexDir: "row", children: [
          /* @__PURE__ */ g(Vt, { height: "24px", width: "160px", borderRadius: "4px" }),
          /* @__PURE__ */ g(Vt, { height: "24px", width: "80px", borderRadius: "4px" })
        ] }),
        /* @__PURE__ */ g(Vt, { height: "12px", width: "100%", borderRadius: "4px" }),
        /* @__PURE__ */ g(Vt, { height: "12px", width: "100%", borderRadius: "4px" })
      ]
    }
  );
}, T3 = ({ bridgeType: e }) => {
  const t = Xe(), { colorMode: n } = Ee(), r = N((o) => o.transfer.routeError);
  return r && r[e] ? /* @__PURE__ */ X(
    h1,
    {
      className: "bccb-widget-route-error",
      position: "static",
      color: t.colors[n].route.warning,
      lineHeight: "16px",
      sx: {
        ">svg": {
          verticalAlign: "-3px"
        }
      },
      children: [
        /* @__PURE__ */ g(K9, { className: "error-icon", display: "inline", w: "16px", h: "16px" }),
        /* @__PURE__ */ g(
          h1,
          {
            className: "error-text",
            ml: "4px",
            display: "inline",
            lineHeight: "16px",
            fontSize: "14px",
            fontWeight: 400,
            children: r[e]
          }
        )
      ]
    }
  ) : null;
}, A3 = ({
  isError: e,
  onSelectBridge: t,
  isSelected: n,
  children: r
}) => {
  const { colorMode: o } = Ee(), i = Xe();
  return /* @__PURE__ */ g(
    re,
    {
      className: `bccb-widget-route-wrapper${n ? "-selected" : ""} ${e ? "route-error" : ""}`,
      flex: 1,
      flexDir: "column",
      gap: "4px",
      border: "1px solid",
      height: "fit-content",
      borderColor: n ? i.colors[o].border.brand : i.colors[o].button.select.border,
      background: n ? "rgba(255, 233, 0, 0.06);" : "none",
      borderRadius: "8px",
      padding: "12px",
      position: "relative",
      cursor: e ? "default" : "pointer",
      _hover: {
        borderColor: e ? i.colors[o].button.select.border : i.colors[o].border.brand
      },
      onClick: t,
      children: r
    }
  );
}, Rde = () => {
  const e = D1(), { toTokenInfo: t, getToDecimals: n } = Vn(), { isAllowSendError: r, bridgeAddress: o, cBridgeAllowedAmt: i } = b6(), a = N((v) => v.transfer.selectedToken), l = N((v) => v.transfer.transferActionInfo), c = N((v) => v.transfer.estimatedAmount), u = N((v) => v.transfer.sendValue), f = N((v) => v.transfer.routeError), p = we(() => c && c?.cBridge && t && Number(u) > 0 && n().cBridge && Number(c?.cBridge?.estimated_receive_amt) > 0 ? `${F1(
    Number(
      x1(
        c?.cBridge?.estimated_receive_amt,
        n().cBridge
      )
    ),
    8
  )}` : "--", [c, t, u, n]);
  Oe(() => {
    Number(c?.cBridge?.estimated_receive_amt) < 0 && e(
      Ht({
        cBridge: "Please increase your send amount"
      })
    );
  }, [e, c?.cBridge?.estimated_receive_amt]);
  const h = we(
    () => c?.cBridge === "error" || f && f?.cBridge || r || p === "--" || !1,
    [c?.cBridge, r, p, f]
  ), C = se(() => {
    h || e(
      kn({
        bridgeType: "cBridge",
        bridgeAddress: o
      })
    );
  }, [o, e, h]);
  return /* @__PURE__ */ X(
    A3,
    {
      isSelected: l?.bridgeType === "cBridge",
      isError: h,
      onSelectBridge: C,
      children: [
        /* @__PURE__ */ g(S2, { isError: h, bridgeType: "cBridge" }),
        /* @__PURE__ */ g(
          Ys,
          {
            isError: h,
            receiveAmt: p,
            toTokenInfo: t?.cBridge
          }
        ),
        /* @__PURE__ */ g(v2, { isError: h, bridgeType: "cBridge" }),
        /* @__PURE__ */ g(b2, { isError: h, bridgeType: "cBridge" }),
        /* @__PURE__ */ g(
          Th,
          {
            position: "static",
            isError: r,
            allowedSendAmount: Number(i.min) && Number(i.max) && a ? {
              min: i.min,
              max: i.max
            } : null
          }
        ),
        !r && /* @__PURE__ */ g(T3, { bridgeType: "cBridge" })
      ]
    }
  );
}, _de = ({}) => {
  const e = D1(), { toTokenInfo: t, getToDecimals: n } = Vn(), r = N((u) => u.transfer.transferActionInfo), o = N((u) => u.transfer.estimatedAmount), i = N((u) => u.transfer.routeError), a = we(() => o?.deBridge && t && Number(o?.deBridge?.estimation?.dstChainTokenOut?.amount) > 0 && n().deBridge ? F1(
    Number(
      x1(
        BigInt(o?.deBridge?.estimation?.dstChainTokenOut?.amount),
        n().deBridge
      )
    ),
    8
  ) : "--", [o, t, n]), l = we(
    () => o?.deBridge === "error" || a === "--" || i && i?.deBridge || !1,
    [o?.deBridge, a, i]
  ), c = se(() => {
    !o || !o?.deBridge?.tx || l || e(
      kn({
        bridgeType: "deBridge",
        bridgeAddress: o.deBridge.tx.to,
        data: o.deBridge.tx.data,
        value: o.deBridge.tx.value,
        orderId: o.deBridge.orderId
      })
    );
  }, [o, e, l]);
  return /* @__PURE__ */ X(
    A3,
    {
      isSelected: r?.bridgeType === "deBridge",
      isError: l,
      onSelectBridge: c,
      children: [
        /* @__PURE__ */ g(S2, { isError: l, bridgeType: "deBridge" }),
        /* @__PURE__ */ g(
          Ys,
          {
            isError: l,
            receiveAmt: a,
            toTokenInfo: t?.deBridge
          }
        ),
        /* @__PURE__ */ g(v2, { isError: l, bridgeType: "deBridge" }),
        /* @__PURE__ */ g(b2, { isError: l, bridgeType: "deBridge" }),
        /* @__PURE__ */ g(T3, { bridgeType: "deBridge" })
      ]
    }
  );
}, Fde = () => {
  const e = D1(), { toTokenInfo: t, getToDecimals: n } = Vn(), { allowedSendAmount: r, isAllowSendError: o } = Ah(), i = N((C) => C.transfer.selectedToken), a = N((C) => C.transfer.sendValue), l = N((C) => C.transfer.transferActionInfo), c = N((C) => C.transfer.estimatedAmount), u = N((C) => C.transfer.routeError), f = we(() => c && t && Number(a) > 0 && c?.stargate?.[2].amountReceivedLD && Number(c.stargate?.[2]?.amountReceivedLD) > 0 ? `${F1(
    Number(
      x1(
        BigInt(c?.stargate?.[2].amountReceivedLD),
        n().stargate || 18
      )
    ),
    8
  )}` : "--", [c, t, a, n]), p = we(
    () => c?.stargate === "error" || o || u && u?.stargate || f === "--" || !1,
    [c?.stargate, o, f, u]
  ), h = se(() => {
    if (!i?.stargate?.raw?.address || p) return;
    const C = i.stargate.raw?.address;
    e(
      kn({
        bridgeType: "stargate",
        bridgeAddress: C
      })
    );
  }, [i, e, p]);
  return /* @__PURE__ */ X(
    A3,
    {
      isError: p,
      onSelectBridge: h,
      isSelected: l?.bridgeType === "stargate",
      children: [
        /* @__PURE__ */ g(S2, { isError: p, bridgeType: "stargate" }),
        /* @__PURE__ */ g(
          Ys,
          {
            isError: p,
            receiveAmt: f,
            toTokenInfo: t?.stargate
          }
        ),
        /* @__PURE__ */ g(v2, { isError: p, bridgeType: "stargate" }),
        /* @__PURE__ */ g(b2, { isError: p, bridgeType: "stargate" }),
        /* @__PURE__ */ g(
          Th,
          {
            position: "static",
            isError: o,
            allowedSendAmount: r
          }
        ),
        !o && /* @__PURE__ */ g(T3, { bridgeType: "stargate" })
      ]
    }
  );
}, Pde = () => {
  const e = D1(), { toTokenInfo: t, getToDecimals: n } = Vn(), r = N((p) => p.transfer.selectedToken), o = N((p) => p.transfer.sendValue), i = N((p) => p.transfer.transferActionInfo), a = N((p) => p.transfer.estimatedAmount), l = N((p) => p.transfer.routeError), c = we(() => a && t && Number(o) > 0 && a?.layerZero && Number(a?.layerZero) > 0 ? `${F1(
    Number(x1(BigInt(a?.layerZero), n().layerZero)),
    8
  )}` : "--", [a, t, o, n]), u = we(
    () => a?.layerZero === "error" || c === "--" || l && l.layerZero || !1,
    [a?.layerZero, c, l]
  ), f = se(() => {
    if (!r?.layerZero?.raw?.bridgeAddress || u) return;
    const p = r.layerZero.raw?.bridgeAddress;
    e(
      kn({
        bridgeType: "layerZero",
        bridgeAddress: p
      })
    );
  }, [r, e, u]);
  return /* @__PURE__ */ X(
    A3,
    {
      isSelected: i?.bridgeType === "layerZero",
      isError: u,
      onSelectBridge: f,
      children: [
        /* @__PURE__ */ g(S2, { isError: u, bridgeType: "layerZero" }),
        /* @__PURE__ */ g(
          Ys,
          {
            isError: u,
            receiveAmt: c,
            toTokenInfo: t?.layerZero
          }
        ),
        /* @__PURE__ */ g(v2, { bridgeType: "layerZero" }),
        /* @__PURE__ */ g(b2, { isError: u, bridgeType: "layerZero" }),
        /* @__PURE__ */ g(T3, { bridgeType: "layerZero" })
      ]
    }
  );
}, Vde = () => {
  const e = D1(), { toTokenInfo: t } = Vn(), n = N((u) => u.transfer.transferActionInfo), r = N((u) => u.transfer.estimatedAmount), o = N((u) => u.transfer.routeError), i = N((u) => u.transfer.fromChain), a = we(() => Number(r?.meson) ? r?.meson : "--", [r]), l = we(
    () => r?.meson === "error" || o && o?.meson || a === "--" || !1,
    [r?.meson, a, o]
  ), c = se(() => {
    if (!i?.meson?.raw?.address || l) return;
    const u = i?.meson?.raw?.address;
    e(
      kn({
        bridgeType: "meson",
        bridgeAddress: u
      })
    );
  }, [i, e, l]);
  return /* @__PURE__ */ X(
    A3,
    {
      isError: l,
      onSelectBridge: c,
      isSelected: n?.bridgeType === "meson",
      children: [
        /* @__PURE__ */ g(S2, { isError: l, bridgeType: "meson" }),
        /* @__PURE__ */ g(Ys, { isError: l, receiveAmt: a, toTokenInfo: t?.meson }),
        /* @__PURE__ */ g(v2, { isError: l, bridgeType: "meson" }),
        /* @__PURE__ */ g(b2, { isError: l, bridgeType: "meson" }),
        /* @__PURE__ */ g(T3, { bridgeType: "meson" })
      ]
    }
  );
}, Hde = Zd(function({
  isDisabled: t = !1
}) {
  const { bridgeAddress: n } = C6(), r = fa(), o = N((c) => c.transfer.fromChain), i = eo({ chainId: o?.id }), a = N((c) => c.transfer.selectedToken), l = D1();
  return Oe(() => {
    (async () => {
      try {
        if (a?.isPegged || !i || !n || !a?.address || t || !r?.cBridge) {
          l(wd({ min: "0", max: "0" }));
          return;
        }
        const { min: c, max: u } = await r.cBridge.getSendRange({
          bridgeAddress: n,
          tokenAddress: a?.address,
          client: i
        });
        l(
          wd({
            min: x1(c, a?.decimals),
            max: x1(u, a?.decimals)
          })
        );
      } catch (c) {
        console.log("error", c);
      }
    })();
  }, [
    l,
    a?.address,
    a?.isPegged,
    a?.decimals,
    i,
    n,
    t,
    r?.cBridge
  ]), null;
});
function aw(e) {
  const { routeContentBottom: t, ...n } = e, r = D1(), { formatMessage: o } = n1(), { colorMode: i } = Ee(), a = Xe(), l = C2(), { loadingBridgeFees: c } = Ih(), { getSortedReceiveAmount: u } = v6(), f = N((F) => F.transfer.selectedToken), p = N((F) => F.transfer.isGlobalFeeLoading), h = N((F) => F.transfer.sendValue), C = N((F) => F.transfer.estimatedAmount), v = N((F) => F.transfer.toToken), b = S3(h, _s), y = Gt({ base: !0, lg: !1 }) ?? !1, x = N((F) => F.transfer.toToken);
  Oe(() => {
    if (!(y || !x || !h))
      if (h === b) {
        if (r(kn(void 0)), !f || !Number(b)) {
          r(V1(void 0)), r(Mo(!1)), r(or(!1));
          return;
        }
        r(or(!0)), r(Mo(!0)), c(), r(Mo(!1));
      } else
        r(or(!0));
  }, [f, b, r, h, c, y, x]);
  const T = we(() => u(), [u]), A = we(() => {
    if (!Number(b) || !C || !T || Object.values(T).every(
      ($) => $.value === null || $.value === void 0
    ))
      return [];
    const F = [];
    for (const $ in T)
      $ === "cBridge" && C?.cBridge && F.push(/* @__PURE__ */ g(Rde, {}, "cBridge-option")), $ === "deBridge" && C?.deBridge && F.push(/* @__PURE__ */ g(_de, {}, "deBridge-option")), $ === "stargate" && C.stargate && F.push(/* @__PURE__ */ g(Fde, {}, "stargate-option")), $ === "layerZero" && C.layerZero && F.push(/* @__PURE__ */ g(Pde, {}, "layerZero-option")), $ === "meson" && C.meson && F.push(/* @__PURE__ */ g(Vde, {}, "meson-option"));
    return F;
  }, [T, b, C]), L = f && !!Number(h) && v && A && !!A?.length, I = !A || !A?.length || p, M = /* @__PURE__ */ g(
    h1,
    {
      className: "bccb-widget-route-container",
      position: "relative",
      borderRadius: "24px",
      py: "24px",
      background: { base: "transparent", lg: a.colors[i].layer[2].default },
      boxShadow: { base: "none", lg: "0px 24px 64px 0px rgba(0, 0, 0, 0.48)" },
      maxW: ["auto", "auto", "auto", "384px"],
      w: "100%",
      overflow: ["auto", "auto", "auto", "hidden"],
      children: /* @__PURE__ */ X(re, { className: "bccb-widget-route-container-inner", flexDir: "column", gap: "12px", children: [
        /* @__PURE__ */ X(
          re,
          {
            className: "bccb-widget-route-header",
            display: { base: "none", lg: "flex" },
            justifyContent: "space-between",
            alignItems: "center",
            px: ["0", "0", "0", "24px"],
            color: a.colors[i].text.route.title,
            fontSize: "14px",
            fontWeight: 500,
            whiteSpace: "nowrap",
            h: "32px",
            sx: {
              svg: {
                w: "32px",
                h: "32px"
              }
            },
            children: [
              o({ id: "route.title" }),
              !A.length || p ? /* @__PURE__ */ g(J9, { className: "skeleton", w: "32px", h: "32px" }) : y ? null : /* @__PURE__ */ g(ch, {})
            ]
          }
        ),
        /* @__PURE__ */ g(
          h1,
          {
            className: "bccb-widget-route-body",
            px: ["0", "0", "0", "24px"],
            flex: 1,
            overflow: "auto",
            overscrollBehavior: "contain",
            maxHeight: "698px",
            w: ["auto", "auto", "auto", "384px"],
            children: I ? /* @__PURE__ */ X(re, { flexDir: "column", gap: "12px", children: [
              /* @__PURE__ */ g($c, {}),
              /* @__PURE__ */ g($c, {}),
              /* @__PURE__ */ g($c, {})
            ] }) : /* @__PURE__ */ g(re, { className: "bccb-widget-route-list", flexDir: "column", gap: "12px", children: A?.map((F) => F) })
          }
        )
      ] })
    }
  ), k = !!l.getAdapter("cBridge"), _ = L || !!t;
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-overview",
      w: { base: "auto", lg: _ ? "408px" : 0 },
      "data-show": _ ? !0 : void 0,
      transition: "width 0.15s",
      ...n,
      children: [
        k && /* @__PURE__ */ g(Hde, {}),
        /* @__PURE__ */ X(
          re,
          {
            className: "bccb-widget-route",
            flexDir: "column",
            gap: "8px",
            ml: { base: 0, lg: "24px" },
            w: "100%",
            children: [
              t ? /* @__PURE__ */ g(h1, { mb: L ? 0 : "-8px", borderRadius: "24px", overflow: "hidden", children: /* @__PURE__ */ g($9, { in: L, animateOpacity: !0, children: M }) }) : M,
              /* @__PURE__ */ g(h1, { className: "bccb-widget-route-bottom", children: t || null })
            ]
          }
        )
      ]
    }
  );
}
function Ode(e) {
  const { isOpen: t, title: n, children: r, onClose: o } = e, i = Xe(), { colorMode: a } = Ee(), l = N((c) => c.transfer.transferActionInfo);
  return Oe(() => {
    l?.bridgeType && o();
  }, [l?.bridgeType]), /* @__PURE__ */ X(i3, { isOpen: t, onClose: o, size: { base: "full", md: "lg" }, isCentered: !0, children: [
    /* @__PURE__ */ g(s3, { className: "bccb-widget-modal-route-overlay", w: "100%" }),
    /* @__PURE__ */ X(
      a3,
      {
        className: "bccb-widget-modal-route-content",
        background: i.colors[a].background.modal,
        p: 0,
        h: ["100vh", "80vh", "665px"],
        w: ["100%", "100%", "558px"],
        overflow: ["auto", "auto", "auto", "hidden"],
        margin: 0,
        children: [
          /* @__PURE__ */ X(
            re,
            {
              className: "bccb-widget-modal-route-header",
              h: "64px",
              px: "20px",
              py: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              lineHeight: 1.4,
              fontWeight: 500,
              fontSize: "20px",
              borderBottom: `1px solid ${i.colors[a].border[3]}`,
              flexShrink: 0,
              children: [
                /* @__PURE__ */ g(re, { boxSize: "24px" }),
                n,
                /* @__PURE__ */ g(
                  d2,
                  {
                    boxSize: "24px",
                    onClick: o,
                    cursor: "pointer",
                    color: i.colors[a].modal.close.default,
                    _hover: {
                      color: i.colors[a].modal.close.hover
                    }
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ g(
            re,
            {
              className: "bccb-widget-modal-route-wrapper",
              flexDir: "column",
              p: ["20px", "20px", "24px 20px 16px"],
              flex: 1,
              children: /* @__PURE__ */ g(re, { flexDir: "column", mt: ["0", "0", "0", "24px"], flex: 1, overflowY: "auto", children: r })
            }
          )
        ]
      }
    )
  ] });
}
const Nde = () => {
  const e = Lt(), t = D1(), n = N((i) => i.transfer.isGlobalFeeLoading), r = N((i) => i.transfer.transferActionInfo), o = we(() => e.http?.refetchingInterval ?? 3e4, [e.http?.refetchingInterval]);
  return Oe(() => {
    if (!r || n) return;
    let i, a;
    const l = (c) => {
      i || (i = c);
      const u = c - i, f = Math.min(u / o, 1);
      t(_E(f)), f < 1 || (i = c), a = requestAnimationFrame(l);
    };
    return a = requestAnimationFrame(l), () => {
      a && cancelAnimationFrame(a);
    };
  }, [o, t, n, r]), null;
};
function xfe() {
  const { formatMessage: e } = n1(), t = D1(), n = Gt({ base: !0, lg: !1 }) ?? !1, { loadingBridgeFees: r } = Ih(), o = Lt(), i = N((u) => u.transfer.isRoutesModalOpen), a = N((u) => u.transfer.transferActionInfo), l = N((u) => u.transfer.isManuallyReload), c = N((u) => u.transfer.toToken);
  return Nde(), Oe(() => {
    let u = !0;
    if (!(!u || !c))
      if (a) {
        const f = {
          triggerType: "refresh"
        };
        let p = setInterval(() => {
          t(or(!0)), r(f);
        }, o.http.refetchingInterval ?? 3e4);
        return l === !0 && (t(d0(!1)), t(Mo(!0)), p && (clearInterval(p), t(or(!0)), r(f), t(Mo(!1)), p = setInterval(() => {
          t(or(!0)), r(f);
        }, o.http?.refetchingInterval ?? 3e4))), () => {
          u = !1, p && clearInterval(p), t(d0(!1));
        };
      } else
        t(d0(!1)), u = !1;
  }, [
    a,
    r,
    t,
    o.http.refetchingInterval,
    l,
    c
  ]), n ? /* @__PURE__ */ g(
    Ode,
    {
      title: e({ id: "route.title.select.routes" }),
      isOpen: i,
      onClose: () => t(Kp(!1)),
      children: /* @__PURE__ */ g(aw, {})
    }
  ) : /* @__PURE__ */ g(aw, { routeContentBottom: o.components.routeContentBottom });
}
const wfe = {
  en: Md
};
function Sfe(e) {
  const { walletIcons: t, onClickNetwork: n, ...r } = e, o = Xe(), { colorMode: i } = Ee(), { formatMessage: a } = n1(), l = N((p) => p.transfer.fromChain), { onClickConnectWalletButton: c } = Lt(), f = Us();
  return /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-header-wallet-connect",
      alignItems: "center",
      gap: "16px",
      ...r,
      children: [
        !f && /* @__PURE__ */ g(
          Hr,
          {
            className: "bccb-widget-header-wallet-connect-button",
            variant: "outline",
            h: "40px",
            px: "16px",
            borderRadius: "8px",
            fontSize: "14px",
            lineHeight: "16px",
            fontWeight: 500,
            onClick: () => {
              c?.({
                chainType: l.chainType,
                chainId: l.id
              });
            },
            sx: {
              "@media (hover: none)": {
                _hover: {
                  bg: "transparent",
                  color: o.colors[i].button.primary.default,
                  borderColor: o.colors[i].button.primary.default
                }
              }
            },
            children: a({ id: "wallet.button.connect-wallet" })
          }
        ),
        f && /* @__PURE__ */ X(st, { children: [
          /* @__PURE__ */ g(zde, { onClickNetwork: n }),
          /* @__PURE__ */ g(Yde, { walletIcons: t })
        ] })
      ]
    }
  );
}
function Hd(e) {
  const { ...t } = e;
  return /* @__PURE__ */ g(fp, { placement: "bottom-end", ...t });
}
function Od(e) {
  const { children: t, isActive: n = !1, isWarning: r = !1, ...o } = e, i = Xe(), { colorMode: a } = Ee(), l = {
    warning: {
      default: i.colors[a].support.warning[3],
      hover: i.colors[a].support.warning[3],
      active: i.colors[a].support.warning[3]
    },
    normal: {
      default: i.colors[a].input.border.default,
      hover: i.colors[a].input.border.hover,
      active: i.colors[a].input.border.active
    }
  }, c = r ? l.warning : l.normal;
  return /* @__PURE__ */ g(
    mp,
    {
      h: { base: "32px", md: "40px" },
      minW: { base: "32px", md: "40px" },
      pl: { base: "8px", md: "12px" },
      pr: { base: "12px", md: "16px" },
      lineHeight: "16px",
      outline: n ? "2px solid" : "1px solid",
      outlineColor: n ? c.active : c.default,
      bg: n ? i.colors[a].button.select.background.hover : void 0,
      borderRadius: "100px",
      fontWeight: 500,
      fontSize: "14px",
      transitionDuration: "normal",
      justifyContent: "center",
      border: "none",
      _hover: {
        outlineWidth: 2,
        outlineColor: n ? c.active : c.hover
      },
      ...o,
      children: /* @__PURE__ */ g(re, { alignItems: "center", gap: "8px", justifyContent: "center", children: t })
    }
  );
}
function Nd(e) {
  const { ...t } = e, n = Xe(), { colorMode: r } = Ee();
  return /* @__PURE__ */ g(
    hp,
    {
      className: "bccb-widget-header-menu-list",
      bg: n.colors[r].popover.background,
      borderRadius: "8px",
      maxH: "400px",
      minW: "200px",
      maxW: "300px",
      overflowY: "auto",
      sx: {
        "::-webkit-scrollbar": {
          display: "none"
        }
      },
      boxShadow: n.colors[r].popover.shadow,
      ...t
    }
  );
}
function Dde(e) {
  const { className: t, ...n } = e, r = Xe(), { colorMode: o } = Ee();
  return /* @__PURE__ */ g(
    rI,
    {
      className: t,
      px: "16px",
      h: "40px",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "16px",
      gap: "8px",
      transitionDuration: "normal",
      _hover: {
        color: r.colors[o].text.primary,
        bg: r.colors[o].popover.selected
      },
      ...n
    }
  );
}
function sw(e) {
  return /* @__PURE__ */ g(U1, { width: "24px", height: "24px", viewBox: "0 0 24 24", fill: "none", ...e, children: /* @__PURE__ */ g("g", { id: "warning-fill", children: /* @__PURE__ */ g(
    "path",
    {
      id: "warning",
      d: "M2.72674 21C2.54341 21 2.37674 20.9542 2.22674 20.8625C2.07674 20.7708 1.96008 20.65 1.87674 20.5C1.79341 20.35 1.74758 20.1875 1.73924 20.0125C1.73091 19.8375 1.77674 19.6667 1.87674 19.5L11.1267 3.5C11.2267 3.33333 11.3559 3.20833 11.5142 3.125C11.6726 3.04167 11.8351 3 12.0017 3C12.1684 3 12.3309 3.04167 12.4892 3.125C12.6476 3.20833 12.7767 3.33333 12.8767 3.5L22.1267 19.5C22.2267 19.6667 22.2726 19.8375 22.2642 20.0125C22.2559 20.1875 22.2101 20.35 22.1267 20.5C22.0434 20.65 21.9267 20.7708 21.7767 20.8625C21.6267 20.9542 21.4601 21 21.2767 21H2.72674ZM12.0017 18C12.2851 18 12.5226 17.9042 12.7142 17.7125C12.9059 17.5208 13.0017 17.2833 13.0017 17C13.0017 16.7167 12.9059 16.4792 12.7142 16.2875C12.5226 16.0958 12.2851 16 12.0017 16C11.7184 16 11.4809 16.0958 11.2892 16.2875C11.0976 16.4792 11.0017 16.7167 11.0017 17C11.0017 17.2833 11.0976 17.5208 11.2892 17.7125C11.4809 17.9042 11.7184 18 12.0017 18ZM12.0017 15C12.2851 15 12.5226 14.9042 12.7142 14.7125C12.9059 14.5208 13.0017 14.2833 13.0017 14V11C13.0017 10.7167 12.9059 10.4792 12.7142 10.2875C12.5226 10.0958 12.2851 10 12.0017 10C11.7184 10 11.4809 10.0958 11.2892 10.2875C11.0976 10.4792 11.0017 10.7167 11.0017 11V14C11.0017 14.2833 11.0976 14.5208 11.2892 14.7125C11.4809 14.9042 11.7184 15 12.0017 15Z",
      fill: "#FF8A38"
    }
  ) }) });
}
function Zde(e = {}) {
  const { onClickConnectWalletButton: t } = Lt(), { selectFromChain: n } = w2(), r = lt(), o = hr(), i = Ho(), { switchChain: a } = IM({
    mutation: {
      onMutate() {
        e.onPending?.();
      },
      onSettled() {
        e.onSettle?.();
      },
      onSuccess(c, { chainId: u }) {
        n(u);
      }
    }
  }), { switchChain: l } = LM({
    mutation: {
      onMutate() {
        e.onPending?.();
      },
      onSettled() {
        e.onSettle?.();
      },
      onSuccess({ chainId: c }) {
        n(c);
      }
    }
  });
  return {
    async autoSelectFromChain({ chainType: c, chainId: u }) {
      const f = () => {
        t?.({
          chainType: c,
          chainId: u,
          onConnected({ walletType: p } = {}) {
            p === c && n(u);
          }
        });
      };
      c === "evm" ? r.isConnected ? r.chainId !== u ? a({
        chainId: u
      }) : n(u) : f() : c === "tron" ? o.isConnected ? o.chainId !== u ? l({
        chainId: u
      }) : n(u) : f() : c === "solana" && (i.isConnected ? n(u) : f());
    }
  };
}
function zde(e) {
  const { onClickNetwork: t } = e, n = N((b) => b.transfer.fromChain), { formatMessage: r } = n1(), o = Xe(), { colorMode: i } = Ee(), a = Sh(), { needSwitchChain: l } = MM(), c = Re(!1), u = Re(), { autoSelectFromChain: f } = Zde({
    onPending() {
      clearTimeout(u.current), c.current = !0, u.current = setTimeout(() => {
        c.current = !1;
      }, 60 * 1e3);
    },
    onSettle() {
      u.current = setTimeout(() => {
        c.current = !1;
      }, 1e3);
    }
  }), { walletChain: p, hasWalletConnected: h } = Gde(), C = (b) => /* @__PURE__ */ g(Nd, { className: "bccb-widget-header-network-status", maxW: "240px", children: /* @__PURE__ */ X(re, { flexDir: "column", alignItems: "center", padding: "16px", gap: "8px", children: [
    /* @__PURE__ */ X(
      mt,
      {
        className: "bccb-widget-header-network-status-title",
        color: o.colors[i].text.secondary,
        variant: "label",
        size: "md",
        display: "flex",
        align: "center",
        gap: "4px",
        children: [
          /* @__PURE__ */ g(K9, { boxSize: "16px", color: o.colors[i].text.tertiary }),
          r(l ? { id: "wallet.network.switch-network" } : { id: "wallet.network.connect-wallet" })
        ]
      }
    ),
    /* @__PURE__ */ g(kM, { w: "24px", h: "24px", transform: "rotate(90deg)" }),
    /* @__PURE__ */ X(
      re,
      {
        className: "bccb-widget-header-network-status-network",
        maxW: "100%",
        borderRadius: "24px",
        padding: "4px",
        pr: "8px",
        alignItems: "center",
        justifyContent: "center",
        bg: o.colors[i].support.primary[4],
        gap: "8px",
        children: [
          /* @__PURE__ */ g(Bo, { src: n.icon, boxSize: "24px", flexShrink: 0 }),
          /* @__PURE__ */ g(
            mt,
            {
              as: "div",
              display: "flex",
              flex: 1,
              flexShrink: 0,
              noOfLines: 1,
              variant: "label",
              size: "md",
              gap: "4px",
              children: n.name
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ g(h1, { onClick: b, w: "100%", children: l ? /* @__PURE__ */ g(EM, { h: "40px", mt: "16px", fontSize: "14px" }) : /* @__PURE__ */ g(CM, { h: "40px", mt: "16px", fontSize: "14px" }) })
  ] }) });
  if (!p)
    return h ? /* @__PURE__ */ g(Hd, { children: ({ isOpen: b, onClose: y }) => /* @__PURE__ */ X(st, { children: [
      /* @__PURE__ */ X(
        Od,
        {
          className: "bccb-widget-header-dropdown-button-not-connect",
          bgColor: o.colors[i].layer[3].default,
          isActive: b,
          isWarning: b,
          children: [
            /* @__PURE__ */ g(
              sw,
              {
                boxSize: "24px",
                color: o.colors[i].support.warning[3]
              }
            ),
            /* @__PURE__ */ X(re, { flexDir: "column", gap: "0", alignItems: "flex-start", textAlign: "left", children: [
              /* @__PURE__ */ g(
                _n,
                {
                  fontSize: "14px",
                  noOfLines: 1,
                  fontWeight: 500,
                  display: { base: "none", md: "block" },
                  children: r({ id: "wallet.network.unknown-network" })
                }
              ),
              /* @__PURE__ */ g(
                _n,
                {
                  fontSize: "14px",
                  noOfLines: 1,
                  fontWeight: 500,
                  display: { base: "block", md: "none" },
                  children: r({ id: "wallet.network.unknown-network-mobile" })
                }
              )
            ] })
          ]
        }
      ),
      C(y)
    ] }) }) : null;
  const v = l && !c.current;
  return /* @__PURE__ */ g(Hd, { children: ({ isOpen: b, onClose: y }) => /* @__PURE__ */ X(st, { children: [
    /* @__PURE__ */ X(
      Od,
      {
        className: "bccb-widget-header-dropdown-button",
        bgColor: o.colors[i].layer[3].default,
        isActive: b,
        isWarning: b && v,
        children: [
          v ? /* @__PURE__ */ g(
            sw,
            {
              boxSize: "24px",
              color: o.colors[i].support.warning[3]
            }
          ) : /* @__PURE__ */ g(
            Bo,
            {
              src: p.icon,
              boxSize: "24px",
              overflow: "hidden",
              borderRadius: "100%"
            }
          ),
          /* @__PURE__ */ g(
            re,
            {
              className: "chain-name",
              flexDir: "column",
              gap: "0",
              alignItems: "flex-start",
              textAlign: "left",
              children: /* @__PURE__ */ g(_n, { fontSize: "14px", noOfLines: 1, children: p.name })
            }
          )
        ]
      }
    ),
    v ? C(y) : /* @__PURE__ */ g(Nd, { children: a.map((x) => {
      const T = n?.id === x.id;
      return /* @__PURE__ */ X(
        Dde,
        {
          className: "bccb-widget-header-menu-item" + (T ? "-selected" : ""),
          color: T ? o.colors[i].text.primary : o.colors[i].text.secondary,
          bg: T ? o.colors[i].popover.selected : void 0,
          onClick: () => {
            if (x.chainType === "link") {
              E6(x.externalBridgeUrl);
              return;
            }
            t ? t?.({
              chainType: x.chainType,
              chainId: x.id
            }) : f({
              chainType: x.chainType,
              chainId: x.id
            });
          },
          children: [
            /* @__PURE__ */ g(Bo, { src: x.icon, boxSize: "16px", flexShrink: 0 }),
            /* @__PURE__ */ g(re, { flex: 1, flexShrink: 0, noOfLines: 1, children: x.name }),
            x.chainType === "link" && /* @__PURE__ */ g(
              $s,
              {
                ml: "4px",
                color: o.colors[i].text.secondary,
                boxSize: o.sizes[4]
              }
            ),
            T && /* @__PURE__ */ g(xp, { boxSize: "16px" })
          ]
        },
        x.id
      );
    }) })
  ] }) });
}
function Gde() {
  const e = Sh(), t = N((a) => a.transfer.fromChain), n = lt(), r = hr(), o = Ho();
  return {
    walletChain: we(() => {
      const a = e.find(
        (u) => u.chainType === "evm" && u.id === n.chainId
      ), l = e.find(
        (u) => u.chainType === "tron" && u.id === r.chainId
      ), c = e.find(
        (u) => u.chainType === "solana" && u.id === o.chainId
      );
      if (t?.chainType === "evm") return a;
      if (t?.chainType === "tron") return l;
      if (t?.chainType === "solana") return c;
    }, [
      n.chainId,
      t?.chainType,
      o.chainId,
      e,
      r.chainId
    ]),
    hasWalletConnected: n.isConnected || r.isConnected || !!o.isConnected
  };
}
function Wde(e) {
  return /* @__PURE__ */ g(U1, { width: "17px", height: "17px", viewBox: "0 0 17 17", fill: "currentColor", ...e, children: /* @__PURE__ */ g("path", { d: "M7.24651 12.751C6.90973 12.751 6.62467 12.6343 6.39134 12.401C6.15801 12.1676 6.04134 11.8826 6.04134 11.5458V3.95614C6.04134 3.61937 6.15801 3.33431 6.39134 3.10098C6.62467 2.86764 6.90973 2.75098 7.24651 2.75098H12.8362C13.173 2.75098 13.458 2.86764 13.6913 3.10098C13.9247 3.33431 14.0413 3.61937 14.0413 3.95614V11.5458C14.0413 11.8826 13.9247 12.1676 13.6913 12.401C13.458 12.6343 13.173 12.751 12.8362 12.751H7.24651ZM7.24651 11.751H12.8362C12.8875 11.751 12.9345 11.7296 12.9772 11.6868C13.02 11.6441 13.0413 11.5971 13.0413 11.5458V3.95614C13.0413 3.90481 13.02 3.85781 12.9772 3.81514C12.9345 3.77237 12.8875 3.75098 12.8362 3.75098H7.24651C7.19517 3.75098 7.14817 3.77237 7.10551 3.81514C7.06273 3.85781 7.04134 3.90481 7.04134 3.95614V11.5458C7.04134 11.5971 7.06273 11.6441 7.10551 11.6868C7.14817 11.7296 7.19517 11.751 7.24651 11.751ZM4.91317 15.0843C4.5764 15.0843 4.29134 14.9676 4.05801 14.7343C3.82467 14.501 3.70801 14.2159 3.70801 13.8791V5.78948C3.70801 5.64759 3.7559 5.52875 3.85167 5.43298C3.94734 5.33731 4.06612 5.28948 4.20801 5.28948C4.3499 5.28948 4.46873 5.33731 4.56451 5.43298C4.66017 5.52875 4.70801 5.64759 4.70801 5.78948V13.8791C4.70801 13.9305 4.7294 13.9775 4.77217 14.0201C4.81484 14.0629 4.86184 14.0843 4.91317 14.0843H11.0028C11.1447 14.0843 11.2636 14.1321 11.3593 14.2278C11.455 14.3236 11.5028 14.4424 11.5028 14.5843C11.5028 14.7262 11.455 14.845 11.3593 14.9406C11.2636 15.0364 11.1447 15.0843 11.0028 15.0843H4.91317Z" }) });
}
const $de = ({
  content: e,
  tooltipStyle: t,
  iconStyle: n,
  ...r
}) => {
  const { colorMode: o } = Ee(), { onCopy: i, hasCopied: a } = Xq(e || "");
  return e ? /* @__PURE__ */ X(
    re,
    {
      className: "bccb-widget-copy-address",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      boxSize: "24px",
      cursor: "pointer",
      color: H.colors[o].text.secondary,
      bg: H.colors[o].button.primary.subtle,
      borderRadius: "4px",
      transitionProperty: "colors",
      transitionDuration: "normal",
      _hover: {
        color: H.colors[o].text.inverse,
        bg: H.colors[o].button.primary.hover
      },
      ...r,
      children: [
        /* @__PURE__ */ g(
          Wde,
          {
            ...n,
            onClick: () => {
              i();
            }
          }
        ),
        a && /* @__PURE__ */ g(
          h1,
          {
            position: "absolute",
            bottom: "calc(100% + 8px)",
            left: "50%",
            transform: "translateX(-50%)",
            background: H.colors[o].layer.inverse,
            padding: "4px 8px",
            borderRadius: "4px",
            color: H.colors[o].layer[3].default,
            fontSize: "12px",
            whiteSpace: "nowrap",
            _after: {
              content: '""',
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderLeft: "4px solid transparent",
              borderRight: "4px solid transparent",
              borderTop: `4px solid ${H.colors[o].layer.inverse}`
            },
            ...t,
            children: "Copied"
          }
        )
      ]
    }
  ) : null;
};
function Ude() {
  const e = eo(), { chain: t, chainId: n, address: r } = lt();
  return gi({
    queryKey: ["useEvmBalance", r, n],
    refetchInterval: l6,
    enabled: !!r && !!t && !!n,
    queryFn: async () => {
      const o = await e.getBalance({
        address: r
      });
      return {
        formatted: x1(o, t.nativeCurrency.decimals),
        symbol: t.nativeCurrency.symbol,
        value: BigInt(o)
      };
    }
  });
}
function jde() {
  const e = g3(), { address: t } = hr();
  return gi({
    queryKey: ["useTronBalance", t],
    refetchInterval: l6,
    enabled: !!t && !!e,
    queryFn: async () => {
      const n = await e.trx.getUnconfirmedBalance(t), r = e.fromSun(n);
      return {
        formatted: String(r),
        symbol: "TRX",
        value: BigInt(n)
      };
    }
  });
}
function Xde(e) {
  return /* @__PURE__ */ g(U1, { width: "17px", height: "17px", viewBox: "0 0 17 17", fill: "currentcolor", ...e, children: /* @__PURE__ */ g("path", { d: "M4.17955 14.9177C3.815 14.9177 3.50644 14.7942 3.25386 14.5471C3.00129 14.3001 2.875 13.9983 2.875 13.6417V4.19378C2.875 3.8372 3.00129 3.53537 3.25386 3.28831C3.50644 3.04125 3.815 2.91772 4.17955 2.91772H8.47476C8.62823 2.91772 8.7568 2.96843 8.86048 3.06984C8.96403 3.17114 9.01581 3.2969 9.01581 3.44714C9.01581 3.59737 8.96403 3.72314 8.86048 3.82443C8.7568 3.92584 8.62823 3.97655 8.47476 3.97655H4.17955C4.12398 3.97655 4.07311 3.99919 4.02692 4.04449C3.98062 4.08967 3.95746 4.13943 3.95746 4.19378V13.6417C3.95746 13.696 3.98062 13.7458 4.02692 13.791C4.07311 13.8363 4.12398 13.8589 4.17955 13.8589H8.47476C8.62823 13.8589 8.7568 13.9096 8.86048 14.011C8.96403 14.1123 9.01581 14.2381 9.01581 14.3883C9.01581 14.5385 8.96403 14.6643 8.86048 14.7656C8.7568 14.867 8.62823 14.9177 8.47476 14.9177H4.17955ZM13.0626 9.44714H7.45472C7.30113 9.44714 7.1725 9.39643 7.06882 9.29502C6.96526 9.19372 6.91349 9.06796 6.91349 8.91772C6.91349 8.76749 6.96526 8.64172 7.06882 8.54043C7.1725 8.43902 7.30113 8.38831 7.45472 8.38831H13.0626L11.6749 7.0309C11.5749 6.93314 11.5238 6.8139 11.5215 6.6732C11.5192 6.53249 11.5704 6.40737 11.6749 6.29784C11.7794 6.18831 11.9062 6.13172 12.0552 6.12808C12.2041 6.12455 12.3345 6.17749 12.4465 6.2869L14.6794 8.47108C14.8098 8.59872 14.875 8.74761 14.875 8.91772C14.875 9.08784 14.8098 9.23673 14.6794 9.36437L12.4465 11.5485C12.3392 11.6535 12.2118 11.7053 12.0642 11.7038C11.9166 11.7025 11.7869 11.6471 11.6749 11.5376C11.5704 11.4281 11.52 11.3023 11.5237 11.1603C11.5273 11.0182 11.5814 10.896 11.6861 10.7938L13.0626 9.44714Z" }) });
}
const Yde = (e) => {
  const { walletIcons: t } = e, { colorMode: n } = Ee(), r = Xe(), o = N((y) => y.transfer.fromChain), i = lt(), a = hr(), l = Ho(), c = Ude(), u = jde(), f = x6(), { disconnect: p } = dH(), { disconnect: h } = $d(), { disconnect: C } = r2(), v = [
    {
      walletType: "evm",
      walletIcon: t?.find((y) => y.walletType === "evm")?.icon,
      address: i.address,
      isConnected: i.isConnected,
      balance: c.data,
      disconnect: p
    },
    {
      walletType: "solana",
      walletIcon: t?.find((y) => y.walletType === "solana")?.icon,
      address: l.address,
      isConnected: l.isConnected,
      balance: f.data,
      disconnect: h
    },
    {
      walletType: "tron",
      walletIcon: t?.find((y) => y.walletType === "tron")?.icon,
      address: a.address,
      isConnected: a.isConnected,
      balance: u.data,
      disconnect: C
    }
  ].filter((y) => y.isConnected), b = v.find((y) => y.walletType === o?.chainType);
  return /* @__PURE__ */ g(Hd, { children: ({ isOpen: y, onClose: x }) => /* @__PURE__ */ X(st, { children: [
    /* @__PURE__ */ X(
      Od,
      {
        className: "bccb-widget-header-profile-button",
        bgColor: r.colors[n].layer[3].default,
        isActive: y,
        pl: { base: "0", md: "12px" },
        pr: { base: "0", md: "16px" },
        children: [
          /* @__PURE__ */ g(
            pi,
            {
              boxSize: 1,
              opacity: 0,
              position: "absolute",
              left: 0,
              zIndex: -1,
              sx: {
                opacity: 0,
                boxSize: 1
              },
              children: b.walletIcon
            }
          ),
          b.walletIcon && /* @__PURE__ */ g(
            np,
            {
              overflow: "hidden",
              sx: {
                "svg, img": {
                  boxSize: "24px"
                }
              },
              children: b.walletIcon
            }
          ),
          /* @__PURE__ */ g(h1, { display: { base: "none", md: "block" }, children: /* @__PURE__ */ g(
            mt,
            {
              className: "profile-address",
              as: "span",
              variant: "label",
              size: "md",
              fontWeight: 500,
              children: n2({ address: b.address })
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ g(Nd, { className: "bccb-widget-header-profile-list", overflowY: "visible", children: /* @__PURE__ */ g(re, { alignItems: "flex-start", p: "12px", gap: "12px", flexDir: "column", w: "240px", children: v.map((T) => /* @__PURE__ */ X(
      re,
      {
        gap: "8px",
        flexDir: "column",
        w: "100%",
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "16px",
        children: [
          /* @__PURE__ */ X(re, { gap: "12px", alignItems: "center", children: [
            /* @__PURE__ */ g(re, { color: r.colors[n].text.placeholder, children: T.walletType.toUpperCase() }),
            /* @__PURE__ */ g(
              re,
              {
                flex: 1,
                borderTop: "1px solid",
                borderColor: r.colors[n].popover.separator
              }
            )
          ] }),
          /* @__PURE__ */ X(re, { alignItems: "center", children: [
            T.walletIcon && /* @__PURE__ */ g(
              pi,
              {
                boxSize: "32px",
                mr: "8px",
                borderRadius: "8px",
                overflow: "hidden",
                sx: {
                  "svg, img": {
                    boxSize: "100%"
                  }
                },
                children: T.walletIcon
              }
            ),
            /* @__PURE__ */ X(re, { flexDir: "column", flex: 1, children: [
              /* @__PURE__ */ g(re, { fontWeight: 700, fontSize: "14px", children: n2({ address: T.address }) }),
              /* @__PURE__ */ X(re, { color: r.colors[n].text.secondary, children: [
                F1(Number(T.balance?.formatted), 4),
                " ",
                T?.balance?.symbol
              ] })
            ] }),
            /* @__PURE__ */ X(re, { alignItems: "center", gap: "8px", children: [
              /* @__PURE__ */ g($de, { content: T.address }),
              /* @__PURE__ */ g(
                m4e,
                {
                  className: "bccb-widget-header-profile-disconnect-link",
                  variant: "outline",
                  boxSize: "24px",
                  minW: "24px",
                  icon: /* @__PURE__ */ g(Xde, {}),
                  cursor: "pointer",
                  borderColor: r.colors[n].button.primary.subtle,
                  color: r.colors[n].text.secondary,
                  borderRadius: "4px",
                  _hover: {
                    color: r.colors[n].text.inverse,
                    bg: r.colors[n].button.primary.hover
                  },
                  onClick: () => {
                    T.disconnect(), x();
                  },
                  "aria-label": ""
                }
              )
            ] })
          ] })
        ]
      },
      T.walletType
    )) }) })
  ] }) });
};
export {
  xfe as BridgeRoutes,
  yfe as BridgeTransfer,
  bfe as CanonicalBridgeProvider,
  Sfe as ConnectButton,
  AM as ERROR_TYPES,
  zde as NetworkList,
  Yde as Profile,
  g2 as StateModal,
  wfe as locales,
  qt as reportEvent,
  gfe as useBridge,
  Lt as useBridgeConfig,
  Ude as useEvmBalance,
  IM as useEvmSwitchChain,
  Gde as useFromChainConnectedInfo,
  Ho as useSolanaAccount,
  x6 as useSolanaBalance,
  hr as useTronAccount,
  jde as useTronBalance,
  LM as useTronSwitchChain
};
